import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  bigint: any;
  date: any;
  float8: any;
  jsonb: any;
  money: any;
  numeric: any;
  smallint: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  timetz: any;
  uuid: any;
};

export type TixAdditionalInfosInput = {
  companyName: Scalars['String'];
  userEmail: Scalars['String'];
  userId: Scalars['String'];
};

/** columns and relationships of "address.address" */
export type TixAddress = {
  __typename?: 'Address';
  addressId: Scalars['uuid'];
  city?: Maybe<Scalars['String']>;
  /** An object relationship */
  companyAddress?: Maybe<TixCompanyAddress>;
  /** An object relationship */
  contactAddress?: Maybe<TixContactAddress>;
  countryCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  sameAsCompany?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  suiteApartment?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venueAddress?: Maybe<TixVenueAddress>;
};

/** aggregated selection of "address.address" */
export type TixAddressAggregate = {
  __typename?: 'Address_aggregate';
  aggregate?: Maybe<TixAddressAggregateFields>;
  nodes: Array<TixAddress>;
};

/** aggregate fields of "address.address" */
export type TixAddressAggregateFields = {
  __typename?: 'Address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixAddressMaxFields>;
  min?: Maybe<TixAddressMinFields>;
};


/** aggregate fields of "address.address" */
export type TixAddressAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "address.address". All fields are combined with a logical 'AND'. */
export type TixAddressBoolExp = {
  _and?: InputMaybe<Array<TixAddressBoolExp>>;
  _not?: InputMaybe<TixAddressBoolExp>;
  _or?: InputMaybe<Array<TixAddressBoolExp>>;
  addressId?: InputMaybe<TixUuidComparisonExp>;
  city?: InputMaybe<TixStringComparisonExp>;
  companyAddress?: InputMaybe<TixCompanyAddressBoolExp>;
  contactAddress?: InputMaybe<TixContactAddressBoolExp>;
  countryCode?: InputMaybe<TixStringComparisonExp>;
  postalCode?: InputMaybe<TixStringComparisonExp>;
  sameAsCompany?: InputMaybe<TixBooleanComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  stateProvince?: InputMaybe<TixStringComparisonExp>;
  streetAddress?: InputMaybe<TixStringComparisonExp>;
  suiteApartment?: InputMaybe<TixStringComparisonExp>;
  timezone?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueAddress?: InputMaybe<TixVenueAddressBoolExp>;
};

/** unique or primary key constraints on table "address.address" */
export enum TixAddressConstraint {
  /** unique or primary key constraint on columns "address_id" */
  AddressPkey = 'address_pkey'
}

/** input type for inserting data into table "address.address" */
export type TixAddressInsertInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  companyAddress?: InputMaybe<TixCompanyAddressObjRelInsertInput>;
  contactAddress?: InputMaybe<TixContactAddressObjRelInsertInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  sameAsCompany?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueAddress?: InputMaybe<TixVenueAddressObjRelInsertInput>;
};

/** aggregate max on columns */
export type TixAddressMaxFields = {
  __typename?: 'Address_max_fields';
  addressId?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  suiteApartment?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixAddressMinFields = {
  __typename?: 'Address_min_fields';
  addressId?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  suiteApartment?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "address.address" */
export type TixAddressMutationResponse = {
  __typename?: 'Address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixAddress>;
};

/** input type for inserting object relation for remote table "address.address" */
export type TixAddressObjRelInsertInput = {
  data: TixAddressInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixAddressOnConflict>;
};

/** on_conflict condition type for table "address.address" */
export type TixAddressOnConflict = {
  constraint: TixAddressConstraint;
  update_columns?: Array<TixAddressUpdateColumn>;
  where?: InputMaybe<TixAddressBoolExp>;
};

/** Ordering options when selecting data from "address.address". */
export type TixAddressOrderBy = {
  addressId?: InputMaybe<TixOrderBy>;
  city?: InputMaybe<TixOrderBy>;
  companyAddress?: InputMaybe<TixCompanyAddressOrderBy>;
  contactAddress?: InputMaybe<TixContactAddressOrderBy>;
  countryCode?: InputMaybe<TixOrderBy>;
  postalCode?: InputMaybe<TixOrderBy>;
  sameAsCompany?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stateProvince?: InputMaybe<TixOrderBy>;
  streetAddress?: InputMaybe<TixOrderBy>;
  suiteApartment?: InputMaybe<TixOrderBy>;
  timezone?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueAddress?: InputMaybe<TixVenueAddressOrderBy>;
};

/** primary key columns input for table: address.address */
export type TixAddressPkColumnsInput = {
  addressId: Scalars['uuid'];
};

/** select columns of table "address.address" */
export enum TixAddressSelectColumn {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  City = 'city',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  SameAsCompany = 'sameAsCompany',
  /** column name */
  State = 'state',
  /** column name */
  StateProvince = 'stateProvince',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  SuiteApartment = 'suiteApartment',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "address.address" */
export type TixAddressSetInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  sameAsCompany?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Address" */
export type TixAddressStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixAddressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixAddressStreamCursorValueInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  sameAsCompany?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.address" */
export enum TixAddressUpdateColumn {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  City = 'city',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  SameAsCompany = 'sameAsCompany',
  /** column name */
  State = 'state',
  /** column name */
  StateProvince = 'stateProvince',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  SuiteApartment = 'suiteApartment',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixAddressUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixAddressSetInput>;
  /** filter the rows which have to be updated */
  where: TixAddressBoolExp;
};

export type TixAvailableBreakdown = {
  __typename?: 'AvailableBreakdown';
  Class_Tuition?: Maybe<Scalars['Float']>;
  General_Admission?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  VIP?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type TixBooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "utility.business_code_group" */
export type TixBusinessCodeGroup = {
  __typename?: 'BusinessCodeGroup';
  busCodeGroupId: Scalars['uuid'];
  /** An array relationship */
  businessCodes: Array<TixBusinessCodes>;
  /** An aggregate relationship */
  businessCodes_aggregate: TixBusinessCodesAggregate;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "utility.business_code_group" */
export type TixBusinessCodeGroupBusinessCodesArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodesOrderBy>>;
  where?: InputMaybe<TixBusinessCodesBoolExp>;
};


/** columns and relationships of "utility.business_code_group" */
export type TixBusinessCodeGroupBusinessCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodesOrderBy>>;
  where?: InputMaybe<TixBusinessCodesBoolExp>;
};

/** aggregated selection of "utility.business_code_group" */
export type TixBusinessCodeGroupAggregate = {
  __typename?: 'BusinessCodeGroup_aggregate';
  aggregate?: Maybe<TixBusinessCodeGroupAggregateFields>;
  nodes: Array<TixBusinessCodeGroup>;
};

/** aggregate fields of "utility.business_code_group" */
export type TixBusinessCodeGroupAggregateFields = {
  __typename?: 'BusinessCodeGroup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixBusinessCodeGroupMaxFields>;
  min?: Maybe<TixBusinessCodeGroupMinFields>;
};


/** aggregate fields of "utility.business_code_group" */
export type TixBusinessCodeGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixBusinessCodeGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "utility.business_code_group". All fields are combined with a logical 'AND'. */
export type TixBusinessCodeGroupBoolExp = {
  _and?: InputMaybe<Array<TixBusinessCodeGroupBoolExp>>;
  _not?: InputMaybe<TixBusinessCodeGroupBoolExp>;
  _or?: InputMaybe<Array<TixBusinessCodeGroupBoolExp>>;
  busCodeGroupId?: InputMaybe<TixUuidComparisonExp>;
  businessCodes?: InputMaybe<TixBusinessCodesBoolExp>;
  businessCodes_aggregate?: InputMaybe<TixBusinessCodesAggregateBoolExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "utility.business_code_group" */
export enum TixBusinessCodeGroupConstraint {
  /** unique or primary key constraint on columns "bus_code_group_id" */
  BusinessCodeGroupPkey = 'business_code_group_pkey'
}

/** input type for inserting data into table "utility.business_code_group" */
export type TixBusinessCodeGroupInsertInput = {
  busCodeGroupId?: InputMaybe<Scalars['uuid']>;
  businessCodes?: InputMaybe<TixBusinessCodesArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixBusinessCodeGroupMaxFields = {
  __typename?: 'BusinessCodeGroup_max_fields';
  busCodeGroupId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixBusinessCodeGroupMinFields = {
  __typename?: 'BusinessCodeGroup_min_fields';
  busCodeGroupId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "utility.business_code_group" */
export type TixBusinessCodeGroupMutationResponse = {
  __typename?: 'BusinessCodeGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixBusinessCodeGroup>;
};

/** input type for inserting object relation for remote table "utility.business_code_group" */
export type TixBusinessCodeGroupObjRelInsertInput = {
  data: TixBusinessCodeGroupInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixBusinessCodeGroupOnConflict>;
};

/** on_conflict condition type for table "utility.business_code_group" */
export type TixBusinessCodeGroupOnConflict = {
  constraint: TixBusinessCodeGroupConstraint;
  update_columns?: Array<TixBusinessCodeGroupUpdateColumn>;
  where?: InputMaybe<TixBusinessCodeGroupBoolExp>;
};

/** Ordering options when selecting data from "utility.business_code_group". */
export type TixBusinessCodeGroupOrderBy = {
  busCodeGroupId?: InputMaybe<TixOrderBy>;
  businessCodes_aggregate?: InputMaybe<TixBusinessCodesAggregateOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: utility.business_code_group */
export type TixBusinessCodeGroupPkColumnsInput = {
  busCodeGroupId: Scalars['uuid'];
};

/** select columns of table "utility.business_code_group" */
export enum TixBusinessCodeGroupSelectColumn {
  /** column name */
  BusCodeGroupId = 'busCodeGroupId',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "utility.business_code_group" */
export type TixBusinessCodeGroupSetInput = {
  busCodeGroupId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "BusinessCodeGroup" */
export type TixBusinessCodeGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixBusinessCodeGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixBusinessCodeGroupStreamCursorValueInput = {
  busCodeGroupId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "utility.business_code_group" */
export enum TixBusinessCodeGroupUpdateColumn {
  /** column name */
  BusCodeGroupId = 'busCodeGroupId',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixBusinessCodeGroupUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixBusinessCodeGroupSetInput>;
  /** filter the rows which have to be updated */
  where: TixBusinessCodeGroupBoolExp;
};

/** columns and relationships of "utility.business_codes" */
export type TixBusinessCodes = {
  __typename?: 'BusinessCodes';
  busCodeGroupId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  businessCodeGroup?: Maybe<TixBusinessCodeGroup>;
  businessCodeId: Scalars['uuid'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** used if the business code has a related URL */
  url?: Maybe<Scalars['String']>;
};

/** aggregated selection of "utility.business_codes" */
export type TixBusinessCodesAggregate = {
  __typename?: 'BusinessCodes_aggregate';
  aggregate?: Maybe<TixBusinessCodesAggregateFields>;
  nodes: Array<TixBusinessCodes>;
};

export type TixBusinessCodesAggregateBoolExp = {
  count?: InputMaybe<TixBusinessCodesAggregateBoolExpCount>;
};

export type TixBusinessCodesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixBusinessCodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixBusinessCodesBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "utility.business_codes" */
export type TixBusinessCodesAggregateFields = {
  __typename?: 'BusinessCodes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixBusinessCodesMaxFields>;
  min?: Maybe<TixBusinessCodesMinFields>;
};


/** aggregate fields of "utility.business_codes" */
export type TixBusinessCodesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixBusinessCodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "utility.business_codes" */
export type TixBusinessCodesAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixBusinessCodesMaxOrderBy>;
  min?: InputMaybe<TixBusinessCodesMinOrderBy>;
};

/** input type for inserting array relation for remote table "utility.business_codes" */
export type TixBusinessCodesArrRelInsertInput = {
  data: Array<TixBusinessCodesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixBusinessCodesOnConflict>;
};

/** Boolean expression to filter rows from the table "utility.business_codes". All fields are combined with a logical 'AND'. */
export type TixBusinessCodesBoolExp = {
  _and?: InputMaybe<Array<TixBusinessCodesBoolExp>>;
  _not?: InputMaybe<TixBusinessCodesBoolExp>;
  _or?: InputMaybe<Array<TixBusinessCodesBoolExp>>;
  busCodeGroupId?: InputMaybe<TixUuidComparisonExp>;
  businessCodeGroup?: InputMaybe<TixBusinessCodeGroupBoolExp>;
  businessCodeId?: InputMaybe<TixUuidComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  url?: InputMaybe<TixStringComparisonExp>;
};

/** unique or primary key constraints on table "utility.business_codes" */
export enum TixBusinessCodesConstraint {
  /** unique or primary key constraint on columns "business_code_id" */
  BusinessCodesPkey = 'business_codes_pkey'
}

/** input type for inserting data into table "utility.business_codes" */
export type TixBusinessCodesInsertInput = {
  busCodeGroupId?: InputMaybe<Scalars['uuid']>;
  businessCodeGroup?: InputMaybe<TixBusinessCodeGroupObjRelInsertInput>;
  businessCodeId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  /** used if the business code has a related URL */
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TixBusinessCodesMaxFields = {
  __typename?: 'BusinessCodes_max_fields';
  busCodeGroupId?: Maybe<Scalars['uuid']>;
  businessCodeId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  /** used if the business code has a related URL */
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "utility.business_codes" */
export type TixBusinessCodesMaxOrderBy = {
  busCodeGroupId?: InputMaybe<TixOrderBy>;
  businessCodeId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  /** used if the business code has a related URL */
  url?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixBusinessCodesMinFields = {
  __typename?: 'BusinessCodes_min_fields';
  busCodeGroupId?: Maybe<Scalars['uuid']>;
  businessCodeId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  /** used if the business code has a related URL */
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "utility.business_codes" */
export type TixBusinessCodesMinOrderBy = {
  busCodeGroupId?: InputMaybe<TixOrderBy>;
  businessCodeId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  /** used if the business code has a related URL */
  url?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "utility.business_codes" */
export type TixBusinessCodesMutationResponse = {
  __typename?: 'BusinessCodes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixBusinessCodes>;
};

/** on_conflict condition type for table "utility.business_codes" */
export type TixBusinessCodesOnConflict = {
  constraint: TixBusinessCodesConstraint;
  update_columns?: Array<TixBusinessCodesUpdateColumn>;
  where?: InputMaybe<TixBusinessCodesBoolExp>;
};

/** Ordering options when selecting data from "utility.business_codes". */
export type TixBusinessCodesOrderBy = {
  busCodeGroupId?: InputMaybe<TixOrderBy>;
  businessCodeGroup?: InputMaybe<TixBusinessCodeGroupOrderBy>;
  businessCodeId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  url?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: utility.business_codes */
export type TixBusinessCodesPkColumnsInput = {
  businessCodeId: Scalars['uuid'];
};

/** select columns of table "utility.business_codes" */
export enum TixBusinessCodesSelectColumn {
  /** column name */
  BusCodeGroupId = 'busCodeGroupId',
  /** column name */
  BusinessCodeId = 'businessCodeId',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "utility.business_codes" */
export type TixBusinessCodesSetInput = {
  busCodeGroupId?: InputMaybe<Scalars['uuid']>;
  businessCodeId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  /** used if the business code has a related URL */
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "BusinessCodes" */
export type TixBusinessCodesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixBusinessCodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixBusinessCodesStreamCursorValueInput = {
  busCodeGroupId?: InputMaybe<Scalars['uuid']>;
  businessCodeId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  /** used if the business code has a related URL */
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "utility.business_codes" */
export enum TixBusinessCodesUpdateColumn {
  /** column name */
  BusCodeGroupId = 'busCodeGroupId',
  /** column name */
  BusinessCodeId = 'businessCodeId',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url'
}

export type TixBusinessCodesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixBusinessCodesSetInput>;
  /** filter the rows which have to be updated */
  where: TixBusinessCodesBoolExp;
};

/** columns and relationships of "company.company" */
export type TixCompany = {
  __typename?: 'Company';
  /** An array relationship */
  addresses: Array<TixCompanyAddress>;
  /** An aggregate relationship */
  addresses_aggregate: TixCompanyAddressAggregate;
  companyId: Scalars['uuid'];
  /** An array relationship */
  companyVenueEvents: Array<TixEventCompanyVenue>;
  /** An aggregate relationship */
  companyVenueEvents_aggregate: TixEventCompanyVenueAggregate;
  /** An array relationship */
  configurationValues: Array<TixCompanyConfigurationValue>;
  /** An aggregate relationship */
  configurationValues_aggregate: TixCompanyConfigurationValueAggregate;
  /** An array relationship */
  contacts: Array<TixCompanyContact>;
  /** An aggregate relationship */
  contacts_aggregate: TixCompanyContactAggregate;
  is_platform_company?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  mediaFiles: Array<TixCompanyMediaFile>;
  /** An aggregate relationship */
  mediaFiles_aggregate: TixCompanyMediaFileAggregate;
  name: Scalars['String'];
  parentCompanyId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  payouts: Array<TixPayout>;
  /** An aggregate relationship */
  payouts_aggregate: TixPayoutAggregate;
  /** An array relationship */
  performers: Array<TixPerformer>;
  /** An aggregate relationship */
  performers_aggregate: TixPerformerAggregate;
  /** An array relationship */
  phoneNumbers: Array<TixCompanyPhoneNumber>;
  /** An aggregate relationship */
  phoneNumbers_aggregate: TixCompanyPhoneNumberAggregate;
  /** An array relationship */
  policy: Array<TixUtilityPolicy>;
  /** An aggregate relationship */
  policy_aggregate: TixUtilityPolicyAggregate;
  /** An array relationship */
  socialMediaLinks: Array<TixCompanySocialMedia>;
  /** An aggregate relationship */
  socialMediaLinks_aggregate: TixCompanySocialMediaAggregate;
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  url?: Maybe<Scalars['String']>;
  /** An array relationship */
  venues: Array<TixVenue>;
  /** An aggregate relationship */
  venues_aggregate: TixVenueAggregate;
  /** An array relationship */
  warnings: Array<TixCompanyWarning>;
  /** An aggregate relationship */
  warnings_aggregate: TixCompanyWarningAggregate;
};


/** columns and relationships of "company.company" */
export type TixCompanyAddressesArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyAddressOrderBy>>;
  where?: InputMaybe<TixCompanyAddressBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyAddressesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyAddressOrderBy>>;
  where?: InputMaybe<TixCompanyAddressBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyCompanyVenueEventsArgs = {
  distinct_on?: InputMaybe<Array<TixEventCompanyVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCompanyVenueOrderBy>>;
  where?: InputMaybe<TixEventCompanyVenueBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyCompanyVenueEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventCompanyVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCompanyVenueOrderBy>>;
  where?: InputMaybe<TixEventCompanyVenueBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyConfigurationValuesArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyConfigurationValueOrderBy>>;
  where?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyConfigurationValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyConfigurationValueOrderBy>>;
  where?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyContactsArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyContactOrderBy>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyContactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyContactOrderBy>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyMediaFilesArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyMediaFileOrderBy>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyMediaFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyMediaFileOrderBy>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyPayoutsArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutOrderBy>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyPayoutsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutOrderBy>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPerformerOrderBy>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPerformerOrderBy>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyPhoneNumbersArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyPhoneNumberOrderBy>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyPhoneNumbersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyPhoneNumberOrderBy>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyPolicyArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityPolicyOrderBy>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyPolicyAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityPolicyOrderBy>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanySocialMediaLinksArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySocialMediaOrderBy>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanySocialMediaLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySocialMediaOrderBy>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyVenuesArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueOrderBy>>;
  where?: InputMaybe<TixVenueBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyVenuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueOrderBy>>;
  where?: InputMaybe<TixVenueBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyWarningsArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyWarningOrderBy>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};


/** columns and relationships of "company.company" */
export type TixCompanyWarningsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyWarningOrderBy>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};

/** columns and relationships of "address.company_address" */
export type TixCompanyAddress = {
  __typename?: 'CompanyAddress';
  /** An object relationship */
  address?: Maybe<TixAddress>;
  addressId: Scalars['uuid'];
  /** An object relationship */
  companyAddress?: Maybe<TixCompany>;
  companyAddressId: Scalars['uuid'];
  companyId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['String'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "address.company_address" */
export type TixCompanyAddressAggregate = {
  __typename?: 'CompanyAddress_aggregate';
  aggregate?: Maybe<TixCompanyAddressAggregateFields>;
  nodes: Array<TixCompanyAddress>;
};

export type TixCompanyAddressAggregateBoolExp = {
  count?: InputMaybe<TixCompanyAddressAggregateBoolExpCount>;
};

export type TixCompanyAddressAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixCompanyAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixCompanyAddressBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "address.company_address" */
export type TixCompanyAddressAggregateFields = {
  __typename?: 'CompanyAddress_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCompanyAddressMaxFields>;
  min?: Maybe<TixCompanyAddressMinFields>;
};


/** aggregate fields of "address.company_address" */
export type TixCompanyAddressAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanyAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address.company_address" */
export type TixCompanyAddressAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixCompanyAddressMaxOrderBy>;
  min?: InputMaybe<TixCompanyAddressMinOrderBy>;
};

/** input type for inserting array relation for remote table "address.company_address" */
export type TixCompanyAddressArrRelInsertInput = {
  data: Array<TixCompanyAddressInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyAddressOnConflict>;
};

/** Boolean expression to filter rows from the table "address.company_address". All fields are combined with a logical 'AND'. */
export type TixCompanyAddressBoolExp = {
  _and?: InputMaybe<Array<TixCompanyAddressBoolExp>>;
  _not?: InputMaybe<TixCompanyAddressBoolExp>;
  _or?: InputMaybe<Array<TixCompanyAddressBoolExp>>;
  address?: InputMaybe<TixAddressBoolExp>;
  addressId?: InputMaybe<TixUuidComparisonExp>;
  companyAddress?: InputMaybe<TixCompanyBoolExp>;
  companyAddressId?: InputMaybe<TixUuidComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixStringComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "address.company_address" */
export enum TixCompanyAddressConstraint {
  /** unique or primary key constraint on columns "company_address_id" */
  CompanyAddressPkey = 'company_address_pkey'
}

/** input type for inserting data into table "address.company_address" */
export type TixCompanyAddressInsertInput = {
  address?: InputMaybe<TixAddressObjRelInsertInput>;
  addressId?: InputMaybe<Scalars['uuid']>;
  companyAddress?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyAddressId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCompanyAddressMaxFields = {
  __typename?: 'CompanyAddress_max_fields';
  addressId?: Maybe<Scalars['uuid']>;
  companyAddressId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "address.company_address" */
export type TixCompanyAddressMaxOrderBy = {
  addressId?: InputMaybe<TixOrderBy>;
  companyAddressId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixCompanyAddressMinFields = {
  __typename?: 'CompanyAddress_min_fields';
  addressId?: Maybe<Scalars['uuid']>;
  companyAddressId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "address.company_address" */
export type TixCompanyAddressMinOrderBy = {
  addressId?: InputMaybe<TixOrderBy>;
  companyAddressId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "address.company_address" */
export type TixCompanyAddressMutationResponse = {
  __typename?: 'CompanyAddress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCompanyAddress>;
};

/** input type for inserting object relation for remote table "address.company_address" */
export type TixCompanyAddressObjRelInsertInput = {
  data: TixCompanyAddressInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyAddressOnConflict>;
};

/** on_conflict condition type for table "address.company_address" */
export type TixCompanyAddressOnConflict = {
  constraint: TixCompanyAddressConstraint;
  update_columns?: Array<TixCompanyAddressUpdateColumn>;
  where?: InputMaybe<TixCompanyAddressBoolExp>;
};

/** Ordering options when selecting data from "address.company_address". */
export type TixCompanyAddressOrderBy = {
  address?: InputMaybe<TixAddressOrderBy>;
  addressId?: InputMaybe<TixOrderBy>;
  companyAddress?: InputMaybe<TixCompanyOrderBy>;
  companyAddressId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: address.company_address */
export type TixCompanyAddressPkColumnsInput = {
  companyAddressId: Scalars['uuid'];
};

/** select columns of table "address.company_address" */
export enum TixCompanyAddressSelectColumn {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  CompanyAddressId = 'companyAddressId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "address.company_address" */
export type TixCompanyAddressSetInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  companyAddressId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "CompanyAddress" */
export type TixCompanyAddressStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanyAddressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanyAddressStreamCursorValueInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  companyAddressId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.company_address" */
export enum TixCompanyAddressUpdateColumn {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  CompanyAddressId = 'companyAddressId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCompanyAddressUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCompanyAddressSetInput>;
  /** filter the rows which have to be updated */
  where: TixCompanyAddressBoolExp;
};

/** columns and relationships of "configuration.company_configuration_value" */
export type TixCompanyConfigurationValue = {
  __typename?: 'CompanyConfigurationValue';
  /** An object relationship */
  ConfigurationValue: TixConfigurationValue;
  /** An object relationship */
  company: TixCompany;
  companyConfigurationValueId: Scalars['uuid'];
  companyId: Scalars['uuid'];
  configurationId: Scalars['uuid'];
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueAggregate = {
  __typename?: 'CompanyConfigurationValue_aggregate';
  aggregate?: Maybe<TixCompanyConfigurationValueAggregateFields>;
  nodes: Array<TixCompanyConfigurationValue>;
};

export type TixCompanyConfigurationValueAggregateBoolExp = {
  count?: InputMaybe<TixCompanyConfigurationValueAggregateBoolExpCount>;
};

export type TixCompanyConfigurationValueAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixCompanyConfigurationValueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueAggregateFields = {
  __typename?: 'CompanyConfigurationValue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCompanyConfigurationValueMaxFields>;
  min?: Maybe<TixCompanyConfigurationValueMinFields>;
};


/** aggregate fields of "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanyConfigurationValueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixCompanyConfigurationValueMaxOrderBy>;
  min?: InputMaybe<TixCompanyConfigurationValueMinOrderBy>;
};

/** input type for inserting array relation for remote table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueArrRelInsertInput = {
  data: Array<TixCompanyConfigurationValueInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyConfigurationValueOnConflict>;
};

/** Boolean expression to filter rows from the table "configuration.company_configuration_value". All fields are combined with a logical 'AND'. */
export type TixCompanyConfigurationValueBoolExp = {
  ConfigurationValue?: InputMaybe<TixConfigurationValueBoolExp>;
  _and?: InputMaybe<Array<TixCompanyConfigurationValueBoolExp>>;
  _not?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
  _or?: InputMaybe<Array<TixCompanyConfigurationValueBoolExp>>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyConfigurationValueId?: InputMaybe<TixUuidComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  configurationId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "configuration.company_configuration_value" */
export enum TixCompanyConfigurationValueConstraint {
  /** unique or primary key constraint on columns "company_configuration_value_id" */
  CompanyConfigurationValuePkey = 'company_configuration_value_pkey'
}

/** input type for inserting data into table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueInsertInput = {
  ConfigurationValue?: InputMaybe<TixConfigurationValueObjRelInsertInput>;
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyConfigurationValueId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  configurationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCompanyConfigurationValueMaxFields = {
  __typename?: 'CompanyConfigurationValue_max_fields';
  companyConfigurationValueId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  configurationId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueMaxOrderBy = {
  companyConfigurationValueId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  configurationId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixCompanyConfigurationValueMinFields = {
  __typename?: 'CompanyConfigurationValue_min_fields';
  companyConfigurationValueId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  configurationId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueMinOrderBy = {
  companyConfigurationValueId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  configurationId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueMutationResponse = {
  __typename?: 'CompanyConfigurationValue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCompanyConfigurationValue>;
};

/** input type for inserting object relation for remote table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueObjRelInsertInput = {
  data: TixCompanyConfigurationValueInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyConfigurationValueOnConflict>;
};

/** on_conflict condition type for table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueOnConflict = {
  constraint: TixCompanyConfigurationValueConstraint;
  update_columns?: Array<TixCompanyConfigurationValueUpdateColumn>;
  where?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
};

/** Ordering options when selecting data from "configuration.company_configuration_value". */
export type TixCompanyConfigurationValueOrderBy = {
  ConfigurationValue?: InputMaybe<TixConfigurationValueOrderBy>;
  company?: InputMaybe<TixCompanyOrderBy>;
  companyConfigurationValueId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  configurationId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: configuration.company_configuration_value */
export type TixCompanyConfigurationValuePkColumnsInput = {
  companyConfigurationValueId: Scalars['uuid'];
};

/** select columns of table "configuration.company_configuration_value" */
export enum TixCompanyConfigurationValueSelectColumn {
  /** column name */
  CompanyConfigurationValueId = 'companyConfigurationValueId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  ConfigurationId = 'configurationId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "configuration.company_configuration_value" */
export type TixCompanyConfigurationValueSetInput = {
  companyConfigurationValueId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  configurationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "CompanyConfigurationValue" */
export type TixCompanyConfigurationValueStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanyConfigurationValueStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanyConfigurationValueStreamCursorValueInput = {
  companyConfigurationValueId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  configurationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "configuration.company_configuration_value" */
export enum TixCompanyConfigurationValueUpdateColumn {
  /** column name */
  CompanyConfigurationValueId = 'companyConfigurationValueId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  ConfigurationId = 'configurationId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCompanyConfigurationValueUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCompanyConfigurationValueSetInput>;
  /** filter the rows which have to be updated */
  where: TixCompanyConfigurationValueBoolExp;
};

/** columns and relationships of "contact.company_contact" */
export type TixCompanyContact = {
  __typename?: 'CompanyContact';
  /** An object relationship */
  company: TixCompany;
  companyContactId: Scalars['uuid'];
  companyId: Scalars['uuid'];
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contactId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "contact.company_contact" */
export type TixCompanyContactAggregate = {
  __typename?: 'CompanyContact_aggregate';
  aggregate?: Maybe<TixCompanyContactAggregateFields>;
  nodes: Array<TixCompanyContact>;
};

export type TixCompanyContactAggregateBoolExp = {
  count?: InputMaybe<TixCompanyContactAggregateBoolExpCount>;
};

export type TixCompanyContactAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixCompanyContactBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "contact.company_contact" */
export type TixCompanyContactAggregateFields = {
  __typename?: 'CompanyContact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCompanyContactMaxFields>;
  min?: Maybe<TixCompanyContactMinFields>;
};


/** aggregate fields of "contact.company_contact" */
export type TixCompanyContactAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contact.company_contact" */
export type TixCompanyContactAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixCompanyContactMaxOrderBy>;
  min?: InputMaybe<TixCompanyContactMinOrderBy>;
};

/** input type for inserting array relation for remote table "contact.company_contact" */
export type TixCompanyContactArrRelInsertInput = {
  data: Array<TixCompanyContactInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyContactOnConflict>;
};

/** Boolean expression to filter rows from the table "contact.company_contact". All fields are combined with a logical 'AND'. */
export type TixCompanyContactBoolExp = {
  _and?: InputMaybe<Array<TixCompanyContactBoolExp>>;
  _not?: InputMaybe<TixCompanyContactBoolExp>;
  _or?: InputMaybe<Array<TixCompanyContactBoolExp>>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyContactId?: InputMaybe<TixUuidComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "contact.company_contact" */
export enum TixCompanyContactConstraint {
  /** unique or primary key constraint on columns "company_contact_id" */
  CompanyContactPkey = 'company_contact_pkey'
}

/** input type for inserting data into table "contact.company_contact" */
export type TixCompanyContactInsertInput = {
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyContactId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCompanyContactMaxFields = {
  __typename?: 'CompanyContact_max_fields';
  companyContactId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  contactId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "contact.company_contact" */
export type TixCompanyContactMaxOrderBy = {
  companyContactId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixCompanyContactMinFields = {
  __typename?: 'CompanyContact_min_fields';
  companyContactId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  contactId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "contact.company_contact" */
export type TixCompanyContactMinOrderBy = {
  companyContactId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "contact.company_contact" */
export type TixCompanyContactMutationResponse = {
  __typename?: 'CompanyContact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCompanyContact>;
};

/** on_conflict condition type for table "contact.company_contact" */
export type TixCompanyContactOnConflict = {
  constraint: TixCompanyContactConstraint;
  update_columns?: Array<TixCompanyContactUpdateColumn>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};

/** Ordering options when selecting data from "contact.company_contact". */
export type TixCompanyContactOrderBy = {
  company?: InputMaybe<TixCompanyOrderBy>;
  companyContactId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  contact?: InputMaybe<TixContactOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: contact.company_contact */
export type TixCompanyContactPkColumnsInput = {
  companyContactId: Scalars['uuid'];
};

/** select columns of table "contact.company_contact" */
export enum TixCompanyContactSelectColumn {
  /** column name */
  CompanyContactId = 'companyContactId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "contact.company_contact" */
export type TixCompanyContactSetInput = {
  companyContactId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "CompanyContact" */
export type TixCompanyContactStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanyContactStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanyContactStreamCursorValueInput = {
  companyContactId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "contact.company_contact" */
export enum TixCompanyContactUpdateColumn {
  /** column name */
  CompanyContactId = 'companyContactId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCompanyContactUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCompanyContactSetInput>;
  /** filter the rows which have to be updated */
  where: TixCompanyContactBoolExp;
};

/** columns and relationships of "media.company_media_file" */
export type TixCompanyMediaFile = {
  __typename?: 'CompanyMediaFile';
  /** An object relationship */
  Company: TixCompany;
  companyId: Scalars['uuid'];
  companyImageFileId: Scalars['uuid'];
  /** An object relationship */
  mediaFile: TixMediaFile;
  mediaFileId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "media.company_media_file" */
export type TixCompanyMediaFileAggregate = {
  __typename?: 'CompanyMediaFile_aggregate';
  aggregate?: Maybe<TixCompanyMediaFileAggregateFields>;
  nodes: Array<TixCompanyMediaFile>;
};

export type TixCompanyMediaFileAggregateBoolExp = {
  count?: InputMaybe<TixCompanyMediaFileAggregateBoolExpCount>;
};

export type TixCompanyMediaFileAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixCompanyMediaFileBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "media.company_media_file" */
export type TixCompanyMediaFileAggregateFields = {
  __typename?: 'CompanyMediaFile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCompanyMediaFileMaxFields>;
  min?: Maybe<TixCompanyMediaFileMinFields>;
};


/** aggregate fields of "media.company_media_file" */
export type TixCompanyMediaFileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media.company_media_file" */
export type TixCompanyMediaFileAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixCompanyMediaFileMaxOrderBy>;
  min?: InputMaybe<TixCompanyMediaFileMinOrderBy>;
};

/** input type for inserting array relation for remote table "media.company_media_file" */
export type TixCompanyMediaFileArrRelInsertInput = {
  data: Array<TixCompanyMediaFileInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyMediaFileOnConflict>;
};

/** Boolean expression to filter rows from the table "media.company_media_file". All fields are combined with a logical 'AND'. */
export type TixCompanyMediaFileBoolExp = {
  Company?: InputMaybe<TixCompanyBoolExp>;
  _and?: InputMaybe<Array<TixCompanyMediaFileBoolExp>>;
  _not?: InputMaybe<TixCompanyMediaFileBoolExp>;
  _or?: InputMaybe<Array<TixCompanyMediaFileBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyImageFileId?: InputMaybe<TixUuidComparisonExp>;
  mediaFile?: InputMaybe<TixMediaFileBoolExp>;
  mediaFileId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "media.company_media_file" */
export enum TixCompanyMediaFileConstraint {
  /** unique or primary key constraint on columns "company_image_file_id" */
  CompanyImageFilePkey = 'company_image_file_pkey'
}

/** input type for inserting data into table "media.company_media_file" */
export type TixCompanyMediaFileInsertInput = {
  Company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyImageFileId?: InputMaybe<Scalars['uuid']>;
  mediaFile?: InputMaybe<TixMediaFileObjRelInsertInput>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCompanyMediaFileMaxFields = {
  __typename?: 'CompanyMediaFile_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyImageFileId?: Maybe<Scalars['uuid']>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "media.company_media_file" */
export type TixCompanyMediaFileMaxOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyImageFileId?: InputMaybe<TixOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixCompanyMediaFileMinFields = {
  __typename?: 'CompanyMediaFile_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyImageFileId?: Maybe<Scalars['uuid']>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "media.company_media_file" */
export type TixCompanyMediaFileMinOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyImageFileId?: InputMaybe<TixOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "media.company_media_file" */
export type TixCompanyMediaFileMutationResponse = {
  __typename?: 'CompanyMediaFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCompanyMediaFile>;
};

/** on_conflict condition type for table "media.company_media_file" */
export type TixCompanyMediaFileOnConflict = {
  constraint: TixCompanyMediaFileConstraint;
  update_columns?: Array<TixCompanyMediaFileUpdateColumn>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};

/** Ordering options when selecting data from "media.company_media_file". */
export type TixCompanyMediaFileOrderBy = {
  Company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyImageFileId?: InputMaybe<TixOrderBy>;
  mediaFile?: InputMaybe<TixMediaFileOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: media.company_media_file */
export type TixCompanyMediaFilePkColumnsInput = {
  companyImageFileId: Scalars['uuid'];
};

/** select columns of table "media.company_media_file" */
export enum TixCompanyMediaFileSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyImageFileId = 'companyImageFileId',
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "media.company_media_file" */
export type TixCompanyMediaFileSetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyImageFileId?: InputMaybe<Scalars['uuid']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "CompanyMediaFile" */
export type TixCompanyMediaFileStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanyMediaFileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanyMediaFileStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyImageFileId?: InputMaybe<Scalars['uuid']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.company_media_file" */
export enum TixCompanyMediaFileUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyImageFileId = 'companyImageFileId',
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCompanyMediaFileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCompanyMediaFileSetInput>;
  /** filter the rows which have to be updated */
  where: TixCompanyMediaFileBoolExp;
};

/** columns and relationships of "address.company_phone_number" */
export type TixCompanyPhoneNumber = {
  __typename?: 'CompanyPhoneNumber';
  /** An object relationship */
  company: TixCompany;
  companyId: Scalars['uuid'];
  companyPhoneNumberId: Scalars['uuid'];
  /** An object relationship */
  phoneNumber?: Maybe<TixPhoneNumber>;
  phoneNumberId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "address.company_phone_number" */
export type TixCompanyPhoneNumberAggregate = {
  __typename?: 'CompanyPhoneNumber_aggregate';
  aggregate?: Maybe<TixCompanyPhoneNumberAggregateFields>;
  nodes: Array<TixCompanyPhoneNumber>;
};

export type TixCompanyPhoneNumberAggregateBoolExp = {
  count?: InputMaybe<TixCompanyPhoneNumberAggregateBoolExpCount>;
};

export type TixCompanyPhoneNumberAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "address.company_phone_number" */
export type TixCompanyPhoneNumberAggregateFields = {
  __typename?: 'CompanyPhoneNumber_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCompanyPhoneNumberMaxFields>;
  min?: Maybe<TixCompanyPhoneNumberMinFields>;
};


/** aggregate fields of "address.company_phone_number" */
export type TixCompanyPhoneNumberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address.company_phone_number" */
export type TixCompanyPhoneNumberAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixCompanyPhoneNumberMaxOrderBy>;
  min?: InputMaybe<TixCompanyPhoneNumberMinOrderBy>;
};

/** input type for inserting array relation for remote table "address.company_phone_number" */
export type TixCompanyPhoneNumberArrRelInsertInput = {
  data: Array<TixCompanyPhoneNumberInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyPhoneNumberOnConflict>;
};

/** Boolean expression to filter rows from the table "address.company_phone_number". All fields are combined with a logical 'AND'. */
export type TixCompanyPhoneNumberBoolExp = {
  _and?: InputMaybe<Array<TixCompanyPhoneNumberBoolExp>>;
  _not?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
  _or?: InputMaybe<Array<TixCompanyPhoneNumberBoolExp>>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyPhoneNumberId?: InputMaybe<TixUuidComparisonExp>;
  phoneNumber?: InputMaybe<TixPhoneNumberBoolExp>;
  phoneNumberId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "address.company_phone_number" */
export enum TixCompanyPhoneNumberConstraint {
  /** unique or primary key constraint on columns "company_phone_number_id" */
  CompanyPhoneNumberPkey = 'company_phone_number_pkey'
}

/** input type for inserting data into table "address.company_phone_number" */
export type TixCompanyPhoneNumberInsertInput = {
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyPhoneNumberId?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<TixPhoneNumberObjRelInsertInput>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCompanyPhoneNumberMaxFields = {
  __typename?: 'CompanyPhoneNumber_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyPhoneNumberId?: Maybe<Scalars['uuid']>;
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "address.company_phone_number" */
export type TixCompanyPhoneNumberMaxOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyPhoneNumberId?: InputMaybe<TixOrderBy>;
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixCompanyPhoneNumberMinFields = {
  __typename?: 'CompanyPhoneNumber_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyPhoneNumberId?: Maybe<Scalars['uuid']>;
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "address.company_phone_number" */
export type TixCompanyPhoneNumberMinOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyPhoneNumberId?: InputMaybe<TixOrderBy>;
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "address.company_phone_number" */
export type TixCompanyPhoneNumberMutationResponse = {
  __typename?: 'CompanyPhoneNumber_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCompanyPhoneNumber>;
};

/** on_conflict condition type for table "address.company_phone_number" */
export type TixCompanyPhoneNumberOnConflict = {
  constraint: TixCompanyPhoneNumberConstraint;
  update_columns?: Array<TixCompanyPhoneNumberUpdateColumn>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};

/** Ordering options when selecting data from "address.company_phone_number". */
export type TixCompanyPhoneNumberOrderBy = {
  company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyPhoneNumberId?: InputMaybe<TixOrderBy>;
  phoneNumber?: InputMaybe<TixPhoneNumberOrderBy>;
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: address.company_phone_number */
export type TixCompanyPhoneNumberPkColumnsInput = {
  companyPhoneNumberId: Scalars['uuid'];
};

/** select columns of table "address.company_phone_number" */
export enum TixCompanyPhoneNumberSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyPhoneNumberId = 'companyPhoneNumberId',
  /** column name */
  PhoneNumberId = 'phoneNumberId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "address.company_phone_number" */
export type TixCompanyPhoneNumberSetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyPhoneNumberId?: InputMaybe<Scalars['uuid']>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "CompanyPhoneNumber" */
export type TixCompanyPhoneNumberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanyPhoneNumberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanyPhoneNumberStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyPhoneNumberId?: InputMaybe<Scalars['uuid']>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.company_phone_number" */
export enum TixCompanyPhoneNumberUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyPhoneNumberId = 'companyPhoneNumberId',
  /** column name */
  PhoneNumberId = 'phoneNumberId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCompanyPhoneNumberUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCompanyPhoneNumberSetInput>;
  /** filter the rows which have to be updated */
  where: TixCompanyPhoneNumberBoolExp;
};

/** columns and relationships of "media.company_social_media" */
export type TixCompanySocialMedia = {
  __typename?: 'CompanySocialMedia';
  /** An object relationship */
  Company: TixCompany;
  companyId: Scalars['uuid'];
  companySocialMediaId: Scalars['uuid'];
  /** An object relationship */
  socialMedia: TixSocialMedia;
  socialMediaId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "media.company_social_media" */
export type TixCompanySocialMediaAggregate = {
  __typename?: 'CompanySocialMedia_aggregate';
  aggregate?: Maybe<TixCompanySocialMediaAggregateFields>;
  nodes: Array<TixCompanySocialMedia>;
};

export type TixCompanySocialMediaAggregateBoolExp = {
  count?: InputMaybe<TixCompanySocialMediaAggregateBoolExpCount>;
};

export type TixCompanySocialMediaAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixCompanySocialMediaBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "media.company_social_media" */
export type TixCompanySocialMediaAggregateFields = {
  __typename?: 'CompanySocialMedia_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCompanySocialMediaMaxFields>;
  min?: Maybe<TixCompanySocialMediaMinFields>;
};


/** aggregate fields of "media.company_social_media" */
export type TixCompanySocialMediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media.company_social_media" */
export type TixCompanySocialMediaAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixCompanySocialMediaMaxOrderBy>;
  min?: InputMaybe<TixCompanySocialMediaMinOrderBy>;
};

/** input type for inserting array relation for remote table "media.company_social_media" */
export type TixCompanySocialMediaArrRelInsertInput = {
  data: Array<TixCompanySocialMediaInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanySocialMediaOnConflict>;
};

/** Boolean expression to filter rows from the table "media.company_social_media". All fields are combined with a logical 'AND'. */
export type TixCompanySocialMediaBoolExp = {
  Company?: InputMaybe<TixCompanyBoolExp>;
  _and?: InputMaybe<Array<TixCompanySocialMediaBoolExp>>;
  _not?: InputMaybe<TixCompanySocialMediaBoolExp>;
  _or?: InputMaybe<Array<TixCompanySocialMediaBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companySocialMediaId?: InputMaybe<TixUuidComparisonExp>;
  socialMedia?: InputMaybe<TixSocialMediaBoolExp>;
  socialMediaId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "media.company_social_media" */
export enum TixCompanySocialMediaConstraint {
  /** unique or primary key constraint on columns "company_social_media_id" */
  CompanySocialMediaIdPkey = 'company_social_media_id_pkey'
}

/** input type for inserting data into table "media.company_social_media" */
export type TixCompanySocialMediaInsertInput = {
  Company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companySocialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMedia?: InputMaybe<TixSocialMediaObjRelInsertInput>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCompanySocialMediaMaxFields = {
  __typename?: 'CompanySocialMedia_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companySocialMediaId?: Maybe<Scalars['uuid']>;
  socialMediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "media.company_social_media" */
export type TixCompanySocialMediaMaxOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companySocialMediaId?: InputMaybe<TixOrderBy>;
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixCompanySocialMediaMinFields = {
  __typename?: 'CompanySocialMedia_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companySocialMediaId?: Maybe<Scalars['uuid']>;
  socialMediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "media.company_social_media" */
export type TixCompanySocialMediaMinOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companySocialMediaId?: InputMaybe<TixOrderBy>;
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "media.company_social_media" */
export type TixCompanySocialMediaMutationResponse = {
  __typename?: 'CompanySocialMedia_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCompanySocialMedia>;
};

/** on_conflict condition type for table "media.company_social_media" */
export type TixCompanySocialMediaOnConflict = {
  constraint: TixCompanySocialMediaConstraint;
  update_columns?: Array<TixCompanySocialMediaUpdateColumn>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};

/** Ordering options when selecting data from "media.company_social_media". */
export type TixCompanySocialMediaOrderBy = {
  Company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companySocialMediaId?: InputMaybe<TixOrderBy>;
  socialMedia?: InputMaybe<TixSocialMediaOrderBy>;
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: media.company_social_media */
export type TixCompanySocialMediaPkColumnsInput = {
  companySocialMediaId: Scalars['uuid'];
};

/** select columns of table "media.company_social_media" */
export enum TixCompanySocialMediaSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanySocialMediaId = 'companySocialMediaId',
  /** column name */
  SocialMediaId = 'socialMediaId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "media.company_social_media" */
export type TixCompanySocialMediaSetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companySocialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "CompanySocialMedia" */
export type TixCompanySocialMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanySocialMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanySocialMediaStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companySocialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.company_social_media" */
export enum TixCompanySocialMediaUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanySocialMediaId = 'companySocialMediaId',
  /** column name */
  SocialMediaId = 'socialMediaId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCompanySocialMediaUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCompanySocialMediaSetInput>;
  /** filter the rows which have to be updated */
  where: TixCompanySocialMediaBoolExp;
};

/** columns and relationships of "reporting.v_company_summary_report" */
export type TixCompanySummaryReport = {
  __typename?: 'CompanySummaryReport';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['numeric']>;
  eventDate?: Maybe<Scalars['date']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  noTicketsSold?: Maybe<Scalars['numeric']>;
  paymenttoken?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationno?: Maybe<Scalars['String']>;
  showRevenue?: Maybe<Scalars['numeric']>;
  startTime?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['numeric']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketname?: Maybe<Scalars['String']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalFees?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_company_summary_report" */
export type TixCompanySummaryReportAggregate = {
  __typename?: 'CompanySummaryReport_aggregate';
  aggregate?: Maybe<TixCompanySummaryReportAggregateFields>;
  nodes: Array<TixCompanySummaryReport>;
};

/** aggregate fields of "reporting.v_company_summary_report" */
export type TixCompanySummaryReportAggregateFields = {
  __typename?: 'CompanySummaryReport_aggregate_fields';
  avg?: Maybe<TixCompanySummaryReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixCompanySummaryReportMaxFields>;
  min?: Maybe<TixCompanySummaryReportMinFields>;
  stddev?: Maybe<TixCompanySummaryReportStddevFields>;
  stddev_pop?: Maybe<TixCompanySummaryReportStddevPopFields>;
  stddev_samp?: Maybe<TixCompanySummaryReportStddevSampFields>;
  sum?: Maybe<TixCompanySummaryReportSumFields>;
  var_pop?: Maybe<TixCompanySummaryReportVarPopFields>;
  var_samp?: Maybe<TixCompanySummaryReportVarSampFields>;
  variance?: Maybe<TixCompanySummaryReportVarianceFields>;
};


/** aggregate fields of "reporting.v_company_summary_report" */
export type TixCompanySummaryReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanySummaryReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixCompanySummaryReportAvgFields = {
  __typename?: 'CompanySummaryReport_avg_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  noTicketsSold?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_company_summary_report". All fields are combined with a logical 'AND'. */
export type TixCompanySummaryReportBoolExp = {
  _and?: InputMaybe<Array<TixCompanySummaryReportBoolExp>>;
  _not?: InputMaybe<TixCompanySummaryReportBoolExp>;
  _or?: InputMaybe<Array<TixCompanySummaryReportBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  discountAmount?: InputMaybe<TixNumericComparisonExp>;
  eventDate?: InputMaybe<TixDateComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  noTicketsSold?: InputMaybe<TixNumericComparisonExp>;
  paymenttoken?: InputMaybe<TixStringComparisonExp>;
  platformFee?: InputMaybe<TixNumericComparisonExp>;
  processingFee?: InputMaybe<TixNumericComparisonExp>;
  refundAmount?: InputMaybe<TixNumericComparisonExp>;
  reservationno?: InputMaybe<TixStringComparisonExp>;
  showRevenue?: InputMaybe<TixNumericComparisonExp>;
  startTime?: InputMaybe<TixStringComparisonExp>;
  subtotal?: InputMaybe<TixNumericComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  ticketname?: InputMaybe<TixStringComparisonExp>;
  totalAmountPaid?: InputMaybe<TixNumericComparisonExp>;
  totalFees?: InputMaybe<TixNumericComparisonExp>;
  venueFee?: InputMaybe<TixNumericComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixCompanySummaryReportMaxFields = {
  __typename?: 'CompanySummaryReport_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['numeric']>;
  eventDate?: Maybe<Scalars['date']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  noTicketsSold?: Maybe<Scalars['numeric']>;
  paymenttoken?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationno?: Maybe<Scalars['String']>;
  showRevenue?: Maybe<Scalars['numeric']>;
  startTime?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['numeric']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketname?: Maybe<Scalars['String']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalFees?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixCompanySummaryReportMinFields = {
  __typename?: 'CompanySummaryReport_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['numeric']>;
  eventDate?: Maybe<Scalars['date']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  noTicketsSold?: Maybe<Scalars['numeric']>;
  paymenttoken?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationno?: Maybe<Scalars['String']>;
  showRevenue?: Maybe<Scalars['numeric']>;
  startTime?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['numeric']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketname?: Maybe<Scalars['String']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalFees?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reporting.v_company_summary_report". */
export type TixCompanySummaryReportOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  eventDate?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  noTicketsSold?: InputMaybe<TixOrderBy>;
  paymenttoken?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  reservationno?: InputMaybe<TixOrderBy>;
  showRevenue?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  subtotal?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  ticketname?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  totalFees?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_company_summary_report" */
export enum TixCompanySummaryReportSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  EventDate = 'eventDate',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventState = 'eventState',
  /** column name */
  NoTicketsSold = 'noTicketsSold',
  /** column name */
  Paymenttoken = 'paymenttoken',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  Reservationno = 'reservationno',
  /** column name */
  ShowRevenue = 'showRevenue',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  Ticketname = 'ticketname',
  /** column name */
  TotalAmountPaid = 'totalAmountPaid',
  /** column name */
  TotalFees = 'totalFees',
  /** column name */
  VenueFee = 'venueFee',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName'
}

/** aggregate stddev on columns */
export type TixCompanySummaryReportStddevFields = {
  __typename?: 'CompanySummaryReport_stddev_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  noTicketsSold?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixCompanySummaryReportStddevPopFields = {
  __typename?: 'CompanySummaryReport_stddev_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  noTicketsSold?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixCompanySummaryReportStddevSampFields = {
  __typename?: 'CompanySummaryReport_stddev_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  noTicketsSold?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "CompanySummaryReport" */
export type TixCompanySummaryReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanySummaryReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanySummaryReportStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  discountAmount?: InputMaybe<Scalars['numeric']>;
  eventDate?: InputMaybe<Scalars['date']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  noTicketsSold?: InputMaybe<Scalars['numeric']>;
  paymenttoken?: InputMaybe<Scalars['String']>;
  platformFee?: InputMaybe<Scalars['numeric']>;
  processingFee?: InputMaybe<Scalars['numeric']>;
  refundAmount?: InputMaybe<Scalars['numeric']>;
  reservationno?: InputMaybe<Scalars['String']>;
  showRevenue?: InputMaybe<Scalars['numeric']>;
  startTime?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['numeric']>;
  ticketType?: InputMaybe<Scalars['String']>;
  ticketname?: InputMaybe<Scalars['String']>;
  totalAmountPaid?: InputMaybe<Scalars['numeric']>;
  totalFees?: InputMaybe<Scalars['numeric']>;
  venueFee?: InputMaybe<Scalars['numeric']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixCompanySummaryReportSumFields = {
  __typename?: 'CompanySummaryReport_sum_fields';
  discountAmount?: Maybe<Scalars['numeric']>;
  noTicketsSold?: Maybe<Scalars['numeric']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  showRevenue?: Maybe<Scalars['numeric']>;
  subtotal?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalFees?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type TixCompanySummaryReportVarPopFields = {
  __typename?: 'CompanySummaryReport_var_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  noTicketsSold?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixCompanySummaryReportVarSampFields = {
  __typename?: 'CompanySummaryReport_var_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  noTicketsSold?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixCompanySummaryReportVarianceFields = {
  __typename?: 'CompanySummaryReport_variance_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  noTicketsSold?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** company warning message */
export type TixCompanyWarning = {
  __typename?: 'CompanyWarning';
  /** An object relationship */
  company: TixCompany;
  companyId: Scalars['uuid'];
  companyWarningId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  warning: TixWarning;
  warningId: Scalars['uuid'];
};

/** aggregated selection of "warning.company_warning" */
export type TixCompanyWarningAggregate = {
  __typename?: 'CompanyWarning_aggregate';
  aggregate?: Maybe<TixCompanyWarningAggregateFields>;
  nodes: Array<TixCompanyWarning>;
};

export type TixCompanyWarningAggregateBoolExp = {
  count?: InputMaybe<TixCompanyWarningAggregateBoolExpCount>;
};

export type TixCompanyWarningAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixCompanyWarningBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "warning.company_warning" */
export type TixCompanyWarningAggregateFields = {
  __typename?: 'CompanyWarning_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCompanyWarningMaxFields>;
  min?: Maybe<TixCompanyWarningMinFields>;
};


/** aggregate fields of "warning.company_warning" */
export type TixCompanyWarningAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "warning.company_warning" */
export type TixCompanyWarningAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixCompanyWarningMaxOrderBy>;
  min?: InputMaybe<TixCompanyWarningMinOrderBy>;
};

/** input type for inserting array relation for remote table "warning.company_warning" */
export type TixCompanyWarningArrRelInsertInput = {
  data: Array<TixCompanyWarningInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyWarningOnConflict>;
};

/** Boolean expression to filter rows from the table "warning.company_warning". All fields are combined with a logical 'AND'. */
export type TixCompanyWarningBoolExp = {
  _and?: InputMaybe<Array<TixCompanyWarningBoolExp>>;
  _not?: InputMaybe<TixCompanyWarningBoolExp>;
  _or?: InputMaybe<Array<TixCompanyWarningBoolExp>>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyWarningId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  warning?: InputMaybe<TixWarningBoolExp>;
  warningId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "warning.company_warning" */
export enum TixCompanyWarningConstraint {
  /** unique or primary key constraint on columns "company_warning_id" */
  CompanyWarningPkey = 'company_warning_pkey',
  /** unique or primary key constraint on columns "warning_id" */
  CompanyWarningWarningIdKey = 'company_warning_warning_id_key'
}

/** input type for inserting data into table "warning.company_warning" */
export type TixCompanyWarningInsertInput = {
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyWarningId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  warning?: InputMaybe<TixWarningObjRelInsertInput>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCompanyWarningMaxFields = {
  __typename?: 'CompanyWarning_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyWarningId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  warningId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "warning.company_warning" */
export type TixCompanyWarningMaxOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyWarningId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  warningId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixCompanyWarningMinFields = {
  __typename?: 'CompanyWarning_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyWarningId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  warningId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "warning.company_warning" */
export type TixCompanyWarningMinOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyWarningId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  warningId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "warning.company_warning" */
export type TixCompanyWarningMutationResponse = {
  __typename?: 'CompanyWarning_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCompanyWarning>;
};

/** on_conflict condition type for table "warning.company_warning" */
export type TixCompanyWarningOnConflict = {
  constraint: TixCompanyWarningConstraint;
  update_columns?: Array<TixCompanyWarningUpdateColumn>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};

/** Ordering options when selecting data from "warning.company_warning". */
export type TixCompanyWarningOrderBy = {
  company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyWarningId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  warning?: InputMaybe<TixWarningOrderBy>;
  warningId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: warning.company_warning */
export type TixCompanyWarningPkColumnsInput = {
  companyWarningId: Scalars['uuid'];
};

/** select columns of table "warning.company_warning" */
export enum TixCompanyWarningSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyWarningId = 'companyWarningId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WarningId = 'warningId'
}

/** input type for updating data in table "warning.company_warning" */
export type TixCompanyWarningSetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyWarningId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "CompanyWarning" */
export type TixCompanyWarningStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanyWarningStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanyWarningStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyWarningId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "warning.company_warning" */
export enum TixCompanyWarningUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyWarningId = 'companyWarningId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WarningId = 'warningId'
}

export type TixCompanyWarningUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCompanyWarningSetInput>;
  /** filter the rows which have to be updated */
  where: TixCompanyWarningBoolExp;
};

/** aggregated selection of "company.company" */
export type TixCompanyAggregate = {
  __typename?: 'Company_aggregate';
  aggregate?: Maybe<TixCompanyAggregateFields>;
  nodes: Array<TixCompany>;
};

/** aggregate fields of "company.company" */
export type TixCompanyAggregateFields = {
  __typename?: 'Company_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCompanyMaxFields>;
  min?: Maybe<TixCompanyMinFields>;
};


/** aggregate fields of "company.company" */
export type TixCompanyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCompanySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company.company". All fields are combined with a logical 'AND'. */
export type TixCompanyBoolExp = {
  _and?: InputMaybe<Array<TixCompanyBoolExp>>;
  _not?: InputMaybe<TixCompanyBoolExp>;
  _or?: InputMaybe<Array<TixCompanyBoolExp>>;
  addresses?: InputMaybe<TixCompanyAddressBoolExp>;
  addresses_aggregate?: InputMaybe<TixCompanyAddressAggregateBoolExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyVenueEvents?: InputMaybe<TixEventCompanyVenueBoolExp>;
  companyVenueEvents_aggregate?: InputMaybe<TixEventCompanyVenueAggregateBoolExp>;
  configurationValues?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
  configurationValues_aggregate?: InputMaybe<TixCompanyConfigurationValueAggregateBoolExp>;
  contacts?: InputMaybe<TixCompanyContactBoolExp>;
  contacts_aggregate?: InputMaybe<TixCompanyContactAggregateBoolExp>;
  is_platform_company?: InputMaybe<TixBooleanComparisonExp>;
  mediaFiles?: InputMaybe<TixCompanyMediaFileBoolExp>;
  mediaFiles_aggregate?: InputMaybe<TixCompanyMediaFileAggregateBoolExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  parentCompanyId?: InputMaybe<TixUuidComparisonExp>;
  payouts?: InputMaybe<TixPayoutBoolExp>;
  payouts_aggregate?: InputMaybe<TixPayoutAggregateBoolExp>;
  performers?: InputMaybe<TixPerformerBoolExp>;
  performers_aggregate?: InputMaybe<TixPerformerAggregateBoolExp>;
  phoneNumbers?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
  phoneNumbers_aggregate?: InputMaybe<TixCompanyPhoneNumberAggregateBoolExp>;
  policy?: InputMaybe<TixUtilityPolicyBoolExp>;
  policy_aggregate?: InputMaybe<TixUtilityPolicyAggregateBoolExp>;
  socialMediaLinks?: InputMaybe<TixCompanySocialMediaBoolExp>;
  socialMediaLinks_aggregate?: InputMaybe<TixCompanySocialMediaAggregateBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  url?: InputMaybe<TixStringComparisonExp>;
  venues?: InputMaybe<TixVenueBoolExp>;
  venues_aggregate?: InputMaybe<TixVenueAggregateBoolExp>;
  warnings?: InputMaybe<TixCompanyWarningBoolExp>;
  warnings_aggregate?: InputMaybe<TixCompanyWarningAggregateBoolExp>;
};

/** unique or primary key constraints on table "company.company" */
export enum TixCompanyConstraint {
  /** unique or primary key constraint on columns "company_id" */
  CompanyPkey = 'company_pkey'
}

/** input type for inserting data into table "company.company" */
export type TixCompanyInsertInput = {
  addresses?: InputMaybe<TixCompanyAddressArrRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyVenueEvents?: InputMaybe<TixEventCompanyVenueArrRelInsertInput>;
  configurationValues?: InputMaybe<TixCompanyConfigurationValueArrRelInsertInput>;
  contacts?: InputMaybe<TixCompanyContactArrRelInsertInput>;
  is_platform_company?: InputMaybe<Scalars['Boolean']>;
  mediaFiles?: InputMaybe<TixCompanyMediaFileArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  parentCompanyId?: InputMaybe<Scalars['uuid']>;
  payouts?: InputMaybe<TixPayoutArrRelInsertInput>;
  performers?: InputMaybe<TixPerformerArrRelInsertInput>;
  phoneNumbers?: InputMaybe<TixCompanyPhoneNumberArrRelInsertInput>;
  policy?: InputMaybe<TixUtilityPolicyArrRelInsertInput>;
  socialMediaLinks?: InputMaybe<TixCompanySocialMediaArrRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
  venues?: InputMaybe<TixVenueArrRelInsertInput>;
  warnings?: InputMaybe<TixCompanyWarningArrRelInsertInput>;
};

/** aggregate max on columns */
export type TixCompanyMaxFields = {
  __typename?: 'Company_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentCompanyId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixCompanyMinFields = {
  __typename?: 'Company_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentCompanyId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company.company" */
export type TixCompanyMutationResponse = {
  __typename?: 'Company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCompany>;
};

/** input type for inserting object relation for remote table "company.company" */
export type TixCompanyObjRelInsertInput = {
  data: TixCompanyInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCompanyOnConflict>;
};

/** on_conflict condition type for table "company.company" */
export type TixCompanyOnConflict = {
  constraint: TixCompanyConstraint;
  update_columns?: Array<TixCompanyUpdateColumn>;
  where?: InputMaybe<TixCompanyBoolExp>;
};

/** Ordering options when selecting data from "company.company". */
export type TixCompanyOrderBy = {
  addresses_aggregate?: InputMaybe<TixCompanyAddressAggregateOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyVenueEvents_aggregate?: InputMaybe<TixEventCompanyVenueAggregateOrderBy>;
  configurationValues_aggregate?: InputMaybe<TixCompanyConfigurationValueAggregateOrderBy>;
  contacts_aggregate?: InputMaybe<TixCompanyContactAggregateOrderBy>;
  is_platform_company?: InputMaybe<TixOrderBy>;
  mediaFiles_aggregate?: InputMaybe<TixCompanyMediaFileAggregateOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  parentCompanyId?: InputMaybe<TixOrderBy>;
  payouts_aggregate?: InputMaybe<TixPayoutAggregateOrderBy>;
  performers_aggregate?: InputMaybe<TixPerformerAggregateOrderBy>;
  phoneNumbers_aggregate?: InputMaybe<TixCompanyPhoneNumberAggregateOrderBy>;
  policy_aggregate?: InputMaybe<TixUtilityPolicyAggregateOrderBy>;
  socialMediaLinks_aggregate?: InputMaybe<TixCompanySocialMediaAggregateOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  url?: InputMaybe<TixOrderBy>;
  venues_aggregate?: InputMaybe<TixVenueAggregateOrderBy>;
  warnings_aggregate?: InputMaybe<TixCompanyWarningAggregateOrderBy>;
};

/** primary key columns input for table: company.company */
export type TixCompanyPkColumnsInput = {
  companyId: Scalars['uuid'];
};

/** select columns of table "company.company" */
export enum TixCompanySelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  IsPlatformCompany = 'is_platform_company',
  /** column name */
  Name = 'name',
  /** column name */
  ParentCompanyId = 'parentCompanyId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "company.company" */
export type TixCompanySetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  is_platform_company?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentCompanyId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Company" */
export type TixCompanyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCompanyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCompanyStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  is_platform_company?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentCompanyId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "company.company" */
export enum TixCompanyUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  IsPlatformCompany = 'is_platform_company',
  /** column name */
  Name = 'name',
  /** column name */
  ParentCompanyId = 'parentCompanyId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url'
}

export type TixCompanyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCompanySetInput>;
  /** filter the rows which have to be updated */
  where: TixCompanyBoolExp;
};

/** columns and relationships of "configuration.configuration_group" */
export type TixConfigurationGroup = {
  __typename?: 'ConfigurationGroup';
  configGroupType?: Maybe<Scalars['String']>;
  configurationGroupId: Scalars['uuid'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  groupItem?: Maybe<TixConfigurationGroupItem>;
  /** An array relationship */
  groupItems: Array<TixConfigurationGroupItem>;
  /** An aggregate relationship */
  groupItems_aggregate: TixConfigurationGroupItemAggregate;
  name: Scalars['String'];
  state: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "configuration.configuration_group" */
export type TixConfigurationGroupGroupItemsArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupItemOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupItemBoolExp>;
};


/** columns and relationships of "configuration.configuration_group" */
export type TixConfigurationGroupGroupItemsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupItemOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupItemBoolExp>;
};

/** columns and relationships of "configuration.configuration_group_item" */
export type TixConfigurationGroupItem = {
  __typename?: 'ConfigurationGroupItem';
  /** An object relationship */
  Group?: Maybe<TixConfigurationGroup>;
  /** An object relationship */
  Item?: Maybe<TixConfigurationItem>;
  configurationGroupId: Scalars['uuid'];
  configurationGroupItemId: Scalars['uuid'];
  configurationItemId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  viewOrder?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "configuration.configuration_group_item" */
export type TixConfigurationGroupItemAggregate = {
  __typename?: 'ConfigurationGroupItem_aggregate';
  aggregate?: Maybe<TixConfigurationGroupItemAggregateFields>;
  nodes: Array<TixConfigurationGroupItem>;
};

export type TixConfigurationGroupItemAggregateBoolExp = {
  count?: InputMaybe<TixConfigurationGroupItemAggregateBoolExpCount>;
};

export type TixConfigurationGroupItemAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixConfigurationGroupItemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixConfigurationGroupItemBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "configuration.configuration_group_item" */
export type TixConfigurationGroupItemAggregateFields = {
  __typename?: 'ConfigurationGroupItem_aggregate_fields';
  avg?: Maybe<TixConfigurationGroupItemAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixConfigurationGroupItemMaxFields>;
  min?: Maybe<TixConfigurationGroupItemMinFields>;
  stddev?: Maybe<TixConfigurationGroupItemStddevFields>;
  stddev_pop?: Maybe<TixConfigurationGroupItemStddevPopFields>;
  stddev_samp?: Maybe<TixConfigurationGroupItemStddevSampFields>;
  sum?: Maybe<TixConfigurationGroupItemSumFields>;
  var_pop?: Maybe<TixConfigurationGroupItemVarPopFields>;
  var_samp?: Maybe<TixConfigurationGroupItemVarSampFields>;
  variance?: Maybe<TixConfigurationGroupItemVarianceFields>;
};


/** aggregate fields of "configuration.configuration_group_item" */
export type TixConfigurationGroupItemAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixConfigurationGroupItemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemAggregateOrderBy = {
  avg?: InputMaybe<TixConfigurationGroupItemAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixConfigurationGroupItemMaxOrderBy>;
  min?: InputMaybe<TixConfigurationGroupItemMinOrderBy>;
  stddev?: InputMaybe<TixConfigurationGroupItemStddevOrderBy>;
  stddev_pop?: InputMaybe<TixConfigurationGroupItemStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixConfigurationGroupItemStddevSampOrderBy>;
  sum?: InputMaybe<TixConfigurationGroupItemSumOrderBy>;
  var_pop?: InputMaybe<TixConfigurationGroupItemVarPopOrderBy>;
  var_samp?: InputMaybe<TixConfigurationGroupItemVarSampOrderBy>;
  variance?: InputMaybe<TixConfigurationGroupItemVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemArrRelInsertInput = {
  data: Array<TixConfigurationGroupItemInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixConfigurationGroupItemOnConflict>;
};

/** aggregate avg on columns */
export type TixConfigurationGroupItemAvgFields = {
  __typename?: 'ConfigurationGroupItem_avg_fields';
  viewOrder?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemAvgOrderBy = {
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "configuration.configuration_group_item". All fields are combined with a logical 'AND'. */
export type TixConfigurationGroupItemBoolExp = {
  Group?: InputMaybe<TixConfigurationGroupBoolExp>;
  Item?: InputMaybe<TixConfigurationItemBoolExp>;
  _and?: InputMaybe<Array<TixConfigurationGroupItemBoolExp>>;
  _not?: InputMaybe<TixConfigurationGroupItemBoolExp>;
  _or?: InputMaybe<Array<TixConfigurationGroupItemBoolExp>>;
  configurationGroupId?: InputMaybe<TixUuidComparisonExp>;
  configurationGroupItemId?: InputMaybe<TixUuidComparisonExp>;
  configurationItemId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  viewOrder?: InputMaybe<TixIntComparisonExp>;
};

/** unique or primary key constraints on table "configuration.configuration_group_item" */
export enum TixConfigurationGroupItemConstraint {
  /** unique or primary key constraint on columns "configuration_group_item_id" */
  ConfigurationGroupItemPkey = 'configuration_group_item_pkey'
}

/** input type for incrementing numeric columns in table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemIncInput = {
  viewOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemInsertInput = {
  Group?: InputMaybe<TixConfigurationGroupObjRelInsertInput>;
  Item?: InputMaybe<TixConfigurationItemObjRelInsertInput>;
  configurationGroupId?: InputMaybe<Scalars['uuid']>;
  configurationGroupItemId?: InputMaybe<Scalars['uuid']>;
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  viewOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TixConfigurationGroupItemMaxFields = {
  __typename?: 'ConfigurationGroupItem_max_fields';
  configurationGroupId?: Maybe<Scalars['uuid']>;
  configurationGroupItemId?: Maybe<Scalars['uuid']>;
  configurationItemId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  viewOrder?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemMaxOrderBy = {
  configurationGroupId?: InputMaybe<TixOrderBy>;
  configurationGroupItemId?: InputMaybe<TixOrderBy>;
  configurationItemId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixConfigurationGroupItemMinFields = {
  __typename?: 'ConfigurationGroupItem_min_fields';
  configurationGroupId?: Maybe<Scalars['uuid']>;
  configurationGroupItemId?: Maybe<Scalars['uuid']>;
  configurationItemId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  viewOrder?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemMinOrderBy = {
  configurationGroupId?: InputMaybe<TixOrderBy>;
  configurationGroupItemId?: InputMaybe<TixOrderBy>;
  configurationItemId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemMutationResponse = {
  __typename?: 'ConfigurationGroupItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixConfigurationGroupItem>;
};

/** input type for inserting object relation for remote table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemObjRelInsertInput = {
  data: TixConfigurationGroupItemInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixConfigurationGroupItemOnConflict>;
};

/** on_conflict condition type for table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemOnConflict = {
  constraint: TixConfigurationGroupItemConstraint;
  update_columns?: Array<TixConfigurationGroupItemUpdateColumn>;
  where?: InputMaybe<TixConfigurationGroupItemBoolExp>;
};

/** Ordering options when selecting data from "configuration.configuration_group_item". */
export type TixConfigurationGroupItemOrderBy = {
  Group?: InputMaybe<TixConfigurationGroupOrderBy>;
  Item?: InputMaybe<TixConfigurationItemOrderBy>;
  configurationGroupId?: InputMaybe<TixOrderBy>;
  configurationGroupItemId?: InputMaybe<TixOrderBy>;
  configurationItemId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: configuration.configuration_group_item */
export type TixConfigurationGroupItemPkColumnsInput = {
  configurationGroupItemId: Scalars['uuid'];
};

/** select columns of table "configuration.configuration_group_item" */
export enum TixConfigurationGroupItemSelectColumn {
  /** column name */
  ConfigurationGroupId = 'configurationGroupId',
  /** column name */
  ConfigurationGroupItemId = 'configurationGroupItemId',
  /** column name */
  ConfigurationItemId = 'configurationItemId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  ViewOrder = 'viewOrder'
}

/** input type for updating data in table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemSetInput = {
  configurationGroupId?: InputMaybe<Scalars['uuid']>;
  configurationGroupItemId?: InputMaybe<Scalars['uuid']>;
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  viewOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TixConfigurationGroupItemStddevFields = {
  __typename?: 'ConfigurationGroupItem_stddev_fields';
  viewOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemStddevOrderBy = {
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixConfigurationGroupItemStddevPopFields = {
  __typename?: 'ConfigurationGroupItem_stddev_pop_fields';
  viewOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemStddevPopOrderBy = {
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixConfigurationGroupItemStddevSampFields = {
  __typename?: 'ConfigurationGroupItem_stddev_samp_fields';
  viewOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemStddevSampOrderBy = {
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "ConfigurationGroupItem" */
export type TixConfigurationGroupItemStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixConfigurationGroupItemStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixConfigurationGroupItemStreamCursorValueInput = {
  configurationGroupId?: InputMaybe<Scalars['uuid']>;
  configurationGroupItemId?: InputMaybe<Scalars['uuid']>;
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  viewOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TixConfigurationGroupItemSumFields = {
  __typename?: 'ConfigurationGroupItem_sum_fields';
  viewOrder?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemSumOrderBy = {
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** update columns of table "configuration.configuration_group_item" */
export enum TixConfigurationGroupItemUpdateColumn {
  /** column name */
  ConfigurationGroupId = 'configurationGroupId',
  /** column name */
  ConfigurationGroupItemId = 'configurationGroupItemId',
  /** column name */
  ConfigurationItemId = 'configurationItemId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  ViewOrder = 'viewOrder'
}

export type TixConfigurationGroupItemUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixConfigurationGroupItemIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixConfigurationGroupItemSetInput>;
  /** filter the rows which have to be updated */
  where: TixConfigurationGroupItemBoolExp;
};

/** aggregate var_pop on columns */
export type TixConfigurationGroupItemVarPopFields = {
  __typename?: 'ConfigurationGroupItem_var_pop_fields';
  viewOrder?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemVarPopOrderBy = {
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixConfigurationGroupItemVarSampFields = {
  __typename?: 'ConfigurationGroupItem_var_samp_fields';
  viewOrder?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemVarSampOrderBy = {
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixConfigurationGroupItemVarianceFields = {
  __typename?: 'ConfigurationGroupItem_variance_fields';
  viewOrder?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "configuration.configuration_group_item" */
export type TixConfigurationGroupItemVarianceOrderBy = {
  viewOrder?: InputMaybe<TixOrderBy>;
};

/** aggregated selection of "configuration.configuration_group" */
export type TixConfigurationGroupAggregate = {
  __typename?: 'ConfigurationGroup_aggregate';
  aggregate?: Maybe<TixConfigurationGroupAggregateFields>;
  nodes: Array<TixConfigurationGroup>;
};

/** aggregate fields of "configuration.configuration_group" */
export type TixConfigurationGroupAggregateFields = {
  __typename?: 'ConfigurationGroup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixConfigurationGroupMaxFields>;
  min?: Maybe<TixConfigurationGroupMinFields>;
};


/** aggregate fields of "configuration.configuration_group" */
export type TixConfigurationGroupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixConfigurationGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "configuration.configuration_group". All fields are combined with a logical 'AND'. */
export type TixConfigurationGroupBoolExp = {
  _and?: InputMaybe<Array<TixConfigurationGroupBoolExp>>;
  _not?: InputMaybe<TixConfigurationGroupBoolExp>;
  _or?: InputMaybe<Array<TixConfigurationGroupBoolExp>>;
  configGroupType?: InputMaybe<TixStringComparisonExp>;
  configurationGroupId?: InputMaybe<TixUuidComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  groupItem?: InputMaybe<TixConfigurationGroupItemBoolExp>;
  groupItems?: InputMaybe<TixConfigurationGroupItemBoolExp>;
  groupItems_aggregate?: InputMaybe<TixConfigurationGroupItemAggregateBoolExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "configuration.configuration_group" */
export enum TixConfigurationGroupConstraint {
  /** unique or primary key constraint on columns "configuration_group_id" */
  ConfigurationGroupPkey = 'configuration_group_pkey'
}

/** input type for inserting data into table "configuration.configuration_group" */
export type TixConfigurationGroupInsertInput = {
  configGroupType?: InputMaybe<Scalars['String']>;
  configurationGroupId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  groupItem?: InputMaybe<TixConfigurationGroupItemObjRelInsertInput>;
  groupItems?: InputMaybe<TixConfigurationGroupItemArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixConfigurationGroupMaxFields = {
  __typename?: 'ConfigurationGroup_max_fields';
  configGroupType?: Maybe<Scalars['String']>;
  configurationGroupId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixConfigurationGroupMinFields = {
  __typename?: 'ConfigurationGroup_min_fields';
  configGroupType?: Maybe<Scalars['String']>;
  configurationGroupId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "configuration.configuration_group" */
export type TixConfigurationGroupMutationResponse = {
  __typename?: 'ConfigurationGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixConfigurationGroup>;
};

/** input type for inserting object relation for remote table "configuration.configuration_group" */
export type TixConfigurationGroupObjRelInsertInput = {
  data: TixConfigurationGroupInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixConfigurationGroupOnConflict>;
};

/** on_conflict condition type for table "configuration.configuration_group" */
export type TixConfigurationGroupOnConflict = {
  constraint: TixConfigurationGroupConstraint;
  update_columns?: Array<TixConfigurationGroupUpdateColumn>;
  where?: InputMaybe<TixConfigurationGroupBoolExp>;
};

/** Ordering options when selecting data from "configuration.configuration_group". */
export type TixConfigurationGroupOrderBy = {
  configGroupType?: InputMaybe<TixOrderBy>;
  configurationGroupId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  groupItem?: InputMaybe<TixConfigurationGroupItemOrderBy>;
  groupItems_aggregate?: InputMaybe<TixConfigurationGroupItemAggregateOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: configuration.configuration_group */
export type TixConfigurationGroupPkColumnsInput = {
  configurationGroupId: Scalars['uuid'];
};

/** select columns of table "configuration.configuration_group" */
export enum TixConfigurationGroupSelectColumn {
  /** column name */
  ConfigGroupType = 'configGroupType',
  /** column name */
  ConfigurationGroupId = 'configurationGroupId',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "configuration.configuration_group" */
export type TixConfigurationGroupSetInput = {
  configGroupType?: InputMaybe<Scalars['String']>;
  configurationGroupId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ConfigurationGroup" */
export type TixConfigurationGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixConfigurationGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixConfigurationGroupStreamCursorValueInput = {
  configGroupType?: InputMaybe<Scalars['String']>;
  configurationGroupId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "configuration.configuration_group" */
export enum TixConfigurationGroupUpdateColumn {
  /** column name */
  ConfigGroupType = 'configGroupType',
  /** column name */
  ConfigurationGroupId = 'configurationGroupId',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixConfigurationGroupUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixConfigurationGroupSetInput>;
  /** filter the rows which have to be updated */
  where: TixConfigurationGroupBoolExp;
};

/** this will be used for configuring certain items related to a company, venue, event, event instance set up. */
export type TixConfigurationItem = {
  __typename?: 'ConfigurationItem';
  /** An object relationship */
  GroupItem?: Maybe<TixConfigurationGroupItem>;
  /** An array relationship */
  Values: Array<TixConfigurationValue>;
  /** An aggregate relationship */
  Values_aggregate: TixConfigurationValueAggregate;
  configurationItemId: Scalars['uuid'];
  defaultValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  helpText?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  regex?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** this will be used for configuring certain items related to a company, venue, event, event instance set up. */
export type TixConfigurationItemValuesArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationValueOrderBy>>;
  where?: InputMaybe<TixConfigurationValueBoolExp>;
};


/** this will be used for configuring certain items related to a company, venue, event, event instance set up. */
export type TixConfigurationItemValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationValueOrderBy>>;
  where?: InputMaybe<TixConfigurationValueBoolExp>;
};

/** aggregated selection of "configuration.configuration_item" */
export type TixConfigurationItemAggregate = {
  __typename?: 'ConfigurationItem_aggregate';
  aggregate?: Maybe<TixConfigurationItemAggregateFields>;
  nodes: Array<TixConfigurationItem>;
};

/** aggregate fields of "configuration.configuration_item" */
export type TixConfigurationItemAggregateFields = {
  __typename?: 'ConfigurationItem_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixConfigurationItemMaxFields>;
  min?: Maybe<TixConfigurationItemMinFields>;
};


/** aggregate fields of "configuration.configuration_item" */
export type TixConfigurationItemAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixConfigurationItemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "configuration.configuration_item". All fields are combined with a logical 'AND'. */
export type TixConfigurationItemBoolExp = {
  GroupItem?: InputMaybe<TixConfigurationGroupItemBoolExp>;
  Values?: InputMaybe<TixConfigurationValueBoolExp>;
  Values_aggregate?: InputMaybe<TixConfigurationValueAggregateBoolExp>;
  _and?: InputMaybe<Array<TixConfigurationItemBoolExp>>;
  _not?: InputMaybe<TixConfigurationItemBoolExp>;
  _or?: InputMaybe<Array<TixConfigurationItemBoolExp>>;
  configurationItemId?: InputMaybe<TixUuidComparisonExp>;
  defaultValue?: InputMaybe<TixStringComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  elementType?: InputMaybe<TixStringComparisonExp>;
  helpText?: InputMaybe<TixStringComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  placeholder?: InputMaybe<TixStringComparisonExp>;
  regex?: InputMaybe<TixStringComparisonExp>;
  required?: InputMaybe<TixBooleanComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "configuration.configuration_item" */
export enum TixConfigurationItemConstraint {
  /** unique or primary key constraint on columns "configuration_item_id" */
  ConfigurationItemPkey = 'configuration_item_pkey'
}

/** input type for inserting data into table "configuration.configuration_item" */
export type TixConfigurationItemInsertInput = {
  GroupItem?: InputMaybe<TixConfigurationGroupItemObjRelInsertInput>;
  Values?: InputMaybe<TixConfigurationValueArrRelInsertInput>;
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  elementType?: InputMaybe<Scalars['String']>;
  helpText?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  regex?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixConfigurationItemMaxFields = {
  __typename?: 'ConfigurationItem_max_fields';
  configurationItemId?: Maybe<Scalars['uuid']>;
  defaultValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  helpText?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  regex?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixConfigurationItemMinFields = {
  __typename?: 'ConfigurationItem_min_fields';
  configurationItemId?: Maybe<Scalars['uuid']>;
  defaultValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  elementType?: Maybe<Scalars['String']>;
  helpText?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  regex?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "configuration.configuration_item" */
export type TixConfigurationItemMutationResponse = {
  __typename?: 'ConfigurationItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixConfigurationItem>;
};

/** input type for inserting object relation for remote table "configuration.configuration_item" */
export type TixConfigurationItemObjRelInsertInput = {
  data: TixConfigurationItemInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixConfigurationItemOnConflict>;
};

/** on_conflict condition type for table "configuration.configuration_item" */
export type TixConfigurationItemOnConflict = {
  constraint: TixConfigurationItemConstraint;
  update_columns?: Array<TixConfigurationItemUpdateColumn>;
  where?: InputMaybe<TixConfigurationItemBoolExp>;
};

/** Ordering options when selecting data from "configuration.configuration_item". */
export type TixConfigurationItemOrderBy = {
  GroupItem?: InputMaybe<TixConfigurationGroupItemOrderBy>;
  Values_aggregate?: InputMaybe<TixConfigurationValueAggregateOrderBy>;
  configurationItemId?: InputMaybe<TixOrderBy>;
  defaultValue?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  elementType?: InputMaybe<TixOrderBy>;
  helpText?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  placeholder?: InputMaybe<TixOrderBy>;
  regex?: InputMaybe<TixOrderBy>;
  required?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: configuration.configuration_item */
export type TixConfigurationItemPkColumnsInput = {
  configurationItemId: Scalars['uuid'];
};

/** select columns of table "configuration.configuration_item" */
export enum TixConfigurationItemSelectColumn {
  /** column name */
  ConfigurationItemId = 'configurationItemId',
  /** column name */
  DefaultValue = 'defaultValue',
  /** column name */
  Description = 'description',
  /** column name */
  ElementType = 'elementType',
  /** column name */
  HelpText = 'helpText',
  /** column name */
  Name = 'name',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  Regex = 'regex',
  /** column name */
  Required = 'required',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "configuration.configuration_item" */
export type TixConfigurationItemSetInput = {
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  elementType?: InputMaybe<Scalars['String']>;
  helpText?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  regex?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ConfigurationItem" */
export type TixConfigurationItemStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixConfigurationItemStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixConfigurationItemStreamCursorValueInput = {
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  elementType?: InputMaybe<Scalars['String']>;
  helpText?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  regex?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "configuration.configuration_item" */
export enum TixConfigurationItemUpdateColumn {
  /** column name */
  ConfigurationItemId = 'configurationItemId',
  /** column name */
  DefaultValue = 'defaultValue',
  /** column name */
  Description = 'description',
  /** column name */
  ElementType = 'elementType',
  /** column name */
  HelpText = 'helpText',
  /** column name */
  Name = 'name',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  Regex = 'regex',
  /** column name */
  Required = 'required',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixConfigurationItemUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixConfigurationItemSetInput>;
  /** filter the rows which have to be updated */
  where: TixConfigurationItemBoolExp;
};

/** this will be used to store the specifics about a configuration for a company, venue, event or event instance. */
export type TixConfigurationValue = {
  __typename?: 'ConfigurationValue';
  /** An object relationship */
  Item?: Maybe<TixConfigurationItem>;
  /** An object relationship */
  VenueValue?: Maybe<TixVenueConfigurationValue>;
  /** An object relationship */
  company_config_value?: Maybe<TixCompanyConfigurationValue>;
  configurationItemId: Scalars['uuid'];
  configurationValueId: Scalars['uuid'];
  /** An object relationship */
  event_instance_value?: Maybe<TixEventInstanceConfigurationValue>;
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  value: Scalars['String'];
};

/** aggregated selection of "configuration.configuration_value" */
export type TixConfigurationValueAggregate = {
  __typename?: 'ConfigurationValue_aggregate';
  aggregate?: Maybe<TixConfigurationValueAggregateFields>;
  nodes: Array<TixConfigurationValue>;
};

export type TixConfigurationValueAggregateBoolExp = {
  count?: InputMaybe<TixConfigurationValueAggregateBoolExpCount>;
};

export type TixConfigurationValueAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixConfigurationValueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixConfigurationValueBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "configuration.configuration_value" */
export type TixConfigurationValueAggregateFields = {
  __typename?: 'ConfigurationValue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixConfigurationValueMaxFields>;
  min?: Maybe<TixConfigurationValueMinFields>;
};


/** aggregate fields of "configuration.configuration_value" */
export type TixConfigurationValueAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixConfigurationValueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "configuration.configuration_value" */
export type TixConfigurationValueAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixConfigurationValueMaxOrderBy>;
  min?: InputMaybe<TixConfigurationValueMinOrderBy>;
};

/** input type for inserting array relation for remote table "configuration.configuration_value" */
export type TixConfigurationValueArrRelInsertInput = {
  data: Array<TixConfigurationValueInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixConfigurationValueOnConflict>;
};

/** Boolean expression to filter rows from the table "configuration.configuration_value". All fields are combined with a logical 'AND'. */
export type TixConfigurationValueBoolExp = {
  Item?: InputMaybe<TixConfigurationItemBoolExp>;
  VenueValue?: InputMaybe<TixVenueConfigurationValueBoolExp>;
  _and?: InputMaybe<Array<TixConfigurationValueBoolExp>>;
  _not?: InputMaybe<TixConfigurationValueBoolExp>;
  _or?: InputMaybe<Array<TixConfigurationValueBoolExp>>;
  company_config_value?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
  configurationItemId?: InputMaybe<TixUuidComparisonExp>;
  configurationValueId?: InputMaybe<TixUuidComparisonExp>;
  event_instance_value?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  value?: InputMaybe<TixStringComparisonExp>;
};

/** unique or primary key constraints on table "configuration.configuration_value" */
export enum TixConfigurationValueConstraint {
  /** unique or primary key constraint on columns "configuration_value_id" */
  ConfigurationValueConfigurationValueIdKey = 'configuration_value_configuration_value_id_key',
  /** unique or primary key constraint on columns "configuration_value_id" */
  ConfigurationValuePkey = 'configuration_value_pkey'
}

/** input type for inserting data into table "configuration.configuration_value" */
export type TixConfigurationValueInsertInput = {
  Item?: InputMaybe<TixConfigurationItemObjRelInsertInput>;
  VenueValue?: InputMaybe<TixVenueConfigurationValueObjRelInsertInput>;
  company_config_value?: InputMaybe<TixCompanyConfigurationValueObjRelInsertInput>;
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  event_instance_value?: InputMaybe<TixEventInstanceConfigurationValueObjRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TixConfigurationValueMaxFields = {
  __typename?: 'ConfigurationValue_max_fields';
  configurationItemId?: Maybe<Scalars['uuid']>;
  configurationValueId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "configuration.configuration_value" */
export type TixConfigurationValueMaxOrderBy = {
  configurationItemId?: InputMaybe<TixOrderBy>;
  configurationValueId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  value?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixConfigurationValueMinFields = {
  __typename?: 'ConfigurationValue_min_fields';
  configurationItemId?: Maybe<Scalars['uuid']>;
  configurationValueId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "configuration.configuration_value" */
export type TixConfigurationValueMinOrderBy = {
  configurationItemId?: InputMaybe<TixOrderBy>;
  configurationValueId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  value?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "configuration.configuration_value" */
export type TixConfigurationValueMutationResponse = {
  __typename?: 'ConfigurationValue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixConfigurationValue>;
};

/** input type for inserting object relation for remote table "configuration.configuration_value" */
export type TixConfigurationValueObjRelInsertInput = {
  data: TixConfigurationValueInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixConfigurationValueOnConflict>;
};

/** on_conflict condition type for table "configuration.configuration_value" */
export type TixConfigurationValueOnConflict = {
  constraint: TixConfigurationValueConstraint;
  update_columns?: Array<TixConfigurationValueUpdateColumn>;
  where?: InputMaybe<TixConfigurationValueBoolExp>;
};

/** Ordering options when selecting data from "configuration.configuration_value". */
export type TixConfigurationValueOrderBy = {
  Item?: InputMaybe<TixConfigurationItemOrderBy>;
  VenueValue?: InputMaybe<TixVenueConfigurationValueOrderBy>;
  company_config_value?: InputMaybe<TixCompanyConfigurationValueOrderBy>;
  configurationItemId?: InputMaybe<TixOrderBy>;
  configurationValueId?: InputMaybe<TixOrderBy>;
  event_instance_value?: InputMaybe<TixEventInstanceConfigurationValueOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  value?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: configuration.configuration_value */
export type TixConfigurationValuePkColumnsInput = {
  configurationValueId: Scalars['uuid'];
};

/** select columns of table "configuration.configuration_value" */
export enum TixConfigurationValueSelectColumn {
  /** column name */
  ConfigurationItemId = 'configurationItemId',
  /** column name */
  ConfigurationValueId = 'configurationValueId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "configuration.configuration_value" */
export type TixConfigurationValueSetInput = {
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ConfigurationValue" */
export type TixConfigurationValueStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixConfigurationValueStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixConfigurationValueStreamCursorValueInput = {
  configurationItemId?: InputMaybe<Scalars['uuid']>;
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "configuration.configuration_value" */
export enum TixConfigurationValueUpdateColumn {
  /** column name */
  ConfigurationItemId = 'configurationItemId',
  /** column name */
  ConfigurationValueId = 'configurationValueId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Value = 'value'
}

export type TixConfigurationValueUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixConfigurationValueSetInput>;
  /** filter the rows which have to be updated */
  where: TixConfigurationValueBoolExp;
};

/** columns and relationships of "contact.contact" */
export type TixContact = {
  __typename?: 'Contact';
  /** An array relationship */
  addresses: Array<TixContactAddress>;
  /** An aggregate relationship */
  addresses_aggregate: TixContactAddressAggregate;
  /** An array relationship */
  companyContacts: Array<TixCompanyContact>;
  /** An aggregate relationship */
  companyContacts_aggregate: TixCompanyContactAggregate;
  contactId: Scalars['uuid'];
  /** An object relationship */
  customer?: Maybe<TixCustomer>;
  dob?: Maybe<Scalars['date']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  /** A computed field, executes function "contact.contact_full_name" */
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  isPromoter?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  /** An array relationship */
  phoneNumbers: Array<TixContactPhoneNumber>;
  /** An aggregate relationship */
  phoneNumbers_aggregate: TixContactPhoneNumberAggregate;
  profilePicture?: Maybe<Scalars['String']>;
  /** An array relationship */
  reservations: Array<TixTicketReservation>;
  /** An aggregate relationship */
  reservations_aggregate: TixTicketReservationAggregate;
  resetToken?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  /** An array relationship */
  tickets: Array<TixTicket>;
  /** An aggregate relationship */
  tickets_aggregate: TixTicketAggregate;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  user?: Maybe<TixUser>;
};


/** columns and relationships of "contact.contact" */
export type TixContactAddressesArgs = {
  distinct_on?: InputMaybe<Array<TixContactAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactAddressOrderBy>>;
  where?: InputMaybe<TixContactAddressBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactAddressesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactAddressOrderBy>>;
  where?: InputMaybe<TixContactAddressBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactCompanyContactsArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyContactOrderBy>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactCompanyContactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyContactOrderBy>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactPhoneNumbersArgs = {
  distinct_on?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactPhoneNumberOrderBy>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactPhoneNumbersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactPhoneNumberOrderBy>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactReservationsArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactReservationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactTicketsArgs = {
  distinct_on?: InputMaybe<Array<TixTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketOrderBy>>;
  where?: InputMaybe<TixTicketBoolExp>;
};


/** columns and relationships of "contact.contact" */
export type TixContactTicketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketOrderBy>>;
  where?: InputMaybe<TixTicketBoolExp>;
};

/** columns and relationships of "address.contact_address" */
export type TixContactAddress = {
  __typename?: 'ContactAddress';
  /** An object relationship */
  address?: Maybe<TixAddress>;
  addressId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contactAddressId: Scalars['uuid'];
  contactId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "address.contact_address" */
export type TixContactAddressAggregate = {
  __typename?: 'ContactAddress_aggregate';
  aggregate?: Maybe<TixContactAddressAggregateFields>;
  nodes: Array<TixContactAddress>;
};

export type TixContactAddressAggregateBoolExp = {
  count?: InputMaybe<TixContactAddressAggregateBoolExpCount>;
};

export type TixContactAddressAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixContactAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixContactAddressBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "address.contact_address" */
export type TixContactAddressAggregateFields = {
  __typename?: 'ContactAddress_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixContactAddressMaxFields>;
  min?: Maybe<TixContactAddressMinFields>;
};


/** aggregate fields of "address.contact_address" */
export type TixContactAddressAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixContactAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address.contact_address" */
export type TixContactAddressAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixContactAddressMaxOrderBy>;
  min?: InputMaybe<TixContactAddressMinOrderBy>;
};

/** input type for inserting array relation for remote table "address.contact_address" */
export type TixContactAddressArrRelInsertInput = {
  data: Array<TixContactAddressInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixContactAddressOnConflict>;
};

/** Boolean expression to filter rows from the table "address.contact_address". All fields are combined with a logical 'AND'. */
export type TixContactAddressBoolExp = {
  _and?: InputMaybe<Array<TixContactAddressBoolExp>>;
  _not?: InputMaybe<TixContactAddressBoolExp>;
  _or?: InputMaybe<Array<TixContactAddressBoolExp>>;
  address?: InputMaybe<TixAddressBoolExp>;
  addressId?: InputMaybe<TixUuidComparisonExp>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactAddressId?: InputMaybe<TixUuidComparisonExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "address.contact_address" */
export enum TixContactAddressConstraint {
  /** unique or primary key constraint on columns "contact_address_id" */
  ContactAddressPkey = 'contact_address_pkey'
}

/** input type for inserting data into table "address.contact_address" */
export type TixContactAddressInsertInput = {
  address?: InputMaybe<TixAddressObjRelInsertInput>;
  addressId?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contactAddressId?: InputMaybe<Scalars['uuid']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixContactAddressMaxFields = {
  __typename?: 'ContactAddress_max_fields';
  addressId?: Maybe<Scalars['uuid']>;
  contactAddressId?: Maybe<Scalars['uuid']>;
  contactId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "address.contact_address" */
export type TixContactAddressMaxOrderBy = {
  addressId?: InputMaybe<TixOrderBy>;
  contactAddressId?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixContactAddressMinFields = {
  __typename?: 'ContactAddress_min_fields';
  addressId?: Maybe<Scalars['uuid']>;
  contactAddressId?: Maybe<Scalars['uuid']>;
  contactId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "address.contact_address" */
export type TixContactAddressMinOrderBy = {
  addressId?: InputMaybe<TixOrderBy>;
  contactAddressId?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "address.contact_address" */
export type TixContactAddressMutationResponse = {
  __typename?: 'ContactAddress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixContactAddress>;
};

/** input type for inserting object relation for remote table "address.contact_address" */
export type TixContactAddressObjRelInsertInput = {
  data: TixContactAddressInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixContactAddressOnConflict>;
};

/** on_conflict condition type for table "address.contact_address" */
export type TixContactAddressOnConflict = {
  constraint: TixContactAddressConstraint;
  update_columns?: Array<TixContactAddressUpdateColumn>;
  where?: InputMaybe<TixContactAddressBoolExp>;
};

/** Ordering options when selecting data from "address.contact_address". */
export type TixContactAddressOrderBy = {
  address?: InputMaybe<TixAddressOrderBy>;
  addressId?: InputMaybe<TixOrderBy>;
  contact?: InputMaybe<TixContactOrderBy>;
  contactAddressId?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: address.contact_address */
export type TixContactAddressPkColumnsInput = {
  contactAddressId: Scalars['uuid'];
};

/** select columns of table "address.contact_address" */
export enum TixContactAddressSelectColumn {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  ContactAddressId = 'contactAddressId',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "address.contact_address" */
export type TixContactAddressSetInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  contactAddressId?: InputMaybe<Scalars['uuid']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ContactAddress" */
export type TixContactAddressStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixContactAddressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixContactAddressStreamCursorValueInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  contactAddressId?: InputMaybe<Scalars['uuid']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.contact_address" */
export enum TixContactAddressUpdateColumn {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  ContactAddressId = 'contactAddressId',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixContactAddressUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixContactAddressSetInput>;
  /** filter the rows which have to be updated */
  where: TixContactAddressBoolExp;
};

/** columns and relationships of "address.contact_phone_number" */
export type TixContactPhoneNumber = {
  __typename?: 'ContactPhoneNumber';
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contactId?: Maybe<Scalars['uuid']>;
  contactPhoneNumberId: Scalars['uuid'];
  /** An object relationship */
  phoneNumber?: Maybe<TixPhoneNumber>;
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "address.contact_phone_number" */
export type TixContactPhoneNumberAggregate = {
  __typename?: 'ContactPhoneNumber_aggregate';
  aggregate?: Maybe<TixContactPhoneNumberAggregateFields>;
  nodes: Array<TixContactPhoneNumber>;
};

export type TixContactPhoneNumberAggregateBoolExp = {
  count?: InputMaybe<TixContactPhoneNumberAggregateBoolExpCount>;
};

export type TixContactPhoneNumberAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixContactPhoneNumberBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "address.contact_phone_number" */
export type TixContactPhoneNumberAggregateFields = {
  __typename?: 'ContactPhoneNumber_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixContactPhoneNumberMaxFields>;
  min?: Maybe<TixContactPhoneNumberMinFields>;
};


/** aggregate fields of "address.contact_phone_number" */
export type TixContactPhoneNumberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address.contact_phone_number" */
export type TixContactPhoneNumberAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixContactPhoneNumberMaxOrderBy>;
  min?: InputMaybe<TixContactPhoneNumberMinOrderBy>;
};

/** input type for inserting array relation for remote table "address.contact_phone_number" */
export type TixContactPhoneNumberArrRelInsertInput = {
  data: Array<TixContactPhoneNumberInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixContactPhoneNumberOnConflict>;
};

/** Boolean expression to filter rows from the table "address.contact_phone_number". All fields are combined with a logical 'AND'. */
export type TixContactPhoneNumberBoolExp = {
  _and?: InputMaybe<Array<TixContactPhoneNumberBoolExp>>;
  _not?: InputMaybe<TixContactPhoneNumberBoolExp>;
  _or?: InputMaybe<Array<TixContactPhoneNumberBoolExp>>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  contactPhoneNumberId?: InputMaybe<TixUuidComparisonExp>;
  phoneNumber?: InputMaybe<TixPhoneNumberBoolExp>;
  phoneNumberId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "address.contact_phone_number" */
export enum TixContactPhoneNumberConstraint {
  /** unique or primary key constraint on columns "contact_phone_number_id" */
  ContactPhoneNumberContactPhoneNumberIdKey = 'contact_phone_number_contact_phone_number_id_key',
  /** unique or primary key constraint on columns "contact_phone_number_id" */
  ContactPhoneNumberPkey = 'contact_phone_number_pkey'
}

/** input type for inserting data into table "address.contact_phone_number" */
export type TixContactPhoneNumberInsertInput = {
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  contactPhoneNumberId?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<TixPhoneNumberObjRelInsertInput>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixContactPhoneNumberMaxFields = {
  __typename?: 'ContactPhoneNumber_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  contactPhoneNumberId?: Maybe<Scalars['uuid']>;
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "address.contact_phone_number" */
export type TixContactPhoneNumberMaxOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  contactPhoneNumberId?: InputMaybe<TixOrderBy>;
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixContactPhoneNumberMinFields = {
  __typename?: 'ContactPhoneNumber_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  contactPhoneNumberId?: Maybe<Scalars['uuid']>;
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "address.contact_phone_number" */
export type TixContactPhoneNumberMinOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  contactPhoneNumberId?: InputMaybe<TixOrderBy>;
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "address.contact_phone_number" */
export type TixContactPhoneNumberMutationResponse = {
  __typename?: 'ContactPhoneNumber_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixContactPhoneNumber>;
};

/** on_conflict condition type for table "address.contact_phone_number" */
export type TixContactPhoneNumberOnConflict = {
  constraint: TixContactPhoneNumberConstraint;
  update_columns?: Array<TixContactPhoneNumberUpdateColumn>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};

/** Ordering options when selecting data from "address.contact_phone_number". */
export type TixContactPhoneNumberOrderBy = {
  contact?: InputMaybe<TixContactOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  contactPhoneNumberId?: InputMaybe<TixOrderBy>;
  phoneNumber?: InputMaybe<TixPhoneNumberOrderBy>;
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: address.contact_phone_number */
export type TixContactPhoneNumberPkColumnsInput = {
  contactPhoneNumberId: Scalars['uuid'];
};

/** select columns of table "address.contact_phone_number" */
export enum TixContactPhoneNumberSelectColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  ContactPhoneNumberId = 'contactPhoneNumberId',
  /** column name */
  PhoneNumberId = 'phoneNumberId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "address.contact_phone_number" */
export type TixContactPhoneNumberSetInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  contactPhoneNumberId?: InputMaybe<Scalars['uuid']>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ContactPhoneNumber" */
export type TixContactPhoneNumberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixContactPhoneNumberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixContactPhoneNumberStreamCursorValueInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  contactPhoneNumberId?: InputMaybe<Scalars['uuid']>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.contact_phone_number" */
export enum TixContactPhoneNumberUpdateColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  ContactPhoneNumberId = 'contactPhoneNumberId',
  /** column name */
  PhoneNumberId = 'phoneNumberId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixContactPhoneNumberUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixContactPhoneNumberSetInput>;
  /** filter the rows which have to be updated */
  where: TixContactPhoneNumberBoolExp;
};

/** aggregated selection of "contact.contact" */
export type TixContactAggregate = {
  __typename?: 'Contact_aggregate';
  aggregate?: Maybe<TixContactAggregateFields>;
  nodes: Array<TixContact>;
};

export type TixContactAggregateBoolExp = {
  bool_and?: InputMaybe<TixContactAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixContactAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixContactAggregateBoolExpCount>;
};

export type TixContactAggregateBoolExpBoolAnd = {
  arguments: TixContactSelectColumnContactAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixContactBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixContactAggregateBoolExpBoolOr = {
  arguments: TixContactSelectColumnContactAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixContactBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixContactAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixContactSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixContactBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "contact.contact" */
export type TixContactAggregateFields = {
  __typename?: 'Contact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixContactMaxFields>;
  min?: Maybe<TixContactMinFields>;
};


/** aggregate fields of "contact.contact" */
export type TixContactAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixContactSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contact.contact" */
export type TixContactAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixContactMaxOrderBy>;
  min?: InputMaybe<TixContactMinOrderBy>;
};

/** input type for inserting array relation for remote table "contact.contact" */
export type TixContactArrRelInsertInput = {
  data: Array<TixContactInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixContactOnConflict>;
};

/** Boolean expression to filter rows from the table "contact.contact". All fields are combined with a logical 'AND'. */
export type TixContactBoolExp = {
  _and?: InputMaybe<Array<TixContactBoolExp>>;
  _not?: InputMaybe<TixContactBoolExp>;
  _or?: InputMaybe<Array<TixContactBoolExp>>;
  addresses?: InputMaybe<TixContactAddressBoolExp>;
  addresses_aggregate?: InputMaybe<TixContactAddressAggregateBoolExp>;
  companyContacts?: InputMaybe<TixCompanyContactBoolExp>;
  companyContacts_aggregate?: InputMaybe<TixCompanyContactAggregateBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  customer?: InputMaybe<TixCustomerBoolExp>;
  dob?: InputMaybe<TixDateComparisonExp>;
  emailAddress?: InputMaybe<TixStringComparisonExp>;
  firstName?: InputMaybe<TixStringComparisonExp>;
  fullName?: InputMaybe<TixStringComparisonExp>;
  gender?: InputMaybe<TixStringComparisonExp>;
  isPromoter?: InputMaybe<TixBooleanComparisonExp>;
  lastName?: InputMaybe<TixStringComparisonExp>;
  phoneNumbers?: InputMaybe<TixContactPhoneNumberBoolExp>;
  phoneNumbers_aggregate?: InputMaybe<TixContactPhoneNumberAggregateBoolExp>;
  profilePicture?: InputMaybe<TixStringComparisonExp>;
  reservations?: InputMaybe<TixTicketReservationBoolExp>;
  reservations_aggregate?: InputMaybe<TixTicketReservationAggregateBoolExp>;
  resetToken?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  tickets?: InputMaybe<TixTicketBoolExp>;
  tickets_aggregate?: InputMaybe<TixTicketAggregateBoolExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  user?: InputMaybe<TixUserBoolExp>;
};

/** unique or primary key constraints on table "contact.contact" */
export enum TixContactConstraint {
  /** unique or primary key constraint on columns "contact_id" */
  ContactPkey = 'contact_pkey',
  /** unique or primary key constraint on columns "email_address" */
  EmailUnique = 'email_unique'
}

/** input type for inserting data into table "contact.contact" */
export type TixContactInsertInput = {
  addresses?: InputMaybe<TixContactAddressArrRelInsertInput>;
  companyContacts?: InputMaybe<TixCompanyContactArrRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  customer?: InputMaybe<TixCustomerObjRelInsertInput>;
  dob?: InputMaybe<Scalars['date']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  isPromoter?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<TixContactPhoneNumberArrRelInsertInput>;
  profilePicture?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<TixTicketReservationArrRelInsertInput>;
  resetToken?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tickets?: InputMaybe<TixTicketArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<TixUserObjRelInsertInput>;
};

/** aggregate max on columns */
export type TixContactMaxFields = {
  __typename?: 'Contact_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['date']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "contact.contact_full_name" */
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  resetToken?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "contact.contact" */
export type TixContactMaxOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  dob?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  firstName?: InputMaybe<TixOrderBy>;
  gender?: InputMaybe<TixOrderBy>;
  lastName?: InputMaybe<TixOrderBy>;
  profilePicture?: InputMaybe<TixOrderBy>;
  resetToken?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixContactMinFields = {
  __typename?: 'Contact_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['date']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "contact.contact_full_name" */
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  resetToken?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "contact.contact" */
export type TixContactMinOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  dob?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  firstName?: InputMaybe<TixOrderBy>;
  gender?: InputMaybe<TixOrderBy>;
  lastName?: InputMaybe<TixOrderBy>;
  profilePicture?: InputMaybe<TixOrderBy>;
  resetToken?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "contact.contact" */
export type TixContactMutationResponse = {
  __typename?: 'Contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixContact>;
};

/** input type for inserting object relation for remote table "contact.contact" */
export type TixContactObjRelInsertInput = {
  data: TixContactInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixContactOnConflict>;
};

/** on_conflict condition type for table "contact.contact" */
export type TixContactOnConflict = {
  constraint: TixContactConstraint;
  update_columns?: Array<TixContactUpdateColumn>;
  where?: InputMaybe<TixContactBoolExp>;
};

/** Ordering options when selecting data from "contact.contact". */
export type TixContactOrderBy = {
  addresses_aggregate?: InputMaybe<TixContactAddressAggregateOrderBy>;
  companyContacts_aggregate?: InputMaybe<TixCompanyContactAggregateOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  customer?: InputMaybe<TixCustomerOrderBy>;
  dob?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  firstName?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  gender?: InputMaybe<TixOrderBy>;
  isPromoter?: InputMaybe<TixOrderBy>;
  lastName?: InputMaybe<TixOrderBy>;
  phoneNumbers_aggregate?: InputMaybe<TixContactPhoneNumberAggregateOrderBy>;
  profilePicture?: InputMaybe<TixOrderBy>;
  reservations_aggregate?: InputMaybe<TixTicketReservationAggregateOrderBy>;
  resetToken?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  tickets_aggregate?: InputMaybe<TixTicketAggregateOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  user?: InputMaybe<TixUserOrderBy>;
};

/** primary key columns input for table: contact.contact */
export type TixContactPkColumnsInput = {
  contactId: Scalars['uuid'];
};

/** select columns of table "contact.contact" */
export enum TixContactSelectColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  Dob = 'dob',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  IsPromoter = 'isPromoter',
  /** column name */
  LastName = 'lastName',
  /** column name */
  ProfilePicture = 'profilePicture',
  /** column name */
  ResetToken = 'resetToken',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** select "Contact_aggregate_bool_exp_bool_and_arguments_columns" columns of table "contact.contact" */
export enum TixContactSelectColumnContactAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPromoter = 'isPromoter'
}

/** select "Contact_aggregate_bool_exp_bool_or_arguments_columns" columns of table "contact.contact" */
export enum TixContactSelectColumnContactAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPromoter = 'isPromoter'
}

/** input type for updating data in table "contact.contact" */
export type TixContactSetInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  dob?: InputMaybe<Scalars['date']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  isPromoter?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
  resetToken?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Contact" */
export type TixContactStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixContactStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixContactStreamCursorValueInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  dob?: InputMaybe<Scalars['date']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  isPromoter?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
  resetToken?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "contact.contact" */
export enum TixContactUpdateColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  Dob = 'dob',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  IsPromoter = 'isPromoter',
  /** column name */
  LastName = 'lastName',
  /** column name */
  ProfilePicture = 'profilePicture',
  /** column name */
  ResetToken = 'resetToken',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixContactUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixContactSetInput>;
  /** filter the rows which have to be updated */
  where: TixContactBoolExp;
};

export type TixCustomTickets = {
  __typename?: 'CustomTickets';
  ticketAmount: Scalars['Float'];
  ticketCount: Scalars['Int'];
};

/** columns and relationships of "contact.customer" */
export type TixCustomer = {
  __typename?: 'Customer';
  city?: Maybe<Scalars['String']>;
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contact_id?: Maybe<Scalars['uuid']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "contact.customer_full_name" */
  customerFullName?: Maybe<Scalars['String']>;
  customerId: Scalars['uuid'];
  dob?: Maybe<Scalars['date']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  /** Does the user opt in for email marketing material */
  optInEmail?: Maybe<Scalars['Boolean']>;
  /** Does the user opt in for SMS marketing material */
  optInSMS?: Maybe<Scalars['Boolean']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  suiteApartment?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

export type TixCustomerInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['DateTime']>;
  emailAddress: Scalars['String'];
  emails?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['Boolean']>;
  stAddress?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "contact.v_customer_search" */
export type TixCustomerSearch = {
  __typename?: 'CustomerSearch';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  eventDateFormatted?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  refundAmount?: Maybe<Scalars['money']>;
  /** An object relationship */
  reservation?: Maybe<TixTicketReservation>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationDateFormatted?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['time']>;
  startTimeFormatted?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['money']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueRevenue?: Maybe<Scalars['money']>;
};

/** aggregated selection of "contact.v_customer_search" */
export type TixCustomerSearchAggregate = {
  __typename?: 'CustomerSearch_aggregate';
  aggregate?: Maybe<TixCustomerSearchAggregateFields>;
  nodes: Array<TixCustomerSearch>;
};

/** aggregate fields of "contact.v_customer_search" */
export type TixCustomerSearchAggregateFields = {
  __typename?: 'CustomerSearch_aggregate_fields';
  avg?: Maybe<TixCustomerSearchAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixCustomerSearchMaxFields>;
  min?: Maybe<TixCustomerSearchMinFields>;
  stddev?: Maybe<TixCustomerSearchStddevFields>;
  stddev_pop?: Maybe<TixCustomerSearchStddevPopFields>;
  stddev_samp?: Maybe<TixCustomerSearchStddevSampFields>;
  sum?: Maybe<TixCustomerSearchSumFields>;
  var_pop?: Maybe<TixCustomerSearchVarPopFields>;
  var_samp?: Maybe<TixCustomerSearchVarSampFields>;
  variance?: Maybe<TixCustomerSearchVarianceFields>;
};


/** aggregate fields of "contact.v_customer_search" */
export type TixCustomerSearchAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCustomerSearchSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixCustomerSearchAvgFields = {
  __typename?: 'CustomerSearch_avg_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  venueRevenue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "contact.v_customer_search". All fields are combined with a logical 'AND'. */
export type TixCustomerSearchBoolExp = {
  _and?: InputMaybe<Array<TixCustomerSearchBoolExp>>;
  _not?: InputMaybe<TixCustomerSearchBoolExp>;
  _or?: InputMaybe<Array<TixCustomerSearchBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  discountAmount?: InputMaybe<TixMoneyComparisonExp>;
  discountCode?: InputMaybe<TixStringComparisonExp>;
  emailAddress?: InputMaybe<TixStringComparisonExp>;
  eventDate?: InputMaybe<TixDateComparisonExp>;
  eventDateFormatted?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  firstName?: InputMaybe<TixStringComparisonExp>;
  lastName?: InputMaybe<TixStringComparisonExp>;
  paymentType?: InputMaybe<TixStringComparisonExp>;
  phoneNumber?: InputMaybe<TixStringComparisonExp>;
  platformFee?: InputMaybe<TixMoneyComparisonExp>;
  processingFee?: InputMaybe<TixMoneyComparisonExp>;
  refundAmount?: InputMaybe<TixMoneyComparisonExp>;
  reservation?: InputMaybe<TixTicketReservationBoolExp>;
  reservationDate?: InputMaybe<TixDateComparisonExp>;
  reservationDateFormatted?: InputMaybe<TixStringComparisonExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  reservationNo?: InputMaybe<TixStringComparisonExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  startTime?: InputMaybe<TixTimeComparisonExp>;
  startTimeFormatted?: InputMaybe<TixStringComparisonExp>;
  subTotal?: InputMaybe<TixMoneyComparisonExp>;
  ticketCount?: InputMaybe<TixBigintComparisonExp>;
  totalAmountPaid?: InputMaybe<TixMoneyComparisonExp>;
  venueFee?: InputMaybe<TixMoneyComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  venueRevenue?: InputMaybe<TixMoneyComparisonExp>;
};

/** aggregate max on columns */
export type TixCustomerSearchMaxFields = {
  __typename?: 'CustomerSearch_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  eventDateFormatted?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  refundAmount?: Maybe<Scalars['money']>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationDateFormatted?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  startTimeFormatted?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['money']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueRevenue?: Maybe<Scalars['money']>;
};

/** aggregate min on columns */
export type TixCustomerSearchMinFields = {
  __typename?: 'CustomerSearch_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  eventDateFormatted?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  refundAmount?: Maybe<Scalars['money']>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationDateFormatted?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  startTimeFormatted?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['money']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueRevenue?: Maybe<Scalars['money']>;
};

/** Ordering options when selecting data from "contact.v_customer_search". */
export type TixCustomerSearchOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  eventDate?: InputMaybe<TixOrderBy>;
  eventDateFormatted?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  firstName?: InputMaybe<TixOrderBy>;
  lastName?: InputMaybe<TixOrderBy>;
  paymentType?: InputMaybe<TixOrderBy>;
  phoneNumber?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  reservation?: InputMaybe<TixTicketReservationOrderBy>;
  reservationDate?: InputMaybe<TixOrderBy>;
  reservationDateFormatted?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationNo?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  startTimeFormatted?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueRevenue?: InputMaybe<TixOrderBy>;
};

/** select columns of table "contact.v_customer_search" */
export enum TixCustomerSearchSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  DiscountCode = 'discountCode',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  EventDate = 'eventDate',
  /** column name */
  EventDateFormatted = 'eventDateFormatted',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  LastName = 'lastName',
  /** column name */
  PaymentType = 'paymentType',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  ReservationDate = 'reservationDate',
  /** column name */
  ReservationDateFormatted = 'reservationDateFormatted',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationNo = 'reservationNo',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StartTimeFormatted = 'startTimeFormatted',
  /** column name */
  SubTotal = 'subTotal',
  /** column name */
  TicketCount = 'ticketCount',
  /** column name */
  TotalAmountPaid = 'totalAmountPaid',
  /** column name */
  VenueFee = 'venueFee',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  VenueRevenue = 'venueRevenue'
}

/** aggregate stddev on columns */
export type TixCustomerSearchStddevFields = {
  __typename?: 'CustomerSearch_stddev_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  venueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixCustomerSearchStddevPopFields = {
  __typename?: 'CustomerSearch_stddev_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  venueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixCustomerSearchStddevSampFields = {
  __typename?: 'CustomerSearch_stddev_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  venueRevenue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "CustomerSearch" */
export type TixCustomerSearchStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCustomerSearchStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCustomerSearchStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  discountAmount?: InputMaybe<Scalars['money']>;
  discountCode?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['date']>;
  eventDateFormatted?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  refundAmount?: InputMaybe<Scalars['money']>;
  reservationDate?: InputMaybe<Scalars['date']>;
  reservationDateFormatted?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationNo?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['time']>;
  startTimeFormatted?: InputMaybe<Scalars['String']>;
  subTotal?: InputMaybe<Scalars['money']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
  totalAmountPaid?: InputMaybe<Scalars['money']>;
  venueFee?: InputMaybe<Scalars['money']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  venueRevenue?: InputMaybe<Scalars['money']>;
};

/** aggregate sum on columns */
export type TixCustomerSearchSumFields = {
  __typename?: 'CustomerSearch_sum_fields';
  discountAmount?: Maybe<Scalars['money']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  refundAmount?: Maybe<Scalars['money']>;
  subTotal?: Maybe<Scalars['money']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
  venueRevenue?: Maybe<Scalars['money']>;
};

/** aggregate var_pop on columns */
export type TixCustomerSearchVarPopFields = {
  __typename?: 'CustomerSearch_var_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  venueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixCustomerSearchVarSampFields = {
  __typename?: 'CustomerSearch_var_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  venueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixCustomerSearchVarianceFields = {
  __typename?: 'CustomerSearch_variance_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  venueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "contact.customer" */
export type TixCustomerAggregate = {
  __typename?: 'Customer_aggregate';
  aggregate?: Maybe<TixCustomerAggregateFields>;
  nodes: Array<TixCustomer>;
};

/** aggregate fields of "contact.customer" */
export type TixCustomerAggregateFields = {
  __typename?: 'Customer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCustomerMaxFields>;
  min?: Maybe<TixCustomerMinFields>;
};


/** aggregate fields of "contact.customer" */
export type TixCustomerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCustomerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "contact.customer". All fields are combined with a logical 'AND'. */
export type TixCustomerBoolExp = {
  _and?: InputMaybe<Array<TixCustomerBoolExp>>;
  _not?: InputMaybe<TixCustomerBoolExp>;
  _or?: InputMaybe<Array<TixCustomerBoolExp>>;
  city?: InputMaybe<TixStringComparisonExp>;
  contact?: InputMaybe<TixContactBoolExp>;
  contact_id?: InputMaybe<TixUuidComparisonExp>;
  countryCode?: InputMaybe<TixStringComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  customerFullName?: InputMaybe<TixStringComparisonExp>;
  customerId?: InputMaybe<TixUuidComparisonExp>;
  dob?: InputMaybe<TixDateComparisonExp>;
  emailAddress?: InputMaybe<TixStringComparisonExp>;
  firstName?: InputMaybe<TixStringComparisonExp>;
  gender?: InputMaybe<TixStringComparisonExp>;
  lastName?: InputMaybe<TixStringComparisonExp>;
  optInEmail?: InputMaybe<TixBooleanComparisonExp>;
  optInSMS?: InputMaybe<TixBooleanComparisonExp>;
  phoneCountryCode?: InputMaybe<TixStringComparisonExp>;
  phoneNumber?: InputMaybe<TixStringComparisonExp>;
  postalCode?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  stateProvince?: InputMaybe<TixStringComparisonExp>;
  streetAddress?: InputMaybe<TixStringComparisonExp>;
  suiteApartment?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "contact.customer" */
export enum TixCustomerConstraint {
  /** unique or primary key constraint on columns "email_address" */
  CustomerEmailAddressKey = 'customer_email_address_key',
  /** unique or primary key constraint on columns "customer_id" */
  CustomerPkey = 'customer_pkey'
}

/** input type for inserting data into table "contact.customer" */
export type TixCustomerInsertInput = {
  city?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contact_id?: InputMaybe<Scalars['uuid']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  customerId?: InputMaybe<Scalars['uuid']>;
  dob?: InputMaybe<Scalars['date']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** Does the user opt in for email marketing material */
  optInEmail?: InputMaybe<Scalars['Boolean']>;
  /** Does the user opt in for SMS marketing material */
  optInSMS?: InputMaybe<Scalars['Boolean']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCustomerMaxFields = {
  __typename?: 'Customer_max_fields';
  city?: Maybe<Scalars['String']>;
  contact_id?: Maybe<Scalars['uuid']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "contact.customer_full_name" */
  customerFullName?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['date']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  suiteApartment?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixCustomerMinFields = {
  __typename?: 'Customer_min_fields';
  city?: Maybe<Scalars['String']>;
  contact_id?: Maybe<Scalars['uuid']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "contact.customer_full_name" */
  customerFullName?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['date']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  suiteApartment?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "contact.customer" */
export type TixCustomerMutationResponse = {
  __typename?: 'Customer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCustomer>;
};

/** input type for inserting object relation for remote table "contact.customer" */
export type TixCustomerObjRelInsertInput = {
  data: TixCustomerInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCustomerOnConflict>;
};

/** on_conflict condition type for table "contact.customer" */
export type TixCustomerOnConflict = {
  constraint: TixCustomerConstraint;
  update_columns?: Array<TixCustomerUpdateColumn>;
  where?: InputMaybe<TixCustomerBoolExp>;
};

/** Ordering options when selecting data from "contact.customer". */
export type TixCustomerOrderBy = {
  city?: InputMaybe<TixOrderBy>;
  contact?: InputMaybe<TixContactOrderBy>;
  contact_id?: InputMaybe<TixOrderBy>;
  countryCode?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  customerFullName?: InputMaybe<TixOrderBy>;
  customerId?: InputMaybe<TixOrderBy>;
  dob?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  firstName?: InputMaybe<TixOrderBy>;
  gender?: InputMaybe<TixOrderBy>;
  lastName?: InputMaybe<TixOrderBy>;
  optInEmail?: InputMaybe<TixOrderBy>;
  optInSMS?: InputMaybe<TixOrderBy>;
  phoneCountryCode?: InputMaybe<TixOrderBy>;
  phoneNumber?: InputMaybe<TixOrderBy>;
  postalCode?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stateProvince?: InputMaybe<TixOrderBy>;
  streetAddress?: InputMaybe<TixOrderBy>;
  suiteApartment?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: contact.customer */
export type TixCustomerPkColumnsInput = {
  customerId: Scalars['uuid'];
};

/** select columns of table "contact.customer" */
export enum TixCustomerSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Dob = 'dob',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OptInEmail = 'optInEmail',
  /** column name */
  OptInSms = 'optInSMS',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  State = 'state',
  /** column name */
  StateProvince = 'stateProvince',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  SuiteApartment = 'suiteApartment',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "contact.customer" */
export type TixCustomerSetInput = {
  city?: InputMaybe<Scalars['String']>;
  contact_id?: InputMaybe<Scalars['uuid']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  customerId?: InputMaybe<Scalars['uuid']>;
  dob?: InputMaybe<Scalars['date']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** Does the user opt in for email marketing material */
  optInEmail?: InputMaybe<Scalars['Boolean']>;
  /** Does the user opt in for SMS marketing material */
  optInSMS?: InputMaybe<Scalars['Boolean']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Customer" */
export type TixCustomerStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCustomerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCustomerStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  contact_id?: InputMaybe<Scalars['uuid']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  customerId?: InputMaybe<Scalars['uuid']>;
  dob?: InputMaybe<Scalars['date']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** Does the user opt in for email marketing material */
  optInEmail?: InputMaybe<Scalars['Boolean']>;
  /** Does the user opt in for SMS marketing material */
  optInSMS?: InputMaybe<Scalars['Boolean']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "contact.customer" */
export enum TixCustomerUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Dob = 'dob',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OptInEmail = 'optInEmail',
  /** column name */
  OptInSms = 'optInSMS',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  State = 'state',
  /** column name */
  StateProvince = 'stateProvince',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  SuiteApartment = 'suiteApartment',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCustomerUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCustomerSetInput>;
  /** filter the rows which have to be updated */
  where: TixCustomerBoolExp;
};

/** columns and relationships of "reporting.v_daily_audit" */
export type TixDailyAuditReport = {
  __typename?: 'DailyAuditReport';
  boxofficeTicketCount?: Maybe<Scalars['bigint']>;
  companyName?: Maybe<Scalars['String']>;
  dailyRevenue?: Maybe<Scalars['money']>;
  date?: Maybe<Scalars['date']>;
  daysOut?: Maybe<Scalars['float8']>;
  eventDate?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventTime?: Maybe<Scalars['time']>;
  includeFees?: Maybe<Scalars['Boolean']>;
  onlineTicketCount?: Maybe<Scalars['bigint']>;
  percentSold?: Maybe<Scalars['String']>;
  performance?: Maybe<Scalars['String']>;
  performanceDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  ticketName?: Maybe<Scalars['String']>;
  todayComp?: Maybe<Scalars['bigint']>;
  todayDiscounts?: Maybe<Scalars['money']>;
  todayRefundCount?: Maybe<Scalars['numeric']>;
  todayRefunds?: Maybe<Scalars['money']>;
  todayTicketRevenue?: Maybe<Scalars['money']>;
  todayTicketsSold?: Maybe<Scalars['bigint']>;
  todayVenueRevenue?: Maybe<Scalars['money']>;
  totalComp?: Maybe<Scalars['bigint']>;
  totalDiscounts?: Maybe<Scalars['money']>;
  totalRefundAmount?: Maybe<Scalars['money']>;
  totalRefundCount?: Maybe<Scalars['numeric']>;
  totalRevenue?: Maybe<Scalars['money']>;
  totalSeatsAvailable?: Maybe<Scalars['Int']>;
  totalSeatsRemaining?: Maybe<Scalars['bigint']>;
  totalTicketRevenue?: Maybe<Scalars['money']>;
  totalTicketsSold?: Maybe<Scalars['bigint']>;
  totalVenueRevenue?: Maybe<Scalars['money']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdayComp?: Maybe<Scalars['bigint']>;
  yesterdayDiscounts?: Maybe<Scalars['money']>;
  yesterdayRefundCount?: Maybe<Scalars['numeric']>;
  yesterdayRefunds?: Maybe<Scalars['money']>;
  yesterdayRevenue?: Maybe<Scalars['money']>;
  yesterdayTicketRevenue?: Maybe<Scalars['money']>;
  yesterdayTicketsSold?: Maybe<Scalars['bigint']>;
  yesterdayVenueRevenue?: Maybe<Scalars['money']>;
};

/** columns and relationships of "reporting.v_daily_audit_report_final" */
export type TixDailyAuditReportFinal = {
  __typename?: 'DailyAuditReportFinal';
  companyName?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  formattedDate?: Maybe<Scalars['String']>;
  formattedStartTime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentTicketName?: Maybe<Scalars['String']>;
  performance?: Maybe<Scalars['String']>;
  performanceDate?: Maybe<Scalars['String']>;
  platformFeeTotalByTicket?: Maybe<Scalars['money']>;
  processingFeeTotalByTicket?: Maybe<Scalars['money']>;
  rawDate?: Maybe<Scalars['date']>;
  rawStartTime?: Maybe<Scalars['time']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  todayCashAmount?: Maybe<Scalars['money']>;
  todayCashCount?: Maybe<Scalars['bigint']>;
  todayCompAmount?: Maybe<Scalars['money']>;
  todayCompCount?: Maybe<Scalars['bigint']>;
  todayRefundAmount?: Maybe<Scalars['money']>;
  todayRefundCount?: Maybe<Scalars['bigint']>;
  todayTotalDiscountAmount?: Maybe<Scalars['money']>;
  todayTotalDiscountCount?: Maybe<Scalars['bigint']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['money']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['bigint']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['money']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['bigint']>;
  totalCashAmount?: Maybe<Scalars['money']>;
  totalCashCount?: Maybe<Scalars['bigint']>;
  totalCompAmount?: Maybe<Scalars['money']>;
  totalCompCount?: Maybe<Scalars['bigint']>;
  totalDiscountAmount?: Maybe<Scalars['money']>;
  totalDiscountCount?: Maybe<Scalars['bigint']>;
  totalFeesByTicket?: Maybe<Scalars['money']>;
  totalOnlineTicketAmount?: Maybe<Scalars['money']>;
  totalOnlineTicketCount?: Maybe<Scalars['bigint']>;
  totalRefundAmount?: Maybe<Scalars['money']>;
  totalRefundCount?: Maybe<Scalars['bigint']>;
  totalTicketSalesAmount?: Maybe<Scalars['money']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  totalTicketSalesCount?: Maybe<Scalars['bigint']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
  totalTicketsAvailable?: Maybe<Scalars['bigint']>;
  totalTicketsForSale?: Maybe<Scalars['Int']>;
  venueFeeTotalByTicket?: Maybe<Scalars['money']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdayCashAmount?: Maybe<Scalars['money']>;
  yesterdayCashCount?: Maybe<Scalars['bigint']>;
  yesterdayCompAmount?: Maybe<Scalars['money']>;
  yesterdayCompCount?: Maybe<Scalars['bigint']>;
  yesterdayDiscountAmount?: Maybe<Scalars['money']>;
  yesterdayDiscountCount?: Maybe<Scalars['bigint']>;
  yesterdayRefundAmount?: Maybe<Scalars['money']>;
  yesterdayRefundCount?: Maybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['money']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "reporting.v_daily_audit_report_final" */
export type TixDailyAuditReportFinalAggregate = {
  __typename?: 'DailyAuditReportFinal_aggregate';
  aggregate?: Maybe<TixDailyAuditReportFinalAggregateFields>;
  nodes: Array<TixDailyAuditReportFinal>;
};

/** aggregate fields of "reporting.v_daily_audit_report_final" */
export type TixDailyAuditReportFinalAggregateFields = {
  __typename?: 'DailyAuditReportFinal_aggregate_fields';
  avg?: Maybe<TixDailyAuditReportFinalAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixDailyAuditReportFinalMaxFields>;
  min?: Maybe<TixDailyAuditReportFinalMinFields>;
  stddev?: Maybe<TixDailyAuditReportFinalStddevFields>;
  stddev_pop?: Maybe<TixDailyAuditReportFinalStddevPopFields>;
  stddev_samp?: Maybe<TixDailyAuditReportFinalStddevSampFields>;
  sum?: Maybe<TixDailyAuditReportFinalSumFields>;
  var_pop?: Maybe<TixDailyAuditReportFinalVarPopFields>;
  var_samp?: Maybe<TixDailyAuditReportFinalVarSampFields>;
  variance?: Maybe<TixDailyAuditReportFinalVarianceFields>;
};


/** aggregate fields of "reporting.v_daily_audit_report_final" */
export type TixDailyAuditReportFinalAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixDailyAuditReportFinalSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixDailyAuditReportFinalAvgFields = {
  __typename?: 'DailyAuditReportFinal_avg_fields';
  platformFeeTotalByTicket?: Maybe<Scalars['Float']>;
  processingFeeTotalByTicket?: Maybe<Scalars['Float']>;
  todayCashAmount?: Maybe<Scalars['Float']>;
  todayCashCount?: Maybe<Scalars['Float']>;
  todayCompAmount?: Maybe<Scalars['Float']>;
  todayCompCount?: Maybe<Scalars['Float']>;
  todayRefundAmount?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayTotalDiscountAmount?: Maybe<Scalars['Float']>;
  todayTotalDiscountCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['Float']>;
  totalCashAmount?: Maybe<Scalars['Float']>;
  totalCashCount?: Maybe<Scalars['Float']>;
  totalCompAmount?: Maybe<Scalars['Float']>;
  totalCompCount?: Maybe<Scalars['Float']>;
  totalDiscountAmount?: Maybe<Scalars['Float']>;
  totalDiscountCount?: Maybe<Scalars['Float']>;
  totalFeesByTicket?: Maybe<Scalars['Float']>;
  totalOnlineTicketAmount?: Maybe<Scalars['Float']>;
  totalOnlineTicketCount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  totalTicketSalesCount?: Maybe<Scalars['Float']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalTicketsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsForSale?: Maybe<Scalars['Float']>;
  venueFeeTotalByTicket?: Maybe<Scalars['Float']>;
  yesterdayCashAmount?: Maybe<Scalars['Float']>;
  yesterdayCashCount?: Maybe<Scalars['Float']>;
  yesterdayCompAmount?: Maybe<Scalars['Float']>;
  yesterdayCompCount?: Maybe<Scalars['Float']>;
  yesterdayDiscountAmount?: Maybe<Scalars['Float']>;
  yesterdayDiscountCount?: Maybe<Scalars['Float']>;
  yesterdayRefundAmount?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_daily_audit_report_final". All fields are combined with a logical 'AND'. */
export type TixDailyAuditReportFinalBoolExp = {
  _and?: InputMaybe<Array<TixDailyAuditReportFinalBoolExp>>;
  _not?: InputMaybe<TixDailyAuditReportFinalBoolExp>;
  _or?: InputMaybe<Array<TixDailyAuditReportFinalBoolExp>>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  formattedDate?: InputMaybe<TixStringComparisonExp>;
  formattedStartTime?: InputMaybe<TixStringComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  parentTicketName?: InputMaybe<TixStringComparisonExp>;
  performance?: InputMaybe<TixStringComparisonExp>;
  performanceDate?: InputMaybe<TixStringComparisonExp>;
  platformFeeTotalByTicket?: InputMaybe<TixMoneyComparisonExp>;
  processingFeeTotalByTicket?: InputMaybe<TixMoneyComparisonExp>;
  rawDate?: InputMaybe<TixDateComparisonExp>;
  rawStartTime?: InputMaybe<TixTimeComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  todayCashAmount?: InputMaybe<TixMoneyComparisonExp>;
  todayCashCount?: InputMaybe<TixBigintComparisonExp>;
  todayCompAmount?: InputMaybe<TixMoneyComparisonExp>;
  todayCompCount?: InputMaybe<TixBigintComparisonExp>;
  todayRefundAmount?: InputMaybe<TixMoneyComparisonExp>;
  todayRefundCount?: InputMaybe<TixBigintComparisonExp>;
  todayTotalDiscountAmount?: InputMaybe<TixMoneyComparisonExp>;
  todayTotalDiscountCount?: InputMaybe<TixBigintComparisonExp>;
  todayTotalTicketSalesAmount?: InputMaybe<TixMoneyComparisonExp>;
  todayTotalTicketSalesAmountOverall?: InputMaybe<TixMoneyComparisonExp>;
  todayTotalTicketSalesCount?: InputMaybe<TixBigintComparisonExp>;
  todayTotalTicketSalesCountOverall?: InputMaybe<TixBigintComparisonExp>;
  totalBoxofficeTicketAmount?: InputMaybe<TixMoneyComparisonExp>;
  totalBoxofficeTicketCount?: InputMaybe<TixBigintComparisonExp>;
  totalCashAmount?: InputMaybe<TixMoneyComparisonExp>;
  totalCashCount?: InputMaybe<TixBigintComparisonExp>;
  totalCompAmount?: InputMaybe<TixMoneyComparisonExp>;
  totalCompCount?: InputMaybe<TixBigintComparisonExp>;
  totalDiscountAmount?: InputMaybe<TixMoneyComparisonExp>;
  totalDiscountCount?: InputMaybe<TixBigintComparisonExp>;
  totalFeesByTicket?: InputMaybe<TixMoneyComparisonExp>;
  totalOnlineTicketAmount?: InputMaybe<TixMoneyComparisonExp>;
  totalOnlineTicketCount?: InputMaybe<TixBigintComparisonExp>;
  totalRefundAmount?: InputMaybe<TixMoneyComparisonExp>;
  totalRefundCount?: InputMaybe<TixBigintComparisonExp>;
  totalTicketSalesAmount?: InputMaybe<TixMoneyComparisonExp>;
  totalTicketSalesAmountOverall?: InputMaybe<TixMoneyComparisonExp>;
  totalTicketSalesCount?: InputMaybe<TixBigintComparisonExp>;
  totalTicketSalesCountOverall?: InputMaybe<TixBigintComparisonExp>;
  totalTicketsAvailable?: InputMaybe<TixBigintComparisonExp>;
  totalTicketsForSale?: InputMaybe<TixIntComparisonExp>;
  venueFeeTotalByTicket?: InputMaybe<TixMoneyComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  yesterdayCashAmount?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayCashCount?: InputMaybe<TixBigintComparisonExp>;
  yesterdayCompAmount?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayCompCount?: InputMaybe<TixBigintComparisonExp>;
  yesterdayDiscountAmount?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayDiscountCount?: InputMaybe<TixBigintComparisonExp>;
  yesterdayRefundAmount?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayRefundCount?: InputMaybe<TixBigintComparisonExp>;
  yesterdayTotalTicketSalesAmount?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayTotalTicketSalesAmountOverall?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayTotalTicketSalesCount?: InputMaybe<TixBigintComparisonExp>;
  yesterdayTotalTicketSalesCountOverall?: InputMaybe<TixBigintComparisonExp>;
};

/** aggregate max on columns */
export type TixDailyAuditReportFinalMaxFields = {
  __typename?: 'DailyAuditReportFinal_max_fields';
  companyName?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  formattedDate?: Maybe<Scalars['String']>;
  formattedStartTime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentTicketName?: Maybe<Scalars['String']>;
  performance?: Maybe<Scalars['String']>;
  performanceDate?: Maybe<Scalars['String']>;
  platformFeeTotalByTicket?: Maybe<Scalars['money']>;
  processingFeeTotalByTicket?: Maybe<Scalars['money']>;
  rawDate?: Maybe<Scalars['date']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  todayCashAmount?: Maybe<Scalars['money']>;
  todayCashCount?: Maybe<Scalars['bigint']>;
  todayCompAmount?: Maybe<Scalars['money']>;
  todayCompCount?: Maybe<Scalars['bigint']>;
  todayRefundAmount?: Maybe<Scalars['money']>;
  todayRefundCount?: Maybe<Scalars['bigint']>;
  todayTotalDiscountAmount?: Maybe<Scalars['money']>;
  todayTotalDiscountCount?: Maybe<Scalars['bigint']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['money']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['bigint']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['money']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['bigint']>;
  totalCashAmount?: Maybe<Scalars['money']>;
  totalCashCount?: Maybe<Scalars['bigint']>;
  totalCompAmount?: Maybe<Scalars['money']>;
  totalCompCount?: Maybe<Scalars['bigint']>;
  totalDiscountAmount?: Maybe<Scalars['money']>;
  totalDiscountCount?: Maybe<Scalars['bigint']>;
  totalFeesByTicket?: Maybe<Scalars['money']>;
  totalOnlineTicketAmount?: Maybe<Scalars['money']>;
  totalOnlineTicketCount?: Maybe<Scalars['bigint']>;
  totalRefundAmount?: Maybe<Scalars['money']>;
  totalRefundCount?: Maybe<Scalars['bigint']>;
  totalTicketSalesAmount?: Maybe<Scalars['money']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  totalTicketSalesCount?: Maybe<Scalars['bigint']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
  totalTicketsAvailable?: Maybe<Scalars['bigint']>;
  totalTicketsForSale?: Maybe<Scalars['Int']>;
  venueFeeTotalByTicket?: Maybe<Scalars['money']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdayCashAmount?: Maybe<Scalars['money']>;
  yesterdayCashCount?: Maybe<Scalars['bigint']>;
  yesterdayCompAmount?: Maybe<Scalars['money']>;
  yesterdayCompCount?: Maybe<Scalars['bigint']>;
  yesterdayDiscountAmount?: Maybe<Scalars['money']>;
  yesterdayDiscountCount?: Maybe<Scalars['bigint']>;
  yesterdayRefundAmount?: Maybe<Scalars['money']>;
  yesterdayRefundCount?: Maybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['money']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type TixDailyAuditReportFinalMinFields = {
  __typename?: 'DailyAuditReportFinal_min_fields';
  companyName?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  formattedDate?: Maybe<Scalars['String']>;
  formattedStartTime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentTicketName?: Maybe<Scalars['String']>;
  performance?: Maybe<Scalars['String']>;
  performanceDate?: Maybe<Scalars['String']>;
  platformFeeTotalByTicket?: Maybe<Scalars['money']>;
  processingFeeTotalByTicket?: Maybe<Scalars['money']>;
  rawDate?: Maybe<Scalars['date']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  todayCashAmount?: Maybe<Scalars['money']>;
  todayCashCount?: Maybe<Scalars['bigint']>;
  todayCompAmount?: Maybe<Scalars['money']>;
  todayCompCount?: Maybe<Scalars['bigint']>;
  todayRefundAmount?: Maybe<Scalars['money']>;
  todayRefundCount?: Maybe<Scalars['bigint']>;
  todayTotalDiscountAmount?: Maybe<Scalars['money']>;
  todayTotalDiscountCount?: Maybe<Scalars['bigint']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['money']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['bigint']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['money']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['bigint']>;
  totalCashAmount?: Maybe<Scalars['money']>;
  totalCashCount?: Maybe<Scalars['bigint']>;
  totalCompAmount?: Maybe<Scalars['money']>;
  totalCompCount?: Maybe<Scalars['bigint']>;
  totalDiscountAmount?: Maybe<Scalars['money']>;
  totalDiscountCount?: Maybe<Scalars['bigint']>;
  totalFeesByTicket?: Maybe<Scalars['money']>;
  totalOnlineTicketAmount?: Maybe<Scalars['money']>;
  totalOnlineTicketCount?: Maybe<Scalars['bigint']>;
  totalRefundAmount?: Maybe<Scalars['money']>;
  totalRefundCount?: Maybe<Scalars['bigint']>;
  totalTicketSalesAmount?: Maybe<Scalars['money']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  totalTicketSalesCount?: Maybe<Scalars['bigint']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
  totalTicketsAvailable?: Maybe<Scalars['bigint']>;
  totalTicketsForSale?: Maybe<Scalars['Int']>;
  venueFeeTotalByTicket?: Maybe<Scalars['money']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdayCashAmount?: Maybe<Scalars['money']>;
  yesterdayCashCount?: Maybe<Scalars['bigint']>;
  yesterdayCompAmount?: Maybe<Scalars['money']>;
  yesterdayCompCount?: Maybe<Scalars['bigint']>;
  yesterdayDiscountAmount?: Maybe<Scalars['money']>;
  yesterdayDiscountCount?: Maybe<Scalars['bigint']>;
  yesterdayRefundAmount?: Maybe<Scalars['money']>;
  yesterdayRefundCount?: Maybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['money']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "reporting.v_daily_audit_report_final". */
export type TixDailyAuditReportFinalOrderBy = {
  companyName?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  formattedDate?: InputMaybe<TixOrderBy>;
  formattedStartTime?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  parentTicketName?: InputMaybe<TixOrderBy>;
  performance?: InputMaybe<TixOrderBy>;
  performanceDate?: InputMaybe<TixOrderBy>;
  platformFeeTotalByTicket?: InputMaybe<TixOrderBy>;
  processingFeeTotalByTicket?: InputMaybe<TixOrderBy>;
  rawDate?: InputMaybe<TixOrderBy>;
  rawStartTime?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  todayCashAmount?: InputMaybe<TixOrderBy>;
  todayCashCount?: InputMaybe<TixOrderBy>;
  todayCompAmount?: InputMaybe<TixOrderBy>;
  todayCompCount?: InputMaybe<TixOrderBy>;
  todayRefundAmount?: InputMaybe<TixOrderBy>;
  todayRefundCount?: InputMaybe<TixOrderBy>;
  todayTotalDiscountAmount?: InputMaybe<TixOrderBy>;
  todayTotalDiscountCount?: InputMaybe<TixOrderBy>;
  todayTotalTicketSalesAmount?: InputMaybe<TixOrderBy>;
  todayTotalTicketSalesAmountOverall?: InputMaybe<TixOrderBy>;
  todayTotalTicketSalesCount?: InputMaybe<TixOrderBy>;
  todayTotalTicketSalesCountOverall?: InputMaybe<TixOrderBy>;
  totalBoxofficeTicketAmount?: InputMaybe<TixOrderBy>;
  totalBoxofficeTicketCount?: InputMaybe<TixOrderBy>;
  totalCashAmount?: InputMaybe<TixOrderBy>;
  totalCashCount?: InputMaybe<TixOrderBy>;
  totalCompAmount?: InputMaybe<TixOrderBy>;
  totalCompCount?: InputMaybe<TixOrderBy>;
  totalDiscountAmount?: InputMaybe<TixOrderBy>;
  totalDiscountCount?: InputMaybe<TixOrderBy>;
  totalFeesByTicket?: InputMaybe<TixOrderBy>;
  totalOnlineTicketAmount?: InputMaybe<TixOrderBy>;
  totalOnlineTicketCount?: InputMaybe<TixOrderBy>;
  totalRefundAmount?: InputMaybe<TixOrderBy>;
  totalRefundCount?: InputMaybe<TixOrderBy>;
  totalTicketSalesAmount?: InputMaybe<TixOrderBy>;
  totalTicketSalesAmountOverall?: InputMaybe<TixOrderBy>;
  totalTicketSalesCount?: InputMaybe<TixOrderBy>;
  totalTicketSalesCountOverall?: InputMaybe<TixOrderBy>;
  totalTicketsAvailable?: InputMaybe<TixOrderBy>;
  totalTicketsForSale?: InputMaybe<TixOrderBy>;
  venueFeeTotalByTicket?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  yesterdayCashAmount?: InputMaybe<TixOrderBy>;
  yesterdayCashCount?: InputMaybe<TixOrderBy>;
  yesterdayCompAmount?: InputMaybe<TixOrderBy>;
  yesterdayCompCount?: InputMaybe<TixOrderBy>;
  yesterdayDiscountAmount?: InputMaybe<TixOrderBy>;
  yesterdayDiscountCount?: InputMaybe<TixOrderBy>;
  yesterdayRefundAmount?: InputMaybe<TixOrderBy>;
  yesterdayRefundCount?: InputMaybe<TixOrderBy>;
  yesterdayTotalTicketSalesAmount?: InputMaybe<TixOrderBy>;
  yesterdayTotalTicketSalesAmountOverall?: InputMaybe<TixOrderBy>;
  yesterdayTotalTicketSalesCount?: InputMaybe<TixOrderBy>;
  yesterdayTotalTicketSalesCountOverall?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_daily_audit_report_final" */
export enum TixDailyAuditReportFinalSelectColumn {
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  FormattedDate = 'formattedDate',
  /** column name */
  FormattedStartTime = 'formattedStartTime',
  /** column name */
  Name = 'name',
  /** column name */
  ParentTicketName = 'parentTicketName',
  /** column name */
  Performance = 'performance',
  /** column name */
  PerformanceDate = 'performanceDate',
  /** column name */
  PlatformFeeTotalByTicket = 'platformFeeTotalByTicket',
  /** column name */
  ProcessingFeeTotalByTicket = 'processingFeeTotalByTicket',
  /** column name */
  RawDate = 'rawDate',
  /** column name */
  RawStartTime = 'rawStartTime',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TodayCashAmount = 'todayCashAmount',
  /** column name */
  TodayCashCount = 'todayCashCount',
  /** column name */
  TodayCompAmount = 'todayCompAmount',
  /** column name */
  TodayCompCount = 'todayCompCount',
  /** column name */
  TodayRefundAmount = 'todayRefundAmount',
  /** column name */
  TodayRefundCount = 'todayRefundCount',
  /** column name */
  TodayTotalDiscountAmount = 'todayTotalDiscountAmount',
  /** column name */
  TodayTotalDiscountCount = 'todayTotalDiscountCount',
  /** column name */
  TodayTotalTicketSalesAmount = 'todayTotalTicketSalesAmount',
  /** column name */
  TodayTotalTicketSalesAmountOverall = 'todayTotalTicketSalesAmountOverall',
  /** column name */
  TodayTotalTicketSalesCount = 'todayTotalTicketSalesCount',
  /** column name */
  TodayTotalTicketSalesCountOverall = 'todayTotalTicketSalesCountOverall',
  /** column name */
  TotalBoxofficeTicketAmount = 'totalBoxofficeTicketAmount',
  /** column name */
  TotalBoxofficeTicketCount = 'totalBoxofficeTicketCount',
  /** column name */
  TotalCashAmount = 'totalCashAmount',
  /** column name */
  TotalCashCount = 'totalCashCount',
  /** column name */
  TotalCompAmount = 'totalCompAmount',
  /** column name */
  TotalCompCount = 'totalCompCount',
  /** column name */
  TotalDiscountAmount = 'totalDiscountAmount',
  /** column name */
  TotalDiscountCount = 'totalDiscountCount',
  /** column name */
  TotalFeesByTicket = 'totalFeesByTicket',
  /** column name */
  TotalOnlineTicketAmount = 'totalOnlineTicketAmount',
  /** column name */
  TotalOnlineTicketCount = 'totalOnlineTicketCount',
  /** column name */
  TotalRefundAmount = 'totalRefundAmount',
  /** column name */
  TotalRefundCount = 'totalRefundCount',
  /** column name */
  TotalTicketSalesAmount = 'totalTicketSalesAmount',
  /** column name */
  TotalTicketSalesAmountOverall = 'totalTicketSalesAmountOverall',
  /** column name */
  TotalTicketSalesCount = 'totalTicketSalesCount',
  /** column name */
  TotalTicketSalesCountOverall = 'totalTicketSalesCountOverall',
  /** column name */
  TotalTicketsAvailable = 'totalTicketsAvailable',
  /** column name */
  TotalTicketsForSale = 'totalTicketsForSale',
  /** column name */
  VenueFeeTotalByTicket = 'venueFeeTotalByTicket',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  YesterdayCashAmount = 'yesterdayCashAmount',
  /** column name */
  YesterdayCashCount = 'yesterdayCashCount',
  /** column name */
  YesterdayCompAmount = 'yesterdayCompAmount',
  /** column name */
  YesterdayCompCount = 'yesterdayCompCount',
  /** column name */
  YesterdayDiscountAmount = 'yesterdayDiscountAmount',
  /** column name */
  YesterdayDiscountCount = 'yesterdayDiscountCount',
  /** column name */
  YesterdayRefundAmount = 'yesterdayRefundAmount',
  /** column name */
  YesterdayRefundCount = 'yesterdayRefundCount',
  /** column name */
  YesterdayTotalTicketSalesAmount = 'yesterdayTotalTicketSalesAmount',
  /** column name */
  YesterdayTotalTicketSalesAmountOverall = 'yesterdayTotalTicketSalesAmountOverall',
  /** column name */
  YesterdayTotalTicketSalesCount = 'yesterdayTotalTicketSalesCount',
  /** column name */
  YesterdayTotalTicketSalesCountOverall = 'yesterdayTotalTicketSalesCountOverall'
}

/** aggregate stddev on columns */
export type TixDailyAuditReportFinalStddevFields = {
  __typename?: 'DailyAuditReportFinal_stddev_fields';
  platformFeeTotalByTicket?: Maybe<Scalars['Float']>;
  processingFeeTotalByTicket?: Maybe<Scalars['Float']>;
  todayCashAmount?: Maybe<Scalars['Float']>;
  todayCashCount?: Maybe<Scalars['Float']>;
  todayCompAmount?: Maybe<Scalars['Float']>;
  todayCompCount?: Maybe<Scalars['Float']>;
  todayRefundAmount?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayTotalDiscountAmount?: Maybe<Scalars['Float']>;
  todayTotalDiscountCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['Float']>;
  totalCashAmount?: Maybe<Scalars['Float']>;
  totalCashCount?: Maybe<Scalars['Float']>;
  totalCompAmount?: Maybe<Scalars['Float']>;
  totalCompCount?: Maybe<Scalars['Float']>;
  totalDiscountAmount?: Maybe<Scalars['Float']>;
  totalDiscountCount?: Maybe<Scalars['Float']>;
  totalFeesByTicket?: Maybe<Scalars['Float']>;
  totalOnlineTicketAmount?: Maybe<Scalars['Float']>;
  totalOnlineTicketCount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  totalTicketSalesCount?: Maybe<Scalars['Float']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalTicketsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsForSale?: Maybe<Scalars['Float']>;
  venueFeeTotalByTicket?: Maybe<Scalars['Float']>;
  yesterdayCashAmount?: Maybe<Scalars['Float']>;
  yesterdayCashCount?: Maybe<Scalars['Float']>;
  yesterdayCompAmount?: Maybe<Scalars['Float']>;
  yesterdayCompCount?: Maybe<Scalars['Float']>;
  yesterdayDiscountAmount?: Maybe<Scalars['Float']>;
  yesterdayDiscountCount?: Maybe<Scalars['Float']>;
  yesterdayRefundAmount?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixDailyAuditReportFinalStddevPopFields = {
  __typename?: 'DailyAuditReportFinal_stddev_pop_fields';
  platformFeeTotalByTicket?: Maybe<Scalars['Float']>;
  processingFeeTotalByTicket?: Maybe<Scalars['Float']>;
  todayCashAmount?: Maybe<Scalars['Float']>;
  todayCashCount?: Maybe<Scalars['Float']>;
  todayCompAmount?: Maybe<Scalars['Float']>;
  todayCompCount?: Maybe<Scalars['Float']>;
  todayRefundAmount?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayTotalDiscountAmount?: Maybe<Scalars['Float']>;
  todayTotalDiscountCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['Float']>;
  totalCashAmount?: Maybe<Scalars['Float']>;
  totalCashCount?: Maybe<Scalars['Float']>;
  totalCompAmount?: Maybe<Scalars['Float']>;
  totalCompCount?: Maybe<Scalars['Float']>;
  totalDiscountAmount?: Maybe<Scalars['Float']>;
  totalDiscountCount?: Maybe<Scalars['Float']>;
  totalFeesByTicket?: Maybe<Scalars['Float']>;
  totalOnlineTicketAmount?: Maybe<Scalars['Float']>;
  totalOnlineTicketCount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  totalTicketSalesCount?: Maybe<Scalars['Float']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalTicketsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsForSale?: Maybe<Scalars['Float']>;
  venueFeeTotalByTicket?: Maybe<Scalars['Float']>;
  yesterdayCashAmount?: Maybe<Scalars['Float']>;
  yesterdayCashCount?: Maybe<Scalars['Float']>;
  yesterdayCompAmount?: Maybe<Scalars['Float']>;
  yesterdayCompCount?: Maybe<Scalars['Float']>;
  yesterdayDiscountAmount?: Maybe<Scalars['Float']>;
  yesterdayDiscountCount?: Maybe<Scalars['Float']>;
  yesterdayRefundAmount?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixDailyAuditReportFinalStddevSampFields = {
  __typename?: 'DailyAuditReportFinal_stddev_samp_fields';
  platformFeeTotalByTicket?: Maybe<Scalars['Float']>;
  processingFeeTotalByTicket?: Maybe<Scalars['Float']>;
  todayCashAmount?: Maybe<Scalars['Float']>;
  todayCashCount?: Maybe<Scalars['Float']>;
  todayCompAmount?: Maybe<Scalars['Float']>;
  todayCompCount?: Maybe<Scalars['Float']>;
  todayRefundAmount?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayTotalDiscountAmount?: Maybe<Scalars['Float']>;
  todayTotalDiscountCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['Float']>;
  totalCashAmount?: Maybe<Scalars['Float']>;
  totalCashCount?: Maybe<Scalars['Float']>;
  totalCompAmount?: Maybe<Scalars['Float']>;
  totalCompCount?: Maybe<Scalars['Float']>;
  totalDiscountAmount?: Maybe<Scalars['Float']>;
  totalDiscountCount?: Maybe<Scalars['Float']>;
  totalFeesByTicket?: Maybe<Scalars['Float']>;
  totalOnlineTicketAmount?: Maybe<Scalars['Float']>;
  totalOnlineTicketCount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  totalTicketSalesCount?: Maybe<Scalars['Float']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalTicketsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsForSale?: Maybe<Scalars['Float']>;
  venueFeeTotalByTicket?: Maybe<Scalars['Float']>;
  yesterdayCashAmount?: Maybe<Scalars['Float']>;
  yesterdayCashCount?: Maybe<Scalars['Float']>;
  yesterdayCompAmount?: Maybe<Scalars['Float']>;
  yesterdayCompCount?: Maybe<Scalars['Float']>;
  yesterdayDiscountAmount?: Maybe<Scalars['Float']>;
  yesterdayDiscountCount?: Maybe<Scalars['Float']>;
  yesterdayRefundAmount?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "DailyAuditReportFinal" */
export type TixDailyAuditReportFinalStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixDailyAuditReportFinalStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixDailyAuditReportFinalStreamCursorValueInput = {
  companyName?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  formattedDate?: InputMaybe<Scalars['String']>;
  formattedStartTime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentTicketName?: InputMaybe<Scalars['String']>;
  performance?: InputMaybe<Scalars['String']>;
  performanceDate?: InputMaybe<Scalars['String']>;
  platformFeeTotalByTicket?: InputMaybe<Scalars['money']>;
  processingFeeTotalByTicket?: InputMaybe<Scalars['money']>;
  rawDate?: InputMaybe<Scalars['date']>;
  rawStartTime?: InputMaybe<Scalars['time']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  todayCashAmount?: InputMaybe<Scalars['money']>;
  todayCashCount?: InputMaybe<Scalars['bigint']>;
  todayCompAmount?: InputMaybe<Scalars['money']>;
  todayCompCount?: InputMaybe<Scalars['bigint']>;
  todayRefundAmount?: InputMaybe<Scalars['money']>;
  todayRefundCount?: InputMaybe<Scalars['bigint']>;
  todayTotalDiscountAmount?: InputMaybe<Scalars['money']>;
  todayTotalDiscountCount?: InputMaybe<Scalars['bigint']>;
  todayTotalTicketSalesAmount?: InputMaybe<Scalars['money']>;
  todayTotalTicketSalesAmountOverall?: InputMaybe<Scalars['money']>;
  todayTotalTicketSalesCount?: InputMaybe<Scalars['bigint']>;
  todayTotalTicketSalesCountOverall?: InputMaybe<Scalars['bigint']>;
  totalBoxofficeTicketAmount?: InputMaybe<Scalars['money']>;
  totalBoxofficeTicketCount?: InputMaybe<Scalars['bigint']>;
  totalCashAmount?: InputMaybe<Scalars['money']>;
  totalCashCount?: InputMaybe<Scalars['bigint']>;
  totalCompAmount?: InputMaybe<Scalars['money']>;
  totalCompCount?: InputMaybe<Scalars['bigint']>;
  totalDiscountAmount?: InputMaybe<Scalars['money']>;
  totalDiscountCount?: InputMaybe<Scalars['bigint']>;
  totalFeesByTicket?: InputMaybe<Scalars['money']>;
  totalOnlineTicketAmount?: InputMaybe<Scalars['money']>;
  totalOnlineTicketCount?: InputMaybe<Scalars['bigint']>;
  totalRefundAmount?: InputMaybe<Scalars['money']>;
  totalRefundCount?: InputMaybe<Scalars['bigint']>;
  totalTicketSalesAmount?: InputMaybe<Scalars['money']>;
  totalTicketSalesAmountOverall?: InputMaybe<Scalars['money']>;
  totalTicketSalesCount?: InputMaybe<Scalars['bigint']>;
  totalTicketSalesCountOverall?: InputMaybe<Scalars['bigint']>;
  totalTicketsAvailable?: InputMaybe<Scalars['bigint']>;
  totalTicketsForSale?: InputMaybe<Scalars['Int']>;
  venueFeeTotalByTicket?: InputMaybe<Scalars['money']>;
  venueName?: InputMaybe<Scalars['String']>;
  yesterdayCashAmount?: InputMaybe<Scalars['money']>;
  yesterdayCashCount?: InputMaybe<Scalars['bigint']>;
  yesterdayCompAmount?: InputMaybe<Scalars['money']>;
  yesterdayCompCount?: InputMaybe<Scalars['bigint']>;
  yesterdayDiscountAmount?: InputMaybe<Scalars['money']>;
  yesterdayDiscountCount?: InputMaybe<Scalars['bigint']>;
  yesterdayRefundAmount?: InputMaybe<Scalars['money']>;
  yesterdayRefundCount?: InputMaybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesAmount?: InputMaybe<Scalars['money']>;
  yesterdayTotalTicketSalesAmountOverall?: InputMaybe<Scalars['money']>;
  yesterdayTotalTicketSalesCount?: InputMaybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesCountOverall?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TixDailyAuditReportFinalSumFields = {
  __typename?: 'DailyAuditReportFinal_sum_fields';
  platformFeeTotalByTicket?: Maybe<Scalars['money']>;
  processingFeeTotalByTicket?: Maybe<Scalars['money']>;
  todayCashAmount?: Maybe<Scalars['money']>;
  todayCashCount?: Maybe<Scalars['bigint']>;
  todayCompAmount?: Maybe<Scalars['money']>;
  todayCompCount?: Maybe<Scalars['bigint']>;
  todayRefundAmount?: Maybe<Scalars['money']>;
  todayRefundCount?: Maybe<Scalars['bigint']>;
  todayTotalDiscountAmount?: Maybe<Scalars['money']>;
  todayTotalDiscountCount?: Maybe<Scalars['bigint']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['money']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['bigint']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['money']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['bigint']>;
  totalCashAmount?: Maybe<Scalars['money']>;
  totalCashCount?: Maybe<Scalars['bigint']>;
  totalCompAmount?: Maybe<Scalars['money']>;
  totalCompCount?: Maybe<Scalars['bigint']>;
  totalDiscountAmount?: Maybe<Scalars['money']>;
  totalDiscountCount?: Maybe<Scalars['bigint']>;
  totalFeesByTicket?: Maybe<Scalars['money']>;
  totalOnlineTicketAmount?: Maybe<Scalars['money']>;
  totalOnlineTicketCount?: Maybe<Scalars['bigint']>;
  totalRefundAmount?: Maybe<Scalars['money']>;
  totalRefundCount?: Maybe<Scalars['bigint']>;
  totalTicketSalesAmount?: Maybe<Scalars['money']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  totalTicketSalesCount?: Maybe<Scalars['bigint']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
  totalTicketsAvailable?: Maybe<Scalars['bigint']>;
  totalTicketsForSale?: Maybe<Scalars['Int']>;
  venueFeeTotalByTicket?: Maybe<Scalars['money']>;
  yesterdayCashAmount?: Maybe<Scalars['money']>;
  yesterdayCashCount?: Maybe<Scalars['bigint']>;
  yesterdayCompAmount?: Maybe<Scalars['money']>;
  yesterdayCompCount?: Maybe<Scalars['bigint']>;
  yesterdayDiscountAmount?: Maybe<Scalars['money']>;
  yesterdayDiscountCount?: Maybe<Scalars['bigint']>;
  yesterdayRefundAmount?: Maybe<Scalars['money']>;
  yesterdayRefundCount?: Maybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['money']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['money']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['bigint']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type TixDailyAuditReportFinalVarPopFields = {
  __typename?: 'DailyAuditReportFinal_var_pop_fields';
  platformFeeTotalByTicket?: Maybe<Scalars['Float']>;
  processingFeeTotalByTicket?: Maybe<Scalars['Float']>;
  todayCashAmount?: Maybe<Scalars['Float']>;
  todayCashCount?: Maybe<Scalars['Float']>;
  todayCompAmount?: Maybe<Scalars['Float']>;
  todayCompCount?: Maybe<Scalars['Float']>;
  todayRefundAmount?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayTotalDiscountAmount?: Maybe<Scalars['Float']>;
  todayTotalDiscountCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['Float']>;
  totalCashAmount?: Maybe<Scalars['Float']>;
  totalCashCount?: Maybe<Scalars['Float']>;
  totalCompAmount?: Maybe<Scalars['Float']>;
  totalCompCount?: Maybe<Scalars['Float']>;
  totalDiscountAmount?: Maybe<Scalars['Float']>;
  totalDiscountCount?: Maybe<Scalars['Float']>;
  totalFeesByTicket?: Maybe<Scalars['Float']>;
  totalOnlineTicketAmount?: Maybe<Scalars['Float']>;
  totalOnlineTicketCount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  totalTicketSalesCount?: Maybe<Scalars['Float']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalTicketsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsForSale?: Maybe<Scalars['Float']>;
  venueFeeTotalByTicket?: Maybe<Scalars['Float']>;
  yesterdayCashAmount?: Maybe<Scalars['Float']>;
  yesterdayCashCount?: Maybe<Scalars['Float']>;
  yesterdayCompAmount?: Maybe<Scalars['Float']>;
  yesterdayCompCount?: Maybe<Scalars['Float']>;
  yesterdayDiscountAmount?: Maybe<Scalars['Float']>;
  yesterdayDiscountCount?: Maybe<Scalars['Float']>;
  yesterdayRefundAmount?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixDailyAuditReportFinalVarSampFields = {
  __typename?: 'DailyAuditReportFinal_var_samp_fields';
  platformFeeTotalByTicket?: Maybe<Scalars['Float']>;
  processingFeeTotalByTicket?: Maybe<Scalars['Float']>;
  todayCashAmount?: Maybe<Scalars['Float']>;
  todayCashCount?: Maybe<Scalars['Float']>;
  todayCompAmount?: Maybe<Scalars['Float']>;
  todayCompCount?: Maybe<Scalars['Float']>;
  todayRefundAmount?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayTotalDiscountAmount?: Maybe<Scalars['Float']>;
  todayTotalDiscountCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['Float']>;
  totalCashAmount?: Maybe<Scalars['Float']>;
  totalCashCount?: Maybe<Scalars['Float']>;
  totalCompAmount?: Maybe<Scalars['Float']>;
  totalCompCount?: Maybe<Scalars['Float']>;
  totalDiscountAmount?: Maybe<Scalars['Float']>;
  totalDiscountCount?: Maybe<Scalars['Float']>;
  totalFeesByTicket?: Maybe<Scalars['Float']>;
  totalOnlineTicketAmount?: Maybe<Scalars['Float']>;
  totalOnlineTicketCount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  totalTicketSalesCount?: Maybe<Scalars['Float']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalTicketsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsForSale?: Maybe<Scalars['Float']>;
  venueFeeTotalByTicket?: Maybe<Scalars['Float']>;
  yesterdayCashAmount?: Maybe<Scalars['Float']>;
  yesterdayCashCount?: Maybe<Scalars['Float']>;
  yesterdayCompAmount?: Maybe<Scalars['Float']>;
  yesterdayCompCount?: Maybe<Scalars['Float']>;
  yesterdayDiscountAmount?: Maybe<Scalars['Float']>;
  yesterdayDiscountCount?: Maybe<Scalars['Float']>;
  yesterdayRefundAmount?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixDailyAuditReportFinalVarianceFields = {
  __typename?: 'DailyAuditReportFinal_variance_fields';
  platformFeeTotalByTicket?: Maybe<Scalars['Float']>;
  processingFeeTotalByTicket?: Maybe<Scalars['Float']>;
  todayCashAmount?: Maybe<Scalars['Float']>;
  todayCashCount?: Maybe<Scalars['Float']>;
  todayCompAmount?: Maybe<Scalars['Float']>;
  todayCompCount?: Maybe<Scalars['Float']>;
  todayRefundAmount?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayTotalDiscountAmount?: Maybe<Scalars['Float']>;
  todayTotalDiscountCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  todayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketAmount?: Maybe<Scalars['Float']>;
  totalBoxofficeTicketCount?: Maybe<Scalars['Float']>;
  totalCashAmount?: Maybe<Scalars['Float']>;
  totalCashCount?: Maybe<Scalars['Float']>;
  totalCompAmount?: Maybe<Scalars['Float']>;
  totalCompCount?: Maybe<Scalars['Float']>;
  totalDiscountAmount?: Maybe<Scalars['Float']>;
  totalDiscountCount?: Maybe<Scalars['Float']>;
  totalFeesByTicket?: Maybe<Scalars['Float']>;
  totalOnlineTicketAmount?: Maybe<Scalars['Float']>;
  totalOnlineTicketCount?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmount?: Maybe<Scalars['Float']>;
  totalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  totalTicketSalesCount?: Maybe<Scalars['Float']>;
  totalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
  totalTicketsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsForSale?: Maybe<Scalars['Float']>;
  venueFeeTotalByTicket?: Maybe<Scalars['Float']>;
  yesterdayCashAmount?: Maybe<Scalars['Float']>;
  yesterdayCashCount?: Maybe<Scalars['Float']>;
  yesterdayCompAmount?: Maybe<Scalars['Float']>;
  yesterdayCompCount?: Maybe<Scalars['Float']>;
  yesterdayDiscountAmount?: Maybe<Scalars['Float']>;
  yesterdayDiscountCount?: Maybe<Scalars['Float']>;
  yesterdayRefundAmount?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesAmountOverall?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCount?: Maybe<Scalars['Float']>;
  yesterdayTotalTicketSalesCountOverall?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "reporting.v_daily_audit" */
export type TixDailyAuditReportAggregate = {
  __typename?: 'DailyAuditReport_aggregate';
  aggregate?: Maybe<TixDailyAuditReportAggregateFields>;
  nodes: Array<TixDailyAuditReport>;
};

/** aggregate fields of "reporting.v_daily_audit" */
export type TixDailyAuditReportAggregateFields = {
  __typename?: 'DailyAuditReport_aggregate_fields';
  avg?: Maybe<TixDailyAuditReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixDailyAuditReportMaxFields>;
  min?: Maybe<TixDailyAuditReportMinFields>;
  stddev?: Maybe<TixDailyAuditReportStddevFields>;
  stddev_pop?: Maybe<TixDailyAuditReportStddevPopFields>;
  stddev_samp?: Maybe<TixDailyAuditReportStddevSampFields>;
  sum?: Maybe<TixDailyAuditReportSumFields>;
  var_pop?: Maybe<TixDailyAuditReportVarPopFields>;
  var_samp?: Maybe<TixDailyAuditReportVarSampFields>;
  variance?: Maybe<TixDailyAuditReportVarianceFields>;
};


/** aggregate fields of "reporting.v_daily_audit" */
export type TixDailyAuditReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixDailyAuditReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixDailyAuditReportAvgFields = {
  __typename?: 'DailyAuditReport_avg_fields';
  boxofficeTicketCount?: Maybe<Scalars['Float']>;
  dailyRevenue?: Maybe<Scalars['Float']>;
  daysOut?: Maybe<Scalars['Float']>;
  onlineTicketCount?: Maybe<Scalars['Float']>;
  todayComp?: Maybe<Scalars['Float']>;
  todayDiscounts?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayRefunds?: Maybe<Scalars['Float']>;
  todayTicketRevenue?: Maybe<Scalars['Float']>;
  todayTicketsSold?: Maybe<Scalars['Float']>;
  todayVenueRevenue?: Maybe<Scalars['Float']>;
  totalComp?: Maybe<Scalars['Float']>;
  totalDiscounts?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalSeatsRemaining?: Maybe<Scalars['Float']>;
  totalTicketRevenue?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  totalVenueRevenue?: Maybe<Scalars['Float']>;
  yesterdayComp?: Maybe<Scalars['Float']>;
  yesterdayDiscounts?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayRefunds?: Maybe<Scalars['Float']>;
  yesterdayRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketsSold?: Maybe<Scalars['Float']>;
  yesterdayVenueRevenue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_daily_audit". All fields are combined with a logical 'AND'. */
export type TixDailyAuditReportBoolExp = {
  _and?: InputMaybe<Array<TixDailyAuditReportBoolExp>>;
  _not?: InputMaybe<TixDailyAuditReportBoolExp>;
  _or?: InputMaybe<Array<TixDailyAuditReportBoolExp>>;
  boxofficeTicketCount?: InputMaybe<TixBigintComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  dailyRevenue?: InputMaybe<TixMoneyComparisonExp>;
  date?: InputMaybe<TixDateComparisonExp>;
  daysOut?: InputMaybe<TixFloat8ComparisonExp>;
  eventDate?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventTime?: InputMaybe<TixTimeComparisonExp>;
  includeFees?: InputMaybe<TixBooleanComparisonExp>;
  onlineTicketCount?: InputMaybe<TixBigintComparisonExp>;
  percentSold?: InputMaybe<TixStringComparisonExp>;
  performance?: InputMaybe<TixStringComparisonExp>;
  performanceDate?: InputMaybe<TixStringComparisonExp>;
  startTime?: InputMaybe<TixStringComparisonExp>;
  ticketName?: InputMaybe<TixStringComparisonExp>;
  todayComp?: InputMaybe<TixBigintComparisonExp>;
  todayDiscounts?: InputMaybe<TixMoneyComparisonExp>;
  todayRefundCount?: InputMaybe<TixNumericComparisonExp>;
  todayRefunds?: InputMaybe<TixMoneyComparisonExp>;
  todayTicketRevenue?: InputMaybe<TixMoneyComparisonExp>;
  todayTicketsSold?: InputMaybe<TixBigintComparisonExp>;
  todayVenueRevenue?: InputMaybe<TixMoneyComparisonExp>;
  totalComp?: InputMaybe<TixBigintComparisonExp>;
  totalDiscounts?: InputMaybe<TixMoneyComparisonExp>;
  totalRefundAmount?: InputMaybe<TixMoneyComparisonExp>;
  totalRefundCount?: InputMaybe<TixNumericComparisonExp>;
  totalRevenue?: InputMaybe<TixMoneyComparisonExp>;
  totalSeatsAvailable?: InputMaybe<TixIntComparisonExp>;
  totalSeatsRemaining?: InputMaybe<TixBigintComparisonExp>;
  totalTicketRevenue?: InputMaybe<TixMoneyComparisonExp>;
  totalTicketsSold?: InputMaybe<TixBigintComparisonExp>;
  totalVenueRevenue?: InputMaybe<TixMoneyComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  yesterdayComp?: InputMaybe<TixBigintComparisonExp>;
  yesterdayDiscounts?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayRefundCount?: InputMaybe<TixNumericComparisonExp>;
  yesterdayRefunds?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayRevenue?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayTicketRevenue?: InputMaybe<TixMoneyComparisonExp>;
  yesterdayTicketsSold?: InputMaybe<TixBigintComparisonExp>;
  yesterdayVenueRevenue?: InputMaybe<TixMoneyComparisonExp>;
};

/** aggregate max on columns */
export type TixDailyAuditReportMaxFields = {
  __typename?: 'DailyAuditReport_max_fields';
  boxofficeTicketCount?: Maybe<Scalars['bigint']>;
  companyName?: Maybe<Scalars['String']>;
  dailyRevenue?: Maybe<Scalars['money']>;
  date?: Maybe<Scalars['date']>;
  daysOut?: Maybe<Scalars['float8']>;
  eventDate?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  onlineTicketCount?: Maybe<Scalars['bigint']>;
  percentSold?: Maybe<Scalars['String']>;
  performance?: Maybe<Scalars['String']>;
  performanceDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  ticketName?: Maybe<Scalars['String']>;
  todayComp?: Maybe<Scalars['bigint']>;
  todayDiscounts?: Maybe<Scalars['money']>;
  todayRefundCount?: Maybe<Scalars['numeric']>;
  todayRefunds?: Maybe<Scalars['money']>;
  todayTicketRevenue?: Maybe<Scalars['money']>;
  todayTicketsSold?: Maybe<Scalars['bigint']>;
  todayVenueRevenue?: Maybe<Scalars['money']>;
  totalComp?: Maybe<Scalars['bigint']>;
  totalDiscounts?: Maybe<Scalars['money']>;
  totalRefundAmount?: Maybe<Scalars['money']>;
  totalRefundCount?: Maybe<Scalars['numeric']>;
  totalRevenue?: Maybe<Scalars['money']>;
  totalSeatsAvailable?: Maybe<Scalars['Int']>;
  totalSeatsRemaining?: Maybe<Scalars['bigint']>;
  totalTicketRevenue?: Maybe<Scalars['money']>;
  totalTicketsSold?: Maybe<Scalars['bigint']>;
  totalVenueRevenue?: Maybe<Scalars['money']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdayComp?: Maybe<Scalars['bigint']>;
  yesterdayDiscounts?: Maybe<Scalars['money']>;
  yesterdayRefundCount?: Maybe<Scalars['numeric']>;
  yesterdayRefunds?: Maybe<Scalars['money']>;
  yesterdayRevenue?: Maybe<Scalars['money']>;
  yesterdayTicketRevenue?: Maybe<Scalars['money']>;
  yesterdayTicketsSold?: Maybe<Scalars['bigint']>;
  yesterdayVenueRevenue?: Maybe<Scalars['money']>;
};

/** aggregate min on columns */
export type TixDailyAuditReportMinFields = {
  __typename?: 'DailyAuditReport_min_fields';
  boxofficeTicketCount?: Maybe<Scalars['bigint']>;
  companyName?: Maybe<Scalars['String']>;
  dailyRevenue?: Maybe<Scalars['money']>;
  date?: Maybe<Scalars['date']>;
  daysOut?: Maybe<Scalars['float8']>;
  eventDate?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  onlineTicketCount?: Maybe<Scalars['bigint']>;
  percentSold?: Maybe<Scalars['String']>;
  performance?: Maybe<Scalars['String']>;
  performanceDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  ticketName?: Maybe<Scalars['String']>;
  todayComp?: Maybe<Scalars['bigint']>;
  todayDiscounts?: Maybe<Scalars['money']>;
  todayRefundCount?: Maybe<Scalars['numeric']>;
  todayRefunds?: Maybe<Scalars['money']>;
  todayTicketRevenue?: Maybe<Scalars['money']>;
  todayTicketsSold?: Maybe<Scalars['bigint']>;
  todayVenueRevenue?: Maybe<Scalars['money']>;
  totalComp?: Maybe<Scalars['bigint']>;
  totalDiscounts?: Maybe<Scalars['money']>;
  totalRefundAmount?: Maybe<Scalars['money']>;
  totalRefundCount?: Maybe<Scalars['numeric']>;
  totalRevenue?: Maybe<Scalars['money']>;
  totalSeatsAvailable?: Maybe<Scalars['Int']>;
  totalSeatsRemaining?: Maybe<Scalars['bigint']>;
  totalTicketRevenue?: Maybe<Scalars['money']>;
  totalTicketsSold?: Maybe<Scalars['bigint']>;
  totalVenueRevenue?: Maybe<Scalars['money']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdayComp?: Maybe<Scalars['bigint']>;
  yesterdayDiscounts?: Maybe<Scalars['money']>;
  yesterdayRefundCount?: Maybe<Scalars['numeric']>;
  yesterdayRefunds?: Maybe<Scalars['money']>;
  yesterdayRevenue?: Maybe<Scalars['money']>;
  yesterdayTicketRevenue?: Maybe<Scalars['money']>;
  yesterdayTicketsSold?: Maybe<Scalars['bigint']>;
  yesterdayVenueRevenue?: Maybe<Scalars['money']>;
};

/** Ordering options when selecting data from "reporting.v_daily_audit". */
export type TixDailyAuditReportOrderBy = {
  boxofficeTicketCount?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  dailyRevenue?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  daysOut?: InputMaybe<TixOrderBy>;
  eventDate?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventTime?: InputMaybe<TixOrderBy>;
  includeFees?: InputMaybe<TixOrderBy>;
  onlineTicketCount?: InputMaybe<TixOrderBy>;
  percentSold?: InputMaybe<TixOrderBy>;
  performance?: InputMaybe<TixOrderBy>;
  performanceDate?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  ticketName?: InputMaybe<TixOrderBy>;
  todayComp?: InputMaybe<TixOrderBy>;
  todayDiscounts?: InputMaybe<TixOrderBy>;
  todayRefundCount?: InputMaybe<TixOrderBy>;
  todayRefunds?: InputMaybe<TixOrderBy>;
  todayTicketRevenue?: InputMaybe<TixOrderBy>;
  todayTicketsSold?: InputMaybe<TixOrderBy>;
  todayVenueRevenue?: InputMaybe<TixOrderBy>;
  totalComp?: InputMaybe<TixOrderBy>;
  totalDiscounts?: InputMaybe<TixOrderBy>;
  totalRefundAmount?: InputMaybe<TixOrderBy>;
  totalRefundCount?: InputMaybe<TixOrderBy>;
  totalRevenue?: InputMaybe<TixOrderBy>;
  totalSeatsAvailable?: InputMaybe<TixOrderBy>;
  totalSeatsRemaining?: InputMaybe<TixOrderBy>;
  totalTicketRevenue?: InputMaybe<TixOrderBy>;
  totalTicketsSold?: InputMaybe<TixOrderBy>;
  totalVenueRevenue?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  yesterdayComp?: InputMaybe<TixOrderBy>;
  yesterdayDiscounts?: InputMaybe<TixOrderBy>;
  yesterdayRefundCount?: InputMaybe<TixOrderBy>;
  yesterdayRefunds?: InputMaybe<TixOrderBy>;
  yesterdayRevenue?: InputMaybe<TixOrderBy>;
  yesterdayTicketRevenue?: InputMaybe<TixOrderBy>;
  yesterdayTicketsSold?: InputMaybe<TixOrderBy>;
  yesterdayVenueRevenue?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_daily_audit" */
export enum TixDailyAuditReportSelectColumn {
  /** column name */
  BoxofficeTicketCount = 'boxofficeTicketCount',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  DailyRevenue = 'dailyRevenue',
  /** column name */
  Date = 'date',
  /** column name */
  DaysOut = 'daysOut',
  /** column name */
  EventDate = 'eventDate',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventTime = 'eventTime',
  /** column name */
  IncludeFees = 'includeFees',
  /** column name */
  OnlineTicketCount = 'onlineTicketCount',
  /** column name */
  PercentSold = 'percentSold',
  /** column name */
  Performance = 'performance',
  /** column name */
  PerformanceDate = 'performanceDate',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  TicketName = 'ticketName',
  /** column name */
  TodayComp = 'todayComp',
  /** column name */
  TodayDiscounts = 'todayDiscounts',
  /** column name */
  TodayRefundCount = 'todayRefundCount',
  /** column name */
  TodayRefunds = 'todayRefunds',
  /** column name */
  TodayTicketRevenue = 'todayTicketRevenue',
  /** column name */
  TodayTicketsSold = 'todayTicketsSold',
  /** column name */
  TodayVenueRevenue = 'todayVenueRevenue',
  /** column name */
  TotalComp = 'totalComp',
  /** column name */
  TotalDiscounts = 'totalDiscounts',
  /** column name */
  TotalRefundAmount = 'totalRefundAmount',
  /** column name */
  TotalRefundCount = 'totalRefundCount',
  /** column name */
  TotalRevenue = 'totalRevenue',
  /** column name */
  TotalSeatsAvailable = 'totalSeatsAvailable',
  /** column name */
  TotalSeatsRemaining = 'totalSeatsRemaining',
  /** column name */
  TotalTicketRevenue = 'totalTicketRevenue',
  /** column name */
  TotalTicketsSold = 'totalTicketsSold',
  /** column name */
  TotalVenueRevenue = 'totalVenueRevenue',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  YesterdayComp = 'yesterdayComp',
  /** column name */
  YesterdayDiscounts = 'yesterdayDiscounts',
  /** column name */
  YesterdayRefundCount = 'yesterdayRefundCount',
  /** column name */
  YesterdayRefunds = 'yesterdayRefunds',
  /** column name */
  YesterdayRevenue = 'yesterdayRevenue',
  /** column name */
  YesterdayTicketRevenue = 'yesterdayTicketRevenue',
  /** column name */
  YesterdayTicketsSold = 'yesterdayTicketsSold',
  /** column name */
  YesterdayVenueRevenue = 'yesterdayVenueRevenue'
}

/** aggregate stddev on columns */
export type TixDailyAuditReportStddevFields = {
  __typename?: 'DailyAuditReport_stddev_fields';
  boxofficeTicketCount?: Maybe<Scalars['Float']>;
  dailyRevenue?: Maybe<Scalars['Float']>;
  daysOut?: Maybe<Scalars['Float']>;
  onlineTicketCount?: Maybe<Scalars['Float']>;
  todayComp?: Maybe<Scalars['Float']>;
  todayDiscounts?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayRefunds?: Maybe<Scalars['Float']>;
  todayTicketRevenue?: Maybe<Scalars['Float']>;
  todayTicketsSold?: Maybe<Scalars['Float']>;
  todayVenueRevenue?: Maybe<Scalars['Float']>;
  totalComp?: Maybe<Scalars['Float']>;
  totalDiscounts?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalSeatsRemaining?: Maybe<Scalars['Float']>;
  totalTicketRevenue?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  totalVenueRevenue?: Maybe<Scalars['Float']>;
  yesterdayComp?: Maybe<Scalars['Float']>;
  yesterdayDiscounts?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayRefunds?: Maybe<Scalars['Float']>;
  yesterdayRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketsSold?: Maybe<Scalars['Float']>;
  yesterdayVenueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixDailyAuditReportStddevPopFields = {
  __typename?: 'DailyAuditReport_stddev_pop_fields';
  boxofficeTicketCount?: Maybe<Scalars['Float']>;
  dailyRevenue?: Maybe<Scalars['Float']>;
  daysOut?: Maybe<Scalars['Float']>;
  onlineTicketCount?: Maybe<Scalars['Float']>;
  todayComp?: Maybe<Scalars['Float']>;
  todayDiscounts?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayRefunds?: Maybe<Scalars['Float']>;
  todayTicketRevenue?: Maybe<Scalars['Float']>;
  todayTicketsSold?: Maybe<Scalars['Float']>;
  todayVenueRevenue?: Maybe<Scalars['Float']>;
  totalComp?: Maybe<Scalars['Float']>;
  totalDiscounts?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalSeatsRemaining?: Maybe<Scalars['Float']>;
  totalTicketRevenue?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  totalVenueRevenue?: Maybe<Scalars['Float']>;
  yesterdayComp?: Maybe<Scalars['Float']>;
  yesterdayDiscounts?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayRefunds?: Maybe<Scalars['Float']>;
  yesterdayRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketsSold?: Maybe<Scalars['Float']>;
  yesterdayVenueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixDailyAuditReportStddevSampFields = {
  __typename?: 'DailyAuditReport_stddev_samp_fields';
  boxofficeTicketCount?: Maybe<Scalars['Float']>;
  dailyRevenue?: Maybe<Scalars['Float']>;
  daysOut?: Maybe<Scalars['Float']>;
  onlineTicketCount?: Maybe<Scalars['Float']>;
  todayComp?: Maybe<Scalars['Float']>;
  todayDiscounts?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayRefunds?: Maybe<Scalars['Float']>;
  todayTicketRevenue?: Maybe<Scalars['Float']>;
  todayTicketsSold?: Maybe<Scalars['Float']>;
  todayVenueRevenue?: Maybe<Scalars['Float']>;
  totalComp?: Maybe<Scalars['Float']>;
  totalDiscounts?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalSeatsRemaining?: Maybe<Scalars['Float']>;
  totalTicketRevenue?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  totalVenueRevenue?: Maybe<Scalars['Float']>;
  yesterdayComp?: Maybe<Scalars['Float']>;
  yesterdayDiscounts?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayRefunds?: Maybe<Scalars['Float']>;
  yesterdayRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketsSold?: Maybe<Scalars['Float']>;
  yesterdayVenueRevenue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "DailyAuditReport" */
export type TixDailyAuditReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixDailyAuditReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixDailyAuditReportStreamCursorValueInput = {
  boxofficeTicketCount?: InputMaybe<Scalars['bigint']>;
  companyName?: InputMaybe<Scalars['String']>;
  dailyRevenue?: InputMaybe<Scalars['money']>;
  date?: InputMaybe<Scalars['date']>;
  daysOut?: InputMaybe<Scalars['float8']>;
  eventDate?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventTime?: InputMaybe<Scalars['time']>;
  includeFees?: InputMaybe<Scalars['Boolean']>;
  onlineTicketCount?: InputMaybe<Scalars['bigint']>;
  percentSold?: InputMaybe<Scalars['String']>;
  performance?: InputMaybe<Scalars['String']>;
  performanceDate?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  ticketName?: InputMaybe<Scalars['String']>;
  todayComp?: InputMaybe<Scalars['bigint']>;
  todayDiscounts?: InputMaybe<Scalars['money']>;
  todayRefundCount?: InputMaybe<Scalars['numeric']>;
  todayRefunds?: InputMaybe<Scalars['money']>;
  todayTicketRevenue?: InputMaybe<Scalars['money']>;
  todayTicketsSold?: InputMaybe<Scalars['bigint']>;
  todayVenueRevenue?: InputMaybe<Scalars['money']>;
  totalComp?: InputMaybe<Scalars['bigint']>;
  totalDiscounts?: InputMaybe<Scalars['money']>;
  totalRefundAmount?: InputMaybe<Scalars['money']>;
  totalRefundCount?: InputMaybe<Scalars['numeric']>;
  totalRevenue?: InputMaybe<Scalars['money']>;
  totalSeatsAvailable?: InputMaybe<Scalars['Int']>;
  totalSeatsRemaining?: InputMaybe<Scalars['bigint']>;
  totalTicketRevenue?: InputMaybe<Scalars['money']>;
  totalTicketsSold?: InputMaybe<Scalars['bigint']>;
  totalVenueRevenue?: InputMaybe<Scalars['money']>;
  venueName?: InputMaybe<Scalars['String']>;
  yesterdayComp?: InputMaybe<Scalars['bigint']>;
  yesterdayDiscounts?: InputMaybe<Scalars['money']>;
  yesterdayRefundCount?: InputMaybe<Scalars['numeric']>;
  yesterdayRefunds?: InputMaybe<Scalars['money']>;
  yesterdayRevenue?: InputMaybe<Scalars['money']>;
  yesterdayTicketRevenue?: InputMaybe<Scalars['money']>;
  yesterdayTicketsSold?: InputMaybe<Scalars['bigint']>;
  yesterdayVenueRevenue?: InputMaybe<Scalars['money']>;
};

/** aggregate sum on columns */
export type TixDailyAuditReportSumFields = {
  __typename?: 'DailyAuditReport_sum_fields';
  boxofficeTicketCount?: Maybe<Scalars['bigint']>;
  dailyRevenue?: Maybe<Scalars['money']>;
  daysOut?: Maybe<Scalars['float8']>;
  onlineTicketCount?: Maybe<Scalars['bigint']>;
  todayComp?: Maybe<Scalars['bigint']>;
  todayDiscounts?: Maybe<Scalars['money']>;
  todayRefundCount?: Maybe<Scalars['numeric']>;
  todayRefunds?: Maybe<Scalars['money']>;
  todayTicketRevenue?: Maybe<Scalars['money']>;
  todayTicketsSold?: Maybe<Scalars['bigint']>;
  todayVenueRevenue?: Maybe<Scalars['money']>;
  totalComp?: Maybe<Scalars['bigint']>;
  totalDiscounts?: Maybe<Scalars['money']>;
  totalRefundAmount?: Maybe<Scalars['money']>;
  totalRefundCount?: Maybe<Scalars['numeric']>;
  totalRevenue?: Maybe<Scalars['money']>;
  totalSeatsAvailable?: Maybe<Scalars['Int']>;
  totalSeatsRemaining?: Maybe<Scalars['bigint']>;
  totalTicketRevenue?: Maybe<Scalars['money']>;
  totalTicketsSold?: Maybe<Scalars['bigint']>;
  totalVenueRevenue?: Maybe<Scalars['money']>;
  yesterdayComp?: Maybe<Scalars['bigint']>;
  yesterdayDiscounts?: Maybe<Scalars['money']>;
  yesterdayRefundCount?: Maybe<Scalars['numeric']>;
  yesterdayRefunds?: Maybe<Scalars['money']>;
  yesterdayRevenue?: Maybe<Scalars['money']>;
  yesterdayTicketRevenue?: Maybe<Scalars['money']>;
  yesterdayTicketsSold?: Maybe<Scalars['bigint']>;
  yesterdayVenueRevenue?: Maybe<Scalars['money']>;
};

/** aggregate var_pop on columns */
export type TixDailyAuditReportVarPopFields = {
  __typename?: 'DailyAuditReport_var_pop_fields';
  boxofficeTicketCount?: Maybe<Scalars['Float']>;
  dailyRevenue?: Maybe<Scalars['Float']>;
  daysOut?: Maybe<Scalars['Float']>;
  onlineTicketCount?: Maybe<Scalars['Float']>;
  todayComp?: Maybe<Scalars['Float']>;
  todayDiscounts?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayRefunds?: Maybe<Scalars['Float']>;
  todayTicketRevenue?: Maybe<Scalars['Float']>;
  todayTicketsSold?: Maybe<Scalars['Float']>;
  todayVenueRevenue?: Maybe<Scalars['Float']>;
  totalComp?: Maybe<Scalars['Float']>;
  totalDiscounts?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalSeatsRemaining?: Maybe<Scalars['Float']>;
  totalTicketRevenue?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  totalVenueRevenue?: Maybe<Scalars['Float']>;
  yesterdayComp?: Maybe<Scalars['Float']>;
  yesterdayDiscounts?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayRefunds?: Maybe<Scalars['Float']>;
  yesterdayRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketsSold?: Maybe<Scalars['Float']>;
  yesterdayVenueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixDailyAuditReportVarSampFields = {
  __typename?: 'DailyAuditReport_var_samp_fields';
  boxofficeTicketCount?: Maybe<Scalars['Float']>;
  dailyRevenue?: Maybe<Scalars['Float']>;
  daysOut?: Maybe<Scalars['Float']>;
  onlineTicketCount?: Maybe<Scalars['Float']>;
  todayComp?: Maybe<Scalars['Float']>;
  todayDiscounts?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayRefunds?: Maybe<Scalars['Float']>;
  todayTicketRevenue?: Maybe<Scalars['Float']>;
  todayTicketsSold?: Maybe<Scalars['Float']>;
  todayVenueRevenue?: Maybe<Scalars['Float']>;
  totalComp?: Maybe<Scalars['Float']>;
  totalDiscounts?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalSeatsRemaining?: Maybe<Scalars['Float']>;
  totalTicketRevenue?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  totalVenueRevenue?: Maybe<Scalars['Float']>;
  yesterdayComp?: Maybe<Scalars['Float']>;
  yesterdayDiscounts?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayRefunds?: Maybe<Scalars['Float']>;
  yesterdayRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketsSold?: Maybe<Scalars['Float']>;
  yesterdayVenueRevenue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixDailyAuditReportVarianceFields = {
  __typename?: 'DailyAuditReport_variance_fields';
  boxofficeTicketCount?: Maybe<Scalars['Float']>;
  dailyRevenue?: Maybe<Scalars['Float']>;
  daysOut?: Maybe<Scalars['Float']>;
  onlineTicketCount?: Maybe<Scalars['Float']>;
  todayComp?: Maybe<Scalars['Float']>;
  todayDiscounts?: Maybe<Scalars['Float']>;
  todayRefundCount?: Maybe<Scalars['Float']>;
  todayRefunds?: Maybe<Scalars['Float']>;
  todayTicketRevenue?: Maybe<Scalars['Float']>;
  todayTicketsSold?: Maybe<Scalars['Float']>;
  todayVenueRevenue?: Maybe<Scalars['Float']>;
  totalComp?: Maybe<Scalars['Float']>;
  totalDiscounts?: Maybe<Scalars['Float']>;
  totalRefundAmount?: Maybe<Scalars['Float']>;
  totalRefundCount?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalSeatsRemaining?: Maybe<Scalars['Float']>;
  totalTicketRevenue?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  totalVenueRevenue?: Maybe<Scalars['Float']>;
  yesterdayComp?: Maybe<Scalars['Float']>;
  yesterdayDiscounts?: Maybe<Scalars['Float']>;
  yesterdayRefundCount?: Maybe<Scalars['Float']>;
  yesterdayRefunds?: Maybe<Scalars['Float']>;
  yesterdayRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketRevenue?: Maybe<Scalars['Float']>;
  yesterdayTicketsSold?: Maybe<Scalars['Float']>;
  yesterdayVenueRevenue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reporting.v_daily_ticket_count_report" */
export type TixDailyTicketCountReport = {
  __typename?: 'DailyTicketCountReport';
  city?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  eventInstance?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['time']>;
  eventType?: Maybe<Scalars['String']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedEventTime?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  todaysReservations?: Maybe<Scalars['Int']>;
  todaysTickets?: Maybe<Scalars['Int']>;
  totalReservations?: Maybe<Scalars['Int']>;
  totalSeats?: Maybe<Scalars['Int']>;
  totalSeatsAvailable?: Maybe<Scalars['Int']>;
  totalTicketsSold?: Maybe<Scalars['Int']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdaysReservations?: Maybe<Scalars['Int']>;
  yesterdaysTickets?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "reporting.v_daily_ticket_count_report" */
export type TixDailyTicketCountReportAggregate = {
  __typename?: 'DailyTicketCountReport_aggregate';
  aggregate?: Maybe<TixDailyTicketCountReportAggregateFields>;
  nodes: Array<TixDailyTicketCountReport>;
};

/** aggregate fields of "reporting.v_daily_ticket_count_report" */
export type TixDailyTicketCountReportAggregateFields = {
  __typename?: 'DailyTicketCountReport_aggregate_fields';
  avg?: Maybe<TixDailyTicketCountReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixDailyTicketCountReportMaxFields>;
  min?: Maybe<TixDailyTicketCountReportMinFields>;
  stddev?: Maybe<TixDailyTicketCountReportStddevFields>;
  stddev_pop?: Maybe<TixDailyTicketCountReportStddevPopFields>;
  stddev_samp?: Maybe<TixDailyTicketCountReportStddevSampFields>;
  sum?: Maybe<TixDailyTicketCountReportSumFields>;
  var_pop?: Maybe<TixDailyTicketCountReportVarPopFields>;
  var_samp?: Maybe<TixDailyTicketCountReportVarSampFields>;
  variance?: Maybe<TixDailyTicketCountReportVarianceFields>;
};


/** aggregate fields of "reporting.v_daily_ticket_count_report" */
export type TixDailyTicketCountReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixDailyTicketCountReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixDailyTicketCountReportAvgFields = {
  __typename?: 'DailyTicketCountReport_avg_fields';
  todaysReservations?: Maybe<Scalars['Float']>;
  todaysTickets?: Maybe<Scalars['Float']>;
  totalReservations?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  yesterdaysReservations?: Maybe<Scalars['Float']>;
  yesterdaysTickets?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_daily_ticket_count_report". All fields are combined with a logical 'AND'. */
export type TixDailyTicketCountReportBoolExp = {
  _and?: InputMaybe<Array<TixDailyTicketCountReportBoolExp>>;
  _not?: InputMaybe<TixDailyTicketCountReportBoolExp>;
  _or?: InputMaybe<Array<TixDailyTicketCountReportBoolExp>>;
  city?: InputMaybe<TixStringComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  eventDate?: InputMaybe<TixDateComparisonExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventTime?: InputMaybe<TixTimeComparisonExp>;
  eventType?: InputMaybe<TixStringComparisonExp>;
  formattedEventDate?: InputMaybe<TixStringComparisonExp>;
  formattedEventTime?: InputMaybe<TixStringComparisonExp>;
  postalCode?: InputMaybe<TixStringComparisonExp>;
  stateProvince?: InputMaybe<TixStringComparisonExp>;
  streetAddress?: InputMaybe<TixStringComparisonExp>;
  todaysReservations?: InputMaybe<TixIntComparisonExp>;
  todaysTickets?: InputMaybe<TixIntComparisonExp>;
  totalReservations?: InputMaybe<TixIntComparisonExp>;
  totalSeats?: InputMaybe<TixIntComparisonExp>;
  totalSeatsAvailable?: InputMaybe<TixIntComparisonExp>;
  totalTicketsSold?: InputMaybe<TixIntComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  yesterdaysReservations?: InputMaybe<TixIntComparisonExp>;
  yesterdaysTickets?: InputMaybe<TixIntComparisonExp>;
};

/** aggregate max on columns */
export type TixDailyTicketCountReportMaxFields = {
  __typename?: 'DailyTicketCountReport_max_fields';
  city?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedEventTime?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  todaysReservations?: Maybe<Scalars['Int']>;
  todaysTickets?: Maybe<Scalars['Int']>;
  totalReservations?: Maybe<Scalars['Int']>;
  totalSeats?: Maybe<Scalars['Int']>;
  totalSeatsAvailable?: Maybe<Scalars['Int']>;
  totalTicketsSold?: Maybe<Scalars['Int']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdaysReservations?: Maybe<Scalars['Int']>;
  yesterdaysTickets?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type TixDailyTicketCountReportMinFields = {
  __typename?: 'DailyTicketCountReport_min_fields';
  city?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedEventTime?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  todaysReservations?: Maybe<Scalars['Int']>;
  todaysTickets?: Maybe<Scalars['Int']>;
  totalReservations?: Maybe<Scalars['Int']>;
  totalSeats?: Maybe<Scalars['Int']>;
  totalSeatsAvailable?: Maybe<Scalars['Int']>;
  totalTicketsSold?: Maybe<Scalars['Int']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  yesterdaysReservations?: Maybe<Scalars['Int']>;
  yesterdaysTickets?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "reporting.v_daily_ticket_count_report". */
export type TixDailyTicketCountReportOrderBy = {
  city?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  eventDate?: InputMaybe<TixOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventTime?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  formattedEventDate?: InputMaybe<TixOrderBy>;
  formattedEventTime?: InputMaybe<TixOrderBy>;
  postalCode?: InputMaybe<TixOrderBy>;
  stateProvince?: InputMaybe<TixOrderBy>;
  streetAddress?: InputMaybe<TixOrderBy>;
  todaysReservations?: InputMaybe<TixOrderBy>;
  todaysTickets?: InputMaybe<TixOrderBy>;
  totalReservations?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  totalSeatsAvailable?: InputMaybe<TixOrderBy>;
  totalTicketsSold?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  yesterdaysReservations?: InputMaybe<TixOrderBy>;
  yesterdaysTickets?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_daily_ticket_count_report" */
export enum TixDailyTicketCountReportSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  EventDate = 'eventDate',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventTime = 'eventTime',
  /** column name */
  EventType = 'eventType',
  /** column name */
  FormattedEventDate = 'formattedEventDate',
  /** column name */
  FormattedEventTime = 'formattedEventTime',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  StateProvince = 'stateProvince',
  /** column name */
  StreetAddress = 'streetAddress',
  /** column name */
  TodaysReservations = 'todaysReservations',
  /** column name */
  TodaysTickets = 'todaysTickets',
  /** column name */
  TotalReservations = 'totalReservations',
  /** column name */
  TotalSeats = 'totalSeats',
  /** column name */
  TotalSeatsAvailable = 'totalSeatsAvailable',
  /** column name */
  TotalTicketsSold = 'totalTicketsSold',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  YesterdaysReservations = 'yesterdaysReservations',
  /** column name */
  YesterdaysTickets = 'yesterdaysTickets'
}

/** aggregate stddev on columns */
export type TixDailyTicketCountReportStddevFields = {
  __typename?: 'DailyTicketCountReport_stddev_fields';
  todaysReservations?: Maybe<Scalars['Float']>;
  todaysTickets?: Maybe<Scalars['Float']>;
  totalReservations?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  yesterdaysReservations?: Maybe<Scalars['Float']>;
  yesterdaysTickets?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixDailyTicketCountReportStddevPopFields = {
  __typename?: 'DailyTicketCountReport_stddev_pop_fields';
  todaysReservations?: Maybe<Scalars['Float']>;
  todaysTickets?: Maybe<Scalars['Float']>;
  totalReservations?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  yesterdaysReservations?: Maybe<Scalars['Float']>;
  yesterdaysTickets?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixDailyTicketCountReportStddevSampFields = {
  __typename?: 'DailyTicketCountReport_stddev_samp_fields';
  todaysReservations?: Maybe<Scalars['Float']>;
  todaysTickets?: Maybe<Scalars['Float']>;
  totalReservations?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  yesterdaysReservations?: Maybe<Scalars['Float']>;
  yesterdaysTickets?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "DailyTicketCountReport" */
export type TixDailyTicketCountReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixDailyTicketCountReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixDailyTicketCountReportStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['date']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventTime?: InputMaybe<Scalars['time']>;
  eventType?: InputMaybe<Scalars['String']>;
  formattedEventDate?: InputMaybe<Scalars['String']>;
  formattedEventTime?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  todaysReservations?: InputMaybe<Scalars['Int']>;
  todaysTickets?: InputMaybe<Scalars['Int']>;
  totalReservations?: InputMaybe<Scalars['Int']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  totalSeatsAvailable?: InputMaybe<Scalars['Int']>;
  totalTicketsSold?: InputMaybe<Scalars['Int']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  yesterdaysReservations?: InputMaybe<Scalars['Int']>;
  yesterdaysTickets?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TixDailyTicketCountReportSumFields = {
  __typename?: 'DailyTicketCountReport_sum_fields';
  todaysReservations?: Maybe<Scalars['Int']>;
  todaysTickets?: Maybe<Scalars['Int']>;
  totalReservations?: Maybe<Scalars['Int']>;
  totalSeats?: Maybe<Scalars['Int']>;
  totalSeatsAvailable?: Maybe<Scalars['Int']>;
  totalTicketsSold?: Maybe<Scalars['Int']>;
  yesterdaysReservations?: Maybe<Scalars['Int']>;
  yesterdaysTickets?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type TixDailyTicketCountReportVarPopFields = {
  __typename?: 'DailyTicketCountReport_var_pop_fields';
  todaysReservations?: Maybe<Scalars['Float']>;
  todaysTickets?: Maybe<Scalars['Float']>;
  totalReservations?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  yesterdaysReservations?: Maybe<Scalars['Float']>;
  yesterdaysTickets?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixDailyTicketCountReportVarSampFields = {
  __typename?: 'DailyTicketCountReport_var_samp_fields';
  todaysReservations?: Maybe<Scalars['Float']>;
  todaysTickets?: Maybe<Scalars['Float']>;
  totalReservations?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  yesterdaysReservations?: Maybe<Scalars['Float']>;
  yesterdaysTickets?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixDailyTicketCountReportVarianceFields = {
  __typename?: 'DailyTicketCountReport_variance_fields';
  todaysReservations?: Maybe<Scalars['Float']>;
  todaysTickets?: Maybe<Scalars['Float']>;
  totalReservations?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  totalSeatsAvailable?: Maybe<Scalars['Float']>;
  totalTicketsSold?: Maybe<Scalars['Float']>;
  yesterdaysReservations?: Maybe<Scalars['Float']>;
  yesterdaysTickets?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "discount.discount" */
export type TixDiscount = {
  __typename?: 'Discount';
  /** this will either be Ticket or Reservation */
  appliedTo?: Maybe<Scalars['String']>;
  buyAmount?: Maybe<Scalars['numeric']>;
  codeType?: Maybe<Scalars['String']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  company?: Maybe<TixCompany>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  discountCode: Scalars['String'];
  discountId: Scalars['uuid'];
  endDate?: Maybe<Scalars['date']>;
  endTime?: Maybe<Scalars['time']>;
  /** An array relationship */
  eventInstanceDiscount: Array<TixEventInstanceDiscount>;
  /** An aggregate relationship */
  eventInstanceDiscount_aggregate: TixEventInstanceDiscountAggregate;
  getAmount?: Maybe<Scalars['numeric']>;
  groupDiscountAmount?: Maybe<Scalars['numeric']>;
  groupDiscountType?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['numeric']>;
  parentDiscountCodeId?: Maybe<Scalars['uuid']>;
  passcode?: Maybe<Scalars['String']>;
  /** An object relationship */
  payment?: Maybe<TixPaymentDiscount>;
  prefix?: Maybe<Scalars['String']>;
  /** An array relationship */
  reservations: Array<TixTicketReservation>;
  /** An aggregate relationship */
  reservations_aggregate: TixTicketReservationAggregate;
  startDate?: Maybe<Scalars['date']>;
  startTime?: Maybe<Scalars['time']>;
  state?: Maybe<Scalars['String']>;
  /** An array relationship */
  ticketDiscount: Array<TixTicketTicketDiscount>;
  /** An aggregate relationship */
  ticketDiscount_aggregate: TixTicketTicketDiscountAggregate;
  /** discount type (e.g. % Discount, $ Discount) */
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  venueDiscount: Array<TixVenueDiscount>;
  /** An aggregate relationship */
  venueDiscount_aggregate: TixVenueDiscountAggregate;
};


/** columns and relationships of "discount.discount" */
export type TixDiscountEventInstanceDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceDiscountOrderBy>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


/** columns and relationships of "discount.discount" */
export type TixDiscountEventInstanceDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceDiscountOrderBy>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


/** columns and relationships of "discount.discount" */
export type TixDiscountReservationsArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


/** columns and relationships of "discount.discount" */
export type TixDiscountReservationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


/** columns and relationships of "discount.discount" */
export type TixDiscountTicketDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixTicketTicketDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketTicketDiscountOrderBy>>;
  where?: InputMaybe<TixTicketTicketDiscountBoolExp>;
};


/** columns and relationships of "discount.discount" */
export type TixDiscountTicketDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketTicketDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketTicketDiscountOrderBy>>;
  where?: InputMaybe<TixTicketTicketDiscountBoolExp>;
};


/** columns and relationships of "discount.discount" */
export type TixDiscountVenueDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueDiscountOrderBy>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};


/** columns and relationships of "discount.discount" */
export type TixDiscountVenueDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueDiscountOrderBy>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};

/** columns and relationships of "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEvent = {
  __typename?: 'DiscountCodeCountByEvent';
  discountAmount?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  discountsUsed?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventAggregate = {
  __typename?: 'DiscountCodeCountByEvent_aggregate';
  aggregate?: Maybe<TixDiscountCodeCountByEventAggregateFields>;
  nodes: Array<TixDiscountCodeCountByEvent>;
};

export type TixDiscountCodeCountByEventAggregateBoolExp = {
  count?: InputMaybe<TixDiscountCodeCountByEventAggregateBoolExpCount>;
};

export type TixDiscountCodeCountByEventAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixDiscountCodeCountByEventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventAggregateFields = {
  __typename?: 'DiscountCodeCountByEvent_aggregate_fields';
  avg?: Maybe<TixDiscountCodeCountByEventAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixDiscountCodeCountByEventMaxFields>;
  min?: Maybe<TixDiscountCodeCountByEventMinFields>;
  stddev?: Maybe<TixDiscountCodeCountByEventStddevFields>;
  stddev_pop?: Maybe<TixDiscountCodeCountByEventStddevPopFields>;
  stddev_samp?: Maybe<TixDiscountCodeCountByEventStddevSampFields>;
  sum?: Maybe<TixDiscountCodeCountByEventSumFields>;
  var_pop?: Maybe<TixDiscountCodeCountByEventVarPopFields>;
  var_samp?: Maybe<TixDiscountCodeCountByEventVarSampFields>;
  variance?: Maybe<TixDiscountCodeCountByEventVarianceFields>;
};


/** aggregate fields of "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixDiscountCodeCountByEventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventAggregateOrderBy = {
  avg?: InputMaybe<TixDiscountCodeCountByEventAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixDiscountCodeCountByEventMaxOrderBy>;
  min?: InputMaybe<TixDiscountCodeCountByEventMinOrderBy>;
  stddev?: InputMaybe<TixDiscountCodeCountByEventStddevOrderBy>;
  stddev_pop?: InputMaybe<TixDiscountCodeCountByEventStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixDiscountCodeCountByEventStddevSampOrderBy>;
  sum?: InputMaybe<TixDiscountCodeCountByEventSumOrderBy>;
  var_pop?: InputMaybe<TixDiscountCodeCountByEventVarPopOrderBy>;
  var_samp?: InputMaybe<TixDiscountCodeCountByEventVarSampOrderBy>;
  variance?: InputMaybe<TixDiscountCodeCountByEventVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventArrRelInsertInput = {
  data: Array<TixDiscountCodeCountByEventInsertInput>;
};

/** aggregate avg on columns */
export type TixDiscountCodeCountByEventAvgFields = {
  __typename?: 'DiscountCodeCountByEvent_avg_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  discountsUsed?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventAvgOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "reporting.v_discount_count_by_event". All fields are combined with a logical 'AND'. */
export type TixDiscountCodeCountByEventBoolExp = {
  _and?: InputMaybe<Array<TixDiscountCodeCountByEventBoolExp>>;
  _not?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
  _or?: InputMaybe<Array<TixDiscountCodeCountByEventBoolExp>>;
  discountAmount?: InputMaybe<TixMoneyComparisonExp>;
  discountCode?: InputMaybe<TixStringComparisonExp>;
  discountType?: InputMaybe<TixStringComparisonExp>;
  discountsUsed?: InputMaybe<TixBigintComparisonExp>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
};

/** input type for inserting data into table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventInsertInput = {
  discountAmount?: InputMaybe<Scalars['money']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountsUsed?: InputMaybe<Scalars['bigint']>;
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixDiscountCodeCountByEventMaxFields = {
  __typename?: 'DiscountCodeCountByEvent_max_fields';
  discountAmount?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  discountsUsed?: Maybe<Scalars['bigint']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventMaxOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountType?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixDiscountCodeCountByEventMinFields = {
  __typename?: 'DiscountCodeCountByEvent_min_fields';
  discountAmount?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  discountsUsed?: Maybe<Scalars['bigint']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventMinOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountType?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
};

/** Ordering options when selecting data from "reporting.v_discount_count_by_event". */
export type TixDiscountCodeCountByEventOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountType?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_discount_count_by_event" */
export enum TixDiscountCodeCountByEventSelectColumn {
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  DiscountCode = 'discountCode',
  /** column name */
  DiscountType = 'discountType',
  /** column name */
  DiscountsUsed = 'discountsUsed',
  /** column name */
  EventInstanceId = 'eventInstanceId'
}

/** aggregate stddev on columns */
export type TixDiscountCodeCountByEventStddevFields = {
  __typename?: 'DiscountCodeCountByEvent_stddev_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  discountsUsed?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventStddevOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixDiscountCodeCountByEventStddevPopFields = {
  __typename?: 'DiscountCodeCountByEvent_stddev_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  discountsUsed?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventStddevPopOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixDiscountCodeCountByEventStddevSampFields = {
  __typename?: 'DiscountCodeCountByEvent_stddev_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  discountsUsed?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventStddevSampOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "DiscountCodeCountByEvent" */
export type TixDiscountCodeCountByEventStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixDiscountCodeCountByEventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixDiscountCodeCountByEventStreamCursorValueInput = {
  discountAmount?: InputMaybe<Scalars['money']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountsUsed?: InputMaybe<Scalars['bigint']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixDiscountCodeCountByEventSumFields = {
  __typename?: 'DiscountCodeCountByEvent_sum_fields';
  discountAmount?: Maybe<Scalars['money']>;
  discountsUsed?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventSumOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
};

/** aggregate var_pop on columns */
export type TixDiscountCodeCountByEventVarPopFields = {
  __typename?: 'DiscountCodeCountByEvent_var_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  discountsUsed?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventVarPopOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixDiscountCodeCountByEventVarSampFields = {
  __typename?: 'DiscountCodeCountByEvent_var_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  discountsUsed?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventVarSampOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixDiscountCodeCountByEventVarianceFields = {
  __typename?: 'DiscountCodeCountByEvent_variance_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  discountsUsed?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reporting.v_discount_count_by_event" */
export type TixDiscountCodeCountByEventVarianceOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  discountsUsed?: InputMaybe<TixOrderBy>;
};

export type TixDiscountCodeDto = {
  code: Scalars['String'];
  companyId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  passcode?: InputMaybe<Scalars['String']>;
  venueId: Scalars['String'];
};

export type TixDiscountData = {
  __typename?: 'DiscountData';
  appliedTo?: Maybe<Scalars['String']>;
  buyAmount?: Maybe<Scalars['Float']>;
  discountId: Scalars['String'];
  getAmount?: Maybe<Scalars['Float']>;
  groupDiscountAmount?: Maybe<Scalars['Float']>;
  groupDiscountType?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** aggregated selection of "discount.discount" */
export type TixDiscountAggregate = {
  __typename?: 'Discount_aggregate';
  aggregate?: Maybe<TixDiscountAggregateFields>;
  nodes: Array<TixDiscount>;
};

export type TixDiscountAggregateBoolExp = {
  count?: InputMaybe<TixDiscountAggregateBoolExpCount>;
};

export type TixDiscountAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixDiscountBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "discount.discount" */
export type TixDiscountAggregateFields = {
  __typename?: 'Discount_aggregate_fields';
  avg?: Maybe<TixDiscountAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixDiscountMaxFields>;
  min?: Maybe<TixDiscountMinFields>;
  stddev?: Maybe<TixDiscountStddevFields>;
  stddev_pop?: Maybe<TixDiscountStddevPopFields>;
  stddev_samp?: Maybe<TixDiscountStddevSampFields>;
  sum?: Maybe<TixDiscountSumFields>;
  var_pop?: Maybe<TixDiscountVarPopFields>;
  var_samp?: Maybe<TixDiscountVarSampFields>;
  variance?: Maybe<TixDiscountVarianceFields>;
};


/** aggregate fields of "discount.discount" */
export type TixDiscountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount.discount" */
export type TixDiscountAggregateOrderBy = {
  avg?: InputMaybe<TixDiscountAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixDiscountMaxOrderBy>;
  min?: InputMaybe<TixDiscountMinOrderBy>;
  stddev?: InputMaybe<TixDiscountStddevOrderBy>;
  stddev_pop?: InputMaybe<TixDiscountStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixDiscountStddevSampOrderBy>;
  sum?: InputMaybe<TixDiscountSumOrderBy>;
  var_pop?: InputMaybe<TixDiscountVarPopOrderBy>;
  var_samp?: InputMaybe<TixDiscountVarSampOrderBy>;
  variance?: InputMaybe<TixDiscountVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "discount.discount" */
export type TixDiscountArrRelInsertInput = {
  data: Array<TixDiscountInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixDiscountOnConflict>;
};

/** aggregate avg on columns */
export type TixDiscountAvgFields = {
  __typename?: 'Discount_avg_fields';
  buyAmount?: Maybe<Scalars['Float']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['Float']>;
  getAmount?: Maybe<Scalars['Float']>;
  groupDiscountAmount?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "discount.discount" */
export type TixDiscountAvgOrderBy = {
  buyAmount?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "discount.discount". All fields are combined with a logical 'AND'. */
export type TixDiscountBoolExp = {
  _and?: InputMaybe<Array<TixDiscountBoolExp>>;
  _not?: InputMaybe<TixDiscountBoolExp>;
  _or?: InputMaybe<Array<TixDiscountBoolExp>>;
  appliedTo?: InputMaybe<TixStringComparisonExp>;
  buyAmount?: InputMaybe<TixNumericComparisonExp>;
  codeType?: InputMaybe<TixStringComparisonExp>;
  codesToGenerate?: InputMaybe<TixNumericComparisonExp>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  discountCode?: InputMaybe<TixStringComparisonExp>;
  discountId?: InputMaybe<TixUuidComparisonExp>;
  endDate?: InputMaybe<TixDateComparisonExp>;
  endTime?: InputMaybe<TixTimeComparisonExp>;
  eventInstanceDiscount?: InputMaybe<TixEventInstanceDiscountBoolExp>;
  eventInstanceDiscount_aggregate?: InputMaybe<TixEventInstanceDiscountAggregateBoolExp>;
  getAmount?: InputMaybe<TixNumericComparisonExp>;
  groupDiscountAmount?: InputMaybe<TixNumericComparisonExp>;
  groupDiscountType?: InputMaybe<TixStringComparisonExp>;
  limit?: InputMaybe<TixNumericComparisonExp>;
  parentDiscountCodeId?: InputMaybe<TixUuidComparisonExp>;
  passcode?: InputMaybe<TixStringComparisonExp>;
  payment?: InputMaybe<TixPaymentDiscountBoolExp>;
  prefix?: InputMaybe<TixStringComparisonExp>;
  reservations?: InputMaybe<TixTicketReservationBoolExp>;
  reservations_aggregate?: InputMaybe<TixTicketReservationAggregateBoolExp>;
  startDate?: InputMaybe<TixDateComparisonExp>;
  startTime?: InputMaybe<TixTimeComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  ticketDiscount?: InputMaybe<TixTicketTicketDiscountBoolExp>;
  ticketDiscount_aggregate?: InputMaybe<TixTicketTicketDiscountAggregateBoolExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueDiscount?: InputMaybe<TixVenueDiscountBoolExp>;
  venueDiscount_aggregate?: InputMaybe<TixVenueDiscountAggregateBoolExp>;
};

/** unique or primary key constraints on table "discount.discount" */
export enum TixDiscountConstraint {
  /** unique or primary key constraint on columns "discount_id" */
  DiscountPkey = 'discount_pkey',
  /** unique or primary key constraint on columns "start_date", "type", "discount_code", "buy_amount", "end_date", "state", "company_id", "get_amount" */
  DiscountUniqueCode = 'discount_unique_code'
}

/** input type for incrementing numeric columns in table "discount.discount" */
export type TixDiscountIncInput = {
  buyAmount?: InputMaybe<Scalars['numeric']>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<Scalars['numeric']>;
  getAmount?: InputMaybe<Scalars['numeric']>;
  groupDiscountAmount?: InputMaybe<Scalars['numeric']>;
  limit?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "discount.discount" */
export type TixDiscountInsertInput = {
  /** this will either be Ticket or Reservation */
  appliedTo?: InputMaybe<Scalars['String']>;
  buyAmount?: InputMaybe<Scalars['numeric']>;
  codeType?: InputMaybe<Scalars['String']>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<Scalars['numeric']>;
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  endDate?: InputMaybe<Scalars['date']>;
  endTime?: InputMaybe<Scalars['time']>;
  eventInstanceDiscount?: InputMaybe<TixEventInstanceDiscountArrRelInsertInput>;
  getAmount?: InputMaybe<Scalars['numeric']>;
  groupDiscountAmount?: InputMaybe<Scalars['numeric']>;
  groupDiscountType?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['numeric']>;
  parentDiscountCodeId?: InputMaybe<Scalars['uuid']>;
  passcode?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<TixPaymentDiscountObjRelInsertInput>;
  prefix?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<TixTicketReservationArrRelInsertInput>;
  startDate?: InputMaybe<Scalars['date']>;
  startTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  ticketDiscount?: InputMaybe<TixTicketTicketDiscountArrRelInsertInput>;
  /** discount type (e.g. % Discount, $ Discount) */
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueDiscount?: InputMaybe<TixVenueDiscountArrRelInsertInput>;
};

/** aggregate max on columns */
export type TixDiscountMaxFields = {
  __typename?: 'Discount_max_fields';
  /** this will either be Ticket or Reservation */
  appliedTo?: Maybe<Scalars['String']>;
  buyAmount?: Maybe<Scalars['numeric']>;
  codeType?: Maybe<Scalars['String']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['numeric']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['date']>;
  getAmount?: Maybe<Scalars['numeric']>;
  groupDiscountAmount?: Maybe<Scalars['numeric']>;
  groupDiscountType?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['numeric']>;
  parentDiscountCodeId?: Maybe<Scalars['uuid']>;
  passcode?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  /** discount type (e.g. % Discount, $ Discount) */
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "discount.discount" */
export type TixDiscountMaxOrderBy = {
  /** this will either be Ticket or Reservation */
  appliedTo?: InputMaybe<TixOrderBy>;
  buyAmount?: InputMaybe<TixOrderBy>;
  codeType?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  endDate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  groupDiscountType?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
  parentDiscountCodeId?: InputMaybe<TixOrderBy>;
  passcode?: InputMaybe<TixOrderBy>;
  prefix?: InputMaybe<TixOrderBy>;
  startDate?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  /** discount type (e.g. % Discount, $ Discount) */
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixDiscountMinFields = {
  __typename?: 'Discount_min_fields';
  /** this will either be Ticket or Reservation */
  appliedTo?: Maybe<Scalars['String']>;
  buyAmount?: Maybe<Scalars['numeric']>;
  codeType?: Maybe<Scalars['String']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['numeric']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['date']>;
  getAmount?: Maybe<Scalars['numeric']>;
  groupDiscountAmount?: Maybe<Scalars['numeric']>;
  groupDiscountType?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['numeric']>;
  parentDiscountCodeId?: Maybe<Scalars['uuid']>;
  passcode?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  /** discount type (e.g. % Discount, $ Discount) */
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "discount.discount" */
export type TixDiscountMinOrderBy = {
  /** this will either be Ticket or Reservation */
  appliedTo?: InputMaybe<TixOrderBy>;
  buyAmount?: InputMaybe<TixOrderBy>;
  codeType?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  endDate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  groupDiscountType?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
  parentDiscountCodeId?: InputMaybe<TixOrderBy>;
  passcode?: InputMaybe<TixOrderBy>;
  prefix?: InputMaybe<TixOrderBy>;
  startDate?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  /** discount type (e.g. % Discount, $ Discount) */
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "discount.discount" */
export type TixDiscountMutationResponse = {
  __typename?: 'Discount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixDiscount>;
};

/** input type for inserting object relation for remote table "discount.discount" */
export type TixDiscountObjRelInsertInput = {
  data: TixDiscountInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixDiscountOnConflict>;
};

/** on_conflict condition type for table "discount.discount" */
export type TixDiscountOnConflict = {
  constraint: TixDiscountConstraint;
  update_columns?: Array<TixDiscountUpdateColumn>;
  where?: InputMaybe<TixDiscountBoolExp>;
};

/** Ordering options when selecting data from "discount.discount". */
export type TixDiscountOrderBy = {
  appliedTo?: InputMaybe<TixOrderBy>;
  buyAmount?: InputMaybe<TixOrderBy>;
  codeType?: InputMaybe<TixOrderBy>;
  codesToGenerate?: InputMaybe<TixOrderBy>;
  company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  endDate?: InputMaybe<TixOrderBy>;
  endTime?: InputMaybe<TixOrderBy>;
  eventInstanceDiscount_aggregate?: InputMaybe<TixEventInstanceDiscountAggregateOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  groupDiscountType?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
  parentDiscountCodeId?: InputMaybe<TixOrderBy>;
  passcode?: InputMaybe<TixOrderBy>;
  payment?: InputMaybe<TixPaymentDiscountOrderBy>;
  prefix?: InputMaybe<TixOrderBy>;
  reservations_aggregate?: InputMaybe<TixTicketReservationAggregateOrderBy>;
  startDate?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketDiscount_aggregate?: InputMaybe<TixTicketTicketDiscountAggregateOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueDiscount_aggregate?: InputMaybe<TixVenueDiscountAggregateOrderBy>;
};

/** primary key columns input for table: discount.discount */
export type TixDiscountPkColumnsInput = {
  discountId: Scalars['uuid'];
};

/** select columns of table "discount.discount" */
export enum TixDiscountSelectColumn {
  /** column name */
  AppliedTo = 'appliedTo',
  /** column name */
  BuyAmount = 'buyAmount',
  /** column name */
  CodeType = 'codeType',
  /** column name */
  CodesToGenerate = 'codesToGenerate',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountCode = 'discountCode',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  GetAmount = 'getAmount',
  /** column name */
  GroupDiscountAmount = 'groupDiscountAmount',
  /** column name */
  GroupDiscountType = 'groupDiscountType',
  /** column name */
  Limit = 'limit',
  /** column name */
  ParentDiscountCodeId = 'parentDiscountCodeId',
  /** column name */
  Passcode = 'passcode',
  /** column name */
  Prefix = 'prefix',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "discount.discount" */
export type TixDiscountSetInput = {
  /** this will either be Ticket or Reservation */
  appliedTo?: InputMaybe<Scalars['String']>;
  buyAmount?: InputMaybe<Scalars['numeric']>;
  codeType?: InputMaybe<Scalars['String']>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<Scalars['numeric']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  endDate?: InputMaybe<Scalars['date']>;
  endTime?: InputMaybe<Scalars['time']>;
  getAmount?: InputMaybe<Scalars['numeric']>;
  groupDiscountAmount?: InputMaybe<Scalars['numeric']>;
  groupDiscountType?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['numeric']>;
  parentDiscountCodeId?: InputMaybe<Scalars['uuid']>;
  passcode?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['date']>;
  startTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  /** discount type (e.g. % Discount, $ Discount) */
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixDiscountStddevFields = {
  __typename?: 'Discount_stddev_fields';
  buyAmount?: Maybe<Scalars['Float']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['Float']>;
  getAmount?: Maybe<Scalars['Float']>;
  groupDiscountAmount?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "discount.discount" */
export type TixDiscountStddevOrderBy = {
  buyAmount?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixDiscountStddevPopFields = {
  __typename?: 'Discount_stddev_pop_fields';
  buyAmount?: Maybe<Scalars['Float']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['Float']>;
  getAmount?: Maybe<Scalars['Float']>;
  groupDiscountAmount?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "discount.discount" */
export type TixDiscountStddevPopOrderBy = {
  buyAmount?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixDiscountStddevSampFields = {
  __typename?: 'Discount_stddev_samp_fields';
  buyAmount?: Maybe<Scalars['Float']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['Float']>;
  getAmount?: Maybe<Scalars['Float']>;
  groupDiscountAmount?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "discount.discount" */
export type TixDiscountStddevSampOrderBy = {
  buyAmount?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "Discount" */
export type TixDiscountStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixDiscountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixDiscountStreamCursorValueInput = {
  /** this will either be Ticket or Reservation */
  appliedTo?: InputMaybe<Scalars['String']>;
  buyAmount?: InputMaybe<Scalars['numeric']>;
  codeType?: InputMaybe<Scalars['String']>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<Scalars['numeric']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  endDate?: InputMaybe<Scalars['date']>;
  endTime?: InputMaybe<Scalars['time']>;
  getAmount?: InputMaybe<Scalars['numeric']>;
  groupDiscountAmount?: InputMaybe<Scalars['numeric']>;
  groupDiscountType?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['numeric']>;
  parentDiscountCodeId?: InputMaybe<Scalars['uuid']>;
  passcode?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['date']>;
  startTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  /** discount type (e.g. % Discount, $ Discount) */
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixDiscountSumFields = {
  __typename?: 'Discount_sum_fields';
  buyAmount?: Maybe<Scalars['numeric']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['numeric']>;
  getAmount?: Maybe<Scalars['numeric']>;
  groupDiscountAmount?: Maybe<Scalars['numeric']>;
  limit?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "discount.discount" */
export type TixDiscountSumOrderBy = {
  buyAmount?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
};

/** update columns of table "discount.discount" */
export enum TixDiscountUpdateColumn {
  /** column name */
  AppliedTo = 'appliedTo',
  /** column name */
  BuyAmount = 'buyAmount',
  /** column name */
  CodeType = 'codeType',
  /** column name */
  CodesToGenerate = 'codesToGenerate',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountCode = 'discountCode',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  GetAmount = 'getAmount',
  /** column name */
  GroupDiscountAmount = 'groupDiscountAmount',
  /** column name */
  GroupDiscountType = 'groupDiscountType',
  /** column name */
  Limit = 'limit',
  /** column name */
  ParentDiscountCodeId = 'parentDiscountCodeId',
  /** column name */
  Passcode = 'passcode',
  /** column name */
  Prefix = 'prefix',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixDiscountUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixDiscountIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixDiscountSetInput>;
  /** filter the rows which have to be updated */
  where: TixDiscountBoolExp;
};

/** aggregate var_pop on columns */
export type TixDiscountVarPopFields = {
  __typename?: 'Discount_var_pop_fields';
  buyAmount?: Maybe<Scalars['Float']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['Float']>;
  getAmount?: Maybe<Scalars['Float']>;
  groupDiscountAmount?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "discount.discount" */
export type TixDiscountVarPopOrderBy = {
  buyAmount?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixDiscountVarSampFields = {
  __typename?: 'Discount_var_samp_fields';
  buyAmount?: Maybe<Scalars['Float']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['Float']>;
  getAmount?: Maybe<Scalars['Float']>;
  groupDiscountAmount?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "discount.discount" */
export type TixDiscountVarSampOrderBy = {
  buyAmount?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixDiscountVarianceFields = {
  __typename?: 'Discount_variance_fields';
  buyAmount?: Maybe<Scalars['Float']>;
  /** number of single use codes to generate */
  codesToGenerate?: Maybe<Scalars['Float']>;
  getAmount?: Maybe<Scalars['Float']>;
  groupDiscountAmount?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "discount.discount" */
export type TixDiscountVarianceOrderBy = {
  buyAmount?: InputMaybe<TixOrderBy>;
  /** number of single use codes to generate */
  codesToGenerate?: InputMaybe<TixOrderBy>;
  getAmount?: InputMaybe<TixOrderBy>;
  groupDiscountAmount?: InputMaybe<TixOrderBy>;
  limit?: InputMaybe<TixOrderBy>;
};

export type TixDonationInput = {
  amount: Scalars['Float'];
  comment: Scalars['String'];
};

/** columns and relationships of "communications.email_content" */
export type TixEmailContent = {
  __typename?: 'EmailContent';
  /** An array relationship */
  EmailVariableMapping: Array<TixCommunicationsEmailContentVariable>;
  /** An aggregate relationship */
  EmailVariableMapping_aggregate: TixCommunicationsEmailContentVariableAggregate;
  attachments?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId: Scalars['uuid'];
  format?: Maybe<Scalars['String']>;
  formattedBody?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "communications.email_content" */
export type TixEmailContentEmailVariableMappingArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailContentVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailContentVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
};


/** columns and relationships of "communications.email_content" */
export type TixEmailContentEmailVariableMappingAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailContentVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailContentVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
};

/** aggregated selection of "communications.email_content" */
export type TixEmailContentAggregate = {
  __typename?: 'EmailContent_aggregate';
  aggregate?: Maybe<TixEmailContentAggregateFields>;
  nodes: Array<TixEmailContent>;
};

/** aggregate fields of "communications.email_content" */
export type TixEmailContentAggregateFields = {
  __typename?: 'EmailContent_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEmailContentMaxFields>;
  min?: Maybe<TixEmailContentMinFields>;
};


/** aggregate fields of "communications.email_content" */
export type TixEmailContentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEmailContentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "communications.email_content". All fields are combined with a logical 'AND'. */
export type TixEmailContentBoolExp = {
  EmailVariableMapping?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
  EmailVariableMapping_aggregate?: InputMaybe<TixCommunicationsEmailContentVariableAggregateBoolExp>;
  _and?: InputMaybe<Array<TixEmailContentBoolExp>>;
  _not?: InputMaybe<TixEmailContentBoolExp>;
  _or?: InputMaybe<Array<TixEmailContentBoolExp>>;
  attachments?: InputMaybe<TixStringComparisonExp>;
  body?: InputMaybe<TixStringComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  emailContentId?: InputMaybe<TixUuidComparisonExp>;
  format?: InputMaybe<TixStringComparisonExp>;
  formattedBody?: InputMaybe<TixStringComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  sender?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  subject?: InputMaybe<TixStringComparisonExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "communications.email_content" */
export enum TixEmailContentConstraint {
  /** unique or primary key constraint on columns "email_content_id" */
  EmailContentPkey = 'email_content_pkey'
}

/** input type for inserting data into table "communications.email_content" */
export type TixEmailContentInsertInput = {
  EmailVariableMapping?: InputMaybe<TixCommunicationsEmailContentVariableArrRelInsertInput>;
  attachments?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  format?: InputMaybe<Scalars['String']>;
  formattedBody?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEmailContentMaxFields = {
  __typename?: 'EmailContent_max_fields';
  attachments?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  format?: Maybe<Scalars['String']>;
  formattedBody?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixEmailContentMinFields = {
  __typename?: 'EmailContent_min_fields';
  attachments?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  format?: Maybe<Scalars['String']>;
  formattedBody?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "communications.email_content" */
export type TixEmailContentMutationResponse = {
  __typename?: 'EmailContent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEmailContent>;
};

/** input type for inserting object relation for remote table "communications.email_content" */
export type TixEmailContentObjRelInsertInput = {
  data: TixEmailContentInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEmailContentOnConflict>;
};

/** on_conflict condition type for table "communications.email_content" */
export type TixEmailContentOnConflict = {
  constraint: TixEmailContentConstraint;
  update_columns?: Array<TixEmailContentUpdateColumn>;
  where?: InputMaybe<TixEmailContentBoolExp>;
};

/** Ordering options when selecting data from "communications.email_content". */
export type TixEmailContentOrderBy = {
  EmailVariableMapping_aggregate?: InputMaybe<TixCommunicationsEmailContentVariableAggregateOrderBy>;
  attachments?: InputMaybe<TixOrderBy>;
  body?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailContentId?: InputMaybe<TixOrderBy>;
  format?: InputMaybe<TixOrderBy>;
  formattedBody?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  sender?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  subject?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: communications.email_content */
export type TixEmailContentPkColumnsInput = {
  emailContentId: Scalars['uuid'];
};

/** select columns of table "communications.email_content" */
export enum TixEmailContentSelectColumn {
  /** column name */
  Attachments = 'attachments',
  /** column name */
  Body = 'body',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailContentId = 'emailContentId',
  /** column name */
  Format = 'format',
  /** column name */
  FormattedBody = 'formattedBody',
  /** column name */
  Name = 'name',
  /** column name */
  Sender = 'sender',
  /** column name */
  State = 'state',
  /** column name */
  Subject = 'subject',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "communications.email_content" */
export type TixEmailContentSetInput = {
  attachments?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  format?: InputMaybe<Scalars['String']>;
  formattedBody?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EmailContent" */
export type TixEmailContentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEmailContentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEmailContentStreamCursorValueInput = {
  attachments?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  format?: InputMaybe<Scalars['String']>;
  formattedBody?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "communications.email_content" */
export enum TixEmailContentUpdateColumn {
  /** column name */
  Attachments = 'attachments',
  /** column name */
  Body = 'body',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailContentId = 'emailContentId',
  /** column name */
  Format = 'format',
  /** column name */
  FormattedBody = 'formattedBody',
  /** column name */
  Name = 'name',
  /** column name */
  Sender = 'sender',
  /** column name */
  State = 'state',
  /** column name */
  Subject = 'subject',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEmailContentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEmailContentSetInput>;
  /** filter the rows which have to be updated */
  where: TixEmailContentBoolExp;
};

/** columns and relationships of "event.event" */
export type TixEvent = {
  __typename?: 'Event';
  companyId?: Maybe<Scalars['uuid']>;
  eventId: Scalars['uuid'];
  /** An array relationship */
  eventInstances: Array<TixEventInstance>;
  /** An aggregate relationship */
  eventInstances_aggregate: TixEventInstanceAggregate;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  venue_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "event.event" */
export type TixEventEventInstancesArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceOrderBy>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};


/** columns and relationships of "event.event" */
export type TixEventEventInstancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceOrderBy>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};

/** columns and relationships of "event.company_venue_event_list" */
export type TixEventCompanyVenue = {
  __typename?: 'EventCompanyVenue';
  available?: Maybe<Scalars['bigint']>;
  checkedIn?: Maybe<Scalars['bigint']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  doorsOpen?: Maybe<Scalars['time']>;
  endTime?: Maybe<Scalars['time']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  eventInstance?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  hidden?: Maybe<Scalars['Boolean']>;
  mainEventName?: Maybe<Scalars['String']>;
  mediaFileType?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['uuid']>;
  mediaLocation?: Maybe<Scalars['String']>;
  mediaState?: Maybe<Scalars['String']>;
  minimum_age?: Maybe<Scalars['Int']>;
  notCheckedIn?: Maybe<Scalars['bigint']>;
  overridden?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['time']>;
  start_selling_date?: Maybe<Scalars['date']>;
  start_selling_time?: Maybe<Scalars['time']>;
  stop_selling_date?: Maybe<Scalars['date']>;
  stop_selling_time?: Maybe<Scalars['time']>;
  ticketsSold?: Maybe<Scalars['bigint']>;
  totalSeats?: Maybe<Scalars['Int']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venue_ticket_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "event.company_venue_event_list" */
export type TixEventCompanyVenueAggregate = {
  __typename?: 'EventCompanyVenue_aggregate';
  aggregate?: Maybe<TixEventCompanyVenueAggregateFields>;
  nodes: Array<TixEventCompanyVenue>;
};

export type TixEventCompanyVenueAggregateBoolExp = {
  bool_and?: InputMaybe<TixEventCompanyVenueAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixEventCompanyVenueAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixEventCompanyVenueAggregateBoolExpCount>;
};

export type TixEventCompanyVenueAggregateBoolExpBoolAnd = {
  arguments: TixEventCompanyVenueSelectColumnEventCompanyVenueAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventCompanyVenueBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixEventCompanyVenueAggregateBoolExpBoolOr = {
  arguments: TixEventCompanyVenueSelectColumnEventCompanyVenueAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventCompanyVenueBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixEventCompanyVenueAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventCompanyVenueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventCompanyVenueBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "event.company_venue_event_list" */
export type TixEventCompanyVenueAggregateFields = {
  __typename?: 'EventCompanyVenue_aggregate_fields';
  avg?: Maybe<TixEventCompanyVenueAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixEventCompanyVenueMaxFields>;
  min?: Maybe<TixEventCompanyVenueMinFields>;
  stddev?: Maybe<TixEventCompanyVenueStddevFields>;
  stddev_pop?: Maybe<TixEventCompanyVenueStddevPopFields>;
  stddev_samp?: Maybe<TixEventCompanyVenueStddevSampFields>;
  sum?: Maybe<TixEventCompanyVenueSumFields>;
  var_pop?: Maybe<TixEventCompanyVenueVarPopFields>;
  var_samp?: Maybe<TixEventCompanyVenueVarSampFields>;
  variance?: Maybe<TixEventCompanyVenueVarianceFields>;
};


/** aggregate fields of "event.company_venue_event_list" */
export type TixEventCompanyVenueAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventCompanyVenueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event.company_venue_event_list" */
export type TixEventCompanyVenueAggregateOrderBy = {
  avg?: InputMaybe<TixEventCompanyVenueAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventCompanyVenueMaxOrderBy>;
  min?: InputMaybe<TixEventCompanyVenueMinOrderBy>;
  stddev?: InputMaybe<TixEventCompanyVenueStddevOrderBy>;
  stddev_pop?: InputMaybe<TixEventCompanyVenueStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixEventCompanyVenueStddevSampOrderBy>;
  sum?: InputMaybe<TixEventCompanyVenueSumOrderBy>;
  var_pop?: InputMaybe<TixEventCompanyVenueVarPopOrderBy>;
  var_samp?: InputMaybe<TixEventCompanyVenueVarSampOrderBy>;
  variance?: InputMaybe<TixEventCompanyVenueVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event.company_venue_event_list" */
export type TixEventCompanyVenueArrRelInsertInput = {
  data: Array<TixEventCompanyVenueInsertInput>;
};

/** aggregate avg on columns */
export type TixEventCompanyVenueAvgFields = {
  __typename?: 'EventCompanyVenue_avg_fields';
  available?: Maybe<Scalars['Float']>;
  checkedIn?: Maybe<Scalars['Float']>;
  minimum_age?: Maybe<Scalars['Float']>;
  notCheckedIn?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueAvgOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "event.company_venue_event_list". All fields are combined with a logical 'AND'. */
export type TixEventCompanyVenueBoolExp = {
  _and?: InputMaybe<Array<TixEventCompanyVenueBoolExp>>;
  _not?: InputMaybe<TixEventCompanyVenueBoolExp>;
  _or?: InputMaybe<Array<TixEventCompanyVenueBoolExp>>;
  available?: InputMaybe<TixBigintComparisonExp>;
  checkedIn?: InputMaybe<TixBigintComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  date?: InputMaybe<TixStringComparisonExp>;
  doorsOpen?: InputMaybe<TixTimeComparisonExp>;
  endTime?: InputMaybe<TixTimeComparisonExp>;
  eventAdditionalInfo?: InputMaybe<TixStringComparisonExp>;
  eventDescription?: InputMaybe<TixStringComparisonExp>;
  eventId?: InputMaybe<TixUuidComparisonExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventPasscode?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  eventType?: InputMaybe<TixStringComparisonExp>;
  filterDate?: InputMaybe<TixDateComparisonExp>;
  hidden?: InputMaybe<TixBooleanComparisonExp>;
  mainEventName?: InputMaybe<TixStringComparisonExp>;
  mediaFileType?: InputMaybe<TixStringComparisonExp>;
  mediaId?: InputMaybe<TixUuidComparisonExp>;
  mediaLocation?: InputMaybe<TixStringComparisonExp>;
  mediaState?: InputMaybe<TixStringComparisonExp>;
  minimum_age?: InputMaybe<TixIntComparisonExp>;
  notCheckedIn?: InputMaybe<TixBigintComparisonExp>;
  overridden?: InputMaybe<TixBooleanComparisonExp>;
  search?: InputMaybe<TixStringComparisonExp>;
  startTime?: InputMaybe<TixTimeComparisonExp>;
  start_selling_date?: InputMaybe<TixDateComparisonExp>;
  start_selling_time?: InputMaybe<TixTimeComparisonExp>;
  stop_selling_date?: InputMaybe<TixDateComparisonExp>;
  stop_selling_time?: InputMaybe<TixTimeComparisonExp>;
  ticketsSold?: InputMaybe<TixBigintComparisonExp>;
  totalSeats?: InputMaybe<TixIntComparisonExp>;
  venueCity?: InputMaybe<TixStringComparisonExp>;
  venueCityStateProvince?: InputMaybe<TixStringComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  venueStateProvince?: InputMaybe<TixStringComparisonExp>;
  venue_ticket_id?: InputMaybe<TixUuidComparisonExp>;
};

/** input type for inserting data into table "event.company_venue_event_list" */
export type TixEventCompanyVenueInsertInput = {
  available?: InputMaybe<Scalars['bigint']>;
  checkedIn?: InputMaybe<Scalars['bigint']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  eventAdditionalInfo?: InputMaybe<Scalars['String']>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPasscode?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  filterDate?: InputMaybe<Scalars['date']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  mainEventName?: InputMaybe<Scalars['String']>;
  mediaFileType?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  mediaLocation?: InputMaybe<Scalars['String']>;
  mediaState?: InputMaybe<Scalars['String']>;
  minimum_age?: InputMaybe<Scalars['Int']>;
  notCheckedIn?: InputMaybe<Scalars['bigint']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['time']>;
  start_selling_date?: InputMaybe<Scalars['date']>;
  start_selling_time?: InputMaybe<Scalars['time']>;
  stop_selling_date?: InputMaybe<Scalars['date']>;
  stop_selling_time?: InputMaybe<Scalars['time']>;
  ticketsSold?: InputMaybe<Scalars['bigint']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  venueCity?: InputMaybe<Scalars['String']>;
  venueCityStateProvince?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  venueStateProvince?: InputMaybe<Scalars['String']>;
  venue_ticket_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventCompanyVenueMaxFields = {
  __typename?: 'EventCompanyVenue_max_fields';
  available?: Maybe<Scalars['bigint']>;
  checkedIn?: Maybe<Scalars['bigint']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  mainEventName?: Maybe<Scalars['String']>;
  mediaFileType?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['uuid']>;
  mediaLocation?: Maybe<Scalars['String']>;
  mediaState?: Maybe<Scalars['String']>;
  minimum_age?: Maybe<Scalars['Int']>;
  notCheckedIn?: Maybe<Scalars['bigint']>;
  search?: Maybe<Scalars['String']>;
  start_selling_date?: Maybe<Scalars['date']>;
  stop_selling_date?: Maybe<Scalars['date']>;
  ticketsSold?: Maybe<Scalars['bigint']>;
  totalSeats?: Maybe<Scalars['Int']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venue_ticket_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueMaxOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  eventAdditionalInfo?: InputMaybe<TixOrderBy>;
  eventDescription?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventPasscode?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  filterDate?: InputMaybe<TixOrderBy>;
  mainEventName?: InputMaybe<TixOrderBy>;
  mediaFileType?: InputMaybe<TixOrderBy>;
  mediaId?: InputMaybe<TixOrderBy>;
  mediaLocation?: InputMaybe<TixOrderBy>;
  mediaState?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  search?: InputMaybe<TixOrderBy>;
  start_selling_date?: InputMaybe<TixOrderBy>;
  stop_selling_date?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  venueCity?: InputMaybe<TixOrderBy>;
  venueCityStateProvince?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueStateProvince?: InputMaybe<TixOrderBy>;
  venue_ticket_id?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventCompanyVenueMinFields = {
  __typename?: 'EventCompanyVenue_min_fields';
  available?: Maybe<Scalars['bigint']>;
  checkedIn?: Maybe<Scalars['bigint']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  mainEventName?: Maybe<Scalars['String']>;
  mediaFileType?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['uuid']>;
  mediaLocation?: Maybe<Scalars['String']>;
  mediaState?: Maybe<Scalars['String']>;
  minimum_age?: Maybe<Scalars['Int']>;
  notCheckedIn?: Maybe<Scalars['bigint']>;
  search?: Maybe<Scalars['String']>;
  start_selling_date?: Maybe<Scalars['date']>;
  stop_selling_date?: Maybe<Scalars['date']>;
  ticketsSold?: Maybe<Scalars['bigint']>;
  totalSeats?: Maybe<Scalars['Int']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venue_ticket_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueMinOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  eventAdditionalInfo?: InputMaybe<TixOrderBy>;
  eventDescription?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventPasscode?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  filterDate?: InputMaybe<TixOrderBy>;
  mainEventName?: InputMaybe<TixOrderBy>;
  mediaFileType?: InputMaybe<TixOrderBy>;
  mediaId?: InputMaybe<TixOrderBy>;
  mediaLocation?: InputMaybe<TixOrderBy>;
  mediaState?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  search?: InputMaybe<TixOrderBy>;
  start_selling_date?: InputMaybe<TixOrderBy>;
  stop_selling_date?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  venueCity?: InputMaybe<TixOrderBy>;
  venueCityStateProvince?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueStateProvince?: InputMaybe<TixOrderBy>;
  venue_ticket_id?: InputMaybe<TixOrderBy>;
};

/** Ordering options when selecting data from "event.company_venue_event_list". */
export type TixEventCompanyVenueOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  doorsOpen?: InputMaybe<TixOrderBy>;
  endTime?: InputMaybe<TixOrderBy>;
  eventAdditionalInfo?: InputMaybe<TixOrderBy>;
  eventDescription?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventPasscode?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  filterDate?: InputMaybe<TixOrderBy>;
  hidden?: InputMaybe<TixOrderBy>;
  mainEventName?: InputMaybe<TixOrderBy>;
  mediaFileType?: InputMaybe<TixOrderBy>;
  mediaId?: InputMaybe<TixOrderBy>;
  mediaLocation?: InputMaybe<TixOrderBy>;
  mediaState?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  overridden?: InputMaybe<TixOrderBy>;
  search?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  start_selling_date?: InputMaybe<TixOrderBy>;
  start_selling_time?: InputMaybe<TixOrderBy>;
  stop_selling_date?: InputMaybe<TixOrderBy>;
  stop_selling_time?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  venueCity?: InputMaybe<TixOrderBy>;
  venueCityStateProvince?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueStateProvince?: InputMaybe<TixOrderBy>;
  venue_ticket_id?: InputMaybe<TixOrderBy>;
};

/** select columns of table "event.company_venue_event_list" */
export enum TixEventCompanyVenueSelectColumn {
  /** column name */
  Available = 'available',
  /** column name */
  CheckedIn = 'checkedIn',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  Date = 'date',
  /** column name */
  DoorsOpen = 'doorsOpen',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EventAdditionalInfo = 'eventAdditionalInfo',
  /** column name */
  EventDescription = 'eventDescription',
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventPasscode = 'eventPasscode',
  /** column name */
  EventState = 'eventState',
  /** column name */
  EventType = 'eventType',
  /** column name */
  FilterDate = 'filterDate',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  MainEventName = 'mainEventName',
  /** column name */
  MediaFileType = 'mediaFileType',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  MediaLocation = 'mediaLocation',
  /** column name */
  MediaState = 'mediaState',
  /** column name */
  MinimumAge = 'minimum_age',
  /** column name */
  NotCheckedIn = 'notCheckedIn',
  /** column name */
  Overridden = 'overridden',
  /** column name */
  Search = 'search',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StartSellingDate = 'start_selling_date',
  /** column name */
  StartSellingTime = 'start_selling_time',
  /** column name */
  StopSellingDate = 'stop_selling_date',
  /** column name */
  StopSellingTime = 'stop_selling_time',
  /** column name */
  TicketsSold = 'ticketsSold',
  /** column name */
  TotalSeats = 'totalSeats',
  /** column name */
  VenueCity = 'venueCity',
  /** column name */
  VenueCityStateProvince = 'venueCityStateProvince',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  VenueStateProvince = 'venueStateProvince',
  /** column name */
  VenueTicketId = 'venue_ticket_id'
}

/** select "EventCompanyVenue_aggregate_bool_exp_bool_and_arguments_columns" columns of table "event.company_venue_event_list" */
export enum TixEventCompanyVenueSelectColumnEventCompanyVenueAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Overridden = 'overridden'
}

/** select "EventCompanyVenue_aggregate_bool_exp_bool_or_arguments_columns" columns of table "event.company_venue_event_list" */
export enum TixEventCompanyVenueSelectColumnEventCompanyVenueAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Overridden = 'overridden'
}

/** aggregate stddev on columns */
export type TixEventCompanyVenueStddevFields = {
  __typename?: 'EventCompanyVenue_stddev_fields';
  available?: Maybe<Scalars['Float']>;
  checkedIn?: Maybe<Scalars['Float']>;
  minimum_age?: Maybe<Scalars['Float']>;
  notCheckedIn?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueStddevOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixEventCompanyVenueStddevPopFields = {
  __typename?: 'EventCompanyVenue_stddev_pop_fields';
  available?: Maybe<Scalars['Float']>;
  checkedIn?: Maybe<Scalars['Float']>;
  minimum_age?: Maybe<Scalars['Float']>;
  notCheckedIn?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueStddevPopOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixEventCompanyVenueStddevSampFields = {
  __typename?: 'EventCompanyVenue_stddev_samp_fields';
  available?: Maybe<Scalars['Float']>;
  checkedIn?: Maybe<Scalars['Float']>;
  minimum_age?: Maybe<Scalars['Float']>;
  notCheckedIn?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueStddevSampOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "EventCompanyVenue" */
export type TixEventCompanyVenueStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventCompanyVenueStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventCompanyVenueStreamCursorValueInput = {
  available?: InputMaybe<Scalars['bigint']>;
  checkedIn?: InputMaybe<Scalars['bigint']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  eventAdditionalInfo?: InputMaybe<Scalars['String']>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPasscode?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  filterDate?: InputMaybe<Scalars['date']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  mainEventName?: InputMaybe<Scalars['String']>;
  mediaFileType?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  mediaLocation?: InputMaybe<Scalars['String']>;
  mediaState?: InputMaybe<Scalars['String']>;
  minimum_age?: InputMaybe<Scalars['Int']>;
  notCheckedIn?: InputMaybe<Scalars['bigint']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['time']>;
  start_selling_date?: InputMaybe<Scalars['date']>;
  start_selling_time?: InputMaybe<Scalars['time']>;
  stop_selling_date?: InputMaybe<Scalars['date']>;
  stop_selling_time?: InputMaybe<Scalars['time']>;
  ticketsSold?: InputMaybe<Scalars['bigint']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  venueCity?: InputMaybe<Scalars['String']>;
  venueCityStateProvince?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  venueStateProvince?: InputMaybe<Scalars['String']>;
  venue_ticket_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixEventCompanyVenueSumFields = {
  __typename?: 'EventCompanyVenue_sum_fields';
  available?: Maybe<Scalars['bigint']>;
  checkedIn?: Maybe<Scalars['bigint']>;
  minimum_age?: Maybe<Scalars['Int']>;
  notCheckedIn?: Maybe<Scalars['bigint']>;
  ticketsSold?: Maybe<Scalars['bigint']>;
  totalSeats?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueSumOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate var_pop on columns */
export type TixEventCompanyVenueVarPopFields = {
  __typename?: 'EventCompanyVenue_var_pop_fields';
  available?: Maybe<Scalars['Float']>;
  checkedIn?: Maybe<Scalars['Float']>;
  minimum_age?: Maybe<Scalars['Float']>;
  notCheckedIn?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueVarPopOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixEventCompanyVenueVarSampFields = {
  __typename?: 'EventCompanyVenue_var_samp_fields';
  available?: Maybe<Scalars['Float']>;
  checkedIn?: Maybe<Scalars['Float']>;
  minimum_age?: Maybe<Scalars['Float']>;
  notCheckedIn?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueVarSampOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixEventCompanyVenueVarianceFields = {
  __typename?: 'EventCompanyVenue_variance_fields';
  available?: Maybe<Scalars['Float']>;
  checkedIn?: Maybe<Scalars['Float']>;
  minimum_age?: Maybe<Scalars['Float']>;
  notCheckedIn?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event.company_venue_event_list" */
export type TixEventCompanyVenueVarianceOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  checkedIn?: InputMaybe<TixOrderBy>;
  minimum_age?: InputMaybe<TixOrderBy>;
  notCheckedIn?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
};

export type TixEventData = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  endSellingDate?: InputMaybe<Scalars['String']>;
  endSellingTime?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  instanceTime?: InputMaybe<Array<TixEventInstanceTime>>;
  media?: InputMaybe<Array<TixMediaInput>>;
  minAge?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  passcode?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<TixSocialMediaInput>>;
  startSellingDate?: InputMaybe<Scalars['String']>;
  startSellingTime?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  ticketConfigurationID: Scalars['String'];
  type: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  venueId: Scalars['String'];
};

/** columns and relationships of "communications.event_email" */
export type TixEventEmail = {
  __typename?: 'EventEmail';
  /** An object relationship */
  EventEmailContent?: Maybe<TixEmailContent>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  eventEmailId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "communications.event_email" */
export type TixEventEmailAggregate = {
  __typename?: 'EventEmail_aggregate';
  aggregate?: Maybe<TixEventEmailAggregateFields>;
  nodes: Array<TixEventEmail>;
};

/** aggregate fields of "communications.event_email" */
export type TixEventEmailAggregateFields = {
  __typename?: 'EventEmail_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventEmailMaxFields>;
  min?: Maybe<TixEventEmailMinFields>;
};


/** aggregate fields of "communications.event_email" */
export type TixEventEmailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventEmailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "communications.event_email". All fields are combined with a logical 'AND'. */
export type TixEventEmailBoolExp = {
  EventEmailContent?: InputMaybe<TixEmailContentBoolExp>;
  _and?: InputMaybe<Array<TixEventEmailBoolExp>>;
  _not?: InputMaybe<TixEventEmailBoolExp>;
  _or?: InputMaybe<Array<TixEventEmailBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  emailContentId?: InputMaybe<TixUuidComparisonExp>;
  eventEmailId?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** input type for inserting data into table "communications.event_email" */
export type TixEventEmailInsertInput = {
  EventEmailContent?: InputMaybe<TixEmailContentObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  eventEmailId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventEmailMaxFields = {
  __typename?: 'EventEmail_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  eventEmailId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixEventEmailMinFields = {
  __typename?: 'EventEmail_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  eventEmailId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "communications.event_email" */
export type TixEventEmailMutationResponse = {
  __typename?: 'EventEmail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventEmail>;
};

/** Ordering options when selecting data from "communications.event_email". */
export type TixEventEmailOrderBy = {
  EventEmailContent?: InputMaybe<TixEmailContentOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailContentId?: InputMaybe<TixOrderBy>;
  eventEmailId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** select columns of table "communications.event_email" */
export enum TixEventEmailSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailContentId = 'emailContentId',
  /** column name */
  EventEmailId = 'eventEmailId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "communications.event_email" */
export type TixEventEmailSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  eventEmailId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventEmail" */
export type TixEventEmailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventEmailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventEmailStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  eventEmailId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

export type TixEventEmailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventEmailSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventEmailBoolExp;
};

export type TixEventFinancialBreakdown = {
  __typename?: 'EventFinancialBreakdown';
  discountsUsedSummary: TixFinancialBreakdownDiscountUsageSummary;
  id: Scalars['ID'];
  name: Scalars['String'];
  refundsSummary: TixFinancialBreakdownRefundSummary;
  revenueByChannel: Array<TixFinancialBreakdownRevenueByChannel>;
  ticketSalesWeekSummary: Array<TixTicketSalesWeekDaySummary>;
  ticketsSoldByType: Array<TixFinancialBreakdownTicketSalesByType>;
  ticketsSoldCount: Scalars['Int'];
  ticketsTotalCount: Scalars['Int'];
  totalRevenue: Scalars['Float'];
  venue: TixFinancialBreakdownVenue;
};

export type TixEventFinancialReportDetails = {
  __typename?: 'EventFinancialReportDetails';
  byDiscountType: Array<TixGroupedTicketData>;
  bySalesChannel: Array<TixGroupedTicketData>;
  byTicketType: Array<TixGroupedTicketData>;
  canceled: TixCustomTickets;
  discount: TixCustomTickets;
  eventInstanceId?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  refunded: TixCustomTickets;
  ticketsAmountBreakDown: TixTicketsAmountBreakDown;
  totalEventRevenue: Scalars['Float'];
  totalSeats: Scalars['Int'];
  totalTicketSold: Scalars['Int'];
  venueId?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  venueRevenue: Scalars['Float'];
};

export type TixEventFinancialReportDetailsForCsv = {
  __typename?: 'EventFinancialReportDetailsForCsv';
  company_id?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  discount_amount?: Maybe<Scalars['Float']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_description?: Maybe<Scalars['String']>;
  discount_type?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['String']>;
  event_instance_id?: Maybe<Scalars['String']>;
  event_name?: Maybe<Scalars['String']>;
  event_time?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  payment_type?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  platform_fee?: Maybe<Scalars['Float']>;
  processing_fee?: Maybe<Scalars['Float']>;
  reservation_no?: Maybe<Scalars['String']>;
  sales_channel?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  ticket_count?: Maybe<Scalars['Int']>;
  ticket_name?: Maybe<Scalars['String']>;
  ticket_no?: Maybe<Scalars['String']>;
  ticket_revenue?: Maybe<Scalars['Float']>;
  ticket_type?: Maybe<Scalars['String']>;
  total_paid?: Maybe<Scalars['Float']>;
  total_revenue?: Maybe<Scalars['Float']>;
  venue_fee?: Maybe<Scalars['Float']>;
  venue_id?: Maybe<Scalars['String']>;
  venue_name?: Maybe<Scalars['String']>;
};

export type TixEventIdResult = {
  __typename?: 'EventIdResult';
  eventId?: Maybe<Scalars['String']>;
};

/** columns and relationships of "event.event_instance" */
export type TixEventInstance = {
  __typename?: 'EventInstance';
  /** An array relationship */
  DiscountCodeCount: Array<TixDiscountCodeCountByEvent>;
  /** An aggregate relationship */
  DiscountCodeCount_aggregate: TixDiscountCodeCountByEventAggregate;
  /** An array relationship */
  EventTicketCount: Array<TixTicketCountByEvent>;
  /** An aggregate relationship */
  EventTicketCount_aggregate: TixTicketCountByEventAggregate;
  /** An array relationship */
  Refunds: Array<TixReportingVRefundsByEvent>;
  /** An aggregate relationship */
  Refunds_aggregate: TixReportingVRefundsByEventAggregate;
  /** An array relationship */
  RevenueByChannelType: Array<TixRevenueByChannelType>;
  /** An aggregate relationship */
  RevenueByChannelType_aggregate: TixRevenueByChannelTypeAggregate;
  additionalInfo?: Maybe<Scalars['String']>;
  /** An array relationship */
  campaign: Array<TixEventCampaignTracking>;
  /** An aggregate relationship */
  campaign_aggregate: TixEventCampaignTrackingAggregate;
  /** An array relationship */
  configurationItems: Array<TixEventInstanceConfigurationValue>;
  /** An aggregate relationship */
  configurationItems_aggregate: TixEventInstanceConfigurationValueAggregate;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  discounts: Array<TixEventInstanceDiscount>;
  /** An aggregate relationship */
  discounts_aggregate: TixEventInstanceDiscountAggregate;
  doorsOpen?: Maybe<Scalars['time']>;
  endTime?: Maybe<Scalars['time']>;
  /** An object relationship */
  event?: Maybe<TixEvent>;
  eventAdmins?: Maybe<Array<Scalars['uuid']>>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId: Scalars['uuid'];
  /** An array relationship */
  eventInstanceTickets: Array<TixEventInstanceTicket>;
  /** An aggregate relationship */
  eventInstanceTickets_aggregate: TixEventInstanceTicketAggregate;
  /** An array relationship */
  eventPerformers: Array<TixEventPerformers>;
  /** An aggregate relationship */
  eventPerformers_aggregate: TixEventPerformersAggregate;
  /** An array relationship */
  eventProduct: Array<TixEventProduct>;
  /** An aggregate relationship */
  eventProduct_aggregate: TixEventProductAggregate;
  /** An object relationship */
  eventTicketSalesMetrics?: Maybe<TixTicketVTicketSalesMetrics>;
  flatFee?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  media: Array<TixEventInstanceMedialFile>;
  /** An aggregate relationship */
  media_aggregate: TixEventInstanceMedialFileAggregate;
  minimumAge?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  overridden?: Maybe<Scalars['Boolean']>;
  /** used for private events */
  passcode?: Maybe<Scalars['String']>;
  /** An object relationship */
  payout?: Maybe<TixPayout>;
  /** An array relationship */
  reservations: Array<TixTicketReservation>;
  /** An aggregate relationship */
  reservations_aggregate: TixTicketReservationAggregate;
  slug?: Maybe<Scalars['String']>;
  /** An array relationship */
  socialMedia: Array<TixEventInstanceSocialMediaFile>;
  /** An aggregate relationship */
  socialMedia_aggregate: TixEventInstanceSocialMediaFileAggregate;
  startSellingDate?: Maybe<Scalars['date']>;
  startSellingTime?: Maybe<Scalars['time']>;
  startTime?: Maybe<Scalars['time']>;
  state?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  stopSellingTime?: Maybe<Scalars['time']>;
  /** An array relationship */
  ticketCount: Array<TixTicketCountByEvent>;
  /** An aggregate relationship */
  ticketCount_aggregate: TixTicketCountByEventAggregate;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venue?: Maybe<TixVenue>;
  venueId?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceDiscountCodeCountArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountCodeCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountCodeCountByEventOrderBy>>;
  where?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceDiscountCodeCountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountCodeCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountCodeCountByEventOrderBy>>;
  where?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceEventTicketCountArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByEventOrderBy>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceEventTicketCountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByEventOrderBy>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceRefundsArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVRefundsByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVRefundsByEventOrderBy>>;
  where?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceRefundsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVRefundsByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVRefundsByEventOrderBy>>;
  where?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceRevenueByChannelTypeArgs = {
  distinct_on?: InputMaybe<Array<TixRevenueByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRevenueByChannelTypeOrderBy>>;
  where?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceRevenueByChannelTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixRevenueByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRevenueByChannelTypeOrderBy>>;
  where?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceCampaignArgs = {
  distinct_on?: InputMaybe<Array<TixEventCampaignTrackingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCampaignTrackingOrderBy>>;
  where?: InputMaybe<TixEventCampaignTrackingBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceCampaignAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventCampaignTrackingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCampaignTrackingOrderBy>>;
  where?: InputMaybe<TixEventCampaignTrackingBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceConfigurationItemsArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceConfigurationValueOrderBy>>;
  where?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceConfigurationItemsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceConfigurationValueOrderBy>>;
  where?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceDiscountsArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceDiscountOrderBy>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceDiscountsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceDiscountOrderBy>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceEventInstanceTicketsArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceEventInstanceTicketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceEventPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceEventPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceEventProductArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductOrderBy>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceEventProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductOrderBy>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceMediaArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceReservationsArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceReservationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceTicketCountArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByEventOrderBy>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};


/** columns and relationships of "event.event_instance" */
export type TixEventInstanceTicketCountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByEventOrderBy>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};

/** columns and relationships of "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValue = {
  __typename?: 'EventInstanceConfigurationValue';
  configurationValueId: Scalars['uuid'];
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  eventInstanceConfigurationId: Scalars['uuid'];
  eventInstanceId: Scalars['uuid'];
  /** An object relationship */
  event_instance?: Maybe<TixEventInstance>;
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  value?: Maybe<TixConfigurationValue>;
};

/** aggregated selection of "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueAggregate = {
  __typename?: 'EventInstanceConfigurationValue_aggregate';
  aggregate?: Maybe<TixEventInstanceConfigurationValueAggregateFields>;
  nodes: Array<TixEventInstanceConfigurationValue>;
};

export type TixEventInstanceConfigurationValueAggregateBoolExp = {
  count?: InputMaybe<TixEventInstanceConfigurationValueAggregateBoolExpCount>;
};

export type TixEventInstanceConfigurationValueAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventInstanceConfigurationValueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueAggregateFields = {
  __typename?: 'EventInstanceConfigurationValue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventInstanceConfigurationValueMaxFields>;
  min?: Maybe<TixEventInstanceConfigurationValueMinFields>;
};


/** aggregate fields of "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventInstanceConfigurationValueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventInstanceConfigurationValueMaxOrderBy>;
  min?: InputMaybe<TixEventInstanceConfigurationValueMinOrderBy>;
};

/** input type for inserting array relation for remote table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueArrRelInsertInput = {
  data: Array<TixEventInstanceConfigurationValueInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceConfigurationValueOnConflict>;
};

/** Boolean expression to filter rows from the table "configuration.event_instance_configuration_value". All fields are combined with a logical 'AND'. */
export type TixEventInstanceConfigurationValueBoolExp = {
  _and?: InputMaybe<Array<TixEventInstanceConfigurationValueBoolExp>>;
  _not?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
  _or?: InputMaybe<Array<TixEventInstanceConfigurationValueBoolExp>>;
  configurationValueId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceConfigurationId?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  event_instance?: InputMaybe<TixEventInstanceBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  value?: InputMaybe<TixConfigurationValueBoolExp>;
};

/** unique or primary key constraints on table "configuration.event_instance_configuration_value" */
export enum TixEventInstanceConfigurationValueConstraint {
  /** unique or primary key constraint on columns "event_instance_configuration_value_id" */
  EventInstanceConfigurationValuePkey = 'event_instance_configuration_value_pkey'
}

/** input type for inserting data into table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueInsertInput = {
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceConfigurationId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  event_instance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<TixConfigurationValueObjRelInsertInput>;
};

/** aggregate max on columns */
export type TixEventInstanceConfigurationValueMaxFields = {
  __typename?: 'EventInstanceConfigurationValue_max_fields';
  configurationValueId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceConfigurationId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueMaxOrderBy = {
  configurationValueId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceConfigurationId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventInstanceConfigurationValueMinFields = {
  __typename?: 'EventInstanceConfigurationValue_min_fields';
  configurationValueId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceConfigurationId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueMinOrderBy = {
  configurationValueId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceConfigurationId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueMutationResponse = {
  __typename?: 'EventInstanceConfigurationValue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventInstanceConfigurationValue>;
};

/** input type for inserting object relation for remote table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueObjRelInsertInput = {
  data: TixEventInstanceConfigurationValueInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceConfigurationValueOnConflict>;
};

/** on_conflict condition type for table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueOnConflict = {
  constraint: TixEventInstanceConfigurationValueConstraint;
  update_columns?: Array<TixEventInstanceConfigurationValueUpdateColumn>;
  where?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
};

/** Ordering options when selecting data from "configuration.event_instance_configuration_value". */
export type TixEventInstanceConfigurationValueOrderBy = {
  configurationValueId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceConfigurationId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  event_instance?: InputMaybe<TixEventInstanceOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  value?: InputMaybe<TixConfigurationValueOrderBy>;
};

/** primary key columns input for table: configuration.event_instance_configuration_value */
export type TixEventInstanceConfigurationValuePkColumnsInput = {
  eventInstanceConfigurationId: Scalars['uuid'];
};

/** select columns of table "configuration.event_instance_configuration_value" */
export enum TixEventInstanceConfigurationValueSelectColumn {
  /** column name */
  ConfigurationValueId = 'configurationValueId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceConfigurationId = 'eventInstanceConfigurationId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "configuration.event_instance_configuration_value" */
export type TixEventInstanceConfigurationValueSetInput = {
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceConfigurationId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventInstanceConfigurationValue" */
export type TixEventInstanceConfigurationValueStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventInstanceConfigurationValueStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventInstanceConfigurationValueStreamCursorValueInput = {
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceConfigurationId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "configuration.event_instance_configuration_value" */
export enum TixEventInstanceConfigurationValueUpdateColumn {
  /** column name */
  ConfigurationValueId = 'configurationValueId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceConfigurationId = 'eventInstanceConfigurationId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventInstanceConfigurationValueUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventInstanceConfigurationValueSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventInstanceConfigurationValueBoolExp;
};

/** columns and relationships of "discount.event_instance_discount" */
export type TixEventInstanceDiscount = {
  __typename?: 'EventInstanceDiscount';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  discount: Array<TixDiscount>;
  discountId: Scalars['uuid'];
  /** An aggregate relationship */
  discount_aggregate: TixDiscountAggregate;
  /** An object relationship */
  eventInstance?: Maybe<TixEventInstance>;
  eventInstanceDiscountId: Scalars['uuid'];
  eventInstanceId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "discount.event_instance_discount" */
export type TixEventInstanceDiscountDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountOrderBy>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};


/** columns and relationships of "discount.event_instance_discount" */
export type TixEventInstanceDiscountDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountOrderBy>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};

/** aggregated selection of "discount.event_instance_discount" */
export type TixEventInstanceDiscountAggregate = {
  __typename?: 'EventInstanceDiscount_aggregate';
  aggregate?: Maybe<TixEventInstanceDiscountAggregateFields>;
  nodes: Array<TixEventInstanceDiscount>;
};

export type TixEventInstanceDiscountAggregateBoolExp = {
  count?: InputMaybe<TixEventInstanceDiscountAggregateBoolExpCount>;
};

export type TixEventInstanceDiscountAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceDiscountBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "discount.event_instance_discount" */
export type TixEventInstanceDiscountAggregateFields = {
  __typename?: 'EventInstanceDiscount_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventInstanceDiscountMaxFields>;
  min?: Maybe<TixEventInstanceDiscountMinFields>;
};


/** aggregate fields of "discount.event_instance_discount" */
export type TixEventInstanceDiscountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount.event_instance_discount" */
export type TixEventInstanceDiscountAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventInstanceDiscountMaxOrderBy>;
  min?: InputMaybe<TixEventInstanceDiscountMinOrderBy>;
};

/** input type for inserting array relation for remote table "discount.event_instance_discount" */
export type TixEventInstanceDiscountArrRelInsertInput = {
  data: Array<TixEventInstanceDiscountInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceDiscountOnConflict>;
};

/** Boolean expression to filter rows from the table "discount.event_instance_discount". All fields are combined with a logical 'AND'. */
export type TixEventInstanceDiscountBoolExp = {
  _and?: InputMaybe<Array<TixEventInstanceDiscountBoolExp>>;
  _not?: InputMaybe<TixEventInstanceDiscountBoolExp>;
  _or?: InputMaybe<Array<TixEventInstanceDiscountBoolExp>>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  discount?: InputMaybe<TixDiscountBoolExp>;
  discountId?: InputMaybe<TixUuidComparisonExp>;
  discount_aggregate?: InputMaybe<TixDiscountAggregateBoolExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceDiscountId?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "discount.event_instance_discount" */
export enum TixEventInstanceDiscountConstraint {
  /** unique or primary key constraint on columns "event_instance_discount_id" */
  EventInstanceDiscountPkey = 'event_instance_discount_pkey'
}

/** input type for inserting data into table "discount.event_instance_discount" */
export type TixEventInstanceDiscountInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discount?: InputMaybe<TixDiscountArrRelInsertInput>;
  discountId?: InputMaybe<Scalars['uuid']>;
  eventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceDiscountId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventInstanceDiscountMaxFields = {
  __typename?: 'EventInstanceDiscount_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  eventInstanceDiscountId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "discount.event_instance_discount" */
export type TixEventInstanceDiscountMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  eventInstanceDiscountId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventInstanceDiscountMinFields = {
  __typename?: 'EventInstanceDiscount_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  eventInstanceDiscountId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "discount.event_instance_discount" */
export type TixEventInstanceDiscountMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  eventInstanceDiscountId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "discount.event_instance_discount" */
export type TixEventInstanceDiscountMutationResponse = {
  __typename?: 'EventInstanceDiscount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventInstanceDiscount>;
};

/** on_conflict condition type for table "discount.event_instance_discount" */
export type TixEventInstanceDiscountOnConflict = {
  constraint: TixEventInstanceDiscountConstraint;
  update_columns?: Array<TixEventInstanceDiscountUpdateColumn>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};

/** Ordering options when selecting data from "discount.event_instance_discount". */
export type TixEventInstanceDiscountOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  discount_aggregate?: InputMaybe<TixDiscountAggregateOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceDiscountId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: discount.event_instance_discount */
export type TixEventInstanceDiscountPkColumnsInput = {
  eventInstanceDiscountId: Scalars['uuid'];
};

/** select columns of table "discount.event_instance_discount" */
export enum TixEventInstanceDiscountSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  EventInstanceDiscountId = 'eventInstanceDiscountId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "discount.event_instance_discount" */
export type TixEventInstanceDiscountSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  eventInstanceDiscountId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventInstanceDiscount" */
export type TixEventInstanceDiscountStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventInstanceDiscountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventInstanceDiscountStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  eventInstanceDiscountId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "discount.event_instance_discount" */
export enum TixEventInstanceDiscountUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  EventInstanceDiscountId = 'eventInstanceDiscountId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventInstanceDiscountUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventInstanceDiscountSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventInstanceDiscountBoolExp;
};

/** columns and relationships of "media.event_instance_media_file" */
export type TixEventInstanceMedialFile = {
  __typename?: 'EventInstanceMedialFile';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  eventInstance: TixEventInstance;
  eventInstanceId: Scalars['uuid'];
  eventMediaId: Scalars['uuid'];
  /** An object relationship */
  mediaFile: TixMediaFile;
  mediaId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "media.event_instance_media_file" */
export type TixEventInstanceMedialFileAggregate = {
  __typename?: 'EventInstanceMedialFile_aggregate';
  aggregate?: Maybe<TixEventInstanceMedialFileAggregateFields>;
  nodes: Array<TixEventInstanceMedialFile>;
};

export type TixEventInstanceMedialFileAggregateBoolExp = {
  count?: InputMaybe<TixEventInstanceMedialFileAggregateBoolExpCount>;
};

export type TixEventInstanceMedialFileAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "media.event_instance_media_file" */
export type TixEventInstanceMedialFileAggregateFields = {
  __typename?: 'EventInstanceMedialFile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventInstanceMedialFileMaxFields>;
  min?: Maybe<TixEventInstanceMedialFileMinFields>;
};


/** aggregate fields of "media.event_instance_media_file" */
export type TixEventInstanceMedialFileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media.event_instance_media_file" */
export type TixEventInstanceMedialFileAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventInstanceMedialFileMaxOrderBy>;
  min?: InputMaybe<TixEventInstanceMedialFileMinOrderBy>;
};

/** input type for inserting array relation for remote table "media.event_instance_media_file" */
export type TixEventInstanceMedialFileArrRelInsertInput = {
  data: Array<TixEventInstanceMedialFileInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceMedialFileOnConflict>;
};

/** Boolean expression to filter rows from the table "media.event_instance_media_file". All fields are combined with a logical 'AND'. */
export type TixEventInstanceMedialFileBoolExp = {
  _and?: InputMaybe<Array<TixEventInstanceMedialFileBoolExp>>;
  _not?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
  _or?: InputMaybe<Array<TixEventInstanceMedialFileBoolExp>>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventMediaId?: InputMaybe<TixUuidComparisonExp>;
  mediaFile?: InputMaybe<TixMediaFileBoolExp>;
  mediaId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "media.event_instance_media_file" */
export enum TixEventInstanceMedialFileConstraint {
  /** unique or primary key constraint on columns "event_media_id" */
  EventMediaFilePkey = 'event_media_file_pkey'
}

/** input type for inserting data into table "media.event_instance_media_file" */
export type TixEventInstanceMedialFileInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventMediaId?: InputMaybe<Scalars['uuid']>;
  mediaFile?: InputMaybe<TixMediaFileObjRelInsertInput>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventInstanceMedialFileMaxFields = {
  __typename?: 'EventInstanceMedialFile_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventMediaId?: Maybe<Scalars['uuid']>;
  mediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "media.event_instance_media_file" */
export type TixEventInstanceMedialFileMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventMediaId?: InputMaybe<TixOrderBy>;
  mediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventInstanceMedialFileMinFields = {
  __typename?: 'EventInstanceMedialFile_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventMediaId?: Maybe<Scalars['uuid']>;
  mediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "media.event_instance_media_file" */
export type TixEventInstanceMedialFileMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventMediaId?: InputMaybe<TixOrderBy>;
  mediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "media.event_instance_media_file" */
export type TixEventInstanceMedialFileMutationResponse = {
  __typename?: 'EventInstanceMedialFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventInstanceMedialFile>;
};

/** on_conflict condition type for table "media.event_instance_media_file" */
export type TixEventInstanceMedialFileOnConflict = {
  constraint: TixEventInstanceMedialFileConstraint;
  update_columns?: Array<TixEventInstanceMedialFileUpdateColumn>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};

/** Ordering options when selecting data from "media.event_instance_media_file". */
export type TixEventInstanceMedialFileOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventMediaId?: InputMaybe<TixOrderBy>;
  mediaFile?: InputMaybe<TixMediaFileOrderBy>;
  mediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: media.event_instance_media_file */
export type TixEventInstanceMedialFilePkColumnsInput = {
  eventMediaId: Scalars['uuid'];
};

/** select columns of table "media.event_instance_media_file" */
export enum TixEventInstanceMedialFileSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventMediaId = 'eventMediaId',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "media.event_instance_media_file" */
export type TixEventInstanceMedialFileSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventMediaId?: InputMaybe<Scalars['uuid']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventInstanceMedialFile" */
export type TixEventInstanceMedialFileStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventInstanceMedialFileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventInstanceMedialFileStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventMediaId?: InputMaybe<Scalars['uuid']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.event_instance_media_file" */
export enum TixEventInstanceMedialFileUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventMediaId = 'eventMediaId',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventInstanceMedialFileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventInstanceMedialFileSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventInstanceMedialFileBoolExp;
};

/** columns and relationships of "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFile = {
  __typename?: 'EventInstanceSocialMediaFile';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  eventInstance: TixEventInstance;
  eventInstanceId: Scalars['uuid'];
  eventSocialMediaId: Scalars['uuid'];
  /** An object relationship */
  socialMedia: TixSocialMedia;
  socialMediaId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileAggregate = {
  __typename?: 'EventInstanceSocialMediaFile_aggregate';
  aggregate?: Maybe<TixEventInstanceSocialMediaFileAggregateFields>;
  nodes: Array<TixEventInstanceSocialMediaFile>;
};

export type TixEventInstanceSocialMediaFileAggregateBoolExp = {
  count?: InputMaybe<TixEventInstanceSocialMediaFileAggregateBoolExpCount>;
};

export type TixEventInstanceSocialMediaFileAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileAggregateFields = {
  __typename?: 'EventInstanceSocialMediaFile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventInstanceSocialMediaFileMaxFields>;
  min?: Maybe<TixEventInstanceSocialMediaFileMinFields>;
};


/** aggregate fields of "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventInstanceSocialMediaFileMaxOrderBy>;
  min?: InputMaybe<TixEventInstanceSocialMediaFileMinOrderBy>;
};

/** input type for inserting array relation for remote table "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileArrRelInsertInput = {
  data: Array<TixEventInstanceSocialMediaFileInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceSocialMediaFileOnConflict>;
};

/** Boolean expression to filter rows from the table "media.event_instance_social_media". All fields are combined with a logical 'AND'. */
export type TixEventInstanceSocialMediaFileBoolExp = {
  _and?: InputMaybe<Array<TixEventInstanceSocialMediaFileBoolExp>>;
  _not?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
  _or?: InputMaybe<Array<TixEventInstanceSocialMediaFileBoolExp>>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventSocialMediaId?: InputMaybe<TixUuidComparisonExp>;
  socialMedia?: InputMaybe<TixSocialMediaBoolExp>;
  socialMediaId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "media.event_instance_social_media" */
export enum TixEventInstanceSocialMediaFileConstraint {
  /** unique or primary key constraint on columns "event_social_media_id" */
  EventSocialMediaPkey = 'event_social_media_pkey'
}

/** input type for inserting data into table "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventSocialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMedia?: InputMaybe<TixSocialMediaObjRelInsertInput>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventInstanceSocialMediaFileMaxFields = {
  __typename?: 'EventInstanceSocialMediaFile_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventSocialMediaId?: Maybe<Scalars['uuid']>;
  socialMediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventSocialMediaId?: InputMaybe<TixOrderBy>;
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventInstanceSocialMediaFileMinFields = {
  __typename?: 'EventInstanceSocialMediaFile_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventSocialMediaId?: Maybe<Scalars['uuid']>;
  socialMediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventSocialMediaId?: InputMaybe<TixOrderBy>;
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileMutationResponse = {
  __typename?: 'EventInstanceSocialMediaFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventInstanceSocialMediaFile>;
};

/** on_conflict condition type for table "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileOnConflict = {
  constraint: TixEventInstanceSocialMediaFileConstraint;
  update_columns?: Array<TixEventInstanceSocialMediaFileUpdateColumn>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};

/** Ordering options when selecting data from "media.event_instance_social_media". */
export type TixEventInstanceSocialMediaFileOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventSocialMediaId?: InputMaybe<TixOrderBy>;
  socialMedia?: InputMaybe<TixSocialMediaOrderBy>;
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: media.event_instance_social_media */
export type TixEventInstanceSocialMediaFilePkColumnsInput = {
  eventSocialMediaId: Scalars['uuid'];
};

/** select columns of table "media.event_instance_social_media" */
export enum TixEventInstanceSocialMediaFileSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventSocialMediaId = 'eventSocialMediaId',
  /** column name */
  SocialMediaId = 'socialMediaId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "media.event_instance_social_media" */
export type TixEventInstanceSocialMediaFileSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventSocialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventInstanceSocialMediaFile" */
export type TixEventInstanceSocialMediaFileStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventInstanceSocialMediaFileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventInstanceSocialMediaFileStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventSocialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.event_instance_social_media" */
export enum TixEventInstanceSocialMediaFileUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventSocialMediaId = 'eventSocialMediaId',
  /** column name */
  SocialMediaId = 'socialMediaId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventInstanceSocialMediaFileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventInstanceSocialMediaFileSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventInstanceSocialMediaFileBoolExp;
};

/** columns and relationships of "ticket.event_instance_ticket" */
export type TixEventInstanceTicket = {
  __typename?: 'EventInstanceTicket';
  /** An array relationship */
  Configurations: Array<TixEventInstanceTicketConfig>;
  /** An aggregate relationship */
  Configurations_aggregate: TixEventInstanceTicketConfigAggregate;
  /** An object relationship */
  EventInstance: TixEventInstance;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  description?: Maybe<Scalars['String']>;
  eventInstanceId: Scalars['uuid'];
  eventInstanceTicketId: Scalars['uuid'];
  name: Scalars['String'];
  state: Scalars['String'];
  totalSeats?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "ticket.event_instance_ticket" */
export type TixEventInstanceTicketConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketConfigOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
};


/** columns and relationships of "ticket.event_instance_ticket" */
export type TixEventInstanceTicketConfigurationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketConfigOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
};

/** columns and relationships of "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfig = {
  __typename?: 'EventInstanceTicketConfig';
  /** An object relationship */
  EventInstanceTicket: TixEventInstanceTicket;
  /** An object relationship */
  TicketConfigurations: TixTicketConfig;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  eventInstanceTicketConfigId: Scalars['uuid'];
  eventInstanceTicketId: Scalars['uuid'];
  state: Scalars['String'];
  ticketConfigId: Scalars['uuid'];
  /** An object relationship */
  totalTicketsByType?: Maybe<TixTicketVTicketCountByType>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigAggregate = {
  __typename?: 'EventInstanceTicketConfig_aggregate';
  aggregate?: Maybe<TixEventInstanceTicketConfigAggregateFields>;
  nodes: Array<TixEventInstanceTicketConfig>;
};

export type TixEventInstanceTicketConfigAggregateBoolExp = {
  count?: InputMaybe<TixEventInstanceTicketConfigAggregateBoolExpCount>;
};

export type TixEventInstanceTicketConfigAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventInstanceTicketConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigAggregateFields = {
  __typename?: 'EventInstanceTicketConfig_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventInstanceTicketConfigMaxFields>;
  min?: Maybe<TixEventInstanceTicketConfigMinFields>;
};


/** aggregate fields of "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventInstanceTicketConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventInstanceTicketConfigMaxOrderBy>;
  min?: InputMaybe<TixEventInstanceTicketConfigMinOrderBy>;
};

/** input type for inserting array relation for remote table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigArrRelInsertInput = {
  data: Array<TixEventInstanceTicketConfigInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceTicketConfigOnConflict>;
};

/** Boolean expression to filter rows from the table "ticket.event_instance_ticket_config". All fields are combined with a logical 'AND'. */
export type TixEventInstanceTicketConfigBoolExp = {
  EventInstanceTicket?: InputMaybe<TixEventInstanceTicketBoolExp>;
  TicketConfigurations?: InputMaybe<TixTicketConfigBoolExp>;
  _and?: InputMaybe<Array<TixEventInstanceTicketConfigBoolExp>>;
  _not?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
  _or?: InputMaybe<Array<TixEventInstanceTicketConfigBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceTicketConfigId?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceTicketId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  totalTicketsByType?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "ticket.event_instance_ticket_config" */
export enum TixEventInstanceTicketConfigConstraint {
  /** unique or primary key constraint on columns "event_instance_ticket_config_id" */
  EventInstanceTicketConfigPkey = 'event_instance_ticket_config_pkey'
}

/** input type for inserting data into table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigInsertInput = {
  EventInstanceTicket?: InputMaybe<TixEventInstanceTicketObjRelInsertInput>;
  TicketConfigurations?: InputMaybe<TixTicketConfigObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketConfigId?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  totalTicketsByType?: InputMaybe<TixTicketVTicketCountByTypeObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventInstanceTicketConfigMaxFields = {
  __typename?: 'EventInstanceTicketConfig_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceTicketConfigId?: Maybe<Scalars['uuid']>;
  eventInstanceTicketId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceTicketConfigId?: InputMaybe<TixOrderBy>;
  eventInstanceTicketId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventInstanceTicketConfigMinFields = {
  __typename?: 'EventInstanceTicketConfig_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceTicketConfigId?: Maybe<Scalars['uuid']>;
  eventInstanceTicketId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceTicketConfigId?: InputMaybe<TixOrderBy>;
  eventInstanceTicketId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigMutationResponse = {
  __typename?: 'EventInstanceTicketConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventInstanceTicketConfig>;
};

/** input type for inserting object relation for remote table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigObjRelInsertInput = {
  data: TixEventInstanceTicketConfigInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceTicketConfigOnConflict>;
};

/** on_conflict condition type for table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigOnConflict = {
  constraint: TixEventInstanceTicketConfigConstraint;
  update_columns?: Array<TixEventInstanceTicketConfigUpdateColumn>;
  where?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
};

/** Ordering options when selecting data from "ticket.event_instance_ticket_config". */
export type TixEventInstanceTicketConfigOrderBy = {
  EventInstanceTicket?: InputMaybe<TixEventInstanceTicketOrderBy>;
  TicketConfigurations?: InputMaybe<TixTicketConfigOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceTicketConfigId?: InputMaybe<TixOrderBy>;
  eventInstanceTicketId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  totalTicketsByType?: InputMaybe<TixTicketVTicketCountByTypeOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.event_instance_ticket_config */
export type TixEventInstanceTicketConfigPkColumnsInput = {
  eventInstanceTicketConfigId: Scalars['uuid'];
};

/** select columns of table "ticket.event_instance_ticket_config" */
export enum TixEventInstanceTicketConfigSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceTicketConfigId = 'eventInstanceTicketConfigId',
  /** column name */
  EventInstanceTicketId = 'eventInstanceTicketId',
  /** column name */
  State = 'state',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "ticket.event_instance_ticket_config" */
export type TixEventInstanceTicketConfigSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketConfigId?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventInstanceTicketConfig" */
export type TixEventInstanceTicketConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventInstanceTicketConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventInstanceTicketConfigStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketConfigId?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ticket.event_instance_ticket_config" */
export enum TixEventInstanceTicketConfigUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceTicketConfigId = 'eventInstanceTicketConfigId',
  /** column name */
  EventInstanceTicketId = 'eventInstanceTicketId',
  /** column name */
  State = 'state',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventInstanceTicketConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventInstanceTicketConfigSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventInstanceTicketConfigBoolExp;
};

/** aggregated selection of "ticket.event_instance_ticket" */
export type TixEventInstanceTicketAggregate = {
  __typename?: 'EventInstanceTicket_aggregate';
  aggregate?: Maybe<TixEventInstanceTicketAggregateFields>;
  nodes: Array<TixEventInstanceTicket>;
};

export type TixEventInstanceTicketAggregateBoolExp = {
  count?: InputMaybe<TixEventInstanceTicketAggregateBoolExpCount>;
};

export type TixEventInstanceTicketAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceTicketBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.event_instance_ticket" */
export type TixEventInstanceTicketAggregateFields = {
  __typename?: 'EventInstanceTicket_aggregate_fields';
  avg?: Maybe<TixEventInstanceTicketAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixEventInstanceTicketMaxFields>;
  min?: Maybe<TixEventInstanceTicketMinFields>;
  stddev?: Maybe<TixEventInstanceTicketStddevFields>;
  stddev_pop?: Maybe<TixEventInstanceTicketStddevPopFields>;
  stddev_samp?: Maybe<TixEventInstanceTicketStddevSampFields>;
  sum?: Maybe<TixEventInstanceTicketSumFields>;
  var_pop?: Maybe<TixEventInstanceTicketVarPopFields>;
  var_samp?: Maybe<TixEventInstanceTicketVarSampFields>;
  variance?: Maybe<TixEventInstanceTicketVarianceFields>;
};


/** aggregate fields of "ticket.event_instance_ticket" */
export type TixEventInstanceTicketAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketAggregateOrderBy = {
  avg?: InputMaybe<TixEventInstanceTicketAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventInstanceTicketMaxOrderBy>;
  min?: InputMaybe<TixEventInstanceTicketMinOrderBy>;
  stddev?: InputMaybe<TixEventInstanceTicketStddevOrderBy>;
  stddev_pop?: InputMaybe<TixEventInstanceTicketStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixEventInstanceTicketStddevSampOrderBy>;
  sum?: InputMaybe<TixEventInstanceTicketSumOrderBy>;
  var_pop?: InputMaybe<TixEventInstanceTicketVarPopOrderBy>;
  var_samp?: InputMaybe<TixEventInstanceTicketVarSampOrderBy>;
  variance?: InputMaybe<TixEventInstanceTicketVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketArrRelInsertInput = {
  data: Array<TixEventInstanceTicketInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceTicketOnConflict>;
};

/** aggregate avg on columns */
export type TixEventInstanceTicketAvgFields = {
  __typename?: 'EventInstanceTicket_avg_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketAvgOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "ticket.event_instance_ticket". All fields are combined with a logical 'AND'. */
export type TixEventInstanceTicketBoolExp = {
  Configurations?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
  Configurations_aggregate?: InputMaybe<TixEventInstanceTicketConfigAggregateBoolExp>;
  EventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  _and?: InputMaybe<Array<TixEventInstanceTicketBoolExp>>;
  _not?: InputMaybe<TixEventInstanceTicketBoolExp>;
  _or?: InputMaybe<Array<TixEventInstanceTicketBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceTicketId?: InputMaybe<TixUuidComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  totalSeats?: InputMaybe<TixIntComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "ticket.event_instance_ticket" */
export enum TixEventInstanceTicketConstraint {
  /** unique or primary key constraint on columns "event_instance_ticket_id" */
  EventInstanceTicketPkey = 'event_instance_ticket_pkey'
}

/** input type for incrementing numeric columns in table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketIncInput = {
  totalSeats?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketInsertInput = {
  Configurations?: InputMaybe<TixEventInstanceTicketConfigArrRelInsertInput>;
  EventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventInstanceTicketMaxFields = {
  __typename?: 'EventInstanceTicket_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventInstanceTicketId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  totalSeats?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventInstanceTicketId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventInstanceTicketMinFields = {
  __typename?: 'EventInstanceTicket_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventInstanceTicketId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  totalSeats?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventInstanceTicketId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketMutationResponse = {
  __typename?: 'EventInstanceTicket_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventInstanceTicket>;
};

/** input type for inserting object relation for remote table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketObjRelInsertInput = {
  data: TixEventInstanceTicketInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceTicketOnConflict>;
};

/** on_conflict condition type for table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketOnConflict = {
  constraint: TixEventInstanceTicketConstraint;
  update_columns?: Array<TixEventInstanceTicketUpdateColumn>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};

/** Ordering options when selecting data from "ticket.event_instance_ticket". */
export type TixEventInstanceTicketOrderBy = {
  Configurations_aggregate?: InputMaybe<TixEventInstanceTicketConfigAggregateOrderBy>;
  EventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventInstanceTicketId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.event_instance_ticket */
export type TixEventInstanceTicketPkColumnsInput = {
  eventInstanceTicketId: Scalars['uuid'];
};

/** select columns of table "ticket.event_instance_ticket" */
export enum TixEventInstanceTicketSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventInstanceTicketId = 'eventInstanceTicketId',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  TotalSeats = 'totalSeats',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixEventInstanceTicketStddevFields = {
  __typename?: 'EventInstanceTicket_stddev_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketStddevOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixEventInstanceTicketStddevPopFields = {
  __typename?: 'EventInstanceTicket_stddev_pop_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketStddevPopOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixEventInstanceTicketStddevSampFields = {
  __typename?: 'EventInstanceTicket_stddev_samp_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketStddevSampOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "EventInstanceTicket" */
export type TixEventInstanceTicketStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventInstanceTicketStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventInstanceTicketStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventInstanceTicketId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixEventInstanceTicketSumFields = {
  __typename?: 'EventInstanceTicket_sum_fields';
  totalSeats?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketSumOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** update columns of table "ticket.event_instance_ticket" */
export enum TixEventInstanceTicketUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventInstanceTicketId = 'eventInstanceTicketId',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  TotalSeats = 'totalSeats',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventInstanceTicketUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixEventInstanceTicketIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventInstanceTicketSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventInstanceTicketBoolExp;
};

/** aggregate var_pop on columns */
export type TixEventInstanceTicketVarPopFields = {
  __typename?: 'EventInstanceTicket_var_pop_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketVarPopOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixEventInstanceTicketVarSampFields = {
  __typename?: 'EventInstanceTicket_var_samp_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketVarSampOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixEventInstanceTicketVarianceFields = {
  __typename?: 'EventInstanceTicket_variance_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ticket.event_instance_ticket" */
export type TixEventInstanceTicketVarianceOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

export type TixEventInstanceTime = {
  date: Scalars['String'];
  doorsOpen?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "event.event_instance" */
export type TixEventInstanceAggregate = {
  __typename?: 'EventInstance_aggregate';
  aggregate?: Maybe<TixEventInstanceAggregateFields>;
  nodes: Array<TixEventInstance>;
};

export type TixEventInstanceAggregateBoolExp = {
  bool_and?: InputMaybe<TixEventInstanceAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixEventInstanceAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixEventInstanceAggregateBoolExpCount>;
};

export type TixEventInstanceAggregateBoolExpBoolAnd = {
  arguments: TixEventInstanceSelectColumnEventInstanceAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixEventInstanceAggregateBoolExpBoolOr = {
  arguments: TixEventInstanceSelectColumnEventInstanceAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixEventInstanceAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventInstanceBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "event.event_instance" */
export type TixEventInstanceAggregateFields = {
  __typename?: 'EventInstance_aggregate_fields';
  avg?: Maybe<TixEventInstanceAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixEventInstanceMaxFields>;
  min?: Maybe<TixEventInstanceMinFields>;
  stddev?: Maybe<TixEventInstanceStddevFields>;
  stddev_pop?: Maybe<TixEventInstanceStddevPopFields>;
  stddev_samp?: Maybe<TixEventInstanceStddevSampFields>;
  sum?: Maybe<TixEventInstanceSumFields>;
  var_pop?: Maybe<TixEventInstanceVarPopFields>;
  var_samp?: Maybe<TixEventInstanceVarSampFields>;
  variance?: Maybe<TixEventInstanceVarianceFields>;
};


/** aggregate fields of "event.event_instance" */
export type TixEventInstanceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event.event_instance" */
export type TixEventInstanceAggregateOrderBy = {
  avg?: InputMaybe<TixEventInstanceAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventInstanceMaxOrderBy>;
  min?: InputMaybe<TixEventInstanceMinOrderBy>;
  stddev?: InputMaybe<TixEventInstanceStddevOrderBy>;
  stddev_pop?: InputMaybe<TixEventInstanceStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixEventInstanceStddevSampOrderBy>;
  sum?: InputMaybe<TixEventInstanceSumOrderBy>;
  var_pop?: InputMaybe<TixEventInstanceVarPopOrderBy>;
  var_samp?: InputMaybe<TixEventInstanceVarSampOrderBy>;
  variance?: InputMaybe<TixEventInstanceVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event.event_instance" */
export type TixEventInstanceArrRelInsertInput = {
  data: Array<TixEventInstanceInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceOnConflict>;
};

/** aggregate avg on columns */
export type TixEventInstanceAvgFields = {
  __typename?: 'EventInstance_avg_fields';
  minimumAge?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event.event_instance" */
export type TixEventInstanceAvgOrderBy = {
  minimumAge?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "event.event_instance". All fields are combined with a logical 'AND'. */
export type TixEventInstanceBoolExp = {
  DiscountCodeCount?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
  DiscountCodeCount_aggregate?: InputMaybe<TixDiscountCodeCountByEventAggregateBoolExp>;
  EventTicketCount?: InputMaybe<TixTicketCountByEventBoolExp>;
  EventTicketCount_aggregate?: InputMaybe<TixTicketCountByEventAggregateBoolExp>;
  Refunds?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
  Refunds_aggregate?: InputMaybe<TixReportingVRefundsByEventAggregateBoolExp>;
  RevenueByChannelType?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
  RevenueByChannelType_aggregate?: InputMaybe<TixRevenueByChannelTypeAggregateBoolExp>;
  _and?: InputMaybe<Array<TixEventInstanceBoolExp>>;
  _not?: InputMaybe<TixEventInstanceBoolExp>;
  _or?: InputMaybe<Array<TixEventInstanceBoolExp>>;
  additionalInfo?: InputMaybe<TixStringComparisonExp>;
  campaign?: InputMaybe<TixEventCampaignTrackingBoolExp>;
  campaign_aggregate?: InputMaybe<TixEventCampaignTrackingAggregateBoolExp>;
  configurationItems?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
  configurationItems_aggregate?: InputMaybe<TixEventInstanceConfigurationValueAggregateBoolExp>;
  date?: InputMaybe<TixDateComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  discounts?: InputMaybe<TixEventInstanceDiscountBoolExp>;
  discounts_aggregate?: InputMaybe<TixEventInstanceDiscountAggregateBoolExp>;
  doorsOpen?: InputMaybe<TixTimeComparisonExp>;
  endTime?: InputMaybe<TixTimeComparisonExp>;
  event?: InputMaybe<TixEventBoolExp>;
  eventAdmins?: InputMaybe<TixUuidArrayComparisonExp>;
  eventId?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceTickets?: InputMaybe<TixEventInstanceTicketBoolExp>;
  eventInstanceTickets_aggregate?: InputMaybe<TixEventInstanceTicketAggregateBoolExp>;
  eventPerformers?: InputMaybe<TixEventPerformersBoolExp>;
  eventPerformers_aggregate?: InputMaybe<TixEventPerformersAggregateBoolExp>;
  eventProduct?: InputMaybe<TixEventProductBoolExp>;
  eventProduct_aggregate?: InputMaybe<TixEventProductAggregateBoolExp>;
  eventTicketSalesMetrics?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
  flatFee?: InputMaybe<TixBooleanComparisonExp>;
  hidden?: InputMaybe<TixBooleanComparisonExp>;
  media?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
  media_aggregate?: InputMaybe<TixEventInstanceMedialFileAggregateBoolExp>;
  minimumAge?: InputMaybe<TixIntComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  overridden?: InputMaybe<TixBooleanComparisonExp>;
  passcode?: InputMaybe<TixStringComparisonExp>;
  payout?: InputMaybe<TixPayoutBoolExp>;
  reservations?: InputMaybe<TixTicketReservationBoolExp>;
  reservations_aggregate?: InputMaybe<TixTicketReservationAggregateBoolExp>;
  slug?: InputMaybe<TixStringComparisonExp>;
  socialMedia?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
  socialMedia_aggregate?: InputMaybe<TixEventInstanceSocialMediaFileAggregateBoolExp>;
  startSellingDate?: InputMaybe<TixDateComparisonExp>;
  startSellingTime?: InputMaybe<TixTimeComparisonExp>;
  startTime?: InputMaybe<TixTimeComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  stopSellingDate?: InputMaybe<TixDateComparisonExp>;
  stopSellingTime?: InputMaybe<TixTimeComparisonExp>;
  ticketCount?: InputMaybe<TixTicketCountByEventBoolExp>;
  ticketCount_aggregate?: InputMaybe<TixTicketCountByEventAggregateBoolExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueTicketId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "event.event_instance" */
export enum TixEventInstanceConstraint {
  /** unique or primary key constraint on columns "event_instance_id" */
  EventInstancePkey = 'event_instance_pkey'
}

/** input type for incrementing numeric columns in table "event.event_instance" */
export type TixEventInstanceIncInput = {
  minimumAge?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event.event_instance" */
export type TixEventInstanceInsertInput = {
  DiscountCodeCount?: InputMaybe<TixDiscountCodeCountByEventArrRelInsertInput>;
  EventTicketCount?: InputMaybe<TixTicketCountByEventArrRelInsertInput>;
  Refunds?: InputMaybe<TixReportingVRefundsByEventArrRelInsertInput>;
  RevenueByChannelType?: InputMaybe<TixRevenueByChannelTypeArrRelInsertInput>;
  additionalInfo?: InputMaybe<Scalars['String']>;
  campaign?: InputMaybe<TixEventCampaignTrackingArrRelInsertInput>;
  configurationItems?: InputMaybe<TixEventInstanceConfigurationValueArrRelInsertInput>;
  date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  discounts?: InputMaybe<TixEventInstanceDiscountArrRelInsertInput>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  event?: InputMaybe<TixEventObjRelInsertInput>;
  eventAdmins?: InputMaybe<Array<Scalars['uuid']>>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventInstanceTickets?: InputMaybe<TixEventInstanceTicketArrRelInsertInput>;
  eventPerformers?: InputMaybe<TixEventPerformersArrRelInsertInput>;
  eventProduct?: InputMaybe<TixEventProductArrRelInsertInput>;
  eventTicketSalesMetrics?: InputMaybe<TixTicketVTicketSalesMetricsObjRelInsertInput>;
  flatFee?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<TixEventInstanceMedialFileArrRelInsertInput>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  /** used for private events */
  passcode?: InputMaybe<Scalars['String']>;
  payout?: InputMaybe<TixPayoutObjRelInsertInput>;
  reservations?: InputMaybe<TixTicketReservationArrRelInsertInput>;
  slug?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<TixEventInstanceSocialMediaFileArrRelInsertInput>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  startTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  ticketCount?: InputMaybe<TixTicketCountByEventArrRelInsertInput>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventInstanceMaxFields = {
  __typename?: 'EventInstance_max_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  eventAdmins?: Maybe<Array<Scalars['uuid']>>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  minimumAge?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** used for private events */
  passcode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event.event_instance" */
export type TixEventInstanceMaxOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventAdmins?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  minimumAge?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  /** used for private events */
  passcode?: InputMaybe<TixOrderBy>;
  slug?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventInstanceMinFields = {
  __typename?: 'EventInstance_min_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  eventAdmins?: Maybe<Array<Scalars['uuid']>>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  minimumAge?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** used for private events */
  passcode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event.event_instance" */
export type TixEventInstanceMinOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventAdmins?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  minimumAge?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  /** used for private events */
  passcode?: InputMaybe<TixOrderBy>;
  slug?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "event.event_instance" */
export type TixEventInstanceMutationResponse = {
  __typename?: 'EventInstance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventInstance>;
};

/** input type for inserting object relation for remote table "event.event_instance" */
export type TixEventInstanceObjRelInsertInput = {
  data: TixEventInstanceInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventInstanceOnConflict>;
};

/** on_conflict condition type for table "event.event_instance" */
export type TixEventInstanceOnConflict = {
  constraint: TixEventInstanceConstraint;
  update_columns?: Array<TixEventInstanceUpdateColumn>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};

/** Ordering options when selecting data from "event.event_instance". */
export type TixEventInstanceOrderBy = {
  DiscountCodeCount_aggregate?: InputMaybe<TixDiscountCodeCountByEventAggregateOrderBy>;
  EventTicketCount_aggregate?: InputMaybe<TixTicketCountByEventAggregateOrderBy>;
  Refunds_aggregate?: InputMaybe<TixReportingVRefundsByEventAggregateOrderBy>;
  RevenueByChannelType_aggregate?: InputMaybe<TixRevenueByChannelTypeAggregateOrderBy>;
  additionalInfo?: InputMaybe<TixOrderBy>;
  campaign_aggregate?: InputMaybe<TixEventCampaignTrackingAggregateOrderBy>;
  configurationItems_aggregate?: InputMaybe<TixEventInstanceConfigurationValueAggregateOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  discounts_aggregate?: InputMaybe<TixEventInstanceDiscountAggregateOrderBy>;
  doorsOpen?: InputMaybe<TixOrderBy>;
  endTime?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventOrderBy>;
  eventAdmins?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventInstanceTickets_aggregate?: InputMaybe<TixEventInstanceTicketAggregateOrderBy>;
  eventPerformers_aggregate?: InputMaybe<TixEventPerformersAggregateOrderBy>;
  eventProduct_aggregate?: InputMaybe<TixEventProductAggregateOrderBy>;
  eventTicketSalesMetrics?: InputMaybe<TixTicketVTicketSalesMetricsOrderBy>;
  flatFee?: InputMaybe<TixOrderBy>;
  hidden?: InputMaybe<TixOrderBy>;
  media_aggregate?: InputMaybe<TixEventInstanceMedialFileAggregateOrderBy>;
  minimumAge?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  overridden?: InputMaybe<TixOrderBy>;
  passcode?: InputMaybe<TixOrderBy>;
  payout?: InputMaybe<TixPayoutOrderBy>;
  reservations_aggregate?: InputMaybe<TixTicketReservationAggregateOrderBy>;
  slug?: InputMaybe<TixOrderBy>;
  socialMedia_aggregate?: InputMaybe<TixEventInstanceSocialMediaFileAggregateOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  startSellingTime?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  stopSellingTime?: InputMaybe<TixOrderBy>;
  ticketCount_aggregate?: InputMaybe<TixTicketCountByEventAggregateOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: event.event_instance */
export type TixEventInstancePkColumnsInput = {
  eventInstanceId: Scalars['uuid'];
};

/** select columns of table "event.event_instance" */
export enum TixEventInstanceSelectColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  DoorsOpen = 'doorsOpen',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EventAdmins = 'eventAdmins',
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  FlatFee = 'flatFee',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  Name = 'name',
  /** column name */
  Overridden = 'overridden',
  /** column name */
  Passcode = 'passcode',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  State = 'state',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueTicketId = 'venueTicketId'
}

/** select "EventInstance_aggregate_bool_exp_bool_and_arguments_columns" columns of table "event.event_instance" */
export enum TixEventInstanceSelectColumnEventInstanceAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  FlatFee = 'flatFee',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Overridden = 'overridden'
}

/** select "EventInstance_aggregate_bool_exp_bool_or_arguments_columns" columns of table "event.event_instance" */
export enum TixEventInstanceSelectColumnEventInstanceAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  FlatFee = 'flatFee',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Overridden = 'overridden'
}

/** input type for updating data in table "event.event_instance" */
export type TixEventInstanceSetInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  eventAdmins?: InputMaybe<Array<Scalars['uuid']>>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  flatFee?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  /** used for private events */
  passcode?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  startTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixEventInstanceStddevFields = {
  __typename?: 'EventInstance_stddev_fields';
  minimumAge?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event.event_instance" */
export type TixEventInstanceStddevOrderBy = {
  minimumAge?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixEventInstanceStddevPopFields = {
  __typename?: 'EventInstance_stddev_pop_fields';
  minimumAge?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event.event_instance" */
export type TixEventInstanceStddevPopOrderBy = {
  minimumAge?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixEventInstanceStddevSampFields = {
  __typename?: 'EventInstance_stddev_samp_fields';
  minimumAge?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event.event_instance" */
export type TixEventInstanceStddevSampOrderBy = {
  minimumAge?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "EventInstance" */
export type TixEventInstanceStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventInstanceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventInstanceStreamCursorValueInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  eventAdmins?: InputMaybe<Array<Scalars['uuid']>>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  flatFee?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  /** used for private events */
  passcode?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  startTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixEventInstanceSumFields = {
  __typename?: 'EventInstance_sum_fields';
  minimumAge?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event.event_instance" */
export type TixEventInstanceSumOrderBy = {
  minimumAge?: InputMaybe<TixOrderBy>;
};

/** update columns of table "event.event_instance" */
export enum TixEventInstanceUpdateColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  DoorsOpen = 'doorsOpen',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EventAdmins = 'eventAdmins',
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  FlatFee = 'flatFee',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  Name = 'name',
  /** column name */
  Overridden = 'overridden',
  /** column name */
  Passcode = 'passcode',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  State = 'state',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueTicketId = 'venueTicketId'
}

export type TixEventInstanceUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixEventInstanceIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventInstanceSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventInstanceBoolExp;
};

/** aggregate var_pop on columns */
export type TixEventInstanceVarPopFields = {
  __typename?: 'EventInstance_var_pop_fields';
  minimumAge?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event.event_instance" */
export type TixEventInstanceVarPopOrderBy = {
  minimumAge?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixEventInstanceVarSampFields = {
  __typename?: 'EventInstance_var_samp_fields';
  minimumAge?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event.event_instance" */
export type TixEventInstanceVarSampOrderBy = {
  minimumAge?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixEventInstanceVarianceFields = {
  __typename?: 'EventInstance_variance_fields';
  minimumAge?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event.event_instance" */
export type TixEventInstanceVarianceOrderBy = {
  minimumAge?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "performer.event_lineup" */
export type TixEventLineup = {
  __typename?: 'EventLineup';
  additionalInfo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  eventInstance?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  event_lineup_id: Scalars['uuid'];
  /** An object relationship */
  lineup?: Maybe<TixLineup>;
  lineupId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  overridden?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "performer.event_lineup" */
export type TixEventLineupAggregate = {
  __typename?: 'EventLineup_aggregate';
  aggregate?: Maybe<TixEventLineupAggregateFields>;
  nodes: Array<TixEventLineup>;
};

/** aggregate fields of "performer.event_lineup" */
export type TixEventLineupAggregateFields = {
  __typename?: 'EventLineup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventLineupMaxFields>;
  min?: Maybe<TixEventLineupMinFields>;
};


/** aggregate fields of "performer.event_lineup" */
export type TixEventLineupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventLineupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "performer.event_lineup". All fields are combined with a logical 'AND'. */
export type TixEventLineupBoolExp = {
  _and?: InputMaybe<Array<TixEventLineupBoolExp>>;
  _not?: InputMaybe<TixEventLineupBoolExp>;
  _or?: InputMaybe<Array<TixEventLineupBoolExp>>;
  additionalInfo?: InputMaybe<TixStringComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  eventId?: InputMaybe<TixUuidComparisonExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  event_lineup_id?: InputMaybe<TixUuidComparisonExp>;
  lineup?: InputMaybe<TixLineupBoolExp>;
  lineupId?: InputMaybe<TixUuidComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  overridden?: InputMaybe<TixBooleanComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "performer.event_lineup" */
export enum TixEventLineupConstraint {
  /** unique or primary key constraint on columns "event_lineup_id" */
  EventLineupPkey = 'event_lineup_pkey'
}

/** input type for inserting data into table "performer.event_lineup" */
export type TixEventLineupInsertInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  event_lineup_id?: InputMaybe<Scalars['uuid']>;
  lineup?: InputMaybe<TixLineupObjRelInsertInput>;
  lineupId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventLineupMaxFields = {
  __typename?: 'EventLineup_max_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  event_lineup_id?: Maybe<Scalars['uuid']>;
  lineupId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixEventLineupMinFields = {
  __typename?: 'EventLineup_min_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  event_lineup_id?: Maybe<Scalars['uuid']>;
  lineupId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "performer.event_lineup" */
export type TixEventLineupMutationResponse = {
  __typename?: 'EventLineup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventLineup>;
};

/** on_conflict condition type for table "performer.event_lineup" */
export type TixEventLineupOnConflict = {
  constraint: TixEventLineupConstraint;
  update_columns?: Array<TixEventLineupUpdateColumn>;
  where?: InputMaybe<TixEventLineupBoolExp>;
};

/** Ordering options when selecting data from "performer.event_lineup". */
export type TixEventLineupOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  event_lineup_id?: InputMaybe<TixOrderBy>;
  lineup?: InputMaybe<TixLineupOrderBy>;
  lineupId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  overridden?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: performer.event_lineup */
export type TixEventLineupPkColumnsInput = {
  event_lineup_id: Scalars['uuid'];
};

/** select columns of table "performer.event_lineup" */
export enum TixEventLineupSelectColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  Description = 'description',
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventLineupId = 'event_lineup_id',
  /** column name */
  LineupId = 'lineupId',
  /** column name */
  Name = 'name',
  /** column name */
  Overridden = 'overridden',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "performer.event_lineup" */
export type TixEventLineupSetInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  event_lineup_id?: InputMaybe<Scalars['uuid']>;
  lineupId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventLineup" */
export type TixEventLineupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventLineupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventLineupStreamCursorValueInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  event_lineup_id?: InputMaybe<Scalars['uuid']>;
  lineupId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "performer.event_lineup" */
export enum TixEventLineupUpdateColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  Description = 'description',
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventLineupId = 'event_lineup_id',
  /** column name */
  LineupId = 'lineupId',
  /** column name */
  Name = 'name',
  /** column name */
  Overridden = 'overridden',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventLineupUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventLineupSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventLineupBoolExp;
};

/** columns and relationships of "event.v_event_list" */
export type TixEventList = {
  __typename?: 'EventList';
  /** An array relationship */
  Performers: Array<TixEventPerformers>;
  /** An aggregate relationship */
  Performers_aggregate: TixEventPerformersAggregate;
  /** An array relationship */
  Tickets: Array<TixVenueTicket>;
  /** An aggregate relationship */
  Tickets_aggregate: TixVenueTicketAggregate;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  doorsOpen?: Maybe<Scalars['time']>;
  endTime?: Maybe<Scalars['time']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  hidden?: Maybe<Scalars['Boolean']>;
  mainEventName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  overridden?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  startSellingTime?: Maybe<Scalars['time']>;
  startTime?: Maybe<Scalars['time']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  stopSellingTime?: Maybe<Scalars['time']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};


/** columns and relationships of "event.v_event_list" */
export type TixEventListPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** columns and relationships of "event.v_event_list" */
export type TixEventListPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** columns and relationships of "event.v_event_list" */
export type TixEventListTicketsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


/** columns and relationships of "event.v_event_list" */
export type TixEventListTicketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};

/** aggregated selection of "event.v_event_list" */
export type TixEventListAggregate = {
  __typename?: 'EventList_aggregate';
  aggregate?: Maybe<TixEventListAggregateFields>;
  nodes: Array<TixEventList>;
};

/** aggregate fields of "event.v_event_list" */
export type TixEventListAggregateFields = {
  __typename?: 'EventList_aggregate_fields';
  avg?: Maybe<TixEventListAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixEventListMaxFields>;
  min?: Maybe<TixEventListMinFields>;
  stddev?: Maybe<TixEventListStddevFields>;
  stddev_pop?: Maybe<TixEventListStddevPopFields>;
  stddev_samp?: Maybe<TixEventListStddevSampFields>;
  sum?: Maybe<TixEventListSumFields>;
  var_pop?: Maybe<TixEventListVarPopFields>;
  var_samp?: Maybe<TixEventListVarSampFields>;
  variance?: Maybe<TixEventListVarianceFields>;
};


/** aggregate fields of "event.v_event_list" */
export type TixEventListAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventListSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixEventListAvgFields = {
  __typename?: 'EventList_avg_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event.v_event_list". All fields are combined with a logical 'AND'. */
export type TixEventListBoolExp = {
  Performers?: InputMaybe<TixEventPerformersBoolExp>;
  Performers_aggregate?: InputMaybe<TixEventPerformersAggregateBoolExp>;
  Tickets?: InputMaybe<TixVenueTicketBoolExp>;
  Tickets_aggregate?: InputMaybe<TixVenueTicketAggregateBoolExp>;
  _and?: InputMaybe<Array<TixEventListBoolExp>>;
  _not?: InputMaybe<TixEventListBoolExp>;
  _or?: InputMaybe<Array<TixEventListBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  date?: InputMaybe<TixStringComparisonExp>;
  day?: InputMaybe<TixFloat8ComparisonExp>;
  doorsOpen?: InputMaybe<TixTimeComparisonExp>;
  endTime?: InputMaybe<TixTimeComparisonExp>;
  eventAdditionalInfo?: InputMaybe<TixStringComparisonExp>;
  eventDescription?: InputMaybe<TixStringComparisonExp>;
  eventId?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventPasscode?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  eventType?: InputMaybe<TixStringComparisonExp>;
  filterDate?: InputMaybe<TixDateComparisonExp>;
  hidden?: InputMaybe<TixBooleanComparisonExp>;
  mainEventName?: InputMaybe<TixStringComparisonExp>;
  minimumAge?: InputMaybe<TixIntComparisonExp>;
  month?: InputMaybe<TixFloat8ComparisonExp>;
  overridden?: InputMaybe<TixBooleanComparisonExp>;
  search?: InputMaybe<TixStringComparisonExp>;
  startSellingDate?: InputMaybe<TixDateComparisonExp>;
  startSellingTime?: InputMaybe<TixTimeComparisonExp>;
  startTime?: InputMaybe<TixTimeComparisonExp>;
  stopSellingDate?: InputMaybe<TixDateComparisonExp>;
  stopSellingTime?: InputMaybe<TixTimeComparisonExp>;
  venueCity?: InputMaybe<TixStringComparisonExp>;
  venueCityStateProvince?: InputMaybe<TixStringComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  venueStateProvince?: InputMaybe<TixStringComparisonExp>;
  venueTicketId?: InputMaybe<TixUuidComparisonExp>;
  year?: InputMaybe<TixFloat8ComparisonExp>;
};

/** aggregate max on columns */
export type TixEventListMaxFields = {
  __typename?: 'EventList_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  mainEventName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  search?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type TixEventListMinFields = {
  __typename?: 'EventList_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  mainEventName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  search?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};

/** Ordering options when selecting data from "event.v_event_list". */
export type TixEventListOrderBy = {
  Performers_aggregate?: InputMaybe<TixEventPerformersAggregateOrderBy>;
  Tickets_aggregate?: InputMaybe<TixVenueTicketAggregateOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  day?: InputMaybe<TixOrderBy>;
  doorsOpen?: InputMaybe<TixOrderBy>;
  endTime?: InputMaybe<TixOrderBy>;
  eventAdditionalInfo?: InputMaybe<TixOrderBy>;
  eventDescription?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventPasscode?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  filterDate?: InputMaybe<TixOrderBy>;
  hidden?: InputMaybe<TixOrderBy>;
  mainEventName?: InputMaybe<TixOrderBy>;
  minimumAge?: InputMaybe<TixOrderBy>;
  month?: InputMaybe<TixOrderBy>;
  overridden?: InputMaybe<TixOrderBy>;
  search?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  startSellingTime?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  stopSellingTime?: InputMaybe<TixOrderBy>;
  venueCity?: InputMaybe<TixOrderBy>;
  venueCityStateProvince?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueStateProvince?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
  year?: InputMaybe<TixOrderBy>;
};

/** select columns of table "event.v_event_list" */
export enum TixEventListSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  DoorsOpen = 'doorsOpen',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EventAdditionalInfo = 'eventAdditionalInfo',
  /** column name */
  EventDescription = 'eventDescription',
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventPasscode = 'eventPasscode',
  /** column name */
  EventState = 'eventState',
  /** column name */
  EventType = 'eventType',
  /** column name */
  FilterDate = 'filterDate',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  MainEventName = 'mainEventName',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  Month = 'month',
  /** column name */
  Overridden = 'overridden',
  /** column name */
  Search = 'search',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  VenueCity = 'venueCity',
  /** column name */
  VenueCityStateProvince = 'venueCityStateProvince',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  VenueStateProvince = 'venueStateProvince',
  /** column name */
  VenueTicketId = 'venueTicketId',
  /** column name */
  Year = 'year'
}

/** aggregate stddev on columns */
export type TixEventListStddevFields = {
  __typename?: 'EventList_stddev_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixEventListStddevPopFields = {
  __typename?: 'EventList_stddev_pop_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixEventListStddevSampFields = {
  __typename?: 'EventList_stddev_samp_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "EventList" */
export type TixEventListStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventListStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventListStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  day?: InputMaybe<Scalars['float8']>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  eventAdditionalInfo?: InputMaybe<Scalars['String']>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPasscode?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  filterDate?: InputMaybe<Scalars['date']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  mainEventName?: InputMaybe<Scalars['String']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['float8']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  startTime?: InputMaybe<Scalars['time']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  venueCity?: InputMaybe<Scalars['String']>;
  venueCityStateProvince?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  venueStateProvince?: InputMaybe<Scalars['String']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
  year?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type TixEventListSumFields = {
  __typename?: 'EventList_sum_fields';
  day?: Maybe<Scalars['float8']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type TixEventListVarPopFields = {
  __typename?: 'EventList_var_pop_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixEventListVarSampFields = {
  __typename?: 'EventList_var_samp_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixEventListVarianceFields = {
  __typename?: 'EventList_variance_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "performer.event_performers" */
export type TixEventPerformers = {
  __typename?: 'EventPerformers';
  /** An object relationship */
  Performer?: Maybe<TixPerformer>;
  /** An array relationship */
  Performers: Array<TixPerformer>;
  /** An aggregate relationship */
  Performers_aggregate: TixPerformerAggregate;
  eventInstanceId: Scalars['uuid'];
  eventPerformerId: Scalars['uuid'];
  performerId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "performer.event_performers" */
export type TixEventPerformersPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPerformerOrderBy>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};


/** columns and relationships of "performer.event_performers" */
export type TixEventPerformersPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPerformerOrderBy>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};

/** aggregated selection of "performer.event_performers" */
export type TixEventPerformersAggregate = {
  __typename?: 'EventPerformers_aggregate';
  aggregate?: Maybe<TixEventPerformersAggregateFields>;
  nodes: Array<TixEventPerformers>;
};

export type TixEventPerformersAggregateBoolExp = {
  count?: InputMaybe<TixEventPerformersAggregateBoolExpCount>;
};

export type TixEventPerformersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventPerformersBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "performer.event_performers" */
export type TixEventPerformersAggregateFields = {
  __typename?: 'EventPerformers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventPerformersMaxFields>;
  min?: Maybe<TixEventPerformersMinFields>;
};


/** aggregate fields of "performer.event_performers" */
export type TixEventPerformersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "performer.event_performers" */
export type TixEventPerformersAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventPerformersMaxOrderBy>;
  min?: InputMaybe<TixEventPerformersMinOrderBy>;
};

/** input type for inserting array relation for remote table "performer.event_performers" */
export type TixEventPerformersArrRelInsertInput = {
  data: Array<TixEventPerformersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventPerformersOnConflict>;
};

/** Boolean expression to filter rows from the table "performer.event_performers". All fields are combined with a logical 'AND'. */
export type TixEventPerformersBoolExp = {
  Performer?: InputMaybe<TixPerformerBoolExp>;
  Performers?: InputMaybe<TixPerformerBoolExp>;
  Performers_aggregate?: InputMaybe<TixPerformerAggregateBoolExp>;
  _and?: InputMaybe<Array<TixEventPerformersBoolExp>>;
  _not?: InputMaybe<TixEventPerformersBoolExp>;
  _or?: InputMaybe<Array<TixEventPerformersBoolExp>>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventPerformerId?: InputMaybe<TixUuidComparisonExp>;
  performerId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "performer.event_performers" */
export enum TixEventPerformersConstraint {
  /** unique or primary key constraint on columns "event_performer_id" */
  EventPerformersPkey = 'event_performers_pkey'
}

/** input type for inserting data into table "performer.event_performers" */
export type TixEventPerformersInsertInput = {
  Performer?: InputMaybe<TixPerformerObjRelInsertInput>;
  Performers?: InputMaybe<TixPerformerArrRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventPerformerId?: InputMaybe<Scalars['uuid']>;
  performerId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventPerformersMaxFields = {
  __typename?: 'EventPerformers_max_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventPerformerId?: Maybe<Scalars['uuid']>;
  performerId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "performer.event_performers" */
export type TixEventPerformersMaxOrderBy = {
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventPerformerId?: InputMaybe<TixOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventPerformersMinFields = {
  __typename?: 'EventPerformers_min_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventPerformerId?: Maybe<Scalars['uuid']>;
  performerId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "performer.event_performers" */
export type TixEventPerformersMinOrderBy = {
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventPerformerId?: InputMaybe<TixOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "performer.event_performers" */
export type TixEventPerformersMutationResponse = {
  __typename?: 'EventPerformers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventPerformers>;
};

/** on_conflict condition type for table "performer.event_performers" */
export type TixEventPerformersOnConflict = {
  constraint: TixEventPerformersConstraint;
  update_columns?: Array<TixEventPerformersUpdateColumn>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};

/** Ordering options when selecting data from "performer.event_performers". */
export type TixEventPerformersOrderBy = {
  Performer?: InputMaybe<TixPerformerOrderBy>;
  Performers_aggregate?: InputMaybe<TixPerformerAggregateOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventPerformerId?: InputMaybe<TixOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: performer.event_performers */
export type TixEventPerformersPkColumnsInput = {
  eventPerformerId: Scalars['uuid'];
};

/** select columns of table "performer.event_performers" */
export enum TixEventPerformersSelectColumn {
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventPerformerId = 'eventPerformerId',
  /** column name */
  PerformerId = 'performerId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "performer.event_performers" */
export type TixEventPerformersSetInput = {
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventPerformerId?: InputMaybe<Scalars['uuid']>;
  performerId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventPerformers" */
export type TixEventPerformersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventPerformersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventPerformersStreamCursorValueInput = {
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventPerformerId?: InputMaybe<Scalars['uuid']>;
  performerId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "performer.event_performers" */
export enum TixEventPerformersUpdateColumn {
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventPerformerId = 'eventPerformerId',
  /** column name */
  PerformerId = 'performerId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventPerformersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventPerformersSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventPerformersBoolExp;
};

/** columns and relationships of "product.event_product" */
export type TixEventProduct = {
  __typename?: 'EventProduct';
  /** An array relationship */
  EventProductMedia: Array<TixEventProductMedia>;
  /** An aggregate relationship */
  EventProductMedia_aggregate: TixEventProductMediaAggregate;
  additionalInfo?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId: Scalars['uuid'];
  eventProductId: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['money']>;
  productId: Scalars['uuid'];
  /** An array relationship */
  productevent: Array<TixEventProduct>;
  /** An aggregate relationship */
  productevent_aggregate: TixEventProductAggregate;
  quantity?: Maybe<Scalars['Int']>;
  quantityRemaining?: Maybe<Scalars['Int']>;
  quantitySold?: Maybe<Scalars['Int']>;
  salesChannel?: Maybe<Scalars['String']>;
  startSelling?: Maybe<Scalars['timestamp']>;
  startSellingDate?: Maybe<Scalars['date']>;
  startSellingTime?: Maybe<Scalars['time']>;
  state: Scalars['String'];
  stopSelling?: Maybe<Scalars['timestamp']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  stopSellingTime?: Maybe<Scalars['time']>;
  tax?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  use_global_inventory: Scalars['Boolean'];
};


/** columns and relationships of "product.event_product" */
export type TixEventProductEventProductMediaArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductMediaOrderBy>>;
  where?: InputMaybe<TixEventProductMediaBoolExp>;
};


/** columns and relationships of "product.event_product" */
export type TixEventProductEventProductMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductMediaOrderBy>>;
  where?: InputMaybe<TixEventProductMediaBoolExp>;
};


/** columns and relationships of "product.event_product" */
export type TixEventProductProducteventArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductOrderBy>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};


/** columns and relationships of "product.event_product" */
export type TixEventProductProducteventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductOrderBy>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};

/** columns and relationships of "media.event_product_media_file" */
export type TixEventProductMedia = {
  __typename?: 'EventProductMedia';
  /** An object relationship */
  EventProduct?: Maybe<TixEventProduct>;
  /** An object relationship */
  MediaFile?: Maybe<TixMediaFile>;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  eventProductId: Scalars['uuid'];
  eventProductMediaImageFileId: Scalars['uuid'];
  mediaFileId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "media.event_product_media_file" */
export type TixEventProductMediaAggregate = {
  __typename?: 'EventProductMedia_aggregate';
  aggregate?: Maybe<TixEventProductMediaAggregateFields>;
  nodes: Array<TixEventProductMedia>;
};

export type TixEventProductMediaAggregateBoolExp = {
  count?: InputMaybe<TixEventProductMediaAggregateBoolExpCount>;
};

export type TixEventProductMediaAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventProductMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventProductMediaBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "media.event_product_media_file" */
export type TixEventProductMediaAggregateFields = {
  __typename?: 'EventProductMedia_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventProductMediaMaxFields>;
  min?: Maybe<TixEventProductMediaMinFields>;
};


/** aggregate fields of "media.event_product_media_file" */
export type TixEventProductMediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventProductMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media.event_product_media_file" */
export type TixEventProductMediaAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventProductMediaMaxOrderBy>;
  min?: InputMaybe<TixEventProductMediaMinOrderBy>;
};

/** input type for inserting array relation for remote table "media.event_product_media_file" */
export type TixEventProductMediaArrRelInsertInput = {
  data: Array<TixEventProductMediaInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventProductMediaOnConflict>;
};

/** Boolean expression to filter rows from the table "media.event_product_media_file". All fields are combined with a logical 'AND'. */
export type TixEventProductMediaBoolExp = {
  EventProduct?: InputMaybe<TixEventProductBoolExp>;
  MediaFile?: InputMaybe<TixMediaFileBoolExp>;
  _and?: InputMaybe<Array<TixEventProductMediaBoolExp>>;
  _not?: InputMaybe<TixEventProductMediaBoolExp>;
  _or?: InputMaybe<Array<TixEventProductMediaBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  eventProductId?: InputMaybe<TixUuidComparisonExp>;
  eventProductMediaImageFileId?: InputMaybe<TixUuidComparisonExp>;
  mediaFileId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "media.event_product_media_file" */
export enum TixEventProductMediaConstraint {
  /** unique or primary key constraint on columns "event_product_media_image_file_id" */
  EventProductMediaFilePkey = 'event_product_media_file_pkey'
}

/** input type for inserting data into table "media.event_product_media_file" */
export type TixEventProductMediaInsertInput = {
  EventProduct?: InputMaybe<TixEventProductObjRelInsertInput>;
  MediaFile?: InputMaybe<TixMediaFileObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  eventProductMediaImageFileId?: InputMaybe<Scalars['uuid']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventProductMediaMaxFields = {
  __typename?: 'EventProductMedia_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventProductId?: Maybe<Scalars['uuid']>;
  eventProductMediaImageFileId?: Maybe<Scalars['uuid']>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "media.event_product_media_file" */
export type TixEventProductMediaMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  eventProductMediaImageFileId?: InputMaybe<TixOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventProductMediaMinFields = {
  __typename?: 'EventProductMedia_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventProductId?: Maybe<Scalars['uuid']>;
  eventProductMediaImageFileId?: Maybe<Scalars['uuid']>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "media.event_product_media_file" */
export type TixEventProductMediaMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  eventProductMediaImageFileId?: InputMaybe<TixOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "media.event_product_media_file" */
export type TixEventProductMediaMutationResponse = {
  __typename?: 'EventProductMedia_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventProductMedia>;
};

/** input type for inserting object relation for remote table "media.event_product_media_file" */
export type TixEventProductMediaObjRelInsertInput = {
  data: TixEventProductMediaInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventProductMediaOnConflict>;
};

/** on_conflict condition type for table "media.event_product_media_file" */
export type TixEventProductMediaOnConflict = {
  constraint: TixEventProductMediaConstraint;
  update_columns?: Array<TixEventProductMediaUpdateColumn>;
  where?: InputMaybe<TixEventProductMediaBoolExp>;
};

/** Ordering options when selecting data from "media.event_product_media_file". */
export type TixEventProductMediaOrderBy = {
  EventProduct?: InputMaybe<TixEventProductOrderBy>;
  MediaFile?: InputMaybe<TixMediaFileOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  eventProductMediaImageFileId?: InputMaybe<TixOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: media.event_product_media_file */
export type TixEventProductMediaPkColumnsInput = {
  eventProductMediaImageFileId: Scalars['uuid'];
};

/** select columns of table "media.event_product_media_file" */
export enum TixEventProductMediaSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventProductId = 'eventProductId',
  /** column name */
  EventProductMediaImageFileId = 'eventProductMediaImageFileId',
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "media.event_product_media_file" */
export type TixEventProductMediaSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  eventProductMediaImageFileId?: InputMaybe<Scalars['uuid']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventProductMedia" */
export type TixEventProductMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventProductMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventProductMediaStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  eventProductMediaImageFileId?: InputMaybe<Scalars['uuid']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.event_product_media_file" */
export enum TixEventProductMediaUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventProductId = 'eventProductId',
  /** column name */
  EventProductMediaImageFileId = 'eventProductMediaImageFileId',
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventProductMediaUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventProductMediaSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventProductMediaBoolExp;
};

/** aggregated selection of "product.event_product" */
export type TixEventProductAggregate = {
  __typename?: 'EventProduct_aggregate';
  aggregate?: Maybe<TixEventProductAggregateFields>;
  nodes: Array<TixEventProduct>;
};

export type TixEventProductAggregateBoolExp = {
  bool_and?: InputMaybe<TixEventProductAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixEventProductAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixEventProductAggregateBoolExpCount>;
};

export type TixEventProductAggregateBoolExpBoolAnd = {
  arguments: TixEventProductSelectColumnEventProductAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventProductBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixEventProductAggregateBoolExpBoolOr = {
  arguments: TixEventProductSelectColumnEventProductAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventProductBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixEventProductAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventProductBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "product.event_product" */
export type TixEventProductAggregateFields = {
  __typename?: 'EventProduct_aggregate_fields';
  avg?: Maybe<TixEventProductAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixEventProductMaxFields>;
  min?: Maybe<TixEventProductMinFields>;
  stddev?: Maybe<TixEventProductStddevFields>;
  stddev_pop?: Maybe<TixEventProductStddevPopFields>;
  stddev_samp?: Maybe<TixEventProductStddevSampFields>;
  sum?: Maybe<TixEventProductSumFields>;
  var_pop?: Maybe<TixEventProductVarPopFields>;
  var_samp?: Maybe<TixEventProductVarSampFields>;
  variance?: Maybe<TixEventProductVarianceFields>;
};


/** aggregate fields of "product.event_product" */
export type TixEventProductAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product.event_product" */
export type TixEventProductAggregateOrderBy = {
  avg?: InputMaybe<TixEventProductAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventProductMaxOrderBy>;
  min?: InputMaybe<TixEventProductMinOrderBy>;
  stddev?: InputMaybe<TixEventProductStddevOrderBy>;
  stddev_pop?: InputMaybe<TixEventProductStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixEventProductStddevSampOrderBy>;
  sum?: InputMaybe<TixEventProductSumOrderBy>;
  var_pop?: InputMaybe<TixEventProductVarPopOrderBy>;
  var_samp?: InputMaybe<TixEventProductVarSampOrderBy>;
  variance?: InputMaybe<TixEventProductVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "product.event_product" */
export type TixEventProductArrRelInsertInput = {
  data: Array<TixEventProductInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventProductOnConflict>;
};

/** aggregate avg on columns */
export type TixEventProductAvgFields = {
  __typename?: 'EventProduct_avg_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityRemaining?: Maybe<Scalars['Float']>;
  quantitySold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product.event_product" */
export type TixEventProductAvgOrderBy = {
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "product.event_product". All fields are combined with a logical 'AND'. */
export type TixEventProductBoolExp = {
  EventProductMedia?: InputMaybe<TixEventProductMediaBoolExp>;
  EventProductMedia_aggregate?: InputMaybe<TixEventProductMediaAggregateBoolExp>;
  _and?: InputMaybe<Array<TixEventProductBoolExp>>;
  _not?: InputMaybe<TixEventProductBoolExp>;
  _or?: InputMaybe<Array<TixEventProductBoolExp>>;
  additionalInfo?: InputMaybe<TixStringComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventProductId?: InputMaybe<TixUuidComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  price?: InputMaybe<TixMoneyComparisonExp>;
  productId?: InputMaybe<TixUuidComparisonExp>;
  productevent?: InputMaybe<TixEventProductBoolExp>;
  productevent_aggregate?: InputMaybe<TixEventProductAggregateBoolExp>;
  quantity?: InputMaybe<TixIntComparisonExp>;
  quantityRemaining?: InputMaybe<TixIntComparisonExp>;
  quantitySold?: InputMaybe<TixIntComparisonExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  startSelling?: InputMaybe<TixTimestampComparisonExp>;
  startSellingDate?: InputMaybe<TixDateComparisonExp>;
  startSellingTime?: InputMaybe<TixTimeComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  stopSelling?: InputMaybe<TixTimestampComparisonExp>;
  stopSellingDate?: InputMaybe<TixDateComparisonExp>;
  stopSellingTime?: InputMaybe<TixTimeComparisonExp>;
  tax?: InputMaybe<TixNumericComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  use_global_inventory?: InputMaybe<TixBooleanComparisonExp>;
};

/** unique or primary key constraints on table "product.event_product" */
export enum TixEventProductConstraint {
  /** unique or primary key constraint on columns "event_product_id" */
  EventProductPkey = 'event_product_pkey'
}

/** input type for incrementing numeric columns in table "product.event_product" */
export type TixEventProductIncInput = {
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityRemaining?: InputMaybe<Scalars['Int']>;
  quantitySold?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "product.event_product" */
export type TixEventProductInsertInput = {
  EventProductMedia?: InputMaybe<TixEventProductMediaArrRelInsertInput>;
  additionalInfo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['money']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productevent?: InputMaybe<TixEventProductArrRelInsertInput>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityRemaining?: InputMaybe<Scalars['Int']>;
  quantitySold?: InputMaybe<Scalars['Int']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  startSelling?: InputMaybe<Scalars['timestamp']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSelling?: InputMaybe<Scalars['timestamp']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  tax?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  use_global_inventory?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type TixEventProductMaxFields = {
  __typename?: 'EventProduct_max_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventProductId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['money']>;
  productId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityRemaining?: Maybe<Scalars['Int']>;
  quantitySold?: Maybe<Scalars['Int']>;
  salesChannel?: Maybe<Scalars['String']>;
  startSelling?: Maybe<Scalars['timestamp']>;
  startSellingDate?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  stopSelling?: Maybe<Scalars['timestamp']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  tax?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product.event_product" */
export type TixEventProductMaxOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  startSelling?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stopSelling?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventProductMinFields = {
  __typename?: 'EventProduct_min_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventProductId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['money']>;
  productId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityRemaining?: Maybe<Scalars['Int']>;
  quantitySold?: Maybe<Scalars['Int']>;
  salesChannel?: Maybe<Scalars['String']>;
  startSelling?: Maybe<Scalars['timestamp']>;
  startSellingDate?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  stopSelling?: Maybe<Scalars['timestamp']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  tax?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product.event_product" */
export type TixEventProductMinOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  startSelling?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stopSelling?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "product.event_product" */
export type TixEventProductMutationResponse = {
  __typename?: 'EventProduct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventProduct>;
};

/** input type for inserting object relation for remote table "product.event_product" */
export type TixEventProductObjRelInsertInput = {
  data: TixEventProductInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventProductOnConflict>;
};

/** on_conflict condition type for table "product.event_product" */
export type TixEventProductOnConflict = {
  constraint: TixEventProductConstraint;
  update_columns?: Array<TixEventProductUpdateColumn>;
  where?: InputMaybe<TixEventProductBoolExp>;
};

/** Ordering options when selecting data from "product.event_product". */
export type TixEventProductOrderBy = {
  EventProductMedia_aggregate?: InputMaybe<TixEventProductMediaAggregateOrderBy>;
  additionalInfo?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  productevent_aggregate?: InputMaybe<TixEventProductAggregateOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  startSelling?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  startSellingTime?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stopSelling?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  stopSellingTime?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  use_global_inventory?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: product.event_product */
export type TixEventProductPkColumnsInput = {
  eventProductId: Scalars['uuid'];
};

/** select columns of table "product.event_product" */
export enum TixEventProductSelectColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventProductId = 'eventProductId',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityRemaining = 'quantityRemaining',
  /** column name */
  QuantitySold = 'quantitySold',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  StartSelling = 'startSelling',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  State = 'state',
  /** column name */
  StopSelling = 'stopSelling',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  Tax = 'tax',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UseGlobalInventory = 'use_global_inventory'
}

/** select "EventProduct_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product.event_product" */
export enum TixEventProductSelectColumnEventProductAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  UseGlobalInventory = 'use_global_inventory'
}

/** select "EventProduct_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product.event_product" */
export enum TixEventProductSelectColumnEventProductAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  UseGlobalInventory = 'use_global_inventory'
}

/** input type for updating data in table "product.event_product" */
export type TixEventProductSetInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['money']>;
  productId?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityRemaining?: InputMaybe<Scalars['Int']>;
  quantitySold?: InputMaybe<Scalars['Int']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  startSelling?: InputMaybe<Scalars['timestamp']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSelling?: InputMaybe<Scalars['timestamp']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  tax?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  use_global_inventory?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type TixEventProductStddevFields = {
  __typename?: 'EventProduct_stddev_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityRemaining?: Maybe<Scalars['Float']>;
  quantitySold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product.event_product" */
export type TixEventProductStddevOrderBy = {
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixEventProductStddevPopFields = {
  __typename?: 'EventProduct_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityRemaining?: Maybe<Scalars['Float']>;
  quantitySold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product.event_product" */
export type TixEventProductStddevPopOrderBy = {
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixEventProductStddevSampFields = {
  __typename?: 'EventProduct_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityRemaining?: Maybe<Scalars['Float']>;
  quantitySold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product.event_product" */
export type TixEventProductStddevSampOrderBy = {
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "EventProduct" */
export type TixEventProductStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventProductStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventProductStreamCursorValueInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['money']>;
  productId?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityRemaining?: InputMaybe<Scalars['Int']>;
  quantitySold?: InputMaybe<Scalars['Int']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  startSelling?: InputMaybe<Scalars['timestamp']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSelling?: InputMaybe<Scalars['timestamp']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  tax?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  use_global_inventory?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type TixEventProductSumFields = {
  __typename?: 'EventProduct_sum_fields';
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityRemaining?: Maybe<Scalars['Int']>;
  quantitySold?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "product.event_product" */
export type TixEventProductSumOrderBy = {
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
};

/** update columns of table "product.event_product" */
export enum TixEventProductUpdateColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventProductId = 'eventProductId',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityRemaining = 'quantityRemaining',
  /** column name */
  QuantitySold = 'quantitySold',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  StartSelling = 'startSelling',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  State = 'state',
  /** column name */
  StopSelling = 'stopSelling',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  Tax = 'tax',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UseGlobalInventory = 'use_global_inventory'
}

export type TixEventProductUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixEventProductIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventProductSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventProductBoolExp;
};

/** aggregate var_pop on columns */
export type TixEventProductVarPopFields = {
  __typename?: 'EventProduct_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityRemaining?: Maybe<Scalars['Float']>;
  quantitySold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product.event_product" */
export type TixEventProductVarPopOrderBy = {
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixEventProductVarSampFields = {
  __typename?: 'EventProduct_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityRemaining?: Maybe<Scalars['Float']>;
  quantitySold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product.event_product" */
export type TixEventProductVarSampOrderBy = {
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixEventProductVarianceFields = {
  __typename?: 'EventProduct_variance_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityRemaining?: Maybe<Scalars['Float']>;
  quantitySold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product.event_product" */
export type TixEventProductVarianceOrderBy = {
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantityRemaining?: InputMaybe<TixOrderBy>;
  quantitySold?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
};

export type TixEventResult = {
  __typename?: 'EventResult';
  returning?: Maybe<Array<TixEventIdResult>>;
};

/** columns and relationships of "event.event_venue" */
export type TixEventVenue = {
  __typename?: 'EventVenue';
  eventId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  eventInstance?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventVenueId: Scalars['uuid'];
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<TixVenue>;
  venueId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venueTicket?: Maybe<TixVenueTicket>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "event.event_venue" */
export type TixEventVenueAggregate = {
  __typename?: 'EventVenue_aggregate';
  aggregate?: Maybe<TixEventVenueAggregateFields>;
  nodes: Array<TixEventVenue>;
};

/** aggregate fields of "event.event_venue" */
export type TixEventVenueAggregateFields = {
  __typename?: 'EventVenue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventVenueMaxFields>;
  min?: Maybe<TixEventVenueMinFields>;
};


/** aggregate fields of "event.event_venue" */
export type TixEventVenueAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventVenueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event.event_venue". All fields are combined with a logical 'AND'. */
export type TixEventVenueBoolExp = {
  _and?: InputMaybe<Array<TixEventVenueBoolExp>>;
  _not?: InputMaybe<TixEventVenueBoolExp>;
  _or?: InputMaybe<Array<TixEventVenueBoolExp>>;
  eventId?: InputMaybe<TixUuidComparisonExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventVenueId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueTicket?: InputMaybe<TixVenueTicketBoolExp>;
  venueTicketId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "event.event_venue" */
export enum TixEventVenueConstraint {
  /** unique or primary key constraint on columns "event_venue_id" */
  EventVenuePkey = 'event_venue_pkey'
}

/** input type for inserting data into table "event.event_venue" */
export type TixEventVenueInsertInput = {
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventVenueId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicket?: InputMaybe<TixVenueTicketObjRelInsertInput>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventVenueMaxFields = {
  __typename?: 'EventVenue_max_fields';
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventVenueId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixEventVenueMinFields = {
  __typename?: 'EventVenue_min_fields';
  eventId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventVenueId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "event.event_venue" */
export type TixEventVenueMutationResponse = {
  __typename?: 'EventVenue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventVenue>;
};

/** on_conflict condition type for table "event.event_venue" */
export type TixEventVenueOnConflict = {
  constraint: TixEventVenueConstraint;
  update_columns?: Array<TixEventVenueUpdateColumn>;
  where?: InputMaybe<TixEventVenueBoolExp>;
};

/** Ordering options when selecting data from "event.event_venue". */
export type TixEventVenueOrderBy = {
  eventId?: InputMaybe<TixOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventVenueId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueTicket?: InputMaybe<TixVenueTicketOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: event.event_venue */
export type TixEventVenuePkColumnsInput = {
  eventVenueId: Scalars['uuid'];
};

/** select columns of table "event.event_venue" */
export enum TixEventVenueSelectColumn {
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventVenueId = 'eventVenueId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueTicketId = 'venueTicketId'
}

/** input type for updating data in table "event.event_venue" */
export type TixEventVenueSetInput = {
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventVenueId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "EventVenue" */
export type TixEventVenueStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventVenueStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventVenueStreamCursorValueInput = {
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventVenueId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event.event_venue" */
export enum TixEventVenueUpdateColumn {
  /** column name */
  EventId = 'eventId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventVenueId = 'eventVenueId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueTicketId = 'venueTicketId'
}

export type TixEventVenueUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventVenueSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventVenueBoolExp;
};

/** aggregated selection of "event.event" */
export type TixEventAggregate = {
  __typename?: 'Event_aggregate';
  aggregate?: Maybe<TixEventAggregateFields>;
  nodes: Array<TixEvent>;
};

/** aggregate fields of "event.event" */
export type TixEventAggregateFields = {
  __typename?: 'Event_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventMaxFields>;
  min?: Maybe<TixEventMinFields>;
};


/** aggregate fields of "event.event" */
export type TixEventAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event.event". All fields are combined with a logical 'AND'. */
export type TixEventBoolExp = {
  _and?: InputMaybe<Array<TixEventBoolExp>>;
  _not?: InputMaybe<TixEventBoolExp>;
  _or?: InputMaybe<Array<TixEventBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  eventId?: InputMaybe<TixUuidComparisonExp>;
  eventInstances?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstances_aggregate?: InputMaybe<TixEventInstanceAggregateBoolExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue_id?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "event.event" */
export enum TixEventConstraint {
  /** unique or primary key constraint on columns "event_id" */
  EventConfigPkey = 'event_config_pkey'
}

/** input type for inserting data into table "event.event" */
export type TixEventInsertInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  eventInstances?: InputMaybe<TixEventInstanceArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventMaxFields = {
  __typename?: 'Event_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  eventId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixEventMinFields = {
  __typename?: 'Event_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  eventId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venue_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "event.event" */
export type TixEventMutationResponse = {
  __typename?: 'Event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEvent>;
};

/** input type for inserting object relation for remote table "event.event" */
export type TixEventObjRelInsertInput = {
  data: TixEventInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventOnConflict>;
};

/** on_conflict condition type for table "event.event" */
export type TixEventOnConflict = {
  constraint: TixEventConstraint;
  update_columns?: Array<TixEventUpdateColumn>;
  where?: InputMaybe<TixEventBoolExp>;
};

/** Ordering options when selecting data from "event.event". */
export type TixEventOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  eventId?: InputMaybe<TixOrderBy>;
  eventInstances_aggregate?: InputMaybe<TixEventInstanceAggregateOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue_id?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: event.event */
export type TixEventPkColumnsInput = {
  eventId: Scalars['uuid'];
};

/** select columns of table "event.event" */
export enum TixEventSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venue_id'
}

/** input type for updating data in table "event.event" */
export type TixEventSetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Event" */
export type TixEventStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event.event" */
export enum TixEventUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venue_id'
}

export type TixEventUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventBoolExp;
};

export type TixExternalOrderHoldItemResult = {
  __typename?: 'ExternalOrderHoldItemResult';
  id: Scalars['String'];
  quantity: Scalars['Float'];
};

/** The categories of feedback */
export enum TixFeedbackCategory {
  BugReport = 'BUG_REPORT',
  FeatureRequest = 'FEATURE_REQUEST',
  Other = 'OTHER',
  SuggestedImprovement = 'SUGGESTED_IMPROVEMENT'
}

export type TixFeedbackAttachmentUrl = {
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type TixFeedbackInput = {
  category: TixFeedbackCategory;
  description: Scalars['String'];
  title: Scalars['String'];
};

export type TixFinancialBreakdownDiscount = {
  __typename?: 'FinancialBreakdownDiscount';
  appliedTo?: Maybe<Scalars['String']>;
  buyAmount?: Maybe<Scalars['Float']>;
  codeType?: Maybe<Scalars['String']>;
  codesToGenerate?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discountCode: Scalars['String'];
  discountId: Scalars['ID'];
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export type TixFinancialBreakdownDiscountUsageSummary = {
  __typename?: 'FinancialBreakdownDiscountUsageSummary';
  count: Scalars['Int'];
  discount: Array<TixFinancialBreakdownDiscount>;
  totalValue: Scalars['Float'];
};

export type TixFinancialBreakdownRefundSummary = {
  __typename?: 'FinancialBreakdownRefundSummary';
  count: Scalars['Int'];
  totalAmount: Scalars['Float'];
};

export type TixFinancialBreakdownRevenueByChannel = {
  __typename?: 'FinancialBreakdownRevenueByChannel';
  count: Scalars['Int'];
  revenue: Scalars['Float'];
  salesChannel: TixFinancialBreakdownSalesChannel;
};

export type TixFinancialBreakdownSalesChannel = {
  __typename?: 'FinancialBreakdownSalesChannel';
  channelName: Scalars['String'];
};

export type TixFinancialBreakdownTicketSalesByType = {
  __typename?: 'FinancialBreakdownTicketSalesByType';
  count: Scalars['Int'];
  revenue: Scalars['Float'];
  ticketType: TixFinancialBreakdownTicketType;
};

export type TixFinancialBreakdownTicketType = {
  __typename?: 'FinancialBreakdownTicketType';
  typeName: Scalars['String'];
};

export type TixFinancialBreakdownVenue = {
  __typename?: 'FinancialBreakdownVenue';
  name: Scalars['String'];
};

/** Contact information for a reservation */
export type TixGqlContact = {
  __typename?: 'GQLContact';
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

/** Details of a discount applied to a reservation */
export type TixGqlDiscount = {
  __typename?: 'GQLDiscount';
  appliedTo?: Maybe<Scalars['String']>;
  buyAmount?: Maybe<Scalars['Int']>;
  discountId: Scalars['String'];
  getAmount?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** Information about a specific event instance */
export type TixGqlEventInstance = {
  __typename?: 'GQLEventInstance';
  date?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

/** Details of a product in an order */
export type TixGqlEventProduct = {
  __typename?: 'GQLEventProduct';
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Float']>;
};

/** An order for products */
export type TixGqlOrder = {
  __typename?: 'GQLOrder';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  orderDetails: Array<TixGqlProductOrderDetail>;
  payment_type?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Details of a payment transaction */
export type TixGqlPayment = {
  __typename?: 'GQLPayment';
  paymentId: Scalars['String'];
  paymentToken?: Maybe<Scalars['String']>;
};

/** Represents the complete state of a ticket exchange process. */
export type TixGqlPaymentExchangeData = {
  __typename?: 'GQLPaymentExchangeData';
  amount: Scalars['Float'];
  createdAt: Scalars['String'];
  exchangeId: Scalars['String'];
  exchangedProductIds: Array<Scalars['String']>;
  exchangedTicketIds: Array<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  newReservation?: Maybe<TixGqlTicketReservation>;
  newReservationId: Scalars['String'];
  originalReservation?: Maybe<TixGqlTicketReservation>;
  originalReservationId: Scalars['String'];
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  required_action: Scalars['String'];
  state: Scalars['String'];
};

/** A line item in a product order */
export type TixGqlProductOrderDetail = {
  __typename?: 'GQLProductOrderDetail';
  active: Scalars['Boolean'];
  amount?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  eventProductId?: Maybe<Scalars['String']>;
  eventproduct?: Maybe<TixGqlEventProduct>;
  orderDetailId: Scalars['String'];
  price?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Link between a reservation and a payment */
export type TixGqlReservationPayment = {
  __typename?: 'GQLReservationPayment';
  payment?: Maybe<TixGqlPayment>;
};

/** A specific ticket within a reservation */
export type TixGqlTicket = {
  __typename?: 'GQLTicket';
  active?: Maybe<Scalars['Boolean']>;
  checkedInAt?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['String']>;
  processingFee?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['String']>;
  reservationNo?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  ticketConfig?: Maybe<TixGqlTicketConfig>;
  ticketConfigId?: Maybe<Scalars['String']>;
  ticketId: Scalars['String'];
  ticketNo?: Maybe<Scalars['String']>;
  ticketPrice?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  venueFee?: Maybe<Scalars['String']>;
};

/** Configuration details for a ticket */
export type TixGqlTicketConfig = {
  __typename?: 'GQLTicketConfig';
  includeFees?: Maybe<Scalars['Boolean']>;
  section?: Maybe<Scalars['String']>;
  ticketConfigId: Scalars['String'];
  ticketPrice?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  venueFee?: Maybe<Scalars['String']>;
};

/** A reservation for one or more tickets */
export type TixGqlTicketReservation = {
  __typename?: 'GQLTicketReservation';
  contact?: Maybe<TixGqlContact>;
  discount?: Maybe<TixGqlDiscount>;
  discountAmount?: Maybe<Scalars['String']>;
  event?: Maybe<TixGqlEventInstance>;
  eventInstanceId?: Maybe<Scalars['String']>;
  payment?: Maybe<TixGqlReservationPayment>;
  productOrder?: Maybe<TixGqlOrder>;
  reservationDetails: Array<TixGqlTicketReservationDetail>;
  subTotal?: Maybe<Scalars['String']>;
  tickets: Array<TixGqlTicket>;
  totalAmountPaid?: Maybe<Scalars['String']>;
};

/** A line item in a ticket reservation */
export type TixGqlTicketReservationDetail = {
  __typename?: 'GQLTicketReservationDetail';
  amount?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  reservationDetailId: Scalars['String'];
  ticketConfigId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TixGraphQlUploadResult = {
  __typename?: 'GraphQLUploadResult';
  url: Scalars['String'];
};

export type TixGroupedTicketData = {
  __typename?: 'GroupedTicketData';
  groupName: Scalars['String'];
  ticketCount: Scalars['Int'];
  totalRevenue: Scalars['Float'];
};

export type TixHasPasscodeDto = {
  code: Scalars['String'];
  companyId: Scalars['String'];
  eventId?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['String']>;
};

export type TixInsertEventResult = {
  __typename?: 'InsertEventResult';
  InsertEvent?: Maybe<TixEventResult>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type TixIntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type TixInviteUserResult = {
  __typename?: 'InviteUserResult';
  invited?: Maybe<Scalars['Boolean']>;
};

/** columns and relationships of "performer.lineup" */
export type TixLineup = {
  __typename?: 'Lineup';
  lineupId: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  performers: Array<TixLineupPerformer>;
  /** An aggregate relationship */
  performers_aggregate: TixLineupPerformerAggregate;
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An array relationship */
  venueLineups: Array<TixVenueLineup>;
  /** An aggregate relationship */
  venueLineups_aggregate: TixVenueLineupAggregate;
};


/** columns and relationships of "performer.lineup" */
export type TixLineupPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupPerformerOrderBy>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


/** columns and relationships of "performer.lineup" */
export type TixLineupPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupPerformerOrderBy>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


/** columns and relationships of "performer.lineup" */
export type TixLineupVenueLineupsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueLineupOrderBy>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};


/** columns and relationships of "performer.lineup" */
export type TixLineupVenueLineupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueLineupOrderBy>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};

/** columns and relationships of "performer.lineup_performer" */
export type TixLineupPerformer = {
  __typename?: 'LineupPerformer';
  /** An object relationship */
  lineup: TixLineup;
  lineupId: Scalars['uuid'];
  lineupPerformerId: Scalars['uuid'];
  /** An object relationship */
  performer: TixPerformer;
  performerId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "performer.lineup_performer" */
export type TixLineupPerformerAggregate = {
  __typename?: 'LineupPerformer_aggregate';
  aggregate?: Maybe<TixLineupPerformerAggregateFields>;
  nodes: Array<TixLineupPerformer>;
};

export type TixLineupPerformerAggregateBoolExp = {
  count?: InputMaybe<TixLineupPerformerAggregateBoolExpCount>;
};

export type TixLineupPerformerAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixLineupPerformerBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "performer.lineup_performer" */
export type TixLineupPerformerAggregateFields = {
  __typename?: 'LineupPerformer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixLineupPerformerMaxFields>;
  min?: Maybe<TixLineupPerformerMinFields>;
};


/** aggregate fields of "performer.lineup_performer" */
export type TixLineupPerformerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "performer.lineup_performer" */
export type TixLineupPerformerAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixLineupPerformerMaxOrderBy>;
  min?: InputMaybe<TixLineupPerformerMinOrderBy>;
};

/** input type for inserting array relation for remote table "performer.lineup_performer" */
export type TixLineupPerformerArrRelInsertInput = {
  data: Array<TixLineupPerformerInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixLineupPerformerOnConflict>;
};

/** Boolean expression to filter rows from the table "performer.lineup_performer". All fields are combined with a logical 'AND'. */
export type TixLineupPerformerBoolExp = {
  _and?: InputMaybe<Array<TixLineupPerformerBoolExp>>;
  _not?: InputMaybe<TixLineupPerformerBoolExp>;
  _or?: InputMaybe<Array<TixLineupPerformerBoolExp>>;
  lineup?: InputMaybe<TixLineupBoolExp>;
  lineupId?: InputMaybe<TixUuidComparisonExp>;
  lineupPerformerId?: InputMaybe<TixUuidComparisonExp>;
  performer?: InputMaybe<TixPerformerBoolExp>;
  performerId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "performer.lineup_performer" */
export enum TixLineupPerformerConstraint {
  /** unique or primary key constraint on columns "lineup_performer_id" */
  LineupPerformerIdPk = 'lineup_performer_id_pk'
}

/** input type for inserting data into table "performer.lineup_performer" */
export type TixLineupPerformerInsertInput = {
  lineup?: InputMaybe<TixLineupObjRelInsertInput>;
  lineupId?: InputMaybe<Scalars['uuid']>;
  lineupPerformerId?: InputMaybe<Scalars['uuid']>;
  performer?: InputMaybe<TixPerformerObjRelInsertInput>;
  performerId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixLineupPerformerMaxFields = {
  __typename?: 'LineupPerformer_max_fields';
  lineupId?: Maybe<Scalars['uuid']>;
  lineupPerformerId?: Maybe<Scalars['uuid']>;
  performerId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "performer.lineup_performer" */
export type TixLineupPerformerMaxOrderBy = {
  lineupId?: InputMaybe<TixOrderBy>;
  lineupPerformerId?: InputMaybe<TixOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixLineupPerformerMinFields = {
  __typename?: 'LineupPerformer_min_fields';
  lineupId?: Maybe<Scalars['uuid']>;
  lineupPerformerId?: Maybe<Scalars['uuid']>;
  performerId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "performer.lineup_performer" */
export type TixLineupPerformerMinOrderBy = {
  lineupId?: InputMaybe<TixOrderBy>;
  lineupPerformerId?: InputMaybe<TixOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "performer.lineup_performer" */
export type TixLineupPerformerMutationResponse = {
  __typename?: 'LineupPerformer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixLineupPerformer>;
};

/** on_conflict condition type for table "performer.lineup_performer" */
export type TixLineupPerformerOnConflict = {
  constraint: TixLineupPerformerConstraint;
  update_columns?: Array<TixLineupPerformerUpdateColumn>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};

/** Ordering options when selecting data from "performer.lineup_performer". */
export type TixLineupPerformerOrderBy = {
  lineup?: InputMaybe<TixLineupOrderBy>;
  lineupId?: InputMaybe<TixOrderBy>;
  lineupPerformerId?: InputMaybe<TixOrderBy>;
  performer?: InputMaybe<TixPerformerOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: performer.lineup_performer */
export type TixLineupPerformerPkColumnsInput = {
  lineupPerformerId: Scalars['uuid'];
};

/** select columns of table "performer.lineup_performer" */
export enum TixLineupPerformerSelectColumn {
  /** column name */
  LineupId = 'lineupId',
  /** column name */
  LineupPerformerId = 'lineupPerformerId',
  /** column name */
  PerformerId = 'performerId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "performer.lineup_performer" */
export type TixLineupPerformerSetInput = {
  lineupId?: InputMaybe<Scalars['uuid']>;
  lineupPerformerId?: InputMaybe<Scalars['uuid']>;
  performerId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "LineupPerformer" */
export type TixLineupPerformerStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixLineupPerformerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixLineupPerformerStreamCursorValueInput = {
  lineupId?: InputMaybe<Scalars['uuid']>;
  lineupPerformerId?: InputMaybe<Scalars['uuid']>;
  performerId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "performer.lineup_performer" */
export enum TixLineupPerformerUpdateColumn {
  /** column name */
  LineupId = 'lineupId',
  /** column name */
  LineupPerformerId = 'lineupPerformerId',
  /** column name */
  PerformerId = 'performerId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixLineupPerformerUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixLineupPerformerSetInput>;
  /** filter the rows which have to be updated */
  where: TixLineupPerformerBoolExp;
};

/** aggregated selection of "performer.lineup" */
export type TixLineupAggregate = {
  __typename?: 'Lineup_aggregate';
  aggregate?: Maybe<TixLineupAggregateFields>;
  nodes: Array<TixLineup>;
};

/** aggregate fields of "performer.lineup" */
export type TixLineupAggregateFields = {
  __typename?: 'Lineup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixLineupMaxFields>;
  min?: Maybe<TixLineupMinFields>;
};


/** aggregate fields of "performer.lineup" */
export type TixLineupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixLineupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "performer.lineup". All fields are combined with a logical 'AND'. */
export type TixLineupBoolExp = {
  _and?: InputMaybe<Array<TixLineupBoolExp>>;
  _not?: InputMaybe<TixLineupBoolExp>;
  _or?: InputMaybe<Array<TixLineupBoolExp>>;
  lineupId?: InputMaybe<TixUuidComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  performers?: InputMaybe<TixLineupPerformerBoolExp>;
  performers_aggregate?: InputMaybe<TixLineupPerformerAggregateBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueLineups?: InputMaybe<TixVenueLineupBoolExp>;
  venueLineups_aggregate?: InputMaybe<TixVenueLineupAggregateBoolExp>;
};

/** unique or primary key constraints on table "performer.lineup" */
export enum TixLineupConstraint {
  /** unique or primary key constraint on columns "lineup_id" */
  LineupPkey = 'lineup_pkey'
}

/** input type for inserting data into table "performer.lineup" */
export type TixLineupInsertInput = {
  lineupId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  performers?: InputMaybe<TixLineupPerformerArrRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueLineups?: InputMaybe<TixVenueLineupArrRelInsertInput>;
};

/** aggregate max on columns */
export type TixLineupMaxFields = {
  __typename?: 'Lineup_max_fields';
  lineupId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixLineupMinFields = {
  __typename?: 'Lineup_min_fields';
  lineupId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "performer.lineup" */
export type TixLineupMutationResponse = {
  __typename?: 'Lineup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixLineup>;
};

/** input type for inserting object relation for remote table "performer.lineup" */
export type TixLineupObjRelInsertInput = {
  data: TixLineupInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixLineupOnConflict>;
};

/** on_conflict condition type for table "performer.lineup" */
export type TixLineupOnConflict = {
  constraint: TixLineupConstraint;
  update_columns?: Array<TixLineupUpdateColumn>;
  where?: InputMaybe<TixLineupBoolExp>;
};

/** Ordering options when selecting data from "performer.lineup". */
export type TixLineupOrderBy = {
  lineupId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  performers_aggregate?: InputMaybe<TixLineupPerformerAggregateOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueLineups_aggregate?: InputMaybe<TixVenueLineupAggregateOrderBy>;
};

/** primary key columns input for table: performer.lineup */
export type TixLineupPkColumnsInput = {
  lineupId: Scalars['uuid'];
};

/** select columns of table "performer.lineup" */
export enum TixLineupSelectColumn {
  /** column name */
  LineupId = 'lineupId',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "performer.lineup" */
export type TixLineupSetInput = {
  lineupId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Lineup" */
export type TixLineupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixLineupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixLineupStreamCursorValueInput = {
  lineupId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "performer.lineup" */
export enum TixLineupUpdateColumn {
  /** column name */
  LineupId = 'lineupId',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixLineupUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixLineupSetInput>;
  /** filter the rows which have to be updated */
  where: TixLineupBoolExp;
};

/** columns and relationships of "reporting.logging" */
export type TixLogging = {
  __typename?: 'Logging';
  createdAt?: Maybe<Scalars['timestamp']>;
  log?: Maybe<Scalars['jsonb']>;
  logId: Scalars['uuid'];
  type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "reporting.logging" */
export type TixLoggingLogArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "reporting.logging" */
export type TixLoggingAggregate = {
  __typename?: 'Logging_aggregate';
  aggregate?: Maybe<TixLoggingAggregateFields>;
  nodes: Array<TixLogging>;
};

/** aggregate fields of "reporting.logging" */
export type TixLoggingAggregateFields = {
  __typename?: 'Logging_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixLoggingMaxFields>;
  min?: Maybe<TixLoggingMinFields>;
};


/** aggregate fields of "reporting.logging" */
export type TixLoggingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixLoggingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TixLoggingAppendInput = {
  log?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "reporting.logging". All fields are combined with a logical 'AND'. */
export type TixLoggingBoolExp = {
  _and?: InputMaybe<Array<TixLoggingBoolExp>>;
  _not?: InputMaybe<TixLoggingBoolExp>;
  _or?: InputMaybe<Array<TixLoggingBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  log?: InputMaybe<TixJsonbComparisonExp>;
  logId?: InputMaybe<TixUuidComparisonExp>;
  type?: InputMaybe<TixStringComparisonExp>;
};

/** unique or primary key constraints on table "reporting.logging" */
export enum TixLoggingConstraint {
  /** unique or primary key constraint on columns "log_id" */
  LoggingPkey = 'logging_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TixLoggingDeleteAtPathInput = {
  log?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TixLoggingDeleteElemInput = {
  log?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TixLoggingDeleteKeyInput = {
  log?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "reporting.logging" */
export type TixLoggingInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  log?: InputMaybe<Scalars['jsonb']>;
  logId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TixLoggingMaxFields = {
  __typename?: 'Logging_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  logId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixLoggingMinFields = {
  __typename?: 'Logging_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  logId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "reporting.logging" */
export type TixLoggingMutationResponse = {
  __typename?: 'Logging_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixLogging>;
};

/** on_conflict condition type for table "reporting.logging" */
export type TixLoggingOnConflict = {
  constraint: TixLoggingConstraint;
  update_columns?: Array<TixLoggingUpdateColumn>;
  where?: InputMaybe<TixLoggingBoolExp>;
};

/** Ordering options when selecting data from "reporting.logging". */
export type TixLoggingOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  log?: InputMaybe<TixOrderBy>;
  logId?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: reporting.logging */
export type TixLoggingPkColumnsInput = {
  logId: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TixLoggingPrependInput = {
  log?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "reporting.logging" */
export enum TixLoggingSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Log = 'log',
  /** column name */
  LogId = 'logId',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "reporting.logging" */
export type TixLoggingSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  log?: InputMaybe<Scalars['jsonb']>;
  logId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Logging" */
export type TixLoggingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixLoggingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixLoggingStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  log?: InputMaybe<Scalars['jsonb']>;
  logId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "reporting.logging" */
export enum TixLoggingUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Log = 'log',
  /** column name */
  LogId = 'logId',
  /** column name */
  Type = 'type'
}

export type TixLoggingUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TixLoggingAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TixLoggingDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TixLoggingDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TixLoggingDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TixLoggingPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixLoggingSetInput>;
  /** filter the rows which have to be updated */
  where: TixLoggingBoolExp;
};

/** columns and relationships of "media.media_file" */
export type TixMediaFile = {
  __typename?: 'MediaFile';
  /** An array relationship */
  companyMediaFile: Array<TixCompanyMediaFile>;
  /** An aggregate relationship */
  companyMediaFile_aggregate: TixCompanyMediaFileAggregate;
  /** An array relationship */
  eventMediaFile: Array<TixEventInstanceMedialFile>;
  /** An aggregate relationship */
  eventMediaFile_aggregate: TixEventInstanceMedialFileAggregate;
  /** An object relationship */
  eventProductMediaFile?: Maybe<TixEventProductMedia>;
  fileType?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  mediaFileId: Scalars['uuid'];
  mediaType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object relationship */
  productMediaFile?: Maybe<TixProductMediaFile>;
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An array relationship */
  venueMediaFile: Array<TixVenueMediaFile>;
  /** An aggregate relationship */
  venueMediaFile_aggregate: TixVenueMediaFileAggregate;
};


/** columns and relationships of "media.media_file" */
export type TixMediaFileCompanyMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyMediaFileOrderBy>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


/** columns and relationships of "media.media_file" */
export type TixMediaFileCompanyMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyMediaFileOrderBy>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


/** columns and relationships of "media.media_file" */
export type TixMediaFileEventMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


/** columns and relationships of "media.media_file" */
export type TixMediaFileEventMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


/** columns and relationships of "media.media_file" */
export type TixMediaFileVenueMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueMediaFileOrderBy>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};


/** columns and relationships of "media.media_file" */
export type TixMediaFileVenueMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueMediaFileOrderBy>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};

/** aggregated selection of "media.media_file" */
export type TixMediaFileAggregate = {
  __typename?: 'MediaFile_aggregate';
  aggregate?: Maybe<TixMediaFileAggregateFields>;
  nodes: Array<TixMediaFile>;
};

/** aggregate fields of "media.media_file" */
export type TixMediaFileAggregateFields = {
  __typename?: 'MediaFile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixMediaFileMaxFields>;
  min?: Maybe<TixMediaFileMinFields>;
};


/** aggregate fields of "media.media_file" */
export type TixMediaFileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "media.media_file". All fields are combined with a logical 'AND'. */
export type TixMediaFileBoolExp = {
  _and?: InputMaybe<Array<TixMediaFileBoolExp>>;
  _not?: InputMaybe<TixMediaFileBoolExp>;
  _or?: InputMaybe<Array<TixMediaFileBoolExp>>;
  companyMediaFile?: InputMaybe<TixCompanyMediaFileBoolExp>;
  companyMediaFile_aggregate?: InputMaybe<TixCompanyMediaFileAggregateBoolExp>;
  eventMediaFile?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
  eventMediaFile_aggregate?: InputMaybe<TixEventInstanceMedialFileAggregateBoolExp>;
  eventProductMediaFile?: InputMaybe<TixEventProductMediaBoolExp>;
  fileType?: InputMaybe<TixStringComparisonExp>;
  location?: InputMaybe<TixStringComparisonExp>;
  mediaFileId?: InputMaybe<TixUuidComparisonExp>;
  mediaType?: InputMaybe<TixStringComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  productMediaFile?: InputMaybe<TixProductMediaFileBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueMediaFile?: InputMaybe<TixVenueMediaFileBoolExp>;
  venueMediaFile_aggregate?: InputMaybe<TixVenueMediaFileAggregateBoolExp>;
};

/** unique or primary key constraints on table "media.media_file" */
export enum TixMediaFileConstraint {
  /** unique or primary key constraint on columns "media_file_id" */
  ImageFilePkey = 'image_file_pkey'
}

/** input type for inserting data into table "media.media_file" */
export type TixMediaFileInsertInput = {
  companyMediaFile?: InputMaybe<TixCompanyMediaFileArrRelInsertInput>;
  eventMediaFile?: InputMaybe<TixEventInstanceMedialFileArrRelInsertInput>;
  eventProductMediaFile?: InputMaybe<TixEventProductMediaObjRelInsertInput>;
  fileType?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  mediaType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productMediaFile?: InputMaybe<TixProductMediaFileObjRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueMediaFile?: InputMaybe<TixVenueMediaFileArrRelInsertInput>;
};

/** aggregate max on columns */
export type TixMediaFileMaxFields = {
  __typename?: 'MediaFile_max_fields';
  fileType?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  mediaType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixMediaFileMinFields = {
  __typename?: 'MediaFile_min_fields';
  fileType?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  mediaType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "media.media_file" */
export type TixMediaFileMutationResponse = {
  __typename?: 'MediaFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixMediaFile>;
};

/** input type for inserting object relation for remote table "media.media_file" */
export type TixMediaFileObjRelInsertInput = {
  data: TixMediaFileInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixMediaFileOnConflict>;
};

/** on_conflict condition type for table "media.media_file" */
export type TixMediaFileOnConflict = {
  constraint: TixMediaFileConstraint;
  update_columns?: Array<TixMediaFileUpdateColumn>;
  where?: InputMaybe<TixMediaFileBoolExp>;
};

/** Ordering options when selecting data from "media.media_file". */
export type TixMediaFileOrderBy = {
  companyMediaFile_aggregate?: InputMaybe<TixCompanyMediaFileAggregateOrderBy>;
  eventMediaFile_aggregate?: InputMaybe<TixEventInstanceMedialFileAggregateOrderBy>;
  eventProductMediaFile?: InputMaybe<TixEventProductMediaOrderBy>;
  fileType?: InputMaybe<TixOrderBy>;
  location?: InputMaybe<TixOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  mediaType?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  productMediaFile?: InputMaybe<TixProductMediaFileOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueMediaFile_aggregate?: InputMaybe<TixVenueMediaFileAggregateOrderBy>;
};

/** primary key columns input for table: media.media_file */
export type TixMediaFilePkColumnsInput = {
  mediaFileId: Scalars['uuid'];
};

/** select columns of table "media.media_file" */
export enum TixMediaFileSelectColumn {
  /** column name */
  FileType = 'fileType',
  /** column name */
  Location = 'location',
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  MediaType = 'mediaType',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "media.media_file" */
export type TixMediaFileSetInput = {
  fileType?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  mediaType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "MediaFile" */
export type TixMediaFileStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixMediaFileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixMediaFileStreamCursorValueInput = {
  fileType?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  mediaType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.media_file" */
export enum TixMediaFileUpdateColumn {
  /** column name */
  FileType = 'fileType',
  /** column name */
  Location = 'location',
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  MediaType = 'mediaType',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixMediaFileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixMediaFileSetInput>;
  /** filter the rows which have to be updated */
  where: TixMediaFileBoolExp;
};

export type TixMediaInput = {
  fileType: Scalars['String'];
  location: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "notification.notification" */
export type TixNotification = {
  __typename?: 'Notification';
  /** An object relationship */
  ContactNotification?: Maybe<TixNotificationContactNotification>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  expirationDate?: Maybe<Scalars['date']>;
  notificationId: Scalars['uuid'];
  state?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "notification.notification" */
export type TixNotificationAggregate = {
  __typename?: 'Notification_aggregate';
  aggregate?: Maybe<TixNotificationAggregateFields>;
  nodes: Array<TixNotification>;
};

/** aggregate fields of "notification.notification" */
export type TixNotificationAggregateFields = {
  __typename?: 'Notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixNotificationMaxFields>;
  min?: Maybe<TixNotificationMinFields>;
};


/** aggregate fields of "notification.notification" */
export type TixNotificationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixNotificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification.notification". All fields are combined with a logical 'AND'. */
export type TixNotificationBoolExp = {
  ContactNotification?: InputMaybe<TixNotificationContactNotificationBoolExp>;
  _and?: InputMaybe<Array<TixNotificationBoolExp>>;
  _not?: InputMaybe<TixNotificationBoolExp>;
  _or?: InputMaybe<Array<TixNotificationBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  expirationDate?: InputMaybe<TixDateComparisonExp>;
  notificationId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  text?: InputMaybe<TixStringComparisonExp>;
  title?: InputMaybe<TixStringComparisonExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "notification.notification" */
export enum TixNotificationConstraint {
  /** unique or primary key constraint on columns "notification_id" */
  NotificationPkey = 'notification_pkey'
}

/** input type for inserting data into table "notification.notification" */
export type TixNotificationInsertInput = {
  ContactNotification?: InputMaybe<TixNotificationContactNotificationObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  notificationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixNotificationMaxFields = {
  __typename?: 'Notification_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  expirationDate?: Maybe<Scalars['date']>;
  notificationId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixNotificationMinFields = {
  __typename?: 'Notification_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  expirationDate?: Maybe<Scalars['date']>;
  notificationId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "notification.notification" */
export type TixNotificationMutationResponse = {
  __typename?: 'Notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixNotification>;
};

/** input type for inserting object relation for remote table "notification.notification" */
export type TixNotificationObjRelInsertInput = {
  data: TixNotificationInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixNotificationOnConflict>;
};

/** on_conflict condition type for table "notification.notification" */
export type TixNotificationOnConflict = {
  constraint: TixNotificationConstraint;
  update_columns?: Array<TixNotificationUpdateColumn>;
  where?: InputMaybe<TixNotificationBoolExp>;
};

/** Ordering options when selecting data from "notification.notification". */
export type TixNotificationOrderBy = {
  ContactNotification?: InputMaybe<TixNotificationContactNotificationOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  expirationDate?: InputMaybe<TixOrderBy>;
  notificationId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  text?: InputMaybe<TixOrderBy>;
  title?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: notification.notification */
export type TixNotificationPkColumnsInput = {
  notificationId: Scalars['uuid'];
};

/** select columns of table "notification.notification" */
export enum TixNotificationSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  NotificationId = 'notificationId',
  /** column name */
  State = 'state',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "notification.notification" */
export type TixNotificationSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  notificationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Notification" */
export type TixNotificationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixNotificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixNotificationStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  expirationDate?: InputMaybe<Scalars['date']>;
  notificationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "notification.notification" */
export enum TixNotificationUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  NotificationId = 'notificationId',
  /** column name */
  State = 'state',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixNotificationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixNotificationSetInput>;
  /** filter the rows which have to be updated */
  where: TixNotificationBoolExp;
};

/** columns and relationships of "product.order" */
export type TixOrder = {
  __typename?: 'Order';
  contactId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  orderId: Scalars['uuid'];
  /** An array relationship */
  order_detail: Array<TixProductOrderDetail>;
  /** An aggregate relationship */
  order_detail_aggregate: TixProductOrderDetailAggregate;
  payment_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  reservation?: Maybe<TixTicketReservation>;
  reservationId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "product.order" */
export type TixOrderOrderDetailArgs = {
  distinct_on?: InputMaybe<Array<TixProductOrderDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderDetailOrderBy>>;
  where?: InputMaybe<TixProductOrderDetailBoolExp>;
};


/** columns and relationships of "product.order" */
export type TixOrderOrderDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixProductOrderDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderDetailOrderBy>>;
  where?: InputMaybe<TixProductOrderDetailBoolExp>;
};

export type TixOrderHoldItemInput = {
  id: Scalars['String'];
  quantity: Scalars['Float'];
  type: Scalars['String'];
};

export type TixOrderHoldItemResult = {
  __typename?: 'OrderHoldItemResult';
  expiresAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  quantity: Scalars['Float'];
  type: Scalars['String'];
};

export type TixOrderInput = {
  appliedDiscountId?: InputMaybe<Scalars['String']>;
  donation?: InputMaybe<TixDonationInput>;
  products: Array<TixProductInput>;
  tickets: Array<TixTicketInput>;
};

/** aggregated selection of "product.order" */
export type TixOrderAggregate = {
  __typename?: 'Order_aggregate';
  aggregate?: Maybe<TixOrderAggregateFields>;
  nodes: Array<TixOrder>;
};

/** aggregate fields of "product.order" */
export type TixOrderAggregateFields = {
  __typename?: 'Order_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixOrderMaxFields>;
  min?: Maybe<TixOrderMinFields>;
};


/** aggregate fields of "product.order" */
export type TixOrderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixOrderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "product.order". All fields are combined with a logical 'AND'. */
export type TixOrderBoolExp = {
  _and?: InputMaybe<Array<TixOrderBoolExp>>;
  _not?: InputMaybe<TixOrderBoolExp>;
  _or?: InputMaybe<Array<TixOrderBoolExp>>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  orderId?: InputMaybe<TixUuidComparisonExp>;
  order_detail?: InputMaybe<TixProductOrderDetailBoolExp>;
  order_detail_aggregate?: InputMaybe<TixProductOrderDetailAggregateBoolExp>;
  payment_type?: InputMaybe<TixStringComparisonExp>;
  reservation?: InputMaybe<TixTicketReservationBoolExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "product.order" */
export enum TixOrderConstraint {
  /** unique or primary key constraint on columns "order_id" */
  OrderPkey = 'order_pkey'
}

/** input type for inserting data into table "product.order" */
export type TixOrderInsertInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  order_detail?: InputMaybe<TixProductOrderDetailArrRelInsertInput>;
  payment_type?: InputMaybe<Scalars['String']>;
  reservation?: InputMaybe<TixTicketReservationObjRelInsertInput>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixOrderMaxFields = {
  __typename?: 'Order_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  payment_type?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixOrderMinFields = {
  __typename?: 'Order_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  payment_type?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "product.order" */
export type TixOrderMutationResponse = {
  __typename?: 'Order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixOrder>;
};

/** input type for inserting object relation for remote table "product.order" */
export type TixOrderObjRelInsertInput = {
  data: TixOrderInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixOrderOnConflict>;
};

/** on_conflict condition type for table "product.order" */
export type TixOrderOnConflict = {
  constraint: TixOrderConstraint;
  update_columns?: Array<TixOrderUpdateColumn>;
  where?: InputMaybe<TixOrderBoolExp>;
};

/** Ordering options when selecting data from "product.order". */
export type TixOrderOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  orderId?: InputMaybe<TixOrderBy>;
  order_detail_aggregate?: InputMaybe<TixProductOrderDetailAggregateOrderBy>;
  payment_type?: InputMaybe<TixOrderBy>;
  reservation?: InputMaybe<TixTicketReservationOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: product.order */
export type TixOrderPkColumnsInput = {
  orderId: Scalars['uuid'];
};

/** select columns of table "product.order" */
export enum TixOrderSelectColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  PaymentType = 'payment_type',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "product.order" */
export type TixOrderSetInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  payment_type?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Order" */
export type TixOrderStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixOrderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixOrderStreamCursorValueInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  payment_type?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "product.order" */
export enum TixOrderUpdateColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  PaymentType = 'payment_type',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixOrderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixOrderSetInput>;
  /** filter the rows which have to be updated */
  where: TixOrderBoolExp;
};

/** Unfiltered list of events */
export type TixPatronEventList = {
  __typename?: 'PatronEventList';
  /** An object relationship */
  Company?: Maybe<TixCompany>;
  /** An object relationship */
  Metrics?: Maybe<TixTicketVTicketSalesMetrics>;
  /** An array relationship */
  Performers: Array<TixEventPerformers>;
  /** An aggregate relationship */
  Performers_aggregate: TixEventPerformersAggregate;
  /** An array relationship */
  Tickets: Array<TixVenueTicket>;
  /** An aggregate relationship */
  Tickets_aggregate: TixVenueTicketAggregate;
  /** An object relationship */
  Venue?: Maybe<TixVenue>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  doorsOpen?: Maybe<Scalars['time']>;
  endTime?: Maybe<Scalars['time']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  overridden?: Maybe<Scalars['Boolean']>;
  startSelling?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  startSellingTime?: Maybe<Scalars['time']>;
  startTime?: Maybe<Scalars['time']>;
  stopSelling?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  stopSellingTime?: Maybe<Scalars['time']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};


/** Unfiltered list of events */
export type TixPatronEventListPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** Unfiltered list of events */
export type TixPatronEventListPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** Unfiltered list of events */
export type TixPatronEventListTicketsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


/** Unfiltered list of events */
export type TixPatronEventListTicketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};

/** aggregated selection of "event.v_patron_events_list" */
export type TixPatronEventListAggregate = {
  __typename?: 'PatronEventList_aggregate';
  aggregate?: Maybe<TixPatronEventListAggregateFields>;
  nodes: Array<TixPatronEventList>;
};

/** aggregate fields of "event.v_patron_events_list" */
export type TixPatronEventListAggregateFields = {
  __typename?: 'PatronEventList_aggregate_fields';
  avg?: Maybe<TixPatronEventListAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixPatronEventListMaxFields>;
  min?: Maybe<TixPatronEventListMinFields>;
  stddev?: Maybe<TixPatronEventListStddevFields>;
  stddev_pop?: Maybe<TixPatronEventListStddevPopFields>;
  stddev_samp?: Maybe<TixPatronEventListStddevSampFields>;
  sum?: Maybe<TixPatronEventListSumFields>;
  var_pop?: Maybe<TixPatronEventListVarPopFields>;
  var_samp?: Maybe<TixPatronEventListVarSampFields>;
  variance?: Maybe<TixPatronEventListVarianceFields>;
};


/** aggregate fields of "event.v_patron_events_list" */
export type TixPatronEventListAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPatronEventListSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixPatronEventListAvgFields = {
  __typename?: 'PatronEventList_avg_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event.v_patron_events_list". All fields are combined with a logical 'AND'. */
export type TixPatronEventListBoolExp = {
  Company?: InputMaybe<TixCompanyBoolExp>;
  Metrics?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
  Performers?: InputMaybe<TixEventPerformersBoolExp>;
  Performers_aggregate?: InputMaybe<TixEventPerformersAggregateBoolExp>;
  Tickets?: InputMaybe<TixVenueTicketBoolExp>;
  Tickets_aggregate?: InputMaybe<TixVenueTicketAggregateBoolExp>;
  Venue?: InputMaybe<TixVenueBoolExp>;
  _and?: InputMaybe<Array<TixPatronEventListBoolExp>>;
  _not?: InputMaybe<TixPatronEventListBoolExp>;
  _or?: InputMaybe<Array<TixPatronEventListBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  date?: InputMaybe<TixStringComparisonExp>;
  day?: InputMaybe<TixFloat8ComparisonExp>;
  doorsOpen?: InputMaybe<TixTimeComparisonExp>;
  endTime?: InputMaybe<TixTimeComparisonExp>;
  eventAdditionalInfo?: InputMaybe<TixStringComparisonExp>;
  eventDescription?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventPasscode?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  eventType?: InputMaybe<TixStringComparisonExp>;
  hidden?: InputMaybe<TixBooleanComparisonExp>;
  minimumAge?: InputMaybe<TixIntComparisonExp>;
  month?: InputMaybe<TixFloat8ComparisonExp>;
  overridden?: InputMaybe<TixBooleanComparisonExp>;
  startSelling?: InputMaybe<TixStringComparisonExp>;
  startSellingDate?: InputMaybe<TixDateComparisonExp>;
  startSellingTime?: InputMaybe<TixTimeComparisonExp>;
  startTime?: InputMaybe<TixTimeComparisonExp>;
  stopSelling?: InputMaybe<TixStringComparisonExp>;
  stopSellingDate?: InputMaybe<TixDateComparisonExp>;
  stopSellingTime?: InputMaybe<TixTimeComparisonExp>;
  venueCity?: InputMaybe<TixStringComparisonExp>;
  venueCityStateProvince?: InputMaybe<TixStringComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  venueStateProvince?: InputMaybe<TixStringComparisonExp>;
  venueTicketId?: InputMaybe<TixUuidComparisonExp>;
  year?: InputMaybe<TixFloat8ComparisonExp>;
};

/** aggregate max on columns */
export type TixPatronEventListMaxFields = {
  __typename?: 'PatronEventList_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  startSelling?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  stopSelling?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type TixPatronEventListMinFields = {
  __typename?: 'PatronEventList_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventPasscode?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  startSelling?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  stopSelling?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};

/** Ordering options when selecting data from "event.v_patron_events_list". */
export type TixPatronEventListOrderBy = {
  Company?: InputMaybe<TixCompanyOrderBy>;
  Metrics?: InputMaybe<TixTicketVTicketSalesMetricsOrderBy>;
  Performers_aggregate?: InputMaybe<TixEventPerformersAggregateOrderBy>;
  Tickets_aggregate?: InputMaybe<TixVenueTicketAggregateOrderBy>;
  Venue?: InputMaybe<TixVenueOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  day?: InputMaybe<TixOrderBy>;
  doorsOpen?: InputMaybe<TixOrderBy>;
  endTime?: InputMaybe<TixOrderBy>;
  eventAdditionalInfo?: InputMaybe<TixOrderBy>;
  eventDescription?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventPasscode?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  hidden?: InputMaybe<TixOrderBy>;
  minimumAge?: InputMaybe<TixOrderBy>;
  month?: InputMaybe<TixOrderBy>;
  overridden?: InputMaybe<TixOrderBy>;
  startSelling?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  startSellingTime?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  stopSelling?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  stopSellingTime?: InputMaybe<TixOrderBy>;
  venueCity?: InputMaybe<TixOrderBy>;
  venueCityStateProvince?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueStateProvince?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
  year?: InputMaybe<TixOrderBy>;
};

/** select columns of table "event.v_patron_events_list" */
export enum TixPatronEventListSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  DoorsOpen = 'doorsOpen',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EventAdditionalInfo = 'eventAdditionalInfo',
  /** column name */
  EventDescription = 'eventDescription',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventPasscode = 'eventPasscode',
  /** column name */
  EventState = 'eventState',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  Month = 'month',
  /** column name */
  Overridden = 'overridden',
  /** column name */
  StartSelling = 'startSelling',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StopSelling = 'stopSelling',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  VenueCity = 'venueCity',
  /** column name */
  VenueCityStateProvince = 'venueCityStateProvince',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  VenueStateProvince = 'venueStateProvince',
  /** column name */
  VenueTicketId = 'venueTicketId',
  /** column name */
  Year = 'year'
}

/** aggregate stddev on columns */
export type TixPatronEventListStddevFields = {
  __typename?: 'PatronEventList_stddev_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixPatronEventListStddevPopFields = {
  __typename?: 'PatronEventList_stddev_pop_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixPatronEventListStddevSampFields = {
  __typename?: 'PatronEventList_stddev_samp_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PatronEventList" */
export type TixPatronEventListStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPatronEventListStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPatronEventListStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  day?: InputMaybe<Scalars['float8']>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  eventAdditionalInfo?: InputMaybe<Scalars['String']>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPasscode?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['float8']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  startSelling?: InputMaybe<Scalars['String']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  startTime?: InputMaybe<Scalars['time']>;
  stopSelling?: InputMaybe<Scalars['String']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  venueCity?: InputMaybe<Scalars['String']>;
  venueCityStateProvince?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  venueStateProvince?: InputMaybe<Scalars['String']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
  year?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type TixPatronEventListSumFields = {
  __typename?: 'PatronEventList_sum_fields';
  day?: Maybe<Scalars['float8']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type TixPatronEventListVarPopFields = {
  __typename?: 'PatronEventList_var_pop_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixPatronEventListVarSampFields = {
  __typename?: 'PatronEventList_var_samp_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixPatronEventListVarianceFields = {
  __typename?: 'PatronEventList_variance_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsList = {
  __typename?: 'PatronFIlteredEventsList';
  /** An object relationship */
  Company?: Maybe<TixCompany>;
  /** An array relationship */
  Media: Array<TixEventInstanceMedialFile>;
  /** An aggregate relationship */
  Media_aggregate: TixEventInstanceMedialFileAggregate;
  /** An object relationship */
  Metrics?: Maybe<TixTicketVTicketSalesMetrics>;
  /** An array relationship */
  Performers: Array<TixEventPerformers>;
  /** An aggregate relationship */
  Performers_aggregate: TixEventPerformersAggregate;
  /** An array relationship */
  SocialMedia: Array<TixEventInstanceSocialMediaFile>;
  /** An aggregate relationship */
  SocialMedia_aggregate: TixEventInstanceSocialMediaFileAggregate;
  /** An array relationship */
  TicketCountsByType: Array<TixTicketVTicketCountByType>;
  /** An aggregate relationship */
  TicketCountsByType_aggregate: TixTicketVTicketCountByTypeAggregate;
  /** An array relationship */
  Tickets: Array<TixEventInstanceTicket>;
  /** An aggregate relationship */
  Tickets_aggregate: TixEventInstanceTicketAggregate;
  /** An object relationship */
  Venue?: Maybe<TixVenue>;
  /** An array relationship */
  VenueTickets: Array<TixVenueTicket>;
  /** An aggregate relationship */
  VenueTickets_aggregate: TixVenueTicketAggregate;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  doorsOpen?: Maybe<Scalars['time']>;
  endTime?: Maybe<Scalars['time']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  event_passcode?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  hidden?: Maybe<Scalars['Boolean']>;
  mediaFileType?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['uuid']>;
  mediaLocation?: Maybe<Scalars['String']>;
  mediaState?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  overridden?: Maybe<Scalars['Boolean']>;
  startSelling?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  startSellingTime?: Maybe<Scalars['time']>;
  startTime?: Maybe<Scalars['time']>;
  stopSelling?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  stopSellingTime?: Maybe<Scalars['time']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListMediaArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListTicketCountsByTypeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketCountByTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketCountByTypeOrderBy>>;
  where?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListTicketCountsByTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketCountByTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketCountByTypeOrderBy>>;
  where?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListTicketsArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListTicketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListVenueTicketsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


/** filtered list of events used for the patron page.  it is filtered for all active events with can be sold based on start selling date and end selling date. */
export type TixPatronFIlteredEventsListVenueTicketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};

/** aggregated selection of "event.v_patron_filtered_events_list" */
export type TixPatronFIlteredEventsListAggregate = {
  __typename?: 'PatronFIlteredEventsList_aggregate';
  aggregate?: Maybe<TixPatronFIlteredEventsListAggregateFields>;
  nodes: Array<TixPatronFIlteredEventsList>;
};

/** aggregate fields of "event.v_patron_filtered_events_list" */
export type TixPatronFIlteredEventsListAggregateFields = {
  __typename?: 'PatronFIlteredEventsList_aggregate_fields';
  avg?: Maybe<TixPatronFIlteredEventsListAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixPatronFIlteredEventsListMaxFields>;
  min?: Maybe<TixPatronFIlteredEventsListMinFields>;
  stddev?: Maybe<TixPatronFIlteredEventsListStddevFields>;
  stddev_pop?: Maybe<TixPatronFIlteredEventsListStddevPopFields>;
  stddev_samp?: Maybe<TixPatronFIlteredEventsListStddevSampFields>;
  sum?: Maybe<TixPatronFIlteredEventsListSumFields>;
  var_pop?: Maybe<TixPatronFIlteredEventsListVarPopFields>;
  var_samp?: Maybe<TixPatronFIlteredEventsListVarSampFields>;
  variance?: Maybe<TixPatronFIlteredEventsListVarianceFields>;
};


/** aggregate fields of "event.v_patron_filtered_events_list" */
export type TixPatronFIlteredEventsListAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPatronFIlteredEventsListSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixPatronFIlteredEventsListAvgFields = {
  __typename?: 'PatronFIlteredEventsList_avg_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event.v_patron_filtered_events_list". All fields are combined with a logical 'AND'. */
export type TixPatronFIlteredEventsListBoolExp = {
  Company?: InputMaybe<TixCompanyBoolExp>;
  Media?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
  Media_aggregate?: InputMaybe<TixEventInstanceMedialFileAggregateBoolExp>;
  Metrics?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
  Performers?: InputMaybe<TixEventPerformersBoolExp>;
  Performers_aggregate?: InputMaybe<TixEventPerformersAggregateBoolExp>;
  SocialMedia?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
  SocialMedia_aggregate?: InputMaybe<TixEventInstanceSocialMediaFileAggregateBoolExp>;
  TicketCountsByType?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
  TicketCountsByType_aggregate?: InputMaybe<TixTicketVTicketCountByTypeAggregateBoolExp>;
  Tickets?: InputMaybe<TixEventInstanceTicketBoolExp>;
  Tickets_aggregate?: InputMaybe<TixEventInstanceTicketAggregateBoolExp>;
  Venue?: InputMaybe<TixVenueBoolExp>;
  VenueTickets?: InputMaybe<TixVenueTicketBoolExp>;
  VenueTickets_aggregate?: InputMaybe<TixVenueTicketAggregateBoolExp>;
  _and?: InputMaybe<Array<TixPatronFIlteredEventsListBoolExp>>;
  _not?: InputMaybe<TixPatronFIlteredEventsListBoolExp>;
  _or?: InputMaybe<Array<TixPatronFIlteredEventsListBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  date?: InputMaybe<TixStringComparisonExp>;
  day?: InputMaybe<TixFloat8ComparisonExp>;
  doorsOpen?: InputMaybe<TixTimeComparisonExp>;
  endTime?: InputMaybe<TixTimeComparisonExp>;
  eventAdditionalInfo?: InputMaybe<TixStringComparisonExp>;
  eventDescription?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  eventType?: InputMaybe<TixStringComparisonExp>;
  event_passcode?: InputMaybe<TixStringComparisonExp>;
  filterDate?: InputMaybe<TixDateComparisonExp>;
  hidden?: InputMaybe<TixBooleanComparisonExp>;
  mediaFileType?: InputMaybe<TixStringComparisonExp>;
  mediaId?: InputMaybe<TixUuidComparisonExp>;
  mediaLocation?: InputMaybe<TixStringComparisonExp>;
  mediaState?: InputMaybe<TixStringComparisonExp>;
  minimumAge?: InputMaybe<TixIntComparisonExp>;
  month?: InputMaybe<TixFloat8ComparisonExp>;
  overridden?: InputMaybe<TixBooleanComparisonExp>;
  startSelling?: InputMaybe<TixStringComparisonExp>;
  startSellingDate?: InputMaybe<TixDateComparisonExp>;
  startSellingTime?: InputMaybe<TixTimeComparisonExp>;
  startTime?: InputMaybe<TixTimeComparisonExp>;
  stopSelling?: InputMaybe<TixStringComparisonExp>;
  stopSellingDate?: InputMaybe<TixDateComparisonExp>;
  stopSellingTime?: InputMaybe<TixTimeComparisonExp>;
  venueCity?: InputMaybe<TixStringComparisonExp>;
  venueCityStateProvince?: InputMaybe<TixStringComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  venueStateProvince?: InputMaybe<TixStringComparisonExp>;
  venueTicketId?: InputMaybe<TixUuidComparisonExp>;
  year?: InputMaybe<TixFloat8ComparisonExp>;
};

/** aggregate max on columns */
export type TixPatronFIlteredEventsListMaxFields = {
  __typename?: 'PatronFIlteredEventsList_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  event_passcode?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  mediaFileType?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['uuid']>;
  mediaLocation?: Maybe<Scalars['String']>;
  mediaState?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  startSelling?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  stopSelling?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type TixPatronFIlteredEventsListMinFields = {
  __typename?: 'PatronFIlteredEventsList_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['float8']>;
  eventAdditionalInfo?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  event_passcode?: Maybe<Scalars['String']>;
  filterDate?: Maybe<Scalars['date']>;
  mediaFileType?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['uuid']>;
  mediaLocation?: Maybe<Scalars['String']>;
  mediaState?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  startSelling?: Maybe<Scalars['String']>;
  startSellingDate?: Maybe<Scalars['date']>;
  stopSelling?: Maybe<Scalars['String']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCityStateProvince?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueStateProvince?: Maybe<Scalars['String']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['float8']>;
};

/** Ordering options when selecting data from "event.v_patron_filtered_events_list". */
export type TixPatronFIlteredEventsListOrderBy = {
  Company?: InputMaybe<TixCompanyOrderBy>;
  Media_aggregate?: InputMaybe<TixEventInstanceMedialFileAggregateOrderBy>;
  Metrics?: InputMaybe<TixTicketVTicketSalesMetricsOrderBy>;
  Performers_aggregate?: InputMaybe<TixEventPerformersAggregateOrderBy>;
  SocialMedia_aggregate?: InputMaybe<TixEventInstanceSocialMediaFileAggregateOrderBy>;
  TicketCountsByType_aggregate?: InputMaybe<TixTicketVTicketCountByTypeAggregateOrderBy>;
  Tickets_aggregate?: InputMaybe<TixEventInstanceTicketAggregateOrderBy>;
  Venue?: InputMaybe<TixVenueOrderBy>;
  VenueTickets_aggregate?: InputMaybe<TixVenueTicketAggregateOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  day?: InputMaybe<TixOrderBy>;
  doorsOpen?: InputMaybe<TixOrderBy>;
  endTime?: InputMaybe<TixOrderBy>;
  eventAdditionalInfo?: InputMaybe<TixOrderBy>;
  eventDescription?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  event_passcode?: InputMaybe<TixOrderBy>;
  filterDate?: InputMaybe<TixOrderBy>;
  hidden?: InputMaybe<TixOrderBy>;
  mediaFileType?: InputMaybe<TixOrderBy>;
  mediaId?: InputMaybe<TixOrderBy>;
  mediaLocation?: InputMaybe<TixOrderBy>;
  mediaState?: InputMaybe<TixOrderBy>;
  minimumAge?: InputMaybe<TixOrderBy>;
  month?: InputMaybe<TixOrderBy>;
  overridden?: InputMaybe<TixOrderBy>;
  startSelling?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  startSellingTime?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  stopSelling?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  stopSellingTime?: InputMaybe<TixOrderBy>;
  venueCity?: InputMaybe<TixOrderBy>;
  venueCityStateProvince?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueStateProvince?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
  year?: InputMaybe<TixOrderBy>;
};

/** select columns of table "event.v_patron_filtered_events_list" */
export enum TixPatronFIlteredEventsListSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  DoorsOpen = 'doorsOpen',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EventAdditionalInfo = 'eventAdditionalInfo',
  /** column name */
  EventDescription = 'eventDescription',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventState = 'eventState',
  /** column name */
  EventType = 'eventType',
  /** column name */
  EventPasscode = 'event_passcode',
  /** column name */
  FilterDate = 'filterDate',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  MediaFileType = 'mediaFileType',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  MediaLocation = 'mediaLocation',
  /** column name */
  MediaState = 'mediaState',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  Month = 'month',
  /** column name */
  Overridden = 'overridden',
  /** column name */
  StartSelling = 'startSelling',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StopSelling = 'stopSelling',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  VenueCity = 'venueCity',
  /** column name */
  VenueCityStateProvince = 'venueCityStateProvince',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  VenueStateProvince = 'venueStateProvince',
  /** column name */
  VenueTicketId = 'venueTicketId',
  /** column name */
  Year = 'year'
}

/** aggregate stddev on columns */
export type TixPatronFIlteredEventsListStddevFields = {
  __typename?: 'PatronFIlteredEventsList_stddev_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixPatronFIlteredEventsListStddevPopFields = {
  __typename?: 'PatronFIlteredEventsList_stddev_pop_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixPatronFIlteredEventsListStddevSampFields = {
  __typename?: 'PatronFIlteredEventsList_stddev_samp_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PatronFIlteredEventsList" */
export type TixPatronFIlteredEventsListStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPatronFIlteredEventsListStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPatronFIlteredEventsListStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  day?: InputMaybe<Scalars['float8']>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  eventAdditionalInfo?: InputMaybe<Scalars['String']>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  event_passcode?: InputMaybe<Scalars['String']>;
  filterDate?: InputMaybe<Scalars['date']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  mediaFileType?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['uuid']>;
  mediaLocation?: InputMaybe<Scalars['String']>;
  mediaState?: InputMaybe<Scalars['String']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['float8']>;
  overridden?: InputMaybe<Scalars['Boolean']>;
  startSelling?: InputMaybe<Scalars['String']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  startTime?: InputMaybe<Scalars['time']>;
  stopSelling?: InputMaybe<Scalars['String']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  venueCity?: InputMaybe<Scalars['String']>;
  venueCityStateProvince?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  venueStateProvince?: InputMaybe<Scalars['String']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
  year?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type TixPatronFIlteredEventsListSumFields = {
  __typename?: 'PatronFIlteredEventsList_sum_fields';
  day?: Maybe<Scalars['float8']>;
  minimumAge?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['float8']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type TixPatronFIlteredEventsListVarPopFields = {
  __typename?: 'PatronFIlteredEventsList_var_pop_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixPatronFIlteredEventsListVarSampFields = {
  __typename?: 'PatronFIlteredEventsList_var_samp_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixPatronFIlteredEventsListVarianceFields = {
  __typename?: 'PatronFIlteredEventsList_variance_fields';
  day?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "payment.payment" */
export type TixPayment = {
  __typename?: 'Payment';
  /** An object relationship */
  Contact?: Maybe<TixContact>;
  /** An object relationship */
  Discount?: Maybe<TixPaymentDiscount>;
  /** An object relationship */
  Reservation?: Maybe<TixReservationPayment>;
  /** An object relationship */
  VendorPaymentLog?: Maybe<TixPaymentVendorLog>;
  active: Scalars['Boolean'];
  cardToken?: Maybe<Scalars['String']>;
  /** An array relationship */
  children: Array<TixPayment>;
  /** An aggregate relationship */
  children_aggregate: TixPaymentAggregate;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  paymentId: Scalars['uuid'];
  paymentPoolId?: Maybe<Scalars['uuid']>;
  paymentProvider: Scalars['String'];
  paymentResponse?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  refundAmount?: Maybe<Scalars['money']>;
  state: Scalars['String'];
  totalAmount: Scalars['money'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "payment.payment" */
export type TixPaymentChildrenArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentOrderBy>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};


/** columns and relationships of "payment.payment" */
export type TixPaymentChildrenAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentOrderBy>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};

/** columns and relationships of "payment.payment_discount" */
export type TixPaymentDiscount = {
  __typename?: 'PaymentDiscount';
  /** An object relationship */
  Discount?: Maybe<TixDiscount>;
  /** An object relationship */
  Payment?: Maybe<TixPayment>;
  /** An array relationship */
  Payments: Array<TixPayment>;
  /** An aggregate relationship */
  Payments_aggregate: TixPaymentAggregate;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  discountId: Scalars['uuid'];
  paymentDiscountId: Scalars['uuid'];
  paymentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "payment.payment_discount" */
export type TixPaymentDiscountPaymentsArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentOrderBy>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};


/** columns and relationships of "payment.payment_discount" */
export type TixPaymentDiscountPaymentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentOrderBy>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};

/** aggregated selection of "payment.payment_discount" */
export type TixPaymentDiscountAggregate = {
  __typename?: 'PaymentDiscount_aggregate';
  aggregate?: Maybe<TixPaymentDiscountAggregateFields>;
  nodes: Array<TixPaymentDiscount>;
};

/** aggregate fields of "payment.payment_discount" */
export type TixPaymentDiscountAggregateFields = {
  __typename?: 'PaymentDiscount_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixPaymentDiscountMaxFields>;
  min?: Maybe<TixPaymentDiscountMinFields>;
};


/** aggregate fields of "payment.payment_discount" */
export type TixPaymentDiscountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPaymentDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment.payment_discount". All fields are combined with a logical 'AND'. */
export type TixPaymentDiscountBoolExp = {
  Discount?: InputMaybe<TixDiscountBoolExp>;
  Payment?: InputMaybe<TixPaymentBoolExp>;
  Payments?: InputMaybe<TixPaymentBoolExp>;
  Payments_aggregate?: InputMaybe<TixPaymentAggregateBoolExp>;
  _and?: InputMaybe<Array<TixPaymentDiscountBoolExp>>;
  _not?: InputMaybe<TixPaymentDiscountBoolExp>;
  _or?: InputMaybe<Array<TixPaymentDiscountBoolExp>>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  discountId?: InputMaybe<TixUuidComparisonExp>;
  paymentDiscountId?: InputMaybe<TixUuidComparisonExp>;
  paymentId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "payment.payment_discount" */
export enum TixPaymentDiscountConstraint {
  /** unique or primary key constraint on columns "payment_discount_id" */
  PaymentDiscountPkey = 'payment_discount_pkey'
}

/** input type for inserting data into table "payment.payment_discount" */
export type TixPaymentDiscountInsertInput = {
  Discount?: InputMaybe<TixDiscountObjRelInsertInput>;
  Payment?: InputMaybe<TixPaymentObjRelInsertInput>;
  Payments?: InputMaybe<TixPaymentArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  paymentDiscountId?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixPaymentDiscountMaxFields = {
  __typename?: 'PaymentDiscount_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  paymentDiscountId?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixPaymentDiscountMinFields = {
  __typename?: 'PaymentDiscount_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  paymentDiscountId?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "payment.payment_discount" */
export type TixPaymentDiscountMutationResponse = {
  __typename?: 'PaymentDiscount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPaymentDiscount>;
};

/** input type for inserting object relation for remote table "payment.payment_discount" */
export type TixPaymentDiscountObjRelInsertInput = {
  data: TixPaymentDiscountInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPaymentDiscountOnConflict>;
};

/** on_conflict condition type for table "payment.payment_discount" */
export type TixPaymentDiscountOnConflict = {
  constraint: TixPaymentDiscountConstraint;
  update_columns?: Array<TixPaymentDiscountUpdateColumn>;
  where?: InputMaybe<TixPaymentDiscountBoolExp>;
};

/** Ordering options when selecting data from "payment.payment_discount". */
export type TixPaymentDiscountOrderBy = {
  Discount?: InputMaybe<TixDiscountOrderBy>;
  Payment?: InputMaybe<TixPaymentOrderBy>;
  Payments_aggregate?: InputMaybe<TixPaymentAggregateOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  paymentDiscountId?: InputMaybe<TixOrderBy>;
  paymentId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: payment.payment_discount */
export type TixPaymentDiscountPkColumnsInput = {
  paymentDiscountId: Scalars['uuid'];
};

/** select columns of table "payment.payment_discount" */
export enum TixPaymentDiscountSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  PaymentDiscountId = 'paymentDiscountId',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment.payment_discount" */
export type TixPaymentDiscountSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  paymentDiscountId?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "PaymentDiscount" */
export type TixPaymentDiscountStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPaymentDiscountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPaymentDiscountStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  paymentDiscountId?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "payment.payment_discount" */
export enum TixPaymentDiscountUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  PaymentDiscountId = 'paymentDiscountId',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixPaymentDiscountUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPaymentDiscountSetInput>;
  /** filter the rows which have to be updated */
  where: TixPaymentDiscountBoolExp;
};

export type TixPaymentIntentResult = {
  __typename?: 'PaymentIntentResult';
  clientSecret: Scalars['String'];
  paymentIntentId: Scalars['String'];
};

export enum TixPaymentMethod {
  StripeOnline = 'stripe_online',
  StripeTerminal = 'stripe_terminal'
}

/** columns and relationships of "payment.vendor_payment_log" */
export type TixPaymentVendorLog = {
  __typename?: 'PaymentVendorLog';
  amount?: Maybe<Scalars['money']>;
  amountRefunded?: Maybe<Scalars['money']>;
  captured?: Maybe<Scalars['Boolean']>;
  cardAVSZipStatus?: Maybe<Scalars['String']>;
  cardAddressZip?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardCVCStatus?: Maybe<Scalars['String']>;
  cardExpMonth?: Maybe<Scalars['numeric']>;
  cardExpYear?: Maybe<Scalars['numeric']>;
  cardFingerPrint?: Maybe<Scalars['String']>;
  cardFunding?: Maybe<Scalars['String']>;
  cardId?: Maybe<Scalars['String']>;
  cardIssueCountry?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  convertedAmount?: Maybe<Scalars['money']>;
  convertedAmountRefunded?: Maybe<Scalars['money']>;
  convertedCurrency?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customerDescription?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['money']>;
  id?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentSourceType?: Maybe<Scalars['String']>;
  sellerMessage?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['money']>;
  transfer?: Maybe<Scalars['String']>;
  transferGroup?: Maybe<Scalars['String']>;
  vendorPaymentLogId: Scalars['uuid'];
};

/** aggregated selection of "payment.vendor_payment_log" */
export type TixPaymentVendorLogAggregate = {
  __typename?: 'PaymentVendorLog_aggregate';
  aggregate?: Maybe<TixPaymentVendorLogAggregateFields>;
  nodes: Array<TixPaymentVendorLog>;
};

/** aggregate fields of "payment.vendor_payment_log" */
export type TixPaymentVendorLogAggregateFields = {
  __typename?: 'PaymentVendorLog_aggregate_fields';
  avg?: Maybe<TixPaymentVendorLogAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixPaymentVendorLogMaxFields>;
  min?: Maybe<TixPaymentVendorLogMinFields>;
  stddev?: Maybe<TixPaymentVendorLogStddevFields>;
  stddev_pop?: Maybe<TixPaymentVendorLogStddevPopFields>;
  stddev_samp?: Maybe<TixPaymentVendorLogStddevSampFields>;
  sum?: Maybe<TixPaymentVendorLogSumFields>;
  var_pop?: Maybe<TixPaymentVendorLogVarPopFields>;
  var_samp?: Maybe<TixPaymentVendorLogVarSampFields>;
  variance?: Maybe<TixPaymentVendorLogVarianceFields>;
};


/** aggregate fields of "payment.vendor_payment_log" */
export type TixPaymentVendorLogAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPaymentVendorLogSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixPaymentVendorLogAvgFields = {
  __typename?: 'PaymentVendorLog_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  cardExpMonth?: Maybe<Scalars['Float']>;
  cardExpYear?: Maybe<Scalars['Float']>;
  convertedAmount?: Maybe<Scalars['Float']>;
  convertedAmountRefunded?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "payment.vendor_payment_log". All fields are combined with a logical 'AND'. */
export type TixPaymentVendorLogBoolExp = {
  _and?: InputMaybe<Array<TixPaymentVendorLogBoolExp>>;
  _not?: InputMaybe<TixPaymentVendorLogBoolExp>;
  _or?: InputMaybe<Array<TixPaymentVendorLogBoolExp>>;
  amount?: InputMaybe<TixMoneyComparisonExp>;
  amountRefunded?: InputMaybe<TixMoneyComparisonExp>;
  captured?: InputMaybe<TixBooleanComparisonExp>;
  cardAVSZipStatus?: InputMaybe<TixStringComparisonExp>;
  cardAddressZip?: InputMaybe<TixStringComparisonExp>;
  cardBrand?: InputMaybe<TixStringComparisonExp>;
  cardCVCStatus?: InputMaybe<TixStringComparisonExp>;
  cardExpMonth?: InputMaybe<TixNumericComparisonExp>;
  cardExpYear?: InputMaybe<TixNumericComparisonExp>;
  cardFingerPrint?: InputMaybe<TixStringComparisonExp>;
  cardFunding?: InputMaybe<TixStringComparisonExp>;
  cardId?: InputMaybe<TixStringComparisonExp>;
  cardIssueCountry?: InputMaybe<TixStringComparisonExp>;
  cardLast4?: InputMaybe<TixStringComparisonExp>;
  convertedAmount?: InputMaybe<TixMoneyComparisonExp>;
  convertedAmountRefunded?: InputMaybe<TixMoneyComparisonExp>;
  convertedCurrency?: InputMaybe<TixStringComparisonExp>;
  created?: InputMaybe<TixTimestampComparisonExp>;
  created_at?: InputMaybe<TixTimestamptzComparisonExp>;
  created_by?: InputMaybe<TixStringComparisonExp>;
  currency?: InputMaybe<TixStringComparisonExp>;
  customerDescription?: InputMaybe<TixStringComparisonExp>;
  customerEmail?: InputMaybe<TixStringComparisonExp>;
  customerId?: InputMaybe<TixStringComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  fee?: InputMaybe<TixMoneyComparisonExp>;
  id?: InputMaybe<TixStringComparisonExp>;
  mode?: InputMaybe<TixStringComparisonExp>;
  paymentIntentId?: InputMaybe<TixStringComparisonExp>;
  paymentSourceType?: InputMaybe<TixStringComparisonExp>;
  sellerMessage?: InputMaybe<TixStringComparisonExp>;
  statementDescriptor?: InputMaybe<TixStringComparisonExp>;
  status?: InputMaybe<TixStringComparisonExp>;
  tax?: InputMaybe<TixMoneyComparisonExp>;
  transfer?: InputMaybe<TixStringComparisonExp>;
  transferGroup?: InputMaybe<TixStringComparisonExp>;
  vendorPaymentLogId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "payment.vendor_payment_log" */
export enum TixPaymentVendorLogConstraint {
  /** unique or primary key constraint on columns "vendor_payment_log_id" */
  VendorPaymentLogPkey = 'vendor_payment_log_pkey'
}

/** input type for incrementing numeric columns in table "payment.vendor_payment_log" */
export type TixPaymentVendorLogIncInput = {
  amount?: InputMaybe<Scalars['money']>;
  amountRefunded?: InputMaybe<Scalars['money']>;
  cardExpMonth?: InputMaybe<Scalars['numeric']>;
  cardExpYear?: InputMaybe<Scalars['numeric']>;
  convertedAmount?: InputMaybe<Scalars['money']>;
  convertedAmountRefunded?: InputMaybe<Scalars['money']>;
  fee?: InputMaybe<Scalars['money']>;
  tax?: InputMaybe<Scalars['money']>;
};

/** input type for inserting data into table "payment.vendor_payment_log" */
export type TixPaymentVendorLogInsertInput = {
  amount?: InputMaybe<Scalars['money']>;
  amountRefunded?: InputMaybe<Scalars['money']>;
  captured?: InputMaybe<Scalars['Boolean']>;
  cardAVSZipStatus?: InputMaybe<Scalars['String']>;
  cardAddressZip?: InputMaybe<Scalars['String']>;
  cardBrand?: InputMaybe<Scalars['String']>;
  cardCVCStatus?: InputMaybe<Scalars['String']>;
  cardExpMonth?: InputMaybe<Scalars['numeric']>;
  cardExpYear?: InputMaybe<Scalars['numeric']>;
  cardFingerPrint?: InputMaybe<Scalars['String']>;
  cardFunding?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['String']>;
  cardIssueCountry?: InputMaybe<Scalars['String']>;
  cardLast4?: InputMaybe<Scalars['String']>;
  convertedAmount?: InputMaybe<Scalars['money']>;
  convertedAmountRefunded?: InputMaybe<Scalars['money']>;
  convertedCurrency?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customerDescription?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['money']>;
  id?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentSourceType?: InputMaybe<Scalars['String']>;
  sellerMessage?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['money']>;
  transfer?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  vendorPaymentLogId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixPaymentVendorLogMaxFields = {
  __typename?: 'PaymentVendorLog_max_fields';
  amount?: Maybe<Scalars['money']>;
  amountRefunded?: Maybe<Scalars['money']>;
  cardAVSZipStatus?: Maybe<Scalars['String']>;
  cardAddressZip?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardCVCStatus?: Maybe<Scalars['String']>;
  cardExpMonth?: Maybe<Scalars['numeric']>;
  cardExpYear?: Maybe<Scalars['numeric']>;
  cardFingerPrint?: Maybe<Scalars['String']>;
  cardFunding?: Maybe<Scalars['String']>;
  cardId?: Maybe<Scalars['String']>;
  cardIssueCountry?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  convertedAmount?: Maybe<Scalars['money']>;
  convertedAmountRefunded?: Maybe<Scalars['money']>;
  convertedCurrency?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customerDescription?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['money']>;
  id?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentSourceType?: Maybe<Scalars['String']>;
  sellerMessage?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['money']>;
  transfer?: Maybe<Scalars['String']>;
  transferGroup?: Maybe<Scalars['String']>;
  vendorPaymentLogId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixPaymentVendorLogMinFields = {
  __typename?: 'PaymentVendorLog_min_fields';
  amount?: Maybe<Scalars['money']>;
  amountRefunded?: Maybe<Scalars['money']>;
  cardAVSZipStatus?: Maybe<Scalars['String']>;
  cardAddressZip?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardCVCStatus?: Maybe<Scalars['String']>;
  cardExpMonth?: Maybe<Scalars['numeric']>;
  cardExpYear?: Maybe<Scalars['numeric']>;
  cardFingerPrint?: Maybe<Scalars['String']>;
  cardFunding?: Maybe<Scalars['String']>;
  cardId?: Maybe<Scalars['String']>;
  cardIssueCountry?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  convertedAmount?: Maybe<Scalars['money']>;
  convertedAmountRefunded?: Maybe<Scalars['money']>;
  convertedCurrency?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customerDescription?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['money']>;
  id?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentSourceType?: Maybe<Scalars['String']>;
  sellerMessage?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['money']>;
  transfer?: Maybe<Scalars['String']>;
  transferGroup?: Maybe<Scalars['String']>;
  vendorPaymentLogId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "payment.vendor_payment_log" */
export type TixPaymentVendorLogMutationResponse = {
  __typename?: 'PaymentVendorLog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPaymentVendorLog>;
};

/** input type for inserting object relation for remote table "payment.vendor_payment_log" */
export type TixPaymentVendorLogObjRelInsertInput = {
  data: TixPaymentVendorLogInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPaymentVendorLogOnConflict>;
};

/** on_conflict condition type for table "payment.vendor_payment_log" */
export type TixPaymentVendorLogOnConflict = {
  constraint: TixPaymentVendorLogConstraint;
  update_columns?: Array<TixPaymentVendorLogUpdateColumn>;
  where?: InputMaybe<TixPaymentVendorLogBoolExp>;
};

/** Ordering options when selecting data from "payment.vendor_payment_log". */
export type TixPaymentVendorLogOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  amountRefunded?: InputMaybe<TixOrderBy>;
  captured?: InputMaybe<TixOrderBy>;
  cardAVSZipStatus?: InputMaybe<TixOrderBy>;
  cardAddressZip?: InputMaybe<TixOrderBy>;
  cardBrand?: InputMaybe<TixOrderBy>;
  cardCVCStatus?: InputMaybe<TixOrderBy>;
  cardExpMonth?: InputMaybe<TixOrderBy>;
  cardExpYear?: InputMaybe<TixOrderBy>;
  cardFingerPrint?: InputMaybe<TixOrderBy>;
  cardFunding?: InputMaybe<TixOrderBy>;
  cardId?: InputMaybe<TixOrderBy>;
  cardIssueCountry?: InputMaybe<TixOrderBy>;
  cardLast4?: InputMaybe<TixOrderBy>;
  convertedAmount?: InputMaybe<TixOrderBy>;
  convertedAmountRefunded?: InputMaybe<TixOrderBy>;
  convertedCurrency?: InputMaybe<TixOrderBy>;
  created?: InputMaybe<TixOrderBy>;
  created_at?: InputMaybe<TixOrderBy>;
  created_by?: InputMaybe<TixOrderBy>;
  currency?: InputMaybe<TixOrderBy>;
  customerDescription?: InputMaybe<TixOrderBy>;
  customerEmail?: InputMaybe<TixOrderBy>;
  customerId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  fee?: InputMaybe<TixOrderBy>;
  id?: InputMaybe<TixOrderBy>;
  mode?: InputMaybe<TixOrderBy>;
  paymentIntentId?: InputMaybe<TixOrderBy>;
  paymentSourceType?: InputMaybe<TixOrderBy>;
  sellerMessage?: InputMaybe<TixOrderBy>;
  statementDescriptor?: InputMaybe<TixOrderBy>;
  status?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
  transfer?: InputMaybe<TixOrderBy>;
  transferGroup?: InputMaybe<TixOrderBy>;
  vendorPaymentLogId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: payment.vendor_payment_log */
export type TixPaymentVendorLogPkColumnsInput = {
  vendorPaymentLogId: Scalars['uuid'];
};

/** select columns of table "payment.vendor_payment_log" */
export enum TixPaymentVendorLogSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountRefunded = 'amountRefunded',
  /** column name */
  Captured = 'captured',
  /** column name */
  CardAvsZipStatus = 'cardAVSZipStatus',
  /** column name */
  CardAddressZip = 'cardAddressZip',
  /** column name */
  CardBrand = 'cardBrand',
  /** column name */
  CardCvcStatus = 'cardCVCStatus',
  /** column name */
  CardExpMonth = 'cardExpMonth',
  /** column name */
  CardExpYear = 'cardExpYear',
  /** column name */
  CardFingerPrint = 'cardFingerPrint',
  /** column name */
  CardFunding = 'cardFunding',
  /** column name */
  CardId = 'cardId',
  /** column name */
  CardIssueCountry = 'cardIssueCountry',
  /** column name */
  CardLast4 = 'cardLast4',
  /** column name */
  ConvertedAmount = 'convertedAmount',
  /** column name */
  ConvertedAmountRefunded = 'convertedAmountRefunded',
  /** column name */
  ConvertedCurrency = 'convertedCurrency',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerDescription = 'customerDescription',
  /** column name */
  CustomerEmail = 'customerEmail',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Description = 'description',
  /** column name */
  Fee = 'fee',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  PaymentIntentId = 'paymentIntentId',
  /** column name */
  PaymentSourceType = 'paymentSourceType',
  /** column name */
  SellerMessage = 'sellerMessage',
  /** column name */
  StatementDescriptor = 'statementDescriptor',
  /** column name */
  Status = 'status',
  /** column name */
  Tax = 'tax',
  /** column name */
  Transfer = 'transfer',
  /** column name */
  TransferGroup = 'transferGroup',
  /** column name */
  VendorPaymentLogId = 'vendorPaymentLogId'
}

/** input type for updating data in table "payment.vendor_payment_log" */
export type TixPaymentVendorLogSetInput = {
  amount?: InputMaybe<Scalars['money']>;
  amountRefunded?: InputMaybe<Scalars['money']>;
  captured?: InputMaybe<Scalars['Boolean']>;
  cardAVSZipStatus?: InputMaybe<Scalars['String']>;
  cardAddressZip?: InputMaybe<Scalars['String']>;
  cardBrand?: InputMaybe<Scalars['String']>;
  cardCVCStatus?: InputMaybe<Scalars['String']>;
  cardExpMonth?: InputMaybe<Scalars['numeric']>;
  cardExpYear?: InputMaybe<Scalars['numeric']>;
  cardFingerPrint?: InputMaybe<Scalars['String']>;
  cardFunding?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['String']>;
  cardIssueCountry?: InputMaybe<Scalars['String']>;
  cardLast4?: InputMaybe<Scalars['String']>;
  convertedAmount?: InputMaybe<Scalars['money']>;
  convertedAmountRefunded?: InputMaybe<Scalars['money']>;
  convertedCurrency?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customerDescription?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['money']>;
  id?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentSourceType?: InputMaybe<Scalars['String']>;
  sellerMessage?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['money']>;
  transfer?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  vendorPaymentLogId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixPaymentVendorLogStddevFields = {
  __typename?: 'PaymentVendorLog_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  cardExpMonth?: Maybe<Scalars['Float']>;
  cardExpYear?: Maybe<Scalars['Float']>;
  convertedAmount?: Maybe<Scalars['Float']>;
  convertedAmountRefunded?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixPaymentVendorLogStddevPopFields = {
  __typename?: 'PaymentVendorLog_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  cardExpMonth?: Maybe<Scalars['Float']>;
  cardExpYear?: Maybe<Scalars['Float']>;
  convertedAmount?: Maybe<Scalars['Float']>;
  convertedAmountRefunded?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixPaymentVendorLogStddevSampFields = {
  __typename?: 'PaymentVendorLog_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  cardExpMonth?: Maybe<Scalars['Float']>;
  cardExpYear?: Maybe<Scalars['Float']>;
  convertedAmount?: Maybe<Scalars['Float']>;
  convertedAmountRefunded?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PaymentVendorLog" */
export type TixPaymentVendorLogStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPaymentVendorLogStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPaymentVendorLogStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['money']>;
  amountRefunded?: InputMaybe<Scalars['money']>;
  captured?: InputMaybe<Scalars['Boolean']>;
  cardAVSZipStatus?: InputMaybe<Scalars['String']>;
  cardAddressZip?: InputMaybe<Scalars['String']>;
  cardBrand?: InputMaybe<Scalars['String']>;
  cardCVCStatus?: InputMaybe<Scalars['String']>;
  cardExpMonth?: InputMaybe<Scalars['numeric']>;
  cardExpYear?: InputMaybe<Scalars['numeric']>;
  cardFingerPrint?: InputMaybe<Scalars['String']>;
  cardFunding?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['String']>;
  cardIssueCountry?: InputMaybe<Scalars['String']>;
  cardLast4?: InputMaybe<Scalars['String']>;
  convertedAmount?: InputMaybe<Scalars['money']>;
  convertedAmountRefunded?: InputMaybe<Scalars['money']>;
  convertedCurrency?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customerDescription?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['money']>;
  id?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentSourceType?: InputMaybe<Scalars['String']>;
  sellerMessage?: InputMaybe<Scalars['String']>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['money']>;
  transfer?: InputMaybe<Scalars['String']>;
  transferGroup?: InputMaybe<Scalars['String']>;
  vendorPaymentLogId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixPaymentVendorLogSumFields = {
  __typename?: 'PaymentVendorLog_sum_fields';
  amount?: Maybe<Scalars['money']>;
  amountRefunded?: Maybe<Scalars['money']>;
  cardExpMonth?: Maybe<Scalars['numeric']>;
  cardExpYear?: Maybe<Scalars['numeric']>;
  convertedAmount?: Maybe<Scalars['money']>;
  convertedAmountRefunded?: Maybe<Scalars['money']>;
  fee?: Maybe<Scalars['money']>;
  tax?: Maybe<Scalars['money']>;
};

/** update columns of table "payment.vendor_payment_log" */
export enum TixPaymentVendorLogUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountRefunded = 'amountRefunded',
  /** column name */
  Captured = 'captured',
  /** column name */
  CardAvsZipStatus = 'cardAVSZipStatus',
  /** column name */
  CardAddressZip = 'cardAddressZip',
  /** column name */
  CardBrand = 'cardBrand',
  /** column name */
  CardCvcStatus = 'cardCVCStatus',
  /** column name */
  CardExpMonth = 'cardExpMonth',
  /** column name */
  CardExpYear = 'cardExpYear',
  /** column name */
  CardFingerPrint = 'cardFingerPrint',
  /** column name */
  CardFunding = 'cardFunding',
  /** column name */
  CardId = 'cardId',
  /** column name */
  CardIssueCountry = 'cardIssueCountry',
  /** column name */
  CardLast4 = 'cardLast4',
  /** column name */
  ConvertedAmount = 'convertedAmount',
  /** column name */
  ConvertedAmountRefunded = 'convertedAmountRefunded',
  /** column name */
  ConvertedCurrency = 'convertedCurrency',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerDescription = 'customerDescription',
  /** column name */
  CustomerEmail = 'customerEmail',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Description = 'description',
  /** column name */
  Fee = 'fee',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  PaymentIntentId = 'paymentIntentId',
  /** column name */
  PaymentSourceType = 'paymentSourceType',
  /** column name */
  SellerMessage = 'sellerMessage',
  /** column name */
  StatementDescriptor = 'statementDescriptor',
  /** column name */
  Status = 'status',
  /** column name */
  Tax = 'tax',
  /** column name */
  Transfer = 'transfer',
  /** column name */
  TransferGroup = 'transferGroup',
  /** column name */
  VendorPaymentLogId = 'vendorPaymentLogId'
}

export type TixPaymentVendorLogUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixPaymentVendorLogIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPaymentVendorLogSetInput>;
  /** filter the rows which have to be updated */
  where: TixPaymentVendorLogBoolExp;
};

/** aggregate var_pop on columns */
export type TixPaymentVendorLogVarPopFields = {
  __typename?: 'PaymentVendorLog_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  cardExpMonth?: Maybe<Scalars['Float']>;
  cardExpYear?: Maybe<Scalars['Float']>;
  convertedAmount?: Maybe<Scalars['Float']>;
  convertedAmountRefunded?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixPaymentVendorLogVarSampFields = {
  __typename?: 'PaymentVendorLog_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  cardExpMonth?: Maybe<Scalars['Float']>;
  cardExpYear?: Maybe<Scalars['Float']>;
  convertedAmount?: Maybe<Scalars['Float']>;
  convertedAmountRefunded?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixPaymentVendorLogVarianceFields = {
  __typename?: 'PaymentVendorLog_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  cardExpMonth?: Maybe<Scalars['Float']>;
  cardExpYear?: Maybe<Scalars['Float']>;
  convertedAmount?: Maybe<Scalars['Float']>;
  convertedAmountRefunded?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "payment.payment" */
export type TixPaymentAggregate = {
  __typename?: 'Payment_aggregate';
  aggregate?: Maybe<TixPaymentAggregateFields>;
  nodes: Array<TixPayment>;
};

export type TixPaymentAggregateBoolExp = {
  bool_and?: InputMaybe<TixPaymentAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixPaymentAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixPaymentAggregateBoolExpCount>;
};

export type TixPaymentAggregateBoolExpBoolAnd = {
  arguments: TixPaymentSelectColumnPaymentAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixPaymentBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixPaymentAggregateBoolExpBoolOr = {
  arguments: TixPaymentSelectColumnPaymentAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixPaymentBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixPaymentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixPaymentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixPaymentBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "payment.payment" */
export type TixPaymentAggregateFields = {
  __typename?: 'Payment_aggregate_fields';
  avg?: Maybe<TixPaymentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixPaymentMaxFields>;
  min?: Maybe<TixPaymentMinFields>;
  stddev?: Maybe<TixPaymentStddevFields>;
  stddev_pop?: Maybe<TixPaymentStddevPopFields>;
  stddev_samp?: Maybe<TixPaymentStddevSampFields>;
  sum?: Maybe<TixPaymentSumFields>;
  var_pop?: Maybe<TixPaymentVarPopFields>;
  var_samp?: Maybe<TixPaymentVarSampFields>;
  variance?: Maybe<TixPaymentVarianceFields>;
};


/** aggregate fields of "payment.payment" */
export type TixPaymentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPaymentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment.payment" */
export type TixPaymentAggregateOrderBy = {
  avg?: InputMaybe<TixPaymentAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixPaymentMaxOrderBy>;
  min?: InputMaybe<TixPaymentMinOrderBy>;
  stddev?: InputMaybe<TixPaymentStddevOrderBy>;
  stddev_pop?: InputMaybe<TixPaymentStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixPaymentStddevSampOrderBy>;
  sum?: InputMaybe<TixPaymentSumOrderBy>;
  var_pop?: InputMaybe<TixPaymentVarPopOrderBy>;
  var_samp?: InputMaybe<TixPaymentVarSampOrderBy>;
  variance?: InputMaybe<TixPaymentVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "payment.payment" */
export type TixPaymentArrRelInsertInput = {
  data: Array<TixPaymentInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPaymentOnConflict>;
};

/** aggregate avg on columns */
export type TixPaymentAvgFields = {
  __typename?: 'Payment_avg_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment.payment" */
export type TixPaymentAvgOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "payment.payment". All fields are combined with a logical 'AND'. */
export type TixPaymentBoolExp = {
  Contact?: InputMaybe<TixContactBoolExp>;
  Discount?: InputMaybe<TixPaymentDiscountBoolExp>;
  Reservation?: InputMaybe<TixReservationPaymentBoolExp>;
  VendorPaymentLog?: InputMaybe<TixPaymentVendorLogBoolExp>;
  _and?: InputMaybe<Array<TixPaymentBoolExp>>;
  _not?: InputMaybe<TixPaymentBoolExp>;
  _or?: InputMaybe<Array<TixPaymentBoolExp>>;
  active?: InputMaybe<TixBooleanComparisonExp>;
  cardToken?: InputMaybe<TixStringComparisonExp>;
  children?: InputMaybe<TixPaymentBoolExp>;
  children_aggregate?: InputMaybe<TixPaymentAggregateBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  paymentId?: InputMaybe<TixUuidComparisonExp>;
  paymentPoolId?: InputMaybe<TixUuidComparisonExp>;
  paymentProvider?: InputMaybe<TixStringComparisonExp>;
  paymentResponse?: InputMaybe<TixStringComparisonExp>;
  paymentToken?: InputMaybe<TixStringComparisonExp>;
  refundAmount?: InputMaybe<TixMoneyComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  totalAmount?: InputMaybe<TixMoneyComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "payment.payment" */
export enum TixPaymentConstraint {
  /** unique or primary key constraint on columns "payment_id" */
  PaymentPkey = 'payment_pkey'
}

/** input type for incrementing numeric columns in table "payment.payment" */
export type TixPaymentIncInput = {
  refundAmount?: InputMaybe<Scalars['money']>;
  totalAmount?: InputMaybe<Scalars['money']>;
};

/** input type for inserting data into table "payment.payment" */
export type TixPaymentInsertInput = {
  Contact?: InputMaybe<TixContactObjRelInsertInput>;
  Discount?: InputMaybe<TixPaymentDiscountObjRelInsertInput>;
  Reservation?: InputMaybe<TixReservationPaymentObjRelInsertInput>;
  VendorPaymentLog?: InputMaybe<TixPaymentVendorLogObjRelInsertInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  cardToken?: InputMaybe<Scalars['String']>;
  children?: InputMaybe<TixPaymentArrRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  paymentPoolId?: InputMaybe<Scalars['uuid']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
  paymentResponse?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  refundAmount?: InputMaybe<Scalars['money']>;
  state?: InputMaybe<Scalars['String']>;
  totalAmount?: InputMaybe<Scalars['money']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixPaymentMaxFields = {
  __typename?: 'Payment_max_fields';
  cardToken?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  paymentPoolId?: Maybe<Scalars['uuid']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentResponse?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  refundAmount?: Maybe<Scalars['money']>;
  state?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['money']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment.payment" */
export type TixPaymentMaxOrderBy = {
  cardToken?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  paymentId?: InputMaybe<TixOrderBy>;
  paymentPoolId?: InputMaybe<TixOrderBy>;
  paymentProvider?: InputMaybe<TixOrderBy>;
  paymentResponse?: InputMaybe<TixOrderBy>;
  paymentToken?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixPaymentMinFields = {
  __typename?: 'Payment_min_fields';
  cardToken?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  paymentId?: Maybe<Scalars['uuid']>;
  paymentPoolId?: Maybe<Scalars['uuid']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentResponse?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  refundAmount?: Maybe<Scalars['money']>;
  state?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['money']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment.payment" */
export type TixPaymentMinOrderBy = {
  cardToken?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  paymentId?: InputMaybe<TixOrderBy>;
  paymentPoolId?: InputMaybe<TixOrderBy>;
  paymentProvider?: InputMaybe<TixOrderBy>;
  paymentResponse?: InputMaybe<TixOrderBy>;
  paymentToken?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "payment.payment" */
export type TixPaymentMutationResponse = {
  __typename?: 'Payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPayment>;
};

/** input type for inserting object relation for remote table "payment.payment" */
export type TixPaymentObjRelInsertInput = {
  data: TixPaymentInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPaymentOnConflict>;
};

/** on_conflict condition type for table "payment.payment" */
export type TixPaymentOnConflict = {
  constraint: TixPaymentConstraint;
  update_columns?: Array<TixPaymentUpdateColumn>;
  where?: InputMaybe<TixPaymentBoolExp>;
};

/** Ordering options when selecting data from "payment.payment". */
export type TixPaymentOrderBy = {
  Contact?: InputMaybe<TixContactOrderBy>;
  Discount?: InputMaybe<TixPaymentDiscountOrderBy>;
  Reservation?: InputMaybe<TixReservationPaymentOrderBy>;
  VendorPaymentLog?: InputMaybe<TixPaymentVendorLogOrderBy>;
  active?: InputMaybe<TixOrderBy>;
  cardToken?: InputMaybe<TixOrderBy>;
  children_aggregate?: InputMaybe<TixPaymentAggregateOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  paymentId?: InputMaybe<TixOrderBy>;
  paymentPoolId?: InputMaybe<TixOrderBy>;
  paymentProvider?: InputMaybe<TixOrderBy>;
  paymentResponse?: InputMaybe<TixOrderBy>;
  paymentToken?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: payment.payment */
export type TixPaymentPkColumnsInput = {
  paymentId: Scalars['uuid'];
};

/** select columns of table "payment.payment" */
export enum TixPaymentSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CardToken = 'cardToken',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  PaymentPoolId = 'paymentPoolId',
  /** column name */
  PaymentProvider = 'paymentProvider',
  /** column name */
  PaymentResponse = 'paymentResponse',
  /** column name */
  PaymentToken = 'paymentToken',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  State = 'state',
  /** column name */
  TotalAmount = 'totalAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** select "Payment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "payment.payment" */
export enum TixPaymentSelectColumnPaymentAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "Payment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "payment.payment" */
export enum TixPaymentSelectColumnPaymentAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "payment.payment" */
export type TixPaymentSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cardToken?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  paymentPoolId?: InputMaybe<Scalars['uuid']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
  paymentResponse?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  refundAmount?: InputMaybe<Scalars['money']>;
  state?: InputMaybe<Scalars['String']>;
  totalAmount?: InputMaybe<Scalars['money']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixPaymentStddevFields = {
  __typename?: 'Payment_stddev_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment.payment" */
export type TixPaymentStddevOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixPaymentStddevPopFields = {
  __typename?: 'Payment_stddev_pop_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment.payment" */
export type TixPaymentStddevPopOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixPaymentStddevSampFields = {
  __typename?: 'Payment_stddev_samp_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment.payment" */
export type TixPaymentStddevSampOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "Payment" */
export type TixPaymentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPaymentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPaymentStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cardToken?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  paymentPoolId?: InputMaybe<Scalars['uuid']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
  paymentResponse?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  refundAmount?: InputMaybe<Scalars['money']>;
  state?: InputMaybe<Scalars['String']>;
  totalAmount?: InputMaybe<Scalars['money']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixPaymentSumFields = {
  __typename?: 'Payment_sum_fields';
  refundAmount?: Maybe<Scalars['money']>;
  totalAmount?: Maybe<Scalars['money']>;
};

/** order by sum() on columns of table "payment.payment" */
export type TixPaymentSumOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
};

/** update columns of table "payment.payment" */
export enum TixPaymentUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CardToken = 'cardToken',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  PaymentPoolId = 'paymentPoolId',
  /** column name */
  PaymentProvider = 'paymentProvider',
  /** column name */
  PaymentResponse = 'paymentResponse',
  /** column name */
  PaymentToken = 'paymentToken',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  State = 'state',
  /** column name */
  TotalAmount = 'totalAmount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixPaymentUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixPaymentIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPaymentSetInput>;
  /** filter the rows which have to be updated */
  where: TixPaymentBoolExp;
};

/** aggregate var_pop on columns */
export type TixPaymentVarPopFields = {
  __typename?: 'Payment_var_pop_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment.payment" */
export type TixPaymentVarPopOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixPaymentVarSampFields = {
  __typename?: 'Payment_var_samp_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment.payment" */
export type TixPaymentVarSampOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixPaymentVarianceFields = {
  __typename?: 'Payment_variance_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment.payment" */
export type TixPaymentVarianceOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "payment.payout" */
export type TixPayout = {
  __typename?: 'Payout';
  /** An object relationship */
  PayoutCompany: TixCompany;
  /** An array relationship */
  PayoutDetails: Array<TixPayoutDetail>;
  /** An aggregate relationship */
  PayoutDetails_aggregate: TixPayoutDetailAggregate;
  /** An object relationship */
  PayoutVenue: TixVenue;
  comment?: Maybe<Scalars['String']>;
  companyId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  datePaid?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  initiatedAt?: Maybe<Scalars['timestamp']>;
  initiatedBy?: Maybe<Scalars['uuid']>;
  payoutId: Scalars['uuid'];
  payoutReferenceId?: Maybe<Scalars['String']>;
  payout_adjustment?: Maybe<Scalars['money']>;
  state?: Maybe<Scalars['String']>;
  totalPaidOut?: Maybe<Scalars['money']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
  venueId: Scalars['uuid'];
};


/** columns and relationships of "payment.payout" */
export type TixPayoutPayoutDetailsArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutDetailOrderBy>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};


/** columns and relationships of "payment.payout" */
export type TixPayoutPayoutDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutDetailOrderBy>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};

/** columns and relationships of "payment.payout_connection" */
export type TixPayoutConnect = {
  __typename?: 'PayoutConnect';
  accountId: Scalars['String'];
  companyId: Scalars['uuid'];
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  payoutConnectionId: Scalars['uuid'];
  state: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "payment.payout_connection" */
export type TixPayoutConnectAggregate = {
  __typename?: 'PayoutConnect_aggregate';
  aggregate?: Maybe<TixPayoutConnectAggregateFields>;
  nodes: Array<TixPayoutConnect>;
};

/** aggregate fields of "payment.payout_connection" */
export type TixPayoutConnectAggregateFields = {
  __typename?: 'PayoutConnect_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixPayoutConnectMaxFields>;
  min?: Maybe<TixPayoutConnectMinFields>;
};


/** aggregate fields of "payment.payout_connection" */
export type TixPayoutConnectAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPayoutConnectSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment.payout_connection". All fields are combined with a logical 'AND'. */
export type TixPayoutConnectBoolExp = {
  _and?: InputMaybe<Array<TixPayoutConnectBoolExp>>;
  _not?: InputMaybe<TixPayoutConnectBoolExp>;
  _or?: InputMaybe<Array<TixPayoutConnectBoolExp>>;
  accountId?: InputMaybe<TixStringComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  payoutConnectionId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "payment.payout_connection" */
export enum TixPayoutConnectConstraint {
  /** unique or primary key constraint on columns "payout_connection_id" */
  PayoutConnectionPkey = 'payout_connection_pkey'
}

/** input type for inserting data into table "payment.payout_connection" */
export type TixPayoutConnectInsertInput = {
  accountId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  payoutConnectionId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixPayoutConnectMaxFields = {
  __typename?: 'PayoutConnect_max_fields';
  accountId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  payoutConnectionId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixPayoutConnectMinFields = {
  __typename?: 'PayoutConnect_min_fields';
  accountId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  payoutConnectionId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "payment.payout_connection" */
export type TixPayoutConnectMutationResponse = {
  __typename?: 'PayoutConnect_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPayoutConnect>;
};

/** on_conflict condition type for table "payment.payout_connection" */
export type TixPayoutConnectOnConflict = {
  constraint: TixPayoutConnectConstraint;
  update_columns?: Array<TixPayoutConnectUpdateColumn>;
  where?: InputMaybe<TixPayoutConnectBoolExp>;
};

/** Ordering options when selecting data from "payment.payout_connection". */
export type TixPayoutConnectOrderBy = {
  accountId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  payoutConnectionId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: payment.payout_connection */
export type TixPayoutConnectPkColumnsInput = {
  payoutConnectionId: Scalars['uuid'];
};

/** select columns of table "payment.payout_connection" */
export enum TixPayoutConnectSelectColumn {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  PayoutConnectionId = 'payoutConnectionId',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "payment.payout_connection" */
export type TixPayoutConnectSetInput = {
  accountId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  payoutConnectionId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "PayoutConnect" */
export type TixPayoutConnectStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPayoutConnectStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPayoutConnectStreamCursorValueInput = {
  accountId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  payoutConnectionId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "payment.payout_connection" */
export enum TixPayoutConnectUpdateColumn {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  PayoutConnectionId = 'payoutConnectionId',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId'
}

export type TixPayoutConnectUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPayoutConnectSetInput>;
  /** filter the rows which have to be updated */
  where: TixPayoutConnectBoolExp;
};

export type TixPayoutConnectionResult = {
  __typename?: 'PayoutConnectionResult';
  accountId: Scalars['String'];
  redirectUrl: Scalars['String'];
};

/** columns and relationships of "payment.payout_detail" */
export type TixPayoutDetail = {
  __typename?: 'PayoutDetail';
  /** An object relationship */
  Payout: TixPayout;
  /** An object relationship */
  Reservation: TixTicketReservation;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  paidOutAt?: Maybe<Scalars['timestamptz']>;
  payoutDetailId: Scalars['uuid'];
  payoutId: Scalars['uuid'];
  reservationId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** updatedBy */
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "payment.payout_detail" */
export type TixPayoutDetailAggregate = {
  __typename?: 'PayoutDetail_aggregate';
  aggregate?: Maybe<TixPayoutDetailAggregateFields>;
  nodes: Array<TixPayoutDetail>;
};

export type TixPayoutDetailAggregateBoolExp = {
  count?: InputMaybe<TixPayoutDetailAggregateBoolExpCount>;
};

export type TixPayoutDetailAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixPayoutDetailBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "payment.payout_detail" */
export type TixPayoutDetailAggregateFields = {
  __typename?: 'PayoutDetail_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixPayoutDetailMaxFields>;
  min?: Maybe<TixPayoutDetailMinFields>;
};


/** aggregate fields of "payment.payout_detail" */
export type TixPayoutDetailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment.payout_detail" */
export type TixPayoutDetailAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixPayoutDetailMaxOrderBy>;
  min?: InputMaybe<TixPayoutDetailMinOrderBy>;
};

/** input type for inserting array relation for remote table "payment.payout_detail" */
export type TixPayoutDetailArrRelInsertInput = {
  data: Array<TixPayoutDetailInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPayoutDetailOnConflict>;
};

/** Boolean expression to filter rows from the table "payment.payout_detail". All fields are combined with a logical 'AND'. */
export type TixPayoutDetailBoolExp = {
  Payout?: InputMaybe<TixPayoutBoolExp>;
  Reservation?: InputMaybe<TixTicketReservationBoolExp>;
  _and?: InputMaybe<Array<TixPayoutDetailBoolExp>>;
  _not?: InputMaybe<TixPayoutDetailBoolExp>;
  _or?: InputMaybe<Array<TixPayoutDetailBoolExp>>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  paidOutAt?: InputMaybe<TixTimestamptzComparisonExp>;
  payoutDetailId?: InputMaybe<TixUuidComparisonExp>;
  payoutId?: InputMaybe<TixUuidComparisonExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "payment.payout_detail" */
export enum TixPayoutDetailConstraint {
  /** unique or primary key constraint on columns "payout_detail_id" */
  PayoutDetailPkey = 'payout_detail_pkey'
}

/** input type for inserting data into table "payment.payout_detail" */
export type TixPayoutDetailInsertInput = {
  Payout?: InputMaybe<TixPayoutObjRelInsertInput>;
  Reservation?: InputMaybe<TixTicketReservationObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  paidOutAt?: InputMaybe<Scalars['timestamptz']>;
  payoutDetailId?: InputMaybe<Scalars['uuid']>;
  payoutId?: InputMaybe<Scalars['uuid']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** updatedBy */
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixPayoutDetailMaxFields = {
  __typename?: 'PayoutDetail_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  paidOutAt?: Maybe<Scalars['timestamptz']>;
  payoutDetailId?: Maybe<Scalars['uuid']>;
  payoutId?: Maybe<Scalars['uuid']>;
  reservationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** updatedBy */
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment.payout_detail" */
export type TixPayoutDetailMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  paidOutAt?: InputMaybe<TixOrderBy>;
  payoutDetailId?: InputMaybe<TixOrderBy>;
  payoutId?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  /** updatedBy */
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixPayoutDetailMinFields = {
  __typename?: 'PayoutDetail_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  paidOutAt?: Maybe<Scalars['timestamptz']>;
  payoutDetailId?: Maybe<Scalars['uuid']>;
  payoutId?: Maybe<Scalars['uuid']>;
  reservationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** updatedBy */
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment.payout_detail" */
export type TixPayoutDetailMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  paidOutAt?: InputMaybe<TixOrderBy>;
  payoutDetailId?: InputMaybe<TixOrderBy>;
  payoutId?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  /** updatedBy */
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "payment.payout_detail" */
export type TixPayoutDetailMutationResponse = {
  __typename?: 'PayoutDetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPayoutDetail>;
};

/** on_conflict condition type for table "payment.payout_detail" */
export type TixPayoutDetailOnConflict = {
  constraint: TixPayoutDetailConstraint;
  update_columns?: Array<TixPayoutDetailUpdateColumn>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};

/** Ordering options when selecting data from "payment.payout_detail". */
export type TixPayoutDetailOrderBy = {
  Payout?: InputMaybe<TixPayoutOrderBy>;
  Reservation?: InputMaybe<TixTicketReservationOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  paidOutAt?: InputMaybe<TixOrderBy>;
  payoutDetailId?: InputMaybe<TixOrderBy>;
  payoutId?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: payment.payout_detail */
export type TixPayoutDetailPkColumnsInput = {
  payoutDetailId: Scalars['uuid'];
};

/** select columns of table "payment.payout_detail" */
export enum TixPayoutDetailSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  PaidOutAt = 'paidOutAt',
  /** column name */
  PayoutDetailId = 'payoutDetailId',
  /** column name */
  PayoutId = 'payoutId',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment.payout_detail" */
export type TixPayoutDetailSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  paidOutAt?: InputMaybe<Scalars['timestamptz']>;
  payoutDetailId?: InputMaybe<Scalars['uuid']>;
  payoutId?: InputMaybe<Scalars['uuid']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** updatedBy */
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "PayoutDetail" */
export type TixPayoutDetailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPayoutDetailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPayoutDetailStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  paidOutAt?: InputMaybe<Scalars['timestamptz']>;
  payoutDetailId?: InputMaybe<Scalars['uuid']>;
  payoutId?: InputMaybe<Scalars['uuid']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** updatedBy */
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "payment.payout_detail" */
export enum TixPayoutDetailUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  PaidOutAt = 'paidOutAt',
  /** column name */
  PayoutDetailId = 'payoutDetailId',
  /** column name */
  PayoutId = 'payoutId',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixPayoutDetailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPayoutDetailSetInput>;
  /** filter the rows which have to be updated */
  where: TixPayoutDetailBoolExp;
};

/** aggregated selection of "payment.payout" */
export type TixPayoutAggregate = {
  __typename?: 'Payout_aggregate';
  aggregate?: Maybe<TixPayoutAggregateFields>;
  nodes: Array<TixPayout>;
};

export type TixPayoutAggregateBoolExp = {
  count?: InputMaybe<TixPayoutAggregateBoolExpCount>;
};

export type TixPayoutAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixPayoutSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixPayoutBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "payment.payout" */
export type TixPayoutAggregateFields = {
  __typename?: 'Payout_aggregate_fields';
  avg?: Maybe<TixPayoutAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixPayoutMaxFields>;
  min?: Maybe<TixPayoutMinFields>;
  stddev?: Maybe<TixPayoutStddevFields>;
  stddev_pop?: Maybe<TixPayoutStddevPopFields>;
  stddev_samp?: Maybe<TixPayoutStddevSampFields>;
  sum?: Maybe<TixPayoutSumFields>;
  var_pop?: Maybe<TixPayoutVarPopFields>;
  var_samp?: Maybe<TixPayoutVarSampFields>;
  variance?: Maybe<TixPayoutVarianceFields>;
};


/** aggregate fields of "payment.payout" */
export type TixPayoutAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPayoutSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment.payout" */
export type TixPayoutAggregateOrderBy = {
  avg?: InputMaybe<TixPayoutAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixPayoutMaxOrderBy>;
  min?: InputMaybe<TixPayoutMinOrderBy>;
  stddev?: InputMaybe<TixPayoutStddevOrderBy>;
  stddev_pop?: InputMaybe<TixPayoutStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixPayoutStddevSampOrderBy>;
  sum?: InputMaybe<TixPayoutSumOrderBy>;
  var_pop?: InputMaybe<TixPayoutVarPopOrderBy>;
  var_samp?: InputMaybe<TixPayoutVarSampOrderBy>;
  variance?: InputMaybe<TixPayoutVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "payment.payout" */
export type TixPayoutArrRelInsertInput = {
  data: Array<TixPayoutInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPayoutOnConflict>;
};

/** aggregate avg on columns */
export type TixPayoutAvgFields = {
  __typename?: 'Payout_avg_fields';
  payout_adjustment?: Maybe<Scalars['Float']>;
  totalPaidOut?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment.payout" */
export type TixPayoutAvgOrderBy = {
  payout_adjustment?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "payment.payout". All fields are combined with a logical 'AND'. */
export type TixPayoutBoolExp = {
  PayoutCompany?: InputMaybe<TixCompanyBoolExp>;
  PayoutDetails?: InputMaybe<TixPayoutDetailBoolExp>;
  PayoutDetails_aggregate?: InputMaybe<TixPayoutDetailAggregateBoolExp>;
  PayoutVenue?: InputMaybe<TixVenueBoolExp>;
  _and?: InputMaybe<Array<TixPayoutBoolExp>>;
  _not?: InputMaybe<TixPayoutBoolExp>;
  _or?: InputMaybe<Array<TixPayoutBoolExp>>;
  comment?: InputMaybe<TixStringComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  datePaid?: InputMaybe<TixDateComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  initiatedAt?: InputMaybe<TixTimestampComparisonExp>;
  initiatedBy?: InputMaybe<TixUuidComparisonExp>;
  payoutId?: InputMaybe<TixUuidComparisonExp>;
  payoutReferenceId?: InputMaybe<TixStringComparisonExp>;
  payout_adjustment?: InputMaybe<TixMoneyComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  totalPaidOut?: InputMaybe<TixMoneyComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "payment.payout" */
export enum TixPayoutConstraint {
  /** unique or primary key constraint on columns "payout_id" */
  PayoutPkey = 'payout_pkey'
}

/** input type for incrementing numeric columns in table "payment.payout" */
export type TixPayoutIncInput = {
  payout_adjustment?: InputMaybe<Scalars['money']>;
  totalPaidOut?: InputMaybe<Scalars['money']>;
};

/** input type for inserting data into table "payment.payout" */
export type TixPayoutInsertInput = {
  PayoutCompany?: InputMaybe<TixCompanyObjRelInsertInput>;
  PayoutDetails?: InputMaybe<TixPayoutDetailArrRelInsertInput>;
  PayoutVenue?: InputMaybe<TixVenueObjRelInsertInput>;
  comment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  datePaid?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  initiatedAt?: InputMaybe<Scalars['timestamp']>;
  initiatedBy?: InputMaybe<Scalars['uuid']>;
  payoutId?: InputMaybe<Scalars['uuid']>;
  payoutReferenceId?: InputMaybe<Scalars['String']>;
  payout_adjustment?: InputMaybe<Scalars['money']>;
  state?: InputMaybe<Scalars['String']>;
  totalPaidOut?: InputMaybe<Scalars['money']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixPayoutMaxFields = {
  __typename?: 'Payout_max_fields';
  comment?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  datePaid?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  initiatedAt?: Maybe<Scalars['timestamp']>;
  initiatedBy?: Maybe<Scalars['uuid']>;
  payoutId?: Maybe<Scalars['uuid']>;
  payoutReferenceId?: Maybe<Scalars['String']>;
  payout_adjustment?: Maybe<Scalars['money']>;
  state?: Maybe<Scalars['String']>;
  totalPaidOut?: Maybe<Scalars['money']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment.payout" */
export type TixPayoutMaxOrderBy = {
  comment?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  datePaid?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  initiatedAt?: InputMaybe<TixOrderBy>;
  initiatedBy?: InputMaybe<TixOrderBy>;
  payoutId?: InputMaybe<TixOrderBy>;
  payoutReferenceId?: InputMaybe<TixOrderBy>;
  payout_adjustment?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixPayoutMinFields = {
  __typename?: 'Payout_min_fields';
  comment?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  datePaid?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  initiatedAt?: Maybe<Scalars['timestamp']>;
  initiatedBy?: Maybe<Scalars['uuid']>;
  payoutId?: Maybe<Scalars['uuid']>;
  payoutReferenceId?: Maybe<Scalars['String']>;
  payout_adjustment?: Maybe<Scalars['money']>;
  state?: Maybe<Scalars['String']>;
  totalPaidOut?: Maybe<Scalars['money']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment.payout" */
export type TixPayoutMinOrderBy = {
  comment?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  datePaid?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  initiatedAt?: InputMaybe<TixOrderBy>;
  initiatedBy?: InputMaybe<TixOrderBy>;
  payoutId?: InputMaybe<TixOrderBy>;
  payoutReferenceId?: InputMaybe<TixOrderBy>;
  payout_adjustment?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "payment.payout" */
export type TixPayoutMutationResponse = {
  __typename?: 'Payout_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPayout>;
};

/** input type for inserting object relation for remote table "payment.payout" */
export type TixPayoutObjRelInsertInput = {
  data: TixPayoutInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPayoutOnConflict>;
};

/** on_conflict condition type for table "payment.payout" */
export type TixPayoutOnConflict = {
  constraint: TixPayoutConstraint;
  update_columns?: Array<TixPayoutUpdateColumn>;
  where?: InputMaybe<TixPayoutBoolExp>;
};

/** Ordering options when selecting data from "payment.payout". */
export type TixPayoutOrderBy = {
  PayoutCompany?: InputMaybe<TixCompanyOrderBy>;
  PayoutDetails_aggregate?: InputMaybe<TixPayoutDetailAggregateOrderBy>;
  PayoutVenue?: InputMaybe<TixVenueOrderBy>;
  comment?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  datePaid?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  initiatedAt?: InputMaybe<TixOrderBy>;
  initiatedBy?: InputMaybe<TixOrderBy>;
  payoutId?: InputMaybe<TixOrderBy>;
  payoutReferenceId?: InputMaybe<TixOrderBy>;
  payout_adjustment?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: payment.payout */
export type TixPayoutPkColumnsInput = {
  payoutId: Scalars['uuid'];
};

/** select columns of table "payment.payout" */
export enum TixPayoutSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DatePaid = 'datePaid',
  /** column name */
  Description = 'description',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  InitiatedAt = 'initiatedAt',
  /** column name */
  InitiatedBy = 'initiatedBy',
  /** column name */
  PayoutId = 'payoutId',
  /** column name */
  PayoutReferenceId = 'payoutReferenceId',
  /** column name */
  PayoutAdjustment = 'payout_adjustment',
  /** column name */
  State = 'state',
  /** column name */
  TotalPaidOut = 'totalPaidOut',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "payment.payout" */
export type TixPayoutSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  datePaid?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  initiatedAt?: InputMaybe<Scalars['timestamp']>;
  initiatedBy?: InputMaybe<Scalars['uuid']>;
  payoutId?: InputMaybe<Scalars['uuid']>;
  payoutReferenceId?: InputMaybe<Scalars['String']>;
  payout_adjustment?: InputMaybe<Scalars['money']>;
  state?: InputMaybe<Scalars['String']>;
  totalPaidOut?: InputMaybe<Scalars['money']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixPayoutStddevFields = {
  __typename?: 'Payout_stddev_fields';
  payout_adjustment?: Maybe<Scalars['Float']>;
  totalPaidOut?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment.payout" */
export type TixPayoutStddevOrderBy = {
  payout_adjustment?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixPayoutStddevPopFields = {
  __typename?: 'Payout_stddev_pop_fields';
  payout_adjustment?: Maybe<Scalars['Float']>;
  totalPaidOut?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment.payout" */
export type TixPayoutStddevPopOrderBy = {
  payout_adjustment?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixPayoutStddevSampFields = {
  __typename?: 'Payout_stddev_samp_fields';
  payout_adjustment?: Maybe<Scalars['Float']>;
  totalPaidOut?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment.payout" */
export type TixPayoutStddevSampOrderBy = {
  payout_adjustment?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "Payout" */
export type TixPayoutStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPayoutStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPayoutStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  datePaid?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  initiatedAt?: InputMaybe<Scalars['timestamp']>;
  initiatedBy?: InputMaybe<Scalars['uuid']>;
  payoutId?: InputMaybe<Scalars['uuid']>;
  payoutReferenceId?: InputMaybe<Scalars['String']>;
  payout_adjustment?: InputMaybe<Scalars['money']>;
  state?: InputMaybe<Scalars['String']>;
  totalPaidOut?: InputMaybe<Scalars['money']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixPayoutSumFields = {
  __typename?: 'Payout_sum_fields';
  payout_adjustment?: Maybe<Scalars['money']>;
  totalPaidOut?: Maybe<Scalars['money']>;
};

/** order by sum() on columns of table "payment.payout" */
export type TixPayoutSumOrderBy = {
  payout_adjustment?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
};

/** update columns of table "payment.payout" */
export enum TixPayoutUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DatePaid = 'datePaid',
  /** column name */
  Description = 'description',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  InitiatedAt = 'initiatedAt',
  /** column name */
  InitiatedBy = 'initiatedBy',
  /** column name */
  PayoutId = 'payoutId',
  /** column name */
  PayoutReferenceId = 'payoutReferenceId',
  /** column name */
  PayoutAdjustment = 'payout_adjustment',
  /** column name */
  State = 'state',
  /** column name */
  TotalPaidOut = 'totalPaidOut',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId'
}

export type TixPayoutUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixPayoutIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPayoutSetInput>;
  /** filter the rows which have to be updated */
  where: TixPayoutBoolExp;
};

/** aggregate var_pop on columns */
export type TixPayoutVarPopFields = {
  __typename?: 'Payout_var_pop_fields';
  payout_adjustment?: Maybe<Scalars['Float']>;
  totalPaidOut?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment.payout" */
export type TixPayoutVarPopOrderBy = {
  payout_adjustment?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixPayoutVarSampFields = {
  __typename?: 'Payout_var_samp_fields';
  payout_adjustment?: Maybe<Scalars['Float']>;
  totalPaidOut?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment.payout" */
export type TixPayoutVarSampOrderBy = {
  payout_adjustment?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixPayoutVarianceFields = {
  __typename?: 'Payout_variance_fields';
  payout_adjustment?: Maybe<Scalars['Float']>;
  totalPaidOut?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment.payout" */
export type TixPayoutVarianceOrderBy = {
  payout_adjustment?: InputMaybe<TixOrderBy>;
  totalPaidOut?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "performer.performer" */
export type TixPerformer = {
  __typename?: 'Performer';
  additionalInfo?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  eventPerformers: Array<TixEventPerformers>;
  /** An aggregate relationship */
  eventPerformers_aggregate: TixEventPerformersAggregate;
  /** An array relationship */
  lineupPerformers: Array<TixLineupPerformer>;
  /** An aggregate relationship */
  lineupPerformers_aggregate: TixLineupPerformerAggregate;
  name?: Maybe<Scalars['String']>;
  performerId: Scalars['uuid'];
  /** An array relationship */
  phoneNumbers: Array<TixAddressPerformerPhoneNumber>;
  /** An aggregate relationship */
  phoneNumbers_aggregate: TixAddressPerformerPhoneNumberAggregate;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "performer.performer" */
export type TixPerformerEventPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** columns and relationships of "performer.performer" */
export type TixPerformerEventPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


/** columns and relationships of "performer.performer" */
export type TixPerformerLineupPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupPerformerOrderBy>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


/** columns and relationships of "performer.performer" */
export type TixPerformerLineupPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupPerformerOrderBy>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


/** columns and relationships of "performer.performer" */
export type TixPerformerPhoneNumbersArgs = {
  distinct_on?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressPerformerPhoneNumberOrderBy>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};


/** columns and relationships of "performer.performer" */
export type TixPerformerPhoneNumbersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressPerformerPhoneNumberOrderBy>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};

/** aggregated selection of "performer.performer" */
export type TixPerformerAggregate = {
  __typename?: 'Performer_aggregate';
  aggregate?: Maybe<TixPerformerAggregateFields>;
  nodes: Array<TixPerformer>;
};

export type TixPerformerAggregateBoolExp = {
  count?: InputMaybe<TixPerformerAggregateBoolExpCount>;
};

export type TixPerformerAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixPerformerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixPerformerBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "performer.performer" */
export type TixPerformerAggregateFields = {
  __typename?: 'Performer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixPerformerMaxFields>;
  min?: Maybe<TixPerformerMinFields>;
};


/** aggregate fields of "performer.performer" */
export type TixPerformerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPerformerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "performer.performer" */
export type TixPerformerAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixPerformerMaxOrderBy>;
  min?: InputMaybe<TixPerformerMinOrderBy>;
};

/** input type for inserting array relation for remote table "performer.performer" */
export type TixPerformerArrRelInsertInput = {
  data: Array<TixPerformerInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPerformerOnConflict>;
};

/** Boolean expression to filter rows from the table "performer.performer". All fields are combined with a logical 'AND'. */
export type TixPerformerBoolExp = {
  _and?: InputMaybe<Array<TixPerformerBoolExp>>;
  _not?: InputMaybe<TixPerformerBoolExp>;
  _or?: InputMaybe<Array<TixPerformerBoolExp>>;
  additionalInfo?: InputMaybe<TixStringComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  eventPerformers?: InputMaybe<TixEventPerformersBoolExp>;
  eventPerformers_aggregate?: InputMaybe<TixEventPerformersAggregateBoolExp>;
  lineupPerformers?: InputMaybe<TixLineupPerformerBoolExp>;
  lineupPerformers_aggregate?: InputMaybe<TixLineupPerformerAggregateBoolExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  performerId?: InputMaybe<TixUuidComparisonExp>;
  phoneNumbers?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
  phoneNumbers_aggregate?: InputMaybe<TixAddressPerformerPhoneNumberAggregateBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  title?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "performer.performer" */
export enum TixPerformerConstraint {
  /** unique or primary key constraint on columns "performer_id" */
  PerformerPkey = 'performer_pkey'
}

/** input type for inserting data into table "performer.performer" */
export type TixPerformerInsertInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  eventPerformers?: InputMaybe<TixEventPerformersArrRelInsertInput>;
  lineupPerformers?: InputMaybe<TixLineupPerformerArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  performerId?: InputMaybe<Scalars['uuid']>;
  phoneNumbers?: InputMaybe<TixAddressPerformerPhoneNumberArrRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixPerformerMaxFields = {
  __typename?: 'Performer_max_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  performerId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "performer.performer" */
export type TixPerformerMaxOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  title?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixPerformerMinFields = {
  __typename?: 'Performer_min_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  performerId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "performer.performer" */
export type TixPerformerMinOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  title?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "performer.performer" */
export type TixPerformerMutationResponse = {
  __typename?: 'Performer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPerformer>;
};

/** input type for inserting object relation for remote table "performer.performer" */
export type TixPerformerObjRelInsertInput = {
  data: TixPerformerInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPerformerOnConflict>;
};

/** on_conflict condition type for table "performer.performer" */
export type TixPerformerOnConflict = {
  constraint: TixPerformerConstraint;
  update_columns?: Array<TixPerformerUpdateColumn>;
  where?: InputMaybe<TixPerformerBoolExp>;
};

/** Ordering options when selecting data from "performer.performer". */
export type TixPerformerOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  eventPerformers_aggregate?: InputMaybe<TixEventPerformersAggregateOrderBy>;
  lineupPerformers_aggregate?: InputMaybe<TixLineupPerformerAggregateOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  performerId?: InputMaybe<TixOrderBy>;
  phoneNumbers_aggregate?: InputMaybe<TixAddressPerformerPhoneNumberAggregateOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  title?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: performer.performer */
export type TixPerformerPkColumnsInput = {
  performerId: Scalars['uuid'];
};

/** select columns of table "performer.performer" */
export enum TixPerformerSelectColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  PerformerId = 'performerId',
  /** column name */
  State = 'state',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "performer.performer" */
export type TixPerformerSetInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  performerId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Performer" */
export type TixPerformerStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPerformerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPerformerStreamCursorValueInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  performerId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "performer.performer" */
export enum TixPerformerUpdateColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  PerformerId = 'performerId',
  /** column name */
  State = 'state',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixPerformerUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPerformerSetInput>;
  /** filter the rows which have to be updated */
  where: TixPerformerBoolExp;
};

/** columns and relationships of "access.permission" */
export type TixPermission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  permissionId: Scalars['uuid'];
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "access.permission" */
export type TixPermissionAggregate = {
  __typename?: 'Permission_aggregate';
  aggregate?: Maybe<TixPermissionAggregateFields>;
  nodes: Array<TixPermission>;
};

/** aggregate fields of "access.permission" */
export type TixPermissionAggregateFields = {
  __typename?: 'Permission_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixPermissionMaxFields>;
  min?: Maybe<TixPermissionMinFields>;
};


/** aggregate fields of "access.permission" */
export type TixPermissionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPermissionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "access.permission". All fields are combined with a logical 'AND'. */
export type TixPermissionBoolExp = {
  _and?: InputMaybe<Array<TixPermissionBoolExp>>;
  _not?: InputMaybe<TixPermissionBoolExp>;
  _or?: InputMaybe<Array<TixPermissionBoolExp>>;
  description?: InputMaybe<TixStringComparisonExp>;
  permission?: InputMaybe<TixStringComparisonExp>;
  permissionId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  title?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "access.permission" */
export enum TixPermissionConstraint {
  /** unique or primary key constraint on columns "permission_id" */
  PermissionPkey = 'permission_pkey'
}

/** input type for inserting data into table "access.permission" */
export type TixPermissionInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['String']>;
  permissionId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixPermissionMaxFields = {
  __typename?: 'Permission_max_fields';
  description?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  permissionId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixPermissionMinFields = {
  __typename?: 'Permission_min_fields';
  description?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  permissionId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "access.permission" */
export type TixPermissionMutationResponse = {
  __typename?: 'Permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPermission>;
};

/** input type for inserting object relation for remote table "access.permission" */
export type TixPermissionObjRelInsertInput = {
  data: TixPermissionInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPermissionOnConflict>;
};

/** on_conflict condition type for table "access.permission" */
export type TixPermissionOnConflict = {
  constraint: TixPermissionConstraint;
  update_columns?: Array<TixPermissionUpdateColumn>;
  where?: InputMaybe<TixPermissionBoolExp>;
};

/** Ordering options when selecting data from "access.permission". */
export type TixPermissionOrderBy = {
  description?: InputMaybe<TixOrderBy>;
  permission?: InputMaybe<TixOrderBy>;
  permissionId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  title?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: access.permission */
export type TixPermissionPkColumnsInput = {
  permissionId: Scalars['uuid'];
};

/** select columns of table "access.permission" */
export enum TixPermissionSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Permission = 'permission',
  /** column name */
  PermissionId = 'permissionId',
  /** column name */
  State = 'state',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "access.permission" */
export type TixPermissionSetInput = {
  description?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['String']>;
  permissionId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Permission" */
export type TixPermissionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPermissionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPermissionStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['String']>;
  permissionId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "access.permission" */
export enum TixPermissionUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Permission = 'permission',
  /** column name */
  PermissionId = 'permissionId',
  /** column name */
  State = 'state',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixPermissionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPermissionSetInput>;
  /** filter the rows which have to be updated */
  where: TixPermissionBoolExp;
};

/** columns and relationships of "address.phone_number" */
export type TixPhoneNumber = {
  __typename?: 'PhoneNumber';
  /** An array relationship */
  companyPhoneNumbers: Array<TixCompanyPhoneNumber>;
  /** An aggregate relationship */
  companyPhoneNumbers_aggregate: TixCompanyPhoneNumberAggregate;
  /** An array relationship */
  contactPhoneNumbers: Array<TixContactPhoneNumber>;
  /** An aggregate relationship */
  contactPhoneNumbers_aggregate: TixContactPhoneNumberAggregate;
  countryCode?: Maybe<Scalars['String']>;
  /** An array relationship */
  performerPhoneNumbers: Array<TixAddressPerformerPhoneNumber>;
  /** An aggregate relationship */
  performerPhoneNumbers_aggregate: TixAddressPerformerPhoneNumberAggregate;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberId: Scalars['uuid'];
  sameAsCompany?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An array relationship */
  venuePhoneNumbers: Array<TixVenuePhoneNumber>;
  /** An aggregate relationship */
  venuePhoneNumbers_aggregate: TixVenuePhoneNumberAggregate;
};


/** columns and relationships of "address.phone_number" */
export type TixPhoneNumberCompanyPhoneNumbersArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyPhoneNumberOrderBy>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


/** columns and relationships of "address.phone_number" */
export type TixPhoneNumberCompanyPhoneNumbersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyPhoneNumberOrderBy>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


/** columns and relationships of "address.phone_number" */
export type TixPhoneNumberContactPhoneNumbersArgs = {
  distinct_on?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactPhoneNumberOrderBy>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


/** columns and relationships of "address.phone_number" */
export type TixPhoneNumberContactPhoneNumbersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactPhoneNumberOrderBy>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


/** columns and relationships of "address.phone_number" */
export type TixPhoneNumberPerformerPhoneNumbersArgs = {
  distinct_on?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressPerformerPhoneNumberOrderBy>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};


/** columns and relationships of "address.phone_number" */
export type TixPhoneNumberPerformerPhoneNumbersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressPerformerPhoneNumberOrderBy>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};


/** columns and relationships of "address.phone_number" */
export type TixPhoneNumberVenuePhoneNumbersArgs = {
  distinct_on?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenuePhoneNumberOrderBy>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};


/** columns and relationships of "address.phone_number" */
export type TixPhoneNumberVenuePhoneNumbersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenuePhoneNumberOrderBy>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};

/** aggregated selection of "address.phone_number" */
export type TixPhoneNumberAggregate = {
  __typename?: 'PhoneNumber_aggregate';
  aggregate?: Maybe<TixPhoneNumberAggregateFields>;
  nodes: Array<TixPhoneNumber>;
};

/** aggregate fields of "address.phone_number" */
export type TixPhoneNumberAggregateFields = {
  __typename?: 'PhoneNumber_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixPhoneNumberMaxFields>;
  min?: Maybe<TixPhoneNumberMinFields>;
};


/** aggregate fields of "address.phone_number" */
export type TixPhoneNumberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "address.phone_number". All fields are combined with a logical 'AND'. */
export type TixPhoneNumberBoolExp = {
  _and?: InputMaybe<Array<TixPhoneNumberBoolExp>>;
  _not?: InputMaybe<TixPhoneNumberBoolExp>;
  _or?: InputMaybe<Array<TixPhoneNumberBoolExp>>;
  companyPhoneNumbers?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
  companyPhoneNumbers_aggregate?: InputMaybe<TixCompanyPhoneNumberAggregateBoolExp>;
  contactPhoneNumbers?: InputMaybe<TixContactPhoneNumberBoolExp>;
  contactPhoneNumbers_aggregate?: InputMaybe<TixContactPhoneNumberAggregateBoolExp>;
  countryCode?: InputMaybe<TixStringComparisonExp>;
  performerPhoneNumbers?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
  performerPhoneNumbers_aggregate?: InputMaybe<TixAddressPerformerPhoneNumberAggregateBoolExp>;
  phoneNumber?: InputMaybe<TixStringComparisonExp>;
  phoneNumberId?: InputMaybe<TixUuidComparisonExp>;
  sameAsCompany?: InputMaybe<TixBooleanComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venuePhoneNumbers?: InputMaybe<TixVenuePhoneNumberBoolExp>;
  venuePhoneNumbers_aggregate?: InputMaybe<TixVenuePhoneNumberAggregateBoolExp>;
};

/** unique or primary key constraints on table "address.phone_number" */
export enum TixPhoneNumberConstraint {
  /** unique or primary key constraint on columns "phone_number_id" */
  PhoneNumberPkey = 'phone_number_pkey'
}

/** input type for inserting data into table "address.phone_number" */
export type TixPhoneNumberInsertInput = {
  companyPhoneNumbers?: InputMaybe<TixCompanyPhoneNumberArrRelInsertInput>;
  contactPhoneNumbers?: InputMaybe<TixContactPhoneNumberArrRelInsertInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  performerPhoneNumbers?: InputMaybe<TixAddressPerformerPhoneNumberArrRelInsertInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  sameAsCompany?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venuePhoneNumbers?: InputMaybe<TixVenuePhoneNumberArrRelInsertInput>;
};

/** aggregate max on columns */
export type TixPhoneNumberMaxFields = {
  __typename?: 'PhoneNumber_max_fields';
  countryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixPhoneNumberMinFields = {
  __typename?: 'PhoneNumber_min_fields';
  countryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "address.phone_number" */
export type TixPhoneNumberMutationResponse = {
  __typename?: 'PhoneNumber_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixPhoneNumber>;
};

/** input type for inserting object relation for remote table "address.phone_number" */
export type TixPhoneNumberObjRelInsertInput = {
  data: TixPhoneNumberInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixPhoneNumberOnConflict>;
};

/** on_conflict condition type for table "address.phone_number" */
export type TixPhoneNumberOnConflict = {
  constraint: TixPhoneNumberConstraint;
  update_columns?: Array<TixPhoneNumberUpdateColumn>;
  where?: InputMaybe<TixPhoneNumberBoolExp>;
};

/** Ordering options when selecting data from "address.phone_number". */
export type TixPhoneNumberOrderBy = {
  companyPhoneNumbers_aggregate?: InputMaybe<TixCompanyPhoneNumberAggregateOrderBy>;
  contactPhoneNumbers_aggregate?: InputMaybe<TixContactPhoneNumberAggregateOrderBy>;
  countryCode?: InputMaybe<TixOrderBy>;
  performerPhoneNumbers_aggregate?: InputMaybe<TixAddressPerformerPhoneNumberAggregateOrderBy>;
  phoneNumber?: InputMaybe<TixOrderBy>;
  phoneNumberId?: InputMaybe<TixOrderBy>;
  sameAsCompany?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venuePhoneNumbers_aggregate?: InputMaybe<TixVenuePhoneNumberAggregateOrderBy>;
};

/** primary key columns input for table: address.phone_number */
export type TixPhoneNumberPkColumnsInput = {
  phoneNumberId: Scalars['uuid'];
};

/** select columns of table "address.phone_number" */
export enum TixPhoneNumberSelectColumn {
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberId = 'phoneNumberId',
  /** column name */
  SameAsCompany = 'sameAsCompany',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "address.phone_number" */
export type TixPhoneNumberSetInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  sameAsCompany?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "PhoneNumber" */
export type TixPhoneNumberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixPhoneNumberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixPhoneNumberStreamCursorValueInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  sameAsCompany?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.phone_number" */
export enum TixPhoneNumberUpdateColumn {
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberId = 'phoneNumberId',
  /** column name */
  SameAsCompany = 'sameAsCompany',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixPhoneNumberUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixPhoneNumberSetInput>;
  /** filter the rows which have to be updated */
  where: TixPhoneNumberBoolExp;
};

/** columns and relationships of "product.product" */
export type TixProduct = {
  __typename?: 'Product';
  /** An object relationship */
  EventProduct?: Maybe<TixEventProduct>;
  /** An array relationship */
  VenueProduct: Array<TixVenueProduct>;
  /** An aggregate relationship */
  VenueProduct_aggregate: TixVenueProductAggregate;
  additionalInformation?: Maybe<Scalars['String']>;
  /** An object relationship */
  company?: Maybe<TixCompany>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['money']>;
  productId: Scalars['uuid'];
  /** An array relationship */
  productMedia: Array<TixProductMediaFile>;
  /** An aggregate relationship */
  productMedia_aggregate: TixProductMediaFileAggregate;
  quantity?: Maybe<Scalars['Int']>;
  quantity_sold?: Maybe<Scalars['Int']>;
  state: Scalars['String'];
  tax?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "product.product" */
export type TixProductVenueProductArgs = {
  distinct_on?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueProductOrderBy>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


/** columns and relationships of "product.product" */
export type TixProductVenueProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueProductOrderBy>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


/** columns and relationships of "product.product" */
export type TixProductProductMediaArgs = {
  distinct_on?: InputMaybe<Array<TixProductMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductMediaFileOrderBy>>;
  where?: InputMaybe<TixProductMediaFileBoolExp>;
};


/** columns and relationships of "product.product" */
export type TixProductProductMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixProductMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductMediaFileOrderBy>>;
  where?: InputMaybe<TixProductMediaFileBoolExp>;
};

export type TixProductInput = {
  eventProductId: Scalars['String'];
  id: Scalars['String'];
};

/** columns and relationships of "media.product_media_file" */
export type TixProductMediaFile = {
  __typename?: 'ProductMediaFile';
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  /** An object relationship */
  mediaFile?: Maybe<TixMediaFile>;
  mediaFileId: Scalars['uuid'];
  /** An object relationship */
  product?: Maybe<TixProduct>;
  productId: Scalars['uuid'];
  productMediaImageFileId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "media.product_media_file" */
export type TixProductMediaFileAggregate = {
  __typename?: 'ProductMediaFile_aggregate';
  aggregate?: Maybe<TixProductMediaFileAggregateFields>;
  nodes: Array<TixProductMediaFile>;
};

export type TixProductMediaFileAggregateBoolExp = {
  count?: InputMaybe<TixProductMediaFileAggregateBoolExpCount>;
};

export type TixProductMediaFileAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixProductMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixProductMediaFileBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "media.product_media_file" */
export type TixProductMediaFileAggregateFields = {
  __typename?: 'ProductMediaFile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixProductMediaFileMaxFields>;
  min?: Maybe<TixProductMediaFileMinFields>;
};


/** aggregate fields of "media.product_media_file" */
export type TixProductMediaFileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixProductMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media.product_media_file" */
export type TixProductMediaFileAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixProductMediaFileMaxOrderBy>;
  min?: InputMaybe<TixProductMediaFileMinOrderBy>;
};

/** input type for inserting array relation for remote table "media.product_media_file" */
export type TixProductMediaFileArrRelInsertInput = {
  data: Array<TixProductMediaFileInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixProductMediaFileOnConflict>;
};

/** Boolean expression to filter rows from the table "media.product_media_file". All fields are combined with a logical 'AND'. */
export type TixProductMediaFileBoolExp = {
  _and?: InputMaybe<Array<TixProductMediaFileBoolExp>>;
  _not?: InputMaybe<TixProductMediaFileBoolExp>;
  _or?: InputMaybe<Array<TixProductMediaFileBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  mediaFile?: InputMaybe<TixMediaFileBoolExp>;
  mediaFileId?: InputMaybe<TixUuidComparisonExp>;
  product?: InputMaybe<TixProductBoolExp>;
  productId?: InputMaybe<TixUuidComparisonExp>;
  productMediaImageFileId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "media.product_media_file" */
export enum TixProductMediaFileConstraint {
  /** unique or primary key constraint on columns "product_media_image_file_id" */
  ProductMediaFilePkey = 'product_media_file_pkey'
}

/** input type for inserting data into table "media.product_media_file" */
export type TixProductMediaFileInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  mediaFile?: InputMaybe<TixMediaFileObjRelInsertInput>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<TixProductObjRelInsertInput>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMediaImageFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixProductMediaFileMaxFields = {
  __typename?: 'ProductMediaFile_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  productMediaImageFileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "media.product_media_file" */
export type TixProductMediaFileMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  productMediaImageFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixProductMediaFileMinFields = {
  __typename?: 'ProductMediaFile_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  productMediaImageFileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "media.product_media_file" */
export type TixProductMediaFileMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  productMediaImageFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "media.product_media_file" */
export type TixProductMediaFileMutationResponse = {
  __typename?: 'ProductMediaFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixProductMediaFile>;
};

/** input type for inserting object relation for remote table "media.product_media_file" */
export type TixProductMediaFileObjRelInsertInput = {
  data: TixProductMediaFileInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixProductMediaFileOnConflict>;
};

/** on_conflict condition type for table "media.product_media_file" */
export type TixProductMediaFileOnConflict = {
  constraint: TixProductMediaFileConstraint;
  update_columns?: Array<TixProductMediaFileUpdateColumn>;
  where?: InputMaybe<TixProductMediaFileBoolExp>;
};

/** Ordering options when selecting data from "media.product_media_file". */
export type TixProductMediaFileOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  mediaFile?: InputMaybe<TixMediaFileOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  product?: InputMaybe<TixProductOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  productMediaImageFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: media.product_media_file */
export type TixProductMediaFilePkColumnsInput = {
  productMediaImageFileId: Scalars['uuid'];
};

/** select columns of table "media.product_media_file" */
export enum TixProductMediaFileSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProductMediaImageFileId = 'productMediaImageFileId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "media.product_media_file" */
export type TixProductMediaFileSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMediaImageFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ProductMediaFile" */
export type TixProductMediaFileStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixProductMediaFileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixProductMediaFileStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMediaImageFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.product_media_file" */
export enum TixProductMediaFileUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  ProductMediaImageFileId = 'productMediaImageFileId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixProductMediaFileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixProductMediaFileSetInput>;
  /** filter the rows which have to be updated */
  where: TixProductMediaFileBoolExp;
};

/** Available columns for product sales report */
export enum TixProductSalesColumn {
  Comment = 'COMMENT',
  Customer = 'CUSTOMER',
  Email = 'EMAIL',
  Event = 'EVENT',
  OrderId = 'ORDER_ID',
  Price = 'PRICE',
  ProcessingFees = 'PROCESSING_FEES',
  Product = 'PRODUCT',
  ProductType = 'PRODUCT_TYPE',
  PurchaseDate = 'PURCHASE_DATE',
  Quantity = 'QUANTITY',
  ReservationNo = 'RESERVATION_NO',
  State = 'STATE',
  TaxAmount = 'TAX_AMOUNT',
  TaxPercentage = 'TAX_PERCENTAGE',
  Total = 'TOTAL',
  Venue = 'VENUE'
}

export type TixProductSalesReport = {
  __typename?: 'ProductSalesReport';
  comment: Scalars['String'];
  customerEmail: Scalars['String'];
  customerName: Scalars['String'];
  eventName: Scalars['String'];
  orderDetailId: Scalars['String'];
  orderId: Scalars['String'];
  processingFees: Scalars['Float'];
  productName: Scalars['String'];
  purchaseDate: Scalars['String'];
  quantity: Scalars['Float'];
  reservationNo: Scalars['String'];
  state: Scalars['String'];
  taxAmount: Scalars['Float'];
  totalPaid: Scalars['Float'];
  totalPrice: Scalars['Float'];
  unitPrice: Scalars['Float'];
  venueName: Scalars['String'];
};

/** aggregated selection of "product.product" */
export type TixProductAggregate = {
  __typename?: 'Product_aggregate';
  aggregate?: Maybe<TixProductAggregateFields>;
  nodes: Array<TixProduct>;
};

/** aggregate fields of "product.product" */
export type TixProductAggregateFields = {
  __typename?: 'Product_aggregate_fields';
  avg?: Maybe<TixProductAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixProductMaxFields>;
  min?: Maybe<TixProductMinFields>;
  stddev?: Maybe<TixProductStddevFields>;
  stddev_pop?: Maybe<TixProductStddevPopFields>;
  stddev_samp?: Maybe<TixProductStddevSampFields>;
  sum?: Maybe<TixProductSumFields>;
  var_pop?: Maybe<TixProductVarPopFields>;
  var_samp?: Maybe<TixProductVarSampFields>;
  variance?: Maybe<TixProductVarianceFields>;
};


/** aggregate fields of "product.product" */
export type TixProductAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixProductAvgFields = {
  __typename?: 'Product_avg_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_sold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "product.product". All fields are combined with a logical 'AND'. */
export type TixProductBoolExp = {
  EventProduct?: InputMaybe<TixEventProductBoolExp>;
  VenueProduct?: InputMaybe<TixVenueProductBoolExp>;
  VenueProduct_aggregate?: InputMaybe<TixVenueProductAggregateBoolExp>;
  _and?: InputMaybe<Array<TixProductBoolExp>>;
  _not?: InputMaybe<TixProductBoolExp>;
  _or?: InputMaybe<Array<TixProductBoolExp>>;
  additionalInformation?: InputMaybe<TixStringComparisonExp>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  price?: InputMaybe<TixMoneyComparisonExp>;
  productId?: InputMaybe<TixUuidComparisonExp>;
  productMedia?: InputMaybe<TixProductMediaFileBoolExp>;
  productMedia_aggregate?: InputMaybe<TixProductMediaFileAggregateBoolExp>;
  quantity?: InputMaybe<TixIntComparisonExp>;
  quantity_sold?: InputMaybe<TixIntComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  tax?: InputMaybe<TixNumericComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "product.product" */
export enum TixProductConstraint {
  /** unique or primary key constraint on columns "product_id" */
  AddOnItemPkey = 'add_on_item_pkey'
}

/** input type for incrementing numeric columns in table "product.product" */
export type TixProductIncInput = {
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantity_sold?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "product.product" */
export type TixProductInsertInput = {
  EventProduct?: InputMaybe<TixEventProductObjRelInsertInput>;
  VenueProduct?: InputMaybe<TixVenueProductArrRelInsertInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['money']>;
  productId?: InputMaybe<Scalars['uuid']>;
  productMedia?: InputMaybe<TixProductMediaFileArrRelInsertInput>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantity_sold?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixProductMaxFields = {
  __typename?: 'Product_max_fields';
  additionalInformation?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['money']>;
  productId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_sold?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixProductMinFields = {
  __typename?: 'Product_min_fields';
  additionalInformation?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['money']>;
  productId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_sold?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "product.product" */
export type TixProductMutationResponse = {
  __typename?: 'Product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixProduct>;
};

/** input type for inserting object relation for remote table "product.product" */
export type TixProductObjRelInsertInput = {
  data: TixProductInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixProductOnConflict>;
};

/** on_conflict condition type for table "product.product" */
export type TixProductOnConflict = {
  constraint: TixProductConstraint;
  update_columns?: Array<TixProductUpdateColumn>;
  where?: InputMaybe<TixProductBoolExp>;
};

/** Ordering options when selecting data from "product.product". */
export type TixProductOrderBy = {
  EventProduct?: InputMaybe<TixEventProductOrderBy>;
  VenueProduct_aggregate?: InputMaybe<TixVenueProductAggregateOrderBy>;
  additionalInformation?: InputMaybe<TixOrderBy>;
  company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  productMedia_aggregate?: InputMaybe<TixProductMediaFileAggregateOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  quantity_sold?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  tax?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: product.product */
export type TixProductPkColumnsInput = {
  productId: Scalars['uuid'];
};

/** select columns of table "product.product" */
export enum TixProductSelectColumn {
  /** column name */
  AdditionalInformation = 'additionalInformation',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantitySold = 'quantity_sold',
  /** column name */
  State = 'state',
  /** column name */
  Tax = 'tax',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "product.product" */
export type TixProductSetInput = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['money']>;
  productId?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantity_sold?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixProductStddevFields = {
  __typename?: 'Product_stddev_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_sold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixProductStddevPopFields = {
  __typename?: 'Product_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_sold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixProductStddevSampFields = {
  __typename?: 'Product_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_sold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Product" */
export type TixProductStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixProductStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixProductStreamCursorValueInput = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['money']>;
  productId?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantity_sold?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixProductSumFields = {
  __typename?: 'Product_sum_fields';
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_sold?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['numeric']>;
};

/** update columns of table "product.product" */
export enum TixProductUpdateColumn {
  /** column name */
  AdditionalInformation = 'additionalInformation',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantitySold = 'quantity_sold',
  /** column name */
  State = 'state',
  /** column name */
  Tax = 'tax',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixProductUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixProductIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixProductSetInput>;
  /** filter the rows which have to be updated */
  where: TixProductBoolExp;
};

/** aggregate var_pop on columns */
export type TixProductVarPopFields = {
  __typename?: 'Product_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_sold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixProductVarSampFields = {
  __typename?: 'Product_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_sold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixProductVarianceFields = {
  __typename?: 'Product_variance_fields';
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_sold?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

export type TixRefundAddonsInput = {
  /** Stripe mode: live or test */
  mode?: InputMaybe<Scalars['String']>;
  /** true by default */
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  reservationId: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type TixRequestResetPasswordResponse = {
  __typename?: 'RequestResetPasswordResponse';
  sent?: Maybe<Scalars['Boolean']>;
};

/** columns and relationships of "payment.reservation_payment" */
export type TixReservationPayment = {
  __typename?: 'ReservationPayment';
  amount?: Maybe<Scalars['money']>;
  /** An object relationship */
  payment?: Maybe<TixPayment>;
  paymentId: Scalars['uuid'];
  reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  reservation?: Maybe<TixTicketReservation>;
  reservationId: Scalars['uuid'];
  reservationPaymentId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "payment.reservation_payment" */
export type TixReservationPaymentAggregate = {
  __typename?: 'ReservationPayment_aggregate';
  aggregate?: Maybe<TixReservationPaymentAggregateFields>;
  nodes: Array<TixReservationPayment>;
};

/** aggregate fields of "payment.reservation_payment" */
export type TixReservationPaymentAggregateFields = {
  __typename?: 'ReservationPayment_aggregate_fields';
  avg?: Maybe<TixReservationPaymentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixReservationPaymentMaxFields>;
  min?: Maybe<TixReservationPaymentMinFields>;
  stddev?: Maybe<TixReservationPaymentStddevFields>;
  stddev_pop?: Maybe<TixReservationPaymentStddevPopFields>;
  stddev_samp?: Maybe<TixReservationPaymentStddevSampFields>;
  sum?: Maybe<TixReservationPaymentSumFields>;
  var_pop?: Maybe<TixReservationPaymentVarPopFields>;
  var_samp?: Maybe<TixReservationPaymentVarSampFields>;
  variance?: Maybe<TixReservationPaymentVarianceFields>;
};


/** aggregate fields of "payment.reservation_payment" */
export type TixReservationPaymentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixReservationPaymentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixReservationPaymentAvgFields = {
  __typename?: 'ReservationPayment_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "payment.reservation_payment". All fields are combined with a logical 'AND'. */
export type TixReservationPaymentBoolExp = {
  _and?: InputMaybe<Array<TixReservationPaymentBoolExp>>;
  _not?: InputMaybe<TixReservationPaymentBoolExp>;
  _or?: InputMaybe<Array<TixReservationPaymentBoolExp>>;
  amount?: InputMaybe<TixMoneyComparisonExp>;
  payment?: InputMaybe<TixPaymentBoolExp>;
  paymentId?: InputMaybe<TixUuidComparisonExp>;
  reason?: InputMaybe<TixStringComparisonExp>;
  reservation?: InputMaybe<TixTicketReservationBoolExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  reservationPaymentId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "payment.reservation_payment" */
export enum TixReservationPaymentConstraint {
  /** unique or primary key constraint on columns "reservation_payment_id" */
  ReservationPaymentPkey = 'reservation_payment_pkey'
}

/** input type for incrementing numeric columns in table "payment.reservation_payment" */
export type TixReservationPaymentIncInput = {
  amount?: InputMaybe<Scalars['money']>;
};

/** input type for inserting data into table "payment.reservation_payment" */
export type TixReservationPaymentInsertInput = {
  amount?: InputMaybe<Scalars['money']>;
  payment?: InputMaybe<TixPaymentObjRelInsertInput>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  reservation?: InputMaybe<TixTicketReservationObjRelInsertInput>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationPaymentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixReservationPaymentMaxFields = {
  __typename?: 'ReservationPayment_max_fields';
  amount?: Maybe<Scalars['money']>;
  paymentId?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationPaymentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixReservationPaymentMinFields = {
  __typename?: 'ReservationPayment_min_fields';
  amount?: Maybe<Scalars['money']>;
  paymentId?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationPaymentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "payment.reservation_payment" */
export type TixReservationPaymentMutationResponse = {
  __typename?: 'ReservationPayment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixReservationPayment>;
};

/** input type for inserting object relation for remote table "payment.reservation_payment" */
export type TixReservationPaymentObjRelInsertInput = {
  data: TixReservationPaymentInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixReservationPaymentOnConflict>;
};

/** on_conflict condition type for table "payment.reservation_payment" */
export type TixReservationPaymentOnConflict = {
  constraint: TixReservationPaymentConstraint;
  update_columns?: Array<TixReservationPaymentUpdateColumn>;
  where?: InputMaybe<TixReservationPaymentBoolExp>;
};

/** Ordering options when selecting data from "payment.reservation_payment". */
export type TixReservationPaymentOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  payment?: InputMaybe<TixPaymentOrderBy>;
  paymentId?: InputMaybe<TixOrderBy>;
  reason?: InputMaybe<TixOrderBy>;
  reservation?: InputMaybe<TixTicketReservationOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationPaymentId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: payment.reservation_payment */
export type TixReservationPaymentPkColumnsInput = {
  reservationPaymentId: Scalars['uuid'];
};

/** select columns of table "payment.reservation_payment" */
export enum TixReservationPaymentSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationPaymentId = 'reservationPaymentId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment.reservation_payment" */
export type TixReservationPaymentSetInput = {
  amount?: InputMaybe<Scalars['money']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationPaymentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixReservationPaymentStddevFields = {
  __typename?: 'ReservationPayment_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixReservationPaymentStddevPopFields = {
  __typename?: 'ReservationPayment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixReservationPaymentStddevSampFields = {
  __typename?: 'ReservationPayment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ReservationPayment" */
export type TixReservationPaymentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixReservationPaymentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixReservationPaymentStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['money']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationPaymentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixReservationPaymentSumFields = {
  __typename?: 'ReservationPayment_sum_fields';
  amount?: Maybe<Scalars['money']>;
};

/** update columns of table "payment.reservation_payment" */
export enum TixReservationPaymentUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationPaymentId = 'reservationPaymentId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixReservationPaymentUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixReservationPaymentIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixReservationPaymentSetInput>;
  /** filter the rows which have to be updated */
  where: TixReservationPaymentBoolExp;
};

/** aggregate var_pop on columns */
export type TixReservationPaymentVarPopFields = {
  __typename?: 'ReservationPayment_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixReservationPaymentVarSampFields = {
  __typename?: 'ReservationPayment_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixReservationPaymentVarianceFields = {
  __typename?: 'ReservationPayment_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

export type TixResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  updated?: Maybe<Scalars['Boolean']>;
};

/** columns and relationships of "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelType = {
  __typename?: 'RevenueByChannelType';
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  totalRevenue?: Maybe<Scalars['money']>;
};

/** aggregated selection of "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeAggregate = {
  __typename?: 'RevenueByChannelType_aggregate';
  aggregate?: Maybe<TixRevenueByChannelTypeAggregateFields>;
  nodes: Array<TixRevenueByChannelType>;
};

export type TixRevenueByChannelTypeAggregateBoolExp = {
  count?: InputMaybe<TixRevenueByChannelTypeAggregateBoolExpCount>;
};

export type TixRevenueByChannelTypeAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixRevenueByChannelTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeAggregateFields = {
  __typename?: 'RevenueByChannelType_aggregate_fields';
  avg?: Maybe<TixRevenueByChannelTypeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixRevenueByChannelTypeMaxFields>;
  min?: Maybe<TixRevenueByChannelTypeMinFields>;
  stddev?: Maybe<TixRevenueByChannelTypeStddevFields>;
  stddev_pop?: Maybe<TixRevenueByChannelTypeStddevPopFields>;
  stddev_samp?: Maybe<TixRevenueByChannelTypeStddevSampFields>;
  sum?: Maybe<TixRevenueByChannelTypeSumFields>;
  var_pop?: Maybe<TixRevenueByChannelTypeVarPopFields>;
  var_samp?: Maybe<TixRevenueByChannelTypeVarSampFields>;
  variance?: Maybe<TixRevenueByChannelTypeVarianceFields>;
};


/** aggregate fields of "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixRevenueByChannelTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeAggregateOrderBy = {
  avg?: InputMaybe<TixRevenueByChannelTypeAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixRevenueByChannelTypeMaxOrderBy>;
  min?: InputMaybe<TixRevenueByChannelTypeMinOrderBy>;
  stddev?: InputMaybe<TixRevenueByChannelTypeStddevOrderBy>;
  stddev_pop?: InputMaybe<TixRevenueByChannelTypeStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixRevenueByChannelTypeStddevSampOrderBy>;
  sum?: InputMaybe<TixRevenueByChannelTypeSumOrderBy>;
  var_pop?: InputMaybe<TixRevenueByChannelTypeVarPopOrderBy>;
  var_samp?: InputMaybe<TixRevenueByChannelTypeVarSampOrderBy>;
  variance?: InputMaybe<TixRevenueByChannelTypeVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeArrRelInsertInput = {
  data: Array<TixRevenueByChannelTypeInsertInput>;
};

/** aggregate avg on columns */
export type TixRevenueByChannelTypeAvgFields = {
  __typename?: 'RevenueByChannelType_avg_fields';
  totalRevenue?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeAvgOrderBy = {
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "reporting.v_revenue_by_channel_type". All fields are combined with a logical 'AND'. */
export type TixRevenueByChannelTypeBoolExp = {
  _and?: InputMaybe<Array<TixRevenueByChannelTypeBoolExp>>;
  _not?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
  _or?: InputMaybe<Array<TixRevenueByChannelTypeBoolExp>>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  fullName?: InputMaybe<TixStringComparisonExp>;
  paymentType?: InputMaybe<TixStringComparisonExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  totalRevenue?: InputMaybe<TixMoneyComparisonExp>;
};

/** input type for inserting data into table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeInsertInput = {
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  fullName?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  totalRevenue?: InputMaybe<Scalars['money']>;
};

/** aggregate max on columns */
export type TixRevenueByChannelTypeMaxFields = {
  __typename?: 'RevenueByChannelType_max_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  totalRevenue?: Maybe<Scalars['money']>;
};

/** order by max() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeMaxOrderBy = {
  eventInstanceId?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  paymentType?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixRevenueByChannelTypeMinFields = {
  __typename?: 'RevenueByChannelType_min_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  totalRevenue?: Maybe<Scalars['money']>;
};

/** order by min() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeMinOrderBy = {
  eventInstanceId?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  paymentType?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** Ordering options when selecting data from "reporting.v_revenue_by_channel_type". */
export type TixRevenueByChannelTypeOrderBy = {
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  paymentType?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_revenue_by_channel_type" */
export enum TixRevenueByChannelTypeSelectColumn {
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  FullName = 'fullName',
  /** column name */
  PaymentType = 'paymentType',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  TotalRevenue = 'totalRevenue'
}

/** aggregate stddev on columns */
export type TixRevenueByChannelTypeStddevFields = {
  __typename?: 'RevenueByChannelType_stddev_fields';
  totalRevenue?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeStddevOrderBy = {
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixRevenueByChannelTypeStddevPopFields = {
  __typename?: 'RevenueByChannelType_stddev_pop_fields';
  totalRevenue?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeStddevPopOrderBy = {
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixRevenueByChannelTypeStddevSampFields = {
  __typename?: 'RevenueByChannelType_stddev_samp_fields';
  totalRevenue?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeStddevSampOrderBy = {
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "RevenueByChannelType" */
export type TixRevenueByChannelTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixRevenueByChannelTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixRevenueByChannelTypeStreamCursorValueInput = {
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  fullName?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  totalRevenue?: InputMaybe<Scalars['money']>;
};

/** aggregate sum on columns */
export type TixRevenueByChannelTypeSumFields = {
  __typename?: 'RevenueByChannelType_sum_fields';
  totalRevenue?: Maybe<Scalars['money']>;
};

/** order by sum() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeSumOrderBy = {
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** aggregate var_pop on columns */
export type TixRevenueByChannelTypeVarPopFields = {
  __typename?: 'RevenueByChannelType_var_pop_fields';
  totalRevenue?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeVarPopOrderBy = {
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixRevenueByChannelTypeVarSampFields = {
  __typename?: 'RevenueByChannelType_var_samp_fields';
  totalRevenue?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeVarSampOrderBy = {
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixRevenueByChannelTypeVarianceFields = {
  __typename?: 'RevenueByChannelType_variance_fields';
  totalRevenue?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reporting.v_revenue_by_channel_type" */
export type TixRevenueByChannelTypeVarianceOrderBy = {
  totalRevenue?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "access.role" */
export type TixRole = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roleId: Scalars['uuid'];
  /** An array relationship */
  rolePermission: Array<TixRolePermission>;
  /** An aggregate relationship */
  rolePermission_aggregate: TixRolePermissionAggregate;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "access.role" */
export type TixRoleRolePermissionArgs = {
  distinct_on?: InputMaybe<Array<TixRolePermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRolePermissionOrderBy>>;
  where?: InputMaybe<TixRolePermissionBoolExp>;
};


/** columns and relationships of "access.role" */
export type TixRoleRolePermissionAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixRolePermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRolePermissionOrderBy>>;
  where?: InputMaybe<TixRolePermissionBoolExp>;
};

/** columns and relationships of "access.role_permission" */
export type TixRolePermission = {
  __typename?: 'RolePermission';
  /** An object relationship */
  permission?: Maybe<TixPermission>;
  permissionId?: Maybe<Scalars['uuid']>;
  rolePermissionId: Scalars['uuid'];
  role_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  udpatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "access.role_permission" */
export type TixRolePermissionAggregate = {
  __typename?: 'RolePermission_aggregate';
  aggregate?: Maybe<TixRolePermissionAggregateFields>;
  nodes: Array<TixRolePermission>;
};

export type TixRolePermissionAggregateBoolExp = {
  count?: InputMaybe<TixRolePermissionAggregateBoolExpCount>;
};

export type TixRolePermissionAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixRolePermissionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixRolePermissionBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "access.role_permission" */
export type TixRolePermissionAggregateFields = {
  __typename?: 'RolePermission_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixRolePermissionMaxFields>;
  min?: Maybe<TixRolePermissionMinFields>;
};


/** aggregate fields of "access.role_permission" */
export type TixRolePermissionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixRolePermissionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "access.role_permission" */
export type TixRolePermissionAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixRolePermissionMaxOrderBy>;
  min?: InputMaybe<TixRolePermissionMinOrderBy>;
};

/** input type for inserting array relation for remote table "access.role_permission" */
export type TixRolePermissionArrRelInsertInput = {
  data: Array<TixRolePermissionInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixRolePermissionOnConflict>;
};

/** Boolean expression to filter rows from the table "access.role_permission". All fields are combined with a logical 'AND'. */
export type TixRolePermissionBoolExp = {
  _and?: InputMaybe<Array<TixRolePermissionBoolExp>>;
  _not?: InputMaybe<TixRolePermissionBoolExp>;
  _or?: InputMaybe<Array<TixRolePermissionBoolExp>>;
  permission?: InputMaybe<TixPermissionBoolExp>;
  permissionId?: InputMaybe<TixUuidComparisonExp>;
  rolePermissionId?: InputMaybe<TixUuidComparisonExp>;
  role_id?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  udpatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "access.role_permission" */
export enum TixRolePermissionConstraint {
  /** unique or primary key constraint on columns "role_permission_id" */
  RolePermissionPkey = 'role_permission_pkey'
}

/** input type for inserting data into table "access.role_permission" */
export type TixRolePermissionInsertInput = {
  permission?: InputMaybe<TixPermissionObjRelInsertInput>;
  permissionId?: InputMaybe<Scalars['uuid']>;
  rolePermissionId?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  udpatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixRolePermissionMaxFields = {
  __typename?: 'RolePermission_max_fields';
  permissionId?: Maybe<Scalars['uuid']>;
  rolePermissionId?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  udpatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "access.role_permission" */
export type TixRolePermissionMaxOrderBy = {
  permissionId?: InputMaybe<TixOrderBy>;
  rolePermissionId?: InputMaybe<TixOrderBy>;
  role_id?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  udpatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixRolePermissionMinFields = {
  __typename?: 'RolePermission_min_fields';
  permissionId?: Maybe<Scalars['uuid']>;
  rolePermissionId?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  udpatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "access.role_permission" */
export type TixRolePermissionMinOrderBy = {
  permissionId?: InputMaybe<TixOrderBy>;
  rolePermissionId?: InputMaybe<TixOrderBy>;
  role_id?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  udpatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "access.role_permission" */
export type TixRolePermissionMutationResponse = {
  __typename?: 'RolePermission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixRolePermission>;
};

/** on_conflict condition type for table "access.role_permission" */
export type TixRolePermissionOnConflict = {
  constraint: TixRolePermissionConstraint;
  update_columns?: Array<TixRolePermissionUpdateColumn>;
  where?: InputMaybe<TixRolePermissionBoolExp>;
};

/** Ordering options when selecting data from "access.role_permission". */
export type TixRolePermissionOrderBy = {
  permission?: InputMaybe<TixPermissionOrderBy>;
  permissionId?: InputMaybe<TixOrderBy>;
  rolePermissionId?: InputMaybe<TixOrderBy>;
  role_id?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  udpatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: access.role_permission */
export type TixRolePermissionPkColumnsInput = {
  rolePermissionId: Scalars['uuid'];
};

/** select columns of table "access.role_permission" */
export enum TixRolePermissionSelectColumn {
  /** column name */
  PermissionId = 'permissionId',
  /** column name */
  RolePermissionId = 'rolePermissionId',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  State = 'state',
  /** column name */
  UdpatedAt = 'udpatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "access.role_permission" */
export type TixRolePermissionSetInput = {
  permissionId?: InputMaybe<Scalars['uuid']>;
  rolePermissionId?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  udpatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "RolePermission" */
export type TixRolePermissionStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixRolePermissionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixRolePermissionStreamCursorValueInput = {
  permissionId?: InputMaybe<Scalars['uuid']>;
  rolePermissionId?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  udpatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "access.role_permission" */
export enum TixRolePermissionUpdateColumn {
  /** column name */
  PermissionId = 'permissionId',
  /** column name */
  RolePermissionId = 'rolePermissionId',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  State = 'state',
  /** column name */
  UdpatedAt = 'udpatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixRolePermissionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixRolePermissionSetInput>;
  /** filter the rows which have to be updated */
  where: TixRolePermissionBoolExp;
};

/** aggregated selection of "access.role" */
export type TixRoleAggregate = {
  __typename?: 'Role_aggregate';
  aggregate?: Maybe<TixRoleAggregateFields>;
  nodes: Array<TixRole>;
};

/** aggregate fields of "access.role" */
export type TixRoleAggregateFields = {
  __typename?: 'Role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixRoleMaxFields>;
  min?: Maybe<TixRoleMinFields>;
};


/** aggregate fields of "access.role" */
export type TixRoleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixRoleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "access.role". All fields are combined with a logical 'AND'. */
export type TixRoleBoolExp = {
  _and?: InputMaybe<Array<TixRoleBoolExp>>;
  _not?: InputMaybe<TixRoleBoolExp>;
  _or?: InputMaybe<Array<TixRoleBoolExp>>;
  description?: InputMaybe<TixStringComparisonExp>;
  role?: InputMaybe<TixStringComparisonExp>;
  roleId?: InputMaybe<TixUuidComparisonExp>;
  rolePermission?: InputMaybe<TixRolePermissionBoolExp>;
  rolePermission_aggregate?: InputMaybe<TixRolePermissionAggregateBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  title?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "access.role" */
export enum TixRoleConstraint {
  /** unique or primary key constraint on columns "role_id" */
  RolePkey = 'role_pkey'
}

/** input type for inserting data into table "access.role" */
export type TixRoleInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  rolePermission?: InputMaybe<TixRolePermissionArrRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixRoleMaxFields = {
  __typename?: 'Role_max_fields';
  description?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixRoleMinFields = {
  __typename?: 'Role_min_fields';
  description?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "access.role" */
export type TixRoleMutationResponse = {
  __typename?: 'Role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixRole>;
};

/** input type for inserting object relation for remote table "access.role" */
export type TixRoleObjRelInsertInput = {
  data: TixRoleInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixRoleOnConflict>;
};

/** on_conflict condition type for table "access.role" */
export type TixRoleOnConflict = {
  constraint: TixRoleConstraint;
  update_columns?: Array<TixRoleUpdateColumn>;
  where?: InputMaybe<TixRoleBoolExp>;
};

/** Ordering options when selecting data from "access.role". */
export type TixRoleOrderBy = {
  description?: InputMaybe<TixOrderBy>;
  role?: InputMaybe<TixOrderBy>;
  roleId?: InputMaybe<TixOrderBy>;
  rolePermission_aggregate?: InputMaybe<TixRolePermissionAggregateOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  title?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: access.role */
export type TixRolePkColumnsInput = {
  roleId: Scalars['uuid'];
};

/** select columns of table "access.role" */
export enum TixRoleSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Role = 'role',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  State = 'state',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "access.role" */
export type TixRoleSetInput = {
  description?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Role" */
export type TixRoleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixRoleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixRoleStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "access.role" */
export enum TixRoleUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Role = 'role',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  State = 'state',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixRoleUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixRoleSetInput>;
  /** filter the rows which have to be updated */
  where: TixRoleBoolExp;
};

export type TixScheduledReportInput = {
  columns?: InputMaybe<Array<Scalars['String']>>;
  dailyAuditInstanceId?: InputMaybe<Scalars['String']>;
  defaultRecipient?: InputMaybe<Scalars['String']>;
  discountEndDate?: InputMaybe<Scalars['String']>;
  discountIds?: InputMaybe<Array<Scalars['String']>>;
  discountStartDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  eventInstanceIds?: InputMaybe<Array<Scalars['String']>>;
  frequency?: InputMaybe<Scalars['String']>;
  otherRecipients: Scalars['String'];
  productSalesInstanceId?: InputMaybe<Scalars['String']>;
  reportLevel?: InputMaybe<Array<Scalars['String']>>;
  reportType?: InputMaybe<Scalars['String']>;
  startSending?: InputMaybe<Scalars['String']>;
  stopSending?: InputMaybe<Scalars['String']>;
  time: Scalars['String'];
  zone: Scalars['String'];
};

export type TixScheduledReportObject = {
  __typename?: 'ScheduledReportObject';
  columns?: Maybe<Array<Scalars['String']>>;
  dailyAuditInstanceId?: Maybe<Scalars['String']>;
  defaultRecipient?: Maybe<Scalars['String']>;
  discountEndDate?: Maybe<Scalars['String']>;
  discountIds?: Maybe<Array<Scalars['String']>>;
  discountStartDate?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventInstanceIds?: Maybe<Array<Scalars['String']>>;
  frequency?: Maybe<Scalars['String']>;
  otherRecipients: Scalars['String'];
  reportLevel?: Maybe<Array<Scalars['String']>>;
  reportType?: Maybe<Scalars['String']>;
  startSending?: Maybe<Scalars['String']>;
  stopSending?: Maybe<Scalars['String']>;
  time: Scalars['String'];
  zone: Scalars['String'];
};

export type TixSendETicketInput = {
  baseURL: Scalars['String'];
  reservationId: Scalars['String'];
  ticketId?: InputMaybe<Scalars['String']>;
};

export type TixSendTicketEmailNotificaionInput = {
  eventInstanceId: Scalars['String'];
  reservationId: Scalars['String'];
};

/** columns and relationships of "media.social_media" */
export type TixSocialMedia = {
  __typename?: 'SocialMedia';
  /** An array relationship */
  companySocialMedia: Array<TixCompanySocialMedia>;
  /** An aggregate relationship */
  companySocialMedia_aggregate: TixCompanySocialMediaAggregate;
  /** An array relationship */
  eventInstanceSocialMedia: Array<TixEventInstanceSocialMediaFile>;
  /** An aggregate relationship */
  eventInstanceSocialMedia_aggregate: TixEventInstanceSocialMediaFileAggregate;
  socialMediaId: Scalars['uuid'];
  socialMediaType: Scalars['String'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
  url: Scalars['String'];
  /** An array relationship */
  venueSocialMedia: Array<TixVenueSocialMedia>;
  /** An aggregate relationship */
  venueSocialMedia_aggregate: TixVenueSocialMediaAggregate;
};


/** columns and relationships of "media.social_media" */
export type TixSocialMediaCompanySocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySocialMediaOrderBy>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


/** columns and relationships of "media.social_media" */
export type TixSocialMediaCompanySocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySocialMediaOrderBy>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


/** columns and relationships of "media.social_media" */
export type TixSocialMediaEventInstanceSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


/** columns and relationships of "media.social_media" */
export type TixSocialMediaEventInstanceSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


/** columns and relationships of "media.social_media" */
export type TixSocialMediaVenueSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueSocialMediaOrderBy>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};


/** columns and relationships of "media.social_media" */
export type TixSocialMediaVenueSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueSocialMediaOrderBy>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};

export type TixSocialMediaInput = {
  socialMediaType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "media.social_media" */
export type TixSocialMediaAggregate = {
  __typename?: 'SocialMedia_aggregate';
  aggregate?: Maybe<TixSocialMediaAggregateFields>;
  nodes: Array<TixSocialMedia>;
};

/** aggregate fields of "media.social_media" */
export type TixSocialMediaAggregateFields = {
  __typename?: 'SocialMedia_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixSocialMediaMaxFields>;
  min?: Maybe<TixSocialMediaMinFields>;
};


/** aggregate fields of "media.social_media" */
export type TixSocialMediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixSocialMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "media.social_media". All fields are combined with a logical 'AND'. */
export type TixSocialMediaBoolExp = {
  _and?: InputMaybe<Array<TixSocialMediaBoolExp>>;
  _not?: InputMaybe<TixSocialMediaBoolExp>;
  _or?: InputMaybe<Array<TixSocialMediaBoolExp>>;
  companySocialMedia?: InputMaybe<TixCompanySocialMediaBoolExp>;
  companySocialMedia_aggregate?: InputMaybe<TixCompanySocialMediaAggregateBoolExp>;
  eventInstanceSocialMedia?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
  eventInstanceSocialMedia_aggregate?: InputMaybe<TixEventInstanceSocialMediaFileAggregateBoolExp>;
  socialMediaId?: InputMaybe<TixUuidComparisonExp>;
  socialMediaType?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  url?: InputMaybe<TixStringComparisonExp>;
  venueSocialMedia?: InputMaybe<TixVenueSocialMediaBoolExp>;
  venueSocialMedia_aggregate?: InputMaybe<TixVenueSocialMediaAggregateBoolExp>;
};

/** unique or primary key constraints on table "media.social_media" */
export enum TixSocialMediaConstraint {
  /** unique or primary key constraint on columns "social_media_id" */
  SocialMediaPkey = 'social_media_pkey'
}

/** input type for inserting data into table "media.social_media" */
export type TixSocialMediaInsertInput = {
  companySocialMedia?: InputMaybe<TixCompanySocialMediaArrRelInsertInput>;
  eventInstanceSocialMedia?: InputMaybe<TixEventInstanceSocialMediaFileArrRelInsertInput>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMediaType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
  venueSocialMedia?: InputMaybe<TixVenueSocialMediaArrRelInsertInput>;
};

/** aggregate max on columns */
export type TixSocialMediaMaxFields = {
  __typename?: 'SocialMedia_max_fields';
  socialMediaId?: Maybe<Scalars['uuid']>;
  socialMediaType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixSocialMediaMinFields = {
  __typename?: 'SocialMedia_min_fields';
  socialMediaId?: Maybe<Scalars['uuid']>;
  socialMediaType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "media.social_media" */
export type TixSocialMediaMutationResponse = {
  __typename?: 'SocialMedia_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixSocialMedia>;
};

/** input type for inserting object relation for remote table "media.social_media" */
export type TixSocialMediaObjRelInsertInput = {
  data: TixSocialMediaInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixSocialMediaOnConflict>;
};

/** on_conflict condition type for table "media.social_media" */
export type TixSocialMediaOnConflict = {
  constraint: TixSocialMediaConstraint;
  update_columns?: Array<TixSocialMediaUpdateColumn>;
  where?: InputMaybe<TixSocialMediaBoolExp>;
};

/** Ordering options when selecting data from "media.social_media". */
export type TixSocialMediaOrderBy = {
  companySocialMedia_aggregate?: InputMaybe<TixCompanySocialMediaAggregateOrderBy>;
  eventInstanceSocialMedia_aggregate?: InputMaybe<TixEventInstanceSocialMediaFileAggregateOrderBy>;
  socialMediaId?: InputMaybe<TixOrderBy>;
  socialMediaType?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  url?: InputMaybe<TixOrderBy>;
  venueSocialMedia_aggregate?: InputMaybe<TixVenueSocialMediaAggregateOrderBy>;
};

/** primary key columns input for table: media.social_media */
export type TixSocialMediaPkColumnsInput = {
  socialMediaId: Scalars['uuid'];
};

/** select columns of table "media.social_media" */
export enum TixSocialMediaSelectColumn {
  /** column name */
  SocialMediaId = 'socialMediaId',
  /** column name */
  SocialMediaType = 'socialMediaType',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "media.social_media" */
export type TixSocialMediaSetInput = {
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMediaType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "SocialMedia" */
export type TixSocialMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixSocialMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixSocialMediaStreamCursorValueInput = {
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  socialMediaType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "media.social_media" */
export enum TixSocialMediaUpdateColumn {
  /** column name */
  SocialMediaId = 'socialMediaId',
  /** column name */
  SocialMediaType = 'socialMediaType',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url'
}

export type TixSocialMediaUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixSocialMediaSetInput>;
  /** filter the rows which have to be updated */
  where: TixSocialMediaBoolExp;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type TixStringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ticket.ticket" */
export type TixTicket = {
  __typename?: 'Ticket';
  active?: Maybe<Scalars['Boolean']>;
  checkedInAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  discount?: Maybe<TixTicketTicketDiscount>;
  discountAmount?: Maybe<Scalars['money']>;
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  /** An object relationship */
  reservation?: Maybe<TixTicketReservation>;
  reservationId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "ticket.reservation_no" */
  reservationNo?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  test?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  ticketConfig?: Maybe<TixTicketConfig>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketId: Scalars['uuid'];
  /** A computed field, executes function "ticket.ticket_no" */
  ticketNo?: Maybe<Scalars['String']>;
  ticketPrice?: Maybe<Scalars['money']>;
  ticketType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  venueFee?: Maybe<Scalars['money']>;
};

/** columns and relationships of "ticket.ticket_config" */
export type TixTicketConfig = {
  __typename?: 'TicketConfig';
  assign_row?: Maybe<Scalars['Boolean']>;
  assign_seat?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  event_instance_ticket_config?: Maybe<TixEventInstanceTicketConfig>;
  helpText?: Maybe<Scalars['String']>;
  helpTextTitle?: Maybe<Scalars['String']>;
  includeFees?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  noOfSeats?: Maybe<Scalars['Int']>;
  parentTicketId?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  row?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  showFees: Scalars['Boolean'];
  startSelling?: Maybe<Scalars['timestamp']>;
  startSellingDate?: Maybe<Scalars['date']>;
  startSellingTime?: Maybe<Scalars['time']>;
  state?: Maybe<Scalars['String']>;
  stopSelling?: Maybe<Scalars['timestamp']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  stopSellingTime?: Maybe<Scalars['time']>;
  ticketConfigId: Scalars['uuid'];
  ticketPrice?: Maybe<Scalars['money']>;
  ticketType?: Maybe<Scalars['String']>;
  /** An object relationship */
  totalTicketsByType?: Maybe<TixTicketVTicketCountByType>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  venueFee?: Maybe<Scalars['money']>;
  /** An object relationship */
  venue_ticket_config?: Maybe<TixVenueTicketConfig>;
  view_order?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "ticket.ticket_config" */
export type TixTicketConfigAggregate = {
  __typename?: 'TicketConfig_aggregate';
  aggregate?: Maybe<TixTicketConfigAggregateFields>;
  nodes: Array<TixTicketConfig>;
};

/** aggregate fields of "ticket.ticket_config" */
export type TixTicketConfigAggregateFields = {
  __typename?: 'TicketConfig_aggregate_fields';
  avg?: Maybe<TixTicketConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketConfigMaxFields>;
  min?: Maybe<TixTicketConfigMinFields>;
  stddev?: Maybe<TixTicketConfigStddevFields>;
  stddev_pop?: Maybe<TixTicketConfigStddevPopFields>;
  stddev_samp?: Maybe<TixTicketConfigStddevSampFields>;
  sum?: Maybe<TixTicketConfigSumFields>;
  var_pop?: Maybe<TixTicketConfigVarPopFields>;
  var_samp?: Maybe<TixTicketConfigVarSampFields>;
  variance?: Maybe<TixTicketConfigVarianceFields>;
};


/** aggregate fields of "ticket.ticket_config" */
export type TixTicketConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixTicketConfigAvgFields = {
  __typename?: 'TicketConfig_avg_fields';
  noOfSeats?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  view_order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticket.ticket_config". All fields are combined with a logical 'AND'. */
export type TixTicketConfigBoolExp = {
  _and?: InputMaybe<Array<TixTicketConfigBoolExp>>;
  _not?: InputMaybe<TixTicketConfigBoolExp>;
  _or?: InputMaybe<Array<TixTicketConfigBoolExp>>;
  assign_row?: InputMaybe<TixBooleanComparisonExp>;
  assign_seat?: InputMaybe<TixBooleanComparisonExp>;
  event_instance_ticket_config?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
  helpText?: InputMaybe<TixStringComparisonExp>;
  helpTextTitle?: InputMaybe<TixStringComparisonExp>;
  includeFees?: InputMaybe<TixBooleanComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  noOfSeats?: InputMaybe<TixIntComparisonExp>;
  parentTicketId?: InputMaybe<TixUuidComparisonExp>;
  perOrderMax?: InputMaybe<TixSmallintComparisonExp>;
  perOrderMin?: InputMaybe<TixSmallintComparisonExp>;
  platformFee?: InputMaybe<TixMoneyComparisonExp>;
  processingFee?: InputMaybe<TixMoneyComparisonExp>;
  row?: InputMaybe<TixStringComparisonExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  seat?: InputMaybe<TixStringComparisonExp>;
  section?: InputMaybe<TixStringComparisonExp>;
  showFees?: InputMaybe<TixBooleanComparisonExp>;
  startSelling?: InputMaybe<TixTimestampComparisonExp>;
  startSellingDate?: InputMaybe<TixDateComparisonExp>;
  startSellingTime?: InputMaybe<TixTimeComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  stopSelling?: InputMaybe<TixTimestampComparisonExp>;
  stopSellingDate?: InputMaybe<TixDateComparisonExp>;
  stopSellingTime?: InputMaybe<TixTimeComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  ticketPrice?: InputMaybe<TixMoneyComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  totalTicketsByType?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueFee?: InputMaybe<TixMoneyComparisonExp>;
  venue_ticket_config?: InputMaybe<TixVenueTicketConfigBoolExp>;
  view_order?: InputMaybe<TixIntComparisonExp>;
};

/** unique or primary key constraints on table "ticket.ticket_config" */
export enum TixTicketConfigConstraint {
  /** unique or primary key constraint on columns "ticket_config_id" */
  TicketConfigurationPkey = 'ticket_configuration_pkey'
}

/** input type for incrementing numeric columns in table "ticket.ticket_config" */
export type TixTicketConfigIncInput = {
  noOfSeats?: InputMaybe<Scalars['Int']>;
  perOrderMax?: InputMaybe<Scalars['smallint']>;
  perOrderMin?: InputMaybe<Scalars['smallint']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  ticketPrice?: InputMaybe<Scalars['money']>;
  venueFee?: InputMaybe<Scalars['money']>;
  view_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ticket.ticket_config" */
export type TixTicketConfigInsertInput = {
  assign_row?: InputMaybe<Scalars['Boolean']>;
  assign_seat?: InputMaybe<Scalars['Boolean']>;
  event_instance_ticket_config?: InputMaybe<TixEventInstanceTicketConfigObjRelInsertInput>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextTitle?: InputMaybe<Scalars['String']>;
  includeFees?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  noOfSeats?: InputMaybe<Scalars['Int']>;
  parentTicketId?: InputMaybe<Scalars['uuid']>;
  perOrderMax?: InputMaybe<Scalars['smallint']>;
  perOrderMin?: InputMaybe<Scalars['smallint']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  row?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  seat?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  showFees?: InputMaybe<Scalars['Boolean']>;
  startSelling?: InputMaybe<Scalars['timestamp']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSelling?: InputMaybe<Scalars['timestamp']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketPrice?: InputMaybe<Scalars['money']>;
  ticketType?: InputMaybe<Scalars['String']>;
  totalTicketsByType?: InputMaybe<TixTicketVTicketCountByTypeObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
  venue_ticket_config?: InputMaybe<TixVenueTicketConfigObjRelInsertInput>;
  view_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TixTicketConfigMaxFields = {
  __typename?: 'TicketConfig_max_fields';
  helpText?: Maybe<Scalars['String']>;
  helpTextTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  noOfSeats?: Maybe<Scalars['Int']>;
  parentTicketId?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  row?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startSelling?: Maybe<Scalars['timestamp']>;
  startSellingDate?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  stopSelling?: Maybe<Scalars['timestamp']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketPrice?: Maybe<Scalars['money']>;
  ticketType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueFee?: Maybe<Scalars['money']>;
  view_order?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type TixTicketConfigMinFields = {
  __typename?: 'TicketConfig_min_fields';
  helpText?: Maybe<Scalars['String']>;
  helpTextTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  noOfSeats?: Maybe<Scalars['Int']>;
  parentTicketId?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  row?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startSelling?: Maybe<Scalars['timestamp']>;
  startSellingDate?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  stopSelling?: Maybe<Scalars['timestamp']>;
  stopSellingDate?: Maybe<Scalars['date']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketPrice?: Maybe<Scalars['money']>;
  ticketType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueFee?: Maybe<Scalars['money']>;
  view_order?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "ticket.ticket_config" */
export type TixTicketConfigMutationResponse = {
  __typename?: 'TicketConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixTicketConfig>;
};

/** input type for inserting object relation for remote table "ticket.ticket_config" */
export type TixTicketConfigObjRelInsertInput = {
  data: TixTicketConfigInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixTicketConfigOnConflict>;
};

/** on_conflict condition type for table "ticket.ticket_config" */
export type TixTicketConfigOnConflict = {
  constraint: TixTicketConfigConstraint;
  update_columns?: Array<TixTicketConfigUpdateColumn>;
  where?: InputMaybe<TixTicketConfigBoolExp>;
};

/** Ordering options when selecting data from "ticket.ticket_config". */
export type TixTicketConfigOrderBy = {
  assign_row?: InputMaybe<TixOrderBy>;
  assign_seat?: InputMaybe<TixOrderBy>;
  event_instance_ticket_config?: InputMaybe<TixEventInstanceTicketConfigOrderBy>;
  helpText?: InputMaybe<TixOrderBy>;
  helpTextTitle?: InputMaybe<TixOrderBy>;
  includeFees?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  noOfSeats?: InputMaybe<TixOrderBy>;
  parentTicketId?: InputMaybe<TixOrderBy>;
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  row?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  seat?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  showFees?: InputMaybe<TixOrderBy>;
  startSelling?: InputMaybe<TixOrderBy>;
  startSellingDate?: InputMaybe<TixOrderBy>;
  startSellingTime?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  stopSelling?: InputMaybe<TixOrderBy>;
  stopSellingDate?: InputMaybe<TixOrderBy>;
  stopSellingTime?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  totalTicketsByType?: InputMaybe<TixTicketVTicketCountByTypeOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
  venue_ticket_config?: InputMaybe<TixVenueTicketConfigOrderBy>;
  view_order?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.ticket_config */
export type TixTicketConfigPkColumnsInput = {
  ticketConfigId: Scalars['uuid'];
};

/** select columns of table "ticket.ticket_config" */
export enum TixTicketConfigSelectColumn {
  /** column name */
  AssignRow = 'assign_row',
  /** column name */
  AssignSeat = 'assign_seat',
  /** column name */
  HelpText = 'helpText',
  /** column name */
  HelpTextTitle = 'helpTextTitle',
  /** column name */
  IncludeFees = 'includeFees',
  /** column name */
  Name = 'name',
  /** column name */
  NoOfSeats = 'noOfSeats',
  /** column name */
  ParentTicketId = 'parentTicketId',
  /** column name */
  PerOrderMax = 'perOrderMax',
  /** column name */
  PerOrderMin = 'perOrderMin',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  Row = 'row',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  Seat = 'seat',
  /** column name */
  Section = 'section',
  /** column name */
  ShowFees = 'showFees',
  /** column name */
  StartSelling = 'startSelling',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  State = 'state',
  /** column name */
  StopSelling = 'stopSelling',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TicketPrice = 'ticketPrice',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueFee = 'venueFee',
  /** column name */
  ViewOrder = 'view_order'
}

/** input type for updating data in table "ticket.ticket_config" */
export type TixTicketConfigSetInput = {
  assign_row?: InputMaybe<Scalars['Boolean']>;
  assign_seat?: InputMaybe<Scalars['Boolean']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextTitle?: InputMaybe<Scalars['String']>;
  includeFees?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  noOfSeats?: InputMaybe<Scalars['Int']>;
  parentTicketId?: InputMaybe<Scalars['uuid']>;
  perOrderMax?: InputMaybe<Scalars['smallint']>;
  perOrderMin?: InputMaybe<Scalars['smallint']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  row?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  seat?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  showFees?: InputMaybe<Scalars['Boolean']>;
  startSelling?: InputMaybe<Scalars['timestamp']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSelling?: InputMaybe<Scalars['timestamp']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketPrice?: InputMaybe<Scalars['money']>;
  ticketType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
  view_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TixTicketConfigStddevFields = {
  __typename?: 'TicketConfig_stddev_fields';
  noOfSeats?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  view_order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixTicketConfigStddevPopFields = {
  __typename?: 'TicketConfig_stddev_pop_fields';
  noOfSeats?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  view_order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixTicketConfigStddevSampFields = {
  __typename?: 'TicketConfig_stddev_samp_fields';
  noOfSeats?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  view_order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TicketConfig" */
export type TixTicketConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketConfigStreamCursorValueInput = {
  assign_row?: InputMaybe<Scalars['Boolean']>;
  assign_seat?: InputMaybe<Scalars['Boolean']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextTitle?: InputMaybe<Scalars['String']>;
  includeFees?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  noOfSeats?: InputMaybe<Scalars['Int']>;
  parentTicketId?: InputMaybe<Scalars['uuid']>;
  perOrderMax?: InputMaybe<Scalars['smallint']>;
  perOrderMin?: InputMaybe<Scalars['smallint']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  row?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  seat?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  showFees?: InputMaybe<Scalars['Boolean']>;
  startSelling?: InputMaybe<Scalars['timestamp']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  state?: InputMaybe<Scalars['String']>;
  stopSelling?: InputMaybe<Scalars['timestamp']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketPrice?: InputMaybe<Scalars['money']>;
  ticketType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
  view_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TixTicketConfigSumFields = {
  __typename?: 'TicketConfig_sum_fields';
  noOfSeats?: Maybe<Scalars['Int']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  ticketPrice?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
  view_order?: Maybe<Scalars['Int']>;
};

/** update columns of table "ticket.ticket_config" */
export enum TixTicketConfigUpdateColumn {
  /** column name */
  AssignRow = 'assign_row',
  /** column name */
  AssignSeat = 'assign_seat',
  /** column name */
  HelpText = 'helpText',
  /** column name */
  HelpTextTitle = 'helpTextTitle',
  /** column name */
  IncludeFees = 'includeFees',
  /** column name */
  Name = 'name',
  /** column name */
  NoOfSeats = 'noOfSeats',
  /** column name */
  ParentTicketId = 'parentTicketId',
  /** column name */
  PerOrderMax = 'perOrderMax',
  /** column name */
  PerOrderMin = 'perOrderMin',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  Row = 'row',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  Seat = 'seat',
  /** column name */
  Section = 'section',
  /** column name */
  ShowFees = 'showFees',
  /** column name */
  StartSelling = 'startSelling',
  /** column name */
  StartSellingDate = 'startSellingDate',
  /** column name */
  StartSellingTime = 'startSellingTime',
  /** column name */
  State = 'state',
  /** column name */
  StopSelling = 'stopSelling',
  /** column name */
  StopSellingDate = 'stopSellingDate',
  /** column name */
  StopSellingTime = 'stopSellingTime',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TicketPrice = 'ticketPrice',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueFee = 'venueFee',
  /** column name */
  ViewOrder = 'view_order'
}

export type TixTicketConfigUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixTicketConfigIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixTicketConfigSetInput>;
  /** filter the rows which have to be updated */
  where: TixTicketConfigBoolExp;
};

/** aggregate var_pop on columns */
export type TixTicketConfigVarPopFields = {
  __typename?: 'TicketConfig_var_pop_fields';
  noOfSeats?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  view_order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixTicketConfigVarSampFields = {
  __typename?: 'TicketConfig_var_samp_fields';
  noOfSeats?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  view_order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixTicketConfigVarianceFields = {
  __typename?: 'TicketConfig_variance_fields';
  noOfSeats?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
  view_order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reporting.v_ticket_count_by_sales_channel" */
export type TixTicketCountByChannelType = {
  __typename?: 'TicketCountByChannelType';
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  sales_channel?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "reporting.v_ticket_count_by_sales_channel" */
export type TixTicketCountByChannelTypeAggregate = {
  __typename?: 'TicketCountByChannelType_aggregate';
  aggregate?: Maybe<TixTicketCountByChannelTypeAggregateFields>;
  nodes: Array<TixTicketCountByChannelType>;
};

/** aggregate fields of "reporting.v_ticket_count_by_sales_channel" */
export type TixTicketCountByChannelTypeAggregateFields = {
  __typename?: 'TicketCountByChannelType_aggregate_fields';
  avg?: Maybe<TixTicketCountByChannelTypeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketCountByChannelTypeMaxFields>;
  min?: Maybe<TixTicketCountByChannelTypeMinFields>;
  stddev?: Maybe<TixTicketCountByChannelTypeStddevFields>;
  stddev_pop?: Maybe<TixTicketCountByChannelTypeStddevPopFields>;
  stddev_samp?: Maybe<TixTicketCountByChannelTypeStddevSampFields>;
  sum?: Maybe<TixTicketCountByChannelTypeSumFields>;
  var_pop?: Maybe<TixTicketCountByChannelTypeVarPopFields>;
  var_samp?: Maybe<TixTicketCountByChannelTypeVarSampFields>;
  variance?: Maybe<TixTicketCountByChannelTypeVarianceFields>;
};


/** aggregate fields of "reporting.v_ticket_count_by_sales_channel" */
export type TixTicketCountByChannelTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketCountByChannelTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixTicketCountByChannelTypeAvgFields = {
  __typename?: 'TicketCountByChannelType_avg_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_ticket_count_by_sales_channel". All fields are combined with a logical 'AND'. */
export type TixTicketCountByChannelTypeBoolExp = {
  _and?: InputMaybe<Array<TixTicketCountByChannelTypeBoolExp>>;
  _not?: InputMaybe<TixTicketCountByChannelTypeBoolExp>;
  _or?: InputMaybe<Array<TixTicketCountByChannelTypeBoolExp>>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  fullName?: InputMaybe<TixStringComparisonExp>;
  paymentType?: InputMaybe<TixStringComparisonExp>;
  sales_channel?: InputMaybe<TixStringComparisonExp>;
  ticketCount?: InputMaybe<TixBigintComparisonExp>;
};

/** aggregate max on columns */
export type TixTicketCountByChannelTypeMaxFields = {
  __typename?: 'TicketCountByChannelType_max_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  sales_channel?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type TixTicketCountByChannelTypeMinFields = {
  __typename?: 'TicketCountByChannelType_min_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  sales_channel?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "reporting.v_ticket_count_by_sales_channel". */
export type TixTicketCountByChannelTypeOrderBy = {
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  paymentType?: InputMaybe<TixOrderBy>;
  sales_channel?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_ticket_count_by_sales_channel" */
export enum TixTicketCountByChannelTypeSelectColumn {
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  FullName = 'fullName',
  /** column name */
  PaymentType = 'paymentType',
  /** column name */
  SalesChannel = 'sales_channel',
  /** column name */
  TicketCount = 'ticketCount'
}

/** aggregate stddev on columns */
export type TixTicketCountByChannelTypeStddevFields = {
  __typename?: 'TicketCountByChannelType_stddev_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixTicketCountByChannelTypeStddevPopFields = {
  __typename?: 'TicketCountByChannelType_stddev_pop_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixTicketCountByChannelTypeStddevSampFields = {
  __typename?: 'TicketCountByChannelType_stddev_samp_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TicketCountByChannelType" */
export type TixTicketCountByChannelTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketCountByChannelTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketCountByChannelTypeStreamCursorValueInput = {
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  fullName?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  sales_channel?: InputMaybe<Scalars['String']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TixTicketCountByChannelTypeSumFields = {
  __typename?: 'TicketCountByChannelType_sum_fields';
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type TixTicketCountByChannelTypeVarPopFields = {
  __typename?: 'TicketCountByChannelType_var_pop_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixTicketCountByChannelTypeVarSampFields = {
  __typename?: 'TicketCountByChannelType_var_samp_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixTicketCountByChannelTypeVarianceFields = {
  __typename?: 'TicketCountByChannelType_variance_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEvent = {
  __typename?: 'TicketCountByEvent';
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  parentTicketConfigId?: Maybe<Scalars['uuid']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketSection?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventAggregate = {
  __typename?: 'TicketCountByEvent_aggregate';
  aggregate?: Maybe<TixTicketCountByEventAggregateFields>;
  nodes: Array<TixTicketCountByEvent>;
};

export type TixTicketCountByEventAggregateBoolExp = {
  count?: InputMaybe<TixTicketCountByEventAggregateBoolExpCount>;
};

export type TixTicketCountByEventAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketCountByEventBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventAggregateFields = {
  __typename?: 'TicketCountByEvent_aggregate_fields';
  avg?: Maybe<TixTicketCountByEventAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketCountByEventMaxFields>;
  min?: Maybe<TixTicketCountByEventMinFields>;
  stddev?: Maybe<TixTicketCountByEventStddevFields>;
  stddev_pop?: Maybe<TixTicketCountByEventStddevPopFields>;
  stddev_samp?: Maybe<TixTicketCountByEventStddevSampFields>;
  sum?: Maybe<TixTicketCountByEventSumFields>;
  var_pop?: Maybe<TixTicketCountByEventVarPopFields>;
  var_samp?: Maybe<TixTicketCountByEventVarSampFields>;
  variance?: Maybe<TixTicketCountByEventVarianceFields>;
};


/** aggregate fields of "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventAggregateOrderBy = {
  avg?: InputMaybe<TixTicketCountByEventAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixTicketCountByEventMaxOrderBy>;
  min?: InputMaybe<TixTicketCountByEventMinOrderBy>;
  stddev?: InputMaybe<TixTicketCountByEventStddevOrderBy>;
  stddev_pop?: InputMaybe<TixTicketCountByEventStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixTicketCountByEventStddevSampOrderBy>;
  sum?: InputMaybe<TixTicketCountByEventSumOrderBy>;
  var_pop?: InputMaybe<TixTicketCountByEventVarPopOrderBy>;
  var_samp?: InputMaybe<TixTicketCountByEventVarSampOrderBy>;
  variance?: InputMaybe<TixTicketCountByEventVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventArrRelInsertInput = {
  data: Array<TixTicketCountByEventInsertInput>;
};

/** aggregate avg on columns */
export type TixTicketCountByEventAvgFields = {
  __typename?: 'TicketCountByEvent_avg_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventAvgOrderBy = {
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "reporting.v_ticket_count_by_event". All fields are combined with a logical 'AND'. */
export type TixTicketCountByEventBoolExp = {
  _and?: InputMaybe<Array<TixTicketCountByEventBoolExp>>;
  _not?: InputMaybe<TixTicketCountByEventBoolExp>;
  _or?: InputMaybe<Array<TixTicketCountByEventBoolExp>>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  parentTicketConfigId?: InputMaybe<TixUuidComparisonExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  ticketCount?: InputMaybe<TixBigintComparisonExp>;
  ticketName?: InputMaybe<TixStringComparisonExp>;
  ticketSection?: InputMaybe<TixStringComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
};

/** input type for inserting data into table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventInsertInput = {
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  parentTicketConfigId?: InputMaybe<Scalars['uuid']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
  ticketName?: InputMaybe<Scalars['String']>;
  ticketSection?: InputMaybe<Scalars['String']>;
  ticketType?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TixTicketCountByEventMaxFields = {
  __typename?: 'TicketCountByEvent_max_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  parentTicketConfigId?: Maybe<Scalars['uuid']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketSection?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventMaxOrderBy = {
  eventInstanceId?: InputMaybe<TixOrderBy>;
  parentTicketConfigId?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
  ticketName?: InputMaybe<TixOrderBy>;
  ticketSection?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixTicketCountByEventMinFields = {
  __typename?: 'TicketCountByEvent_min_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  parentTicketConfigId?: Maybe<Scalars['uuid']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketSection?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventMinOrderBy = {
  eventInstanceId?: InputMaybe<TixOrderBy>;
  parentTicketConfigId?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
  ticketName?: InputMaybe<TixOrderBy>;
  ticketSection?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
};

/** Ordering options when selecting data from "reporting.v_ticket_count_by_event". */
export type TixTicketCountByEventOrderBy = {
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  parentTicketConfigId?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
  ticketName?: InputMaybe<TixOrderBy>;
  ticketSection?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_ticket_count_by_event" */
export enum TixTicketCountByEventSelectColumn {
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  ParentTicketConfigId = 'parentTicketConfigId',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TicketCount = 'ticketCount',
  /** column name */
  TicketName = 'ticketName',
  /** column name */
  TicketSection = 'ticketSection',
  /** column name */
  TicketType = 'ticketType'
}

/** aggregate stddev on columns */
export type TixTicketCountByEventStddevFields = {
  __typename?: 'TicketCountByEvent_stddev_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventStddevOrderBy = {
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixTicketCountByEventStddevPopFields = {
  __typename?: 'TicketCountByEvent_stddev_pop_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventStddevPopOrderBy = {
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixTicketCountByEventStddevSampFields = {
  __typename?: 'TicketCountByEvent_stddev_samp_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventStddevSampOrderBy = {
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "TicketCountByEvent" */
export type TixTicketCountByEventStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketCountByEventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketCountByEventStreamCursorValueInput = {
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  parentTicketConfigId?: InputMaybe<Scalars['uuid']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
  ticketName?: InputMaybe<Scalars['String']>;
  ticketSection?: InputMaybe<Scalars['String']>;
  ticketType?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixTicketCountByEventSumFields = {
  __typename?: 'TicketCountByEvent_sum_fields';
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventSumOrderBy = {
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate var_pop on columns */
export type TixTicketCountByEventVarPopFields = {
  __typename?: 'TicketCountByEvent_var_pop_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventVarPopOrderBy = {
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixTicketCountByEventVarSampFields = {
  __typename?: 'TicketCountByEvent_var_samp_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventVarSampOrderBy = {
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixTicketCountByEventVarianceFields = {
  __typename?: 'TicketCountByEvent_variance_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reporting.v_ticket_count_by_event" */
export type TixTicketCountByEventVarianceOrderBy = {
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "reporting.v_ticket_count_by_name" */
export type TixTicketCountByName = {
  __typename?: 'TicketCountByName';
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketType?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_ticket_count_by_name" */
export type TixTicketCountByNameAggregate = {
  __typename?: 'TicketCountByName_aggregate';
  aggregate?: Maybe<TixTicketCountByNameAggregateFields>;
  nodes: Array<TixTicketCountByName>;
};

/** aggregate fields of "reporting.v_ticket_count_by_name" */
export type TixTicketCountByNameAggregateFields = {
  __typename?: 'TicketCountByName_aggregate_fields';
  avg?: Maybe<TixTicketCountByNameAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketCountByNameMaxFields>;
  min?: Maybe<TixTicketCountByNameMinFields>;
  stddev?: Maybe<TixTicketCountByNameStddevFields>;
  stddev_pop?: Maybe<TixTicketCountByNameStddevPopFields>;
  stddev_samp?: Maybe<TixTicketCountByNameStddevSampFields>;
  sum?: Maybe<TixTicketCountByNameSumFields>;
  var_pop?: Maybe<TixTicketCountByNameVarPopFields>;
  var_samp?: Maybe<TixTicketCountByNameVarSampFields>;
  variance?: Maybe<TixTicketCountByNameVarianceFields>;
};


/** aggregate fields of "reporting.v_ticket_count_by_name" */
export type TixTicketCountByNameAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketCountByNameSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixTicketCountByNameAvgFields = {
  __typename?: 'TicketCountByName_avg_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_ticket_count_by_name". All fields are combined with a logical 'AND'. */
export type TixTicketCountByNameBoolExp = {
  _and?: InputMaybe<Array<TixTicketCountByNameBoolExp>>;
  _not?: InputMaybe<TixTicketCountByNameBoolExp>;
  _or?: InputMaybe<Array<TixTicketCountByNameBoolExp>>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  date?: InputMaybe<TixStringComparisonExp>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  fullName?: InputMaybe<TixStringComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  section?: InputMaybe<TixStringComparisonExp>;
  startTime?: InputMaybe<TixStringComparisonExp>;
  ticketCount?: InputMaybe<TixBigintComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixTicketCountByNameMaxFields = {
  __typename?: 'TicketCountByName_max_fields';
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketType?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixTicketCountByNameMinFields = {
  __typename?: 'TicketCountByName_min_fields';
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketType?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reporting.v_ticket_count_by_name". */
export type TixTicketCountByNameOrderBy = {
  companyName?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_ticket_count_by_name" */
export enum TixTicketCountByNameSelectColumn {
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  Date = 'date',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Name = 'name',
  /** column name */
  Section = 'section',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  TicketCount = 'ticketCount',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  VenueName = 'venueName'
}

/** aggregate stddev on columns */
export type TixTicketCountByNameStddevFields = {
  __typename?: 'TicketCountByName_stddev_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixTicketCountByNameStddevPopFields = {
  __typename?: 'TicketCountByName_stddev_pop_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixTicketCountByNameStddevSampFields = {
  __typename?: 'TicketCountByName_stddev_samp_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TicketCountByName" */
export type TixTicketCountByNameStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketCountByNameStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketCountByNameStreamCursorValueInput = {
  companyName?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
  ticketType?: InputMaybe<Scalars['String']>;
  venueName?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixTicketCountByNameSumFields = {
  __typename?: 'TicketCountByName_sum_fields';
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type TixTicketCountByNameVarPopFields = {
  __typename?: 'TicketCountByName_var_pop_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixTicketCountByNameVarSampFields = {
  __typename?: 'TicketCountByName_var_samp_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixTicketCountByNameVarianceFields = {
  __typename?: 'TicketCountByName_variance_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reporting.v_ticket_count_by_channel_type" */
export type TixTicketCountByRevenueType = {
  __typename?: 'TicketCountByRevenueType';
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  paymentType?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketState?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_ticket_count_by_channel_type" */
export type TixTicketCountByRevenueTypeAggregate = {
  __typename?: 'TicketCountByRevenueType_aggregate';
  aggregate?: Maybe<TixTicketCountByRevenueTypeAggregateFields>;
  nodes: Array<TixTicketCountByRevenueType>;
};

/** aggregate fields of "reporting.v_ticket_count_by_channel_type" */
export type TixTicketCountByRevenueTypeAggregateFields = {
  __typename?: 'TicketCountByRevenueType_aggregate_fields';
  avg?: Maybe<TixTicketCountByRevenueTypeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketCountByRevenueTypeMaxFields>;
  min?: Maybe<TixTicketCountByRevenueTypeMinFields>;
  stddev?: Maybe<TixTicketCountByRevenueTypeStddevFields>;
  stddev_pop?: Maybe<TixTicketCountByRevenueTypeStddevPopFields>;
  stddev_samp?: Maybe<TixTicketCountByRevenueTypeStddevSampFields>;
  sum?: Maybe<TixTicketCountByRevenueTypeSumFields>;
  var_pop?: Maybe<TixTicketCountByRevenueTypeVarPopFields>;
  var_samp?: Maybe<TixTicketCountByRevenueTypeVarSampFields>;
  variance?: Maybe<TixTicketCountByRevenueTypeVarianceFields>;
};


/** aggregate fields of "reporting.v_ticket_count_by_channel_type" */
export type TixTicketCountByRevenueTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketCountByRevenueTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixTicketCountByRevenueTypeAvgFields = {
  __typename?: 'TicketCountByRevenueType_avg_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_ticket_count_by_channel_type". All fields are combined with a logical 'AND'. */
export type TixTicketCountByRevenueTypeBoolExp = {
  _and?: InputMaybe<Array<TixTicketCountByRevenueTypeBoolExp>>;
  _not?: InputMaybe<TixTicketCountByRevenueTypeBoolExp>;
  _or?: InputMaybe<Array<TixTicketCountByRevenueTypeBoolExp>>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  paymentType?: InputMaybe<TixStringComparisonExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  ticketCount?: InputMaybe<TixBigintComparisonExp>;
  ticketState?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixTicketCountByRevenueTypeMaxFields = {
  __typename?: 'TicketCountByRevenueType_max_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  paymentType?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketState?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixTicketCountByRevenueTypeMinFields = {
  __typename?: 'TicketCountByRevenueType_min_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  paymentType?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketState?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reporting.v_ticket_count_by_channel_type". */
export type TixTicketCountByRevenueTypeOrderBy = {
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  paymentType?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
  ticketState?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_ticket_count_by_channel_type" */
export enum TixTicketCountByRevenueTypeSelectColumn {
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  PaymentType = 'paymentType',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  TicketCount = 'ticketCount',
  /** column name */
  TicketState = 'ticketState'
}

/** aggregate stddev on columns */
export type TixTicketCountByRevenueTypeStddevFields = {
  __typename?: 'TicketCountByRevenueType_stddev_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixTicketCountByRevenueTypeStddevPopFields = {
  __typename?: 'TicketCountByRevenueType_stddev_pop_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixTicketCountByRevenueTypeStddevSampFields = {
  __typename?: 'TicketCountByRevenueType_stddev_samp_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TicketCountByRevenueType" */
export type TixTicketCountByRevenueTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketCountByRevenueTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketCountByRevenueTypeStreamCursorValueInput = {
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  paymentType?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
  ticketState?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixTicketCountByRevenueTypeSumFields = {
  __typename?: 'TicketCountByRevenueType_sum_fields';
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type TixTicketCountByRevenueTypeVarPopFields = {
  __typename?: 'TicketCountByRevenueType_var_pop_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixTicketCountByRevenueTypeVarSampFields = {
  __typename?: 'TicketCountByRevenueType_var_samp_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixTicketCountByRevenueTypeVarianceFields = {
  __typename?: 'TicketCountByRevenueType_variance_fields';
  ticketCount?: Maybe<Scalars['Float']>;
};

export type TixTicketExchangeActionOutput = {
  __typename?: 'TicketExchangeActionOutput';
  amount: Scalars['Float'];
  type: TixTicketExchangeActionType;
};

export enum TixTicketExchangeActionType {
  None = 'NONE',
  PayExtra = 'PAY_EXTRA',
  Refund = 'REFUND'
}

export enum TixTicketExchangeDonationAction {
  None = 'NONE',
  Refund = 'REFUND'
}

export type TixTicketExchangeNewInput = {
  discountId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  order: TixOrderInput;
};

export type TixTicketExchangeOriginalInput = {
  eventId: Scalars['String'];
  eventProductIds: Array<Scalars['String']>;
  reservationId: Scalars['String'];
  ticketIds: Array<Scalars['String']>;
};

export type TixTicketExchangeRequestInput = {
  customerEmail: Scalars['String'];
  donationAction: TixTicketExchangeDonationAction;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  new: TixTicketExchangeNewInput;
  original: TixTicketExchangeOriginalInput;
};

export type TixTicketInput = {
  ticketConfigId: Scalars['String'];
  ticketId: Scalars['String'];
};

export type TixTicketOnHoldInput = {
  onHold: Scalars['Float'];
  ticketConfigId: Scalars['String'];
};

export type TixTicketOnHoldResult = {
  __typename?: 'TicketOnHoldResult';
  onHold: Scalars['Float'];
  ticketConfigId: Scalars['String'];
  userSessionId?: Maybe<Scalars['String']>;
};

/** columns and relationships of "ticket.reservation_detail" */
export type TixTicketReservationDetail = {
  __typename?: 'TicketReservationDetail';
  active: Scalars['Boolean'];
  amount?: Maybe<Scalars['money']>;
  comment?: Maybe<Scalars['String']>;
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contactId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId: Scalars['uuid'];
  /** An object relationship */
  event_instance?: Maybe<TixEventInstance>;
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  reservation?: Maybe<TixTicketReservation>;
  reservationDetailId: Scalars['uuid'];
  reservationId: Scalars['uuid'];
  ticketConfigId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ticket_config?: Maybe<TixTicketConfig>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "ticket.reservation_detail" */
export type TixTicketReservationDetailAggregate = {
  __typename?: 'TicketReservationDetail_aggregate';
  aggregate?: Maybe<TixTicketReservationDetailAggregateFields>;
  nodes: Array<TixTicketReservationDetail>;
};

export type TixTicketReservationDetailAggregateBoolExp = {
  bool_and?: InputMaybe<TixTicketReservationDetailAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixTicketReservationDetailAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixTicketReservationDetailAggregateBoolExpCount>;
};

export type TixTicketReservationDetailAggregateBoolExpBoolAnd = {
  arguments: TixTicketReservationDetailSelectColumnTicketReservationDetailAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketReservationDetailBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixTicketReservationDetailAggregateBoolExpBoolOr = {
  arguments: TixTicketReservationDetailSelectColumnTicketReservationDetailAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketReservationDetailBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixTicketReservationDetailAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixTicketReservationDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketReservationDetailBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.reservation_detail" */
export type TixTicketReservationDetailAggregateFields = {
  __typename?: 'TicketReservationDetail_aggregate_fields';
  avg?: Maybe<TixTicketReservationDetailAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketReservationDetailMaxFields>;
  min?: Maybe<TixTicketReservationDetailMinFields>;
  stddev?: Maybe<TixTicketReservationDetailStddevFields>;
  stddev_pop?: Maybe<TixTicketReservationDetailStddevPopFields>;
  stddev_samp?: Maybe<TixTicketReservationDetailStddevSampFields>;
  sum?: Maybe<TixTicketReservationDetailSumFields>;
  var_pop?: Maybe<TixTicketReservationDetailVarPopFields>;
  var_samp?: Maybe<TixTicketReservationDetailVarSampFields>;
  variance?: Maybe<TixTicketReservationDetailVarianceFields>;
};


/** aggregate fields of "ticket.reservation_detail" */
export type TixTicketReservationDetailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketReservationDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.reservation_detail" */
export type TixTicketReservationDetailAggregateOrderBy = {
  avg?: InputMaybe<TixTicketReservationDetailAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixTicketReservationDetailMaxOrderBy>;
  min?: InputMaybe<TixTicketReservationDetailMinOrderBy>;
  stddev?: InputMaybe<TixTicketReservationDetailStddevOrderBy>;
  stddev_pop?: InputMaybe<TixTicketReservationDetailStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixTicketReservationDetailStddevSampOrderBy>;
  sum?: InputMaybe<TixTicketReservationDetailSumOrderBy>;
  var_pop?: InputMaybe<TixTicketReservationDetailVarPopOrderBy>;
  var_samp?: InputMaybe<TixTicketReservationDetailVarSampOrderBy>;
  variance?: InputMaybe<TixTicketReservationDetailVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ticket.reservation_detail" */
export type TixTicketReservationDetailArrRelInsertInput = {
  data: Array<TixTicketReservationDetailInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixTicketReservationDetailOnConflict>;
};

/** aggregate avg on columns */
export type TixTicketReservationDetailAvgFields = {
  __typename?: 'TicketReservationDetail_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailAvgOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "ticket.reservation_detail". All fields are combined with a logical 'AND'. */
export type TixTicketReservationDetailBoolExp = {
  _and?: InputMaybe<Array<TixTicketReservationDetailBoolExp>>;
  _not?: InputMaybe<TixTicketReservationDetailBoolExp>;
  _or?: InputMaybe<Array<TixTicketReservationDetailBoolExp>>;
  active?: InputMaybe<TixBooleanComparisonExp>;
  amount?: InputMaybe<TixMoneyComparisonExp>;
  comment?: InputMaybe<TixStringComparisonExp>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  event_instance?: InputMaybe<TixEventInstanceBoolExp>;
  price?: InputMaybe<TixMoneyComparisonExp>;
  quantity?: InputMaybe<TixNumericComparisonExp>;
  reservation?: InputMaybe<TixTicketReservationBoolExp>;
  reservationDetailId?: InputMaybe<TixUuidComparisonExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  ticket_config?: InputMaybe<TixTicketConfigBoolExp>;
  type?: InputMaybe<TixStringComparisonExp>;
};

/** unique or primary key constraints on table "ticket.reservation_detail" */
export enum TixTicketReservationDetailConstraint {
  /** unique or primary key constraint on columns "reservation_detail_id" */
  ReservationDetailPkey = 'reservation_detail_pkey'
}

/** input type for incrementing numeric columns in table "ticket.reservation_detail" */
export type TixTicketReservationDetailIncInput = {
  amount?: InputMaybe<Scalars['money']>;
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "ticket.reservation_detail" */
export type TixTicketReservationDetailInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['money']>;
  comment?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  event_instance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  reservation?: InputMaybe<TixTicketReservationObjRelInsertInput>;
  reservationDetailId?: InputMaybe<Scalars['uuid']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticket_config?: InputMaybe<TixTicketConfigObjRelInsertInput>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TixTicketReservationDetailMaxFields = {
  __typename?: 'TicketReservationDetail_max_fields';
  amount?: Maybe<Scalars['money']>;
  comment?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['numeric']>;
  reservationDetailId?: Maybe<Scalars['uuid']>;
  reservationId?: Maybe<Scalars['uuid']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailMaxOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  comment?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  reservationDetailId?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixTicketReservationDetailMinFields = {
  __typename?: 'TicketReservationDetail_min_fields';
  amount?: Maybe<Scalars['money']>;
  comment?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['numeric']>;
  reservationDetailId?: Maybe<Scalars['uuid']>;
  reservationId?: Maybe<Scalars['uuid']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailMinOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  comment?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  reservationDetailId?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "ticket.reservation_detail" */
export type TixTicketReservationDetailMutationResponse = {
  __typename?: 'TicketReservationDetail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixTicketReservationDetail>;
};

/** on_conflict condition type for table "ticket.reservation_detail" */
export type TixTicketReservationDetailOnConflict = {
  constraint: TixTicketReservationDetailConstraint;
  update_columns?: Array<TixTicketReservationDetailUpdateColumn>;
  where?: InputMaybe<TixTicketReservationDetailBoolExp>;
};

/** Ordering options when selecting data from "ticket.reservation_detail". */
export type TixTicketReservationDetailOrderBy = {
  active?: InputMaybe<TixOrderBy>;
  amount?: InputMaybe<TixOrderBy>;
  comment?: InputMaybe<TixOrderBy>;
  contact?: InputMaybe<TixContactOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  event_instance?: InputMaybe<TixEventInstanceOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  reservation?: InputMaybe<TixTicketReservationOrderBy>;
  reservationDetailId?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticket_config?: InputMaybe<TixTicketConfigOrderBy>;
  type?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.reservation_detail */
export type TixTicketReservationDetailPkColumnsInput = {
  reservationDetailId: Scalars['uuid'];
};

/** select columns of table "ticket.reservation_detail" */
export enum TixTicketReservationDetailSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  Comment = 'comment',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ReservationDetailId = 'reservationDetailId',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  Type = 'type'
}

/** select "TicketReservationDetail_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ticket.reservation_detail" */
export enum TixTicketReservationDetailSelectColumnTicketReservationDetailAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "TicketReservationDetail_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ticket.reservation_detail" */
export enum TixTicketReservationDetailSelectColumnTicketReservationDetailAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "ticket.reservation_detail" */
export type TixTicketReservationDetailSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['money']>;
  comment?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  reservationDetailId?: InputMaybe<Scalars['uuid']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TixTicketReservationDetailStddevFields = {
  __typename?: 'TicketReservationDetail_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailStddevOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixTicketReservationDetailStddevPopFields = {
  __typename?: 'TicketReservationDetail_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailStddevPopOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixTicketReservationDetailStddevSampFields = {
  __typename?: 'TicketReservationDetail_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailStddevSampOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "TicketReservationDetail" */
export type TixTicketReservationDetailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketReservationDetailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketReservationDetailStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['money']>;
  comment?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  reservationDetailId?: InputMaybe<Scalars['uuid']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixTicketReservationDetailSumFields = {
  __typename?: 'TicketReservationDetail_sum_fields';
  amount?: Maybe<Scalars['money']>;
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailSumOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** update columns of table "ticket.reservation_detail" */
export enum TixTicketReservationDetailUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  Comment = 'comment',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ReservationDetailId = 'reservationDetailId',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  Type = 'type'
}

export type TixTicketReservationDetailUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixTicketReservationDetailIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixTicketReservationDetailSetInput>;
  /** filter the rows which have to be updated */
  where: TixTicketReservationDetailBoolExp;
};

/** aggregate var_pop on columns */
export type TixTicketReservationDetailVarPopFields = {
  __typename?: 'TicketReservationDetail_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailVarPopOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixTicketReservationDetailVarSampFields = {
  __typename?: 'TicketReservationDetail_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailVarSampOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixTicketReservationDetailVarianceFields = {
  __typename?: 'TicketReservationDetail_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ticket.reservation_detail" */
export type TixTicketReservationDetailVarianceOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

export type TixTicketSalesWeekDaySummary = {
  __typename?: 'TicketSalesWeekDaySummary';
  ticketTypes: Array<TixTicketSalesWeekTicketType>;
};

export type TixTicketSalesWeekTicketType = {
  __typename?: 'TicketSalesWeekTicketType';
  count: Scalars['Int'];
  ticketType: Scalars['String'];
};

/** aggregated selection of "ticket.ticket" */
export type TixTicketAggregate = {
  __typename?: 'Ticket_aggregate';
  aggregate?: Maybe<TixTicketAggregateFields>;
  nodes: Array<TixTicket>;
};

export type TixTicketAggregateBoolExp = {
  bool_and?: InputMaybe<TixTicketAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixTicketAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixTicketAggregateBoolExpCount>;
};

export type TixTicketAggregateBoolExpBoolAnd = {
  arguments: TixTicketSelectColumnTicketAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixTicketAggregateBoolExpBoolOr = {
  arguments: TixTicketSelectColumnTicketAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixTicketAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixTicketSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.ticket" */
export type TixTicketAggregateFields = {
  __typename?: 'Ticket_aggregate_fields';
  avg?: Maybe<TixTicketAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketMaxFields>;
  min?: Maybe<TixTicketMinFields>;
  stddev?: Maybe<TixTicketStddevFields>;
  stddev_pop?: Maybe<TixTicketStddevPopFields>;
  stddev_samp?: Maybe<TixTicketStddevSampFields>;
  sum?: Maybe<TixTicketSumFields>;
  var_pop?: Maybe<TixTicketVarPopFields>;
  var_samp?: Maybe<TixTicketVarSampFields>;
  variance?: Maybe<TixTicketVarianceFields>;
};


/** aggregate fields of "ticket.ticket" */
export type TixTicketAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.ticket" */
export type TixTicketAggregateOrderBy = {
  avg?: InputMaybe<TixTicketAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixTicketMaxOrderBy>;
  min?: InputMaybe<TixTicketMinOrderBy>;
  stddev?: InputMaybe<TixTicketStddevOrderBy>;
  stddev_pop?: InputMaybe<TixTicketStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixTicketStddevSampOrderBy>;
  sum?: InputMaybe<TixTicketSumOrderBy>;
  var_pop?: InputMaybe<TixTicketVarPopOrderBy>;
  var_samp?: InputMaybe<TixTicketVarSampOrderBy>;
  variance?: InputMaybe<TixTicketVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ticket.ticket" */
export type TixTicketArrRelInsertInput = {
  data: Array<TixTicketInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixTicketOnConflict>;
};

/** aggregate avg on columns */
export type TixTicketAvgFields = {
  __typename?: 'Ticket_avg_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ticket.ticket" */
export type TixTicketAvgOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "ticket.ticket". All fields are combined with a logical 'AND'. */
export type TixTicketBoolExp = {
  _and?: InputMaybe<Array<TixTicketBoolExp>>;
  _not?: InputMaybe<TixTicketBoolExp>;
  _or?: InputMaybe<Array<TixTicketBoolExp>>;
  active?: InputMaybe<TixBooleanComparisonExp>;
  checkedInAt?: InputMaybe<TixTimestamptzComparisonExp>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  discount?: InputMaybe<TixTicketTicketDiscountBoolExp>;
  discountAmount?: InputMaybe<TixMoneyComparisonExp>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  platformFee?: InputMaybe<TixMoneyComparisonExp>;
  processingFee?: InputMaybe<TixMoneyComparisonExp>;
  reservation?: InputMaybe<TixTicketReservationBoolExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  reservationNo?: InputMaybe<TixStringComparisonExp>;
  row?: InputMaybe<TixStringComparisonExp>;
  seat?: InputMaybe<TixStringComparisonExp>;
  section?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  test?: InputMaybe<TixBooleanComparisonExp>;
  ticketConfig?: InputMaybe<TixTicketConfigBoolExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  ticketId?: InputMaybe<TixUuidComparisonExp>;
  ticketNo?: InputMaybe<TixStringComparisonExp>;
  ticketPrice?: InputMaybe<TixMoneyComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueFee?: InputMaybe<TixMoneyComparisonExp>;
};

/** unique or primary key constraints on table "ticket.ticket" */
export enum TixTicketConstraint {
  /** unique or primary key constraint on columns "ticket_id" */
  TicketPkey = 'ticket_pkey'
}

/** input type for incrementing numeric columns in table "ticket.ticket" */
export type TixTicketIncInput = {
  discountAmount?: InputMaybe<Scalars['money']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  ticketPrice?: InputMaybe<Scalars['money']>;
  venueFee?: InputMaybe<Scalars['money']>;
};

/** input type for inserting data into table "ticket.ticket" */
export type TixTicketInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  checkedInAt?: InputMaybe<Scalars['timestamptz']>;
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discount?: InputMaybe<TixTicketTicketDiscountObjRelInsertInput>;
  discountAmount?: InputMaybe<Scalars['money']>;
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  reservation?: InputMaybe<TixTicketReservationObjRelInsertInput>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  row?: InputMaybe<Scalars['String']>;
  seat?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  test?: InputMaybe<Scalars['Boolean']>;
  ticketConfig?: InputMaybe<TixTicketConfigObjRelInsertInput>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketId?: InputMaybe<Scalars['uuid']>;
  ticketPrice?: InputMaybe<Scalars['money']>;
  ticketType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
};

/** aggregate max on columns */
export type TixTicketMaxFields = {
  __typename?: 'Ticket_max_fields';
  checkedInAt?: Maybe<Scalars['timestamptz']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountAmount?: Maybe<Scalars['money']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  reservationId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "ticket.reservation_no" */
  reservationNo?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "ticket.ticket_no" */
  ticketNo?: Maybe<Scalars['String']>;
  ticketPrice?: Maybe<Scalars['money']>;
  ticketType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueFee?: Maybe<Scalars['money']>;
};

/** order by max() on columns of table "ticket.ticket" */
export type TixTicketMaxOrderBy = {
  checkedInAt?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  row?: InputMaybe<TixOrderBy>;
  seat?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketId?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixTicketMinFields = {
  __typename?: 'Ticket_min_fields';
  checkedInAt?: Maybe<Scalars['timestamptz']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountAmount?: Maybe<Scalars['money']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  reservationId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "ticket.reservation_no" */
  reservationNo?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "ticket.ticket_no" */
  ticketNo?: Maybe<Scalars['String']>;
  ticketPrice?: Maybe<Scalars['money']>;
  ticketType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueFee?: Maybe<Scalars['money']>;
};

/** order by min() on columns of table "ticket.ticket" */
export type TixTicketMinOrderBy = {
  checkedInAt?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  row?: InputMaybe<TixOrderBy>;
  seat?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketId?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "ticket.ticket" */
export type TixTicketMutationResponse = {
  __typename?: 'Ticket_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixTicket>;
};

/** input type for inserting object relation for remote table "ticket.ticket" */
export type TixTicketObjRelInsertInput = {
  data: TixTicketInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixTicketOnConflict>;
};

/** on_conflict condition type for table "ticket.ticket" */
export type TixTicketOnConflict = {
  constraint: TixTicketConstraint;
  update_columns?: Array<TixTicketUpdateColumn>;
  where?: InputMaybe<TixTicketBoolExp>;
};

/** Ordering options when selecting data from "ticket.ticket". */
export type TixTicketOrderBy = {
  active?: InputMaybe<TixOrderBy>;
  checkedInAt?: InputMaybe<TixOrderBy>;
  contact?: InputMaybe<TixContactOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  discount?: InputMaybe<TixTicketTicketDiscountOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  reservation?: InputMaybe<TixTicketReservationOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationNo?: InputMaybe<TixOrderBy>;
  row?: InputMaybe<TixOrderBy>;
  seat?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  test?: InputMaybe<TixOrderBy>;
  ticketConfig?: InputMaybe<TixTicketConfigOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketId?: InputMaybe<TixOrderBy>;
  ticketNo?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.ticket */
export type TixTicketPkColumnsInput = {
  ticketId: Scalars['uuid'];
};

/** select columns of table "ticket.ticket" */
export enum TixTicketSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  Row = 'row',
  /** column name */
  Seat = 'seat',
  /** column name */
  Section = 'section',
  /** column name */
  State = 'state',
  /** column name */
  Test = 'test',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TicketId = 'ticketId',
  /** column name */
  TicketPrice = 'ticketPrice',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueFee = 'venueFee'
}

/** select "Ticket_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ticket.ticket" */
export enum TixTicketSelectColumnTicketAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active',
  /** column name */
  Test = 'test'
}

/** select "Ticket_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ticket.ticket" */
export enum TixTicketSelectColumnTicketAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active',
  /** column name */
  Test = 'test'
}

/** input type for updating data in table "ticket.ticket" */
export type TixTicketSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  checkedInAt?: InputMaybe<Scalars['timestamptz']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountAmount?: InputMaybe<Scalars['money']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  row?: InputMaybe<Scalars['String']>;
  seat?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  test?: InputMaybe<Scalars['Boolean']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketId?: InputMaybe<Scalars['uuid']>;
  ticketPrice?: InputMaybe<Scalars['money']>;
  ticketType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
};

/** aggregate stddev on columns */
export type TixTicketStddevFields = {
  __typename?: 'Ticket_stddev_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ticket.ticket" */
export type TixTicketStddevOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixTicketStddevPopFields = {
  __typename?: 'Ticket_stddev_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ticket.ticket" */
export type TixTicketStddevPopOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixTicketStddevSampFields = {
  __typename?: 'Ticket_stddev_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ticket.ticket" */
export type TixTicketStddevSampOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "Ticket" */
export type TixTicketStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  checkedInAt?: InputMaybe<Scalars['timestamptz']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountAmount?: InputMaybe<Scalars['money']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  row?: InputMaybe<Scalars['String']>;
  seat?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  test?: InputMaybe<Scalars['Boolean']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketId?: InputMaybe<Scalars['uuid']>;
  ticketPrice?: InputMaybe<Scalars['money']>;
  ticketType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
};

/** aggregate sum on columns */
export type TixTicketSumFields = {
  __typename?: 'Ticket_sum_fields';
  discountAmount?: Maybe<Scalars['money']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  ticketPrice?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
};

/** order by sum() on columns of table "ticket.ticket" */
export type TixTicketSumOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** update columns of table "ticket.ticket" */
export enum TixTicketUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  Row = 'row',
  /** column name */
  Seat = 'seat',
  /** column name */
  Section = 'section',
  /** column name */
  State = 'state',
  /** column name */
  Test = 'test',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TicketId = 'ticketId',
  /** column name */
  TicketPrice = 'ticketPrice',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueFee = 'venueFee'
}

export type TixTicketUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixTicketIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixTicketSetInput>;
  /** filter the rows which have to be updated */
  where: TixTicketBoolExp;
};

/** aggregate var_pop on columns */
export type TixTicketVarPopFields = {
  __typename?: 'Ticket_var_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ticket.ticket" */
export type TixTicketVarPopOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixTicketVarSampFields = {
  __typename?: 'Ticket_var_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ticket.ticket" */
export type TixTicketVarSampOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixTicketVarianceFields = {
  __typename?: 'Ticket_variance_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ticket.ticket" */
export type TixTicketVarianceOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

export type TixTicketsAmountBreakDown = {
  __typename?: 'TicketsAmountBreakDown';
  cashRevenue: TixCustomTickets;
  compRevenue: TixCustomTickets;
  creditCardRevenue: TixCustomTickets;
};

/** columns and relationships of "access.user" */
export type TixUser = {
  __typename?: 'User';
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contactId?: Maybe<Scalars['uuid']>;
  lastFailedLogin?: Maybe<Scalars['timestamp']>;
  lastSuccessfulLogin?: Maybe<Scalars['timestamp']>;
  noFailedLogins?: Maybe<Scalars['smallint']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  userId: Scalars['uuid'];
  /** An array relationship */
  userRoles: Array<TixUserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: TixUserRoleAggregate;
};


/** columns and relationships of "access.user" */
export type TixUserUserRolesArgs = {
  distinct_on?: InputMaybe<Array<TixUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserRoleOrderBy>>;
  where?: InputMaybe<TixUserRoleBoolExp>;
};


/** columns and relationships of "access.user" */
export type TixUserUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserRoleOrderBy>>;
  where?: InputMaybe<TixUserRoleBoolExp>;
};

/** columns and relationships of "access.user_role" */
export type TixUserRole = {
  __typename?: 'UserRole';
  /** An object relationship */
  Company?: Maybe<TixCompany>;
  companyId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  role?: Maybe<TixRole>;
  roleId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<TixUser>;
  userId?: Maybe<Scalars['uuid']>;
  userRoleId: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "access.user_role" */
export type TixUserRoleAggregate = {
  __typename?: 'UserRole_aggregate';
  aggregate?: Maybe<TixUserRoleAggregateFields>;
  nodes: Array<TixUserRole>;
};

export type TixUserRoleAggregateBoolExp = {
  count?: InputMaybe<TixUserRoleAggregateBoolExpCount>;
};

export type TixUserRoleAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixUserRoleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixUserRoleBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "access.user_role" */
export type TixUserRoleAggregateFields = {
  __typename?: 'UserRole_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixUserRoleMaxFields>;
  min?: Maybe<TixUserRoleMinFields>;
};


/** aggregate fields of "access.user_role" */
export type TixUserRoleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixUserRoleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "access.user_role" */
export type TixUserRoleAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixUserRoleMaxOrderBy>;
  min?: InputMaybe<TixUserRoleMinOrderBy>;
};

/** input type for inserting array relation for remote table "access.user_role" */
export type TixUserRoleArrRelInsertInput = {
  data: Array<TixUserRoleInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixUserRoleOnConflict>;
};

/** Boolean expression to filter rows from the table "access.user_role". All fields are combined with a logical 'AND'. */
export type TixUserRoleBoolExp = {
  Company?: InputMaybe<TixCompanyBoolExp>;
  _and?: InputMaybe<Array<TixUserRoleBoolExp>>;
  _not?: InputMaybe<TixUserRoleBoolExp>;
  _or?: InputMaybe<Array<TixUserRoleBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  role?: InputMaybe<TixRoleBoolExp>;
  roleId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  user?: InputMaybe<TixUserBoolExp>;
  userId?: InputMaybe<TixUuidComparisonExp>;
  userRoleId?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "access.user_role" */
export enum TixUserRoleConstraint {
  /** unique or primary key constraint on columns "user_role_id" */
  UserRolePkey = 'user_role_pkey'
}

/** input type for inserting data into table "access.user_role" */
export type TixUserRoleInsertInput = {
  Company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<TixRoleObjRelInsertInput>;
  roleId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<TixUserObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
  userRoleId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixUserRoleMaxFields = {
  __typename?: 'UserRole_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  roleId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "access.user_role" */
export type TixUserRoleMaxOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  roleId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  userId?: InputMaybe<TixOrderBy>;
  userRoleId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixUserRoleMinFields = {
  __typename?: 'UserRole_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  roleId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "access.user_role" */
export type TixUserRoleMinOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  roleId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  userId?: InputMaybe<TixOrderBy>;
  userRoleId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "access.user_role" */
export type TixUserRoleMutationResponse = {
  __typename?: 'UserRole_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixUserRole>;
};

/** on_conflict condition type for table "access.user_role" */
export type TixUserRoleOnConflict = {
  constraint: TixUserRoleConstraint;
  update_columns?: Array<TixUserRoleUpdateColumn>;
  where?: InputMaybe<TixUserRoleBoolExp>;
};

/** Ordering options when selecting data from "access.user_role". */
export type TixUserRoleOrderBy = {
  Company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  role?: InputMaybe<TixRoleOrderBy>;
  roleId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  user?: InputMaybe<TixUserOrderBy>;
  userId?: InputMaybe<TixOrderBy>;
  userRoleId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: access.user_role */
export type TixUserRolePkColumnsInput = {
  userRoleId: Scalars['uuid'];
};

/** select columns of table "access.user_role" */
export enum TixUserRoleSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserRoleId = 'userRoleId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "access.user_role" */
export type TixUserRoleSetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userRoleId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "UserRole" */
export type TixUserRoleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixUserRoleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixUserRoleStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userRoleId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "access.user_role" */
export enum TixUserRoleUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserRoleId = 'userRoleId',
  /** column name */
  VenueId = 'venueId'
}

export type TixUserRoleUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixUserRoleSetInput>;
  /** filter the rows which have to be updated */
  where: TixUserRoleBoolExp;
};

/** aggregated selection of "access.user" */
export type TixUserAggregate = {
  __typename?: 'User_aggregate';
  aggregate?: Maybe<TixUserAggregateFields>;
  nodes: Array<TixUser>;
};

/** aggregate fields of "access.user" */
export type TixUserAggregateFields = {
  __typename?: 'User_aggregate_fields';
  avg?: Maybe<TixUserAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixUserMaxFields>;
  min?: Maybe<TixUserMinFields>;
  stddev?: Maybe<TixUserStddevFields>;
  stddev_pop?: Maybe<TixUserStddevPopFields>;
  stddev_samp?: Maybe<TixUserStddevSampFields>;
  sum?: Maybe<TixUserSumFields>;
  var_pop?: Maybe<TixUserVarPopFields>;
  var_samp?: Maybe<TixUserVarSampFields>;
  variance?: Maybe<TixUserVarianceFields>;
};


/** aggregate fields of "access.user" */
export type TixUserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixUserAvgFields = {
  __typename?: 'User_avg_fields';
  noFailedLogins?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "access.user". All fields are combined with a logical 'AND'. */
export type TixUserBoolExp = {
  _and?: InputMaybe<Array<TixUserBoolExp>>;
  _not?: InputMaybe<TixUserBoolExp>;
  _or?: InputMaybe<Array<TixUserBoolExp>>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  lastFailedLogin?: InputMaybe<TixTimestampComparisonExp>;
  lastSuccessfulLogin?: InputMaybe<TixTimestampComparisonExp>;
  noFailedLogins?: InputMaybe<TixSmallintComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  userId?: InputMaybe<TixUuidComparisonExp>;
  userRoles?: InputMaybe<TixUserRoleBoolExp>;
  userRoles_aggregate?: InputMaybe<TixUserRoleAggregateBoolExp>;
};

/** unique or primary key constraints on table "access.user" */
export enum TixUserConstraint {
  /** unique or primary key constraint on columns "user_id" */
  UserPkey = 'user_pkey'
}

/** input type for incrementing numeric columns in table "access.user" */
export type TixUserIncInput = {
  noFailedLogins?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "access.user" */
export type TixUserInsertInput = {
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  lastFailedLogin?: InputMaybe<Scalars['timestamp']>;
  lastSuccessfulLogin?: InputMaybe<Scalars['timestamp']>;
  noFailedLogins?: InputMaybe<Scalars['smallint']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userRoles?: InputMaybe<TixUserRoleArrRelInsertInput>;
};

/** aggregate max on columns */
export type TixUserMaxFields = {
  __typename?: 'User_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  lastFailedLogin?: Maybe<Scalars['timestamp']>;
  lastSuccessfulLogin?: Maybe<Scalars['timestamp']>;
  noFailedLogins?: Maybe<Scalars['smallint']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixUserMinFields = {
  __typename?: 'User_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  lastFailedLogin?: Maybe<Scalars['timestamp']>;
  lastSuccessfulLogin?: Maybe<Scalars['timestamp']>;
  noFailedLogins?: Maybe<Scalars['smallint']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "access.user" */
export type TixUserMutationResponse = {
  __typename?: 'User_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixUser>;
};

/** input type for inserting object relation for remote table "access.user" */
export type TixUserObjRelInsertInput = {
  data: TixUserInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixUserOnConflict>;
};

/** on_conflict condition type for table "access.user" */
export type TixUserOnConflict = {
  constraint: TixUserConstraint;
  update_columns?: Array<TixUserUpdateColumn>;
  where?: InputMaybe<TixUserBoolExp>;
};

/** Ordering options when selecting data from "access.user". */
export type TixUserOrderBy = {
  contact?: InputMaybe<TixContactOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  lastFailedLogin?: InputMaybe<TixOrderBy>;
  lastSuccessfulLogin?: InputMaybe<TixOrderBy>;
  noFailedLogins?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  userId?: InputMaybe<TixOrderBy>;
  userRoles_aggregate?: InputMaybe<TixUserRoleAggregateOrderBy>;
};

/** primary key columns input for table: access.user */
export type TixUserPkColumnsInput = {
  userId: Scalars['uuid'];
};

/** select columns of table "access.user" */
export enum TixUserSelectColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  LastFailedLogin = 'lastFailedLogin',
  /** column name */
  LastSuccessfulLogin = 'lastSuccessfulLogin',
  /** column name */
  NoFailedLogins = 'noFailedLogins',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "access.user" */
export type TixUserSetInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  lastFailedLogin?: InputMaybe<Scalars['timestamp']>;
  lastSuccessfulLogin?: InputMaybe<Scalars['timestamp']>;
  noFailedLogins?: InputMaybe<Scalars['smallint']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixUserStddevFields = {
  __typename?: 'User_stddev_fields';
  noFailedLogins?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixUserStddevPopFields = {
  __typename?: 'User_stddev_pop_fields';
  noFailedLogins?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixUserStddevSampFields = {
  __typename?: 'User_stddev_samp_fields';
  noFailedLogins?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "User" */
export type TixUserStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixUserStreamCursorValueInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  lastFailedLogin?: InputMaybe<Scalars['timestamp']>;
  lastSuccessfulLogin?: InputMaybe<Scalars['timestamp']>;
  noFailedLogins?: InputMaybe<Scalars['smallint']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixUserSumFields = {
  __typename?: 'User_sum_fields';
  noFailedLogins?: Maybe<Scalars['smallint']>;
};

/** update columns of table "access.user" */
export enum TixUserUpdateColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  LastFailedLogin = 'lastFailedLogin',
  /** column name */
  LastSuccessfulLogin = 'lastSuccessfulLogin',
  /** column name */
  NoFailedLogins = 'noFailedLogins',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserId = 'userId'
}

export type TixUserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixUserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixUserSetInput>;
  /** filter the rows which have to be updated */
  where: TixUserBoolExp;
};

/** aggregate var_pop on columns */
export type TixUserVarPopFields = {
  __typename?: 'User_var_pop_fields';
  noFailedLogins?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixUserVarSampFields = {
  __typename?: 'User_var_samp_fields';
  noFailedLogins?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixUserVarianceFields = {
  __typename?: 'User_variance_fields';
  noFailedLogins?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "venue.venue" */
export type TixVenue = {
  __typename?: 'Venue';
  additionalInfo?: Maybe<Scalars['String']>;
  /** An array relationship */
  addresses: Array<TixVenueAddress>;
  /** An aggregate relationship */
  addresses_aggregate: TixVenueAddressAggregate;
  /** An object relationship */
  company?: Maybe<TixCompany>;
  companyId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  configurationValues: Array<TixVenueConfigurationValue>;
  /** An aggregate relationship */
  configurationValues_aggregate: TixVenueConfigurationValueAggregate;
  /** An array relationship */
  contacts: Array<TixVenueContact>;
  /** An aggregate relationship */
  contacts_aggregate: TixVenueContactAggregate;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  discounts: Array<TixVenueDiscount>;
  /** An aggregate relationship */
  discounts_aggregate: TixVenueDiscountAggregate;
  /** An array relationship */
  events: Array<TixEventInstance>;
  /** An aggregate relationship */
  events_aggregate: TixEventInstanceAggregate;
  flatFee?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  lineups: Array<TixVenueLineup>;
  /** An aggregate relationship */
  lineups_aggregate: TixVenueLineupAggregate;
  /** An array relationship */
  mediaFiles: Array<TixVenueMediaFile>;
  /** An aggregate relationship */
  mediaFiles_aggregate: TixVenueMediaFileAggregate;
  name: Scalars['String'];
  /** An array relationship */
  payouts: Array<TixPayout>;
  /** An aggregate relationship */
  payouts_aggregate: TixPayoutAggregate;
  /** An array relationship */
  phoneNumbers: Array<TixVenuePhoneNumber>;
  /** An aggregate relationship */
  phoneNumbers_aggregate: TixVenuePhoneNumberAggregate;
  /** An array relationship */
  policy: Array<TixUtilityPolicy>;
  /** An aggregate relationship */
  policy_aggregate: TixUtilityPolicyAggregate;
  slug?: Maybe<Scalars['String']>;
  /** An array relationship */
  socialMedia: Array<TixVenueSocialMedia>;
  /** An aggregate relationship */
  socialMedia_aggregate: TixVenueSocialMediaAggregate;
  state: Scalars['String'];
  /** An array relationship */
  tickets: Array<TixVenueTicket>;
  /** An aggregate relationship */
  tickets_aggregate: TixVenueTicketAggregate;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  url?: Maybe<Scalars['String']>;
  venueId: Scalars['uuid'];
  /** A computed field, executes function "venue.venue_no" */
  venueNo?: Maybe<Scalars['String']>;
  /** An array relationship */
  venueProduct: Array<TixVenueProduct>;
  /** An aggregate relationship */
  venueProduct_aggregate: TixVenueProductAggregate;
  /** An array relationship */
  warnings: Array<TixVenueWarning>;
  /** An aggregate relationship */
  warnings_aggregate: TixVenueWarningAggregate;
};


/** columns and relationships of "venue.venue" */
export type TixVenueAddressesArgs = {
  distinct_on?: InputMaybe<Array<TixVenueAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueAddressOrderBy>>;
  where?: InputMaybe<TixVenueAddressBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueAddressesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueAddressOrderBy>>;
  where?: InputMaybe<TixVenueAddressBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueConfigurationValuesArgs = {
  distinct_on?: InputMaybe<Array<TixVenueConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueConfigurationValueOrderBy>>;
  where?: InputMaybe<TixVenueConfigurationValueBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueConfigurationValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueConfigurationValueOrderBy>>;
  where?: InputMaybe<TixVenueConfigurationValueBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueContactsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueContactOrderBy>>;
  where?: InputMaybe<TixVenueContactBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueContactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueContactOrderBy>>;
  where?: InputMaybe<TixVenueContactBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueDiscountsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueDiscountOrderBy>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueDiscountsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueDiscountOrderBy>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueEventsArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceOrderBy>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceOrderBy>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueLineupsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueLineupOrderBy>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueLineupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueLineupOrderBy>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueMediaFilesArgs = {
  distinct_on?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueMediaFileOrderBy>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueMediaFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueMediaFileOrderBy>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenuePayoutsArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutOrderBy>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenuePayoutsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutOrderBy>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenuePhoneNumbersArgs = {
  distinct_on?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenuePhoneNumberOrderBy>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenuePhoneNumbersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenuePhoneNumberOrderBy>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenuePolicyArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityPolicyOrderBy>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenuePolicyAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityPolicyOrderBy>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueSocialMediaOrderBy>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueSocialMediaOrderBy>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueTicketsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueTicketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueVenueProductArgs = {
  distinct_on?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueProductOrderBy>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueVenueProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueProductOrderBy>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueWarningsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueWarningOrderBy>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};


/** columns and relationships of "venue.venue" */
export type TixVenueWarningsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueWarningOrderBy>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};

/** columns and relationships of "address.venue_address" */
export type TixVenueAddress = {
  __typename?: 'VenueAddress';
  /** An object relationship */
  address?: Maybe<TixAddress>;
  addressId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venue?: Maybe<TixVenue>;
  venueAddressId: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "address.venue_address" */
export type TixVenueAddressAggregate = {
  __typename?: 'VenueAddress_aggregate';
  aggregate?: Maybe<TixVenueAddressAggregateFields>;
  nodes: Array<TixVenueAddress>;
};

export type TixVenueAddressAggregateBoolExp = {
  count?: InputMaybe<TixVenueAddressAggregateBoolExpCount>;
};

export type TixVenueAddressAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueAddressBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "address.venue_address" */
export type TixVenueAddressAggregateFields = {
  __typename?: 'VenueAddress_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueAddressMaxFields>;
  min?: Maybe<TixVenueAddressMinFields>;
};


/** aggregate fields of "address.venue_address" */
export type TixVenueAddressAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address.venue_address" */
export type TixVenueAddressAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueAddressMaxOrderBy>;
  min?: InputMaybe<TixVenueAddressMinOrderBy>;
};

/** input type for inserting array relation for remote table "address.venue_address" */
export type TixVenueAddressArrRelInsertInput = {
  data: Array<TixVenueAddressInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueAddressOnConflict>;
};

/** Boolean expression to filter rows from the table "address.venue_address". All fields are combined with a logical 'AND'. */
export type TixVenueAddressBoolExp = {
  _and?: InputMaybe<Array<TixVenueAddressBoolExp>>;
  _not?: InputMaybe<TixVenueAddressBoolExp>;
  _or?: InputMaybe<Array<TixVenueAddressBoolExp>>;
  address?: InputMaybe<TixAddressBoolExp>;
  addressId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueAddressId?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "address.venue_address" */
export enum TixVenueAddressConstraint {
  /** unique or primary key constraint on columns "venue_address_id" */
  VenueAddressPkey = 'venue_address_pkey'
}

/** input type for inserting data into table "address.venue_address" */
export type TixVenueAddressInsertInput = {
  address?: InputMaybe<TixAddressObjRelInsertInput>;
  addressId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueAddressId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueAddressMaxFields = {
  __typename?: 'VenueAddress_max_fields';
  addressId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueAddressId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "address.venue_address" */
export type TixVenueAddressMaxOrderBy = {
  addressId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueAddressId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueAddressMinFields = {
  __typename?: 'VenueAddress_min_fields';
  addressId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueAddressId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "address.venue_address" */
export type TixVenueAddressMinOrderBy = {
  addressId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueAddressId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "address.venue_address" */
export type TixVenueAddressMutationResponse = {
  __typename?: 'VenueAddress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueAddress>;
};

/** input type for inserting object relation for remote table "address.venue_address" */
export type TixVenueAddressObjRelInsertInput = {
  data: TixVenueAddressInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueAddressOnConflict>;
};

/** on_conflict condition type for table "address.venue_address" */
export type TixVenueAddressOnConflict = {
  constraint: TixVenueAddressConstraint;
  update_columns?: Array<TixVenueAddressUpdateColumn>;
  where?: InputMaybe<TixVenueAddressBoolExp>;
};

/** Ordering options when selecting data from "address.venue_address". */
export type TixVenueAddressOrderBy = {
  address?: InputMaybe<TixAddressOrderBy>;
  addressId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueAddressId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: address.venue_address */
export type TixVenueAddressPkColumnsInput = {
  venueAddressId: Scalars['uuid'];
};

/** select columns of table "address.venue_address" */
export enum TixVenueAddressSelectColumn {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueAddressId = 'venueAddressId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "address.venue_address" */
export type TixVenueAddressSetInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueAddressId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueAddress" */
export type TixVenueAddressStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueAddressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueAddressStreamCursorValueInput = {
  addressId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueAddressId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.venue_address" */
export enum TixVenueAddressUpdateColumn {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueAddressId = 'venueAddressId',
  /** column name */
  VenueId = 'venueId'
}

export type TixVenueAddressUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueAddressSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueAddressBoolExp;
};

/** columns and relationships of "configuration.venue_configuration_value" */
export type TixVenueConfigurationValue = {
  __typename?: 'VenueConfigurationValue';
  /** An object relationship */
  Value?: Maybe<TixConfigurationValue>;
  /** An object relationship */
  Venue?: Maybe<TixVenue>;
  configurationValueId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  venueConfigurationValueId: Scalars['uuid'];
  venueId: Scalars['uuid'];
};

/** aggregated selection of "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueAggregate = {
  __typename?: 'VenueConfigurationValue_aggregate';
  aggregate?: Maybe<TixVenueConfigurationValueAggregateFields>;
  nodes: Array<TixVenueConfigurationValue>;
};

export type TixVenueConfigurationValueAggregateBoolExp = {
  count?: InputMaybe<TixVenueConfigurationValueAggregateBoolExpCount>;
};

export type TixVenueConfigurationValueAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueConfigurationValueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueConfigurationValueBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueAggregateFields = {
  __typename?: 'VenueConfigurationValue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueConfigurationValueMaxFields>;
  min?: Maybe<TixVenueConfigurationValueMinFields>;
};


/** aggregate fields of "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueConfigurationValueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueConfigurationValueMaxOrderBy>;
  min?: InputMaybe<TixVenueConfigurationValueMinOrderBy>;
};

/** input type for inserting array relation for remote table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueArrRelInsertInput = {
  data: Array<TixVenueConfigurationValueInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueConfigurationValueOnConflict>;
};

/** Boolean expression to filter rows from the table "configuration.venue_configuration_value". All fields are combined with a logical 'AND'. */
export type TixVenueConfigurationValueBoolExp = {
  Value?: InputMaybe<TixConfigurationValueBoolExp>;
  Venue?: InputMaybe<TixVenueBoolExp>;
  _and?: InputMaybe<Array<TixVenueConfigurationValueBoolExp>>;
  _not?: InputMaybe<TixVenueConfigurationValueBoolExp>;
  _or?: InputMaybe<Array<TixVenueConfigurationValueBoolExp>>;
  configurationValueId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueConfigurationValueId?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "configuration.venue_configuration_value" */
export enum TixVenueConfigurationValueConstraint {
  /** unique or primary key constraint on columns "venue_configuration_value_id" */
  VenueConfigurationValuePkey = 'venue_configuration_value_pkey'
}

/** input type for inserting data into table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueInsertInput = {
  Value?: InputMaybe<TixConfigurationValueObjRelInsertInput>;
  Venue?: InputMaybe<TixVenueObjRelInsertInput>;
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueConfigurationValueId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueConfigurationValueMaxFields = {
  __typename?: 'VenueConfigurationValue_max_fields';
  configurationValueId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueConfigurationValueId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueMaxOrderBy = {
  configurationValueId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueConfigurationValueId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueConfigurationValueMinFields = {
  __typename?: 'VenueConfigurationValue_min_fields';
  configurationValueId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueConfigurationValueId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueMinOrderBy = {
  configurationValueId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueConfigurationValueId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueMutationResponse = {
  __typename?: 'VenueConfigurationValue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueConfigurationValue>;
};

/** input type for inserting object relation for remote table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueObjRelInsertInput = {
  data: TixVenueConfigurationValueInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueConfigurationValueOnConflict>;
};

/** on_conflict condition type for table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueOnConflict = {
  constraint: TixVenueConfigurationValueConstraint;
  update_columns?: Array<TixVenueConfigurationValueUpdateColumn>;
  where?: InputMaybe<TixVenueConfigurationValueBoolExp>;
};

/** Ordering options when selecting data from "configuration.venue_configuration_value". */
export type TixVenueConfigurationValueOrderBy = {
  Value?: InputMaybe<TixConfigurationValueOrderBy>;
  Venue?: InputMaybe<TixVenueOrderBy>;
  configurationValueId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueConfigurationValueId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: configuration.venue_configuration_value */
export type TixVenueConfigurationValuePkColumnsInput = {
  venueConfigurationValueId: Scalars['uuid'];
};

/** select columns of table "configuration.venue_configuration_value" */
export enum TixVenueConfigurationValueSelectColumn {
  /** column name */
  ConfigurationValueId = 'configurationValueId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueConfigurationValueId = 'venueConfigurationValueId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "configuration.venue_configuration_value" */
export type TixVenueConfigurationValueSetInput = {
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueConfigurationValueId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueConfigurationValue" */
export type TixVenueConfigurationValueStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueConfigurationValueStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueConfigurationValueStreamCursorValueInput = {
  configurationValueId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueConfigurationValueId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "configuration.venue_configuration_value" */
export enum TixVenueConfigurationValueUpdateColumn {
  /** column name */
  ConfigurationValueId = 'configurationValueId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueConfigurationValueId = 'venueConfigurationValueId',
  /** column name */
  VenueId = 'venueId'
}

export type TixVenueConfigurationValueUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueConfigurationValueSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueConfigurationValueBoolExp;
};

/** columns and relationships of "contact.venue_contact" */
export type TixVenueContact = {
  __typename?: 'VenueContact';
  /** An array relationship */
  contact: Array<TixContact>;
  contactId?: Maybe<Scalars['uuid']>;
  contactRoleId?: Maybe<Scalars['uuid']>;
  /** An aggregate relationship */
  contact_aggregate: TixContactAggregate;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venue?: Maybe<TixVenue>;
  venueContactId: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "contact.venue_contact" */
export type TixVenueContactContactArgs = {
  distinct_on?: InputMaybe<Array<TixContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactOrderBy>>;
  where?: InputMaybe<TixContactBoolExp>;
};


/** columns and relationships of "contact.venue_contact" */
export type TixVenueContactContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactOrderBy>>;
  where?: InputMaybe<TixContactBoolExp>;
};

/** aggregated selection of "contact.venue_contact" */
export type TixVenueContactAggregate = {
  __typename?: 'VenueContact_aggregate';
  aggregate?: Maybe<TixVenueContactAggregateFields>;
  nodes: Array<TixVenueContact>;
};

export type TixVenueContactAggregateBoolExp = {
  count?: InputMaybe<TixVenueContactAggregateBoolExpCount>;
};

export type TixVenueContactAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueContactSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueContactBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "contact.venue_contact" */
export type TixVenueContactAggregateFields = {
  __typename?: 'VenueContact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueContactMaxFields>;
  min?: Maybe<TixVenueContactMinFields>;
};


/** aggregate fields of "contact.venue_contact" */
export type TixVenueContactAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueContactSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contact.venue_contact" */
export type TixVenueContactAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueContactMaxOrderBy>;
  min?: InputMaybe<TixVenueContactMinOrderBy>;
};

/** input type for inserting array relation for remote table "contact.venue_contact" */
export type TixVenueContactArrRelInsertInput = {
  data: Array<TixVenueContactInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueContactOnConflict>;
};

/** Boolean expression to filter rows from the table "contact.venue_contact". All fields are combined with a logical 'AND'. */
export type TixVenueContactBoolExp = {
  _and?: InputMaybe<Array<TixVenueContactBoolExp>>;
  _not?: InputMaybe<TixVenueContactBoolExp>;
  _or?: InputMaybe<Array<TixVenueContactBoolExp>>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  contactRoleId?: InputMaybe<TixUuidComparisonExp>;
  contact_aggregate?: InputMaybe<TixContactAggregateBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueContactId?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "contact.venue_contact" */
export enum TixVenueContactConstraint {
  /** unique or primary key constraint on columns "venue_contact_id" */
  VenueContactPkey = 'venue_contact_pkey'
}

/** input type for inserting data into table "contact.venue_contact" */
export type TixVenueContactInsertInput = {
  contact?: InputMaybe<TixContactArrRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  contactRoleId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueContactId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueContactMaxFields = {
  __typename?: 'VenueContact_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  contactRoleId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueContactId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "contact.venue_contact" */
export type TixVenueContactMaxOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  contactRoleId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueContactId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueContactMinFields = {
  __typename?: 'VenueContact_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  contactRoleId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueContactId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "contact.venue_contact" */
export type TixVenueContactMinOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  contactRoleId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueContactId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "contact.venue_contact" */
export type TixVenueContactMutationResponse = {
  __typename?: 'VenueContact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueContact>;
};

/** on_conflict condition type for table "contact.venue_contact" */
export type TixVenueContactOnConflict = {
  constraint: TixVenueContactConstraint;
  update_columns?: Array<TixVenueContactUpdateColumn>;
  where?: InputMaybe<TixVenueContactBoolExp>;
};

/** Ordering options when selecting data from "contact.venue_contact". */
export type TixVenueContactOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  contactRoleId?: InputMaybe<TixOrderBy>;
  contact_aggregate?: InputMaybe<TixContactAggregateOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueContactId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: contact.venue_contact */
export type TixVenueContactPkColumnsInput = {
  venueContactId: Scalars['uuid'];
};

/** select columns of table "contact.venue_contact" */
export enum TixVenueContactSelectColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  ContactRoleId = 'contactRoleId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueContactId = 'venueContactId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "contact.venue_contact" */
export type TixVenueContactSetInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  contactRoleId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueContactId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueContact" */
export type TixVenueContactStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueContactStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueContactStreamCursorValueInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  contactRoleId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueContactId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "contact.venue_contact" */
export enum TixVenueContactUpdateColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  ContactRoleId = 'contactRoleId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueContactId = 'venueContactId',
  /** column name */
  VenueId = 'venueId'
}

export type TixVenueContactUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueContactSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueContactBoolExp;
};

/** columns and relationships of "discount.venue_discount" */
export type TixVenueDiscount = {
  __typename?: 'VenueDiscount';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  discount: Array<TixDiscount>;
  discountId: Scalars['uuid'];
  /** An aggregate relationship */
  discount_aggregate: TixDiscountAggregate;
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venue?: Maybe<TixVenue>;
  venueDiscountId: Scalars['uuid'];
  venueId: Scalars['uuid'];
};


/** columns and relationships of "discount.venue_discount" */
export type TixVenueDiscountDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountOrderBy>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};


/** columns and relationships of "discount.venue_discount" */
export type TixVenueDiscountDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountOrderBy>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};

/** aggregated selection of "discount.venue_discount" */
export type TixVenueDiscountAggregate = {
  __typename?: 'VenueDiscount_aggregate';
  aggregate?: Maybe<TixVenueDiscountAggregateFields>;
  nodes: Array<TixVenueDiscount>;
};

export type TixVenueDiscountAggregateBoolExp = {
  count?: InputMaybe<TixVenueDiscountAggregateBoolExpCount>;
};

export type TixVenueDiscountAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueDiscountBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "discount.venue_discount" */
export type TixVenueDiscountAggregateFields = {
  __typename?: 'VenueDiscount_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueDiscountMaxFields>;
  min?: Maybe<TixVenueDiscountMinFields>;
};


/** aggregate fields of "discount.venue_discount" */
export type TixVenueDiscountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount.venue_discount" */
export type TixVenueDiscountAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueDiscountMaxOrderBy>;
  min?: InputMaybe<TixVenueDiscountMinOrderBy>;
};

/** input type for inserting array relation for remote table "discount.venue_discount" */
export type TixVenueDiscountArrRelInsertInput = {
  data: Array<TixVenueDiscountInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueDiscountOnConflict>;
};

/** Boolean expression to filter rows from the table "discount.venue_discount". All fields are combined with a logical 'AND'. */
export type TixVenueDiscountBoolExp = {
  _and?: InputMaybe<Array<TixVenueDiscountBoolExp>>;
  _not?: InputMaybe<TixVenueDiscountBoolExp>;
  _or?: InputMaybe<Array<TixVenueDiscountBoolExp>>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  discount?: InputMaybe<TixDiscountBoolExp>;
  discountId?: InputMaybe<TixUuidComparisonExp>;
  discount_aggregate?: InputMaybe<TixDiscountAggregateBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueDiscountId?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "discount.venue_discount" */
export enum TixVenueDiscountConstraint {
  /** unique or primary key constraint on columns "venue_discount_id" */
  VenueDiscountPkey = 'venue_discount_pkey'
}

/** input type for inserting data into table "discount.venue_discount" */
export type TixVenueDiscountInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discount?: InputMaybe<TixDiscountArrRelInsertInput>;
  discountId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueDiscountId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueDiscountMaxFields = {
  __typename?: 'VenueDiscount_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueDiscountId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "discount.venue_discount" */
export type TixVenueDiscountMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueDiscountId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueDiscountMinFields = {
  __typename?: 'VenueDiscount_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueDiscountId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "discount.venue_discount" */
export type TixVenueDiscountMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueDiscountId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "discount.venue_discount" */
export type TixVenueDiscountMutationResponse = {
  __typename?: 'VenueDiscount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueDiscount>;
};

/** on_conflict condition type for table "discount.venue_discount" */
export type TixVenueDiscountOnConflict = {
  constraint: TixVenueDiscountConstraint;
  update_columns?: Array<TixVenueDiscountUpdateColumn>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};

/** Ordering options when selecting data from "discount.venue_discount". */
export type TixVenueDiscountOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  discount_aggregate?: InputMaybe<TixDiscountAggregateOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueDiscountId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: discount.venue_discount */
export type TixVenueDiscountPkColumnsInput = {
  venueDiscountId: Scalars['uuid'];
};

/** select columns of table "discount.venue_discount" */
export enum TixVenueDiscountSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueDiscountId = 'venueDiscountId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "discount.venue_discount" */
export type TixVenueDiscountSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueDiscountId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueDiscount" */
export type TixVenueDiscountStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueDiscountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueDiscountStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueDiscountId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "discount.venue_discount" */
export enum TixVenueDiscountUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueDiscountId = 'venueDiscountId',
  /** column name */
  VenueId = 'venueId'
}

export type TixVenueDiscountUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueDiscountSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueDiscountBoolExp;
};

/** columns and relationships of "performer.venue_lineup" */
export type TixVenueLineup = {
  __typename?: 'VenueLineup';
  /** An object relationship */
  lineup: TixLineup;
  lineupId: Scalars['uuid'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venue: TixVenue;
  venueId: Scalars['uuid'];
  venueLineupId: Scalars['uuid'];
};

/** aggregated selection of "performer.venue_lineup" */
export type TixVenueLineupAggregate = {
  __typename?: 'VenueLineup_aggregate';
  aggregate?: Maybe<TixVenueLineupAggregateFields>;
  nodes: Array<TixVenueLineup>;
};

export type TixVenueLineupAggregateBoolExp = {
  count?: InputMaybe<TixVenueLineupAggregateBoolExpCount>;
};

export type TixVenueLineupAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueLineupBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "performer.venue_lineup" */
export type TixVenueLineupAggregateFields = {
  __typename?: 'VenueLineup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueLineupMaxFields>;
  min?: Maybe<TixVenueLineupMinFields>;
};


/** aggregate fields of "performer.venue_lineup" */
export type TixVenueLineupAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "performer.venue_lineup" */
export type TixVenueLineupAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueLineupMaxOrderBy>;
  min?: InputMaybe<TixVenueLineupMinOrderBy>;
};

/** input type for inserting array relation for remote table "performer.venue_lineup" */
export type TixVenueLineupArrRelInsertInput = {
  data: Array<TixVenueLineupInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueLineupOnConflict>;
};

/** Boolean expression to filter rows from the table "performer.venue_lineup". All fields are combined with a logical 'AND'. */
export type TixVenueLineupBoolExp = {
  _and?: InputMaybe<Array<TixVenueLineupBoolExp>>;
  _not?: InputMaybe<TixVenueLineupBoolExp>;
  _or?: InputMaybe<Array<TixVenueLineupBoolExp>>;
  lineup?: InputMaybe<TixLineupBoolExp>;
  lineupId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueLineupId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "performer.venue_lineup" */
export enum TixVenueLineupConstraint {
  /** unique or primary key constraint on columns "venue_lineup_id" */
  VenueLineupIdPk = 'venue_lineup_id_pk'
}

/** input type for inserting data into table "performer.venue_lineup" */
export type TixVenueLineupInsertInput = {
  lineup?: InputMaybe<TixLineupObjRelInsertInput>;
  lineupId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueLineupId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueLineupMaxFields = {
  __typename?: 'VenueLineup_max_fields';
  lineupId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueLineupId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "performer.venue_lineup" */
export type TixVenueLineupMaxOrderBy = {
  lineupId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueLineupId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueLineupMinFields = {
  __typename?: 'VenueLineup_min_fields';
  lineupId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueLineupId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "performer.venue_lineup" */
export type TixVenueLineupMinOrderBy = {
  lineupId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueLineupId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "performer.venue_lineup" */
export type TixVenueLineupMutationResponse = {
  __typename?: 'VenueLineup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueLineup>;
};

/** on_conflict condition type for table "performer.venue_lineup" */
export type TixVenueLineupOnConflict = {
  constraint: TixVenueLineupConstraint;
  update_columns?: Array<TixVenueLineupUpdateColumn>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};

/** Ordering options when selecting data from "performer.venue_lineup". */
export type TixVenueLineupOrderBy = {
  lineup?: InputMaybe<TixLineupOrderBy>;
  lineupId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueLineupId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: performer.venue_lineup */
export type TixVenueLineupPkColumnsInput = {
  venueLineupId: Scalars['uuid'];
};

/** select columns of table "performer.venue_lineup" */
export enum TixVenueLineupSelectColumn {
  /** column name */
  LineupId = 'lineupId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueLineupId = 'venueLineupId'
}

/** input type for updating data in table "performer.venue_lineup" */
export type TixVenueLineupSetInput = {
  lineupId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueLineupId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueLineup" */
export type TixVenueLineupStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueLineupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueLineupStreamCursorValueInput = {
  lineupId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueLineupId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "performer.venue_lineup" */
export enum TixVenueLineupUpdateColumn {
  /** column name */
  LineupId = 'lineupId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueLineupId = 'venueLineupId'
}

export type TixVenueLineupUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueLineupSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueLineupBoolExp;
};

/** columns and relationships of "media.venue_media_file" */
export type TixVenueMediaFile = {
  __typename?: 'VenueMediaFile';
  /** An object relationship */
  Venue?: Maybe<TixVenue>;
  /** An object relationship */
  mediaFile?: Maybe<TixMediaFile>;
  mediaFileId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
  venueImageFileId: Scalars['uuid'];
};

/** aggregated selection of "media.venue_media_file" */
export type TixVenueMediaFileAggregate = {
  __typename?: 'VenueMediaFile_aggregate';
  aggregate?: Maybe<TixVenueMediaFileAggregateFields>;
  nodes: Array<TixVenueMediaFile>;
};

export type TixVenueMediaFileAggregateBoolExp = {
  count?: InputMaybe<TixVenueMediaFileAggregateBoolExpCount>;
};

export type TixVenueMediaFileAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueMediaFileBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "media.venue_media_file" */
export type TixVenueMediaFileAggregateFields = {
  __typename?: 'VenueMediaFile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueMediaFileMaxFields>;
  min?: Maybe<TixVenueMediaFileMinFields>;
};


/** aggregate fields of "media.venue_media_file" */
export type TixVenueMediaFileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media.venue_media_file" */
export type TixVenueMediaFileAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueMediaFileMaxOrderBy>;
  min?: InputMaybe<TixVenueMediaFileMinOrderBy>;
};

/** input type for inserting array relation for remote table "media.venue_media_file" */
export type TixVenueMediaFileArrRelInsertInput = {
  data: Array<TixVenueMediaFileInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueMediaFileOnConflict>;
};

/** Boolean expression to filter rows from the table "media.venue_media_file". All fields are combined with a logical 'AND'. */
export type TixVenueMediaFileBoolExp = {
  Venue?: InputMaybe<TixVenueBoolExp>;
  _and?: InputMaybe<Array<TixVenueMediaFileBoolExp>>;
  _not?: InputMaybe<TixVenueMediaFileBoolExp>;
  _or?: InputMaybe<Array<TixVenueMediaFileBoolExp>>;
  mediaFile?: InputMaybe<TixMediaFileBoolExp>;
  mediaFileId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueImageFileId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "media.venue_media_file" */
export enum TixVenueMediaFileConstraint {
  /** unique or primary key constraint on columns "venue_image_file_id" */
  VenueImageFilePkey = 'venue_image_file_pkey'
}

/** input type for inserting data into table "media.venue_media_file" */
export type TixVenueMediaFileInsertInput = {
  Venue?: InputMaybe<TixVenueObjRelInsertInput>;
  mediaFile?: InputMaybe<TixMediaFileObjRelInsertInput>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueImageFileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueMediaFileMaxFields = {
  __typename?: 'VenueMediaFile_max_fields';
  mediaFileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueImageFileId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "media.venue_media_file" */
export type TixVenueMediaFileMaxOrderBy = {
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueImageFileId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueMediaFileMinFields = {
  __typename?: 'VenueMediaFile_min_fields';
  mediaFileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueImageFileId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "media.venue_media_file" */
export type TixVenueMediaFileMinOrderBy = {
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueImageFileId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "media.venue_media_file" */
export type TixVenueMediaFileMutationResponse = {
  __typename?: 'VenueMediaFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueMediaFile>;
};

/** on_conflict condition type for table "media.venue_media_file" */
export type TixVenueMediaFileOnConflict = {
  constraint: TixVenueMediaFileConstraint;
  update_columns?: Array<TixVenueMediaFileUpdateColumn>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};

/** Ordering options when selecting data from "media.venue_media_file". */
export type TixVenueMediaFileOrderBy = {
  Venue?: InputMaybe<TixVenueOrderBy>;
  mediaFile?: InputMaybe<TixMediaFileOrderBy>;
  mediaFileId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueImageFileId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: media.venue_media_file */
export type TixVenueMediaFilePkColumnsInput = {
  venueImageFileId: Scalars['uuid'];
};

/** select columns of table "media.venue_media_file" */
export enum TixVenueMediaFileSelectColumn {
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueImageFileId = 'venueImageFileId'
}

/** input type for updating data in table "media.venue_media_file" */
export type TixVenueMediaFileSetInput = {
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueImageFileId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueMediaFile" */
export type TixVenueMediaFileStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueMediaFileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueMediaFileStreamCursorValueInput = {
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueImageFileId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.venue_media_file" */
export enum TixVenueMediaFileUpdateColumn {
  /** column name */
  MediaFileId = 'mediaFileId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueImageFileId = 'venueImageFileId'
}

export type TixVenueMediaFileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueMediaFileSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueMediaFileBoolExp;
};

/** columns and relationships of "address.venue_phone_number" */
export type TixVenuePhoneNumber = {
  __typename?: 'VenuePhoneNumber';
  /** An object relationship */
  phoneNumber?: Maybe<TixPhoneNumber>;
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venue?: Maybe<TixVenue>;
  venueId?: Maybe<Scalars['uuid']>;
  venuePhoneNumberId: Scalars['uuid'];
};

/** aggregated selection of "address.venue_phone_number" */
export type TixVenuePhoneNumberAggregate = {
  __typename?: 'VenuePhoneNumber_aggregate';
  aggregate?: Maybe<TixVenuePhoneNumberAggregateFields>;
  nodes: Array<TixVenuePhoneNumber>;
};

export type TixVenuePhoneNumberAggregateBoolExp = {
  count?: InputMaybe<TixVenuePhoneNumberAggregateBoolExpCount>;
};

export type TixVenuePhoneNumberAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenuePhoneNumberBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "address.venue_phone_number" */
export type TixVenuePhoneNumberAggregateFields = {
  __typename?: 'VenuePhoneNumber_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenuePhoneNumberMaxFields>;
  min?: Maybe<TixVenuePhoneNumberMinFields>;
};


/** aggregate fields of "address.venue_phone_number" */
export type TixVenuePhoneNumberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address.venue_phone_number" */
export type TixVenuePhoneNumberAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenuePhoneNumberMaxOrderBy>;
  min?: InputMaybe<TixVenuePhoneNumberMinOrderBy>;
};

/** input type for inserting array relation for remote table "address.venue_phone_number" */
export type TixVenuePhoneNumberArrRelInsertInput = {
  data: Array<TixVenuePhoneNumberInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenuePhoneNumberOnConflict>;
};

/** Boolean expression to filter rows from the table "address.venue_phone_number". All fields are combined with a logical 'AND'. */
export type TixVenuePhoneNumberBoolExp = {
  _and?: InputMaybe<Array<TixVenuePhoneNumberBoolExp>>;
  _not?: InputMaybe<TixVenuePhoneNumberBoolExp>;
  _or?: InputMaybe<Array<TixVenuePhoneNumberBoolExp>>;
  phoneNumber?: InputMaybe<TixPhoneNumberBoolExp>;
  phoneNumberId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venuePhoneNumberId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "address.venue_phone_number" */
export enum TixVenuePhoneNumberConstraint {
  /** unique or primary key constraint on columns "venue_phone_number_id" */
  VenuePhoneNumberPkey = 'venue_phone_number_pkey'
}

/** input type for inserting data into table "address.venue_phone_number" */
export type TixVenuePhoneNumberInsertInput = {
  phoneNumber?: InputMaybe<TixPhoneNumberObjRelInsertInput>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venuePhoneNumberId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenuePhoneNumberMaxFields = {
  __typename?: 'VenuePhoneNumber_max_fields';
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venuePhoneNumberId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "address.venue_phone_number" */
export type TixVenuePhoneNumberMaxOrderBy = {
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venuePhoneNumberId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenuePhoneNumberMinFields = {
  __typename?: 'VenuePhoneNumber_min_fields';
  phoneNumberId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venuePhoneNumberId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "address.venue_phone_number" */
export type TixVenuePhoneNumberMinOrderBy = {
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venuePhoneNumberId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "address.venue_phone_number" */
export type TixVenuePhoneNumberMutationResponse = {
  __typename?: 'VenuePhoneNumber_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenuePhoneNumber>;
};

/** on_conflict condition type for table "address.venue_phone_number" */
export type TixVenuePhoneNumberOnConflict = {
  constraint: TixVenuePhoneNumberConstraint;
  update_columns?: Array<TixVenuePhoneNumberUpdateColumn>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};

/** Ordering options when selecting data from "address.venue_phone_number". */
export type TixVenuePhoneNumberOrderBy = {
  phoneNumber?: InputMaybe<TixPhoneNumberOrderBy>;
  phoneNumberId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venuePhoneNumberId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: address.venue_phone_number */
export type TixVenuePhoneNumberPkColumnsInput = {
  venuePhoneNumberId: Scalars['uuid'];
};

/** select columns of table "address.venue_phone_number" */
export enum TixVenuePhoneNumberSelectColumn {
  /** column name */
  PhoneNumberId = 'phoneNumberId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenuePhoneNumberId = 'venuePhoneNumberId'
}

/** input type for updating data in table "address.venue_phone_number" */
export type TixVenuePhoneNumberSetInput = {
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venuePhoneNumberId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenuePhoneNumber" */
export type TixVenuePhoneNumberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenuePhoneNumberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenuePhoneNumberStreamCursorValueInput = {
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venuePhoneNumberId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.venue_phone_number" */
export enum TixVenuePhoneNumberUpdateColumn {
  /** column name */
  PhoneNumberId = 'phoneNumberId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenuePhoneNumberId = 'venuePhoneNumberId'
}

export type TixVenuePhoneNumberUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenuePhoneNumberSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenuePhoneNumberBoolExp;
};

/** columns and relationships of "product.venue_product" */
export type TixVenueProduct = {
  __typename?: 'VenueProduct';
  /** An object relationship */
  VenueProduct?: Maybe<TixProduct>;
  /** An object relationship */
  VenueProductVenue?: Maybe<TixVenue>;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  productId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  venueId: Scalars['uuid'];
  venueProductId: Scalars['uuid'];
};

/** aggregated selection of "product.venue_product" */
export type TixVenueProductAggregate = {
  __typename?: 'VenueProduct_aggregate';
  aggregate?: Maybe<TixVenueProductAggregateFields>;
  nodes: Array<TixVenueProduct>;
};

export type TixVenueProductAggregateBoolExp = {
  count?: InputMaybe<TixVenueProductAggregateBoolExpCount>;
};

export type TixVenueProductAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueProductBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "product.venue_product" */
export type TixVenueProductAggregateFields = {
  __typename?: 'VenueProduct_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueProductMaxFields>;
  min?: Maybe<TixVenueProductMinFields>;
};


/** aggregate fields of "product.venue_product" */
export type TixVenueProductAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product.venue_product" */
export type TixVenueProductAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueProductMaxOrderBy>;
  min?: InputMaybe<TixVenueProductMinOrderBy>;
};

/** input type for inserting array relation for remote table "product.venue_product" */
export type TixVenueProductArrRelInsertInput = {
  data: Array<TixVenueProductInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueProductOnConflict>;
};

/** Boolean expression to filter rows from the table "product.venue_product". All fields are combined with a logical 'AND'. */
export type TixVenueProductBoolExp = {
  VenueProduct?: InputMaybe<TixProductBoolExp>;
  VenueProductVenue?: InputMaybe<TixVenueBoolExp>;
  _and?: InputMaybe<Array<TixVenueProductBoolExp>>;
  _not?: InputMaybe<TixVenueProductBoolExp>;
  _or?: InputMaybe<Array<TixVenueProductBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  productId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueProductId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "product.venue_product" */
export enum TixVenueProductConstraint {
  /** unique or primary key constraint on columns "venue_product_id" */
  VenueProductPkey = 'venue_product_pkey'
}

/** input type for inserting data into table "product.venue_product" */
export type TixVenueProductInsertInput = {
  VenueProduct?: InputMaybe<TixProductObjRelInsertInput>;
  VenueProductVenue?: InputMaybe<TixVenueObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueProductId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueProductMaxFields = {
  __typename?: 'VenueProduct_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueProductId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product.venue_product" */
export type TixVenueProductMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueProductId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueProductMinFields = {
  __typename?: 'VenueProduct_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  productId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueProductId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product.venue_product" */
export type TixVenueProductMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueProductId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "product.venue_product" */
export type TixVenueProductMutationResponse = {
  __typename?: 'VenueProduct_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueProduct>;
};

/** on_conflict condition type for table "product.venue_product" */
export type TixVenueProductOnConflict = {
  constraint: TixVenueProductConstraint;
  update_columns?: Array<TixVenueProductUpdateColumn>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};

/** Ordering options when selecting data from "product.venue_product". */
export type TixVenueProductOrderBy = {
  VenueProduct?: InputMaybe<TixProductOrderBy>;
  VenueProductVenue?: InputMaybe<TixVenueOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  productId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueProductId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: product.venue_product */
export type TixVenueProductPkColumnsInput = {
  venueProductId: Scalars['uuid'];
};

/** select columns of table "product.venue_product" */
export enum TixVenueProductSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueProductId = 'venueProductId'
}

/** input type for updating data in table "product.venue_product" */
export type TixVenueProductSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueProductId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueProduct" */
export type TixVenueProductStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueProductStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueProductStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  productId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueProductId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "product.venue_product" */
export enum TixVenueProductUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueProductId = 'venueProductId'
}

export type TixVenueProductUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueProductSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueProductBoolExp;
};

/** columns and relationships of "media.venue_social_media" */
export type TixVenueSocialMedia = {
  __typename?: 'VenueSocialMedia';
  /** An object relationship */
  Venue?: Maybe<TixVenue>;
  /** An object relationship */
  socialMedia?: Maybe<TixSocialMedia>;
  socialMediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueSocialMediaId: Scalars['uuid'];
};

/** aggregated selection of "media.venue_social_media" */
export type TixVenueSocialMediaAggregate = {
  __typename?: 'VenueSocialMedia_aggregate';
  aggregate?: Maybe<TixVenueSocialMediaAggregateFields>;
  nodes: Array<TixVenueSocialMedia>;
};

export type TixVenueSocialMediaAggregateBoolExp = {
  count?: InputMaybe<TixVenueSocialMediaAggregateBoolExpCount>;
};

export type TixVenueSocialMediaAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueSocialMediaBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "media.venue_social_media" */
export type TixVenueSocialMediaAggregateFields = {
  __typename?: 'VenueSocialMedia_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueSocialMediaMaxFields>;
  min?: Maybe<TixVenueSocialMediaMinFields>;
};


/** aggregate fields of "media.venue_social_media" */
export type TixVenueSocialMediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "media.venue_social_media" */
export type TixVenueSocialMediaAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueSocialMediaMaxOrderBy>;
  min?: InputMaybe<TixVenueSocialMediaMinOrderBy>;
};

/** input type for inserting array relation for remote table "media.venue_social_media" */
export type TixVenueSocialMediaArrRelInsertInput = {
  data: Array<TixVenueSocialMediaInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueSocialMediaOnConflict>;
};

/** Boolean expression to filter rows from the table "media.venue_social_media". All fields are combined with a logical 'AND'. */
export type TixVenueSocialMediaBoolExp = {
  Venue?: InputMaybe<TixVenueBoolExp>;
  _and?: InputMaybe<Array<TixVenueSocialMediaBoolExp>>;
  _not?: InputMaybe<TixVenueSocialMediaBoolExp>;
  _or?: InputMaybe<Array<TixVenueSocialMediaBoolExp>>;
  socialMedia?: InputMaybe<TixSocialMediaBoolExp>;
  socialMediaId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueSocialMediaId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "media.venue_social_media" */
export enum TixVenueSocialMediaConstraint {
  /** unique or primary key constraint on columns "venue_social_media_id" */
  VenueSocialMediaIdPkey = 'venue_social_media_id_pkey'
}

/** input type for inserting data into table "media.venue_social_media" */
export type TixVenueSocialMediaInsertInput = {
  Venue?: InputMaybe<TixVenueObjRelInsertInput>;
  socialMedia?: InputMaybe<TixSocialMediaObjRelInsertInput>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueSocialMediaId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueSocialMediaMaxFields = {
  __typename?: 'VenueSocialMedia_max_fields';
  socialMediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueSocialMediaId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "media.venue_social_media" */
export type TixVenueSocialMediaMaxOrderBy = {
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueSocialMediaId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueSocialMediaMinFields = {
  __typename?: 'VenueSocialMedia_min_fields';
  socialMediaId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueSocialMediaId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "media.venue_social_media" */
export type TixVenueSocialMediaMinOrderBy = {
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueSocialMediaId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "media.venue_social_media" */
export type TixVenueSocialMediaMutationResponse = {
  __typename?: 'VenueSocialMedia_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueSocialMedia>;
};

/** on_conflict condition type for table "media.venue_social_media" */
export type TixVenueSocialMediaOnConflict = {
  constraint: TixVenueSocialMediaConstraint;
  update_columns?: Array<TixVenueSocialMediaUpdateColumn>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};

/** Ordering options when selecting data from "media.venue_social_media". */
export type TixVenueSocialMediaOrderBy = {
  Venue?: InputMaybe<TixVenueOrderBy>;
  socialMedia?: InputMaybe<TixSocialMediaOrderBy>;
  socialMediaId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueSocialMediaId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: media.venue_social_media */
export type TixVenueSocialMediaPkColumnsInput = {
  venueSocialMediaId: Scalars['uuid'];
};

/** select columns of table "media.venue_social_media" */
export enum TixVenueSocialMediaSelectColumn {
  /** column name */
  SocialMediaId = 'socialMediaId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueSocialMediaId = 'venueSocialMediaId'
}

/** input type for updating data in table "media.venue_social_media" */
export type TixVenueSocialMediaSetInput = {
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueSocialMediaId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueSocialMedia" */
export type TixVenueSocialMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueSocialMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueSocialMediaStreamCursorValueInput = {
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueSocialMediaId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "media.venue_social_media" */
export enum TixVenueSocialMediaUpdateColumn {
  /** column name */
  SocialMediaId = 'socialMediaId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueSocialMediaId = 'venueSocialMediaId'
}

export type TixVenueSocialMediaUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueSocialMediaSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueSocialMediaBoolExp;
};

/** columns and relationships of "ticket.venue_ticket" */
export type TixVenueTicket = {
  __typename?: 'VenueTicket';
  /** An array relationship */
  Configurations: Array<TixVenueTicketConfig>;
  /** An aggregate relationship */
  Configurations_aggregate: TixVenueTicketConfigAggregate;
  /** An object relationship */
  Venue?: Maybe<TixVenue>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  totalSeats?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
  venueTicketId: Scalars['uuid'];
};


/** columns and relationships of "ticket.venue_ticket" */
export type TixVenueTicketConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketConfigOrderBy>>;
  where?: InputMaybe<TixVenueTicketConfigBoolExp>;
};


/** columns and relationships of "ticket.venue_ticket" */
export type TixVenueTicketConfigurationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketConfigOrderBy>>;
  where?: InputMaybe<TixVenueTicketConfigBoolExp>;
};

/** columns and relationships of "ticket.venue_ticket_config" */
export type TixVenueTicketConfig = {
  __typename?: 'VenueTicketConfig';
  /** An object relationship */
  TicketConfigurations?: Maybe<TixTicketConfig>;
  state?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueTicketConfig: Scalars['uuid'];
  venueTicketId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue_ticket?: Maybe<TixVenueTicket>;
};

/** aggregated selection of "ticket.venue_ticket_config" */
export type TixVenueTicketConfigAggregate = {
  __typename?: 'VenueTicketConfig_aggregate';
  aggregate?: Maybe<TixVenueTicketConfigAggregateFields>;
  nodes: Array<TixVenueTicketConfig>;
};

export type TixVenueTicketConfigAggregateBoolExp = {
  count?: InputMaybe<TixVenueTicketConfigAggregateBoolExpCount>;
};

export type TixVenueTicketConfigAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueTicketConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueTicketConfigBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.venue_ticket_config" */
export type TixVenueTicketConfigAggregateFields = {
  __typename?: 'VenueTicketConfig_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueTicketConfigMaxFields>;
  min?: Maybe<TixVenueTicketConfigMinFields>;
};


/** aggregate fields of "ticket.venue_ticket_config" */
export type TixVenueTicketConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueTicketConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueTicketConfigMaxOrderBy>;
  min?: InputMaybe<TixVenueTicketConfigMinOrderBy>;
};

/** input type for inserting array relation for remote table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigArrRelInsertInput = {
  data: Array<TixVenueTicketConfigInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueTicketConfigOnConflict>;
};

/** Boolean expression to filter rows from the table "ticket.venue_ticket_config". All fields are combined with a logical 'AND'. */
export type TixVenueTicketConfigBoolExp = {
  TicketConfigurations?: InputMaybe<TixTicketConfigBoolExp>;
  _and?: InputMaybe<Array<TixVenueTicketConfigBoolExp>>;
  _not?: InputMaybe<TixVenueTicketConfigBoolExp>;
  _or?: InputMaybe<Array<TixVenueTicketConfigBoolExp>>;
  state?: InputMaybe<TixStringComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueTicketConfig?: InputMaybe<TixUuidComparisonExp>;
  venueTicketId?: InputMaybe<TixUuidComparisonExp>;
  venue_ticket?: InputMaybe<TixVenueTicketBoolExp>;
};

/** unique or primary key constraints on table "ticket.venue_ticket_config" */
export enum TixVenueTicketConfigConstraint {
  /** unique or primary key constraint on columns "venue_ticket_config_id" */
  VenueTicketConfigPkey1 = 'venue_ticket_config_pkey1'
}

/** input type for inserting data into table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigInsertInput = {
  TicketConfigurations?: InputMaybe<TixTicketConfigObjRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueTicketConfig?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
  venue_ticket?: InputMaybe<TixVenueTicketObjRelInsertInput>;
};

/** aggregate max on columns */
export type TixVenueTicketConfigMaxFields = {
  __typename?: 'VenueTicketConfig_max_fields';
  state?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueTicketConfig?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigMaxOrderBy = {
  state?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueTicketConfig?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueTicketConfigMinFields = {
  __typename?: 'VenueTicketConfig_min_fields';
  state?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueTicketConfig?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigMinOrderBy = {
  state?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueTicketConfig?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigMutationResponse = {
  __typename?: 'VenueTicketConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueTicketConfig>;
};

/** input type for inserting object relation for remote table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigObjRelInsertInput = {
  data: TixVenueTicketConfigInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueTicketConfigOnConflict>;
};

/** on_conflict condition type for table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigOnConflict = {
  constraint: TixVenueTicketConfigConstraint;
  update_columns?: Array<TixVenueTicketConfigUpdateColumn>;
  where?: InputMaybe<TixVenueTicketConfigBoolExp>;
};

/** Ordering options when selecting data from "ticket.venue_ticket_config". */
export type TixVenueTicketConfigOrderBy = {
  TicketConfigurations?: InputMaybe<TixTicketConfigOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueTicketConfig?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
  venue_ticket?: InputMaybe<TixVenueTicketOrderBy>;
};

/** primary key columns input for table: ticket.venue_ticket_config */
export type TixVenueTicketConfigPkColumnsInput = {
  venueTicketConfig: Scalars['uuid'];
};

/** select columns of table "ticket.venue_ticket_config" */
export enum TixVenueTicketConfigSelectColumn {
  /** column name */
  State = 'state',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueTicketConfig = 'venueTicketConfig',
  /** column name */
  VenueTicketId = 'venueTicketId'
}

/** input type for updating data in table "ticket.venue_ticket_config" */
export type TixVenueTicketConfigSetInput = {
  state?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueTicketConfig?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueTicketConfig" */
export type TixVenueTicketConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueTicketConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueTicketConfigStreamCursorValueInput = {
  state?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueTicketConfig?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ticket.venue_ticket_config" */
export enum TixVenueTicketConfigUpdateColumn {
  /** column name */
  State = 'state',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueTicketConfig = 'venueTicketConfig',
  /** column name */
  VenueTicketId = 'venueTicketId'
}

export type TixVenueTicketConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueTicketConfigSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueTicketConfigBoolExp;
};

/** aggregated selection of "ticket.venue_ticket" */
export type TixVenueTicketAggregate = {
  __typename?: 'VenueTicket_aggregate';
  aggregate?: Maybe<TixVenueTicketAggregateFields>;
  nodes: Array<TixVenueTicket>;
};

export type TixVenueTicketAggregateBoolExp = {
  count?: InputMaybe<TixVenueTicketAggregateBoolExpCount>;
};

export type TixVenueTicketAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueTicketBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.venue_ticket" */
export type TixVenueTicketAggregateFields = {
  __typename?: 'VenueTicket_aggregate_fields';
  avg?: Maybe<TixVenueTicketAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixVenueTicketMaxFields>;
  min?: Maybe<TixVenueTicketMinFields>;
  stddev?: Maybe<TixVenueTicketStddevFields>;
  stddev_pop?: Maybe<TixVenueTicketStddevPopFields>;
  stddev_samp?: Maybe<TixVenueTicketStddevSampFields>;
  sum?: Maybe<TixVenueTicketSumFields>;
  var_pop?: Maybe<TixVenueTicketVarPopFields>;
  var_samp?: Maybe<TixVenueTicketVarSampFields>;
  variance?: Maybe<TixVenueTicketVarianceFields>;
};


/** aggregate fields of "ticket.venue_ticket" */
export type TixVenueTicketAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.venue_ticket" */
export type TixVenueTicketAggregateOrderBy = {
  avg?: InputMaybe<TixVenueTicketAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueTicketMaxOrderBy>;
  min?: InputMaybe<TixVenueTicketMinOrderBy>;
  stddev?: InputMaybe<TixVenueTicketStddevOrderBy>;
  stddev_pop?: InputMaybe<TixVenueTicketStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixVenueTicketStddevSampOrderBy>;
  sum?: InputMaybe<TixVenueTicketSumOrderBy>;
  var_pop?: InputMaybe<TixVenueTicketVarPopOrderBy>;
  var_samp?: InputMaybe<TixVenueTicketVarSampOrderBy>;
  variance?: InputMaybe<TixVenueTicketVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ticket.venue_ticket" */
export type TixVenueTicketArrRelInsertInput = {
  data: Array<TixVenueTicketInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueTicketOnConflict>;
};

/** aggregate avg on columns */
export type TixVenueTicketAvgFields = {
  __typename?: 'VenueTicket_avg_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketAvgOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "ticket.venue_ticket". All fields are combined with a logical 'AND'. */
export type TixVenueTicketBoolExp = {
  Configurations?: InputMaybe<TixVenueTicketConfigBoolExp>;
  Configurations_aggregate?: InputMaybe<TixVenueTicketConfigAggregateBoolExp>;
  Venue?: InputMaybe<TixVenueBoolExp>;
  _and?: InputMaybe<Array<TixVenueTicketBoolExp>>;
  _not?: InputMaybe<TixVenueTicketBoolExp>;
  _or?: InputMaybe<Array<TixVenueTicketBoolExp>>;
  description?: InputMaybe<TixStringComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  totalSeats?: InputMaybe<TixIntComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueTicketId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "ticket.venue_ticket" */
export enum TixVenueTicketConstraint {
  /** unique or primary key constraint on columns "venue_ticket_id" */
  VenueTicketConfigPkey = 'venue_ticket_config_pkey'
}

/** input type for incrementing numeric columns in table "ticket.venue_ticket" */
export type TixVenueTicketIncInput = {
  totalSeats?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ticket.venue_ticket" */
export type TixVenueTicketInsertInput = {
  Configurations?: InputMaybe<TixVenueTicketConfigArrRelInsertInput>;
  Venue?: InputMaybe<TixVenueObjRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueTicketMaxFields = {
  __typename?: 'VenueTicket_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  totalSeats?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketMaxOrderBy = {
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueTicketMinFields = {
  __typename?: 'VenueTicket_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  totalSeats?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueTicketId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketMinOrderBy = {
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "ticket.venue_ticket" */
export type TixVenueTicketMutationResponse = {
  __typename?: 'VenueTicket_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueTicket>;
};

/** input type for inserting object relation for remote table "ticket.venue_ticket" */
export type TixVenueTicketObjRelInsertInput = {
  data: TixVenueTicketInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueTicketOnConflict>;
};

/** on_conflict condition type for table "ticket.venue_ticket" */
export type TixVenueTicketOnConflict = {
  constraint: TixVenueTicketConstraint;
  update_columns?: Array<TixVenueTicketUpdateColumn>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};

/** Ordering options when selecting data from "ticket.venue_ticket". */
export type TixVenueTicketOrderBy = {
  Configurations_aggregate?: InputMaybe<TixVenueTicketConfigAggregateOrderBy>;
  Venue?: InputMaybe<TixVenueOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueTicketId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.venue_ticket */
export type TixVenueTicketPkColumnsInput = {
  venueTicketId: Scalars['uuid'];
};

/** select columns of table "ticket.venue_ticket" */
export enum TixVenueTicketSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  TotalSeats = 'totalSeats',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueTicketId = 'venueTicketId'
}

/** input type for updating data in table "ticket.venue_ticket" */
export type TixVenueTicketSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixVenueTicketStddevFields = {
  __typename?: 'VenueTicket_stddev_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketStddevOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixVenueTicketStddevPopFields = {
  __typename?: 'VenueTicket_stddev_pop_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketStddevPopOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixVenueTicketStddevSampFields = {
  __typename?: 'VenueTicket_stddev_samp_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketStddevSampOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "VenueTicket" */
export type TixVenueTicketStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueTicketStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueTicketStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixVenueTicketSumFields = {
  __typename?: 'VenueTicket_sum_fields';
  totalSeats?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketSumOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** update columns of table "ticket.venue_ticket" */
export enum TixVenueTicketUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  TotalSeats = 'totalSeats',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueTicketId = 'venueTicketId'
}

export type TixVenueTicketUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixVenueTicketIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueTicketSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueTicketBoolExp;
};

/** aggregate var_pop on columns */
export type TixVenueTicketVarPopFields = {
  __typename?: 'VenueTicket_var_pop_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketVarPopOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixVenueTicketVarSampFields = {
  __typename?: 'VenueTicket_var_samp_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketVarSampOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixVenueTicketVarianceFields = {
  __typename?: 'VenueTicket_variance_fields';
  totalSeats?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ticket.venue_ticket" */
export type TixVenueTicketVarianceOrderBy = {
  totalSeats?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "warning.venue_warning" */
export type TixVenueWarning = {
  __typename?: 'VenueWarning';
  companyId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venue: TixVenue;
  venueId: Scalars['uuid'];
  venueWarningId: Scalars['uuid'];
  /** An object relationship */
  warning: TixWarning;
  warningId: Scalars['uuid'];
};

/** aggregated selection of "warning.venue_warning" */
export type TixVenueWarningAggregate = {
  __typename?: 'VenueWarning_aggregate';
  aggregate?: Maybe<TixVenueWarningAggregateFields>;
  nodes: Array<TixVenueWarning>;
};

export type TixVenueWarningAggregateBoolExp = {
  count?: InputMaybe<TixVenueWarningAggregateBoolExpCount>;
};

export type TixVenueWarningAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueWarningBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "warning.venue_warning" */
export type TixVenueWarningAggregateFields = {
  __typename?: 'VenueWarning_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueWarningMaxFields>;
  min?: Maybe<TixVenueWarningMinFields>;
};


/** aggregate fields of "warning.venue_warning" */
export type TixVenueWarningAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "warning.venue_warning" */
export type TixVenueWarningAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueWarningMaxOrderBy>;
  min?: InputMaybe<TixVenueWarningMinOrderBy>;
};

/** input type for inserting array relation for remote table "warning.venue_warning" */
export type TixVenueWarningArrRelInsertInput = {
  data: Array<TixVenueWarningInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueWarningOnConflict>;
};

/** Boolean expression to filter rows from the table "warning.venue_warning". All fields are combined with a logical 'AND'. */
export type TixVenueWarningBoolExp = {
  _and?: InputMaybe<Array<TixVenueWarningBoolExp>>;
  _not?: InputMaybe<TixVenueWarningBoolExp>;
  _or?: InputMaybe<Array<TixVenueWarningBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueWarningId?: InputMaybe<TixUuidComparisonExp>;
  warning?: InputMaybe<TixWarningBoolExp>;
  warningId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "warning.venue_warning" */
export enum TixVenueWarningConstraint {
  /** unique or primary key constraint on columns "venue_warning_id" */
  VenueWarningPkey = 'venue_warning_pkey',
  /** unique or primary key constraint on columns "warning_id" */
  VenueWarningWarningIdKey = 'venue_warning_warning_id_key'
}

/** input type for inserting data into table "warning.venue_warning" */
export type TixVenueWarningInsertInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueWarningId?: InputMaybe<Scalars['uuid']>;
  warning?: InputMaybe<TixWarningObjRelInsertInput>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixVenueWarningMaxFields = {
  __typename?: 'VenueWarning_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueWarningId?: Maybe<Scalars['uuid']>;
  warningId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "warning.venue_warning" */
export type TixVenueWarningMaxOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueWarningId?: InputMaybe<TixOrderBy>;
  warningId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueWarningMinFields = {
  __typename?: 'VenueWarning_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueWarningId?: Maybe<Scalars['uuid']>;
  warningId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "warning.venue_warning" */
export type TixVenueWarningMinOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueWarningId?: InputMaybe<TixOrderBy>;
  warningId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "warning.venue_warning" */
export type TixVenueWarningMutationResponse = {
  __typename?: 'VenueWarning_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenueWarning>;
};

/** on_conflict condition type for table "warning.venue_warning" */
export type TixVenueWarningOnConflict = {
  constraint: TixVenueWarningConstraint;
  update_columns?: Array<TixVenueWarningUpdateColumn>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};

/** Ordering options when selecting data from "warning.venue_warning". */
export type TixVenueWarningOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueWarningId?: InputMaybe<TixOrderBy>;
  warning?: InputMaybe<TixWarningOrderBy>;
  warningId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: warning.venue_warning */
export type TixVenueWarningPkColumnsInput = {
  venueWarningId: Scalars['uuid'];
};

/** select columns of table "warning.venue_warning" */
export enum TixVenueWarningSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueWarningId = 'venueWarningId',
  /** column name */
  WarningId = 'warningId'
}

/** input type for updating data in table "warning.venue_warning" */
export type TixVenueWarningSetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueWarningId?: InputMaybe<Scalars['uuid']>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "VenueWarning" */
export type TixVenueWarningStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueWarningStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueWarningStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueWarningId?: InputMaybe<Scalars['uuid']>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "warning.venue_warning" */
export enum TixVenueWarningUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueWarningId = 'venueWarningId',
  /** column name */
  WarningId = 'warningId'
}

export type TixVenueWarningUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueWarningSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueWarningBoolExp;
};

/** aggregated selection of "venue.venue" */
export type TixVenueAggregate = {
  __typename?: 'Venue_aggregate';
  aggregate?: Maybe<TixVenueAggregateFields>;
  nodes: Array<TixVenue>;
};

export type TixVenueAggregateBoolExp = {
  bool_and?: InputMaybe<TixVenueAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixVenueAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixVenueAggregateBoolExpCount>;
};

export type TixVenueAggregateBoolExpBoolAnd = {
  arguments: TixVenueSelectColumnVenueAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixVenueAggregateBoolExpBoolOr = {
  arguments: TixVenueSelectColumnVenueAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixVenueAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixVenueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixVenueBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "venue.venue" */
export type TixVenueAggregateFields = {
  __typename?: 'Venue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixVenueMaxFields>;
  min?: Maybe<TixVenueMinFields>;
};


/** aggregate fields of "venue.venue" */
export type TixVenueAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixVenueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "venue.venue" */
export type TixVenueAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixVenueMaxOrderBy>;
  min?: InputMaybe<TixVenueMinOrderBy>;
};

/** input type for inserting array relation for remote table "venue.venue" */
export type TixVenueArrRelInsertInput = {
  data: Array<TixVenueInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueOnConflict>;
};

/** Boolean expression to filter rows from the table "venue.venue". All fields are combined with a logical 'AND'. */
export type TixVenueBoolExp = {
  _and?: InputMaybe<Array<TixVenueBoolExp>>;
  _not?: InputMaybe<TixVenueBoolExp>;
  _or?: InputMaybe<Array<TixVenueBoolExp>>;
  additionalInfo?: InputMaybe<TixStringComparisonExp>;
  addresses?: InputMaybe<TixVenueAddressBoolExp>;
  addresses_aggregate?: InputMaybe<TixVenueAddressAggregateBoolExp>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  configurationValues?: InputMaybe<TixVenueConfigurationValueBoolExp>;
  configurationValues_aggregate?: InputMaybe<TixVenueConfigurationValueAggregateBoolExp>;
  contacts?: InputMaybe<TixVenueContactBoolExp>;
  contacts_aggregate?: InputMaybe<TixVenueContactAggregateBoolExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  discounts?: InputMaybe<TixVenueDiscountBoolExp>;
  discounts_aggregate?: InputMaybe<TixVenueDiscountAggregateBoolExp>;
  events?: InputMaybe<TixEventInstanceBoolExp>;
  events_aggregate?: InputMaybe<TixEventInstanceAggregateBoolExp>;
  flatFee?: InputMaybe<TixBooleanComparisonExp>;
  lineups?: InputMaybe<TixVenueLineupBoolExp>;
  lineups_aggregate?: InputMaybe<TixVenueLineupAggregateBoolExp>;
  mediaFiles?: InputMaybe<TixVenueMediaFileBoolExp>;
  mediaFiles_aggregate?: InputMaybe<TixVenueMediaFileAggregateBoolExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  payouts?: InputMaybe<TixPayoutBoolExp>;
  payouts_aggregate?: InputMaybe<TixPayoutAggregateBoolExp>;
  phoneNumbers?: InputMaybe<TixVenuePhoneNumberBoolExp>;
  phoneNumbers_aggregate?: InputMaybe<TixVenuePhoneNumberAggregateBoolExp>;
  policy?: InputMaybe<TixUtilityPolicyBoolExp>;
  policy_aggregate?: InputMaybe<TixUtilityPolicyAggregateBoolExp>;
  slug?: InputMaybe<TixStringComparisonExp>;
  socialMedia?: InputMaybe<TixVenueSocialMediaBoolExp>;
  socialMedia_aggregate?: InputMaybe<TixVenueSocialMediaAggregateBoolExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  tickets?: InputMaybe<TixVenueTicketBoolExp>;
  tickets_aggregate?: InputMaybe<TixVenueTicketAggregateBoolExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  url?: InputMaybe<TixStringComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueNo?: InputMaybe<TixStringComparisonExp>;
  venueProduct?: InputMaybe<TixVenueProductBoolExp>;
  venueProduct_aggregate?: InputMaybe<TixVenueProductAggregateBoolExp>;
  warnings?: InputMaybe<TixVenueWarningBoolExp>;
  warnings_aggregate?: InputMaybe<TixVenueWarningAggregateBoolExp>;
};

/** unique or primary key constraints on table "venue.venue" */
export enum TixVenueConstraint {
  /** unique or primary key constraint on columns "slug" */
  Slug = 'slug',
  /** unique or primary key constraint on columns "venue_id" */
  VenuePkey = 'venue_pkey'
}

/** input type for inserting data into table "venue.venue" */
export type TixVenueInsertInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<TixVenueAddressArrRelInsertInput>;
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  configurationValues?: InputMaybe<TixVenueConfigurationValueArrRelInsertInput>;
  contacts?: InputMaybe<TixVenueContactArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  discounts?: InputMaybe<TixVenueDiscountArrRelInsertInput>;
  events?: InputMaybe<TixEventInstanceArrRelInsertInput>;
  flatFee?: InputMaybe<Scalars['Boolean']>;
  lineups?: InputMaybe<TixVenueLineupArrRelInsertInput>;
  mediaFiles?: InputMaybe<TixVenueMediaFileArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  payouts?: InputMaybe<TixPayoutArrRelInsertInput>;
  phoneNumbers?: InputMaybe<TixVenuePhoneNumberArrRelInsertInput>;
  policy?: InputMaybe<TixUtilityPolicyArrRelInsertInput>;
  slug?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<TixVenueSocialMediaArrRelInsertInput>;
  state?: InputMaybe<Scalars['String']>;
  tickets?: InputMaybe<TixVenueTicketArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueProduct?: InputMaybe<TixVenueProductArrRelInsertInput>;
  warnings?: InputMaybe<TixVenueWarningArrRelInsertInput>;
};

/** aggregate max on columns */
export type TixVenueMaxFields = {
  __typename?: 'Venue_max_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "venue.venue_no" */
  venueNo?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "venue.venue" */
export type TixVenueMaxOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  slug?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  url?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixVenueMinFields = {
  __typename?: 'Venue_min_fields';
  additionalInfo?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "venue.venue_no" */
  venueNo?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "venue.venue" */
export type TixVenueMinOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  slug?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  url?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "venue.venue" */
export type TixVenueMutationResponse = {
  __typename?: 'Venue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixVenue>;
};

/** input type for inserting object relation for remote table "venue.venue" */
export type TixVenueObjRelInsertInput = {
  data: TixVenueInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixVenueOnConflict>;
};

/** on_conflict condition type for table "venue.venue" */
export type TixVenueOnConflict = {
  constraint: TixVenueConstraint;
  update_columns?: Array<TixVenueUpdateColumn>;
  where?: InputMaybe<TixVenueBoolExp>;
};

/** Ordering options when selecting data from "venue.venue". */
export type TixVenueOrderBy = {
  additionalInfo?: InputMaybe<TixOrderBy>;
  addresses_aggregate?: InputMaybe<TixVenueAddressAggregateOrderBy>;
  company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  configurationValues_aggregate?: InputMaybe<TixVenueConfigurationValueAggregateOrderBy>;
  contacts_aggregate?: InputMaybe<TixVenueContactAggregateOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  discounts_aggregate?: InputMaybe<TixVenueDiscountAggregateOrderBy>;
  events_aggregate?: InputMaybe<TixEventInstanceAggregateOrderBy>;
  flatFee?: InputMaybe<TixOrderBy>;
  lineups_aggregate?: InputMaybe<TixVenueLineupAggregateOrderBy>;
  mediaFiles_aggregate?: InputMaybe<TixVenueMediaFileAggregateOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  payouts_aggregate?: InputMaybe<TixPayoutAggregateOrderBy>;
  phoneNumbers_aggregate?: InputMaybe<TixVenuePhoneNumberAggregateOrderBy>;
  policy_aggregate?: InputMaybe<TixUtilityPolicyAggregateOrderBy>;
  slug?: InputMaybe<TixOrderBy>;
  socialMedia_aggregate?: InputMaybe<TixVenueSocialMediaAggregateOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  tickets_aggregate?: InputMaybe<TixVenueTicketAggregateOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  url?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueNo?: InputMaybe<TixOrderBy>;
  venueProduct_aggregate?: InputMaybe<TixVenueProductAggregateOrderBy>;
  warnings_aggregate?: InputMaybe<TixVenueWarningAggregateOrderBy>;
};

/** primary key columns input for table: venue.venue */
export type TixVenuePkColumnsInput = {
  venueId: Scalars['uuid'];
};

/** select columns of table "venue.venue" */
export enum TixVenueSelectColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  Description = 'description',
  /** column name */
  FlatFee = 'flatFee',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url',
  /** column name */
  VenueId = 'venueId'
}

/** select "Venue_aggregate_bool_exp_bool_and_arguments_columns" columns of table "venue.venue" */
export enum TixVenueSelectColumnVenueAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  FlatFee = 'flatFee'
}

/** select "Venue_aggregate_bool_exp_bool_or_arguments_columns" columns of table "venue.venue" */
export enum TixVenueSelectColumnVenueAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  FlatFee = 'flatFee'
}

/** input type for updating data in table "venue.venue" */
export type TixVenueSetInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  flatFee?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Venue" */
export type TixVenueStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixVenueStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixVenueStreamCursorValueInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  flatFee?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "venue.venue" */
export enum TixVenueUpdateColumn {
  /** column name */
  AdditionalInfo = 'additionalInfo',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  Description = 'description',
  /** column name */
  FlatFee = 'flatFee',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Url = 'url',
  /** column name */
  VenueId = 'venueId'
}

export type TixVenueUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixVenueSetInput>;
  /** filter the rows which have to be updated */
  where: TixVenueBoolExp;
};

/** warning message with type */
export type TixWarning = {
  __typename?: 'Warning';
  /** An array relationship */
  company_warning: Array<TixCompanyWarning>;
  /** An aggregate relationship */
  company_warning_aggregate: TixCompanyWarningAggregate;
  createAt: Scalars['timestamptz'];
  message: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
  /** An array relationship */
  venue_warning: Array<TixVenueWarning>;
  /** An aggregate relationship */
  venue_warning_aggregate: TixVenueWarningAggregate;
  warningId: Scalars['uuid'];
};


/** warning message with type */
export type TixWarningCompanyWarningArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyWarningOrderBy>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};


/** warning message with type */
export type TixWarningCompanyWarningAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyWarningOrderBy>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};


/** warning message with type */
export type TixWarningVenueWarningArgs = {
  distinct_on?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueWarningOrderBy>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};


/** warning message with type */
export type TixWarningVenueWarningAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueWarningOrderBy>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};

/** aggregated selection of "warning.warning" */
export type TixWarningAggregate = {
  __typename?: 'Warning_aggregate';
  aggregate?: Maybe<TixWarningAggregateFields>;
  nodes: Array<TixWarning>;
};

/** aggregate fields of "warning.warning" */
export type TixWarningAggregateFields = {
  __typename?: 'Warning_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixWarningMaxFields>;
  min?: Maybe<TixWarningMinFields>;
};


/** aggregate fields of "warning.warning" */
export type TixWarningAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixWarningSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "warning.warning". All fields are combined with a logical 'AND'. */
export type TixWarningBoolExp = {
  _and?: InputMaybe<Array<TixWarningBoolExp>>;
  _not?: InputMaybe<TixWarningBoolExp>;
  _or?: InputMaybe<Array<TixWarningBoolExp>>;
  company_warning?: InputMaybe<TixCompanyWarningBoolExp>;
  company_warning_aggregate?: InputMaybe<TixCompanyWarningAggregateBoolExp>;
  createAt?: InputMaybe<TixTimestamptzComparisonExp>;
  message?: InputMaybe<TixStringComparisonExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue_warning?: InputMaybe<TixVenueWarningBoolExp>;
  venue_warning_aggregate?: InputMaybe<TixVenueWarningAggregateBoolExp>;
  warningId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "warning.warning" */
export enum TixWarningConstraint {
  /** unique or primary key constraint on columns "warning_id" */
  WarningPkey = 'warning_pkey'
}

/** input type for inserting data into table "warning.warning" */
export type TixWarningInsertInput = {
  company_warning?: InputMaybe<TixCompanyWarningArrRelInsertInput>;
  createAt?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue_warning?: InputMaybe<TixVenueWarningArrRelInsertInput>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixWarningMaxFields = {
  __typename?: 'Warning_max_fields';
  createAt?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  warningId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixWarningMinFields = {
  __typename?: 'Warning_min_fields';
  createAt?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  warningId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "warning.warning" */
export type TixWarningMutationResponse = {
  __typename?: 'Warning_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixWarning>;
};

/** input type for inserting object relation for remote table "warning.warning" */
export type TixWarningObjRelInsertInput = {
  data: TixWarningInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixWarningOnConflict>;
};

/** on_conflict condition type for table "warning.warning" */
export type TixWarningOnConflict = {
  constraint: TixWarningConstraint;
  update_columns?: Array<TixWarningUpdateColumn>;
  where?: InputMaybe<TixWarningBoolExp>;
};

/** Ordering options when selecting data from "warning.warning". */
export type TixWarningOrderBy = {
  company_warning_aggregate?: InputMaybe<TixCompanyWarningAggregateOrderBy>;
  createAt?: InputMaybe<TixOrderBy>;
  message?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue_warning_aggregate?: InputMaybe<TixVenueWarningAggregateOrderBy>;
  warningId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: warning.warning */
export type TixWarningPkColumnsInput = {
  warningId: Scalars['uuid'];
};

/** select columns of table "warning.warning" */
export enum TixWarningSelectColumn {
  /** column name */
  CreateAt = 'createAt',
  /** column name */
  Message = 'message',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WarningId = 'warningId'
}

/** input type for updating data in table "warning.warning" */
export type TixWarningSetInput = {
  createAt?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "Warning" */
export type TixWarningStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixWarningStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixWarningStreamCursorValueInput = {
  createAt?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  warningId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "warning.warning" */
export enum TixWarningUpdateColumn {
  /** column name */
  CreateAt = 'createAt',
  /** column name */
  Message = 'message',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WarningId = 'warningId'
}

export type TixWarningUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixWarningSetInput>;
  /** filter the rows which have to be updated */
  where: TixWarningBoolExp;
};

/** columns and relationships of "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumber = {
  __typename?: 'address_performer_phone_number';
  performer_id?: Maybe<Scalars['uuid']>;
  performer_phone_number_id: Scalars['uuid'];
  /** An object relationship */
  phoneNumber?: Maybe<TixPhoneNumber>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamp'];
  updated_by: Scalars['uuid'];
};

/** aggregated selection of "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberAggregate = {
  __typename?: 'address_performer_phone_number_aggregate';
  aggregate?: Maybe<TixAddressPerformerPhoneNumberAggregateFields>;
  nodes: Array<TixAddressPerformerPhoneNumber>;
};

export type TixAddressPerformerPhoneNumberAggregateBoolExp = {
  count?: InputMaybe<TixAddressPerformerPhoneNumberAggregateBoolExpCount>;
};

export type TixAddressPerformerPhoneNumberAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberAggregateFields = {
  __typename?: 'address_performer_phone_number_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixAddressPerformerPhoneNumberMaxFields>;
  min?: Maybe<TixAddressPerformerPhoneNumberMinFields>;
};


/** aggregate fields of "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixAddressPerformerPhoneNumberMaxOrderBy>;
  min?: InputMaybe<TixAddressPerformerPhoneNumberMinOrderBy>;
};

/** input type for inserting array relation for remote table "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberArrRelInsertInput = {
  data: Array<TixAddressPerformerPhoneNumberInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixAddressPerformerPhoneNumberOnConflict>;
};

/** Boolean expression to filter rows from the table "address.performer_phone_number". All fields are combined with a logical 'AND'. */
export type TixAddressPerformerPhoneNumberBoolExp = {
  _and?: InputMaybe<Array<TixAddressPerformerPhoneNumberBoolExp>>;
  _not?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
  _or?: InputMaybe<Array<TixAddressPerformerPhoneNumberBoolExp>>;
  performer_id?: InputMaybe<TixUuidComparisonExp>;
  performer_phone_number_id?: InputMaybe<TixUuidComparisonExp>;
  phoneNumber?: InputMaybe<TixPhoneNumberBoolExp>;
  phone_number_id?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updated_at?: InputMaybe<TixTimestampComparisonExp>;
  updated_by?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "address.performer_phone_number" */
export enum TixAddressPerformerPhoneNumberConstraint {
  /** unique or primary key constraint on columns "performer_phone_number_id" */
  PerformerPhoneNumberPkey = 'performer_phone_number_pkey'
}

/** input type for inserting data into table "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberInsertInput = {
  performer_id?: InputMaybe<Scalars['uuid']>;
  performer_phone_number_id?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<TixPhoneNumberObjRelInsertInput>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixAddressPerformerPhoneNumberMaxFields = {
  __typename?: 'address_performer_phone_number_max_fields';
  performer_id?: Maybe<Scalars['uuid']>;
  performer_phone_number_id?: Maybe<Scalars['uuid']>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberMaxOrderBy = {
  performer_id?: InputMaybe<TixOrderBy>;
  performer_phone_number_id?: InputMaybe<TixOrderBy>;
  phone_number_id?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updated_at?: InputMaybe<TixOrderBy>;
  updated_by?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixAddressPerformerPhoneNumberMinFields = {
  __typename?: 'address_performer_phone_number_min_fields';
  performer_id?: Maybe<Scalars['uuid']>;
  performer_phone_number_id?: Maybe<Scalars['uuid']>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberMinOrderBy = {
  performer_id?: InputMaybe<TixOrderBy>;
  performer_phone_number_id?: InputMaybe<TixOrderBy>;
  phone_number_id?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updated_at?: InputMaybe<TixOrderBy>;
  updated_by?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberMutationResponse = {
  __typename?: 'address_performer_phone_number_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixAddressPerformerPhoneNumber>;
};

/** on_conflict condition type for table "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberOnConflict = {
  constraint: TixAddressPerformerPhoneNumberConstraint;
  update_columns?: Array<TixAddressPerformerPhoneNumberUpdateColumn>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};

/** Ordering options when selecting data from "address.performer_phone_number". */
export type TixAddressPerformerPhoneNumberOrderBy = {
  performer_id?: InputMaybe<TixOrderBy>;
  performer_phone_number_id?: InputMaybe<TixOrderBy>;
  phoneNumber?: InputMaybe<TixPhoneNumberOrderBy>;
  phone_number_id?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updated_at?: InputMaybe<TixOrderBy>;
  updated_by?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: address.performer_phone_number */
export type TixAddressPerformerPhoneNumberPkColumnsInput = {
  performer_phone_number_id: Scalars['uuid'];
};

/** select columns of table "address.performer_phone_number" */
export enum TixAddressPerformerPhoneNumberSelectColumn {
  /** column name */
  PerformerId = 'performer_id',
  /** column name */
  PerformerPhoneNumberId = 'performer_phone_number_id',
  /** column name */
  PhoneNumberId = 'phone_number_id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "address.performer_phone_number" */
export type TixAddressPerformerPhoneNumberSetInput = {
  performer_id?: InputMaybe<Scalars['uuid']>;
  performer_phone_number_id?: InputMaybe<Scalars['uuid']>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "address_performer_phone_number" */
export type TixAddressPerformerPhoneNumberStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixAddressPerformerPhoneNumberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixAddressPerformerPhoneNumberStreamCursorValueInput = {
  performer_id?: InputMaybe<Scalars['uuid']>;
  performer_phone_number_id?: InputMaybe<Scalars['uuid']>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address.performer_phone_number" */
export enum TixAddressPerformerPhoneNumberUpdateColumn {
  /** column name */
  PerformerId = 'performer_id',
  /** column name */
  PerformerPhoneNumberId = 'performer_phone_number_id',
  /** column name */
  PhoneNumberId = 'phone_number_id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type TixAddressPerformerPhoneNumberUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixAddressPerformerPhoneNumberSetInput>;
  /** filter the rows which have to be updated */
  where: TixAddressPerformerPhoneNumberBoolExp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type TixBigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "communications.company_email" */
export type TixCommunicationsCompanyEmail = {
  __typename?: 'communications_company_email';
  /** An object relationship */
  Company?: Maybe<TixCompany>;
  /** An object relationship */
  EmailContent?: Maybe<TixEmailContent>;
  companyEmailId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "communications.company_email" */
export type TixCommunicationsCompanyEmailAggregate = {
  __typename?: 'communications_company_email_aggregate';
  aggregate?: Maybe<TixCommunicationsCompanyEmailAggregateFields>;
  nodes: Array<TixCommunicationsCompanyEmail>;
};

/** aggregate fields of "communications.company_email" */
export type TixCommunicationsCompanyEmailAggregateFields = {
  __typename?: 'communications_company_email_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCommunicationsCompanyEmailMaxFields>;
  min?: Maybe<TixCommunicationsCompanyEmailMinFields>;
};


/** aggregate fields of "communications.company_email" */
export type TixCommunicationsCompanyEmailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCommunicationsCompanyEmailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "communications.company_email". All fields are combined with a logical 'AND'. */
export type TixCommunicationsCompanyEmailBoolExp = {
  Company?: InputMaybe<TixCompanyBoolExp>;
  EmailContent?: InputMaybe<TixEmailContentBoolExp>;
  _and?: InputMaybe<Array<TixCommunicationsCompanyEmailBoolExp>>;
  _not?: InputMaybe<TixCommunicationsCompanyEmailBoolExp>;
  _or?: InputMaybe<Array<TixCommunicationsCompanyEmailBoolExp>>;
  companyEmailId?: InputMaybe<TixUuidComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  emailContentId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** input type for inserting data into table "communications.company_email" */
export type TixCommunicationsCompanyEmailInsertInput = {
  Company?: InputMaybe<TixCompanyObjRelInsertInput>;
  EmailContent?: InputMaybe<TixEmailContentObjRelInsertInput>;
  companyEmailId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCommunicationsCompanyEmailMaxFields = {
  __typename?: 'communications_company_email_max_fields';
  companyEmailId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixCommunicationsCompanyEmailMinFields = {
  __typename?: 'communications_company_email_min_fields';
  companyEmailId?: Maybe<Scalars['uuid']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "communications.company_email" */
export type TixCommunicationsCompanyEmailMutationResponse = {
  __typename?: 'communications_company_email_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCommunicationsCompanyEmail>;
};

/** Ordering options when selecting data from "communications.company_email". */
export type TixCommunicationsCompanyEmailOrderBy = {
  Company?: InputMaybe<TixCompanyOrderBy>;
  EmailContent?: InputMaybe<TixEmailContentOrderBy>;
  companyEmailId?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailContentId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** select columns of table "communications.company_email" */
export enum TixCommunicationsCompanyEmailSelectColumn {
  /** column name */
  CompanyEmailId = 'companyEmailId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailContentId = 'emailContentId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "communications.company_email" */
export type TixCommunicationsCompanyEmailSetInput = {
  companyEmailId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "communications_company_email" */
export type TixCommunicationsCompanyEmailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCommunicationsCompanyEmailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCommunicationsCompanyEmailStreamCursorValueInput = {
  companyEmailId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

export type TixCommunicationsCompanyEmailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCommunicationsCompanyEmailSetInput>;
  /** filter the rows which have to be updated */
  where: TixCommunicationsCompanyEmailBoolExp;
};

/** columns and relationships of "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariable = {
  __typename?: 'communications_email_content_variable';
  /** An object relationship */
  EmailVariable?: Maybe<TixCommunicationsEmailVariable>;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  emailContentId: Scalars['uuid'];
  emailContentVariableId: Scalars['uuid'];
  emailVariableId: Scalars['uuid'];
  /** An object relationship */
  email_content?: Maybe<TixEmailContent>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableAggregate = {
  __typename?: 'communications_email_content_variable_aggregate';
  aggregate?: Maybe<TixCommunicationsEmailContentVariableAggregateFields>;
  nodes: Array<TixCommunicationsEmailContentVariable>;
};

export type TixCommunicationsEmailContentVariableAggregateBoolExp = {
  count?: InputMaybe<TixCommunicationsEmailContentVariableAggregateBoolExpCount>;
};

export type TixCommunicationsEmailContentVariableAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixCommunicationsEmailContentVariableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableAggregateFields = {
  __typename?: 'communications_email_content_variable_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCommunicationsEmailContentVariableMaxFields>;
  min?: Maybe<TixCommunicationsEmailContentVariableMinFields>;
};


/** aggregate fields of "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCommunicationsEmailContentVariableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixCommunicationsEmailContentVariableMaxOrderBy>;
  min?: InputMaybe<TixCommunicationsEmailContentVariableMinOrderBy>;
};

/** input type for inserting array relation for remote table "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableArrRelInsertInput = {
  data: Array<TixCommunicationsEmailContentVariableInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCommunicationsEmailContentVariableOnConflict>;
};

/** Boolean expression to filter rows from the table "communications.email_content_variable". All fields are combined with a logical 'AND'. */
export type TixCommunicationsEmailContentVariableBoolExp = {
  EmailVariable?: InputMaybe<TixCommunicationsEmailVariableBoolExp>;
  _and?: InputMaybe<Array<TixCommunicationsEmailContentVariableBoolExp>>;
  _not?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
  _or?: InputMaybe<Array<TixCommunicationsEmailContentVariableBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  emailContentId?: InputMaybe<TixUuidComparisonExp>;
  emailContentVariableId?: InputMaybe<TixUuidComparisonExp>;
  emailVariableId?: InputMaybe<TixUuidComparisonExp>;
  email_content?: InputMaybe<TixEmailContentBoolExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "communications.email_content_variable" */
export enum TixCommunicationsEmailContentVariableConstraint {
  /** unique or primary key constraint on columns "email_content_variable_id" */
  EmailContentVariablePkey = 'email_content_variable_pkey'
}

/** input type for inserting data into table "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableInsertInput = {
  EmailVariable?: InputMaybe<TixCommunicationsEmailVariableObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  emailContentVariableId?: InputMaybe<Scalars['uuid']>;
  emailVariableId?: InputMaybe<Scalars['uuid']>;
  email_content?: InputMaybe<TixEmailContentObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCommunicationsEmailContentVariableMaxFields = {
  __typename?: 'communications_email_content_variable_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  emailContentVariableId?: Maybe<Scalars['uuid']>;
  emailVariableId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailContentId?: InputMaybe<TixOrderBy>;
  emailContentVariableId?: InputMaybe<TixOrderBy>;
  emailVariableId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixCommunicationsEmailContentVariableMinFields = {
  __typename?: 'communications_email_content_variable_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  emailContentVariableId?: Maybe<Scalars['uuid']>;
  emailVariableId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailContentId?: InputMaybe<TixOrderBy>;
  emailContentVariableId?: InputMaybe<TixOrderBy>;
  emailVariableId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableMutationResponse = {
  __typename?: 'communications_email_content_variable_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCommunicationsEmailContentVariable>;
};

/** on_conflict condition type for table "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableOnConflict = {
  constraint: TixCommunicationsEmailContentVariableConstraint;
  update_columns?: Array<TixCommunicationsEmailContentVariableUpdateColumn>;
  where?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
};

/** Ordering options when selecting data from "communications.email_content_variable". */
export type TixCommunicationsEmailContentVariableOrderBy = {
  EmailVariable?: InputMaybe<TixCommunicationsEmailVariableOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailContentId?: InputMaybe<TixOrderBy>;
  emailContentVariableId?: InputMaybe<TixOrderBy>;
  emailVariableId?: InputMaybe<TixOrderBy>;
  email_content?: InputMaybe<TixEmailContentOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: communications.email_content_variable */
export type TixCommunicationsEmailContentVariablePkColumnsInput = {
  emailContentVariableId: Scalars['uuid'];
};

/** select columns of table "communications.email_content_variable" */
export enum TixCommunicationsEmailContentVariableSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailContentId = 'emailContentId',
  /** column name */
  EmailContentVariableId = 'emailContentVariableId',
  /** column name */
  EmailVariableId = 'emailVariableId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "communications.email_content_variable" */
export type TixCommunicationsEmailContentVariableSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  emailContentVariableId?: InputMaybe<Scalars['uuid']>;
  emailVariableId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "communications_email_content_variable" */
export type TixCommunicationsEmailContentVariableStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCommunicationsEmailContentVariableStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCommunicationsEmailContentVariableStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  emailContentVariableId?: InputMaybe<Scalars['uuid']>;
  emailVariableId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "communications.email_content_variable" */
export enum TixCommunicationsEmailContentVariableUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailContentId = 'emailContentId',
  /** column name */
  EmailContentVariableId = 'emailContentVariableId',
  /** column name */
  EmailVariableId = 'emailVariableId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCommunicationsEmailContentVariableUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCommunicationsEmailContentVariableSetInput>;
  /** filter the rows which have to be updated */
  where: TixCommunicationsEmailContentVariableBoolExp;
};

/** columns and relationships of "communications.email_variable" */
export type TixCommunicationsEmailVariable = {
  __typename?: 'communications_email_variable';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  emailVariableId: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "communications.email_variable" */
export type TixCommunicationsEmailVariableAggregate = {
  __typename?: 'communications_email_variable_aggregate';
  aggregate?: Maybe<TixCommunicationsEmailVariableAggregateFields>;
  nodes: Array<TixCommunicationsEmailVariable>;
};

/** aggregate fields of "communications.email_variable" */
export type TixCommunicationsEmailVariableAggregateFields = {
  __typename?: 'communications_email_variable_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCommunicationsEmailVariableMaxFields>;
  min?: Maybe<TixCommunicationsEmailVariableMinFields>;
};


/** aggregate fields of "communications.email_variable" */
export type TixCommunicationsEmailVariableAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCommunicationsEmailVariableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "communications.email_variable". All fields are combined with a logical 'AND'. */
export type TixCommunicationsEmailVariableBoolExp = {
  _and?: InputMaybe<Array<TixCommunicationsEmailVariableBoolExp>>;
  _not?: InputMaybe<TixCommunicationsEmailVariableBoolExp>;
  _or?: InputMaybe<Array<TixCommunicationsEmailVariableBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  description?: InputMaybe<TixStringComparisonExp>;
  emailVariableId?: InputMaybe<TixUuidComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "communications.email_variable" */
export enum TixCommunicationsEmailVariableConstraint {
  /** unique or primary key constraint on columns "email_variable_id" */
  EmailVariablePkey = 'email_variable_pkey'
}

/** input type for inserting data into table "communications.email_variable" */
export type TixCommunicationsEmailVariableInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  emailVariableId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCommunicationsEmailVariableMaxFields = {
  __typename?: 'communications_email_variable_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  emailVariableId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixCommunicationsEmailVariableMinFields = {
  __typename?: 'communications_email_variable_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  emailVariableId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "communications.email_variable" */
export type TixCommunicationsEmailVariableMutationResponse = {
  __typename?: 'communications_email_variable_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCommunicationsEmailVariable>;
};

/** input type for inserting object relation for remote table "communications.email_variable" */
export type TixCommunicationsEmailVariableObjRelInsertInput = {
  data: TixCommunicationsEmailVariableInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixCommunicationsEmailVariableOnConflict>;
};

/** on_conflict condition type for table "communications.email_variable" */
export type TixCommunicationsEmailVariableOnConflict = {
  constraint: TixCommunicationsEmailVariableConstraint;
  update_columns?: Array<TixCommunicationsEmailVariableUpdateColumn>;
  where?: InputMaybe<TixCommunicationsEmailVariableBoolExp>;
};

/** Ordering options when selecting data from "communications.email_variable". */
export type TixCommunicationsEmailVariableOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  description?: InputMaybe<TixOrderBy>;
  emailVariableId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: communications.email_variable */
export type TixCommunicationsEmailVariablePkColumnsInput = {
  emailVariableId: Scalars['uuid'];
};

/** select columns of table "communications.email_variable" */
export enum TixCommunicationsEmailVariableSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  EmailVariableId = 'emailVariableId',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "communications.email_variable" */
export type TixCommunicationsEmailVariableSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  emailVariableId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "communications_email_variable" */
export type TixCommunicationsEmailVariableStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCommunicationsEmailVariableStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCommunicationsEmailVariableStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  emailVariableId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "communications.email_variable" */
export enum TixCommunicationsEmailVariableUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  EmailVariableId = 'emailVariableId',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixCommunicationsEmailVariableUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCommunicationsEmailVariableSetInput>;
  /** filter the rows which have to be updated */
  where: TixCommunicationsEmailVariableBoolExp;
};

/** columns and relationships of "communications.venue_email" */
export type TixCommunicationsVenueEmail = {
  __typename?: 'communications_venue_email';
  /** An object relationship */
  EmailContent?: Maybe<TixEmailContent>;
  /** An object relationship */
  Venue?: Maybe<TixVenue>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueEmailId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "communications.venue_email" */
export type TixCommunicationsVenueEmailAggregate = {
  __typename?: 'communications_venue_email_aggregate';
  aggregate?: Maybe<TixCommunicationsVenueEmailAggregateFields>;
  nodes: Array<TixCommunicationsVenueEmail>;
};

/** aggregate fields of "communications.venue_email" */
export type TixCommunicationsVenueEmailAggregateFields = {
  __typename?: 'communications_venue_email_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixCommunicationsVenueEmailMaxFields>;
  min?: Maybe<TixCommunicationsVenueEmailMinFields>;
};


/** aggregate fields of "communications.venue_email" */
export type TixCommunicationsVenueEmailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixCommunicationsVenueEmailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "communications.venue_email". All fields are combined with a logical 'AND'. */
export type TixCommunicationsVenueEmailBoolExp = {
  EmailContent?: InputMaybe<TixEmailContentBoolExp>;
  Venue?: InputMaybe<TixVenueBoolExp>;
  _and?: InputMaybe<Array<TixCommunicationsVenueEmailBoolExp>>;
  _not?: InputMaybe<TixCommunicationsVenueEmailBoolExp>;
  _or?: InputMaybe<Array<TixCommunicationsVenueEmailBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  emailContentId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueEmailId?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** input type for inserting data into table "communications.venue_email" */
export type TixCommunicationsVenueEmailInsertInput = {
  EmailContent?: InputMaybe<TixEmailContentObjRelInsertInput>;
  Venue?: InputMaybe<TixVenueObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueEmailId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixCommunicationsVenueEmailMaxFields = {
  __typename?: 'communications_venue_email_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueEmailId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixCommunicationsVenueEmailMinFields = {
  __typename?: 'communications_venue_email_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailContentId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueEmailId?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "communications.venue_email" */
export type TixCommunicationsVenueEmailMutationResponse = {
  __typename?: 'communications_venue_email_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixCommunicationsVenueEmail>;
};

/** Ordering options when selecting data from "communications.venue_email". */
export type TixCommunicationsVenueEmailOrderBy = {
  EmailContent?: InputMaybe<TixEmailContentOrderBy>;
  Venue?: InputMaybe<TixVenueOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailContentId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueEmailId?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** select columns of table "communications.venue_email" */
export enum TixCommunicationsVenueEmailSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailContentId = 'emailContentId',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueEmailId = 'venueEmailId',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "communications.venue_email" */
export type TixCommunicationsVenueEmailSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueEmailId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "communications_venue_email" */
export type TixCommunicationsVenueEmailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixCommunicationsVenueEmailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixCommunicationsVenueEmailStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailContentId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueEmailId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

export type TixCommunicationsVenueEmailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixCommunicationsVenueEmailSetInput>;
  /** filter the rows which have to be updated */
  where: TixCommunicationsVenueEmailBoolExp;
};

/** ordering argument of a cursor */
export enum TixCursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type TixDateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "reporting.v_event_summary_report" */
export type TixEventSummaryReport = {
  __typename?: 'eventSummaryReport';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  discount_amount?: Maybe<Scalars['money']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['money']>;
  refundAmount?: Maybe<Scalars['money']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationNo?: Maybe<Scalars['String']>;
  showRevenue?: Maybe<Scalars['money']>;
  showRevenue2?: Maybe<Scalars['money']>;
  startTIme?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['money']>;
  sub_total?: Maybe<Scalars['money']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  totalFees?: Maybe<Scalars['money']>;
  totalSeats?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_event_summary_report" */
export type TixEventSummaryReportAggregate = {
  __typename?: 'eventSummaryReport_aggregate';
  aggregate?: Maybe<TixEventSummaryReportAggregateFields>;
  nodes: Array<TixEventSummaryReport>;
};

/** aggregate fields of "reporting.v_event_summary_report" */
export type TixEventSummaryReportAggregateFields = {
  __typename?: 'eventSummaryReport_aggregate_fields';
  avg?: Maybe<TixEventSummaryReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixEventSummaryReportMaxFields>;
  min?: Maybe<TixEventSummaryReportMinFields>;
  stddev?: Maybe<TixEventSummaryReportStddevFields>;
  stddev_pop?: Maybe<TixEventSummaryReportStddevPopFields>;
  stddev_samp?: Maybe<TixEventSummaryReportStddevSampFields>;
  sum?: Maybe<TixEventSummaryReportSumFields>;
  var_pop?: Maybe<TixEventSummaryReportVarPopFields>;
  var_samp?: Maybe<TixEventSummaryReportVarSampFields>;
  variance?: Maybe<TixEventSummaryReportVarianceFields>;
};


/** aggregate fields of "reporting.v_event_summary_report" */
export type TixEventSummaryReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventSummaryReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixEventSummaryReportAvgFields = {
  __typename?: 'eventSummaryReport_avg_fields';
  discount_amount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  showRevenue2?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_event_summary_report". All fields are combined with a logical 'AND'. */
export type TixEventSummaryReportBoolExp = {
  _and?: InputMaybe<Array<TixEventSummaryReportBoolExp>>;
  _not?: InputMaybe<TixEventSummaryReportBoolExp>;
  _or?: InputMaybe<Array<TixEventSummaryReportBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  date?: InputMaybe<TixStringComparisonExp>;
  discount_amount?: InputMaybe<TixMoneyComparisonExp>;
  emailAddress?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  firstName?: InputMaybe<TixStringComparisonExp>;
  fullName?: InputMaybe<TixStringComparisonExp>;
  lastName?: InputMaybe<TixStringComparisonExp>;
  platformFee?: InputMaybe<TixMoneyComparisonExp>;
  refundAmount?: InputMaybe<TixMoneyComparisonExp>;
  reservationDate?: InputMaybe<TixStringComparisonExp>;
  reservationNo?: InputMaybe<TixStringComparisonExp>;
  showRevenue?: InputMaybe<TixMoneyComparisonExp>;
  showRevenue2?: InputMaybe<TixMoneyComparisonExp>;
  startTIme?: InputMaybe<TixStringComparisonExp>;
  stripeFeePaid?: InputMaybe<TixMoneyComparisonExp>;
  sub_total?: InputMaybe<TixMoneyComparisonExp>;
  ticketName?: InputMaybe<TixStringComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  ticketsInReservation?: InputMaybe<TixNumericComparisonExp>;
  totalAmountPaid?: InputMaybe<TixMoneyComparisonExp>;
  totalFees?: InputMaybe<TixMoneyComparisonExp>;
  totalSeats?: InputMaybe<TixNumericComparisonExp>;
  total_amount?: InputMaybe<TixMoneyComparisonExp>;
  venueFee?: InputMaybe<TixMoneyComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixEventSummaryReportMaxFields = {
  __typename?: 'eventSummaryReport_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  discount_amount?: Maybe<Scalars['money']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['money']>;
  refundAmount?: Maybe<Scalars['money']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationNo?: Maybe<Scalars['String']>;
  showRevenue?: Maybe<Scalars['money']>;
  showRevenue2?: Maybe<Scalars['money']>;
  startTIme?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['money']>;
  sub_total?: Maybe<Scalars['money']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  totalFees?: Maybe<Scalars['money']>;
  totalSeats?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixEventSummaryReportMinFields = {
  __typename?: 'eventSummaryReport_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  discount_amount?: Maybe<Scalars['money']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['money']>;
  refundAmount?: Maybe<Scalars['money']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationNo?: Maybe<Scalars['String']>;
  showRevenue?: Maybe<Scalars['money']>;
  showRevenue2?: Maybe<Scalars['money']>;
  startTIme?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['money']>;
  sub_total?: Maybe<Scalars['money']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  totalFees?: Maybe<Scalars['money']>;
  totalSeats?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reporting.v_event_summary_report". */
export type TixEventSummaryReportOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  discount_amount?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  firstName?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  lastName?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  reservationDate?: InputMaybe<TixOrderBy>;
  reservationNo?: InputMaybe<TixOrderBy>;
  showRevenue?: InputMaybe<TixOrderBy>;
  showRevenue2?: InputMaybe<TixOrderBy>;
  startTIme?: InputMaybe<TixOrderBy>;
  stripeFeePaid?: InputMaybe<TixOrderBy>;
  sub_total?: InputMaybe<TixOrderBy>;
  ticketName?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  ticketsInReservation?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  totalFees?: InputMaybe<TixOrderBy>;
  totalSeats?: InputMaybe<TixOrderBy>;
  total_amount?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_event_summary_report" */
export enum TixEventSummaryReportSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  Date = 'date',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventState = 'eventState',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FullName = 'fullName',
  /** column name */
  LastName = 'lastName',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  ReservationDate = 'reservationDate',
  /** column name */
  ReservationNo = 'reservationNo',
  /** column name */
  ShowRevenue = 'showRevenue',
  /** column name */
  ShowRevenue2 = 'showRevenue2',
  /** column name */
  StartTIme = 'startTIme',
  /** column name */
  StripeFeePaid = 'stripeFeePaid',
  /** column name */
  SubTotal = 'sub_total',
  /** column name */
  TicketName = 'ticketName',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  TicketsInReservation = 'ticketsInReservation',
  /** column name */
  TotalAmountPaid = 'totalAmountPaid',
  /** column name */
  TotalFees = 'totalFees',
  /** column name */
  TotalSeats = 'totalSeats',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  VenueFee = 'venueFee',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName'
}

/** aggregate stddev on columns */
export type TixEventSummaryReportStddevFields = {
  __typename?: 'eventSummaryReport_stddev_fields';
  discount_amount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  showRevenue2?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixEventSummaryReportStddevPopFields = {
  __typename?: 'eventSummaryReport_stddev_pop_fields';
  discount_amount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  showRevenue2?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixEventSummaryReportStddevSampFields = {
  __typename?: 'eventSummaryReport_stddev_samp_fields';
  discount_amount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  showRevenue2?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "eventSummaryReport" */
export type TixEventSummaryReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventSummaryReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventSummaryReportStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  discount_amount?: InputMaybe<Scalars['money']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  platformFee?: InputMaybe<Scalars['money']>;
  refundAmount?: InputMaybe<Scalars['money']>;
  reservationDate?: InputMaybe<Scalars['String']>;
  reservationNo?: InputMaybe<Scalars['String']>;
  showRevenue?: InputMaybe<Scalars['money']>;
  showRevenue2?: InputMaybe<Scalars['money']>;
  startTIme?: InputMaybe<Scalars['String']>;
  stripeFeePaid?: InputMaybe<Scalars['money']>;
  sub_total?: InputMaybe<Scalars['money']>;
  ticketName?: InputMaybe<Scalars['String']>;
  ticketType?: InputMaybe<Scalars['String']>;
  ticketsInReservation?: InputMaybe<Scalars['numeric']>;
  totalAmountPaid?: InputMaybe<Scalars['money']>;
  totalFees?: InputMaybe<Scalars['money']>;
  totalSeats?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['money']>;
  venueFee?: InputMaybe<Scalars['money']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixEventSummaryReportSumFields = {
  __typename?: 'eventSummaryReport_sum_fields';
  discount_amount?: Maybe<Scalars['money']>;
  platformFee?: Maybe<Scalars['money']>;
  refundAmount?: Maybe<Scalars['money']>;
  showRevenue?: Maybe<Scalars['money']>;
  showRevenue2?: Maybe<Scalars['money']>;
  stripeFeePaid?: Maybe<Scalars['money']>;
  sub_total?: Maybe<Scalars['money']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  totalFees?: Maybe<Scalars['money']>;
  totalSeats?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
};

/** aggregate var_pop on columns */
export type TixEventSummaryReportVarPopFields = {
  __typename?: 'eventSummaryReport_var_pop_fields';
  discount_amount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  showRevenue2?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixEventSummaryReportVarSampFields = {
  __typename?: 'eventSummaryReport_var_samp_fields';
  discount_amount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  showRevenue2?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixEventSummaryReportVarianceFields = {
  __typename?: 'eventSummaryReport_variance_fields';
  discount_amount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  showRevenue?: Maybe<Scalars['Float']>;
  showRevenue2?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalFees?: Maybe<Scalars['Float']>;
  totalSeats?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event.campaign_tracking" */
export type TixEventCampaignTracking = {
  __typename?: 'event_campaign_tracking';
  activity_tag?: Maybe<Scalars['String']>;
  campaignCode?: Maybe<Scalars['String']>;
  campaignType?: Maybe<Scalars['String']>;
  campaign_name?: Maybe<Scalars['String']>;
  campaign_tracking_id: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  eventInstance?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  group_tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "event.campaign_tracking" */
export type TixEventCampaignTrackingAggregate = {
  __typename?: 'event_campaign_tracking_aggregate';
  aggregate?: Maybe<TixEventCampaignTrackingAggregateFields>;
  nodes: Array<TixEventCampaignTracking>;
};

export type TixEventCampaignTrackingAggregateBoolExp = {
  count?: InputMaybe<TixEventCampaignTrackingAggregateBoolExpCount>;
};

export type TixEventCampaignTrackingAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixEventCampaignTrackingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixEventCampaignTrackingBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "event.campaign_tracking" */
export type TixEventCampaignTrackingAggregateFields = {
  __typename?: 'event_campaign_tracking_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixEventCampaignTrackingMaxFields>;
  min?: Maybe<TixEventCampaignTrackingMinFields>;
};


/** aggregate fields of "event.campaign_tracking" */
export type TixEventCampaignTrackingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixEventCampaignTrackingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event.campaign_tracking" */
export type TixEventCampaignTrackingAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixEventCampaignTrackingMaxOrderBy>;
  min?: InputMaybe<TixEventCampaignTrackingMinOrderBy>;
};

/** input type for inserting array relation for remote table "event.campaign_tracking" */
export type TixEventCampaignTrackingArrRelInsertInput = {
  data: Array<TixEventCampaignTrackingInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixEventCampaignTrackingOnConflict>;
};

/** Boolean expression to filter rows from the table "event.campaign_tracking". All fields are combined with a logical 'AND'. */
export type TixEventCampaignTrackingBoolExp = {
  _and?: InputMaybe<Array<TixEventCampaignTrackingBoolExp>>;
  _not?: InputMaybe<TixEventCampaignTrackingBoolExp>;
  _or?: InputMaybe<Array<TixEventCampaignTrackingBoolExp>>;
  activity_tag?: InputMaybe<TixStringComparisonExp>;
  campaignCode?: InputMaybe<TixStringComparisonExp>;
  campaignType?: InputMaybe<TixStringComparisonExp>;
  campaign_name?: InputMaybe<TixStringComparisonExp>;
  campaign_tracking_id?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  group_tag?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "event.campaign_tracking" */
export enum TixEventCampaignTrackingConstraint {
  /** unique or primary key constraint on columns "campaign_tracking_id" */
  CampaignTrackingPkey = 'campaign_tracking_pkey'
}

/** input type for inserting data into table "event.campaign_tracking" */
export type TixEventCampaignTrackingInsertInput = {
  activity_tag?: InputMaybe<Scalars['String']>;
  campaignCode?: InputMaybe<Scalars['String']>;
  campaignType?: InputMaybe<Scalars['String']>;
  campaign_name?: InputMaybe<Scalars['String']>;
  campaign_tracking_id?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  group_tag?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixEventCampaignTrackingMaxFields = {
  __typename?: 'event_campaign_tracking_max_fields';
  activity_tag?: Maybe<Scalars['String']>;
  campaignCode?: Maybe<Scalars['String']>;
  campaignType?: Maybe<Scalars['String']>;
  campaign_name?: Maybe<Scalars['String']>;
  campaign_tracking_id?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  group_tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event.campaign_tracking" */
export type TixEventCampaignTrackingMaxOrderBy = {
  activity_tag?: InputMaybe<TixOrderBy>;
  campaignCode?: InputMaybe<TixOrderBy>;
  campaignType?: InputMaybe<TixOrderBy>;
  campaign_name?: InputMaybe<TixOrderBy>;
  campaign_tracking_id?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  group_tag?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixEventCampaignTrackingMinFields = {
  __typename?: 'event_campaign_tracking_min_fields';
  activity_tag?: Maybe<Scalars['String']>;
  campaignCode?: Maybe<Scalars['String']>;
  campaignType?: Maybe<Scalars['String']>;
  campaign_name?: Maybe<Scalars['String']>;
  campaign_tracking_id?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  group_tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event.campaign_tracking" */
export type TixEventCampaignTrackingMinOrderBy = {
  activity_tag?: InputMaybe<TixOrderBy>;
  campaignCode?: InputMaybe<TixOrderBy>;
  campaignType?: InputMaybe<TixOrderBy>;
  campaign_name?: InputMaybe<TixOrderBy>;
  campaign_tracking_id?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  group_tag?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "event.campaign_tracking" */
export type TixEventCampaignTrackingMutationResponse = {
  __typename?: 'event_campaign_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixEventCampaignTracking>;
};

/** on_conflict condition type for table "event.campaign_tracking" */
export type TixEventCampaignTrackingOnConflict = {
  constraint: TixEventCampaignTrackingConstraint;
  update_columns?: Array<TixEventCampaignTrackingUpdateColumn>;
  where?: InputMaybe<TixEventCampaignTrackingBoolExp>;
};

/** Ordering options when selecting data from "event.campaign_tracking". */
export type TixEventCampaignTrackingOrderBy = {
  activity_tag?: InputMaybe<TixOrderBy>;
  campaignCode?: InputMaybe<TixOrderBy>;
  campaignType?: InputMaybe<TixOrderBy>;
  campaign_name?: InputMaybe<TixOrderBy>;
  campaign_tracking_id?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  group_tag?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: event.campaign_tracking */
export type TixEventCampaignTrackingPkColumnsInput = {
  campaign_tracking_id: Scalars['uuid'];
};

/** select columns of table "event.campaign_tracking" */
export enum TixEventCampaignTrackingSelectColumn {
  /** column name */
  ActivityTag = 'activity_tag',
  /** column name */
  CampaignCode = 'campaignCode',
  /** column name */
  CampaignType = 'campaignType',
  /** column name */
  CampaignName = 'campaign_name',
  /** column name */
  CampaignTrackingId = 'campaign_tracking_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  GroupTag = 'group_tag',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "event.campaign_tracking" */
export type TixEventCampaignTrackingSetInput = {
  activity_tag?: InputMaybe<Scalars['String']>;
  campaignCode?: InputMaybe<Scalars['String']>;
  campaignType?: InputMaybe<Scalars['String']>;
  campaign_name?: InputMaybe<Scalars['String']>;
  campaign_tracking_id?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  group_tag?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_campaign_tracking" */
export type TixEventCampaignTrackingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixEventCampaignTrackingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixEventCampaignTrackingStreamCursorValueInput = {
  activity_tag?: InputMaybe<Scalars['String']>;
  campaignCode?: InputMaybe<Scalars['String']>;
  campaignType?: InputMaybe<Scalars['String']>;
  campaign_name?: InputMaybe<Scalars['String']>;
  campaign_tracking_id?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  group_tag?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event.campaign_tracking" */
export enum TixEventCampaignTrackingUpdateColumn {
  /** column name */
  ActivityTag = 'activity_tag',
  /** column name */
  CampaignCode = 'campaignCode',
  /** column name */
  CampaignType = 'campaignType',
  /** column name */
  CampaignName = 'campaign_name',
  /** column name */
  CampaignTrackingId = 'campaign_tracking_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  GroupTag = 'group_tag',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixEventCampaignTrackingUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixEventCampaignTrackingSetInput>;
  /** filter the rows which have to be updated */
  where: TixEventCampaignTrackingBoolExp;
};

/** columns and relationships of "fees.fees" */
export type TixFees = {
  __typename?: 'fees';
  amount: Scalars['numeric'];
  companyId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  currency?: Maybe<Scalars['String']>;
  feeId: Scalars['uuid'];
  feeType: Scalars['String'];
  rangeHigh?: Maybe<Scalars['numeric']>;
  rangeLow?: Maybe<Scalars['numeric']>;
  state: Scalars['String'];
  typeOfFee: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "fees.fees" */
export type TixFeesAggregate = {
  __typename?: 'fees_aggregate';
  aggregate?: Maybe<TixFeesAggregateFields>;
  nodes: Array<TixFees>;
};

/** aggregate fields of "fees.fees" */
export type TixFeesAggregateFields = {
  __typename?: 'fees_aggregate_fields';
  avg?: Maybe<TixFeesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixFeesMaxFields>;
  min?: Maybe<TixFeesMinFields>;
  stddev?: Maybe<TixFeesStddevFields>;
  stddev_pop?: Maybe<TixFeesStddevPopFields>;
  stddev_samp?: Maybe<TixFeesStddevSampFields>;
  sum?: Maybe<TixFeesSumFields>;
  var_pop?: Maybe<TixFeesVarPopFields>;
  var_samp?: Maybe<TixFeesVarSampFields>;
  variance?: Maybe<TixFeesVarianceFields>;
};


/** aggregate fields of "fees.fees" */
export type TixFeesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixFeesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixFeesAvgFields = {
  __typename?: 'fees_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  rangeHigh?: Maybe<Scalars['Float']>;
  rangeLow?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fees.fees". All fields are combined with a logical 'AND'. */
export type TixFeesBoolExp = {
  _and?: InputMaybe<Array<TixFeesBoolExp>>;
  _not?: InputMaybe<TixFeesBoolExp>;
  _or?: InputMaybe<Array<TixFeesBoolExp>>;
  amount?: InputMaybe<TixNumericComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  currency?: InputMaybe<TixStringComparisonExp>;
  feeId?: InputMaybe<TixUuidComparisonExp>;
  feeType?: InputMaybe<TixStringComparisonExp>;
  rangeHigh?: InputMaybe<TixNumericComparisonExp>;
  rangeLow?: InputMaybe<TixNumericComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  typeOfFee?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "fees.fees" */
export enum TixFeesConstraint {
  /** unique or primary key constraint on columns "fee_id" */
  FeesPkey = 'fees_pkey'
}

/** input type for incrementing numeric columns in table "fees.fees" */
export type TixFeesIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  rangeHigh?: InputMaybe<Scalars['numeric']>;
  rangeLow?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "fees.fees" */
export type TixFeesInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  currency?: InputMaybe<Scalars['String']>;
  feeId?: InputMaybe<Scalars['uuid']>;
  feeType?: InputMaybe<Scalars['String']>;
  rangeHigh?: InputMaybe<Scalars['numeric']>;
  rangeLow?: InputMaybe<Scalars['numeric']>;
  state?: InputMaybe<Scalars['String']>;
  typeOfFee?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixFeesMaxFields = {
  __typename?: 'fees_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  currency?: Maybe<Scalars['String']>;
  feeId?: Maybe<Scalars['uuid']>;
  feeType?: Maybe<Scalars['String']>;
  rangeHigh?: Maybe<Scalars['numeric']>;
  rangeLow?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  typeOfFee?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixFeesMinFields = {
  __typename?: 'fees_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  currency?: Maybe<Scalars['String']>;
  feeId?: Maybe<Scalars['uuid']>;
  feeType?: Maybe<Scalars['String']>;
  rangeHigh?: Maybe<Scalars['numeric']>;
  rangeLow?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  typeOfFee?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fees.fees" */
export type TixFeesMutationResponse = {
  __typename?: 'fees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixFees>;
};

/** on_conflict condition type for table "fees.fees" */
export type TixFeesOnConflict = {
  constraint: TixFeesConstraint;
  update_columns?: Array<TixFeesUpdateColumn>;
  where?: InputMaybe<TixFeesBoolExp>;
};

/** Ordering options when selecting data from "fees.fees". */
export type TixFeesOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  currency?: InputMaybe<TixOrderBy>;
  feeId?: InputMaybe<TixOrderBy>;
  feeType?: InputMaybe<TixOrderBy>;
  rangeHigh?: InputMaybe<TixOrderBy>;
  rangeLow?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  typeOfFee?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: fees.fees */
export type TixFeesPkColumnsInput = {
  feeId: Scalars['uuid'];
};

/** select columns of table "fees.fees" */
export enum TixFeesSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  FeeId = 'feeId',
  /** column name */
  FeeType = 'feeType',
  /** column name */
  RangeHigh = 'rangeHigh',
  /** column name */
  RangeLow = 'rangeLow',
  /** column name */
  State = 'state',
  /** column name */
  TypeOfFee = 'typeOfFee',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "fees.fees" */
export type TixFeesSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  currency?: InputMaybe<Scalars['String']>;
  feeId?: InputMaybe<Scalars['uuid']>;
  feeType?: InputMaybe<Scalars['String']>;
  rangeHigh?: InputMaybe<Scalars['numeric']>;
  rangeLow?: InputMaybe<Scalars['numeric']>;
  state?: InputMaybe<Scalars['String']>;
  typeOfFee?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixFeesStddevFields = {
  __typename?: 'fees_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  rangeHigh?: Maybe<Scalars['Float']>;
  rangeLow?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixFeesStddevPopFields = {
  __typename?: 'fees_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  rangeHigh?: Maybe<Scalars['Float']>;
  rangeLow?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixFeesStddevSampFields = {
  __typename?: 'fees_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  rangeHigh?: Maybe<Scalars['Float']>;
  rangeLow?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fees" */
export type TixFeesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixFeesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixFeesStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  currency?: InputMaybe<Scalars['String']>;
  feeId?: InputMaybe<Scalars['uuid']>;
  feeType?: InputMaybe<Scalars['String']>;
  rangeHigh?: InputMaybe<Scalars['numeric']>;
  rangeLow?: InputMaybe<Scalars['numeric']>;
  state?: InputMaybe<Scalars['String']>;
  typeOfFee?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixFeesSumFields = {
  __typename?: 'fees_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  rangeHigh?: Maybe<Scalars['numeric']>;
  rangeLow?: Maybe<Scalars['numeric']>;
};

/** update columns of table "fees.fees" */
export enum TixFeesUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  FeeId = 'feeId',
  /** column name */
  FeeType = 'feeType',
  /** column name */
  RangeHigh = 'rangeHigh',
  /** column name */
  RangeLow = 'rangeLow',
  /** column name */
  State = 'state',
  /** column name */
  TypeOfFee = 'typeOfFee',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId'
}

export type TixFeesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixFeesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixFeesSetInput>;
  /** filter the rows which have to be updated */
  where: TixFeesBoolExp;
};

/** aggregate var_pop on columns */
export type TixFeesVarPopFields = {
  __typename?: 'fees_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  rangeHigh?: Maybe<Scalars['Float']>;
  rangeLow?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixFeesVarSampFields = {
  __typename?: 'fees_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  rangeHigh?: Maybe<Scalars['Float']>;
  rangeLow?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixFeesVarianceFields = {
  __typename?: 'fees_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  rangeHigh?: Maybe<Scalars['Float']>;
  rangeLow?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type TixFloat8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type TixJsonbCastExp = {
  String?: InputMaybe<TixStringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type TixJsonbComparisonExp = {
  _cast?: InputMaybe<TixJsonbCastExp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** Boolean expression to compare columns of type "money". All fields are combined with logical 'AND'. */
export type TixMoneyComparisonExp = {
  _eq?: InputMaybe<Scalars['money']>;
  _gt?: InputMaybe<Scalars['money']>;
  _gte?: InputMaybe<Scalars['money']>;
  _in?: InputMaybe<Array<Scalars['money']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['money']>;
  _lte?: InputMaybe<Scalars['money']>;
  _neq?: InputMaybe<Scalars['money']>;
  _nin?: InputMaybe<Array<Scalars['money']>>;
};

/** mutation root */
export type TixMutationRoot = {
  __typename?: 'mutation_root';
  /** delete data from the table: "contact.customer" */
  CustomerDelete?: Maybe<TixCustomerMutationResponse>;
  /** delete single row from the table: "contact.customer" */
  CustomerDeleteByPk?: Maybe<TixCustomer>;
  /** insert data into the table: "contact.customer" */
  CustomerInsert?: Maybe<TixCustomerMutationResponse>;
  /** insert a single row into the table: "contact.customer" */
  CustomerInsertOne?: Maybe<TixCustomer>;
  /** update data of the table: "contact.customer" */
  CustomerUpdate?: Maybe<TixCustomerMutationResponse>;
  /** update single row of the table: "contact.customer" */
  CustomerUpdateByPk?: Maybe<TixCustomer>;
  /** update multiples rows of table: "contact.customer" */
  CustomerUpdateMany?: Maybe<Array<Maybe<TixCustomerMutationResponse>>>;
  /** delete data from the table: "address.address" */
  DeleteAddress?: Maybe<TixAddressMutationResponse>;
  /** delete single row from the table: "address.address" */
  DeleteAddressByPK?: Maybe<TixAddress>;
  /** delete data from the table: "utility.business_code_group" */
  DeleteBusinessCodeGroup?: Maybe<TixBusinessCodeGroupMutationResponse>;
  /** delete single row from the table: "utility.business_code_group" */
  DeleteBusinessCodeGroupByPK?: Maybe<TixBusinessCodeGroup>;
  /** delete data from the table: "utility.business_codes" */
  DeleteBusinessCodes?: Maybe<TixBusinessCodesMutationResponse>;
  /** delete single row from the table: "utility.business_codes" */
  DeleteBusinessCodesByPK?: Maybe<TixBusinessCodes>;
  /** delete data from the table: "company.company" */
  DeleteCompany?: Maybe<TixCompanyMutationResponse>;
  /** delete data from the table: "address.company_address" */
  DeleteCompanyAddress?: Maybe<TixCompanyAddressMutationResponse>;
  /** delete single row from the table: "address.company_address" */
  DeleteCompanyAddressByPK?: Maybe<TixCompanyAddress>;
  /** delete data from the table: "configuration.company_configuration_value" */
  DeleteCompanyConfigurationValue?: Maybe<TixCompanyConfigurationValueMutationResponse>;
  /** delete data from the table: "contact.company_contact" */
  DeleteCompanyContact?: Maybe<TixCompanyContactMutationResponse>;
  /** delete single row from the table: "contact.company_contact" */
  DeleteCompanyContactByPK?: Maybe<TixCompanyContact>;
  /** delete data from the table: "media.company_media_file" */
  DeleteCompanyMediaFile?: Maybe<TixCompanyMediaFileMutationResponse>;
  /** delete single row from the table: "media.company_media_file" */
  DeleteCompanyMediaFileByPK?: Maybe<TixCompanyMediaFile>;
  /** delete data from the table: "address.company_phone_number" */
  DeleteCompanyPhoneNumber?: Maybe<TixCompanyPhoneNumberMutationResponse>;
  /** delete single row from the table: "address.company_phone_number" */
  DeleteCompanyPhoneNumberByPK?: Maybe<TixCompanyPhoneNumber>;
  /** delete data from the table: "media.company_social_media" */
  DeleteCompanySocialMedia?: Maybe<TixCompanySocialMediaMutationResponse>;
  /** delete single row from the table: "media.company_social_media" */
  DeleteCompanySocialMediaByPK?: Maybe<TixCompanySocialMedia>;
  /** delete data from the table: "warning.company_warning" */
  DeleteCompanyWarning?: Maybe<TixCompanyWarningMutationResponse>;
  /** delete single row from the table: "warning.company_warning" */
  DeleteCompanyWarningByPK?: Maybe<TixCompanyWarning>;
  /** delete data from the table: "configuration.configuration_group" */
  DeleteConfigurationGroup?: Maybe<TixConfigurationGroupMutationResponse>;
  /** delete single row from the table: "configuration.configuration_group" */
  DeleteConfigurationGroupByPK?: Maybe<TixConfigurationGroup>;
  /** delete data from the table: "configuration.configuration_group_item" */
  DeleteConfigurationGroupItem?: Maybe<TixConfigurationGroupItemMutationResponse>;
  /** delete data from the table: "configuration.configuration_item" */
  DeleteConfigurationItem?: Maybe<TixConfigurationItemMutationResponse>;
  /** delete single row from the table: "configuration.configuration_item" */
  DeleteConfigurationItemByPK?: Maybe<TixConfigurationItem>;
  /** delete data from the table: "configuration.configuration_value" */
  DeleteConfigurationValue?: Maybe<TixConfigurationValueMutationResponse>;
  /** delete data from the table: "contact.contact" */
  DeleteContact?: Maybe<TixContactMutationResponse>;
  /** delete data from the table: "address.contact_address" */
  DeleteContactAddress?: Maybe<TixContactAddressMutationResponse>;
  /** delete single row from the table: "address.contact_address" */
  DeleteContactAddressByPK?: Maybe<TixContactAddress>;
  /** delete single row from the table: "contact.contact" */
  DeleteContactByPK?: Maybe<TixContact>;
  /** delete data from the table: "address.contact_phone_number" */
  DeleteContactPhoneNumber?: Maybe<TixContactPhoneNumberMutationResponse>;
  /** delete single row from the table: "address.contact_phone_number" */
  DeleteContactPhoneNumberByPK?: Maybe<TixContactPhoneNumber>;
  /** delete data from the table: "discount.discount" */
  DeleteDiscount?: Maybe<TixDiscountMutationResponse>;
  /** delete single row from the table: "discount.discount" */
  DeleteDiscountByPK?: Maybe<TixDiscount>;
  /** delete data from the table: "event.event" */
  DeleteEvent?: Maybe<TixEventMutationResponse>;
  /** delete single row from the table: "event.event" */
  DeleteEventByPK?: Maybe<TixEvent>;
  /** delete data from the table: "event.event_instance" */
  DeleteEventInstance?: Maybe<TixEventInstanceMutationResponse>;
  /** delete single row from the table: "event.event_instance" */
  DeleteEventInstanceByPK?: Maybe<TixEventInstance>;
  /** delete data from the table: "configuration.event_instance_configuration_value" */
  DeleteEventInstanceConfigurationValue?: Maybe<TixEventInstanceConfigurationValueMutationResponse>;
  /** delete single row from the table: "configuration.event_instance_configuration_value" */
  DeleteEventInstanceConfigurationValueByPK?: Maybe<TixEventInstanceConfigurationValue>;
  /** delete data from the table: "discount.event_instance_discount" */
  DeleteEventInstanceDiscount?: Maybe<TixEventInstanceDiscountMutationResponse>;
  /** delete single row from the table: "discount.event_instance_discount" */
  DeleteEventInstanceDiscountByPK?: Maybe<TixEventInstanceDiscount>;
  /** delete data from the table: "media.event_instance_media_file" */
  DeleteEventInstanceMedialFile?: Maybe<TixEventInstanceMedialFileMutationResponse>;
  /** delete single row from the table: "media.event_instance_media_file" */
  DeleteEventInstanceMedialFileByPK?: Maybe<TixEventInstanceMedialFile>;
  /** delete data from the table: "media.event_instance_social_media" */
  DeleteEventInstanceSocialMediaFile?: Maybe<TixEventInstanceSocialMediaFileMutationResponse>;
  /** delete single row from the table: "media.event_instance_social_media" */
  DeleteEventInstanceSocialMediaFileByPK?: Maybe<TixEventInstanceSocialMediaFile>;
  /** delete data from the table: "ticket.event_instance_ticket" */
  DeleteEventInstanceTicket?: Maybe<TixEventInstanceTicketMutationResponse>;
  /** delete single row from the table: "ticket.event_instance_ticket" */
  DeleteEventInstanceTicketByPK?: Maybe<TixEventInstanceTicket>;
  /** delete data from the table: "ticket.event_instance_ticket_config" */
  DeleteEventInstanceTicketConfig?: Maybe<TixEventInstanceTicketConfigMutationResponse>;
  /** delete single row from the table: "ticket.event_instance_ticket_config" */
  DeleteEventInstanceTicketConfigByPK?: Maybe<TixEventInstanceTicketConfig>;
  /** delete data from the table: "performer.event_lineup" */
  DeleteEventLineup?: Maybe<TixEventLineupMutationResponse>;
  /** delete single row from the table: "performer.event_lineup" */
  DeleteEventLineupByPK?: Maybe<TixEventLineup>;
  /** delete data from the table: "performer.event_performers" */
  DeleteEventPerformers?: Maybe<TixEventPerformersMutationResponse>;
  /** delete single row from the table: "performer.event_performers" */
  DeleteEventPerformersByPK?: Maybe<TixEventPerformers>;
  /** delete data from the table: "event.event_venue" */
  DeleteEventVenue?: Maybe<TixEventVenueMutationResponse>;
  /** delete single row from the table: "event.event_venue" */
  DeleteEventVenueByPK?: Maybe<TixEventVenue>;
  /** delete data from the table: "performer.lineup" */
  DeleteLineup?: Maybe<TixLineupMutationResponse>;
  /** delete single row from the table: "performer.lineup" */
  DeleteLineupByPK?: Maybe<TixLineup>;
  /** delete data from the table: "performer.lineup_performer" */
  DeleteLineupPerformer?: Maybe<TixLineupPerformerMutationResponse>;
  /** delete single row from the table: "performer.lineup_performer" */
  DeleteLineupPerformerByPK?: Maybe<TixLineupPerformer>;
  /** delete data from the table: "media.media_file" */
  DeleteMediaFile?: Maybe<TixMediaFileMutationResponse>;
  /** delete single row from the table: "media.media_file" */
  DeleteMediaFileByPK?: Maybe<TixMediaFile>;
  /** delete data from the table: "notification.notification" */
  DeleteNotification?: Maybe<TixNotificationMutationResponse>;
  /** delete single row from the table: "notification.notification" */
  DeleteNotificationByPK?: Maybe<TixNotification>;
  /** delete data from the table: "payment.payment" */
  DeletePayment?: Maybe<TixPaymentMutationResponse>;
  /** delete single row from the table: "payment.payment" */
  DeletePaymentByPK?: Maybe<TixPayment>;
  /** delete data from the table: "payment.payment_discount" */
  DeletePaymentDiscount?: Maybe<TixPaymentDiscountMutationResponse>;
  /** delete single row from the table: "payment.payment_discount" */
  DeletePaymentDiscountByPK?: Maybe<TixPaymentDiscount>;
  /** delete data from the table: "payment.vendor_payment_log" */
  DeletePaymentVendorLog?: Maybe<TixPaymentVendorLogMutationResponse>;
  /** delete single row from the table: "payment.vendor_payment_log" */
  DeletePaymentVendorLogByPK?: Maybe<TixPaymentVendorLog>;
  /** delete data from the table: "payment.payout" */
  DeletePayout?: Maybe<TixPayoutMutationResponse>;
  /** delete single row from the table: "payment.payout" */
  DeletePayoutByPK?: Maybe<TixPayout>;
  /** delete data from the table: "performer.performer" */
  DeletePerformer?: Maybe<TixPerformerMutationResponse>;
  /** delete single row from the table: "performer.performer" */
  DeletePerformerByPK?: Maybe<TixPerformer>;
  /** delete data from the table: "access.permission" */
  DeletePermission?: Maybe<TixPermissionMutationResponse>;
  /** delete single row from the table: "access.permission" */
  DeletePermissionByPK?: Maybe<TixPermission>;
  /** delete data from the table: "address.phone_number" */
  DeletePhoneNumber?: Maybe<TixPhoneNumberMutationResponse>;
  /** delete single row from the table: "address.phone_number" */
  DeletePhoneNumberByPK?: Maybe<TixPhoneNumber>;
  /** delete data from the table: "ticket.reservation" */
  DeleteReservation?: Maybe<TixTicketReservationMutationResponse>;
  /** delete single row from the table: "ticket.reservation" */
  DeleteReservationByPK?: Maybe<TixTicketReservation>;
  /** delete data from the table: "payment.reservation_payment" */
  DeleteReservationPayment?: Maybe<TixReservationPaymentMutationResponse>;
  /** delete single row from the table: "payment.reservation_payment" */
  DeleteReservationPaymentByPK?: Maybe<TixReservationPayment>;
  /** delete data from the table: "access.role" */
  DeleteRole?: Maybe<TixRoleMutationResponse>;
  /** delete single row from the table: "access.role" */
  DeleteRoleByPK?: Maybe<TixRole>;
  /** delete data from the table: "access.role_permission" */
  DeleteRolePermission?: Maybe<TixRolePermissionMutationResponse>;
  /** delete single row from the table: "access.role_permission" */
  DeleteRolePermissionByPK?: Maybe<TixRolePermission>;
  /** delete data from the table: "media.social_media" */
  DeleteSocialMedia?: Maybe<TixSocialMediaMutationResponse>;
  /** delete single row from the table: "media.social_media" */
  DeleteSocialMediaByPK?: Maybe<TixSocialMedia>;
  /** delete data from the table: "ticket.ticket" */
  DeleteTicket?: Maybe<TixTicketMutationResponse>;
  /** delete single row from the table: "ticket.ticket" */
  DeleteTicketByPK?: Maybe<TixTicket>;
  /** delete data from the table: "ticket.ticket_config" */
  DeleteTicketConfig?: Maybe<TixTicketConfigMutationResponse>;
  /** delete single row from the table: "ticket.ticket_config" */
  DeleteTicketConfigByPK?: Maybe<TixTicketConfig>;
  /** delete data from the table: "access.user" */
  DeleteUser?: Maybe<TixUserMutationResponse>;
  /** delete single row from the table: "access.user" */
  DeleteUserByPK?: Maybe<TixUser>;
  /** delete data from the table: "access.user_role" */
  DeleteUserRole?: Maybe<TixUserRoleMutationResponse>;
  /** delete single row from the table: "access.user_role" */
  DeleteUserRoleByPK?: Maybe<TixUserRole>;
  /** delete data from the table: "venue.venue" */
  DeleteVenue?: Maybe<TixVenueMutationResponse>;
  /** delete data from the table: "address.venue_address" */
  DeleteVenueAddress?: Maybe<TixVenueAddressMutationResponse>;
  /** delete single row from the table: "address.venue_address" */
  DeleteVenueAddressById?: Maybe<TixVenueAddress>;
  /** delete single row from the table: "venue.venue" */
  DeleteVenueByPK?: Maybe<TixVenue>;
  /** delete data from the table: "configuration.venue_configuration_value" */
  DeleteVenueConfigurationValue?: Maybe<TixVenueConfigurationValueMutationResponse>;
  /** delete single row from the table: "configuration.venue_configuration_value" */
  DeleteVenueConfigurationValueByPK?: Maybe<TixVenueConfigurationValue>;
  /** delete data from the table: "contact.venue_contact" */
  DeleteVenueContact?: Maybe<TixVenueContactMutationResponse>;
  /** delete single row from the table: "contact.venue_contact" */
  DeleteVenueContactByPK?: Maybe<TixVenueContact>;
  /** delete data from the table: "discount.venue_discount" */
  DeleteVenueDiscount?: Maybe<TixVenueDiscountMutationResponse>;
  /** delete single row from the table: "discount.venue_discount" */
  DeleteVenueDiscountByPK?: Maybe<TixVenueDiscount>;
  /** delete data from the table: "performer.venue_lineup" */
  DeleteVenueLineup?: Maybe<TixVenueLineupMutationResponse>;
  /** delete single row from the table: "performer.venue_lineup" */
  DeleteVenueLineupByPK?: Maybe<TixVenueLineup>;
  /** delete data from the table: "media.venue_media_file" */
  DeleteVenueMediaFile?: Maybe<TixVenueMediaFileMutationResponse>;
  /** delete single row from the table: "media.venue_media_file" */
  DeleteVenueMediaFileByPK?: Maybe<TixVenueMediaFile>;
  /** delete data from the table: "address.venue_phone_number" */
  DeleteVenuePhoneNumber?: Maybe<TixVenuePhoneNumberMutationResponse>;
  /** delete single row from the table: "address.venue_phone_number" */
  DeleteVenuePhoneNumberByPK?: Maybe<TixVenuePhoneNumber>;
  /** delete data from the table: "media.venue_social_media" */
  DeleteVenueSocialMedia?: Maybe<TixVenueSocialMediaMutationResponse>;
  /** delete single row from the table: "media.venue_social_media" */
  DeleteVenueSocialMediaByPK?: Maybe<TixVenueSocialMedia>;
  /** delete data from the table: "ticket.venue_ticket" */
  DeleteVenueTicket?: Maybe<TixVenueTicketMutationResponse>;
  /** delete single row from the table: "ticket.venue_ticket" */
  DeleteVenueTicketByPK?: Maybe<TixVenueTicket>;
  /** delete data from the table: "ticket.venue_ticket_config" */
  DeleteVenueTicketConfig?: Maybe<TixVenueTicketConfigMutationResponse>;
  /** delete single row from the table: "ticket.venue_ticket_config" */
  DeleteVenueTicketConfigByPK?: Maybe<TixVenueTicketConfig>;
  /** delete data from the table: "warning.venue_warning" */
  DeleteVenueWarning?: Maybe<TixVenueWarningMutationResponse>;
  /** delete single row from the table: "warning.venue_warning" */
  DeleteVenueWarningByPK?: Maybe<TixVenueWarning>;
  /** delete data from the table: "warning.warning" */
  DeleteWarning?: Maybe<TixWarningMutationResponse>;
  /** delete single row from the table: "warning.warning" */
  DeleteWarningByPK?: Maybe<TixWarning>;
  /** insert data into the table: "communications.email_content" */
  EmailContentInsert?: Maybe<TixEmailContentMutationResponse>;
  /** insert a single row into the table: "communications.email_content" */
  EmailContentInsertOne?: Maybe<TixEmailContent>;
  /** update data of the table: "communications.email_content" */
  EmailContentUpdate?: Maybe<TixEmailContentMutationResponse>;
  /** update single row of the table: "communications.email_content" */
  EmailContentUpdateByPK?: Maybe<TixEmailContent>;
  /** insert data into the table: "communications.event_email" */
  EventEmailInsert?: Maybe<TixEventEmailMutationResponse>;
  /** insert a single row into the table: "communications.event_email" */
  EventEmailInsertOne?: Maybe<TixEventEmail>;
  /** update data of the table: "communications.event_email" */
  EventEmailUpdate?: Maybe<TixEventEmailMutationResponse>;
  /** delete data from the table: "product.event_product" */
  EventProductDelete?: Maybe<TixEventProductMutationResponse>;
  /** delete single row from the table: "product.event_product" */
  EventProductDeleteByPK?: Maybe<TixEventProduct>;
  /** insert data into the table: "product.event_product" */
  EventProductInsert?: Maybe<TixEventProductMutationResponse>;
  /** insert a single row into the table: "product.event_product" */
  EventProductInsertOne?: Maybe<TixEventProduct>;
  /** delete data from the table: "media.event_product_media_file" */
  EventProductMediaDelete?: Maybe<TixEventProductMediaMutationResponse>;
  /** delete single row from the table: "media.event_product_media_file" */
  EventProductMediaDeleteByPK?: Maybe<TixEventProductMedia>;
  /** insert data into the table: "media.event_product_media_file" */
  EventProductMediaInsert?: Maybe<TixEventProductMediaMutationResponse>;
  /** insert a single row into the table: "media.event_product_media_file" */
  EventProductMediaInsertOne?: Maybe<TixEventProductMedia>;
  /** update data of the table: "media.event_product_media_file" */
  EventProductMediaUpdate?: Maybe<TixEventProductMediaMutationResponse>;
  /** update single row of the table: "media.event_product_media_file" */
  EventProductMediaUpdateByPK?: Maybe<TixEventProductMedia>;
  /** update multiples rows of table: "media.event_product_media_file" */
  EventProductMediaUpdateMany?: Maybe<Array<Maybe<TixEventProductMediaMutationResponse>>>;
  /** update data of the table: "product.event_product" */
  EventProductUpdate?: Maybe<TixEventProductMutationResponse>;
  /** update single row of the table: "product.event_product" */
  EventProductUpdateByPK?: Maybe<TixEventProduct>;
  /** update multiples rows of table: "product.event_product" */
  EventProductUpdateMany?: Maybe<Array<Maybe<TixEventProductMutationResponse>>>;
  /** insert data into the table: "warning.venue_warning" */
  InserVenueWarning?: Maybe<TixVenueWarningMutationResponse>;
  /** insert data into the table: "reporting.logging" */
  Insert?: Maybe<TixLoggingMutationResponse>;
  /** insert data into the table: "address.address" */
  InsertAddress?: Maybe<TixAddressMutationResponse>;
  /** insert a single row into the table: "address.address" */
  InsertAddressOne?: Maybe<TixAddress>;
  /** insert data into the table: "utility.business_code_group" */
  InsertBusinessCodeGroup?: Maybe<TixBusinessCodeGroupMutationResponse>;
  /** insert a single row into the table: "utility.business_code_group" */
  InsertBusinessCodeGroupOne?: Maybe<TixBusinessCodeGroup>;
  /** insert data into the table: "utility.business_codes" */
  InsertBusinessCodes?: Maybe<TixBusinessCodesMutationResponse>;
  /** insert a single row into the table: "utility.business_codes" */
  InsertBusinessCodesOne?: Maybe<TixBusinessCodes>;
  /** insert data into the table: "company.company" */
  InsertCompany?: Maybe<TixCompanyMutationResponse>;
  /** insert data into the table: "address.company_address" */
  InsertCompanyAddress?: Maybe<TixCompanyAddressMutationResponse>;
  /** insert a single row into the table: "address.company_address" */
  InsertCompanyAddressOne?: Maybe<TixCompanyAddress>;
  /** insert data into the table: "configuration.company_configuration_value" */
  InsertCompanyConfigurationValue?: Maybe<TixCompanyConfigurationValueMutationResponse>;
  /** insert data into the table: "contact.company_contact" */
  InsertCompanyContact?: Maybe<TixCompanyContactMutationResponse>;
  /** insert a single row into the table: "contact.company_contact" */
  InsertCompanyContactOne?: Maybe<TixCompanyContact>;
  /** insert data into the table: "media.company_media_file" */
  InsertCompanyMediaFile?: Maybe<TixCompanyMediaFileMutationResponse>;
  /** insert a single row into the table: "media.company_media_file" */
  InsertCompanyMediaFileOne?: Maybe<TixCompanyMediaFile>;
  /** insert data into the table: "address.company_phone_number" */
  InsertCompanyPhoneNumber?: Maybe<TixCompanyPhoneNumberMutationResponse>;
  /** insert a single row into the table: "address.company_phone_number" */
  InsertCompanyPhoneNumberOne?: Maybe<TixCompanyPhoneNumber>;
  /** insert data into the table: "media.company_social_media" */
  InsertCompanySocialMedia?: Maybe<TixCompanySocialMediaMutationResponse>;
  /** insert a single row into the table: "media.company_social_media" */
  InsertCompanySocialMediaOne?: Maybe<TixCompanySocialMedia>;
  /** insert data into the table: "warning.company_warning" */
  InsertCompanyWarning?: Maybe<TixCompanyWarningMutationResponse>;
  /** insert a single row into the table: "warning.company_warning" */
  InsertCompanyWarningOne?: Maybe<TixCompanyWarning>;
  /** insert data into the table: "configuration.configuration_group" */
  InsertConfigurationGroup?: Maybe<TixConfigurationGroupMutationResponse>;
  /** insert data into the table: "configuration.configuration_group_item" */
  InsertConfigurationGroupItem?: Maybe<TixConfigurationGroupItemMutationResponse>;
  /** insert a single row into the table: "configuration.configuration_group" */
  InsertConfigurationGroupOne?: Maybe<TixConfigurationGroup>;
  /** insert data into the table: "configuration.configuration_item" */
  InsertConfigurationItem?: Maybe<TixConfigurationItemMutationResponse>;
  /** insert a single row into the table: "configuration.configuration_item" */
  InsertConfigurationItemOne?: Maybe<TixConfigurationItem>;
  /** insert data into the table: "configuration.configuration_value" */
  InsertConfigurationValue?: Maybe<TixConfigurationValueMutationResponse>;
  /** insert data into the table: "contact.contact" */
  InsertContact?: Maybe<TixContactMutationResponse>;
  /** insert data into the table: "address.contact_address" */
  InsertContactAddress?: Maybe<TixContactAddressMutationResponse>;
  /** insert a single row into the table: "contact.contact" */
  InsertContactOne?: Maybe<TixContact>;
  /** insert data into the table: "address.contact_phone_number" */
  InsertContactPhoneNumber?: Maybe<TixContactPhoneNumberMutationResponse>;
  /** insert a single row into the table: "address.contact_phone_number" */
  InsertContactPhoneNumberOne?: Maybe<TixContactPhoneNumber>;
  /** insert data into the table: "discount.discount" */
  InsertDiscount?: Maybe<TixDiscountMutationResponse>;
  /** insert a single row into the table: "discount.discount" */
  InsertDiscountOne?: Maybe<TixDiscount>;
  /** insert data into the table: "event.event" */
  InsertEvent?: Maybe<TixEventMutationResponse>;
  /** insert data into the table: "event.event_instance" */
  InsertEventInstance?: Maybe<TixEventInstanceMutationResponse>;
  /** insert data into the table: "configuration.event_instance_configuration_value" */
  InsertEventInstanceConfigurationValue?: Maybe<TixEventInstanceConfigurationValueMutationResponse>;
  /** insert data into the table: "discount.event_instance_discount" */
  InsertEventInstanceDiscount?: Maybe<TixEventInstanceDiscountMutationResponse>;
  /** insert data into the table: "media.event_instance_media_file" */
  InsertEventInstanceMedialFile?: Maybe<TixEventInstanceMedialFileMutationResponse>;
  /** insert a single row into the table: "media.event_instance_media_file" */
  InsertEventInstanceMedialFileOne?: Maybe<TixEventInstanceMedialFile>;
  /** insert a single row into the table: "event.event_instance" */
  InsertEventInstanceOne?: Maybe<TixEventInstance>;
  /** insert data into the table: "media.event_instance_social_media" */
  InsertEventInstanceSocialMediaFile?: Maybe<TixEventInstanceSocialMediaFileMutationResponse>;
  /** insert a single row into the table: "media.event_instance_social_media" */
  InsertEventInstanceSocialMediaFileOne?: Maybe<TixEventInstanceSocialMediaFile>;
  /** insert data into the table: "ticket.event_instance_ticket" */
  InsertEventInstanceTicket?: Maybe<TixEventInstanceTicketMutationResponse>;
  /** insert data into the table: "ticket.event_instance_ticket_config" */
  InsertEventInstanceTicketConfig?: Maybe<TixEventInstanceTicketConfigMutationResponse>;
  /** insert a single row into the table: "ticket.event_instance_ticket_config" */
  InsertEventInstanceTicketConfigOne?: Maybe<TixEventInstanceTicketConfig>;
  /** insert a single row into the table: "ticket.event_instance_ticket" */
  InsertEventInstanceTicketOne?: Maybe<TixEventInstanceTicket>;
  /** insert data into the table: "performer.event_lineup" */
  InsertEventLineup?: Maybe<TixEventLineupMutationResponse>;
  /** insert a single row into the table: "event.event" */
  InsertEventOne?: Maybe<TixEvent>;
  /** insert data into the table: "performer.event_performers" */
  InsertEventPerformers?: Maybe<TixEventPerformersMutationResponse>;
  /** insert a single row into the table: "performer.event_performers" */
  InsertEventPerformersOne?: Maybe<TixEventPerformers>;
  /** insert data into the table: "event.event_venue" */
  InsertEventVenue?: Maybe<TixEventVenueMutationResponse>;
  /** insert a single row into the table: "event.event_venue" */
  InsertEventVenueOne?: Maybe<TixEventVenue>;
  /** insert data into the table: "performer.lineup" */
  InsertLineup?: Maybe<TixLineupMutationResponse>;
  /** insert data into the table: "performer.lineup_performer" */
  InsertLineupPerformer?: Maybe<TixLineupPerformerMutationResponse>;
  /** insert data into the table: "media.media_file" */
  InsertMediaFile?: Maybe<TixMediaFileMutationResponse>;
  /** insert data into the table: "notification.notification" */
  InsertNotification?: Maybe<TixNotificationMutationResponse>;
  /** insert a single row into the table: "notification.notification" */
  InsertNotificationOne?: Maybe<TixNotification>;
  /** insert a single row into the table: "address.contact_address" */
  InsertOneContactAddress?: Maybe<TixContactAddress>;
  /** insert a single row into the table: "configuration.event_instance_configuration_value" */
  InsertOneEventInstanceConfigurationValue?: Maybe<TixEventInstanceConfigurationValue>;
  /** insert a single row into the table: "discount.event_instance_discount" */
  InsertOneEventInstanceDiscount?: Maybe<TixEventInstanceDiscount>;
  /** insert a single row into the table: "performer.event_lineup" */
  InsertOneEventLineup?: Maybe<TixEventLineup>;
  /** insert a single row into the table: "performer.lineup" */
  InsertOneLineup?: Maybe<TixLineup>;
  /** insert a single row into the table: "performer.lineup_performer" */
  InsertOneLineupPerformer?: Maybe<TixLineupPerformer>;
  /** insert a single row into the table: "media.media_file" */
  InsertOneMediaFile?: Maybe<TixMediaFile>;
  /** insert a single row into the table: "payment.payment" */
  InsertOnePayment?: Maybe<TixPayment>;
  /** insert a single row into the table: "payment.payment_discount" */
  InsertOnePaymentDiscount?: Maybe<TixPaymentDiscount>;
  /** insert a single row into the table: "payment.payout" */
  InsertOnePayout?: Maybe<TixPayout>;
  /** insert a single row into the table: "performer.performer" */
  InsertOnePerformer?: Maybe<TixPerformer>;
  /** insert a single row into the table: "access.permission" */
  InsertOnePermission?: Maybe<TixPermission>;
  /** insert a single row into the table: "payment.reservation_payment" */
  InsertOneReservationPayment?: Maybe<TixReservationPayment>;
  /** insert a single row into the table: "access.role" */
  InsertOneRole?: Maybe<TixRole>;
  /** insert a single row into the table: "access.role_permission" */
  InsertOneRolePermission?: Maybe<TixRolePermission>;
  /** insert a single row into the table: "ticket.ticket_config" */
  InsertOneTicketConfig?: Maybe<TixTicketConfig>;
  /** insert a single row into the table: "access.user_role" */
  InsertOneUserRole?: Maybe<TixUserRole>;
  /** insert a single row into the table: "performer.venue_lineup" */
  InsertOneVenueLineup?: Maybe<TixVenueLineup>;
  /** insert a single row into the table: "ticket.venue_ticket" */
  InsertOneVenueTicket?: Maybe<TixVenueTicket>;
  /** insert a single row into the table: "ticket.venue_ticket_config" */
  InsertOneVenueTicketConfig?: Maybe<TixVenueTicketConfig>;
  /** insert data into the table: "payment.payment" */
  InsertPayment?: Maybe<TixPaymentMutationResponse>;
  /** insert data into the table: "payment.payment_discount" */
  InsertPaymentDiscount?: Maybe<TixPaymentDiscountMutationResponse>;
  /** insert data into the table: "payment.vendor_payment_log" */
  InsertPaymentVendorLog?: Maybe<TixPaymentVendorLogMutationResponse>;
  /** insert a single row into the table: "payment.vendor_payment_log" */
  InsertPaymentVendorLogOne?: Maybe<TixPaymentVendorLog>;
  /** insert data into the table: "payment.payout" */
  InsertPayout?: Maybe<TixPayoutMutationResponse>;
  /** insert data into the table: "payment.payout_detail" */
  InsertPayoutDetail?: Maybe<TixPayoutDetailMutationResponse>;
  /** insert data into the table: "performer.performer" */
  InsertPerformer?: Maybe<TixPerformerMutationResponse>;
  /** insert data into the table: "access.permission" */
  InsertPermission?: Maybe<TixPermissionMutationResponse>;
  /** insert data into the table: "address.phone_number" */
  InsertPhoneNumber?: Maybe<TixPhoneNumberMutationResponse>;
  /** insert a single row into the table: "address.phone_number" */
  InsertPhoneNumberOne?: Maybe<TixPhoneNumber>;
  /** insert data into the table: "ticket.reservation" */
  InsertReservation?: Maybe<TixTicketReservationMutationResponse>;
  /** insert a single row into the table: "ticket.reservation" */
  InsertReservationOne?: Maybe<TixTicketReservation>;
  /** insert data into the table: "payment.reservation_payment" */
  InsertReservationPayment?: Maybe<TixReservationPaymentMutationResponse>;
  /** insert data into the table: "access.role" */
  InsertRole?: Maybe<TixRoleMutationResponse>;
  /** insert data into the table: "access.role_permission" */
  InsertRolePermission?: Maybe<TixRolePermissionMutationResponse>;
  /** insert data into the table: "media.social_media" */
  InsertSocialMedia?: Maybe<TixSocialMediaMutationResponse>;
  /** insert a single row into the table: "media.social_media" */
  InsertSocialMediaOne?: Maybe<TixSocialMedia>;
  /** insert data into the table: "ticket.ticket" */
  InsertTicket?: Maybe<TixTicketMutationResponse>;
  /** insert data into the table: "ticket.ticket_config" */
  InsertTicketConfig?: Maybe<TixTicketConfigMutationResponse>;
  /** insert a single row into the table: "ticket.ticket" */
  InsertTicketOne?: Maybe<TixTicket>;
  /** insert data into the table: "access.user" */
  InsertUser?: Maybe<TixUserMutationResponse>;
  /** insert a single row into the table: "access.user" */
  InsertUserOne?: Maybe<TixUser>;
  /** insert data into the table: "access.user_role" */
  InsertUserRole?: Maybe<TixUserRoleMutationResponse>;
  /** insert data into the table: "venue.venue" */
  InsertVenue?: Maybe<TixVenueMutationResponse>;
  /** insert data into the table: "address.venue_address" */
  InsertVenueAddress?: Maybe<TixVenueAddressMutationResponse>;
  /** insert a single row into the table: "address.venue_address" */
  InsertVenueAddressOne?: Maybe<TixVenueAddress>;
  /** insert data into the table: "configuration.venue_configuration_value" */
  InsertVenueConfigurationValue?: Maybe<TixVenueConfigurationValueMutationResponse>;
  /** insert a single row into the table: "configuration.venue_configuration_value" */
  InsertVenueConfigurationValueOne?: Maybe<TixVenueConfigurationValue>;
  /** insert data into the table: "contact.venue_contact" */
  InsertVenueContact?: Maybe<TixVenueContactMutationResponse>;
  /** insert a single row into the table: "contact.venue_contact" */
  InsertVenueContactOne?: Maybe<TixVenueContact>;
  /** insert data into the table: "discount.venue_discount" */
  InsertVenueDiscount?: Maybe<TixVenueDiscountMutationResponse>;
  /** insert a single row into the table: "discount.venue_discount" */
  InsertVenueDiscountOne?: Maybe<TixVenueDiscount>;
  /** insert data into the table: "performer.venue_lineup" */
  InsertVenueLineup?: Maybe<TixVenueLineupMutationResponse>;
  /** insert data into the table: "media.venue_media_file" */
  InsertVenueMediaFile?: Maybe<TixVenueMediaFileMutationResponse>;
  /** insert a single row into the table: "media.venue_media_file" */
  InsertVenueMediaFileOne?: Maybe<TixVenueMediaFile>;
  /** insert a single row into the table: "venue.venue" */
  InsertVenueOne?: Maybe<TixVenue>;
  /** insert data into the table: "address.venue_phone_number" */
  InsertVenuePhoneNumber?: Maybe<TixVenuePhoneNumberMutationResponse>;
  /** insert a single row into the table: "address.venue_phone_number" */
  InsertVenuePhoneNumberOne?: Maybe<TixVenuePhoneNumber>;
  /** insert data into the table: "media.venue_social_media" */
  InsertVenueSocialMedia?: Maybe<TixVenueSocialMediaMutationResponse>;
  /** insert a single row into the table: "media.venue_social_media" */
  InsertVenueSocialMediaOne?: Maybe<TixVenueSocialMedia>;
  /** insert data into the table: "ticket.venue_ticket" */
  InsertVenueTicket?: Maybe<TixVenueTicketMutationResponse>;
  /** insert data into the table: "ticket.venue_ticket_config" */
  InsertVenueTicketConfig?: Maybe<TixVenueTicketConfigMutationResponse>;
  /** insert a single row into the table: "warning.venue_warning" */
  InsertVenueWarningOne?: Maybe<TixVenueWarning>;
  /** insert data into the table: "warning.warning" */
  InsertWarning?: Maybe<TixWarningMutationResponse>;
  /** insert a single row into the table: "warning.warning" */
  InsertWarningOne?: Maybe<TixWarning>;
  /** insert a single row into the table: "reporting.logging" */
  LoggingInsertOne?: Maybe<TixLogging>;
  /** delete data from the table: "product.order" */
  OrderDelete?: Maybe<TixOrderMutationResponse>;
  /** delete single row from the table: "product.order" */
  OrderDeleteByPK?: Maybe<TixOrder>;
  /** insert data into the table: "product.order" */
  OrderInsert?: Maybe<TixOrderMutationResponse>;
  /** insert a single row into the table: "product.order" */
  OrderInsertOne?: Maybe<TixOrder>;
  /** update data of the table: "product.order" */
  OrderUpdate?: Maybe<TixOrderMutationResponse>;
  /** update single row of the table: "product.order" */
  OrderUpdateByPK?: Maybe<TixOrder>;
  /** update multiples rows of table: "product.order" */
  OrderUpdateMany?: Maybe<Array<Maybe<TixOrderMutationResponse>>>;
  /** insert a single row into the table: "payment.payout_connection" */
  PayoutConnectInsertOne?: Maybe<TixPayoutConnect>;
  /** update data of the table: "payment.payout_connection" */
  PayoutConnectUpdate?: Maybe<TixPayoutConnectMutationResponse>;
  /** delete data from the table: "product.product" */
  ProductDelete?: Maybe<TixProductMutationResponse>;
  /** delete single row from the table: "product.product" */
  ProductDeleteByPK?: Maybe<TixProduct>;
  /** insert data into the table: "product.product" */
  ProductInsert?: Maybe<TixProductMutationResponse>;
  /** insert a single row into the table: "product.product" */
  ProductInsertOne?: Maybe<TixProduct>;
  /** delete data from the table: "media.product_media_file" */
  ProductMediaFileDelete?: Maybe<TixProductMediaFileMutationResponse>;
  /** delete single row from the table: "media.product_media_file" */
  ProductMediaFileDeleteByPK?: Maybe<TixProductMediaFile>;
  /** insert data into the table: "media.product_media_file" */
  ProductMediaFileInsert?: Maybe<TixProductMediaFileMutationResponse>;
  /** insert a single row into the table: "media.product_media_file" */
  ProductMediaFileInsertOne?: Maybe<TixProductMediaFile>;
  /** update data of the table: "media.product_media_file" */
  ProductMediaFileUpdate?: Maybe<TixProductMediaFileMutationResponse>;
  /** update single row of the table: "media.product_media_file" */
  ProductMediaFileUpdateByPK?: Maybe<TixProductMediaFile>;
  /** update multiples rows of table: "media.product_media_file" */
  ProductMediaFileUpdateMany?: Maybe<Array<Maybe<TixProductMediaFileMutationResponse>>>;
  /** update data of the table: "product.product" */
  ProductUpdate?: Maybe<TixProductMutationResponse>;
  /** update single row of the table: "product.product" */
  ProductUpdateByPK?: Maybe<TixProduct>;
  /** update multiples rows of table: "product.product" */
  ProductUpdateMany?: Maybe<Array<Maybe<TixProductMutationResponse>>>;
  /** update single row of the table: "access.role_permission" */
  RolePermission?: Maybe<TixRolePermission>;
  /** insert data into the table: "ticket.reservation_detail" */
  TicketReservationDetailInsert?: Maybe<TixTicketReservationDetailMutationResponse>;
  /** insert a single row into the table: "ticket.reservation_detail" */
  TicketReservationDetailInsertOne?: Maybe<TixTicketReservationDetail>;
  /** update data of the table: "address.address" */
  UpdateAddress?: Maybe<TixAddressMutationResponse>;
  /** update single row of the table: "address.address" */
  UpdateAddressByPK?: Maybe<TixAddress>;
  /** update data of the table: "utility.business_code_group" */
  UpdateBusinessCodeGroup?: Maybe<TixBusinessCodeGroupMutationResponse>;
  /** update single row of the table: "utility.business_code_group" */
  UpdateBusinessCodeGroupByPK?: Maybe<TixBusinessCodeGroup>;
  /** update data of the table: "utility.business_codes" */
  UpdateBusinessCodes?: Maybe<TixBusinessCodesMutationResponse>;
  /** update single row of the table: "utility.business_codes" */
  UpdateBusinessCodesByPK?: Maybe<TixBusinessCodes>;
  /** update data of the table: "company.company" */
  UpdateCompany?: Maybe<TixCompanyMutationResponse>;
  /** update data of the table: "address.company_address" */
  UpdateCompanyAddress?: Maybe<TixCompanyAddressMutationResponse>;
  /** update single row of the table: "address.company_address" */
  UpdateCompanyAddressByPK?: Maybe<TixCompanyAddress>;
  /** update data of the table: "configuration.company_configuration_value" */
  UpdateCompanyConfigurationValue?: Maybe<TixCompanyConfigurationValueMutationResponse>;
  /** update data of the table: "contact.company_contact" */
  UpdateCompanyContact?: Maybe<TixCompanyContactMutationResponse>;
  /** update single row of the table: "contact.company_contact" */
  UpdateCompanyContactByPK?: Maybe<TixCompanyContact>;
  /** update data of the table: "media.company_media_file" */
  UpdateCompanyMediaFile?: Maybe<TixCompanyMediaFileMutationResponse>;
  /** update single row of the table: "media.company_media_file" */
  UpdateCompanyMediaFileByPK?: Maybe<TixCompanyMediaFile>;
  /** update data of the table: "address.company_phone_number" */
  UpdateCompanyPhoneNumber?: Maybe<TixCompanyPhoneNumberMutationResponse>;
  /** update single row of the table: "address.company_phone_number" */
  UpdateCompanyPhoneNumberByPK?: Maybe<TixCompanyPhoneNumber>;
  /** update data of the table: "media.company_social_media" */
  UpdateCompanySocialMedia?: Maybe<TixCompanySocialMediaMutationResponse>;
  /** update single row of the table: "media.company_social_media" */
  UpdateCompanySocialMediaByPK?: Maybe<TixCompanySocialMedia>;
  /** update data of the table: "warning.company_warning" */
  UpdateCompanyWarning?: Maybe<TixCompanyWarningMutationResponse>;
  /** update single row of the table: "warning.company_warning" */
  UpdateCompanyWarningByPK?: Maybe<TixCompanyWarning>;
  /** update data of the table: "configuration.configuration_group" */
  UpdateConfigurationGroup?: Maybe<TixConfigurationGroupMutationResponse>;
  /** update single row of the table: "configuration.configuration_group" */
  UpdateConfigurationGroupByPK?: Maybe<TixConfigurationGroup>;
  /** update data of the table: "configuration.configuration_group_item" */
  UpdateConfigurationGroupItem?: Maybe<TixConfigurationGroupItemMutationResponse>;
  /** update data of the table: "configuration.configuration_item" */
  UpdateConfigurationItem?: Maybe<TixConfigurationItemMutationResponse>;
  /** update single row of the table: "configuration.configuration_item" */
  UpdateConfigurationItemByPK?: Maybe<TixConfigurationItem>;
  /** update data of the table: "configuration.configuration_value" */
  UpdateConfigurationValue?: Maybe<TixConfigurationValueMutationResponse>;
  /** update data of the table: "contact.contact" */
  UpdateContact?: Maybe<TixContactMutationResponse>;
  /** update data of the table: "address.contact_address" */
  UpdateContactAddress?: Maybe<TixContactAddressMutationResponse>;
  /** update single row of the table: "address.contact_address" */
  UpdateContactAddressByPK?: Maybe<TixContactAddress>;
  /** update single row of the table: "contact.contact" */
  UpdateContactByPK?: Maybe<TixContact>;
  /** update data of the table: "address.contact_phone_number" */
  UpdateContactPhoneNumber?: Maybe<TixContactPhoneNumberMutationResponse>;
  /** update single row of the table: "address.contact_phone_number" */
  UpdateContactPhoneNumberByPK?: Maybe<TixContactPhoneNumber>;
  /** update data of the table: "discount.discount" */
  UpdateDiscount?: Maybe<TixDiscountMutationResponse>;
  /** update single row of the table: "discount.discount" */
  UpdateDiscountByPK?: Maybe<TixDiscount>;
  /** update multiples rows of table: "discount.discount" */
  UpdateDiscountMany?: Maybe<Array<Maybe<TixDiscountMutationResponse>>>;
  /** update data of the table: "event.event" */
  UpdateEvent?: Maybe<TixEventMutationResponse>;
  /** update single row of the table: "event.event" */
  UpdateEventByPK?: Maybe<TixEvent>;
  /** update data of the table: "event.event_instance" */
  UpdateEventInstance?: Maybe<TixEventInstanceMutationResponse>;
  /** update single row of the table: "event.event_instance" */
  UpdateEventInstanceByPK?: Maybe<TixEventInstance>;
  /** update data of the table: "configuration.event_instance_configuration_value" */
  UpdateEventInstanceConfigurationValue?: Maybe<TixEventInstanceConfigurationValueMutationResponse>;
  /** update single row of the table: "configuration.event_instance_configuration_value" */
  UpdateEventInstanceConfigurationValueByPK?: Maybe<TixEventInstanceConfigurationValue>;
  /** update multiples rows of table: "configuration.event_instance_configuration_value" */
  UpdateEventInstanceConfigurationValueMany?: Maybe<Array<Maybe<TixEventInstanceConfigurationValueMutationResponse>>>;
  /** update data of the table: "discount.event_instance_discount" */
  UpdateEventInstanceDiscount?: Maybe<TixEventInstanceDiscountMutationResponse>;
  /** update single row of the table: "discount.event_instance_discount" */
  UpdateEventInstanceDiscountByPK?: Maybe<TixEventInstanceDiscount>;
  /** update data of the table: "media.event_instance_media_file" */
  UpdateEventInstanceMedialFile?: Maybe<TixEventInstanceMedialFileMutationResponse>;
  /** update single row of the table: "media.event_instance_media_file" */
  UpdateEventInstanceMedialFileByPK?: Maybe<TixEventInstanceMedialFile>;
  /** update data of the table: "media.event_instance_social_media" */
  UpdateEventInstanceSocialMediaFile?: Maybe<TixEventInstanceSocialMediaFileMutationResponse>;
  /** update single row of the table: "media.event_instance_social_media" */
  UpdateEventInstanceSocialMediaFileByPK?: Maybe<TixEventInstanceSocialMediaFile>;
  /** update data of the table: "ticket.event_instance_ticket" */
  UpdateEventInstanceTicket?: Maybe<TixEventInstanceTicketMutationResponse>;
  /** update single row of the table: "ticket.event_instance_ticket" */
  UpdateEventInstanceTicketByPK?: Maybe<TixEventInstanceTicket>;
  /** update data of the table: "ticket.event_instance_ticket_config" */
  UpdateEventInstanceTicketConfig?: Maybe<TixEventInstanceTicketConfigMutationResponse>;
  /** update single row of the table: "ticket.event_instance_ticket_config" */
  UpdateEventInstanceTicketConfigByPK?: Maybe<TixEventInstanceTicketConfig>;
  /** update data of the table: "performer.event_lineup" */
  UpdateEventLineup?: Maybe<TixEventLineupMutationResponse>;
  /** update single row of the table: "performer.event_lineup" */
  UpdateEventLineupByPK?: Maybe<TixEventLineup>;
  /** update data of the table: "performer.event_performers" */
  UpdateEventPerformers?: Maybe<TixEventPerformersMutationResponse>;
  /** update single row of the table: "performer.event_performers" */
  UpdateEventPerformersByPK?: Maybe<TixEventPerformers>;
  /** update data of the table: "event.event_venue" */
  UpdateEventVenue?: Maybe<TixEventVenueMutationResponse>;
  /** update single row of the table: "event.event_venue" */
  UpdateEventVenueByPK?: Maybe<TixEventVenue>;
  /** update data of the table: "performer.lineup" */
  UpdateLineup?: Maybe<TixLineupMutationResponse>;
  /** update single row of the table: "performer.lineup" */
  UpdateLineupByPK?: Maybe<TixLineup>;
  /** update data of the table: "performer.lineup_performer" */
  UpdateLineupPerformer?: Maybe<TixLineupPerformerMutationResponse>;
  /** update single row of the table: "performer.lineup_performer" */
  UpdateLineupPerformerByPK?: Maybe<TixLineupPerformer>;
  /** update data of the table: "media.media_file" */
  UpdateMediaFile?: Maybe<TixMediaFileMutationResponse>;
  /** update single row of the table: "media.media_file" */
  UpdateMediaFileByPK?: Maybe<TixMediaFile>;
  /** update data of the table: "notification.notification" */
  UpdateNotification?: Maybe<TixNotificationMutationResponse>;
  /** update single row of the table: "notification.notification" */
  UpdateNotificationByPK?: Maybe<TixNotification>;
  /** update data of the table: "payment.payment" */
  UpdatePayment?: Maybe<TixPaymentMutationResponse>;
  /** update single row of the table: "payment.payment" */
  UpdatePaymentByPK?: Maybe<TixPayment>;
  /** update data of the table: "payment.payment_discount" */
  UpdatePaymentDiscount?: Maybe<TixPaymentDiscountMutationResponse>;
  /** update single row of the table: "payment.payment_discount" */
  UpdatePaymentDiscountByPK?: Maybe<TixPaymentDiscount>;
  /** update multiples rows of table: "payment.payment_discount" */
  UpdatePaymentDiscountMany?: Maybe<Array<Maybe<TixPaymentDiscountMutationResponse>>>;
  /** update data of the table: "payment.vendor_payment_log" */
  UpdatePaymentVendorLog?: Maybe<TixPaymentVendorLogMutationResponse>;
  /** update single row of the table: "payment.vendor_payment_log" */
  UpdatePaymentVendorLogByPK?: Maybe<TixPaymentVendorLog>;
  /** update multiples rows of table: "payment.vendor_payment_log" */
  UpdatePaymentVendorLogMany?: Maybe<Array<Maybe<TixPaymentVendorLogMutationResponse>>>;
  /** update data of the table: "payment.payout" */
  UpdatePayout?: Maybe<TixPayoutMutationResponse>;
  /** update single row of the table: "payment.payout" */
  UpdatePayoutByPK?: Maybe<TixPayout>;
  /** update single row of the table: "payment.payout_detail" */
  UpdatePayoutDetailByPK?: Maybe<TixPayoutDetail>;
  /** update multiples rows of table: "payment.payout" */
  UpdatePayoutMany?: Maybe<Array<Maybe<TixPayoutMutationResponse>>>;
  /** update data of the table: "performer.performer" */
  UpdatePerformer?: Maybe<TixPerformerMutationResponse>;
  /** update single row of the table: "performer.performer" */
  UpdatePerformerByPK?: Maybe<TixPerformer>;
  /** update data of the table: "access.permission" */
  UpdatePermission?: Maybe<TixPermissionMutationResponse>;
  /** update single row of the table: "access.permission" */
  UpdatePermissionByPK?: Maybe<TixPermission>;
  /** update data of the table: "address.phone_number" */
  UpdatePhoneNumber?: Maybe<TixPhoneNumberMutationResponse>;
  /** update single row of the table: "address.phone_number" */
  UpdatePhoneNumberByPK?: Maybe<TixPhoneNumber>;
  /** update data of the table: "ticket.reservation" */
  UpdateReservation?: Maybe<TixTicketReservationMutationResponse>;
  /** update single row of the table: "ticket.reservation" */
  UpdateReservationByPK?: Maybe<TixTicketReservation>;
  /** update data of the table: "payment.reservation_payment" */
  UpdateReservationPayment?: Maybe<TixReservationPaymentMutationResponse>;
  /** update single row of the table: "payment.reservation_payment" */
  UpdateReservationPaymentByPK?: Maybe<TixReservationPayment>;
  /** update data of the table: "access.role" */
  UpdateRole?: Maybe<TixRoleMutationResponse>;
  /** update single row of the table: "access.role" */
  UpdateRoleByPK?: Maybe<TixRole>;
  /** update data of the table: "access.role_permission" */
  UpdateRolePermissionByPK?: Maybe<TixRolePermissionMutationResponse>;
  /** update data of the table: "media.social_media" */
  UpdateSocialMedia?: Maybe<TixSocialMediaMutationResponse>;
  /** update single row of the table: "media.social_media" */
  UpdateSocialMediaByPK?: Maybe<TixSocialMedia>;
  /** update data of the table: "ticket.ticket" */
  UpdateTicket?: Maybe<TixTicketMutationResponse>;
  /** update single row of the table: "ticket.ticket" */
  UpdateTicketByPK?: Maybe<TixTicket>;
  /** update data of the table: "ticket.ticket_config" */
  UpdateTicketConfig?: Maybe<TixTicketConfigMutationResponse>;
  /** update single row of the table: "ticket.ticket_config" */
  UpdateTicketConfigByPK?: Maybe<TixTicketConfig>;
  /** update single row of the table: "access.user" */
  UpdateUserByPK?: Maybe<TixUser>;
  /** update data of the table: "access.user_role" */
  UpdateUserRole?: Maybe<TixUserRoleMutationResponse>;
  /** update single row of the table: "access.user_role" */
  UpdateUserRoleByPK?: Maybe<TixUserRole>;
  /** update data of the table: "venue.venue" */
  UpdateVenue?: Maybe<TixVenueMutationResponse>;
  /** update data of the table: "address.venue_address" */
  UpdateVenueAddress?: Maybe<TixVenueAddressMutationResponse>;
  /** update single row of the table: "address.venue_address" */
  UpdateVenueAddressById?: Maybe<TixVenueAddress>;
  /** update single row of the table: "venue.venue" */
  UpdateVenueByPK?: Maybe<TixVenue>;
  /** update data of the table: "configuration.venue_configuration_value" */
  UpdateVenueConfigurationValue?: Maybe<TixVenueConfigurationValueMutationResponse>;
  /** update single row of the table: "configuration.venue_configuration_value" */
  UpdateVenueConfigurationValueByPK?: Maybe<TixVenueConfigurationValue>;
  /** update data of the table: "contact.venue_contact" */
  UpdateVenueContact?: Maybe<TixVenueContactMutationResponse>;
  /** update single row of the table: "contact.venue_contact" */
  UpdateVenueContactByPK?: Maybe<TixVenueContact>;
  /** update data of the table: "discount.venue_discount" */
  UpdateVenueDiscount?: Maybe<TixVenueDiscountMutationResponse>;
  /** update single row of the table: "discount.venue_discount" */
  UpdateVenueDiscountByPK?: Maybe<TixVenueDiscount>;
  /** update multiples rows of table: "discount.venue_discount" */
  UpdateVenueDiscountMany?: Maybe<Array<Maybe<TixVenueDiscountMutationResponse>>>;
  /** update data of the table: "performer.venue_lineup" */
  UpdateVenueLineup?: Maybe<TixVenueLineupMutationResponse>;
  /** update single row of the table: "performer.venue_lineup" */
  UpdateVenueLineupByPK?: Maybe<TixVenueLineup>;
  /** update data of the table: "media.venue_media_file" */
  UpdateVenueMediaFile?: Maybe<TixVenueMediaFileMutationResponse>;
  /** update single row of the table: "media.venue_media_file" */
  UpdateVenueMediaFileByPK?: Maybe<TixVenueMediaFile>;
  /** update data of the table: "address.venue_phone_number" */
  UpdateVenuePhoneNumber?: Maybe<TixVenuePhoneNumberMutationResponse>;
  /** update single row of the table: "address.venue_phone_number" */
  UpdateVenuePhoneNumberByPK?: Maybe<TixVenuePhoneNumber>;
  /** update data of the table: "media.venue_social_media" */
  UpdateVenueSocialMedia?: Maybe<TixVenueSocialMediaMutationResponse>;
  /** update single row of the table: "media.venue_social_media" */
  UpdateVenueSocialMediaByPK?: Maybe<TixVenueSocialMedia>;
  /** update data of the table: "ticket.venue_ticket" */
  UpdateVenueTicket?: Maybe<TixVenueTicketMutationResponse>;
  /** update single row of the table: "ticket.venue_ticket" */
  UpdateVenueTicketByPK?: Maybe<TixVenueTicket>;
  /** update data of the table: "ticket.venue_ticket_config" */
  UpdateVenueTicketConfig?: Maybe<TixVenueTicketConfigMutationResponse>;
  /** update single row of the table: "ticket.venue_ticket_config" */
  UpdateVenueTicketConfigByPK?: Maybe<TixVenueTicketConfig>;
  /** update data of the table: "warning.venue_warning" */
  UpdateVenueWarning?: Maybe<TixVenueWarningMutationResponse>;
  /** update single row of the table: "warning.venue_warning" */
  UpdateVenueWarningByPK?: Maybe<TixVenueWarning>;
  /** update data of the table: "warning.warning" */
  UpdateWarning?: Maybe<TixWarningMutationResponse>;
  /** update single row of the table: "warning.warning" */
  UpdateWarningByPK?: Maybe<TixWarning>;
  /** update data of the table: "access.user" */
  User?: Maybe<TixUserMutationResponse>;
  /** delete data from the table: "product.venue_product" */
  VenueProductDelete?: Maybe<TixVenueProductMutationResponse>;
  /** delete single row from the table: "product.venue_product" */
  VenueProductDeleteByPK?: Maybe<TixVenueProduct>;
  /** insert data into the table: "product.venue_product" */
  VenueProductInsert?: Maybe<TixVenueProductMutationResponse>;
  /** insert a single row into the table: "product.venue_product" */
  VenueProductInsertOne?: Maybe<TixVenueProduct>;
  /** update data of the table: "product.venue_product" */
  VenueProductUpdate?: Maybe<TixVenueProductMutationResponse>;
  /** update single row of the table: "product.venue_product" */
  VenueProductUpdateByPK?: Maybe<TixVenueProduct>;
  /** update multiples rows of table: "product.venue_product" */
  VenueProductUpdateMany?: Maybe<Array<Maybe<TixVenueProductMutationResponse>>>;
  addOrderToHold: Scalars['Boolean'];
  cancelTicketExchange: Scalars['Boolean'];
  /** Returns a status message */
  confirmReservation: Scalars['Boolean'];
  /** Returns whether the exchange is confirmed or not */
  confirmTicketExchange: Scalars['Boolean'];
  createPayment?: Maybe<Scalars['JSON']>;
  createPaymentIntentForOrder: TixPaymentIntentResult;
  createRecurringEvents?: Maybe<TixInsertEventResult>;
  createRedirectCode: Scalars['String'];
  createStripeTerminalConnectionToken: Scalars['String'];
  /** Returns the created reservation id */
  createUnconfirmedReservation: Scalars['String'];
  createUserAndSendEmail?: Maybe<TixInviteUserResult>;
  deleteScheduledReportFromTheQueue: TixScheduledReportObject;
  /** delete single row from the table: "configuration.company_configuration_value" */
  delete_CompanyConfigurationValue_by_pk?: Maybe<TixCompanyConfigurationValue>;
  /** delete single row from the table: "configuration.configuration_group_item" */
  delete_ConfigurationGroupItem_by_pk?: Maybe<TixConfigurationGroupItem>;
  /** delete single row from the table: "configuration.configuration_value" */
  delete_ConfigurationValue_by_pk?: Maybe<TixConfigurationValue>;
  delete_EmailContent?: Maybe<TixEmailContentMutationResponse>;
  delete_EmailContent_by_pk?: Maybe<TixEmailContent>;
  delete_EventEmail?: Maybe<TixEventEmailMutationResponse>;
  delete_Logging?: Maybe<TixLoggingMutationResponse>;
  delete_Logging_by_pk?: Maybe<TixLogging>;
  /** delete data from the table: "payment.payout_connection" */
  delete_PayoutConnect?: Maybe<TixPayoutConnectMutationResponse>;
  /** delete single row from the table: "payment.payout_connection" */
  delete_PayoutConnect_by_pk?: Maybe<TixPayoutConnect>;
  /** delete data from the table: "payment.payout_detail" */
  delete_PayoutDetail?: Maybe<TixPayoutDetailMutationResponse>;
  /** delete single row from the table: "payment.payout_detail" */
  delete_PayoutDetail_by_pk?: Maybe<TixPayoutDetail>;
  delete_TicketReservationDetail?: Maybe<TixTicketReservationDetailMutationResponse>;
  delete_TicketReservationDetail_by_pk?: Maybe<TixTicketReservationDetail>;
  /** delete data from the table: "address.performer_phone_number" */
  delete_address_performer_phone_number?: Maybe<TixAddressPerformerPhoneNumberMutationResponse>;
  /** delete single row from the table: "address.performer_phone_number" */
  delete_address_performer_phone_number_by_pk?: Maybe<TixAddressPerformerPhoneNumber>;
  /** delete data from the table: "communications.company_email" */
  delete_communications_company_email?: Maybe<TixCommunicationsCompanyEmailMutationResponse>;
  /** delete data from the table: "communications.email_content_variable" */
  delete_communications_email_content_variable?: Maybe<TixCommunicationsEmailContentVariableMutationResponse>;
  /** delete single row from the table: "communications.email_content_variable" */
  delete_communications_email_content_variable_by_pk?: Maybe<TixCommunicationsEmailContentVariable>;
  /** delete data from the table: "communications.email_variable" */
  delete_communications_email_variable?: Maybe<TixCommunicationsEmailVariableMutationResponse>;
  /** delete single row from the table: "communications.email_variable" */
  delete_communications_email_variable_by_pk?: Maybe<TixCommunicationsEmailVariable>;
  /** delete data from the table: "communications.venue_email" */
  delete_communications_venue_email?: Maybe<TixCommunicationsVenueEmailMutationResponse>;
  /** delete single row from the table: "company.company" */
  delete_company_by_pk?: Maybe<TixCompany>;
  /** delete data from the table: "event.campaign_tracking" */
  delete_event_campaign_tracking?: Maybe<TixEventCampaignTrackingMutationResponse>;
  /** delete single row from the table: "event.campaign_tracking" */
  delete_event_campaign_tracking_by_pk?: Maybe<TixEventCampaignTracking>;
  /** delete data from the table: "notification.contact_notification" */
  delete_notification_contact_notification?: Maybe<TixNotificationContactNotificationMutationResponse>;
  /** delete single row from the table: "notification.contact_notification" */
  delete_notification_contact_notification_by_pk?: Maybe<TixNotificationContactNotification>;
  /** delete data from the table: "product.order_detail" */
  delete_product_order_detail?: Maybe<TixProductOrderDetailMutationResponse>;
  /** delete single row from the table: "product.order_detail" */
  delete_product_order_detail_by_pk?: Maybe<TixProductOrderDetail>;
  delete_reservationReport?: Maybe<TixReservationReportMutationResponse>;
  delete_reservationReport_by_pk?: Maybe<TixReservationReport>;
  /** delete data from the table: "reporting.saved_report" */
  delete_savedReport?: Maybe<TixSavedReportMutationResponse>;
  /** delete data from the table: "reporting.saved_report_events" */
  delete_savedReportEvents?: Maybe<TixSavedReportEventsMutationResponse>;
  /** delete single row from the table: "reporting.saved_report_events" */
  delete_savedReportEvents_by_pk?: Maybe<TixSavedReportEvents>;
  /** delete data from the table: "reporting.saved_report_layout" */
  delete_savedReportLayout?: Maybe<TixSavedReportLayoutMutationResponse>;
  /** delete single row from the table: "reporting.saved_report_layout" */
  delete_savedReportLayout_by_pk?: Maybe<TixSavedReportLayout>;
  /** delete single row from the table: "reporting.saved_report" */
  delete_savedReport_by_pk?: Maybe<TixSavedReport>;
  /** delete data from the table: "reporting.scheduled_report" */
  delete_scheduledReport?: Maybe<TixScheduledReportMutationResponse>;
  /** delete data from the table: "reporting.scheduled_report_email" */
  delete_scheduledReportEmail?: Maybe<TixScheduledReportEmailMutationResponse>;
  /** delete single row from the table: "reporting.scheduled_report_email" */
  delete_scheduledReportEmail_by_pk?: Maybe<TixScheduledReportEmail>;
  /** delete single row from the table: "reporting.scheduled_report" */
  delete_scheduledReport_by_pk?: Maybe<TixScheduledReport>;
  /** delete data from the table: "ticket.exchange" */
  delete_ticket_exchange?: Maybe<TixTicketExchangeMutationResponse>;
  /** delete single row from the table: "ticket.exchange" */
  delete_ticket_exchange_by_pk?: Maybe<TixTicketExchange>;
  /** delete data from the table: "ticket.ticket_discount" */
  delete_ticket_ticket_discount?: Maybe<TixTicketTicketDiscountMutationResponse>;
  /** delete single row from the table: "ticket.ticket_discount" */
  delete_ticket_ticket_discount_by_pk?: Maybe<TixTicketTicketDiscount>;
  /** delete data from the table: "utility.policy" */
  delete_utility_policy?: Maybe<TixUtilityPolicyMutationResponse>;
  /** delete single row from the table: "utility.policy" */
  delete_utility_policy_by_pk?: Maybe<TixUtilityPolicy>;
  disconnectStripeConnection: Scalars['Boolean'];
  exchangeRedirectCodeForToken: Scalars['String'];
  /** delete data from the table: "fees.fees" */
  feesDelete?: Maybe<TixFeesMutationResponse>;
  /** delete single row from the table: "fees.fees" */
  feesDeleteByPk?: Maybe<TixFees>;
  /** insert data into the table: "fees.fees" */
  feesInsert?: Maybe<TixFeesMutationResponse>;
  /** insert a single row into the table: "fees.fees" */
  feesInsertOne?: Maybe<TixFees>;
  /** update data of the table: "fees.fees" */
  feesUpdate?: Maybe<TixFeesMutationResponse>;
  /** update single row of the table: "fees.fees" */
  feesUpdateByPk?: Maybe<TixFees>;
  /** update multiples rows of table: "fees.fees" */
  feesUpdateMany?: Maybe<Array<Maybe<TixFeesMutationResponse>>>;
  genericAddOrderToHold: Scalars['Boolean'];
  genericRemoveOrderFromHold: Scalars['Boolean'];
  getStripeConnectionURL: TixPayoutConnectionResult;
  grantAccessToCompany: Scalars['Boolean'];
  /** Returns the created exchange id */
  initiateTicketExchange: Scalars['String'];
  insertScheduledReportToTheQueue: TixScheduledReportObject;
  /** insert a single row into the table: "configuration.company_configuration_value" */
  insert_CompanyConfigurationValue_one?: Maybe<TixCompanyConfigurationValue>;
  /** insert a single row into the table: "configuration.configuration_group_item" */
  insert_ConfigurationGroupItem_one?: Maybe<TixConfigurationGroupItem>;
  /** insert a single row into the table: "configuration.configuration_value" */
  insert_ConfigurationValue_one?: Maybe<TixConfigurationValue>;
  /** insert data into the table: "payment.payout_connection" */
  insert_PayoutConnect?: Maybe<TixPayoutConnectMutationResponse>;
  /** insert a single row into the table: "payment.payout_detail" */
  insert_PayoutDetail_one?: Maybe<TixPayoutDetail>;
  /** insert data into the table: "address.performer_phone_number" */
  insert_address_performer_phone_number?: Maybe<TixAddressPerformerPhoneNumberMutationResponse>;
  /** insert a single row into the table: "address.performer_phone_number" */
  insert_address_performer_phone_number_one?: Maybe<TixAddressPerformerPhoneNumber>;
  /** insert data into the table: "communications.company_email" */
  insert_communications_company_email?: Maybe<TixCommunicationsCompanyEmailMutationResponse>;
  /** insert a single row into the table: "communications.company_email" */
  insert_communications_company_email_one?: Maybe<TixCommunicationsCompanyEmail>;
  /** insert data into the table: "communications.email_content_variable" */
  insert_communications_email_content_variable?: Maybe<TixCommunicationsEmailContentVariableMutationResponse>;
  /** insert a single row into the table: "communications.email_content_variable" */
  insert_communications_email_content_variable_one?: Maybe<TixCommunicationsEmailContentVariable>;
  /** insert data into the table: "communications.email_variable" */
  insert_communications_email_variable?: Maybe<TixCommunicationsEmailVariableMutationResponse>;
  /** insert a single row into the table: "communications.email_variable" */
  insert_communications_email_variable_one?: Maybe<TixCommunicationsEmailVariable>;
  /** insert data into the table: "communications.venue_email" */
  insert_communications_venue_email?: Maybe<TixCommunicationsVenueEmailMutationResponse>;
  /** insert a single row into the table: "communications.venue_email" */
  insert_communications_venue_email_one?: Maybe<TixCommunicationsVenueEmail>;
  /** insert a single row into the table: "company.company" */
  insert_company_one?: Maybe<TixCompany>;
  /** insert data into the table: "event.campaign_tracking" */
  insert_event_campaign_tracking?: Maybe<TixEventCampaignTrackingMutationResponse>;
  /** insert a single row into the table: "event.campaign_tracking" */
  insert_event_campaign_tracking_one?: Maybe<TixEventCampaignTracking>;
  /** insert data into the table: "notification.contact_notification" */
  insert_notification_contact_notification?: Maybe<TixNotificationContactNotificationMutationResponse>;
  /** insert a single row into the table: "notification.contact_notification" */
  insert_notification_contact_notification_one?: Maybe<TixNotificationContactNotification>;
  /** insert data into the table: "product.order_detail" */
  insert_product_order_detail?: Maybe<TixProductOrderDetailMutationResponse>;
  /** insert a single row into the table: "product.order_detail" */
  insert_product_order_detail_one?: Maybe<TixProductOrderDetail>;
  /** insert data into the table: "reporting.saved_report" */
  insert_savedReport?: Maybe<TixSavedReportMutationResponse>;
  /** insert data into the table: "reporting.saved_report_events" */
  insert_savedReportEvents?: Maybe<TixSavedReportEventsMutationResponse>;
  /** insert a single row into the table: "reporting.saved_report_events" */
  insert_savedReportEvents_one?: Maybe<TixSavedReportEvents>;
  /** insert data into the table: "reporting.saved_report_layout" */
  insert_savedReportLayout?: Maybe<TixSavedReportLayoutMutationResponse>;
  /** insert a single row into the table: "reporting.saved_report_layout" */
  insert_savedReportLayout_one?: Maybe<TixSavedReportLayout>;
  /** insert a single row into the table: "reporting.saved_report" */
  insert_savedReport_one?: Maybe<TixSavedReport>;
  /** insert data into the table: "reporting.scheduled_report" */
  insert_scheduledReport?: Maybe<TixScheduledReportMutationResponse>;
  /** insert data into the table: "reporting.scheduled_report_email" */
  insert_scheduledReportEmail?: Maybe<TixScheduledReportEmailMutationResponse>;
  /** insert a single row into the table: "reporting.scheduled_report_email" */
  insert_scheduledReportEmail_one?: Maybe<TixScheduledReportEmail>;
  /** insert a single row into the table: "reporting.scheduled_report" */
  insert_scheduledReport_one?: Maybe<TixScheduledReport>;
  /** insert data into the table: "ticket.exchange" */
  insert_ticket_exchange?: Maybe<TixTicketExchangeMutationResponse>;
  /** insert a single row into the table: "ticket.exchange" */
  insert_ticket_exchange_one?: Maybe<TixTicketExchange>;
  /** insert data into the table: "ticket.ticket_discount" */
  insert_ticket_ticket_discount?: Maybe<TixTicketTicketDiscountMutationResponse>;
  /** insert a single row into the table: "ticket.ticket_discount" */
  insert_ticket_ticket_discount_one?: Maybe<TixTicketTicketDiscount>;
  /** insert data into the table: "utility.policy" */
  insert_utility_policy?: Maybe<TixUtilityPolicyMutationResponse>;
  /** insert a single row into the table: "utility.policy" */
  insert_utility_policy_one?: Maybe<TixUtilityPolicy>;
  refundAddons?: Maybe<Scalars['JSON']>;
  refundDonations?: Maybe<Scalars['JSON']>;
  refundReservation?: Maybe<Scalars['JSON']>;
  refundTicket?: Maybe<Scalars['JSON']>;
  removeOrderFromHold: Scalars['Boolean'];
  requestPayout: Scalars['Boolean'];
  requestResetPassword?: Maybe<TixRequestResetPasswordResponse>;
  /** insert a single row into the table: "reporting.reservation_report" */
  reservationReportInserOne?: Maybe<TixReservationReport>;
  /** insert data into the table: "reporting.reservation_report" */
  reservationReportInsert?: Maybe<TixReservationReportMutationResponse>;
  reservationReportUpdate?: Maybe<TixReservationReportMutationResponse>;
  resetPassword?: Maybe<TixResetPasswordResponse>;
  sendEticket?: Maybe<Scalars['Boolean']>;
  /** Send payment email for a pending ticket exchange */
  sendExchangePaymentEmail: Scalars['Boolean'];
  sendTicketExchangeEmail: Scalars['Boolean'];
  sendTicketPurchaseEmail?: Maybe<Scalars['Boolean']>;
  submitFeedback: Scalars['Boolean'];
  submitMobileFeedback: Scalars['Boolean'];
  switchEventProductToIndependentInventory: Scalars['Boolean'];
  switchEventProductToSharedInventory: Scalars['Boolean'];
  /** update single row of the table: "company.company" */
  updateCompanyById?: Maybe<TixCompany>;
  updatePaymentIntentMetadata: Scalars['Boolean'];
  updateProductInventoryQuantity: Scalars['Boolean'];
  updateProductInventoryQuantitySold: Scalars['Boolean'];
  updateScheduledReportInTheQueue: TixScheduledReportObject;
  /** update multiples rows of table: "address.address" */
  update_Address_many?: Maybe<Array<Maybe<TixAddressMutationResponse>>>;
  /** update multiples rows of table: "utility.business_code_group" */
  update_BusinessCodeGroup_many?: Maybe<Array<Maybe<TixBusinessCodeGroupMutationResponse>>>;
  /** update multiples rows of table: "utility.business_codes" */
  update_BusinessCodes_many?: Maybe<Array<Maybe<TixBusinessCodesMutationResponse>>>;
  /** update multiples rows of table: "address.company_address" */
  update_CompanyAddress_many?: Maybe<Array<Maybe<TixCompanyAddressMutationResponse>>>;
  /** update single row of the table: "configuration.company_configuration_value" */
  update_CompanyConfigurationValue_by_pk?: Maybe<TixCompanyConfigurationValue>;
  /** update multiples rows of table: "configuration.company_configuration_value" */
  update_CompanyConfigurationValue_many?: Maybe<Array<Maybe<TixCompanyConfigurationValueMutationResponse>>>;
  /** update multiples rows of table: "contact.company_contact" */
  update_CompanyContact_many?: Maybe<Array<Maybe<TixCompanyContactMutationResponse>>>;
  /** update multiples rows of table: "media.company_media_file" */
  update_CompanyMediaFile_many?: Maybe<Array<Maybe<TixCompanyMediaFileMutationResponse>>>;
  /** update multiples rows of table: "address.company_phone_number" */
  update_CompanyPhoneNumber_many?: Maybe<Array<Maybe<TixCompanyPhoneNumberMutationResponse>>>;
  /** update multiples rows of table: "media.company_social_media" */
  update_CompanySocialMedia_many?: Maybe<Array<Maybe<TixCompanySocialMediaMutationResponse>>>;
  /** update multiples rows of table: "warning.company_warning" */
  update_CompanyWarning_many?: Maybe<Array<Maybe<TixCompanyWarningMutationResponse>>>;
  /** update multiples rows of table: "company.company" */
  update_Company_many?: Maybe<Array<Maybe<TixCompanyMutationResponse>>>;
  /** update single row of the table: "configuration.configuration_group_item" */
  update_ConfigurationGroupItem_by_pk?: Maybe<TixConfigurationGroupItem>;
  /** update multiples rows of table: "configuration.configuration_group_item" */
  update_ConfigurationGroupItem_many?: Maybe<Array<Maybe<TixConfigurationGroupItemMutationResponse>>>;
  /** update multiples rows of table: "configuration.configuration_group" */
  update_ConfigurationGroup_many?: Maybe<Array<Maybe<TixConfigurationGroupMutationResponse>>>;
  /** update multiples rows of table: "configuration.configuration_item" */
  update_ConfigurationItem_many?: Maybe<Array<Maybe<TixConfigurationItemMutationResponse>>>;
  /** update single row of the table: "configuration.configuration_value" */
  update_ConfigurationValue_by_pk?: Maybe<TixConfigurationValue>;
  /** update multiples rows of table: "configuration.configuration_value" */
  update_ConfigurationValue_many?: Maybe<Array<Maybe<TixConfigurationValueMutationResponse>>>;
  /** update multiples rows of table: "address.contact_address" */
  update_ContactAddress_many?: Maybe<Array<Maybe<TixContactAddressMutationResponse>>>;
  /** update multiples rows of table: "address.contact_phone_number" */
  update_ContactPhoneNumber_many?: Maybe<Array<Maybe<TixContactPhoneNumberMutationResponse>>>;
  /** update multiples rows of table: "contact.contact" */
  update_Contact_many?: Maybe<Array<Maybe<TixContactMutationResponse>>>;
  update_EmailContent_many?: Maybe<Array<Maybe<TixEmailContentMutationResponse>>>;
  update_EventEmail_many?: Maybe<Array<Maybe<TixEventEmailMutationResponse>>>;
  /** update multiples rows of table: "discount.event_instance_discount" */
  update_EventInstanceDiscount_many?: Maybe<Array<Maybe<TixEventInstanceDiscountMutationResponse>>>;
  /** update multiples rows of table: "media.event_instance_media_file" */
  update_EventInstanceMedialFile_many?: Maybe<Array<Maybe<TixEventInstanceMedialFileMutationResponse>>>;
  /** update multiples rows of table: "media.event_instance_social_media" */
  update_EventInstanceSocialMediaFile_many?: Maybe<Array<Maybe<TixEventInstanceSocialMediaFileMutationResponse>>>;
  /** update multiples rows of table: "ticket.event_instance_ticket_config" */
  update_EventInstanceTicketConfig_many?: Maybe<Array<Maybe<TixEventInstanceTicketConfigMutationResponse>>>;
  /** update multiples rows of table: "ticket.event_instance_ticket" */
  update_EventInstanceTicket_many?: Maybe<Array<Maybe<TixEventInstanceTicketMutationResponse>>>;
  /** update multiples rows of table: "event.event_instance" */
  update_EventInstance_many?: Maybe<Array<Maybe<TixEventInstanceMutationResponse>>>;
  /** update multiples rows of table: "performer.event_lineup" */
  update_EventLineup_many?: Maybe<Array<Maybe<TixEventLineupMutationResponse>>>;
  /** update multiples rows of table: "performer.event_performers" */
  update_EventPerformers_many?: Maybe<Array<Maybe<TixEventPerformersMutationResponse>>>;
  /** update multiples rows of table: "event.event_venue" */
  update_EventVenue_many?: Maybe<Array<Maybe<TixEventVenueMutationResponse>>>;
  /** update multiples rows of table: "event.event" */
  update_Event_many?: Maybe<Array<Maybe<TixEventMutationResponse>>>;
  /** update multiples rows of table: "performer.lineup_performer" */
  update_LineupPerformer_many?: Maybe<Array<Maybe<TixLineupPerformerMutationResponse>>>;
  /** update multiples rows of table: "performer.lineup" */
  update_Lineup_many?: Maybe<Array<Maybe<TixLineupMutationResponse>>>;
  update_Logging?: Maybe<TixLoggingMutationResponse>;
  update_Logging_by_pk?: Maybe<TixLogging>;
  update_Logging_many?: Maybe<Array<Maybe<TixLoggingMutationResponse>>>;
  /** update multiples rows of table: "media.media_file" */
  update_MediaFile_many?: Maybe<Array<Maybe<TixMediaFileMutationResponse>>>;
  /** update multiples rows of table: "notification.notification" */
  update_Notification_many?: Maybe<Array<Maybe<TixNotificationMutationResponse>>>;
  /** update multiples rows of table: "payment.payment" */
  update_Payment_many?: Maybe<Array<Maybe<TixPaymentMutationResponse>>>;
  /** update single row of the table: "payment.payout_connection" */
  update_PayoutConnect_by_pk?: Maybe<TixPayoutConnect>;
  /** update multiples rows of table: "payment.payout_connection" */
  update_PayoutConnect_many?: Maybe<Array<Maybe<TixPayoutConnectMutationResponse>>>;
  /** update data of the table: "payment.payout_detail" */
  update_PayoutDetail?: Maybe<TixPayoutDetailMutationResponse>;
  /** update multiples rows of table: "payment.payout_detail" */
  update_PayoutDetail_many?: Maybe<Array<Maybe<TixPayoutDetailMutationResponse>>>;
  /** update multiples rows of table: "performer.performer" */
  update_Performer_many?: Maybe<Array<Maybe<TixPerformerMutationResponse>>>;
  /** update multiples rows of table: "access.permission" */
  update_Permission_many?: Maybe<Array<Maybe<TixPermissionMutationResponse>>>;
  /** update multiples rows of table: "address.phone_number" */
  update_PhoneNumber_many?: Maybe<Array<Maybe<TixPhoneNumberMutationResponse>>>;
  /** update multiples rows of table: "payment.reservation_payment" */
  update_ReservationPayment_many?: Maybe<Array<Maybe<TixReservationPaymentMutationResponse>>>;
  /** update multiples rows of table: "access.role_permission" */
  update_RolePermission_many?: Maybe<Array<Maybe<TixRolePermissionMutationResponse>>>;
  /** update multiples rows of table: "access.role" */
  update_Role_many?: Maybe<Array<Maybe<TixRoleMutationResponse>>>;
  /** update multiples rows of table: "media.social_media" */
  update_SocialMedia_many?: Maybe<Array<Maybe<TixSocialMediaMutationResponse>>>;
  /** update multiples rows of table: "ticket.ticket_config" */
  update_TicketConfig_many?: Maybe<Array<Maybe<TixTicketConfigMutationResponse>>>;
  update_TicketReservationDetail?: Maybe<TixTicketReservationDetailMutationResponse>;
  update_TicketReservationDetail_by_pk?: Maybe<TixTicketReservationDetail>;
  update_TicketReservationDetail_many?: Maybe<Array<Maybe<TixTicketReservationDetailMutationResponse>>>;
  /** update multiples rows of table: "ticket.ticket" */
  update_Ticket_many?: Maybe<Array<Maybe<TixTicketMutationResponse>>>;
  /** update multiples rows of table: "access.user_role" */
  update_UserRole_many?: Maybe<Array<Maybe<TixUserRoleMutationResponse>>>;
  /** update multiples rows of table: "access.user" */
  update_User_many?: Maybe<Array<Maybe<TixUserMutationResponse>>>;
  /** update multiples rows of table: "address.venue_address" */
  update_VenueAddress_many?: Maybe<Array<Maybe<TixVenueAddressMutationResponse>>>;
  /** update multiples rows of table: "configuration.venue_configuration_value" */
  update_VenueConfigurationValue_many?: Maybe<Array<Maybe<TixVenueConfigurationValueMutationResponse>>>;
  /** update multiples rows of table: "contact.venue_contact" */
  update_VenueContact_many?: Maybe<Array<Maybe<TixVenueContactMutationResponse>>>;
  /** update multiples rows of table: "performer.venue_lineup" */
  update_VenueLineup_many?: Maybe<Array<Maybe<TixVenueLineupMutationResponse>>>;
  /** update multiples rows of table: "media.venue_media_file" */
  update_VenueMediaFile_many?: Maybe<Array<Maybe<TixVenueMediaFileMutationResponse>>>;
  /** update multiples rows of table: "address.venue_phone_number" */
  update_VenuePhoneNumber_many?: Maybe<Array<Maybe<TixVenuePhoneNumberMutationResponse>>>;
  /** update multiples rows of table: "media.venue_social_media" */
  update_VenueSocialMedia_many?: Maybe<Array<Maybe<TixVenueSocialMediaMutationResponse>>>;
  /** update multiples rows of table: "ticket.venue_ticket_config" */
  update_VenueTicketConfig_many?: Maybe<Array<Maybe<TixVenueTicketConfigMutationResponse>>>;
  /** update multiples rows of table: "ticket.venue_ticket" */
  update_VenueTicket_many?: Maybe<Array<Maybe<TixVenueTicketMutationResponse>>>;
  /** update multiples rows of table: "warning.venue_warning" */
  update_VenueWarning_many?: Maybe<Array<Maybe<TixVenueWarningMutationResponse>>>;
  /** update multiples rows of table: "venue.venue" */
  update_Venue_many?: Maybe<Array<Maybe<TixVenueMutationResponse>>>;
  /** update multiples rows of table: "warning.warning" */
  update_Warning_many?: Maybe<Array<Maybe<TixWarningMutationResponse>>>;
  /** update data of the table: "address.performer_phone_number" */
  update_address_performer_phone_number?: Maybe<TixAddressPerformerPhoneNumberMutationResponse>;
  /** update single row of the table: "address.performer_phone_number" */
  update_address_performer_phone_number_by_pk?: Maybe<TixAddressPerformerPhoneNumber>;
  /** update multiples rows of table: "address.performer_phone_number" */
  update_address_performer_phone_number_many?: Maybe<Array<Maybe<TixAddressPerformerPhoneNumberMutationResponse>>>;
  /** update data of the table: "communications.company_email" */
  update_communications_company_email?: Maybe<TixCommunicationsCompanyEmailMutationResponse>;
  /** update multiples rows of table: "communications.company_email" */
  update_communications_company_email_many?: Maybe<Array<Maybe<TixCommunicationsCompanyEmailMutationResponse>>>;
  /** update data of the table: "communications.email_content_variable" */
  update_communications_email_content_variable?: Maybe<TixCommunicationsEmailContentVariableMutationResponse>;
  /** update single row of the table: "communications.email_content_variable" */
  update_communications_email_content_variable_by_pk?: Maybe<TixCommunicationsEmailContentVariable>;
  /** update multiples rows of table: "communications.email_content_variable" */
  update_communications_email_content_variable_many?: Maybe<Array<Maybe<TixCommunicationsEmailContentVariableMutationResponse>>>;
  /** update data of the table: "communications.email_variable" */
  update_communications_email_variable?: Maybe<TixCommunicationsEmailVariableMutationResponse>;
  /** update single row of the table: "communications.email_variable" */
  update_communications_email_variable_by_pk?: Maybe<TixCommunicationsEmailVariable>;
  /** update multiples rows of table: "communications.email_variable" */
  update_communications_email_variable_many?: Maybe<Array<Maybe<TixCommunicationsEmailVariableMutationResponse>>>;
  /** update data of the table: "communications.venue_email" */
  update_communications_venue_email?: Maybe<TixCommunicationsVenueEmailMutationResponse>;
  /** update multiples rows of table: "communications.venue_email" */
  update_communications_venue_email_many?: Maybe<Array<Maybe<TixCommunicationsVenueEmailMutationResponse>>>;
  /** update data of the table: "event.campaign_tracking" */
  update_event_campaign_tracking?: Maybe<TixEventCampaignTrackingMutationResponse>;
  /** update single row of the table: "event.campaign_tracking" */
  update_event_campaign_tracking_by_pk?: Maybe<TixEventCampaignTracking>;
  /** update multiples rows of table: "event.campaign_tracking" */
  update_event_campaign_tracking_many?: Maybe<Array<Maybe<TixEventCampaignTrackingMutationResponse>>>;
  /** update data of the table: "notification.contact_notification" */
  update_notification_contact_notification?: Maybe<TixNotificationContactNotificationMutationResponse>;
  /** update single row of the table: "notification.contact_notification" */
  update_notification_contact_notification_by_pk?: Maybe<TixNotificationContactNotification>;
  /** update multiples rows of table: "notification.contact_notification" */
  update_notification_contact_notification_many?: Maybe<Array<Maybe<TixNotificationContactNotificationMutationResponse>>>;
  /** update data of the table: "product.order_detail" */
  update_product_order_detail?: Maybe<TixProductOrderDetailMutationResponse>;
  /** update single row of the table: "product.order_detail" */
  update_product_order_detail_by_pk?: Maybe<TixProductOrderDetail>;
  /** update multiples rows of table: "product.order_detail" */
  update_product_order_detail_many?: Maybe<Array<Maybe<TixProductOrderDetailMutationResponse>>>;
  update_reservationReport_by_pk?: Maybe<TixReservationReport>;
  update_reservationReport_many?: Maybe<Array<Maybe<TixReservationReportMutationResponse>>>;
  /** update data of the table: "reporting.saved_report" */
  update_savedReport?: Maybe<TixSavedReportMutationResponse>;
  /** update data of the table: "reporting.saved_report_events" */
  update_savedReportEvents?: Maybe<TixSavedReportEventsMutationResponse>;
  /** update single row of the table: "reporting.saved_report_events" */
  update_savedReportEvents_by_pk?: Maybe<TixSavedReportEvents>;
  /** update multiples rows of table: "reporting.saved_report_events" */
  update_savedReportEvents_many?: Maybe<Array<Maybe<TixSavedReportEventsMutationResponse>>>;
  /** update data of the table: "reporting.saved_report_layout" */
  update_savedReportLayout?: Maybe<TixSavedReportLayoutMutationResponse>;
  /** update single row of the table: "reporting.saved_report_layout" */
  update_savedReportLayout_by_pk?: Maybe<TixSavedReportLayout>;
  /** update multiples rows of table: "reporting.saved_report_layout" */
  update_savedReportLayout_many?: Maybe<Array<Maybe<TixSavedReportLayoutMutationResponse>>>;
  /** update single row of the table: "reporting.saved_report" */
  update_savedReport_by_pk?: Maybe<TixSavedReport>;
  /** update multiples rows of table: "reporting.saved_report" */
  update_savedReport_many?: Maybe<Array<Maybe<TixSavedReportMutationResponse>>>;
  /** update data of the table: "reporting.scheduled_report" */
  update_scheduledReport?: Maybe<TixScheduledReportMutationResponse>;
  /** update data of the table: "reporting.scheduled_report_email" */
  update_scheduledReportEmail?: Maybe<TixScheduledReportEmailMutationResponse>;
  /** update single row of the table: "reporting.scheduled_report_email" */
  update_scheduledReportEmail_by_pk?: Maybe<TixScheduledReportEmail>;
  /** update multiples rows of table: "reporting.scheduled_report_email" */
  update_scheduledReportEmail_many?: Maybe<Array<Maybe<TixScheduledReportEmailMutationResponse>>>;
  /** update single row of the table: "reporting.scheduled_report" */
  update_scheduledReport_by_pk?: Maybe<TixScheduledReport>;
  /** update multiples rows of table: "reporting.scheduled_report" */
  update_scheduledReport_many?: Maybe<Array<Maybe<TixScheduledReportMutationResponse>>>;
  /** update data of the table: "ticket.exchange" */
  update_ticket_exchange?: Maybe<TixTicketExchangeMutationResponse>;
  /** update single row of the table: "ticket.exchange" */
  update_ticket_exchange_by_pk?: Maybe<TixTicketExchange>;
  /** update multiples rows of table: "ticket.exchange" */
  update_ticket_exchange_many?: Maybe<Array<Maybe<TixTicketExchangeMutationResponse>>>;
  /** update multiples rows of table: "ticket.reservation" */
  update_ticket_reservation_many?: Maybe<Array<Maybe<TixTicketReservationMutationResponse>>>;
  /** update data of the table: "ticket.ticket_discount" */
  update_ticket_ticket_discount?: Maybe<TixTicketTicketDiscountMutationResponse>;
  /** update single row of the table: "ticket.ticket_discount" */
  update_ticket_ticket_discount_by_pk?: Maybe<TixTicketTicketDiscount>;
  /** update multiples rows of table: "ticket.ticket_discount" */
  update_ticket_ticket_discount_many?: Maybe<Array<Maybe<TixTicketTicketDiscountMutationResponse>>>;
  /** update data of the table: "utility.policy" */
  update_utility_policy?: Maybe<TixUtilityPolicyMutationResponse>;
  /** update single row of the table: "utility.policy" */
  update_utility_policy_by_pk?: Maybe<TixUtilityPolicy>;
  /** update multiples rows of table: "utility.policy" */
  update_utility_policy_many?: Maybe<Array<Maybe<TixUtilityPolicyMutationResponse>>>;
  uploadMedia: TixGraphQlUploadResult;
};


/** mutation root */
export type TixMutationRootCustomerDeleteArgs = {
  where: TixCustomerBoolExp;
};


/** mutation root */
export type TixMutationRootCustomerDeleteByPkArgs = {
  customerId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootCustomerInsertArgs = {
  objects: Array<TixCustomerInsertInput>;
  on_conflict?: InputMaybe<TixCustomerOnConflict>;
};


/** mutation root */
export type TixMutationRootCustomerInsertOneArgs = {
  object: TixCustomerInsertInput;
  on_conflict?: InputMaybe<TixCustomerOnConflict>;
};


/** mutation root */
export type TixMutationRootCustomerUpdateArgs = {
  _set?: InputMaybe<TixCustomerSetInput>;
  where: TixCustomerBoolExp;
};


/** mutation root */
export type TixMutationRootCustomerUpdateByPkArgs = {
  _set?: InputMaybe<TixCustomerSetInput>;
  pk_columns: TixCustomerPkColumnsInput;
};


/** mutation root */
export type TixMutationRootCustomerUpdateManyArgs = {
  updates: Array<TixCustomerUpdates>;
};


/** mutation root */
export type TixMutationRootDeleteAddressArgs = {
  where: TixAddressBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteAddressByPkArgs = {
  addressId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteBusinessCodeGroupArgs = {
  where: TixBusinessCodeGroupBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteBusinessCodeGroupByPkArgs = {
  busCodeGroupId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteBusinessCodesArgs = {
  where: TixBusinessCodesBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteBusinessCodesByPkArgs = {
  businessCodeId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCompanyArgs = {
  where: TixCompanyBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanyAddressArgs = {
  where: TixCompanyAddressBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanyAddressByPkArgs = {
  companyAddressId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCompanyConfigurationValueArgs = {
  where: TixCompanyConfigurationValueBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanyContactArgs = {
  where: TixCompanyContactBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanyContactByPkArgs = {
  companyContactId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCompanyMediaFileArgs = {
  where: TixCompanyMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanyMediaFileByPkArgs = {
  companyImageFileId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCompanyPhoneNumberArgs = {
  where: TixCompanyPhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanyPhoneNumberByPkArgs = {
  companyPhoneNumberId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCompanySocialMediaArgs = {
  where: TixCompanySocialMediaBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanySocialMediaByPkArgs = {
  companySocialMediaId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCompanyWarningArgs = {
  where: TixCompanyWarningBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanyWarningByPkArgs = {
  companyWarningId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteConfigurationGroupArgs = {
  where: TixConfigurationGroupBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteConfigurationGroupByPkArgs = {
  configurationGroupId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteConfigurationGroupItemArgs = {
  where: TixConfigurationGroupItemBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteConfigurationItemArgs = {
  where: TixConfigurationItemBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteConfigurationItemByPkArgs = {
  configurationItemId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteConfigurationValueArgs = {
  where: TixConfigurationValueBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteContactArgs = {
  where: TixContactBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteContactAddressArgs = {
  where: TixContactAddressBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteContactAddressByPkArgs = {
  contactAddressId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteContactByPkArgs = {
  contactId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteContactPhoneNumberArgs = {
  where: TixContactPhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteContactPhoneNumberByPkArgs = {
  contactPhoneNumberId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteDiscountArgs = {
  where: TixDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteDiscountByPkArgs = {
  discountId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventArgs = {
  where: TixEventBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventByPkArgs = {
  eventId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceArgs = {
  where: TixEventInstanceBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceByPkArgs = {
  eventInstanceId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceConfigurationValueArgs = {
  where: TixEventInstanceConfigurationValueBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceConfigurationValueByPkArgs = {
  eventInstanceConfigurationId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceDiscountArgs = {
  where: TixEventInstanceDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceDiscountByPkArgs = {
  eventInstanceDiscountId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceMedialFileArgs = {
  where: TixEventInstanceMedialFileBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceMedialFileByPkArgs = {
  eventMediaId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceSocialMediaFileArgs = {
  where: TixEventInstanceSocialMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceSocialMediaFileByPkArgs = {
  eventSocialMediaId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceTicketArgs = {
  where: TixEventInstanceTicketBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceTicketByPkArgs = {
  eventInstanceTicketId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceTicketConfigArgs = {
  where: TixEventInstanceTicketConfigBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventInstanceTicketConfigByPkArgs = {
  eventInstanceTicketConfigId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventLineupArgs = {
  where: TixEventLineupBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventLineupByPkArgs = {
  event_lineup_id: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventPerformersArgs = {
  where: TixEventPerformersBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventPerformersByPkArgs = {
  eventPerformerId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventVenueArgs = {
  where: TixEventVenueBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventVenueByPkArgs = {
  eventVenueId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteLineupArgs = {
  where: TixLineupBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteLineupByPkArgs = {
  lineupId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteLineupPerformerArgs = {
  where: TixLineupPerformerBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteLineupPerformerByPkArgs = {
  lineupPerformerId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteMediaFileArgs = {
  where: TixMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteMediaFileByPkArgs = {
  mediaFileId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteNotificationArgs = {
  where: TixNotificationBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteNotificationByPkArgs = {
  notificationId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePaymentArgs = {
  where: TixPaymentBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePaymentByPkArgs = {
  paymentId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePaymentDiscountArgs = {
  where: TixPaymentDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePaymentDiscountByPkArgs = {
  paymentDiscountId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePaymentVendorLogArgs = {
  where: TixPaymentVendorLogBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePaymentVendorLogByPkArgs = {
  vendorPaymentLogId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePayoutArgs = {
  where: TixPayoutBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePayoutByPkArgs = {
  payoutId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePerformerArgs = {
  where: TixPerformerBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePerformerByPkArgs = {
  performerId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePermissionArgs = {
  where: TixPermissionBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePermissionByPkArgs = {
  permissionId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePhoneNumberArgs = {
  where: TixPhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePhoneNumberByPkArgs = {
  phoneNumberId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteReservationArgs = {
  where: TixTicketReservationBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteReservationByPkArgs = {
  reservationId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteReservationPaymentArgs = {
  where: TixReservationPaymentBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteReservationPaymentByPkArgs = {
  reservationPaymentId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteRoleArgs = {
  where: TixRoleBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteRoleByPkArgs = {
  roleId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteRolePermissionArgs = {
  where: TixRolePermissionBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteRolePermissionByPkArgs = {
  rolePermissionId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteSocialMediaArgs = {
  where: TixSocialMediaBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteSocialMediaByPkArgs = {
  socialMediaId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteTicketArgs = {
  where: TixTicketBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteTicketByPkArgs = {
  ticketId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteTicketConfigArgs = {
  where: TixTicketConfigBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteTicketConfigByPkArgs = {
  ticketConfigId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteUserArgs = {
  where: TixUserBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteUserByPkArgs = {
  userId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteUserRoleArgs = {
  where: TixUserRoleBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteUserRoleByPkArgs = {
  userRoleId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueArgs = {
  where: TixVenueBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueAddressArgs = {
  where: TixVenueAddressBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueAddressByIdArgs = {
  venueAddressId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueByPkArgs = {
  venueId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueConfigurationValueArgs = {
  where: TixVenueConfigurationValueBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueConfigurationValueByPkArgs = {
  venueConfigurationValueId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueContactArgs = {
  where: TixVenueContactBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueContactByPkArgs = {
  venueContactId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueDiscountArgs = {
  where: TixVenueDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueDiscountByPkArgs = {
  venueDiscountId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueLineupArgs = {
  where: TixVenueLineupBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueLineupByPkArgs = {
  venueLineupId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueMediaFileArgs = {
  where: TixVenueMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueMediaFileByPkArgs = {
  venueImageFileId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenuePhoneNumberArgs = {
  where: TixVenuePhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenuePhoneNumberByPkArgs = {
  venuePhoneNumberId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueSocialMediaArgs = {
  where: TixVenueSocialMediaBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueSocialMediaByPkArgs = {
  venueSocialMediaId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueTicketArgs = {
  where: TixVenueTicketBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueTicketByPkArgs = {
  venueTicketId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueTicketConfigArgs = {
  where: TixVenueTicketConfigBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueTicketConfigByPkArgs = {
  venueTicketConfig: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteVenueWarningArgs = {
  where: TixVenueWarningBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteVenueWarningByPkArgs = {
  venueWarningId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteWarningArgs = {
  where: TixWarningBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteWarningByPkArgs = {
  warningId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootEmailContentInsertArgs = {
  objects: Array<TixEmailContentInsertInput>;
  on_conflict?: InputMaybe<TixEmailContentOnConflict>;
};


/** mutation root */
export type TixMutationRootEmailContentInsertOneArgs = {
  object: TixEmailContentInsertInput;
  on_conflict?: InputMaybe<TixEmailContentOnConflict>;
};


/** mutation root */
export type TixMutationRootEmailContentUpdateArgs = {
  _set?: InputMaybe<TixEmailContentSetInput>;
  where: TixEmailContentBoolExp;
};


/** mutation root */
export type TixMutationRootEmailContentUpdateByPkArgs = {
  _set?: InputMaybe<TixEmailContentSetInput>;
  pk_columns: TixEmailContentPkColumnsInput;
};


/** mutation root */
export type TixMutationRootEventEmailInsertArgs = {
  objects: Array<TixEventEmailInsertInput>;
};


/** mutation root */
export type TixMutationRootEventEmailInsertOneArgs = {
  object: TixEventEmailInsertInput;
};


/** mutation root */
export type TixMutationRootEventEmailUpdateArgs = {
  _set?: InputMaybe<TixEventEmailSetInput>;
  where: TixEventEmailBoolExp;
};


/** mutation root */
export type TixMutationRootEventProductDeleteArgs = {
  where: TixEventProductBoolExp;
};


/** mutation root */
export type TixMutationRootEventProductDeleteByPkArgs = {
  eventProductId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootEventProductInsertArgs = {
  objects: Array<TixEventProductInsertInput>;
  on_conflict?: InputMaybe<TixEventProductOnConflict>;
};


/** mutation root */
export type TixMutationRootEventProductInsertOneArgs = {
  object: TixEventProductInsertInput;
  on_conflict?: InputMaybe<TixEventProductOnConflict>;
};


/** mutation root */
export type TixMutationRootEventProductMediaDeleteArgs = {
  where: TixEventProductMediaBoolExp;
};


/** mutation root */
export type TixMutationRootEventProductMediaDeleteByPkArgs = {
  eventProductMediaImageFileId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootEventProductMediaInsertArgs = {
  objects: Array<TixEventProductMediaInsertInput>;
  on_conflict?: InputMaybe<TixEventProductMediaOnConflict>;
};


/** mutation root */
export type TixMutationRootEventProductMediaInsertOneArgs = {
  object: TixEventProductMediaInsertInput;
  on_conflict?: InputMaybe<TixEventProductMediaOnConflict>;
};


/** mutation root */
export type TixMutationRootEventProductMediaUpdateArgs = {
  _set?: InputMaybe<TixEventProductMediaSetInput>;
  where: TixEventProductMediaBoolExp;
};


/** mutation root */
export type TixMutationRootEventProductMediaUpdateByPkArgs = {
  _set?: InputMaybe<TixEventProductMediaSetInput>;
  pk_columns: TixEventProductMediaPkColumnsInput;
};


/** mutation root */
export type TixMutationRootEventProductMediaUpdateManyArgs = {
  updates: Array<TixEventProductMediaUpdates>;
};


/** mutation root */
export type TixMutationRootEventProductUpdateArgs = {
  _inc?: InputMaybe<TixEventProductIncInput>;
  _set?: InputMaybe<TixEventProductSetInput>;
  where: TixEventProductBoolExp;
};


/** mutation root */
export type TixMutationRootEventProductUpdateByPkArgs = {
  _inc?: InputMaybe<TixEventProductIncInput>;
  _set?: InputMaybe<TixEventProductSetInput>;
  pk_columns: TixEventProductPkColumnsInput;
};


/** mutation root */
export type TixMutationRootEventProductUpdateManyArgs = {
  updates: Array<TixEventProductUpdates>;
};


/** mutation root */
export type TixMutationRootInserVenueWarningArgs = {
  objects: Array<TixVenueWarningInsertInput>;
  on_conflict?: InputMaybe<TixVenueWarningOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertArgs = {
  objects: Array<TixLoggingInsertInput>;
  on_conflict?: InputMaybe<TixLoggingOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertAddressArgs = {
  objects: Array<TixAddressInsertInput>;
  on_conflict?: InputMaybe<TixAddressOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertAddressOneArgs = {
  object: TixAddressInsertInput;
  on_conflict?: InputMaybe<TixAddressOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertBusinessCodeGroupArgs = {
  objects: Array<TixBusinessCodeGroupInsertInput>;
  on_conflict?: InputMaybe<TixBusinessCodeGroupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertBusinessCodeGroupOneArgs = {
  object: TixBusinessCodeGroupInsertInput;
  on_conflict?: InputMaybe<TixBusinessCodeGroupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertBusinessCodesArgs = {
  objects: Array<TixBusinessCodesInsertInput>;
  on_conflict?: InputMaybe<TixBusinessCodesOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertBusinessCodesOneArgs = {
  object: TixBusinessCodesInsertInput;
  on_conflict?: InputMaybe<TixBusinessCodesOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyArgs = {
  objects: Array<TixCompanyInsertInput>;
  on_conflict?: InputMaybe<TixCompanyOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyAddressArgs = {
  objects: Array<TixCompanyAddressInsertInput>;
  on_conflict?: InputMaybe<TixCompanyAddressOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyAddressOneArgs = {
  object: TixCompanyAddressInsertInput;
  on_conflict?: InputMaybe<TixCompanyAddressOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyConfigurationValueArgs = {
  objects: Array<TixCompanyConfigurationValueInsertInput>;
  on_conflict?: InputMaybe<TixCompanyConfigurationValueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyContactArgs = {
  objects: Array<TixCompanyContactInsertInput>;
  on_conflict?: InputMaybe<TixCompanyContactOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyContactOneArgs = {
  object: TixCompanyContactInsertInput;
  on_conflict?: InputMaybe<TixCompanyContactOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyMediaFileArgs = {
  objects: Array<TixCompanyMediaFileInsertInput>;
  on_conflict?: InputMaybe<TixCompanyMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyMediaFileOneArgs = {
  object: TixCompanyMediaFileInsertInput;
  on_conflict?: InputMaybe<TixCompanyMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyPhoneNumberArgs = {
  objects: Array<TixCompanyPhoneNumberInsertInput>;
  on_conflict?: InputMaybe<TixCompanyPhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyPhoneNumberOneArgs = {
  object: TixCompanyPhoneNumberInsertInput;
  on_conflict?: InputMaybe<TixCompanyPhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanySocialMediaArgs = {
  objects: Array<TixCompanySocialMediaInsertInput>;
  on_conflict?: InputMaybe<TixCompanySocialMediaOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanySocialMediaOneArgs = {
  object: TixCompanySocialMediaInsertInput;
  on_conflict?: InputMaybe<TixCompanySocialMediaOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyWarningArgs = {
  objects: Array<TixCompanyWarningInsertInput>;
  on_conflict?: InputMaybe<TixCompanyWarningOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCompanyWarningOneArgs = {
  object: TixCompanyWarningInsertInput;
  on_conflict?: InputMaybe<TixCompanyWarningOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertConfigurationGroupArgs = {
  objects: Array<TixConfigurationGroupInsertInput>;
  on_conflict?: InputMaybe<TixConfigurationGroupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertConfigurationGroupItemArgs = {
  objects: Array<TixConfigurationGroupItemInsertInput>;
  on_conflict?: InputMaybe<TixConfigurationGroupItemOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertConfigurationGroupOneArgs = {
  object: TixConfigurationGroupInsertInput;
  on_conflict?: InputMaybe<TixConfigurationGroupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertConfigurationItemArgs = {
  objects: Array<TixConfigurationItemInsertInput>;
  on_conflict?: InputMaybe<TixConfigurationItemOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertConfigurationItemOneArgs = {
  object: TixConfigurationItemInsertInput;
  on_conflict?: InputMaybe<TixConfigurationItemOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertConfigurationValueArgs = {
  objects: Array<TixConfigurationValueInsertInput>;
  on_conflict?: InputMaybe<TixConfigurationValueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertContactArgs = {
  objects: Array<TixContactInsertInput>;
  on_conflict?: InputMaybe<TixContactOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertContactAddressArgs = {
  objects: Array<TixContactAddressInsertInput>;
  on_conflict?: InputMaybe<TixContactAddressOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertContactOneArgs = {
  object: TixContactInsertInput;
  on_conflict?: InputMaybe<TixContactOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertContactPhoneNumberArgs = {
  objects: Array<TixContactPhoneNumberInsertInput>;
  on_conflict?: InputMaybe<TixContactPhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertContactPhoneNumberOneArgs = {
  object: TixContactPhoneNumberInsertInput;
  on_conflict?: InputMaybe<TixContactPhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertDiscountArgs = {
  objects: Array<TixDiscountInsertInput>;
  on_conflict?: InputMaybe<TixDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertDiscountOneArgs = {
  object: TixDiscountInsertInput;
  on_conflict?: InputMaybe<TixDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventArgs = {
  objects: Array<TixEventInsertInput>;
  on_conflict?: InputMaybe<TixEventOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceArgs = {
  objects: Array<TixEventInstanceInsertInput>;
  on_conflict?: InputMaybe<TixEventInstanceOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceConfigurationValueArgs = {
  objects: Array<TixEventInstanceConfigurationValueInsertInput>;
  on_conflict?: InputMaybe<TixEventInstanceConfigurationValueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceDiscountArgs = {
  objects: Array<TixEventInstanceDiscountInsertInput>;
  on_conflict?: InputMaybe<TixEventInstanceDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceMedialFileArgs = {
  objects: Array<TixEventInstanceMedialFileInsertInput>;
  on_conflict?: InputMaybe<TixEventInstanceMedialFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceMedialFileOneArgs = {
  object: TixEventInstanceMedialFileInsertInput;
  on_conflict?: InputMaybe<TixEventInstanceMedialFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceOneArgs = {
  object: TixEventInstanceInsertInput;
  on_conflict?: InputMaybe<TixEventInstanceOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceSocialMediaFileArgs = {
  objects: Array<TixEventInstanceSocialMediaFileInsertInput>;
  on_conflict?: InputMaybe<TixEventInstanceSocialMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceSocialMediaFileOneArgs = {
  object: TixEventInstanceSocialMediaFileInsertInput;
  on_conflict?: InputMaybe<TixEventInstanceSocialMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceTicketArgs = {
  objects: Array<TixEventInstanceTicketInsertInput>;
  on_conflict?: InputMaybe<TixEventInstanceTicketOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceTicketConfigArgs = {
  objects: Array<TixEventInstanceTicketConfigInsertInput>;
  on_conflict?: InputMaybe<TixEventInstanceTicketConfigOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceTicketConfigOneArgs = {
  object: TixEventInstanceTicketConfigInsertInput;
  on_conflict?: InputMaybe<TixEventInstanceTicketConfigOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventInstanceTicketOneArgs = {
  object: TixEventInstanceTicketInsertInput;
  on_conflict?: InputMaybe<TixEventInstanceTicketOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventLineupArgs = {
  objects: Array<TixEventLineupInsertInput>;
  on_conflict?: InputMaybe<TixEventLineupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventOneArgs = {
  object: TixEventInsertInput;
  on_conflict?: InputMaybe<TixEventOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventPerformersArgs = {
  objects: Array<TixEventPerformersInsertInput>;
  on_conflict?: InputMaybe<TixEventPerformersOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventPerformersOneArgs = {
  object: TixEventPerformersInsertInput;
  on_conflict?: InputMaybe<TixEventPerformersOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventVenueArgs = {
  objects: Array<TixEventVenueInsertInput>;
  on_conflict?: InputMaybe<TixEventVenueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventVenueOneArgs = {
  object: TixEventVenueInsertInput;
  on_conflict?: InputMaybe<TixEventVenueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertLineupArgs = {
  objects: Array<TixLineupInsertInput>;
  on_conflict?: InputMaybe<TixLineupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertLineupPerformerArgs = {
  objects: Array<TixLineupPerformerInsertInput>;
  on_conflict?: InputMaybe<TixLineupPerformerOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertMediaFileArgs = {
  objects: Array<TixMediaFileInsertInput>;
  on_conflict?: InputMaybe<TixMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertNotificationArgs = {
  objects: Array<TixNotificationInsertInput>;
  on_conflict?: InputMaybe<TixNotificationOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertNotificationOneArgs = {
  object: TixNotificationInsertInput;
  on_conflict?: InputMaybe<TixNotificationOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneContactAddressArgs = {
  object: TixContactAddressInsertInput;
  on_conflict?: InputMaybe<TixContactAddressOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneEventInstanceConfigurationValueArgs = {
  object: TixEventInstanceConfigurationValueInsertInput;
  on_conflict?: InputMaybe<TixEventInstanceConfigurationValueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneEventInstanceDiscountArgs = {
  object: TixEventInstanceDiscountInsertInput;
  on_conflict?: InputMaybe<TixEventInstanceDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneEventLineupArgs = {
  object: TixEventLineupInsertInput;
  on_conflict?: InputMaybe<TixEventLineupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneLineupArgs = {
  object: TixLineupInsertInput;
  on_conflict?: InputMaybe<TixLineupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneLineupPerformerArgs = {
  object: TixLineupPerformerInsertInput;
  on_conflict?: InputMaybe<TixLineupPerformerOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneMediaFileArgs = {
  object: TixMediaFileInsertInput;
  on_conflict?: InputMaybe<TixMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOnePaymentArgs = {
  object: TixPaymentInsertInput;
  on_conflict?: InputMaybe<TixPaymentOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOnePaymentDiscountArgs = {
  object: TixPaymentDiscountInsertInput;
  on_conflict?: InputMaybe<TixPaymentDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOnePayoutArgs = {
  object: TixPayoutInsertInput;
  on_conflict?: InputMaybe<TixPayoutOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOnePerformerArgs = {
  object: TixPerformerInsertInput;
  on_conflict?: InputMaybe<TixPerformerOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOnePermissionArgs = {
  object: TixPermissionInsertInput;
  on_conflict?: InputMaybe<TixPermissionOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneReservationPaymentArgs = {
  object: TixReservationPaymentInsertInput;
  on_conflict?: InputMaybe<TixReservationPaymentOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneRoleArgs = {
  object: TixRoleInsertInput;
  on_conflict?: InputMaybe<TixRoleOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneRolePermissionArgs = {
  object: TixRolePermissionInsertInput;
  on_conflict?: InputMaybe<TixRolePermissionOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneTicketConfigArgs = {
  object: TixTicketConfigInsertInput;
  on_conflict?: InputMaybe<TixTicketConfigOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneUserRoleArgs = {
  object: TixUserRoleInsertInput;
  on_conflict?: InputMaybe<TixUserRoleOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneVenueLineupArgs = {
  object: TixVenueLineupInsertInput;
  on_conflict?: InputMaybe<TixVenueLineupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneVenueTicketArgs = {
  object: TixVenueTicketInsertInput;
  on_conflict?: InputMaybe<TixVenueTicketOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertOneVenueTicketConfigArgs = {
  object: TixVenueTicketConfigInsertInput;
  on_conflict?: InputMaybe<TixVenueTicketConfigOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPaymentArgs = {
  objects: Array<TixPaymentInsertInput>;
  on_conflict?: InputMaybe<TixPaymentOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPaymentDiscountArgs = {
  objects: Array<TixPaymentDiscountInsertInput>;
  on_conflict?: InputMaybe<TixPaymentDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPaymentVendorLogArgs = {
  objects: Array<TixPaymentVendorLogInsertInput>;
  on_conflict?: InputMaybe<TixPaymentVendorLogOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPaymentVendorLogOneArgs = {
  object: TixPaymentVendorLogInsertInput;
  on_conflict?: InputMaybe<TixPaymentVendorLogOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPayoutArgs = {
  objects: Array<TixPayoutInsertInput>;
  on_conflict?: InputMaybe<TixPayoutOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPayoutDetailArgs = {
  objects: Array<TixPayoutDetailInsertInput>;
  on_conflict?: InputMaybe<TixPayoutDetailOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPerformerArgs = {
  objects: Array<TixPerformerInsertInput>;
  on_conflict?: InputMaybe<TixPerformerOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPermissionArgs = {
  objects: Array<TixPermissionInsertInput>;
  on_conflict?: InputMaybe<TixPermissionOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPhoneNumberArgs = {
  objects: Array<TixPhoneNumberInsertInput>;
  on_conflict?: InputMaybe<TixPhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPhoneNumberOneArgs = {
  object: TixPhoneNumberInsertInput;
  on_conflict?: InputMaybe<TixPhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertReservationArgs = {
  objects: Array<TixTicketReservationInsertInput>;
  on_conflict?: InputMaybe<TixTicketReservationOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertReservationOneArgs = {
  object: TixTicketReservationInsertInput;
  on_conflict?: InputMaybe<TixTicketReservationOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertReservationPaymentArgs = {
  objects: Array<TixReservationPaymentInsertInput>;
  on_conflict?: InputMaybe<TixReservationPaymentOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertRoleArgs = {
  objects: Array<TixRoleInsertInput>;
  on_conflict?: InputMaybe<TixRoleOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertRolePermissionArgs = {
  objects: Array<TixRolePermissionInsertInput>;
  on_conflict?: InputMaybe<TixRolePermissionOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertSocialMediaArgs = {
  objects: Array<TixSocialMediaInsertInput>;
  on_conflict?: InputMaybe<TixSocialMediaOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertSocialMediaOneArgs = {
  object: TixSocialMediaInsertInput;
  on_conflict?: InputMaybe<TixSocialMediaOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertTicketArgs = {
  objects: Array<TixTicketInsertInput>;
  on_conflict?: InputMaybe<TixTicketOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertTicketConfigArgs = {
  objects: Array<TixTicketConfigInsertInput>;
  on_conflict?: InputMaybe<TixTicketConfigOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertTicketOneArgs = {
  object: TixTicketInsertInput;
  on_conflict?: InputMaybe<TixTicketOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertUserArgs = {
  objects: Array<TixUserInsertInput>;
  on_conflict?: InputMaybe<TixUserOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertUserOneArgs = {
  object: TixUserInsertInput;
  on_conflict?: InputMaybe<TixUserOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertUserRoleArgs = {
  objects: Array<TixUserRoleInsertInput>;
  on_conflict?: InputMaybe<TixUserRoleOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueArgs = {
  objects: Array<TixVenueInsertInput>;
  on_conflict?: InputMaybe<TixVenueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueAddressArgs = {
  objects: Array<TixVenueAddressInsertInput>;
  on_conflict?: InputMaybe<TixVenueAddressOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueAddressOneArgs = {
  object: TixVenueAddressInsertInput;
  on_conflict?: InputMaybe<TixVenueAddressOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueConfigurationValueArgs = {
  objects: Array<TixVenueConfigurationValueInsertInput>;
  on_conflict?: InputMaybe<TixVenueConfigurationValueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueConfigurationValueOneArgs = {
  object: TixVenueConfigurationValueInsertInput;
  on_conflict?: InputMaybe<TixVenueConfigurationValueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueContactArgs = {
  objects: Array<TixVenueContactInsertInput>;
  on_conflict?: InputMaybe<TixVenueContactOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueContactOneArgs = {
  object: TixVenueContactInsertInput;
  on_conflict?: InputMaybe<TixVenueContactOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueDiscountArgs = {
  objects: Array<TixVenueDiscountInsertInput>;
  on_conflict?: InputMaybe<TixVenueDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueDiscountOneArgs = {
  object: TixVenueDiscountInsertInput;
  on_conflict?: InputMaybe<TixVenueDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueLineupArgs = {
  objects: Array<TixVenueLineupInsertInput>;
  on_conflict?: InputMaybe<TixVenueLineupOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueMediaFileArgs = {
  objects: Array<TixVenueMediaFileInsertInput>;
  on_conflict?: InputMaybe<TixVenueMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueMediaFileOneArgs = {
  object: TixVenueMediaFileInsertInput;
  on_conflict?: InputMaybe<TixVenueMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueOneArgs = {
  object: TixVenueInsertInput;
  on_conflict?: InputMaybe<TixVenueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenuePhoneNumberArgs = {
  objects: Array<TixVenuePhoneNumberInsertInput>;
  on_conflict?: InputMaybe<TixVenuePhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenuePhoneNumberOneArgs = {
  object: TixVenuePhoneNumberInsertInput;
  on_conflict?: InputMaybe<TixVenuePhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueSocialMediaArgs = {
  objects: Array<TixVenueSocialMediaInsertInput>;
  on_conflict?: InputMaybe<TixVenueSocialMediaOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueSocialMediaOneArgs = {
  object: TixVenueSocialMediaInsertInput;
  on_conflict?: InputMaybe<TixVenueSocialMediaOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueTicketArgs = {
  objects: Array<TixVenueTicketInsertInput>;
  on_conflict?: InputMaybe<TixVenueTicketOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueTicketConfigArgs = {
  objects: Array<TixVenueTicketConfigInsertInput>;
  on_conflict?: InputMaybe<TixVenueTicketConfigOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertVenueWarningOneArgs = {
  object: TixVenueWarningInsertInput;
  on_conflict?: InputMaybe<TixVenueWarningOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertWarningArgs = {
  objects: Array<TixWarningInsertInput>;
  on_conflict?: InputMaybe<TixWarningOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertWarningOneArgs = {
  object: TixWarningInsertInput;
  on_conflict?: InputMaybe<TixWarningOnConflict>;
};


/** mutation root */
export type TixMutationRootLoggingInsertOneArgs = {
  object: TixLoggingInsertInput;
  on_conflict?: InputMaybe<TixLoggingOnConflict>;
};


/** mutation root */
export type TixMutationRootOrderDeleteArgs = {
  where: TixOrderBoolExp;
};


/** mutation root */
export type TixMutationRootOrderDeleteByPkArgs = {
  orderId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootOrderInsertArgs = {
  objects: Array<TixOrderInsertInput>;
  on_conflict?: InputMaybe<TixOrderOnConflict>;
};


/** mutation root */
export type TixMutationRootOrderInsertOneArgs = {
  object: TixOrderInsertInput;
  on_conflict?: InputMaybe<TixOrderOnConflict>;
};


/** mutation root */
export type TixMutationRootOrderUpdateArgs = {
  _set?: InputMaybe<TixOrderSetInput>;
  where: TixOrderBoolExp;
};


/** mutation root */
export type TixMutationRootOrderUpdateByPkArgs = {
  _set?: InputMaybe<TixOrderSetInput>;
  pk_columns: TixOrderPkColumnsInput;
};


/** mutation root */
export type TixMutationRootOrderUpdateManyArgs = {
  updates: Array<TixOrderUpdates>;
};


/** mutation root */
export type TixMutationRootPayoutConnectInsertOneArgs = {
  object: TixPayoutConnectInsertInput;
  on_conflict?: InputMaybe<TixPayoutConnectOnConflict>;
};


/** mutation root */
export type TixMutationRootPayoutConnectUpdateArgs = {
  _set?: InputMaybe<TixPayoutConnectSetInput>;
  where: TixPayoutConnectBoolExp;
};


/** mutation root */
export type TixMutationRootProductDeleteArgs = {
  where: TixProductBoolExp;
};


/** mutation root */
export type TixMutationRootProductDeleteByPkArgs = {
  productId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootProductInsertArgs = {
  objects: Array<TixProductInsertInput>;
  on_conflict?: InputMaybe<TixProductOnConflict>;
};


/** mutation root */
export type TixMutationRootProductInsertOneArgs = {
  object: TixProductInsertInput;
  on_conflict?: InputMaybe<TixProductOnConflict>;
};


/** mutation root */
export type TixMutationRootProductMediaFileDeleteArgs = {
  where: TixProductMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootProductMediaFileDeleteByPkArgs = {
  productMediaImageFileId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootProductMediaFileInsertArgs = {
  objects: Array<TixProductMediaFileInsertInput>;
  on_conflict?: InputMaybe<TixProductMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootProductMediaFileInsertOneArgs = {
  object: TixProductMediaFileInsertInput;
  on_conflict?: InputMaybe<TixProductMediaFileOnConflict>;
};


/** mutation root */
export type TixMutationRootProductMediaFileUpdateArgs = {
  _set?: InputMaybe<TixProductMediaFileSetInput>;
  where: TixProductMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootProductMediaFileUpdateByPkArgs = {
  _set?: InputMaybe<TixProductMediaFileSetInput>;
  pk_columns: TixProductMediaFilePkColumnsInput;
};


/** mutation root */
export type TixMutationRootProductMediaFileUpdateManyArgs = {
  updates: Array<TixProductMediaFileUpdates>;
};


/** mutation root */
export type TixMutationRootProductUpdateArgs = {
  _inc?: InputMaybe<TixProductIncInput>;
  _set?: InputMaybe<TixProductSetInput>;
  where: TixProductBoolExp;
};


/** mutation root */
export type TixMutationRootProductUpdateByPkArgs = {
  _inc?: InputMaybe<TixProductIncInput>;
  _set?: InputMaybe<TixProductSetInput>;
  pk_columns: TixProductPkColumnsInput;
};


/** mutation root */
export type TixMutationRootProductUpdateManyArgs = {
  updates: Array<TixProductUpdates>;
};


/** mutation root */
export type TixMutationRootRolePermissionArgs = {
  _set?: InputMaybe<TixRolePermissionSetInput>;
  pk_columns: TixRolePermissionPkColumnsInput;
};


/** mutation root */
export type TixMutationRootTicketReservationDetailInsertArgs = {
  objects: Array<TixTicketReservationDetailInsertInput>;
  on_conflict?: InputMaybe<TixTicketReservationDetailOnConflict>;
};


/** mutation root */
export type TixMutationRootTicketReservationDetailInsertOneArgs = {
  object: TixTicketReservationDetailInsertInput;
  on_conflict?: InputMaybe<TixTicketReservationDetailOnConflict>;
};


/** mutation root */
export type TixMutationRootUpdateAddressArgs = {
  _set?: InputMaybe<TixAddressSetInput>;
  where: TixAddressBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateAddressByPkArgs = {
  _set?: InputMaybe<TixAddressSetInput>;
  pk_columns: TixAddressPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateBusinessCodeGroupArgs = {
  _set?: InputMaybe<TixBusinessCodeGroupSetInput>;
  where: TixBusinessCodeGroupBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateBusinessCodeGroupByPkArgs = {
  _set?: InputMaybe<TixBusinessCodeGroupSetInput>;
  pk_columns: TixBusinessCodeGroupPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateBusinessCodesArgs = {
  _set?: InputMaybe<TixBusinessCodesSetInput>;
  where: TixBusinessCodesBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateBusinessCodesByPkArgs = {
  _set?: InputMaybe<TixBusinessCodesSetInput>;
  pk_columns: TixBusinessCodesPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCompanyArgs = {
  _set?: InputMaybe<TixCompanySetInput>;
  where: TixCompanyBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCompanyAddressArgs = {
  _set?: InputMaybe<TixCompanyAddressSetInput>;
  where: TixCompanyAddressBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCompanyAddressByPkArgs = {
  _set?: InputMaybe<TixCompanyAddressSetInput>;
  pk_columns: TixCompanyAddressPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCompanyConfigurationValueArgs = {
  _set?: InputMaybe<TixCompanyConfigurationValueSetInput>;
  where: TixCompanyConfigurationValueBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCompanyContactArgs = {
  _set?: InputMaybe<TixCompanyContactSetInput>;
  where: TixCompanyContactBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCompanyContactByPkArgs = {
  _set?: InputMaybe<TixCompanyContactSetInput>;
  pk_columns: TixCompanyContactPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCompanyMediaFileArgs = {
  _set?: InputMaybe<TixCompanyMediaFileSetInput>;
  where: TixCompanyMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCompanyMediaFileByPkArgs = {
  _set?: InputMaybe<TixCompanyMediaFileSetInput>;
  pk_columns: TixCompanyMediaFilePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCompanyPhoneNumberArgs = {
  _set?: InputMaybe<TixCompanyPhoneNumberSetInput>;
  where: TixCompanyPhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCompanyPhoneNumberByPkArgs = {
  _set?: InputMaybe<TixCompanyPhoneNumberSetInput>;
  pk_columns: TixCompanyPhoneNumberPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCompanySocialMediaArgs = {
  _set?: InputMaybe<TixCompanySocialMediaSetInput>;
  where: TixCompanySocialMediaBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCompanySocialMediaByPkArgs = {
  _set?: InputMaybe<TixCompanySocialMediaSetInput>;
  pk_columns: TixCompanySocialMediaPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCompanyWarningArgs = {
  _set?: InputMaybe<TixCompanyWarningSetInput>;
  where: TixCompanyWarningBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCompanyWarningByPkArgs = {
  _set?: InputMaybe<TixCompanyWarningSetInput>;
  pk_columns: TixCompanyWarningPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationGroupArgs = {
  _set?: InputMaybe<TixConfigurationGroupSetInput>;
  where: TixConfigurationGroupBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationGroupByPkArgs = {
  _set?: InputMaybe<TixConfigurationGroupSetInput>;
  pk_columns: TixConfigurationGroupPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationGroupItemArgs = {
  _inc?: InputMaybe<TixConfigurationGroupItemIncInput>;
  _set?: InputMaybe<TixConfigurationGroupItemSetInput>;
  where: TixConfigurationGroupItemBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationItemArgs = {
  _set?: InputMaybe<TixConfigurationItemSetInput>;
  where: TixConfigurationItemBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationItemByPkArgs = {
  _set?: InputMaybe<TixConfigurationItemSetInput>;
  pk_columns: TixConfigurationItemPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationValueArgs = {
  _set?: InputMaybe<TixConfigurationValueSetInput>;
  where: TixConfigurationValueBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateContactArgs = {
  _set?: InputMaybe<TixContactSetInput>;
  where: TixContactBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateContactAddressArgs = {
  _set?: InputMaybe<TixContactAddressSetInput>;
  where: TixContactAddressBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateContactAddressByPkArgs = {
  _set?: InputMaybe<TixContactAddressSetInput>;
  pk_columns: TixContactAddressPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateContactByPkArgs = {
  _set?: InputMaybe<TixContactSetInput>;
  pk_columns: TixContactPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateContactPhoneNumberArgs = {
  _set?: InputMaybe<TixContactPhoneNumberSetInput>;
  where: TixContactPhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateContactPhoneNumberByPkArgs = {
  _set?: InputMaybe<TixContactPhoneNumberSetInput>;
  pk_columns: TixContactPhoneNumberPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateDiscountArgs = {
  _inc?: InputMaybe<TixDiscountIncInput>;
  _set?: InputMaybe<TixDiscountSetInput>;
  where: TixDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateDiscountByPkArgs = {
  _inc?: InputMaybe<TixDiscountIncInput>;
  _set?: InputMaybe<TixDiscountSetInput>;
  pk_columns: TixDiscountPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateDiscountManyArgs = {
  updates: Array<TixDiscountUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventArgs = {
  _set?: InputMaybe<TixEventSetInput>;
  where: TixEventBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventByPkArgs = {
  _set?: InputMaybe<TixEventSetInput>;
  pk_columns: TixEventPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceArgs = {
  _inc?: InputMaybe<TixEventInstanceIncInput>;
  _set?: InputMaybe<TixEventInstanceSetInput>;
  where: TixEventInstanceBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceByPkArgs = {
  _inc?: InputMaybe<TixEventInstanceIncInput>;
  _set?: InputMaybe<TixEventInstanceSetInput>;
  pk_columns: TixEventInstancePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceConfigurationValueArgs = {
  _set?: InputMaybe<TixEventInstanceConfigurationValueSetInput>;
  where: TixEventInstanceConfigurationValueBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceConfigurationValueByPkArgs = {
  _set?: InputMaybe<TixEventInstanceConfigurationValueSetInput>;
  pk_columns: TixEventInstanceConfigurationValuePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceConfigurationValueManyArgs = {
  updates: Array<TixEventInstanceConfigurationValueUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceDiscountArgs = {
  _set?: InputMaybe<TixEventInstanceDiscountSetInput>;
  where: TixEventInstanceDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceDiscountByPkArgs = {
  _set?: InputMaybe<TixEventInstanceDiscountSetInput>;
  pk_columns: TixEventInstanceDiscountPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceMedialFileArgs = {
  _set?: InputMaybe<TixEventInstanceMedialFileSetInput>;
  where: TixEventInstanceMedialFileBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceMedialFileByPkArgs = {
  _set?: InputMaybe<TixEventInstanceMedialFileSetInput>;
  pk_columns: TixEventInstanceMedialFilePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceSocialMediaFileArgs = {
  _set?: InputMaybe<TixEventInstanceSocialMediaFileSetInput>;
  where: TixEventInstanceSocialMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceSocialMediaFileByPkArgs = {
  _set?: InputMaybe<TixEventInstanceSocialMediaFileSetInput>;
  pk_columns: TixEventInstanceSocialMediaFilePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceTicketArgs = {
  _inc?: InputMaybe<TixEventInstanceTicketIncInput>;
  _set?: InputMaybe<TixEventInstanceTicketSetInput>;
  where: TixEventInstanceTicketBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceTicketByPkArgs = {
  _inc?: InputMaybe<TixEventInstanceTicketIncInput>;
  _set?: InputMaybe<TixEventInstanceTicketSetInput>;
  pk_columns: TixEventInstanceTicketPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceTicketConfigArgs = {
  _set?: InputMaybe<TixEventInstanceTicketConfigSetInput>;
  where: TixEventInstanceTicketConfigBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceTicketConfigByPkArgs = {
  _set?: InputMaybe<TixEventInstanceTicketConfigSetInput>;
  pk_columns: TixEventInstanceTicketConfigPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventLineupArgs = {
  _set?: InputMaybe<TixEventLineupSetInput>;
  where: TixEventLineupBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventLineupByPkArgs = {
  _set?: InputMaybe<TixEventLineupSetInput>;
  pk_columns: TixEventLineupPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventPerformersArgs = {
  _set?: InputMaybe<TixEventPerformersSetInput>;
  where: TixEventPerformersBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventPerformersByPkArgs = {
  _set?: InputMaybe<TixEventPerformersSetInput>;
  pk_columns: TixEventPerformersPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventVenueArgs = {
  _set?: InputMaybe<TixEventVenueSetInput>;
  where: TixEventVenueBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventVenueByPkArgs = {
  _set?: InputMaybe<TixEventVenueSetInput>;
  pk_columns: TixEventVenuePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateLineupArgs = {
  _set?: InputMaybe<TixLineupSetInput>;
  where: TixLineupBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateLineupByPkArgs = {
  _set?: InputMaybe<TixLineupSetInput>;
  pk_columns: TixLineupPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateLineupPerformerArgs = {
  _set?: InputMaybe<TixLineupPerformerSetInput>;
  where: TixLineupPerformerBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateLineupPerformerByPkArgs = {
  _set?: InputMaybe<TixLineupPerformerSetInput>;
  pk_columns: TixLineupPerformerPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateMediaFileArgs = {
  _set?: InputMaybe<TixMediaFileSetInput>;
  where: TixMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateMediaFileByPkArgs = {
  _set?: InputMaybe<TixMediaFileSetInput>;
  pk_columns: TixMediaFilePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateNotificationArgs = {
  _set?: InputMaybe<TixNotificationSetInput>;
  where: TixNotificationBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateNotificationByPkArgs = {
  _set?: InputMaybe<TixNotificationSetInput>;
  pk_columns: TixNotificationPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePaymentArgs = {
  _inc?: InputMaybe<TixPaymentIncInput>;
  _set?: InputMaybe<TixPaymentSetInput>;
  where: TixPaymentBoolExp;
};


/** mutation root */
export type TixMutationRootUpdatePaymentByPkArgs = {
  _inc?: InputMaybe<TixPaymentIncInput>;
  _set?: InputMaybe<TixPaymentSetInput>;
  pk_columns: TixPaymentPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePaymentDiscountArgs = {
  _set?: InputMaybe<TixPaymentDiscountSetInput>;
  where: TixPaymentDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootUpdatePaymentDiscountByPkArgs = {
  _set?: InputMaybe<TixPaymentDiscountSetInput>;
  pk_columns: TixPaymentDiscountPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePaymentDiscountManyArgs = {
  updates: Array<TixPaymentDiscountUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePaymentVendorLogArgs = {
  _inc?: InputMaybe<TixPaymentVendorLogIncInput>;
  _set?: InputMaybe<TixPaymentVendorLogSetInput>;
  where: TixPaymentVendorLogBoolExp;
};


/** mutation root */
export type TixMutationRootUpdatePaymentVendorLogByPkArgs = {
  _inc?: InputMaybe<TixPaymentVendorLogIncInput>;
  _set?: InputMaybe<TixPaymentVendorLogSetInput>;
  pk_columns: TixPaymentVendorLogPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePaymentVendorLogManyArgs = {
  updates: Array<TixPaymentVendorLogUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePayoutArgs = {
  _inc?: InputMaybe<TixPayoutIncInput>;
  _set?: InputMaybe<TixPayoutSetInput>;
  where: TixPayoutBoolExp;
};


/** mutation root */
export type TixMutationRootUpdatePayoutByPkArgs = {
  _inc?: InputMaybe<TixPayoutIncInput>;
  _set?: InputMaybe<TixPayoutSetInput>;
  pk_columns: TixPayoutPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePayoutDetailByPkArgs = {
  _set?: InputMaybe<TixPayoutDetailSetInput>;
  pk_columns: TixPayoutDetailPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePayoutManyArgs = {
  updates: Array<TixPayoutUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePerformerArgs = {
  _set?: InputMaybe<TixPerformerSetInput>;
  where: TixPerformerBoolExp;
};


/** mutation root */
export type TixMutationRootUpdatePerformerByPkArgs = {
  _set?: InputMaybe<TixPerformerSetInput>;
  pk_columns: TixPerformerPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePermissionArgs = {
  _set?: InputMaybe<TixPermissionSetInput>;
  where: TixPermissionBoolExp;
};


/** mutation root */
export type TixMutationRootUpdatePermissionByPkArgs = {
  _set?: InputMaybe<TixPermissionSetInput>;
  pk_columns: TixPermissionPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePhoneNumberArgs = {
  _set?: InputMaybe<TixPhoneNumberSetInput>;
  where: TixPhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootUpdatePhoneNumberByPkArgs = {
  _set?: InputMaybe<TixPhoneNumberSetInput>;
  pk_columns: TixPhoneNumberPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateReservationArgs = {
  _inc?: InputMaybe<TixTicketReservationIncInput>;
  _set?: InputMaybe<TixTicketReservationSetInput>;
  where: TixTicketReservationBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateReservationByPkArgs = {
  _inc?: InputMaybe<TixTicketReservationIncInput>;
  _set?: InputMaybe<TixTicketReservationSetInput>;
  pk_columns: TixTicketReservationPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateReservationPaymentArgs = {
  _inc?: InputMaybe<TixReservationPaymentIncInput>;
  _set?: InputMaybe<TixReservationPaymentSetInput>;
  where: TixReservationPaymentBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateReservationPaymentByPkArgs = {
  _inc?: InputMaybe<TixReservationPaymentIncInput>;
  _set?: InputMaybe<TixReservationPaymentSetInput>;
  pk_columns: TixReservationPaymentPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateRoleArgs = {
  _set?: InputMaybe<TixRoleSetInput>;
  where: TixRoleBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateRoleByPkArgs = {
  _set?: InputMaybe<TixRoleSetInput>;
  pk_columns: TixRolePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateRolePermissionByPkArgs = {
  _set?: InputMaybe<TixRolePermissionSetInput>;
  where: TixRolePermissionBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateSocialMediaArgs = {
  _set?: InputMaybe<TixSocialMediaSetInput>;
  where: TixSocialMediaBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateSocialMediaByPkArgs = {
  _set?: InputMaybe<TixSocialMediaSetInput>;
  pk_columns: TixSocialMediaPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateTicketArgs = {
  _inc?: InputMaybe<TixTicketIncInput>;
  _set?: InputMaybe<TixTicketSetInput>;
  where: TixTicketBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateTicketByPkArgs = {
  _inc?: InputMaybe<TixTicketIncInput>;
  _set?: InputMaybe<TixTicketSetInput>;
  pk_columns: TixTicketPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateTicketConfigArgs = {
  _inc?: InputMaybe<TixTicketConfigIncInput>;
  _set?: InputMaybe<TixTicketConfigSetInput>;
  where: TixTicketConfigBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateTicketConfigByPkArgs = {
  _inc?: InputMaybe<TixTicketConfigIncInput>;
  _set?: InputMaybe<TixTicketConfigSetInput>;
  pk_columns: TixTicketConfigPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateUserByPkArgs = {
  _inc?: InputMaybe<TixUserIncInput>;
  _set?: InputMaybe<TixUserSetInput>;
  pk_columns: TixUserPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateUserRoleArgs = {
  _set?: InputMaybe<TixUserRoleSetInput>;
  where: TixUserRoleBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateUserRoleByPkArgs = {
  _set?: InputMaybe<TixUserRoleSetInput>;
  pk_columns: TixUserRolePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueArgs = {
  _set?: InputMaybe<TixVenueSetInput>;
  where: TixVenueBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueAddressArgs = {
  _set?: InputMaybe<TixVenueAddressSetInput>;
  where: TixVenueAddressBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueAddressByIdArgs = {
  _set?: InputMaybe<TixVenueAddressSetInput>;
  pk_columns: TixVenueAddressPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueByPkArgs = {
  _set?: InputMaybe<TixVenueSetInput>;
  pk_columns: TixVenuePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueConfigurationValueArgs = {
  _set?: InputMaybe<TixVenueConfigurationValueSetInput>;
  where: TixVenueConfigurationValueBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueConfigurationValueByPkArgs = {
  _set?: InputMaybe<TixVenueConfigurationValueSetInput>;
  pk_columns: TixVenueConfigurationValuePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueContactArgs = {
  _set?: InputMaybe<TixVenueContactSetInput>;
  where: TixVenueContactBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueContactByPkArgs = {
  _set?: InputMaybe<TixVenueContactSetInput>;
  pk_columns: TixVenueContactPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueDiscountArgs = {
  _set?: InputMaybe<TixVenueDiscountSetInput>;
  where: TixVenueDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueDiscountByPkArgs = {
  _set?: InputMaybe<TixVenueDiscountSetInput>;
  pk_columns: TixVenueDiscountPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueDiscountManyArgs = {
  updates: Array<TixVenueDiscountUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueLineupArgs = {
  _set?: InputMaybe<TixVenueLineupSetInput>;
  where: TixVenueLineupBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueLineupByPkArgs = {
  _set?: InputMaybe<TixVenueLineupSetInput>;
  pk_columns: TixVenueLineupPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueMediaFileArgs = {
  _set?: InputMaybe<TixVenueMediaFileSetInput>;
  where: TixVenueMediaFileBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueMediaFileByPkArgs = {
  _set?: InputMaybe<TixVenueMediaFileSetInput>;
  pk_columns: TixVenueMediaFilePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenuePhoneNumberArgs = {
  _set?: InputMaybe<TixVenuePhoneNumberSetInput>;
  where: TixVenuePhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenuePhoneNumberByPkArgs = {
  _set?: InputMaybe<TixVenuePhoneNumberSetInput>;
  pk_columns: TixVenuePhoneNumberPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueSocialMediaArgs = {
  _set?: InputMaybe<TixVenueSocialMediaSetInput>;
  where: TixVenueSocialMediaBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueSocialMediaByPkArgs = {
  _set?: InputMaybe<TixVenueSocialMediaSetInput>;
  pk_columns: TixVenueSocialMediaPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueTicketArgs = {
  _inc?: InputMaybe<TixVenueTicketIncInput>;
  _set?: InputMaybe<TixVenueTicketSetInput>;
  where: TixVenueTicketBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueTicketByPkArgs = {
  _inc?: InputMaybe<TixVenueTicketIncInput>;
  _set?: InputMaybe<TixVenueTicketSetInput>;
  pk_columns: TixVenueTicketPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueTicketConfigArgs = {
  _set?: InputMaybe<TixVenueTicketConfigSetInput>;
  where: TixVenueTicketConfigBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueTicketConfigByPkArgs = {
  _set?: InputMaybe<TixVenueTicketConfigSetInput>;
  pk_columns: TixVenueTicketConfigPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateVenueWarningArgs = {
  _set?: InputMaybe<TixVenueWarningSetInput>;
  where: TixVenueWarningBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateVenueWarningByPkArgs = {
  _set?: InputMaybe<TixVenueWarningSetInput>;
  pk_columns: TixVenueWarningPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateWarningArgs = {
  _set?: InputMaybe<TixWarningSetInput>;
  where: TixWarningBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateWarningByPkArgs = {
  _set?: InputMaybe<TixWarningSetInput>;
  pk_columns: TixWarningPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUserArgs = {
  _inc?: InputMaybe<TixUserIncInput>;
  _set?: InputMaybe<TixUserSetInput>;
  where: TixUserBoolExp;
};


/** mutation root */
export type TixMutationRootVenueProductDeleteArgs = {
  where: TixVenueProductBoolExp;
};


/** mutation root */
export type TixMutationRootVenueProductDeleteByPkArgs = {
  venueProductId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootVenueProductInsertArgs = {
  objects: Array<TixVenueProductInsertInput>;
  on_conflict?: InputMaybe<TixVenueProductOnConflict>;
};


/** mutation root */
export type TixMutationRootVenueProductInsertOneArgs = {
  object: TixVenueProductInsertInput;
  on_conflict?: InputMaybe<TixVenueProductOnConflict>;
};


/** mutation root */
export type TixMutationRootVenueProductUpdateArgs = {
  _set?: InputMaybe<TixVenueProductSetInput>;
  where: TixVenueProductBoolExp;
};


/** mutation root */
export type TixMutationRootVenueProductUpdateByPkArgs = {
  _set?: InputMaybe<TixVenueProductSetInput>;
  pk_columns: TixVenueProductPkColumnsInput;
};


/** mutation root */
export type TixMutationRootVenueProductUpdateManyArgs = {
  updates: Array<TixVenueProductUpdates>;
};


/** mutation root */
export type TixMutationRootAddOrderToHoldArgs = {
  tickets: Array<TixTicketOnHoldInput>;
  userSessionId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootCancelTicketExchangeArgs = {
  exchangeId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootConfirmReservationArgs = {
  method: TixPaymentMethod;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  reservationId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootConfirmTicketExchangeArgs = {
  exchangeId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootCreatePaymentArgs = {
  amount: Scalars['Float'];
  currency?: InputMaybe<Scalars['String']>;
  customerInput?: InputMaybe<TixCustomerInput>;
  description?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type TixMutationRootCreatePaymentIntentForOrderArgs = {
  eventInstanceId: Scalars['String'];
  method: TixPaymentMethod;
  order: TixOrderInput;
};


/** mutation root */
export type TixMutationRootCreateRecurringEventsArgs = {
  data: TixEventData;
};


/** mutation root */
export type TixMutationRootCreateRedirectCodeArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type TixMutationRootCreateStripeTerminalConnectionTokenArgs = {
  mode: Scalars['String'];
};


/** mutation root */
export type TixMutationRootCreateUnconfirmedReservationArgs = {
  customer: TixCustomerInput;
  eventInstanceId: Scalars['String'];
  order: TixOrderInput;
  paymentIntentId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type TixMutationRootCreateUserAndSendEmailArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type TixMutationRootDeleteScheduledReportFromTheQueueArgs = {
  scheduledReport: TixScheduledReportInput;
};


/** mutation root */
export type TixMutationRootDeleteCompanyConfigurationValueByPkArgs = {
  companyConfigurationValueId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteConfigurationGroupItemByPkArgs = {
  configurationGroupItemId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteConfigurationValueByPkArgs = {
  configurationValueId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEmailContentArgs = {
  where: TixEmailContentBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEmailContentByPkArgs = {
  emailContentId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventEmailArgs = {
  where: TixEventEmailBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteLoggingArgs = {
  where: TixLoggingBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteLoggingByPkArgs = {
  logId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePayoutConnectArgs = {
  where: TixPayoutConnectBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePayoutConnectByPkArgs = {
  payoutConnectionId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeletePayoutDetailArgs = {
  where: TixPayoutDetailBoolExp;
};


/** mutation root */
export type TixMutationRootDeletePayoutDetailByPkArgs = {
  payoutDetailId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteTicketReservationDetailArgs = {
  where: TixTicketReservationDetailBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteTicketReservationDetailByPkArgs = {
  reservationDetailId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteAddressPerformerPhoneNumberArgs = {
  where: TixAddressPerformerPhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteAddressPerformerPhoneNumberByPkArgs = {
  performer_phone_number_id: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCommunicationsCompanyEmailArgs = {
  where: TixCommunicationsCompanyEmailBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCommunicationsEmailContentVariableArgs = {
  where: TixCommunicationsEmailContentVariableBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCommunicationsEmailContentVariableByPkArgs = {
  emailContentVariableId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCommunicationsEmailVariableArgs = {
  where: TixCommunicationsEmailVariableBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCommunicationsEmailVariableByPkArgs = {
  emailVariableId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteCommunicationsVenueEmailArgs = {
  where: TixCommunicationsVenueEmailBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteCompanyByPkArgs = {
  companyId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteEventCampaignTrackingArgs = {
  where: TixEventCampaignTrackingBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteEventCampaignTrackingByPkArgs = {
  campaign_tracking_id: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteNotificationContactNotificationArgs = {
  where: TixNotificationContactNotificationBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteNotificationContactNotificationByPkArgs = {
  contactNotificationId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteProductOrderDetailArgs = {
  where: TixProductOrderDetailBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteProductOrderDetailByPkArgs = {
  orderDetailId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteReservationReportArgs = {
  where: TixReservationReportBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteReservationReportByPkArgs = {
  reservationReportId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteSavedReportArgs = {
  where: TixSavedReportBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteSavedReportEventsArgs = {
  where: TixSavedReportEventsBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteSavedReportEventsByPkArgs = {
  savedReportEventsId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteSavedReportLayoutArgs = {
  where: TixSavedReportLayoutBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteSavedReportLayoutByPkArgs = {
  savedReportLayoutId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteSavedReportByPkArgs = {
  savedReportId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteScheduledReportArgs = {
  where: TixScheduledReportBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteScheduledReportEmailArgs = {
  where: TixScheduledReportEmailBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteScheduledReportEmailByPkArgs = {
  scheduledReportEmailId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteScheduledReportByPkArgs = {
  scheduledReportId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteTicketExchangeArgs = {
  where: TixTicketExchangeBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteTicketExchangeByPkArgs = {
  exchangeId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteTicketTicketDiscountArgs = {
  where: TixTicketTicketDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteTicketTicketDiscountByPkArgs = {
  ticketDiscountId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDeleteUtilityPolicyArgs = {
  where: TixUtilityPolicyBoolExp;
};


/** mutation root */
export type TixMutationRootDeleteUtilityPolicyByPkArgs = {
  policyId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootDisconnectStripeConnectionArgs = {
  companyId: Scalars['String'];
  mode: Scalars['String'];
  userId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootExchangeRedirectCodeForTokenArgs = {
  redirectCode: Scalars['String'];
};


/** mutation root */
export type TixMutationRootFeesDeleteArgs = {
  where: TixFeesBoolExp;
};


/** mutation root */
export type TixMutationRootFeesDeleteByPkArgs = {
  feeId: Scalars['uuid'];
};


/** mutation root */
export type TixMutationRootFeesInsertArgs = {
  objects: Array<TixFeesInsertInput>;
  on_conflict?: InputMaybe<TixFeesOnConflict>;
};


/** mutation root */
export type TixMutationRootFeesInsertOneArgs = {
  object: TixFeesInsertInput;
  on_conflict?: InputMaybe<TixFeesOnConflict>;
};


/** mutation root */
export type TixMutationRootFeesUpdateArgs = {
  _inc?: InputMaybe<TixFeesIncInput>;
  _set?: InputMaybe<TixFeesSetInput>;
  where: TixFeesBoolExp;
};


/** mutation root */
export type TixMutationRootFeesUpdateByPkArgs = {
  _inc?: InputMaybe<TixFeesIncInput>;
  _set?: InputMaybe<TixFeesSetInput>;
  pk_columns: TixFeesPkColumnsInput;
};


/** mutation root */
export type TixMutationRootFeesUpdateManyArgs = {
  updates: Array<TixFeesUpdates>;
};


/** mutation root */
export type TixMutationRootGenericAddOrderToHoldArgs = {
  items: Array<TixOrderHoldItemInput>;
  userSessionId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootGenericRemoveOrderFromHoldArgs = {
  userSessionId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootGetStripeConnectionUrlArgs = {
  companyId: Scalars['String'];
  mode: Scalars['String'];
  refreshUrl: Scalars['String'];
  returnUrl: Scalars['String'];
  userId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootGrantAccessToCompanyArgs = {
  companyId: Scalars['String'];
  token: Scalars['String'];
};


/** mutation root */
export type TixMutationRootInitiateTicketExchangeArgs = {
  request: TixTicketExchangeRequestInput;
};


/** mutation root */
export type TixMutationRootInsertScheduledReportToTheQueueArgs = {
  scheduledReport: TixScheduledReportInput;
};


/** mutation root */
export type TixMutationRootInsertCompanyConfigurationValueOneArgs = {
  object: TixCompanyConfigurationValueInsertInput;
  on_conflict?: InputMaybe<TixCompanyConfigurationValueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertConfigurationGroupItemOneArgs = {
  object: TixConfigurationGroupItemInsertInput;
  on_conflict?: InputMaybe<TixConfigurationGroupItemOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertConfigurationValueOneArgs = {
  object: TixConfigurationValueInsertInput;
  on_conflict?: InputMaybe<TixConfigurationValueOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPayoutConnectArgs = {
  objects: Array<TixPayoutConnectInsertInput>;
  on_conflict?: InputMaybe<TixPayoutConnectOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertPayoutDetailOneArgs = {
  object: TixPayoutDetailInsertInput;
  on_conflict?: InputMaybe<TixPayoutDetailOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertAddressPerformerPhoneNumberArgs = {
  objects: Array<TixAddressPerformerPhoneNumberInsertInput>;
  on_conflict?: InputMaybe<TixAddressPerformerPhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertAddressPerformerPhoneNumberOneArgs = {
  object: TixAddressPerformerPhoneNumberInsertInput;
  on_conflict?: InputMaybe<TixAddressPerformerPhoneNumberOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCommunicationsCompanyEmailArgs = {
  objects: Array<TixCommunicationsCompanyEmailInsertInput>;
};


/** mutation root */
export type TixMutationRootInsertCommunicationsCompanyEmailOneArgs = {
  object: TixCommunicationsCompanyEmailInsertInput;
};


/** mutation root */
export type TixMutationRootInsertCommunicationsEmailContentVariableArgs = {
  objects: Array<TixCommunicationsEmailContentVariableInsertInput>;
  on_conflict?: InputMaybe<TixCommunicationsEmailContentVariableOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCommunicationsEmailContentVariableOneArgs = {
  object: TixCommunicationsEmailContentVariableInsertInput;
  on_conflict?: InputMaybe<TixCommunicationsEmailContentVariableOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCommunicationsEmailVariableArgs = {
  objects: Array<TixCommunicationsEmailVariableInsertInput>;
  on_conflict?: InputMaybe<TixCommunicationsEmailVariableOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCommunicationsEmailVariableOneArgs = {
  object: TixCommunicationsEmailVariableInsertInput;
  on_conflict?: InputMaybe<TixCommunicationsEmailVariableOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertCommunicationsVenueEmailArgs = {
  objects: Array<TixCommunicationsVenueEmailInsertInput>;
};


/** mutation root */
export type TixMutationRootInsertCommunicationsVenueEmailOneArgs = {
  object: TixCommunicationsVenueEmailInsertInput;
};


/** mutation root */
export type TixMutationRootInsertCompanyOneArgs = {
  object: TixCompanyInsertInput;
  on_conflict?: InputMaybe<TixCompanyOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventCampaignTrackingArgs = {
  objects: Array<TixEventCampaignTrackingInsertInput>;
  on_conflict?: InputMaybe<TixEventCampaignTrackingOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertEventCampaignTrackingOneArgs = {
  object: TixEventCampaignTrackingInsertInput;
  on_conflict?: InputMaybe<TixEventCampaignTrackingOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertNotificationContactNotificationArgs = {
  objects: Array<TixNotificationContactNotificationInsertInput>;
  on_conflict?: InputMaybe<TixNotificationContactNotificationOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertNotificationContactNotificationOneArgs = {
  object: TixNotificationContactNotificationInsertInput;
  on_conflict?: InputMaybe<TixNotificationContactNotificationOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertProductOrderDetailArgs = {
  objects: Array<TixProductOrderDetailInsertInput>;
  on_conflict?: InputMaybe<TixProductOrderDetailOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertProductOrderDetailOneArgs = {
  object: TixProductOrderDetailInsertInput;
  on_conflict?: InputMaybe<TixProductOrderDetailOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertSavedReportArgs = {
  objects: Array<TixSavedReportInsertInput>;
  on_conflict?: InputMaybe<TixSavedReportOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertSavedReportEventsArgs = {
  objects: Array<TixSavedReportEventsInsertInput>;
  on_conflict?: InputMaybe<TixSavedReportEventsOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertSavedReportEventsOneArgs = {
  object: TixSavedReportEventsInsertInput;
  on_conflict?: InputMaybe<TixSavedReportEventsOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertSavedReportLayoutArgs = {
  objects: Array<TixSavedReportLayoutInsertInput>;
  on_conflict?: InputMaybe<TixSavedReportLayoutOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertSavedReportLayoutOneArgs = {
  object: TixSavedReportLayoutInsertInput;
  on_conflict?: InputMaybe<TixSavedReportLayoutOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertSavedReportOneArgs = {
  object: TixSavedReportInsertInput;
  on_conflict?: InputMaybe<TixSavedReportOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertScheduledReportArgs = {
  objects: Array<TixScheduledReportInsertInput>;
  on_conflict?: InputMaybe<TixScheduledReportOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertScheduledReportEmailArgs = {
  objects: Array<TixScheduledReportEmailInsertInput>;
  on_conflict?: InputMaybe<TixScheduledReportEmailOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertScheduledReportEmailOneArgs = {
  object: TixScheduledReportEmailInsertInput;
  on_conflict?: InputMaybe<TixScheduledReportEmailOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertScheduledReportOneArgs = {
  object: TixScheduledReportInsertInput;
  on_conflict?: InputMaybe<TixScheduledReportOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertTicketExchangeArgs = {
  objects: Array<TixTicketExchangeInsertInput>;
  on_conflict?: InputMaybe<TixTicketExchangeOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertTicketExchangeOneArgs = {
  object: TixTicketExchangeInsertInput;
  on_conflict?: InputMaybe<TixTicketExchangeOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertTicketTicketDiscountArgs = {
  objects: Array<TixTicketTicketDiscountInsertInput>;
  on_conflict?: InputMaybe<TixTicketTicketDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertTicketTicketDiscountOneArgs = {
  object: TixTicketTicketDiscountInsertInput;
  on_conflict?: InputMaybe<TixTicketTicketDiscountOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertUtilityPolicyArgs = {
  objects: Array<TixUtilityPolicyInsertInput>;
  on_conflict?: InputMaybe<TixUtilityPolicyOnConflict>;
};


/** mutation root */
export type TixMutationRootInsertUtilityPolicyOneArgs = {
  object: TixUtilityPolicyInsertInput;
  on_conflict?: InputMaybe<TixUtilityPolicyOnConflict>;
};


/** mutation root */
export type TixMutationRootRefundAddonsArgs = {
  refundAddonsInput: TixRefundAddonsInput;
};


/** mutation root */
export type TixMutationRootRefundDonationsArgs = {
  mode: Scalars['String'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  reservationId: Scalars['String'];
  updatedBy: Scalars['String'];
};


/** mutation root */
export type TixMutationRootRefundReservationArgs = {
  mode: Scalars['String'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  reservationId: Scalars['String'];
  updatedBy: Scalars['String'];
};


/** mutation root */
export type TixMutationRootRefundTicketArgs = {
  mode: Scalars['String'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  ticketId: Scalars['String'];
  updatedBy: Scalars['String'];
};


/** mutation root */
export type TixMutationRootRemoveOrderFromHoldArgs = {
  userSessionId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootRequestPayoutArgs = {
  eventInstanceId: Scalars['String'];
  mode: Scalars['String'];
  userId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootRequestResetPasswordArgs = {
  email: Scalars['String'];
  url: Scalars['String'];
};


/** mutation root */
export type TixMutationRootReservationReportInserOneArgs = {
  object: TixReservationReportInsertInput;
  on_conflict?: InputMaybe<TixReservationReportOnConflict>;
};


/** mutation root */
export type TixMutationRootReservationReportInsertArgs = {
  objects: Array<TixReservationReportInsertInput>;
  on_conflict?: InputMaybe<TixReservationReportOnConflict>;
};


/** mutation root */
export type TixMutationRootReservationReportUpdateArgs = {
  _append?: InputMaybe<TixReservationReportAppendInput>;
  _delete_at_path?: InputMaybe<TixReservationReportDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TixReservationReportDeleteElemInput>;
  _delete_key?: InputMaybe<TixReservationReportDeleteKeyInput>;
  _prepend?: InputMaybe<TixReservationReportPrependInput>;
  _set?: InputMaybe<TixReservationReportSetInput>;
  where: TixReservationReportBoolExp;
};


/** mutation root */
export type TixMutationRootResetPasswordArgs = {
  newPassword: Scalars['String'];
  token: Scalars['String'];
};


/** mutation root */
export type TixMutationRootSendEticketArgs = {
  data: TixSendETicketInput;
};


/** mutation root */
export type TixMutationRootSendExchangePaymentEmailArgs = {
  exchangeId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootSendTicketExchangeEmailArgs = {
  exchangeId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootSendTicketPurchaseEmailArgs = {
  data: TixSendTicketEmailNotificaionInput;
};


/** mutation root */
export type TixMutationRootSubmitFeedbackArgs = {
  additionalInfos: TixAdditionalInfosInput;
  attachments?: InputMaybe<Array<TixFeedbackAttachmentUrl>>;
  consoleLogs?: InputMaybe<Scalars['Upload']>;
  feedback: TixFeedbackInput;
  networkLogs?: InputMaybe<Scalars['Upload']>;
};


/** mutation root */
export type TixMutationRootSubmitMobileFeedbackArgs = {
  additionalInfos: TixAdditionalInfosInput;
  attachments?: InputMaybe<Array<TixFeedbackAttachmentUrl>>;
  feedback: TixFeedbackInput;
};


/** mutation root */
export type TixMutationRootSwitchEventProductToIndependentInventoryArgs = {
  eventProductId: Scalars['String'];
  quantity: Scalars['Float'];
};


/** mutation root */
export type TixMutationRootSwitchEventProductToSharedInventoryArgs = {
  eventProductId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
};


/** mutation root */
export type TixMutationRootUpdateCompanyByIdArgs = {
  _set?: InputMaybe<TixCompanySetInput>;
  pk_columns: TixCompanyPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePaymentIntentMetadataArgs = {
  metadataJSON: Scalars['String'];
  mode: Scalars['String'];
  paymentIntentId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootUpdateProductInventoryQuantityArgs = {
  newTotal: Scalars['Float'];
  productId: Scalars['String'];
};


/** mutation root */
export type TixMutationRootUpdateProductInventoryQuantitySoldArgs = {
  eventProductId: Scalars['String'];
  quantityPurchased: Scalars['Float'];
};


/** mutation root */
export type TixMutationRootUpdateScheduledReportInTheQueueArgs = {
  newValue: TixScheduledReportInput;
  old: TixScheduledReportInput;
};


/** mutation root */
export type TixMutationRootUpdateAddressManyArgs = {
  updates: Array<TixAddressUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateBusinessCodeGroupManyArgs = {
  updates: Array<TixBusinessCodeGroupUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateBusinessCodesManyArgs = {
  updates: Array<TixBusinessCodesUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCompanyAddressManyArgs = {
  updates: Array<TixCompanyAddressUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCompanyConfigurationValueByPkArgs = {
  _set?: InputMaybe<TixCompanyConfigurationValueSetInput>;
  pk_columns: TixCompanyConfigurationValuePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCompanyConfigurationValueManyArgs = {
  updates: Array<TixCompanyConfigurationValueUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCompanyContactManyArgs = {
  updates: Array<TixCompanyContactUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCompanyMediaFileManyArgs = {
  updates: Array<TixCompanyMediaFileUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCompanyPhoneNumberManyArgs = {
  updates: Array<TixCompanyPhoneNumberUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCompanySocialMediaManyArgs = {
  updates: Array<TixCompanySocialMediaUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCompanyWarningManyArgs = {
  updates: Array<TixCompanyWarningUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCompanyManyArgs = {
  updates: Array<TixCompanyUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationGroupItemByPkArgs = {
  _inc?: InputMaybe<TixConfigurationGroupItemIncInput>;
  _set?: InputMaybe<TixConfigurationGroupItemSetInput>;
  pk_columns: TixConfigurationGroupItemPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationGroupItemManyArgs = {
  updates: Array<TixConfigurationGroupItemUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationGroupManyArgs = {
  updates: Array<TixConfigurationGroupUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationItemManyArgs = {
  updates: Array<TixConfigurationItemUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationValueByPkArgs = {
  _set?: InputMaybe<TixConfigurationValueSetInput>;
  pk_columns: TixConfigurationValuePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateConfigurationValueManyArgs = {
  updates: Array<TixConfigurationValueUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateContactAddressManyArgs = {
  updates: Array<TixContactAddressUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateContactPhoneNumberManyArgs = {
  updates: Array<TixContactPhoneNumberUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateContactManyArgs = {
  updates: Array<TixContactUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEmailContentManyArgs = {
  updates: Array<TixEmailContentUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventEmailManyArgs = {
  updates: Array<TixEventEmailUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceDiscountManyArgs = {
  updates: Array<TixEventInstanceDiscountUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceMedialFileManyArgs = {
  updates: Array<TixEventInstanceMedialFileUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceSocialMediaFileManyArgs = {
  updates: Array<TixEventInstanceSocialMediaFileUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceTicketConfigManyArgs = {
  updates: Array<TixEventInstanceTicketConfigUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceTicketManyArgs = {
  updates: Array<TixEventInstanceTicketUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventInstanceManyArgs = {
  updates: Array<TixEventInstanceUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventLineupManyArgs = {
  updates: Array<TixEventLineupUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventPerformersManyArgs = {
  updates: Array<TixEventPerformersUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventVenueManyArgs = {
  updates: Array<TixEventVenueUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventManyArgs = {
  updates: Array<TixEventUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateLineupPerformerManyArgs = {
  updates: Array<TixLineupPerformerUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateLineupManyArgs = {
  updates: Array<TixLineupUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateLoggingArgs = {
  _append?: InputMaybe<TixLoggingAppendInput>;
  _delete_at_path?: InputMaybe<TixLoggingDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TixLoggingDeleteElemInput>;
  _delete_key?: InputMaybe<TixLoggingDeleteKeyInput>;
  _prepend?: InputMaybe<TixLoggingPrependInput>;
  _set?: InputMaybe<TixLoggingSetInput>;
  where: TixLoggingBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateLoggingByPkArgs = {
  _append?: InputMaybe<TixLoggingAppendInput>;
  _delete_at_path?: InputMaybe<TixLoggingDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TixLoggingDeleteElemInput>;
  _delete_key?: InputMaybe<TixLoggingDeleteKeyInput>;
  _prepend?: InputMaybe<TixLoggingPrependInput>;
  _set?: InputMaybe<TixLoggingSetInput>;
  pk_columns: TixLoggingPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateLoggingManyArgs = {
  updates: Array<TixLoggingUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateMediaFileManyArgs = {
  updates: Array<TixMediaFileUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateNotificationManyArgs = {
  updates: Array<TixNotificationUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePaymentManyArgs = {
  updates: Array<TixPaymentUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePayoutConnectByPkArgs = {
  _set?: InputMaybe<TixPayoutConnectSetInput>;
  pk_columns: TixPayoutConnectPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdatePayoutConnectManyArgs = {
  updates: Array<TixPayoutConnectUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePayoutDetailArgs = {
  _set?: InputMaybe<TixPayoutDetailSetInput>;
  where: TixPayoutDetailBoolExp;
};


/** mutation root */
export type TixMutationRootUpdatePayoutDetailManyArgs = {
  updates: Array<TixPayoutDetailUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePerformerManyArgs = {
  updates: Array<TixPerformerUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePermissionManyArgs = {
  updates: Array<TixPermissionUpdates>;
};


/** mutation root */
export type TixMutationRootUpdatePhoneNumberManyArgs = {
  updates: Array<TixPhoneNumberUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateReservationPaymentManyArgs = {
  updates: Array<TixReservationPaymentUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateRolePermissionManyArgs = {
  updates: Array<TixRolePermissionUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateRoleManyArgs = {
  updates: Array<TixRoleUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateSocialMediaManyArgs = {
  updates: Array<TixSocialMediaUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateTicketConfigManyArgs = {
  updates: Array<TixTicketConfigUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateTicketReservationDetailArgs = {
  _inc?: InputMaybe<TixTicketReservationDetailIncInput>;
  _set?: InputMaybe<TixTicketReservationDetailSetInput>;
  where: TixTicketReservationDetailBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateTicketReservationDetailByPkArgs = {
  _inc?: InputMaybe<TixTicketReservationDetailIncInput>;
  _set?: InputMaybe<TixTicketReservationDetailSetInput>;
  pk_columns: TixTicketReservationDetailPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateTicketReservationDetailManyArgs = {
  updates: Array<TixTicketReservationDetailUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateTicketManyArgs = {
  updates: Array<TixTicketUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateUserRoleManyArgs = {
  updates: Array<TixUserRoleUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateUserManyArgs = {
  updates: Array<TixUserUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueAddressManyArgs = {
  updates: Array<TixVenueAddressUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueConfigurationValueManyArgs = {
  updates: Array<TixVenueConfigurationValueUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueContactManyArgs = {
  updates: Array<TixVenueContactUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueLineupManyArgs = {
  updates: Array<TixVenueLineupUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueMediaFileManyArgs = {
  updates: Array<TixVenueMediaFileUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenuePhoneNumberManyArgs = {
  updates: Array<TixVenuePhoneNumberUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueSocialMediaManyArgs = {
  updates: Array<TixVenueSocialMediaUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueTicketConfigManyArgs = {
  updates: Array<TixVenueTicketConfigUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueTicketManyArgs = {
  updates: Array<TixVenueTicketUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueWarningManyArgs = {
  updates: Array<TixVenueWarningUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateVenueManyArgs = {
  updates: Array<TixVenueUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateWarningManyArgs = {
  updates: Array<TixWarningUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateAddressPerformerPhoneNumberArgs = {
  _set?: InputMaybe<TixAddressPerformerPhoneNumberSetInput>;
  where: TixAddressPerformerPhoneNumberBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateAddressPerformerPhoneNumberByPkArgs = {
  _set?: InputMaybe<TixAddressPerformerPhoneNumberSetInput>;
  pk_columns: TixAddressPerformerPhoneNumberPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateAddressPerformerPhoneNumberManyArgs = {
  updates: Array<TixAddressPerformerPhoneNumberUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsCompanyEmailArgs = {
  _set?: InputMaybe<TixCommunicationsCompanyEmailSetInput>;
  where: TixCommunicationsCompanyEmailBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsCompanyEmailManyArgs = {
  updates: Array<TixCommunicationsCompanyEmailUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsEmailContentVariableArgs = {
  _set?: InputMaybe<TixCommunicationsEmailContentVariableSetInput>;
  where: TixCommunicationsEmailContentVariableBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsEmailContentVariableByPkArgs = {
  _set?: InputMaybe<TixCommunicationsEmailContentVariableSetInput>;
  pk_columns: TixCommunicationsEmailContentVariablePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsEmailContentVariableManyArgs = {
  updates: Array<TixCommunicationsEmailContentVariableUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsEmailVariableArgs = {
  _set?: InputMaybe<TixCommunicationsEmailVariableSetInput>;
  where: TixCommunicationsEmailVariableBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsEmailVariableByPkArgs = {
  _set?: InputMaybe<TixCommunicationsEmailVariableSetInput>;
  pk_columns: TixCommunicationsEmailVariablePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsEmailVariableManyArgs = {
  updates: Array<TixCommunicationsEmailVariableUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsVenueEmailArgs = {
  _set?: InputMaybe<TixCommunicationsVenueEmailSetInput>;
  where: TixCommunicationsVenueEmailBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateCommunicationsVenueEmailManyArgs = {
  updates: Array<TixCommunicationsVenueEmailUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateEventCampaignTrackingArgs = {
  _set?: InputMaybe<TixEventCampaignTrackingSetInput>;
  where: TixEventCampaignTrackingBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateEventCampaignTrackingByPkArgs = {
  _set?: InputMaybe<TixEventCampaignTrackingSetInput>;
  pk_columns: TixEventCampaignTrackingPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateEventCampaignTrackingManyArgs = {
  updates: Array<TixEventCampaignTrackingUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateNotificationContactNotificationArgs = {
  _set?: InputMaybe<TixNotificationContactNotificationSetInput>;
  where: TixNotificationContactNotificationBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateNotificationContactNotificationByPkArgs = {
  _set?: InputMaybe<TixNotificationContactNotificationSetInput>;
  pk_columns: TixNotificationContactNotificationPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateNotificationContactNotificationManyArgs = {
  updates: Array<TixNotificationContactNotificationUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateProductOrderDetailArgs = {
  _inc?: InputMaybe<TixProductOrderDetailIncInput>;
  _set?: InputMaybe<TixProductOrderDetailSetInput>;
  where: TixProductOrderDetailBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateProductOrderDetailByPkArgs = {
  _inc?: InputMaybe<TixProductOrderDetailIncInput>;
  _set?: InputMaybe<TixProductOrderDetailSetInput>;
  pk_columns: TixProductOrderDetailPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateProductOrderDetailManyArgs = {
  updates: Array<TixProductOrderDetailUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateReservationReportByPkArgs = {
  _append?: InputMaybe<TixReservationReportAppendInput>;
  _delete_at_path?: InputMaybe<TixReservationReportDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TixReservationReportDeleteElemInput>;
  _delete_key?: InputMaybe<TixReservationReportDeleteKeyInput>;
  _prepend?: InputMaybe<TixReservationReportPrependInput>;
  _set?: InputMaybe<TixReservationReportSetInput>;
  pk_columns: TixReservationReportPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateReservationReportManyArgs = {
  updates: Array<TixReservationReportUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportArgs = {
  _set?: InputMaybe<TixSavedReportSetInput>;
  where: TixSavedReportBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportEventsArgs = {
  _set?: InputMaybe<TixSavedReportEventsSetInput>;
  where: TixSavedReportEventsBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportEventsByPkArgs = {
  _set?: InputMaybe<TixSavedReportEventsSetInput>;
  pk_columns: TixSavedReportEventsPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportEventsManyArgs = {
  updates: Array<TixSavedReportEventsUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportLayoutArgs = {
  _set?: InputMaybe<TixSavedReportLayoutSetInput>;
  where: TixSavedReportLayoutBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportLayoutByPkArgs = {
  _set?: InputMaybe<TixSavedReportLayoutSetInput>;
  pk_columns: TixSavedReportLayoutPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportLayoutManyArgs = {
  updates: Array<TixSavedReportLayoutUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportByPkArgs = {
  _set?: InputMaybe<TixSavedReportSetInput>;
  pk_columns: TixSavedReportPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateSavedReportManyArgs = {
  updates: Array<TixSavedReportUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateScheduledReportArgs = {
  _set?: InputMaybe<TixScheduledReportSetInput>;
  where: TixScheduledReportBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateScheduledReportEmailArgs = {
  _set?: InputMaybe<TixScheduledReportEmailSetInput>;
  where: TixScheduledReportEmailBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateScheduledReportEmailByPkArgs = {
  _set?: InputMaybe<TixScheduledReportEmailSetInput>;
  pk_columns: TixScheduledReportEmailPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateScheduledReportEmailManyArgs = {
  updates: Array<TixScheduledReportEmailUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateScheduledReportByPkArgs = {
  _set?: InputMaybe<TixScheduledReportSetInput>;
  pk_columns: TixScheduledReportPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateScheduledReportManyArgs = {
  updates: Array<TixScheduledReportUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateTicketExchangeArgs = {
  _inc?: InputMaybe<TixTicketExchangeIncInput>;
  _set?: InputMaybe<TixTicketExchangeSetInput>;
  where: TixTicketExchangeBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateTicketExchangeByPkArgs = {
  _inc?: InputMaybe<TixTicketExchangeIncInput>;
  _set?: InputMaybe<TixTicketExchangeSetInput>;
  pk_columns: TixTicketExchangePkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateTicketExchangeManyArgs = {
  updates: Array<TixTicketExchangeUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateTicketReservationManyArgs = {
  updates: Array<TixTicketReservationUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateTicketTicketDiscountArgs = {
  _set?: InputMaybe<TixTicketTicketDiscountSetInput>;
  where: TixTicketTicketDiscountBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateTicketTicketDiscountByPkArgs = {
  _set?: InputMaybe<TixTicketTicketDiscountSetInput>;
  pk_columns: TixTicketTicketDiscountPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateTicketTicketDiscountManyArgs = {
  updates: Array<TixTicketTicketDiscountUpdates>;
};


/** mutation root */
export type TixMutationRootUpdateUtilityPolicyArgs = {
  _set?: InputMaybe<TixUtilityPolicySetInput>;
  where: TixUtilityPolicyBoolExp;
};


/** mutation root */
export type TixMutationRootUpdateUtilityPolicyByPkArgs = {
  _set?: InputMaybe<TixUtilityPolicySetInput>;
  pk_columns: TixUtilityPolicyPkColumnsInput;
};


/** mutation root */
export type TixMutationRootUpdateUtilityPolicyManyArgs = {
  updates: Array<TixUtilityPolicyUpdates>;
};


/** mutation root */
export type TixMutationRootUploadMediaArgs = {
  file: Scalars['Upload'];
  height?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

/** columns and relationships of "notification.contact_notification" */
export type TixNotificationContactNotification = {
  __typename?: 'notification_contact_notification';
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contactId?: Maybe<Scalars['uuid']>;
  contactNotificationId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  isRead?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  notification?: Maybe<TixNotification>;
  notificationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "notification.contact_notification" */
export type TixNotificationContactNotificationAggregate = {
  __typename?: 'notification_contact_notification_aggregate';
  aggregate?: Maybe<TixNotificationContactNotificationAggregateFields>;
  nodes: Array<TixNotificationContactNotification>;
};

/** aggregate fields of "notification.contact_notification" */
export type TixNotificationContactNotificationAggregateFields = {
  __typename?: 'notification_contact_notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixNotificationContactNotificationMaxFields>;
  min?: Maybe<TixNotificationContactNotificationMinFields>;
};


/** aggregate fields of "notification.contact_notification" */
export type TixNotificationContactNotificationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixNotificationContactNotificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification.contact_notification". All fields are combined with a logical 'AND'. */
export type TixNotificationContactNotificationBoolExp = {
  _and?: InputMaybe<Array<TixNotificationContactNotificationBoolExp>>;
  _not?: InputMaybe<TixNotificationContactNotificationBoolExp>;
  _or?: InputMaybe<Array<TixNotificationContactNotificationBoolExp>>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  contactNotificationId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  isRead?: InputMaybe<TixBooleanComparisonExp>;
  notification?: InputMaybe<TixNotificationBoolExp>;
  notificationId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "notification.contact_notification" */
export enum TixNotificationContactNotificationConstraint {
  /** unique or primary key constraint on columns "contact_notification_id" */
  ContactNotificationPkey = 'contact_notification_pkey'
}

/** input type for inserting data into table "notification.contact_notification" */
export type TixNotificationContactNotificationInsertInput = {
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  contactNotificationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  notification?: InputMaybe<TixNotificationObjRelInsertInput>;
  notificationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixNotificationContactNotificationMaxFields = {
  __typename?: 'notification_contact_notification_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  contactNotificationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  notificationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixNotificationContactNotificationMinFields = {
  __typename?: 'notification_contact_notification_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  contactNotificationId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  notificationId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "notification.contact_notification" */
export type TixNotificationContactNotificationMutationResponse = {
  __typename?: 'notification_contact_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixNotificationContactNotification>;
};

/** input type for inserting object relation for remote table "notification.contact_notification" */
export type TixNotificationContactNotificationObjRelInsertInput = {
  data: TixNotificationContactNotificationInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixNotificationContactNotificationOnConflict>;
};

/** on_conflict condition type for table "notification.contact_notification" */
export type TixNotificationContactNotificationOnConflict = {
  constraint: TixNotificationContactNotificationConstraint;
  update_columns?: Array<TixNotificationContactNotificationUpdateColumn>;
  where?: InputMaybe<TixNotificationContactNotificationBoolExp>;
};

/** Ordering options when selecting data from "notification.contact_notification". */
export type TixNotificationContactNotificationOrderBy = {
  contact?: InputMaybe<TixContactOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  contactNotificationId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  isRead?: InputMaybe<TixOrderBy>;
  notification?: InputMaybe<TixNotificationOrderBy>;
  notificationId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: notification.contact_notification */
export type TixNotificationContactNotificationPkColumnsInput = {
  contactNotificationId: Scalars['uuid'];
};

/** select columns of table "notification.contact_notification" */
export enum TixNotificationContactNotificationSelectColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  ContactNotificationId = 'contactNotificationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  IsRead = 'isRead',
  /** column name */
  NotificationId = 'notificationId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "notification.contact_notification" */
export type TixNotificationContactNotificationSetInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  contactNotificationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  notificationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "notification_contact_notification" */
export type TixNotificationContactNotificationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixNotificationContactNotificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixNotificationContactNotificationStreamCursorValueInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  contactNotificationId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  notificationId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "notification.contact_notification" */
export enum TixNotificationContactNotificationUpdateColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  ContactNotificationId = 'contactNotificationId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  IsRead = 'isRead',
  /** column name */
  NotificationId = 'notificationId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixNotificationContactNotificationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixNotificationContactNotificationSetInput>;
  /** filter the rows which have to be updated */
  where: TixNotificationContactNotificationBoolExp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type TixNumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum TixOrderBy {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "product.order_detail" */
export type TixProductOrderDetail = {
  __typename?: 'product_order_detail';
  active: Scalars['Boolean'];
  amount?: Maybe<Scalars['money']>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  eventProductId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  eventproduct?: Maybe<TixEventProduct>;
  /** An object relationship */
  order?: Maybe<TixOrder>;
  orderDetailId: Scalars['uuid'];
  orderId: Scalars['uuid'];
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "product.order_detail" */
export type TixProductOrderDetailAggregate = {
  __typename?: 'product_order_detail_aggregate';
  aggregate?: Maybe<TixProductOrderDetailAggregateFields>;
  nodes: Array<TixProductOrderDetail>;
};

export type TixProductOrderDetailAggregateBoolExp = {
  bool_and?: InputMaybe<TixProductOrderDetailAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixProductOrderDetailAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixProductOrderDetailAggregateBoolExpCount>;
};

export type TixProductOrderDetailAggregateBoolExpBoolAnd = {
  arguments: TixProductOrderDetailSelectColumnProductOrderDetailAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixProductOrderDetailBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixProductOrderDetailAggregateBoolExpBoolOr = {
  arguments: TixProductOrderDetailSelectColumnProductOrderDetailAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixProductOrderDetailBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixProductOrderDetailAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixProductOrderDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixProductOrderDetailBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "product.order_detail" */
export type TixProductOrderDetailAggregateFields = {
  __typename?: 'product_order_detail_aggregate_fields';
  avg?: Maybe<TixProductOrderDetailAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixProductOrderDetailMaxFields>;
  min?: Maybe<TixProductOrderDetailMinFields>;
  stddev?: Maybe<TixProductOrderDetailStddevFields>;
  stddev_pop?: Maybe<TixProductOrderDetailStddevPopFields>;
  stddev_samp?: Maybe<TixProductOrderDetailStddevSampFields>;
  sum?: Maybe<TixProductOrderDetailSumFields>;
  var_pop?: Maybe<TixProductOrderDetailVarPopFields>;
  var_samp?: Maybe<TixProductOrderDetailVarSampFields>;
  variance?: Maybe<TixProductOrderDetailVarianceFields>;
};


/** aggregate fields of "product.order_detail" */
export type TixProductOrderDetailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixProductOrderDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product.order_detail" */
export type TixProductOrderDetailAggregateOrderBy = {
  avg?: InputMaybe<TixProductOrderDetailAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixProductOrderDetailMaxOrderBy>;
  min?: InputMaybe<TixProductOrderDetailMinOrderBy>;
  stddev?: InputMaybe<TixProductOrderDetailStddevOrderBy>;
  stddev_pop?: InputMaybe<TixProductOrderDetailStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixProductOrderDetailStddevSampOrderBy>;
  sum?: InputMaybe<TixProductOrderDetailSumOrderBy>;
  var_pop?: InputMaybe<TixProductOrderDetailVarPopOrderBy>;
  var_samp?: InputMaybe<TixProductOrderDetailVarSampOrderBy>;
  variance?: InputMaybe<TixProductOrderDetailVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "product.order_detail" */
export type TixProductOrderDetailArrRelInsertInput = {
  data: Array<TixProductOrderDetailInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixProductOrderDetailOnConflict>;
};

/** aggregate avg on columns */
export type TixProductOrderDetailAvgFields = {
  __typename?: 'product_order_detail_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product.order_detail" */
export type TixProductOrderDetailAvgOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "product.order_detail". All fields are combined with a logical 'AND'. */
export type TixProductOrderDetailBoolExp = {
  _and?: InputMaybe<Array<TixProductOrderDetailBoolExp>>;
  _not?: InputMaybe<TixProductOrderDetailBoolExp>;
  _or?: InputMaybe<Array<TixProductOrderDetailBoolExp>>;
  active?: InputMaybe<TixBooleanComparisonExp>;
  amount?: InputMaybe<TixMoneyComparisonExp>;
  comment?: InputMaybe<TixStringComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  eventProductId?: InputMaybe<TixUuidComparisonExp>;
  eventproduct?: InputMaybe<TixEventProductBoolExp>;
  order?: InputMaybe<TixOrderBoolExp>;
  orderDetailId?: InputMaybe<TixUuidComparisonExp>;
  orderId?: InputMaybe<TixUuidComparisonExp>;
  price?: InputMaybe<TixMoneyComparisonExp>;
  quantity?: InputMaybe<TixIntComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  type?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "product.order_detail" */
export enum TixProductOrderDetailConstraint {
  /** unique or primary key constraint on columns "order_detail_id" */
  OrderDetailPkey = 'order_detail_pkey'
}

/** input type for incrementing numeric columns in table "product.order_detail" */
export type TixProductOrderDetailIncInput = {
  amount?: InputMaybe<Scalars['money']>;
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product.order_detail" */
export type TixProductOrderDetailInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['money']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  eventproduct?: InputMaybe<TixEventProductObjRelInsertInput>;
  order?: InputMaybe<TixOrderObjRelInsertInput>;
  orderDetailId?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixProductOrderDetailMaxFields = {
  __typename?: 'product_order_detail_max_fields';
  amount?: Maybe<Scalars['money']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventProductId?: Maybe<Scalars['uuid']>;
  orderDetailId?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product.order_detail" */
export type TixProductOrderDetailMaxOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  comment?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  orderDetailId?: InputMaybe<TixOrderBy>;
  orderId?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixProductOrderDetailMinFields = {
  __typename?: 'product_order_detail_min_fields';
  amount?: Maybe<Scalars['money']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventProductId?: Maybe<Scalars['uuid']>;
  orderDetailId?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product.order_detail" */
export type TixProductOrderDetailMinOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  comment?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  orderDetailId?: InputMaybe<TixOrderBy>;
  orderId?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "product.order_detail" */
export type TixProductOrderDetailMutationResponse = {
  __typename?: 'product_order_detail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixProductOrderDetail>;
};

/** on_conflict condition type for table "product.order_detail" */
export type TixProductOrderDetailOnConflict = {
  constraint: TixProductOrderDetailConstraint;
  update_columns?: Array<TixProductOrderDetailUpdateColumn>;
  where?: InputMaybe<TixProductOrderDetailBoolExp>;
};

/** Ordering options when selecting data from "product.order_detail". */
export type TixProductOrderDetailOrderBy = {
  active?: InputMaybe<TixOrderBy>;
  amount?: InputMaybe<TixOrderBy>;
  comment?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventProductId?: InputMaybe<TixOrderBy>;
  eventproduct?: InputMaybe<TixEventProductOrderBy>;
  order?: InputMaybe<TixOrderOrderBy>;
  orderDetailId?: InputMaybe<TixOrderBy>;
  orderId?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  type?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: product.order_detail */
export type TixProductOrderDetailPkColumnsInput = {
  orderDetailId: Scalars['uuid'];
};

/** select columns of table "product.order_detail" */
export enum TixProductOrderDetailSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventProductId = 'eventProductId',
  /** column name */
  OrderDetailId = 'orderDetailId',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** select "product_order_detail_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product.order_detail" */
export enum TixProductOrderDetailSelectColumnProductOrderDetailAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "product_order_detail_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product.order_detail" */
export enum TixProductOrderDetailSelectColumnProductOrderDetailAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "product.order_detail" */
export type TixProductOrderDetailSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['money']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  orderDetailId?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixProductOrderDetailStddevFields = {
  __typename?: 'product_order_detail_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product.order_detail" */
export type TixProductOrderDetailStddevOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixProductOrderDetailStddevPopFields = {
  __typename?: 'product_order_detail_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product.order_detail" */
export type TixProductOrderDetailStddevPopOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixProductOrderDetailStddevSampFields = {
  __typename?: 'product_order_detail_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product.order_detail" */
export type TixProductOrderDetailStddevSampOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "product_order_detail" */
export type TixProductOrderDetailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixProductOrderDetailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixProductOrderDetailStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['money']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
  orderDetailId?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['money']>;
  quantity?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixProductOrderDetailSumFields = {
  __typename?: 'product_order_detail_sum_fields';
  amount?: Maybe<Scalars['money']>;
  price?: Maybe<Scalars['money']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product.order_detail" */
export type TixProductOrderDetailSumOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** update columns of table "product.order_detail" */
export enum TixProductOrderDetailUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  Amount = 'amount',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventProductId = 'eventProductId',
  /** column name */
  OrderDetailId = 'orderDetailId',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  State = 'state',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixProductOrderDetailUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixProductOrderDetailIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixProductOrderDetailSetInput>;
  /** filter the rows which have to be updated */
  where: TixProductOrderDetailBoolExp;
};

/** aggregate var_pop on columns */
export type TixProductOrderDetailVarPopFields = {
  __typename?: 'product_order_detail_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product.order_detail" */
export type TixProductOrderDetailVarPopOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixProductOrderDetailVarSampFields = {
  __typename?: 'product_order_detail_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product.order_detail" */
export type TixProductOrderDetailVarSampOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixProductOrderDetailVarianceFields = {
  __typename?: 'product_order_detail_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product.order_detail" */
export type TixProductOrderDetailVarianceOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  price?: InputMaybe<TixOrderBy>;
  quantity?: InputMaybe<TixOrderBy>;
};

export type TixQueryRoot = {
  __typename?: 'query_root';
  /** fetch data from the table: "address.address" */
  Address: Array<TixAddress>;
  /** fetch aggregated fields from the table: "address.address" */
  AddressAggregate: TixAddressAggregate;
  /** fetch data from the table: "address.address" using primary key columns */
  AddressByPK?: Maybe<TixAddress>;
  /** fetch data from the table: "utility.business_code_group" */
  BusinessCodeGroup: Array<TixBusinessCodeGroup>;
  /** fetch aggregated fields from the table: "utility.business_code_group" */
  BusinessCodeGroupAggregate: TixBusinessCodeGroupAggregate;
  /** fetch data from the table: "utility.business_codes" */
  BusinessCodes: Array<TixBusinessCodes>;
  /** fetch aggregated fields from the table: "utility.business_codes" */
  BusinessCodesAggregate: TixBusinessCodesAggregate;
  /** fetch data from the table: "utility.business_codes" using primary key columns */
  BusinessCodesByPK?: Maybe<TixBusinessCodes>;
  /** fetch data from the table: "company.company" */
  Company: Array<TixCompany>;
  /** fetch data from the table: "address.company_address" */
  CompanyAddress: Array<TixCompanyAddress>;
  /** fetch aggregated fields from the table: "address.company_address" */
  CompanyAddressAggregate: TixCompanyAddressAggregate;
  /** fetch data from the table: "address.company_address" using primary key columns */
  CompanyAddressByPK?: Maybe<TixCompanyAddress>;
  /** fetch aggregated fields from the table: "company.company" */
  CompanyAggregate: TixCompanyAggregate;
  /** fetch data from the table: "company.company" using primary key columns */
  CompanyByPK?: Maybe<TixCompany>;
  /** fetch data from the table: "configuration.company_configuration_value" */
  CompanyConfigurationValue: Array<TixCompanyConfigurationValue>;
  /** fetch aggregated fields from the table: "configuration.company_configuration_value" */
  CompanyConfigurationValue_aggregate: TixCompanyConfigurationValueAggregate;
  /** fetch data from the table: "configuration.company_configuration_value" using primary key columns */
  CompanyConfigurationValue_by_pk?: Maybe<TixCompanyConfigurationValue>;
  /** fetch data from the table: "contact.company_contact" */
  CompanyContact: Array<TixCompanyContact>;
  /** fetch data from the table: "contact.company_contact" using primary key columns */
  CompanyContactByPK?: Maybe<TixCompanyContact>;
  /** fetch aggregated fields from the table: "contact.company_contact" */
  CompanyContact_aggregate: TixCompanyContactAggregate;
  /** fetch data from the table: "media.company_media_file" */
  CompanyMediaFile: Array<TixCompanyMediaFile>;
  /** fetch aggregated fields from the table: "media.company_media_file" */
  CompanyMediaFileAggregate: TixCompanyMediaFileAggregate;
  /** fetch data from the table: "address.company_phone_number" */
  CompanyPhoneNumber: Array<TixCompanyPhoneNumber>;
  /** fetch aggregated fields from the table: "address.company_phone_number" */
  CompanyPhoneNumberAggregate: TixCompanyPhoneNumberAggregate;
  /** fetch data from the table: "address.company_phone_number" using primary key columns */
  CompanyPhoneNumberByPK?: Maybe<TixCompanyPhoneNumber>;
  /** fetch data from the table: "media.company_social_media" */
  CompanySocialMedia: Array<TixCompanySocialMedia>;
  /** fetch aggregated fields from the table: "media.company_social_media" */
  CompanySocialMediaAggregate: TixCompanySocialMediaAggregate;
  /** fetch data from the table: "media.company_social_media" using primary key columns */
  CompanySocialMediaByPK?: Maybe<TixCompanySocialMedia>;
  /** fetch data from the table: "reporting.v_company_summary_report" */
  CompanySummaryReport: Array<TixCompanySummaryReport>;
  /** fetch aggregated fields from the table: "reporting.v_company_summary_report" */
  CompanySummaryReport_aggregate: TixCompanySummaryReportAggregate;
  /** fetch data from the table: "warning.company_warning" */
  CompanyWarning: Array<TixCompanyWarning>;
  /** fetch aggregated fields from the table: "warning.company_warning" */
  CompanyWarningAggregate: TixCompanyWarningAggregate;
  /** fetch data from the table: "warning.company_warning" using primary key columns */
  CompanyWarningByPK?: Maybe<TixCompanyWarning>;
  /** fetch data from the table: "configuration.configuration_group" */
  ConfigurationGroup: Array<TixConfigurationGroup>;
  /** fetch aggregated fields from the table: "configuration.configuration_group" */
  ConfigurationGroupAggregate: TixConfigurationGroupAggregate;
  /** fetch data from the table: "configuration.configuration_group" using primary key columns */
  ConfigurationGroupByPK?: Maybe<TixConfigurationGroup>;
  /** fetch data from the table: "configuration.configuration_group_item" */
  ConfigurationGroupItem: Array<TixConfigurationGroupItem>;
  /** fetch aggregated fields from the table: "configuration.configuration_group_item" */
  ConfigurationGroupItem_aggregate: TixConfigurationGroupItemAggregate;
  /** fetch data from the table: "configuration.configuration_group_item" using primary key columns */
  ConfigurationGroupItem_by_pk?: Maybe<TixConfigurationGroupItem>;
  /** fetch data from the table: "configuration.configuration_item" */
  ConfigurationItem: Array<TixConfigurationItem>;
  /** fetch aggregated fields from the table: "configuration.configuration_item" */
  ConfigurationItemAggregate: TixConfigurationItemAggregate;
  /** fetch data from the table: "configuration.configuration_item" using primary key columns */
  ConfigurationItemByPK?: Maybe<TixConfigurationItem>;
  /** fetch data from the table: "configuration.configuration_value" */
  ConfigurationValue: Array<TixConfigurationValue>;
  /** fetch aggregated fields from the table: "configuration.configuration_value" */
  ConfigurationValue_aggregate: TixConfigurationValueAggregate;
  /** fetch data from the table: "configuration.configuration_value" using primary key columns */
  ConfigurationValue_by_pk?: Maybe<TixConfigurationValue>;
  /** fetch data from the table: "contact.contact" */
  Contact: Array<TixContact>;
  /** fetch data from the table: "address.contact_address" */
  ContactAddress: Array<TixContactAddress>;
  /** fetch aggregated fields from the table: "address.contact_address" */
  ContactAddressAggregate: TixContactAddressAggregate;
  /** fetch data from the table: "address.contact_address" using primary key columns */
  ContactAddressByPK?: Maybe<TixContactAddress>;
  /** fetch aggregated fields from the table: "contact.contact" */
  ContactAggregate: TixContactAggregate;
  /** fetch data from the table: "contact.contact" using primary key columns */
  ContactByPK?: Maybe<TixContact>;
  /** fetch data from the table: "address.contact_phone_number" */
  ContactPhoneNumber: Array<TixContactPhoneNumber>;
  /** fetch aggregated fields from the table: "address.contact_phone_number" */
  ContactPhoneNumberAggregate: TixContactPhoneNumberAggregate;
  /** fetch data from the table: "address.contact_phone_number" using primary key columns */
  ContactPhoneNumberByPK?: Maybe<TixContactPhoneNumber>;
  /** fetch data from the table: "contact.customer" */
  Customer: Array<TixCustomer>;
  /** fetch aggregated fields from the table: "contact.customer" */
  CustomerAggregate: TixCustomerAggregate;
  /** fetch data from the table: "contact.customer" using primary key columns */
  CustomerByPk?: Maybe<TixCustomer>;
  /** fetch data from the table: "contact.v_customer_search" */
  CustomerSearch: Array<TixCustomerSearch>;
  /** fetch aggregated fields from the table: "contact.v_customer_search" */
  CustomerSearchAggregate: TixCustomerSearchAggregate;
  /** fetch data from the table: "reporting.v_daily_audit" */
  DailyAuditReport: Array<TixDailyAuditReport>;
  /** fetch data from the table: "reporting.v_daily_audit_report_final" */
  DailyAuditReportFinal: Array<TixDailyAuditReportFinal>;
  /** fetch aggregated fields from the table: "reporting.v_daily_audit_report_final" */
  DailyAuditReportFinal_aggregate: TixDailyAuditReportFinalAggregate;
  /** fetch aggregated fields from the table: "reporting.v_daily_audit" */
  DailyAuditReport_aggregate: TixDailyAuditReportAggregate;
  /** fetch data from the table: "reporting.v_daily_ticket_count_report" */
  DailyTicketCountReportSelect: Array<TixDailyTicketCountReport>;
  DailyTicketCountReport_aggregate: TixDailyTicketCountReportAggregate;
  /** fetch data from the table: "discount.discount" */
  Discount: Array<TixDiscount>;
  /** fetch aggregated fields from the table: "discount.discount" */
  DiscountAggregate: TixDiscountAggregate;
  DiscountCodeCountByEven: Array<TixDiscountCodeCountByEvent>;
  DiscountCodeCountByEvent_aggregate: TixDiscountCodeCountByEventAggregate;
  /** fetch data from the table: "reporting.v_discount_report" */
  DiscountReport: Array<TixReportingVDiscountReport>;
  /** fetch data from the table: "communications.email_content" */
  EmailContentSelect: Array<TixEmailContent>;
  /** fetch data from the table: "communications.email_content" using primary key columns */
  EmailContentSelectByPK?: Maybe<TixEmailContent>;
  EmailContent_aggregate: TixEmailContentAggregate;
  /** fetch data from the table: "event.event" */
  Event: Array<TixEvent>;
  /** fetch aggregated fields from the table: "event.event" */
  EventAggregate: TixEventAggregate;
  /** fetch data from the table: "event.event" using primary key columns */
  EventByPK?: Maybe<TixEvent>;
  /** fetch data from the table: "event.company_venue_event_list" */
  EventCompanyVenue: Array<TixEventCompanyVenue>;
  /** fetch aggregated fields from the table: "event.company_venue_event_list" */
  EventCompanyVenueAggregate: TixEventCompanyVenueAggregate;
  /** fetch data from the table: "communications.event_email" */
  EventEmailSelect: Array<TixEventEmail>;
  EventEmail_aggregate: TixEventEmailAggregate;
  /** fetch data from the table: "event.event_instance" */
  EventInstance: Array<TixEventInstance>;
  /** fetch aggregated fields from the table: "event.event_instance" */
  EventInstanceAggregate: TixEventInstanceAggregate;
  /** fetch data from the table: "event.event_instance" using primary key columns */
  EventInstanceByPK?: Maybe<TixEventInstance>;
  /** fetch data from the table: "configuration.event_instance_configuration_value" */
  EventInstanceConfigurationValue: Array<TixEventInstanceConfigurationValue>;
  /** fetch aggregated fields from the table: "configuration.event_instance_configuration_value" */
  EventInstanceConfigurationValueAggregate: TixEventInstanceConfigurationValueAggregate;
  /** fetch data from the table: "configuration.event_instance_configuration_value" using primary key columns */
  EventInstanceConfigurationValueByPK?: Maybe<TixEventInstanceConfigurationValue>;
  /** fetch data from the table: "discount.event_instance_discount" */
  EventInstanceDiscount: Array<TixEventInstanceDiscount>;
  /** fetch aggregated fields from the table: "discount.event_instance_discount" */
  EventInstanceDiscountAggregate: TixEventInstanceDiscountAggregate;
  /** fetch data from the table: "media.event_instance_media_file" */
  EventInstanceMedialFile: Array<TixEventInstanceMedialFile>;
  /** fetch aggregated fields from the table: "media.event_instance_media_file" */
  EventInstanceMedialFileAggregate: TixEventInstanceMedialFileAggregate;
  /** fetch data from the table: "media.event_instance_media_file" using primary key columns */
  EventInstanceMedialFileByPK?: Maybe<TixEventInstanceMedialFile>;
  /** fetch data from the table: "media.event_instance_social_media" */
  EventInstanceSocialMediaFile: Array<TixEventInstanceSocialMediaFile>;
  /** fetch aggregated fields from the table: "media.event_instance_social_media" */
  EventInstanceSocialMediaFileAggregate: TixEventInstanceSocialMediaFileAggregate;
  /** fetch data from the table: "ticket.event_instance_ticket" */
  EventInstanceTicket: Array<TixEventInstanceTicket>;
  /** fetch aggregated fields from the table: "ticket.event_instance_ticket" */
  EventInstanceTicketAggregate: TixEventInstanceTicketAggregate;
  /** fetch data from the table: "ticket.event_instance_ticket" using primary key columns */
  EventInstanceTicketByPK?: Maybe<TixEventInstanceTicket>;
  /** fetch data from the table: "ticket.event_instance_ticket_config" */
  EventInstanceTicketConfig: Array<TixEventInstanceTicketConfig>;
  /** fetch aggregated fields from the table: "ticket.event_instance_ticket_config" */
  EventInstanceTicketConfigAggregate: TixEventInstanceTicketConfigAggregate;
  /** fetch data from the table: "ticket.event_instance_ticket_config" using primary key columns */
  EventInstanceTicketConfigByPK?: Maybe<TixEventInstanceTicketConfig>;
  /** fetch data from the table: "performer.event_lineup" */
  EventLineup: Array<TixEventLineup>;
  /** fetch aggregated fields from the table: "performer.event_lineup" */
  EventLineupAggregate: TixEventLineupAggregate;
  /** fetch data from the table: "event.v_event_list" */
  EventList: Array<TixEventList>;
  /** fetch aggregated fields from the table: "event.v_event_list" */
  EventListAggregate: TixEventListAggregate;
  /** fetch data from the table: "performer.event_performers" */
  EventPerformers: Array<TixEventPerformers>;
  /** fetch aggregated fields from the table: "performer.event_performers" */
  EventPerformersAggregate: TixEventPerformersAggregate;
  /** fetch data from the table: "performer.event_performers" using primary key columns */
  EventPerformersByPK?: Maybe<TixEventPerformers>;
  /** fetch aggregated fields from the table: "product.event_product" */
  EventProductAggregate: TixEventProductAggregate;
  /** fetch aggregated fields from the table: "media.event_product_media_file" */
  EventProductMediaAggregate: TixEventProductMediaAggregate;
  /** fetch data from the table: "media.event_product_media_file" */
  EventProductMediaSelect: Array<TixEventProductMedia>;
  /** fetch data from the table: "media.event_product_media_file" using primary key columns */
  EventProductMediaSelectByPK?: Maybe<TixEventProductMedia>;
  /** fetch data from the table: "product.event_product" */
  EventProductSelect: Array<TixEventProduct>;
  /** fetch data from the table: "product.event_product" using primary key columns */
  EventProductSelectByPK?: Maybe<TixEventProduct>;
  /** fetch data from the table: "event.event_venue" */
  EventVenue: Array<TixEventVenue>;
  /** fetch aggregated fields from the table: "event.event_venue" */
  EventVenueAggregate: TixEventVenueAggregate;
  /** fetch data from the table: "event.event_venue" using primary key columns */
  EventVenueByPK?: Maybe<TixEventVenue>;
  /** fetch data from the table: "performer.lineup" */
  Lineup: Array<TixLineup>;
  /** fetch aggregated fields from the table: "performer.lineup" */
  LineupAggregate: TixLineupAggregate;
  /** fetch data from the table: "performer.lineup_performer" */
  LineupPerformer: Array<TixLineupPerformer>;
  /** fetch aggregated fields from the table: "performer.lineup_performer" */
  LineupPerformerAggregate: TixLineupPerformerAggregate;
  /** fetch data from the table: "reporting.logging" */
  Logging: Array<TixLogging>;
  Logging_aggregate: TixLoggingAggregate;
  Logging_by_pk?: Maybe<TixLogging>;
  /** fetch data from the table: "media.media_file" */
  MediaFile: Array<TixMediaFile>;
  /** fetch aggregated fields from the table: "media.media_file" */
  MediaFileAggregate: TixMediaFileAggregate;
  /** fetch data from the table: "notification.notification" */
  Notification: Array<TixNotification>;
  /** fetch aggregated fields from the table: "notification.notification" */
  NotificationAggregate: TixNotificationAggregate;
  /** fetch data from the table: "notification.notification" using primary key columns */
  NotificationByPK?: Maybe<TixNotification>;
  /** fetch aggregated fields from the table: "product.order" */
  OrderAggregate: TixOrderAggregate;
  /** fetch data from the table: "product.order" */
  OrderSelect: Array<TixOrder>;
  /** fetch data from the table: "product.order" using primary key columns */
  OrderSelectByPK?: Maybe<TixOrder>;
  /** fetch data from the table: "event.v_patron_events_list" */
  PatronEventList: Array<TixPatronEventList>;
  /** fetch aggregated fields from the table: "event.v_patron_events_list" */
  PatronEventListAggregate: TixPatronEventListAggregate;
  /** fetch data from the table: "event.v_patron_filtered_events_list" */
  PatronFIlteredEventsList: Array<TixPatronFIlteredEventsList>;
  /** fetch aggregated fields from the table: "event.v_patron_filtered_events_list" */
  PatronFIlteredEventsListAggregate: TixPatronFIlteredEventsListAggregate;
  /** fetch data from the table: "payment.payment" */
  Payment: Array<TixPayment>;
  /** fetch aggregated fields from the table: "payment.payment" */
  PaymentAggregate: TixPaymentAggregate;
  /** fetch data from the table: "payment.payment_discount" */
  PaymentDiscount: Array<TixPaymentDiscount>;
  /** fetch aggregated fields from the table: "payment.payment_discount" */
  PaymentDiscountAggregate: TixPaymentDiscountAggregate;
  /** fetch data from the table: "payment.vendor_payment_log" */
  PaymentVendorLog: Array<TixPaymentVendorLog>;
  /** fetch aggregated fields from the table: "payment.vendor_payment_log" */
  PaymentVendorLogAggregate: TixPaymentVendorLogAggregate;
  /** fetch data from the table: "payment.payout" */
  Payout: Array<TixPayout>;
  /** fetch aggregated fields from the table: "payment.payout" */
  PayoutAggregate: TixPayoutAggregate;
  /** fetch data from the table: "payment.payout" using primary key columns */
  PayoutByPK?: Maybe<TixPayout>;
  /** fetch data from the table: "payment.payout_connection" */
  PayoutConnectSelect: Array<TixPayoutConnect>;
  /** fetch aggregated fields from the table: "payment.payout_connection" */
  PayoutConnect_aggregate: TixPayoutConnectAggregate;
  /** fetch data from the table: "payment.payout_connection" using primary key columns */
  PayoutConnect_by_pk?: Maybe<TixPayoutConnect>;
  /** fetch data from the table: "payment.payout_detail" */
  PayoutDetail: Array<TixPayoutDetail>;
  /** fetch aggregated fields from the table: "payment.payout_detail" */
  PayoutDetail_aggregate: TixPayoutDetailAggregate;
  /** fetch data from the table: "payment.payout_detail" using primary key columns */
  PayoutDetail_by_pk?: Maybe<TixPayoutDetail>;
  /** fetch data from the table: "performer.performer" */
  Performer: Array<TixPerformer>;
  /** fetch aggregated fields from the table: "performer.performer" */
  PerformerAggregate: TixPerformerAggregate;
  /** fetch data from the table: "access.permission" */
  Permission: Array<TixPermission>;
  /** fetch aggregated fields from the table: "access.permission" */
  PermissionAggregate: TixPermissionAggregate;
  /** fetch data from the table: "address.phone_number" */
  PhoneNumber: Array<TixPhoneNumber>;
  /** fetch aggregated fields from the table: "address.phone_number" */
  PhoneNumberAggregate: TixPhoneNumberAggregate;
  /** fetch data from the table: "address.phone_number" using primary key columns */
  PhoneNumberByPK?: Maybe<TixPhoneNumber>;
  /** fetch data from the table: "utility.policy" */
  Policy: Array<TixUtilityPolicy>;
  /** fetch aggregated fields from the table: "product.product" */
  ProductAggregate: TixProductAggregate;
  /** fetch aggregated fields from the table: "media.product_media_file" */
  ProductMediaFileAggregate: TixProductMediaFileAggregate;
  /** fetch data from the table: "media.product_media_file" */
  ProductMediaFileSelect: Array<TixProductMediaFile>;
  /** fetch data from the table: "media.product_media_file" using primary key columns */
  ProductMediaFileSelectByPK?: Maybe<TixProductMediaFile>;
  /** fetch data from the table: "product.product" */
  ProductSelect: Array<TixProduct>;
  /** fetch data from the table: "product.product" using primary key columns */
  ProductSelectByPK?: Maybe<TixProduct>;
  /** fetch data from the table: "reporting.v_refunds_by_event" */
  RefundsByEvent: Array<TixReportingVRefundsByEvent>;
  /** fetch data from the table: "ticket.reservation" */
  Reservation: Array<TixTicketReservation>;
  /** fetch aggregated fields from the table: "ticket.reservation" */
  ReservationAggregate: TixTicketReservationAggregate;
  /** fetch data from the table: "ticket.reservation" using primary key columns */
  ReservationByPK?: Maybe<TixTicketReservation>;
  /** fetch data from the table: "payment.reservation_payment" */
  ReservationPayment: Array<TixReservationPayment>;
  /** fetch aggregated fields from the table: "payment.reservation_payment" */
  ReservationPaymentAggregate: TixReservationPaymentAggregate;
  /** An array relationship */
  RevenueByChannelType: Array<TixRevenueByChannelType>;
  /** An aggregate relationship */
  RevenueByChannelType_aggregate: TixRevenueByChannelTypeAggregate;
  /** fetch data from the table: "access.role" */
  Role: Array<TixRole>;
  /** fetch aggregated fields from the table: "access.role" */
  RoleAggregate: TixRoleAggregate;
  /** fetch aggregated fields from the table: "access.role_permission" */
  RolePermissionAggregate: TixRolePermissionAggregate;
  /** fetch data from the table: "utility.business_code_group" using primary key columns */
  SelectBusinessCodeGroupByPK?: Maybe<TixBusinessCodeGroup>;
  /** fetch data from the table: "media.company_media_file" using primary key columns */
  SelectCompanyMediaFileByPK?: Maybe<TixCompanyMediaFile>;
  /** fetch data from the table: "discount.discount" using primary key columns */
  SelectDiscountByPK?: Maybe<TixDiscount>;
  /** fetch data from the table: "discount.event_instance_discount" using primary key columns */
  SelectEventInstanceDiscountByPK?: Maybe<TixEventInstanceDiscount>;
  /** fetch data from the table: "media.event_instance_social_media" using primary key columns */
  SelectEventInstanceSocialMediaFileByPK?: Maybe<TixEventInstanceSocialMediaFile>;
  /** fetch data from the table: "performer.event_lineup" using primary key columns */
  SelectEventLineupByPK?: Maybe<TixEventLineup>;
  /** fetch data from the table: "performer.lineup" using primary key columns */
  SelectLineupByPK?: Maybe<TixLineup>;
  /** fetch data from the table: "performer.lineup_performer" using primary key columns */
  SelectLineupPerformerByPK?: Maybe<TixLineupPerformer>;
  /** fetch data from the table: "media.media_file" using primary key columns */
  SelectMediaFilebyPK?: Maybe<TixMediaFile>;
  /** fetch data from the table: "payment.payment" using primary key columns */
  SelectPaymentByPK?: Maybe<TixPayment>;
  /** fetch data from the table: "payment.payment_discount" using primary key columns */
  SelectPaymentDiscountByPK?: Maybe<TixPaymentDiscount>;
  /** fetch data from the table: "payment.vendor_payment_log" using primary key columns */
  SelectPaymentVendorLogByPK?: Maybe<TixPaymentVendorLog>;
  /** fetch data from the table: "performer.performer" using primary key columns */
  SelectPerformerByPK?: Maybe<TixPerformer>;
  /** fetch data from the table: "access.permission" using primary key columns */
  SelectPermissionByPK?: Maybe<TixPermission>;
  /** fetch data from the table: "payment.reservation_payment" using primary key columns */
  SelectReservationPaymentByPK?: Maybe<TixReservationPayment>;
  /** fetch data from the table: "access.role" using primary key columns */
  SelectRoleByPK?: Maybe<TixRole>;
  /** fetch data from the table: "access.role_permission" */
  SelectRolePermission: Array<TixRolePermission>;
  /** fetch data from the table: "access.role_permission" using primary key columns */
  SelectRolePermissionByPK?: Maybe<TixRolePermission>;
  /** fetch data from the table: "access.user" */
  SelectUser: Array<TixUser>;
  /** fetch data from the table: "access.user" using primary key columns */
  SelectUserByPK?: Maybe<TixUser>;
  /** fetch data from the table: "access.user_role" */
  SelectUserRole: Array<TixUserRole>;
  /** fetch data from the table: "access.user_role" using primary key columns */
  SelectUserRoleByPK?: Maybe<TixUserRole>;
  /** fetch aggregated fields from the table: "discount.venue_discount" */
  SelectVenueDiscountAggregate: TixVenueDiscountAggregate;
  /** fetch data from the table: "discount.venue_discount" using primary key columns */
  SelectVenueDiscountByPK?: Maybe<TixVenueDiscount>;
  /** fetch data from the table: "performer.venue_lineup" using primary key columns */
  SelectVenueLineupByPK?: Maybe<TixVenueLineup>;
  /** fetch data from the table: "media.social_media" */
  SocialMedia: Array<TixSocialMedia>;
  /** fetch aggregated fields from the table: "media.social_media" */
  SocialMediaAggregate: TixSocialMediaAggregate;
  /** fetch data from the table: "media.social_media" using primary key columns */
  SocialMediaByPK?: Maybe<TixSocialMedia>;
  /** fetch data from the table: "ticket.ticket" */
  Ticket: Array<TixTicket>;
  /** fetch aggregated fields from the table: "ticket.ticket" */
  TicketAggregate: TixTicketAggregate;
  /** fetch data from the table: "ticket.ticket" using primary key columns */
  TicketByPK?: Maybe<TixTicket>;
  /** fetch data from the table: "ticket.ticket_config" */
  TicketConfig: Array<TixTicketConfig>;
  /** fetch aggregated fields from the table: "ticket.ticket_config" */
  TicketConfigAggregate: TixTicketConfigAggregate;
  /** fetch data from the table: "ticket.ticket_config" using primary key columns */
  TicketConfigByPK?: Maybe<TixTicketConfig>;
  /** fetch data from the table: "reporting.v_ticket_count_by_sales_channel" */
  TicketCountByChannelType: Array<TixTicketCountByChannelType>;
  TicketCountByChannelType_aggregate: TixTicketCountByChannelTypeAggregate;
  /** fetch data from the table: "reporting.v_ticket_count_by_event" */
  TicketCountByEvent: Array<TixTicketCountByEvent>;
  TicketCountByEvent_aggregate: TixTicketCountByEventAggregate;
  /** fetch data from the table: "reporting.v_ticket_count_by_name" */
  TicketCountByName: Array<TixTicketCountByName>;
  TicketCountByName_aggregate: TixTicketCountByNameAggregate;
  /** fetch data from the table: "reporting.v_ticket_count_by_channel_type" */
  TicketCountByRevenueType: Array<TixTicketCountByRevenueType>;
  /** fetch aggregated fields from the table: "reporting.v_ticket_count_by_channel_type" */
  TicketCountByRevenueType_aggregate: TixTicketCountByRevenueTypeAggregate;
  /** fetch aggregated fields from the table: "ticket.reservation_detail" */
  TicketReservationDetailAggregate: TixTicketReservationDetailAggregate;
  /** fetch data from the table: "ticket.reservation_detail" */
  TicketReservationDetailSelect: Array<TixTicketReservationDetail>;
  /** fetch data from the table: "ticket.reservation_detail" using primary key columns */
  TicketReservationDetailSelectByPK?: Maybe<TixTicketReservationDetail>;
  /** fetch aggregated fields from the table: "access.user" */
  UserAggregate: TixUserAggregate;
  /** fetch aggregated fields from the table: "access.user_role" */
  UserRoleAggregate: TixUserRoleAggregate;
  /** fetch data from the table: "venue.venue" */
  Venue: Array<TixVenue>;
  /** fetch data from the table: "address.venue_address" */
  VenueAddress: Array<TixVenueAddress>;
  /** fetch aggregated fields from the table: "address.venue_address" */
  VenueAddressAggregate: TixVenueAddressAggregate;
  /** fetch data from the table: "address.venue_address" using primary key columns */
  VenueAddressByPK?: Maybe<TixVenueAddress>;
  /** fetch aggregated fields from the table: "venue.venue" */
  VenueAggregate: TixVenueAggregate;
  /** fetch data from the table: "venue.venue" using primary key columns */
  VenueByPK?: Maybe<TixVenue>;
  /** fetch data from the table: "configuration.venue_configuration_value" */
  VenueConfigurationValue: Array<TixVenueConfigurationValue>;
  /** fetch aggregated fields from the table: "configuration.venue_configuration_value" */
  VenueConfigurationValueAggregate: TixVenueConfigurationValueAggregate;
  /** fetch data from the table: "configuration.venue_configuration_value" using primary key columns */
  VenueConfigurationValueByPK?: Maybe<TixVenueConfigurationValue>;
  /** fetch data from the table: "contact.venue_contact" */
  VenueContact: Array<TixVenueContact>;
  /** fetch aggregated fields from the table: "contact.venue_contact" */
  VenueContactAggregate: TixVenueContactAggregate;
  /** fetch data from the table: "contact.venue_contact" using primary key columns */
  VenueContactByPK?: Maybe<TixVenueContact>;
  /** fetch data from the table: "discount.venue_discount" */
  VenueDiscount: Array<TixVenueDiscount>;
  /** fetch data from the table: "performer.venue_lineup" */
  VenueLineup: Array<TixVenueLineup>;
  /** fetch aggregated fields from the table: "performer.venue_lineup" */
  VenueLineupAggregate: TixVenueLineupAggregate;
  /** fetch data from the table: "media.venue_media_file" */
  VenueMediaFile: Array<TixVenueMediaFile>;
  /** fetch aggregated fields from the table: "media.venue_media_file" */
  VenueMediaFileAggregate: TixVenueMediaFileAggregate;
  /** fetch data from the table: "media.venue_media_file" using primary key columns */
  VenueMediaFileByPK?: Maybe<TixVenueMediaFile>;
  /** fetch data from the table: "address.venue_phone_number" */
  VenuePhoneNumber: Array<TixVenuePhoneNumber>;
  /** fetch aggregated fields from the table: "address.venue_phone_number" */
  VenuePhoneNumberAggregate: TixVenuePhoneNumberAggregate;
  /** fetch data from the table: "address.venue_phone_number" using primary key columns */
  VenuePhoneNumberByPK?: Maybe<TixVenuePhoneNumber>;
  /** fetch aggregated fields from the table: "product.venue_product" */
  VenueProductAggregate: TixVenueProductAggregate;
  /** fetch data from the table: "product.venue_product" */
  VenueProductSelect: Array<TixVenueProduct>;
  /** fetch data from the table: "product.venue_product" using primary key columns */
  VenueProductSelectByPK?: Maybe<TixVenueProduct>;
  /** fetch data from the table: "media.venue_social_media" */
  VenueSocialMedia: Array<TixVenueSocialMedia>;
  /** fetch aggregated fields from the table: "media.venue_social_media" */
  VenueSocialMediaAggregate: TixVenueSocialMediaAggregate;
  /** fetch data from the table: "media.venue_social_media" using primary key columns */
  VenueSocialMediaByPK?: Maybe<TixVenueSocialMedia>;
  /** fetch data from the table: "ticket.venue_ticket" */
  VenueTicket: Array<TixVenueTicket>;
  /** fetch aggregated fields from the table: "ticket.venue_ticket" */
  VenueTicketAggregate: TixVenueTicketAggregate;
  /** fetch data from the table: "ticket.venue_ticket" using primary key columns */
  VenueTicketByPK?: Maybe<TixVenueTicket>;
  /** fetch data from the table: "ticket.venue_ticket_config" */
  VenueTicketConfig: Array<TixVenueTicketConfig>;
  /** fetch aggregated fields from the table: "ticket.venue_ticket_config" */
  VenueTicketConfigAggregate: TixVenueTicketConfigAggregate;
  /** fetch data from the table: "ticket.venue_ticket_config" using primary key columns */
  VenueTicketConfigByPK?: Maybe<TixVenueTicketConfig>;
  /** fetch data from the table: "warning.venue_warning" */
  VenueWarning: Array<TixVenueWarning>;
  /** fetch aggregated fields from the table: "warning.venue_warning" */
  VenueWarningAggregate: TixVenueWarningAggregate;
  /** fetch data from the table: "warning.venue_warning" using primary key columns */
  VenueWarningByPK?: Maybe<TixVenueWarning>;
  /** fetch data from the table: "warning.warning" */
  Warning: Array<TixWarning>;
  /** fetch aggregated fields from the table: "warning.warning" */
  WarningAggregate: TixWarningAggregate;
  /** fetch data from the table: "warning.warning" using primary key columns */
  WarningByPK?: Maybe<TixWarning>;
  /** fetch data from the table: "address.performer_phone_number" */
  address_performer_phone_number: Array<TixAddressPerformerPhoneNumber>;
  /** fetch aggregated fields from the table: "address.performer_phone_number" */
  address_performer_phone_number_aggregate: TixAddressPerformerPhoneNumberAggregate;
  /** fetch data from the table: "address.performer_phone_number" using primary key columns */
  address_performer_phone_number_by_pk?: Maybe<TixAddressPerformerPhoneNumber>;
  calculateAvailableTicketStats?: Maybe<TixAvailableBreakdown>;
  canRequestPayout: Scalars['Boolean'];
  /** fetch data from the table: "communications.company_email" */
  communications_company_email: Array<TixCommunicationsCompanyEmail>;
  /** fetch aggregated fields from the table: "communications.company_email" */
  communications_company_email_aggregate: TixCommunicationsCompanyEmailAggregate;
  /** fetch data from the table: "communications.email_content_variable" */
  communications_email_content_variable: Array<TixCommunicationsEmailContentVariable>;
  /** fetch aggregated fields from the table: "communications.email_content_variable" */
  communications_email_content_variable_aggregate: TixCommunicationsEmailContentVariableAggregate;
  /** fetch data from the table: "communications.email_content_variable" using primary key columns */
  communications_email_content_variable_by_pk?: Maybe<TixCommunicationsEmailContentVariable>;
  /** fetch data from the table: "communications.email_variable" */
  communications_email_variable: Array<TixCommunicationsEmailVariable>;
  /** fetch aggregated fields from the table: "communications.email_variable" */
  communications_email_variable_aggregate: TixCommunicationsEmailVariableAggregate;
  /** fetch data from the table: "communications.email_variable" using primary key columns */
  communications_email_variable_by_pk?: Maybe<TixCommunicationsEmailVariable>;
  /** fetch data from the table: "communications.venue_email" */
  communications_venue_email: Array<TixCommunicationsVenueEmail>;
  /** fetch aggregated fields from the table: "communications.venue_email" */
  communications_venue_email_aggregate: TixCommunicationsVenueEmailAggregate;
  /** fetch data from the table: "reporting.v_event_summary_report" */
  eventSummaryReport: Array<TixEventSummaryReport>;
  /** fetch aggregated fields from the table: "reporting.v_event_summary_report" */
  eventSummaryReportAggregate: TixEventSummaryReportAggregate;
  /** fetch data from the table: "event.campaign_tracking" */
  event_campaign_tracking: Array<TixEventCampaignTracking>;
  /** fetch aggregated fields from the table: "event.campaign_tracking" */
  event_campaign_tracking_aggregate: TixEventCampaignTrackingAggregate;
  /** fetch data from the table: "event.campaign_tracking" using primary key columns */
  event_campaign_tracking_by_pk?: Maybe<TixEventCampaignTracking>;
  /** fetch data from the table: "fees.fees" */
  fees: Array<TixFees>;
  /** fetch aggregated fields from the table: "fees.fees" */
  feesAggregate: TixFeesAggregate;
  /** fetch data from the table: "fees.fees" using primary key columns */
  feesByPk?: Maybe<TixFees>;
  genericGetOrderItemsOnHoldByOtherUsers: Array<TixExternalOrderHoldItemResult>;
  genericGetOrderOnHold: Array<TixOrderHoldItemResult>;
  getAmountToPayForOrder: Scalars['Float'];
  getAppleWalletPassUrl?: Maybe<Scalars['String']>;
  getDiscountData: TixDiscountData;
  getEventFinancialBreakdown: TixEventFinancialBreakdown;
  getEventFinancialReportDetails: TixEventFinancialReportDetails;
  getEventFinancialReportDetailsForCsv?: Maybe<Array<TixEventFinancialReportDetailsForCsv>>;
  getEventRevenue: Scalars['Float'];
  getGoogleWalletUrl?: Maybe<Scalars['String']>;
  getNumberOfTicketsOnHoldForTicketConfig: Scalars['Float'];
  getOrderFromHold: Array<TixTicketOnHoldResult>;
  getOtherUsersOnHoldTickets: Array<TixTicketOnHoldResult>;
  getPaymentExchangeData: TixGqlPaymentExchangeData;
  getProductSalesReport: Array<TixProductSalesReport>;
  getProductSalesReportForCsv: Scalars['String'];
  getRefundAmountDonations?: Maybe<Scalars['JSON']>;
  getRefundAmountForAddons?: Maybe<Scalars['JSON']>;
  getRefundAmountForTicket?: Maybe<Scalars['JSON']>;
  getRefundAmountReservation?: Maybe<Scalars['JSON']>;
  getReservationTicketsZip: Scalars['String'];
  getTicketExchangeRequiredAction: TixTicketExchangeActionOutput;
  getTicketPDFUrls: Array<Scalars['String']>;
  getTicketPDFsZipUrl: Scalars['String'];
  hasPasscode?: Maybe<Scalars['Boolean']>;
  isValidDiscountCode?: Maybe<Scalars['Boolean']>;
  isValidToken?: Maybe<Scalars['Boolean']>;
  /** fetch data from the table: "notification.contact_notification" */
  notification_contact_notification: Array<TixNotificationContactNotification>;
  /** fetch aggregated fields from the table: "notification.contact_notification" */
  notification_contact_notification_aggregate: TixNotificationContactNotificationAggregate;
  /** fetch data from the table: "notification.contact_notification" using primary key columns */
  notification_contact_notification_by_pk?: Maybe<TixNotificationContactNotification>;
  /** fetch data from the table: "product.order_detail" */
  product_order_detail: Array<TixProductOrderDetail>;
  /** fetch aggregated fields from the table: "product.order_detail" */
  product_order_detail_aggregate: TixProductOrderDetailAggregate;
  /** fetch data from the table: "product.order_detail" using primary key columns */
  product_order_detail_by_pk?: Maybe<TixProductOrderDetail>;
  /** fetch aggregated fields from the table: "reporting.v_discount_report" */
  reporting_v_discount_report_aggregate: TixReportingVDiscountReportAggregate;
  reporting_v_refunds_by_event_aggregate: TixReportingVRefundsByEventAggregate;
  /** fetch data from the table: "reporting.v_ticket_detail_report" */
  reporting_v_ticket_detail_report: Array<TixReportingVTicketDetailReport>;
  /** fetch aggregated fields from the table: "reporting.v_ticket_detail_report" */
  reporting_v_ticket_detail_report_aggregate: TixReportingVTicketDetailReportAggregate;
  /** fetch data from the table: "reporting.v_reservation_detail_report" */
  reservationDetailReport: Array<TixReservationDetailReport>;
  /** fetch aggregated fields from the table: "reporting.v_reservation_detail_report" */
  reservationDetailReportAggregate: TixReservationDetailReportAggregate;
  /** fetch data from the table: "reporting.reservation_report" */
  reservationReport: Array<TixReservationReport>;
  /** fetch aggregated fields from the table: "reporting.reservation_report" */
  reservationReportAggregate: TixReservationReportAggregate;
  /** fetch data from the table: "reporting.reservation_report" using primary key columns */
  reservationReportByPK?: Maybe<TixReservationReport>;
  /** fetch data from the table: "reporting.v_reservation_summary_report" */
  reservationSummaryReport: Array<TixReservationSummaryReport>;
  /** fetch aggregated fields from the table: "reporting.v_reservation_summary_report" */
  reservationSummaryReportAggregate: TixReservationSummaryReportAggregate;
  /** fetch data from the table: "reporting.saved_report" */
  savedReport: Array<TixSavedReport>;
  /** An array relationship */
  savedReportEvents: Array<TixSavedReportEvents>;
  /** An aggregate relationship */
  savedReportEvents_aggregate: TixSavedReportEventsAggregate;
  /** fetch data from the table: "reporting.saved_report_events" using primary key columns */
  savedReportEvents_by_pk?: Maybe<TixSavedReportEvents>;
  /** fetch data from the table: "reporting.saved_report_layout" */
  savedReportLayout: Array<TixSavedReportLayout>;
  /** fetch aggregated fields from the table: "reporting.saved_report_layout" */
  savedReportLayout_aggregate: TixSavedReportLayoutAggregate;
  /** fetch data from the table: "reporting.saved_report_layout" using primary key columns */
  savedReportLayout_by_pk?: Maybe<TixSavedReportLayout>;
  /** fetch aggregated fields from the table: "reporting.saved_report" */
  savedReport_aggregate: TixSavedReportAggregate;
  /** fetch data from the table: "reporting.saved_report" using primary key columns */
  savedReport_by_pk?: Maybe<TixSavedReport>;
  /** fetch data from the table: "reporting.scheduled_report" */
  scheduledReport: Array<TixScheduledReport>;
  /** fetch data from the table: "reporting.scheduled_report_email" */
  scheduledReportEmail: Array<TixScheduledReportEmail>;
  /** fetch aggregated fields from the table: "reporting.scheduled_report_email" */
  scheduledReportEmail_aggregate: TixScheduledReportEmailAggregate;
  /** fetch data from the table: "reporting.scheduled_report_email" using primary key columns */
  scheduledReportEmail_by_pk?: Maybe<TixScheduledReportEmail>;
  /** fetch aggregated fields from the table: "reporting.scheduled_report" */
  scheduledReport_aggregate: TixScheduledReportAggregate;
  /** fetch data from the table: "reporting.scheduled_report" using primary key columns */
  scheduledReport_by_pk?: Maybe<TixScheduledReport>;
  /** fetch data from the table: "ticket.exchange" */
  ticket_exchange: Array<TixTicketExchange>;
  /** fetch aggregated fields from the table: "ticket.exchange" */
  ticket_exchange_aggregate: TixTicketExchangeAggregate;
  /** fetch data from the table: "ticket.exchange" using primary key columns */
  ticket_exchange_by_pk?: Maybe<TixTicketExchange>;
  /** fetch data from the table: "ticket.ticket_discount" */
  ticket_ticket_discount: Array<TixTicketTicketDiscount>;
  /** fetch aggregated fields from the table: "ticket.ticket_discount" */
  ticket_ticket_discount_aggregate: TixTicketTicketDiscountAggregate;
  /** fetch data from the table: "ticket.ticket_discount" using primary key columns */
  ticket_ticket_discount_by_pk?: Maybe<TixTicketTicketDiscount>;
  /** fetch data from the table: "ticket.v_ticket_count_by_type" */
  ticket_v_ticket_count_by_type: Array<TixTicketVTicketCountByType>;
  /** fetch aggregated fields from the table: "ticket.v_ticket_count_by_type" */
  ticket_v_ticket_count_by_type_aggregate: TixTicketVTicketCountByTypeAggregate;
  /** fetch data from the table: "ticket.v_ticket_sales_metrics" */
  ticket_v_ticket_sales_metrics: Array<TixTicketVTicketSalesMetrics>;
  /** fetch aggregated fields from the table: "ticket.v_ticket_sales_metrics" */
  ticket_v_ticket_sales_metrics_aggregate: TixTicketVTicketSalesMetricsAggregate;
  /** fetch aggregated fields from the table: "utility.policy" */
  utility_policy_aggregate: TixUtilityPolicyAggregate;
  /** fetch data from the table: "utility.policy" using primary key columns */
  utility_policy_by_pk?: Maybe<TixUtilityPolicy>;
  /** fetch data from the table: "utility.timestamp_by_timezone" */
  utility_timestamp_by_timezone: Array<TixUtilityTimestampByTimezone>;
  /** fetch aggregated fields from the table: "utility.timestamp_by_timezone" */
  utility_timestamp_by_timezone_aggregate: TixUtilityTimestampByTimezoneAggregate;
};


export type TixQueryRootAddressArgs = {
  distinct_on?: InputMaybe<Array<TixAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressOrderBy>>;
  where?: InputMaybe<TixAddressBoolExp>;
};


export type TixQueryRootAddressAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressOrderBy>>;
  where?: InputMaybe<TixAddressBoolExp>;
};


export type TixQueryRootAddressByPkArgs = {
  addressId: Scalars['uuid'];
};


export type TixQueryRootBusinessCodeGroupArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodeGroupOrderBy>>;
  where?: InputMaybe<TixBusinessCodeGroupBoolExp>;
};


export type TixQueryRootBusinessCodeGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodeGroupOrderBy>>;
  where?: InputMaybe<TixBusinessCodeGroupBoolExp>;
};


export type TixQueryRootBusinessCodesArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodesOrderBy>>;
  where?: InputMaybe<TixBusinessCodesBoolExp>;
};


export type TixQueryRootBusinessCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodesOrderBy>>;
  where?: InputMaybe<TixBusinessCodesBoolExp>;
};


export type TixQueryRootBusinessCodesByPkArgs = {
  businessCodeId: Scalars['uuid'];
};


export type TixQueryRootCompanyArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyOrderBy>>;
  where?: InputMaybe<TixCompanyBoolExp>;
};


export type TixQueryRootCompanyAddressArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyAddressOrderBy>>;
  where?: InputMaybe<TixCompanyAddressBoolExp>;
};


export type TixQueryRootCompanyAddressAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyAddressOrderBy>>;
  where?: InputMaybe<TixCompanyAddressBoolExp>;
};


export type TixQueryRootCompanyAddressByPkArgs = {
  companyAddressId: Scalars['uuid'];
};


export type TixQueryRootCompanyAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyOrderBy>>;
  where?: InputMaybe<TixCompanyBoolExp>;
};


export type TixQueryRootCompanyByPkArgs = {
  companyId: Scalars['uuid'];
};


export type TixQueryRootCompanyConfigurationValueArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyConfigurationValueOrderBy>>;
  where?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
};


export type TixQueryRootCompanyConfigurationValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyConfigurationValueOrderBy>>;
  where?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
};


export type TixQueryRootCompanyConfigurationValueByPkArgs = {
  companyConfigurationValueId: Scalars['uuid'];
};


export type TixQueryRootCompanyContactArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyContactOrderBy>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


export type TixQueryRootCompanyContactByPkArgs = {
  companyContactId: Scalars['uuid'];
};


export type TixQueryRootCompanyContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyContactOrderBy>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


export type TixQueryRootCompanyMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyMediaFileOrderBy>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


export type TixQueryRootCompanyMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyMediaFileOrderBy>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


export type TixQueryRootCompanyPhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyPhoneNumberOrderBy>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


export type TixQueryRootCompanyPhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyPhoneNumberOrderBy>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


export type TixQueryRootCompanyPhoneNumberByPkArgs = {
  companyPhoneNumberId: Scalars['uuid'];
};


export type TixQueryRootCompanySocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySocialMediaOrderBy>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


export type TixQueryRootCompanySocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySocialMediaOrderBy>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


export type TixQueryRootCompanySocialMediaByPkArgs = {
  companySocialMediaId: Scalars['uuid'];
};


export type TixQueryRootCompanySummaryReportArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySummaryReportOrderBy>>;
  where?: InputMaybe<TixCompanySummaryReportBoolExp>;
};


export type TixQueryRootCompanySummaryReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySummaryReportOrderBy>>;
  where?: InputMaybe<TixCompanySummaryReportBoolExp>;
};


export type TixQueryRootCompanyWarningArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyWarningOrderBy>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};


export type TixQueryRootCompanyWarningAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyWarningOrderBy>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};


export type TixQueryRootCompanyWarningByPkArgs = {
  companyWarningId: Scalars['uuid'];
};


export type TixQueryRootConfigurationGroupArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupBoolExp>;
};


export type TixQueryRootConfigurationGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupBoolExp>;
};


export type TixQueryRootConfigurationGroupByPkArgs = {
  configurationGroupId: Scalars['uuid'];
};


export type TixQueryRootConfigurationGroupItemArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupItemOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupItemBoolExp>;
};


export type TixQueryRootConfigurationGroupItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupItemOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupItemBoolExp>;
};


export type TixQueryRootConfigurationGroupItemByPkArgs = {
  configurationGroupItemId: Scalars['uuid'];
};


export type TixQueryRootConfigurationItemArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationItemOrderBy>>;
  where?: InputMaybe<TixConfigurationItemBoolExp>;
};


export type TixQueryRootConfigurationItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationItemOrderBy>>;
  where?: InputMaybe<TixConfigurationItemBoolExp>;
};


export type TixQueryRootConfigurationItemByPkArgs = {
  configurationItemId: Scalars['uuid'];
};


export type TixQueryRootConfigurationValueArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationValueOrderBy>>;
  where?: InputMaybe<TixConfigurationValueBoolExp>;
};


export type TixQueryRootConfigurationValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationValueOrderBy>>;
  where?: InputMaybe<TixConfigurationValueBoolExp>;
};


export type TixQueryRootConfigurationValueByPkArgs = {
  configurationValueId: Scalars['uuid'];
};


export type TixQueryRootContactArgs = {
  distinct_on?: InputMaybe<Array<TixContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactOrderBy>>;
  where?: InputMaybe<TixContactBoolExp>;
};


export type TixQueryRootContactAddressArgs = {
  distinct_on?: InputMaybe<Array<TixContactAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactAddressOrderBy>>;
  where?: InputMaybe<TixContactAddressBoolExp>;
};


export type TixQueryRootContactAddressAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactAddressOrderBy>>;
  where?: InputMaybe<TixContactAddressBoolExp>;
};


export type TixQueryRootContactAddressByPkArgs = {
  contactAddressId: Scalars['uuid'];
};


export type TixQueryRootContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactOrderBy>>;
  where?: InputMaybe<TixContactBoolExp>;
};


export type TixQueryRootContactByPkArgs = {
  contactId: Scalars['uuid'];
};


export type TixQueryRootContactPhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactPhoneNumberOrderBy>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


export type TixQueryRootContactPhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactPhoneNumberOrderBy>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


export type TixQueryRootContactPhoneNumberByPkArgs = {
  contactPhoneNumberId: Scalars['uuid'];
};


export type TixQueryRootCustomerArgs = {
  distinct_on?: InputMaybe<Array<TixCustomerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCustomerOrderBy>>;
  where?: InputMaybe<TixCustomerBoolExp>;
};


export type TixQueryRootCustomerAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCustomerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCustomerOrderBy>>;
  where?: InputMaybe<TixCustomerBoolExp>;
};


export type TixQueryRootCustomerByPkArgs = {
  customerId: Scalars['uuid'];
};


export type TixQueryRootCustomerSearchArgs = {
  distinct_on?: InputMaybe<Array<TixCustomerSearchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCustomerSearchOrderBy>>;
  where?: InputMaybe<TixCustomerSearchBoolExp>;
};


export type TixQueryRootCustomerSearchAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCustomerSearchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCustomerSearchOrderBy>>;
  where?: InputMaybe<TixCustomerSearchBoolExp>;
};


export type TixQueryRootDailyAuditReportArgs = {
  distinct_on?: InputMaybe<Array<TixDailyAuditReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyAuditReportOrderBy>>;
  where?: InputMaybe<TixDailyAuditReportBoolExp>;
};


export type TixQueryRootDailyAuditReportFinalArgs = {
  distinct_on?: InputMaybe<Array<TixDailyAuditReportFinalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyAuditReportFinalOrderBy>>;
  where?: InputMaybe<TixDailyAuditReportFinalBoolExp>;
};


export type TixQueryRootDailyAuditReportFinalAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDailyAuditReportFinalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyAuditReportFinalOrderBy>>;
  where?: InputMaybe<TixDailyAuditReportFinalBoolExp>;
};


export type TixQueryRootDailyAuditReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDailyAuditReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyAuditReportOrderBy>>;
  where?: InputMaybe<TixDailyAuditReportBoolExp>;
};


export type TixQueryRootDailyTicketCountReportSelectArgs = {
  distinct_on?: InputMaybe<Array<TixDailyTicketCountReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyTicketCountReportOrderBy>>;
  where?: InputMaybe<TixDailyTicketCountReportBoolExp>;
};


export type TixQueryRootDailyTicketCountReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDailyTicketCountReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyTicketCountReportOrderBy>>;
  where?: InputMaybe<TixDailyTicketCountReportBoolExp>;
};


export type TixQueryRootDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountOrderBy>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};


export type TixQueryRootDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountOrderBy>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};


export type TixQueryRootDiscountCodeCountByEvenArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountCodeCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountCodeCountByEventOrderBy>>;
  where?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
};


export type TixQueryRootDiscountCodeCountByEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountCodeCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountCodeCountByEventOrderBy>>;
  where?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
};


export type TixQueryRootDiscountReportArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVDiscountReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVDiscountReportOrderBy>>;
  where?: InputMaybe<TixReportingVDiscountReportBoolExp>;
};


export type TixQueryRootEmailContentSelectArgs = {
  distinct_on?: InputMaybe<Array<TixEmailContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEmailContentOrderBy>>;
  where?: InputMaybe<TixEmailContentBoolExp>;
};


export type TixQueryRootEmailContentSelectByPkArgs = {
  emailContentId: Scalars['uuid'];
};


export type TixQueryRootEmailContentAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEmailContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEmailContentOrderBy>>;
  where?: InputMaybe<TixEmailContentBoolExp>;
};


export type TixQueryRootEventArgs = {
  distinct_on?: InputMaybe<Array<TixEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventOrderBy>>;
  where?: InputMaybe<TixEventBoolExp>;
};


export type TixQueryRootEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventOrderBy>>;
  where?: InputMaybe<TixEventBoolExp>;
};


export type TixQueryRootEventByPkArgs = {
  eventId: Scalars['uuid'];
};


export type TixQueryRootEventCompanyVenueArgs = {
  distinct_on?: InputMaybe<Array<TixEventCompanyVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCompanyVenueOrderBy>>;
  where?: InputMaybe<TixEventCompanyVenueBoolExp>;
};


export type TixQueryRootEventCompanyVenueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventCompanyVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCompanyVenueOrderBy>>;
  where?: InputMaybe<TixEventCompanyVenueBoolExp>;
};


export type TixQueryRootEventEmailSelectArgs = {
  distinct_on?: InputMaybe<Array<TixEventEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventEmailOrderBy>>;
  where?: InputMaybe<TixEventEmailBoolExp>;
};


export type TixQueryRootEventEmailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventEmailOrderBy>>;
  where?: InputMaybe<TixEventEmailBoolExp>;
};


export type TixQueryRootEventInstanceArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceOrderBy>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};


export type TixQueryRootEventInstanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceOrderBy>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};


export type TixQueryRootEventInstanceByPkArgs = {
  eventInstanceId: Scalars['uuid'];
};


export type TixQueryRootEventInstanceConfigurationValueArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceConfigurationValueOrderBy>>;
  where?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
};


export type TixQueryRootEventInstanceConfigurationValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceConfigurationValueOrderBy>>;
  where?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
};


export type TixQueryRootEventInstanceConfigurationValueByPkArgs = {
  eventInstanceConfigurationId: Scalars['uuid'];
};


export type TixQueryRootEventInstanceDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceDiscountOrderBy>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


export type TixQueryRootEventInstanceDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceDiscountOrderBy>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


export type TixQueryRootEventInstanceMedialFileArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


export type TixQueryRootEventInstanceMedialFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


export type TixQueryRootEventInstanceMedialFileByPkArgs = {
  eventMediaId: Scalars['uuid'];
};


export type TixQueryRootEventInstanceSocialMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


export type TixQueryRootEventInstanceSocialMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


export type TixQueryRootEventInstanceTicketArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


export type TixQueryRootEventInstanceTicketAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


export type TixQueryRootEventInstanceTicketByPkArgs = {
  eventInstanceTicketId: Scalars['uuid'];
};


export type TixQueryRootEventInstanceTicketConfigArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketConfigOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
};


export type TixQueryRootEventInstanceTicketConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketConfigOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
};


export type TixQueryRootEventInstanceTicketConfigByPkArgs = {
  eventInstanceTicketConfigId: Scalars['uuid'];
};


export type TixQueryRootEventLineupArgs = {
  distinct_on?: InputMaybe<Array<TixEventLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventLineupOrderBy>>;
  where?: InputMaybe<TixEventLineupBoolExp>;
};


export type TixQueryRootEventLineupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventLineupOrderBy>>;
  where?: InputMaybe<TixEventLineupBoolExp>;
};


export type TixQueryRootEventListArgs = {
  distinct_on?: InputMaybe<Array<TixEventListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventListOrderBy>>;
  where?: InputMaybe<TixEventListBoolExp>;
};


export type TixQueryRootEventListAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventListOrderBy>>;
  where?: InputMaybe<TixEventListBoolExp>;
};


export type TixQueryRootEventPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


export type TixQueryRootEventPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


export type TixQueryRootEventPerformersByPkArgs = {
  eventPerformerId: Scalars['uuid'];
};


export type TixQueryRootEventProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductOrderBy>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};


export type TixQueryRootEventProductMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductMediaOrderBy>>;
  where?: InputMaybe<TixEventProductMediaBoolExp>;
};


export type TixQueryRootEventProductMediaSelectArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductMediaOrderBy>>;
  where?: InputMaybe<TixEventProductMediaBoolExp>;
};


export type TixQueryRootEventProductMediaSelectByPkArgs = {
  eventProductMediaImageFileId: Scalars['uuid'];
};


export type TixQueryRootEventProductSelectArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductOrderBy>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};


export type TixQueryRootEventProductSelectByPkArgs = {
  eventProductId: Scalars['uuid'];
};


export type TixQueryRootEventVenueArgs = {
  distinct_on?: InputMaybe<Array<TixEventVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventVenueOrderBy>>;
  where?: InputMaybe<TixEventVenueBoolExp>;
};


export type TixQueryRootEventVenueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventVenueOrderBy>>;
  where?: InputMaybe<TixEventVenueBoolExp>;
};


export type TixQueryRootEventVenueByPkArgs = {
  eventVenueId: Scalars['uuid'];
};


export type TixQueryRootLineupArgs = {
  distinct_on?: InputMaybe<Array<TixLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupOrderBy>>;
  where?: InputMaybe<TixLineupBoolExp>;
};


export type TixQueryRootLineupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupOrderBy>>;
  where?: InputMaybe<TixLineupBoolExp>;
};


export type TixQueryRootLineupPerformerArgs = {
  distinct_on?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupPerformerOrderBy>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


export type TixQueryRootLineupPerformerAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupPerformerOrderBy>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


export type TixQueryRootLoggingArgs = {
  distinct_on?: InputMaybe<Array<TixLoggingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLoggingOrderBy>>;
  where?: InputMaybe<TixLoggingBoolExp>;
};


export type TixQueryRootLoggingAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixLoggingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLoggingOrderBy>>;
  where?: InputMaybe<TixLoggingBoolExp>;
};


export type TixQueryRootLoggingByPkArgs = {
  logId: Scalars['uuid'];
};


export type TixQueryRootMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixMediaFileOrderBy>>;
  where?: InputMaybe<TixMediaFileBoolExp>;
};


export type TixQueryRootMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixMediaFileOrderBy>>;
  where?: InputMaybe<TixMediaFileBoolExp>;
};


export type TixQueryRootNotificationArgs = {
  distinct_on?: InputMaybe<Array<TixNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixNotificationOrderBy>>;
  where?: InputMaybe<TixNotificationBoolExp>;
};


export type TixQueryRootNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixNotificationOrderBy>>;
  where?: InputMaybe<TixNotificationBoolExp>;
};


export type TixQueryRootNotificationByPkArgs = {
  notificationId: Scalars['uuid'];
};


export type TixQueryRootOrderAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixOrderOrderBy>>;
  where?: InputMaybe<TixOrderBoolExp>;
};


export type TixQueryRootOrderSelectArgs = {
  distinct_on?: InputMaybe<Array<TixOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixOrderOrderBy>>;
  where?: InputMaybe<TixOrderBoolExp>;
};


export type TixQueryRootOrderSelectByPkArgs = {
  orderId: Scalars['uuid'];
};


export type TixQueryRootPatronEventListArgs = {
  distinct_on?: InputMaybe<Array<TixPatronEventListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPatronEventListOrderBy>>;
  where?: InputMaybe<TixPatronEventListBoolExp>;
};


export type TixQueryRootPatronEventListAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPatronEventListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPatronEventListOrderBy>>;
  where?: InputMaybe<TixPatronEventListBoolExp>;
};


export type TixQueryRootPatronFIlteredEventsListArgs = {
  distinct_on?: InputMaybe<Array<TixPatronFIlteredEventsListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPatronFIlteredEventsListOrderBy>>;
  where?: InputMaybe<TixPatronFIlteredEventsListBoolExp>;
};


export type TixQueryRootPatronFIlteredEventsListAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPatronFIlteredEventsListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPatronFIlteredEventsListOrderBy>>;
  where?: InputMaybe<TixPatronFIlteredEventsListBoolExp>;
};


export type TixQueryRootPaymentArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentOrderBy>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};


export type TixQueryRootPaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentOrderBy>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};


export type TixQueryRootPaymentDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentDiscountOrderBy>>;
  where?: InputMaybe<TixPaymentDiscountBoolExp>;
};


export type TixQueryRootPaymentDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentDiscountOrderBy>>;
  where?: InputMaybe<TixPaymentDiscountBoolExp>;
};


export type TixQueryRootPaymentVendorLogArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentVendorLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentVendorLogOrderBy>>;
  where?: InputMaybe<TixPaymentVendorLogBoolExp>;
};


export type TixQueryRootPaymentVendorLogAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentVendorLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentVendorLogOrderBy>>;
  where?: InputMaybe<TixPaymentVendorLogBoolExp>;
};


export type TixQueryRootPayoutArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutOrderBy>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


export type TixQueryRootPayoutAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutOrderBy>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


export type TixQueryRootPayoutByPkArgs = {
  payoutId: Scalars['uuid'];
};


export type TixQueryRootPayoutConnectSelectArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutConnectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutConnectOrderBy>>;
  where?: InputMaybe<TixPayoutConnectBoolExp>;
};


export type TixQueryRootPayoutConnectAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutConnectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutConnectOrderBy>>;
  where?: InputMaybe<TixPayoutConnectBoolExp>;
};


export type TixQueryRootPayoutConnectByPkArgs = {
  payoutConnectionId: Scalars['uuid'];
};


export type TixQueryRootPayoutDetailArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutDetailOrderBy>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};


export type TixQueryRootPayoutDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutDetailOrderBy>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};


export type TixQueryRootPayoutDetailByPkArgs = {
  payoutDetailId: Scalars['uuid'];
};


export type TixQueryRootPerformerArgs = {
  distinct_on?: InputMaybe<Array<TixPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPerformerOrderBy>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};


export type TixQueryRootPerformerAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPerformerOrderBy>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};


export type TixQueryRootPermissionArgs = {
  distinct_on?: InputMaybe<Array<TixPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPermissionOrderBy>>;
  where?: InputMaybe<TixPermissionBoolExp>;
};


export type TixQueryRootPermissionAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPermissionOrderBy>>;
  where?: InputMaybe<TixPermissionBoolExp>;
};


export type TixQueryRootPhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPhoneNumberOrderBy>>;
  where?: InputMaybe<TixPhoneNumberBoolExp>;
};


export type TixQueryRootPhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPhoneNumberOrderBy>>;
  where?: InputMaybe<TixPhoneNumberBoolExp>;
};


export type TixQueryRootPhoneNumberByPkArgs = {
  phoneNumberId: Scalars['uuid'];
};


export type TixQueryRootPolicyArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityPolicyOrderBy>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


export type TixQueryRootProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderBy>>;
  where?: InputMaybe<TixProductBoolExp>;
};


export type TixQueryRootProductMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixProductMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductMediaFileOrderBy>>;
  where?: InputMaybe<TixProductMediaFileBoolExp>;
};


export type TixQueryRootProductMediaFileSelectArgs = {
  distinct_on?: InputMaybe<Array<TixProductMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductMediaFileOrderBy>>;
  where?: InputMaybe<TixProductMediaFileBoolExp>;
};


export type TixQueryRootProductMediaFileSelectByPkArgs = {
  productMediaImageFileId: Scalars['uuid'];
};


export type TixQueryRootProductSelectArgs = {
  distinct_on?: InputMaybe<Array<TixProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderBy>>;
  where?: InputMaybe<TixProductBoolExp>;
};


export type TixQueryRootProductSelectByPkArgs = {
  productId: Scalars['uuid'];
};


export type TixQueryRootRefundsByEventArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVRefundsByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVRefundsByEventOrderBy>>;
  where?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
};


export type TixQueryRootReservationArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


export type TixQueryRootReservationAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


export type TixQueryRootReservationByPkArgs = {
  reservationId: Scalars['uuid'];
};


export type TixQueryRootReservationPaymentArgs = {
  distinct_on?: InputMaybe<Array<TixReservationPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationPaymentOrderBy>>;
  where?: InputMaybe<TixReservationPaymentBoolExp>;
};


export type TixQueryRootReservationPaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReservationPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationPaymentOrderBy>>;
  where?: InputMaybe<TixReservationPaymentBoolExp>;
};


export type TixQueryRootRevenueByChannelTypeArgs = {
  distinct_on?: InputMaybe<Array<TixRevenueByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRevenueByChannelTypeOrderBy>>;
  where?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
};


export type TixQueryRootRevenueByChannelTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixRevenueByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRevenueByChannelTypeOrderBy>>;
  where?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
};


export type TixQueryRootRoleArgs = {
  distinct_on?: InputMaybe<Array<TixRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRoleOrderBy>>;
  where?: InputMaybe<TixRoleBoolExp>;
};


export type TixQueryRootRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRoleOrderBy>>;
  where?: InputMaybe<TixRoleBoolExp>;
};


export type TixQueryRootRolePermissionAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixRolePermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRolePermissionOrderBy>>;
  where?: InputMaybe<TixRolePermissionBoolExp>;
};


export type TixQueryRootSelectBusinessCodeGroupByPkArgs = {
  busCodeGroupId: Scalars['uuid'];
};


export type TixQueryRootSelectCompanyMediaFileByPkArgs = {
  companyImageFileId: Scalars['uuid'];
};


export type TixQueryRootSelectDiscountByPkArgs = {
  discountId: Scalars['uuid'];
};


export type TixQueryRootSelectEventInstanceDiscountByPkArgs = {
  eventInstanceDiscountId: Scalars['uuid'];
};


export type TixQueryRootSelectEventInstanceSocialMediaFileByPkArgs = {
  eventSocialMediaId: Scalars['uuid'];
};


export type TixQueryRootSelectEventLineupByPkArgs = {
  event_lineup_id: Scalars['uuid'];
};


export type TixQueryRootSelectLineupByPkArgs = {
  lineupId: Scalars['uuid'];
};


export type TixQueryRootSelectLineupPerformerByPkArgs = {
  lineupPerformerId: Scalars['uuid'];
};


export type TixQueryRootSelectMediaFilebyPkArgs = {
  mediaFileId: Scalars['uuid'];
};


export type TixQueryRootSelectPaymentByPkArgs = {
  paymentId: Scalars['uuid'];
};


export type TixQueryRootSelectPaymentDiscountByPkArgs = {
  paymentDiscountId: Scalars['uuid'];
};


export type TixQueryRootSelectPaymentVendorLogByPkArgs = {
  vendorPaymentLogId: Scalars['uuid'];
};


export type TixQueryRootSelectPerformerByPkArgs = {
  performerId: Scalars['uuid'];
};


export type TixQueryRootSelectPermissionByPkArgs = {
  permissionId: Scalars['uuid'];
};


export type TixQueryRootSelectReservationPaymentByPkArgs = {
  reservationPaymentId: Scalars['uuid'];
};


export type TixQueryRootSelectRoleByPkArgs = {
  roleId: Scalars['uuid'];
};


export type TixQueryRootSelectRolePermissionArgs = {
  distinct_on?: InputMaybe<Array<TixRolePermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRolePermissionOrderBy>>;
  where?: InputMaybe<TixRolePermissionBoolExp>;
};


export type TixQueryRootSelectRolePermissionByPkArgs = {
  rolePermissionId: Scalars['uuid'];
};


export type TixQueryRootSelectUserArgs = {
  distinct_on?: InputMaybe<Array<TixUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserOrderBy>>;
  where?: InputMaybe<TixUserBoolExp>;
};


export type TixQueryRootSelectUserByPkArgs = {
  userId: Scalars['uuid'];
};


export type TixQueryRootSelectUserRoleArgs = {
  distinct_on?: InputMaybe<Array<TixUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserRoleOrderBy>>;
  where?: InputMaybe<TixUserRoleBoolExp>;
};


export type TixQueryRootSelectUserRoleByPkArgs = {
  userRoleId: Scalars['uuid'];
};


export type TixQueryRootSelectVenueDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueDiscountOrderBy>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};


export type TixQueryRootSelectVenueDiscountByPkArgs = {
  venueDiscountId: Scalars['uuid'];
};


export type TixQueryRootSelectVenueLineupByPkArgs = {
  venueLineupId: Scalars['uuid'];
};


export type TixQueryRootSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSocialMediaOrderBy>>;
  where?: InputMaybe<TixSocialMediaBoolExp>;
};


export type TixQueryRootSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSocialMediaOrderBy>>;
  where?: InputMaybe<TixSocialMediaBoolExp>;
};


export type TixQueryRootSocialMediaByPkArgs = {
  socialMediaId: Scalars['uuid'];
};


export type TixQueryRootTicketArgs = {
  distinct_on?: InputMaybe<Array<TixTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketOrderBy>>;
  where?: InputMaybe<TixTicketBoolExp>;
};


export type TixQueryRootTicketAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketOrderBy>>;
  where?: InputMaybe<TixTicketBoolExp>;
};


export type TixQueryRootTicketByPkArgs = {
  ticketId: Scalars['uuid'];
};


export type TixQueryRootTicketConfigArgs = {
  distinct_on?: InputMaybe<Array<TixTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketConfigOrderBy>>;
  where?: InputMaybe<TixTicketConfigBoolExp>;
};


export type TixQueryRootTicketConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketConfigOrderBy>>;
  where?: InputMaybe<TixTicketConfigBoolExp>;
};


export type TixQueryRootTicketConfigByPkArgs = {
  ticketConfigId: Scalars['uuid'];
};


export type TixQueryRootTicketCountByChannelTypeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByChannelTypeOrderBy>>;
  where?: InputMaybe<TixTicketCountByChannelTypeBoolExp>;
};


export type TixQueryRootTicketCountByChannelTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByChannelTypeOrderBy>>;
  where?: InputMaybe<TixTicketCountByChannelTypeBoolExp>;
};


export type TixQueryRootTicketCountByEventArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByEventOrderBy>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};


export type TixQueryRootTicketCountByEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByEventOrderBy>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};


export type TixQueryRootTicketCountByNameArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByNameOrderBy>>;
  where?: InputMaybe<TixTicketCountByNameBoolExp>;
};


export type TixQueryRootTicketCountByNameAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByNameOrderBy>>;
  where?: InputMaybe<TixTicketCountByNameBoolExp>;
};


export type TixQueryRootTicketCountByRevenueTypeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByRevenueTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByRevenueTypeOrderBy>>;
  where?: InputMaybe<TixTicketCountByRevenueTypeBoolExp>;
};


export type TixQueryRootTicketCountByRevenueTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByRevenueTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByRevenueTypeOrderBy>>;
  where?: InputMaybe<TixTicketCountByRevenueTypeBoolExp>;
};


export type TixQueryRootTicketReservationDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationDetailOrderBy>>;
  where?: InputMaybe<TixTicketReservationDetailBoolExp>;
};


export type TixQueryRootTicketReservationDetailSelectArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationDetailOrderBy>>;
  where?: InputMaybe<TixTicketReservationDetailBoolExp>;
};


export type TixQueryRootTicketReservationDetailSelectByPkArgs = {
  reservationDetailId: Scalars['uuid'];
};


export type TixQueryRootUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserOrderBy>>;
  where?: InputMaybe<TixUserBoolExp>;
};


export type TixQueryRootUserRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserRoleOrderBy>>;
  where?: InputMaybe<TixUserRoleBoolExp>;
};


export type TixQueryRootVenueArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueOrderBy>>;
  where?: InputMaybe<TixVenueBoolExp>;
};


export type TixQueryRootVenueAddressArgs = {
  distinct_on?: InputMaybe<Array<TixVenueAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueAddressOrderBy>>;
  where?: InputMaybe<TixVenueAddressBoolExp>;
};


export type TixQueryRootVenueAddressAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueAddressOrderBy>>;
  where?: InputMaybe<TixVenueAddressBoolExp>;
};


export type TixQueryRootVenueAddressByPkArgs = {
  venueAddressId: Scalars['uuid'];
};


export type TixQueryRootVenueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueOrderBy>>;
  where?: InputMaybe<TixVenueBoolExp>;
};


export type TixQueryRootVenueByPkArgs = {
  venueId: Scalars['uuid'];
};


export type TixQueryRootVenueConfigurationValueArgs = {
  distinct_on?: InputMaybe<Array<TixVenueConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueConfigurationValueOrderBy>>;
  where?: InputMaybe<TixVenueConfigurationValueBoolExp>;
};


export type TixQueryRootVenueConfigurationValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueConfigurationValueOrderBy>>;
  where?: InputMaybe<TixVenueConfigurationValueBoolExp>;
};


export type TixQueryRootVenueConfigurationValueByPkArgs = {
  venueConfigurationValueId: Scalars['uuid'];
};


export type TixQueryRootVenueContactArgs = {
  distinct_on?: InputMaybe<Array<TixVenueContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueContactOrderBy>>;
  where?: InputMaybe<TixVenueContactBoolExp>;
};


export type TixQueryRootVenueContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueContactOrderBy>>;
  where?: InputMaybe<TixVenueContactBoolExp>;
};


export type TixQueryRootVenueContactByPkArgs = {
  venueContactId: Scalars['uuid'];
};


export type TixQueryRootVenueDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueDiscountOrderBy>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};


export type TixQueryRootVenueLineupArgs = {
  distinct_on?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueLineupOrderBy>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};


export type TixQueryRootVenueLineupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueLineupOrderBy>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};


export type TixQueryRootVenueMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueMediaFileOrderBy>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};


export type TixQueryRootVenueMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueMediaFileOrderBy>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};


export type TixQueryRootVenueMediaFileByPkArgs = {
  venueImageFileId: Scalars['uuid'];
};


export type TixQueryRootVenuePhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenuePhoneNumberOrderBy>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};


export type TixQueryRootVenuePhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenuePhoneNumberOrderBy>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};


export type TixQueryRootVenuePhoneNumberByPkArgs = {
  venuePhoneNumberId: Scalars['uuid'];
};


export type TixQueryRootVenueProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueProductOrderBy>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


export type TixQueryRootVenueProductSelectArgs = {
  distinct_on?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueProductOrderBy>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


export type TixQueryRootVenueProductSelectByPkArgs = {
  venueProductId: Scalars['uuid'];
};


export type TixQueryRootVenueSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueSocialMediaOrderBy>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};


export type TixQueryRootVenueSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueSocialMediaOrderBy>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};


export type TixQueryRootVenueSocialMediaByPkArgs = {
  venueSocialMediaId: Scalars['uuid'];
};


export type TixQueryRootVenueTicketArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


export type TixQueryRootVenueTicketAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


export type TixQueryRootVenueTicketByPkArgs = {
  venueTicketId: Scalars['uuid'];
};


export type TixQueryRootVenueTicketConfigArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketConfigOrderBy>>;
  where?: InputMaybe<TixVenueTicketConfigBoolExp>;
};


export type TixQueryRootVenueTicketConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketConfigOrderBy>>;
  where?: InputMaybe<TixVenueTicketConfigBoolExp>;
};


export type TixQueryRootVenueTicketConfigByPkArgs = {
  venueTicketConfig: Scalars['uuid'];
};


export type TixQueryRootVenueWarningArgs = {
  distinct_on?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueWarningOrderBy>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};


export type TixQueryRootVenueWarningAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueWarningOrderBy>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};


export type TixQueryRootVenueWarningByPkArgs = {
  venueWarningId: Scalars['uuid'];
};


export type TixQueryRootWarningArgs = {
  distinct_on?: InputMaybe<Array<TixWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixWarningOrderBy>>;
  where?: InputMaybe<TixWarningBoolExp>;
};


export type TixQueryRootWarningAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixWarningOrderBy>>;
  where?: InputMaybe<TixWarningBoolExp>;
};


export type TixQueryRootWarningByPkArgs = {
  warningId: Scalars['uuid'];
};


export type TixQueryRootAddressPerformerPhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressPerformerPhoneNumberOrderBy>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};


export type TixQueryRootAddressPerformerPhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressPerformerPhoneNumberOrderBy>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};


export type TixQueryRootAddressPerformerPhoneNumberByPkArgs = {
  performer_phone_number_id: Scalars['uuid'];
};


export type TixQueryRootCalculateAvailableTicketStatsArgs = {
  eventInstanceId: Scalars['String'];
};


export type TixQueryRootCanRequestPayoutArgs = {
  eventInstanceId: Scalars['String'];
};


export type TixQueryRootCommunicationsCompanyEmailArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsCompanyEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsCompanyEmailOrderBy>>;
  where?: InputMaybe<TixCommunicationsCompanyEmailBoolExp>;
};


export type TixQueryRootCommunicationsCompanyEmailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsCompanyEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsCompanyEmailOrderBy>>;
  where?: InputMaybe<TixCommunicationsCompanyEmailBoolExp>;
};


export type TixQueryRootCommunicationsEmailContentVariableArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailContentVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailContentVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
};


export type TixQueryRootCommunicationsEmailContentVariableAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailContentVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailContentVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
};


export type TixQueryRootCommunicationsEmailContentVariableByPkArgs = {
  emailContentVariableId: Scalars['uuid'];
};


export type TixQueryRootCommunicationsEmailVariableArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailVariableBoolExp>;
};


export type TixQueryRootCommunicationsEmailVariableAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailVariableBoolExp>;
};


export type TixQueryRootCommunicationsEmailVariableByPkArgs = {
  emailVariableId: Scalars['uuid'];
};


export type TixQueryRootCommunicationsVenueEmailArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsVenueEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsVenueEmailOrderBy>>;
  where?: InputMaybe<TixCommunicationsVenueEmailBoolExp>;
};


export type TixQueryRootCommunicationsVenueEmailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsVenueEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsVenueEmailOrderBy>>;
  where?: InputMaybe<TixCommunicationsVenueEmailBoolExp>;
};


export type TixQueryRootEventSummaryReportArgs = {
  distinct_on?: InputMaybe<Array<TixEventSummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventSummaryReportOrderBy>>;
  where?: InputMaybe<TixEventSummaryReportBoolExp>;
};


export type TixQueryRootEventSummaryReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventSummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventSummaryReportOrderBy>>;
  where?: InputMaybe<TixEventSummaryReportBoolExp>;
};


export type TixQueryRootEventCampaignTrackingArgs = {
  distinct_on?: InputMaybe<Array<TixEventCampaignTrackingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCampaignTrackingOrderBy>>;
  where?: InputMaybe<TixEventCampaignTrackingBoolExp>;
};


export type TixQueryRootEventCampaignTrackingAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventCampaignTrackingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCampaignTrackingOrderBy>>;
  where?: InputMaybe<TixEventCampaignTrackingBoolExp>;
};


export type TixQueryRootEventCampaignTrackingByPkArgs = {
  campaign_tracking_id: Scalars['uuid'];
};


export type TixQueryRootFeesArgs = {
  distinct_on?: InputMaybe<Array<TixFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixFeesOrderBy>>;
  where?: InputMaybe<TixFeesBoolExp>;
};


export type TixQueryRootFeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixFeesOrderBy>>;
  where?: InputMaybe<TixFeesBoolExp>;
};


export type TixQueryRootFeesByPkArgs = {
  feeId: Scalars['uuid'];
};


export type TixQueryRootGenericGetOrderItemsOnHoldByOtherUsersArgs = {
  itemIds: Array<Scalars['String']>;
  userSessionId: Scalars['String'];
};


export type TixQueryRootGenericGetOrderOnHoldArgs = {
  userSessionId: Scalars['String'];
};


export type TixQueryRootGetAmountToPayForOrderArgs = {
  eventInstanceId: Scalars['String'];
  method: TixPaymentMethod;
  order: TixOrderInput;
};


export type TixQueryRootGetAppleWalletPassUrlArgs = {
  data: TixSendETicketInput;
};


export type TixQueryRootGetDiscountDataArgs = {
  data: TixDiscountCodeDto;
};


export type TixQueryRootGetEventFinancialBreakdownArgs = {
  eventId: Scalars['String'];
};


export type TixQueryRootGetEventFinancialReportDetailsArgs = {
  eventInstanceId: Scalars['String'];
};


export type TixQueryRootGetEventFinancialReportDetailsForCsvArgs = {
  eventInstanceId: Scalars['String'];
};


export type TixQueryRootGetEventRevenueArgs = {
  eventInstanceId: Scalars['String'];
};


export type TixQueryRootGetGoogleWalletUrlArgs = {
  data: TixSendETicketInput;
};


export type TixQueryRootGetNumberOfTicketsOnHoldForTicketConfigArgs = {
  ticketConfigId: Scalars['String'];
};


export type TixQueryRootGetOrderFromHoldArgs = {
  userSessionId: Scalars['String'];
};


export type TixQueryRootGetOtherUsersOnHoldTicketsArgs = {
  ticketConfigIds: Array<Scalars['String']>;
  userSessionId: Scalars['String'];
};


export type TixQueryRootGetPaymentExchangeDataArgs = {
  exchangeId: Scalars['String'];
};


export type TixQueryRootGetProductSalesReportArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['String']>;
};


export type TixQueryRootGetProductSalesReportForCsvArgs = {
  columns?: InputMaybe<Array<TixProductSalesColumn>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  eventInstanceId?: InputMaybe<Scalars['String']>;
  reportLevel?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  venueId?: InputMaybe<Scalars['String']>;
};


export type TixQueryRootGetRefundAmountDonationsArgs = {
  mode: Scalars['String'];
  notify: Scalars['Boolean'];
  reservationId: Scalars['String'];
};


export type TixQueryRootGetRefundAmountForAddonsArgs = {
  mode: Scalars['String'];
  notify?: InputMaybe<Scalars['Boolean']>;
  reservationId: Scalars['String'];
};


export type TixQueryRootGetRefundAmountForTicketArgs = {
  mode: Scalars['String'];
  notify: Scalars['Boolean'];
  reservationId: Scalars['String'];
  ticketId: Scalars['String'];
};


export type TixQueryRootGetRefundAmountReservationArgs = {
  mode: Scalars['String'];
  notify: Scalars['Boolean'];
  reservationId: Scalars['String'];
};


export type TixQueryRootGetReservationTicketsZipArgs = {
  baseTicketQrCodeScanUrl: Scalars['String'];
  reservationId: Scalars['String'];
  zipName: Scalars['String'];
};


export type TixQueryRootGetTicketExchangeRequiredActionArgs = {
  request: TixTicketExchangeRequestInput;
};


export type TixQueryRootGetTicketPdfUrlsArgs = {
  baseTicketQrCodeScanUrl: Scalars['String'];
  ticketIds: Array<Scalars['String']>;
};


export type TixQueryRootGetTicketPdFsZipUrlArgs = {
  baseTicketQrCodeScanUrl: Scalars['String'];
  ticketIds: Array<Scalars['String']>;
  zipName: Scalars['String'];
};


export type TixQueryRootHasPasscodeArgs = {
  data: TixHasPasscodeDto;
};


export type TixQueryRootIsValidDiscountCodeArgs = {
  data: TixDiscountCodeDto;
};


export type TixQueryRootIsValidTokenArgs = {
  token: Scalars['String'];
};


export type TixQueryRootNotificationContactNotificationArgs = {
  distinct_on?: InputMaybe<Array<TixNotificationContactNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixNotificationContactNotificationOrderBy>>;
  where?: InputMaybe<TixNotificationContactNotificationBoolExp>;
};


export type TixQueryRootNotificationContactNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixNotificationContactNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixNotificationContactNotificationOrderBy>>;
  where?: InputMaybe<TixNotificationContactNotificationBoolExp>;
};


export type TixQueryRootNotificationContactNotificationByPkArgs = {
  contactNotificationId: Scalars['uuid'];
};


export type TixQueryRootProductOrderDetailArgs = {
  distinct_on?: InputMaybe<Array<TixProductOrderDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderDetailOrderBy>>;
  where?: InputMaybe<TixProductOrderDetailBoolExp>;
};


export type TixQueryRootProductOrderDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixProductOrderDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderDetailOrderBy>>;
  where?: InputMaybe<TixProductOrderDetailBoolExp>;
};


export type TixQueryRootProductOrderDetailByPkArgs = {
  orderDetailId: Scalars['uuid'];
};


export type TixQueryRootReportingVDiscountReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVDiscountReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVDiscountReportOrderBy>>;
  where?: InputMaybe<TixReportingVDiscountReportBoolExp>;
};


export type TixQueryRootReportingVRefundsByEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVRefundsByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVRefundsByEventOrderBy>>;
  where?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
};


export type TixQueryRootReportingVTicketDetailReportArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVTicketDetailReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVTicketDetailReportOrderBy>>;
  where?: InputMaybe<TixReportingVTicketDetailReportBoolExp>;
};


export type TixQueryRootReportingVTicketDetailReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVTicketDetailReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVTicketDetailReportOrderBy>>;
  where?: InputMaybe<TixReportingVTicketDetailReportBoolExp>;
};


export type TixQueryRootReservationDetailReportArgs = {
  distinct_on?: InputMaybe<Array<TixReservationDetailReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationDetailReportOrderBy>>;
  where?: InputMaybe<TixReservationDetailReportBoolExp>;
};


export type TixQueryRootReservationDetailReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReservationDetailReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationDetailReportOrderBy>>;
  where?: InputMaybe<TixReservationDetailReportBoolExp>;
};


export type TixQueryRootReservationReportArgs = {
  distinct_on?: InputMaybe<Array<TixReservationReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationReportOrderBy>>;
  where?: InputMaybe<TixReservationReportBoolExp>;
};


export type TixQueryRootReservationReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReservationReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationReportOrderBy>>;
  where?: InputMaybe<TixReservationReportBoolExp>;
};


export type TixQueryRootReservationReportByPkArgs = {
  reservationReportId: Scalars['uuid'];
};


export type TixQueryRootReservationSummaryReportArgs = {
  distinct_on?: InputMaybe<Array<TixReservationSummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationSummaryReportOrderBy>>;
  where?: InputMaybe<TixReservationSummaryReportBoolExp>;
};


export type TixQueryRootReservationSummaryReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReservationSummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationSummaryReportOrderBy>>;
  where?: InputMaybe<TixReservationSummaryReportBoolExp>;
};


export type TixQueryRootSavedReportArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportOrderBy>>;
  where?: InputMaybe<TixSavedReportBoolExp>;
};


export type TixQueryRootSavedReportEventsArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportEventsOrderBy>>;
  where?: InputMaybe<TixSavedReportEventsBoolExp>;
};


export type TixQueryRootSavedReportEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportEventsOrderBy>>;
  where?: InputMaybe<TixSavedReportEventsBoolExp>;
};


export type TixQueryRootSavedReportEventsByPkArgs = {
  savedReportEventsId: Scalars['uuid'];
};


export type TixQueryRootSavedReportLayoutArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportLayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportLayoutOrderBy>>;
  where?: InputMaybe<TixSavedReportLayoutBoolExp>;
};


export type TixQueryRootSavedReportLayoutAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportLayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportLayoutOrderBy>>;
  where?: InputMaybe<TixSavedReportLayoutBoolExp>;
};


export type TixQueryRootSavedReportLayoutByPkArgs = {
  savedReportLayoutId: Scalars['uuid'];
};


export type TixQueryRootSavedReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportOrderBy>>;
  where?: InputMaybe<TixSavedReportBoolExp>;
};


export type TixQueryRootSavedReportByPkArgs = {
  savedReportId: Scalars['uuid'];
};


export type TixQueryRootScheduledReportArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportOrderBy>>;
  where?: InputMaybe<TixScheduledReportBoolExp>;
};


export type TixQueryRootScheduledReportEmailArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportEmailOrderBy>>;
  where?: InputMaybe<TixScheduledReportEmailBoolExp>;
};


export type TixQueryRootScheduledReportEmailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportEmailOrderBy>>;
  where?: InputMaybe<TixScheduledReportEmailBoolExp>;
};


export type TixQueryRootScheduledReportEmailByPkArgs = {
  scheduledReportEmailId: Scalars['uuid'];
};


export type TixQueryRootScheduledReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportOrderBy>>;
  where?: InputMaybe<TixScheduledReportBoolExp>;
};


export type TixQueryRootScheduledReportByPkArgs = {
  scheduledReportId: Scalars['uuid'];
};


export type TixQueryRootTicketExchangeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketExchangeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketExchangeOrderBy>>;
  where?: InputMaybe<TixTicketExchangeBoolExp>;
};


export type TixQueryRootTicketExchangeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketExchangeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketExchangeOrderBy>>;
  where?: InputMaybe<TixTicketExchangeBoolExp>;
};


export type TixQueryRootTicketExchangeByPkArgs = {
  exchangeId: Scalars['uuid'];
};


export type TixQueryRootTicketTicketDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixTicketTicketDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketTicketDiscountOrderBy>>;
  where?: InputMaybe<TixTicketTicketDiscountBoolExp>;
};


export type TixQueryRootTicketTicketDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketTicketDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketTicketDiscountOrderBy>>;
  where?: InputMaybe<TixTicketTicketDiscountBoolExp>;
};


export type TixQueryRootTicketTicketDiscountByPkArgs = {
  ticketDiscountId: Scalars['uuid'];
};


export type TixQueryRootTicketVTicketCountByTypeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketCountByTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketCountByTypeOrderBy>>;
  where?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
};


export type TixQueryRootTicketVTicketCountByTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketCountByTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketCountByTypeOrderBy>>;
  where?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
};


export type TixQueryRootTicketVTicketSalesMetricsArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketSalesMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketSalesMetricsOrderBy>>;
  where?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
};


export type TixQueryRootTicketVTicketSalesMetricsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketSalesMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketSalesMetricsOrderBy>>;
  where?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
};


export type TixQueryRootUtilityPolicyAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityPolicyOrderBy>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


export type TixQueryRootUtilityPolicyByPkArgs = {
  policyId: Scalars['uuid'];
};


export type TixQueryRootUtilityTimestampByTimezoneArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityTimestampByTimezoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityTimestampByTimezoneOrderBy>>;
  where?: InputMaybe<TixUtilityTimestampByTimezoneBoolExp>;
};


export type TixQueryRootUtilityTimestampByTimezoneAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityTimestampByTimezoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityTimestampByTimezoneOrderBy>>;
  where?: InputMaybe<TixUtilityTimestampByTimezoneBoolExp>;
};

/** columns and relationships of "reporting.v_discount_report" */
export type TixReportingVDiscountReport = {
  __typename?: 'reporting_v_discount_report';
  appliedTo?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  dateUsed?: Maybe<Scalars['date']>;
  discountAmountPerTicket?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  discountDescription?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['uuid']>;
  eventDate?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventStartTime?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['uuid']>;
  ticketNo?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_discount_report" */
export type TixReportingVDiscountReportAggregate = {
  __typename?: 'reporting_v_discount_report_aggregate';
  aggregate?: Maybe<TixReportingVDiscountReportAggregateFields>;
  nodes: Array<TixReportingVDiscountReport>;
};

/** aggregate fields of "reporting.v_discount_report" */
export type TixReportingVDiscountReportAggregateFields = {
  __typename?: 'reporting_v_discount_report_aggregate_fields';
  avg?: Maybe<TixReportingVDiscountReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixReportingVDiscountReportMaxFields>;
  min?: Maybe<TixReportingVDiscountReportMinFields>;
  stddev?: Maybe<TixReportingVDiscountReportStddevFields>;
  stddev_pop?: Maybe<TixReportingVDiscountReportStddevPopFields>;
  stddev_samp?: Maybe<TixReportingVDiscountReportStddevSampFields>;
  sum?: Maybe<TixReportingVDiscountReportSumFields>;
  var_pop?: Maybe<TixReportingVDiscountReportVarPopFields>;
  var_samp?: Maybe<TixReportingVDiscountReportVarSampFields>;
  variance?: Maybe<TixReportingVDiscountReportVarianceFields>;
};


/** aggregate fields of "reporting.v_discount_report" */
export type TixReportingVDiscountReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixReportingVDiscountReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixReportingVDiscountReportAvgFields = {
  __typename?: 'reporting_v_discount_report_avg_fields';
  discountAmountPerTicket?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_discount_report". All fields are combined with a logical 'AND'. */
export type TixReportingVDiscountReportBoolExp = {
  _and?: InputMaybe<Array<TixReportingVDiscountReportBoolExp>>;
  _not?: InputMaybe<TixReportingVDiscountReportBoolExp>;
  _or?: InputMaybe<Array<TixReportingVDiscountReportBoolExp>>;
  appliedTo?: InputMaybe<TixStringComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  dateUsed?: InputMaybe<TixDateComparisonExp>;
  discountAmountPerTicket?: InputMaybe<TixMoneyComparisonExp>;
  discountCode?: InputMaybe<TixStringComparisonExp>;
  discountDescription?: InputMaybe<TixStringComparisonExp>;
  discountId?: InputMaybe<TixUuidComparisonExp>;
  eventDate?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventStartTime?: InputMaybe<TixStringComparisonExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  reservationNo?: InputMaybe<TixStringComparisonExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  ticketId?: InputMaybe<TixUuidComparisonExp>;
  ticketNo?: InputMaybe<TixStringComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixReportingVDiscountReportMaxFields = {
  __typename?: 'reporting_v_discount_report_max_fields';
  appliedTo?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  dateUsed?: Maybe<Scalars['date']>;
  discountAmountPerTicket?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  discountDescription?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['uuid']>;
  eventDate?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventStartTime?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['uuid']>;
  ticketNo?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixReportingVDiscountReportMinFields = {
  __typename?: 'reporting_v_discount_report_min_fields';
  appliedTo?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  dateUsed?: Maybe<Scalars['date']>;
  discountAmountPerTicket?: Maybe<Scalars['money']>;
  discountCode?: Maybe<Scalars['String']>;
  discountDescription?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['uuid']>;
  eventDate?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventStartTime?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['uuid']>;
  ticketNo?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reporting.v_discount_report". */
export type TixReportingVDiscountReportOrderBy = {
  appliedTo?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  dateUsed?: InputMaybe<TixOrderBy>;
  discountAmountPerTicket?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountDescription?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  eventDate?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventStartTime?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationNo?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  ticketId?: InputMaybe<TixOrderBy>;
  ticketNo?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_discount_report" */
export enum TixReportingVDiscountReportSelectColumn {
  /** column name */
  AppliedTo = 'appliedTo',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  DateUsed = 'dateUsed',
  /** column name */
  DiscountAmountPerTicket = 'discountAmountPerTicket',
  /** column name */
  DiscountCode = 'discountCode',
  /** column name */
  DiscountDescription = 'discountDescription',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  EventDate = 'eventDate',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventStartTime = 'eventStartTime',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationNo = 'reservationNo',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  TicketId = 'ticketId',
  /** column name */
  TicketNo = 'ticketNo',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName'
}

/** aggregate stddev on columns */
export type TixReportingVDiscountReportStddevFields = {
  __typename?: 'reporting_v_discount_report_stddev_fields';
  discountAmountPerTicket?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixReportingVDiscountReportStddevPopFields = {
  __typename?: 'reporting_v_discount_report_stddev_pop_fields';
  discountAmountPerTicket?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixReportingVDiscountReportStddevSampFields = {
  __typename?: 'reporting_v_discount_report_stddev_samp_fields';
  discountAmountPerTicket?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reporting_v_discount_report" */
export type TixReportingVDiscountReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixReportingVDiscountReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixReportingVDiscountReportStreamCursorValueInput = {
  appliedTo?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  dateUsed?: InputMaybe<Scalars['date']>;
  discountAmountPerTicket?: InputMaybe<Scalars['money']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountDescription?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  eventDate?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventStartTime?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationNo?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  ticketId?: InputMaybe<Scalars['uuid']>;
  ticketNo?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixReportingVDiscountReportSumFields = {
  __typename?: 'reporting_v_discount_report_sum_fields';
  discountAmountPerTicket?: Maybe<Scalars['money']>;
};

/** aggregate var_pop on columns */
export type TixReportingVDiscountReportVarPopFields = {
  __typename?: 'reporting_v_discount_report_var_pop_fields';
  discountAmountPerTicket?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixReportingVDiscountReportVarSampFields = {
  __typename?: 'reporting_v_discount_report_var_samp_fields';
  discountAmountPerTicket?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixReportingVDiscountReportVarianceFields = {
  __typename?: 'reporting_v_discount_report_variance_fields';
  discountAmountPerTicket?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEvent = {
  __typename?: 'reporting_v_refunds_by_event';
  contactId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  refundAmount?: Maybe<Scalars['money']>;
  state?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventAggregate = {
  __typename?: 'reporting_v_refunds_by_event_aggregate';
  aggregate?: Maybe<TixReportingVRefundsByEventAggregateFields>;
  nodes: Array<TixReportingVRefundsByEvent>;
};

export type TixReportingVRefundsByEventAggregateBoolExp = {
  count?: InputMaybe<TixReportingVRefundsByEventAggregateBoolExpCount>;
};

export type TixReportingVRefundsByEventAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixReportingVRefundsByEventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventAggregateFields = {
  __typename?: 'reporting_v_refunds_by_event_aggregate_fields';
  avg?: Maybe<TixReportingVRefundsByEventAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixReportingVRefundsByEventMaxFields>;
  min?: Maybe<TixReportingVRefundsByEventMinFields>;
  stddev?: Maybe<TixReportingVRefundsByEventStddevFields>;
  stddev_pop?: Maybe<TixReportingVRefundsByEventStddevPopFields>;
  stddev_samp?: Maybe<TixReportingVRefundsByEventStddevSampFields>;
  sum?: Maybe<TixReportingVRefundsByEventSumFields>;
  var_pop?: Maybe<TixReportingVRefundsByEventVarPopFields>;
  var_samp?: Maybe<TixReportingVRefundsByEventVarSampFields>;
  variance?: Maybe<TixReportingVRefundsByEventVarianceFields>;
};


/** aggregate fields of "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixReportingVRefundsByEventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventAggregateOrderBy = {
  avg?: InputMaybe<TixReportingVRefundsByEventAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixReportingVRefundsByEventMaxOrderBy>;
  min?: InputMaybe<TixReportingVRefundsByEventMinOrderBy>;
  stddev?: InputMaybe<TixReportingVRefundsByEventStddevOrderBy>;
  stddev_pop?: InputMaybe<TixReportingVRefundsByEventStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixReportingVRefundsByEventStddevSampOrderBy>;
  sum?: InputMaybe<TixReportingVRefundsByEventSumOrderBy>;
  var_pop?: InputMaybe<TixReportingVRefundsByEventVarPopOrderBy>;
  var_samp?: InputMaybe<TixReportingVRefundsByEventVarSampOrderBy>;
  variance?: InputMaybe<TixReportingVRefundsByEventVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventArrRelInsertInput = {
  data: Array<TixReportingVRefundsByEventInsertInput>;
};

/** aggregate avg on columns */
export type TixReportingVRefundsByEventAvgFields = {
  __typename?: 'reporting_v_refunds_by_event_avg_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventAvgOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "reporting.v_refunds_by_event". All fields are combined with a logical 'AND'. */
export type TixReportingVRefundsByEventBoolExp = {
  _and?: InputMaybe<Array<TixReportingVRefundsByEventBoolExp>>;
  _not?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
  _or?: InputMaybe<Array<TixReportingVRefundsByEventBoolExp>>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  refundAmount?: InputMaybe<TixMoneyComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  ticketCount?: InputMaybe<TixBigintComparisonExp>;
};

/** input type for inserting data into table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventInsertInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  refundAmount?: InputMaybe<Scalars['money']>;
  state?: InputMaybe<Scalars['String']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type TixReportingVRefundsByEventMaxFields = {
  __typename?: 'reporting_v_refunds_by_event_max_fields';
  contactId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  refundAmount?: Maybe<Scalars['money']>;
  state?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventMaxOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixReportingVRefundsByEventMinFields = {
  __typename?: 'reporting_v_refunds_by_event_min_fields';
  contactId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  refundAmount?: Maybe<Scalars['money']>;
  state?: Maybe<Scalars['String']>;
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventMinOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** Ordering options when selecting data from "reporting.v_refunds_by_event". */
export type TixReportingVRefundsByEventOrderBy = {
  contactId?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_refunds_by_event" */
export enum TixReportingVRefundsByEventSelectColumn {
  /** column name */
  ContactId = 'contactId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  State = 'state',
  /** column name */
  TicketCount = 'ticketCount'
}

/** aggregate stddev on columns */
export type TixReportingVRefundsByEventStddevFields = {
  __typename?: 'reporting_v_refunds_by_event_stddev_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventStddevOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixReportingVRefundsByEventStddevPopFields = {
  __typename?: 'reporting_v_refunds_by_event_stddev_pop_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventStddevPopOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixReportingVRefundsByEventStddevSampFields = {
  __typename?: 'reporting_v_refunds_by_event_stddev_samp_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventStddevSampOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "reporting_v_refunds_by_event" */
export type TixReportingVRefundsByEventStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixReportingVRefundsByEventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixReportingVRefundsByEventStreamCursorValueInput = {
  contactId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  refundAmount?: InputMaybe<Scalars['money']>;
  state?: InputMaybe<Scalars['String']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TixReportingVRefundsByEventSumFields = {
  __typename?: 'reporting_v_refunds_by_event_sum_fields';
  refundAmount?: Maybe<Scalars['money']>;
  ticketCount?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventSumOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate var_pop on columns */
export type TixReportingVRefundsByEventVarPopFields = {
  __typename?: 'reporting_v_refunds_by_event_var_pop_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventVarPopOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixReportingVRefundsByEventVarSampFields = {
  __typename?: 'reporting_v_refunds_by_event_var_samp_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventVarSampOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixReportingVRefundsByEventVarianceFields = {
  __typename?: 'reporting_v_refunds_by_event_variance_fields';
  refundAmount?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reporting.v_refunds_by_event" */
export type TixReportingVRefundsByEventVarianceOrderBy = {
  refundAmount?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "reporting.v_ticket_detail_report" */
export type TixReportingVTicketDetailReport = {
  __typename?: 'reporting_v_ticket_detail_report';
  checkedInAt?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  currentTicketPrice?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  doorsOpen?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groupCode?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  isGroup?: Maybe<Scalars['Boolean']>;
  isSpecialOccasion?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  noOfTickets?: Maybe<Scalars['Int']>;
  occasionName?: Maybe<Scalars['String']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  paymentTotalAmountPaid?: Maybe<Scalars['numeric']>;
  payment_id?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  platformFeePaid?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationDiscountAmount?: Maybe<Scalars['numeric']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  reservationSubTotal?: Maybe<Scalars['numeric']>;
  reservationTotalAmount?: Maybe<Scalars['numeric']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['numeric']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketNo?: Maybe<Scalars['String']>;
  ticketState?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['uuid']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueURL?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_ticket_detail_report" */
export type TixReportingVTicketDetailReportAggregate = {
  __typename?: 'reporting_v_ticket_detail_report_aggregate';
  aggregate?: Maybe<TixReportingVTicketDetailReportAggregateFields>;
  nodes: Array<TixReportingVTicketDetailReport>;
};

/** aggregate fields of "reporting.v_ticket_detail_report" */
export type TixReportingVTicketDetailReportAggregateFields = {
  __typename?: 'reporting_v_ticket_detail_report_aggregate_fields';
  avg?: Maybe<TixReportingVTicketDetailReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixReportingVTicketDetailReportMaxFields>;
  min?: Maybe<TixReportingVTicketDetailReportMinFields>;
  stddev?: Maybe<TixReportingVTicketDetailReportStddevFields>;
  stddev_pop?: Maybe<TixReportingVTicketDetailReportStddevPopFields>;
  stddev_samp?: Maybe<TixReportingVTicketDetailReportStddevSampFields>;
  sum?: Maybe<TixReportingVTicketDetailReportSumFields>;
  var_pop?: Maybe<TixReportingVTicketDetailReportVarPopFields>;
  var_samp?: Maybe<TixReportingVTicketDetailReportVarSampFields>;
  variance?: Maybe<TixReportingVTicketDetailReportVarianceFields>;
};


/** aggregate fields of "reporting.v_ticket_detail_report" */
export type TixReportingVTicketDetailReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixReportingVTicketDetailReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixReportingVTicketDetailReportAvgFields = {
  __typename?: 'reporting_v_ticket_detail_report_avg_fields';
  currentTicketPrice?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  paymentTotalAmountPaid?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  platformFeePaid?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  reservationDiscountAmount?: Maybe<Scalars['Float']>;
  reservationSubTotal?: Maybe<Scalars['Float']>;
  reservationTotalAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_ticket_detail_report". All fields are combined with a logical 'AND'. */
export type TixReportingVTicketDetailReportBoolExp = {
  _and?: InputMaybe<Array<TixReportingVTicketDetailReportBoolExp>>;
  _not?: InputMaybe<TixReportingVTicketDetailReportBoolExp>;
  _or?: InputMaybe<Array<TixReportingVTicketDetailReportBoolExp>>;
  checkedInAt?: InputMaybe<TixStringComparisonExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  companyURL?: InputMaybe<TixStringComparisonExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  currentTicketPrice?: InputMaybe<TixNumericComparisonExp>;
  date?: InputMaybe<TixStringComparisonExp>;
  discountCode?: InputMaybe<TixStringComparisonExp>;
  discountId?: InputMaybe<TixStringComparisonExp>;
  discountType?: InputMaybe<TixStringComparisonExp>;
  dob?: InputMaybe<TixStringComparisonExp>;
  doorsOpen?: InputMaybe<TixStringComparisonExp>;
  emailAddress?: InputMaybe<TixStringComparisonExp>;
  endTime?: InputMaybe<TixStringComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  eventType?: InputMaybe<TixStringComparisonExp>;
  firstName?: InputMaybe<TixStringComparisonExp>;
  groupCode?: InputMaybe<TixStringComparisonExp>;
  hidden?: InputMaybe<TixBooleanComparisonExp>;
  isGroup?: InputMaybe<TixBooleanComparisonExp>;
  isSpecialOccasion?: InputMaybe<TixBooleanComparisonExp>;
  lastName?: InputMaybe<TixStringComparisonExp>;
  minimumAge?: InputMaybe<TixIntComparisonExp>;
  noOfTickets?: InputMaybe<TixIntComparisonExp>;
  occasionName?: InputMaybe<TixStringComparisonExp>;
  paymentProvider?: InputMaybe<TixStringComparisonExp>;
  paymentStatus?: InputMaybe<TixStringComparisonExp>;
  paymentToken?: InputMaybe<TixStringComparisonExp>;
  paymentTotalAmountPaid?: InputMaybe<TixNumericComparisonExp>;
  payment_id?: InputMaybe<TixUuidComparisonExp>;
  perOrderMax?: InputMaybe<TixSmallintComparisonExp>;
  perOrderMin?: InputMaybe<TixSmallintComparisonExp>;
  phoneNumber?: InputMaybe<TixStringComparisonExp>;
  platformFee?: InputMaybe<TixNumericComparisonExp>;
  platformFeePaid?: InputMaybe<TixNumericComparisonExp>;
  processingFee?: InputMaybe<TixNumericComparisonExp>;
  refundAmount?: InputMaybe<TixNumericComparisonExp>;
  reservationDate?: InputMaybe<TixStringComparisonExp>;
  reservationDiscountAmount?: InputMaybe<TixNumericComparisonExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  reservationNo?: InputMaybe<TixStringComparisonExp>;
  reservationSubTotal?: InputMaybe<TixNumericComparisonExp>;
  reservationTotalAmount?: InputMaybe<TixNumericComparisonExp>;
  row?: InputMaybe<TixStringComparisonExp>;
  seat?: InputMaybe<TixStringComparisonExp>;
  section?: InputMaybe<TixStringComparisonExp>;
  startTime?: InputMaybe<TixStringComparisonExp>;
  stripeFeePaid?: InputMaybe<TixNumericComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  ticketName?: InputMaybe<TixStringComparisonExp>;
  ticketNo?: InputMaybe<TixStringComparisonExp>;
  ticketState?: InputMaybe<TixStringComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  ticket_id?: InputMaybe<TixUuidComparisonExp>;
  ticketsInReservation?: InputMaybe<TixNumericComparisonExp>;
  venueFee?: InputMaybe<TixNumericComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  venueURL?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixReportingVTicketDetailReportMaxFields = {
  __typename?: 'reporting_v_ticket_detail_report_max_fields';
  checkedInAt?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  currentTicketPrice?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  doorsOpen?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groupCode?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  noOfTickets?: Maybe<Scalars['Int']>;
  occasionName?: Maybe<Scalars['String']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  paymentTotalAmountPaid?: Maybe<Scalars['numeric']>;
  payment_id?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  platformFeePaid?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationDiscountAmount?: Maybe<Scalars['numeric']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  reservationSubTotal?: Maybe<Scalars['numeric']>;
  reservationTotalAmount?: Maybe<Scalars['numeric']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['numeric']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketNo?: Maybe<Scalars['String']>;
  ticketState?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['uuid']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueURL?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixReportingVTicketDetailReportMinFields = {
  __typename?: 'reporting_v_ticket_detail_report_min_fields';
  checkedInAt?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  currentTicketPrice?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  doorsOpen?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groupCode?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  noOfTickets?: Maybe<Scalars['Int']>;
  occasionName?: Maybe<Scalars['String']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  paymentTotalAmountPaid?: Maybe<Scalars['numeric']>;
  payment_id?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  phoneNumber?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  platformFeePaid?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationDiscountAmount?: Maybe<Scalars['numeric']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  reservationSubTotal?: Maybe<Scalars['numeric']>;
  reservationTotalAmount?: Maybe<Scalars['numeric']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['numeric']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketNo?: Maybe<Scalars['String']>;
  ticketState?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['uuid']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueURL?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reporting.v_ticket_detail_report". */
export type TixReportingVTicketDetailReportOrderBy = {
  checkedInAt?: InputMaybe<TixOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  companyURL?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  currentTicketPrice?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  discountType?: InputMaybe<TixOrderBy>;
  dob?: InputMaybe<TixOrderBy>;
  doorsOpen?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  endTime?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  firstName?: InputMaybe<TixOrderBy>;
  groupCode?: InputMaybe<TixOrderBy>;
  hidden?: InputMaybe<TixOrderBy>;
  isGroup?: InputMaybe<TixOrderBy>;
  isSpecialOccasion?: InputMaybe<TixOrderBy>;
  lastName?: InputMaybe<TixOrderBy>;
  minimumAge?: InputMaybe<TixOrderBy>;
  noOfTickets?: InputMaybe<TixOrderBy>;
  occasionName?: InputMaybe<TixOrderBy>;
  paymentProvider?: InputMaybe<TixOrderBy>;
  paymentStatus?: InputMaybe<TixOrderBy>;
  paymentToken?: InputMaybe<TixOrderBy>;
  paymentTotalAmountPaid?: InputMaybe<TixOrderBy>;
  payment_id?: InputMaybe<TixOrderBy>;
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  phoneNumber?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  platformFeePaid?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  reservationDate?: InputMaybe<TixOrderBy>;
  reservationDiscountAmount?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationNo?: InputMaybe<TixOrderBy>;
  reservationSubTotal?: InputMaybe<TixOrderBy>;
  reservationTotalAmount?: InputMaybe<TixOrderBy>;
  row?: InputMaybe<TixOrderBy>;
  seat?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  stripeFeePaid?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketName?: InputMaybe<TixOrderBy>;
  ticketNo?: InputMaybe<TixOrderBy>;
  ticketState?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  ticket_id?: InputMaybe<TixOrderBy>;
  ticketsInReservation?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueURL?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_ticket_detail_report" */
export enum TixReportingVTicketDetailReportSelectColumn {
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  CompanyUrl = 'companyURL',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CurrentTicketPrice = 'currentTicketPrice',
  /** column name */
  Date = 'date',
  /** column name */
  DiscountCode = 'discountCode',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  DiscountType = 'discountType',
  /** column name */
  Dob = 'dob',
  /** column name */
  DoorsOpen = 'doorsOpen',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventState = 'eventState',
  /** column name */
  EventType = 'eventType',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  GroupCode = 'groupCode',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsGroup = 'isGroup',
  /** column name */
  IsSpecialOccasion = 'isSpecialOccasion',
  /** column name */
  LastName = 'lastName',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  NoOfTickets = 'noOfTickets',
  /** column name */
  OccasionName = 'occasionName',
  /** column name */
  PaymentProvider = 'paymentProvider',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  PaymentToken = 'paymentToken',
  /** column name */
  PaymentTotalAmountPaid = 'paymentTotalAmountPaid',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PerOrderMax = 'perOrderMax',
  /** column name */
  PerOrderMin = 'perOrderMin',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  PlatformFeePaid = 'platformFeePaid',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  ReservationDate = 'reservationDate',
  /** column name */
  ReservationDiscountAmount = 'reservationDiscountAmount',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationNo = 'reservationNo',
  /** column name */
  ReservationSubTotal = 'reservationSubTotal',
  /** column name */
  ReservationTotalAmount = 'reservationTotalAmount',
  /** column name */
  Row = 'row',
  /** column name */
  Seat = 'seat',
  /** column name */
  Section = 'section',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StripeFeePaid = 'stripeFeePaid',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TicketName = 'ticketName',
  /** column name */
  TicketNo = 'ticketNo',
  /** column name */
  TicketState = 'ticketState',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  TicketsInReservation = 'ticketsInReservation',
  /** column name */
  VenueFee = 'venueFee',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  VenueUrl = 'venueURL'
}

/** aggregate stddev on columns */
export type TixReportingVTicketDetailReportStddevFields = {
  __typename?: 'reporting_v_ticket_detail_report_stddev_fields';
  currentTicketPrice?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  paymentTotalAmountPaid?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  platformFeePaid?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  reservationDiscountAmount?: Maybe<Scalars['Float']>;
  reservationSubTotal?: Maybe<Scalars['Float']>;
  reservationTotalAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixReportingVTicketDetailReportStddevPopFields = {
  __typename?: 'reporting_v_ticket_detail_report_stddev_pop_fields';
  currentTicketPrice?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  paymentTotalAmountPaid?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  platformFeePaid?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  reservationDiscountAmount?: Maybe<Scalars['Float']>;
  reservationSubTotal?: Maybe<Scalars['Float']>;
  reservationTotalAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixReportingVTicketDetailReportStddevSampFields = {
  __typename?: 'reporting_v_ticket_detail_report_stddev_samp_fields';
  currentTicketPrice?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  paymentTotalAmountPaid?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  platformFeePaid?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  reservationDiscountAmount?: Maybe<Scalars['Float']>;
  reservationSubTotal?: Maybe<Scalars['Float']>;
  reservationTotalAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reporting_v_ticket_detail_report" */
export type TixReportingVTicketDetailReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixReportingVTicketDetailReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixReportingVTicketDetailReportStreamCursorValueInput = {
  checkedInAt?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyURL?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  currentTicketPrice?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['String']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['String']>;
  discountType?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  doorsOpen?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupCode?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  isSpecialOccasion?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  noOfTickets?: InputMaybe<Scalars['Int']>;
  occasionName?: InputMaybe<Scalars['String']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  paymentTotalAmountPaid?: InputMaybe<Scalars['numeric']>;
  payment_id?: InputMaybe<Scalars['uuid']>;
  perOrderMax?: InputMaybe<Scalars['smallint']>;
  perOrderMin?: InputMaybe<Scalars['smallint']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platformFee?: InputMaybe<Scalars['numeric']>;
  platformFeePaid?: InputMaybe<Scalars['numeric']>;
  processingFee?: InputMaybe<Scalars['numeric']>;
  refundAmount?: InputMaybe<Scalars['numeric']>;
  reservationDate?: InputMaybe<Scalars['String']>;
  reservationDiscountAmount?: InputMaybe<Scalars['numeric']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationNo?: InputMaybe<Scalars['String']>;
  reservationSubTotal?: InputMaybe<Scalars['numeric']>;
  reservationTotalAmount?: InputMaybe<Scalars['numeric']>;
  row?: InputMaybe<Scalars['String']>;
  seat?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  stripeFeePaid?: InputMaybe<Scalars['numeric']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketName?: InputMaybe<Scalars['String']>;
  ticketNo?: InputMaybe<Scalars['String']>;
  ticketState?: InputMaybe<Scalars['String']>;
  ticketType?: InputMaybe<Scalars['String']>;
  ticket_id?: InputMaybe<Scalars['uuid']>;
  ticketsInReservation?: InputMaybe<Scalars['numeric']>;
  venueFee?: InputMaybe<Scalars['numeric']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  venueURL?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixReportingVTicketDetailReportSumFields = {
  __typename?: 'reporting_v_ticket_detail_report_sum_fields';
  currentTicketPrice?: Maybe<Scalars['numeric']>;
  minimumAge?: Maybe<Scalars['Int']>;
  noOfTickets?: Maybe<Scalars['Int']>;
  paymentTotalAmountPaid?: Maybe<Scalars['numeric']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['numeric']>;
  platformFeePaid?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDiscountAmount?: Maybe<Scalars['numeric']>;
  reservationSubTotal?: Maybe<Scalars['numeric']>;
  reservationTotalAmount?: Maybe<Scalars['numeric']>;
  stripeFeePaid?: Maybe<Scalars['numeric']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type TixReportingVTicketDetailReportVarPopFields = {
  __typename?: 'reporting_v_ticket_detail_report_var_pop_fields';
  currentTicketPrice?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  paymentTotalAmountPaid?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  platformFeePaid?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  reservationDiscountAmount?: Maybe<Scalars['Float']>;
  reservationSubTotal?: Maybe<Scalars['Float']>;
  reservationTotalAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixReportingVTicketDetailReportVarSampFields = {
  __typename?: 'reporting_v_ticket_detail_report_var_samp_fields';
  currentTicketPrice?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  paymentTotalAmountPaid?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  platformFeePaid?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  reservationDiscountAmount?: Maybe<Scalars['Float']>;
  reservationSubTotal?: Maybe<Scalars['Float']>;
  reservationTotalAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixReportingVTicketDetailReportVarianceFields = {
  __typename?: 'reporting_v_ticket_detail_report_variance_fields';
  currentTicketPrice?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  paymentTotalAmountPaid?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  platformFeePaid?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  reservationDiscountAmount?: Maybe<Scalars['Float']>;
  reservationSubTotal?: Maybe<Scalars['Float']>;
  reservationTotalAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reporting.v_reservation_detail_report" */
export type TixReservationDetailReport = {
  __typename?: 'reservationDetailReport';
  checkedInAt?: Maybe<Scalars['String']>;
  companyID?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['numeric']>;
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  doorsOpen?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  groupCode?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  isGroup?: Maybe<Scalars['Boolean']>;
  isSpecialOccasion?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  noOfTickets?: Maybe<Scalars['Int']>;
  occasionName?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['uuid']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['numeric']>;
  subTotal?: Maybe<Scalars['numeric']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketId?: Maybe<Scalars['uuid']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketNo?: Maybe<Scalars['String']>;
  ticketPrice?: Maybe<Scalars['numeric']>;
  ticketPricePaid?: Maybe<Scalars['numeric']>;
  ticketState?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  totalAmount?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalPaidPerTicket?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueURL?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_reservation_detail_report" */
export type TixReservationDetailReportAggregate = {
  __typename?: 'reservationDetailReport_aggregate';
  aggregate?: Maybe<TixReservationDetailReportAggregateFields>;
  nodes: Array<TixReservationDetailReport>;
};

/** aggregate fields of "reporting.v_reservation_detail_report" */
export type TixReservationDetailReportAggregateFields = {
  __typename?: 'reservationDetailReport_aggregate_fields';
  avg?: Maybe<TixReservationDetailReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixReservationDetailReportMaxFields>;
  min?: Maybe<TixReservationDetailReportMinFields>;
  stddev?: Maybe<TixReservationDetailReportStddevFields>;
  stddev_pop?: Maybe<TixReservationDetailReportStddevPopFields>;
  stddev_samp?: Maybe<TixReservationDetailReportStddevSampFields>;
  sum?: Maybe<TixReservationDetailReportSumFields>;
  var_pop?: Maybe<TixReservationDetailReportVarPopFields>;
  var_samp?: Maybe<TixReservationDetailReportVarSampFields>;
  variance?: Maybe<TixReservationDetailReportVarianceFields>;
};


/** aggregate fields of "reporting.v_reservation_detail_report" */
export type TixReservationDetailReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixReservationDetailReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixReservationDetailReportAvgFields = {
  __typename?: 'reservationDetailReport_avg_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  ticketPricePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalPaidPerTicket?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_reservation_detail_report". All fields are combined with a logical 'AND'. */
export type TixReservationDetailReportBoolExp = {
  _and?: InputMaybe<Array<TixReservationDetailReportBoolExp>>;
  _not?: InputMaybe<TixReservationDetailReportBoolExp>;
  _or?: InputMaybe<Array<TixReservationDetailReportBoolExp>>;
  checkedInAt?: InputMaybe<TixStringComparisonExp>;
  companyID?: InputMaybe<TixUuidComparisonExp>;
  companyName?: InputMaybe<TixStringComparisonExp>;
  companyURL?: InputMaybe<TixStringComparisonExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  date?: InputMaybe<TixStringComparisonExp>;
  discountAmount?: InputMaybe<TixNumericComparisonExp>;
  discountCode?: InputMaybe<TixStringComparisonExp>;
  discountId?: InputMaybe<TixStringComparisonExp>;
  discountType?: InputMaybe<TixStringComparisonExp>;
  dob?: InputMaybe<TixStringComparisonExp>;
  doorsOpen?: InputMaybe<TixStringComparisonExp>;
  emailAddress?: InputMaybe<TixStringComparisonExp>;
  endTime?: InputMaybe<TixStringComparisonExp>;
  estPlatformFeePaidPerTicket?: InputMaybe<TixNumericComparisonExp>;
  estProcessingFeePaidPerTicket?: InputMaybe<TixNumericComparisonExp>;
  estTotalFeePaidPerTicket?: InputMaybe<TixNumericComparisonExp>;
  estVenueFeePaidPerTicket?: InputMaybe<TixNumericComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  eventType?: InputMaybe<TixStringComparisonExp>;
  firstName?: InputMaybe<TixStringComparisonExp>;
  fullName?: InputMaybe<TixStringComparisonExp>;
  groupCode?: InputMaybe<TixStringComparisonExp>;
  hidden?: InputMaybe<TixBooleanComparisonExp>;
  isGroup?: InputMaybe<TixBooleanComparisonExp>;
  isSpecialOccasion?: InputMaybe<TixBooleanComparisonExp>;
  lastName?: InputMaybe<TixStringComparisonExp>;
  minimumAge?: InputMaybe<TixIntComparisonExp>;
  noOfTickets?: InputMaybe<TixIntComparisonExp>;
  occasionName?: InputMaybe<TixStringComparisonExp>;
  paymentId?: InputMaybe<TixUuidComparisonExp>;
  paymentProvider?: InputMaybe<TixStringComparisonExp>;
  paymentStatus?: InputMaybe<TixStringComparisonExp>;
  paymentToken?: InputMaybe<TixStringComparisonExp>;
  perOrderMax?: InputMaybe<TixSmallintComparisonExp>;
  perOrderMin?: InputMaybe<TixSmallintComparisonExp>;
  platformFee?: InputMaybe<TixNumericComparisonExp>;
  processingFee?: InputMaybe<TixNumericComparisonExp>;
  refundAmount?: InputMaybe<TixNumericComparisonExp>;
  reservationDate?: InputMaybe<TixStringComparisonExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  reservationNo?: InputMaybe<TixStringComparisonExp>;
  row?: InputMaybe<TixStringComparisonExp>;
  seat?: InputMaybe<TixStringComparisonExp>;
  section?: InputMaybe<TixStringComparisonExp>;
  startTime?: InputMaybe<TixStringComparisonExp>;
  stripeFeePaid?: InputMaybe<TixNumericComparisonExp>;
  subTotal?: InputMaybe<TixNumericComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  ticketId?: InputMaybe<TixUuidComparisonExp>;
  ticketName?: InputMaybe<TixStringComparisonExp>;
  ticketNo?: InputMaybe<TixStringComparisonExp>;
  ticketPrice?: InputMaybe<TixNumericComparisonExp>;
  ticketPricePaid?: InputMaybe<TixNumericComparisonExp>;
  ticketState?: InputMaybe<TixStringComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  ticketsInReservation?: InputMaybe<TixNumericComparisonExp>;
  totalAmount?: InputMaybe<TixNumericComparisonExp>;
  totalAmountPaid?: InputMaybe<TixNumericComparisonExp>;
  totalPaidPerTicket?: InputMaybe<TixNumericComparisonExp>;
  venueFee?: InputMaybe<TixNumericComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
  venueURL?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixReservationDetailReportMaxFields = {
  __typename?: 'reservationDetailReport_max_fields';
  checkedInAt?: Maybe<Scalars['String']>;
  companyID?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['numeric']>;
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  doorsOpen?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  groupCode?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  noOfTickets?: Maybe<Scalars['Int']>;
  occasionName?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['uuid']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['numeric']>;
  subTotal?: Maybe<Scalars['numeric']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketId?: Maybe<Scalars['uuid']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketNo?: Maybe<Scalars['String']>;
  ticketPrice?: Maybe<Scalars['numeric']>;
  ticketPricePaid?: Maybe<Scalars['numeric']>;
  ticketState?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  totalAmount?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalPaidPerTicket?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueURL?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixReservationDetailReportMinFields = {
  __typename?: 'reservationDetailReport_min_fields';
  checkedInAt?: Maybe<Scalars['String']>;
  companyID?: Maybe<Scalars['uuid']>;
  companyName?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['numeric']>;
  discountCode?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  doorsOpen?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  groupCode?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
  noOfTickets?: Maybe<Scalars['Int']>;
  occasionName?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['uuid']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  seat?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  stripeFeePaid?: Maybe<Scalars['numeric']>;
  subTotal?: Maybe<Scalars['numeric']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketId?: Maybe<Scalars['uuid']>;
  ticketName?: Maybe<Scalars['String']>;
  ticketNo?: Maybe<Scalars['String']>;
  ticketPrice?: Maybe<Scalars['numeric']>;
  ticketPricePaid?: Maybe<Scalars['numeric']>;
  ticketState?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  totalAmount?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalPaidPerTicket?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
  venueURL?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reporting.v_reservation_detail_report". */
export type TixReservationDetailReportOrderBy = {
  checkedInAt?: InputMaybe<TixOrderBy>;
  companyID?: InputMaybe<TixOrderBy>;
  companyName?: InputMaybe<TixOrderBy>;
  companyURL?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  date?: InputMaybe<TixOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  discountType?: InputMaybe<TixOrderBy>;
  dob?: InputMaybe<TixOrderBy>;
  doorsOpen?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  endTime?: InputMaybe<TixOrderBy>;
  estPlatformFeePaidPerTicket?: InputMaybe<TixOrderBy>;
  estProcessingFeePaidPerTicket?: InputMaybe<TixOrderBy>;
  estTotalFeePaidPerTicket?: InputMaybe<TixOrderBy>;
  estVenueFeePaidPerTicket?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  eventType?: InputMaybe<TixOrderBy>;
  firstName?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  groupCode?: InputMaybe<TixOrderBy>;
  hidden?: InputMaybe<TixOrderBy>;
  isGroup?: InputMaybe<TixOrderBy>;
  isSpecialOccasion?: InputMaybe<TixOrderBy>;
  lastName?: InputMaybe<TixOrderBy>;
  minimumAge?: InputMaybe<TixOrderBy>;
  noOfTickets?: InputMaybe<TixOrderBy>;
  occasionName?: InputMaybe<TixOrderBy>;
  paymentId?: InputMaybe<TixOrderBy>;
  paymentProvider?: InputMaybe<TixOrderBy>;
  paymentStatus?: InputMaybe<TixOrderBy>;
  paymentToken?: InputMaybe<TixOrderBy>;
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  reservationDate?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationNo?: InputMaybe<TixOrderBy>;
  row?: InputMaybe<TixOrderBy>;
  seat?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  stripeFeePaid?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketId?: InputMaybe<TixOrderBy>;
  ticketName?: InputMaybe<TixOrderBy>;
  ticketNo?: InputMaybe<TixOrderBy>;
  ticketPrice?: InputMaybe<TixOrderBy>;
  ticketPricePaid?: InputMaybe<TixOrderBy>;
  ticketState?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  ticketsInReservation?: InputMaybe<TixOrderBy>;
  totalAmount?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  totalPaidPerTicket?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
  venueURL?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_reservation_detail_report" */
export enum TixReservationDetailReportSelectColumn {
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  CompanyId = 'companyID',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  CompanyUrl = 'companyURL',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  Date = 'date',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  DiscountCode = 'discountCode',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  DiscountType = 'discountType',
  /** column name */
  Dob = 'dob',
  /** column name */
  DoorsOpen = 'doorsOpen',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EstPlatformFeePaidPerTicket = 'estPlatformFeePaidPerTicket',
  /** column name */
  EstProcessingFeePaidPerTicket = 'estProcessingFeePaidPerTicket',
  /** column name */
  EstTotalFeePaidPerTicket = 'estTotalFeePaidPerTicket',
  /** column name */
  EstVenueFeePaidPerTicket = 'estVenueFeePaidPerTicket',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventState = 'eventState',
  /** column name */
  EventType = 'eventType',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FullName = 'fullName',
  /** column name */
  GroupCode = 'groupCode',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsGroup = 'isGroup',
  /** column name */
  IsSpecialOccasion = 'isSpecialOccasion',
  /** column name */
  LastName = 'lastName',
  /** column name */
  MinimumAge = 'minimumAge',
  /** column name */
  NoOfTickets = 'noOfTickets',
  /** column name */
  OccasionName = 'occasionName',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  PaymentProvider = 'paymentProvider',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  PaymentToken = 'paymentToken',
  /** column name */
  PerOrderMax = 'perOrderMax',
  /** column name */
  PerOrderMin = 'perOrderMin',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  ReservationDate = 'reservationDate',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationNo = 'reservationNo',
  /** column name */
  Row = 'row',
  /** column name */
  Seat = 'seat',
  /** column name */
  Section = 'section',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StripeFeePaid = 'stripeFeePaid',
  /** column name */
  SubTotal = 'subTotal',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TicketId = 'ticketId',
  /** column name */
  TicketName = 'ticketName',
  /** column name */
  TicketNo = 'ticketNo',
  /** column name */
  TicketPrice = 'ticketPrice',
  /** column name */
  TicketPricePaid = 'ticketPricePaid',
  /** column name */
  TicketState = 'ticketState',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  TicketsInReservation = 'ticketsInReservation',
  /** column name */
  TotalAmount = 'totalAmount',
  /** column name */
  TotalAmountPaid = 'totalAmountPaid',
  /** column name */
  TotalPaidPerTicket = 'totalPaidPerTicket',
  /** column name */
  VenueFee = 'venueFee',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName',
  /** column name */
  VenueUrl = 'venueURL'
}

/** aggregate stddev on columns */
export type TixReservationDetailReportStddevFields = {
  __typename?: 'reservationDetailReport_stddev_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  ticketPricePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalPaidPerTicket?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixReservationDetailReportStddevPopFields = {
  __typename?: 'reservationDetailReport_stddev_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  ticketPricePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalPaidPerTicket?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixReservationDetailReportStddevSampFields = {
  __typename?: 'reservationDetailReport_stddev_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  ticketPricePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalPaidPerTicket?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reservationDetailReport" */
export type TixReservationDetailReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixReservationDetailReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixReservationDetailReportStreamCursorValueInput = {
  checkedInAt?: InputMaybe<Scalars['String']>;
  companyID?: InputMaybe<Scalars['uuid']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyURL?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  date?: InputMaybe<Scalars['String']>;
  discountAmount?: InputMaybe<Scalars['numeric']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountId?: InputMaybe<Scalars['String']>;
  discountType?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  doorsOpen?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  estPlatformFeePaidPerTicket?: InputMaybe<Scalars['numeric']>;
  estProcessingFeePaidPerTicket?: InputMaybe<Scalars['numeric']>;
  estTotalFeePaidPerTicket?: InputMaybe<Scalars['numeric']>;
  estVenueFeePaidPerTicket?: InputMaybe<Scalars['numeric']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  groupCode?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  isSpecialOccasion?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  noOfTickets?: InputMaybe<Scalars['Int']>;
  occasionName?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['uuid']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  perOrderMax?: InputMaybe<Scalars['smallint']>;
  perOrderMin?: InputMaybe<Scalars['smallint']>;
  platformFee?: InputMaybe<Scalars['numeric']>;
  processingFee?: InputMaybe<Scalars['numeric']>;
  refundAmount?: InputMaybe<Scalars['numeric']>;
  reservationDate?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationNo?: InputMaybe<Scalars['String']>;
  row?: InputMaybe<Scalars['String']>;
  seat?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  stripeFeePaid?: InputMaybe<Scalars['numeric']>;
  subTotal?: InputMaybe<Scalars['numeric']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketId?: InputMaybe<Scalars['uuid']>;
  ticketName?: InputMaybe<Scalars['String']>;
  ticketNo?: InputMaybe<Scalars['String']>;
  ticketPrice?: InputMaybe<Scalars['numeric']>;
  ticketPricePaid?: InputMaybe<Scalars['numeric']>;
  ticketState?: InputMaybe<Scalars['String']>;
  ticketType?: InputMaybe<Scalars['String']>;
  ticketsInReservation?: InputMaybe<Scalars['numeric']>;
  totalAmount?: InputMaybe<Scalars['numeric']>;
  totalAmountPaid?: InputMaybe<Scalars['numeric']>;
  totalPaidPerTicket?: InputMaybe<Scalars['numeric']>;
  venueFee?: InputMaybe<Scalars['numeric']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
  venueURL?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixReservationDetailReportSumFields = {
  __typename?: 'reservationDetailReport_sum_fields';
  discountAmount?: Maybe<Scalars['numeric']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['numeric']>;
  minimumAge?: Maybe<Scalars['Int']>;
  noOfTickets?: Maybe<Scalars['Int']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  stripeFeePaid?: Maybe<Scalars['numeric']>;
  subTotal?: Maybe<Scalars['numeric']>;
  ticketPrice?: Maybe<Scalars['numeric']>;
  ticketPricePaid?: Maybe<Scalars['numeric']>;
  ticketsInReservation?: Maybe<Scalars['numeric']>;
  totalAmount?: Maybe<Scalars['numeric']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalPaidPerTicket?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type TixReservationDetailReportVarPopFields = {
  __typename?: 'reservationDetailReport_var_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  ticketPricePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalPaidPerTicket?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixReservationDetailReportVarSampFields = {
  __typename?: 'reservationDetailReport_var_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  ticketPricePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalPaidPerTicket?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixReservationDetailReportVarianceFields = {
  __typename?: 'reservationDetailReport_variance_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  estPlatformFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estProcessingFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estTotalFeePaidPerTicket?: Maybe<Scalars['Float']>;
  estVenueFeePaidPerTicket?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  noOfTickets?: Maybe<Scalars['Float']>;
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  stripeFeePaid?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketPrice?: Maybe<Scalars['Float']>;
  ticketPricePaid?: Maybe<Scalars['Float']>;
  ticketsInReservation?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalPaidPerTicket?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reporting.reservation_report" */
export type TixReservationReport = {
  __typename?: 'reservationReport';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  reservationReport?: Maybe<Scalars['jsonb']>;
  reservationReportId: Scalars['uuid'];
};


/** columns and relationships of "reporting.reservation_report" */
export type TixReservationReportReservationReportArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "reporting.reservation_report" */
export type TixReservationReportAggregate = {
  __typename?: 'reservationReport_aggregate';
  aggregate?: Maybe<TixReservationReportAggregateFields>;
  nodes: Array<TixReservationReport>;
};

/** aggregate fields of "reporting.reservation_report" */
export type TixReservationReportAggregateFields = {
  __typename?: 'reservationReport_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixReservationReportMaxFields>;
  min?: Maybe<TixReservationReportMinFields>;
};


/** aggregate fields of "reporting.reservation_report" */
export type TixReservationReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixReservationReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TixReservationReportAppendInput = {
  reservationReport?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "reporting.reservation_report". All fields are combined with a logical 'AND'. */
export type TixReservationReportBoolExp = {
  _and?: InputMaybe<Array<TixReservationReportBoolExp>>;
  _not?: InputMaybe<TixReservationReportBoolExp>;
  _or?: InputMaybe<Array<TixReservationReportBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  reservationReport?: InputMaybe<TixJsonbComparisonExp>;
  reservationReportId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "reporting.reservation_report" */
export enum TixReservationReportConstraint {
  /** unique or primary key constraint on columns "reservation_report_id" */
  ReservationsPkey = 'reservations_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TixReservationReportDeleteAtPathInput = {
  reservationReport?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TixReservationReportDeleteElemInput = {
  reservationReport?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TixReservationReportDeleteKeyInput = {
  reservationReport?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "reporting.reservation_report" */
export type TixReservationReportInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  reservationReport?: InputMaybe<Scalars['jsonb']>;
  reservationReportId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixReservationReportMaxFields = {
  __typename?: 'reservationReport_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  reservationReportId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixReservationReportMinFields = {
  __typename?: 'reservationReport_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  reservationReportId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "reporting.reservation_report" */
export type TixReservationReportMutationResponse = {
  __typename?: 'reservationReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixReservationReport>;
};

/** on_conflict condition type for table "reporting.reservation_report" */
export type TixReservationReportOnConflict = {
  constraint: TixReservationReportConstraint;
  update_columns?: Array<TixReservationReportUpdateColumn>;
  where?: InputMaybe<TixReservationReportBoolExp>;
};

/** Ordering options when selecting data from "reporting.reservation_report". */
export type TixReservationReportOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  reservationReport?: InputMaybe<TixOrderBy>;
  reservationReportId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: reporting.reservation_report */
export type TixReservationReportPkColumnsInput = {
  reservationReportId: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TixReservationReportPrependInput = {
  reservationReport?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "reporting.reservation_report" */
export enum TixReservationReportSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  ReservationReport = 'reservationReport',
  /** column name */
  ReservationReportId = 'reservationReportId'
}

/** input type for updating data in table "reporting.reservation_report" */
export type TixReservationReportSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  reservationReport?: InputMaybe<Scalars['jsonb']>;
  reservationReportId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "reservationReport" */
export type TixReservationReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixReservationReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixReservationReportStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  reservationReport?: InputMaybe<Scalars['jsonb']>;
  reservationReportId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "reporting.reservation_report" */
export enum TixReservationReportUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  ReservationReport = 'reservationReport',
  /** column name */
  ReservationReportId = 'reservationReportId'
}

export type TixReservationReportUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TixReservationReportAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TixReservationReportDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TixReservationReportDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TixReservationReportDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TixReservationReportPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixReservationReportSetInput>;
  /** filter the rows which have to be updated */
  where: TixReservationReportBoolExp;
};

/** columns and relationships of "reporting.v_reservation_summary_report" */
export type TixReservationSummaryReport = {
  __typename?: 'reservationSummaryReport';
  CompanyName?: Maybe<Scalars['String']>;
  /** An object relationship */
  TicketMetrics?: Maybe<TixTicketVTicketSalesMetrics>;
  companyId?: Maybe<Scalars['uuid']>;
  discount?: Maybe<Scalars['numeric']>;
  discountCode?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedReservationDate?: Maybe<Scalars['String']>;
  formattedStartTime?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  reservationState?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['time']>;
  subTotal?: Maybe<Scalars['numeric']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketType?: Maybe<Scalars['String']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalRevenue?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reporting.v_reservation_summary_report" */
export type TixReservationSummaryReportAggregate = {
  __typename?: 'reservationSummaryReport_aggregate';
  aggregate?: Maybe<TixReservationSummaryReportAggregateFields>;
  nodes: Array<TixReservationSummaryReport>;
};

/** aggregate fields of "reporting.v_reservation_summary_report" */
export type TixReservationSummaryReportAggregateFields = {
  __typename?: 'reservationSummaryReport_aggregate_fields';
  avg?: Maybe<TixReservationSummaryReportAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixReservationSummaryReportMaxFields>;
  min?: Maybe<TixReservationSummaryReportMinFields>;
  stddev?: Maybe<TixReservationSummaryReportStddevFields>;
  stddev_pop?: Maybe<TixReservationSummaryReportStddevPopFields>;
  stddev_samp?: Maybe<TixReservationSummaryReportStddevSampFields>;
  sum?: Maybe<TixReservationSummaryReportSumFields>;
  var_pop?: Maybe<TixReservationSummaryReportVarPopFields>;
  var_samp?: Maybe<TixReservationSummaryReportVarSampFields>;
  variance?: Maybe<TixReservationSummaryReportVarianceFields>;
};


/** aggregate fields of "reporting.v_reservation_summary_report" */
export type TixReservationSummaryReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixReservationSummaryReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixReservationSummaryReportAvgFields = {
  __typename?: 'reservationSummaryReport_avg_fields';
  discount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reporting.v_reservation_summary_report". All fields are combined with a logical 'AND'. */
export type TixReservationSummaryReportBoolExp = {
  CompanyName?: InputMaybe<TixStringComparisonExp>;
  TicketMetrics?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
  _and?: InputMaybe<Array<TixReservationSummaryReportBoolExp>>;
  _not?: InputMaybe<TixReservationSummaryReportBoolExp>;
  _or?: InputMaybe<Array<TixReservationSummaryReportBoolExp>>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  discount?: InputMaybe<TixNumericComparisonExp>;
  discountCode?: InputMaybe<TixStringComparisonExp>;
  emailAddress?: InputMaybe<TixStringComparisonExp>;
  eventDate?: InputMaybe<TixDateComparisonExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  eventName?: InputMaybe<TixStringComparisonExp>;
  eventState?: InputMaybe<TixStringComparisonExp>;
  formattedEventDate?: InputMaybe<TixStringComparisonExp>;
  formattedReservationDate?: InputMaybe<TixStringComparisonExp>;
  formattedStartTime?: InputMaybe<TixStringComparisonExp>;
  fullName?: InputMaybe<TixStringComparisonExp>;
  paymentState?: InputMaybe<TixStringComparisonExp>;
  paymentType?: InputMaybe<TixStringComparisonExp>;
  platformFee?: InputMaybe<TixNumericComparisonExp>;
  processingFee?: InputMaybe<TixNumericComparisonExp>;
  refundAmount?: InputMaybe<TixNumericComparisonExp>;
  reservationDate?: InputMaybe<TixDateComparisonExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  reservationNo?: InputMaybe<TixStringComparisonExp>;
  reservationState?: InputMaybe<TixStringComparisonExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  startTime?: InputMaybe<TixTimeComparisonExp>;
  subTotal?: InputMaybe<TixNumericComparisonExp>;
  ticketCount?: InputMaybe<TixBigintComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  totalAmountPaid?: InputMaybe<TixNumericComparisonExp>;
  totalRevenue?: InputMaybe<TixNumericComparisonExp>;
  venueFee?: InputMaybe<TixNumericComparisonExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  venueName?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixReservationSummaryReportMaxFields = {
  __typename?: 'reservationSummaryReport_max_fields';
  CompanyName?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  discount?: Maybe<Scalars['numeric']>;
  discountCode?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedReservationDate?: Maybe<Scalars['String']>;
  formattedStartTime?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  reservationState?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['numeric']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketType?: Maybe<Scalars['String']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalRevenue?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixReservationSummaryReportMinFields = {
  __typename?: 'reservationSummaryReport_min_fields';
  CompanyName?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['uuid']>;
  discount?: Maybe<Scalars['numeric']>;
  discountCode?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['date']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  eventName?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  formattedEventDate?: Maybe<Scalars['String']>;
  formattedReservationDate?: Maybe<Scalars['String']>;
  formattedStartTime?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationNo?: Maybe<Scalars['String']>;
  reservationState?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['numeric']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  ticketType?: Maybe<Scalars['String']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalRevenue?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
  venueId?: Maybe<Scalars['uuid']>;
  venueName?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reporting.v_reservation_summary_report". */
export type TixReservationSummaryReportOrderBy = {
  CompanyName?: InputMaybe<TixOrderBy>;
  TicketMetrics?: InputMaybe<TixTicketVTicketSalesMetricsOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  discount?: InputMaybe<TixOrderBy>;
  discountCode?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  eventDate?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  eventName?: InputMaybe<TixOrderBy>;
  eventState?: InputMaybe<TixOrderBy>;
  formattedEventDate?: InputMaybe<TixOrderBy>;
  formattedReservationDate?: InputMaybe<TixOrderBy>;
  formattedStartTime?: InputMaybe<TixOrderBy>;
  fullName?: InputMaybe<TixOrderBy>;
  paymentState?: InputMaybe<TixOrderBy>;
  paymentType?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  refundAmount?: InputMaybe<TixOrderBy>;
  reservationDate?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationNo?: InputMaybe<TixOrderBy>;
  reservationState?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  startTime?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  ticketCount?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  totalRevenue?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  venueName?: InputMaybe<TixOrderBy>;
};

/** select columns of table "reporting.v_reservation_summary_report" */
export enum TixReservationSummaryReportSelectColumn {
  /** column name */
  CompanyName = 'CompanyName',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  Discount = 'discount',
  /** column name */
  DiscountCode = 'discountCode',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  EventDate = 'eventDate',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  EventName = 'eventName',
  /** column name */
  EventState = 'eventState',
  /** column name */
  FormattedEventDate = 'formattedEventDate',
  /** column name */
  FormattedReservationDate = 'formattedReservationDate',
  /** column name */
  FormattedStartTime = 'formattedStartTime',
  /** column name */
  FullName = 'fullName',
  /** column name */
  PaymentState = 'paymentState',
  /** column name */
  PaymentType = 'paymentType',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  RefundAmount = 'refundAmount',
  /** column name */
  ReservationDate = 'reservationDate',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationNo = 'reservationNo',
  /** column name */
  ReservationState = 'reservationState',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  SubTotal = 'subTotal',
  /** column name */
  TicketCount = 'ticketCount',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  TotalAmountPaid = 'totalAmountPaid',
  /** column name */
  TotalRevenue = 'totalRevenue',
  /** column name */
  VenueFee = 'venueFee',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  VenueName = 'venueName'
}

/** aggregate stddev on columns */
export type TixReservationSummaryReportStddevFields = {
  __typename?: 'reservationSummaryReport_stddev_fields';
  discount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixReservationSummaryReportStddevPopFields = {
  __typename?: 'reservationSummaryReport_stddev_pop_fields';
  discount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixReservationSummaryReportStddevSampFields = {
  __typename?: 'reservationSummaryReport_stddev_samp_fields';
  discount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reservationSummaryReport" */
export type TixReservationSummaryReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixReservationSummaryReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixReservationSummaryReportStreamCursorValueInput = {
  CompanyName?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  discount?: InputMaybe<Scalars['numeric']>;
  discountCode?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['date']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  formattedEventDate?: InputMaybe<Scalars['String']>;
  formattedReservationDate?: InputMaybe<Scalars['String']>;
  formattedStartTime?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  paymentState?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  platformFee?: InputMaybe<Scalars['numeric']>;
  processingFee?: InputMaybe<Scalars['numeric']>;
  refundAmount?: InputMaybe<Scalars['numeric']>;
  reservationDate?: InputMaybe<Scalars['date']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationNo?: InputMaybe<Scalars['String']>;
  reservationState?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['time']>;
  subTotal?: InputMaybe<Scalars['numeric']>;
  ticketCount?: InputMaybe<Scalars['bigint']>;
  ticketType?: InputMaybe<Scalars['String']>;
  totalAmountPaid?: InputMaybe<Scalars['numeric']>;
  totalRevenue?: InputMaybe<Scalars['numeric']>;
  venueFee?: InputMaybe<Scalars['numeric']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueName?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type TixReservationSummaryReportSumFields = {
  __typename?: 'reservationSummaryReport_sum_fields';
  discount?: Maybe<Scalars['numeric']>;
  platformFee?: Maybe<Scalars['numeric']>;
  processingFee?: Maybe<Scalars['numeric']>;
  refundAmount?: Maybe<Scalars['numeric']>;
  subTotal?: Maybe<Scalars['numeric']>;
  ticketCount?: Maybe<Scalars['bigint']>;
  totalAmountPaid?: Maybe<Scalars['numeric']>;
  totalRevenue?: Maybe<Scalars['numeric']>;
  venueFee?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type TixReservationSummaryReportVarPopFields = {
  __typename?: 'reservationSummaryReport_var_pop_fields';
  discount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixReservationSummaryReportVarSampFields = {
  __typename?: 'reservationSummaryReport_var_samp_fields';
  discount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixReservationSummaryReportVarianceFields = {
  __typename?: 'reservationSummaryReport_variance_fields';
  discount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  ticketCount?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reporting.saved_report" */
export type TixSavedReport = {
  __typename?: 'savedReport';
  /** An object relationship */
  company: TixCompany;
  companyId: Scalars['uuid'];
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  discountCodeId?: Maybe<Array<Scalars['uuid']>>;
  discountEndDate?: Maybe<Scalars['date']>;
  discountStartDate?: Maybe<Scalars['date']>;
  level?: Maybe<Scalars['String']>;
  reportName: Scalars['String'];
  reportType?: Maybe<Scalars['String']>;
  reportVenueIds?: Maybe<Array<Scalars['uuid']>>;
  /** An array relationship */
  savedReportEvents: Array<TixSavedReportEvents>;
  /** An aggregate relationship */
  savedReportEvents_aggregate: TixSavedReportEventsAggregate;
  savedReportId: Scalars['uuid'];
  /** An array relationship */
  savedReportLayouts: Array<TixSavedReportLayout>;
  /** An aggregate relationship */
  savedReportLayouts_aggregate: TixSavedReportLayoutAggregate;
  /** An array relationship */
  scheduledReports: Array<TixScheduledReport>;
  /** An aggregate relationship */
  scheduledReports_aggregate: TixScheduledReportAggregate;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
  /** An object relationship */
  venue: TixVenue;
  venueId: Scalars['uuid'];
  visibility?: Maybe<Scalars['String']>;
};


/** columns and relationships of "reporting.saved_report" */
export type TixSavedReportSavedReportEventsArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportEventsOrderBy>>;
  where?: InputMaybe<TixSavedReportEventsBoolExp>;
};


/** columns and relationships of "reporting.saved_report" */
export type TixSavedReportSavedReportEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportEventsOrderBy>>;
  where?: InputMaybe<TixSavedReportEventsBoolExp>;
};


/** columns and relationships of "reporting.saved_report" */
export type TixSavedReportSavedReportLayoutsArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportLayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportLayoutOrderBy>>;
  where?: InputMaybe<TixSavedReportLayoutBoolExp>;
};


/** columns and relationships of "reporting.saved_report" */
export type TixSavedReportSavedReportLayoutsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportLayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportLayoutOrderBy>>;
  where?: InputMaybe<TixSavedReportLayoutBoolExp>;
};


/** columns and relationships of "reporting.saved_report" */
export type TixSavedReportScheduledReportsArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportOrderBy>>;
  where?: InputMaybe<TixScheduledReportBoolExp>;
};


/** columns and relationships of "reporting.saved_report" */
export type TixSavedReportScheduledReportsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportOrderBy>>;
  where?: InputMaybe<TixScheduledReportBoolExp>;
};

/** columns and relationships of "reporting.saved_report_events" */
export type TixSavedReportEvents = {
  __typename?: 'savedReportEvents';
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId: Scalars['uuid'];
  savedReportEventsId: Scalars['uuid'];
  savedReportId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "reporting.saved_report_events" */
export type TixSavedReportEventsAggregate = {
  __typename?: 'savedReportEvents_aggregate';
  aggregate?: Maybe<TixSavedReportEventsAggregateFields>;
  nodes: Array<TixSavedReportEvents>;
};

export type TixSavedReportEventsAggregateBoolExp = {
  count?: InputMaybe<TixSavedReportEventsAggregateBoolExpCount>;
};

export type TixSavedReportEventsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixSavedReportEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixSavedReportEventsBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "reporting.saved_report_events" */
export type TixSavedReportEventsAggregateFields = {
  __typename?: 'savedReportEvents_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixSavedReportEventsMaxFields>;
  min?: Maybe<TixSavedReportEventsMinFields>;
};


/** aggregate fields of "reporting.saved_report_events" */
export type TixSavedReportEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixSavedReportEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.saved_report_events" */
export type TixSavedReportEventsAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixSavedReportEventsMaxOrderBy>;
  min?: InputMaybe<TixSavedReportEventsMinOrderBy>;
};

/** input type for inserting array relation for remote table "reporting.saved_report_events" */
export type TixSavedReportEventsArrRelInsertInput = {
  data: Array<TixSavedReportEventsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixSavedReportEventsOnConflict>;
};

/** Boolean expression to filter rows from the table "reporting.saved_report_events". All fields are combined with a logical 'AND'. */
export type TixSavedReportEventsBoolExp = {
  _and?: InputMaybe<Array<TixSavedReportEventsBoolExp>>;
  _not?: InputMaybe<TixSavedReportEventsBoolExp>;
  _or?: InputMaybe<Array<TixSavedReportEventsBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  savedReportEventsId?: InputMaybe<TixUuidComparisonExp>;
  savedReportId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "reporting.saved_report_events" */
export enum TixSavedReportEventsConstraint {
  /** unique or primary key constraint on columns "saved_report_events_id" */
  SavedReportEventsPkey = 'saved_report_events_pkey'
}

/** input type for inserting data into table "reporting.saved_report_events" */
export type TixSavedReportEventsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  savedReportEventsId?: InputMaybe<Scalars['uuid']>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixSavedReportEventsMaxFields = {
  __typename?: 'savedReportEvents_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  savedReportEventsId?: Maybe<Scalars['uuid']>;
  savedReportId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reporting.saved_report_events" */
export type TixSavedReportEventsMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  savedReportEventsId?: InputMaybe<TixOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixSavedReportEventsMinFields = {
  __typename?: 'savedReportEvents_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  savedReportEventsId?: Maybe<Scalars['uuid']>;
  savedReportId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reporting.saved_report_events" */
export type TixSavedReportEventsMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  savedReportEventsId?: InputMaybe<TixOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "reporting.saved_report_events" */
export type TixSavedReportEventsMutationResponse = {
  __typename?: 'savedReportEvents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixSavedReportEvents>;
};

/** on_conflict condition type for table "reporting.saved_report_events" */
export type TixSavedReportEventsOnConflict = {
  constraint: TixSavedReportEventsConstraint;
  update_columns?: Array<TixSavedReportEventsUpdateColumn>;
  where?: InputMaybe<TixSavedReportEventsBoolExp>;
};

/** Ordering options when selecting data from "reporting.saved_report_events". */
export type TixSavedReportEventsOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  savedReportEventsId?: InputMaybe<TixOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: reporting.saved_report_events */
export type TixSavedReportEventsPkColumnsInput = {
  savedReportEventsId: Scalars['uuid'];
};

/** select columns of table "reporting.saved_report_events" */
export enum TixSavedReportEventsSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  SavedReportEventsId = 'savedReportEventsId',
  /** column name */
  SavedReportId = 'savedReportId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "reporting.saved_report_events" */
export type TixSavedReportEventsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  savedReportEventsId?: InputMaybe<Scalars['uuid']>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "savedReportEvents" */
export type TixSavedReportEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixSavedReportEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixSavedReportEventsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  savedReportEventsId?: InputMaybe<Scalars['uuid']>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "reporting.saved_report_events" */
export enum TixSavedReportEventsUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  SavedReportEventsId = 'savedReportEventsId',
  /** column name */
  SavedReportId = 'savedReportId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixSavedReportEventsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixSavedReportEventsSetInput>;
  /** filter the rows which have to be updated */
  where: TixSavedReportEventsBoolExp;
};

/** columns and relationships of "reporting.saved_report_layout" */
export type TixSavedReportLayout = {
  __typename?: 'savedReportLayout';
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  includedColumnName: Scalars['String'];
  savedReportId: Scalars['uuid'];
  savedReportLayoutId: Scalars['uuid'];
  /** An object relationship */
  saved_report: TixSavedReport;
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "reporting.saved_report_layout" */
export type TixSavedReportLayoutAggregate = {
  __typename?: 'savedReportLayout_aggregate';
  aggregate?: Maybe<TixSavedReportLayoutAggregateFields>;
  nodes: Array<TixSavedReportLayout>;
};

export type TixSavedReportLayoutAggregateBoolExp = {
  count?: InputMaybe<TixSavedReportLayoutAggregateBoolExpCount>;
};

export type TixSavedReportLayoutAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixSavedReportLayoutSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixSavedReportLayoutBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "reporting.saved_report_layout" */
export type TixSavedReportLayoutAggregateFields = {
  __typename?: 'savedReportLayout_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixSavedReportLayoutMaxFields>;
  min?: Maybe<TixSavedReportLayoutMinFields>;
};


/** aggregate fields of "reporting.saved_report_layout" */
export type TixSavedReportLayoutAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixSavedReportLayoutSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.saved_report_layout" */
export type TixSavedReportLayoutAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixSavedReportLayoutMaxOrderBy>;
  min?: InputMaybe<TixSavedReportLayoutMinOrderBy>;
};

/** input type for inserting array relation for remote table "reporting.saved_report_layout" */
export type TixSavedReportLayoutArrRelInsertInput = {
  data: Array<TixSavedReportLayoutInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixSavedReportLayoutOnConflict>;
};

/** Boolean expression to filter rows from the table "reporting.saved_report_layout". All fields are combined with a logical 'AND'. */
export type TixSavedReportLayoutBoolExp = {
  _and?: InputMaybe<Array<TixSavedReportLayoutBoolExp>>;
  _not?: InputMaybe<TixSavedReportLayoutBoolExp>;
  _or?: InputMaybe<Array<TixSavedReportLayoutBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  includedColumnName?: InputMaybe<TixStringComparisonExp>;
  savedReportId?: InputMaybe<TixUuidComparisonExp>;
  savedReportLayoutId?: InputMaybe<TixUuidComparisonExp>;
  saved_report?: InputMaybe<TixSavedReportBoolExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "reporting.saved_report_layout" */
export enum TixSavedReportLayoutConstraint {
  /** unique or primary key constraint on columns "saved_report_layout_id" */
  SavedReportLayoutPkey = 'saved_report_layout_pkey'
}

/** input type for inserting data into table "reporting.saved_report_layout" */
export type TixSavedReportLayoutInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  includedColumnName?: InputMaybe<Scalars['String']>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  savedReportLayoutId?: InputMaybe<Scalars['uuid']>;
  saved_report?: InputMaybe<TixSavedReportObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixSavedReportLayoutMaxFields = {
  __typename?: 'savedReportLayout_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  includedColumnName?: Maybe<Scalars['String']>;
  savedReportId?: Maybe<Scalars['uuid']>;
  savedReportLayoutId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reporting.saved_report_layout" */
export type TixSavedReportLayoutMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  includedColumnName?: InputMaybe<TixOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  savedReportLayoutId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixSavedReportLayoutMinFields = {
  __typename?: 'savedReportLayout_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  includedColumnName?: Maybe<Scalars['String']>;
  savedReportId?: Maybe<Scalars['uuid']>;
  savedReportLayoutId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reporting.saved_report_layout" */
export type TixSavedReportLayoutMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  includedColumnName?: InputMaybe<TixOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  savedReportLayoutId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "reporting.saved_report_layout" */
export type TixSavedReportLayoutMutationResponse = {
  __typename?: 'savedReportLayout_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixSavedReportLayout>;
};

/** on_conflict condition type for table "reporting.saved_report_layout" */
export type TixSavedReportLayoutOnConflict = {
  constraint: TixSavedReportLayoutConstraint;
  update_columns?: Array<TixSavedReportLayoutUpdateColumn>;
  where?: InputMaybe<TixSavedReportLayoutBoolExp>;
};

/** Ordering options when selecting data from "reporting.saved_report_layout". */
export type TixSavedReportLayoutOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  includedColumnName?: InputMaybe<TixOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  savedReportLayoutId?: InputMaybe<TixOrderBy>;
  saved_report?: InputMaybe<TixSavedReportOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: reporting.saved_report_layout */
export type TixSavedReportLayoutPkColumnsInput = {
  savedReportLayoutId: Scalars['uuid'];
};

/** select columns of table "reporting.saved_report_layout" */
export enum TixSavedReportLayoutSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  IncludedColumnName = 'includedColumnName',
  /** column name */
  SavedReportId = 'savedReportId',
  /** column name */
  SavedReportLayoutId = 'savedReportLayoutId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "reporting.saved_report_layout" */
export type TixSavedReportLayoutSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  includedColumnName?: InputMaybe<Scalars['String']>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  savedReportLayoutId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "savedReportLayout" */
export type TixSavedReportLayoutStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixSavedReportLayoutStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixSavedReportLayoutStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  includedColumnName?: InputMaybe<Scalars['String']>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  savedReportLayoutId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "reporting.saved_report_layout" */
export enum TixSavedReportLayoutUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  IncludedColumnName = 'includedColumnName',
  /** column name */
  SavedReportId = 'savedReportId',
  /** column name */
  SavedReportLayoutId = 'savedReportLayoutId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixSavedReportLayoutUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixSavedReportLayoutSetInput>;
  /** filter the rows which have to be updated */
  where: TixSavedReportLayoutBoolExp;
};

/** aggregated selection of "reporting.saved_report" */
export type TixSavedReportAggregate = {
  __typename?: 'savedReport_aggregate';
  aggregate?: Maybe<TixSavedReportAggregateFields>;
  nodes: Array<TixSavedReport>;
};

/** aggregate fields of "reporting.saved_report" */
export type TixSavedReportAggregateFields = {
  __typename?: 'savedReport_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixSavedReportMaxFields>;
  min?: Maybe<TixSavedReportMinFields>;
};


/** aggregate fields of "reporting.saved_report" */
export type TixSavedReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixSavedReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "reporting.saved_report". All fields are combined with a logical 'AND'. */
export type TixSavedReportBoolExp = {
  _and?: InputMaybe<Array<TixSavedReportBoolExp>>;
  _not?: InputMaybe<TixSavedReportBoolExp>;
  _or?: InputMaybe<Array<TixSavedReportBoolExp>>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  discountCodeId?: InputMaybe<TixUuidArrayComparisonExp>;
  discountEndDate?: InputMaybe<TixDateComparisonExp>;
  discountStartDate?: InputMaybe<TixDateComparisonExp>;
  level?: InputMaybe<TixStringComparisonExp>;
  reportName?: InputMaybe<TixStringComparisonExp>;
  reportType?: InputMaybe<TixStringComparisonExp>;
  reportVenueIds?: InputMaybe<TixUuidArrayComparisonExp>;
  savedReportEvents?: InputMaybe<TixSavedReportEventsBoolExp>;
  savedReportEvents_aggregate?: InputMaybe<TixSavedReportEventsAggregateBoolExp>;
  savedReportId?: InputMaybe<TixUuidComparisonExp>;
  savedReportLayouts?: InputMaybe<TixSavedReportLayoutBoolExp>;
  savedReportLayouts_aggregate?: InputMaybe<TixSavedReportLayoutAggregateBoolExp>;
  scheduledReports?: InputMaybe<TixScheduledReportBoolExp>;
  scheduledReports_aggregate?: InputMaybe<TixScheduledReportAggregateBoolExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
  visibility?: InputMaybe<TixStringComparisonExp>;
};

/** unique or primary key constraints on table "reporting.saved_report" */
export enum TixSavedReportConstraint {
  /** unique or primary key constraint on columns "saved_report_id" */
  SavedReportPkey = 'saved_report_pkey'
}

/** input type for inserting data into table "reporting.saved_report" */
export type TixSavedReportInsertInput = {
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountCodeId?: InputMaybe<Array<Scalars['uuid']>>;
  discountEndDate?: InputMaybe<Scalars['date']>;
  discountStartDate?: InputMaybe<Scalars['date']>;
  level?: InputMaybe<Scalars['String']>;
  reportName?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['String']>;
  reportVenueIds?: InputMaybe<Array<Scalars['uuid']>>;
  savedReportEvents?: InputMaybe<TixSavedReportEventsArrRelInsertInput>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  savedReportLayouts?: InputMaybe<TixSavedReportLayoutArrRelInsertInput>;
  scheduledReports?: InputMaybe<TixScheduledReportArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
  visibility?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TixSavedReportMaxFields = {
  __typename?: 'savedReport_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountCodeId?: Maybe<Array<Scalars['uuid']>>;
  discountEndDate?: Maybe<Scalars['date']>;
  discountStartDate?: Maybe<Scalars['date']>;
  level?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['String']>;
  reportVenueIds?: Maybe<Array<Scalars['uuid']>>;
  savedReportId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  visibility?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixSavedReportMinFields = {
  __typename?: 'savedReport_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountCodeId?: Maybe<Array<Scalars['uuid']>>;
  discountEndDate?: Maybe<Scalars['date']>;
  discountStartDate?: Maybe<Scalars['date']>;
  level?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['String']>;
  reportVenueIds?: Maybe<Array<Scalars['uuid']>>;
  savedReportId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
  visibility?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "reporting.saved_report" */
export type TixSavedReportMutationResponse = {
  __typename?: 'savedReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixSavedReport>;
};

/** input type for inserting object relation for remote table "reporting.saved_report" */
export type TixSavedReportObjRelInsertInput = {
  data: TixSavedReportInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixSavedReportOnConflict>;
};

/** on_conflict condition type for table "reporting.saved_report" */
export type TixSavedReportOnConflict = {
  constraint: TixSavedReportConstraint;
  update_columns?: Array<TixSavedReportUpdateColumn>;
  where?: InputMaybe<TixSavedReportBoolExp>;
};

/** Ordering options when selecting data from "reporting.saved_report". */
export type TixSavedReportOrderBy = {
  company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountCodeId?: InputMaybe<TixOrderBy>;
  discountEndDate?: InputMaybe<TixOrderBy>;
  discountStartDate?: InputMaybe<TixOrderBy>;
  level?: InputMaybe<TixOrderBy>;
  reportName?: InputMaybe<TixOrderBy>;
  reportType?: InputMaybe<TixOrderBy>;
  reportVenueIds?: InputMaybe<TixOrderBy>;
  savedReportEvents_aggregate?: InputMaybe<TixSavedReportEventsAggregateOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  savedReportLayouts_aggregate?: InputMaybe<TixSavedReportLayoutAggregateOrderBy>;
  scheduledReports_aggregate?: InputMaybe<TixScheduledReportAggregateOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
  visibility?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: reporting.saved_report */
export type TixSavedReportPkColumnsInput = {
  savedReportId: Scalars['uuid'];
};

/** select columns of table "reporting.saved_report" */
export enum TixSavedReportSelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountCodeId = 'discountCodeId',
  /** column name */
  DiscountEndDate = 'discountEndDate',
  /** column name */
  DiscountStartDate = 'discountStartDate',
  /** column name */
  Level = 'level',
  /** column name */
  ReportName = 'reportName',
  /** column name */
  ReportType = 'reportType',
  /** column name */
  ReportVenueIds = 'reportVenueIds',
  /** column name */
  SavedReportId = 'savedReportId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  Visibility = 'visibility'
}

/** input type for updating data in table "reporting.saved_report" */
export type TixSavedReportSetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountCodeId?: InputMaybe<Array<Scalars['uuid']>>;
  discountEndDate?: InputMaybe<Scalars['date']>;
  discountStartDate?: InputMaybe<Scalars['date']>;
  level?: InputMaybe<Scalars['String']>;
  reportName?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['String']>;
  reportVenueIds?: InputMaybe<Array<Scalars['uuid']>>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  visibility?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "savedReport" */
export type TixSavedReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixSavedReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixSavedReportStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountCodeId?: InputMaybe<Array<Scalars['uuid']>>;
  discountEndDate?: InputMaybe<Scalars['date']>;
  discountStartDate?: InputMaybe<Scalars['date']>;
  level?: InputMaybe<Scalars['String']>;
  reportName?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['String']>;
  reportVenueIds?: InputMaybe<Array<Scalars['uuid']>>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  visibility?: InputMaybe<Scalars['String']>;
};

/** update columns of table "reporting.saved_report" */
export enum TixSavedReportUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountCodeId = 'discountCodeId',
  /** column name */
  DiscountEndDate = 'discountEndDate',
  /** column name */
  DiscountStartDate = 'discountStartDate',
  /** column name */
  Level = 'level',
  /** column name */
  ReportName = 'reportName',
  /** column name */
  ReportType = 'reportType',
  /** column name */
  ReportVenueIds = 'reportVenueIds',
  /** column name */
  SavedReportId = 'savedReportId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId',
  /** column name */
  Visibility = 'visibility'
}

export type TixSavedReportUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixSavedReportSetInput>;
  /** filter the rows which have to be updated */
  where: TixSavedReportBoolExp;
};

/** columns and relationships of "reporting.scheduled_report" */
export type TixScheduledReport = {
  __typename?: 'scheduledReport';
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  frequency: Scalars['String'];
  /** An object relationship */
  savedReport: TixSavedReport;
  savedReportId: Scalars['uuid'];
  scheduleName: Scalars['String'];
  /** An array relationship */
  scheduledReportEmails: Array<TixScheduledReportEmail>;
  /** An aggregate relationship */
  scheduledReportEmails_aggregate: TixScheduledReportEmailAggregate;
  scheduledReportId: Scalars['uuid'];
  startSendingTimestamp: Scalars['timestamptz'];
  stopSendingTimestamp: Scalars['timestamptz'];
  timeOfDay: Scalars['timetz'];
  timezone: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};


/** columns and relationships of "reporting.scheduled_report" */
export type TixScheduledReportScheduledReportEmailsArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportEmailOrderBy>>;
  where?: InputMaybe<TixScheduledReportEmailBoolExp>;
};


/** columns and relationships of "reporting.scheduled_report" */
export type TixScheduledReportScheduledReportEmailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportEmailOrderBy>>;
  where?: InputMaybe<TixScheduledReportEmailBoolExp>;
};

/** columns and relationships of "reporting.scheduled_report_email" */
export type TixScheduledReportEmail = {
  __typename?: 'scheduledReportEmail';
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['uuid'];
  emailAddress: Scalars['String'];
  scheduleReportId: Scalars['uuid'];
  /** An object relationship */
  scheduledReport: TixScheduledReport;
  scheduledReportEmailId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "reporting.scheduled_report_email" */
export type TixScheduledReportEmailAggregate = {
  __typename?: 'scheduledReportEmail_aggregate';
  aggregate?: Maybe<TixScheduledReportEmailAggregateFields>;
  nodes: Array<TixScheduledReportEmail>;
};

export type TixScheduledReportEmailAggregateBoolExp = {
  count?: InputMaybe<TixScheduledReportEmailAggregateBoolExpCount>;
};

export type TixScheduledReportEmailAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixScheduledReportEmailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixScheduledReportEmailBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "reporting.scheduled_report_email" */
export type TixScheduledReportEmailAggregateFields = {
  __typename?: 'scheduledReportEmail_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixScheduledReportEmailMaxFields>;
  min?: Maybe<TixScheduledReportEmailMinFields>;
};


/** aggregate fields of "reporting.scheduled_report_email" */
export type TixScheduledReportEmailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixScheduledReportEmailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.scheduled_report_email" */
export type TixScheduledReportEmailAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixScheduledReportEmailMaxOrderBy>;
  min?: InputMaybe<TixScheduledReportEmailMinOrderBy>;
};

/** input type for inserting array relation for remote table "reporting.scheduled_report_email" */
export type TixScheduledReportEmailArrRelInsertInput = {
  data: Array<TixScheduledReportEmailInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixScheduledReportEmailOnConflict>;
};

/** Boolean expression to filter rows from the table "reporting.scheduled_report_email". All fields are combined with a logical 'AND'. */
export type TixScheduledReportEmailBoolExp = {
  _and?: InputMaybe<Array<TixScheduledReportEmailBoolExp>>;
  _not?: InputMaybe<TixScheduledReportEmailBoolExp>;
  _or?: InputMaybe<Array<TixScheduledReportEmailBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  emailAddress?: InputMaybe<TixStringComparisonExp>;
  scheduleReportId?: InputMaybe<TixUuidComparisonExp>;
  scheduledReport?: InputMaybe<TixScheduledReportBoolExp>;
  scheduledReportEmailId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "reporting.scheduled_report_email" */
export enum TixScheduledReportEmailConstraint {
  /** unique or primary key constraint on columns "scheduled_report_email_id" */
  ScheduledReportEmailsPkey = 'scheduled_report_emails_pkey'
}

/** input type for inserting data into table "reporting.scheduled_report_email" */
export type TixScheduledReportEmailInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  scheduleReportId?: InputMaybe<Scalars['uuid']>;
  scheduledReport?: InputMaybe<TixScheduledReportObjRelInsertInput>;
  scheduledReportEmailId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixScheduledReportEmailMaxFields = {
  __typename?: 'scheduledReportEmail_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailAddress?: Maybe<Scalars['String']>;
  scheduleReportId?: Maybe<Scalars['uuid']>;
  scheduledReportEmailId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reporting.scheduled_report_email" */
export type TixScheduledReportEmailMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  scheduleReportId?: InputMaybe<TixOrderBy>;
  scheduledReportEmailId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixScheduledReportEmailMinFields = {
  __typename?: 'scheduledReportEmail_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailAddress?: Maybe<Scalars['String']>;
  scheduleReportId?: Maybe<Scalars['uuid']>;
  scheduledReportEmailId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reporting.scheduled_report_email" */
export type TixScheduledReportEmailMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  scheduleReportId?: InputMaybe<TixOrderBy>;
  scheduledReportEmailId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "reporting.scheduled_report_email" */
export type TixScheduledReportEmailMutationResponse = {
  __typename?: 'scheduledReportEmail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixScheduledReportEmail>;
};

/** on_conflict condition type for table "reporting.scheduled_report_email" */
export type TixScheduledReportEmailOnConflict = {
  constraint: TixScheduledReportEmailConstraint;
  update_columns?: Array<TixScheduledReportEmailUpdateColumn>;
  where?: InputMaybe<TixScheduledReportEmailBoolExp>;
};

/** Ordering options when selecting data from "reporting.scheduled_report_email". */
export type TixScheduledReportEmailOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  emailAddress?: InputMaybe<TixOrderBy>;
  scheduleReportId?: InputMaybe<TixOrderBy>;
  scheduledReport?: InputMaybe<TixScheduledReportOrderBy>;
  scheduledReportEmailId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: reporting.scheduled_report_email */
export type TixScheduledReportEmailPkColumnsInput = {
  scheduledReportEmailId: Scalars['uuid'];
};

/** select columns of table "reporting.scheduled_report_email" */
export enum TixScheduledReportEmailSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  ScheduleReportId = 'scheduleReportId',
  /** column name */
  ScheduledReportEmailId = 'scheduledReportEmailId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "reporting.scheduled_report_email" */
export type TixScheduledReportEmailSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  scheduleReportId?: InputMaybe<Scalars['uuid']>;
  scheduledReportEmailId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "scheduledReportEmail" */
export type TixScheduledReportEmailStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixScheduledReportEmailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixScheduledReportEmailStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  scheduleReportId?: InputMaybe<Scalars['uuid']>;
  scheduledReportEmailId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "reporting.scheduled_report_email" */
export enum TixScheduledReportEmailUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  ScheduleReportId = 'scheduleReportId',
  /** column name */
  ScheduledReportEmailId = 'scheduledReportEmailId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixScheduledReportEmailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixScheduledReportEmailSetInput>;
  /** filter the rows which have to be updated */
  where: TixScheduledReportEmailBoolExp;
};

/** aggregated selection of "reporting.scheduled_report" */
export type TixScheduledReportAggregate = {
  __typename?: 'scheduledReport_aggregate';
  aggregate?: Maybe<TixScheduledReportAggregateFields>;
  nodes: Array<TixScheduledReport>;
};

export type TixScheduledReportAggregateBoolExp = {
  count?: InputMaybe<TixScheduledReportAggregateBoolExpCount>;
};

export type TixScheduledReportAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixScheduledReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixScheduledReportBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "reporting.scheduled_report" */
export type TixScheduledReportAggregateFields = {
  __typename?: 'scheduledReport_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixScheduledReportMaxFields>;
  min?: Maybe<TixScheduledReportMinFields>;
};


/** aggregate fields of "reporting.scheduled_report" */
export type TixScheduledReportAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixScheduledReportSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reporting.scheduled_report" */
export type TixScheduledReportAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixScheduledReportMaxOrderBy>;
  min?: InputMaybe<TixScheduledReportMinOrderBy>;
};

/** input type for inserting array relation for remote table "reporting.scheduled_report" */
export type TixScheduledReportArrRelInsertInput = {
  data: Array<TixScheduledReportInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixScheduledReportOnConflict>;
};

/** Boolean expression to filter rows from the table "reporting.scheduled_report". All fields are combined with a logical 'AND'. */
export type TixScheduledReportBoolExp = {
  _and?: InputMaybe<Array<TixScheduledReportBoolExp>>;
  _not?: InputMaybe<TixScheduledReportBoolExp>;
  _or?: InputMaybe<Array<TixScheduledReportBoolExp>>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  frequency?: InputMaybe<TixStringComparisonExp>;
  savedReport?: InputMaybe<TixSavedReportBoolExp>;
  savedReportId?: InputMaybe<TixUuidComparisonExp>;
  scheduleName?: InputMaybe<TixStringComparisonExp>;
  scheduledReportEmails?: InputMaybe<TixScheduledReportEmailBoolExp>;
  scheduledReportEmails_aggregate?: InputMaybe<TixScheduledReportEmailAggregateBoolExp>;
  scheduledReportId?: InputMaybe<TixUuidComparisonExp>;
  startSendingTimestamp?: InputMaybe<TixTimestamptzComparisonExp>;
  stopSendingTimestamp?: InputMaybe<TixTimestamptzComparisonExp>;
  timeOfDay?: InputMaybe<TixTimetzComparisonExp>;
  timezone?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "reporting.scheduled_report" */
export enum TixScheduledReportConstraint {
  /** unique or primary key constraint on columns "scheduled_report_id" */
  ScheduledReportPkey = 'scheduled_report_pkey'
}

/** input type for inserting data into table "reporting.scheduled_report" */
export type TixScheduledReportInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  frequency?: InputMaybe<Scalars['String']>;
  savedReport?: InputMaybe<TixSavedReportObjRelInsertInput>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  scheduleName?: InputMaybe<Scalars['String']>;
  scheduledReportEmails?: InputMaybe<TixScheduledReportEmailArrRelInsertInput>;
  scheduledReportId?: InputMaybe<Scalars['uuid']>;
  startSendingTimestamp?: InputMaybe<Scalars['timestamptz']>;
  stopSendingTimestamp?: InputMaybe<Scalars['timestamptz']>;
  timeOfDay?: InputMaybe<Scalars['timetz']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixScheduledReportMaxFields = {
  __typename?: 'scheduledReport_max_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  frequency?: Maybe<Scalars['String']>;
  savedReportId?: Maybe<Scalars['uuid']>;
  scheduleName?: Maybe<Scalars['String']>;
  scheduledReportId?: Maybe<Scalars['uuid']>;
  startSendingTimestamp?: Maybe<Scalars['timestamptz']>;
  stopSendingTimestamp?: Maybe<Scalars['timestamptz']>;
  timeOfDay?: Maybe<Scalars['timetz']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reporting.scheduled_report" */
export type TixScheduledReportMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  frequency?: InputMaybe<TixOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  scheduleName?: InputMaybe<TixOrderBy>;
  scheduledReportId?: InputMaybe<TixOrderBy>;
  startSendingTimestamp?: InputMaybe<TixOrderBy>;
  stopSendingTimestamp?: InputMaybe<TixOrderBy>;
  timeOfDay?: InputMaybe<TixOrderBy>;
  timezone?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixScheduledReportMinFields = {
  __typename?: 'scheduledReport_min_fields';
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  frequency?: Maybe<Scalars['String']>;
  savedReportId?: Maybe<Scalars['uuid']>;
  scheduleName?: Maybe<Scalars['String']>;
  scheduledReportId?: Maybe<Scalars['uuid']>;
  startSendingTimestamp?: Maybe<Scalars['timestamptz']>;
  stopSendingTimestamp?: Maybe<Scalars['timestamptz']>;
  timeOfDay?: Maybe<Scalars['timetz']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reporting.scheduled_report" */
export type TixScheduledReportMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  frequency?: InputMaybe<TixOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  scheduleName?: InputMaybe<TixOrderBy>;
  scheduledReportId?: InputMaybe<TixOrderBy>;
  startSendingTimestamp?: InputMaybe<TixOrderBy>;
  stopSendingTimestamp?: InputMaybe<TixOrderBy>;
  timeOfDay?: InputMaybe<TixOrderBy>;
  timezone?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "reporting.scheduled_report" */
export type TixScheduledReportMutationResponse = {
  __typename?: 'scheduledReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixScheduledReport>;
};

/** input type for inserting object relation for remote table "reporting.scheduled_report" */
export type TixScheduledReportObjRelInsertInput = {
  data: TixScheduledReportInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixScheduledReportOnConflict>;
};

/** on_conflict condition type for table "reporting.scheduled_report" */
export type TixScheduledReportOnConflict = {
  constraint: TixScheduledReportConstraint;
  update_columns?: Array<TixScheduledReportUpdateColumn>;
  where?: InputMaybe<TixScheduledReportBoolExp>;
};

/** Ordering options when selecting data from "reporting.scheduled_report". */
export type TixScheduledReportOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  frequency?: InputMaybe<TixOrderBy>;
  savedReport?: InputMaybe<TixSavedReportOrderBy>;
  savedReportId?: InputMaybe<TixOrderBy>;
  scheduleName?: InputMaybe<TixOrderBy>;
  scheduledReportEmails_aggregate?: InputMaybe<TixScheduledReportEmailAggregateOrderBy>;
  scheduledReportId?: InputMaybe<TixOrderBy>;
  startSendingTimestamp?: InputMaybe<TixOrderBy>;
  stopSendingTimestamp?: InputMaybe<TixOrderBy>;
  timeOfDay?: InputMaybe<TixOrderBy>;
  timezone?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: reporting.scheduled_report */
export type TixScheduledReportPkColumnsInput = {
  scheduledReportId: Scalars['uuid'];
};

/** select columns of table "reporting.scheduled_report" */
export enum TixScheduledReportSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  SavedReportId = 'savedReportId',
  /** column name */
  ScheduleName = 'scheduleName',
  /** column name */
  ScheduledReportId = 'scheduledReportId',
  /** column name */
  StartSendingTimestamp = 'startSendingTimestamp',
  /** column name */
  StopSendingTimestamp = 'stopSendingTimestamp',
  /** column name */
  TimeOfDay = 'timeOfDay',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "reporting.scheduled_report" */
export type TixScheduledReportSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  frequency?: InputMaybe<Scalars['String']>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  scheduleName?: InputMaybe<Scalars['String']>;
  scheduledReportId?: InputMaybe<Scalars['uuid']>;
  startSendingTimestamp?: InputMaybe<Scalars['timestamptz']>;
  stopSendingTimestamp?: InputMaybe<Scalars['timestamptz']>;
  timeOfDay?: InputMaybe<Scalars['timetz']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "scheduledReport" */
export type TixScheduledReportStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixScheduledReportStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixScheduledReportStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  frequency?: InputMaybe<Scalars['String']>;
  savedReportId?: InputMaybe<Scalars['uuid']>;
  scheduleName?: InputMaybe<Scalars['String']>;
  scheduledReportId?: InputMaybe<Scalars['uuid']>;
  startSendingTimestamp?: InputMaybe<Scalars['timestamptz']>;
  stopSendingTimestamp?: InputMaybe<Scalars['timestamptz']>;
  timeOfDay?: InputMaybe<Scalars['timetz']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "reporting.scheduled_report" */
export enum TixScheduledReportUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  SavedReportId = 'savedReportId',
  /** column name */
  ScheduleName = 'scheduleName',
  /** column name */
  ScheduledReportId = 'scheduledReportId',
  /** column name */
  StartSendingTimestamp = 'startSendingTimestamp',
  /** column name */
  StopSendingTimestamp = 'stopSendingTimestamp',
  /** column name */
  TimeOfDay = 'timeOfDay',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixScheduledReportUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixScheduledReportSetInput>;
  /** filter the rows which have to be updated */
  where: TixScheduledReportBoolExp;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type TixSmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

export type TixSubscriptionRoot = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "address.address" */
  Address: Array<TixAddress>;
  /** fetch aggregated fields from the table: "address.address" */
  AddressAggregate: TixAddressAggregate;
  /** fetch data from the table: "address.address" using primary key columns */
  AddressByPK?: Maybe<TixAddress>;
  /** fetch data from the table in a streaming manner: "address.address" */
  Address_stream: Array<TixAddress>;
  /** fetch data from the table: "utility.business_code_group" */
  BusinessCodeGroup: Array<TixBusinessCodeGroup>;
  /** fetch aggregated fields from the table: "utility.business_code_group" */
  BusinessCodeGroupAggregate: TixBusinessCodeGroupAggregate;
  /** fetch data from the table in a streaming manner: "utility.business_code_group" */
  BusinessCodeGroup_stream: Array<TixBusinessCodeGroup>;
  /** fetch data from the table: "utility.business_codes" */
  BusinessCodes: Array<TixBusinessCodes>;
  /** fetch aggregated fields from the table: "utility.business_codes" */
  BusinessCodesAggregate: TixBusinessCodesAggregate;
  /** fetch data from the table: "utility.business_codes" using primary key columns */
  BusinessCodesByPK?: Maybe<TixBusinessCodes>;
  /** fetch data from the table in a streaming manner: "utility.business_codes" */
  BusinessCodes_stream: Array<TixBusinessCodes>;
  /** fetch data from the table: "company.company" */
  Company: Array<TixCompany>;
  /** fetch data from the table: "address.company_address" */
  CompanyAddress: Array<TixCompanyAddress>;
  /** fetch aggregated fields from the table: "address.company_address" */
  CompanyAddressAggregate: TixCompanyAddressAggregate;
  /** fetch data from the table: "address.company_address" using primary key columns */
  CompanyAddressByPK?: Maybe<TixCompanyAddress>;
  /** fetch data from the table in a streaming manner: "address.company_address" */
  CompanyAddress_stream: Array<TixCompanyAddress>;
  /** fetch aggregated fields from the table: "company.company" */
  CompanyAggregate: TixCompanyAggregate;
  /** fetch data from the table: "company.company" using primary key columns */
  CompanyByPK?: Maybe<TixCompany>;
  /** fetch data from the table: "configuration.company_configuration_value" */
  CompanyConfigurationValue: Array<TixCompanyConfigurationValue>;
  /** fetch aggregated fields from the table: "configuration.company_configuration_value" */
  CompanyConfigurationValue_aggregate: TixCompanyConfigurationValueAggregate;
  /** fetch data from the table: "configuration.company_configuration_value" using primary key columns */
  CompanyConfigurationValue_by_pk?: Maybe<TixCompanyConfigurationValue>;
  /** fetch data from the table in a streaming manner: "configuration.company_configuration_value" */
  CompanyConfigurationValue_stream: Array<TixCompanyConfigurationValue>;
  /** fetch data from the table: "contact.company_contact" */
  CompanyContact: Array<TixCompanyContact>;
  /** fetch data from the table: "contact.company_contact" using primary key columns */
  CompanyContactByPK?: Maybe<TixCompanyContact>;
  /** fetch aggregated fields from the table: "contact.company_contact" */
  CompanyContact_aggregate: TixCompanyContactAggregate;
  /** fetch data from the table in a streaming manner: "contact.company_contact" */
  CompanyContact_stream: Array<TixCompanyContact>;
  /** fetch data from the table: "media.company_media_file" */
  CompanyMediaFile: Array<TixCompanyMediaFile>;
  /** fetch aggregated fields from the table: "media.company_media_file" */
  CompanyMediaFileAggregate: TixCompanyMediaFileAggregate;
  /** fetch data from the table in a streaming manner: "media.company_media_file" */
  CompanyMediaFile_stream: Array<TixCompanyMediaFile>;
  /** fetch data from the table: "address.company_phone_number" */
  CompanyPhoneNumber: Array<TixCompanyPhoneNumber>;
  /** fetch aggregated fields from the table: "address.company_phone_number" */
  CompanyPhoneNumberAggregate: TixCompanyPhoneNumberAggregate;
  /** fetch data from the table: "address.company_phone_number" using primary key columns */
  CompanyPhoneNumberByPK?: Maybe<TixCompanyPhoneNumber>;
  /** fetch data from the table in a streaming manner: "address.company_phone_number" */
  CompanyPhoneNumber_stream: Array<TixCompanyPhoneNumber>;
  /** fetch data from the table: "media.company_social_media" */
  CompanySocialMedia: Array<TixCompanySocialMedia>;
  /** fetch aggregated fields from the table: "media.company_social_media" */
  CompanySocialMediaAggregate: TixCompanySocialMediaAggregate;
  /** fetch data from the table: "media.company_social_media" using primary key columns */
  CompanySocialMediaByPK?: Maybe<TixCompanySocialMedia>;
  /** fetch data from the table in a streaming manner: "media.company_social_media" */
  CompanySocialMedia_stream: Array<TixCompanySocialMedia>;
  /** fetch data from the table: "reporting.v_company_summary_report" */
  CompanySummaryReport: Array<TixCompanySummaryReport>;
  /** fetch aggregated fields from the table: "reporting.v_company_summary_report" */
  CompanySummaryReport_aggregate: TixCompanySummaryReportAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_company_summary_report" */
  CompanySummaryReport_stream: Array<TixCompanySummaryReport>;
  /** fetch data from the table: "warning.company_warning" */
  CompanyWarning: Array<TixCompanyWarning>;
  /** fetch aggregated fields from the table: "warning.company_warning" */
  CompanyWarningAggregate: TixCompanyWarningAggregate;
  /** fetch data from the table: "warning.company_warning" using primary key columns */
  CompanyWarningByPK?: Maybe<TixCompanyWarning>;
  /** fetch data from the table in a streaming manner: "warning.company_warning" */
  CompanyWarning_stream: Array<TixCompanyWarning>;
  /** fetch data from the table in a streaming manner: "company.company" */
  Company_stream: Array<TixCompany>;
  /** fetch data from the table: "configuration.configuration_group" */
  ConfigurationGroup: Array<TixConfigurationGroup>;
  /** fetch aggregated fields from the table: "configuration.configuration_group" */
  ConfigurationGroupAggregate: TixConfigurationGroupAggregate;
  /** fetch data from the table: "configuration.configuration_group" using primary key columns */
  ConfigurationGroupByPK?: Maybe<TixConfigurationGroup>;
  /** fetch data from the table: "configuration.configuration_group_item" */
  ConfigurationGroupItem: Array<TixConfigurationGroupItem>;
  /** fetch aggregated fields from the table: "configuration.configuration_group_item" */
  ConfigurationGroupItem_aggregate: TixConfigurationGroupItemAggregate;
  /** fetch data from the table: "configuration.configuration_group_item" using primary key columns */
  ConfigurationGroupItem_by_pk?: Maybe<TixConfigurationGroupItem>;
  /** fetch data from the table in a streaming manner: "configuration.configuration_group_item" */
  ConfigurationGroupItem_stream: Array<TixConfigurationGroupItem>;
  /** fetch data from the table in a streaming manner: "configuration.configuration_group" */
  ConfigurationGroup_stream: Array<TixConfigurationGroup>;
  /** fetch data from the table: "configuration.configuration_item" */
  ConfigurationItem: Array<TixConfigurationItem>;
  /** fetch aggregated fields from the table: "configuration.configuration_item" */
  ConfigurationItemAggregate: TixConfigurationItemAggregate;
  /** fetch data from the table: "configuration.configuration_item" using primary key columns */
  ConfigurationItemByPK?: Maybe<TixConfigurationItem>;
  /** fetch data from the table in a streaming manner: "configuration.configuration_item" */
  ConfigurationItem_stream: Array<TixConfigurationItem>;
  /** fetch data from the table: "configuration.configuration_value" */
  ConfigurationValue: Array<TixConfigurationValue>;
  /** fetch aggregated fields from the table: "configuration.configuration_value" */
  ConfigurationValue_aggregate: TixConfigurationValueAggregate;
  /** fetch data from the table: "configuration.configuration_value" using primary key columns */
  ConfigurationValue_by_pk?: Maybe<TixConfigurationValue>;
  /** fetch data from the table in a streaming manner: "configuration.configuration_value" */
  ConfigurationValue_stream: Array<TixConfigurationValue>;
  /** fetch data from the table: "contact.contact" */
  Contact: Array<TixContact>;
  /** fetch data from the table: "address.contact_address" */
  ContactAddress: Array<TixContactAddress>;
  /** fetch aggregated fields from the table: "address.contact_address" */
  ContactAddressAggregate: TixContactAddressAggregate;
  /** fetch data from the table: "address.contact_address" using primary key columns */
  ContactAddressByPK?: Maybe<TixContactAddress>;
  /** fetch data from the table in a streaming manner: "address.contact_address" */
  ContactAddress_stream: Array<TixContactAddress>;
  /** fetch aggregated fields from the table: "contact.contact" */
  ContactAggregate: TixContactAggregate;
  /** fetch data from the table: "contact.contact" using primary key columns */
  ContactByPK?: Maybe<TixContact>;
  /** fetch data from the table: "address.contact_phone_number" */
  ContactPhoneNumber: Array<TixContactPhoneNumber>;
  /** fetch aggregated fields from the table: "address.contact_phone_number" */
  ContactPhoneNumberAggregate: TixContactPhoneNumberAggregate;
  /** fetch data from the table: "address.contact_phone_number" using primary key columns */
  ContactPhoneNumberByPK?: Maybe<TixContactPhoneNumber>;
  /** fetch data from the table in a streaming manner: "address.contact_phone_number" */
  ContactPhoneNumber_stream: Array<TixContactPhoneNumber>;
  /** fetch data from the table in a streaming manner: "contact.contact" */
  Contact_stream: Array<TixContact>;
  /** fetch data from the table: "contact.customer" */
  Customer: Array<TixCustomer>;
  /** fetch aggregated fields from the table: "contact.customer" */
  CustomerAggregate: TixCustomerAggregate;
  /** fetch data from the table: "contact.customer" using primary key columns */
  CustomerByPk?: Maybe<TixCustomer>;
  /** fetch data from the table: "contact.v_customer_search" */
  CustomerSearch: Array<TixCustomerSearch>;
  /** fetch aggregated fields from the table: "contact.v_customer_search" */
  CustomerSearchAggregate: TixCustomerSearchAggregate;
  /** fetch data from the table in a streaming manner: "contact.v_customer_search" */
  CustomerSearchStream: Array<TixCustomerSearch>;
  /** fetch data from the table in a streaming manner: "contact.customer" */
  CustomerStream: Array<TixCustomer>;
  /** fetch data from the table: "reporting.v_daily_audit" */
  DailyAuditReport: Array<TixDailyAuditReport>;
  /** fetch data from the table: "reporting.v_daily_audit_report_final" */
  DailyAuditReportFinal: Array<TixDailyAuditReportFinal>;
  /** fetch aggregated fields from the table: "reporting.v_daily_audit_report_final" */
  DailyAuditReportFinal_aggregate: TixDailyAuditReportFinalAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_daily_audit_report_final" */
  DailyAuditReportFinal_stream: Array<TixDailyAuditReportFinal>;
  /** fetch aggregated fields from the table: "reporting.v_daily_audit" */
  DailyAuditReport_aggregate: TixDailyAuditReportAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_daily_audit" */
  DailyAuditReport_stream: Array<TixDailyAuditReport>;
  /** fetch data from the table: "reporting.v_daily_ticket_count_report" */
  DailyTicketCountReportSelect: Array<TixDailyTicketCountReport>;
  DailyTicketCountReport_aggregate: TixDailyTicketCountReportAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_daily_ticket_count_report" */
  DailyTicketCountReport_stream: Array<TixDailyTicketCountReport>;
  /** fetch data from the table: "discount.discount" */
  Discount: Array<TixDiscount>;
  /** fetch aggregated fields from the table: "discount.discount" */
  DiscountAggregate: TixDiscountAggregate;
  DiscountCodeCountByEven: Array<TixDiscountCodeCountByEvent>;
  DiscountCodeCountByEvent_aggregate: TixDiscountCodeCountByEventAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_discount_count_by_event" */
  DiscountCodeCountByEvent_stream: Array<TixDiscountCodeCountByEvent>;
  /** fetch data from the table: "reporting.v_discount_report" */
  DiscountReport: Array<TixReportingVDiscountReport>;
  /** fetch data from the table in a streaming manner: "discount.discount" */
  DiscountStream: Array<TixDiscount>;
  /** fetch data from the table: "communications.email_content" */
  EmailContentSelect: Array<TixEmailContent>;
  /** fetch data from the table: "communications.email_content" using primary key columns */
  EmailContentSelectByPK?: Maybe<TixEmailContent>;
  EmailContent_aggregate: TixEmailContentAggregate;
  /** fetch data from the table in a streaming manner: "communications.email_content" */
  EmailContent_stream: Array<TixEmailContent>;
  /** fetch data from the table: "event.event" */
  Event: Array<TixEvent>;
  /** fetch aggregated fields from the table: "event.event" */
  EventAggregate: TixEventAggregate;
  /** fetch data from the table: "event.event" using primary key columns */
  EventByPK?: Maybe<TixEvent>;
  /** fetch data from the table: "event.company_venue_event_list" */
  EventCompanyVenue: Array<TixEventCompanyVenue>;
  /** fetch aggregated fields from the table: "event.company_venue_event_list" */
  EventCompanyVenueAggregate: TixEventCompanyVenueAggregate;
  /** fetch data from the table in a streaming manner: "event.company_venue_event_list" */
  EventCompanyVenue_stream: Array<TixEventCompanyVenue>;
  /** fetch data from the table: "communications.event_email" */
  EventEmailSelect: Array<TixEventEmail>;
  /** fetch data from the table in a streaming manner: "communications.event_email" */
  EventEmailStream: Array<TixEventEmail>;
  EventEmail_aggregate: TixEventEmailAggregate;
  /** fetch data from the table: "event.event_instance" */
  EventInstance: Array<TixEventInstance>;
  /** fetch aggregated fields from the table: "event.event_instance" */
  EventInstanceAggregate: TixEventInstanceAggregate;
  /** fetch data from the table: "event.event_instance" using primary key columns */
  EventInstanceByPK?: Maybe<TixEventInstance>;
  /** fetch data from the table: "configuration.event_instance_configuration_value" */
  EventInstanceConfigurationValue: Array<TixEventInstanceConfigurationValue>;
  /** fetch aggregated fields from the table: "configuration.event_instance_configuration_value" */
  EventInstanceConfigurationValueAggregate: TixEventInstanceConfigurationValueAggregate;
  /** fetch data from the table: "configuration.event_instance_configuration_value" using primary key columns */
  EventInstanceConfigurationValueByPK?: Maybe<TixEventInstanceConfigurationValue>;
  /** fetch data from the table in a streaming manner: "configuration.event_instance_configuration_value" */
  EventInstanceConfigurationValueStream: Array<TixEventInstanceConfigurationValue>;
  /** fetch data from the table: "discount.event_instance_discount" */
  EventInstanceDiscount: Array<TixEventInstanceDiscount>;
  /** fetch aggregated fields from the table: "discount.event_instance_discount" */
  EventInstanceDiscountAggregate: TixEventInstanceDiscountAggregate;
  /** fetch data from the table in a streaming manner: "discount.event_instance_discount" */
  EventInstanceDiscount_stream: Array<TixEventInstanceDiscount>;
  /** fetch data from the table: "media.event_instance_media_file" */
  EventInstanceMedialFile: Array<TixEventInstanceMedialFile>;
  /** fetch aggregated fields from the table: "media.event_instance_media_file" */
  EventInstanceMedialFileAggregate: TixEventInstanceMedialFileAggregate;
  /** fetch data from the table: "media.event_instance_media_file" using primary key columns */
  EventInstanceMedialFileByPK?: Maybe<TixEventInstanceMedialFile>;
  /** fetch data from the table in a streaming manner: "media.event_instance_media_file" */
  EventInstanceMedialFile_stream: Array<TixEventInstanceMedialFile>;
  /** fetch data from the table: "media.event_instance_social_media" */
  EventInstanceSocialMediaFile: Array<TixEventInstanceSocialMediaFile>;
  /** fetch aggregated fields from the table: "media.event_instance_social_media" */
  EventInstanceSocialMediaFileAggregate: TixEventInstanceSocialMediaFileAggregate;
  /** fetch data from the table in a streaming manner: "media.event_instance_social_media" */
  EventInstanceSocialMediaFile_stream: Array<TixEventInstanceSocialMediaFile>;
  /** fetch data from the table: "ticket.event_instance_ticket" */
  EventInstanceTicket: Array<TixEventInstanceTicket>;
  /** fetch aggregated fields from the table: "ticket.event_instance_ticket" */
  EventInstanceTicketAggregate: TixEventInstanceTicketAggregate;
  /** fetch data from the table: "ticket.event_instance_ticket" using primary key columns */
  EventInstanceTicketByPK?: Maybe<TixEventInstanceTicket>;
  /** fetch data from the table: "ticket.event_instance_ticket_config" */
  EventInstanceTicketConfig: Array<TixEventInstanceTicketConfig>;
  /** fetch aggregated fields from the table: "ticket.event_instance_ticket_config" */
  EventInstanceTicketConfigAggregate: TixEventInstanceTicketConfigAggregate;
  /** fetch data from the table: "ticket.event_instance_ticket_config" using primary key columns */
  EventInstanceTicketConfigByPK?: Maybe<TixEventInstanceTicketConfig>;
  /** fetch data from the table in a streaming manner: "ticket.event_instance_ticket_config" */
  EventInstanceTicketConfig_stream: Array<TixEventInstanceTicketConfig>;
  /** fetch data from the table in a streaming manner: "ticket.event_instance_ticket" */
  EventInstanceTicket_stream: Array<TixEventInstanceTicket>;
  /** fetch data from the table in a streaming manner: "event.event_instance" */
  EventInstance_stream: Array<TixEventInstance>;
  /** fetch data from the table: "performer.event_lineup" */
  EventLineup: Array<TixEventLineup>;
  /** fetch aggregated fields from the table: "performer.event_lineup" */
  EventLineupAggregate: TixEventLineupAggregate;
  /** fetch data from the table in a streaming manner: "performer.event_lineup" */
  EventLineup_stream: Array<TixEventLineup>;
  /** fetch data from the table: "event.v_event_list" */
  EventList: Array<TixEventList>;
  /** fetch aggregated fields from the table: "event.v_event_list" */
  EventListAggregate: TixEventListAggregate;
  /** fetch data from the table in a streaming manner: "event.v_event_list" */
  EventList_stream: Array<TixEventList>;
  /** fetch data from the table: "performer.event_performers" */
  EventPerformers: Array<TixEventPerformers>;
  /** fetch aggregated fields from the table: "performer.event_performers" */
  EventPerformersAggregate: TixEventPerformersAggregate;
  /** fetch data from the table: "performer.event_performers" using primary key columns */
  EventPerformersByPK?: Maybe<TixEventPerformers>;
  /** fetch data from the table in a streaming manner: "performer.event_performers" */
  EventPerformers_stream: Array<TixEventPerformers>;
  /** fetch aggregated fields from the table: "product.event_product" */
  EventProductAggregate: TixEventProductAggregate;
  /** fetch aggregated fields from the table: "media.event_product_media_file" */
  EventProductMediaAggregate: TixEventProductMediaAggregate;
  /** fetch data from the table: "media.event_product_media_file" */
  EventProductMediaSelect: Array<TixEventProductMedia>;
  /** fetch data from the table: "media.event_product_media_file" using primary key columns */
  EventProductMediaSelectByPK?: Maybe<TixEventProductMedia>;
  /** fetch data from the table in a streaming manner: "media.event_product_media_file" */
  EventProductMediaStream: Array<TixEventProductMedia>;
  /** fetch data from the table: "product.event_product" */
  EventProductSelect: Array<TixEventProduct>;
  /** fetch data from the table: "product.event_product" using primary key columns */
  EventProductSelectByPK?: Maybe<TixEventProduct>;
  /** fetch data from the table in a streaming manner: "product.event_product" */
  EventProductStream: Array<TixEventProduct>;
  /** fetch data from the table: "event.event_venue" */
  EventVenue: Array<TixEventVenue>;
  /** fetch aggregated fields from the table: "event.event_venue" */
  EventVenueAggregate: TixEventVenueAggregate;
  /** fetch data from the table: "event.event_venue" using primary key columns */
  EventVenueByPK?: Maybe<TixEventVenue>;
  /** fetch data from the table in a streaming manner: "event.event_venue" */
  EventVenue_stream: Array<TixEventVenue>;
  /** fetch data from the table in a streaming manner: "event.event" */
  Event_stream: Array<TixEvent>;
  /** fetch data from the table: "performer.lineup" */
  Lineup: Array<TixLineup>;
  /** fetch aggregated fields from the table: "performer.lineup" */
  LineupAggregate: TixLineupAggregate;
  /** fetch data from the table: "performer.lineup_performer" */
  LineupPerformer: Array<TixLineupPerformer>;
  /** fetch aggregated fields from the table: "performer.lineup_performer" */
  LineupPerformerAggregate: TixLineupPerformerAggregate;
  /** fetch data from the table in a streaming manner: "performer.lineup_performer" */
  LineupPerformer_stream: Array<TixLineupPerformer>;
  /** fetch data from the table in a streaming manner: "performer.lineup" */
  Lineup_stream: Array<TixLineup>;
  /** fetch data from the table: "reporting.logging" */
  Logging: Array<TixLogging>;
  Logging_aggregate: TixLoggingAggregate;
  Logging_by_pk?: Maybe<TixLogging>;
  /** fetch data from the table in a streaming manner: "reporting.logging" */
  Logging_stream: Array<TixLogging>;
  /** fetch data from the table: "media.media_file" */
  MediaFile: Array<TixMediaFile>;
  /** fetch aggregated fields from the table: "media.media_file" */
  MediaFileAggregate: TixMediaFileAggregate;
  /** fetch data from the table in a streaming manner: "media.media_file" */
  MediaFile_stream: Array<TixMediaFile>;
  /** fetch data from the table: "notification.notification" */
  Notification: Array<TixNotification>;
  /** fetch aggregated fields from the table: "notification.notification" */
  NotificationAggregate: TixNotificationAggregate;
  /** fetch data from the table: "notification.notification" using primary key columns */
  NotificationByPK?: Maybe<TixNotification>;
  /** fetch data from the table in a streaming manner: "notification.notification" */
  Notification_stream: Array<TixNotification>;
  /** fetch aggregated fields from the table: "product.order" */
  OrderAggregate: TixOrderAggregate;
  /** fetch data from the table: "product.order" */
  OrderSelect: Array<TixOrder>;
  /** fetch data from the table: "product.order" using primary key columns */
  OrderSelectByPK?: Maybe<TixOrder>;
  /** fetch data from the table in a streaming manner: "product.order" */
  OrderStream: Array<TixOrder>;
  /** fetch data from the table: "event.v_patron_events_list" */
  PatronEventList: Array<TixPatronEventList>;
  /** fetch aggregated fields from the table: "event.v_patron_events_list" */
  PatronEventListAggregate: TixPatronEventListAggregate;
  /** fetch data from the table in a streaming manner: "event.v_patron_events_list" */
  PatronEventList_stream: Array<TixPatronEventList>;
  /** fetch data from the table: "event.v_patron_filtered_events_list" */
  PatronFIlteredEventsList: Array<TixPatronFIlteredEventsList>;
  /** fetch aggregated fields from the table: "event.v_patron_filtered_events_list" */
  PatronFIlteredEventsListAggregate: TixPatronFIlteredEventsListAggregate;
  /** fetch data from the table in a streaming manner: "event.v_patron_filtered_events_list" */
  PatronFIlteredEventsList_stream: Array<TixPatronFIlteredEventsList>;
  /** fetch data from the table: "payment.payment" */
  Payment: Array<TixPayment>;
  /** fetch aggregated fields from the table: "payment.payment" */
  PaymentAggregate: TixPaymentAggregate;
  /** fetch data from the table: "payment.payment_discount" */
  PaymentDiscount: Array<TixPaymentDiscount>;
  /** fetch aggregated fields from the table: "payment.payment_discount" */
  PaymentDiscountAggregate: TixPaymentDiscountAggregate;
  /** fetch data from the table in a streaming manner: "payment.payment_discount" */
  PaymentDiscountStream: Array<TixPaymentDiscount>;
  /** fetch data from the table: "payment.vendor_payment_log" */
  PaymentVendorLog: Array<TixPaymentVendorLog>;
  /** fetch aggregated fields from the table: "payment.vendor_payment_log" */
  PaymentVendorLogAggregate: TixPaymentVendorLogAggregate;
  /** fetch data from the table in a streaming manner: "payment.vendor_payment_log" */
  PaymentVendorLogStream: Array<TixPaymentVendorLog>;
  /** fetch data from the table in a streaming manner: "payment.payment" */
  Payment_stream: Array<TixPayment>;
  /** fetch data from the table: "payment.payout" */
  Payout: Array<TixPayout>;
  /** fetch aggregated fields from the table: "payment.payout" */
  PayoutAggregate: TixPayoutAggregate;
  /** fetch data from the table: "payment.payout" using primary key columns */
  PayoutByPK?: Maybe<TixPayout>;
  /** fetch data from the table: "payment.payout_connection" */
  PayoutConnectSelect: Array<TixPayoutConnect>;
  /** fetch aggregated fields from the table: "payment.payout_connection" */
  PayoutConnect_aggregate: TixPayoutConnectAggregate;
  /** fetch data from the table: "payment.payout_connection" using primary key columns */
  PayoutConnect_by_pk?: Maybe<TixPayoutConnect>;
  /** fetch data from the table in a streaming manner: "payment.payout_connection" */
  PayoutConnect_stream: Array<TixPayoutConnect>;
  /** fetch data from the table: "payment.payout_detail" */
  PayoutDetail: Array<TixPayoutDetail>;
  /** fetch aggregated fields from the table: "payment.payout_detail" */
  PayoutDetail_aggregate: TixPayoutDetailAggregate;
  /** fetch data from the table: "payment.payout_detail" using primary key columns */
  PayoutDetail_by_pk?: Maybe<TixPayoutDetail>;
  /** fetch data from the table in a streaming manner: "payment.payout_detail" */
  PayoutDetail_stream: Array<TixPayoutDetail>;
  /** fetch data from the table in a streaming manner: "payment.payout" */
  PayoutStream: Array<TixPayout>;
  /** fetch data from the table: "performer.performer" */
  Performer: Array<TixPerformer>;
  /** fetch aggregated fields from the table: "performer.performer" */
  PerformerAggregate: TixPerformerAggregate;
  /** fetch data from the table in a streaming manner: "performer.performer" */
  Performer_stream: Array<TixPerformer>;
  /** fetch data from the table: "access.permission" */
  Permission: Array<TixPermission>;
  /** fetch aggregated fields from the table: "access.permission" */
  PermissionAggregate: TixPermissionAggregate;
  /** fetch data from the table in a streaming manner: "access.permission" */
  Permission_stream: Array<TixPermission>;
  /** fetch data from the table: "address.phone_number" */
  PhoneNumber: Array<TixPhoneNumber>;
  /** fetch aggregated fields from the table: "address.phone_number" */
  PhoneNumberAggregate: TixPhoneNumberAggregate;
  /** fetch data from the table: "address.phone_number" using primary key columns */
  PhoneNumberByPK?: Maybe<TixPhoneNumber>;
  /** fetch data from the table in a streaming manner: "address.phone_number" */
  PhoneNumber_stream: Array<TixPhoneNumber>;
  /** fetch data from the table: "utility.policy" */
  Policy: Array<TixUtilityPolicy>;
  /** fetch aggregated fields from the table: "product.product" */
  ProductAggregate: TixProductAggregate;
  /** fetch aggregated fields from the table: "media.product_media_file" */
  ProductMediaFileAggregate: TixProductMediaFileAggregate;
  /** fetch data from the table: "media.product_media_file" */
  ProductMediaFileSelect: Array<TixProductMediaFile>;
  /** fetch data from the table: "media.product_media_file" using primary key columns */
  ProductMediaFileSelectByPK?: Maybe<TixProductMediaFile>;
  /** fetch data from the table in a streaming manner: "media.product_media_file" */
  ProductMediaFileStream: Array<TixProductMediaFile>;
  /** fetch data from the table: "product.product" */
  ProductSelect: Array<TixProduct>;
  /** fetch data from the table: "product.product" using primary key columns */
  ProductSelectByPK?: Maybe<TixProduct>;
  /** fetch data from the table in a streaming manner: "product.product" */
  ProductStream: Array<TixProduct>;
  /** fetch data from the table: "reporting.v_refunds_by_event" */
  RefundsByEvent: Array<TixReportingVRefundsByEvent>;
  /** fetch data from the table: "ticket.reservation" */
  Reservation: Array<TixTicketReservation>;
  /** fetch aggregated fields from the table: "ticket.reservation" */
  ReservationAggregate: TixTicketReservationAggregate;
  /** fetch data from the table: "ticket.reservation" using primary key columns */
  ReservationByPK?: Maybe<TixTicketReservation>;
  /** fetch data from the table: "payment.reservation_payment" */
  ReservationPayment: Array<TixReservationPayment>;
  /** fetch aggregated fields from the table: "payment.reservation_payment" */
  ReservationPaymentAggregate: TixReservationPaymentAggregate;
  /** fetch data from the table in a streaming manner: "payment.reservation_payment" */
  ReservationPayment_stream: Array<TixReservationPayment>;
  /** An array relationship */
  RevenueByChannelType: Array<TixRevenueByChannelType>;
  /** An aggregate relationship */
  RevenueByChannelType_aggregate: TixRevenueByChannelTypeAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_revenue_by_channel_type" */
  RevenueByChannelType_stream: Array<TixRevenueByChannelType>;
  /** fetch data from the table: "access.role" */
  Role: Array<TixRole>;
  /** fetch aggregated fields from the table: "access.role" */
  RoleAggregate: TixRoleAggregate;
  /** fetch aggregated fields from the table: "access.role_permission" */
  RolePermissionAggregate: TixRolePermissionAggregate;
  /** fetch data from the table in a streaming manner: "access.role_permission" */
  RolePermission_stream: Array<TixRolePermission>;
  /** fetch data from the table in a streaming manner: "access.role" */
  Role_stream: Array<TixRole>;
  /** fetch data from the table: "utility.business_code_group" using primary key columns */
  SelectBusinessCodeGroupByPK?: Maybe<TixBusinessCodeGroup>;
  /** fetch data from the table: "media.company_media_file" using primary key columns */
  SelectCompanyMediaFileByPK?: Maybe<TixCompanyMediaFile>;
  /** fetch data from the table: "discount.discount" using primary key columns */
  SelectDiscountByPK?: Maybe<TixDiscount>;
  /** fetch data from the table: "discount.event_instance_discount" using primary key columns */
  SelectEventInstanceDiscountByPK?: Maybe<TixEventInstanceDiscount>;
  /** fetch data from the table: "media.event_instance_social_media" using primary key columns */
  SelectEventInstanceSocialMediaFileByPK?: Maybe<TixEventInstanceSocialMediaFile>;
  /** fetch data from the table: "performer.event_lineup" using primary key columns */
  SelectEventLineupByPK?: Maybe<TixEventLineup>;
  /** fetch data from the table: "performer.lineup" using primary key columns */
  SelectLineupByPK?: Maybe<TixLineup>;
  /** fetch data from the table: "performer.lineup_performer" using primary key columns */
  SelectLineupPerformerByPK?: Maybe<TixLineupPerformer>;
  /** fetch data from the table: "media.media_file" using primary key columns */
  SelectMediaFilebyPK?: Maybe<TixMediaFile>;
  /** fetch data from the table: "payment.payment" using primary key columns */
  SelectPaymentByPK?: Maybe<TixPayment>;
  /** fetch data from the table: "payment.payment_discount" using primary key columns */
  SelectPaymentDiscountByPK?: Maybe<TixPaymentDiscount>;
  /** fetch data from the table: "payment.vendor_payment_log" using primary key columns */
  SelectPaymentVendorLogByPK?: Maybe<TixPaymentVendorLog>;
  /** fetch data from the table: "performer.performer" using primary key columns */
  SelectPerformerByPK?: Maybe<TixPerformer>;
  /** fetch data from the table: "access.permission" using primary key columns */
  SelectPermissionByPK?: Maybe<TixPermission>;
  /** fetch data from the table: "payment.reservation_payment" using primary key columns */
  SelectReservationPaymentByPK?: Maybe<TixReservationPayment>;
  /** fetch data from the table: "access.role" using primary key columns */
  SelectRoleByPK?: Maybe<TixRole>;
  /** fetch data from the table: "access.role_permission" */
  SelectRolePermission: Array<TixRolePermission>;
  /** fetch data from the table: "access.role_permission" using primary key columns */
  SelectRolePermissionByPK?: Maybe<TixRolePermission>;
  /** fetch data from the table: "access.user" */
  SelectUser: Array<TixUser>;
  /** fetch data from the table: "access.user" using primary key columns */
  SelectUserByPK?: Maybe<TixUser>;
  /** fetch data from the table: "access.user_role" */
  SelectUserRole: Array<TixUserRole>;
  /** fetch data from the table: "access.user_role" using primary key columns */
  SelectUserRoleByPK?: Maybe<TixUserRole>;
  /** fetch aggregated fields from the table: "discount.venue_discount" */
  SelectVenueDiscountAggregate: TixVenueDiscountAggregate;
  /** fetch data from the table: "discount.venue_discount" using primary key columns */
  SelectVenueDiscountByPK?: Maybe<TixVenueDiscount>;
  /** fetch data from the table: "performer.venue_lineup" using primary key columns */
  SelectVenueLineupByPK?: Maybe<TixVenueLineup>;
  /** fetch data from the table: "media.social_media" */
  SocialMedia: Array<TixSocialMedia>;
  /** fetch aggregated fields from the table: "media.social_media" */
  SocialMediaAggregate: TixSocialMediaAggregate;
  /** fetch data from the table: "media.social_media" using primary key columns */
  SocialMediaByPK?: Maybe<TixSocialMedia>;
  /** fetch data from the table in a streaming manner: "media.social_media" */
  SocialMedia_stream: Array<TixSocialMedia>;
  /** fetch data from the table in a streaming manner: "discount.venue_discount" */
  StreamVenueDiscount: Array<TixVenueDiscount>;
  /** fetch data from the table: "ticket.ticket" */
  Ticket: Array<TixTicket>;
  /** fetch aggregated fields from the table: "ticket.ticket" */
  TicketAggregate: TixTicketAggregate;
  /** fetch data from the table: "ticket.ticket" using primary key columns */
  TicketByPK?: Maybe<TixTicket>;
  /** fetch data from the table: "ticket.ticket_config" */
  TicketConfig: Array<TixTicketConfig>;
  /** fetch aggregated fields from the table: "ticket.ticket_config" */
  TicketConfigAggregate: TixTicketConfigAggregate;
  /** fetch data from the table: "ticket.ticket_config" using primary key columns */
  TicketConfigByPK?: Maybe<TixTicketConfig>;
  /** fetch data from the table in a streaming manner: "ticket.ticket_config" */
  TicketConfig_stream: Array<TixTicketConfig>;
  /** fetch data from the table: "reporting.v_ticket_count_by_sales_channel" */
  TicketCountByChannelType: Array<TixTicketCountByChannelType>;
  TicketCountByChannelType_aggregate: TixTicketCountByChannelTypeAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_ticket_count_by_sales_channel" */
  TicketCountByChannelType_stream: Array<TixTicketCountByChannelType>;
  /** fetch data from the table: "reporting.v_ticket_count_by_event" */
  TicketCountByEvent: Array<TixTicketCountByEvent>;
  TicketCountByEvent_aggregate: TixTicketCountByEventAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_ticket_count_by_event" */
  TicketCountByEvent_stream: Array<TixTicketCountByEvent>;
  /** fetch data from the table: "reporting.v_ticket_count_by_name" */
  TicketCountByName: Array<TixTicketCountByName>;
  TicketCountByName_aggregate: TixTicketCountByNameAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_ticket_count_by_name" */
  TicketCountByName_stream: Array<TixTicketCountByName>;
  /** fetch data from the table: "reporting.v_ticket_count_by_channel_type" */
  TicketCountByRevenueType: Array<TixTicketCountByRevenueType>;
  /** fetch aggregated fields from the table: "reporting.v_ticket_count_by_channel_type" */
  TicketCountByRevenueType_aggregate: TixTicketCountByRevenueTypeAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_ticket_count_by_channel_type" */
  TicketCountByRevenueType_stream: Array<TixTicketCountByRevenueType>;
  /** fetch aggregated fields from the table: "ticket.reservation_detail" */
  TicketReservationDetailAggregate: TixTicketReservationDetailAggregate;
  /** fetch data from the table: "ticket.reservation_detail" */
  TicketReservationDetailSelect: Array<TixTicketReservationDetail>;
  /** fetch data from the table: "ticket.reservation_detail" using primary key columns */
  TicketReservationDetailSelectByPK?: Maybe<TixTicketReservationDetail>;
  /** fetch data from the table in a streaming manner: "ticket.reservation_detail" */
  TicketReservationDetailStream: Array<TixTicketReservationDetail>;
  /** fetch data from the table in a streaming manner: "ticket.ticket" */
  Ticket_stream: Array<TixTicket>;
  /** fetch aggregated fields from the table: "access.user" */
  UserAggregate: TixUserAggregate;
  /** fetch aggregated fields from the table: "access.user_role" */
  UserRoleAggregate: TixUserRoleAggregate;
  /** fetch data from the table in a streaming manner: "access.user_role" */
  UserRole_stream: Array<TixUserRole>;
  /** fetch data from the table in a streaming manner: "access.user" */
  User_stream: Array<TixUser>;
  /** fetch data from the table: "venue.venue" */
  Venue: Array<TixVenue>;
  /** fetch data from the table: "address.venue_address" */
  VenueAddress: Array<TixVenueAddress>;
  /** fetch aggregated fields from the table: "address.venue_address" */
  VenueAddressAggregate: TixVenueAddressAggregate;
  /** fetch data from the table: "address.venue_address" using primary key columns */
  VenueAddressByPK?: Maybe<TixVenueAddress>;
  /** fetch data from the table in a streaming manner: "address.venue_address" */
  VenueAddress_stream: Array<TixVenueAddress>;
  /** fetch aggregated fields from the table: "venue.venue" */
  VenueAggregate: TixVenueAggregate;
  /** fetch data from the table: "venue.venue" using primary key columns */
  VenueByPK?: Maybe<TixVenue>;
  /** fetch data from the table: "configuration.venue_configuration_value" */
  VenueConfigurationValue: Array<TixVenueConfigurationValue>;
  /** fetch aggregated fields from the table: "configuration.venue_configuration_value" */
  VenueConfigurationValueAggregate: TixVenueConfigurationValueAggregate;
  /** fetch data from the table: "configuration.venue_configuration_value" using primary key columns */
  VenueConfigurationValueByPK?: Maybe<TixVenueConfigurationValue>;
  /** fetch data from the table in a streaming manner: "configuration.venue_configuration_value" */
  VenueConfigurationValue_stream: Array<TixVenueConfigurationValue>;
  /** fetch data from the table: "contact.venue_contact" */
  VenueContact: Array<TixVenueContact>;
  /** fetch aggregated fields from the table: "contact.venue_contact" */
  VenueContactAggregate: TixVenueContactAggregate;
  /** fetch data from the table: "contact.venue_contact" using primary key columns */
  VenueContactByPK?: Maybe<TixVenueContact>;
  /** fetch data from the table in a streaming manner: "contact.venue_contact" */
  VenueContact_stream: Array<TixVenueContact>;
  /** fetch data from the table: "discount.venue_discount" */
  VenueDiscount: Array<TixVenueDiscount>;
  /** fetch data from the table: "performer.venue_lineup" */
  VenueLineup: Array<TixVenueLineup>;
  /** fetch aggregated fields from the table: "performer.venue_lineup" */
  VenueLineupAggregate: TixVenueLineupAggregate;
  /** fetch data from the table in a streaming manner: "performer.venue_lineup" */
  VenueLineup_stream: Array<TixVenueLineup>;
  /** fetch data from the table: "media.venue_media_file" */
  VenueMediaFile: Array<TixVenueMediaFile>;
  /** fetch aggregated fields from the table: "media.venue_media_file" */
  VenueMediaFileAggregate: TixVenueMediaFileAggregate;
  /** fetch data from the table: "media.venue_media_file" using primary key columns */
  VenueMediaFileByPK?: Maybe<TixVenueMediaFile>;
  /** fetch data from the table in a streaming manner: "media.venue_media_file" */
  VenueMediaFile_stream: Array<TixVenueMediaFile>;
  /** fetch data from the table: "address.venue_phone_number" */
  VenuePhoneNumber: Array<TixVenuePhoneNumber>;
  /** fetch aggregated fields from the table: "address.venue_phone_number" */
  VenuePhoneNumberAggregate: TixVenuePhoneNumberAggregate;
  /** fetch data from the table: "address.venue_phone_number" using primary key columns */
  VenuePhoneNumberByPK?: Maybe<TixVenuePhoneNumber>;
  /** fetch data from the table in a streaming manner: "address.venue_phone_number" */
  VenuePhoneNumber_stream: Array<TixVenuePhoneNumber>;
  /** fetch aggregated fields from the table: "product.venue_product" */
  VenueProductAggregate: TixVenueProductAggregate;
  /** fetch data from the table: "product.venue_product" */
  VenueProductSelect: Array<TixVenueProduct>;
  /** fetch data from the table: "product.venue_product" using primary key columns */
  VenueProductSelectByPK?: Maybe<TixVenueProduct>;
  /** fetch data from the table in a streaming manner: "product.venue_product" */
  VenueProductStream: Array<TixVenueProduct>;
  /** fetch data from the table: "media.venue_social_media" */
  VenueSocialMedia: Array<TixVenueSocialMedia>;
  /** fetch aggregated fields from the table: "media.venue_social_media" */
  VenueSocialMediaAggregate: TixVenueSocialMediaAggregate;
  /** fetch data from the table: "media.venue_social_media" using primary key columns */
  VenueSocialMediaByPK?: Maybe<TixVenueSocialMedia>;
  /** fetch data from the table in a streaming manner: "media.venue_social_media" */
  VenueSocialMedia_stream: Array<TixVenueSocialMedia>;
  /** fetch data from the table: "ticket.venue_ticket" */
  VenueTicket: Array<TixVenueTicket>;
  /** fetch aggregated fields from the table: "ticket.venue_ticket" */
  VenueTicketAggregate: TixVenueTicketAggregate;
  /** fetch data from the table: "ticket.venue_ticket" using primary key columns */
  VenueTicketByPK?: Maybe<TixVenueTicket>;
  /** fetch data from the table: "ticket.venue_ticket_config" */
  VenueTicketConfig: Array<TixVenueTicketConfig>;
  /** fetch aggregated fields from the table: "ticket.venue_ticket_config" */
  VenueTicketConfigAggregate: TixVenueTicketConfigAggregate;
  /** fetch data from the table: "ticket.venue_ticket_config" using primary key columns */
  VenueTicketConfigByPK?: Maybe<TixVenueTicketConfig>;
  /** fetch data from the table in a streaming manner: "ticket.venue_ticket_config" */
  VenueTicketConfig_stream: Array<TixVenueTicketConfig>;
  /** fetch data from the table in a streaming manner: "ticket.venue_ticket" */
  VenueTicket_stream: Array<TixVenueTicket>;
  /** fetch data from the table: "warning.venue_warning" */
  VenueWarning: Array<TixVenueWarning>;
  /** fetch aggregated fields from the table: "warning.venue_warning" */
  VenueWarningAggregate: TixVenueWarningAggregate;
  /** fetch data from the table: "warning.venue_warning" using primary key columns */
  VenueWarningByPK?: Maybe<TixVenueWarning>;
  /** fetch data from the table in a streaming manner: "warning.venue_warning" */
  VenueWarning_stream: Array<TixVenueWarning>;
  /** fetch data from the table in a streaming manner: "venue.venue" */
  Venue_stream: Array<TixVenue>;
  /** fetch data from the table: "warning.warning" */
  Warning: Array<TixWarning>;
  /** fetch aggregated fields from the table: "warning.warning" */
  WarningAggregate: TixWarningAggregate;
  /** fetch data from the table: "warning.warning" using primary key columns */
  WarningByPK?: Maybe<TixWarning>;
  /** fetch data from the table in a streaming manner: "warning.warning" */
  Warning_stream: Array<TixWarning>;
  /** fetch data from the table: "address.performer_phone_number" */
  address_performer_phone_number: Array<TixAddressPerformerPhoneNumber>;
  /** fetch aggregated fields from the table: "address.performer_phone_number" */
  address_performer_phone_number_aggregate: TixAddressPerformerPhoneNumberAggregate;
  /** fetch data from the table: "address.performer_phone_number" using primary key columns */
  address_performer_phone_number_by_pk?: Maybe<TixAddressPerformerPhoneNumber>;
  /** fetch data from the table in a streaming manner: "address.performer_phone_number" */
  address_performer_phone_number_stream: Array<TixAddressPerformerPhoneNumber>;
  /** fetch data from the table: "communications.company_email" */
  communications_company_email: Array<TixCommunicationsCompanyEmail>;
  /** fetch aggregated fields from the table: "communications.company_email" */
  communications_company_email_aggregate: TixCommunicationsCompanyEmailAggregate;
  /** fetch data from the table in a streaming manner: "communications.company_email" */
  communications_company_email_stream: Array<TixCommunicationsCompanyEmail>;
  /** fetch data from the table: "communications.email_content_variable" */
  communications_email_content_variable: Array<TixCommunicationsEmailContentVariable>;
  /** fetch aggregated fields from the table: "communications.email_content_variable" */
  communications_email_content_variable_aggregate: TixCommunicationsEmailContentVariableAggregate;
  /** fetch data from the table: "communications.email_content_variable" using primary key columns */
  communications_email_content_variable_by_pk?: Maybe<TixCommunicationsEmailContentVariable>;
  /** fetch data from the table in a streaming manner: "communications.email_content_variable" */
  communications_email_content_variable_stream: Array<TixCommunicationsEmailContentVariable>;
  /** fetch data from the table: "communications.email_variable" */
  communications_email_variable: Array<TixCommunicationsEmailVariable>;
  /** fetch aggregated fields from the table: "communications.email_variable" */
  communications_email_variable_aggregate: TixCommunicationsEmailVariableAggregate;
  /** fetch data from the table: "communications.email_variable" using primary key columns */
  communications_email_variable_by_pk?: Maybe<TixCommunicationsEmailVariable>;
  /** fetch data from the table in a streaming manner: "communications.email_variable" */
  communications_email_variable_stream: Array<TixCommunicationsEmailVariable>;
  /** fetch data from the table: "communications.venue_email" */
  communications_venue_email: Array<TixCommunicationsVenueEmail>;
  /** fetch aggregated fields from the table: "communications.venue_email" */
  communications_venue_email_aggregate: TixCommunicationsVenueEmailAggregate;
  /** fetch data from the table in a streaming manner: "communications.venue_email" */
  communications_venue_email_stream: Array<TixCommunicationsVenueEmail>;
  /** fetch data from the table: "reporting.v_event_summary_report" */
  eventSummaryReport: Array<TixEventSummaryReport>;
  /** fetch aggregated fields from the table: "reporting.v_event_summary_report" */
  eventSummaryReportAggregate: TixEventSummaryReportAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_event_summary_report" */
  eventSummaryReport_stream: Array<TixEventSummaryReport>;
  /** fetch data from the table: "event.campaign_tracking" */
  event_campaign_tracking: Array<TixEventCampaignTracking>;
  /** fetch aggregated fields from the table: "event.campaign_tracking" */
  event_campaign_tracking_aggregate: TixEventCampaignTrackingAggregate;
  /** fetch data from the table: "event.campaign_tracking" using primary key columns */
  event_campaign_tracking_by_pk?: Maybe<TixEventCampaignTracking>;
  /** fetch data from the table in a streaming manner: "event.campaign_tracking" */
  event_campaign_tracking_stream: Array<TixEventCampaignTracking>;
  /** fetch data from the table: "fees.fees" */
  fees: Array<TixFees>;
  /** fetch aggregated fields from the table: "fees.fees" */
  feesAggregate: TixFeesAggregate;
  /** fetch data from the table: "fees.fees" using primary key columns */
  feesByPk?: Maybe<TixFees>;
  /** fetch data from the table in a streaming manner: "fees.fees" */
  feesStream: Array<TixFees>;
  /** fetch data from the table: "notification.contact_notification" */
  notification_contact_notification: Array<TixNotificationContactNotification>;
  /** fetch aggregated fields from the table: "notification.contact_notification" */
  notification_contact_notification_aggregate: TixNotificationContactNotificationAggregate;
  /** fetch data from the table: "notification.contact_notification" using primary key columns */
  notification_contact_notification_by_pk?: Maybe<TixNotificationContactNotification>;
  /** fetch data from the table in a streaming manner: "notification.contact_notification" */
  notification_contact_notification_stream: Array<TixNotificationContactNotification>;
  /** fetch data from the table: "product.order_detail" */
  product_order_detail: Array<TixProductOrderDetail>;
  /** fetch aggregated fields from the table: "product.order_detail" */
  product_order_detail_aggregate: TixProductOrderDetailAggregate;
  /** fetch data from the table: "product.order_detail" using primary key columns */
  product_order_detail_by_pk?: Maybe<TixProductOrderDetail>;
  /** fetch data from the table in a streaming manner: "product.order_detail" */
  product_order_detail_stream: Array<TixProductOrderDetail>;
  /** fetch aggregated fields from the table: "reporting.v_discount_report" */
  reporting_v_discount_report_aggregate: TixReportingVDiscountReportAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_discount_report" */
  reporting_v_discount_report_stream: Array<TixReportingVDiscountReport>;
  reporting_v_refunds_by_event_aggregate: TixReportingVRefundsByEventAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_refunds_by_event" */
  reporting_v_refunds_by_event_stream: Array<TixReportingVRefundsByEvent>;
  /** fetch data from the table: "reporting.v_ticket_detail_report" */
  reporting_v_ticket_detail_report: Array<TixReportingVTicketDetailReport>;
  /** fetch aggregated fields from the table: "reporting.v_ticket_detail_report" */
  reporting_v_ticket_detail_report_aggregate: TixReportingVTicketDetailReportAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_ticket_detail_report" */
  reporting_v_ticket_detail_report_stream: Array<TixReportingVTicketDetailReport>;
  /** fetch data from the table: "reporting.v_reservation_detail_report" */
  reservationDetailReport: Array<TixReservationDetailReport>;
  /** fetch aggregated fields from the table: "reporting.v_reservation_detail_report" */
  reservationDetailReportAggregate: TixReservationDetailReportAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_reservation_detail_report" */
  reservationDetailReportStream: Array<TixReservationDetailReport>;
  /** fetch data from the table: "reporting.reservation_report" */
  reservationReport: Array<TixReservationReport>;
  /** fetch aggregated fields from the table: "reporting.reservation_report" */
  reservationReportAggregate: TixReservationReportAggregate;
  /** fetch data from the table: "reporting.reservation_report" using primary key columns */
  reservationReportByPK?: Maybe<TixReservationReport>;
  /** fetch data from the table in a streaming manner: "reporting.reservation_report" */
  reservationReportStream: Array<TixReservationReport>;
  /** fetch data from the table: "reporting.v_reservation_summary_report" */
  reservationSummaryReport: Array<TixReservationSummaryReport>;
  /** fetch aggregated fields from the table: "reporting.v_reservation_summary_report" */
  reservationSummaryReportAggregate: TixReservationSummaryReportAggregate;
  /** fetch data from the table in a streaming manner: "reporting.v_reservation_summary_report" */
  reservationSummaryReportStream: Array<TixReservationSummaryReport>;
  /** fetch data from the table: "reporting.saved_report" */
  savedReport: Array<TixSavedReport>;
  /** An array relationship */
  savedReportEvents: Array<TixSavedReportEvents>;
  /** An aggregate relationship */
  savedReportEvents_aggregate: TixSavedReportEventsAggregate;
  /** fetch data from the table: "reporting.saved_report_events" using primary key columns */
  savedReportEvents_by_pk?: Maybe<TixSavedReportEvents>;
  /** fetch data from the table in a streaming manner: "reporting.saved_report_events" */
  savedReportEvents_stream: Array<TixSavedReportEvents>;
  /** fetch data from the table: "reporting.saved_report_layout" */
  savedReportLayout: Array<TixSavedReportLayout>;
  /** fetch aggregated fields from the table: "reporting.saved_report_layout" */
  savedReportLayout_aggregate: TixSavedReportLayoutAggregate;
  /** fetch data from the table: "reporting.saved_report_layout" using primary key columns */
  savedReportLayout_by_pk?: Maybe<TixSavedReportLayout>;
  /** fetch data from the table in a streaming manner: "reporting.saved_report_layout" */
  savedReportLayout_stream: Array<TixSavedReportLayout>;
  /** fetch aggregated fields from the table: "reporting.saved_report" */
  savedReport_aggregate: TixSavedReportAggregate;
  /** fetch data from the table: "reporting.saved_report" using primary key columns */
  savedReport_by_pk?: Maybe<TixSavedReport>;
  /** fetch data from the table in a streaming manner: "reporting.saved_report" */
  savedReport_stream: Array<TixSavedReport>;
  /** fetch data from the table: "reporting.scheduled_report" */
  scheduledReport: Array<TixScheduledReport>;
  /** fetch data from the table: "reporting.scheduled_report_email" */
  scheduledReportEmail: Array<TixScheduledReportEmail>;
  /** fetch aggregated fields from the table: "reporting.scheduled_report_email" */
  scheduledReportEmail_aggregate: TixScheduledReportEmailAggregate;
  /** fetch data from the table: "reporting.scheduled_report_email" using primary key columns */
  scheduledReportEmail_by_pk?: Maybe<TixScheduledReportEmail>;
  /** fetch data from the table in a streaming manner: "reporting.scheduled_report_email" */
  scheduledReportEmail_stream: Array<TixScheduledReportEmail>;
  /** fetch aggregated fields from the table: "reporting.scheduled_report" */
  scheduledReport_aggregate: TixScheduledReportAggregate;
  /** fetch data from the table: "reporting.scheduled_report" using primary key columns */
  scheduledReport_by_pk?: Maybe<TixScheduledReport>;
  /** fetch data from the table in a streaming manner: "reporting.scheduled_report" */
  scheduledReport_stream: Array<TixScheduledReport>;
  /** fetch data from the table: "ticket.exchange" */
  ticket_exchange: Array<TixTicketExchange>;
  /** fetch aggregated fields from the table: "ticket.exchange" */
  ticket_exchange_aggregate: TixTicketExchangeAggregate;
  /** fetch data from the table: "ticket.exchange" using primary key columns */
  ticket_exchange_by_pk?: Maybe<TixTicketExchange>;
  /** fetch data from the table in a streaming manner: "ticket.exchange" */
  ticket_exchange_stream: Array<TixTicketExchange>;
  /** fetch data from the table in a streaming manner: "ticket.reservation" */
  ticket_reservation_stream: Array<TixTicketReservation>;
  /** fetch data from the table: "ticket.ticket_discount" */
  ticket_ticket_discount: Array<TixTicketTicketDiscount>;
  /** fetch aggregated fields from the table: "ticket.ticket_discount" */
  ticket_ticket_discount_aggregate: TixTicketTicketDiscountAggregate;
  /** fetch data from the table: "ticket.ticket_discount" using primary key columns */
  ticket_ticket_discount_by_pk?: Maybe<TixTicketTicketDiscount>;
  /** fetch data from the table in a streaming manner: "ticket.ticket_discount" */
  ticket_ticket_discount_stream: Array<TixTicketTicketDiscount>;
  /** fetch data from the table: "ticket.v_ticket_count_by_type" */
  ticket_v_ticket_count_by_type: Array<TixTicketVTicketCountByType>;
  /** fetch aggregated fields from the table: "ticket.v_ticket_count_by_type" */
  ticket_v_ticket_count_by_type_aggregate: TixTicketVTicketCountByTypeAggregate;
  /** fetch data from the table in a streaming manner: "ticket.v_ticket_count_by_type" */
  ticket_v_ticket_count_by_type_stream: Array<TixTicketVTicketCountByType>;
  /** fetch data from the table: "ticket.v_ticket_sales_metrics" */
  ticket_v_ticket_sales_metrics: Array<TixTicketVTicketSalesMetrics>;
  /** fetch aggregated fields from the table: "ticket.v_ticket_sales_metrics" */
  ticket_v_ticket_sales_metrics_aggregate: TixTicketVTicketSalesMetricsAggregate;
  /** fetch data from the table in a streaming manner: "ticket.v_ticket_sales_metrics" */
  ticket_v_ticket_sales_metrics_stream: Array<TixTicketVTicketSalesMetrics>;
  /** fetch aggregated fields from the table: "utility.policy" */
  utility_policy_aggregate: TixUtilityPolicyAggregate;
  /** fetch data from the table: "utility.policy" using primary key columns */
  utility_policy_by_pk?: Maybe<TixUtilityPolicy>;
  /** fetch data from the table in a streaming manner: "utility.policy" */
  utility_policy_stream: Array<TixUtilityPolicy>;
  /** fetch data from the table: "utility.timestamp_by_timezone" */
  utility_timestamp_by_timezone: Array<TixUtilityTimestampByTimezone>;
  /** fetch aggregated fields from the table: "utility.timestamp_by_timezone" */
  utility_timestamp_by_timezone_aggregate: TixUtilityTimestampByTimezoneAggregate;
  /** fetch data from the table in a streaming manner: "utility.timestamp_by_timezone" */
  utility_timestamp_by_timezone_stream: Array<TixUtilityTimestampByTimezone>;
};


export type TixSubscriptionRootAddressArgs = {
  distinct_on?: InputMaybe<Array<TixAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressOrderBy>>;
  where?: InputMaybe<TixAddressBoolExp>;
};


export type TixSubscriptionRootAddressAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressOrderBy>>;
  where?: InputMaybe<TixAddressBoolExp>;
};


export type TixSubscriptionRootAddressByPkArgs = {
  addressId: Scalars['uuid'];
};


export type TixSubscriptionRootAddressStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixAddressStreamCursorInput>>;
  where?: InputMaybe<TixAddressBoolExp>;
};


export type TixSubscriptionRootBusinessCodeGroupArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodeGroupOrderBy>>;
  where?: InputMaybe<TixBusinessCodeGroupBoolExp>;
};


export type TixSubscriptionRootBusinessCodeGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodeGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodeGroupOrderBy>>;
  where?: InputMaybe<TixBusinessCodeGroupBoolExp>;
};


export type TixSubscriptionRootBusinessCodeGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixBusinessCodeGroupStreamCursorInput>>;
  where?: InputMaybe<TixBusinessCodeGroupBoolExp>;
};


export type TixSubscriptionRootBusinessCodesArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodesOrderBy>>;
  where?: InputMaybe<TixBusinessCodesBoolExp>;
};


export type TixSubscriptionRootBusinessCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixBusinessCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixBusinessCodesOrderBy>>;
  where?: InputMaybe<TixBusinessCodesBoolExp>;
};


export type TixSubscriptionRootBusinessCodesByPkArgs = {
  businessCodeId: Scalars['uuid'];
};


export type TixSubscriptionRootBusinessCodesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixBusinessCodesStreamCursorInput>>;
  where?: InputMaybe<TixBusinessCodesBoolExp>;
};


export type TixSubscriptionRootCompanyArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyOrderBy>>;
  where?: InputMaybe<TixCompanyBoolExp>;
};


export type TixSubscriptionRootCompanyAddressArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyAddressOrderBy>>;
  where?: InputMaybe<TixCompanyAddressBoolExp>;
};


export type TixSubscriptionRootCompanyAddressAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyAddressOrderBy>>;
  where?: InputMaybe<TixCompanyAddressBoolExp>;
};


export type TixSubscriptionRootCompanyAddressByPkArgs = {
  companyAddressId: Scalars['uuid'];
};


export type TixSubscriptionRootCompanyAddressStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanyAddressStreamCursorInput>>;
  where?: InputMaybe<TixCompanyAddressBoolExp>;
};


export type TixSubscriptionRootCompanyAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyOrderBy>>;
  where?: InputMaybe<TixCompanyBoolExp>;
};


export type TixSubscriptionRootCompanyByPkArgs = {
  companyId: Scalars['uuid'];
};


export type TixSubscriptionRootCompanyConfigurationValueArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyConfigurationValueOrderBy>>;
  where?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
};


export type TixSubscriptionRootCompanyConfigurationValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyConfigurationValueOrderBy>>;
  where?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
};


export type TixSubscriptionRootCompanyConfigurationValueByPkArgs = {
  companyConfigurationValueId: Scalars['uuid'];
};


export type TixSubscriptionRootCompanyConfigurationValueStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanyConfigurationValueStreamCursorInput>>;
  where?: InputMaybe<TixCompanyConfigurationValueBoolExp>;
};


export type TixSubscriptionRootCompanyContactArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyContactOrderBy>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


export type TixSubscriptionRootCompanyContactByPkArgs = {
  companyContactId: Scalars['uuid'];
};


export type TixSubscriptionRootCompanyContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyContactOrderBy>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


export type TixSubscriptionRootCompanyContactStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanyContactStreamCursorInput>>;
  where?: InputMaybe<TixCompanyContactBoolExp>;
};


export type TixSubscriptionRootCompanyMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyMediaFileOrderBy>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


export type TixSubscriptionRootCompanyMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyMediaFileOrderBy>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


export type TixSubscriptionRootCompanyMediaFileStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanyMediaFileStreamCursorInput>>;
  where?: InputMaybe<TixCompanyMediaFileBoolExp>;
};


export type TixSubscriptionRootCompanyPhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyPhoneNumberOrderBy>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


export type TixSubscriptionRootCompanyPhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyPhoneNumberOrderBy>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


export type TixSubscriptionRootCompanyPhoneNumberByPkArgs = {
  companyPhoneNumberId: Scalars['uuid'];
};


export type TixSubscriptionRootCompanyPhoneNumberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanyPhoneNumberStreamCursorInput>>;
  where?: InputMaybe<TixCompanyPhoneNumberBoolExp>;
};


export type TixSubscriptionRootCompanySocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySocialMediaOrderBy>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


export type TixSubscriptionRootCompanySocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySocialMediaOrderBy>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


export type TixSubscriptionRootCompanySocialMediaByPkArgs = {
  companySocialMediaId: Scalars['uuid'];
};


export type TixSubscriptionRootCompanySocialMediaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanySocialMediaStreamCursorInput>>;
  where?: InputMaybe<TixCompanySocialMediaBoolExp>;
};


export type TixSubscriptionRootCompanySummaryReportArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySummaryReportOrderBy>>;
  where?: InputMaybe<TixCompanySummaryReportBoolExp>;
};


export type TixSubscriptionRootCompanySummaryReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanySummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanySummaryReportOrderBy>>;
  where?: InputMaybe<TixCompanySummaryReportBoolExp>;
};


export type TixSubscriptionRootCompanySummaryReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanySummaryReportStreamCursorInput>>;
  where?: InputMaybe<TixCompanySummaryReportBoolExp>;
};


export type TixSubscriptionRootCompanyWarningArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyWarningOrderBy>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};


export type TixSubscriptionRootCompanyWarningAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCompanyWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCompanyWarningOrderBy>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};


export type TixSubscriptionRootCompanyWarningByPkArgs = {
  companyWarningId: Scalars['uuid'];
};


export type TixSubscriptionRootCompanyWarningStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanyWarningStreamCursorInput>>;
  where?: InputMaybe<TixCompanyWarningBoolExp>;
};


export type TixSubscriptionRootCompanyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCompanyStreamCursorInput>>;
  where?: InputMaybe<TixCompanyBoolExp>;
};


export type TixSubscriptionRootConfigurationGroupArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupBoolExp>;
};


export type TixSubscriptionRootConfigurationGroupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupBoolExp>;
};


export type TixSubscriptionRootConfigurationGroupByPkArgs = {
  configurationGroupId: Scalars['uuid'];
};


export type TixSubscriptionRootConfigurationGroupItemArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupItemOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupItemBoolExp>;
};


export type TixSubscriptionRootConfigurationGroupItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationGroupItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationGroupItemOrderBy>>;
  where?: InputMaybe<TixConfigurationGroupItemBoolExp>;
};


export type TixSubscriptionRootConfigurationGroupItemByPkArgs = {
  configurationGroupItemId: Scalars['uuid'];
};


export type TixSubscriptionRootConfigurationGroupItemStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixConfigurationGroupItemStreamCursorInput>>;
  where?: InputMaybe<TixConfigurationGroupItemBoolExp>;
};


export type TixSubscriptionRootConfigurationGroupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixConfigurationGroupStreamCursorInput>>;
  where?: InputMaybe<TixConfigurationGroupBoolExp>;
};


export type TixSubscriptionRootConfigurationItemArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationItemOrderBy>>;
  where?: InputMaybe<TixConfigurationItemBoolExp>;
};


export type TixSubscriptionRootConfigurationItemAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationItemOrderBy>>;
  where?: InputMaybe<TixConfigurationItemBoolExp>;
};


export type TixSubscriptionRootConfigurationItemByPkArgs = {
  configurationItemId: Scalars['uuid'];
};


export type TixSubscriptionRootConfigurationItemStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixConfigurationItemStreamCursorInput>>;
  where?: InputMaybe<TixConfigurationItemBoolExp>;
};


export type TixSubscriptionRootConfigurationValueArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationValueOrderBy>>;
  where?: InputMaybe<TixConfigurationValueBoolExp>;
};


export type TixSubscriptionRootConfigurationValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixConfigurationValueOrderBy>>;
  where?: InputMaybe<TixConfigurationValueBoolExp>;
};


export type TixSubscriptionRootConfigurationValueByPkArgs = {
  configurationValueId: Scalars['uuid'];
};


export type TixSubscriptionRootConfigurationValueStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixConfigurationValueStreamCursorInput>>;
  where?: InputMaybe<TixConfigurationValueBoolExp>;
};


export type TixSubscriptionRootContactArgs = {
  distinct_on?: InputMaybe<Array<TixContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactOrderBy>>;
  where?: InputMaybe<TixContactBoolExp>;
};


export type TixSubscriptionRootContactAddressArgs = {
  distinct_on?: InputMaybe<Array<TixContactAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactAddressOrderBy>>;
  where?: InputMaybe<TixContactAddressBoolExp>;
};


export type TixSubscriptionRootContactAddressAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactAddressOrderBy>>;
  where?: InputMaybe<TixContactAddressBoolExp>;
};


export type TixSubscriptionRootContactAddressByPkArgs = {
  contactAddressId: Scalars['uuid'];
};


export type TixSubscriptionRootContactAddressStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixContactAddressStreamCursorInput>>;
  where?: InputMaybe<TixContactAddressBoolExp>;
};


export type TixSubscriptionRootContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactOrderBy>>;
  where?: InputMaybe<TixContactBoolExp>;
};


export type TixSubscriptionRootContactByPkArgs = {
  contactId: Scalars['uuid'];
};


export type TixSubscriptionRootContactPhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactPhoneNumberOrderBy>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


export type TixSubscriptionRootContactPhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixContactPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixContactPhoneNumberOrderBy>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


export type TixSubscriptionRootContactPhoneNumberByPkArgs = {
  contactPhoneNumberId: Scalars['uuid'];
};


export type TixSubscriptionRootContactPhoneNumberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixContactPhoneNumberStreamCursorInput>>;
  where?: InputMaybe<TixContactPhoneNumberBoolExp>;
};


export type TixSubscriptionRootContactStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixContactStreamCursorInput>>;
  where?: InputMaybe<TixContactBoolExp>;
};


export type TixSubscriptionRootCustomerArgs = {
  distinct_on?: InputMaybe<Array<TixCustomerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCustomerOrderBy>>;
  where?: InputMaybe<TixCustomerBoolExp>;
};


export type TixSubscriptionRootCustomerAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCustomerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCustomerOrderBy>>;
  where?: InputMaybe<TixCustomerBoolExp>;
};


export type TixSubscriptionRootCustomerByPkArgs = {
  customerId: Scalars['uuid'];
};


export type TixSubscriptionRootCustomerSearchArgs = {
  distinct_on?: InputMaybe<Array<TixCustomerSearchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCustomerSearchOrderBy>>;
  where?: InputMaybe<TixCustomerSearchBoolExp>;
};


export type TixSubscriptionRootCustomerSearchAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCustomerSearchSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCustomerSearchOrderBy>>;
  where?: InputMaybe<TixCustomerSearchBoolExp>;
};


export type TixSubscriptionRootCustomerSearchStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCustomerSearchStreamCursorInput>>;
  where?: InputMaybe<TixCustomerSearchBoolExp>;
};


export type TixSubscriptionRootCustomerStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCustomerStreamCursorInput>>;
  where?: InputMaybe<TixCustomerBoolExp>;
};


export type TixSubscriptionRootDailyAuditReportArgs = {
  distinct_on?: InputMaybe<Array<TixDailyAuditReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyAuditReportOrderBy>>;
  where?: InputMaybe<TixDailyAuditReportBoolExp>;
};


export type TixSubscriptionRootDailyAuditReportFinalArgs = {
  distinct_on?: InputMaybe<Array<TixDailyAuditReportFinalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyAuditReportFinalOrderBy>>;
  where?: InputMaybe<TixDailyAuditReportFinalBoolExp>;
};


export type TixSubscriptionRootDailyAuditReportFinalAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDailyAuditReportFinalSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyAuditReportFinalOrderBy>>;
  where?: InputMaybe<TixDailyAuditReportFinalBoolExp>;
};


export type TixSubscriptionRootDailyAuditReportFinalStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixDailyAuditReportFinalStreamCursorInput>>;
  where?: InputMaybe<TixDailyAuditReportFinalBoolExp>;
};


export type TixSubscriptionRootDailyAuditReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDailyAuditReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyAuditReportOrderBy>>;
  where?: InputMaybe<TixDailyAuditReportBoolExp>;
};


export type TixSubscriptionRootDailyAuditReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixDailyAuditReportStreamCursorInput>>;
  where?: InputMaybe<TixDailyAuditReportBoolExp>;
};


export type TixSubscriptionRootDailyTicketCountReportSelectArgs = {
  distinct_on?: InputMaybe<Array<TixDailyTicketCountReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyTicketCountReportOrderBy>>;
  where?: InputMaybe<TixDailyTicketCountReportBoolExp>;
};


export type TixSubscriptionRootDailyTicketCountReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDailyTicketCountReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDailyTicketCountReportOrderBy>>;
  where?: InputMaybe<TixDailyTicketCountReportBoolExp>;
};


export type TixSubscriptionRootDailyTicketCountReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixDailyTicketCountReportStreamCursorInput>>;
  where?: InputMaybe<TixDailyTicketCountReportBoolExp>;
};


export type TixSubscriptionRootDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountOrderBy>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};


export type TixSubscriptionRootDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountOrderBy>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};


export type TixSubscriptionRootDiscountCodeCountByEvenArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountCodeCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountCodeCountByEventOrderBy>>;
  where?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
};


export type TixSubscriptionRootDiscountCodeCountByEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixDiscountCodeCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixDiscountCodeCountByEventOrderBy>>;
  where?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
};


export type TixSubscriptionRootDiscountCodeCountByEventStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixDiscountCodeCountByEventStreamCursorInput>>;
  where?: InputMaybe<TixDiscountCodeCountByEventBoolExp>;
};


export type TixSubscriptionRootDiscountReportArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVDiscountReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVDiscountReportOrderBy>>;
  where?: InputMaybe<TixReportingVDiscountReportBoolExp>;
};


export type TixSubscriptionRootDiscountStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixDiscountStreamCursorInput>>;
  where?: InputMaybe<TixDiscountBoolExp>;
};


export type TixSubscriptionRootEmailContentSelectArgs = {
  distinct_on?: InputMaybe<Array<TixEmailContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEmailContentOrderBy>>;
  where?: InputMaybe<TixEmailContentBoolExp>;
};


export type TixSubscriptionRootEmailContentSelectByPkArgs = {
  emailContentId: Scalars['uuid'];
};


export type TixSubscriptionRootEmailContentAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEmailContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEmailContentOrderBy>>;
  where?: InputMaybe<TixEmailContentBoolExp>;
};


export type TixSubscriptionRootEmailContentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEmailContentStreamCursorInput>>;
  where?: InputMaybe<TixEmailContentBoolExp>;
};


export type TixSubscriptionRootEventArgs = {
  distinct_on?: InputMaybe<Array<TixEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventOrderBy>>;
  where?: InputMaybe<TixEventBoolExp>;
};


export type TixSubscriptionRootEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventOrderBy>>;
  where?: InputMaybe<TixEventBoolExp>;
};


export type TixSubscriptionRootEventByPkArgs = {
  eventId: Scalars['uuid'];
};


export type TixSubscriptionRootEventCompanyVenueArgs = {
  distinct_on?: InputMaybe<Array<TixEventCompanyVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCompanyVenueOrderBy>>;
  where?: InputMaybe<TixEventCompanyVenueBoolExp>;
};


export type TixSubscriptionRootEventCompanyVenueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventCompanyVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCompanyVenueOrderBy>>;
  where?: InputMaybe<TixEventCompanyVenueBoolExp>;
};


export type TixSubscriptionRootEventCompanyVenueStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventCompanyVenueStreamCursorInput>>;
  where?: InputMaybe<TixEventCompanyVenueBoolExp>;
};


export type TixSubscriptionRootEventEmailSelectArgs = {
  distinct_on?: InputMaybe<Array<TixEventEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventEmailOrderBy>>;
  where?: InputMaybe<TixEventEmailBoolExp>;
};


export type TixSubscriptionRootEventEmailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventEmailStreamCursorInput>>;
  where?: InputMaybe<TixEventEmailBoolExp>;
};


export type TixSubscriptionRootEventEmailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventEmailOrderBy>>;
  where?: InputMaybe<TixEventEmailBoolExp>;
};


export type TixSubscriptionRootEventInstanceArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceOrderBy>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};


export type TixSubscriptionRootEventInstanceAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceOrderBy>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};


export type TixSubscriptionRootEventInstanceByPkArgs = {
  eventInstanceId: Scalars['uuid'];
};


export type TixSubscriptionRootEventInstanceConfigurationValueArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceConfigurationValueOrderBy>>;
  where?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
};


export type TixSubscriptionRootEventInstanceConfigurationValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceConfigurationValueOrderBy>>;
  where?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
};


export type TixSubscriptionRootEventInstanceConfigurationValueByPkArgs = {
  eventInstanceConfigurationId: Scalars['uuid'];
};


export type TixSubscriptionRootEventInstanceConfigurationValueStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventInstanceConfigurationValueStreamCursorInput>>;
  where?: InputMaybe<TixEventInstanceConfigurationValueBoolExp>;
};


export type TixSubscriptionRootEventInstanceDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceDiscountOrderBy>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


export type TixSubscriptionRootEventInstanceDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceDiscountOrderBy>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


export type TixSubscriptionRootEventInstanceDiscountStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventInstanceDiscountStreamCursorInput>>;
  where?: InputMaybe<TixEventInstanceDiscountBoolExp>;
};


export type TixSubscriptionRootEventInstanceMedialFileArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


export type TixSubscriptionRootEventInstanceMedialFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceMedialFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceMedialFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


export type TixSubscriptionRootEventInstanceMedialFileByPkArgs = {
  eventMediaId: Scalars['uuid'];
};


export type TixSubscriptionRootEventInstanceMedialFileStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventInstanceMedialFileStreamCursorInput>>;
  where?: InputMaybe<TixEventInstanceMedialFileBoolExp>;
};


export type TixSubscriptionRootEventInstanceSocialMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


export type TixSubscriptionRootEventInstanceSocialMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceSocialMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceSocialMediaFileOrderBy>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


export type TixSubscriptionRootEventInstanceSocialMediaFileStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventInstanceSocialMediaFileStreamCursorInput>>;
  where?: InputMaybe<TixEventInstanceSocialMediaFileBoolExp>;
};


export type TixSubscriptionRootEventInstanceTicketArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


export type TixSubscriptionRootEventInstanceTicketAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


export type TixSubscriptionRootEventInstanceTicketByPkArgs = {
  eventInstanceTicketId: Scalars['uuid'];
};


export type TixSubscriptionRootEventInstanceTicketConfigArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketConfigOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
};


export type TixSubscriptionRootEventInstanceTicketConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventInstanceTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventInstanceTicketConfigOrderBy>>;
  where?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
};


export type TixSubscriptionRootEventInstanceTicketConfigByPkArgs = {
  eventInstanceTicketConfigId: Scalars['uuid'];
};


export type TixSubscriptionRootEventInstanceTicketConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventInstanceTicketConfigStreamCursorInput>>;
  where?: InputMaybe<TixEventInstanceTicketConfigBoolExp>;
};


export type TixSubscriptionRootEventInstanceTicketStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventInstanceTicketStreamCursorInput>>;
  where?: InputMaybe<TixEventInstanceTicketBoolExp>;
};


export type TixSubscriptionRootEventInstanceStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventInstanceStreamCursorInput>>;
  where?: InputMaybe<TixEventInstanceBoolExp>;
};


export type TixSubscriptionRootEventLineupArgs = {
  distinct_on?: InputMaybe<Array<TixEventLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventLineupOrderBy>>;
  where?: InputMaybe<TixEventLineupBoolExp>;
};


export type TixSubscriptionRootEventLineupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventLineupOrderBy>>;
  where?: InputMaybe<TixEventLineupBoolExp>;
};


export type TixSubscriptionRootEventLineupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventLineupStreamCursorInput>>;
  where?: InputMaybe<TixEventLineupBoolExp>;
};


export type TixSubscriptionRootEventListArgs = {
  distinct_on?: InputMaybe<Array<TixEventListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventListOrderBy>>;
  where?: InputMaybe<TixEventListBoolExp>;
};


export type TixSubscriptionRootEventListAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventListOrderBy>>;
  where?: InputMaybe<TixEventListBoolExp>;
};


export type TixSubscriptionRootEventListStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventListStreamCursorInput>>;
  where?: InputMaybe<TixEventListBoolExp>;
};


export type TixSubscriptionRootEventPerformersArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


export type TixSubscriptionRootEventPerformersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventPerformersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventPerformersOrderBy>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


export type TixSubscriptionRootEventPerformersByPkArgs = {
  eventPerformerId: Scalars['uuid'];
};


export type TixSubscriptionRootEventPerformersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventPerformersStreamCursorInput>>;
  where?: InputMaybe<TixEventPerformersBoolExp>;
};


export type TixSubscriptionRootEventProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductOrderBy>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};


export type TixSubscriptionRootEventProductMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductMediaOrderBy>>;
  where?: InputMaybe<TixEventProductMediaBoolExp>;
};


export type TixSubscriptionRootEventProductMediaSelectArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductMediaOrderBy>>;
  where?: InputMaybe<TixEventProductMediaBoolExp>;
};


export type TixSubscriptionRootEventProductMediaSelectByPkArgs = {
  eventProductMediaImageFileId: Scalars['uuid'];
};


export type TixSubscriptionRootEventProductMediaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventProductMediaStreamCursorInput>>;
  where?: InputMaybe<TixEventProductMediaBoolExp>;
};


export type TixSubscriptionRootEventProductSelectArgs = {
  distinct_on?: InputMaybe<Array<TixEventProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventProductOrderBy>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};


export type TixSubscriptionRootEventProductSelectByPkArgs = {
  eventProductId: Scalars['uuid'];
};


export type TixSubscriptionRootEventProductStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventProductStreamCursorInput>>;
  where?: InputMaybe<TixEventProductBoolExp>;
};


export type TixSubscriptionRootEventVenueArgs = {
  distinct_on?: InputMaybe<Array<TixEventVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventVenueOrderBy>>;
  where?: InputMaybe<TixEventVenueBoolExp>;
};


export type TixSubscriptionRootEventVenueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventVenueOrderBy>>;
  where?: InputMaybe<TixEventVenueBoolExp>;
};


export type TixSubscriptionRootEventVenueByPkArgs = {
  eventVenueId: Scalars['uuid'];
};


export type TixSubscriptionRootEventVenueStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventVenueStreamCursorInput>>;
  where?: InputMaybe<TixEventVenueBoolExp>;
};


export type TixSubscriptionRootEventStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventStreamCursorInput>>;
  where?: InputMaybe<TixEventBoolExp>;
};


export type TixSubscriptionRootLineupArgs = {
  distinct_on?: InputMaybe<Array<TixLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupOrderBy>>;
  where?: InputMaybe<TixLineupBoolExp>;
};


export type TixSubscriptionRootLineupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupOrderBy>>;
  where?: InputMaybe<TixLineupBoolExp>;
};


export type TixSubscriptionRootLineupPerformerArgs = {
  distinct_on?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupPerformerOrderBy>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


export type TixSubscriptionRootLineupPerformerAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixLineupPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLineupPerformerOrderBy>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


export type TixSubscriptionRootLineupPerformerStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixLineupPerformerStreamCursorInput>>;
  where?: InputMaybe<TixLineupPerformerBoolExp>;
};


export type TixSubscriptionRootLineupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixLineupStreamCursorInput>>;
  where?: InputMaybe<TixLineupBoolExp>;
};


export type TixSubscriptionRootLoggingArgs = {
  distinct_on?: InputMaybe<Array<TixLoggingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLoggingOrderBy>>;
  where?: InputMaybe<TixLoggingBoolExp>;
};


export type TixSubscriptionRootLoggingAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixLoggingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixLoggingOrderBy>>;
  where?: InputMaybe<TixLoggingBoolExp>;
};


export type TixSubscriptionRootLoggingByPkArgs = {
  logId: Scalars['uuid'];
};


export type TixSubscriptionRootLoggingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixLoggingStreamCursorInput>>;
  where?: InputMaybe<TixLoggingBoolExp>;
};


export type TixSubscriptionRootMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixMediaFileOrderBy>>;
  where?: InputMaybe<TixMediaFileBoolExp>;
};


export type TixSubscriptionRootMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixMediaFileOrderBy>>;
  where?: InputMaybe<TixMediaFileBoolExp>;
};


export type TixSubscriptionRootMediaFileStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixMediaFileStreamCursorInput>>;
  where?: InputMaybe<TixMediaFileBoolExp>;
};


export type TixSubscriptionRootNotificationArgs = {
  distinct_on?: InputMaybe<Array<TixNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixNotificationOrderBy>>;
  where?: InputMaybe<TixNotificationBoolExp>;
};


export type TixSubscriptionRootNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixNotificationOrderBy>>;
  where?: InputMaybe<TixNotificationBoolExp>;
};


export type TixSubscriptionRootNotificationByPkArgs = {
  notificationId: Scalars['uuid'];
};


export type TixSubscriptionRootNotificationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixNotificationStreamCursorInput>>;
  where?: InputMaybe<TixNotificationBoolExp>;
};


export type TixSubscriptionRootOrderAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixOrderOrderBy>>;
  where?: InputMaybe<TixOrderBoolExp>;
};


export type TixSubscriptionRootOrderSelectArgs = {
  distinct_on?: InputMaybe<Array<TixOrderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixOrderOrderBy>>;
  where?: InputMaybe<TixOrderBoolExp>;
};


export type TixSubscriptionRootOrderSelectByPkArgs = {
  orderId: Scalars['uuid'];
};


export type TixSubscriptionRootOrderStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixOrderStreamCursorInput>>;
  where?: InputMaybe<TixOrderBoolExp>;
};


export type TixSubscriptionRootPatronEventListArgs = {
  distinct_on?: InputMaybe<Array<TixPatronEventListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPatronEventListOrderBy>>;
  where?: InputMaybe<TixPatronEventListBoolExp>;
};


export type TixSubscriptionRootPatronEventListAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPatronEventListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPatronEventListOrderBy>>;
  where?: InputMaybe<TixPatronEventListBoolExp>;
};


export type TixSubscriptionRootPatronEventListStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPatronEventListStreamCursorInput>>;
  where?: InputMaybe<TixPatronEventListBoolExp>;
};


export type TixSubscriptionRootPatronFIlteredEventsListArgs = {
  distinct_on?: InputMaybe<Array<TixPatronFIlteredEventsListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPatronFIlteredEventsListOrderBy>>;
  where?: InputMaybe<TixPatronFIlteredEventsListBoolExp>;
};


export type TixSubscriptionRootPatronFIlteredEventsListAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPatronFIlteredEventsListSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPatronFIlteredEventsListOrderBy>>;
  where?: InputMaybe<TixPatronFIlteredEventsListBoolExp>;
};


export type TixSubscriptionRootPatronFIlteredEventsListStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPatronFIlteredEventsListStreamCursorInput>>;
  where?: InputMaybe<TixPatronFIlteredEventsListBoolExp>;
};


export type TixSubscriptionRootPaymentArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentOrderBy>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};


export type TixSubscriptionRootPaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentOrderBy>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};


export type TixSubscriptionRootPaymentDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentDiscountOrderBy>>;
  where?: InputMaybe<TixPaymentDiscountBoolExp>;
};


export type TixSubscriptionRootPaymentDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentDiscountOrderBy>>;
  where?: InputMaybe<TixPaymentDiscountBoolExp>;
};


export type TixSubscriptionRootPaymentDiscountStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPaymentDiscountStreamCursorInput>>;
  where?: InputMaybe<TixPaymentDiscountBoolExp>;
};


export type TixSubscriptionRootPaymentVendorLogArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentVendorLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentVendorLogOrderBy>>;
  where?: InputMaybe<TixPaymentVendorLogBoolExp>;
};


export type TixSubscriptionRootPaymentVendorLogAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPaymentVendorLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPaymentVendorLogOrderBy>>;
  where?: InputMaybe<TixPaymentVendorLogBoolExp>;
};


export type TixSubscriptionRootPaymentVendorLogStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPaymentVendorLogStreamCursorInput>>;
  where?: InputMaybe<TixPaymentVendorLogBoolExp>;
};


export type TixSubscriptionRootPaymentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPaymentStreamCursorInput>>;
  where?: InputMaybe<TixPaymentBoolExp>;
};


export type TixSubscriptionRootPayoutArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutOrderBy>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


export type TixSubscriptionRootPayoutAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutOrderBy>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


export type TixSubscriptionRootPayoutByPkArgs = {
  payoutId: Scalars['uuid'];
};


export type TixSubscriptionRootPayoutConnectSelectArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutConnectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutConnectOrderBy>>;
  where?: InputMaybe<TixPayoutConnectBoolExp>;
};


export type TixSubscriptionRootPayoutConnectAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutConnectSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutConnectOrderBy>>;
  where?: InputMaybe<TixPayoutConnectBoolExp>;
};


export type TixSubscriptionRootPayoutConnectByPkArgs = {
  payoutConnectionId: Scalars['uuid'];
};


export type TixSubscriptionRootPayoutConnectStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPayoutConnectStreamCursorInput>>;
  where?: InputMaybe<TixPayoutConnectBoolExp>;
};


export type TixSubscriptionRootPayoutDetailArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutDetailOrderBy>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};


export type TixSubscriptionRootPayoutDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutDetailOrderBy>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};


export type TixSubscriptionRootPayoutDetailByPkArgs = {
  payoutDetailId: Scalars['uuid'];
};


export type TixSubscriptionRootPayoutDetailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPayoutDetailStreamCursorInput>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};


export type TixSubscriptionRootPayoutStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPayoutStreamCursorInput>>;
  where?: InputMaybe<TixPayoutBoolExp>;
};


export type TixSubscriptionRootPerformerArgs = {
  distinct_on?: InputMaybe<Array<TixPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPerformerOrderBy>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};


export type TixSubscriptionRootPerformerAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPerformerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPerformerOrderBy>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};


export type TixSubscriptionRootPerformerStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPerformerStreamCursorInput>>;
  where?: InputMaybe<TixPerformerBoolExp>;
};


export type TixSubscriptionRootPermissionArgs = {
  distinct_on?: InputMaybe<Array<TixPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPermissionOrderBy>>;
  where?: InputMaybe<TixPermissionBoolExp>;
};


export type TixSubscriptionRootPermissionAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPermissionOrderBy>>;
  where?: InputMaybe<TixPermissionBoolExp>;
};


export type TixSubscriptionRootPermissionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPermissionStreamCursorInput>>;
  where?: InputMaybe<TixPermissionBoolExp>;
};


export type TixSubscriptionRootPhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPhoneNumberOrderBy>>;
  where?: InputMaybe<TixPhoneNumberBoolExp>;
};


export type TixSubscriptionRootPhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPhoneNumberOrderBy>>;
  where?: InputMaybe<TixPhoneNumberBoolExp>;
};


export type TixSubscriptionRootPhoneNumberByPkArgs = {
  phoneNumberId: Scalars['uuid'];
};


export type TixSubscriptionRootPhoneNumberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixPhoneNumberStreamCursorInput>>;
  where?: InputMaybe<TixPhoneNumberBoolExp>;
};


export type TixSubscriptionRootPolicyArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityPolicyOrderBy>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


export type TixSubscriptionRootProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderBy>>;
  where?: InputMaybe<TixProductBoolExp>;
};


export type TixSubscriptionRootProductMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixProductMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductMediaFileOrderBy>>;
  where?: InputMaybe<TixProductMediaFileBoolExp>;
};


export type TixSubscriptionRootProductMediaFileSelectArgs = {
  distinct_on?: InputMaybe<Array<TixProductMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductMediaFileOrderBy>>;
  where?: InputMaybe<TixProductMediaFileBoolExp>;
};


export type TixSubscriptionRootProductMediaFileSelectByPkArgs = {
  productMediaImageFileId: Scalars['uuid'];
};


export type TixSubscriptionRootProductMediaFileStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixProductMediaFileStreamCursorInput>>;
  where?: InputMaybe<TixProductMediaFileBoolExp>;
};


export type TixSubscriptionRootProductSelectArgs = {
  distinct_on?: InputMaybe<Array<TixProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderBy>>;
  where?: InputMaybe<TixProductBoolExp>;
};


export type TixSubscriptionRootProductSelectByPkArgs = {
  productId: Scalars['uuid'];
};


export type TixSubscriptionRootProductStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixProductStreamCursorInput>>;
  where?: InputMaybe<TixProductBoolExp>;
};


export type TixSubscriptionRootRefundsByEventArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVRefundsByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVRefundsByEventOrderBy>>;
  where?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
};


export type TixSubscriptionRootReservationArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


export type TixSubscriptionRootReservationAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationOrderBy>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


export type TixSubscriptionRootReservationByPkArgs = {
  reservationId: Scalars['uuid'];
};


export type TixSubscriptionRootReservationPaymentArgs = {
  distinct_on?: InputMaybe<Array<TixReservationPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationPaymentOrderBy>>;
  where?: InputMaybe<TixReservationPaymentBoolExp>;
};


export type TixSubscriptionRootReservationPaymentAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReservationPaymentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationPaymentOrderBy>>;
  where?: InputMaybe<TixReservationPaymentBoolExp>;
};


export type TixSubscriptionRootReservationPaymentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixReservationPaymentStreamCursorInput>>;
  where?: InputMaybe<TixReservationPaymentBoolExp>;
};


export type TixSubscriptionRootRevenueByChannelTypeArgs = {
  distinct_on?: InputMaybe<Array<TixRevenueByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRevenueByChannelTypeOrderBy>>;
  where?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
};


export type TixSubscriptionRootRevenueByChannelTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixRevenueByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRevenueByChannelTypeOrderBy>>;
  where?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
};


export type TixSubscriptionRootRevenueByChannelTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixRevenueByChannelTypeStreamCursorInput>>;
  where?: InputMaybe<TixRevenueByChannelTypeBoolExp>;
};


export type TixSubscriptionRootRoleArgs = {
  distinct_on?: InputMaybe<Array<TixRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRoleOrderBy>>;
  where?: InputMaybe<TixRoleBoolExp>;
};


export type TixSubscriptionRootRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRoleOrderBy>>;
  where?: InputMaybe<TixRoleBoolExp>;
};


export type TixSubscriptionRootRolePermissionAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixRolePermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRolePermissionOrderBy>>;
  where?: InputMaybe<TixRolePermissionBoolExp>;
};


export type TixSubscriptionRootRolePermissionStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixRolePermissionStreamCursorInput>>;
  where?: InputMaybe<TixRolePermissionBoolExp>;
};


export type TixSubscriptionRootRoleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixRoleStreamCursorInput>>;
  where?: InputMaybe<TixRoleBoolExp>;
};


export type TixSubscriptionRootSelectBusinessCodeGroupByPkArgs = {
  busCodeGroupId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectCompanyMediaFileByPkArgs = {
  companyImageFileId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectDiscountByPkArgs = {
  discountId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectEventInstanceDiscountByPkArgs = {
  eventInstanceDiscountId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectEventInstanceSocialMediaFileByPkArgs = {
  eventSocialMediaId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectEventLineupByPkArgs = {
  event_lineup_id: Scalars['uuid'];
};


export type TixSubscriptionRootSelectLineupByPkArgs = {
  lineupId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectLineupPerformerByPkArgs = {
  lineupPerformerId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectMediaFilebyPkArgs = {
  mediaFileId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectPaymentByPkArgs = {
  paymentId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectPaymentDiscountByPkArgs = {
  paymentDiscountId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectPaymentVendorLogByPkArgs = {
  vendorPaymentLogId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectPerformerByPkArgs = {
  performerId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectPermissionByPkArgs = {
  permissionId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectReservationPaymentByPkArgs = {
  reservationPaymentId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectRoleByPkArgs = {
  roleId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectRolePermissionArgs = {
  distinct_on?: InputMaybe<Array<TixRolePermissionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixRolePermissionOrderBy>>;
  where?: InputMaybe<TixRolePermissionBoolExp>;
};


export type TixSubscriptionRootSelectRolePermissionByPkArgs = {
  rolePermissionId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectUserArgs = {
  distinct_on?: InputMaybe<Array<TixUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserOrderBy>>;
  where?: InputMaybe<TixUserBoolExp>;
};


export type TixSubscriptionRootSelectUserByPkArgs = {
  userId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectUserRoleArgs = {
  distinct_on?: InputMaybe<Array<TixUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserRoleOrderBy>>;
  where?: InputMaybe<TixUserRoleBoolExp>;
};


export type TixSubscriptionRootSelectUserRoleByPkArgs = {
  userRoleId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectVenueDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueDiscountOrderBy>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};


export type TixSubscriptionRootSelectVenueDiscountByPkArgs = {
  venueDiscountId: Scalars['uuid'];
};


export type TixSubscriptionRootSelectVenueLineupByPkArgs = {
  venueLineupId: Scalars['uuid'];
};


export type TixSubscriptionRootSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSocialMediaOrderBy>>;
  where?: InputMaybe<TixSocialMediaBoolExp>;
};


export type TixSubscriptionRootSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSocialMediaOrderBy>>;
  where?: InputMaybe<TixSocialMediaBoolExp>;
};


export type TixSubscriptionRootSocialMediaByPkArgs = {
  socialMediaId: Scalars['uuid'];
};


export type TixSubscriptionRootSocialMediaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixSocialMediaStreamCursorInput>>;
  where?: InputMaybe<TixSocialMediaBoolExp>;
};


export type TixSubscriptionRootStreamVenueDiscountArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueDiscountStreamCursorInput>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};


export type TixSubscriptionRootTicketArgs = {
  distinct_on?: InputMaybe<Array<TixTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketOrderBy>>;
  where?: InputMaybe<TixTicketBoolExp>;
};


export type TixSubscriptionRootTicketAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketOrderBy>>;
  where?: InputMaybe<TixTicketBoolExp>;
};


export type TixSubscriptionRootTicketByPkArgs = {
  ticketId: Scalars['uuid'];
};


export type TixSubscriptionRootTicketConfigArgs = {
  distinct_on?: InputMaybe<Array<TixTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketConfigOrderBy>>;
  where?: InputMaybe<TixTicketConfigBoolExp>;
};


export type TixSubscriptionRootTicketConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketConfigOrderBy>>;
  where?: InputMaybe<TixTicketConfigBoolExp>;
};


export type TixSubscriptionRootTicketConfigByPkArgs = {
  ticketConfigId: Scalars['uuid'];
};


export type TixSubscriptionRootTicketConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketConfigStreamCursorInput>>;
  where?: InputMaybe<TixTicketConfigBoolExp>;
};


export type TixSubscriptionRootTicketCountByChannelTypeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByChannelTypeOrderBy>>;
  where?: InputMaybe<TixTicketCountByChannelTypeBoolExp>;
};


export type TixSubscriptionRootTicketCountByChannelTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByChannelTypeOrderBy>>;
  where?: InputMaybe<TixTicketCountByChannelTypeBoolExp>;
};


export type TixSubscriptionRootTicketCountByChannelTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketCountByChannelTypeStreamCursorInput>>;
  where?: InputMaybe<TixTicketCountByChannelTypeBoolExp>;
};


export type TixSubscriptionRootTicketCountByEventArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByEventOrderBy>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};


export type TixSubscriptionRootTicketCountByEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByEventOrderBy>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};


export type TixSubscriptionRootTicketCountByEventStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketCountByEventStreamCursorInput>>;
  where?: InputMaybe<TixTicketCountByEventBoolExp>;
};


export type TixSubscriptionRootTicketCountByNameArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByNameOrderBy>>;
  where?: InputMaybe<TixTicketCountByNameBoolExp>;
};


export type TixSubscriptionRootTicketCountByNameAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByNameSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByNameOrderBy>>;
  where?: InputMaybe<TixTicketCountByNameBoolExp>;
};


export type TixSubscriptionRootTicketCountByNameStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketCountByNameStreamCursorInput>>;
  where?: InputMaybe<TixTicketCountByNameBoolExp>;
};


export type TixSubscriptionRootTicketCountByRevenueTypeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByRevenueTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByRevenueTypeOrderBy>>;
  where?: InputMaybe<TixTicketCountByRevenueTypeBoolExp>;
};


export type TixSubscriptionRootTicketCountByRevenueTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketCountByRevenueTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketCountByRevenueTypeOrderBy>>;
  where?: InputMaybe<TixTicketCountByRevenueTypeBoolExp>;
};


export type TixSubscriptionRootTicketCountByRevenueTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketCountByRevenueTypeStreamCursorInput>>;
  where?: InputMaybe<TixTicketCountByRevenueTypeBoolExp>;
};


export type TixSubscriptionRootTicketReservationDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationDetailOrderBy>>;
  where?: InputMaybe<TixTicketReservationDetailBoolExp>;
};


export type TixSubscriptionRootTicketReservationDetailSelectArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationDetailOrderBy>>;
  where?: InputMaybe<TixTicketReservationDetailBoolExp>;
};


export type TixSubscriptionRootTicketReservationDetailSelectByPkArgs = {
  reservationDetailId: Scalars['uuid'];
};


export type TixSubscriptionRootTicketReservationDetailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketReservationDetailStreamCursorInput>>;
  where?: InputMaybe<TixTicketReservationDetailBoolExp>;
};


export type TixSubscriptionRootTicketStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketStreamCursorInput>>;
  where?: InputMaybe<TixTicketBoolExp>;
};


export type TixSubscriptionRootUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserOrderBy>>;
  where?: InputMaybe<TixUserBoolExp>;
};


export type TixSubscriptionRootUserRoleAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUserRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUserRoleOrderBy>>;
  where?: InputMaybe<TixUserRoleBoolExp>;
};


export type TixSubscriptionRootUserRoleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixUserRoleStreamCursorInput>>;
  where?: InputMaybe<TixUserRoleBoolExp>;
};


export type TixSubscriptionRootUserStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixUserStreamCursorInput>>;
  where?: InputMaybe<TixUserBoolExp>;
};


export type TixSubscriptionRootVenueArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueOrderBy>>;
  where?: InputMaybe<TixVenueBoolExp>;
};


export type TixSubscriptionRootVenueAddressArgs = {
  distinct_on?: InputMaybe<Array<TixVenueAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueAddressOrderBy>>;
  where?: InputMaybe<TixVenueAddressBoolExp>;
};


export type TixSubscriptionRootVenueAddressAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueAddressOrderBy>>;
  where?: InputMaybe<TixVenueAddressBoolExp>;
};


export type TixSubscriptionRootVenueAddressByPkArgs = {
  venueAddressId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueAddressStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueAddressStreamCursorInput>>;
  where?: InputMaybe<TixVenueAddressBoolExp>;
};


export type TixSubscriptionRootVenueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueOrderBy>>;
  where?: InputMaybe<TixVenueBoolExp>;
};


export type TixSubscriptionRootVenueByPkArgs = {
  venueId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueConfigurationValueArgs = {
  distinct_on?: InputMaybe<Array<TixVenueConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueConfigurationValueOrderBy>>;
  where?: InputMaybe<TixVenueConfigurationValueBoolExp>;
};


export type TixSubscriptionRootVenueConfigurationValueAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueConfigurationValueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueConfigurationValueOrderBy>>;
  where?: InputMaybe<TixVenueConfigurationValueBoolExp>;
};


export type TixSubscriptionRootVenueConfigurationValueByPkArgs = {
  venueConfigurationValueId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueConfigurationValueStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueConfigurationValueStreamCursorInput>>;
  where?: InputMaybe<TixVenueConfigurationValueBoolExp>;
};


export type TixSubscriptionRootVenueContactArgs = {
  distinct_on?: InputMaybe<Array<TixVenueContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueContactOrderBy>>;
  where?: InputMaybe<TixVenueContactBoolExp>;
};


export type TixSubscriptionRootVenueContactAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueContactSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueContactOrderBy>>;
  where?: InputMaybe<TixVenueContactBoolExp>;
};


export type TixSubscriptionRootVenueContactByPkArgs = {
  venueContactId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueContactStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueContactStreamCursorInput>>;
  where?: InputMaybe<TixVenueContactBoolExp>;
};


export type TixSubscriptionRootVenueDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixVenueDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueDiscountOrderBy>>;
  where?: InputMaybe<TixVenueDiscountBoolExp>;
};


export type TixSubscriptionRootVenueLineupArgs = {
  distinct_on?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueLineupOrderBy>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};


export type TixSubscriptionRootVenueLineupAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueLineupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueLineupOrderBy>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};


export type TixSubscriptionRootVenueLineupStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueLineupStreamCursorInput>>;
  where?: InputMaybe<TixVenueLineupBoolExp>;
};


export type TixSubscriptionRootVenueMediaFileArgs = {
  distinct_on?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueMediaFileOrderBy>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};


export type TixSubscriptionRootVenueMediaFileAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueMediaFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueMediaFileOrderBy>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};


export type TixSubscriptionRootVenueMediaFileByPkArgs = {
  venueImageFileId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueMediaFileStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueMediaFileStreamCursorInput>>;
  where?: InputMaybe<TixVenueMediaFileBoolExp>;
};


export type TixSubscriptionRootVenuePhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenuePhoneNumberOrderBy>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};


export type TixSubscriptionRootVenuePhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenuePhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenuePhoneNumberOrderBy>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};


export type TixSubscriptionRootVenuePhoneNumberByPkArgs = {
  venuePhoneNumberId: Scalars['uuid'];
};


export type TixSubscriptionRootVenuePhoneNumberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenuePhoneNumberStreamCursorInput>>;
  where?: InputMaybe<TixVenuePhoneNumberBoolExp>;
};


export type TixSubscriptionRootVenueProductAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueProductOrderBy>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


export type TixSubscriptionRootVenueProductSelectArgs = {
  distinct_on?: InputMaybe<Array<TixVenueProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueProductOrderBy>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


export type TixSubscriptionRootVenueProductSelectByPkArgs = {
  venueProductId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueProductStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueProductStreamCursorInput>>;
  where?: InputMaybe<TixVenueProductBoolExp>;
};


export type TixSubscriptionRootVenueSocialMediaArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueSocialMediaOrderBy>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};


export type TixSubscriptionRootVenueSocialMediaAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueSocialMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueSocialMediaOrderBy>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};


export type TixSubscriptionRootVenueSocialMediaByPkArgs = {
  venueSocialMediaId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueSocialMediaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueSocialMediaStreamCursorInput>>;
  where?: InputMaybe<TixVenueSocialMediaBoolExp>;
};


export type TixSubscriptionRootVenueTicketArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


export type TixSubscriptionRootVenueTicketAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketOrderBy>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


export type TixSubscriptionRootVenueTicketByPkArgs = {
  venueTicketId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueTicketConfigArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketConfigOrderBy>>;
  where?: InputMaybe<TixVenueTicketConfigBoolExp>;
};


export type TixSubscriptionRootVenueTicketConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueTicketConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueTicketConfigOrderBy>>;
  where?: InputMaybe<TixVenueTicketConfigBoolExp>;
};


export type TixSubscriptionRootVenueTicketConfigByPkArgs = {
  venueTicketConfig: Scalars['uuid'];
};


export type TixSubscriptionRootVenueTicketConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueTicketConfigStreamCursorInput>>;
  where?: InputMaybe<TixVenueTicketConfigBoolExp>;
};


export type TixSubscriptionRootVenueTicketStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueTicketStreamCursorInput>>;
  where?: InputMaybe<TixVenueTicketBoolExp>;
};


export type TixSubscriptionRootVenueWarningArgs = {
  distinct_on?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueWarningOrderBy>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};


export type TixSubscriptionRootVenueWarningAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixVenueWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixVenueWarningOrderBy>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};


export type TixSubscriptionRootVenueWarningByPkArgs = {
  venueWarningId: Scalars['uuid'];
};


export type TixSubscriptionRootVenueWarningStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueWarningStreamCursorInput>>;
  where?: InputMaybe<TixVenueWarningBoolExp>;
};


export type TixSubscriptionRootVenueStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixVenueStreamCursorInput>>;
  where?: InputMaybe<TixVenueBoolExp>;
};


export type TixSubscriptionRootWarningArgs = {
  distinct_on?: InputMaybe<Array<TixWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixWarningOrderBy>>;
  where?: InputMaybe<TixWarningBoolExp>;
};


export type TixSubscriptionRootWarningAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixWarningSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixWarningOrderBy>>;
  where?: InputMaybe<TixWarningBoolExp>;
};


export type TixSubscriptionRootWarningByPkArgs = {
  warningId: Scalars['uuid'];
};


export type TixSubscriptionRootWarningStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixWarningStreamCursorInput>>;
  where?: InputMaybe<TixWarningBoolExp>;
};


export type TixSubscriptionRootAddressPerformerPhoneNumberArgs = {
  distinct_on?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressPerformerPhoneNumberOrderBy>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};


export type TixSubscriptionRootAddressPerformerPhoneNumberAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixAddressPerformerPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixAddressPerformerPhoneNumberOrderBy>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};


export type TixSubscriptionRootAddressPerformerPhoneNumberByPkArgs = {
  performer_phone_number_id: Scalars['uuid'];
};


export type TixSubscriptionRootAddressPerformerPhoneNumberStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixAddressPerformerPhoneNumberStreamCursorInput>>;
  where?: InputMaybe<TixAddressPerformerPhoneNumberBoolExp>;
};


export type TixSubscriptionRootCommunicationsCompanyEmailArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsCompanyEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsCompanyEmailOrderBy>>;
  where?: InputMaybe<TixCommunicationsCompanyEmailBoolExp>;
};


export type TixSubscriptionRootCommunicationsCompanyEmailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsCompanyEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsCompanyEmailOrderBy>>;
  where?: InputMaybe<TixCommunicationsCompanyEmailBoolExp>;
};


export type TixSubscriptionRootCommunicationsCompanyEmailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCommunicationsCompanyEmailStreamCursorInput>>;
  where?: InputMaybe<TixCommunicationsCompanyEmailBoolExp>;
};


export type TixSubscriptionRootCommunicationsEmailContentVariableArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailContentVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailContentVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
};


export type TixSubscriptionRootCommunicationsEmailContentVariableAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailContentVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailContentVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
};


export type TixSubscriptionRootCommunicationsEmailContentVariableByPkArgs = {
  emailContentVariableId: Scalars['uuid'];
};


export type TixSubscriptionRootCommunicationsEmailContentVariableStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCommunicationsEmailContentVariableStreamCursorInput>>;
  where?: InputMaybe<TixCommunicationsEmailContentVariableBoolExp>;
};


export type TixSubscriptionRootCommunicationsEmailVariableArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailVariableBoolExp>;
};


export type TixSubscriptionRootCommunicationsEmailVariableAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsEmailVariableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsEmailVariableOrderBy>>;
  where?: InputMaybe<TixCommunicationsEmailVariableBoolExp>;
};


export type TixSubscriptionRootCommunicationsEmailVariableByPkArgs = {
  emailVariableId: Scalars['uuid'];
};


export type TixSubscriptionRootCommunicationsEmailVariableStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCommunicationsEmailVariableStreamCursorInput>>;
  where?: InputMaybe<TixCommunicationsEmailVariableBoolExp>;
};


export type TixSubscriptionRootCommunicationsVenueEmailArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsVenueEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsVenueEmailOrderBy>>;
  where?: InputMaybe<TixCommunicationsVenueEmailBoolExp>;
};


export type TixSubscriptionRootCommunicationsVenueEmailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixCommunicationsVenueEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixCommunicationsVenueEmailOrderBy>>;
  where?: InputMaybe<TixCommunicationsVenueEmailBoolExp>;
};


export type TixSubscriptionRootCommunicationsVenueEmailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixCommunicationsVenueEmailStreamCursorInput>>;
  where?: InputMaybe<TixCommunicationsVenueEmailBoolExp>;
};


export type TixSubscriptionRootEventSummaryReportArgs = {
  distinct_on?: InputMaybe<Array<TixEventSummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventSummaryReportOrderBy>>;
  where?: InputMaybe<TixEventSummaryReportBoolExp>;
};


export type TixSubscriptionRootEventSummaryReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventSummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventSummaryReportOrderBy>>;
  where?: InputMaybe<TixEventSummaryReportBoolExp>;
};


export type TixSubscriptionRootEventSummaryReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventSummaryReportStreamCursorInput>>;
  where?: InputMaybe<TixEventSummaryReportBoolExp>;
};


export type TixSubscriptionRootEventCampaignTrackingArgs = {
  distinct_on?: InputMaybe<Array<TixEventCampaignTrackingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCampaignTrackingOrderBy>>;
  where?: InputMaybe<TixEventCampaignTrackingBoolExp>;
};


export type TixSubscriptionRootEventCampaignTrackingAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixEventCampaignTrackingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixEventCampaignTrackingOrderBy>>;
  where?: InputMaybe<TixEventCampaignTrackingBoolExp>;
};


export type TixSubscriptionRootEventCampaignTrackingByPkArgs = {
  campaign_tracking_id: Scalars['uuid'];
};


export type TixSubscriptionRootEventCampaignTrackingStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixEventCampaignTrackingStreamCursorInput>>;
  where?: InputMaybe<TixEventCampaignTrackingBoolExp>;
};


export type TixSubscriptionRootFeesArgs = {
  distinct_on?: InputMaybe<Array<TixFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixFeesOrderBy>>;
  where?: InputMaybe<TixFeesBoolExp>;
};


export type TixSubscriptionRootFeesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixFeesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixFeesOrderBy>>;
  where?: InputMaybe<TixFeesBoolExp>;
};


export type TixSubscriptionRootFeesByPkArgs = {
  feeId: Scalars['uuid'];
};


export type TixSubscriptionRootFeesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixFeesStreamCursorInput>>;
  where?: InputMaybe<TixFeesBoolExp>;
};


export type TixSubscriptionRootNotificationContactNotificationArgs = {
  distinct_on?: InputMaybe<Array<TixNotificationContactNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixNotificationContactNotificationOrderBy>>;
  where?: InputMaybe<TixNotificationContactNotificationBoolExp>;
};


export type TixSubscriptionRootNotificationContactNotificationAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixNotificationContactNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixNotificationContactNotificationOrderBy>>;
  where?: InputMaybe<TixNotificationContactNotificationBoolExp>;
};


export type TixSubscriptionRootNotificationContactNotificationByPkArgs = {
  contactNotificationId: Scalars['uuid'];
};


export type TixSubscriptionRootNotificationContactNotificationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixNotificationContactNotificationStreamCursorInput>>;
  where?: InputMaybe<TixNotificationContactNotificationBoolExp>;
};


export type TixSubscriptionRootProductOrderDetailArgs = {
  distinct_on?: InputMaybe<Array<TixProductOrderDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderDetailOrderBy>>;
  where?: InputMaybe<TixProductOrderDetailBoolExp>;
};


export type TixSubscriptionRootProductOrderDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixProductOrderDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixProductOrderDetailOrderBy>>;
  where?: InputMaybe<TixProductOrderDetailBoolExp>;
};


export type TixSubscriptionRootProductOrderDetailByPkArgs = {
  orderDetailId: Scalars['uuid'];
};


export type TixSubscriptionRootProductOrderDetailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixProductOrderDetailStreamCursorInput>>;
  where?: InputMaybe<TixProductOrderDetailBoolExp>;
};


export type TixSubscriptionRootReportingVDiscountReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVDiscountReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVDiscountReportOrderBy>>;
  where?: InputMaybe<TixReportingVDiscountReportBoolExp>;
};


export type TixSubscriptionRootReportingVDiscountReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixReportingVDiscountReportStreamCursorInput>>;
  where?: InputMaybe<TixReportingVDiscountReportBoolExp>;
};


export type TixSubscriptionRootReportingVRefundsByEventAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVRefundsByEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVRefundsByEventOrderBy>>;
  where?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
};


export type TixSubscriptionRootReportingVRefundsByEventStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixReportingVRefundsByEventStreamCursorInput>>;
  where?: InputMaybe<TixReportingVRefundsByEventBoolExp>;
};


export type TixSubscriptionRootReportingVTicketDetailReportArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVTicketDetailReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVTicketDetailReportOrderBy>>;
  where?: InputMaybe<TixReportingVTicketDetailReportBoolExp>;
};


export type TixSubscriptionRootReportingVTicketDetailReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReportingVTicketDetailReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReportingVTicketDetailReportOrderBy>>;
  where?: InputMaybe<TixReportingVTicketDetailReportBoolExp>;
};


export type TixSubscriptionRootReportingVTicketDetailReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixReportingVTicketDetailReportStreamCursorInput>>;
  where?: InputMaybe<TixReportingVTicketDetailReportBoolExp>;
};


export type TixSubscriptionRootReservationDetailReportArgs = {
  distinct_on?: InputMaybe<Array<TixReservationDetailReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationDetailReportOrderBy>>;
  where?: InputMaybe<TixReservationDetailReportBoolExp>;
};


export type TixSubscriptionRootReservationDetailReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReservationDetailReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationDetailReportOrderBy>>;
  where?: InputMaybe<TixReservationDetailReportBoolExp>;
};


export type TixSubscriptionRootReservationDetailReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixReservationDetailReportStreamCursorInput>>;
  where?: InputMaybe<TixReservationDetailReportBoolExp>;
};


export type TixSubscriptionRootReservationReportArgs = {
  distinct_on?: InputMaybe<Array<TixReservationReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationReportOrderBy>>;
  where?: InputMaybe<TixReservationReportBoolExp>;
};


export type TixSubscriptionRootReservationReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReservationReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationReportOrderBy>>;
  where?: InputMaybe<TixReservationReportBoolExp>;
};


export type TixSubscriptionRootReservationReportByPkArgs = {
  reservationReportId: Scalars['uuid'];
};


export type TixSubscriptionRootReservationReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixReservationReportStreamCursorInput>>;
  where?: InputMaybe<TixReservationReportBoolExp>;
};


export type TixSubscriptionRootReservationSummaryReportArgs = {
  distinct_on?: InputMaybe<Array<TixReservationSummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationSummaryReportOrderBy>>;
  where?: InputMaybe<TixReservationSummaryReportBoolExp>;
};


export type TixSubscriptionRootReservationSummaryReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixReservationSummaryReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixReservationSummaryReportOrderBy>>;
  where?: InputMaybe<TixReservationSummaryReportBoolExp>;
};


export type TixSubscriptionRootReservationSummaryReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixReservationSummaryReportStreamCursorInput>>;
  where?: InputMaybe<TixReservationSummaryReportBoolExp>;
};


export type TixSubscriptionRootSavedReportArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportOrderBy>>;
  where?: InputMaybe<TixSavedReportBoolExp>;
};


export type TixSubscriptionRootSavedReportEventsArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportEventsOrderBy>>;
  where?: InputMaybe<TixSavedReportEventsBoolExp>;
};


export type TixSubscriptionRootSavedReportEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportEventsOrderBy>>;
  where?: InputMaybe<TixSavedReportEventsBoolExp>;
};


export type TixSubscriptionRootSavedReportEventsByPkArgs = {
  savedReportEventsId: Scalars['uuid'];
};


export type TixSubscriptionRootSavedReportEventsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixSavedReportEventsStreamCursorInput>>;
  where?: InputMaybe<TixSavedReportEventsBoolExp>;
};


export type TixSubscriptionRootSavedReportLayoutArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportLayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportLayoutOrderBy>>;
  where?: InputMaybe<TixSavedReportLayoutBoolExp>;
};


export type TixSubscriptionRootSavedReportLayoutAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportLayoutSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportLayoutOrderBy>>;
  where?: InputMaybe<TixSavedReportLayoutBoolExp>;
};


export type TixSubscriptionRootSavedReportLayoutByPkArgs = {
  savedReportLayoutId: Scalars['uuid'];
};


export type TixSubscriptionRootSavedReportLayoutStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixSavedReportLayoutStreamCursorInput>>;
  where?: InputMaybe<TixSavedReportLayoutBoolExp>;
};


export type TixSubscriptionRootSavedReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixSavedReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixSavedReportOrderBy>>;
  where?: InputMaybe<TixSavedReportBoolExp>;
};


export type TixSubscriptionRootSavedReportByPkArgs = {
  savedReportId: Scalars['uuid'];
};


export type TixSubscriptionRootSavedReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixSavedReportStreamCursorInput>>;
  where?: InputMaybe<TixSavedReportBoolExp>;
};


export type TixSubscriptionRootScheduledReportArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportOrderBy>>;
  where?: InputMaybe<TixScheduledReportBoolExp>;
};


export type TixSubscriptionRootScheduledReportEmailArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportEmailOrderBy>>;
  where?: InputMaybe<TixScheduledReportEmailBoolExp>;
};


export type TixSubscriptionRootScheduledReportEmailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportEmailOrderBy>>;
  where?: InputMaybe<TixScheduledReportEmailBoolExp>;
};


export type TixSubscriptionRootScheduledReportEmailByPkArgs = {
  scheduledReportEmailId: Scalars['uuid'];
};


export type TixSubscriptionRootScheduledReportEmailStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixScheduledReportEmailStreamCursorInput>>;
  where?: InputMaybe<TixScheduledReportEmailBoolExp>;
};


export type TixSubscriptionRootScheduledReportAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixScheduledReportSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixScheduledReportOrderBy>>;
  where?: InputMaybe<TixScheduledReportBoolExp>;
};


export type TixSubscriptionRootScheduledReportByPkArgs = {
  scheduledReportId: Scalars['uuid'];
};


export type TixSubscriptionRootScheduledReportStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixScheduledReportStreamCursorInput>>;
  where?: InputMaybe<TixScheduledReportBoolExp>;
};


export type TixSubscriptionRootTicketExchangeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketExchangeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketExchangeOrderBy>>;
  where?: InputMaybe<TixTicketExchangeBoolExp>;
};


export type TixSubscriptionRootTicketExchangeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketExchangeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketExchangeOrderBy>>;
  where?: InputMaybe<TixTicketExchangeBoolExp>;
};


export type TixSubscriptionRootTicketExchangeByPkArgs = {
  exchangeId: Scalars['uuid'];
};


export type TixSubscriptionRootTicketExchangeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketExchangeStreamCursorInput>>;
  where?: InputMaybe<TixTicketExchangeBoolExp>;
};


export type TixSubscriptionRootTicketReservationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketReservationStreamCursorInput>>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};


export type TixSubscriptionRootTicketTicketDiscountArgs = {
  distinct_on?: InputMaybe<Array<TixTicketTicketDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketTicketDiscountOrderBy>>;
  where?: InputMaybe<TixTicketTicketDiscountBoolExp>;
};


export type TixSubscriptionRootTicketTicketDiscountAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketTicketDiscountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketTicketDiscountOrderBy>>;
  where?: InputMaybe<TixTicketTicketDiscountBoolExp>;
};


export type TixSubscriptionRootTicketTicketDiscountByPkArgs = {
  ticketDiscountId: Scalars['uuid'];
};


export type TixSubscriptionRootTicketTicketDiscountStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketTicketDiscountStreamCursorInput>>;
  where?: InputMaybe<TixTicketTicketDiscountBoolExp>;
};


export type TixSubscriptionRootTicketVTicketCountByTypeArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketCountByTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketCountByTypeOrderBy>>;
  where?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
};


export type TixSubscriptionRootTicketVTicketCountByTypeAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketCountByTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketCountByTypeOrderBy>>;
  where?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
};


export type TixSubscriptionRootTicketVTicketCountByTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketVTicketCountByTypeStreamCursorInput>>;
  where?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
};


export type TixSubscriptionRootTicketVTicketSalesMetricsArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketSalesMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketSalesMetricsOrderBy>>;
  where?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
};


export type TixSubscriptionRootTicketVTicketSalesMetricsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketVTicketSalesMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketVTicketSalesMetricsOrderBy>>;
  where?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
};


export type TixSubscriptionRootTicketVTicketSalesMetricsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixTicketVTicketSalesMetricsStreamCursorInput>>;
  where?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
};


export type TixSubscriptionRootUtilityPolicyAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityPolicyOrderBy>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


export type TixSubscriptionRootUtilityPolicyByPkArgs = {
  policyId: Scalars['uuid'];
};


export type TixSubscriptionRootUtilityPolicyStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixUtilityPolicyStreamCursorInput>>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};


export type TixSubscriptionRootUtilityTimestampByTimezoneArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityTimestampByTimezoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityTimestampByTimezoneOrderBy>>;
  where?: InputMaybe<TixUtilityTimestampByTimezoneBoolExp>;
};


export type TixSubscriptionRootUtilityTimestampByTimezoneAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixUtilityTimestampByTimezoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixUtilityTimestampByTimezoneOrderBy>>;
  where?: InputMaybe<TixUtilityTimestampByTimezoneBoolExp>;
};


export type TixSubscriptionRootUtilityTimestampByTimezoneStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TixUtilityTimestampByTimezoneStreamCursorInput>>;
  where?: InputMaybe<TixUtilityTimestampByTimezoneBoolExp>;
};

/** columns and relationships of "ticket.exchange" */
export type TixTicketExchange = {
  __typename?: 'ticket_exchange';
  amount: Scalars['numeric'];
  createdAt: Scalars['timestamp'];
  createdBy?: Maybe<Scalars['uuid']>;
  donationIncluded: Scalars['Boolean'];
  exchangeId: Scalars['uuid'];
  exchangedProductIds: Array<Scalars['uuid']>;
  exchangedTicketIds: Array<Scalars['uuid']>;
  expiresAt?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  newReservation?: Maybe<TixTicketReservation>;
  newReservationId: Scalars['uuid'];
  /** An object relationship */
  originalReservation?: Maybe<TixTicketReservation>;
  originalReservationId: Scalars['uuid'];
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  required_action: Scalars['String'];
  state: Scalars['String'];
  updatedAt: Scalars['timestamp'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "ticket.exchange" */
export type TixTicketExchangeAggregate = {
  __typename?: 'ticket_exchange_aggregate';
  aggregate?: Maybe<TixTicketExchangeAggregateFields>;
  nodes: Array<TixTicketExchange>;
};

/** aggregate fields of "ticket.exchange" */
export type TixTicketExchangeAggregateFields = {
  __typename?: 'ticket_exchange_aggregate_fields';
  avg?: Maybe<TixTicketExchangeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketExchangeMaxFields>;
  min?: Maybe<TixTicketExchangeMinFields>;
  stddev?: Maybe<TixTicketExchangeStddevFields>;
  stddev_pop?: Maybe<TixTicketExchangeStddevPopFields>;
  stddev_samp?: Maybe<TixTicketExchangeStddevSampFields>;
  sum?: Maybe<TixTicketExchangeSumFields>;
  var_pop?: Maybe<TixTicketExchangeVarPopFields>;
  var_samp?: Maybe<TixTicketExchangeVarSampFields>;
  variance?: Maybe<TixTicketExchangeVarianceFields>;
};


/** aggregate fields of "ticket.exchange" */
export type TixTicketExchangeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketExchangeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixTicketExchangeAvgFields = {
  __typename?: 'ticket_exchange_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticket.exchange". All fields are combined with a logical 'AND'. */
export type TixTicketExchangeBoolExp = {
  _and?: InputMaybe<Array<TixTicketExchangeBoolExp>>;
  _not?: InputMaybe<TixTicketExchangeBoolExp>;
  _or?: InputMaybe<Array<TixTicketExchangeBoolExp>>;
  amount?: InputMaybe<TixNumericComparisonExp>;
  createdAt?: InputMaybe<TixTimestampComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  donationIncluded?: InputMaybe<TixBooleanComparisonExp>;
  exchangeId?: InputMaybe<TixUuidComparisonExp>;
  exchangedProductIds?: InputMaybe<TixUuidArrayComparisonExp>;
  exchangedTicketIds?: InputMaybe<TixUuidArrayComparisonExp>;
  expiresAt?: InputMaybe<TixTimestampComparisonExp>;
  newReservation?: InputMaybe<TixTicketReservationBoolExp>;
  newReservationId?: InputMaybe<TixUuidComparisonExp>;
  originalReservation?: InputMaybe<TixTicketReservationBoolExp>;
  originalReservationId?: InputMaybe<TixUuidComparisonExp>;
  paymentIntentClientSecret?: InputMaybe<TixStringComparisonExp>;
  paymentIntentId?: InputMaybe<TixStringComparisonExp>;
  required_action?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "ticket.exchange" */
export enum TixTicketExchangeConstraint {
  /** unique or primary key constraint on columns "exchange_id" */
  ExchangePkey = 'exchange_pkey'
}

/** input type for incrementing numeric columns in table "ticket.exchange" */
export type TixTicketExchangeIncInput = {
  amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "ticket.exchange" */
export type TixTicketExchangeInsertInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  donationIncluded?: InputMaybe<Scalars['Boolean']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  exchangedProductIds?: InputMaybe<Array<Scalars['uuid']>>;
  exchangedTicketIds?: InputMaybe<Array<Scalars['uuid']>>;
  expiresAt?: InputMaybe<Scalars['timestamp']>;
  newReservation?: InputMaybe<TixTicketReservationObjRelInsertInput>;
  newReservationId?: InputMaybe<Scalars['uuid']>;
  originalReservation?: InputMaybe<TixTicketReservationObjRelInsertInput>;
  originalReservationId?: InputMaybe<Scalars['uuid']>;
  paymentIntentClientSecret?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  required_action?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixTicketExchangeMaxFields = {
  __typename?: 'ticket_exchange_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  exchangeId?: Maybe<Scalars['uuid']>;
  exchangedProductIds?: Maybe<Array<Scalars['uuid']>>;
  exchangedTicketIds?: Maybe<Array<Scalars['uuid']>>;
  expiresAt?: Maybe<Scalars['timestamp']>;
  newReservationId?: Maybe<Scalars['uuid']>;
  originalReservationId?: Maybe<Scalars['uuid']>;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  required_action?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TixTicketExchangeMinFields = {
  __typename?: 'ticket_exchange_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['uuid']>;
  exchangeId?: Maybe<Scalars['uuid']>;
  exchangedProductIds?: Maybe<Array<Scalars['uuid']>>;
  exchangedTicketIds?: Maybe<Array<Scalars['uuid']>>;
  expiresAt?: Maybe<Scalars['timestamp']>;
  newReservationId?: Maybe<Scalars['uuid']>;
  originalReservationId?: Maybe<Scalars['uuid']>;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  required_action?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "ticket.exchange" */
export type TixTicketExchangeMutationResponse = {
  __typename?: 'ticket_exchange_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixTicketExchange>;
};

/** on_conflict condition type for table "ticket.exchange" */
export type TixTicketExchangeOnConflict = {
  constraint: TixTicketExchangeConstraint;
  update_columns?: Array<TixTicketExchangeUpdateColumn>;
  where?: InputMaybe<TixTicketExchangeBoolExp>;
};

/** Ordering options when selecting data from "ticket.exchange". */
export type TixTicketExchangeOrderBy = {
  amount?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  donationIncluded?: InputMaybe<TixOrderBy>;
  exchangeId?: InputMaybe<TixOrderBy>;
  exchangedProductIds?: InputMaybe<TixOrderBy>;
  exchangedTicketIds?: InputMaybe<TixOrderBy>;
  expiresAt?: InputMaybe<TixOrderBy>;
  newReservation?: InputMaybe<TixTicketReservationOrderBy>;
  newReservationId?: InputMaybe<TixOrderBy>;
  originalReservation?: InputMaybe<TixTicketReservationOrderBy>;
  originalReservationId?: InputMaybe<TixOrderBy>;
  paymentIntentClientSecret?: InputMaybe<TixOrderBy>;
  paymentIntentId?: InputMaybe<TixOrderBy>;
  required_action?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.exchange */
export type TixTicketExchangePkColumnsInput = {
  exchangeId: Scalars['uuid'];
};

/** select columns of table "ticket.exchange" */
export enum TixTicketExchangeSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DonationIncluded = 'donationIncluded',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  ExchangedProductIds = 'exchangedProductIds',
  /** column name */
  ExchangedTicketIds = 'exchangedTicketIds',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  NewReservationId = 'newReservationId',
  /** column name */
  OriginalReservationId = 'originalReservationId',
  /** column name */
  PaymentIntentClientSecret = 'paymentIntentClientSecret',
  /** column name */
  PaymentIntentId = 'paymentIntentId',
  /** column name */
  RequiredAction = 'required_action',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "ticket.exchange" */
export type TixTicketExchangeSetInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  donationIncluded?: InputMaybe<Scalars['Boolean']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  exchangedProductIds?: InputMaybe<Array<Scalars['uuid']>>;
  exchangedTicketIds?: InputMaybe<Array<Scalars['uuid']>>;
  expiresAt?: InputMaybe<Scalars['timestamp']>;
  newReservationId?: InputMaybe<Scalars['uuid']>;
  originalReservationId?: InputMaybe<Scalars['uuid']>;
  paymentIntentClientSecret?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  required_action?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TixTicketExchangeStddevFields = {
  __typename?: 'ticket_exchange_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixTicketExchangeStddevPopFields = {
  __typename?: 'ticket_exchange_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixTicketExchangeStddevSampFields = {
  __typename?: 'ticket_exchange_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticket_exchange" */
export type TixTicketExchangeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketExchangeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketExchangeStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  donationIncluded?: InputMaybe<Scalars['Boolean']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  exchangedProductIds?: InputMaybe<Array<Scalars['uuid']>>;
  exchangedTicketIds?: InputMaybe<Array<Scalars['uuid']>>;
  expiresAt?: InputMaybe<Scalars['timestamp']>;
  newReservationId?: InputMaybe<Scalars['uuid']>;
  originalReservationId?: InputMaybe<Scalars['uuid']>;
  paymentIntentClientSecret?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  required_action?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TixTicketExchangeSumFields = {
  __typename?: 'ticket_exchange_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "ticket.exchange" */
export enum TixTicketExchangeUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DonationIncluded = 'donationIncluded',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  ExchangedProductIds = 'exchangedProductIds',
  /** column name */
  ExchangedTicketIds = 'exchangedTicketIds',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  NewReservationId = 'newReservationId',
  /** column name */
  OriginalReservationId = 'originalReservationId',
  /** column name */
  PaymentIntentClientSecret = 'paymentIntentClientSecret',
  /** column name */
  PaymentIntentId = 'paymentIntentId',
  /** column name */
  RequiredAction = 'required_action',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixTicketExchangeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixTicketExchangeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixTicketExchangeSetInput>;
  /** filter the rows which have to be updated */
  where: TixTicketExchangeBoolExp;
};

/** aggregate var_pop on columns */
export type TixTicketExchangeVarPopFields = {
  __typename?: 'ticket_exchange_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixTicketExchangeVarSampFields = {
  __typename?: 'ticket_exchange_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixTicketExchangeVarianceFields = {
  __typename?: 'ticket_exchange_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ticket.reservation" */
export type TixTicketReservation = {
  __typename?: 'ticket_reservation';
  active?: Maybe<Scalars['Boolean']>;
  additionalComments?: Maybe<Scalars['String']>;
  agreeToTerms?: Maybe<Scalars['Boolean']>;
  checkedInAt?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  contact?: Maybe<TixContact>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  discount?: Maybe<TixDiscount>;
  discountAmount?: Maybe<Scalars['money']>;
  discountId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  groupCode?: Maybe<Scalars['String']>;
  isGroup?: Maybe<Scalars['Boolean']>;
  isSpecialOccasion?: Maybe<Scalars['Boolean']>;
  occasionName?: Maybe<Scalars['String']>;
  /** An object relationship */
  payment?: Maybe<TixReservationPayment>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  /** An object relationship */
  product_order?: Maybe<TixOrder>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationId: Scalars['uuid'];
  reservationStatus?: Maybe<Scalars['String']>;
  /** An array relationship */
  reservation_detail: Array<TixTicketReservationDetail>;
  /** An aggregate relationship */
  reservation_detail_aggregate: TixTicketReservationDetailAggregate;
  /** An array relationship */
  reservation_payout_details: Array<TixPayoutDetail>;
  /** An aggregate relationship */
  reservation_payout_details_aggregate: TixPayoutDetailAggregate;
  salesChannel?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['money']>;
  /** An array relationship */
  tickets: Array<TixTicket>;
  /** An aggregate relationship */
  tickets_aggregate: TixTicketAggregate;
  totalAmountPaid?: Maybe<Scalars['money']>;
  /** when the record was last updated */
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueFee?: Maybe<Scalars['money']>;
};


/** columns and relationships of "ticket.reservation" */
export type TixTicketReservationReservationDetailArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationDetailOrderBy>>;
  where?: InputMaybe<TixTicketReservationDetailBoolExp>;
};


/** columns and relationships of "ticket.reservation" */
export type TixTicketReservationReservationDetailAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketReservationDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketReservationDetailOrderBy>>;
  where?: InputMaybe<TixTicketReservationDetailBoolExp>;
};


/** columns and relationships of "ticket.reservation" */
export type TixTicketReservationReservationPayoutDetailsArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutDetailOrderBy>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};


/** columns and relationships of "ticket.reservation" */
export type TixTicketReservationReservationPayoutDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixPayoutDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixPayoutDetailOrderBy>>;
  where?: InputMaybe<TixPayoutDetailBoolExp>;
};


/** columns and relationships of "ticket.reservation" */
export type TixTicketReservationTicketsArgs = {
  distinct_on?: InputMaybe<Array<TixTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketOrderBy>>;
  where?: InputMaybe<TixTicketBoolExp>;
};


/** columns and relationships of "ticket.reservation" */
export type TixTicketReservationTicketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TixTicketSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TixTicketOrderBy>>;
  where?: InputMaybe<TixTicketBoolExp>;
};

/** aggregated selection of "ticket.reservation" */
export type TixTicketReservationAggregate = {
  __typename?: 'ticket_reservation_aggregate';
  aggregate?: Maybe<TixTicketReservationAggregateFields>;
  nodes: Array<TixTicketReservation>;
};

export type TixTicketReservationAggregateBoolExp = {
  bool_and?: InputMaybe<TixTicketReservationAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TixTicketReservationAggregateBoolExpBoolOr>;
  count?: InputMaybe<TixTicketReservationAggregateBoolExpCount>;
};

export type TixTicketReservationAggregateBoolExpBoolAnd = {
  arguments: TixTicketReservationSelectColumnTicketReservationAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketReservationBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixTicketReservationAggregateBoolExpBoolOr = {
  arguments: TixTicketReservationSelectColumnTicketReservationAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketReservationBoolExp>;
  predicate: TixBooleanComparisonExp;
};

export type TixTicketReservationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketReservationBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.reservation" */
export type TixTicketReservationAggregateFields = {
  __typename?: 'ticket_reservation_aggregate_fields';
  avg?: Maybe<TixTicketReservationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketReservationMaxFields>;
  min?: Maybe<TixTicketReservationMinFields>;
  stddev?: Maybe<TixTicketReservationStddevFields>;
  stddev_pop?: Maybe<TixTicketReservationStddevPopFields>;
  stddev_samp?: Maybe<TixTicketReservationStddevSampFields>;
  sum?: Maybe<TixTicketReservationSumFields>;
  var_pop?: Maybe<TixTicketReservationVarPopFields>;
  var_samp?: Maybe<TixTicketReservationVarSampFields>;
  variance?: Maybe<TixTicketReservationVarianceFields>;
};


/** aggregate fields of "ticket.reservation" */
export type TixTicketReservationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketReservationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.reservation" */
export type TixTicketReservationAggregateOrderBy = {
  avg?: InputMaybe<TixTicketReservationAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixTicketReservationMaxOrderBy>;
  min?: InputMaybe<TixTicketReservationMinOrderBy>;
  stddev?: InputMaybe<TixTicketReservationStddevOrderBy>;
  stddev_pop?: InputMaybe<TixTicketReservationStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixTicketReservationStddevSampOrderBy>;
  sum?: InputMaybe<TixTicketReservationSumOrderBy>;
  var_pop?: InputMaybe<TixTicketReservationVarPopOrderBy>;
  var_samp?: InputMaybe<TixTicketReservationVarSampOrderBy>;
  variance?: InputMaybe<TixTicketReservationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ticket.reservation" */
export type TixTicketReservationArrRelInsertInput = {
  data: Array<TixTicketReservationInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixTicketReservationOnConflict>;
};

/** aggregate avg on columns */
export type TixTicketReservationAvgFields = {
  __typename?: 'ticket_reservation_avg_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ticket.reservation" */
export type TixTicketReservationAvgOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "ticket.reservation". All fields are combined with a logical 'AND'. */
export type TixTicketReservationBoolExp = {
  _and?: InputMaybe<Array<TixTicketReservationBoolExp>>;
  _not?: InputMaybe<TixTicketReservationBoolExp>;
  _or?: InputMaybe<Array<TixTicketReservationBoolExp>>;
  active?: InputMaybe<TixBooleanComparisonExp>;
  additionalComments?: InputMaybe<TixStringComparisonExp>;
  agreeToTerms?: InputMaybe<TixBooleanComparisonExp>;
  checkedInAt?: InputMaybe<TixTimestampComparisonExp>;
  contact?: InputMaybe<TixContactBoolExp>;
  contactId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  discount?: InputMaybe<TixDiscountBoolExp>;
  discountAmount?: InputMaybe<TixMoneyComparisonExp>;
  discountId?: InputMaybe<TixUuidComparisonExp>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  groupCode?: InputMaybe<TixStringComparisonExp>;
  isGroup?: InputMaybe<TixBooleanComparisonExp>;
  isSpecialOccasion?: InputMaybe<TixBooleanComparisonExp>;
  occasionName?: InputMaybe<TixStringComparisonExp>;
  payment?: InputMaybe<TixReservationPaymentBoolExp>;
  platformFee?: InputMaybe<TixMoneyComparisonExp>;
  processingFee?: InputMaybe<TixMoneyComparisonExp>;
  product_order?: InputMaybe<TixOrderBoolExp>;
  reservationDate?: InputMaybe<TixDateComparisonExp>;
  reservationId?: InputMaybe<TixUuidComparisonExp>;
  reservationStatus?: InputMaybe<TixStringComparisonExp>;
  reservation_detail?: InputMaybe<TixTicketReservationDetailBoolExp>;
  reservation_detail_aggregate?: InputMaybe<TixTicketReservationDetailAggregateBoolExp>;
  reservation_payout_details?: InputMaybe<TixPayoutDetailBoolExp>;
  reservation_payout_details_aggregate?: InputMaybe<TixPayoutDetailAggregateBoolExp>;
  salesChannel?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  subTotal?: InputMaybe<TixMoneyComparisonExp>;
  tickets?: InputMaybe<TixTicketBoolExp>;
  tickets_aggregate?: InputMaybe<TixTicketAggregateBoolExp>;
  totalAmountPaid?: InputMaybe<TixMoneyComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venueFee?: InputMaybe<TixMoneyComparisonExp>;
};

/** unique or primary key constraints on table "ticket.reservation" */
export enum TixTicketReservationConstraint {
  /** unique or primary key constraint on columns "reservation_id" */
  ReservationsPkey = 'reservations_pkey'
}

/** input type for incrementing numeric columns in table "ticket.reservation" */
export type TixTicketReservationIncInput = {
  discountAmount?: InputMaybe<Scalars['money']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  subTotal?: InputMaybe<Scalars['money']>;
  totalAmountPaid?: InputMaybe<Scalars['money']>;
  venueFee?: InputMaybe<Scalars['money']>;
};

/** input type for inserting data into table "ticket.reservation" */
export type TixTicketReservationInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  additionalComments?: InputMaybe<Scalars['String']>;
  agreeToTerms?: InputMaybe<Scalars['Boolean']>;
  checkedInAt?: InputMaybe<Scalars['timestamp']>;
  contact?: InputMaybe<TixContactObjRelInsertInput>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discount?: InputMaybe<TixDiscountObjRelInsertInput>;
  discountAmount?: InputMaybe<Scalars['money']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  groupCode?: InputMaybe<Scalars['String']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  isSpecialOccasion?: InputMaybe<Scalars['Boolean']>;
  occasionName?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<TixReservationPaymentObjRelInsertInput>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  product_order?: InputMaybe<TixOrderObjRelInsertInput>;
  reservationDate?: InputMaybe<Scalars['date']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationStatus?: InputMaybe<Scalars['String']>;
  reservation_detail?: InputMaybe<TixTicketReservationDetailArrRelInsertInput>;
  reservation_payout_details?: InputMaybe<TixPayoutDetailArrRelInsertInput>;
  salesChannel?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subTotal?: InputMaybe<Scalars['money']>;
  tickets?: InputMaybe<TixTicketArrRelInsertInput>;
  totalAmountPaid?: InputMaybe<Scalars['money']>;
  /** when the record was last updated */
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
};

/** aggregate max on columns */
export type TixTicketReservationMaxFields = {
  __typename?: 'ticket_reservation_max_fields';
  additionalComments?: Maybe<Scalars['String']>;
  checkedInAt?: Maybe<Scalars['timestamp']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountAmount?: Maybe<Scalars['money']>;
  discountId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  groupCode?: Maybe<Scalars['String']>;
  occasionName?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationStatus?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['money']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  /** when the record was last updated */
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueFee?: Maybe<Scalars['money']>;
};

/** order by max() on columns of table "ticket.reservation" */
export type TixTicketReservationMaxOrderBy = {
  additionalComments?: InputMaybe<TixOrderBy>;
  checkedInAt?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  groupCode?: InputMaybe<TixOrderBy>;
  occasionName?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  reservationDate?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationStatus?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  /** when the record was last updated */
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixTicketReservationMinFields = {
  __typename?: 'ticket_reservation_min_fields';
  additionalComments?: Maybe<Scalars['String']>;
  checkedInAt?: Maybe<Scalars['timestamp']>;
  contactId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountAmount?: Maybe<Scalars['money']>;
  discountId?: Maybe<Scalars['uuid']>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  groupCode?: Maybe<Scalars['String']>;
  occasionName?: Maybe<Scalars['String']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  reservationDate?: Maybe<Scalars['date']>;
  reservationId?: Maybe<Scalars['uuid']>;
  reservationStatus?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['money']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  /** when the record was last updated */
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueFee?: Maybe<Scalars['money']>;
};

/** order by min() on columns of table "ticket.reservation" */
export type TixTicketReservationMinOrderBy = {
  additionalComments?: InputMaybe<TixOrderBy>;
  checkedInAt?: InputMaybe<TixOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  groupCode?: InputMaybe<TixOrderBy>;
  occasionName?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  reservationDate?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationStatus?: InputMaybe<TixOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  /** when the record was last updated */
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "ticket.reservation" */
export type TixTicketReservationMutationResponse = {
  __typename?: 'ticket_reservation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixTicketReservation>;
};

/** input type for inserting object relation for remote table "ticket.reservation" */
export type TixTicketReservationObjRelInsertInput = {
  data: TixTicketReservationInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixTicketReservationOnConflict>;
};

/** on_conflict condition type for table "ticket.reservation" */
export type TixTicketReservationOnConflict = {
  constraint: TixTicketReservationConstraint;
  update_columns?: Array<TixTicketReservationUpdateColumn>;
  where?: InputMaybe<TixTicketReservationBoolExp>;
};

/** Ordering options when selecting data from "ticket.reservation". */
export type TixTicketReservationOrderBy = {
  active?: InputMaybe<TixOrderBy>;
  additionalComments?: InputMaybe<TixOrderBy>;
  agreeToTerms?: InputMaybe<TixOrderBy>;
  checkedInAt?: InputMaybe<TixOrderBy>;
  contact?: InputMaybe<TixContactOrderBy>;
  contactId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  discount?: InputMaybe<TixDiscountOrderBy>;
  discountAmount?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  groupCode?: InputMaybe<TixOrderBy>;
  isGroup?: InputMaybe<TixOrderBy>;
  isSpecialOccasion?: InputMaybe<TixOrderBy>;
  occasionName?: InputMaybe<TixOrderBy>;
  payment?: InputMaybe<TixReservationPaymentOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  product_order?: InputMaybe<TixOrderOrderBy>;
  reservationDate?: InputMaybe<TixOrderBy>;
  reservationId?: InputMaybe<TixOrderBy>;
  reservationStatus?: InputMaybe<TixOrderBy>;
  reservation_detail_aggregate?: InputMaybe<TixTicketReservationDetailAggregateOrderBy>;
  reservation_payout_details_aggregate?: InputMaybe<TixPayoutDetailAggregateOrderBy>;
  salesChannel?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  tickets_aggregate?: InputMaybe<TixTicketAggregateOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.reservation */
export type TixTicketReservationPkColumnsInput = {
  reservationId: Scalars['uuid'];
};

/** select columns of table "ticket.reservation" */
export enum TixTicketReservationSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  AdditionalComments = 'additionalComments',
  /** column name */
  AgreeToTerms = 'agreeToTerms',
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  GroupCode = 'groupCode',
  /** column name */
  IsGroup = 'isGroup',
  /** column name */
  IsSpecialOccasion = 'isSpecialOccasion',
  /** column name */
  OccasionName = 'occasionName',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  ReservationDate = 'reservationDate',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationStatus = 'reservationStatus',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  State = 'state',
  /** column name */
  SubTotal = 'subTotal',
  /** column name */
  TotalAmountPaid = 'totalAmountPaid',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueFee = 'venueFee'
}

/** select "ticket_reservation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ticket.reservation" */
export enum TixTicketReservationSelectColumnTicketReservationAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active',
  /** column name */
  AgreeToTerms = 'agreeToTerms',
  /** column name */
  IsGroup = 'isGroup',
  /** column name */
  IsSpecialOccasion = 'isSpecialOccasion'
}

/** select "ticket_reservation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ticket.reservation" */
export enum TixTicketReservationSelectColumnTicketReservationAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active',
  /** column name */
  AgreeToTerms = 'agreeToTerms',
  /** column name */
  IsGroup = 'isGroup',
  /** column name */
  IsSpecialOccasion = 'isSpecialOccasion'
}

/** input type for updating data in table "ticket.reservation" */
export type TixTicketReservationSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  additionalComments?: InputMaybe<Scalars['String']>;
  agreeToTerms?: InputMaybe<Scalars['Boolean']>;
  checkedInAt?: InputMaybe<Scalars['timestamp']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountAmount?: InputMaybe<Scalars['money']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  groupCode?: InputMaybe<Scalars['String']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  isSpecialOccasion?: InputMaybe<Scalars['Boolean']>;
  occasionName?: InputMaybe<Scalars['String']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  reservationDate?: InputMaybe<Scalars['date']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationStatus?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subTotal?: InputMaybe<Scalars['money']>;
  totalAmountPaid?: InputMaybe<Scalars['money']>;
  /** when the record was last updated */
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
};

/** aggregate stddev on columns */
export type TixTicketReservationStddevFields = {
  __typename?: 'ticket_reservation_stddev_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ticket.reservation" */
export type TixTicketReservationStddevOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixTicketReservationStddevPopFields = {
  __typename?: 'ticket_reservation_stddev_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ticket.reservation" */
export type TixTicketReservationStddevPopOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixTicketReservationStddevSampFields = {
  __typename?: 'ticket_reservation_stddev_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ticket.reservation" */
export type TixTicketReservationStddevSampOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "ticket_reservation" */
export type TixTicketReservationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketReservationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketReservationStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  additionalComments?: InputMaybe<Scalars['String']>;
  agreeToTerms?: InputMaybe<Scalars['Boolean']>;
  checkedInAt?: InputMaybe<Scalars['timestamp']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountAmount?: InputMaybe<Scalars['money']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  groupCode?: InputMaybe<Scalars['String']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  isSpecialOccasion?: InputMaybe<Scalars['Boolean']>;
  occasionName?: InputMaybe<Scalars['String']>;
  platformFee?: InputMaybe<Scalars['money']>;
  processingFee?: InputMaybe<Scalars['money']>;
  reservationDate?: InputMaybe<Scalars['date']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
  reservationStatus?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subTotal?: InputMaybe<Scalars['money']>;
  totalAmountPaid?: InputMaybe<Scalars['money']>;
  /** when the record was last updated */
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueFee?: InputMaybe<Scalars['money']>;
};

/** aggregate sum on columns */
export type TixTicketReservationSumFields = {
  __typename?: 'ticket_reservation_sum_fields';
  discountAmount?: Maybe<Scalars['money']>;
  platformFee?: Maybe<Scalars['money']>;
  processingFee?: Maybe<Scalars['money']>;
  subTotal?: Maybe<Scalars['money']>;
  totalAmountPaid?: Maybe<Scalars['money']>;
  venueFee?: Maybe<Scalars['money']>;
};

/** order by sum() on columns of table "ticket.reservation" */
export type TixTicketReservationSumOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** update columns of table "ticket.reservation" */
export enum TixTicketReservationUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  AdditionalComments = 'additionalComments',
  /** column name */
  AgreeToTerms = 'agreeToTerms',
  /** column name */
  CheckedInAt = 'checkedInAt',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscountAmount = 'discountAmount',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  GroupCode = 'groupCode',
  /** column name */
  IsGroup = 'isGroup',
  /** column name */
  IsSpecialOccasion = 'isSpecialOccasion',
  /** column name */
  OccasionName = 'occasionName',
  /** column name */
  PlatformFee = 'platformFee',
  /** column name */
  ProcessingFee = 'processingFee',
  /** column name */
  ReservationDate = 'reservationDate',
  /** column name */
  ReservationId = 'reservationId',
  /** column name */
  ReservationStatus = 'reservationStatus',
  /** column name */
  SalesChannel = 'salesChannel',
  /** column name */
  State = 'state',
  /** column name */
  SubTotal = 'subTotal',
  /** column name */
  TotalAmountPaid = 'totalAmountPaid',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueFee = 'venueFee'
}

export type TixTicketReservationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TixTicketReservationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixTicketReservationSetInput>;
  /** filter the rows which have to be updated */
  where: TixTicketReservationBoolExp;
};

/** aggregate var_pop on columns */
export type TixTicketReservationVarPopFields = {
  __typename?: 'ticket_reservation_var_pop_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ticket.reservation" */
export type TixTicketReservationVarPopOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixTicketReservationVarSampFields = {
  __typename?: 'ticket_reservation_var_samp_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ticket.reservation" */
export type TixTicketReservationVarSampOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixTicketReservationVarianceFields = {
  __typename?: 'ticket_reservation_variance_fields';
  discountAmount?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  totalAmountPaid?: Maybe<Scalars['Float']>;
  venueFee?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ticket.reservation" */
export type TixTicketReservationVarianceOrderBy = {
  discountAmount?: InputMaybe<TixOrderBy>;
  platformFee?: InputMaybe<TixOrderBy>;
  processingFee?: InputMaybe<TixOrderBy>;
  subTotal?: InputMaybe<TixOrderBy>;
  totalAmountPaid?: InputMaybe<TixOrderBy>;
  venueFee?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "ticket.ticket_discount" */
export type TixTicketTicketDiscount = {
  __typename?: 'ticket_ticket_discount';
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  discountId: Scalars['uuid'];
  state?: Maybe<Scalars['String']>;
  /** An object relationship */
  ticket?: Maybe<TixTicket>;
  ticketDiscountId: Scalars['uuid'];
  ticketId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
  updatedBy: Scalars['uuid'];
};

/** aggregated selection of "ticket.ticket_discount" */
export type TixTicketTicketDiscountAggregate = {
  __typename?: 'ticket_ticket_discount_aggregate';
  aggregate?: Maybe<TixTicketTicketDiscountAggregateFields>;
  nodes: Array<TixTicketTicketDiscount>;
};

export type TixTicketTicketDiscountAggregateBoolExp = {
  count?: InputMaybe<TixTicketTicketDiscountAggregateBoolExpCount>;
};

export type TixTicketTicketDiscountAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixTicketTicketDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketTicketDiscountBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.ticket_discount" */
export type TixTicketTicketDiscountAggregateFields = {
  __typename?: 'ticket_ticket_discount_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixTicketTicketDiscountMaxFields>;
  min?: Maybe<TixTicketTicketDiscountMinFields>;
};


/** aggregate fields of "ticket.ticket_discount" */
export type TixTicketTicketDiscountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketTicketDiscountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.ticket_discount" */
export type TixTicketTicketDiscountAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixTicketTicketDiscountMaxOrderBy>;
  min?: InputMaybe<TixTicketTicketDiscountMinOrderBy>;
};

/** input type for inserting array relation for remote table "ticket.ticket_discount" */
export type TixTicketTicketDiscountArrRelInsertInput = {
  data: Array<TixTicketTicketDiscountInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixTicketTicketDiscountOnConflict>;
};

/** Boolean expression to filter rows from the table "ticket.ticket_discount". All fields are combined with a logical 'AND'. */
export type TixTicketTicketDiscountBoolExp = {
  _and?: InputMaybe<Array<TixTicketTicketDiscountBoolExp>>;
  _not?: InputMaybe<TixTicketTicketDiscountBoolExp>;
  _or?: InputMaybe<Array<TixTicketTicketDiscountBoolExp>>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  discountId?: InputMaybe<TixUuidComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  ticket?: InputMaybe<TixTicketBoolExp>;
  ticketDiscountId?: InputMaybe<TixUuidComparisonExp>;
  ticketId?: InputMaybe<TixUuidComparisonExp>;
  updatedAt?: InputMaybe<TixTimestampComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "ticket.ticket_discount" */
export enum TixTicketTicketDiscountConstraint {
  /** unique or primary key constraint on columns "ticket_discount_id" */
  ReservationDiscountPkey = 'reservation_discount_pkey'
}

/** input type for inserting data into table "ticket.ticket_discount" */
export type TixTicketTicketDiscountInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  ticket?: InputMaybe<TixTicketObjRelInsertInput>;
  ticketDiscountId?: InputMaybe<Scalars['uuid']>;
  ticketId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixTicketTicketDiscountMaxFields = {
  __typename?: 'ticket_ticket_discount_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  ticketDiscountId?: Maybe<Scalars['uuid']>;
  ticketId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ticket.ticket_discount" */
export type TixTicketTicketDiscountMaxOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketDiscountId?: InputMaybe<TixOrderBy>;
  ticketId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixTicketTicketDiscountMinFields = {
  __typename?: 'ticket_ticket_discount_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  ticketDiscountId?: Maybe<Scalars['uuid']>;
  ticketId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ticket.ticket_discount" */
export type TixTicketTicketDiscountMinOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticketDiscountId?: InputMaybe<TixOrderBy>;
  ticketId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "ticket.ticket_discount" */
export type TixTicketTicketDiscountMutationResponse = {
  __typename?: 'ticket_ticket_discount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixTicketTicketDiscount>;
};

/** input type for inserting object relation for remote table "ticket.ticket_discount" */
export type TixTicketTicketDiscountObjRelInsertInput = {
  data: TixTicketTicketDiscountInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TixTicketTicketDiscountOnConflict>;
};

/** on_conflict condition type for table "ticket.ticket_discount" */
export type TixTicketTicketDiscountOnConflict = {
  constraint: TixTicketTicketDiscountConstraint;
  update_columns?: Array<TixTicketTicketDiscountUpdateColumn>;
  where?: InputMaybe<TixTicketTicketDiscountBoolExp>;
};

/** Ordering options when selecting data from "ticket.ticket_discount". */
export type TixTicketTicketDiscountOrderBy = {
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  discountId?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  ticket?: InputMaybe<TixTicketOrderBy>;
  ticketDiscountId?: InputMaybe<TixOrderBy>;
  ticketId?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: ticket.ticket_discount */
export type TixTicketTicketDiscountPkColumnsInput = {
  ticketDiscountId: Scalars['uuid'];
};

/** select columns of table "ticket.ticket_discount" */
export enum TixTicketTicketDiscountSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  State = 'state',
  /** column name */
  TicketDiscountId = 'ticketDiscountId',
  /** column name */
  TicketId = 'ticketId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "ticket.ticket_discount" */
export type TixTicketTicketDiscountSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  ticketDiscountId?: InputMaybe<Scalars['uuid']>;
  ticketId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ticket_ticket_discount" */
export type TixTicketTicketDiscountStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketTicketDiscountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketTicketDiscountStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  discountId?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  ticketDiscountId?: InputMaybe<Scalars['uuid']>;
  ticketId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ticket.ticket_discount" */
export enum TixTicketTicketDiscountUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  State = 'state',
  /** column name */
  TicketDiscountId = 'ticketDiscountId',
  /** column name */
  TicketId = 'ticketId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type TixTicketTicketDiscountUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixTicketTicketDiscountSetInput>;
  /** filter the rows which have to be updated */
  where: TixTicketTicketDiscountBoolExp;
};

/** columns and relationships of "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByType = {
  __typename?: 'ticket_v_ticket_count_by_type';
  /** An object relationship */
  event?: Maybe<TixEventInstance>;
  eventInstanceId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentChildType?: Maybe<Scalars['String']>;
  parentTicketConfigId?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  section?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsRemaining?: Maybe<Scalars['bigint']>;
  ticketsSold?: Maybe<Scalars['bigint']>;
  totalTickets?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeAggregate = {
  __typename?: 'ticket_v_ticket_count_by_type_aggregate';
  aggregate?: Maybe<TixTicketVTicketCountByTypeAggregateFields>;
  nodes: Array<TixTicketVTicketCountByType>;
};

export type TixTicketVTicketCountByTypeAggregateBoolExp = {
  count?: InputMaybe<TixTicketVTicketCountByTypeAggregateBoolExpCount>;
};

export type TixTicketVTicketCountByTypeAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixTicketVTicketCountByTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeAggregateFields = {
  __typename?: 'ticket_v_ticket_count_by_type_aggregate_fields';
  avg?: Maybe<TixTicketVTicketCountByTypeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketVTicketCountByTypeMaxFields>;
  min?: Maybe<TixTicketVTicketCountByTypeMinFields>;
  stddev?: Maybe<TixTicketVTicketCountByTypeStddevFields>;
  stddev_pop?: Maybe<TixTicketVTicketCountByTypeStddevPopFields>;
  stddev_samp?: Maybe<TixTicketVTicketCountByTypeStddevSampFields>;
  sum?: Maybe<TixTicketVTicketCountByTypeSumFields>;
  var_pop?: Maybe<TixTicketVTicketCountByTypeVarPopFields>;
  var_samp?: Maybe<TixTicketVTicketCountByTypeVarSampFields>;
  variance?: Maybe<TixTicketVTicketCountByTypeVarianceFields>;
};


/** aggregate fields of "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketVTicketCountByTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeAggregateOrderBy = {
  avg?: InputMaybe<TixTicketVTicketCountByTypeAvgOrderBy>;
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixTicketVTicketCountByTypeMaxOrderBy>;
  min?: InputMaybe<TixTicketVTicketCountByTypeMinOrderBy>;
  stddev?: InputMaybe<TixTicketVTicketCountByTypeStddevOrderBy>;
  stddev_pop?: InputMaybe<TixTicketVTicketCountByTypeStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TixTicketVTicketCountByTypeStddevSampOrderBy>;
  sum?: InputMaybe<TixTicketVTicketCountByTypeSumOrderBy>;
  var_pop?: InputMaybe<TixTicketVTicketCountByTypeVarPopOrderBy>;
  var_samp?: InputMaybe<TixTicketVTicketCountByTypeVarSampOrderBy>;
  variance?: InputMaybe<TixTicketVTicketCountByTypeVarianceOrderBy>;
};

/** aggregate avg on columns */
export type TixTicketVTicketCountByTypeAvgFields = {
  __typename?: 'ticket_v_ticket_count_by_type_avg_fields';
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  ticketsRemaining?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalTickets?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeAvgOrderBy = {
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** Boolean expression to filter rows from the table "ticket.v_ticket_count_by_type". All fields are combined with a logical 'AND'. */
export type TixTicketVTicketCountByTypeBoolExp = {
  _and?: InputMaybe<Array<TixTicketVTicketCountByTypeBoolExp>>;
  _not?: InputMaybe<TixTicketVTicketCountByTypeBoolExp>;
  _or?: InputMaybe<Array<TixTicketVTicketCountByTypeBoolExp>>;
  event?: InputMaybe<TixEventInstanceBoolExp>;
  eventInstanceId?: InputMaybe<TixUuidComparisonExp>;
  name?: InputMaybe<TixStringComparisonExp>;
  parentChildType?: InputMaybe<TixStringComparisonExp>;
  parentTicketConfigId?: InputMaybe<TixUuidComparisonExp>;
  perOrderMax?: InputMaybe<TixSmallintComparisonExp>;
  perOrderMin?: InputMaybe<TixSmallintComparisonExp>;
  section?: InputMaybe<TixStringComparisonExp>;
  ticketConfigId?: InputMaybe<TixUuidComparisonExp>;
  ticketType?: InputMaybe<TixStringComparisonExp>;
  ticketsRemaining?: InputMaybe<TixBigintComparisonExp>;
  ticketsSold?: InputMaybe<TixBigintComparisonExp>;
  totalTickets?: InputMaybe<TixIntComparisonExp>;
};

/** input type for inserting data into table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeInsertInput = {
  event?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parentChildType?: InputMaybe<Scalars['String']>;
  parentTicketConfigId?: InputMaybe<Scalars['uuid']>;
  perOrderMax?: InputMaybe<Scalars['smallint']>;
  perOrderMin?: InputMaybe<Scalars['smallint']>;
  section?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketType?: InputMaybe<Scalars['String']>;
  ticketsRemaining?: InputMaybe<Scalars['bigint']>;
  ticketsSold?: InputMaybe<Scalars['bigint']>;
  totalTickets?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TixTicketVTicketCountByTypeMaxFields = {
  __typename?: 'ticket_v_ticket_count_by_type_max_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentChildType?: Maybe<Scalars['String']>;
  parentTicketConfigId?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  section?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsRemaining?: Maybe<Scalars['bigint']>;
  ticketsSold?: Maybe<Scalars['bigint']>;
  totalTickets?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeMaxOrderBy = {
  eventInstanceId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  parentChildType?: InputMaybe<TixOrderBy>;
  parentTicketConfigId?: InputMaybe<TixOrderBy>;
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixTicketVTicketCountByTypeMinFields = {
  __typename?: 'ticket_v_ticket_count_by_type_min_fields';
  eventInstanceId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentChildType?: Maybe<Scalars['String']>;
  parentTicketConfigId?: Maybe<Scalars['uuid']>;
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  section?: Maybe<Scalars['String']>;
  ticketConfigId?: Maybe<Scalars['uuid']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketsRemaining?: Maybe<Scalars['bigint']>;
  ticketsSold?: Maybe<Scalars['bigint']>;
  totalTickets?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeMinOrderBy = {
  eventInstanceId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  parentChildType?: InputMaybe<TixOrderBy>;
  parentTicketConfigId?: InputMaybe<TixOrderBy>;
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** input type for inserting object relation for remote table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeObjRelInsertInput = {
  data: TixTicketVTicketCountByTypeInsertInput;
};

/** Ordering options when selecting data from "ticket.v_ticket_count_by_type". */
export type TixTicketVTicketCountByTypeOrderBy = {
  event?: InputMaybe<TixEventInstanceOrderBy>;
  eventInstanceId?: InputMaybe<TixOrderBy>;
  name?: InputMaybe<TixOrderBy>;
  parentChildType?: InputMaybe<TixOrderBy>;
  parentTicketConfigId?: InputMaybe<TixOrderBy>;
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  section?: InputMaybe<TixOrderBy>;
  ticketConfigId?: InputMaybe<TixOrderBy>;
  ticketType?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** select columns of table "ticket.v_ticket_count_by_type" */
export enum TixTicketVTicketCountByTypeSelectColumn {
  /** column name */
  EventInstanceId = 'eventInstanceId',
  /** column name */
  Name = 'name',
  /** column name */
  ParentChildType = 'parentChildType',
  /** column name */
  ParentTicketConfigId = 'parentTicketConfigId',
  /** column name */
  PerOrderMax = 'perOrderMax',
  /** column name */
  PerOrderMin = 'perOrderMin',
  /** column name */
  Section = 'section',
  /** column name */
  TicketConfigId = 'ticketConfigId',
  /** column name */
  TicketType = 'ticketType',
  /** column name */
  TicketsRemaining = 'ticketsRemaining',
  /** column name */
  TicketsSold = 'ticketsSold',
  /** column name */
  TotalTickets = 'totalTickets'
}

/** aggregate stddev on columns */
export type TixTicketVTicketCountByTypeStddevFields = {
  __typename?: 'ticket_v_ticket_count_by_type_stddev_fields';
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  ticketsRemaining?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalTickets?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeStddevOrderBy = {
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_pop on columns */
export type TixTicketVTicketCountByTypeStddevPopFields = {
  __typename?: 'ticket_v_ticket_count_by_type_stddev_pop_fields';
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  ticketsRemaining?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalTickets?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeStddevPopOrderBy = {
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** aggregate stddev_samp on columns */
export type TixTicketVTicketCountByTypeStddevSampFields = {
  __typename?: 'ticket_v_ticket_count_by_type_stddev_samp_fields';
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  ticketsRemaining?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalTickets?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeStddevSampOrderBy = {
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** Streaming cursor of the table "ticket_v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketVTicketCountByTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketVTicketCountByTypeStreamCursorValueInput = {
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parentChildType?: InputMaybe<Scalars['String']>;
  parentTicketConfigId?: InputMaybe<Scalars['uuid']>;
  perOrderMax?: InputMaybe<Scalars['smallint']>;
  perOrderMin?: InputMaybe<Scalars['smallint']>;
  section?: InputMaybe<Scalars['String']>;
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  ticketType?: InputMaybe<Scalars['String']>;
  ticketsRemaining?: InputMaybe<Scalars['bigint']>;
  ticketsSold?: InputMaybe<Scalars['bigint']>;
  totalTickets?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TixTicketVTicketCountByTypeSumFields = {
  __typename?: 'ticket_v_ticket_count_by_type_sum_fields';
  perOrderMax?: Maybe<Scalars['smallint']>;
  perOrderMin?: Maybe<Scalars['smallint']>;
  ticketsRemaining?: Maybe<Scalars['bigint']>;
  ticketsSold?: Maybe<Scalars['bigint']>;
  totalTickets?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeSumOrderBy = {
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** aggregate var_pop on columns */
export type TixTicketVTicketCountByTypeVarPopFields = {
  __typename?: 'ticket_v_ticket_count_by_type_var_pop_fields';
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  ticketsRemaining?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalTickets?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeVarPopOrderBy = {
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** aggregate var_samp on columns */
export type TixTicketVTicketCountByTypeVarSampFields = {
  __typename?: 'ticket_v_ticket_count_by_type_var_samp_fields';
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  ticketsRemaining?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalTickets?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeVarSampOrderBy = {
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** aggregate variance on columns */
export type TixTicketVTicketCountByTypeVarianceFields = {
  __typename?: 'ticket_v_ticket_count_by_type_variance_fields';
  perOrderMax?: Maybe<Scalars['Float']>;
  perOrderMin?: Maybe<Scalars['Float']>;
  ticketsRemaining?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  totalTickets?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ticket.v_ticket_count_by_type" */
export type TixTicketVTicketCountByTypeVarianceOrderBy = {
  perOrderMax?: InputMaybe<TixOrderBy>;
  perOrderMin?: InputMaybe<TixOrderBy>;
  ticketsRemaining?: InputMaybe<TixOrderBy>;
  ticketsSold?: InputMaybe<TixOrderBy>;
  totalTickets?: InputMaybe<TixOrderBy>;
};

/** columns and relationships of "ticket.v_ticket_sales_metrics" */
export type TixTicketVTicketSalesMetrics = {
  __typename?: 'ticket_v_ticket_sales_metrics';
  available?: Maybe<Scalars['bigint']>;
  cancelled?: Maybe<Scalars['bigint']>;
  checked_in?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  eventInstance?: Maybe<TixEventInstance>;
  event_instance_id?: Maybe<Scalars['uuid']>;
  not_checked_in?: Maybe<Scalars['bigint']>;
  refunded?: Maybe<Scalars['bigint']>;
  total_seats?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "ticket.v_ticket_sales_metrics" */
export type TixTicketVTicketSalesMetricsAggregate = {
  __typename?: 'ticket_v_ticket_sales_metrics_aggregate';
  aggregate?: Maybe<TixTicketVTicketSalesMetricsAggregateFields>;
  nodes: Array<TixTicketVTicketSalesMetrics>;
};

/** aggregate fields of "ticket.v_ticket_sales_metrics" */
export type TixTicketVTicketSalesMetricsAggregateFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_aggregate_fields';
  avg?: Maybe<TixTicketVTicketSalesMetricsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TixTicketVTicketSalesMetricsMaxFields>;
  min?: Maybe<TixTicketVTicketSalesMetricsMinFields>;
  stddev?: Maybe<TixTicketVTicketSalesMetricsStddevFields>;
  stddev_pop?: Maybe<TixTicketVTicketSalesMetricsStddevPopFields>;
  stddev_samp?: Maybe<TixTicketVTicketSalesMetricsStddevSampFields>;
  sum?: Maybe<TixTicketVTicketSalesMetricsSumFields>;
  var_pop?: Maybe<TixTicketVTicketSalesMetricsVarPopFields>;
  var_samp?: Maybe<TixTicketVTicketSalesMetricsVarSampFields>;
  variance?: Maybe<TixTicketVTicketSalesMetricsVarianceFields>;
};


/** aggregate fields of "ticket.v_ticket_sales_metrics" */
export type TixTicketVTicketSalesMetricsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixTicketVTicketSalesMetricsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TixTicketVTicketSalesMetricsAvgFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_avg_fields';
  available?: Maybe<Scalars['Float']>;
  cancelled?: Maybe<Scalars['Float']>;
  checked_in?: Maybe<Scalars['Float']>;
  not_checked_in?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  total_seats?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticket.v_ticket_sales_metrics". All fields are combined with a logical 'AND'. */
export type TixTicketVTicketSalesMetricsBoolExp = {
  _and?: InputMaybe<Array<TixTicketVTicketSalesMetricsBoolExp>>;
  _not?: InputMaybe<TixTicketVTicketSalesMetricsBoolExp>;
  _or?: InputMaybe<Array<TixTicketVTicketSalesMetricsBoolExp>>;
  available?: InputMaybe<TixBigintComparisonExp>;
  cancelled?: InputMaybe<TixBigintComparisonExp>;
  checked_in?: InputMaybe<TixBigintComparisonExp>;
  eventInstance?: InputMaybe<TixEventInstanceBoolExp>;
  event_instance_id?: InputMaybe<TixUuidComparisonExp>;
  not_checked_in?: InputMaybe<TixBigintComparisonExp>;
  refunded?: InputMaybe<TixBigintComparisonExp>;
  total_seats?: InputMaybe<TixIntComparisonExp>;
};

/** input type for inserting data into table "ticket.v_ticket_sales_metrics" */
export type TixTicketVTicketSalesMetricsInsertInput = {
  available?: InputMaybe<Scalars['bigint']>;
  cancelled?: InputMaybe<Scalars['bigint']>;
  checked_in?: InputMaybe<Scalars['bigint']>;
  eventInstance?: InputMaybe<TixEventInstanceObjRelInsertInput>;
  event_instance_id?: InputMaybe<Scalars['uuid']>;
  not_checked_in?: InputMaybe<Scalars['bigint']>;
  refunded?: InputMaybe<Scalars['bigint']>;
  total_seats?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TixTicketVTicketSalesMetricsMaxFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_max_fields';
  available?: Maybe<Scalars['bigint']>;
  cancelled?: Maybe<Scalars['bigint']>;
  checked_in?: Maybe<Scalars['bigint']>;
  event_instance_id?: Maybe<Scalars['uuid']>;
  not_checked_in?: Maybe<Scalars['bigint']>;
  refunded?: Maybe<Scalars['bigint']>;
  total_seats?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type TixTicketVTicketSalesMetricsMinFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_min_fields';
  available?: Maybe<Scalars['bigint']>;
  cancelled?: Maybe<Scalars['bigint']>;
  checked_in?: Maybe<Scalars['bigint']>;
  event_instance_id?: Maybe<Scalars['uuid']>;
  not_checked_in?: Maybe<Scalars['bigint']>;
  refunded?: Maybe<Scalars['bigint']>;
  total_seats?: Maybe<Scalars['Int']>;
};

/** input type for inserting object relation for remote table "ticket.v_ticket_sales_metrics" */
export type TixTicketVTicketSalesMetricsObjRelInsertInput = {
  data: TixTicketVTicketSalesMetricsInsertInput;
};

/** Ordering options when selecting data from "ticket.v_ticket_sales_metrics". */
export type TixTicketVTicketSalesMetricsOrderBy = {
  available?: InputMaybe<TixOrderBy>;
  cancelled?: InputMaybe<TixOrderBy>;
  checked_in?: InputMaybe<TixOrderBy>;
  eventInstance?: InputMaybe<TixEventInstanceOrderBy>;
  event_instance_id?: InputMaybe<TixOrderBy>;
  not_checked_in?: InputMaybe<TixOrderBy>;
  refunded?: InputMaybe<TixOrderBy>;
  total_seats?: InputMaybe<TixOrderBy>;
};

/** select columns of table "ticket.v_ticket_sales_metrics" */
export enum TixTicketVTicketSalesMetricsSelectColumn {
  /** column name */
  Available = 'available',
  /** column name */
  Cancelled = 'cancelled',
  /** column name */
  CheckedIn = 'checked_in',
  /** column name */
  EventInstanceId = 'event_instance_id',
  /** column name */
  NotCheckedIn = 'not_checked_in',
  /** column name */
  Refunded = 'refunded',
  /** column name */
  TotalSeats = 'total_seats'
}

/** aggregate stddev on columns */
export type TixTicketVTicketSalesMetricsStddevFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_stddev_fields';
  available?: Maybe<Scalars['Float']>;
  cancelled?: Maybe<Scalars['Float']>;
  checked_in?: Maybe<Scalars['Float']>;
  not_checked_in?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  total_seats?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TixTicketVTicketSalesMetricsStddevPopFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_stddev_pop_fields';
  available?: Maybe<Scalars['Float']>;
  cancelled?: Maybe<Scalars['Float']>;
  checked_in?: Maybe<Scalars['Float']>;
  not_checked_in?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  total_seats?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TixTicketVTicketSalesMetricsStddevSampFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_stddev_samp_fields';
  available?: Maybe<Scalars['Float']>;
  cancelled?: Maybe<Scalars['Float']>;
  checked_in?: Maybe<Scalars['Float']>;
  not_checked_in?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  total_seats?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticket_v_ticket_sales_metrics" */
export type TixTicketVTicketSalesMetricsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixTicketVTicketSalesMetricsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixTicketVTicketSalesMetricsStreamCursorValueInput = {
  available?: InputMaybe<Scalars['bigint']>;
  cancelled?: InputMaybe<Scalars['bigint']>;
  checked_in?: InputMaybe<Scalars['bigint']>;
  event_instance_id?: InputMaybe<Scalars['uuid']>;
  not_checked_in?: InputMaybe<Scalars['bigint']>;
  refunded?: InputMaybe<Scalars['bigint']>;
  total_seats?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TixTicketVTicketSalesMetricsSumFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_sum_fields';
  available?: Maybe<Scalars['bigint']>;
  cancelled?: Maybe<Scalars['bigint']>;
  checked_in?: Maybe<Scalars['bigint']>;
  not_checked_in?: Maybe<Scalars['bigint']>;
  refunded?: Maybe<Scalars['bigint']>;
  total_seats?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type TixTicketVTicketSalesMetricsVarPopFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_var_pop_fields';
  available?: Maybe<Scalars['Float']>;
  cancelled?: Maybe<Scalars['Float']>;
  checked_in?: Maybe<Scalars['Float']>;
  not_checked_in?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  total_seats?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TixTicketVTicketSalesMetricsVarSampFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_var_samp_fields';
  available?: Maybe<Scalars['Float']>;
  cancelled?: Maybe<Scalars['Float']>;
  checked_in?: Maybe<Scalars['Float']>;
  not_checked_in?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  total_seats?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TixTicketVTicketSalesMetricsVarianceFields = {
  __typename?: 'ticket_v_ticket_sales_metrics_variance_fields';
  available?: Maybe<Scalars['Float']>;
  cancelled?: Maybe<Scalars['Float']>;
  checked_in?: Maybe<Scalars['Float']>;
  not_checked_in?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  total_seats?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type TixTimeComparisonExp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TixTimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TixTimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type TixTimetzComparisonExp = {
  _eq?: InputMaybe<Scalars['timetz']>;
  _gt?: InputMaybe<Scalars['timetz']>;
  _gte?: InputMaybe<Scalars['timetz']>;
  _in?: InputMaybe<Array<Scalars['timetz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timetz']>;
  _lte?: InputMaybe<Scalars['timetz']>;
  _neq?: InputMaybe<Scalars['timetz']>;
  _nin?: InputMaybe<Array<Scalars['timetz']>>;
};

/** columns and relationships of "utility.policy" */
export type TixUtilityPolicy = {
  __typename?: 'utility_policy';
  /** An object relationship */
  company?: Maybe<TixCompany>;
  companyId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  policyId: Scalars['uuid'];
  policyText: Scalars['String'];
  /** Look up value from Business Code table */
  policyType?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  venue?: Maybe<TixVenue>;
  venueId: Scalars['uuid'];
};

/** aggregated selection of "utility.policy" */
export type TixUtilityPolicyAggregate = {
  __typename?: 'utility_policy_aggregate';
  aggregate?: Maybe<TixUtilityPolicyAggregateFields>;
  nodes: Array<TixUtilityPolicy>;
};

export type TixUtilityPolicyAggregateBoolExp = {
  count?: InputMaybe<TixUtilityPolicyAggregateBoolExpCount>;
};

export type TixUtilityPolicyAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TixUtilityPolicyBoolExp>;
  predicate: TixIntComparisonExp;
};

/** aggregate fields of "utility.policy" */
export type TixUtilityPolicyAggregateFields = {
  __typename?: 'utility_policy_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixUtilityPolicyMaxFields>;
  min?: Maybe<TixUtilityPolicyMinFields>;
};


/** aggregate fields of "utility.policy" */
export type TixUtilityPolicyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixUtilityPolicySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "utility.policy" */
export type TixUtilityPolicyAggregateOrderBy = {
  count?: InputMaybe<TixOrderBy>;
  max?: InputMaybe<TixUtilityPolicyMaxOrderBy>;
  min?: InputMaybe<TixUtilityPolicyMinOrderBy>;
};

/** input type for inserting array relation for remote table "utility.policy" */
export type TixUtilityPolicyArrRelInsertInput = {
  data: Array<TixUtilityPolicyInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TixUtilityPolicyOnConflict>;
};

/** Boolean expression to filter rows from the table "utility.policy". All fields are combined with a logical 'AND'. */
export type TixUtilityPolicyBoolExp = {
  _and?: InputMaybe<Array<TixUtilityPolicyBoolExp>>;
  _not?: InputMaybe<TixUtilityPolicyBoolExp>;
  _or?: InputMaybe<Array<TixUtilityPolicyBoolExp>>;
  company?: InputMaybe<TixCompanyBoolExp>;
  companyId?: InputMaybe<TixUuidComparisonExp>;
  createdAt?: InputMaybe<TixTimestamptzComparisonExp>;
  createdBy?: InputMaybe<TixUuidComparisonExp>;
  policyId?: InputMaybe<TixUuidComparisonExp>;
  policyText?: InputMaybe<TixStringComparisonExp>;
  policyType?: InputMaybe<TixStringComparisonExp>;
  state?: InputMaybe<TixStringComparisonExp>;
  updatedAt?: InputMaybe<TixTimestamptzComparisonExp>;
  updatedBy?: InputMaybe<TixUuidComparisonExp>;
  venue?: InputMaybe<TixVenueBoolExp>;
  venueId?: InputMaybe<TixUuidComparisonExp>;
};

/** unique or primary key constraints on table "utility.policy" */
export enum TixUtilityPolicyConstraint {
  /** unique or primary key constraint on columns "policy_id" */
  PolicyPkey = 'policy_pkey'
}

/** input type for inserting data into table "utility.policy" */
export type TixUtilityPolicyInsertInput = {
  company?: InputMaybe<TixCompanyObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  policyId?: InputMaybe<Scalars['uuid']>;
  policyText?: InputMaybe<Scalars['String']>;
  /** Look up value from Business Code table */
  policyType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venue?: InputMaybe<TixVenueObjRelInsertInput>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TixUtilityPolicyMaxFields = {
  __typename?: 'utility_policy_max_fields';
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  policyId?: Maybe<Scalars['uuid']>;
  policyText?: Maybe<Scalars['String']>;
  /** Look up value from Business Code table */
  policyType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "utility.policy" */
export type TixUtilityPolicyMaxOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  policyId?: InputMaybe<TixOrderBy>;
  policyText?: InputMaybe<TixOrderBy>;
  /** Look up value from Business Code table */
  policyType?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** aggregate min on columns */
export type TixUtilityPolicyMinFields = {
  __typename?: 'utility_policy_min_fields';
  companyId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  policyId?: Maybe<Scalars['uuid']>;
  policyText?: Maybe<Scalars['String']>;
  /** Look up value from Business Code table */
  policyType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  venueId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "utility.policy" */
export type TixUtilityPolicyMinOrderBy = {
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  policyId?: InputMaybe<TixOrderBy>;
  policyText?: InputMaybe<TixOrderBy>;
  /** Look up value from Business Code table */
  policyType?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** response of any mutation on the table "utility.policy" */
export type TixUtilityPolicyMutationResponse = {
  __typename?: 'utility_policy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TixUtilityPolicy>;
};

/** on_conflict condition type for table "utility.policy" */
export type TixUtilityPolicyOnConflict = {
  constraint: TixUtilityPolicyConstraint;
  update_columns?: Array<TixUtilityPolicyUpdateColumn>;
  where?: InputMaybe<TixUtilityPolicyBoolExp>;
};

/** Ordering options when selecting data from "utility.policy". */
export type TixUtilityPolicyOrderBy = {
  company?: InputMaybe<TixCompanyOrderBy>;
  companyId?: InputMaybe<TixOrderBy>;
  createdAt?: InputMaybe<TixOrderBy>;
  createdBy?: InputMaybe<TixOrderBy>;
  policyId?: InputMaybe<TixOrderBy>;
  policyText?: InputMaybe<TixOrderBy>;
  policyType?: InputMaybe<TixOrderBy>;
  state?: InputMaybe<TixOrderBy>;
  updatedAt?: InputMaybe<TixOrderBy>;
  updatedBy?: InputMaybe<TixOrderBy>;
  venue?: InputMaybe<TixVenueOrderBy>;
  venueId?: InputMaybe<TixOrderBy>;
};

/** primary key columns input for table: utility.policy */
export type TixUtilityPolicyPkColumnsInput = {
  policyId: Scalars['uuid'];
};

/** select columns of table "utility.policy" */
export enum TixUtilityPolicySelectColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  PolicyId = 'policyId',
  /** column name */
  PolicyText = 'policyText',
  /** column name */
  PolicyType = 'policyType',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId'
}

/** input type for updating data in table "utility.policy" */
export type TixUtilityPolicySetInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  policyId?: InputMaybe<Scalars['uuid']>;
  policyText?: InputMaybe<Scalars['String']>;
  /** Look up value from Business Code table */
  policyType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "utility_policy" */
export type TixUtilityPolicyStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixUtilityPolicyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixUtilityPolicyStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  policyId?: InputMaybe<Scalars['uuid']>;
  policyText?: InputMaybe<Scalars['String']>;
  /** Look up value from Business Code table */
  policyType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "utility.policy" */
export enum TixUtilityPolicyUpdateColumn {
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  PolicyId = 'policyId',
  /** column name */
  PolicyText = 'policyText',
  /** column name */
  PolicyType = 'policyType',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  VenueId = 'venueId'
}

export type TixUtilityPolicyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TixUtilityPolicySetInput>;
  /** filter the rows which have to be updated */
  where: TixUtilityPolicyBoolExp;
};

/** columns and relationships of "utility.timestamp_by_timezone" */
export type TixUtilityTimestampByTimezone = {
  __typename?: 'utility_timestamp_by_timezone';
  abbreviation?: Maybe<Scalars['String']>;
  current_date_in_timezone?: Maybe<Scalars['date']>;
  current_date_time_in_timezone?: Maybe<Scalars['timestamp']>;
  current_time_in_timezone?: Maybe<Scalars['time']>;
  timezone?: Maybe<Scalars['String']>;
};

/** aggregated selection of "utility.timestamp_by_timezone" */
export type TixUtilityTimestampByTimezoneAggregate = {
  __typename?: 'utility_timestamp_by_timezone_aggregate';
  aggregate?: Maybe<TixUtilityTimestampByTimezoneAggregateFields>;
  nodes: Array<TixUtilityTimestampByTimezone>;
};

/** aggregate fields of "utility.timestamp_by_timezone" */
export type TixUtilityTimestampByTimezoneAggregateFields = {
  __typename?: 'utility_timestamp_by_timezone_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TixUtilityTimestampByTimezoneMaxFields>;
  min?: Maybe<TixUtilityTimestampByTimezoneMinFields>;
};


/** aggregate fields of "utility.timestamp_by_timezone" */
export type TixUtilityTimestampByTimezoneAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TixUtilityTimestampByTimezoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "utility.timestamp_by_timezone". All fields are combined with a logical 'AND'. */
export type TixUtilityTimestampByTimezoneBoolExp = {
  _and?: InputMaybe<Array<TixUtilityTimestampByTimezoneBoolExp>>;
  _not?: InputMaybe<TixUtilityTimestampByTimezoneBoolExp>;
  _or?: InputMaybe<Array<TixUtilityTimestampByTimezoneBoolExp>>;
  abbreviation?: InputMaybe<TixStringComparisonExp>;
  current_date_in_timezone?: InputMaybe<TixDateComparisonExp>;
  current_date_time_in_timezone?: InputMaybe<TixTimestampComparisonExp>;
  current_time_in_timezone?: InputMaybe<TixTimeComparisonExp>;
  timezone?: InputMaybe<TixStringComparisonExp>;
};

/** aggregate max on columns */
export type TixUtilityTimestampByTimezoneMaxFields = {
  __typename?: 'utility_timestamp_by_timezone_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  current_date_in_timezone?: Maybe<Scalars['date']>;
  current_date_time_in_timezone?: Maybe<Scalars['timestamp']>;
  timezone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type TixUtilityTimestampByTimezoneMinFields = {
  __typename?: 'utility_timestamp_by_timezone_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  current_date_in_timezone?: Maybe<Scalars['date']>;
  current_date_time_in_timezone?: Maybe<Scalars['timestamp']>;
  timezone?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "utility.timestamp_by_timezone". */
export type TixUtilityTimestampByTimezoneOrderBy = {
  abbreviation?: InputMaybe<TixOrderBy>;
  current_date_in_timezone?: InputMaybe<TixOrderBy>;
  current_date_time_in_timezone?: InputMaybe<TixOrderBy>;
  current_time_in_timezone?: InputMaybe<TixOrderBy>;
  timezone?: InputMaybe<TixOrderBy>;
};

/** select columns of table "utility.timestamp_by_timezone" */
export enum TixUtilityTimestampByTimezoneSelectColumn {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CurrentDateInTimezone = 'current_date_in_timezone',
  /** column name */
  CurrentDateTimeInTimezone = 'current_date_time_in_timezone',
  /** column name */
  CurrentTimeInTimezone = 'current_time_in_timezone',
  /** column name */
  Timezone = 'timezone'
}

/** Streaming cursor of the table "utility_timestamp_by_timezone" */
export type TixUtilityTimestampByTimezoneStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TixUtilityTimestampByTimezoneStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TixCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TixUtilityTimestampByTimezoneStreamCursorValueInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  current_date_in_timezone?: InputMaybe<Scalars['date']>;
  current_date_time_in_timezone?: InputMaybe<Scalars['timestamp']>;
  current_time_in_timezone?: InputMaybe<Scalars['time']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type TixUuidArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['uuid']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['uuid']>>;
  _eq?: InputMaybe<Array<Scalars['uuid']>>;
  _gt?: InputMaybe<Array<Scalars['uuid']>>;
  _gte?: InputMaybe<Array<Scalars['uuid']>>;
  _in?: InputMaybe<Array<Array<Scalars['uuid']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['uuid']>>;
  _lte?: InputMaybe<Array<Scalars['uuid']>>;
  _neq?: InputMaybe<Array<Scalars['uuid']>>;
  _nin?: InputMaybe<Array<Array<Scalars['uuid']>>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type TixUuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type TixCreateRedirectCodeMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type TixCreateRedirectCodeMutation = { __typename?: 'mutation_root', createRedirectCode: string };

export type TixExchangeRedirectCodeForTokenMutationVariables = Exact<{
  redirectCode: Scalars['String'];
}>;


export type TixExchangeRedirectCodeForTokenMutation = { __typename?: 'mutation_root', exchangeRedirectCodeForToken: string };

export type TixGetBusinessCodesByGroupNameQueryVariables = Exact<{
  codegroup?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TixOrderBy>;
}>;


export type TixGetBusinessCodesByGroupNameQuery = { __typename?: 'query_root', BusinessCodeGroup: Array<{ __typename?: 'BusinessCodeGroup', name: string, description?: string | null | undefined, busCodeGroupId: any, businessCodes: Array<{ __typename?: 'BusinessCodes', businessCodeId: any, name: string, description?: string | null | undefined }> }> };

export type TixCreatePaymentMutationVariables = Exact<{
  amount: Scalars['Float'];
  mode?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
}>;


export type TixCreatePaymentMutation = { __typename?: 'mutation_root', createPayment?: any | null | undefined };

export type TixCreatePayoutDetailMutationVariables = Exact<{
  reservationId: Scalars['uuid'];
  payoutId: Scalars['uuid'];
  createdBy?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
}>;


export type TixCreatePayoutDetailMutation = { __typename?: 'mutation_root', InsertPayoutDetail?: { __typename?: 'PayoutDetail_mutation_response', affected_rows: number } | null | undefined };

export type TixCreatePayoutMutationVariables = Exact<{
  companyId: Scalars['uuid'];
  venueId: Scalars['uuid'];
  eventInstanceId: Scalars['uuid'];
  createdAt?: Scalars['timestamptz'];
  updatedAt?: Scalars['timestamptz'];
  updatedBy: Scalars['uuid'];
  createdBy: Scalars['uuid'];
  description: Scalars['String'];
}>;


export type TixCreatePayoutMutation = { __typename?: 'mutation_root', InsertPayout?: { __typename?: 'Payout_mutation_response', affected_rows: number } | null | undefined };

export type TixGetPayoutByEventInstanceIdQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetPayoutByEventInstanceIdQuery = { __typename?: 'query_root', Payout: Array<{ __typename?: 'Payout', payoutId: any }> };

export type TixGetReservationByContactIdQueryVariables = Exact<{
  contactId?: InputMaybe<Scalars['uuid']>;
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetReservationByContactIdQuery = { __typename?: 'query_root', Reservation: Array<{ __typename?: 'ticket_reservation', tickets: Array<{ __typename?: 'Ticket', ticketType?: string | null | undefined }> }> };

export type TixGetReservationByIdQueryVariables = Exact<{
  reservationId: Scalars['uuid'];
}>;


export type TixGetReservationByIdQuery = { __typename?: 'query_root', Reservation: Array<{ __typename?: 'ticket_reservation', reservationId: any, contactId?: any | null | undefined }> };

export type TixGetReservationDetailsByIdQueryVariables = Exact<{
  reservationId: Scalars['uuid'];
}>;


export type TixGetReservationDetailsByIdQuery = { __typename?: 'query_root', Reservation: Array<{ __typename?: 'ticket_reservation', reservationId: any, contactId?: any | null | undefined, reservation_detail: Array<{ __typename?: 'TicketReservationDetail', eventInstanceId: any, comment?: string | null | undefined, amount?: any | null | undefined, reservationId: any, createdBy?: any | null | undefined, contactId: any, type?: string | null | undefined }> }> };

export type TixGetReservationOrderDetailsQueryVariables = Exact<{
  reservationId: Scalars['uuid'];
}>;


export type TixGetReservationOrderDetailsQuery = { __typename?: 'query_root', Reservation: Array<{ __typename?: 'ticket_reservation', product_order?: { __typename?: 'Order', order_detail: Array<{ __typename?: 'product_order_detail', type?: string | null | undefined, state?: string | null | undefined }> } | null | undefined }> };

export type TixGetTotalNumberTicketsSoldForEventQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetTotalNumberTicketsSoldForEventQuery = { __typename?: 'query_root', TicketAggregate: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } };

export type TixGetVenueByPrimaryKeyQueryVariables = Exact<{
  venueId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetVenueByPrimaryKeyQuery = { __typename?: 'query_root', VenueByPK?: { __typename?: 'Venue', venueId: any, name: string, description?: string | null | undefined, additionalInfo?: string | null | undefined, state: string, url?: string | null | undefined, addresses: Array<{ __typename?: 'VenueAddress', address?: { __typename?: 'Address', streetAddress?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', mediaFile?: { __typename?: 'MediaFile', fileType?: string | null | undefined, location: string } | null | undefined }>, phoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, sameAsCompany?: boolean | null | undefined, type?: string | null | undefined } | null | undefined }>, company?: { __typename?: 'Company', name: string, addresses: Array<{ __typename?: 'CompanyAddress', address?: { __typename?: 'Address', streetAddress?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined } | null | undefined }>, phoneNumbers: Array<{ __typename?: 'CompanyPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, type?: string | null | undefined } | null | undefined }>, mediaFiles: Array<{ __typename?: 'CompanyMediaFile', mediaFile: { __typename?: 'MediaFile', fileType?: string | null | undefined, location: string } }>, warnings: Array<{ __typename?: 'CompanyWarning', warning: { __typename?: 'Warning', message: string, type: string } }> } | null | undefined, warnings: Array<{ __typename?: 'VenueWarning', warning: { __typename?: 'Warning', message: string, type: string } }>, configurationValues: Array<{ __typename?: 'VenueConfigurationValue', Value?: { __typename?: 'ConfigurationValue', configurationItemId: any, value: string, configurationValueId: any, Item?: { __typename?: 'ConfigurationItem', placeholder?: string | null | undefined, helpText?: string | null | undefined, description?: string | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type TixTicketReservationDetailInsertMutationVariables = Exact<{
  objects: Array<TixTicketReservationDetailInsertInput> | TixTicketReservationDetailInsertInput;
}>;


export type TixTicketReservationDetailInsertMutation = { __typename?: 'mutation_root', TicketReservationDetailInsert?: { __typename?: 'TicketReservationDetail_mutation_response', returning: Array<{ __typename?: 'TicketReservationDetail', amount?: any | null | undefined }> } | null | undefined };

export type TixInsertPaymentReservationTicketMutationVariables = Exact<{
  insertPayment?: InputMaybe<Array<TixPaymentInsertInput> | TixPaymentInsertInput>;
}>;


export type TixInsertPaymentReservationTicketMutation = { __typename?: 'mutation_root', InsertPayment?: { __typename?: 'Payment_mutation_response', returning: Array<{ __typename?: 'Payment', paymentId: any, cardToken?: string | null | undefined, paymentToken?: string | null | undefined, paymentProvider: string, totalAmount: any, paymentResponse?: string | null | undefined, state: string, updatedBy: any, createdBy?: any | null | undefined, updatedAt: any, Contact?: { __typename?: 'Contact', emailAddress: string, firstName: string, lastName: string, dob?: any | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined } | null | undefined }> } | null | undefined, Reservation?: { __typename?: 'ReservationPayment', reservation?: { __typename?: 'ticket_reservation', reservationId: any, eventInstanceId?: any | null | undefined, contactId?: any | null | undefined, additionalComments?: string | null | undefined, groupCode?: string | null | undefined, discountAmount?: any | null | undefined, isGroup?: boolean | null | undefined, reservationDate?: any | null | undefined, reservationStatus?: string | null | undefined, state?: string | null | undefined, updatedBy?: any | null | undefined, updatedAt?: any | null | undefined, reservation_detail: Array<{ __typename?: 'TicketReservationDetail', eventInstanceId: any, comment?: string | null | undefined, amount?: any | null | undefined, reservationId: any, createdBy?: any | null | undefined, contactId: any, type?: string | null | undefined }>, discount?: { __typename?: 'Discount', appliedTo?: string | null | undefined, getAmount?: any | null | undefined } | null | undefined, contact?: { __typename?: 'Contact', customer?: { __typename?: 'Customer', customerId: any } | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'Ticket', ticketId: any, eventInstanceId?: any | null | undefined, reservationId?: any | null | undefined, ticketConfigId?: any | null | undefined, contactId?: any | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketPrice?: any | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, state?: string | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined }> } | null | undefined } | null | undefined }> } | null | undefined };

export type TixRefundDonationsMutationVariables = Exact<{
  updatedBy: Scalars['String'];
  mode: Scalars['String'];
  reservationId: Scalars['String'];
}>;


export type TixRefundDonationsMutation = { __typename?: 'mutation_root', refundDonations?: any | null | undefined };

export type TixRefundReservationMutationVariables = Exact<{
  reservationId: Scalars['String'];
  mode: Scalars['String'];
  updatedBy: Scalars['String'];
}>;


export type TixRefundReservationMutation = { __typename?: 'mutation_root', refundReservation?: any | null | undefined };

export type TixRefundTicketMutationVariables = Exact<{
  mode: Scalars['String'];
  ticketId: Scalars['String'];
  updatedBy: Scalars['String'];
}>;


export type TixRefundTicketMutation = { __typename?: 'mutation_root', refundTicket?: any | null | undefined };

export type TixSendETicketMutationVariables = Exact<{
  data: TixSendETicketInput;
}>;


export type TixSendETicketMutation = { __typename?: 'mutation_root', sendEticket?: boolean | null | undefined };

export type TixSendTicketPurchaseEmailMutationVariables = Exact<{
  data: TixSendTicketEmailNotificaionInput;
}>;


export type TixSendTicketPurchaseEmailMutation = { __typename?: 'mutation_root', sendTicketPurchaseEmail?: boolean | null | undefined };

export type TixUpdatePaymentIntentMetadataMutationVariables = Exact<{
  metadataJson: Scalars['String'];
  paymentIntentId: Scalars['String'];
  mode: Scalars['String'];
}>;


export type TixUpdatePaymentIntentMetadataMutation = { __typename?: 'mutation_root', updatePaymentIntentMetadata: boolean };

export type TixUpdatePaymentMutationVariables = Exact<{
  paymentObject?: InputMaybe<TixPaymentSetInput>;
  reservationId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixUpdatePaymentMutation = { __typename?: 'mutation_root', UpdatePayment?: { __typename?: 'Payment_mutation_response', returning: Array<{ __typename?: 'Payment', createdBy?: any | null | undefined }> } | null | undefined };

export type TixDeleteCompanyEmailMutationVariables = Exact<{
  companyId: Scalars['uuid'];
}>;


export type TixDeleteCompanyEmailMutation = { __typename?: 'mutation_root', delete_communications_company_email?: { __typename?: 'communications_company_email_mutation_response', returning: Array<{ __typename?: 'communications_company_email', companyEmailId?: any | null | undefined, emailContentId?: any | null | undefined }> } | null | undefined };

export type TixDeleteEmailTemplateByIdMutationVariables = Exact<{
  emailContentId: Scalars['uuid'];
}>;


export type TixDeleteEmailTemplateByIdMutation = { __typename?: 'mutation_root', delete_EmailContent?: { __typename?: 'EmailContent_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteEventEmailMutationVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixDeleteEventEmailMutation = { __typename?: 'mutation_root', delete_EventEmail?: { __typename?: 'EventEmail_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteVenueEmailMutationVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type TixDeleteVenueEmailMutation = { __typename?: 'mutation_root', delete_communications_venue_email?: { __typename?: 'communications_venue_email_mutation_response', returning: Array<{ __typename?: 'communications_venue_email', createdBy?: any | null | undefined, state?: string | null | undefined }> } | null | undefined };

export type TixGetAllEmailVariablesQueryVariables = Exact<{ [key: string]: never; }>;


export type TixGetAllEmailVariablesQuery = { __typename?: 'query_root', communications_email_variable: Array<{ __typename?: 'communications_email_variable', name?: string | null | undefined }> };

export type TixGetCompaniesOfTemplatesByIdQueryVariables = Exact<{
  emailContentId: Scalars['uuid'];
}>;


export type TixGetCompaniesOfTemplatesByIdQuery = { __typename?: 'query_root', communications_company_email: Array<{ __typename?: 'communications_company_email', companyId?: any | null | undefined, emailContentId?: any | null | undefined }> };

export type TixGetCompanyEmailQueryVariables = Exact<{
  companyId: Scalars['uuid'];
}>;


export type TixGetCompanyEmailQuery = { __typename?: 'query_root', communications_company_email: Array<{ __typename?: 'communications_company_email', emailContentId?: any | null | undefined, companyId?: any | null | undefined, companyEmailId?: any | null | undefined }> };

export type TixEventEmailSelectQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixEventEmailSelectQuery = { __typename?: 'query_root', EventEmailSelect: Array<{ __typename?: 'EventEmail', emailContentId?: any | null | undefined, eventEmailId?: any | null | undefined, eventInstanceId?: any | null | undefined }> };

export type TixGetEmailTemplateByidQueryVariables = Exact<{
  emailContentId: Scalars['uuid'];
}>;


export type TixGetEmailTemplateByidQuery = { __typename?: 'query_root', EmailContentSelect: Array<{ __typename?: 'EmailContent', emailContentId: any, companyId?: any | null | undefined, name?: string | null | undefined, body?: string | null | undefined, sender?: string | null | undefined, state?: string | null | undefined, format?: string | null | undefined, subject?: string | null | undefined, type?: string | null | undefined, createdAt?: any | null | undefined }> };

export type TixGetEmailTemplateOfEventQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetEmailTemplateOfEventQuery = { __typename?: 'query_root', EventEmailSelect: Array<{ __typename?: 'EventEmail', emailContentId?: any | null | undefined, EventEmailContent?: { __typename?: 'EmailContent', emailContentId: any, type?: string | null | undefined } | null | undefined }> };

export type TixGetEmailTemplateByCompanyidQueryVariables = Exact<{
  companyId: Scalars['uuid'];
  type?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  nameOrSubject?: InputMaybe<Scalars['String']>;
}>;


export type TixGetEmailTemplateByCompanyidQuery = { __typename?: 'query_root', EmailContentSelect: Array<{ __typename?: 'EmailContent', emailContentId: any, companyId?: any | null | undefined, name?: string | null | undefined, format?: string | null | undefined, subject?: string | null | undefined, body?: string | null | undefined, state?: string | null | undefined, type?: string | null | undefined, createdAt?: any | null | undefined }> };

export type TixGetEventsOfTemplateByIdQueryVariables = Exact<{
  templateId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetEventsOfTemplateByIdQuery = { __typename?: 'query_root', EventEmailSelect: Array<{ __typename?: 'EventEmail', emailContentId?: any | null | undefined, eventEmailId?: any | null | undefined, EventEmailContent?: { __typename?: 'EmailContent', emailContentId: any } | null | undefined }> };

export type TixGetVenueEmailQueryVariables = Exact<{
  venueId?: Scalars['uuid'];
}>;


export type TixGetVenueEmailQuery = { __typename?: 'query_root', communications_venue_email: Array<{ __typename?: 'communications_venue_email', emailContentId?: any | null | undefined, venueEmailId?: any | null | undefined, venueId?: any | null | undefined }> };

export type TixGetVenuesOfTemplatesByIdQueryVariables = Exact<{
  emailContentId: Scalars['uuid'];
}>;


export type TixGetVenuesOfTemplatesByIdQuery = { __typename?: 'query_root', communications_venue_email: Array<{ __typename?: 'communications_venue_email', emailContentId?: any | null | undefined, venueEmailId?: any | null | undefined, venueId?: any | null | undefined }> };

export type TixInsertCompanyEmailMutationVariables = Exact<{
  objects: Array<TixCommunicationsCompanyEmailInsertInput> | TixCommunicationsCompanyEmailInsertInput;
}>;


export type TixInsertCompanyEmailMutation = { __typename?: 'mutation_root', insert_communications_company_email?: { __typename?: 'communications_company_email_mutation_response', returning: Array<{ __typename?: 'communications_company_email', companyId?: any | null | undefined, emailContentId?: any | null | undefined }> } | null | undefined };

export type TixInsertEmailTemplateMutationVariables = Exact<{
  companyId: Scalars['uuid'];
  body?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  formattedBody?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixInsertEmailTemplateMutation = { __typename?: 'mutation_root', EmailContentInsertOne?: { __typename?: 'EmailContent', createdAt?: any | null | undefined, companyId?: any | null | undefined, format?: string | null | undefined, type?: string | null | undefined, name?: string | null | undefined, state?: string | null | undefined, sender?: string | null | undefined, subject?: string | null | undefined } | null | undefined };

export type TixInsertEmailTemplatesOfEventMutationVariables = Exact<{
  objects: Array<TixEventEmailInsertInput> | TixEventEmailInsertInput;
}>;


export type TixInsertEmailTemplatesOfEventMutation = { __typename?: 'mutation_root', EventEmailInsert?: { __typename?: 'EventEmail_mutation_response', returning: Array<{ __typename?: 'EventEmail', eventInstanceId?: any | null | undefined, emailContentId?: any | null | undefined }> } | null | undefined };

export type TixInsertVenueEmailMutationVariables = Exact<{
  objects: Array<TixCommunicationsVenueEmailInsertInput> | TixCommunicationsVenueEmailInsertInput;
}>;


export type TixInsertVenueEmailMutation = { __typename?: 'mutation_root', insert_communications_venue_email?: { __typename?: 'communications_venue_email_mutation_response', returning: Array<{ __typename?: 'communications_venue_email', emailContentId?: any | null | undefined, venueId?: any | null | undefined }> } | null | undefined };

export type TixUpdateEmailTemplateByIdMutationVariables = Exact<{
  emailContentId?: Scalars['uuid'];
  type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  formattedBody?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixUpdateEmailTemplateByIdMutation = { __typename?: 'mutation_root', EmailContentUpdate?: { __typename?: 'EmailContent_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'EmailContent', type?: string | null | undefined, name?: string | null | undefined, body?: string | null | undefined }> } | null | undefined };

export type TixEventEmailUpdateMutationVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
  emailContentId: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixEventEmailUpdateMutation = { __typename?: 'mutation_root', EventEmailUpdate?: { __typename?: 'EventEmail_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'EventEmail', emailContentId?: any | null | undefined }> } | null | undefined };

export type TixDeleteCompanyMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixDeleteCompanyMutation = { __typename?: 'mutation_root', DeleteCompany?: { __typename?: 'Company_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteCompanyMediaFileByMediaFilePkMutationVariables = Exact<{
  mediaFileId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteCompanyMediaFileByMediaFilePkMutation = { __typename?: 'mutation_root', DeleteCompanyMediaFile?: { __typename?: 'CompanyMediaFile_mutation_response', returning: Array<{ __typename?: 'CompanyMediaFile', companyId: any, companyImageFileId: any }> } | null | undefined, DeleteMediaFileByPK?: { __typename?: 'MediaFile', companyMediaFile: Array<{ __typename?: 'CompanyMediaFile', companyId: any, companyImageFileId: any }> } | null | undefined };

export type TixDeleteCompanyPhoneNumberByPhoneNumberPkMutationVariables = Exact<{
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteCompanyPhoneNumberByPhoneNumberPkMutation = { __typename?: 'mutation_root', DeleteCompanyPhoneNumber?: { __typename?: 'CompanyPhoneNumber_mutation_response', returning: Array<{ __typename?: 'CompanyPhoneNumber', companyId: any, companyPhoneNumberId: any }> } | null | undefined, DeletePhoneNumberByPK?: { __typename?: 'PhoneNumber', companyPhoneNumbers: Array<{ __typename?: 'CompanyPhoneNumber', companyId: any, companyPhoneNumberId: any }> } | null | undefined };

export type TixDeleteCompanySocialMediaBySocialMediaPkMutationVariables = Exact<{
  socialMediaId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteCompanySocialMediaBySocialMediaPkMutation = { __typename?: 'mutation_root', DeleteCompanySocialMedia?: { __typename?: 'CompanySocialMedia_mutation_response', returning: Array<{ __typename?: 'CompanySocialMedia', companyId: any, companySocialMediaId: any }> } | null | undefined, DeleteSocialMediaByPK?: { __typename?: 'SocialMedia', companySocialMedia: Array<{ __typename?: 'CompanySocialMedia', companyId: any, companySocialMediaId: any }> } | null | undefined };

export type TixDeleteCompanyWarningByWarningPkMutationVariables = Exact<{
  warningId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteCompanyWarningByWarningPkMutation = { __typename?: 'mutation_root', DeleteCompanyWarning?: { __typename?: 'CompanyWarning_mutation_response', returning: Array<{ __typename?: 'CompanyWarning', companyId: any, companyWarningId: any }> } | null | undefined, DeleteWarningByPK?: { __typename?: 'Warning', company_warning: Array<{ __typename?: 'CompanyWarning', companyId: any, companyWarningId: any }> } | null | undefined };

export type TixGetAllCompaniesQueryVariables = Exact<{
  phoneNumberType?: InputMaybe<Scalars['String']>;
  companyMediaFileType?: InputMaybe<Scalars['String']>;
}>;


export type TixGetAllCompaniesQuery = { __typename?: 'query_root', Company: Array<{ __typename?: 'Company', companyId: any, name: string, url?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'CompanyPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'CompanyAddress', address?: { __typename?: 'Address', streetAddress?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined } | null | undefined }>, venues_aggregate: { __typename?: 'Venue_aggregate', aggregate?: { __typename?: 'Venue_aggregate_fields', count: number } | null | undefined }, mediaFiles: Array<{ __typename?: 'CompanyMediaFile', mediaFile: { __typename?: 'MediaFile', name: string, location: string, fileType?: string | null | undefined } }>, contacts_aggregate: { __typename?: 'CompanyContact_aggregate', aggregate?: { __typename?: 'CompanyContact_aggregate_fields', count: number } | null | undefined } }> };

export type TixGetCompaniesByCompanyIdsQueryVariables = Exact<{
  phoneNumberType?: InputMaybe<Scalars['String']>;
  companyMediaFileType?: InputMaybe<Scalars['String']>;
  companyIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixGetCompaniesByCompanyIdsQuery = { __typename?: 'query_root', Company: Array<{ __typename?: 'Company', companyId: any, name: string, url?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'CompanyPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, type?: string | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'CompanyAddress', address?: { __typename?: 'Address', streetAddress?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, state: string } | null | undefined }>, mediaFiles: Array<{ __typename?: 'CompanyMediaFile', mediaFile: { __typename?: 'MediaFile', name: string, location: string, fileType?: string | null | undefined } }>, venues_aggregate: { __typename?: 'Venue_aggregate', aggregate?: { __typename?: 'Venue_aggregate_fields', count: number } | null | undefined }, upcomingEvents_aggregate: { __typename?: 'EventCompanyVenue_aggregate', aggregate?: { __typename?: 'EventCompanyVenue_aggregate_fields', count: number } | null | undefined }, contacts_aggregate: { __typename?: 'CompanyContact_aggregate', aggregate?: { __typename?: 'CompanyContact_aggregate_fields', count: number } | null | undefined }, companyVenueEvents_aggregate: { __typename?: 'EventCompanyVenue_aggregate', aggregate?: { __typename?: 'EventCompanyVenue_aggregate_fields', count: number } | null | undefined } }> };

export type TixGetCompanyByCompanyIdQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetCompanyByCompanyIdQuery = { __typename?: 'query_root', Company: Array<{ __typename?: 'Company', companyId: any, name: string, url?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'CompanyPhoneNumber', companyPhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, type?: string | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'CompanyAddress', address?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, countryCode?: string | null | undefined, postalCode?: string | null | undefined } | null | undefined }>, mediaFiles: Array<{ __typename?: 'CompanyMediaFile', companyImageFileId: any, mediaFile: { __typename?: 'MediaFile', mediaFileId: any, name: string, location: string, fileType?: string | null | undefined } }>, socialMediaLinks: Array<{ __typename?: 'CompanySocialMedia', companySocialMediaId: any, socialMedia: { __typename?: 'SocialMedia', socialMediaId: any, url: string, socialMediaType: string, state: string } }>, venues_aggregate: { __typename?: 'Venue_aggregate', aggregate?: { __typename?: 'Venue_aggregate_fields', count: number } | null | undefined }, companyVenueEvents_aggregate: { __typename?: 'EventCompanyVenue_aggregate', aggregate?: { __typename?: 'EventCompanyVenue_aggregate_fields', count: number } | null | undefined }, contacts_aggregate: { __typename?: 'CompanyContact_aggregate', aggregate?: { __typename?: 'CompanyContact_aggregate_fields', count: number } | null | undefined }, warnings: Array<{ __typename?: 'CompanyWarning', companyId: any, companyWarningId: any, createdAt: any, updatedBy: any, updatedAt: any, warningId: any, warning: { __typename?: 'Warning', createAt: any, message: string, type: string, updatedAt: any, updatedBy: any, warningId: any } }> }> };

export type TixGetContactsByCompanyIdQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetContactsByCompanyIdQuery = { __typename?: 'query_root', CompanyContact: Array<{ __typename?: 'CompanyContact', contactId: any, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, profilePicture?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', contactPhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, countryCode?: string | null | undefined, type?: string | null | undefined, phoneNumber?: string | null | undefined } | null | undefined }>, user?: { __typename?: 'User', userId: any, userRoles: Array<{ __typename?: 'UserRole', userRoleId: any, companyId?: any | null | undefined, venueId?: any | null | undefined, role?: { __typename?: 'Role', roleId: any, role?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined }> };

export type TixGetTicketForScannerQueryVariables = Exact<{
  ticketId?: InputMaybe<Scalars['uuid']>;
  reservationId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetTicketForScannerQuery = { __typename?: 'query_root', Ticket: Array<{ __typename?: 'Ticket', state?: string | null | undefined, checkedInAt?: any | null | undefined, reservationNo?: string | null | undefined, reservationId?: any | null | undefined, ticketNo?: string | null | undefined, ticketId: any, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, contact?: { __typename?: 'Contact', fullName?: string | null | undefined, emailAddress: string, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined } | null | undefined }> } | null | undefined, event?: { __typename?: 'EventInstance', eventInstanceId: any, name?: string | null | undefined, date?: any | null | undefined, doorsOpen?: any | null | undefined, startTime?: any | null | undefined } | null | undefined, reservation?: { __typename?: 'ticket_reservation', groupCode?: string | null | undefined } | null | undefined }>, TicketAggregate: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } };

export type TixInsertAddressMutationVariables = Exact<{
  objects: Array<TixAddressInsertInput> | TixAddressInsertInput;
}>;


export type TixInsertAddressMutation = { __typename?: 'mutation_root', InsertAddress?: { __typename?: 'Address_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, city?: string | null | undefined, suiteApartment?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined, state: string, updatedBy: any, updatedAt: any, companyAddress?: { __typename?: 'CompanyAddress', addressId: any, companyAddressId: any, companyId: any, state: string, updatedBy: any, updatedAt: string } | null | undefined, venueAddress?: { __typename?: 'VenueAddress', addressId?: any | null | undefined, venueAddressId: any, venueId?: any | null | undefined, state?: string | null | undefined, updatedAt: any, updatedBy: any } | null | undefined }> } | null | undefined };

export type TixInsertCompanyProfileMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixInsertCompanyProfileMutation = { __typename?: 'mutation_root', InsertCompany?: { __typename?: 'Company_mutation_response', returning: Array<{ __typename?: 'Company', companyId: any, name: string, url?: string | null | undefined, state: string, updatedBy: any, updatedAt: any }> } | null | undefined };

export type TixInsertMediaFileMutationVariables = Exact<{
  objects: Array<TixMediaFileInsertInput> | TixMediaFileInsertInput;
}>;


export type TixInsertMediaFileMutation = { __typename?: 'mutation_root', InsertMediaFile?: { __typename?: 'MediaFile_mutation_response', returning: Array<{ __typename: 'MediaFile', fileType?: string | null | undefined, location: string, name: string, state: string, mediaFileId: any, updatedBy: any, updatedAt: any, companyMediaFile: Array<{ __typename: 'CompanyMediaFile', companyId: any, companyImageFileId: any, updatedBy: any, updatedAt: any }>, venueMediaFile: Array<{ __typename?: 'VenueMediaFile', venueId?: any | null | undefined, venueImageFileId: any, updatedAt: any, updatedBy: any }> }> } | null | undefined };

export type TixInsertPhoneNumberMutationVariables = Exact<{
  objects: Array<TixPhoneNumberInsertInput> | TixPhoneNumberInsertInput;
}>;


export type TixInsertPhoneNumberMutation = { __typename?: 'mutation_root', InsertPhoneNumber?: { __typename?: 'PhoneNumber_mutation_response', returning: Array<{ __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined, phoneNumberId: any, state: string, type?: string | null | undefined, sameAsCompany?: boolean | null | undefined, updatedBy: any, updatedAt: any, countryCode?: string | null | undefined, companyPhoneNumbers: Array<{ __typename?: 'CompanyPhoneNumber', companyId: any, companyPhoneNumberId: any, updatedBy: any, state: string, updatedAt: any }>, venuePhoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', venueId?: any | null | undefined, venuePhoneNumberId: any, updatedBy: any, state?: string | null | undefined, updatedAt: any }> }> } | null | undefined };

export type TixInsertSocialMediaMutationVariables = Exact<{
  objects: Array<TixSocialMediaInsertInput> | TixSocialMediaInsertInput;
}>;


export type TixInsertSocialMediaMutation = { __typename?: 'mutation_root', InsertSocialMedia?: { __typename?: 'SocialMedia_mutation_response', returning: Array<{ __typename: 'SocialMedia', url: string, socialMediaId: any, state: string, socialMediaType: string, updatedBy: any, updatedAt: any, companySocialMedia: Array<{ __typename: 'CompanySocialMedia', companyId: any, companySocialMediaId: any, updatedBy: any, updatedAt: any }>, venueSocialMedia: Array<{ __typename: 'VenueSocialMedia', venueId?: any | null | undefined, venueSocialMediaId: any, updatedAt?: any | null | undefined, updatedBy?: any | null | undefined }> }> } | null | undefined };

export type TixInsertWarningMutationVariables = Exact<{
  objects: Array<TixWarningInsertInput> | TixWarningInsertInput;
}>;


export type TixInsertWarningMutation = { __typename?: 'mutation_root', InsertWarning?: { __typename?: 'Warning_mutation_response', returning: Array<{ __typename?: 'Warning', createAt: any, message: string, type: string, updatedAt: any, updatedBy: any, warningId: any, venue_warning: Array<{ __typename?: 'VenueWarning', createdAt: any, updatedBy: any, updatedAt: any, venueId: any, venueWarningId: any, warningId: any }>, company_warning: Array<{ __typename?: 'CompanyWarning', companyId: any, companyWarningId: any, createdAt: any, updatedBy: any, updatedAt: any, warningId: any }> }> } | null | undefined };

export type TixMarkCompanyAsDeletedMutationVariables = Exact<{
  companyId: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy: Scalars['uuid'];
}>;


export type TixMarkCompanyAsDeletedMutation = { __typename?: 'mutation_root', UpdateCompany?: { __typename?: 'Company_mutation_response', affected_rows: number } | null | undefined };

export type TixUpdateAddressMutationVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  sameAsCompany?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  addressId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy: Scalars['uuid'];
}>;


export type TixUpdateAddressMutation = { __typename?: 'mutation_root', UpdateAddressByPK?: { __typename?: 'Address', addressId: any, city?: string | null | undefined, countryCode?: string | null | undefined, postalCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined, state: string, stateProvince?: string | null | undefined, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, updatedAt: any, updatedBy: any, companyAddress?: { __typename?: 'CompanyAddress', companyId: any, companyAddressId: any, state: string, updatedAt: string, updatedBy: any, addressId: any } | null | undefined, venueAddress?: { __typename?: 'VenueAddress', venueId?: any | null | undefined, venueAddressId: any, state?: string | null | undefined, updatedAt: any, updatedBy: any, addressId?: any | null | undefined } | null | undefined } | null | undefined };

export type TixUpdateCompanyByIdMutationVariables = Exact<{
  companyId?: Scalars['uuid'];
  name?: Scalars['String'];
  state?: Scalars['String'];
  url?: Scalars['String'];
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixUpdateCompanyByIdMutation = { __typename?: 'mutation_root', companyProfile?: { __typename?: 'Company', companyId: any, name: string, url?: string | null | undefined, state: string, updatedBy: any, updatedAt: any } | null | undefined };

export type TixUpdateMediaFileByPkMutationVariables = Exact<{
  fileType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mediaFileId?: InputMaybe<Scalars['uuid']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type TixUpdateMediaFileByPkMutation = { __typename?: 'mutation_root', UpdateMediaFileByPK?: { __typename?: 'MediaFile', mediaFileId: any, fileType?: string | null | undefined, location: string, state: string, updatedBy: any, updatedAt: any, name: string, companyMediaFile: Array<{ __typename?: 'CompanyMediaFile', companyImageFileId: any, companyId: any, updatedBy: any, updatedAt: any }>, venueMediaFile: Array<{ __typename?: 'VenueMediaFile', venueId?: any | null | undefined, venueImageFileId: any, updatedAt: any, updatedBy: any }> } | null | undefined };

export type TixUpdatePhoneNumberByPkMutationVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixUpdatePhoneNumberByPkMutation = { __typename?: 'mutation_root', UpdatePhoneNumberByPK?: { __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined, phoneNumberId: any, sameAsCompany?: boolean | null | undefined, state: string, countryCode?: string | null | undefined, type?: string | null | undefined, updatedBy: any, updatedAt: any, companyPhoneNumbers: Array<{ __typename?: 'CompanyPhoneNumber', companyId: any, companyPhoneNumberId: any, updatedBy: any, state: string, updatedAt: any }>, venuePhoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', venueId?: any | null | undefined, venuePhoneNumberId: any, updatedAt: any, updatedBy: any, state?: string | null | undefined }> } | null | undefined };

export type TixUpdateSocialMediaByPkMutationVariables = Exact<{
  socialMediaType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  socialMediaId?: InputMaybe<Scalars['uuid']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type TixUpdateSocialMediaByPkMutation = { __typename?: 'mutation_root', UpdateSocialMediaByPK?: { __typename?: 'SocialMedia', socialMediaId: any, socialMediaType: string, url: string, state: string, updatedBy: any, updatedAt: any, companySocialMedia: Array<{ __typename?: 'CompanySocialMedia', companySocialMediaId: any, companyId: any, updatedBy: any, updatedAt: any }>, venueSocialMedia: Array<{ __typename?: 'VenueSocialMedia', venueSocialMediaId: any, venueId?: any | null | undefined, updatedAt?: any | null | undefined, updatedBy?: any | null | undefined }> } | null | undefined };

export type TixUpdateVenueByPkMutationVariables = Exact<{
  additionalInfo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy: Scalars['uuid'];
}>;


export type TixUpdateVenueByPkMutation = { __typename?: 'mutation_root', UpdateVenueByPK?: { __typename?: 'Venue', description?: string | null | undefined, name: string, additionalInfo?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type TixUpdateWarningByPkMutationVariables = Exact<{
  warningId?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type TixUpdateWarningByPkMutation = { __typename?: 'mutation_root', UpdateWarningByPK?: { __typename?: 'Warning', createAt: any, message: string, type: string, updatedAt: any, updatedBy: any, warningId: any, company_warning: Array<{ __typename?: 'CompanyWarning', companyId: any, companyWarningId: any, createdAt: any, updatedBy: any, updatedAt: any }>, venue_warning: Array<{ __typename?: 'VenueWarning', updatedBy: any, updatedAt: any, createdAt: any, venueId: any, venueWarningId: any }> } | null | undefined };

export type TixGetConfigurationItemByGroupItemQueryVariables = Exact<{
  groupType?: InputMaybe<Scalars['String']>;
}>;


export type TixGetConfigurationItemByGroupItemQuery = { __typename?: 'query_root', ConfigurationItem: Array<{ __typename?: 'ConfigurationItem', configurationItemId: any, description?: string | null | undefined, elementType?: string | null | undefined, helpText?: string | null | undefined, name: string, placeholder?: string | null | undefined, state: string, regex?: string | null | undefined, defaultValue?: string | null | undefined, required?: boolean | null | undefined, GroupItem?: { __typename?: 'ConfigurationGroupItem', configurationGroupId: any, viewOrder?: number | null | undefined, Group?: { __typename?: 'ConfigurationGroup', name: string } | null | undefined } | null | undefined }> };

export type TixGetConfigurationItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type TixGetConfigurationItemsQuery = { __typename?: 'query_root', ConfigurationItem: Array<{ __typename?: 'ConfigurationItem', configurationItemId: any, description?: string | null | undefined, elementType?: string | null | undefined, helpText?: string | null | undefined, name: string, placeholder?: string | null | undefined }> };

export type TixUpdateConfigurationValuesForEventInstanceMutationVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
  configurationItemId: Scalars['uuid'];
  objects: Array<TixEventInstanceConfigurationValueInsertInput> | TixEventInstanceConfigurationValueInsertInput;
}>;


export type TixUpdateConfigurationValuesForEventInstanceMutation = { __typename?: 'mutation_root', DeleteEventInstanceConfigurationValue?: { __typename?: 'EventInstanceConfigurationValue_mutation_response', affected_rows: number } | null | undefined, InsertEventInstanceConfigurationValue?: { __typename?: 'EventInstanceConfigurationValue_mutation_response', affected_rows: number } | null | undefined };

export type TixUpdateConfigurationValuesForVenueMutationVariables = Exact<{
  venueId: Scalars['uuid'];
  configurationItemId: Scalars['uuid'];
  objects: Array<TixVenueConfigurationValueInsertInput> | TixVenueConfigurationValueInsertInput;
}>;


export type TixUpdateConfigurationValuesForVenueMutation = { __typename?: 'mutation_root', DeleteVenueConfigurationValue?: { __typename?: 'VenueConfigurationValue_mutation_response', affected_rows: number } | null | undefined, InsertVenueConfigurationValue?: { __typename?: 'VenueConfigurationValue_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteContactPhoneNumberByPhoneNumberPkMutationVariables = Exact<{
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteContactPhoneNumberByPhoneNumberPkMutation = { __typename?: 'mutation_root', DeleteContactPhoneNumber?: { __typename?: 'ContactPhoneNumber_mutation_response', returning: Array<{ __typename?: 'ContactPhoneNumber', contactId?: any | null | undefined, contactPhoneNumberId: any }> } | null | undefined, DeletePhoneNumberByPK?: { __typename?: 'PhoneNumber', contactPhoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', contactId?: any | null | undefined, contactPhoneNumberId: any }> } | null | undefined };

export type TixDeletePhoneNumbersByIdsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixDeletePhoneNumbersByIdsMutation = { __typename?: 'mutation_root', DeletePhoneNumber?: { __typename?: 'PhoneNumber_mutation_response', affected_rows: number } | null | undefined };

export type TixOldGetContactByEmailAddressQueryVariables = Exact<{
  emailAddress?: InputMaybe<Scalars['String']>;
}>;


export type TixOldGetContactByEmailAddressQuery = { __typename?: 'query_root', Contact: Array<{ __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, dob?: any | null | undefined, profilePicture?: string | null | undefined, user?: { __typename?: 'User', userId: any, userRoles: Array<{ __typename?: 'UserRole', userRoleId: any, companyId?: any | null | undefined, venueId?: any | null | undefined, role?: { __typename?: 'Role', roleId: any, role?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined } | null | undefined }> } | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', contactPhoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', contactPhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, type?: string | null | undefined } | null | undefined }> } | null | undefined }>, addresses: Array<{ __typename?: 'ContactAddress', address?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, contactAddress?: { __typename?: 'ContactAddress', contactAddressId: any } | null | undefined } | null | undefined }> }> };

export type TixGrantAccessToCompanyMutationVariables = Exact<{
  currentToken: Scalars['String'];
  companyId: Scalars['String'];
}>;


export type TixGrantAccessToCompanyMutation = { __typename?: 'mutation_root', grantAccessToCompany: boolean };

export type TixInsertContactAddressMutationVariables = Exact<{
  streetAddress?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['uuid']>;
  updatedByContact?: InputMaybe<Scalars['uuid']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixInsertContactAddressMutation = { __typename?: 'mutation_root', InsertAddress?: { __typename?: 'Address_mutation_response', returning: Array<{ __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, city?: string | null | undefined, suiteApartment?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, contactAddress?: { __typename?: 'ContactAddress', contactId?: any | null | undefined, contactAddressId: any, state?: string | null | undefined, updatedBy: any, updatedAt: any } | null | undefined }> } | null | undefined };

export type TixInsertContactPhoneNumberMutationVariables = Exact<{
  objects?: InputMaybe<Array<TixPhoneNumberInsertInput> | TixPhoneNumberInsertInput>;
}>;


export type TixInsertContactPhoneNumberMutation = { __typename?: 'mutation_root', InsertPhoneNumber?: { __typename?: 'PhoneNumber_mutation_response', returning: Array<{ __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined, phoneNumberId: any, countryCode?: string | null | undefined, type?: string | null | undefined, state: string, updatedAt: any, updatedBy: any, contactPhoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', contactId?: any | null | undefined, contactPhoneNumberId: any, state?: string | null | undefined, updatedBy: any, updatedAt: any }> }> } | null | undefined };

export type TixInsertContactMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixInsertContactMutation = { __typename?: 'mutation_root', InsertContact?: { __typename?: 'Contact_mutation_response', returning: Array<{ __typename?: 'Contact', contactId: any, emailAddress: string, firstName: string, lastName: string, dob?: any | null | undefined, state: string, updatedBy: any, updatedAt: any }> } | null | undefined };

export type TixIsValidResetPasswordTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type TixIsValidResetPasswordTokenQuery = { __typename?: 'query_root', isValidToken?: boolean | null | undefined };

export type TixRequestResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  url: Scalars['String'];
}>;


export type TixRequestResetPasswordMutation = { __typename?: 'mutation_root', requestResetPassword?: { __typename?: 'RequestResetPasswordResponse', sent?: boolean | null | undefined } | null | undefined };

export type TixResetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  token: Scalars['String'];
}>;


export type TixResetPasswordMutation = { __typename?: 'mutation_root', resetPassword?: { __typename?: 'ResetPasswordResponse', updated?: boolean | null | undefined } | null | undefined };

export type TixUpdateAddressByPkMutationVariables = Exact<{
  suiteApartment?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  addressId?: InputMaybe<Scalars['uuid']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixUpdateAddressByPkMutation = { __typename?: 'mutation_root', UpdateAddressByPK?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, city?: string | null | undefined, suiteApartment?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, contactAddress?: { __typename?: 'ContactAddress', contactId?: any | null | undefined, contactAddressId: any, state?: string | null | undefined, updatedBy: any, updatedAt: any } | null | undefined } | null | undefined };

export type TixUpdateContactByPkMutationVariables = Exact<{
  contactId?: InputMaybe<Scalars['uuid']>;
  dob?: InputMaybe<Scalars['date']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy: Scalars['uuid'];
}>;


export type TixUpdateContactByPkMutation = { __typename?: 'mutation_root', UpdateContactByPK?: { __typename?: 'Contact', contactId: any, dob?: any | null | undefined, lastName: string, firstName: string, emailAddress: string, profilePicture?: string | null | undefined, state: string } | null | undefined };

export type TixUpsertContactMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixUpsertContactMutation = { __typename?: 'mutation_root', InsertContact?: { __typename?: 'Contact_mutation_response', returning: Array<{ __typename?: 'Contact', contactId: any, emailAddress: string, firstName: string, lastName: string, dob?: any | null | undefined, state: string, updatedBy: any, updatedAt: any }> } | null | undefined };

export type TixCustomerSearchElementFragment = { __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined };

export type TixGetCustomerByCompanyIdQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetCustomerByCompanyIdQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerByDatesForEventAdminQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['date']>;
  endDate?: InputMaybe<Scalars['date']>;
  userId?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetCustomerByDatesForEventAdminQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerByDatesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['date']>;
  endDate?: InputMaybe<Scalars['date']>;
}>;


export type TixGetCustomerByDatesQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerByEmailQueryVariables = Exact<{
  customerEmail?: InputMaybe<Scalars['String']>;
}>;


export type TixGetCustomerByEmailQuery = { __typename?: 'query_root', Customer: Array<{ __typename?: 'Customer', customerFullName?: string | null | undefined, emailAddress?: string | null | undefined, contact?: { __typename?: 'Contact', contactId: any } | null | undefined }> };

export type TixGetCustomerByInputForAdminQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  input: Scalars['String'];
  userId?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetCustomerByInputForAdminQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerByInputQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  input: Scalars['String'];
}>;


export type TixGetCustomerByInputQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerBySearchForEventAdminQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  input: Scalars['String'];
  startDate?: InputMaybe<Scalars['date']>;
  endDate?: InputMaybe<Scalars['date']>;
  userId?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetCustomerBySearchForEventAdminQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerBySearchQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  input: Scalars['String'];
  startDate?: InputMaybe<Scalars['date']>;
  endDate?: InputMaybe<Scalars['date']>;
}>;


export type TixGetCustomerBySearchQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerBySingleDateForEventAdminQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  input: Scalars['String'];
  date?: InputMaybe<Scalars['date']>;
  userId?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetCustomerBySingleDateForEventAdminQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerBySingleDateQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  input: Scalars['String'];
  date?: InputMaybe<Scalars['date']>;
}>;


export type TixGetCustomerBySingleDateQuery = { __typename?: 'query_root', CustomerSearch: Array<{ __typename?: 'CustomerSearch', firstName?: string | null | undefined, lastName?: string | null | undefined, emailAddress?: string | null | undefined, phoneNumber?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationDate?: any | null | undefined, companyId?: any | null | undefined, eventDateFormatted?: string | null | undefined, startTimeFormatted?: string | null | undefined, reservationDateFormatted?: string | null | undefined, companyName?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventDate?: any | null | undefined, startTime?: any | null | undefined, salesChannel?: string | null | undefined, ticketCount?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, venueRevenue?: any | null | undefined, totalAmountPaid?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, discountCode?: string | null | undefined, paymentType?: string | null | undefined, refundAmount?: any | null | undefined }> };

export type TixGetCustomerCountQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetCustomerCountQuery = { __typename?: 'query_root', CustomerSearchAggregate: { __typename?: 'CustomerSearch_aggregate', aggregate?: { __typename?: 'CustomerSearch_aggregate_fields', count: number } | null | undefined } };

export type TixInsertCustomerMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  sms?: InputMaybe<Scalars['Boolean']>;
  emails?: InputMaybe<Scalars['Boolean']>;
  stAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  contact_id?: InputMaybe<Scalars['uuid']>;
}>;


export type TixInsertCustomerMutation = { __typename?: 'mutation_root', CustomerInsertOne?: { __typename?: 'Customer', customerId: any, firstName?: string | null | undefined, lastName?: string | null | undefined, phoneNumber?: string | null | undefined, emailAddress?: string | null | undefined, dob?: any | null | undefined, updatedAt?: any | null | undefined, optInSMS?: boolean | null | undefined, optInEmail?: boolean | null | undefined, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined } | null | undefined };

export type TixUpdateCustomerByEmailMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  sms?: InputMaybe<Scalars['Boolean']>;
  emails?: InputMaybe<Scalars['Boolean']>;
  stAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  contact_id?: InputMaybe<Scalars['uuid']>;
}>;


export type TixUpdateCustomerByEmailMutation = { __typename?: 'mutation_root', CustomerUpdate?: { __typename?: 'Customer_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Customer', customerId: any }> } | null | undefined };

export type TixUpsertCustomerMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  sms?: InputMaybe<Scalars['Boolean']>;
  emails?: InputMaybe<Scalars['Boolean']>;
  stAddress?: InputMaybe<Scalars['String']>;
  suiteApartment?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
}>;


export type TixUpsertCustomerMutation = { __typename?: 'mutation_root', CustomerInsert?: { __typename?: 'Customer_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Customer', customerId: any, firstName?: string | null | undefined, lastName?: string | null | undefined, phoneNumber?: string | null | undefined, emailAddress?: string | null | undefined, dob?: any | null | undefined, updatedAt?: any | null | undefined, optInSMS?: boolean | null | undefined, optInEmail?: boolean | null | undefined, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined }> } | null | undefined };

export type TixDecrementDiscountLimitMutationVariables = Exact<{
  discountId: Scalars['uuid'];
}>;


export type TixDecrementDiscountLimitMutation = { __typename?: 'mutation_root', UpdateDiscount?: { __typename?: 'Discount_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteDiscountMutationVariables = Exact<{
  discountId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy: Scalars['uuid'];
}>;


export type TixDeleteDiscountMutation = { __typename?: 'mutation_root', UpdateDiscountByPK?: { __typename?: 'Discount', discountId: any } | null | undefined, UpdateDiscount?: { __typename?: 'Discount_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteEventInstanceDiscountsMutationVariables = Exact<{
  eventInstanceDiscountIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixDeleteEventInstanceDiscountsMutation = { __typename?: 'mutation_root', DeleteEventInstanceDiscount?: { __typename?: 'EventInstanceDiscount_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteVenueDiscountsMutationVariables = Exact<{
  venueDiscountIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixDeleteVenueDiscountsMutation = { __typename?: 'mutation_root', DeleteVenueDiscount?: { __typename?: 'VenueDiscount_mutation_response', affected_rows: number } | null | undefined };

export type TixDiscountHasPasscodeQueryVariables = Exact<{
  data: TixHasPasscodeDto;
}>;


export type TixDiscountHasPasscodeQuery = { __typename?: 'query_root', hasPasscode?: boolean | null | undefined };

export type TixGetDiscountByIdQueryVariables = Exact<{
  discountId: Scalars['uuid'];
}>;


export type TixGetDiscountByIdQuery = { __typename?: 'query_root', SelectDiscountByPK?: { __typename?: 'Discount', discountId: any, companyId?: any | null | undefined, discountCode: string, type?: string | null | undefined, state?: string | null | undefined, passcode?: string | null | undefined, limit?: any | null | undefined, description?: string | null | undefined, buyAmount?: any | null | undefined, getAmount?: any | null | undefined, createdAt?: any | null | undefined, codeType?: string | null | undefined, codesToGenerate?: any | null | undefined, prefix?: string | null | undefined, parentDiscountCodeId?: any | null | undefined, groupDiscountType?: string | null | undefined, groupDiscountAmount?: any | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, appliedTo?: string | null | undefined, eventInstanceDiscount: Array<{ __typename?: 'EventInstanceDiscount', eventInstanceDiscountId: any, eventInstanceId: any, eventInstance?: { __typename?: 'EventInstance', venueId?: any | null | undefined } | null | undefined }>, venueDiscount: Array<{ __typename?: 'VenueDiscount', venueDiscountId: any, venueId: any, venue?: { __typename?: 'Venue', name: string } | null | undefined }> } | null | undefined };

export type TixGetDiscountsByParentIdQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetDiscountsByParentIdQuery = { __typename?: 'query_root', Discount: Array<{ __typename?: 'Discount', discountId: any, discountCode: string, state?: string | null | undefined, reservations_aggregate: { __typename?: 'ticket_reservation_aggregate', aggregate?: { __typename?: 'ticket_reservation_aggregate_fields', discountsUsed: number } | null | undefined } }> };

export type TixGetDiscountInfoQueryVariables = Exact<{
  data: TixDiscountCodeDto;
}>;


export type TixGetDiscountInfoQuery = { __typename?: 'query_root', discount: { __typename?: 'DiscountData', discountId: string, buyAmount?: number | null | undefined, getAmount?: number | null | undefined, groupDiscountType?: string | null | undefined, groupDiscountAmount?: number | null | undefined, type: string, appliedTo?: string | null | undefined } };

export type TixGetDiscountsByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['uuid'];
  startDate?: InputMaybe<Scalars['date']>;
  endDate?: InputMaybe<Scalars['date']>;
}>;


export type TixGetDiscountsByCompanyIdQuery = { __typename?: 'query_root', Discount: Array<{ __typename?: 'Discount', discountId: any, companyId?: any | null | undefined, discountCode: string, type?: string | null | undefined, state?: string | null | undefined, codeType?: string | null | undefined, codesToGenerate?: any | null | undefined, prefix?: string | null | undefined, parentDiscountCodeId?: any | null | undefined, passcode?: string | null | undefined, limit?: any | null | undefined, description?: string | null | undefined, buyAmount?: any | null | undefined, getAmount?: any | null | undefined, createdAt?: any | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, appliedTo?: string | null | undefined, eventInstanceDiscount: Array<{ __typename?: 'EventInstanceDiscount', eventInstanceId: any, eventInstance?: { __typename?: 'EventInstance', venueId?: any | null | undefined } | null | undefined }>, venueDiscount: Array<{ __typename?: 'VenueDiscount', venueId: any, venue?: { __typename?: 'Venue', name: string } | null | undefined }>, reservations_aggregate: { __typename?: 'ticket_reservation_aggregate', aggregate?: { __typename?: 'ticket_reservation_aggregate_fields', discountsUsed: number } | null | undefined } }> };

export type TixInsertDiscountMutationVariables = Exact<{
  discount: TixDiscountInsertInput;
}>;


export type TixInsertDiscountMutation = { __typename?: 'mutation_root', InsertDiscountOne?: { __typename?: 'Discount', discountId: any, companyId?: any | null | undefined, discountCode: string, type?: string | null | undefined, state?: string | null | undefined, passcode?: string | null | undefined, limit?: any | null | undefined, description?: string | null | undefined, buyAmount?: any | null | undefined, getAmount?: any | null | undefined, createdAt?: any | null | undefined, codeType?: string | null | undefined, codesToGenerate?: any | null | undefined, prefix?: string | null | undefined, parentDiscountCodeId?: any | null | undefined, groupDiscountType?: string | null | undefined, groupDiscountAmount?: any | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, appliedTo?: string | null | undefined, eventInstanceDiscount: Array<{ __typename?: 'EventInstanceDiscount', eventInstanceId: any }>, venueDiscount: Array<{ __typename?: 'VenueDiscount', venueId: any }> } | null | undefined };

export type TixInsertEventInstanceDiscountsMutationVariables = Exact<{
  objects: Array<TixEventInstanceDiscountInsertInput> | TixEventInstanceDiscountInsertInput;
}>;


export type TixInsertEventInstanceDiscountsMutation = { __typename?: 'mutation_root', InsertEventInstanceDiscount?: { __typename?: 'EventInstanceDiscount_mutation_response', affected_rows: number } | null | undefined };

export type TixInsertVenueDiscountsMutationVariables = Exact<{
  objects: Array<TixVenueDiscountInsertInput> | TixVenueDiscountInsertInput;
}>;


export type TixInsertVenueDiscountsMutation = { __typename?: 'mutation_root', InsertVenueDiscount?: { __typename?: 'VenueDiscount_mutation_response', affected_rows: number } | null | undefined };

export type TixIsValidDiscountCodeQueryVariables = Exact<{
  data: TixDiscountCodeDto;
}>;


export type TixIsValidDiscountCodeQuery = { __typename?: 'query_root', isValidDiscountCode?: boolean | null | undefined };

export type TixUpdateDiscountByIdMutationVariables = Exact<{
  discountId: Scalars['uuid'];
  data?: InputMaybe<TixDiscountSetInput>;
}>;


export type TixUpdateDiscountByIdMutation = { __typename?: 'mutation_root', UpdateDiscountByPK?: { __typename?: 'Discount', discountId: any, companyId?: any | null | undefined, discountCode: string, type?: string | null | undefined, state?: string | null | undefined, passcode?: string | null | undefined, limit?: any | null | undefined, description?: string | null | undefined, buyAmount?: any | null | undefined, getAmount?: any | null | undefined, codeType?: string | null | undefined, codesToGenerate?: any | null | undefined, prefix?: string | null | undefined, parentDiscountCodeId?: any | null | undefined, createdAt?: any | null | undefined, groupDiscountType?: string | null | undefined, groupDiscountAmount?: any | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, appliedTo?: string | null | undefined, eventInstanceDiscount: Array<{ __typename?: 'EventInstanceDiscount', eventInstanceId: any }>, venueDiscount: Array<{ __typename?: 'VenueDiscount', venueId: any }> } | null | undefined };

export type TixGetDonationSetUpByEventIdQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetDonationSetUpByEventIdQuery = { __typename?: 'query_root', EventInstanceConfigurationValue: Array<{ __typename?: 'EventInstanceConfigurationValue', eventInstanceId: any, value?: { __typename?: 'ConfigurationValue', value: string, configurationValueId: any, configurationItemId: any, Item?: { __typename?: 'ConfigurationItem', name: string, GroupItem?: { __typename?: 'ConfigurationGroupItem', configurationGroupId: any } | null | undefined } | null | undefined } | null | undefined }> };

export type TixInsertEventInstanceMutationVariables = Exact<{
  objects: Array<TixEventInsertInput> | TixEventInsertInput;
}>;


export type TixInsertEventInstanceMutation = { __typename?: 'mutation_root', InsertEvent?: { __typename?: 'Event_mutation_response', returning: Array<{ __typename?: 'Event', eventId: any, companyId?: any | null | undefined, name?: string | null | undefined, type?: string | null | undefined, state?: string | null | undefined, updatedBy: any, updatedAt: any, eventInstances: Array<{ __typename?: 'EventInstance', eventInstanceId: any, eventId?: any | null | undefined, name?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, additionalInfo?: string | null | undefined, date?: any | null | undefined, doorsOpen?: any | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, minimumAge?: number | null | undefined, hidden?: boolean | null | undefined, passcode?: string | null | undefined, overridden?: boolean | null | undefined, venueId?: any | null | undefined, venueTicketId?: any | null | undefined, state?: string | null | undefined, updatedBy: any, updatedAt: any, venue?: { __typename?: 'Venue', name: string, companyId?: any | null | undefined } | null | undefined, eventInstanceTickets: Array<{ __typename?: 'EventInstanceTicket', Configurations: Array<{ __typename?: 'EventInstanceTicketConfig', TicketConfigurations: { __typename?: 'TicketConfig', view_order?: number | null | undefined, name?: string | null | undefined, includeFees?: boolean | null | undefined, noOfSeats?: number | null | undefined, parentTicketId?: any | null | undefined, salesChannel?: string | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, state?: string | null | undefined, ticketConfigId: any, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined } }> }>, eventPerformers: Array<{ __typename?: 'EventPerformers', eventPerformerId: any, eventInstanceId: any, performerId: any, state: string, updatedBy: any, updatedAt: any, Performers: Array<{ __typename?: 'Performer', performerId: any, companyId?: any | null | undefined, name?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined, additionalInfo?: string | null | undefined, state?: string | null | undefined, updatedBy: any, updatedAt: any }> }> }> }> } | null | undefined };

export type TixCreateRecurringEventsMutationVariables = Exact<{
  data: TixEventData;
}>;


export type TixCreateRecurringEventsMutation = { __typename?: 'mutation_root', createRecurringEvents?: { __typename?: 'InsertEventResult', InsertEvent?: { __typename?: 'EventResult', returning?: Array<{ __typename?: 'EventIdResult', eventId?: string | null | undefined }> | null | undefined } | null | undefined } | null | undefined };

export type TixCalculateAvailableTicketsStatsQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['String']>;
}>;


export type TixCalculateAvailableTicketsStatsQuery = { __typename?: 'query_root', calculateAvailableTicketStats?: { __typename?: 'AvailableBreakdown', Class_Tuition?: number | null | undefined, VIP?: number | null | undefined, General_Admission?: number | null | undefined } | null | undefined };

export type TixDeleteCampaignTrackingMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixDeleteCampaignTrackingMutation = { __typename?: 'mutation_root', delete_event_campaign_tracking?: { __typename?: 'event_campaign_tracking_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteEventInstanceTicketConfigByIdMutationVariables = Exact<{
  ticketConfigId: Scalars['uuid'];
}>;


export type TixDeleteEventInstanceTicketConfigByIdMutation = { __typename?: 'mutation_root', DeleteEventInstanceTicketConfig?: { __typename?: 'EventInstanceTicketConfig_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteEventPerformersByPkMutationVariables = Exact<{
  eventPerformerId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteEventPerformersByPkMutation = { __typename?: 'mutation_root', DeleteEventPerformersByPK?: { __typename?: 'EventPerformers', eventPerformerId: any, eventInstanceId: any, performerId: any, state: string, updatedBy: any, updatedAt: any } | null | undefined };

export type TixDeleteMediaFilesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixDeleteMediaFilesMutation = { __typename?: 'mutation_root', DeleteMediaFile?: { __typename?: 'MediaFile_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteSocialMediasMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixDeleteSocialMediasMutation = { __typename?: 'mutation_root', DeleteSocialMedia?: { __typename?: 'SocialMedia_mutation_response', affected_rows: number } | null | undefined };

export type TixGetEventAdminsByEventInstanceIdQueryVariables = Exact<{
  eventInstanceId?: Scalars['uuid'];
}>;


export type TixGetEventAdminsByEventInstanceIdQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventAdmins?: Array<any> | null | undefined }> };

export type TixGetEventByEventInstanceIdQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetEventByEventInstanceIdQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename: 'EventInstance', eventId?: any | null | undefined, eventInstanceId: any, name?: string | null | undefined, description?: string | null | undefined, additionalInfo?: string | null | undefined, venueId?: any | null | undefined, date?: any | null | undefined, slug?: string | null | undefined, eventAdmins?: Array<any> | null | undefined, doorsOpen?: any | null | undefined, minimumAge?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, passcode?: string | null | undefined, state?: string | null | undefined, type?: string | null | undefined, hidden?: boolean | null | undefined, overridden?: boolean | null | undefined, venueTicketId?: any | null | undefined, configurationItems: Array<{ __typename: 'EventInstanceConfigurationValue', value?: { __typename: 'ConfigurationValue', configurationValueId: any, configurationItemId: any, value: string } | null | undefined }>, venue?: { __typename: 'Venue', name: string, companyId?: any | null | undefined, company?: { __typename: 'Company', name: string } | null | undefined } | null | undefined, eventInstanceTickets: Array<{ __typename: 'EventInstanceTicket', eventInstanceTicketId: any, name: string, description?: string | null | undefined, state: string, totalSeats?: number | null | undefined, Configurations: Array<{ __typename: 'EventInstanceTicketConfig', totalTicketsByType?: { __typename: 'ticket_v_ticket_count_by_type', totalTickets?: number | null | undefined, ticketsSold?: any | null | undefined, ticketsRemaining?: any | null | undefined, ticketType?: string | null | undefined } | null | undefined, TicketConfigurations: { __typename: 'TicketConfig', name?: string | null | undefined, parentTicketId?: any | null | undefined, includeFees?: boolean | null | undefined, salesChannel?: string | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, noOfSeats?: number | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, state?: string | null | undefined, ticketConfigId: any, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined } }> }>, media: Array<{ __typename: 'EventInstanceMedialFile', mediaFile: { __typename: 'MediaFile', mediaFileId: any, location: string, fileType?: string | null | undefined, name: string } }>, socialMedia: Array<{ __typename: 'EventInstanceSocialMediaFile', socialMedia: { __typename: 'SocialMedia', socialMediaId: any, url: string, socialMediaType: string } }>, campaign: Array<{ __typename: 'event_campaign_tracking', campaign_name?: string | null | undefined, campaignType?: string | null | undefined, campaignCode?: string | null | undefined, campaign_tracking_id: any, createdAt?: any | null | undefined, createdBy?: any | null | undefined, eventInstanceId?: any | null | undefined, updatedAt?: any | null | undefined, updatedBy?: any | null | undefined }>, eventProduct: Array<{ __typename: 'EventProduct', eventProductId: any, name?: string | null | undefined, state: string, price?: any | null | undefined, quantity?: number | null | undefined, quantitySold?: number | null | undefined, quantityRemaining?: number | null | undefined, tax?: any | null | undefined, salesChannel?: string | null | undefined, additionalInfo?: string | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, startSelling?: any | null | undefined, stopSelling?: any | null | undefined, stopSellingTime?: any | null | undefined, productId: any, EventProductMedia: Array<{ __typename: 'EventProductMedia', eventProductMediaImageFileId: any, MediaFile?: { __typename: 'MediaFile', location: string, name: string, mediaFileId: any, fileType?: string | null | undefined, state: string } | null | undefined }> }> }> };

export type TixGetEventInstanceByPkQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetEventInstanceByPkQuery = { __typename?: 'query_root', EventInstanceByPK?: { __typename?: 'EventInstance', description?: string | null | undefined, name?: string | null | undefined, date?: any | null | undefined, slug?: string | null | undefined, doorsOpen?: any | null | undefined, endTime?: any | null | undefined, startTime?: any | null | undefined, type?: string | null | undefined, eventInstanceId: any, venueTicketId?: any | null | undefined, configurationItems: Array<{ __typename?: 'EventInstanceConfigurationValue', value?: { __typename?: 'ConfigurationValue', configurationValueId: any, configurationItemId: any, value: string } | null | undefined }>, venue?: { __typename?: 'Venue', name: string, venueId: any, state: string, company?: { __typename?: 'Company', name: string } | null | undefined, configurationValues: Array<{ __typename?: 'VenueConfigurationValue', Venue?: { __typename?: 'Venue', tickets: Array<{ __typename?: 'VenueTicket', Configurations: Array<{ __typename?: 'VenueTicketConfig', venueTicketId?: any | null | undefined, TicketConfigurations?: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, ticketConfigId: any, salesChannel?: string | null | undefined, ticketType?: string | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, noOfSeats?: number | null | undefined, ticketPrice?: any | null | undefined } | null | undefined }> }> } | null | undefined }> } | null | undefined, eventInstanceTickets: Array<{ __typename?: 'EventInstanceTicket', Configurations: Array<{ __typename?: 'EventInstanceTicketConfig', TicketConfigurations: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, name?: string | null | undefined, noOfSeats?: number | null | undefined, salesChannel?: string | null | undefined, parentTicketId?: any | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, state?: string | null | undefined, ticketConfigId: any, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined } }> }>, eventTicketSalesMetrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, checked_in?: any | null | undefined, event_instance_id?: any | null | undefined, not_checked_in?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined } | null | undefined };

export type TixGetEventTicketConfigurationsQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetEventTicketConfigurationsQuery = { __typename?: 'query_root', EventInstanceByPK?: { __typename?: 'EventInstance', eventInstanceTickets: Array<{ __typename?: 'EventInstanceTicket', Configurations: Array<{ __typename?: 'EventInstanceTicketConfig', TicketConfigurations: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, salesChannel?: string | null | undefined, noOfSeats?: number | null | undefined, ticketConfigId: any, name?: string | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketPrice?: any | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, venueFee?: any | null | undefined, state?: string | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, ticketConfigTotals?: { __typename?: 'ticket_v_ticket_count_by_type', totalTickets?: number | null | undefined, ticketsSold?: any | null | undefined, ticketsRemaining?: any | null | undefined } | null | undefined } }> }>, Metrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined } | null | undefined };

export type TixGetEventTicketsSoldCountForContactQueryVariables = Exact<{
  ticketConfigId: Scalars['uuid'];
  contactId: Scalars['uuid'];
}>;


export type TixGetEventTicketsSoldCountForContactQuery = { __typename?: 'query_root', TicketAggregate: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } };

export type TixGetEventsByCompanyIdForEventAdminQueryVariables = Exact<{
  companyId: Scalars['uuid'];
  userId?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetEventsByCompanyIdForEventAdminQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, eventId?: any | null | undefined, venueId?: any | null | undefined, eventAdmins?: Array<any> | null | undefined }> };

export type TixGetEventsByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['uuid'];
  eventName?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orExp?: InputMaybe<Array<TixEventCompanyVenueBoolExp> | TixEventCompanyVenueBoolExp>;
  eventStates?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type TixGetEventsByCompanyIdQuery = { __typename?: 'query_root', EventCompanyVenueAggregate: { __typename?: 'EventCompanyVenue_aggregate', aggregate?: { __typename?: 'EventCompanyVenue_aggregate_fields', count: number } | null | undefined }, EventCompanyVenue: Array<{ __typename?: 'EventCompanyVenue', eventInstanceId?: any | null | undefined, eventId?: any | null | undefined, eventName?: string | null | undefined, ticketsSold?: any | null | undefined, available?: any | null | undefined, mainEventName?: string | null | undefined, date?: string | null | undefined, filterDate?: any | null | undefined, startTime?: any | null | undefined, doorsOpen?: any | null | undefined, venueName?: string | null | undefined, venueId?: any | null | undefined, eventState?: string | null | undefined, mediaId?: any | null | undefined, mediaState?: string | null | undefined, mediaFileType?: string | null | undefined, mediaLocation?: string | null | undefined, eventInstance?: { __typename?: 'EventInstance', slug?: string | null | undefined, eventAdmins?: Array<any> | null | undefined } | null | undefined }> };

export type TixGetEventsByEventAdminQueryVariables = Exact<{
  adminId?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetEventsByEventAdminQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventAdmins?: Array<any> | null | undefined, eventInstanceId: any }> };

export type TixGetEventsByVenueIdQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type TixGetEventsByVenueIdQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, name?: string | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, doorsOpen?: any | null | undefined, date?: any | null | undefined, venueId?: any | null | undefined, eventAdmins?: Array<any> | null | undefined }> };

export type TixGetEventsForVenuesQueryVariables = Exact<{
  venueIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixGetEventsForVenuesQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, name?: string | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, doorsOpen?: any | null | undefined, date?: any | null | undefined, venueId?: any | null | undefined, eventAdmins?: Array<any> | null | undefined }> };

export type TixGetTicketTypeUsersStatsQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
}>;


export type TixGetTicketTypeUsersStatsQuery = { __typename?: 'query_root', pendingUserStats: { __typename?: 'Ticket_aggregate', nodes: Array<{ __typename?: 'Ticket', state?: string | null | undefined, ticketId: any, ticketPrice?: any | null | undefined, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string } | null | undefined, reservation?: { __typename?: 'ticket_reservation', reservationId: any, reservationDate?: any | null | undefined } | null | undefined }> }, checkedInUserStats: { __typename?: 'Ticket_aggregate', nodes: Array<{ __typename?: 'Ticket', ticketId: any, ticketPrice?: any | null | undefined, state?: string | null | undefined, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string } | null | undefined, reservation?: { __typename?: 'ticket_reservation', reservationId: any, reservationDate?: any | null | undefined } | null | undefined }> }, refundedUserStats: { __typename?: 'Ticket_aggregate', nodes: Array<{ __typename?: 'Ticket', state?: string | null | undefined, ticketId: any, ticketPrice?: any | null | undefined, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string } | null | undefined, reservation?: { __typename?: 'ticket_reservation', reservationId: any, reservationDate?: any | null | undefined } | null | undefined }> } };

export type TixGetPerformerDropDownListByCompanyIdQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetPerformerDropDownListByCompanyIdQuery = { __typename?: 'query_root', Performer: Array<{ __typename?: 'Performer', performerId: any, name?: string | null | undefined, companyId?: any | null | undefined }> };

export type TixGetPerformerSearchByNameQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type TixGetPerformerSearchByNameQuery = { __typename?: 'query_root', Performer: Array<{ __typename?: 'Performer', performerId: any, title?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, companyId?: any | null | undefined, additionalInfo?: string | null | undefined, state?: string | null | undefined, updatedBy: any, updatedAt: any }> };

export type TixTicketNodeFragment = { __typename?: 'Ticket', state?: string | null | undefined, venueFee?: any | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, discountAmount?: any | null | undefined, checkedInAt?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketType?: string | null | undefined, ticketNo?: string | null | undefined, reservationNo?: string | null | undefined, section?: string | null | undefined, ticketId: any, ticketPrice?: any | null | undefined, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, dob?: any | null | undefined, fullName?: string | null | undefined, customer?: { __typename?: 'Customer', city?: string | null | undefined, streetAddress?: string | null | undefined, stateProvince?: string | null | undefined, countryCode?: string | null | undefined, postalCode?: string | null | undefined, emailAddress?: string | null | undefined, customerFullName?: string | null | undefined, dob?: any | null | undefined, phoneNumber?: string | null | undefined, phoneCountryCode?: string | null | undefined } | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined } | null | undefined }> } | null | undefined, ticketConfig?: { __typename?: 'TicketConfig', name?: string | null | undefined } | null | undefined, reservation?: { __typename?: 'ticket_reservation', totalAmountPaid?: any | null | undefined, groupCode?: string | null | undefined, reservationId: any, reservationDate?: any | null | undefined, discountAmount?: any | null | undefined } | null | undefined };

export type TixGetReservationStatsByPkQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetReservationStatsByPkQuery = { __typename?: 'query_root', Reservation: Array<{ __typename?: 'ticket_reservation', reservationId: any, groupCode?: string | null | undefined, tickets: Array<{ __typename?: 'Ticket', state?: string | null | undefined, venueFee?: any | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, discountAmount?: any | null | undefined, checkedInAt?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketType?: string | null | undefined, ticketNo?: string | null | undefined, reservationNo?: string | null | undefined, section?: string | null | undefined, ticketId: any, ticketPrice?: any | null | undefined, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, dob?: any | null | undefined, fullName?: string | null | undefined, customer?: { __typename?: 'Customer', city?: string | null | undefined, streetAddress?: string | null | undefined, stateProvince?: string | null | undefined, countryCode?: string | null | undefined, postalCode?: string | null | undefined, emailAddress?: string | null | undefined, customerFullName?: string | null | undefined, dob?: any | null | undefined, phoneNumber?: string | null | undefined, phoneCountryCode?: string | null | undefined } | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined } | null | undefined }> } | null | undefined, ticketConfig?: { __typename?: 'TicketConfig', name?: string | null | undefined } | null | undefined, reservation?: { __typename?: 'ticket_reservation', totalAmountPaid?: any | null | undefined, groupCode?: string | null | undefined, reservationId: any, reservationDate?: any | null | undefined, discountAmount?: any | null | undefined } | null | undefined }> }>, pendingReservationStats: { __typename?: 'ticket_reservation_aggregate', nodes: Array<{ __typename?: 'ticket_reservation', totalAmountPaid?: any | null | undefined, reservationId: any, tickets: Array<{ __typename?: 'Ticket', state?: string | null | undefined, venueFee?: any | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, discountAmount?: any | null | undefined, checkedInAt?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketType?: string | null | undefined, ticketNo?: string | null | undefined, reservationNo?: string | null | undefined, section?: string | null | undefined, ticketId: any, ticketPrice?: any | null | undefined, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, dob?: any | null | undefined, fullName?: string | null | undefined, customer?: { __typename?: 'Customer', city?: string | null | undefined, streetAddress?: string | null | undefined, stateProvince?: string | null | undefined, countryCode?: string | null | undefined, postalCode?: string | null | undefined, emailAddress?: string | null | undefined, customerFullName?: string | null | undefined, dob?: any | null | undefined, phoneNumber?: string | null | undefined, phoneCountryCode?: string | null | undefined } | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined } | null | undefined }> } | null | undefined, ticketConfig?: { __typename?: 'TicketConfig', name?: string | null | undefined } | null | undefined, reservation?: { __typename?: 'ticket_reservation', totalAmountPaid?: any | null | undefined, groupCode?: string | null | undefined, reservationId: any, reservationDate?: any | null | undefined, discountAmount?: any | null | undefined } | null | undefined }>, tickets_aggregate: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } }> }, refundedReservationStats: { __typename?: 'ticket_reservation_aggregate', nodes: Array<{ __typename?: 'ticket_reservation', totalAmountPaid?: any | null | undefined, reservationId: any, tickets: Array<{ __typename?: 'Ticket', state?: string | null | undefined, venueFee?: any | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, discountAmount?: any | null | undefined, checkedInAt?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketType?: string | null | undefined, ticketNo?: string | null | undefined, reservationNo?: string | null | undefined, section?: string | null | undefined, ticketId: any, ticketPrice?: any | null | undefined, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, dob?: any | null | undefined, fullName?: string | null | undefined, customer?: { __typename?: 'Customer', city?: string | null | undefined, streetAddress?: string | null | undefined, stateProvince?: string | null | undefined, countryCode?: string | null | undefined, postalCode?: string | null | undefined, emailAddress?: string | null | undefined, customerFullName?: string | null | undefined, dob?: any | null | undefined, phoneNumber?: string | null | undefined, phoneCountryCode?: string | null | undefined } | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined } | null | undefined }> } | null | undefined, ticketConfig?: { __typename?: 'TicketConfig', name?: string | null | undefined } | null | undefined, reservation?: { __typename?: 'ticket_reservation', totalAmountPaid?: any | null | undefined, groupCode?: string | null | undefined, reservationId: any, reservationDate?: any | null | undefined, discountAmount?: any | null | undefined } | null | undefined }>, tickets_aggregate: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } }> }, checkedInReservationStats: { __typename?: 'ticket_reservation_aggregate', nodes: Array<{ __typename?: 'ticket_reservation', totalAmountPaid?: any | null | undefined, reservationId: any, tickets: Array<{ __typename?: 'Ticket', state?: string | null | undefined, venueFee?: any | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, discountAmount?: any | null | undefined, checkedInAt?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketType?: string | null | undefined, ticketNo?: string | null | undefined, reservationNo?: string | null | undefined, section?: string | null | undefined, ticketId: any, ticketPrice?: any | null | undefined, contact?: { __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, dob?: any | null | undefined, fullName?: string | null | undefined, customer?: { __typename?: 'Customer', city?: string | null | undefined, streetAddress?: string | null | undefined, stateProvince?: string | null | undefined, countryCode?: string | null | undefined, postalCode?: string | null | undefined, emailAddress?: string | null | undefined, customerFullName?: string | null | undefined, dob?: any | null | undefined, phoneNumber?: string | null | undefined, phoneCountryCode?: string | null | undefined } | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber?: string | null | undefined } | null | undefined }> } | null | undefined, ticketConfig?: { __typename?: 'TicketConfig', name?: string | null | undefined } | null | undefined, reservation?: { __typename?: 'ticket_reservation', totalAmountPaid?: any | null | undefined, groupCode?: string | null | undefined, reservationId: any, reservationDate?: any | null | undefined, discountAmount?: any | null | undefined } | null | undefined }>, tickets_aggregate: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } }> } };

export type TixGetSlugByEventInstanceIdQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetSlugByEventInstanceIdQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', slug?: string | null | undefined }> };

export type TixGetTicketConfigDropdownListByVenueIdQueryVariables = Exact<{
  venueId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetTicketConfigDropdownListByVenueIdQuery = { __typename?: 'query_root', VenueTicket: Array<{ __typename?: 'VenueTicket', name?: string | null | undefined, state?: string | null | undefined, totalSeats?: number | null | undefined, updatedAt: any, updatedBy: any, venueId?: any | null | undefined, venueTicketId: any, description?: string | null | undefined, Configurations: Array<{ __typename?: 'VenueTicketConfig', state?: string | null | undefined, ticketConfigId?: any | null | undefined, updatedAt?: any | null | undefined, updatedBy?: any | null | undefined, venueTicketConfig: any, venueTicketId?: any | null | undefined, TicketConfigurations?: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, salesChannel?: string | null | undefined, name?: string | null | undefined, noOfSeats?: number | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId: any, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, ticketPrice?: any | null | undefined, ticketType?: string | null | undefined, updatedAt: any, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, updatedBy: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined } | null | undefined }>, Configurations_aggregate: { __typename?: 'VenueTicketConfig_aggregate', aggregate?: { __typename?: 'VenueTicketConfig_aggregate_fields', count: number } | null | undefined } }> };

export type TixGetTicketsSoldForTicketConfigQueryVariables = Exact<{
  ticketConfigId: Scalars['uuid'];
}>;


export type TixGetTicketsSoldForTicketConfigQuery = { __typename?: 'query_root', TicketAggregate: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } };

export type TixGetUpcomingEventsByCompanyIdForEventAdminQueryVariables = Exact<{
  companyId: Scalars['uuid'];
  userId?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetUpcomingEventsByCompanyIdForEventAdminQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, name?: string | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, doorsOpen?: any | null | undefined, date?: any | null | undefined, venueId?: any | null | undefined, venue?: { __typename?: 'Venue', name: string } | null | undefined, eventTicketSalesMetrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, checked_in?: any | null | undefined, not_checked_in?: any | null | undefined, refunded?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined }> };

export type TixGetUpcomingEventsByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['uuid'];
}>;


export type TixGetUpcomingEventsByCompanyIdQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, name?: string | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, doorsOpen?: any | null | undefined, date?: any | null | undefined, venueId?: any | null | undefined, venue?: { __typename?: 'Venue', name: string } | null | undefined, eventTicketSalesMetrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, checked_in?: any | null | undefined, not_checked_in?: any | null | undefined, refunded?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined }> };

export type TixGetVenueDropdownListByCompanyIdQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetVenueDropdownListByCompanyIdQuery = { __typename?: 'query_root', Venue: Array<{ __typename?: 'Venue', venueId: any, name: string, state: string, events: Array<{ __typename?: 'EventInstance', eventAdmins?: Array<any> | null | undefined, event?: { __typename?: 'Event', state?: string | null | undefined } | null | undefined }>, configurationValues: Array<{ __typename?: 'VenueConfigurationValue', Value?: { __typename?: 'ConfigurationValue', value: string, Item?: { __typename?: 'ConfigurationItem', name: string } | null | undefined } | null | undefined }>, tickets_aggregate: { __typename?: 'VenueTicket_aggregate', aggregate?: { __typename?: 'VenueTicket_aggregate_fields', count: number } | null | undefined } }> };

export type TixGetTicketsBreakdownByEventInstanceIdQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  ticketName?: InputMaybe<Scalars['String']>;
}>;


export type TixGetTicketsBreakdownByEventInstanceIdQuery = { __typename?: 'query_root', checked_in: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined }, not_checked_in: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } };

export type TixInsertCampaignTrackingMutationVariables = Exact<{
  objects: Array<TixEventCampaignTrackingInsertInput> | TixEventCampaignTrackingInsertInput;
}>;


export type TixInsertCampaignTrackingMutation = { __typename?: 'mutation_root', insert_event_campaign_tracking?: { __typename?: 'event_campaign_tracking_mutation_response', returning: Array<{ __typename?: 'event_campaign_tracking', campaignCode?: string | null | undefined, campaignType?: string | null | undefined, campaign_name?: string | null | undefined, campaign_tracking_id: any, createdBy?: any | null | undefined, eventInstanceId?: any | null | undefined }> } | null | undefined };

export type TixInsertNewEventInstanceTicketConfigMutationVariables = Exact<{
  object: TixEventInstanceTicketConfigInsertInput;
}>;


export type TixInsertNewEventInstanceTicketConfigMutation = { __typename?: 'mutation_root', InsertEventInstanceTicketConfigOne?: { __typename?: 'EventInstanceTicketConfig', createdAt: any } | null | undefined };

export type TixInsertEventPerformersMutationVariables = Exact<{
  objects?: InputMaybe<Array<TixEventPerformersInsertInput> | TixEventPerformersInsertInput>;
}>;


export type TixInsertEventPerformersMutation = { __typename?: 'mutation_root', InsertEventPerformers?: { __typename?: 'EventPerformers_mutation_response', returning: Array<{ __typename?: 'EventPerformers', eventPerformerId: any, eventInstanceId: any, performerId: any, state: string, updatedBy: any, updatedAt: any }> } | null | undefined };

export type TixInsertSocialMediasMutationVariables = Exact<{
  objects: Array<TixSocialMediaInsertInput> | TixSocialMediaInsertInput;
}>;


export type TixInsertSocialMediasMutation = { __typename?: 'mutation_root', InsertSocialMedia?: { __typename?: 'SocialMedia_mutation_response', affected_rows: number } | null | undefined };

export type TixMarkEventAsDeletedMutationVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
  updatedBy: Scalars['uuid'];
}>;


export type TixMarkEventAsDeletedMutation = { __typename?: 'mutation_root', UpdateEventInstance?: { __typename?: 'EventInstance_mutation_response', affected_rows: number } | null | undefined };

export type TixUpdateEventAdminForEventMutationVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
  eventAdmins?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixUpdateEventAdminForEventMutation = { __typename?: 'mutation_root', UpdateEventInstanceByPK?: { __typename?: 'EventInstance', eventInstanceId: any } | null | undefined };

export type TixUpdateEventInstanceByPkMutationVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  additionalInfo?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  doorsOpen?: InputMaybe<Scalars['time']>;
  startTime?: InputMaybe<Scalars['time']>;
  endTime?: InputMaybe<Scalars['time']>;
  startSellingDate?: InputMaybe<Scalars['date']>;
  startSellingTime?: InputMaybe<Scalars['time']>;
  stopSellingDate?: InputMaybe<Scalars['date']>;
  stopSellingTime?: InputMaybe<Scalars['time']>;
  minimumAge?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  passcode?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  venueTicketId?: InputMaybe<Scalars['uuid']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  slug?: InputMaybe<Scalars['String']>;
  eventAdmins?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixUpdateEventInstanceByPkMutation = { __typename?: 'mutation_root', UpdateEventInstanceByPK?: { __typename?: 'EventInstance', eventInstanceId: any, eventId?: any | null | undefined, name?: string | null | undefined, type?: string | null | undefined, eventAdmins?: Array<any> | null | undefined, state?: string | null | undefined, slug?: string | null | undefined, description?: string | null | undefined, additionalInfo?: string | null | undefined, date?: any | null | undefined, doorsOpen?: any | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, minimumAge?: number | null | undefined, hidden?: boolean | null | undefined, passcode?: string | null | undefined, venueId?: any | null | undefined, venueTicketId?: any | null | undefined, updatedBy: any, updatedAt: any } | null | undefined };

export type TixUpdateEventByPkMutationVariables = Exact<{
  eventId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixUpdateEventByPkMutation = { __typename?: 'mutation_root', UpdateEventByPK?: { __typename?: 'Event', eventId: any, companyId?: any | null | undefined, name?: string | null | undefined, type?: string | null | undefined, state?: string | null | undefined, updatedBy: any, updatedAt: any } | null | undefined };

export type TixUpdateEventInstanceTicketByIdMutationVariables = Exact<{
  eventInstanceTicketId: Scalars['uuid'];
  _set?: InputMaybe<TixEventInstanceTicketSetInput>;
}>;


export type TixUpdateEventInstanceTicketByIdMutation = { __typename?: 'mutation_root', UpdateEventInstanceTicketByPK?: { __typename?: 'EventInstanceTicket', name: string } | null | undefined };

export type TixUpdateReservationTicketsStateMutationVariables = Exact<{
  reservationId: Scalars['uuid'];
  checked_in_at?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
}>;


export type TixUpdateReservationTicketsStateMutation = { __typename?: 'mutation_root', UpdateTicket?: { __typename?: 'Ticket_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Ticket', ticketId: any, contactId?: any | null | undefined, eventInstanceId?: any | null | undefined, state?: string | null | undefined }> } | null | undefined };

export type TixUpdateTicketStateMutationVariables = Exact<{
  ticketId: Scalars['uuid'];
  checked_in_at?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
}>;


export type TixUpdateTicketStateMutation = { __typename?: 'mutation_root', UpdateTicket?: { __typename?: 'Ticket_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Ticket', ticketId: any, contactId?: any | null | undefined, eventInstanceId?: any | null | undefined, state?: string | null | undefined }> } | null | undefined };

export type TixGetFeesForCompanyQueryVariables = Exact<{
  companyId: Scalars['uuid'];
}>;


export type TixGetFeesForCompanyQuery = { __typename?: 'query_root', fees: Array<{ __typename?: 'fees', feeId: any, companyId?: any | null | undefined, venueId?: any | null | undefined, amount: any, feeType: string, typeOfFee: string }> };

export type TixGetFeesForVenueQueryVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type TixGetFeesForVenueQuery = { __typename?: 'query_root', fees: Array<{ __typename?: 'fees', feeId: any, companyId?: any | null | undefined, venueId?: any | null | undefined, amount: any, feeType: string, typeOfFee: string }> };

export type TixGetGlobalFeesQueryVariables = Exact<{ [key: string]: never; }>;


export type TixGetGlobalFeesQuery = { __typename?: 'query_root', fees: Array<{ __typename?: 'fees', feeId: any, companyId?: any | null | undefined, venueId?: any | null | undefined, amount: any, feeType: string, typeOfFee: string }> };

export type TixGenericAddOrderToHoldMutationVariables = Exact<{
  items: Array<TixOrderHoldItemInput> | TixOrderHoldItemInput;
  userSessionId: Scalars['String'];
}>;


export type TixGenericAddOrderToHoldMutation = { __typename?: 'mutation_root', genericAddOrderToHold: boolean };

export type TixGetItemsAmountsSoldQueryVariables = Exact<{
  itemIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TixGetItemsAmountsSoldQuery = { __typename?: 'query_root', TicketConfig: Array<{ __typename?: 'TicketConfig', ticketConfigId: any, noOfSeats?: number | null | undefined, totalTicketsByType?: { __typename?: 'ticket_v_ticket_count_by_type', ticketsSold?: any | null | undefined } | null | undefined }>, EventProductSelect: Array<{ __typename?: 'EventProduct', eventProductId: any, quantity?: number | null | undefined, quantitySold?: number | null | undefined, quantityRemaining?: number | null | undefined }> };

export type TixGenericGetOrderItemsOnHoldByOtherUsersQueryVariables = Exact<{
  itemIds: Array<Scalars['String']> | Scalars['String'];
  userSessionId: Scalars['String'];
}>;


export type TixGenericGetOrderItemsOnHoldByOtherUsersQuery = { __typename?: 'query_root', genericGetOrderItemsOnHoldByOtherUsers: Array<{ __typename?: 'ExternalOrderHoldItemResult', id: string, quantity: number }> };

export type TixGenericGetOrderOnHoldQueryVariables = Exact<{
  userSessionId: Scalars['String'];
}>;


export type TixGenericGetOrderOnHoldQuery = { __typename?: 'query_root', genericGetOrderOnHold: Array<{ __typename?: 'OrderHoldItemResult', id: string, quantity: number, type: string, expiresAt?: number | null | undefined }> };

export type TixHoldItemFragment = { __typename?: 'OrderHoldItemResult', id: string, quantity: number, type: string, expiresAt?: number | null | undefined };

export type TixGenericRemoveOrderFromHoldMutationVariables = Exact<{
  userSessionId: Scalars['String'];
}>;


export type TixGenericRemoveOrderFromHoldMutation = { __typename?: 'mutation_root', genericRemoveOrderFromHold: boolean };

export type TixEventProductSelectSubscriptionSubscriptionVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
}>;


export type TixEventProductSelectSubscriptionSubscription = { __typename?: 'subscription_root', EventProductSelect: Array<{ __typename?: 'EventProduct', eventProductId: any, name?: string | null | undefined, state: string, price?: any | null | undefined, quantity?: number | null | undefined, quantitySold?: number | null | undefined, quantityRemaining?: number | null | undefined, tax?: any | null | undefined, salesChannel?: string | null | undefined, additionalInfo?: string | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, productId: any, EventProductMedia: Array<{ __typename?: 'EventProductMedia', eventProductMediaImageFileId: any, MediaFile?: { __typename?: 'MediaFile', location: string, name: string, mediaFileId: any, state: string } | null | undefined }> }> };

export type TixEventProductSelectByPkSubscriptionVariables = Exact<{
  eventProductId: Scalars['uuid'];
}>;


export type TixEventProductSelectByPkSubscription = { __typename?: 'subscription_root', EventProductSelectByPK?: { __typename?: 'EventProduct', quantity?: number | null | undefined, quantitySold?: number | null | undefined, quantityRemaining?: number | null | undefined } | null | undefined };

export type TixEventProductPullProductQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  _and?: InputMaybe<Array<TixProductBoolExp> | TixProductBoolExp>;
}>;


export type TixEventProductPullProductQuery = { __typename?: 'query_root', ProductSelect: Array<{ __typename?: 'Product', name?: string | null | undefined, state: string, quantity?: number | null | undefined, price?: any | null | undefined, tax?: any | null | undefined, productId: any, additionalInformation?: string | null | undefined, productMedia: Array<{ __typename?: 'ProductMediaFile', mediaFile?: { __typename?: 'MediaFile', location: string, name: string, fileType?: string | null | undefined } | null | undefined }> }> };

export type TixBuyerProductFragmentFragment = { __typename?: 'EventProduct', eventProductId: any, name?: string | null | undefined, price?: any | null | undefined, quantity?: number | null | undefined, quantitySold?: number | null | undefined, quantityRemaining?: number | null | undefined, tax?: any | null | undefined, state: string, salesChannel?: string | null | undefined, additionalInfo?: string | null | undefined, productId: any, EventProductMedia: Array<{ __typename?: 'EventProductMedia', MediaFile?: { __typename?: 'MediaFile', location: string, name: string } | null | undefined }> };

export type TixEventProductSelectQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  today?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixEventProductSelectQuery = { __typename?: 'query_root', EventProductSelect: Array<{ __typename?: 'EventProduct', eventProductId: any, name?: string | null | undefined, price?: any | null | undefined, quantity?: number | null | undefined, quantitySold?: number | null | undefined, quantityRemaining?: number | null | undefined, tax?: any | null | undefined, state: string, salesChannel?: string | null | undefined, additionalInfo?: string | null | undefined, productId: any, EventProductMedia: Array<{ __typename?: 'EventProductMedia', MediaFile?: { __typename?: 'MediaFile', location: string, name: string } | null | undefined }> }> };

export type TixEventProductSelectTodaySubscriptionSubscriptionVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
  today?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixEventProductSelectTodaySubscriptionSubscription = { __typename?: 'subscription_root', EventProductSelect: Array<{ __typename?: 'EventProduct', eventProductId: any, name?: string | null | undefined, price?: any | null | undefined, quantity?: number | null | undefined, quantitySold?: number | null | undefined, quantityRemaining?: number | null | undefined, tax?: any | null | undefined, salesChannel?: string | null | undefined, additionalInfo?: string | null | undefined, productId: any, EventProductMedia: Array<{ __typename?: 'EventProductMedia', MediaFile?: { __typename?: 'MediaFile', location: string, name: string } | null | undefined }> }> };

export type TixEventProductInsertMutationVariables = Exact<{
  eventProducts: Array<TixEventProductInsertInput> | TixEventProductInsertInput;
  mediaFiles: Array<TixEventProductMediaInsertInput> | TixEventProductMediaInsertInput;
}>;


export type TixEventProductInsertMutation = { __typename?: 'mutation_root', EventProductInsert?: { __typename?: 'EventProduct_mutation_response', affected_rows: number } | null | undefined, EventProductMediaInsert?: { __typename?: 'EventProductMedia_mutation_response', affected_rows: number } | null | undefined };

export type TixEventProductMediaInsertOneMutationVariables = Exact<{
  eventProductId?: InputMaybe<Scalars['uuid']>;
  eventProductMediaImageFileId?: InputMaybe<Scalars['uuid']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  mediaFile?: InputMaybe<TixMediaFileObjRelInsertInput>;
}>;


export type TixEventProductMediaInsertOneMutation = { __typename?: 'mutation_root', EventProductMediaInsertOne?: { __typename?: 'EventProductMedia', eventProductMediaImageFileId: any, MediaFile?: { __typename?: 'MediaFile', fileType?: string | null | undefined, location: string, mediaFileId: any, name: string, state: string } | null | undefined } | null | undefined };

export type TixOrderedEventProductsMutationVariables = Exact<{
  updatedEventProducts: Array<TixEventProductUpdates> | TixEventProductUpdates;
  order: TixOrderInsertInput;
  productOrderDetail: Array<TixProductOrderDetailInsertInput> | TixProductOrderDetailInsertInput;
}>;


export type TixOrderedEventProductsMutation = { __typename?: 'mutation_root', EventProductUpdateMany?: Array<{ __typename?: 'EventProduct_mutation_response', affected_rows: number } | null | undefined> | null | undefined, OrderInsertOne?: { __typename?: 'Order', orderId: any } | null | undefined, insert_product_order_detail?: { __typename?: 'product_order_detail_mutation_response', affected_rows: number } | null | undefined };

export type TixEventProductSoftDeleteMutationVariables = Exact<{
  eventProductId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixEventProductSoftDeleteMutation = { __typename?: 'mutation_root', EventProductUpdate?: { __typename?: 'EventProduct_mutation_response', returning: Array<{ __typename?: 'EventProduct', eventInstanceId: any, eventProductId: any, productId: any }> } | null | undefined };

export type TixEventProductEventProductMediaDeleteMutationVariables = Exact<{
  eventProductMediaImageFileId: Scalars['uuid'];
  mediaFileId: Scalars['uuid'];
}>;


export type TixEventProductEventProductMediaDeleteMutation = { __typename?: 'mutation_root', EventProductMediaDeleteByPK?: { __typename?: 'EventProductMedia', mediaFileId: any } | null | undefined, DeleteMediaFileByPK?: { __typename?: 'MediaFile', mediaFileId: any } | null | undefined };

export type TixEventProductUpdateMutationVariables = Exact<{
  _set?: InputMaybe<TixEventProductSetInput>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixEventProductUpdateMutation = { __typename?: 'mutation_root', EventProductUpdate?: { __typename?: 'EventProduct_mutation_response', returning: Array<{ __typename?: 'EventProduct', additionalInfo?: string | null | undefined, eventInstanceId: any, eventProductId: any, price?: any | null | undefined, name?: string | null | undefined, productId: any, quantity?: number | null | undefined, quantitySold?: number | null | undefined, quantityRemaining?: number | null | undefined, salesChannel?: string | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, state: string, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, tax?: any | null | undefined, EventProductMedia: Array<{ __typename?: 'EventProductMedia', MediaFile?: { __typename?: 'MediaFile', location: string, name: string } | null | undefined }> }> } | null | undefined };

export type TixEventProductPingMutationVariables = Exact<{
  _set?: InputMaybe<TixEventProductSetInput>;
  eventProductId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixEventProductPingMutation = { __typename?: 'mutation_root', EventProductUpdate?: { __typename?: 'EventProduct_mutation_response', returning: Array<{ __typename?: 'EventProduct', additionalInfo?: string | null | undefined, eventInstanceId: any, eventProductId: any, price?: any | null | undefined }> } | null | undefined };

export type TixProductFragmentFragment = { __typename?: 'Product', name?: string | null | undefined, state: string, quantity?: number | null | undefined, price?: any | null | undefined, tax?: any | null | undefined, productId: any, additionalInformation?: string | null | undefined, productMedia: Array<{ __typename?: 'ProductMediaFile', mediaFile?: { __typename?: 'MediaFile', location: string } | null | undefined }> };

export type TixProductSelectAllQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
}>;


export type TixProductSelectAllQuery = { __typename?: 'query_root', ProductSelect: Array<{ __typename?: 'Product', name?: string | null | undefined, state: string, quantity?: number | null | undefined, price?: any | null | undefined, tax?: any | null | undefined, productId: any, additionalInformation?: string | null | undefined, productMedia: Array<{ __typename?: 'ProductMediaFile', mediaFile?: { __typename?: 'MediaFile', location: string } | null | undefined }> }> };

export type TixProductSelectOneQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
}>;


export type TixProductSelectOneQuery = { __typename?: 'query_root', ProductSelect: Array<{ __typename?: 'Product', name?: string | null | undefined, state: string, quantity?: number | null | undefined, price?: any | null | undefined, tax?: any | null | undefined, productId: any, additionalInformation?: string | null | undefined, productMedia: Array<{ __typename?: 'ProductMediaFile', productMediaImageFileId: any, mediaFile?: { __typename?: 'MediaFile', location: string, name: string, mediaFileId: any } | null | undefined }>, VenueProduct: Array<{ __typename?: 'VenueProduct', productId: any, venueId: any, VenueProductVenue?: { __typename?: 'Venue', name: string, venueId: any } | null | undefined }> }> };

export type TixProductCompanyVenuesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixProductCompanyVenuesQuery = { __typename?: 'query_root', Venue: Array<{ __typename?: 'Venue', name: string, description?: string | null | undefined, state: string, venueId: any }> };

export type TixProductInsertOneMutationVariables = Exact<{
  additionalInformation?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['money']>;
  createdBy: Scalars['uuid'];
  updatedBy?: InputMaybe<Scalars['uuid']>;
  companyId?: InputMaybe<Scalars['uuid']>;
  venueId?: InputMaybe<Scalars['uuid']>;
  data: Array<TixVenueProductInsertInput> | TixVenueProductInsertInput;
}>;


export type TixProductInsertOneMutation = { __typename?: 'mutation_root', ProductInsertOne?: { __typename?: 'Product', name?: string | null | undefined, state: string, quantity?: number | null | undefined, price?: any | null | undefined, tax?: any | null | undefined, productId: any, additionalInformation?: string | null | undefined, createdBy: any, updatedBy: any } | null | undefined };

export type TixProductMediaFileInsertOneMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['uuid']>;
  productMediaImageFileId?: InputMaybe<Scalars['uuid']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  mediaFile?: InputMaybe<TixMediaFileObjRelInsertInput>;
}>;


export type TixProductMediaFileInsertOneMutation = { __typename?: 'mutation_root', ProductMediaFileInsertOne?: { __typename?: 'ProductMediaFile', mediaFile?: { __typename?: 'MediaFile', fileType?: string | null | undefined, location: string, mediaFileId: any, name: string, state: string } | null | undefined } | null | undefined };

export type TixRefundAddonsMutationVariables = Exact<{
  refund: TixRefundAddonsInput;
}>;


export type TixRefundAddonsMutation = { __typename?: 'mutation_root', refundAddons?: any | null | undefined };

export type TixProductSoftDeleteMutationVariables = Exact<{
  productId: Scalars['uuid'];
  updatedBy: Scalars['uuid'];
}>;


export type TixProductSoftDeleteMutation = { __typename?: 'mutation_root', ProductUpdate?: { __typename?: 'Product_mutation_response', returning: Array<{ __typename?: 'Product', productId: any }> } | null | undefined };

export type TixProductMediaFileDeleteByPkMutationVariables = Exact<{
  productMediaImageFileId: Scalars['uuid'];
  mediaFileId: Scalars['uuid'];
}>;


export type TixProductMediaFileDeleteByPkMutation = { __typename?: 'mutation_root', ProductMediaFileDeleteByPK?: { __typename?: 'ProductMediaFile', createdBy: any, productId: any, productMediaImageFileId: any } | null | undefined, DeleteMediaFileByPK?: { __typename?: 'MediaFile', mediaFileId: any } | null | undefined };

export type TixProductUpdateMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['uuid']>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['money']>;
  updatedBy?: InputMaybe<Scalars['uuid']>;
  data: Array<TixVenueProductInsertInput> | TixVenueProductInsertInput;
}>;


export type TixProductUpdateMutation = { __typename?: 'mutation_root', VenueProductDelete?: { __typename?: 'VenueProduct_mutation_response', affected_rows: number } | null | undefined, ProductUpdate?: { __typename?: 'Product_mutation_response', returning: Array<{ __typename?: 'Product', name?: string | null | undefined, state: string, quantity?: number | null | undefined, price?: any | null | undefined, tax?: any | null | undefined, productId: any, additionalInformation?: string | null | undefined }> } | null | undefined, VenueProductInsert?: { __typename?: 'VenueProduct_mutation_response', affected_rows: number } | null | undefined };

export type TixConfirmReservationMutationVariables = Exact<{
  method: TixPaymentMethod;
  reservationId: Scalars['String'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
}>;


export type TixConfirmReservationMutation = { __typename?: 'mutation_root', confirmReservation: boolean };

export type TixCreatePaymentIntentForOrderMutationVariables = Exact<{
  eventInstanceId: Scalars['String'];
  order: TixOrderInput;
}>;


export type TixCreatePaymentIntentForOrderMutation = { __typename?: 'mutation_root', createPaymentIntentForOrder: { __typename?: 'PaymentIntentResult', clientSecret: string, paymentIntentId: string } };

export type TixCreateUnconfirmedReservationMutationVariables = Exact<{
  customer: TixCustomerInput;
  eventInstanceId: Scalars['String'];
  order: TixOrderInput;
  paymentIntentId?: InputMaybe<Scalars['String']>;
}>;


export type TixCreateUnconfirmedReservationMutation = { __typename?: 'mutation_root', createUnconfirmedReservation: string };

export type TixGetAmountToPayForOrderQueryVariables = Exact<{
  order: TixOrderInput;
  eventInstanceId: Scalars['String'];
}>;


export type TixGetAmountToPayForOrderQuery = { __typename?: 'query_root', getAmountToPayForOrder: number };

export type TixDeleteSavedReportMutationVariables = Exact<{
  savedReportId: Scalars['uuid'];
}>;


export type TixDeleteSavedReportMutation = { __typename?: 'mutation_root', delete_savedReportLayout?: { __typename?: 'savedReportLayout_mutation_response', affected_rows: number } | null | undefined, delete_savedReportEvents?: { __typename?: 'savedReportEvents_mutation_response', affected_rows: number } | null | undefined, delete_savedReport?: { __typename?: 'savedReport_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteSavedScheduleMutationVariables = Exact<{
  scheduledReportId: Scalars['uuid'];
}>;


export type TixDeleteSavedScheduleMutation = { __typename?: 'mutation_root', delete_scheduledReportEmail?: { __typename?: 'scheduledReportEmail_mutation_response', affected_rows: number } | null | undefined, delete_scheduledReport?: { __typename?: 'scheduledReport_mutation_response', affected_rows: number } | null | undefined };

export type TixGetEventsByVenueIdsQueryVariables = Exact<{
  venueIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type TixGetEventsByVenueIdsQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, name?: string | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, doorsOpen?: any | null | undefined, date?: any | null | undefined, venueId?: any | null | undefined }> };

export type TixGetDailyAuditReportQueryVariables = Exact<{
  eventInstanceIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetDailyAuditReportQuery = { __typename?: 'query_root', DailyAuditReportFinal: Array<{ __typename?: 'DailyAuditReportFinal', companyName?: string | null | undefined, eventInstanceId?: any | null | undefined, formattedDate?: string | null | undefined, formattedStartTime?: string | null | undefined, name?: string | null | undefined, parentTicketName?: string | null | undefined, performance?: string | null | undefined, performanceDate?: string | null | undefined, rawDate?: any | null | undefined, rawStartTime?: any | null | undefined, todayCashAmount?: any | null | undefined, todayCashCount?: any | null | undefined, todayCompAmount?: any | null | undefined, todayCompCount?: any | null | undefined, todayRefundAmount?: any | null | undefined, todayRefundCount?: any | null | undefined, todayTotalDiscountAmount?: any | null | undefined, todayTotalDiscountCount?: any | null | undefined, todayTotalTicketSalesAmount?: any | null | undefined, todayTotalTicketSalesAmountOverall?: any | null | undefined, todayTotalTicketSalesCount?: any | null | undefined, todayTotalTicketSalesCountOverall?: any | null | undefined, totalBoxofficeTicketAmount?: any | null | undefined, totalBoxofficeTicketCount?: any | null | undefined, totalCashAmount?: any | null | undefined, totalCashCount?: any | null | undefined, totalCompAmount?: any | null | undefined, totalCompCount?: any | null | undefined, totalDiscountAmount?: any | null | undefined, totalDiscountCount?: any | null | undefined, totalOnlineTicketAmount?: any | null | undefined, totalOnlineTicketCount?: any | null | undefined, totalRefundAmount?: any | null | undefined, totalRefundCount?: any | null | undefined, totalTicketSalesAmount?: any | null | undefined, totalTicketSalesAmountOverall?: any | null | undefined, totalTicketSalesCount?: any | null | undefined, totalTicketSalesCountOverall?: any | null | undefined, totalTicketsForSale?: number | null | undefined, venueName?: string | null | undefined, yesterdayCashAmount?: any | null | undefined, yesterdayCashCount?: any | null | undefined, yesterdayDiscountAmount?: any | null | undefined, yesterdayDiscountCount?: any | null | undefined, yesterdayRefundAmount?: any | null | undefined, yesterdayRefundCount?: any | null | undefined, yesterdayTotalTicketSalesAmount?: any | null | undefined, yesterdayTotalTicketSalesAmountOverall?: any | null | undefined, yesterdayTotalTicketSalesCount?: any | null | undefined, yesterdayTotalTicketSalesCountOverall?: any | null | undefined, platformFeeTotalByTicket?: any | null | undefined, processingFeeTotalByTicket?: any | null | undefined, ticketConfigId?: any | null | undefined, totalFeesByTicket?: any | null | undefined, totalTicketsAvailable?: any | null | undefined, venueFeeTotalByTicket?: any | null | undefined }> };

export type TixGetDiscountCodesReportQueryVariables = Exact<{
  eventInstanceIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  discountIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['date']>;
  endDate?: InputMaybe<Scalars['date']>;
}>;


export type TixGetDiscountCodesReportQuery = { __typename?: 'query_root', DiscountReport: Array<{ __typename?: 'reporting_v_discount_report', appliedTo?: string | null | undefined, companyId?: any | null | undefined, companyName?: string | null | undefined, dateUsed?: any | null | undefined, discountAmountPerTicket?: any | null | undefined, discountCode?: string | null | undefined, discountId?: any | null | undefined, discountDescription?: string | null | undefined, eventDate?: string | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventStartTime?: string | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, salesChannel?: string | null | undefined, ticketId?: any | null | undefined, ticketNo?: string | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined }> };

export type TixGetDiscountCodesQueryVariables = Exact<{
  venueIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  eventInstanceIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['date']>;
  endDate?: InputMaybe<Scalars['date']>;
}>;


export type TixGetDiscountCodesQuery = { __typename?: 'query_root', Discount: Array<{ __typename?: 'Discount', discountId: any, endDate?: any | null | undefined, endTime?: any | null | undefined, startDate?: any | null | undefined, startTime?: any | null | undefined, appliedTo?: string | null | undefined, discountCode: string, type?: string | null | undefined }> };

export type TixGetDiscountsByIdQueryVariables = Exact<{
  discountIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetDiscountsByIdQuery = { __typename?: 'query_root', Discount: Array<{ __typename?: 'Discount', discountCode: string, discountId: any }> };

export type TixGetSavedReportsQueryVariables = Exact<{
  companyId: Scalars['uuid'];
  reportType?: InputMaybe<Scalars['String']>;
}>;


export type TixGetSavedReportsQuery = { __typename?: 'query_root', savedReport: Array<{ __typename?: 'savedReport', reportName: string, savedReportId: any, venueId: any, reportVenueIds?: Array<any> | null | undefined, discountCodeId?: Array<any> | null | undefined, discountEndDate?: any | null | undefined, discountStartDate?: any | null | undefined, level?: string | null | undefined, reportType?: string | null | undefined, visibility?: string | null | undefined, createdBy: any, updatedBy: any, savedReportEvents: Array<{ __typename?: 'savedReportEvents', eventInstanceId: any, savedReportEventsId: any, savedReportId: any }>, savedReportLayouts: Array<{ __typename?: 'savedReportLayout', includedColumnName: string, savedReportLayoutId: any }>, scheduledReports: Array<{ __typename?: 'scheduledReport', frequency: string, scheduledReportId: any, scheduleName: string, startSendingTimestamp: any, stopSendingTimestamp: any, timeOfDay: any, timezone: string, scheduledReportEmails: Array<{ __typename?: 'scheduledReportEmail', emailAddress: string, scheduledReportEmailId: any, scheduleReportId: any }> }> }> };

export type TixInsertSavedReportsMutationVariables = Exact<{
  objects: Array<TixSavedReportInsertInput> | TixSavedReportInsertInput;
}>;


export type TixInsertSavedReportsMutation = { __typename?: 'mutation_root', insert_savedReport?: { __typename?: 'savedReport_mutation_response', returning: Array<{ __typename?: 'savedReport', venueId: any, companyId: any, createdAt: any, reportVenueIds?: Array<any> | null | undefined, discountCodeId?: Array<any> | null | undefined, discountEndDate?: any | null | undefined, discountStartDate?: any | null | undefined, createdBy: any, reportName: string, savedReportId: any, updatedBy: any, updatedAt: any, level?: string | null | undefined, reportType?: string | null | undefined, visibility?: string | null | undefined, savedReportEvents: Array<{ __typename?: 'savedReportEvents', savedReportEventsId: any, eventInstanceId: any, savedReportId: any, createdAt: any, createdBy: any, updatedAt: any, updatedBy: any }>, savedReportLayouts: Array<{ __typename?: 'savedReportLayout', createdAt: any, createdBy: any, includedColumnName: string, savedReportId: any, savedReportLayoutId: any, updatedAt: any, updatedBy: any }>, scheduledReports: Array<{ __typename?: 'scheduledReport', createdAt: any, createdBy: any, frequency: string, savedReportId: any, scheduledReportId: any, startSendingTimestamp: any, stopSendingTimestamp: any, timezone: string, scheduleName: string, timeOfDay: any, updatedAt: any, updatedBy: any, scheduledReportEmails: Array<{ __typename?: 'scheduledReportEmail', emailAddress: string, scheduledReportEmailId: any, scheduleReportId: any, createdAt: any, createdBy: any }> }> }> } | null | undefined };

export type TixUpdateSavedReportMutationVariables = Exact<{
  savedReportId: Scalars['uuid'];
  UpdatedReport: TixSavedReportSetInput;
  UpdatedReportLayout: TixSavedReportLayoutSetInput;
  newReportEvents: Array<TixSavedReportEventsInsertInput> | TixSavedReportEventsInsertInput;
}>;


export type TixUpdateSavedReportMutation = { __typename?: 'mutation_root', update_savedReport?: { __typename?: 'savedReport_mutation_response', returning: Array<{ __typename?: 'savedReport', reportType?: string | null | undefined, savedReportId: any, discountCodeId?: Array<any> | null | undefined, discountEndDate?: any | null | undefined, discountStartDate?: any | null | undefined, reportName: string, updatedAt: any, updatedBy: any, level?: string | null | undefined, visibility?: string | null | undefined }> } | null | undefined, update_savedReportLayout?: { __typename?: 'savedReportLayout_mutation_response', returning: Array<{ __typename?: 'savedReportLayout', includedColumnName: string }> } | null | undefined, delete_savedReportEvents?: { __typename?: 'savedReportEvents_mutation_response', affected_rows: number } | null | undefined, insert_savedReportEvents?: { __typename?: 'savedReportEvents_mutation_response', returning: Array<{ __typename?: 'savedReportEvents', eventInstanceId: any }> } | null | undefined };

export type TixGetCompanyReportQueryVariables = Exact<{
  companyId: Scalars['uuid'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type TixGetCompanyReportQuery = { __typename?: 'query_root', reservationSummaryReport: Array<{ __typename?: 'reservationSummaryReport', CompanyName?: string | null | undefined, companyId?: any | null | undefined, discount?: any | null | undefined, discountCode?: string | null | undefined, emailAddress?: string | null | undefined, eventDate?: any | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventState?: string | null | undefined, formattedEventDate?: string | null | undefined, formattedReservationDate?: string | null | undefined, formattedStartTime?: string | null | undefined, fullName?: string | null | undefined, paymentState?: string | null | undefined, paymentType?: string | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, refundAmount?: any | null | undefined, reservationDate?: any | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationState?: string | null | undefined, salesChannel?: string | null | undefined, startTime?: any | null | undefined, subTotal?: any | null | undefined, ticketCount?: any | null | undefined, ticketType?: string | null | undefined, totalAmountPaid?: any | null | undefined, totalRevenue?: any | null | undefined, venueFee?: any | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined }> };

export type TixGetEventReportQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetEventReportQuery = { __typename?: 'query_root', ticket_v_ticket_sales_metrics: Array<{ __typename?: 'ticket_v_ticket_sales_metrics', total_seats?: number | null | undefined, available?: any | null | undefined, checked_in?: any | null | undefined, not_checked_in?: any | null | undefined }>, reservationDetailReport: Array<{ __typename?: 'reservationDetailReport', companyName?: string | null | undefined, venueName?: string | null | undefined, eventName?: string | null | undefined, eventInstanceId?: any | null | undefined, date?: string | null | undefined, startTime?: string | null | undefined, reservationNo?: string | null | undefined, paymentToken?: string | null | undefined, emailAddress?: string | null | undefined, reservationDate?: string | null | undefined, ticketId?: any | null | undefined, noOfTickets?: number | null | undefined, ticketPrice?: any | null | undefined, totalAmountPaid?: any | null | undefined, stripeFeePaid?: any | null | undefined, platformFee?: any | null | undefined, venueFee?: any | null | undefined, ticketNo?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, ticketType?: string | null | undefined }> };

export type TixGetEventSummaryReportQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetEventSummaryReportQuery = { __typename?: 'query_root', reservationSummaryReport: Array<{ __typename?: 'reservationSummaryReport', CompanyName?: string | null | undefined, companyId?: any | null | undefined, discount?: any | null | undefined, discountCode?: string | null | undefined, emailAddress?: string | null | undefined, eventDate?: any | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventState?: string | null | undefined, formattedEventDate?: string | null | undefined, formattedReservationDate?: string | null | undefined, formattedStartTime?: string | null | undefined, fullName?: string | null | undefined, paymentState?: string | null | undefined, paymentType?: string | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, refundAmount?: any | null | undefined, reservationDate?: any | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationState?: string | null | undefined, salesChannel?: string | null | undefined, startTime?: any | null | undefined, subTotal?: any | null | undefined, ticketCount?: any | null | undefined, ticketType?: string | null | undefined, totalAmountPaid?: any | null | undefined, totalRevenue?: any | null | undefined, venueFee?: any | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined }> };

export type TixGetNightlyCloseoutReportQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetNightlyCloseoutReportQuery = { __typename?: 'query_root', EventInstanceByPK?: { __typename?: 'EventInstance', name?: string | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined, DiscountCodeCount: Array<{ __typename?: 'DiscountCodeCountByEvent', discountCode?: string | null | undefined, discountType?: string | null | undefined, discountsUsed?: any | null | undefined, discountAmount?: any | null | undefined }>, EventTicketCount: Array<{ __typename?: 'TicketCountByEvent', ticketCount?: any | null | undefined, ticketName?: string | null | undefined, ticketType?: string | null | undefined, ticketSection?: string | null | undefined }>, Refunds: Array<{ __typename?: 'reporting_v_refunds_by_event', contactId?: any | null | undefined, refundAmount?: any | null | undefined, ticketCount?: any | null | undefined, state?: string | null | undefined }>, RevenueByChannelType: Array<{ __typename?: 'RevenueByChannelType', fullName?: string | null | undefined, paymentType?: string | null | undefined, salesChannel?: string | null | undefined, totalRevenue?: any | null | undefined }> } | null | undefined };

export type TixGetProductSalesReportForCsvQueryVariables = Exact<{
  columns: Array<TixProductSalesColumn> | TixProductSalesColumn;
  reportLevel?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type TixGetProductSalesReportForCsvQuery = { __typename?: 'query_root', getProductSalesReportForCsv: string };

export type TixGetProductSalesReportQueryVariables = Exact<{
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  venueId?: InputMaybe<Scalars['String']>;
  eventInstanceId?: InputMaybe<Scalars['String']>;
}>;


export type TixGetProductSalesReportQuery = { __typename?: 'query_root', getProductSalesReport: Array<{ __typename?: 'ProductSalesReport', comment: string, orderDetailId: string, reservationNo: string, customerName: string, customerEmail: string, quantity: number, productName: string, unitPrice: number, totalPrice: number, purchaseDate: string, eventName: string, venueName: string, orderId: string, state: string, processingFees: number, taxAmount: number, totalPaid: number }> };

export type TixGetTicketNamesByEventInstanceQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetTicketNamesByEventInstanceQuery = { __typename?: 'query_root', TicketCountByName: Array<{ __typename?: 'TicketCountByName', name?: string | null | undefined }> };

export type TixGetTicketByTypeReportQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
  ticketNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type TixGetTicketByTypeReportQuery = { __typename?: 'query_root', TicketCountByName: Array<{ __typename?: 'TicketCountByName', fullName?: string | null | undefined, name?: string | null | undefined, ticketCount?: any | null | undefined, venueName?: string | null | undefined, startTime?: string | null | undefined, date?: string | null | undefined, ticketType?: string | null | undefined }> };

export type TixGetUpcomingEventsSummaryReportQueryVariables = Exact<{
  companyId: Scalars['uuid'];
}>;


export type TixGetUpcomingEventsSummaryReportQuery = { __typename?: 'query_root', reservationSummaryReport: Array<{ __typename?: 'reservationSummaryReport', CompanyName?: string | null | undefined, companyId?: any | null | undefined, discount?: any | null | undefined, discountCode?: string | null | undefined, emailAddress?: string | null | undefined, eventDate?: any | null | undefined, eventInstanceId?: any | null | undefined, eventName?: string | null | undefined, eventState?: string | null | undefined, formattedEventDate?: string | null | undefined, formattedReservationDate?: string | null | undefined, formattedStartTime?: string | null | undefined, fullName?: string | null | undefined, paymentState?: string | null | undefined, paymentType?: string | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, refundAmount?: any | null | undefined, reservationDate?: any | null | undefined, reservationId?: any | null | undefined, reservationNo?: string | null | undefined, reservationState?: string | null | undefined, salesChannel?: string | null | undefined, startTime?: any | null | undefined, subTotal?: any | null | undefined, ticketCount?: any | null | undefined, ticketType?: string | null | undefined, totalAmountPaid?: any | null | undefined, totalRevenue?: any | null | undefined, venueFee?: any | null | undefined, venueId?: any | null | undefined, venueName?: string | null | undefined, TicketMetrics?: { __typename?: 'ticket_v_ticket_sales_metrics', total_seats?: number | null | undefined } | null | undefined }> };

export type TixTicketCountByRevenueTypeQueryVariables = Exact<{
  eventInstanceId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixTicketCountByRevenueTypeQuery = { __typename?: 'query_root', TicketCountByChannelType: Array<{ __typename?: 'TicketCountByChannelType', paymentType?: string | null | undefined, sales_channel?: string | null | undefined, ticketCount?: any | null | undefined, eventInstanceId?: any | null | undefined }> };

export type TixDeleteScheduledAuditReportMutationVariables = Exact<{
  scheduledReport: TixScheduledReportInput;
  scheduledReportId: Scalars['uuid'];
}>;


export type TixDeleteScheduledAuditReportMutation = { __typename?: 'mutation_root', delete_scheduledReportEmail?: { __typename?: 'scheduledReportEmail_mutation_response', affected_rows: number } | null | undefined, delete_scheduledReport?: { __typename?: 'scheduledReport_mutation_response', affected_rows: number } | null | undefined, deleteScheduledReportFromTheQueue: { __typename?: 'ScheduledReportObject', defaultRecipient?: string | null | undefined, time: string, zone: string, otherRecipients: string, eventId?: string | null | undefined } };

export type TixDeleteScheduledEventReportMutationVariables = Exact<{
  deletedValues: Array<TixConfigurationValueUpdates> | TixConfigurationValueUpdates;
  deletedEventConfigLinks: Array<TixEventInstanceConfigurationValueUpdates> | TixEventInstanceConfigurationValueUpdates;
  scheduledReport: TixScheduledReportInput;
}>;


export type TixDeleteScheduledEventReportMutation = { __typename?: 'mutation_root', update_ConfigurationValue_many?: Array<{ __typename?: 'ConfigurationValue_mutation_response', returning: Array<{ __typename?: 'ConfigurationValue', configurationValueId: any, value: string }> } | null | undefined> | null | undefined, UpdateEventInstanceConfigurationValueMany?: Array<{ __typename?: 'EventInstanceConfigurationValue_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'EventInstanceConfigurationValue', eventInstanceId: any, configurationValueId: any }> } | null | undefined> | null | undefined, deleteScheduledReportFromTheQueue: { __typename?: 'ScheduledReportObject', defaultRecipient?: string | null | undefined, time: string, zone: string, otherRecipients: string, eventId?: string | null | undefined } };

export type TixGetScheduledEventReportQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type TixGetScheduledEventReportQuery = { __typename?: 'query_root', ConfigurationItem: Array<{ __typename?: 'ConfigurationItem', configurationItemId: any, name: string, defaultValue?: string | null | undefined, elementType?: string | null | undefined, required?: boolean | null | undefined, helpText?: string | null | undefined, placeholder?: string | null | undefined }>, EventInstanceConfigurationValue: Array<{ __typename?: 'EventInstanceConfigurationValue', eventInstanceConfigurationId: any, value?: { __typename?: 'ConfigurationValue', configurationValueId: any, value: string } | null | undefined }> };

export type TixInsertScheduledAuditReportMutationVariables = Exact<{
  scheduledReport: TixScheduledReportInput;
  objects: Array<TixScheduledReportInsertInput> | TixScheduledReportInsertInput;
}>;


export type TixInsertScheduledAuditReportMutation = { __typename?: 'mutation_root', insert_scheduledReport?: { __typename?: 'scheduledReport_mutation_response', returning: Array<{ __typename?: 'scheduledReport', savedReportId: any, frequency: string, scheduledReportId: any, scheduleName: string, startSendingTimestamp: any, stopSendingTimestamp: any, timeOfDay: any, timezone: string, scheduledReportEmails: Array<{ __typename?: 'scheduledReportEmail', emailAddress: string, scheduleReportId: any }> }> } | null | undefined, insertScheduledReportToTheQueue: { __typename?: 'ScheduledReportObject', defaultRecipient?: string | null | undefined, time: string, zone: string, otherRecipients: string, eventId?: string | null | undefined } };

export type TixInsertScheduledEventReportMutationVariables = Exact<{
  configurationValues: Array<TixConfigurationValueInsertInput> | TixConfigurationValueInsertInput;
  eventInstanceConfigurationValues: Array<TixEventInstanceConfigurationValueInsertInput> | TixEventInstanceConfigurationValueInsertInput;
  scheduledReport: TixScheduledReportInput;
}>;


export type TixInsertScheduledEventReportMutation = { __typename?: 'mutation_root', InsertConfigurationValue?: { __typename?: 'ConfigurationValue_mutation_response', affected_rows: number } | null | undefined, InsertEventInstanceConfigurationValue?: { __typename?: 'EventInstanceConfigurationValue_mutation_response', affected_rows: number } | null | undefined, insertScheduledReportToTheQueue: { __typename?: 'ScheduledReportObject', defaultRecipient?: string | null | undefined, time: string, zone: string, otherRecipients: string, eventId?: string | null | undefined } };

export type TixUpdateScheduledAuditReportMutationVariables = Exact<{
  old: TixScheduledReportInput;
  newValue: TixScheduledReportInput;
  UpdatedScheduleReport: TixScheduledReportSetInput;
  scheduledReportId: Scalars['uuid'];
  insertScheduledReportEmail: Array<TixScheduledReportEmailInsertInput> | TixScheduledReportEmailInsertInput;
}>;


export type TixUpdateScheduledAuditReportMutation = { __typename?: 'mutation_root', update_scheduledReport?: { __typename?: 'scheduledReport_mutation_response', returning: Array<{ __typename?: 'scheduledReport', savedReportId: any, frequency: string, scheduledReportId: any, scheduleName: string, startSendingTimestamp: any, stopSendingTimestamp: any, timeOfDay: any, timezone: string, scheduledReportEmails: Array<{ __typename?: 'scheduledReportEmail', emailAddress: string, scheduleReportId: any }> }> } | null | undefined, delete_scheduledReportEmail?: { __typename?: 'scheduledReportEmail_mutation_response', affected_rows: number } | null | undefined, insert_scheduledReportEmail?: { __typename?: 'scheduledReportEmail_mutation_response', returning: Array<{ __typename?: 'scheduledReportEmail', emailAddress: string, scheduleReportId: any }> } | null | undefined, updateScheduledReportInTheQueue: { __typename?: 'ScheduledReportObject', defaultRecipient?: string | null | undefined, time: string, zone: string, otherRecipients: string, eventId?: string | null | undefined } };

export type TixUpdateScheduledEventReportMutationVariables = Exact<{
  updatedValues: Array<TixConfigurationValueUpdates> | TixConfigurationValueUpdates;
  old: TixScheduledReportInput;
  newValue: TixScheduledReportInput;
}>;


export type TixUpdateScheduledEventReportMutation = { __typename?: 'mutation_root', update_ConfigurationValue_many?: Array<{ __typename?: 'ConfigurationValue_mutation_response', returning: Array<{ __typename?: 'ConfigurationValue', configurationValueId: any, value: string }> } | null | undefined> | null | undefined, updateScheduledReportInTheQueue: { __typename?: 'ScheduledReportObject', defaultRecipient?: string | null | undefined, time: string, zone: string, otherRecipients: string, eventId?: string | null | undefined } };

export type TixInsertCompanyContactMutationVariables = Exact<{
  objects?: InputMaybe<Array<TixCompanyContactInsertInput> | TixCompanyContactInsertInput>;
}>;


export type TixInsertCompanyContactMutation = { __typename?: 'mutation_root', InsertCompanyContact?: { __typename?: 'CompanyContact_mutation_response', returning: Array<{ __typename?: 'CompanyContact', companyContactId: any, contactId: any, companyId: any, state: string, updatedBy: any, updatedAt: any }> } | null | undefined };

export type TixInsertStaffUserMutationVariables = Exact<{
  objects?: InputMaybe<Array<TixUserInsertInput> | TixUserInsertInput>;
}>;


export type TixInsertStaffUserMutation = { __typename?: 'mutation_root', InsertUser?: { __typename?: 'User_mutation_response', returning: Array<{ __typename?: 'User', userId: any, contactId?: any | null | undefined, state?: string | null | undefined, updatedBy: any, updatedAt: any }> } | null | undefined };

export type TixDeleteCompanyStaffRoleMutationVariables = Exact<{
  userRoleId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteCompanyStaffRoleMutation = { __typename?: 'mutation_root', DeleteUserRole?: { __typename?: 'UserRole_mutation_response', returning: Array<{ __typename?: 'UserRole', userRoleId: any, userId?: any | null | undefined, companyId?: any | null | undefined, roleId?: any | null | undefined, state?: string | null | undefined, updatedBy?: any | null | undefined, updatedAt?: any | null | undefined }> } | null | undefined };

export type TixDeleteContactCompanyRolesMutationVariables = Exact<{
  companyId: Scalars['uuid'];
  userId: Scalars['uuid'];
}>;


export type TixDeleteContactCompanyRolesMutation = { __typename?: 'mutation_root', DeleteUserRole?: { __typename?: 'UserRole_mutation_response', returning: Array<{ __typename?: 'UserRole', userRoleId: any, userId?: any | null | undefined, companyId?: any | null | undefined, roleId?: any | null | undefined, state?: string | null | undefined, updatedBy?: any | null | undefined, updatedAt?: any | null | undefined }> } | null | undefined };

export type TixDeleteContactPhoneNumbersMutationVariables = Exact<{
  contactId: Scalars['uuid'];
}>;


export type TixDeleteContactPhoneNumbersMutation = { __typename?: 'mutation_root', DeleteContactPhoneNumber?: { __typename?: 'ContactPhoneNumber_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteUserFromStaffMutationVariables = Exact<{
  companyId: Scalars['uuid'];
  contactId: Scalars['uuid'];
}>;


export type TixDeleteUserFromStaffMutation = { __typename?: 'mutation_root', DeleteCompanyContact?: { __typename?: 'CompanyContact_mutation_response', affected_rows: number } | null | undefined };

export type TixGetContactByEmailAddressQueryVariables = Exact<{
  emailAddress?: InputMaybe<Scalars['String']>;
}>;


export type TixGetContactByEmailAddressQuery = { __typename?: 'query_root', Contact: Array<{ __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, dob?: any | null | undefined, profilePicture?: string | null | undefined, user?: { __typename?: 'User', userId: any, userRoles: Array<{ __typename?: 'UserRole', userRoleId: any, companyId?: any | null | undefined, venueId?: any | null | undefined, role?: { __typename?: 'Role', roleId: any, role?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined } | null | undefined }> } | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', contactPhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, type?: string | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'ContactAddress', address?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, contactAddress?: { __typename?: 'ContactAddress', contactAddressId: any } | null | undefined } | null | undefined }> }> };

export type TixGetContactByEmailAddressSearchQueryVariables = Exact<{
  emailAddress?: InputMaybe<Scalars['String']>;
}>;


export type TixGetContactByEmailAddressSearchQuery = { __typename?: 'query_root', Contact: Array<{ __typename?: 'Contact', contactId: any, emailAddress: string, firstName: string, lastName: string, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', contactPhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, countryCode?: string | null | undefined, type?: string | null | undefined, phoneNumber?: string | null | undefined } | null | undefined }>, user?: { __typename?: 'User', userId: any, userRoles: Array<{ __typename?: 'UserRole', companyId?: any | null | undefined, userRoleId: any, venueId?: any | null | undefined, role?: { __typename?: 'Role', description?: string | null | undefined, role?: string | null | undefined, state?: string | null | undefined, title?: string | null | undefined } | null | undefined }> } | null | undefined }> };

export type TixGetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type TixGetRolesQuery = { __typename?: 'query_root', Role: Array<{ __typename?: 'Role', roleId: any, role?: string | null | undefined, description?: string | null | undefined, title?: string | null | undefined }> };

export type TixGetStaffByPkQueryVariables = Exact<{
  contactId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetStaffByPkQuery = { __typename?: 'query_root', Contact: Array<{ __typename?: 'Contact', contactId: any, firstName: string, lastName: string, emailAddress: string, profilePicture?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'ContactPhoneNumber', contactPhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, countryCode?: string | null | undefined, type?: string | null | undefined, phoneNumber?: string | null | undefined } | null | undefined }>, user?: { __typename?: 'User', userId: any, userRoles: Array<{ __typename?: 'UserRole', userRoleId: any, companyId?: any | null | undefined, venueId?: any | null | undefined, role?: { __typename?: 'Role', roleId: any, role?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined } | null | undefined }> } | null | undefined }> };

export type TixInsertCompanyContactUserRolesMutationVariables = Exact<{
  objects: Array<TixUserRoleInsertInput> | TixUserRoleInsertInput;
}>;


export type TixInsertCompanyContactUserRolesMutation = { __typename?: 'mutation_root', InsertUserRole?: { __typename?: 'UserRole_mutation_response', affected_rows: number } | null | undefined };

export type TixInsertStaffContactMutationVariables = Exact<{
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy: Scalars['uuid'];
}>;


export type TixInsertStaffContactMutation = { __typename?: 'mutation_root', InsertContactOne?: { __typename?: 'Contact', contactId: any } | null | undefined };

export type TixGetStaffContactIdByEmailQueryVariables = Exact<{
  emailAddress: Scalars['String'];
}>;


export type TixGetStaffContactIdByEmailQuery = { __typename?: 'query_root', Contact: Array<{ __typename?: 'Contact', contactId: any }> };

export type TixInsertStaffCompanyContactRelationshipMutationVariables = Exact<{
  companyId: Scalars['uuid'];
  contactId: Scalars['uuid'];
}>;


export type TixInsertStaffCompanyContactRelationshipMutation = { __typename?: 'mutation_root', InsertCompanyContact?: { __typename?: 'CompanyContact_mutation_response', affected_rows: number } | null | undefined };

export type TixInsertStaffUserAndRolesMutationVariables = Exact<{
  contactId: Scalars['uuid'];
  data?: InputMaybe<Array<TixUserRoleInsertInput> | TixUserRoleInsertInput>;
}>;


export type TixInsertStaffUserAndRolesMutation = { __typename?: 'mutation_root', InsertUserOne?: { __typename?: 'User', contactId?: any | null | undefined, lastFailedLogin?: any | null | undefined, lastSuccessfulLogin?: any | null | undefined, noFailedLogins?: any | null | undefined, state?: string | null | undefined, updatedAt: any, updatedBy: any, userId: any, contact?: { __typename?: 'Contact', contactId: any, emailAddress: string, firstName: string, lastName: string, state: string, companyContacts: Array<{ __typename?: 'CompanyContact', companyContactId: any, companyId: any, contactId: any, state: string }> } | null | undefined } | null | undefined };

export type TixInsertCompanyStaffRoleMutationVariables = Exact<{
  objects?: InputMaybe<Array<TixUserRoleInsertInput> | TixUserRoleInsertInput>;
}>;


export type TixInsertCompanyStaffRoleMutation = { __typename?: 'mutation_root', InsertUserRole?: { __typename?: 'UserRole_mutation_response', returning: Array<{ __typename?: 'UserRole', userRoleId: any, userId?: any | null | undefined, roleId?: any | null | undefined, companyId?: any | null | undefined, state?: string | null | undefined, updatedBy?: any | null | undefined, updatedAt?: any | null | undefined }> } | null | undefined };

export type TixInsertExistingUserToStaffMutationVariables = Exact<{
  companyId: Scalars['uuid'];
  contactId: Scalars['uuid'];
}>;


export type TixInsertExistingUserToStaffMutation = { __typename?: 'mutation_root', InsertCompanyContactOne?: { __typename?: 'CompanyContact', contactId: any, contact?: { __typename?: 'Contact', contactId: any, emailAddress: string, firstName: string, lastName: string, state: string, companyContacts: Array<{ __typename?: 'CompanyContact', companyContactId: any, companyId: any, contactId: any, state: string }> } | null | undefined } | null | undefined };

export type TixSendMailByEmailMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type TixSendMailByEmailMutation = { __typename?: 'mutation_root', createUserAndSendEmail?: { __typename?: 'InviteUserResult', invited?: boolean | null | undefined } | null | undefined };

export type TixGetTicketQueryVariables = Exact<{
  reservationId: Scalars['uuid'];
}>;


export type TixGetTicketQuery = { __typename?: 'query_root', reservationInfo: { __typename?: 'ticket_reservation_aggregate', nodes: Array<{ __typename?: 'ticket_reservation', tickets_aggregate: { __typename?: 'Ticket_aggregate', aggregate?: { __typename?: 'Ticket_aggregate_fields', count: number } | null | undefined } }> } };

export type TixGetAppleWalletPassUrlQueryVariables = Exact<{
  data: TixSendETicketInput;
}>;


export type TixGetAppleWalletPassUrlQuery = { __typename?: 'query_root', getAppleWalletPassUrl?: string | null | undefined };

export type TixGetGoogleWalletUrlQueryVariables = Exact<{
  data: TixSendETicketInput;
}>;


export type TixGetGoogleWalletUrlQuery = { __typename?: 'query_root', getGoogleWalletUrl?: string | null | undefined };

export type TixCancelExchangeMutationVariables = Exact<{
  exchangeId: Scalars['String'];
}>;


export type TixCancelExchangeMutation = { __typename?: 'mutation_root', cancelTicketExchange: boolean };

export type TixConfirmExchangeMutationVariables = Exact<{
  exchangeId: Scalars['String'];
}>;


export type TixConfirmExchangeMutation = { __typename?: 'mutation_root', confirmTicketExchange: boolean };

export type TixGetEventExchangesCountQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetEventExchangesCountQuery = { __typename?: 'query_root', ticket_exchange_aggregate: { __typename?: 'ticket_exchange_aggregate', aggregate?: { __typename?: 'ticket_exchange_aggregate_fields', count: number } | null | undefined } };

export type TixGetEventsForExchangeQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  startDate?: Scalars['date'];
  endDate?: Scalars['date'];
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TixGetEventsForExchangeQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, name?: string | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, doorsOpen?: any | null | undefined, date?: any | null | undefined, venueId?: any | null | undefined, eventAdmins?: Array<any> | null | undefined, eventInstanceTickets: Array<{ __typename?: 'EventInstanceTicket', Configurations: Array<{ __typename?: 'EventInstanceTicketConfig', TicketConfigurations: { __typename?: 'TicketConfig', includeFees?: boolean | null | undefined, name?: string | null | undefined, noOfSeats?: number | null | undefined, salesChannel?: string | null | undefined, parentTicketId?: any | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, state?: string | null | undefined, ticketConfigId: any, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, totalTicketsByType?: { __typename?: 'ticket_v_ticket_count_by_type', ticketsSold?: any | null | undefined, ticketsRemaining?: any | null | undefined } | null | undefined } }> }>, eventTicketSalesMetrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, checked_in?: any | null | undefined, event_instance_id?: any | null | undefined, not_checked_in?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined }> };

export type TixPaymentExchangeDataFragment = { __typename?: 'GQLPaymentExchangeData', exchangeId: string, expiresAt?: string | null | undefined, state: string, createdAt: string, originalReservationId: string, newReservationId: string, amount: number, required_action: string, exchangedTicketIds: Array<string>, exchangedProductIds: Array<string>, paymentIntentClientSecret?: string | null | undefined, originalReservation?: { __typename?: 'GQLTicketReservation', totalAmountPaid?: string | null | undefined, subTotal?: string | null | undefined, discountAmount?: string | null | undefined, eventInstanceId?: string | null | undefined, event?: { __typename?: 'GQLEventInstance', name?: string | null | undefined, date?: string | null | undefined, startTime?: string | null | undefined } | null | undefined, contact?: { __typename?: 'GQLContact', firstName: string, lastName: string, emailAddress: string } | null | undefined, payment?: { __typename?: 'GQLReservationPayment', payment?: { __typename?: 'GQLPayment', paymentId: string, paymentToken?: string | null | undefined } | null | undefined } | null | undefined, discount?: { __typename?: 'GQLDiscount', discountId: string, type?: string | null | undefined, appliedTo?: string | null | undefined, buyAmount?: number | null | undefined, getAmount?: number | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'GQLTicket', ticketId: string, active?: boolean | null | undefined, checkedInAt?: string | null | undefined, contactId?: string | null | undefined, createdAt?: string | null | undefined, discountAmount?: string | null | undefined, eventInstanceId?: string | null | undefined, platformFee?: string | null | undefined, processingFee?: string | null | undefined, reservationId?: string | null | undefined, reservationNo?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId?: string | null | undefined, ticketNo?: string | null | undefined, ticketPrice?: string | null | undefined, ticketType?: string | null | undefined, venueFee?: string | null | undefined, ticketConfig?: { __typename?: 'GQLTicketConfig', ticketConfigId: string, ticketPrice?: string | null | undefined, venueFee?: string | null | undefined, includeFees?: boolean | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined } | null | undefined }>, reservationDetails: Array<{ __typename?: 'GQLTicketReservationDetail', reservationDetailId: string, amount?: string | null | undefined, comment?: string | null | undefined, createdAt?: string | null | undefined, createdBy?: string | null | undefined, price?: string | null | undefined, quantity?: number | null | undefined, ticketConfigId?: string | null | undefined, type?: string | null | undefined }>, productOrder?: { __typename?: 'GQLOrder', createdAt?: string | null | undefined, createdBy?: string | null | undefined, payment_type?: string | null | undefined, state?: string | null | undefined, orderDetails: Array<{ __typename?: 'GQLProductOrderDetail', orderDetailId: string, active: boolean, amount?: string | null | undefined, comment?: string | null | undefined, eventProductId?: string | null | undefined, price?: string | null | undefined, quantity?: number | null | undefined, state?: string | null | undefined, type?: string | null | undefined, eventproduct?: { __typename?: 'GQLEventProduct', name?: string | null | undefined, price?: string | null | undefined, tax?: number | null | undefined } | null | undefined }> } | null | undefined } | null | undefined, newReservation?: { __typename?: 'GQLTicketReservation', totalAmountPaid?: string | null | undefined, subTotal?: string | null | undefined, discountAmount?: string | null | undefined, eventInstanceId?: string | null | undefined, event?: { __typename?: 'GQLEventInstance', name?: string | null | undefined, date?: string | null | undefined, startTime?: string | null | undefined } | null | undefined, contact?: { __typename?: 'GQLContact', firstName: string, lastName: string, emailAddress: string } | null | undefined, payment?: { __typename?: 'GQLReservationPayment', payment?: { __typename?: 'GQLPayment', paymentId: string, paymentToken?: string | null | undefined } | null | undefined } | null | undefined, discount?: { __typename?: 'GQLDiscount', discountId: string, type?: string | null | undefined, appliedTo?: string | null | undefined, buyAmount?: number | null | undefined, getAmount?: number | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'GQLTicket', ticketId: string, active?: boolean | null | undefined, checkedInAt?: string | null | undefined, contactId?: string | null | undefined, createdAt?: string | null | undefined, discountAmount?: string | null | undefined, eventInstanceId?: string | null | undefined, platformFee?: string | null | undefined, processingFee?: string | null | undefined, reservationId?: string | null | undefined, reservationNo?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId?: string | null | undefined, ticketNo?: string | null | undefined, ticketPrice?: string | null | undefined, ticketType?: string | null | undefined, venueFee?: string | null | undefined, ticketConfig?: { __typename?: 'GQLTicketConfig', ticketConfigId: string, ticketPrice?: string | null | undefined, venueFee?: string | null | undefined, includeFees?: boolean | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined } | null | undefined }>, reservationDetails: Array<{ __typename?: 'GQLTicketReservationDetail', reservationDetailId: string, amount?: string | null | undefined, comment?: string | null | undefined, createdAt?: string | null | undefined, createdBy?: string | null | undefined, price?: string | null | undefined, quantity?: number | null | undefined, ticketConfigId?: string | null | undefined, type?: string | null | undefined }>, productOrder?: { __typename?: 'GQLOrder', createdAt?: string | null | undefined, createdBy?: string | null | undefined, payment_type?: string | null | undefined, state?: string | null | undefined, orderDetails: Array<{ __typename?: 'GQLProductOrderDetail', orderDetailId: string, active: boolean, amount?: string | null | undefined, comment?: string | null | undefined, eventProductId?: string | null | undefined, price?: string | null | undefined, quantity?: number | null | undefined, state?: string | null | undefined, type?: string | null | undefined, eventproduct?: { __typename?: 'GQLEventProduct', name?: string | null | undefined, price?: string | null | undefined, tax?: number | null | undefined } | null | undefined }> } | null | undefined } | null | undefined };

export type TixGetExchangeByIdForPaymentQueryVariables = Exact<{
  exchangeId: Scalars['String'];
}>;


export type TixGetExchangeByIdForPaymentQuery = { __typename?: 'query_root', getPaymentExchangeData: { __typename?: 'GQLPaymentExchangeData', exchangeId: string, expiresAt?: string | null | undefined, state: string, createdAt: string, originalReservationId: string, newReservationId: string, amount: number, required_action: string, exchangedTicketIds: Array<string>, exchangedProductIds: Array<string>, paymentIntentClientSecret?: string | null | undefined, originalReservation?: { __typename?: 'GQLTicketReservation', totalAmountPaid?: string | null | undefined, subTotal?: string | null | undefined, discountAmount?: string | null | undefined, eventInstanceId?: string | null | undefined, event?: { __typename?: 'GQLEventInstance', name?: string | null | undefined, date?: string | null | undefined, startTime?: string | null | undefined } | null | undefined, contact?: { __typename?: 'GQLContact', firstName: string, lastName: string, emailAddress: string } | null | undefined, payment?: { __typename?: 'GQLReservationPayment', payment?: { __typename?: 'GQLPayment', paymentId: string, paymentToken?: string | null | undefined } | null | undefined } | null | undefined, discount?: { __typename?: 'GQLDiscount', discountId: string, type?: string | null | undefined, appliedTo?: string | null | undefined, buyAmount?: number | null | undefined, getAmount?: number | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'GQLTicket', ticketId: string, active?: boolean | null | undefined, checkedInAt?: string | null | undefined, contactId?: string | null | undefined, createdAt?: string | null | undefined, discountAmount?: string | null | undefined, eventInstanceId?: string | null | undefined, platformFee?: string | null | undefined, processingFee?: string | null | undefined, reservationId?: string | null | undefined, reservationNo?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId?: string | null | undefined, ticketNo?: string | null | undefined, ticketPrice?: string | null | undefined, ticketType?: string | null | undefined, venueFee?: string | null | undefined, ticketConfig?: { __typename?: 'GQLTicketConfig', ticketConfigId: string, ticketPrice?: string | null | undefined, venueFee?: string | null | undefined, includeFees?: boolean | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined } | null | undefined }>, reservationDetails: Array<{ __typename?: 'GQLTicketReservationDetail', reservationDetailId: string, amount?: string | null | undefined, comment?: string | null | undefined, createdAt?: string | null | undefined, createdBy?: string | null | undefined, price?: string | null | undefined, quantity?: number | null | undefined, ticketConfigId?: string | null | undefined, type?: string | null | undefined }>, productOrder?: { __typename?: 'GQLOrder', createdAt?: string | null | undefined, createdBy?: string | null | undefined, payment_type?: string | null | undefined, state?: string | null | undefined, orderDetails: Array<{ __typename?: 'GQLProductOrderDetail', orderDetailId: string, active: boolean, amount?: string | null | undefined, comment?: string | null | undefined, eventProductId?: string | null | undefined, price?: string | null | undefined, quantity?: number | null | undefined, state?: string | null | undefined, type?: string | null | undefined, eventproduct?: { __typename?: 'GQLEventProduct', name?: string | null | undefined, price?: string | null | undefined, tax?: number | null | undefined } | null | undefined }> } | null | undefined } | null | undefined, newReservation?: { __typename?: 'GQLTicketReservation', totalAmountPaid?: string | null | undefined, subTotal?: string | null | undefined, discountAmount?: string | null | undefined, eventInstanceId?: string | null | undefined, event?: { __typename?: 'GQLEventInstance', name?: string | null | undefined, date?: string | null | undefined, startTime?: string | null | undefined } | null | undefined, contact?: { __typename?: 'GQLContact', firstName: string, lastName: string, emailAddress: string } | null | undefined, payment?: { __typename?: 'GQLReservationPayment', payment?: { __typename?: 'GQLPayment', paymentId: string, paymentToken?: string | null | undefined } | null | undefined } | null | undefined, discount?: { __typename?: 'GQLDiscount', discountId: string, type?: string | null | undefined, appliedTo?: string | null | undefined, buyAmount?: number | null | undefined, getAmount?: number | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'GQLTicket', ticketId: string, active?: boolean | null | undefined, checkedInAt?: string | null | undefined, contactId?: string | null | undefined, createdAt?: string | null | undefined, discountAmount?: string | null | undefined, eventInstanceId?: string | null | undefined, platformFee?: string | null | undefined, processingFee?: string | null | undefined, reservationId?: string | null | undefined, reservationNo?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId?: string | null | undefined, ticketNo?: string | null | undefined, ticketPrice?: string | null | undefined, ticketType?: string | null | undefined, venueFee?: string | null | undefined, ticketConfig?: { __typename?: 'GQLTicketConfig', ticketConfigId: string, ticketPrice?: string | null | undefined, venueFee?: string | null | undefined, includeFees?: boolean | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined } | null | undefined }>, reservationDetails: Array<{ __typename?: 'GQLTicketReservationDetail', reservationDetailId: string, amount?: string | null | undefined, comment?: string | null | undefined, createdAt?: string | null | undefined, createdBy?: string | null | undefined, price?: string | null | undefined, quantity?: number | null | undefined, ticketConfigId?: string | null | undefined, type?: string | null | undefined }>, productOrder?: { __typename?: 'GQLOrder', createdAt?: string | null | undefined, createdBy?: string | null | undefined, payment_type?: string | null | undefined, state?: string | null | undefined, orderDetails: Array<{ __typename?: 'GQLProductOrderDetail', orderDetailId: string, active: boolean, amount?: string | null | undefined, comment?: string | null | undefined, eventProductId?: string | null | undefined, price?: string | null | undefined, quantity?: number | null | undefined, state?: string | null | undefined, type?: string | null | undefined, eventproduct?: { __typename?: 'GQLEventProduct', name?: string | null | undefined, price?: string | null | undefined, tax?: number | null | undefined } | null | undefined }> } | null | undefined } | null | undefined } };

export type TixGetExchangeVenueQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetExchangeVenueQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', venue?: { __typename?: 'Venue', name: string, state: string, addresses: Array<{ __typename?: 'VenueAddress', venueAddressId: any, address?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, socialMedia: Array<{ __typename?: 'VenueSocialMedia', venueSocialMediaId: any, socialMedia?: { __typename?: 'SocialMedia', socialMediaId: any, url: string, socialMediaType: string } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', mediaFile?: { __typename?: 'MediaFile', mediaFileId: any, name: string, location: string, fileType?: string | null | undefined } | null | undefined }> } | null | undefined }> };

export type TixExchangeReservationDataFragment = { __typename?: 'ticket_reservation', reservationId: any, eventInstanceId?: any | null | undefined, contact?: { __typename?: 'Contact', fullName?: string | null | undefined, emailAddress: string } | null | undefined, event?: { __typename?: 'EventInstance', name?: string | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'Ticket', ticketId: any, ticketNo?: string | null | undefined, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, reservationNo?: string | null | undefined, section?: string | null | undefined }>, product_order?: { __typename?: 'Order', order_detail: Array<{ __typename?: 'product_order_detail', orderDetailId: any, quantity?: number | null | undefined, price?: any | null | undefined, type?: string | null | undefined, eventProductId?: any | null | undefined, eventproduct?: { __typename?: 'EventProduct', name?: string | null | undefined, price?: any | null | undefined } | null | undefined }> } | null | undefined };

export type TixGetExchangesByEventQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetExchangesByEventQuery = { __typename?: 'query_root', ticket_exchange: Array<{ __typename?: 'ticket_exchange', createdAt: any, exchangeId: any, state: string, amount: any, expiresAt?: any | null | undefined, exchangedProductIds: Array<any>, exchangedTicketIds: Array<any>, originalReservation?: { __typename?: 'ticket_reservation', reservationId: any, eventInstanceId?: any | null | undefined, contact?: { __typename?: 'Contact', fullName?: string | null | undefined, emailAddress: string } | null | undefined, event?: { __typename?: 'EventInstance', name?: string | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'Ticket', ticketId: any, ticketNo?: string | null | undefined, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, reservationNo?: string | null | undefined, section?: string | null | undefined }>, product_order?: { __typename?: 'Order', order_detail: Array<{ __typename?: 'product_order_detail', orderDetailId: any, quantity?: number | null | undefined, price?: any | null | undefined, type?: string | null | undefined, eventProductId?: any | null | undefined, eventproduct?: { __typename?: 'EventProduct', name?: string | null | undefined, price?: any | null | undefined } | null | undefined }> } | null | undefined } | null | undefined, newReservation?: { __typename?: 'ticket_reservation', reservationId: any, eventInstanceId?: any | null | undefined, contact?: { __typename?: 'Contact', fullName?: string | null | undefined, emailAddress: string } | null | undefined, event?: { __typename?: 'EventInstance', name?: string | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'Ticket', ticketId: any, ticketNo?: string | null | undefined, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, discountAmount?: any | null | undefined, venueFee?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, reservationNo?: string | null | undefined, section?: string | null | undefined }>, product_order?: { __typename?: 'Order', order_detail: Array<{ __typename?: 'product_order_detail', orderDetailId: any, quantity?: number | null | undefined, price?: any | null | undefined, type?: string | null | undefined, eventProductId?: any | null | undefined, eventproduct?: { __typename?: 'EventProduct', name?: string | null | undefined, price?: any | null | undefined } | null | undefined }> } | null | undefined } | null | undefined }> };

export type TixGetRequiredActionForExchangeQueryVariables = Exact<{
  request: TixTicketExchangeRequestInput;
}>;


export type TixGetRequiredActionForExchangeQuery = { __typename?: 'query_root', getTicketExchangeRequiredAction: { __typename?: 'TicketExchangeActionOutput', type: TixTicketExchangeActionType, amount: number } };

export type TixOrderDataFragment = { __typename?: 'ticket_reservation', active?: boolean | null | undefined, state?: string | null | undefined, reservationId: any, eventInstanceId?: any | null | undefined, totalAmountPaid?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, event?: { __typename?: 'EventInstance', name?: string | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined, venue?: { __typename?: 'Venue', name: string } | null | undefined } | null | undefined, contact?: { __typename?: 'Contact', fullName?: string | null | undefined, emailAddress: string } | null | undefined, payment?: { __typename?: 'ReservationPayment', payment?: { __typename?: 'Payment', paymentToken?: string | null | undefined } | null | undefined } | null | undefined, discount?: { __typename?: 'Discount', type?: string | null | undefined, appliedTo?: string | null | undefined, buyAmount?: any | null | undefined, getAmount?: any | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'Ticket', ticketId: any, ticketNo?: string | null | undefined, reservationNo?: string | null | undefined, active?: boolean | null | undefined, checkedInAt?: any | null | undefined, contactId?: any | null | undefined, createdAt?: any | null | undefined, discountAmount?: any | null | undefined, eventInstanceId?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId?: any | null | undefined, ticketPrice?: any | null | undefined, ticketType?: string | null | undefined, venueFee?: any | null | undefined, ticketConfig?: { __typename?: 'TicketConfig', ticketConfigId: any, ticketPrice?: any | null | undefined, venueFee?: any | null | undefined, includeFees?: boolean | null | undefined } | null | undefined }>, reservationDetails: Array<{ __typename?: 'TicketReservationDetail', active: boolean, amount?: any | null | undefined, comment?: string | null | undefined, createdAt?: any | null | undefined, createdBy?: any | null | undefined, price?: any | null | undefined, quantity?: any | null | undefined, ticketConfigId?: any | null | undefined, type?: string | null | undefined }>, productOrder?: { __typename?: 'Order', createdAt?: any | null | undefined, createdBy?: any | null | undefined, payment_type?: string | null | undefined, state?: string | null | undefined, orderDetails: Array<{ __typename?: 'product_order_detail', orderDetailId: any, active: boolean, amount?: any | null | undefined, comment?: string | null | undefined, eventProductId?: any | null | undefined, price?: any | null | undefined, quantity?: number | null | undefined, state?: string | null | undefined, type?: string | null | undefined, eventproduct?: { __typename?: 'EventProduct', name?: string | null | undefined, price?: any | null | undefined, tax?: any | null | undefined } | null | undefined }> } | null | undefined };

export type TixGetReservationsByEventQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
  searchQuery?: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TixGetReservationsByEventQuery = { __typename?: 'query_root', reservation: Array<{ __typename?: 'ticket_reservation', active?: boolean | null | undefined, state?: string | null | undefined, reservationId: any, eventInstanceId?: any | null | undefined, totalAmountPaid?: any | null | undefined, subTotal?: any | null | undefined, discountAmount?: any | null | undefined, event?: { __typename?: 'EventInstance', name?: string | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined, venue?: { __typename?: 'Venue', name: string } | null | undefined } | null | undefined, contact?: { __typename?: 'Contact', fullName?: string | null | undefined, emailAddress: string } | null | undefined, payment?: { __typename?: 'ReservationPayment', payment?: { __typename?: 'Payment', paymentToken?: string | null | undefined } | null | undefined } | null | undefined, discount?: { __typename?: 'Discount', type?: string | null | undefined, appliedTo?: string | null | undefined, buyAmount?: any | null | undefined, getAmount?: any | null | undefined } | null | undefined, tickets: Array<{ __typename?: 'Ticket', ticketId: any, ticketNo?: string | null | undefined, reservationNo?: string | null | undefined, active?: boolean | null | undefined, checkedInAt?: any | null | undefined, contactId?: any | null | undefined, createdAt?: any | null | undefined, discountAmount?: any | null | undefined, eventInstanceId?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId?: any | null | undefined, ticketPrice?: any | null | undefined, ticketType?: string | null | undefined, venueFee?: any | null | undefined, ticketConfig?: { __typename?: 'TicketConfig', ticketConfigId: any, ticketPrice?: any | null | undefined, venueFee?: any | null | undefined, includeFees?: boolean | null | undefined } | null | undefined }>, reservationDetails: Array<{ __typename?: 'TicketReservationDetail', active: boolean, amount?: any | null | undefined, comment?: string | null | undefined, createdAt?: any | null | undefined, createdBy?: any | null | undefined, price?: any | null | undefined, quantity?: any | null | undefined, ticketConfigId?: any | null | undefined, type?: string | null | undefined }>, productOrder?: { __typename?: 'Order', createdAt?: any | null | undefined, createdBy?: any | null | undefined, payment_type?: string | null | undefined, state?: string | null | undefined, orderDetails: Array<{ __typename?: 'product_order_detail', orderDetailId: any, active: boolean, amount?: any | null | undefined, comment?: string | null | undefined, eventProductId?: any | null | undefined, price?: any | null | undefined, quantity?: number | null | undefined, state?: string | null | undefined, type?: string | null | undefined, eventproduct?: { __typename?: 'EventProduct', name?: string | null | undefined, price?: any | null | undefined, tax?: any | null | undefined } | null | undefined }> } | null | undefined }> };

export type TixInitiateExchangeMutationVariables = Exact<{
  request: TixTicketExchangeRequestInput;
}>;


export type TixInitiateExchangeMutation = { __typename?: 'mutation_root', exchangeId: string };

export type TixSendExchangeEmailMutationVariables = Exact<{
  exchangeId: Scalars['String'];
}>;


export type TixSendExchangeEmailMutation = { __typename?: 'mutation_root', sendTicketExchangeEmail: boolean };

export type TixSendExchangePaymentEmailMutationVariables = Exact<{
  exchangeId: Scalars['String'];
}>;


export type TixSendExchangePaymentEmailMutation = { __typename?: 'mutation_root', sendExchangePaymentEmail: boolean };

export type TixAddOrderToHoldMutationVariables = Exact<{
  userSessionId: Scalars['String'];
  tickets: Array<TixTicketOnHoldInput> | TixTicketOnHoldInput;
}>;


export type TixAddOrderToHoldMutation = { __typename?: 'mutation_root', addOrderToHold: boolean };

export type TixGetOtherOrdersOnHoldQueryVariables = Exact<{
  userSessionId: Scalars['String'];
  tickets: Array<Scalars['String']> | Scalars['String'];
}>;


export type TixGetOtherOrdersOnHoldQuery = { __typename?: 'query_root', getOtherUsersOnHoldTickets: Array<{ __typename?: 'TicketOnHoldResult', onHold: number, ticketConfigId: string }> };

export type TixRemoveOrderFromHoldMutationVariables = Exact<{
  userSessionId: Scalars['String'];
}>;


export type TixRemoveOrderFromHoldMutation = { __typename?: 'mutation_root', removeOrderFromHold: boolean };

export type TixGetReservationTicketsZipQueryVariables = Exact<{
  reservationId: Scalars['String'];
  baseTicketQrCodeScanUrl: Scalars['String'];
  zipName: Scalars['String'];
}>;


export type TixGetReservationTicketsZipQuery = { __typename?: 'query_root', getReservationTicketsZip: string };

export type TixGetTicketIdsInReservationQueryVariables = Exact<{
  reservationId: Scalars['uuid'];
}>;


export type TixGetTicketIdsInReservationQuery = { __typename?: 'query_root', Reservation: Array<{ __typename?: 'ticket_reservation', tickets: Array<{ __typename?: 'Ticket', ticketId: any }> }> };

export type TixGetTicketPdfUrlsQueryVariables = Exact<{
  baseTicketQrCodeScanUrl: Scalars['String'];
  ticketIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type TixGetTicketPdfUrlsQuery = { __typename?: 'query_root', getTicketPDFUrls: Array<string> };

export type TixUploadMediaMutationVariables = Exact<{
  file?: InputMaybe<Scalars['Upload']>;
}>;


export type TixUploadMediaMutation = { __typename?: 'mutation_root', uploadMedia: { __typename?: 'GraphQLUploadResult', url: string } };

export type TixGetEventCalendarDatesQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  monthStartDate: Scalars['date'];
  monthEndDate: Scalars['date'];
  currentDate?: InputMaybe<Scalars['date']>;
}>;


export type TixGetEventCalendarDatesQuery = { __typename?: 'query_root', calendarEventDates: Array<{ __typename?: 'EventInstance', date?: any | null | undefined }> };

export type TixGetVenuePortalEventQueryVariables = Exact<{
  eventInstanceId: Scalars['uuid'];
}>;


export type TixGetVenuePortalEventQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, venueId?: any | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined, doorsOpen?: any | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, passcode?: string | null | undefined, minimumAge?: number | null | undefined, eventName?: string | null | undefined, eventDescription?: string | null | undefined, eventAdditionalInfo?: string | null | undefined, eventType?: string | null | undefined, venue?: { __typename?: 'Venue', companyId?: any | null | undefined, venueId: any, name: string } | null | undefined, media: Array<{ __typename?: 'EventInstanceMedialFile', mediaId: any, mediaFile: { __typename?: 'MediaFile', fileType?: string | null | undefined, location: string, mediaFileId: any } }>, SocialMedia: Array<{ __typename?: 'EventInstanceSocialMediaFile', socialMedia: { __typename?: 'SocialMedia', socialMediaType: string, url: string } }>, campaign: Array<{ __typename?: 'event_campaign_tracking', campaign_tracking_id: any, campaign_name?: string | null | undefined, campaignCode?: string | null | undefined, campaignType?: string | null | undefined }>, Tickets: Array<{ __typename?: 'EventInstanceTicket', Configurations: Array<{ __typename?: 'EventInstanceTicketConfig', TicketConfigurations: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, parentTicketId?: any | null | undefined, salesChannel?: string | null | undefined, noOfSeats?: number | null | undefined, ticketConfigId: any, name?: string | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketPrice?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, venueFee?: any | null | undefined, state?: string | null | undefined, updatedAt: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, ticketConfigTotals?: { __typename?: 'ticket_v_ticket_count_by_type', totalTickets?: number | null | undefined, ticketsSold?: any | null | undefined, ticketsRemaining?: any | null | undefined } | null | undefined } }> }>, Metrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined, ticketCount: Array<{ __typename?: 'TicketCountByEvent', ticketCount?: any | null | undefined, parentTicketConfigId?: any | null | undefined, ticketConfigId?: any | null | undefined, salesChannel?: string | null | undefined }> }> };

export type TixGetVenuePortalEventsWithSlugQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  searchQuery?: Scalars['String'];
  startDate: Scalars['date'];
  endDate?: InputMaybe<Scalars['date']>;
  states?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  currentDate?: InputMaybe<Scalars['date']>;
  currentTime?: InputMaybe<Scalars['time']>;
  filterKeyword?: Scalars['String'];
}>;


export type TixGetVenuePortalEventsWithSlugQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, venueId?: any | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined, doorsOpen?: any | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, passcode?: string | null | undefined, minimumAge?: number | null | undefined, eventName?: string | null | undefined, eventDescription?: string | null | undefined, eventAdditionalInfo?: string | null | undefined, eventType?: string | null | undefined, venue?: { __typename?: 'Venue', companyId?: any | null | undefined, venueId: any, name: string } | null | undefined, media: Array<{ __typename?: 'EventInstanceMedialFile', mediaId: any, mediaFile: { __typename?: 'MediaFile', fileType?: string | null | undefined, location: string, mediaFileId: any } }>, SocialMedia: Array<{ __typename?: 'EventInstanceSocialMediaFile', socialMedia: { __typename?: 'SocialMedia', socialMediaType: string, url: string } }>, campaign: Array<{ __typename?: 'event_campaign_tracking', campaign_tracking_id: any, campaign_name?: string | null | undefined, campaignCode?: string | null | undefined, campaignType?: string | null | undefined }>, Tickets: Array<{ __typename?: 'EventInstanceTicket', Configurations: Array<{ __typename?: 'EventInstanceTicketConfig', TicketConfigurations: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, parentTicketId?: any | null | undefined, salesChannel?: string | null | undefined, noOfSeats?: number | null | undefined, ticketConfigId: any, name?: string | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketPrice?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, venueFee?: any | null | undefined, state?: string | null | undefined, updatedAt: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, ticketConfigTotals?: { __typename?: 'ticket_v_ticket_count_by_type', totalTickets?: number | null | undefined, ticketsSold?: any | null | undefined, ticketsRemaining?: any | null | undefined } | null | undefined } }> }>, Metrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined, ticketCount: Array<{ __typename?: 'TicketCountByEvent', ticketCount?: any | null | undefined, parentTicketConfigId?: any | null | undefined, ticketConfigId?: any | null | undefined, salesChannel?: string | null | undefined }> }> };

export type TixGetVenuePortalEventsQueryVariables = Exact<{
  venueId: Scalars['uuid'];
  searchQuery?: Scalars['String'];
  startDate: Scalars['date'];
  endDate?: InputMaybe<Scalars['date']>;
  states?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  currentDate?: InputMaybe<Scalars['date']>;
  currentTime?: InputMaybe<Scalars['time']>;
}>;


export type TixGetVenuePortalEventsQuery = { __typename?: 'query_root', EventInstance: Array<{ __typename?: 'EventInstance', eventInstanceId: any, venueId?: any | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined, doorsOpen?: any | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, passcode?: string | null | undefined, minimumAge?: number | null | undefined, eventName?: string | null | undefined, eventDescription?: string | null | undefined, eventAdditionalInfo?: string | null | undefined, eventType?: string | null | undefined, venue?: { __typename?: 'Venue', companyId?: any | null | undefined, venueId: any, name: string } | null | undefined, media: Array<{ __typename?: 'EventInstanceMedialFile', mediaId: any, mediaFile: { __typename?: 'MediaFile', fileType?: string | null | undefined, location: string, mediaFileId: any } }>, SocialMedia: Array<{ __typename?: 'EventInstanceSocialMediaFile', socialMedia: { __typename?: 'SocialMedia', socialMediaType: string, url: string } }>, campaign: Array<{ __typename?: 'event_campaign_tracking', campaign_tracking_id: any, campaign_name?: string | null | undefined, campaignCode?: string | null | undefined, campaignType?: string | null | undefined }>, Tickets: Array<{ __typename?: 'EventInstanceTicket', Configurations: Array<{ __typename?: 'EventInstanceTicketConfig', TicketConfigurations: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, parentTicketId?: any | null | undefined, salesChannel?: string | null | undefined, noOfSeats?: number | null | undefined, ticketConfigId: any, name?: string | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketPrice?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, venueFee?: any | null | undefined, state?: string | null | undefined, updatedAt: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, ticketConfigTotals?: { __typename?: 'ticket_v_ticket_count_by_type', totalTickets?: number | null | undefined, ticketsSold?: any | null | undefined, ticketsRemaining?: any | null | undefined } | null | undefined } }> }>, Metrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined, ticketCount: Array<{ __typename?: 'TicketCountByEvent', ticketCount?: any | null | undefined, parentTicketConfigId?: any | null | undefined, ticketConfigId?: any | null | undefined, salesChannel?: string | null | undefined }> }> };

export type TixVenuePortalEventFragment = { __typename?: 'EventInstance', eventInstanceId: any, venueId?: any | null | undefined, date?: any | null | undefined, startTime?: any | null | undefined, doorsOpen?: any | null | undefined, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, passcode?: string | null | undefined, minimumAge?: number | null | undefined, eventName?: string | null | undefined, eventDescription?: string | null | undefined, eventAdditionalInfo?: string | null | undefined, eventType?: string | null | undefined, venue?: { __typename?: 'Venue', companyId?: any | null | undefined, venueId: any, name: string } | null | undefined, media: Array<{ __typename?: 'EventInstanceMedialFile', mediaId: any, mediaFile: { __typename?: 'MediaFile', fileType?: string | null | undefined, location: string, mediaFileId: any } }>, SocialMedia: Array<{ __typename?: 'EventInstanceSocialMediaFile', socialMedia: { __typename?: 'SocialMedia', socialMediaType: string, url: string } }>, campaign: Array<{ __typename?: 'event_campaign_tracking', campaign_tracking_id: any, campaign_name?: string | null | undefined, campaignCode?: string | null | undefined, campaignType?: string | null | undefined }>, Tickets: Array<{ __typename?: 'EventInstanceTicket', Configurations: Array<{ __typename?: 'EventInstanceTicketConfig', TicketConfigurations: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, parentTicketId?: any | null | undefined, salesChannel?: string | null | undefined, noOfSeats?: number | null | undefined, ticketConfigId: any, name?: string | null | undefined, ticketType?: string | null | undefined, section?: string | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, ticketPrice?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined, processingFee?: any | null | undefined, platformFee?: any | null | undefined, venueFee?: any | null | undefined, state?: string | null | undefined, updatedAt: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, ticketConfigTotals?: { __typename?: 'ticket_v_ticket_count_by_type', totalTickets?: number | null | undefined, ticketsSold?: any | null | undefined, ticketsRemaining?: any | null | undefined } | null | undefined } }> }>, Metrics?: { __typename?: 'ticket_v_ticket_sales_metrics', available?: any | null | undefined, total_seats?: number | null | undefined } | null | undefined, ticketCount: Array<{ __typename?: 'TicketCountByEvent', ticketCount?: any | null | undefined, parentTicketConfigId?: any | null | undefined, ticketConfigId?: any | null | undefined, salesChannel?: string | null | undefined }> };

export type TixCreateNewVenueMutationVariables = Exact<{
  objects?: InputMaybe<Array<TixVenueInsertInput> | TixVenueInsertInput>;
}>;


export type TixCreateNewVenueMutation = { __typename?: 'mutation_root', InsertVenue?: { __typename?: 'Venue_mutation_response', returning: Array<{ __typename?: 'Venue', venueId: any, name: string, description?: string | null | undefined, additionalInfo?: string | null | undefined, url?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', venuePhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, phoneNumber?: string | null | undefined, type?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'VenueAddress', venueAddressId: any, address?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, socialMedia: Array<{ __typename?: 'VenueSocialMedia', venueSocialMediaId: any, socialMedia?: { __typename?: 'SocialMedia', socialMediaId: any, url: string, socialMediaType: string } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', venueImageFileId: any, mediaFile?: { __typename?: 'MediaFile', mediaFileId: any, name: string, location: string, fileType?: string | null | undefined } | null | undefined }>, tickets: Array<{ __typename?: 'VenueTicket', venueTicketId: any, name?: string | null | undefined, description?: string | null | undefined, totalSeats?: number | null | undefined, Configurations: Array<{ __typename?: 'VenueTicketConfig', venueTicketConfig: any, TicketConfigurations?: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, salesChannel?: string | null | undefined, name?: string | null | undefined, section?: string | null | undefined, ticketType?: string | null | undefined, noOfSeats?: number | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, perOrderMin?: any | null | undefined, perOrderMax?: any | null | undefined, ticketPrice?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, ticketConfigId: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined } | null | undefined }>, Configurations_aggregate: { __typename?: 'VenueTicketConfig_aggregate', aggregate?: { __typename?: 'VenueTicketConfig_aggregate_fields', count: number } | null | undefined } }>, lineups: Array<{ __typename?: 'VenueLineup', venueLineupId: any, lineup: { __typename?: 'Lineup', lineupId: any, name: string, performers_aggregate: { __typename?: 'LineupPerformer_aggregate', aggregate?: { __typename?: 'LineupPerformer_aggregate_fields', count: number } | null | undefined }, performers: Array<{ __typename?: 'LineupPerformer', lineupPerformerId: any, performer: { __typename?: 'Performer', performerId: any, name?: string | null | undefined, title?: string | null | undefined, additionalInfo?: string | null | undefined, description?: string | null | undefined } }> } }> }> } | null | undefined };

export type TixDeleteTicketConfigurationMutationVariables = Exact<{
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteTicketConfigurationMutation = { __typename?: 'mutation_root', DeleteTicketConfigByPK?: { __typename?: 'TicketConfig', ticketConfigId: any } | null | undefined, DeleteVenueTicketConfig?: { __typename?: 'VenueTicketConfig_mutation_response', returning: Array<{ __typename?: 'VenueTicketConfig', venueTicketConfig: any }> } | null | undefined };

export type TixDeleteVenueAddressesMutationVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type TixDeleteVenueAddressesMutation = { __typename?: 'mutation_root', DeleteVenueAddress?: { __typename?: 'VenueAddress_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteVenueMediaFileByMediaFilePkMutationVariables = Exact<{
  mediaFileId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteVenueMediaFileByMediaFilePkMutation = { __typename?: 'mutation_root', DeleteVenueMediaFile?: { __typename?: 'VenueMediaFile_mutation_response', returning: Array<{ __typename?: 'VenueMediaFile', venueId?: any | null | undefined, venueImageFileId: any }> } | null | undefined, DeleteMediaFileByPK?: { __typename?: 'MediaFile', venueMediaFile: Array<{ __typename?: 'VenueMediaFile', venueId?: any | null | undefined, venueImageFileId: any }> } | null | undefined };

export type TixDeleteVenueMediaFilesMutationVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type TixDeleteVenueMediaFilesMutation = { __typename?: 'mutation_root', DeleteVenueMediaFile?: { __typename?: 'VenueMediaFile_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteVenuePhoneNumberByPhoneNumberPkMutationVariables = Exact<{
  phoneNumberId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteVenuePhoneNumberByPhoneNumberPkMutation = { __typename?: 'mutation_root', DeleteVenuePhoneNumber?: { __typename?: 'VenuePhoneNumber_mutation_response', returning: Array<{ __typename?: 'VenuePhoneNumber', venueId?: any | null | undefined, venuePhoneNumberId: any }> } | null | undefined, DeletePhoneNumberByPK?: { __typename?: 'PhoneNumber', venuePhoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', venueId?: any | null | undefined, venuePhoneNumberId: any }> } | null | undefined };

export type TixDeleteVenuePhoneNumbersMutationVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type TixDeleteVenuePhoneNumbersMutation = { __typename?: 'mutation_root', DeleteVenuePhoneNumber?: { __typename?: 'VenuePhoneNumber_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteVenueSocialMediaBySocialMediaPkMutationVariables = Exact<{
  socialMediaId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteVenueSocialMediaBySocialMediaPkMutation = { __typename?: 'mutation_root', DeleteVenueSocialMedia?: { __typename?: 'VenueSocialMedia_mutation_response', returning: Array<{ __typename?: 'VenueSocialMedia', venueId?: any | null | undefined, venueSocialMediaId: any }> } | null | undefined, DeleteSocialMediaByPK?: { __typename?: 'SocialMedia', venueSocialMedia: Array<{ __typename?: 'VenueSocialMedia', venueId?: any | null | undefined, venueSocialMediaId: any }> } | null | undefined };

export type TixDeleteVenueSocialMediasMutationVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type TixDeleteVenueSocialMediasMutation = { __typename?: 'mutation_root', DeleteVenueSocialMedia?: { __typename?: 'VenueSocialMedia_mutation_response', affected_rows: number } | null | undefined };

export type TixDeleteVenueTicketMutationVariables = Exact<{
  venueTicketId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteVenueTicketMutation = { __typename?: 'mutation_root', DeleteVenueTicketByPK?: { __typename?: 'VenueTicket', venueTicketId: any } | null | undefined };

export type TixDeleteVenueWarningByWarningPkMutationVariables = Exact<{
  warningId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixDeleteVenueWarningByWarningPkMutation = { __typename?: 'mutation_root', DeleteVenueWarning?: { __typename?: 'VenueWarning_mutation_response', returning: Array<{ __typename?: 'VenueWarning', venueId: any, venueWarningId: any }> } | null | undefined, DeleteWarningByPK?: { __typename?: 'Warning', venue_warning: Array<{ __typename?: 'VenueWarning', venueId: any, venueWarningId: any }> } | null | undefined };

export type TixDeleteVenueWarningsMutationVariables = Exact<{
  venueId: Scalars['uuid'];
}>;


export type TixDeleteVenueWarningsMutation = { __typename?: 'mutation_root', DeleteVenueWarning?: { __typename?: 'VenueWarning_mutation_response', affected_rows: number } | null | undefined };

export type TixFullVenueFragment = { __typename?: 'Venue', venueId: any, companyId?: any | null | undefined, name: string, slug?: string | null | undefined, description?: string | null | undefined, additionalInfo?: string | null | undefined, url?: string | null | undefined, state: string, phoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', venuePhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, phoneNumber?: string | null | undefined, type?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'VenueAddress', venueAddressId: any, address?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, socialMedia: Array<{ __typename?: 'VenueSocialMedia', venueSocialMediaId: any, socialMedia?: { __typename?: 'SocialMedia', socialMediaId: any, url: string, socialMediaType: string } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', venueImageFileId: any, mediaFile?: { __typename?: 'MediaFile', mediaFileId: any, name: string, location: string, fileType?: string | null | undefined } | null | undefined }>, tickets: Array<{ __typename?: 'VenueTicket', venueTicketId: any, name?: string | null | undefined, description?: string | null | undefined, totalSeats?: number | null | undefined, Configurations: Array<{ __typename?: 'VenueTicketConfig', venueTicketConfig: any, TicketConfigurations?: { __typename?: 'TicketConfig', includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, view_order?: number | null | undefined, name?: string | null | undefined, salesChannel?: string | null | undefined, section?: string | null | undefined, ticketType?: string | null | undefined, noOfSeats?: number | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, perOrderMin?: any | null | undefined, perOrderMax?: any | null | undefined, ticketPrice?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, ticketConfigId: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined } | null | undefined }>, Configurations_aggregate: { __typename?: 'VenueTicketConfig_aggregate', aggregate?: { __typename?: 'VenueTicketConfig_aggregate_fields', count: number } | null | undefined } }>, warnings: Array<{ __typename?: 'VenueWarning', companyId?: any | null | undefined, createdAt: any, updatedAt: any, updatedBy: any, venueId: any, venueWarningId: any, warningId: any, warning: { __typename?: 'Warning', createAt: any, message: string, type: string, updatedAt: any, updatedBy: any, warningId: any } }>, configurationValues: Array<{ __typename?: 'VenueConfigurationValue', Value?: { __typename?: 'ConfigurationValue', configurationItemId: any, value: string, configurationValueId: any, Item?: { __typename?: 'ConfigurationItem', placeholder?: string | null | undefined, helpText?: string | null | undefined, description?: string | null | undefined } | null | undefined } | null | undefined }> };

export type TixVenueListItemFragment = { __typename?: 'Venue', venueId: any, companyId?: any | null | undefined, name: string, url?: string | null | undefined, slug?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, sameAsCompany?: boolean | null | undefined, type?: string | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'VenueAddress', address?: { __typename?: 'Address', streetAddress?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', mediaFile?: { __typename?: 'MediaFile', name: string, location: string, fileType?: string | null | undefined } | null | undefined }>, contacts_aggregate: { __typename?: 'VenueContact_aggregate', aggregate?: { __typename?: 'VenueContact_aggregate_fields', count: number } | null | undefined }, company?: { __typename?: 'Company', name: string } | null | undefined };

export type TixGetPolicyByVenueIdQueryVariables = Exact<{
  venueId?: InputMaybe<Scalars['uuid']>;
  policyType?: InputMaybe<Scalars['String']>;
}>;


export type TixGetPolicyByVenueIdQuery = { __typename?: 'query_root', Policy: Array<{ __typename?: 'utility_policy', policyId: any, policyType?: string | null | undefined, policyText: string }> };

export type TixGetVenueByIdQueryVariables = Exact<{
  venueId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetVenueByIdQuery = { __typename?: 'query_root', VenueByPK?: { __typename?: 'Venue', venueId: any, companyId?: any | null | undefined, name: string, slug?: string | null | undefined, description?: string | null | undefined, additionalInfo?: string | null | undefined, url?: string | null | undefined, state: string, phoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', venuePhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, phoneNumber?: string | null | undefined, type?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'VenueAddress', venueAddressId: any, address?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, socialMedia: Array<{ __typename?: 'VenueSocialMedia', venueSocialMediaId: any, socialMedia?: { __typename?: 'SocialMedia', socialMediaId: any, url: string, socialMediaType: string } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', venueImageFileId: any, mediaFile?: { __typename?: 'MediaFile', mediaFileId: any, name: string, location: string, fileType?: string | null | undefined } | null | undefined }>, tickets: Array<{ __typename?: 'VenueTicket', venueTicketId: any, name?: string | null | undefined, description?: string | null | undefined, totalSeats?: number | null | undefined, Configurations: Array<{ __typename?: 'VenueTicketConfig', venueTicketConfig: any, TicketConfigurations?: { __typename?: 'TicketConfig', includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, view_order?: number | null | undefined, name?: string | null | undefined, salesChannel?: string | null | undefined, section?: string | null | undefined, ticketType?: string | null | undefined, noOfSeats?: number | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, perOrderMin?: any | null | undefined, perOrderMax?: any | null | undefined, ticketPrice?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, ticketConfigId: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined } | null | undefined }>, Configurations_aggregate: { __typename?: 'VenueTicketConfig_aggregate', aggregate?: { __typename?: 'VenueTicketConfig_aggregate_fields', count: number } | null | undefined } }>, warnings: Array<{ __typename?: 'VenueWarning', companyId?: any | null | undefined, createdAt: any, updatedAt: any, updatedBy: any, venueId: any, venueWarningId: any, warningId: any, warning: { __typename?: 'Warning', createAt: any, message: string, type: string, updatedAt: any, updatedBy: any, warningId: any } }>, configurationValues: Array<{ __typename?: 'VenueConfigurationValue', Value?: { __typename?: 'ConfigurationValue', configurationItemId: any, value: string, configurationValueId: any, Item?: { __typename?: 'ConfigurationItem', placeholder?: string | null | undefined, helpText?: string | null | undefined, description?: string | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type TixGetVenueBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type TixGetVenueBySlugQuery = { __typename?: 'query_root', Venue: Array<{ __typename?: 'Venue', venueId: any, companyId?: any | null | undefined, name: string, slug?: string | null | undefined, description?: string | null | undefined, additionalInfo?: string | null | undefined, url?: string | null | undefined, state: string, phoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', venuePhoneNumberId: any, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId: any, phoneNumber?: string | null | undefined, type?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'VenueAddress', venueAddressId: any, address?: { __typename?: 'Address', addressId: any, streetAddress?: string | null | undefined, suiteApartment?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, countryCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, socialMedia: Array<{ __typename?: 'VenueSocialMedia', venueSocialMediaId: any, socialMedia?: { __typename?: 'SocialMedia', socialMediaId: any, url: string, socialMediaType: string } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', venueImageFileId: any, mediaFile?: { __typename?: 'MediaFile', mediaFileId: any, name: string, location: string, fileType?: string | null | undefined } | null | undefined }>, tickets: Array<{ __typename?: 'VenueTicket', venueTicketId: any, name?: string | null | undefined, description?: string | null | undefined, totalSeats?: number | null | undefined, Configurations: Array<{ __typename?: 'VenueTicketConfig', venueTicketConfig: any, TicketConfigurations?: { __typename?: 'TicketConfig', includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, view_order?: number | null | undefined, name?: string | null | undefined, salesChannel?: string | null | undefined, section?: string | null | undefined, ticketType?: string | null | undefined, noOfSeats?: number | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, perOrderMin?: any | null | undefined, perOrderMax?: any | null | undefined, ticketPrice?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, ticketConfigId: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined } | null | undefined }>, Configurations_aggregate: { __typename?: 'VenueTicketConfig_aggregate', aggregate?: { __typename?: 'VenueTicketConfig_aggregate_fields', count: number } | null | undefined } }>, warnings: Array<{ __typename?: 'VenueWarning', companyId?: any | null | undefined, createdAt: any, updatedAt: any, updatedBy: any, venueId: any, venueWarningId: any, warningId: any, warning: { __typename?: 'Warning', createAt: any, message: string, type: string, updatedAt: any, updatedBy: any, warningId: any } }>, configurationValues: Array<{ __typename?: 'VenueConfigurationValue', Value?: { __typename?: 'ConfigurationValue', configurationItemId: any, value: string, configurationValueId: any, Item?: { __typename?: 'ConfigurationItem', placeholder?: string | null | undefined, helpText?: string | null | undefined, description?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type TixGetVenueTicketByPkQueryVariables = Exact<{
  venueTicketId?: InputMaybe<Scalars['uuid']>;
}>;


export type TixGetVenueTicketByPkQuery = { __typename?: 'query_root', VenueTicketByPK?: { __typename?: 'VenueTicket', name?: string | null | undefined, state?: string | null | undefined, totalSeats?: number | null | undefined, updatedAt: any, updatedBy: any, venueId?: any | null | undefined, venueTicketId: any, description?: string | null | undefined, Configurations: Array<{ __typename?: 'VenueTicketConfig', state?: string | null | undefined, ticketConfigId?: any | null | undefined, updatedAt?: any | null | undefined, updatedBy?: any | null | undefined, venueTicketConfig: any, venueTicketId?: any | null | undefined, TicketConfigurations?: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, name?: string | null | undefined, salesChannel?: string | null | undefined, noOfSeats?: number | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId: any, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, ticketPrice?: any | null | undefined, ticketType?: string | null | undefined, updatedAt: any, updatedBy: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined, helpText?: string | null | undefined, helpTextTitle?: string | null | undefined } | null | undefined }>, Configurations_aggregate: { __typename?: 'VenueTicketConfig_aggregate', aggregate?: { __typename?: 'VenueTicketConfig_aggregate_fields', count: number } | null | undefined } } | null | undefined };

export type TixGetVenuesByCompanyIdQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  fileType?: InputMaybe<Scalars['String']>;
}>;


export type TixGetVenuesByCompanyIdQuery = { __typename?: 'query_root', Venue: Array<{ __typename?: 'Venue', venueId: any, companyId?: any | null | undefined, name: string, url?: string | null | undefined, slug?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, sameAsCompany?: boolean | null | undefined, type?: string | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'VenueAddress', address?: { __typename?: 'Address', streetAddress?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', mediaFile?: { __typename?: 'MediaFile', name: string, location: string, fileType?: string | null | undefined } | null | undefined }>, contacts_aggregate: { __typename?: 'VenueContact_aggregate', aggregate?: { __typename?: 'VenueContact_aggregate_fields', count: number } | null | undefined }, company?: { __typename?: 'Company', name: string } | null | undefined }> };

export type TixGetVenuesByEventAdminIdQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['uuid']>;
  fileType?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TixGetVenuesByEventAdminIdQuery = { __typename?: 'query_root', Venue: Array<{ __typename?: 'Venue', venueId: any, companyId?: any | null | undefined, name: string, url?: string | null | undefined, slug?: string | null | undefined, phoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, sameAsCompany?: boolean | null | undefined, type?: string | null | undefined } | null | undefined }>, addresses: Array<{ __typename?: 'VenueAddress', address?: { __typename?: 'Address', streetAddress?: string | null | undefined, city?: string | null | undefined, stateProvince?: string | null | undefined, postalCode?: string | null | undefined, sameAsCompany?: boolean | null | undefined } | null | undefined }>, mediaFiles: Array<{ __typename?: 'VenueMediaFile', mediaFile?: { __typename?: 'MediaFile', name: string, location: string, fileType?: string | null | undefined } | null | undefined }>, contacts_aggregate: { __typename?: 'VenueContact_aggregate', aggregate?: { __typename?: 'VenueContact_aggregate_fields', count: number } | null | undefined }, company?: { __typename?: 'Company', name: string } | null | undefined }> };

export type TixInsertVenueTicketConfigMutationVariables = Exact<{
  objects?: InputMaybe<Array<TixVenueTicketConfigInsertInput> | TixVenueTicketConfigInsertInput>;
}>;


export type TixInsertVenueTicketConfigMutation = { __typename?: 'mutation_root', InsertVenueTicketConfig?: { __typename?: 'VenueTicketConfig_mutation_response', returning: Array<{ __typename?: 'VenueTicketConfig', TicketConfigurations?: { __typename?: 'TicketConfig', includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, view_order?: number | null | undefined, name?: string | null | undefined, salesChannel?: string | null | undefined, noOfSeats?: number | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, seat?: string | null | undefined, row?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, ticketConfigId: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined } | null | undefined }> } | null | undefined };

export type TixInsertVenueTicketMutationVariables = Exact<{
  objects?: InputMaybe<Array<TixVenueTicketInsertInput> | TixVenueTicketInsertInput>;
}>;


export type TixInsertVenueTicketMutation = { __typename?: 'mutation_root', InsertVenueTicket?: { __typename?: 'VenueTicket_mutation_response', returning: Array<{ __typename?: 'VenueTicket', state?: string | null | undefined, updatedAt: any, updatedBy: any, venueTicketId: any, name?: string | null | undefined, totalSeats?: number | null | undefined, description?: string | null | undefined, venueId?: any | null | undefined, Configurations: Array<{ __typename?: 'VenueTicketConfig', ticketConfigId?: any | null | undefined, updatedAt?: any | null | undefined, updatedBy?: any | null | undefined, venueTicketConfig: any, venueTicketId?: any | null | undefined, state?: string | null | undefined, TicketConfigurations?: { __typename?: 'TicketConfig', view_order?: number | null | undefined, includeFees?: boolean | null | undefined, parentTicketId?: any | null | undefined, name?: string | null | undefined, salesChannel?: string | null | undefined, noOfSeats?: number | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, seat?: string | null | undefined, row?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketType?: string | null | undefined, ticketPrice?: any | null | undefined, platformFee?: any | null | undefined, processingFee?: any | null | undefined, venueFee?: any | null | undefined, ticketConfigId: any, updatedAt: any, updatedBy: any, startSellingDate?: any | null | undefined, stopSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingTime?: any | null | undefined } | null | undefined }>, Configurations_aggregate: { __typename?: 'VenueTicketConfig_aggregate', aggregate?: { __typename?: 'VenueTicketConfig_aggregate_fields', count: number } | null | undefined } }> } | null | undefined };

export type TixMarkVenueAsDeletedMutationVariables = Exact<{
  venueId: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  updatedBy: Scalars['uuid'];
}>;


export type TixMarkVenueAsDeletedMutation = { __typename?: 'mutation_root', UpdateVenue?: { __typename?: 'Venue_mutation_response', affected_rows: number } | null | undefined };

export type TixSetVenuePhoneNumbersSameAsCompanyMutationVariables = Exact<{
  venueId?: InputMaybe<Scalars['uuid']>;
  updatedBy: Scalars['uuid'];
  updatedAt?: InputMaybe<Scalars['timestamp']>;
}>;


export type TixSetVenuePhoneNumbersSameAsCompanyMutation = { __typename?: 'mutation_root', DeleteVenuePhoneNumber?: { __typename?: 'VenuePhoneNumber_mutation_response', affected_rows: number } | null | undefined, DeletePhoneNumber?: { __typename?: 'PhoneNumber_mutation_response', affected_rows: number } | null | undefined, InsertPhoneNumber?: { __typename?: 'PhoneNumber_mutation_response', returning: Array<{ __typename?: 'PhoneNumber', countryCode?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberId: any, state: string, type?: string | null | undefined, updatedAt: any, updatedBy: any, venuePhoneNumbers: Array<{ __typename?: 'VenuePhoneNumber', venueId?: any | null | undefined, venuePhoneNumberId: any, updatedAt: any, updatedBy: any }> }> } | null | undefined };

export type TixUpdateTicketConfigByPkMutationVariables = Exact<{
  ticketConfigId?: InputMaybe<Scalars['uuid']>;
  _set?: InputMaybe<TixTicketConfigSetInput>;
}>;


export type TixUpdateTicketConfigByPkMutation = { __typename?: 'mutation_root', UpdateTicketConfigByPK?: { __typename?: 'TicketConfig', name?: string | null | undefined, noOfSeats?: number | null | undefined, perOrderMax?: any | null | undefined, perOrderMin?: any | null | undefined, row?: string | null | undefined, seat?: string | null | undefined, section?: string | null | undefined, state?: string | null | undefined, ticketConfigId: any, platformFee?: any | null | undefined, ticketPrice?: any | null | undefined, ticketType?: string | null | undefined, updatedAt: any, updatedBy: any, startSellingDate?: any | null | undefined, startSellingTime?: any | null | undefined, stopSellingDate?: any | null | undefined, stopSellingTime?: any | null | undefined, view_order?: number | null | undefined } | null | undefined };

export type TixUpdateVenueTicketByPkMutationVariables = Exact<{
  venueTicketId?: InputMaybe<Scalars['uuid']>;
  _set?: InputMaybe<TixVenueTicketSetInput>;
}>;


export type TixUpdateVenueTicketByPkMutation = { __typename?: 'mutation_root', UpdateVenueTicketByPK?: { __typename?: 'VenueTicket', name?: string | null | undefined, state?: string | null | undefined, totalSeats?: number | null | undefined, updatedAt: any, updatedBy: any, venueId?: any | null | undefined, venueTicketId: any, description?: string | null | undefined } | null | undefined };

export const CustomerSearchElementFragmentDoc = gql`
    fragment CustomerSearchElement on CustomerSearch {
  firstName
  lastName
  emailAddress
  phoneNumber
  reservationId
  reservationNo
  reservationDate
  companyId
  eventDateFormatted
  startTimeFormatted
  reservationDateFormatted
  companyName
  venueId
  venueName
  eventInstanceId
  eventName
  eventDate
  startTime
  salesChannel
  ticketCount
  subTotal
  discountAmount
  venueFee
  venueRevenue
  totalAmountPaid
  platformFee
  processingFee
  discountCode
  paymentType
  refundAmount
}
    `;
export const TicketNodeFragmentDoc = gql`
    fragment TicketNode on Ticket {
  state
  venueFee
  processingFee
  platformFee
  discountAmount
  contact {
    contactId
    firstName
    lastName
    emailAddress
    dob
    fullName
    customer {
      city
      streetAddress
      stateProvince
      countryCode
      postalCode
      emailAddress
      customerFullName
      dob
      phoneNumber
      phoneCountryCode
    }
    phoneNumbers {
      phoneNumber {
        phoneNumber
      }
    }
  }
  checkedInAt
  row
  seat
  ticketType
  ticketConfig {
    name
  }
  ticketNo
  reservationNo
  section
  state
  reservation {
    totalAmountPaid
    groupCode
    reservationId
    reservationDate
    discountAmount
  }
  ticketId
  ticketPrice
  discountAmount
}
    `;
export const HoldItemFragmentDoc = gql`
    fragment HoldItem on OrderHoldItemResult {
  id
  quantity
  type
  expiresAt
}
    `;
export const BuyerProductFragmentFragmentDoc = gql`
    fragment BuyerProductFragment on EventProduct {
  eventProductId
  name
  price
  quantity
  quantitySold
  quantityRemaining
  tax
  state
  salesChannel
  additionalInfo
  productId
  EventProductMedia {
    MediaFile {
      location
      name
    }
  }
}
    `;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  name
  state
  quantity
  price
  tax
  productId
  additionalInformation
  productMedia {
    mediaFile {
      location
    }
  }
}
    `;
export const PaymentExchangeDataFragmentDoc = gql`
    fragment PaymentExchangeData on GQLPaymentExchangeData {
  exchangeId
  expiresAt
  state
  createdAt
  originalReservationId
  newReservationId
  amount
  required_action
  exchangedTicketIds
  exchangedProductIds
  paymentIntentClientSecret
  originalReservation {
    totalAmountPaid
    subTotal
    discountAmount
    eventInstanceId
    event {
      name
      date
      startTime
    }
    contact {
      firstName
      lastName
      emailAddress
    }
    payment {
      payment {
        paymentId
        paymentToken
      }
    }
    discount {
      discountId
      type
      appliedTo
      buyAmount
      getAmount
    }
    tickets {
      ticketId
      active
      checkedInAt
      contactId
      createdAt
      discountAmount
      eventInstanceId
      platformFee
      processingFee
      reservationId
      reservationNo
      row
      seat
      section
      state
      ticketConfigId
      ticketNo
      ticketPrice
      ticketType
      venueFee
      ticketConfig {
        ticketConfigId
        ticketPrice
        venueFee
        includeFees
        ticketType
        section
      }
    }
    reservationDetails {
      reservationDetailId
      amount
      comment
      createdAt
      createdBy
      price
      quantity
      ticketConfigId
      type
    }
    productOrder {
      createdAt
      createdBy
      payment_type
      state
      orderDetails {
        orderDetailId
        active
        amount
        comment
        eventProductId
        price
        quantity
        state
        type
        eventproduct {
          name
          price
          tax
        }
      }
    }
  }
  newReservation {
    totalAmountPaid
    subTotal
    discountAmount
    eventInstanceId
    event {
      name
      date
      startTime
    }
    contact {
      firstName
      lastName
      emailAddress
    }
    payment {
      payment {
        paymentId
        paymentToken
      }
    }
    discount {
      discountId
      type
      appliedTo
      buyAmount
      getAmount
    }
    tickets {
      ticketId
      active
      checkedInAt
      contactId
      createdAt
      discountAmount
      eventInstanceId
      platformFee
      processingFee
      reservationId
      reservationNo
      row
      seat
      section
      state
      ticketConfigId
      ticketNo
      ticketPrice
      ticketType
      venueFee
      ticketConfig {
        ticketConfigId
        ticketPrice
        venueFee
        includeFees
        ticketType
        section
      }
    }
    reservationDetails {
      reservationDetailId
      amount
      comment
      createdAt
      createdBy
      price
      quantity
      ticketConfigId
      type
    }
    productOrder {
      createdAt
      createdBy
      payment_type
      state
      orderDetails {
        orderDetailId
        active
        amount
        comment
        eventProductId
        price
        quantity
        state
        type
        eventproduct {
          name
          price
          tax
        }
      }
    }
  }
}
    `;
export const ExchangeReservationDataFragmentDoc = gql`
    fragment ExchangeReservationData on ticket_reservation {
  contact {
    fullName
    emailAddress
  }
  reservationId
  eventInstanceId
  event {
    name
    date
    startTime
  }
  tickets {
    ticketId
    ticketNo
    ticketType
    ticketPrice
    discountAmount
    venueFee
    platformFee
    processingFee
    reservationNo
    section
  }
  product_order {
    order_detail {
      orderDetailId
      quantity
      price
      type
      eventProductId
      eventproduct {
        name
        price
      }
    }
  }
}
    `;
export const OrderDataFragmentDoc = gql`
    fragment OrderData on ticket_reservation {
  active
  state
  reservationId
  eventInstanceId
  totalAmountPaid
  subTotal
  discountAmount
  event {
    name
    date
    startTime
    venue {
      name
    }
  }
  contact {
    fullName
    emailAddress
  }
  payment {
    payment {
      paymentToken
    }
  }
  discount {
    type
    appliedTo
    buyAmount
    getAmount
  }
  tickets {
    ticketId
    ticketNo
    reservationNo
    ticketConfig {
      ticketConfigId
      ticketPrice
      venueFee
      includeFees
    }
    active
    checkedInAt
    contactId
    createdAt
    discountAmount
    eventInstanceId
    platformFee
    processingFee
    row
    seat
    section
    state
    ticketConfigId
    ticketPrice
    ticketType
    venueFee
  }
  reservationDetails: reservation_detail {
    active
    amount
    comment
    createdAt
    createdBy
    price
    quantity
    ticketConfigId
    type
  }
  productOrder: product_order {
    createdAt
    createdBy
    payment_type
    state
    orderDetails: order_detail {
      orderDetailId
      eventproduct {
        name
        price
        tax
      }
      active
      amount
      comment
      eventProductId
      price
      quantity
      state
      type
    }
  }
}
    `;
export const VenuePortalEventFragmentDoc = gql`
    fragment VenuePortalEvent on EventInstance {
  eventInstanceId
  venueId
  eventName: name
  eventDescription: description
  eventAdditionalInfo: additionalInfo
  date
  startTime
  doorsOpen
  startSellingDate
  startSellingTime
  stopSellingDate
  stopSellingTime
  passcode
  venue {
    companyId
    venueId
    name
  }
  media {
    mediaId
    mediaFile {
      fileType
      location
      mediaFileId
    }
  }
  SocialMedia: socialMedia {
    socialMedia {
      socialMediaType
      url
    }
  }
  campaign {
    campaign_tracking_id
    campaign_name
    campaignCode
    campaignType
  }
  eventType: type
  minimumAge
  Tickets: eventInstanceTickets {
    Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
      TicketConfigurations {
        view_order
        includeFees
        perOrderMax
        perOrderMin
        parentTicketId
        salesChannel
        ticketConfigTotals: totalTicketsByType {
          totalTickets
          ticketsSold
          ticketsRemaining
        }
        noOfSeats
        ticketConfigId
        name
        ticketType
        section
        row
        seat
        ticketPrice
        helpText
        helpTextTitle
        processingFee
        platformFee
        venueFee
        state
        updatedAt
        startSellingDate
        stopSellingDate
        startSellingTime
        stopSellingTime
      }
    }
  }
  Metrics: eventTicketSalesMetrics {
    available
    total_seats
  }
  ticketCount {
    ticketCount
    parentTicketConfigId
    ticketConfigId
    salesChannel
  }
}
    `;
export const FullVenueFragmentDoc = gql`
    fragment FullVenue on Venue {
  venueId
  companyId
  name
  slug
  description
  additionalInfo
  url
  state
  companyId
  phoneNumbers {
    venuePhoneNumberId
    phoneNumber {
      phoneNumberId
      phoneNumber
      type
      sameAsCompany
    }
  }
  addresses {
    venueAddressId
    address {
      addressId
      streetAddress
      suiteApartment
      city
      stateProvince
      postalCode
      countryCode
      sameAsCompany
    }
  }
  socialMedia {
    venueSocialMediaId
    socialMedia {
      socialMediaId
      url
      socialMediaType
    }
  }
  mediaFiles {
    venueImageFileId
    mediaFile {
      mediaFileId
      name
      location
      fileType
    }
  }
  tickets {
    venueTicketId
    name
    description
    totalSeats
    Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
      venueTicketConfig
      TicketConfigurations {
        includeFees
        parentTicketId
        view_order
        name
        salesChannel
        section
        ticketType
        noOfSeats
        row
        seat
        perOrderMin
        perOrderMax
        ticketPrice
        platformFee
        processingFee
        venueFee
        ticketConfigId
        startSellingDate
        stopSellingDate
        startSellingTime
        stopSellingTime
        helpText
        helpTextTitle
      }
    }
    Configurations_aggregate {
      aggregate {
        count(columns: venueTicketConfig)
      }
    }
  }
  warnings {
    companyId
    createdAt
    updatedAt
    updatedBy
    venueId
    venueWarningId
    warning {
      createAt
      message
      type
      updatedAt
      updatedBy
      warningId
    }
    warningId
  }
  configurationValues {
    Value {
      configurationItemId
      value
      configurationValueId
      Item {
        placeholder
        helpText
        description
      }
    }
  }
}
    `;
export const VenueListItemFragmentDoc = gql`
    fragment VenueListItem on Venue {
  venueId
  companyId
  name
  url
  slug
  phoneNumbers {
    phoneNumber {
      countryCode
      phoneNumber
      sameAsCompany
      type
    }
  }
  addresses {
    address {
      streetAddress
      city
      stateProvince
      postalCode
      sameAsCompany
    }
  }
  mediaFiles(where: {mediaFile: {fileType: {_eq: $fileType}}}) {
    mediaFile {
      name
      location
      fileType
    }
  }
  contacts_aggregate {
    aggregate {
      count(distinct: true)
    }
  }
  company {
    name
  }
}
    `;
export const CreateRedirectCodeDocument = gql`
    mutation CreateRedirectCode($token: String!) {
  createRedirectCode(token: $token)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCreateRedirectCodeGQL extends Apollo.Mutation<TixCreateRedirectCodeMutation, TixCreateRedirectCodeMutationVariables> {
    document = CreateRedirectCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExchangeRedirectCodeForTokenDocument = gql`
    mutation ExchangeRedirectCodeForToken($redirectCode: String!) {
  exchangeRedirectCodeForToken(redirectCode: $redirectCode)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixExchangeRedirectCodeForTokenGQL extends Apollo.Mutation<TixExchangeRedirectCodeForTokenMutation, TixExchangeRedirectCodeForTokenMutationVariables> {
    document = ExchangeRedirectCodeForTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessCodesByGroupNameDocument = gql`
    query getBusinessCodesByGroupName($codegroup: String, $name: order_by = asc) @cached {
  BusinessCodeGroup(where: {name: {_eq: $codegroup}}) {
    name
    description
    busCodeGroupId
    businessCodes(order_by: {name: $name}) {
      businessCodeId
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetBusinessCodesByGroupNameGQL extends Apollo.Query<TixGetBusinessCodesByGroupNameQuery, TixGetBusinessCodesByGroupNameQueryVariables> {
    document = GetBusinessCodesByGroupNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePaymentDocument = gql`
    mutation CreatePayment($amount: Float!, $mode: String = "test", $description: String!) {
  createPayment(amount: $amount, mode: $mode, description: $description)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCreatePaymentGQL extends Apollo.Mutation<TixCreatePaymentMutation, TixCreatePaymentMutationVariables> {
    document = CreatePaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePayoutDetailDocument = gql`
    mutation CreatePayoutDetail($reservationId: uuid!, $payoutId: uuid!, $createdBy: uuid, $createdAt: timestamptz = "now()", $updatedAt: timestamptz = "now()", $updatedBy: uuid) {
  InsertPayoutDetail(
    objects: [{reservationId: $reservationId, payoutId: $payoutId, updatedAt: $updatedAt, updatedBy: $updatedBy, createdAt: $createdAt, createdBy: $createdBy}]
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCreatePayoutDetailGQL extends Apollo.Mutation<TixCreatePayoutDetailMutation, TixCreatePayoutDetailMutationVariables> {
    document = CreatePayoutDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePayoutDocument = gql`
    mutation CreatePayout($companyId: uuid!, $venueId: uuid!, $eventInstanceId: uuid!, $createdAt: timestamptz! = "now()", $updatedAt: timestamptz! = "now()", $updatedBy: uuid!, $createdBy: uuid!, $description: String!) {
  InsertPayout(
    objects: [{companyId: $companyId, venueId: $venueId, eventInstanceId: $eventInstanceId, createdAt: $createdAt, createdBy: $createdBy, updatedAt: $updatedAt, updatedBy: $updatedBy, description: $description}]
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCreatePayoutGQL extends Apollo.Mutation<TixCreatePayoutMutation, TixCreatePayoutMutationVariables> {
    document = CreatePayoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayoutByEventInstanceIdDocument = gql`
    query GetPayoutByEventInstanceId($eventInstanceId: uuid!) {
  Payout(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    payoutId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetPayoutByEventInstanceIdGQL extends Apollo.Query<TixGetPayoutByEventInstanceIdQuery, TixGetPayoutByEventInstanceIdQueryVariables> {
    document = GetPayoutByEventInstanceIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationByContactIdDocument = gql`
    query GetReservationByContactId($contactId: uuid, $eventInstanceId: uuid) {
  Reservation(
    where: {contactId: {_eq: $contactId}, eventInstanceId: {_eq: $eventInstanceId}}
  ) {
    tickets {
      ticketType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetReservationByContactIdGQL extends Apollo.Query<TixGetReservationByContactIdQuery, TixGetReservationByContactIdQueryVariables> {
    document = GetReservationByContactIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationByIdDocument = gql`
    query GetReservationById($reservationId: uuid!) {
  Reservation(where: {reservationId: {_eq: $reservationId}}) {
    reservationId
    contactId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetReservationByIdGQL extends Apollo.Query<TixGetReservationByIdQuery, TixGetReservationByIdQueryVariables> {
    document = GetReservationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationDetailsByIdDocument = gql`
    query GetReservationDetailsById($reservationId: uuid!) {
  Reservation(where: {reservationId: {_eq: $reservationId}}) {
    reservationId
    contactId
    reservation_detail {
      eventInstanceId
      comment
      amount
      reservationId
      createdBy
      contactId
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetReservationDetailsByIdGQL extends Apollo.Query<TixGetReservationDetailsByIdQuery, TixGetReservationDetailsByIdQueryVariables> {
    document = GetReservationDetailsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationOrderDetailsDocument = gql`
    query GetReservationOrderDetails($reservationId: uuid!) {
  Reservation(where: {reservationId: {_eq: $reservationId}}) {
    product_order {
      order_detail {
        type
        state
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetReservationOrderDetailsGQL extends Apollo.Query<TixGetReservationOrderDetailsQuery, TixGetReservationOrderDetailsQueryVariables> {
    document = GetReservationOrderDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTotalNumberTicketsSoldForEventDocument = gql`
    query GetTotalNumberTicketsSoldForEvent($eventInstanceId: uuid!) {
  TicketAggregate(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTotalNumberTicketsSoldForEventGQL extends Apollo.Query<TixGetTotalNumberTicketsSoldForEventQuery, TixGetTotalNumberTicketsSoldForEventQueryVariables> {
    document = GetTotalNumberTicketsSoldForEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenueByPrimaryKeyDocument = gql`
    query GetVenueByPrimaryKey($venueId: uuid = "") {
  VenueByPK(venueId: $venueId) {
    venueId
    name
    description
    additionalInfo
    state
    url
    addresses {
      address {
        streetAddress
        city
        stateProvince
        postalCode
        sameAsCompany
      }
    }
    mediaFiles {
      mediaFile {
        fileType
        location
      }
    }
    phoneNumbers {
      phoneNumber {
        countryCode
        phoneNumber
        sameAsCompany
        type
      }
    }
    company {
      name
      addresses {
        address {
          streetAddress
          city
          stateProvince
          postalCode
        }
      }
      phoneNumbers {
        phoneNumber {
          countryCode
          phoneNumber
          type
        }
      }
      mediaFiles {
        mediaFile {
          fileType
          location
        }
      }
      warnings {
        warning {
          message
          type
        }
      }
    }
    warnings {
      warning {
        message
        type
      }
    }
    configurationValues {
      Value {
        configurationItemId
        value
        configurationValueId
        Item {
          placeholder
          helpText
          description
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenueByPrimaryKeyGQL extends Apollo.Query<TixGetVenueByPrimaryKeyQuery, TixGetVenueByPrimaryKeyQueryVariables> {
    document = GetVenueByPrimaryKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TicketReservationDetailInsertDocument = gql`
    mutation TicketReservationDetailInsert($objects: [TicketReservationDetail_insert_input!]!) {
  TicketReservationDetailInsert(objects: $objects) {
    returning {
      amount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixTicketReservationDetailInsertGQL extends Apollo.Mutation<TixTicketReservationDetailInsertMutation, TixTicketReservationDetailInsertMutationVariables> {
    document = TicketReservationDetailInsertDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertPaymentReservationTicketDocument = gql`
    mutation InsertPaymentReservationTicket($insertPayment: [Payment_insert_input!] = {}) {
  InsertPayment(objects: $insertPayment) {
    returning {
      paymentId
      cardToken
      paymentToken
      paymentProvider
      totalAmount
      paymentResponse
      state
      updatedBy
      createdBy
      updatedAt
      Contact {
        emailAddress
        firstName
        lastName
        dob
        phoneNumbers {
          phoneNumber {
            phoneNumber
          }
        }
      }
      Reservation {
        reservation {
          reservationId
          eventInstanceId
          contactId
          additionalComments
          groupCode
          discountAmount
          isGroup
          reservationDate
          reservationStatus
          state
          updatedBy
          updatedAt
          reservation_detail {
            eventInstanceId
            comment
            amount
            reservationId
            createdBy
            contactId
            type
          }
          discount {
            appliedTo
            getAmount
          }
          contact {
            customer {
              customerId
            }
          }
          tickets {
            ticketId
            eventInstanceId
            reservationId
            ticketConfigId
            contactId
            ticketType
            section
            row
            seat
            ticketPrice
            processingFee
            platformFee
            state
            discountAmount
            venueFee
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertPaymentReservationTicketGQL extends Apollo.Mutation<TixInsertPaymentReservationTicketMutation, TixInsertPaymentReservationTicketMutationVariables> {
    document = InsertPaymentReservationTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefundDonationsDocument = gql`
    mutation RefundDonations($updatedBy: String!, $mode: String!, $reservationId: String!) {
  refundDonations(
    updatedBy: $updatedBy
    mode: $mode
    reservationId: $reservationId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixRefundDonationsGQL extends Apollo.Mutation<TixRefundDonationsMutation, TixRefundDonationsMutationVariables> {
    document = RefundDonationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefundReservationDocument = gql`
    mutation RefundReservation($reservationId: String!, $mode: String!, $updatedBy: String!) {
  refundReservation(
    mode: $mode
    updatedBy: $updatedBy
    reservationId: $reservationId
    notifyCustomer: true
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixRefundReservationGQL extends Apollo.Mutation<TixRefundReservationMutation, TixRefundReservationMutationVariables> {
    document = RefundReservationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefundTicketDocument = gql`
    mutation RefundTicket($mode: String!, $ticketId: String!, $updatedBy: String!) {
  refundTicket(
    mode: $mode
    ticketId: $ticketId
    notifyCustomer: true
    updatedBy: $updatedBy
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixRefundTicketGQL extends Apollo.Mutation<TixRefundTicketMutation, TixRefundTicketMutationVariables> {
    document = RefundTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendETicketDocument = gql`
    mutation SendETicket($data: SendETicketInput!) {
  sendEticket(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixSendETicketGQL extends Apollo.Mutation<TixSendETicketMutation, TixSendETicketMutationVariables> {
    document = SendETicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendTicketPurchaseEmailDocument = gql`
    mutation SendTicketPurchaseEmail($data: SendTicketEmailNotificaionInput!) {
  sendTicketPurchaseEmail(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixSendTicketPurchaseEmailGQL extends Apollo.Mutation<TixSendTicketPurchaseEmailMutation, TixSendTicketPurchaseEmailMutationVariables> {
    document = SendTicketPurchaseEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePaymentIntentMetadataDocument = gql`
    mutation UpdatePaymentIntentMetadata($metadataJson: String!, $paymentIntentId: String!, $mode: String!) {
  updatePaymentIntentMetadata(
    metadataJSON: $metadataJson
    paymentIntentId: $paymentIntentId
    mode: $mode
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdatePaymentIntentMetadataGQL extends Apollo.Mutation<TixUpdatePaymentIntentMetadataMutation, TixUpdatePaymentIntentMetadataMutationVariables> {
    document = UpdatePaymentIntentMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($paymentObject: Payment_set_input, $reservationId: uuid) {
  UpdatePayment(
    where: {Reservation: {reservationId: {_eq: $reservationId}}}
    _set: $paymentObject
  ) {
    returning {
      createdBy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdatePaymentGQL extends Apollo.Mutation<TixUpdatePaymentMutation, TixUpdatePaymentMutationVariables> {
    document = UpdatePaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyEmailDocument = gql`
    mutation deleteCompanyEmail($companyId: uuid!) {
  delete_communications_company_email(where: {companyId: {_eq: $companyId}}) {
    returning {
      companyEmailId
      emailContentId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteCompanyEmailGQL extends Apollo.Mutation<TixDeleteCompanyEmailMutation, TixDeleteCompanyEmailMutationVariables> {
    document = DeleteCompanyEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEmailTemplateByIdDocument = gql`
    mutation DeleteEmailTemplateById($emailContentId: uuid!) {
  delete_EmailContent(where: {emailContentId: {_eq: $emailContentId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteEmailTemplateByIdGQL extends Apollo.Mutation<TixDeleteEmailTemplateByIdMutation, TixDeleteEmailTemplateByIdMutationVariables> {
    document = DeleteEmailTemplateByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEventEmailDocument = gql`
    mutation DeleteEventEmail($eventInstanceId: uuid!) {
  delete_EventEmail(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteEventEmailGQL extends Apollo.Mutation<TixDeleteEventEmailMutation, TixDeleteEventEmailMutationVariables> {
    document = DeleteEventEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueEmailDocument = gql`
    mutation deleteVenueEmail($venueId: uuid!) {
  delete_communications_venue_email(where: {venueId: {_eq: $venueId}}) {
    returning {
      createdBy
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueEmailGQL extends Apollo.Mutation<TixDeleteVenueEmailMutation, TixDeleteVenueEmailMutationVariables> {
    document = DeleteVenueEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllEmailVariablesDocument = gql`
    query getAllEmailVariables {
  communications_email_variable {
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetAllEmailVariablesGQL extends Apollo.Query<TixGetAllEmailVariablesQuery, TixGetAllEmailVariablesQueryVariables> {
    document = GetAllEmailVariablesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompaniesOfTemplatesByIdDocument = gql`
    query getCompaniesOfTemplatesById($emailContentId: uuid!) {
  communications_company_email(where: {emailContentId: {_eq: $emailContentId}}) {
    companyId
    emailContentId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCompaniesOfTemplatesByIdGQL extends Apollo.Query<TixGetCompaniesOfTemplatesByIdQuery, TixGetCompaniesOfTemplatesByIdQueryVariables> {
    document = GetCompaniesOfTemplatesByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyEmailDocument = gql`
    query getCompanyEmail($companyId: uuid!) {
  communications_company_email(where: {companyId: {_eq: $companyId}}) {
    emailContentId
    companyId
    companyEmailId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCompanyEmailGQL extends Apollo.Query<TixGetCompanyEmailQuery, TixGetCompanyEmailQueryVariables> {
    document = GetCompanyEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventEmailSelectDocument = gql`
    query EventEmailSelect($eventInstanceId: uuid) {
  EventEmailSelect(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    emailContentId
    eventEmailId
    eventInstanceId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventEmailSelectGQL extends Apollo.Query<TixEventEmailSelectQuery, TixEventEmailSelectQueryVariables> {
    document = EventEmailSelectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailTemplateByidDocument = gql`
    query getEmailTemplateByid($emailContentId: uuid!) {
  EmailContentSelect(where: {emailContentId: {_eq: $emailContentId}}) {
    emailContentId
    companyId
    name
    body
    sender
    state
    format
    subject
    type
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEmailTemplateByidGQL extends Apollo.Query<TixGetEmailTemplateByidQuery, TixGetEmailTemplateByidQueryVariables> {
    document = GetEmailTemplateByidDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailTemplateOfEventDocument = gql`
    query getEmailTemplateOfEvent($eventInstanceId: uuid) {
  EventEmailSelect(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    emailContentId
    EventEmailContent {
      emailContentId
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEmailTemplateOfEventGQL extends Apollo.Query<TixGetEmailTemplateOfEventQuery, TixGetEmailTemplateOfEventQueryVariables> {
    document = GetEmailTemplateOfEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailTemplateByCompanyidDocument = gql`
    query getEmailTemplateByCompanyid($companyId: uuid!, $type: String = "%%", $state: String = "Active", $nameOrSubject: String = "%%") {
  EmailContentSelect(
    where: {companyId: {_eq: $companyId}, _and: [{type: {_ilike: $type}}, {state: {_like: $state}}, {_or: [{name: {_ilike: $nameOrSubject}}, {subject: {_ilike: $nameOrSubject}}]}]}
  ) {
    emailContentId
    companyId
    name
    format
    subject
    body
    state
    type
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEmailTemplateByCompanyidGQL extends Apollo.Query<TixGetEmailTemplateByCompanyidQuery, TixGetEmailTemplateByCompanyidQueryVariables> {
    document = GetEmailTemplateByCompanyidDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsOfTemplateByIdDocument = gql`
    query getEventsOfTemplateById($templateId: uuid) {
  EventEmailSelect(where: {emailContentId: {_eq: $templateId}}) {
    emailContentId
    eventEmailId
    EventEmailContent {
      emailContentId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventsOfTemplateByIdGQL extends Apollo.Query<TixGetEventsOfTemplateByIdQuery, TixGetEventsOfTemplateByIdQueryVariables> {
    document = GetEventsOfTemplateByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenueEmailDocument = gql`
    query getVenueEmail($venueId: uuid! = "%%") {
  communications_venue_email(where: {venueId: {_eq: $venueId}}) {
    emailContentId
    venueEmailId
    venueId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenueEmailGQL extends Apollo.Query<TixGetVenueEmailQuery, TixGetVenueEmailQueryVariables> {
    document = GetVenueEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenuesOfTemplatesByIdDocument = gql`
    query getVenuesOfTemplatesById($emailContentId: uuid!) {
  communications_venue_email(where: {emailContentId: {_eq: $emailContentId}}) {
    emailContentId
    venueEmailId
    venueId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenuesOfTemplatesByIdGQL extends Apollo.Query<TixGetVenuesOfTemplatesByIdQuery, TixGetVenuesOfTemplatesByIdQueryVariables> {
    document = GetVenuesOfTemplatesByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCompanyEmailDocument = gql`
    mutation insertCompanyEmail($objects: [communications_company_email_insert_input!]!) {
  insert_communications_company_email(objects: $objects) {
    returning {
      companyId
      emailContentId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertCompanyEmailGQL extends Apollo.Mutation<TixInsertCompanyEmailMutation, TixInsertCompanyEmailMutationVariables> {
    document = InsertCompanyEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertEmailTemplateDocument = gql`
    mutation InsertEmailTemplate($companyId: uuid!, $body: String = "", $name: String = "", $type: String = "", $subject: String = "", $sender: String = "", $state: String = "", $format: String = "", $formattedBody: String = "", $createdAt: timestamp = "now()", $updatedAt: timestamp = "now()") {
  EmailContentInsertOne(
    object: {companyId: $companyId, body: $body, name: $name, subject: $subject, sender: $sender, formattedBody: $formattedBody, format: $format, state: $state, type: $type, createdAt: $createdAt, updatedAt: $updatedAt}
  ) {
    createdAt
    companyId
    format
    type
    name
    state
    sender
    subject
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertEmailTemplateGQL extends Apollo.Mutation<TixInsertEmailTemplateMutation, TixInsertEmailTemplateMutationVariables> {
    document = InsertEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertEmailTemplatesOfEventDocument = gql`
    mutation insertEmailTemplatesOfEvent($objects: [EventEmail_insert_input!]!) {
  EventEmailInsert(objects: $objects) {
    returning {
      eventInstanceId
      emailContentId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertEmailTemplatesOfEventGQL extends Apollo.Mutation<TixInsertEmailTemplatesOfEventMutation, TixInsertEmailTemplatesOfEventMutationVariables> {
    document = InsertEmailTemplatesOfEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertVenueEmailDocument = gql`
    mutation insertVenueEmail($objects: [communications_venue_email_insert_input!]!) {
  insert_communications_venue_email(objects: $objects) {
    returning {
      emailContentId
      venueId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertVenueEmailGQL extends Apollo.Mutation<TixInsertVenueEmailMutation, TixInsertVenueEmailMutationVariables> {
    document = InsertVenueEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmailTemplateByIdDocument = gql`
    mutation updateEmailTemplateById($emailContentId: uuid! = "", $type: String = "", $name: String = "", $body: String = "", $subject: String = "", $format: String = "", $state: String = "", $sender: String = "", $formattedBody: String = "", $updatedAt: timestamp = "now()") {
  EmailContentUpdate(
    where: {emailContentId: {_eq: $emailContentId}}
    _set: {type: $type, name: $name, body: $body, state: $state, updatedAt: $updatedAt, subject: $subject, sender: $sender, format: $format, formattedBody: $formattedBody}
  ) {
    affected_rows
    returning {
      type
      name
      body
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateEmailTemplateByIdGQL extends Apollo.Mutation<TixUpdateEmailTemplateByIdMutation, TixUpdateEmailTemplateByIdMutationVariables> {
    document = UpdateEmailTemplateByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventEmailUpdateDocument = gql`
    mutation EventEmailUpdate($eventInstanceId: uuid!, $emailContentId: uuid!, $updatedAt: timestamp = "now()") {
  EventEmailUpdate(
    where: {eventInstanceId: {_eq: $eventInstanceId}}
    _set: {emailContentId: $emailContentId, updatedAt: $updatedAt}
  ) {
    affected_rows
    returning {
      emailContentId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventEmailUpdateGQL extends Apollo.Mutation<TixEventEmailUpdateMutation, TixEventEmailUpdateMutationVariables> {
    document = EventEmailUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($id: uuid = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()") {
  DeleteCompany(where: {companyId: {_eq: $id}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteCompanyGQL extends Apollo.Mutation<TixDeleteCompanyMutation, TixDeleteCompanyMutationVariables> {
    document = DeleteCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyMediaFileByMediaFilePkDocument = gql`
    mutation DeleteCompanyMediaFileByMediaFilePK($mediaFileId: uuid = "") {
  DeleteCompanyMediaFile(where: {mediaFileId: {_eq: $mediaFileId}}) {
    returning {
      companyId
      companyImageFileId
    }
  }
  DeleteMediaFileByPK(mediaFileId: $mediaFileId) {
    companyMediaFile {
      companyId
      companyImageFileId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteCompanyMediaFileByMediaFilePkGQL extends Apollo.Mutation<TixDeleteCompanyMediaFileByMediaFilePkMutation, TixDeleteCompanyMediaFileByMediaFilePkMutationVariables> {
    document = DeleteCompanyMediaFileByMediaFilePkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyPhoneNumberByPhoneNumberPkDocument = gql`
    mutation DeleteCompanyPhoneNumberByPhoneNumberPK($phoneNumberId: uuid = "") {
  DeleteCompanyPhoneNumber(where: {phoneNumberId: {_eq: $phoneNumberId}}) {
    returning {
      companyId
      companyPhoneNumberId
    }
  }
  DeletePhoneNumberByPK(phoneNumberId: $phoneNumberId) {
    companyPhoneNumbers {
      companyId
      companyPhoneNumberId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteCompanyPhoneNumberByPhoneNumberPkGQL extends Apollo.Mutation<TixDeleteCompanyPhoneNumberByPhoneNumberPkMutation, TixDeleteCompanyPhoneNumberByPhoneNumberPkMutationVariables> {
    document = DeleteCompanyPhoneNumberByPhoneNumberPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanySocialMediaBySocialMediaPkDocument = gql`
    mutation DeleteCompanySocialMediaBySocialMediaPK($socialMediaId: uuid = "") {
  DeleteCompanySocialMedia(where: {socialMediaId: {_eq: $socialMediaId}}) {
    returning {
      companyId
      companySocialMediaId
    }
  }
  DeleteSocialMediaByPK(socialMediaId: $socialMediaId) {
    companySocialMedia {
      companyId
      companySocialMediaId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteCompanySocialMediaBySocialMediaPkGQL extends Apollo.Mutation<TixDeleteCompanySocialMediaBySocialMediaPkMutation, TixDeleteCompanySocialMediaBySocialMediaPkMutationVariables> {
    document = DeleteCompanySocialMediaBySocialMediaPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyWarningByWarningPkDocument = gql`
    mutation DeleteCompanyWarningByWarningPK($warningId: uuid = "") {
  DeleteCompanyWarning(where: {warningId: {_eq: $warningId}}) {
    returning {
      companyId
      companyWarningId
    }
  }
  DeleteWarningByPK(warningId: $warningId) {
    company_warning {
      companyId
      companyWarningId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteCompanyWarningByWarningPkGQL extends Apollo.Mutation<TixDeleteCompanyWarningByWarningPkMutation, TixDeleteCompanyWarningByWarningPkMutationVariables> {
    document = DeleteCompanyWarningByWarningPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllCompaniesDocument = gql`
    query getAllCompanies($phoneNumberType: String = "Primary", $companyMediaFileType: String = "Company Logo") {
  Company {
    companyId
    name
    url
    phoneNumbers(where: {phoneNumber: {type: {_eq: $phoneNumberType}}}) {
      phoneNumber {
        countryCode
        phoneNumber
      }
    }
    addresses {
      address {
        streetAddress
        city
        stateProvince
        postalCode
      }
    }
    venues_aggregate {
      aggregate {
        count(distinct: true)
      }
    }
    mediaFiles(where: {mediaFile: {fileType: {_eq: $companyMediaFileType}}}) {
      mediaFile {
        name
        location
        fileType
      }
    }
    contacts_aggregate {
      aggregate {
        count(distinct: true)
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetAllCompaniesGQL extends Apollo.Query<TixGetAllCompaniesQuery, TixGetAllCompaniesQueryVariables> {
    document = GetAllCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompaniesByCompanyIdsDocument = gql`
    query getCompaniesByCompanyIds($phoneNumberType: String = "Primary", $companyMediaFileType: String = "Company Logo", $companyIds: [uuid!]!) {
  Company(where: {companyId: {_in: $companyIds}, state: {_neq: "Deleted"}}) {
    companyId
    name
    url
    phoneNumbers(where: {phoneNumber: {type: {_eq: $phoneNumberType}}}, limit: 1) {
      phoneNumber {
        countryCode
        phoneNumber
        type
      }
    }
    addresses {
      address {
        streetAddress
        city
        stateProvince
        postalCode
        state
      }
    }
    mediaFiles(where: {mediaFile: {fileType: {_eq: $companyMediaFileType}}}) {
      mediaFile {
        name
        location
        fileType
      }
    }
    venues_aggregate {
      aggregate {
        count(distinct: true, columns: venueId)
      }
    }
    upcomingEvents_aggregate: companyVenueEvents_aggregate(
      where: {eventState: {_neq: "Deleted"}, filterDate: {_gte: "now()"}}
    ) {
      aggregate {
        count(distinct: true, columns: eventInstanceId)
      }
    }
    contacts_aggregate {
      aggregate {
        count(distinct: true, columns: companyContactId)
      }
    }
    companyVenueEvents_aggregate {
      aggregate {
        count(distinct: true, columns: eventInstanceId)
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCompaniesByCompanyIdsGQL extends Apollo.Query<TixGetCompaniesByCompanyIdsQuery, TixGetCompaniesByCompanyIdsQueryVariables> {
    document = GetCompaniesByCompanyIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyByCompanyIdDocument = gql`
    query getCompanyByCompanyId($companyId: uuid = "23170204-17cc-4d19-bb44-3fc5cf7b14a2") {
  Company(where: {companyId: {_eq: $companyId}}) {
    companyId
    name
    url
    phoneNumbers {
      phoneNumber {
        phoneNumberId
        countryCode
        phoneNumber
        type
      }
      companyPhoneNumberId
    }
    addresses {
      address {
        addressId
        streetAddress
        suiteApartment
        city
        stateProvince
        countryCode
        postalCode
      }
    }
    mediaFiles {
      mediaFile {
        mediaFileId
        name
        location
        fileType
      }
      companyImageFileId
    }
    socialMediaLinks {
      socialMedia {
        socialMediaId
        url
        socialMediaType
        state
      }
      companySocialMediaId
    }
    venues_aggregate(where: {state: {_neq: "Deleted"}}) {
      aggregate {
        count(distinct: true, columns: venueId)
      }
    }
    companyVenueEvents_aggregate(where: {eventState: {_neq: "Deleted"}}) {
      aggregate {
        count(distinct: true, columns: eventInstanceId)
      }
    }
    contacts_aggregate {
      aggregate {
        count(distinct: true)
      }
    }
    warnings {
      companyId
      companyWarningId
      createdAt
      updatedBy
      updatedAt
      warning {
        createAt
        message
        type
        updatedAt
        updatedBy
        warningId
      }
      warningId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCompanyByCompanyIdGQL extends Apollo.Query<TixGetCompanyByCompanyIdQuery, TixGetCompanyByCompanyIdQueryVariables> {
    document = GetCompanyByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContactsByCompanyIdDocument = gql`
    query getContactsByCompanyId($companyId: uuid = "") {
  CompanyContact(where: {companyId: {_eq: $companyId}}) {
    contactId
    contact {
      contactId
      firstName
      lastName
      emailAddress
      profilePicture
      phoneNumbers {
        contactPhoneNumberId
        phoneNumber {
          phoneNumberId
          countryCode
          type
          phoneNumber
        }
      }
      user {
        userId
        userRoles {
          userRoleId
          companyId
          venueId
          role {
            roleId
            role
            title
            description
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetContactsByCompanyIdGQL extends Apollo.Query<TixGetContactsByCompanyIdQuery, TixGetContactsByCompanyIdQueryVariables> {
    document = GetContactsByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketForScannerDocument = gql`
    query getTicketForScanner($ticketId: uuid = "", $reservationId: uuid = "") {
  Ticket(
    where: {ticketId: {_eq: $ticketId}, reservationId: {_eq: $reservationId}}
  ) {
    state
    checkedInAt
    reservationNo
    reservationId
    ticketNo
    ticketId
    ticketType
    contact {
      fullName
      emailAddress
      phoneNumbers(limit: 1) {
        phoneNumber {
          countryCode
          phoneNumber
        }
      }
    }
    event {
      eventInstanceId
      name
      date
      doorsOpen
      startTime
    }
    ticketPrice
    reservation {
      groupCode
    }
  }
  TicketAggregate(where: {reservationId: {_eq: $reservationId}}) {
    aggregate {
      count(columns: reservationId)
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketForScannerGQL extends Apollo.Query<TixGetTicketForScannerQuery, TixGetTicketForScannerQueryVariables> {
    document = GetTicketForScannerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertAddressDocument = gql`
    mutation InsertAddress($objects: [Address_insert_input!]!) {
  InsertAddress(objects: $objects) {
    affected_rows
    returning {
      addressId
      streetAddress
      city
      suiteApartment
      stateProvince
      postalCode
      countryCode
      sameAsCompany
      state
      updatedBy
      updatedAt
      companyAddress {
        addressId
        companyAddressId
        companyId
        state
        updatedBy
        updatedAt
      }
      venueAddress {
        addressId
        venueAddressId
        venueId
        state
        updatedAt
        updatedBy
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertAddressGQL extends Apollo.Mutation<TixInsertAddressMutation, TixInsertAddressMutationVariables> {
    document = InsertAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCompanyProfileDocument = gql`
    mutation insertCompanyProfile($name: String = "", $url: String = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()") {
  InsertCompany(
    objects: {name: $name, url: $url, updatedAt: $updatedAt, updatedBy: $updatedBy}
  ) {
    returning {
      companyId
      name
      url
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertCompanyProfileGQL extends Apollo.Mutation<TixInsertCompanyProfileMutation, TixInsertCompanyProfileMutationVariables> {
    document = InsertCompanyProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertMediaFileDocument = gql`
    mutation InsertMediaFile($objects: [MediaFile_insert_input!]!) {
  InsertMediaFile(objects: $objects) {
    returning {
      __typename
      fileType
      location
      name
      state
      mediaFileId
      updatedBy
      updatedAt
      companyMediaFile {
        companyId
        companyImageFileId
        updatedBy
        updatedAt
        __typename
      }
      venueMediaFile {
        venueId
        venueImageFileId
        updatedAt
        updatedBy
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertMediaFileGQL extends Apollo.Mutation<TixInsertMediaFileMutation, TixInsertMediaFileMutationVariables> {
    document = InsertMediaFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertPhoneNumberDocument = gql`
    mutation InsertPhoneNumber($objects: [PhoneNumber_insert_input!]!) {
  InsertPhoneNumber(objects: $objects) {
    returning {
      phoneNumber
      phoneNumberId
      state
      type
      sameAsCompany
      updatedBy
      updatedAt
      countryCode
      companyPhoneNumbers {
        companyId
        companyPhoneNumberId
        updatedBy
        state
        updatedAt
      }
      venuePhoneNumbers {
        venueId
        venuePhoneNumberId
        updatedBy
        state
        updatedAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertPhoneNumberGQL extends Apollo.Mutation<TixInsertPhoneNumberMutation, TixInsertPhoneNumberMutationVariables> {
    document = InsertPhoneNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertSocialMediaDocument = gql`
    mutation InsertSocialMedia($objects: [SocialMedia_insert_input!]!) {
  InsertSocialMedia(objects: $objects) {
    returning {
      __typename
      url
      socialMediaId
      state
      socialMediaType
      updatedBy
      updatedAt
      companySocialMedia {
        companyId
        companySocialMediaId
        updatedBy
        updatedAt
        __typename
      }
      venueSocialMedia {
        venueId
        venueSocialMediaId
        updatedAt
        updatedBy
        __typename
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertSocialMediaGQL extends Apollo.Mutation<TixInsertSocialMediaMutation, TixInsertSocialMediaMutationVariables> {
    document = InsertSocialMediaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertWarningDocument = gql`
    mutation InsertWarning($objects: [Warning_insert_input!]!) {
  InsertWarning(objects: $objects) {
    returning {
      createAt
      message
      type
      updatedAt
      updatedBy
      warningId
      venue_warning {
        createdAt
        updatedBy
        updatedAt
        venueId
        venueWarningId
        warningId
      }
      company_warning {
        companyId
        companyWarningId
        createdAt
        updatedBy
        updatedAt
        warningId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertWarningGQL extends Apollo.Mutation<TixInsertWarningMutation, TixInsertWarningMutationVariables> {
    document = InsertWarningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkCompanyAsDeletedDocument = gql`
    mutation MarkCompanyAsDeleted($companyId: uuid!, $updatedAt: timestamp = "now()", $updatedBy: uuid!) {
  UpdateCompany(
    where: {companyId: {_eq: $companyId}}
    _set: {state: "Deleted", updatedAt: $updatedAt, updatedBy: $updatedBy}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixMarkCompanyAsDeletedGQL extends Apollo.Mutation<TixMarkCompanyAsDeletedMutation, TixMarkCompanyAsDeletedMutationVariables> {
    document = MarkCompanyAsDeletedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($city: String = "", $postalCode: String = "", $countryCode: String = "", $sameAsCompany: Boolean = false, $state: String = "", $stateProvince: String = "", $streetAddress: String = "", $suiteApartment: String = "", $addressId: uuid = "", $updatedAt: timestamp = "now()", $updatedBy: uuid!) {
  UpdateAddressByPK(
    pk_columns: {addressId: $addressId}
    _set: {updatedAt: $updatedAt, updatedBy: $updatedBy, city: $city, postalCode: $postalCode, sameAsCompany: $sameAsCompany, state: $state, stateProvince: $stateProvince, streetAddress: $streetAddress, suiteApartment: $suiteApartment, countryCode: $countryCode}
  ) {
    addressId
    city
    countryCode
    postalCode
    sameAsCompany
    state
    stateProvince
    streetAddress
    suiteApartment
    updatedAt
    updatedBy
    companyAddress {
      companyId
      companyAddressId
      state
      updatedAt
      updatedBy
      addressId
    }
    venueAddress {
      venueId
      venueAddressId
      state
      updatedAt
      updatedBy
      addressId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateAddressGQL extends Apollo.Mutation<TixUpdateAddressMutation, TixUpdateAddressMutationVariables> {
    document = UpdateAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyByIdDocument = gql`
    mutation updateCompanyById($companyId: uuid! = "", $name: String! = "", $state: String! = "", $url: String! = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()") {
  companyProfile: updateCompanyById(
    _set: {name: $name, url: $url, state: $state, updatedBy: $updatedBy, updatedAt: $updatedAt}
    pk_columns: {companyId: $companyId}
  ) {
    companyId
    name
    url
    state
    updatedBy
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateCompanyByIdGQL extends Apollo.Mutation<TixUpdateCompanyByIdMutation, TixUpdateCompanyByIdMutationVariables> {
    document = UpdateCompanyByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMediaFileByPkDocument = gql`
    mutation UpdateMediaFileByPK($fileType: String = "", $state: String = "ACTIVE", $location: String = "", $mediaFileId: uuid = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()", $name: String = "") {
  UpdateMediaFileByPK(
    _set: {location: $location, state: $state, fileType: $fileType, updatedAt: $updatedAt, updatedBy: $updatedBy, name: $name}
    pk_columns: {mediaFileId: $mediaFileId}
  ) {
    mediaFileId
    fileType
    location
    state
    updatedBy
    updatedAt
    name
    companyMediaFile {
      companyImageFileId
      companyId
      updatedBy
      updatedAt
    }
    venueMediaFile {
      venueId
      venueImageFileId
      updatedAt
      updatedBy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateMediaFileByPkGQL extends Apollo.Mutation<TixUpdateMediaFileByPkMutation, TixUpdateMediaFileByPkMutationVariables> {
    document = UpdateMediaFileByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePhoneNumberByPkDocument = gql`
    mutation UpdatePhoneNumberByPK($type: String = "", $state: String = "ACTIVE", $phoneNumber: String = "", $countryCode: String = "+1", $phoneNumberId: uuid = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()") {
  UpdatePhoneNumberByPK(
    _set: {phoneNumber: $phoneNumber, countryCode: $countryCode, sameAsCompany: false, state: $state, type: $type, updatedAt: $updatedAt, updatedBy: $updatedBy}
    pk_columns: {phoneNumberId: $phoneNumberId}
  ) {
    phoneNumber
    phoneNumberId
    sameAsCompany
    state
    countryCode
    type
    updatedBy
    updatedAt
    companyPhoneNumbers {
      companyId
      companyPhoneNumberId
      updatedBy
      state
      updatedAt
    }
    venuePhoneNumbers {
      venueId
      venuePhoneNumberId
      updatedAt
      updatedBy
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdatePhoneNumberByPkGQL extends Apollo.Mutation<TixUpdatePhoneNumberByPkMutation, TixUpdatePhoneNumberByPkMutationVariables> {
    document = UpdatePhoneNumberByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSocialMediaByPkDocument = gql`
    mutation UpdateSocialMediaByPK($socialMediaType: String = "", $state: String = "ACTIVE", $url: String = "", $socialMediaId: uuid = "", $updatedBy: uuid!, $updatedAt: timestamptz = "now()") {
  UpdateSocialMediaByPK(
    _set: {url: $url, state: $state, socialMediaType: $socialMediaType, updatedBy: $updatedBy, updatedAt: $updatedAt}
    pk_columns: {socialMediaId: $socialMediaId}
  ) {
    socialMediaId
    socialMediaType
    url
    state
    updatedBy
    updatedAt
    companySocialMedia {
      companySocialMediaId
      companyId
      updatedBy
      updatedAt
    }
    venueSocialMedia {
      venueSocialMediaId
      venueId
      updatedAt
      updatedBy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateSocialMediaByPkGQL extends Apollo.Mutation<TixUpdateSocialMediaByPkMutation, TixUpdateSocialMediaByPkMutationVariables> {
    document = UpdateSocialMediaByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateVenueByPkDocument = gql`
    mutation UpdateVenueByPk($additionalInfo: String = "", $description: String = "", $name: String = "", $url: String = "", $state: String = "", $venueId: uuid = "", $slug: String, $updatedAt: timestamp = "now()", $updatedBy: uuid!) {
  UpdateVenueByPK(
    pk_columns: {venueId: $venueId}
    _set: {additionalInfo: $additionalInfo, description: $description, name: $name, url: $url, state: $state, updatedAt: $updatedAt, updatedBy: $updatedBy, slug: $slug}
  ) {
    description
    name
    additionalInfo
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateVenueByPkGQL extends Apollo.Mutation<TixUpdateVenueByPkMutation, TixUpdateVenueByPkMutationVariables> {
    document = UpdateVenueByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateWarningByPkDocument = gql`
    mutation UpdateWarningByPK($warningId: uuid = "", $message: String = "", $type: String = "", $updatedBy: uuid!, $updatedAt: timestamptz = "now()") {
  UpdateWarningByPK(
    pk_columns: {warningId: $warningId}
    _set: {message: $message, type: $type, updatedBy: $updatedBy, updatedAt: $updatedAt}
  ) {
    createAt
    message
    type
    updatedAt
    updatedBy
    warningId
    company_warning {
      companyId
      companyWarningId
      createdAt
      updatedBy
      updatedAt
    }
    venue_warning {
      updatedBy
      updatedAt
      createdAt
      venueId
      venueWarningId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateWarningByPkGQL extends Apollo.Mutation<TixUpdateWarningByPkMutation, TixUpdateWarningByPkMutationVariables> {
    document = UpdateWarningByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurationItemByGroupItemDocument = gql`
    query GetConfigurationItemByGroupItem($groupType: String = "") {
  ConfigurationItem(
    where: {GroupItem: {Group: {state: {_ilike: "active"}, configGroupType: {_eq: $groupType}}}, state: {_ilike: "active"}}
  ) {
    configurationItemId
    description
    elementType
    helpText
    name
    placeholder
    state
    regex
    defaultValue
    required
    GroupItem {
      configurationGroupId
      Group {
        name
      }
      viewOrder
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetConfigurationItemByGroupItemGQL extends Apollo.Query<TixGetConfigurationItemByGroupItemQuery, TixGetConfigurationItemByGroupItemQueryVariables> {
    document = GetConfigurationItemByGroupItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurationItemsDocument = gql`
    query GetConfigurationItems {
  ConfigurationItem {
    configurationItemId
    description
    elementType
    helpText
    name
    placeholder
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetConfigurationItemsGQL extends Apollo.Query<TixGetConfigurationItemsQuery, TixGetConfigurationItemsQueryVariables> {
    document = GetConfigurationItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateConfigurationValuesForEventInstanceDocument = gql`
    mutation UpdateConfigurationValuesForEventInstance($eventInstanceId: uuid!, $configurationItemId: uuid!, $objects: [EventInstanceConfigurationValue_insert_input!]!) {
  DeleteEventInstanceConfigurationValue(
    where: {eventInstanceId: {_eq: $eventInstanceId}, value: {configurationItemId: {_eq: $configurationItemId}}}
  ) {
    affected_rows
  }
  InsertEventInstanceConfigurationValue(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateConfigurationValuesForEventInstanceGQL extends Apollo.Mutation<TixUpdateConfigurationValuesForEventInstanceMutation, TixUpdateConfigurationValuesForEventInstanceMutationVariables> {
    document = UpdateConfigurationValuesForEventInstanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateConfigurationValuesForVenueDocument = gql`
    mutation UpdateConfigurationValuesForVenue($venueId: uuid!, $configurationItemId: uuid!, $objects: [VenueConfigurationValue_insert_input!]!) {
  DeleteVenueConfigurationValue(
    where: {venueId: {_eq: $venueId}, Value: {configurationItemId: {_eq: $configurationItemId}}}
  ) {
    affected_rows
  }
  InsertVenueConfigurationValue(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateConfigurationValuesForVenueGQL extends Apollo.Mutation<TixUpdateConfigurationValuesForVenueMutation, TixUpdateConfigurationValuesForVenueMutationVariables> {
    document = UpdateConfigurationValuesForVenueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteContactPhoneNumberByPhoneNumberPkDocument = gql`
    mutation DeleteContactPhoneNumberByPhoneNumberPK($phoneNumberId: uuid = "") {
  DeleteContactPhoneNumber(where: {phoneNumberId: {_eq: $phoneNumberId}}) {
    returning {
      contactId
      contactPhoneNumberId
    }
  }
  DeletePhoneNumberByPK(phoneNumberId: $phoneNumberId) {
    contactPhoneNumbers {
      contactId
      contactPhoneNumberId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteContactPhoneNumberByPhoneNumberPkGQL extends Apollo.Mutation<TixDeleteContactPhoneNumberByPhoneNumberPkMutation, TixDeleteContactPhoneNumberByPhoneNumberPkMutationVariables> {
    document = DeleteContactPhoneNumberByPhoneNumberPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePhoneNumbersByIdsDocument = gql`
    mutation DeletePhoneNumbersByIds($ids: [uuid!]!) {
  DeletePhoneNumber(where: {phoneNumberId: {_in: $ids}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeletePhoneNumbersByIdsGQL extends Apollo.Mutation<TixDeletePhoneNumbersByIdsMutation, TixDeletePhoneNumbersByIdsMutationVariables> {
    document = DeletePhoneNumbersByIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OldGetContactByEmailAddressDocument = gql`
    query oldGetContactByEmailAddress($emailAddress: String = "%%") {
  Contact(where: {emailAddress: {_ilike: $emailAddress}}) {
    contactId
    firstName
    lastName
    emailAddress
    dob
    profilePicture
    user {
      userId
      userRoles {
        userRoleId
        companyId
        venueId
        role {
          roleId
          role
          title
          description
        }
      }
    }
    phoneNumbers {
      phoneNumber {
        contactPhoneNumbers {
          contactPhoneNumberId
          phoneNumber {
            phoneNumberId
            countryCode
            phoneNumber
            type
          }
        }
      }
    }
    addresses {
      address {
        contactAddress {
          contactAddressId
        }
        addressId
        streetAddress
        suiteApartment
        city
        stateProvince
        postalCode
        countryCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixOldGetContactByEmailAddressGQL extends Apollo.Query<TixOldGetContactByEmailAddressQuery, TixOldGetContactByEmailAddressQueryVariables> {
    document = OldGetContactByEmailAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GrantAccessToCompanyDocument = gql`
    mutation GrantAccessToCompany($currentToken: String!, $companyId: String!) {
  grantAccessToCompany(token: $currentToken, companyId: $companyId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGrantAccessToCompanyGQL extends Apollo.Mutation<TixGrantAccessToCompanyMutation, TixGrantAccessToCompanyMutationVariables> {
    document = GrantAccessToCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertContactAddressDocument = gql`
    mutation InsertContactAddress($streetAddress: String = "", $city: String = "", $suiteApartment: String = "", $stateProvince: String = "", $countryCode: String = "", $postalCode: String = "", $contactId: uuid = "", $updatedByContact: uuid = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()") {
  InsertAddress(
    objects: {streetAddress: $streetAddress, city: $city, suiteApartment: $suiteApartment, stateProvince: $stateProvince, countryCode: $countryCode, postalCode: $postalCode, updatedBy: $updatedBy, updatedAt: $updatedAt, contactAddress: {data: {contactId: $contactId, updatedBy: $updatedByContact}}}
  ) {
    returning {
      addressId
      streetAddress
      city
      suiteApartment
      stateProvince
      postalCode
      countryCode
      contactAddress {
        contactId
        contactAddressId
        state
        updatedBy
        updatedAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertContactAddressGQL extends Apollo.Mutation<TixInsertContactAddressMutation, TixInsertContactAddressMutationVariables> {
    document = InsertContactAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertContactPhoneNumberDocument = gql`
    mutation InsertContactPhoneNumber($objects: [PhoneNumber_insert_input!] = {}) {
  InsertPhoneNumber(objects: $objects) {
    returning {
      phoneNumber
      phoneNumberId
      countryCode
      type
      state
      updatedAt
      updatedBy
      contactPhoneNumbers {
        contactId
        contactPhoneNumberId
        state
        updatedBy
        updatedAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertContactPhoneNumberGQL extends Apollo.Mutation<TixInsertContactPhoneNumberMutation, TixInsertContactPhoneNumberMutationVariables> {
    document = InsertContactPhoneNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertContactDocument = gql`
    mutation InsertContact($firstName: String = "", $lastName: String = "", $emailAddress: String = "", $updatedAt: timestamp = "now()") {
  InsertContact(
    objects: {firstName: $firstName, lastName: $lastName, emailAddress: $emailAddress, dob: null, updatedAt: $updatedAt}
  ) {
    returning {
      contactId
      emailAddress
      firstName
      lastName
      dob
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertContactGQL extends Apollo.Mutation<TixInsertContactMutation, TixInsertContactMutationVariables> {
    document = InsertContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsValidResetPasswordTokenDocument = gql`
    query IsValidResetPasswordToken($token: String!) {
  isValidToken(token: $token)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixIsValidResetPasswordTokenGQL extends Apollo.Query<TixIsValidResetPasswordTokenQuery, TixIsValidResetPasswordTokenQueryVariables> {
    document = IsValidResetPasswordTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestResetPasswordDocument = gql`
    mutation RequestResetPassword($email: String!, $url: String!) {
  requestResetPassword(email: $email, url: $url) {
    sent
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixRequestResetPasswordGQL extends Apollo.Mutation<TixRequestResetPasswordMutation, TixRequestResetPasswordMutationVariables> {
    document = RequestResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation ResetPassword($newPassword: String!, $token: String!) {
  resetPassword(newPassword: $newPassword, token: $token) {
    updated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixResetPasswordGQL extends Apollo.Mutation<TixResetPasswordMutation, TixResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAddressByPkDocument = gql`
    mutation UpdateAddressByPK($suiteApartment: String = "", $streetAddress: String = "", $stateProvince: String = "", $postalCode: String = "", $countryCode: String = "", $city: String = "", $addressId: uuid = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()") {
  UpdateAddressByPK(
    _set: {suiteApartment: $suiteApartment, streetAddress: $streetAddress, stateProvince: $stateProvince, postalCode: $postalCode, countryCode: $countryCode, city: $city, addressId: $addressId, updatedBy: $updatedBy, updatedAt: $updatedAt}
    pk_columns: {addressId: $addressId}
  ) {
    addressId
    streetAddress
    city
    suiteApartment
    stateProvince
    postalCode
    countryCode
    contactAddress {
      contactId
      contactAddressId
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateAddressByPkGQL extends Apollo.Mutation<TixUpdateAddressByPkMutation, TixUpdateAddressByPkMutationVariables> {
    document = UpdateAddressByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContactByPkDocument = gql`
    mutation UpdateContactByPK($contactId: uuid = "", $dob: date, $firstName: String = "", $lastName: String = "", $profilePicture: String = "", $updatedAt: timestamp = "now()", $updatedBy: uuid!) {
  UpdateContactByPK(
    pk_columns: {contactId: $contactId}
    _set: {updatedAt: $updatedAt, updatedBy: $updatedBy, dob: $dob, firstName: $firstName, lastName: $lastName, profilePicture: $profilePicture}
  ) {
    contactId
    dob
    lastName
    firstName
    emailAddress
    profilePicture
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateContactByPkGQL extends Apollo.Mutation<TixUpdateContactByPkMutation, TixUpdateContactByPkMutationVariables> {
    document = UpdateContactByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertContactDocument = gql`
    mutation UpsertContact($firstName: String = "", $lastName: String = "", $emailAddress: String = "", $updatedAt: timestamp = "now()") {
  InsertContact(
    objects: {firstName: $firstName, lastName: $lastName, emailAddress: $emailAddress, dob: null, updatedAt: $updatedAt}
    on_conflict: {constraint: email_unique, update_columns: [firstName, lastName, updatedAt]}
  ) {
    returning {
      contactId
      emailAddress
      firstName
      lastName
      dob
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpsertContactGQL extends Apollo.Mutation<TixUpsertContactMutation, TixUpsertContactMutationVariables> {
    document = UpsertContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerByCompanyIdDocument = gql`
    query getCustomerByCompanyId($companyId: uuid) {
  CustomerSearch(
    where: {companyId: {_eq: $companyId}, reservation: {active: {_eq: true}}}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerByCompanyIdGQL extends Apollo.Query<TixGetCustomerByCompanyIdQuery, TixGetCustomerByCompanyIdQueryVariables> {
    document = GetCustomerByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerByDatesForEventAdminDocument = gql`
    query getCustomerByDatesForEventAdmin($companyId: uuid, $startDate: date, $endDate: date, $userId: [uuid!]) {
  CustomerSearch(
    where: {_and: [{reservation: {active: {_eq: true}}}, {companyId: {_eq: $companyId}}, {_or: [{eventDate: {_eq: $startDate}}, {eventDate: {_eq: $endDate}}, {eventDate: {_gte: $startDate, _lte: $endDate}}]}, {reservation: {event: {eventAdmins: {_contains: $userId}}}}]}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerByDatesForEventAdminGQL extends Apollo.Query<TixGetCustomerByDatesForEventAdminQuery, TixGetCustomerByDatesForEventAdminQueryVariables> {
    document = GetCustomerByDatesForEventAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerByDatesDocument = gql`
    query getCustomerByDates($companyId: uuid, $startDate: date, $endDate: date) {
  CustomerSearch(
    where: {_and: [{reservation: {active: {_eq: true}}}, {companyId: {_eq: $companyId}}, {_or: [{eventDate: {_eq: $startDate}}, {eventDate: {_eq: $endDate}}, {eventDate: {_gte: $startDate, _lte: $endDate}}]}]}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerByDatesGQL extends Apollo.Query<TixGetCustomerByDatesQuery, TixGetCustomerByDatesQueryVariables> {
    document = GetCustomerByDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerByEmailDocument = gql`
    query getCustomerByEmail($customerEmail: String = "") {
  Customer(where: {emailAddress: {_eq: $customerEmail}}) {
    customerFullName
    emailAddress
    contact {
      contactId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerByEmailGQL extends Apollo.Query<TixGetCustomerByEmailQuery, TixGetCustomerByEmailQueryVariables> {
    document = GetCustomerByEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerByInputForAdminDocument = gql`
    query getCustomerByInputForAdmin($companyId: uuid, $input: String!, $userId: [uuid!]) {
  CustomerSearch(
    where: {_and: [{reservation: {active: {_eq: true}}}, {companyId: {_eq: $companyId}}, {_or: [{lastName: {_ilike: $input}}, {firstName: {_ilike: $input}}, {emailAddress: {_ilike: $input}}, {eventName: {_ilike: $input}}]}, {reservation: {event: {eventAdmins: {_contains: $userId}}}}]}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerByInputForAdminGQL extends Apollo.Query<TixGetCustomerByInputForAdminQuery, TixGetCustomerByInputForAdminQueryVariables> {
    document = GetCustomerByInputForAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerByInputDocument = gql`
    query getCustomerByInput($companyId: uuid, $input: String!) {
  CustomerSearch(
    where: {_and: [{reservation: {active: {_eq: true}}}, {companyId: {_eq: $companyId}}, {_or: [{lastName: {_ilike: $input}}, {firstName: {_ilike: $input}}, {emailAddress: {_ilike: $input}}, {eventName: {_ilike: $input}}]}]}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerByInputGQL extends Apollo.Query<TixGetCustomerByInputQuery, TixGetCustomerByInputQueryVariables> {
    document = GetCustomerByInputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerBySearchForEventAdminDocument = gql`
    query getCustomerBySearchForEventAdmin($companyId: uuid, $input: String!, $startDate: date, $endDate: date, $userId: [uuid!]) {
  CustomerSearch(
    where: {_and: [{reservation: {active: {_eq: true}}}, {companyId: {_eq: $companyId}}, {_or: [{lastName: {_ilike: $input}}, {firstName: {_ilike: $input}}, {emailAddress: {_ilike: $input}}, {eventName: {_ilike: $input}}]}, {_or: [{eventDate: {_eq: $startDate}}, {eventDate: {_eq: $endDate}}, {eventDate: {_gte: $startDate, _lte: $endDate}}]}, {reservation: {event: {eventAdmins: {_contains: $userId}}}}]}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerBySearchForEventAdminGQL extends Apollo.Query<TixGetCustomerBySearchForEventAdminQuery, TixGetCustomerBySearchForEventAdminQueryVariables> {
    document = GetCustomerBySearchForEventAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerBySearchDocument = gql`
    query getCustomerBySearch($companyId: uuid, $input: String!, $startDate: date, $endDate: date) {
  CustomerSearch(
    where: {_and: [{reservation: {active: {_eq: true}}}, {companyId: {_eq: $companyId}}, {_or: [{lastName: {_ilike: $input}}, {firstName: {_ilike: $input}}, {emailAddress: {_ilike: $input}}, {eventName: {_ilike: $input}}]}, {_or: [{eventDate: {_eq: $startDate}}, {eventDate: {_eq: $endDate}}, {eventDate: {_gte: $startDate, _lte: $endDate}}]}]}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerBySearchGQL extends Apollo.Query<TixGetCustomerBySearchQuery, TixGetCustomerBySearchQueryVariables> {
    document = GetCustomerBySearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerBySingleDateForEventAdminDocument = gql`
    query getCustomerBySingleDateForEventAdmin($companyId: uuid, $input: String!, $date: date, $userId: [uuid!]) {
  CustomerSearch(
    where: {_and: [{reservation: {active: {_eq: true}}}, {companyId: {_eq: $companyId}}, {_or: [{lastName: {_ilike: $input}}, {firstName: {_ilike: $input}}, {emailAddress: {_ilike: $input}}, {eventName: {_ilike: $input}}]}, {_or: [{eventDate: {_eq: $date}}, {eventDate: {_eq: $date}}, {eventDate: {_gte: $date, _lte: $date}}]}, {reservation: {event: {eventAdmins: {_contains: $userId}}}}]}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerBySingleDateForEventAdminGQL extends Apollo.Query<TixGetCustomerBySingleDateForEventAdminQuery, TixGetCustomerBySingleDateForEventAdminQueryVariables> {
    document = GetCustomerBySingleDateForEventAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerBySingleDateDocument = gql`
    query getCustomerBySingleDate($companyId: uuid, $input: String!, $date: date) {
  CustomerSearch(
    where: {_and: [{reservation: {active: {_eq: true}}}, {companyId: {_eq: $companyId}}, {_or: [{lastName: {_ilike: $input}}, {firstName: {_ilike: $input}}, {emailAddress: {_ilike: $input}}, {eventName: {_ilike: $input}}]}, {_or: [{eventDate: {_eq: $date}}, {eventDate: {_eq: $date}}, {eventDate: {_gte: $date, _lte: $date}}]}]}
    order_by: {emailAddress: asc, venueName: asc, eventName: asc, eventDate: asc}
  ) {
    ...CustomerSearchElement
  }
}
    ${CustomerSearchElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerBySingleDateGQL extends Apollo.Query<TixGetCustomerBySingleDateQuery, TixGetCustomerBySingleDateQueryVariables> {
    document = GetCustomerBySingleDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerCountDocument = gql`
    query getCustomerCount($companyId: uuid) {
  CustomerSearchAggregate(where: {companyId: {_eq: $companyId}}) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCustomerCountGQL extends Apollo.Query<TixGetCustomerCountQuery, TixGetCustomerCountQueryVariables> {
    document = GetCustomerCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCustomerDocument = gql`
    mutation InsertCustomer($firstName: String = "", $lastName: String = "", $emailAddress: String = "", $phoneNumber: String = "", $dob: date, $updatedAt: timestamp = "now()", $sms: Boolean = false, $emails: Boolean = false, $stAddress: String = "", $suiteApartment: String = "", $city: String = "", $stateProvince: String = "", $postalCode: String = "", $countryCode: String = "", $contact_id: uuid = null) {
  CustomerInsertOne(
    object: {firstName: $firstName, lastName: $lastName, emailAddress: $emailAddress, phoneNumber: $phoneNumber, dob: $dob, updatedAt: $updatedAt, optInSMS: $sms, optInEmail: $emails, streetAddress: $stAddress, suiteApartment: $suiteApartment, city: $city, stateProvince: $stateProvince, postalCode: $postalCode, countryCode: $countryCode, contact_id: $contact_id}
  ) {
    customerId
    firstName
    lastName
    phoneNumber
    emailAddress
    dob
    updatedAt
    optInSMS
    optInEmail
    streetAddress
    suiteApartment
    city
    stateProvince
    postalCode
    countryCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertCustomerGQL extends Apollo.Mutation<TixInsertCustomerMutation, TixInsertCustomerMutationVariables> {
    document = InsertCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomerByEmailDocument = gql`
    mutation UpdateCustomerByEmail($firstName: String = "", $lastName: String = "", $emailAddress: String = "", $phoneNumber: String = "", $dob: date, $updatedAt: timestamp = "now()", $sms: Boolean = false, $emails: Boolean = false, $stAddress: String = "", $suiteApartment: String = "", $city: String = "", $stateProvince: String = "", $postalCode: String = "", $countryCode: String = "", $contact_id: uuid = null) {
  CustomerUpdate(
    where: {emailAddress: {_eq: $emailAddress}}
    _set: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, dob: $dob, updatedAt: $updatedAt, optInSMS: $sms, optInEmail: $emails, streetAddress: $stAddress, suiteApartment: $suiteApartment, city: $city, stateProvince: $stateProvince, postalCode: $postalCode, countryCode: $countryCode, contact_id: $contact_id}
  ) {
    affected_rows
    returning {
      customerId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateCustomerByEmailGQL extends Apollo.Mutation<TixUpdateCustomerByEmailMutation, TixUpdateCustomerByEmailMutationVariables> {
    document = UpdateCustomerByEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertCustomerDocument = gql`
    mutation UpsertCustomer($firstName: String = "", $lastName: String = "", $emailAddress: String = "", $phoneNumber: String = "", $dob: date = null, $updatedAt: timestamp = "now()", $sms: Boolean = false, $emails: Boolean = false, $stAddress: String = "", $suiteApartment: String = "", $city: String = "", $stateProvince: String = "", $postalCode: String = "", $countryCode: String = "") {
  CustomerInsert(
    on_conflict: {constraint: customer_email_address_key, update_columns: [firstName, lastName, streetAddress, city, stateProvince, optInSMS, optInEmail, postalCode, countryCode, suiteApartment, dob, updatedAt]}
    objects: {firstName: $firstName, lastName: $lastName, emailAddress: $emailAddress, phoneNumber: $phoneNumber, dob: $dob, updatedAt: $updatedAt, optInSMS: $sms, optInEmail: $emails, streetAddress: $stAddress, suiteApartment: $suiteApartment, city: $city, stateProvince: $stateProvince, postalCode: $postalCode, countryCode: $countryCode}
  ) {
    affected_rows
    returning {
      customerId
      firstName
      lastName
      phoneNumber
      emailAddress
      dob
      updatedAt
      optInSMS
      optInEmail
      streetAddress
      suiteApartment
      city
      stateProvince
      postalCode
      countryCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpsertCustomerGQL extends Apollo.Mutation<TixUpsertCustomerMutation, TixUpsertCustomerMutationVariables> {
    document = UpsertCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DecrementDiscountLimitDocument = gql`
    mutation DecrementDiscountLimit($discountId: uuid!) {
  UpdateDiscount(
    _inc: {limit: -1}
    where: {discountId: {_eq: $discountId}, _not: {limit: {_is_null: true}}}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDecrementDiscountLimitGQL extends Apollo.Mutation<TixDecrementDiscountLimitMutation, TixDecrementDiscountLimitMutationVariables> {
    document = DecrementDiscountLimitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDiscountDocument = gql`
    mutation DeleteDiscount($discountId: uuid = "", $updatedAt: timestamp = "now()", $updatedBy: uuid!) {
  UpdateDiscountByPK(
    pk_columns: {discountId: $discountId}
    _set: {state: "Deleted", updatedAt: $updatedAt, updatedBy: $updatedBy}
  ) {
    discountId
  }
  UpdateDiscount(
    where: {parentDiscountCodeId: {_eq: $discountId}}
    _set: {state: "Deleted", updatedAt: $updatedAt, updatedBy: $updatedBy}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteDiscountGQL extends Apollo.Mutation<TixDeleteDiscountMutation, TixDeleteDiscountMutationVariables> {
    document = DeleteDiscountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEventInstanceDiscountsDocument = gql`
    mutation DeleteEventInstanceDiscounts($eventInstanceDiscountIds: [uuid!]!) {
  DeleteEventInstanceDiscount(
    where: {eventInstanceDiscountId: {_in: $eventInstanceDiscountIds}}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteEventInstanceDiscountsGQL extends Apollo.Mutation<TixDeleteEventInstanceDiscountsMutation, TixDeleteEventInstanceDiscountsMutationVariables> {
    document = DeleteEventInstanceDiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueDiscountsDocument = gql`
    mutation DeleteVenueDiscounts($venueDiscountIds: [uuid!]!) {
  DeleteVenueDiscount(where: {venueDiscountId: {_in: $venueDiscountIds}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueDiscountsGQL extends Apollo.Mutation<TixDeleteVenueDiscountsMutation, TixDeleteVenueDiscountsMutationVariables> {
    document = DeleteVenueDiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DiscountHasPasscodeDocument = gql`
    query DiscountHasPasscode($data: HasPasscodeDTO!) {
  hasPasscode(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDiscountHasPasscodeGQL extends Apollo.Query<TixDiscountHasPasscodeQuery, TixDiscountHasPasscodeQueryVariables> {
    document = DiscountHasPasscodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountByIdDocument = gql`
    query GetDiscountById($discountId: uuid!) {
  SelectDiscountByPK(discountId: $discountId) {
    discountId
    companyId
    discountCode
    type
    state
    passcode
    limit
    description
    buyAmount
    getAmount
    createdAt
    codeType
    codesToGenerate
    prefix
    parentDiscountCodeId
    groupDiscountType
    groupDiscountAmount
    startDate
    endDate
    startTime
    endTime
    appliedTo
    eventInstanceDiscount {
      eventInstanceDiscountId
      eventInstanceId
      eventInstance {
        venueId
      }
    }
    venueDiscount {
      venueDiscountId
      venueId
      venue {
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDiscountByIdGQL extends Apollo.Query<TixGetDiscountByIdQuery, TixGetDiscountByIdQueryVariables> {
    document = GetDiscountByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountsByParentIdDocument = gql`
    query GetDiscountsByParentId($parentId: uuid) {
  Discount(where: {parentDiscountCodeId: {_eq: $parentId}}) {
    discountId
    discountCode
    state
    reservations_aggregate {
      aggregate {
        discountsUsed: count(columns: discountId)
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDiscountsByParentIdGQL extends Apollo.Query<TixGetDiscountsByParentIdQuery, TixGetDiscountsByParentIdQueryVariables> {
    document = GetDiscountsByParentIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountInfoDocument = gql`
    query getDiscountInfo($data: DiscountCodeDTO!) {
  discount: getDiscountData(data: $data) {
    discountId
    buyAmount
    getAmount
    groupDiscountType
    groupDiscountAmount
    type
    appliedTo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDiscountInfoGQL extends Apollo.Query<TixGetDiscountInfoQuery, TixGetDiscountInfoQueryVariables> {
    document = GetDiscountInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountsByCompanyIdDocument = gql`
    query GetDiscountsByCompanyId($companyId: uuid!, $startDate: date = "2000-01-01", $endDate: date = "2100-01-01") {
  Discount(
    where: {_and: [{companyId: {_eq: $companyId}, state: {_nilike: "deleted"}}, {_or: [{_and: [{endDate: {_gte: $startDate}}, {endDate: {_lte: $endDate}}]}, {endDate: {_is_null: true}}]}], parentDiscountCodeId: {_is_null: true}}
  ) {
    discountId
    companyId
    discountCode
    type
    state
    codeType
    codesToGenerate
    prefix
    parentDiscountCodeId
    passcode
    limit
    description
    buyAmount
    getAmount
    createdAt
    startDate
    endDate
    startTime
    endTime
    appliedTo
    eventInstanceDiscount {
      eventInstanceId
      eventInstance {
        venueId
      }
    }
    venueDiscount {
      venueId
      venue {
        name
      }
    }
    reservations_aggregate {
      aggregate {
        discountsUsed: count(columns: discountId)
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDiscountsByCompanyIdGQL extends Apollo.Query<TixGetDiscountsByCompanyIdQuery, TixGetDiscountsByCompanyIdQueryVariables> {
    document = GetDiscountsByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertDiscountDocument = gql`
    mutation InsertDiscount($discount: Discount_insert_input!) {
  InsertDiscountOne(object: $discount) {
    discountId
    companyId
    discountCode
    type
    state
    passcode
    limit
    description
    buyAmount
    getAmount
    createdAt
    codeType
    codesToGenerate
    prefix
    parentDiscountCodeId
    groupDiscountType
    groupDiscountAmount
    startDate
    endDate
    startTime
    endTime
    appliedTo
    eventInstanceDiscount {
      eventInstanceId
    }
    venueDiscount {
      venueId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertDiscountGQL extends Apollo.Mutation<TixInsertDiscountMutation, TixInsertDiscountMutationVariables> {
    document = InsertDiscountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertEventInstanceDiscountsDocument = gql`
    mutation InsertEventInstanceDiscounts($objects: [EventInstanceDiscount_insert_input!]!) {
  InsertEventInstanceDiscount(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertEventInstanceDiscountsGQL extends Apollo.Mutation<TixInsertEventInstanceDiscountsMutation, TixInsertEventInstanceDiscountsMutationVariables> {
    document = InsertEventInstanceDiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertVenueDiscountsDocument = gql`
    mutation InsertVenueDiscounts($objects: [VenueDiscount_insert_input!]!) {
  InsertVenueDiscount(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertVenueDiscountsGQL extends Apollo.Mutation<TixInsertVenueDiscountsMutation, TixInsertVenueDiscountsMutationVariables> {
    document = InsertVenueDiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsValidDiscountCodeDocument = gql`
    query IsValidDiscountCode($data: DiscountCodeDTO!) {
  isValidDiscountCode(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixIsValidDiscountCodeGQL extends Apollo.Query<TixIsValidDiscountCodeQuery, TixIsValidDiscountCodeQueryVariables> {
    document = IsValidDiscountCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDiscountByIdDocument = gql`
    mutation UpdateDiscountById($discountId: uuid!, $data: Discount_set_input) {
  UpdateDiscountByPK(pk_columns: {discountId: $discountId}, _set: $data) {
    discountId
    companyId
    discountCode
    type
    state
    passcode
    limit
    description
    buyAmount
    getAmount
    codeType
    codesToGenerate
    prefix
    parentDiscountCodeId
    createdAt
    groupDiscountType
    groupDiscountAmount
    startDate
    endDate
    startTime
    endTime
    appliedTo
    eventInstanceDiscount {
      eventInstanceId
    }
    venueDiscount {
      venueId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateDiscountByIdGQL extends Apollo.Mutation<TixUpdateDiscountByIdMutation, TixUpdateDiscountByIdMutationVariables> {
    document = UpdateDiscountByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDonationSetUpByEventIdDocument = gql`
    query getDonationSetUpByEventId($eventInstanceId: uuid) {
  EventInstanceConfigurationValue(
    where: {eventInstanceId: {_eq: $eventInstanceId}, value: {Item: {state: {_ilike: "active"}, GroupItem: {Group: {state: {_ilike: "active"}}, configurationGroupId: {_eq: "587f618b-6e3b-4c67-963c-8fcb54b69a49"}}}}}
  ) {
    eventInstanceId
    value {
      value
      configurationValueId
      configurationItemId
      Item {
        name
        GroupItem {
          configurationGroupId
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDonationSetUpByEventIdGQL extends Apollo.Query<TixGetDonationSetUpByEventIdQuery, TixGetDonationSetUpByEventIdQueryVariables> {
    document = GetDonationSetUpByEventIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertEventInstanceDocument = gql`
    mutation insertEventInstance($objects: [Event_insert_input!]!) {
  InsertEvent(objects: $objects) {
    returning {
      eventId
      companyId
      name
      type
      state
      updatedBy
      updatedAt
      eventInstances {
        eventInstanceId
        eventId
        name
        type
        description
        additionalInfo
        date
        doorsOpen
        startTime
        endTime
        startSellingDate
        startSellingTime
        stopSellingDate
        stopSellingTime
        minimumAge
        hidden
        passcode
        overridden
        venueId
        venue {
          name
          companyId
        }
        eventInstanceTickets {
          Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
            TicketConfigurations {
              view_order
              name
              includeFees
              noOfSeats
              parentTicketId
              salesChannel
              perOrderMax
              perOrderMin
              platformFee
              processingFee
              venueFee
              seat
              section
              row
              state
              ticketConfigId
              ticketType
              ticketPrice
              startSellingDate
              stopSellingDate
              startSellingTime
              stopSellingTime
            }
          }
        }
        venueTicketId
        state
        updatedBy
        updatedAt
        eventPerformers {
          eventPerformerId
          eventInstanceId
          performerId
          state
          updatedBy
          updatedAt
          Performers {
            performerId
            companyId
            name
            title
            description
            additionalInfo
            state
            updatedBy
            updatedAt
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertEventInstanceGQL extends Apollo.Mutation<TixInsertEventInstanceMutation, TixInsertEventInstanceMutationVariables> {
    document = InsertEventInstanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRecurringEventsDocument = gql`
    mutation CreateRecurringEvents($data: EventData!) {
  createRecurringEvents(data: $data) {
    InsertEvent {
      returning {
        eventId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCreateRecurringEventsGQL extends Apollo.Mutation<TixCreateRecurringEventsMutation, TixCreateRecurringEventsMutationVariables> {
    document = CreateRecurringEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateAvailableTicketsStatsDocument = gql`
    query calculateAvailableTicketsStats($eventInstanceId: String = "") {
  calculateAvailableTicketStats(eventInstanceId: $eventInstanceId) {
    Class_Tuition
    VIP
    General_Admission
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCalculateAvailableTicketsStatsGQL extends Apollo.Query<TixCalculateAvailableTicketsStatsQuery, TixCalculateAvailableTicketsStatsQueryVariables> {
    document = CalculateAvailableTicketsStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCampaignTrackingDocument = gql`
    mutation deleteCampaignTracking($ids: [uuid!]!) {
  delete_event_campaign_tracking(where: {campaign_tracking_id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteCampaignTrackingGQL extends Apollo.Mutation<TixDeleteCampaignTrackingMutation, TixDeleteCampaignTrackingMutationVariables> {
    document = DeleteCampaignTrackingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEventInstanceTicketConfigByIdDocument = gql`
    mutation DeleteEventInstanceTicketConfigById($ticketConfigId: uuid!) {
  DeleteEventInstanceTicketConfig(where: {ticketConfigId: {_eq: $ticketConfigId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteEventInstanceTicketConfigByIdGQL extends Apollo.Mutation<TixDeleteEventInstanceTicketConfigByIdMutation, TixDeleteEventInstanceTicketConfigByIdMutationVariables> {
    document = DeleteEventInstanceTicketConfigByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEventPerformersByPkDocument = gql`
    mutation DeleteEventPerformersByPK($eventPerformerId: uuid = "") {
  DeleteEventPerformersByPK(eventPerformerId: $eventPerformerId) {
    eventPerformerId
    eventInstanceId
    performerId
    state
    updatedBy
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteEventPerformersByPkGQL extends Apollo.Mutation<TixDeleteEventPerformersByPkMutation, TixDeleteEventPerformersByPkMutationVariables> {
    document = DeleteEventPerformersByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMediaFilesDocument = gql`
    mutation DeleteMediaFiles($ids: [uuid!]!) {
  DeleteMediaFile(where: {mediaFileId: {_in: $ids}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteMediaFilesGQL extends Apollo.Mutation<TixDeleteMediaFilesMutation, TixDeleteMediaFilesMutationVariables> {
    document = DeleteMediaFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSocialMediasDocument = gql`
    mutation DeleteSocialMedias($ids: [uuid!]!) {
  DeleteSocialMedia(where: {socialMediaId: {_in: $ids}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteSocialMediasGQL extends Apollo.Mutation<TixDeleteSocialMediasMutation, TixDeleteSocialMediasMutationVariables> {
    document = DeleteSocialMediasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventAdminsByEventInstanceIdDocument = gql`
    query getEventAdminsByEventInstanceId($eventInstanceId: uuid! = "") {
  EventInstance(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    eventAdmins
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventAdminsByEventInstanceIdGQL extends Apollo.Query<TixGetEventAdminsByEventInstanceIdQuery, TixGetEventAdminsByEventInstanceIdQueryVariables> {
    document = GetEventAdminsByEventInstanceIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventByEventInstanceIdDocument = gql`
    query getEventByEventInstanceId($eventInstanceId: uuid = "") {
  EventInstance(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    eventId
    eventInstanceId
    name
    description
    additionalInfo
    venueId
    date
    slug
    eventAdmins
    doorsOpen
    minimumAge
    startTime
    endTime
    startSellingDate
    startSellingTime
    stopSellingDate
    stopSellingTime
    passcode
    state
    type
    hidden
    overridden
    venueTicketId
    configurationItems {
      value {
        configurationValueId
        configurationItemId
        value
        __typename
      }
      __typename
    }
    venue {
      name
      companyId
      company {
        name
        __typename
      }
      __typename
    }
    eventInstanceTickets {
      eventInstanceTicketId
      name
      description
      state
      totalSeats
      Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
        totalTicketsByType {
          totalTickets
          ticketsSold
          ticketsRemaining
          ticketType
          __typename
        }
        TicketConfigurations {
          name
          parentTicketId
          includeFees
          salesChannel
          helpText
          helpTextTitle
          noOfSeats
          parentTicketId
          perOrderMax
          perOrderMin
          platformFee
          processingFee
          venueFee
          seat
          section
          row
          state
          ticketConfigId
          ticketType
          ticketPrice
          startSellingDate
          stopSellingDate
          startSellingTime
          stopSellingTime
          __typename
        }
        __typename
      }
      __typename
    }
    media {
      mediaFile {
        mediaFileId
        location
        fileType
        name
        __typename
      }
      __typename
    }
    socialMedia {
      socialMedia {
        socialMediaId
        url
        socialMediaType
        __typename
      }
      __typename
    }
    campaign {
      campaign_name
      campaignType
      campaignCode
      campaign_tracking_id
      createdAt
      createdBy
      eventInstanceId
      updatedAt
      updatedBy
      __typename
    }
    eventProduct(where: {state: {_neq: "Deleted"}}) {
      eventProductId
      name
      state
      price
      quantity
      quantitySold
      quantityRemaining
      tax
      salesChannel
      additionalInfo
      startSellingDate
      startSellingTime
      stopSellingDate
      startSelling
      stopSelling
      stopSellingTime
      productId
      EventProductMedia {
        MediaFile {
          location
          name
          mediaFileId
          fileType
          state
          __typename
        }
        eventProductMediaImageFileId
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventByEventInstanceIdGQL extends Apollo.Query<TixGetEventByEventInstanceIdQuery, TixGetEventByEventInstanceIdQueryVariables> {
    document = GetEventByEventInstanceIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventInstanceByPkDocument = gql`
    query getEventInstanceByPK($eventInstanceId: uuid = "") {
  EventInstanceByPK(eventInstanceId: $eventInstanceId) {
    description
    name
    date
    slug
    doorsOpen
    endTime
    startTime
    type
    eventInstanceId
    venueTicketId
    configurationItems {
      value {
        configurationValueId
        configurationItemId
        value
      }
    }
    venue {
      name
      company {
        name
      }
      venueId
      state
      configurationValues {
        Venue {
          tickets {
            Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
              venueTicketId
              TicketConfigurations {
                view_order
                includeFees
                parentTicketId
                ticketConfigId
                salesChannel
                ticketType
                platformFee
                processingFee
                venueFee
                noOfSeats
                ticketPrice
              }
            }
          }
        }
      }
    }
    eventInstanceTickets {
      Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
        TicketConfigurations {
          view_order
          includeFees
          name
          noOfSeats
          salesChannel
          parentTicketId
          perOrderMax
          perOrderMin
          platformFee
          processingFee
          venueFee
          helpText
          helpTextTitle
          seat
          section
          row
          state
          ticketConfigId
          ticketType
          ticketPrice
        }
      }
    }
    eventTicketSalesMetrics {
      available
      checked_in
      event_instance_id
      not_checked_in
      total_seats
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventInstanceByPkGQL extends Apollo.Query<TixGetEventInstanceByPkQuery, TixGetEventInstanceByPkQueryVariables> {
    document = GetEventInstanceByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventTicketConfigurationsDocument = gql`
    query GetEventTicketConfigurations($eventInstanceId: uuid!) {
  EventInstanceByPK(eventInstanceId: $eventInstanceId) {
    eventInstanceTickets {
      Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
        TicketConfigurations {
          view_order
          includeFees
          parentTicketId
          perOrderMax
          perOrderMin
          salesChannel
          ticketConfigTotals: totalTicketsByType {
            totalTickets
            ticketsSold
            ticketsRemaining
          }
          noOfSeats
          ticketConfigId
          name
          ticketType
          section
          row
          seat
          ticketPrice
          processingFee
          platformFee
          venueFee
          state
          helpText
          helpTextTitle
          startSellingDate
          stopSellingDate
          startSellingTime
          stopSellingTime
          view_order
        }
      }
    }
    Metrics: eventTicketSalesMetrics {
      available
      total_seats
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventTicketConfigurationsGQL extends Apollo.Query<TixGetEventTicketConfigurationsQuery, TixGetEventTicketConfigurationsQueryVariables> {
    document = GetEventTicketConfigurationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventTicketsSoldCountForContactDocument = gql`
    query GetEventTicketsSoldCountForContact($ticketConfigId: uuid!, $contactId: uuid!) {
  TicketAggregate(
    where: {_and: {contactId: {_eq: $contactId}, ticketConfig: {ticketConfigId: {_eq: $ticketConfigId}}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventTicketsSoldCountForContactGQL extends Apollo.Query<TixGetEventTicketsSoldCountForContactQuery, TixGetEventTicketsSoldCountForContactQueryVariables> {
    document = GetEventTicketsSoldCountForContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsByCompanyIdForEventAdminDocument = gql`
    query getEventsByCompanyIdForEventAdmin($companyId: uuid!, $userId: [uuid!]) {
  EventInstance(
    where: {venue: {companyId: {_eq: $companyId}}, eventAdmins: {_contains: $userId}}
  ) {
    eventInstanceId
    eventId
    venueId
    eventAdmins
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventsByCompanyIdForEventAdminGQL extends Apollo.Query<TixGetEventsByCompanyIdForEventAdminQuery, TixGetEventsByCompanyIdForEventAdminQueryVariables> {
    document = GetEventsByCompanyIdForEventAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsByCompanyIdDocument = gql`
    query getEventsByCompanyId($companyId: uuid!, $eventName: String = "%%", $date: String = "%%", $limit: Int, $offset: Int, $orExp: [EventCompanyVenue_bool_exp!] = [], $eventStates: [String!] = ["Active", "Deleted", "Inactive", "Pending", "Cancelled"]) {
  EventCompanyVenueAggregate(
    where: {companyId: {_eq: $companyId}, eventName: {_ilike: $eventName}, date: {_ilike: $date}, _or: $orExp, eventState: {_in: $eventStates}}
  ) {
    aggregate {
      count
    }
  }
  EventCompanyVenue(
    limit: $limit
    offset: $offset
    where: {companyId: {_eq: $companyId}, eventName: {_ilike: $eventName}, date: {_ilike: $date}, _or: $orExp, eventState: {_in: $eventStates}}
    order_by: {eventInstance: {date: asc}, startTime: asc}
  ) {
    eventInstanceId
    eventId
    eventName
    ticketsSold
    available
    mainEventName
    date
    filterDate
    startTime
    doorsOpen
    venueName
    venueId
    eventState
    mediaId
    mediaState
    mediaFileType
    mediaLocation
    eventInstance {
      slug
      eventAdmins
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventsByCompanyIdGQL extends Apollo.Query<TixGetEventsByCompanyIdQuery, TixGetEventsByCompanyIdQueryVariables> {
    document = GetEventsByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsByEventAdminDocument = gql`
    query getEventsByEventAdmin($adminId: [uuid!]) {
  EventInstance(where: {eventAdmins: {_contains: $adminId}}) {
    eventAdmins
    eventInstanceId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventsByEventAdminGQL extends Apollo.Query<TixGetEventsByEventAdminQuery, TixGetEventsByEventAdminQueryVariables> {
    document = GetEventsByEventAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsByVenueIdDocument = gql`
    query getEventsByVenueId($venueId: uuid!, $startDate: date!, $endDate: date!) {
  EventInstance(
    where: {venueId: {_eq: $venueId}, state: {_neq: "Deleted"}, date: {_gte: $startDate, _lte: $endDate}}
    order_by: {date: asc, startTime: asc}
  ) {
    eventInstanceId
    name
    startTime
    endTime
    doorsOpen
    date
    venueId
    eventAdmins
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventsByVenueIdGQL extends Apollo.Query<TixGetEventsByVenueIdQuery, TixGetEventsByVenueIdQueryVariables> {
    document = GetEventsByVenueIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsForVenuesDocument = gql`
    query GetEventsForVenues($venueIds: [uuid!]!) {
  EventInstance(where: {venueId: {_in: $venueIds}, date: {_gte: "now()"}}) {
    eventInstanceId
    name
    startTime
    endTime
    doorsOpen
    date
    date
    venueId
    eventAdmins
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventsForVenuesGQL extends Apollo.Query<TixGetEventsForVenuesQuery, TixGetEventsForVenuesQueryVariables> {
    document = GetEventsForVenuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketTypeUsersStatsDocument = gql`
    query getTicketTypeUsersStats($eventInstanceId: uuid = "", $name: String = "%%", $emailAddress: String = "%%", $phoneNumber: String = "%%") {
  pendingUserStats: TicketAggregate(
    where: {eventInstanceId: {_eq: $eventInstanceId}, state: {_eq: "Pending"}, contact: {fullName: {_ilike: $name}, emailAddress: {_ilike: $emailAddress}, phoneNumbers: {phoneNumber: {phoneNumber: {_ilike: $phoneNumber}}}}, active: {_eq: true}}
  ) {
    nodes {
      state
      contact {
        contactId
        firstName
        lastName
        emailAddress
      }
      reservation {
        reservationId
        reservationDate
      }
      ticketId
      ticketPrice
    }
  }
  checkedInUserStats: TicketAggregate(
    where: {eventInstanceId: {_eq: $eventInstanceId}, state: {_eq: "Checked In"}, contact: {fullName: {_ilike: $name}, emailAddress: {_ilike: $emailAddress}, phoneNumbers: {phoneNumber: {phoneNumber: {_ilike: $phoneNumber}}}}, active: {_eq: true}}
  ) {
    nodes {
      contact {
        contactId
        firstName
        lastName
        emailAddress
      }
      reservation {
        reservationId
        reservationDate
      }
      ticketId
      ticketPrice
      state
    }
  }
  refundedUserStats: TicketAggregate(
    where: {eventInstanceId: {_eq: $eventInstanceId}, state: {_eq: "Refunded"}, contact: {fullName: {_ilike: $name}, emailAddress: {_ilike: $emailAddress}, phoneNumbers: {phoneNumber: {phoneNumber: {_ilike: $phoneNumber}}}}, active: {_eq: true}}
  ) {
    nodes {
      state
      contact {
        contactId
        firstName
        lastName
        emailAddress
      }
      reservation {
        reservationId
        reservationDate
      }
      ticketId
      ticketPrice
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketTypeUsersStatsGQL extends Apollo.Query<TixGetTicketTypeUsersStatsQuery, TixGetTicketTypeUsersStatsQueryVariables> {
    document = GetTicketTypeUsersStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPerformerDropDownListByCompanyIdDocument = gql`
    query getPerformerDropDownListByCompanyId($companyId: uuid = "") {
  Performer(where: {companyId: {_eq: $companyId}}) {
    performerId
    name
    companyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetPerformerDropDownListByCompanyIdGQL extends Apollo.Query<TixGetPerformerDropDownListByCompanyIdQuery, TixGetPerformerDropDownListByCompanyIdQueryVariables> {
    document = GetPerformerDropDownListByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPerformerSearchByNameDocument = gql`
    query getPerformerSearchByName($companyId: uuid = "", $name: String = "%%") {
  Performer(
    limit: 5
    order_by: {name: asc}
    where: {_and: {companyId: {_eq: $companyId}, name: {_ilike: $name}}}
  ) {
    performerId
    title
    name
    description
    companyId
    additionalInfo
    state
    updatedBy
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetPerformerSearchByNameGQL extends Apollo.Query<TixGetPerformerSearchByNameQuery, TixGetPerformerSearchByNameQueryVariables> {
    document = GetPerformerSearchByNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationStatsByPkDocument = gql`
    query getReservationStatsByPK($eventInstanceId: uuid = "") {
  Reservation(
    where: {eventInstanceId: {_eq: $eventInstanceId}, active: {_eq: true}}
  ) {
    reservationId
    groupCode
    tickets(where: {active: {_eq: true}}) {
      ...TicketNode
    }
  }
  pendingReservationStats: ReservationAggregate(
    where: {eventInstanceId: {_eq: $eventInstanceId}, tickets: {state: {_eq: "Pending"}, active: {_eq: true}}}
  ) {
    nodes {
      totalAmountPaid
      reservationId
      tickets(where: {active: {_eq: true}}) {
        ...TicketNode
      }
      tickets_aggregate(where: {active: {_eq: true}}) {
        aggregate {
          count
        }
      }
    }
  }
  refundedReservationStats: ReservationAggregate(
    where: {eventInstanceId: {_eq: $eventInstanceId}, tickets: {state: {_eq: "Refunded"}, active: {_eq: true}}}
  ) {
    nodes {
      totalAmountPaid
      reservationId
      tickets(where: {active: {_eq: true}}) {
        ...TicketNode
      }
      tickets_aggregate(where: {active: {_eq: true}}) {
        aggregate {
          count
        }
      }
    }
  }
  checkedInReservationStats: ReservationAggregate(
    where: {eventInstanceId: {_eq: $eventInstanceId}, tickets: {state: {_eq: "Checked In"}, active: {_eq: true}}}
  ) {
    nodes {
      totalAmountPaid
      reservationId
      tickets(where: {active: {_eq: true}}) {
        ...TicketNode
      }
      tickets_aggregate(where: {active: {_eq: true}}) {
        aggregate {
          count
        }
      }
    }
  }
}
    ${TicketNodeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetReservationStatsByPkGQL extends Apollo.Query<TixGetReservationStatsByPkQuery, TixGetReservationStatsByPkQueryVariables> {
    document = GetReservationStatsByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSlugByEventInstanceIdDocument = gql`
    query getSlugByEventInstanceId($eventInstanceId: uuid!) {
  EventInstance(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    slug
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetSlugByEventInstanceIdGQL extends Apollo.Query<TixGetSlugByEventInstanceIdQuery, TixGetSlugByEventInstanceIdQueryVariables> {
    document = GetSlugByEventInstanceIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketConfigDropdownListByVenueIdDocument = gql`
    query getTicketConfigDropdownListByVenueId($venueId: uuid = "") {
  VenueTicket(where: {venueId: {_eq: $venueId}}) {
    name
    state
    totalSeats
    updatedAt
    updatedBy
    venueId
    venueTicketId
    Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
      state
      ticketConfigId
      updatedAt
      updatedBy
      venueTicketConfig
      venueTicketId
      TicketConfigurations {
        view_order
        includeFees
        parentTicketId
        salesChannel
        name
        noOfSeats
        perOrderMax
        perOrderMin
        row
        seat
        section
        state
        ticketConfigId
        platformFee
        processingFee
        venueFee
        ticketPrice
        ticketType
        updatedAt
        helpText
        helpTextTitle
        updatedBy
        startSellingDate
        stopSellingDate
        startSellingTime
        stopSellingTime
      }
    }
    Configurations_aggregate {
      aggregate {
        count(columns: venueTicketConfig)
      }
    }
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketConfigDropdownListByVenueIdGQL extends Apollo.Query<TixGetTicketConfigDropdownListByVenueIdQuery, TixGetTicketConfigDropdownListByVenueIdQueryVariables> {
    document = GetTicketConfigDropdownListByVenueIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketsSoldForTicketConfigDocument = gql`
    query GetTicketsSoldForTicketConfig($ticketConfigId: uuid!) {
  TicketAggregate(
    where: {_or: [{ticketConfig: {ticketConfigId: {_eq: $ticketConfigId}}}, {ticketConfig: {parentTicketId: {_eq: $ticketConfigId}}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketsSoldForTicketConfigGQL extends Apollo.Query<TixGetTicketsSoldForTicketConfigQuery, TixGetTicketsSoldForTicketConfigQueryVariables> {
    document = GetTicketsSoldForTicketConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingEventsByCompanyIdForEventAdminDocument = gql`
    query getUpcomingEventsByCompanyIdForEventAdmin($companyId: uuid!, $userId: [uuid!]) {
  EventInstance(
    where: {venue: {companyId: {_eq: $companyId}}, state: {_eq: "Active"}, date: {_gte: "now()"}, eventAdmins: {_contains: $userId}}
    order_by: {venue: {name: asc}, date: asc}
  ) {
    eventInstanceId
    name
    startTime
    endTime
    doorsOpen
    date
    venueId
    venue {
      name
    }
    eventTicketSalesMetrics {
      available
      checked_in
      not_checked_in
      refunded
      total_seats
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetUpcomingEventsByCompanyIdForEventAdminGQL extends Apollo.Query<TixGetUpcomingEventsByCompanyIdForEventAdminQuery, TixGetUpcomingEventsByCompanyIdForEventAdminQueryVariables> {
    document = GetUpcomingEventsByCompanyIdForEventAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingEventsByCompanyIdDocument = gql`
    query getUpcomingEventsByCompanyId($companyId: uuid!) {
  EventInstance(
    where: {venue: {companyId: {_eq: $companyId}}, state: {_eq: "Active"}, date: {_gte: "now()"}}
    order_by: {venue: {name: asc}, date: asc}
  ) {
    eventInstanceId
    name
    startTime
    endTime
    doorsOpen
    date
    venueId
    venue {
      name
    }
    eventTicketSalesMetrics {
      available
      checked_in
      not_checked_in
      refunded
      total_seats
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetUpcomingEventsByCompanyIdGQL extends Apollo.Query<TixGetUpcomingEventsByCompanyIdQuery, TixGetUpcomingEventsByCompanyIdQueryVariables> {
    document = GetUpcomingEventsByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenueDropdownListByCompanyIdDocument = gql`
    query getVenueDropdownListByCompanyId($companyId: uuid = "") {
  Venue(
    where: {_and: [{companyId: {_eq: $companyId}}, {state: {_neq: "Deleted"}}]}
  ) {
    venueId
    name
    state
    events {
      eventAdmins
      event {
        state
      }
    }
    configurationValues {
      Value {
        Item {
          name
        }
        value
      }
    }
    tickets_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenueDropdownListByCompanyIdGQL extends Apollo.Query<TixGetVenueDropdownListByCompanyIdQuery, TixGetVenueDropdownListByCompanyIdQueryVariables> {
    document = GetVenueDropdownListByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketsBreakdownByEventInstanceIdDocument = gql`
    query getTicketsBreakdownByEventInstanceId($eventInstanceId: uuid = "", $ticketName: String) {
  checked_in: TicketAggregate(
    where: {eventInstanceId: {_eq: $eventInstanceId}, state: {_eq: "Checked In"}, _or: [{active: {_eq: true}}, {active: {_is_null: true}}], ticketConfig: {name: {_eq: $ticketName}}}
  ) {
    aggregate {
      count
    }
  }
  not_checked_in: TicketAggregate(
    where: {eventInstanceId: {_eq: $eventInstanceId}, state: {_eq: "Pending"}, _or: [{active: {_eq: true}}, {active: {_is_null: true}}], ticketConfig: {name: {_eq: $ticketName}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketsBreakdownByEventInstanceIdGQL extends Apollo.Query<TixGetTicketsBreakdownByEventInstanceIdQuery, TixGetTicketsBreakdownByEventInstanceIdQueryVariables> {
    document = GetTicketsBreakdownByEventInstanceIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCampaignTrackingDocument = gql`
    mutation InsertCampaignTracking($objects: [event_campaign_tracking_insert_input!]!) {
  insert_event_campaign_tracking(objects: $objects) {
    returning {
      campaignCode
      campaignType
      campaign_name
      campaign_tracking_id
      createdBy
      eventInstanceId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertCampaignTrackingGQL extends Apollo.Mutation<TixInsertCampaignTrackingMutation, TixInsertCampaignTrackingMutationVariables> {
    document = InsertCampaignTrackingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertNewEventInstanceTicketConfigDocument = gql`
    mutation InsertNewEventInstanceTicketConfig($object: EventInstanceTicketConfig_insert_input!) {
  InsertEventInstanceTicketConfigOne(object: $object) {
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertNewEventInstanceTicketConfigGQL extends Apollo.Mutation<TixInsertNewEventInstanceTicketConfigMutation, TixInsertNewEventInstanceTicketConfigMutationVariables> {
    document = InsertNewEventInstanceTicketConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertEventPerformersDocument = gql`
    mutation InsertEventPerformers($objects: [EventPerformers_insert_input!] = {eventInstanceId: "", performerId: "", updatedBy: ""}) {
  InsertEventPerformers(objects: $objects) {
    returning {
      eventPerformerId
      eventInstanceId
      performerId
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertEventPerformersGQL extends Apollo.Mutation<TixInsertEventPerformersMutation, TixInsertEventPerformersMutationVariables> {
    document = InsertEventPerformersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertSocialMediasDocument = gql`
    mutation InsertSocialMedias($objects: [SocialMedia_insert_input!]!) {
  InsertSocialMedia(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertSocialMediasGQL extends Apollo.Mutation<TixInsertSocialMediasMutation, TixInsertSocialMediasMutationVariables> {
    document = InsertSocialMediasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkEventAsDeletedDocument = gql`
    mutation MarkEventAsDeleted($eventInstanceId: uuid!, $updatedBy: uuid!) {
  UpdateEventInstance(
    where: {eventInstanceId: {_eq: $eventInstanceId}}
    _set: {state: "Deleted", updatedBy: $updatedBy, updatedAt: "now()"}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixMarkEventAsDeletedGQL extends Apollo.Mutation<TixMarkEventAsDeletedMutation, TixMarkEventAsDeletedMutationVariables> {
    document = MarkEventAsDeletedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEventAdminForEventDocument = gql`
    mutation updateEventAdminForEvent($eventInstanceId: uuid!, $eventAdmins: [uuid!]) {
  UpdateEventInstanceByPK(
    pk_columns: {eventInstanceId: $eventInstanceId}
    _set: {eventAdmins: $eventAdmins}
  ) {
    eventInstanceId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateEventAdminForEventGQL extends Apollo.Mutation<TixUpdateEventAdminForEventMutation, TixUpdateEventAdminForEventMutationVariables> {
    document = UpdateEventAdminForEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEventInstanceByPkDocument = gql`
    mutation UpdateEventInstanceByPK($eventInstanceId: uuid = "", $name: String = "", $description: String = "", $additionalInfo: String = "", $type: String = "", $state: String = "", $date: date = "", $doorsOpen: time = "", $startTime: time = "", $endTime: time = "", $startSellingDate: date = "", $startSellingTime: time = "", $stopSellingDate: date = "", $stopSellingTime: time = "", $minimumAge: Int = 10, $hidden: Boolean = false, $passcode: String = "", $venueId: uuid = "", $venueTicketId: uuid = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()", $slug: String, $eventAdmins: [uuid!]) {
  UpdateEventInstanceByPK(
    pk_columns: {eventInstanceId: $eventInstanceId}
    _set: {name: $name, type: $type, state: $state, slug: $slug, description: $description, additionalInfo: $additionalInfo, date: $date, doorsOpen: $doorsOpen, startTime: $startTime, endTime: $endTime, startSellingDate: $startSellingDate, startSellingTime: $startSellingTime, stopSellingDate: $stopSellingDate, stopSellingTime: $stopSellingTime, minimumAge: $minimumAge, hidden: $hidden, passcode: $passcode, venueId: $venueId, venueTicketId: $venueTicketId, updatedBy: $updatedBy, updatedAt: $updatedAt, eventAdmins: $eventAdmins}
  ) {
    eventInstanceId
    eventId
    name
    type
    eventAdmins
    state
    slug
    description
    additionalInfo
    date
    doorsOpen
    startTime
    endTime
    startSellingDate
    startSellingTime
    stopSellingDate
    stopSellingTime
    minimumAge
    hidden
    passcode
    venueId
    venueTicketId
    updatedBy
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateEventInstanceByPkGQL extends Apollo.Mutation<TixUpdateEventInstanceByPkMutation, TixUpdateEventInstanceByPkMutationVariables> {
    document = UpdateEventInstanceByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEventByPkDocument = gql`
    mutation UpdateEventByPK($eventId: uuid = "", $companyId: uuid = "", $name: String = "", $type: String = "", $state: String = "", $updatedBy: uuid!, $updatedAt: timestamp = "now()") {
  UpdateEventByPK(
    pk_columns: {eventId: $eventId}
    _set: {eventId: $eventId, companyId: $companyId, name: $name, type: $type, state: $state, updatedBy: $updatedBy, updatedAt: $updatedAt}
  ) {
    eventId
    companyId
    name
    type
    state
    updatedBy
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateEventByPkGQL extends Apollo.Mutation<TixUpdateEventByPkMutation, TixUpdateEventByPkMutationVariables> {
    document = UpdateEventByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEventInstanceTicketByIdDocument = gql`
    mutation UpdateEventInstanceTicketById($eventInstanceTicketId: uuid!, $_set: EventInstanceTicket_set_input) {
  UpdateEventInstanceTicketByPK(
    pk_columns: {eventInstanceTicketId: $eventInstanceTicketId}
    _set: $_set
  ) {
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateEventInstanceTicketByIdGQL extends Apollo.Mutation<TixUpdateEventInstanceTicketByIdMutation, TixUpdateEventInstanceTicketByIdMutationVariables> {
    document = UpdateEventInstanceTicketByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReservationTicketsStateDocument = gql`
    mutation updateReservationTicketsState($reservationId: uuid!, $checked_in_at: timestamptz = "now()", $updatedAt: timestamp = "now()", $updatedBy: uuid, $state: String = "Checked In") {
  UpdateTicket(
    where: {reservationId: {_eq: $reservationId}, state: {_neq: "Refunded"}}
    _set: {state: $state, checkedInAt: $checked_in_at, updatedAt: $updatedAt, updatedBy: $updatedBy}
  ) {
    affected_rows
    returning {
      ticketId
      contactId
      eventInstanceId
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateReservationTicketsStateGQL extends Apollo.Mutation<TixUpdateReservationTicketsStateMutation, TixUpdateReservationTicketsStateMutationVariables> {
    document = UpdateReservationTicketsStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTicketStateDocument = gql`
    mutation updateTicketState($ticketId: uuid!, $checked_in_at: timestamptz = "now()", $updatedAt: timestamp = "now()", $updatedBy: uuid, $state: String = "Checked In") {
  UpdateTicket(
    where: {ticketId: {_eq: $ticketId}}
    _set: {state: $state, checkedInAt: $checked_in_at, updatedBy: $updatedBy, updatedAt: $updatedAt}
  ) {
    affected_rows
    returning {
      ticketId
      contactId
      eventInstanceId
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateTicketStateGQL extends Apollo.Mutation<TixUpdateTicketStateMutation, TixUpdateTicketStateMutationVariables> {
    document = UpdateTicketStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFeesForCompanyDocument = gql`
    query GetFeesForCompany($companyId: uuid!) @cached {
  fees(where: {companyId: {_eq: $companyId}, venueId: {_is_null: true}}) {
    feeId
    companyId
    venueId
    amount
    feeType
    typeOfFee
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetFeesForCompanyGQL extends Apollo.Query<TixGetFeesForCompanyQuery, TixGetFeesForCompanyQueryVariables> {
    document = GetFeesForCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFeesForVenueDocument = gql`
    query GetFeesForVenue($venueId: uuid!) @cached {
  fees(where: {venueId: {_eq: $venueId}}) {
    feeId
    companyId
    venueId
    amount
    feeType
    typeOfFee
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetFeesForVenueGQL extends Apollo.Query<TixGetFeesForVenueQuery, TixGetFeesForVenueQueryVariables> {
    document = GetFeesForVenueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGlobalFeesDocument = gql`
    query GetGlobalFees @cached {
  fees(where: {companyId: {_is_null: true}, venueId: {_is_null: true}}) {
    feeId
    companyId
    venueId
    amount
    feeType
    typeOfFee
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetGlobalFeesGQL extends Apollo.Query<TixGetGlobalFeesQuery, TixGetGlobalFeesQueryVariables> {
    document = GetGlobalFeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenericAddOrderToHoldDocument = gql`
    mutation GenericAddOrderToHold($items: [OrderHoldItemInput!]!, $userSessionId: String!) {
  genericAddOrderToHold(items: $items, userSessionId: $userSessionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGenericAddOrderToHoldGQL extends Apollo.Mutation<TixGenericAddOrderToHoldMutation, TixGenericAddOrderToHoldMutationVariables> {
    document = GenericAddOrderToHoldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetItemsAmountsSoldDocument = gql`
    query GetItemsAmountsSold($itemIds: [uuid!]!) {
  TicketConfig(where: {ticketConfigId: {_in: $itemIds}}) {
    ticketConfigId
    noOfSeats
    totalTicketsByType {
      ticketsSold
    }
  }
  EventProductSelect(where: {eventProductId: {_in: $itemIds}}) {
    eventProductId
    quantity
    quantitySold
    quantityRemaining
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetItemsAmountsSoldGQL extends Apollo.Query<TixGetItemsAmountsSoldQuery, TixGetItemsAmountsSoldQueryVariables> {
    document = GetItemsAmountsSoldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenericGetOrderItemsOnHoldByOtherUsersDocument = gql`
    query GenericGetOrderItemsOnHoldByOtherUsers($itemIds: [String!]!, $userSessionId: String!) {
  genericGetOrderItemsOnHoldByOtherUsers(
    itemIds: $itemIds
    userSessionId: $userSessionId
  ) {
    id
    quantity
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGenericGetOrderItemsOnHoldByOtherUsersGQL extends Apollo.Query<TixGenericGetOrderItemsOnHoldByOtherUsersQuery, TixGenericGetOrderItemsOnHoldByOtherUsersQueryVariables> {
    document = GenericGetOrderItemsOnHoldByOtherUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenericGetOrderOnHoldDocument = gql`
    query GenericGetOrderOnHold($userSessionId: String!) {
  genericGetOrderOnHold(userSessionId: $userSessionId) {
    ...HoldItem
  }
}
    ${HoldItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGenericGetOrderOnHoldGQL extends Apollo.Query<TixGenericGetOrderOnHoldQuery, TixGenericGetOrderOnHoldQueryVariables> {
    document = GenericGetOrderOnHoldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenericRemoveOrderFromHoldDocument = gql`
    mutation GenericRemoveOrderFromHold($userSessionId: String!) {
  genericRemoveOrderFromHold(userSessionId: $userSessionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGenericRemoveOrderFromHoldGQL extends Apollo.Mutation<TixGenericRemoveOrderFromHoldMutation, TixGenericRemoveOrderFromHoldMutationVariables> {
    document = GenericRemoveOrderFromHoldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductSelectSubscriptionDocument = gql`
    subscription eventProductSelectSubscription($eventInstanceId: uuid, $createdBy: uuid) {
  EventProductSelect(
    where: {eventInstanceId: {_eq: $eventInstanceId}, state: {_neq: "Deleted"}}
    order_by: {state: asc, name: asc}
  ) {
    eventProductId
    name
    state
    price
    quantity
    quantitySold
    quantityRemaining
    tax
    salesChannel
    additionalInfo
    startSellingDate
    startSellingTime
    stopSellingDate
    stopSellingTime
    productId
    EventProductMedia {
      MediaFile {
        location
        name
        mediaFileId
        state
      }
      eventProductMediaImageFileId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductSelectSubscriptionGQL extends Apollo.Subscription<TixEventProductSelectSubscriptionSubscription, TixEventProductSelectSubscriptionSubscriptionVariables> {
    document = EventProductSelectSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductSelectByPkDocument = gql`
    subscription eventProductSelectByPK($eventProductId: uuid!) {
  EventProductSelectByPK(eventProductId: $eventProductId) {
    quantity
    quantitySold
    quantityRemaining
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductSelectByPkGQL extends Apollo.Subscription<TixEventProductSelectByPkSubscription, TixEventProductSelectByPkSubscriptionVariables> {
    document = EventProductSelectByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductPullProductDocument = gql`
    query eventProductPullProduct($companyId: uuid, $createdBy: uuid, $_and: [Product_bool_exp!]) {
  ProductSelect(
    where: {companyId: {_eq: $companyId}, state: {_neq: "Deleted"}, _and: $_and}
    order_by: {state: asc, name: asc}
  ) {
    name
    state
    quantity
    price
    tax
    productId
    additionalInformation
    productMedia {
      mediaFile {
        location
        name
        fileType
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductPullProductGQL extends Apollo.Query<TixEventProductPullProductQuery, TixEventProductPullProductQueryVariables> {
    document = EventProductPullProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductSelectDocument = gql`
    query eventProductSelect($eventInstanceId: uuid, $today: timestamp) {
  EventProductSelect(
    where: {eventInstanceId: {_eq: $eventInstanceId}, salesChannel: {_in: ["both", "online"]}, state: {_eq: "Active"}, _and: [{startSelling: {_lte: $today}}, {stopSelling: {_gte: $today}}]}
    order_by: {state: asc, name: asc}
  ) {
    ...BuyerProductFragment
  }
}
    ${BuyerProductFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductSelectGQL extends Apollo.Query<TixEventProductSelectQuery, TixEventProductSelectQueryVariables> {
    document = EventProductSelectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductSelectTodaySubscriptionDocument = gql`
    subscription eventProductSelectTodaySubscription($eventInstanceId: uuid, $today: timestamp) {
  EventProductSelect(
    where: {eventInstanceId: {_eq: $eventInstanceId}, state: {_eq: "Active"}, _and: [{startSelling: {_lte: $today}}, {stopSelling: {_gte: $today}}]}
    order_by: {state: asc, name: asc}
  ) {
    eventProductId
    name
    price
    quantity
    quantitySold
    quantityRemaining
    tax
    salesChannel
    additionalInfo
    productId
    EventProductMedia {
      MediaFile {
        location
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductSelectTodaySubscriptionGQL extends Apollo.Subscription<TixEventProductSelectTodaySubscriptionSubscription, TixEventProductSelectTodaySubscriptionSubscriptionVariables> {
    document = EventProductSelectTodaySubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductInsertDocument = gql`
    mutation eventProductInsert($eventProducts: [EventProduct_insert_input!]!, $mediaFiles: [EventProductMedia_insert_input!]!) {
  EventProductInsert(objects: $eventProducts) {
    affected_rows
  }
  EventProductMediaInsert(objects: $mediaFiles) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductInsertGQL extends Apollo.Mutation<TixEventProductInsertMutation, TixEventProductInsertMutationVariables> {
    document = EventProductInsertDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductMediaInsertOneDocument = gql`
    mutation eventProductMediaInsertOne($eventProductId: uuid, $eventProductMediaImageFileId: uuid, $createdBy: uuid, $updatedBy: uuid, $mediaFile: MediaFile_obj_rel_insert_input) {
  EventProductMediaInsertOne(
    object: {eventProductId: $eventProductId, eventProductMediaImageFileId: $eventProductMediaImageFileId, createdBy: $createdBy, updatedBy: $updatedBy, updatedAt: "now()", createdAt: "now()", MediaFile: $mediaFile}
  ) {
    MediaFile {
      fileType
      location
      mediaFileId
      name
      state
    }
    eventProductMediaImageFileId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductMediaInsertOneGQL extends Apollo.Mutation<TixEventProductMediaInsertOneMutation, TixEventProductMediaInsertOneMutationVariables> {
    document = EventProductMediaInsertOneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderedEventProductsDocument = gql`
    mutation orderedEventProducts($updatedEventProducts: [EventProduct_updates!]!, $order: Order_insert_input!, $productOrderDetail: [product_order_detail_insert_input!]!) {
  EventProductUpdateMany(updates: $updatedEventProducts) {
    affected_rows
  }
  OrderInsertOne(object: $order) {
    orderId
  }
  insert_product_order_detail(objects: $productOrderDetail) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixOrderedEventProductsGQL extends Apollo.Mutation<TixOrderedEventProductsMutation, TixOrderedEventProductsMutationVariables> {
    document = OrderedEventProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductSoftDeleteDocument = gql`
    mutation eventProductSoftDelete($eventProductId: uuid) {
  EventProductUpdate(
    _set: {state: "Deleted"}
    where: {eventProductId: {_eq: $eventProductId}}
  ) {
    returning {
      eventInstanceId
      eventProductId
      productId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductSoftDeleteGQL extends Apollo.Mutation<TixEventProductSoftDeleteMutation, TixEventProductSoftDeleteMutationVariables> {
    document = EventProductSoftDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductEventProductMediaDeleteDocument = gql`
    mutation eventProductEventProductMediaDelete($eventProductMediaImageFileId: uuid!, $mediaFileId: uuid!) {
  EventProductMediaDeleteByPK(
    eventProductMediaImageFileId: $eventProductMediaImageFileId
  ) {
    mediaFileId
  }
  DeleteMediaFileByPK(mediaFileId: $mediaFileId) {
    mediaFileId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductEventProductMediaDeleteGQL extends Apollo.Mutation<TixEventProductEventProductMediaDeleteMutation, TixEventProductEventProductMediaDeleteMutationVariables> {
    document = EventProductEventProductMediaDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductUpdateDocument = gql`
    mutation eventProductUpdate($_set: EventProduct_set_input, $eventProductId: uuid) {
  EventProductUpdate(where: {eventProductId: {_eq: $eventProductId}}, _set: $_set) {
    returning {
      additionalInfo
      eventInstanceId
      eventProductId
      price
      name
      productId
      quantity
      quantitySold
      quantityRemaining
      salesChannel
      startSellingDate
      startSellingTime
      state
      stopSellingDate
      stopSellingTime
      tax
      EventProductMedia {
        MediaFile {
          location
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductUpdateGQL extends Apollo.Mutation<TixEventProductUpdateMutation, TixEventProductUpdateMutationVariables> {
    document = EventProductUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventProductPingDocument = gql`
    mutation eventProductPing($_set: EventProduct_set_input, $eventProductId: uuid) {
  EventProductUpdate(where: {eventProductId: {_eq: $eventProductId}}, _set: $_set) {
    returning {
      additionalInfo
      eventInstanceId
      eventProductId
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixEventProductPingGQL extends Apollo.Mutation<TixEventProductPingMutation, TixEventProductPingMutationVariables> {
    document = EventProductPingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductSelectAllDocument = gql`
    query productSelectAll($companyId: uuid, $createdBy: uuid) {
  ProductSelect(
    order_by: {state: asc, name: asc}
    where: {companyId: {_eq: $companyId}, state: {_neq: "Deleted"}}
  ) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixProductSelectAllGQL extends Apollo.Query<TixProductSelectAllQuery, TixProductSelectAllQueryVariables> {
    document = ProductSelectAllDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductSelectOneDocument = gql`
    query productSelectOne($productId: uuid, $companyId: uuid, $createdBy: uuid) {
  ProductSelect(
    where: {productId: {_eq: $productId}, companyId: {_eq: $companyId}, state: {_neq: "Deleted"}}
  ) {
    name
    state
    quantity
    price
    tax
    productId
    additionalInformation
    productMedia {
      mediaFile {
        location
        name
        mediaFileId
      }
      productMediaImageFileId
    }
    VenueProduct {
      VenueProductVenue {
        name
        venueId
      }
      productId
      venueId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixProductSelectOneGQL extends Apollo.Query<TixProductSelectOneQuery, TixProductSelectOneQueryVariables> {
    document = ProductSelectOneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductCompanyVenuesDocument = gql`
    query productCompanyVenues($companyId: uuid) {
  Venue(where: {companyId: {_eq: $companyId}, state: {_neq: "Deleted"}}) {
    name
    description
    state
    venueId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixProductCompanyVenuesGQL extends Apollo.Query<TixProductCompanyVenuesQuery, TixProductCompanyVenuesQueryVariables> {
    document = ProductCompanyVenuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductInsertOneDocument = gql`
    mutation productInsertOne($additionalInformation: String, $name: String, $state: String, $quantity: Int, $tax: numeric, $price: money, $createdBy: uuid!, $updatedBy: uuid, $companyId: uuid, $venueId: uuid, $data: [VenueProduct_insert_input!]!) {
  ProductInsertOne(
    object: {additionalInformation: $additionalInformation, name: $name, state: $state, tax: $tax, price: $price, quantity: $quantity, createdBy: $createdBy, updatedBy: $updatedBy, companyId: $companyId, VenueProduct: {data: $data}}
  ) {
    name
    state
    quantity
    price
    tax
    productId
    additionalInformation
    createdBy
    updatedBy
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixProductInsertOneGQL extends Apollo.Mutation<TixProductInsertOneMutation, TixProductInsertOneMutationVariables> {
    document = ProductInsertOneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductMediaFileInsertOneDocument = gql`
    mutation productMediaFileInsertOne($productId: uuid, $productMediaImageFileId: uuid, $createdBy: uuid, $updatedBy: uuid, $mediaFile: MediaFile_obj_rel_insert_input) {
  ProductMediaFileInsertOne(
    object: {productId: $productId, productMediaImageFileId: $productMediaImageFileId, createdBy: $createdBy, updatedBy: $updatedBy, updatedAt: "now()", createdAt: "now()", mediaFile: $mediaFile}
  ) {
    mediaFile {
      fileType
      location
      mediaFileId
      name
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixProductMediaFileInsertOneGQL extends Apollo.Mutation<TixProductMediaFileInsertOneMutation, TixProductMediaFileInsertOneMutationVariables> {
    document = ProductMediaFileInsertOneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefundAddonsDocument = gql`
    mutation RefundAddons($refund: RefundAddonsInput!) {
  refundAddons(refundAddonsInput: $refund)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixRefundAddonsGQL extends Apollo.Mutation<TixRefundAddonsMutation, TixRefundAddonsMutationVariables> {
    document = RefundAddonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductSoftDeleteDocument = gql`
    mutation productSoftDelete($productId: uuid!, $updatedBy: uuid!) {
  ProductUpdate(
    where: {productId: {_eq: $productId}}
    _set: {state: "Deleted", updatedBy: $updatedBy, updatedAt: "now()"}
  ) {
    returning {
      productId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixProductSoftDeleteGQL extends Apollo.Mutation<TixProductSoftDeleteMutation, TixProductSoftDeleteMutationVariables> {
    document = ProductSoftDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductMediaFileDeleteByPkDocument = gql`
    mutation productMediaFileDeleteByPK($productMediaImageFileId: uuid!, $mediaFileId: uuid!) {
  ProductMediaFileDeleteByPK(productMediaImageFileId: $productMediaImageFileId) {
    createdBy
    productId
    productMediaImageFileId
  }
  DeleteMediaFileByPK(mediaFileId: $mediaFileId) {
    mediaFileId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixProductMediaFileDeleteByPkGQL extends Apollo.Mutation<TixProductMediaFileDeleteByPkMutation, TixProductMediaFileDeleteByPkMutationVariables> {
    document = ProductMediaFileDeleteByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductUpdateDocument = gql`
    mutation productUpdate($productId: uuid, $additionalInformation: String, $name: String, $state: String, $quantity: Int, $tax: numeric, $price: money, $updatedBy: uuid, $data: [VenueProduct_insert_input!]!) {
  VenueProductDelete(where: {productId: {_eq: $productId}}) {
    affected_rows
  }
  ProductUpdate(
    where: {productId: {_eq: $productId}}
    _set: {additionalInformation: $additionalInformation, name: $name, state: $state, tax: $tax, price: $price, quantity: $quantity, updatedBy: $updatedBy}
  ) {
    returning {
      name
      state
      quantity
      price
      tax
      productId
      additionalInformation
    }
  }
  VenueProductInsert(objects: $data) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixProductUpdateGQL extends Apollo.Mutation<TixProductUpdateMutation, TixProductUpdateMutationVariables> {
    document = ProductUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmReservationDocument = gql`
    mutation ConfirmReservation($method: PaymentMethod!, $reservationId: String!, $paymentIntentId: String) {
  confirmReservation(
    method: $method
    reservationId: $reservationId
    paymentIntentId: $paymentIntentId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixConfirmReservationGQL extends Apollo.Mutation<TixConfirmReservationMutation, TixConfirmReservationMutationVariables> {
    document = ConfirmReservationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePaymentIntentForOrderDocument = gql`
    mutation CreatePaymentIntentForOrder($eventInstanceId: String!, $order: OrderInput!) {
  createPaymentIntentForOrder(
    eventInstanceId: $eventInstanceId
    method: stripe_online
    order: $order
  ) {
    clientSecret
    paymentIntentId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCreatePaymentIntentForOrderGQL extends Apollo.Mutation<TixCreatePaymentIntentForOrderMutation, TixCreatePaymentIntentForOrderMutationVariables> {
    document = CreatePaymentIntentForOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUnconfirmedReservationDocument = gql`
    mutation CreateUnconfirmedReservation($customer: CustomerInput!, $eventInstanceId: String!, $order: OrderInput!, $paymentIntentId: String) {
  createUnconfirmedReservation(
    customer: $customer
    eventInstanceId: $eventInstanceId
    order: $order
    paymentIntentId: $paymentIntentId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCreateUnconfirmedReservationGQL extends Apollo.Mutation<TixCreateUnconfirmedReservationMutation, TixCreateUnconfirmedReservationMutationVariables> {
    document = CreateUnconfirmedReservationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAmountToPayForOrderDocument = gql`
    query GetAmountToPayForOrder($order: OrderInput!, $eventInstanceId: String!) {
  getAmountToPayForOrder(
    order: $order
    eventInstanceId: $eventInstanceId
    method: stripe_online
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetAmountToPayForOrderGQL extends Apollo.Query<TixGetAmountToPayForOrderQuery, TixGetAmountToPayForOrderQueryVariables> {
    document = GetAmountToPayForOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSavedReportDocument = gql`
    mutation DeleteSavedReport($savedReportId: uuid!) {
  delete_savedReportLayout(where: {savedReportId: {_eq: $savedReportId}}) {
    affected_rows
  }
  delete_savedReportEvents(where: {savedReportId: {_eq: $savedReportId}}) {
    affected_rows
  }
  delete_savedReport(where: {savedReportId: {_eq: $savedReportId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteSavedReportGQL extends Apollo.Mutation<TixDeleteSavedReportMutation, TixDeleteSavedReportMutationVariables> {
    document = DeleteSavedReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSavedScheduleDocument = gql`
    mutation DeleteSavedSchedule($scheduledReportId: uuid!) {
  delete_scheduledReportEmail(
    where: {scheduleReportId: {_eq: $scheduledReportId}}
  ) {
    affected_rows
  }
  delete_scheduledReport(where: {scheduledReportId: {_eq: $scheduledReportId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteSavedScheduleGQL extends Apollo.Mutation<TixDeleteSavedScheduleMutation, TixDeleteSavedScheduleMutationVariables> {
    document = DeleteSavedScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsByVenueIdsDocument = gql`
    query getEventsByVenueIds($venueIds: [uuid!], $startDate: date!, $endDate: date!) {
  EventInstance(
    where: {venueId: {_in: $venueIds}, state: {_neq: "Deleted"}, date: {_gte: $startDate, _lte: $endDate}}
    order_by: {date: asc, startTime: asc}
  ) {
    eventInstanceId
    name
    startTime
    endTime
    doorsOpen
    date
    venueId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventsByVenueIdsGQL extends Apollo.Query<TixGetEventsByVenueIdsQuery, TixGetEventsByVenueIdsQueryVariables> {
    document = GetEventsByVenueIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDailyAuditReportDocument = gql`
    query GetDailyAuditReport($eventInstanceIds: [uuid!]) {
  DailyAuditReportFinal(where: {eventInstanceId: {_in: $eventInstanceIds}}) {
    companyName
    eventInstanceId
    formattedDate
    formattedStartTime
    name
    parentTicketName
    performance
    performanceDate
    rawDate
    rawStartTime
    todayCashAmount
    todayCashCount
    todayCompAmount
    todayCompCount
    todayRefundAmount
    todayRefundCount
    todayTotalDiscountAmount
    todayTotalDiscountCount
    todayTotalTicketSalesAmount
    todayTotalTicketSalesAmountOverall
    todayTotalTicketSalesCount
    todayTotalTicketSalesCountOverall
    todayTotalTicketSalesCountOverall
    totalBoxofficeTicketAmount
    totalBoxofficeTicketCount
    totalCashAmount
    totalCashCount
    totalCompAmount
    totalCompCount
    totalDiscountAmount
    totalDiscountCount
    totalOnlineTicketAmount
    totalOnlineTicketCount
    totalRefundAmount
    totalRefundCount
    totalTicketSalesAmount
    totalTicketSalesAmountOverall
    totalTicketSalesCount
    totalTicketSalesCountOverall
    totalTicketsForSale
    venueName
    yesterdayCashAmount
    yesterdayCashCount
    yesterdayDiscountAmount
    yesterdayDiscountCount
    yesterdayRefundAmount
    yesterdayRefundCount
    yesterdayTotalTicketSalesAmount
    yesterdayTotalTicketSalesAmountOverall
    yesterdayTotalTicketSalesCount
    yesterdayTotalTicketSalesCount
    yesterdayTotalTicketSalesCountOverall
    platformFeeTotalByTicket
    processingFeeTotalByTicket
    ticketConfigId
    totalFeesByTicket
    totalTicketsAvailable
    venueFeeTotalByTicket
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDailyAuditReportGQL extends Apollo.Query<TixGetDailyAuditReportQuery, TixGetDailyAuditReportQueryVariables> {
    document = GetDailyAuditReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountCodesReportDocument = gql`
    query getDiscountCodesReport($eventInstanceIds: [uuid!], $discountIds: [uuid!], $startDate: date, $endDate: date) {
  DiscountReport(
    where: {eventInstanceId: {_in: $eventInstanceIds}, discountId: {_in: $discountIds}, dateUsed: {_gte: $startDate, _lte: $endDate}}
    order_by: {discountCode: asc, dateUsed: asc}
  ) {
    appliedTo
    companyId
    companyName
    dateUsed
    discountAmountPerTicket
    discountCode
    discountId
    discountDescription
    eventDate
    eventInstanceId
    eventName
    eventStartTime
    reservationId
    reservationNo
    salesChannel
    ticketId
    ticketNo
    venueId
    venueName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDiscountCodesReportGQL extends Apollo.Query<TixGetDiscountCodesReportQuery, TixGetDiscountCodesReportQueryVariables> {
    document = GetDiscountCodesReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountCodesDocument = gql`
    query getDiscountCodes($venueIds: [uuid!], $eventInstanceIds: [uuid!], $startDate: date, $endDate: date) {
  Discount(
    where: {state: {_eq: "Active"}, _and: [{_or: [{startDate: {_gte: $startDate}}, {startDate: {_is_null: true}}]}, {_or: [{endDate: {_lte: $endDate}}, {endDate: {_is_null: true}}]}], _or: [{venueDiscount: {venueId: {_in: $venueIds}, state: {_eq: "Active"}}, eventInstanceDiscount: {eventInstanceId: {_in: $eventInstanceIds}, state: {_eq: "Active"}}}, {venueDiscount: {venueId: {_in: $venueIds}, venue: {events: {eventInstanceId: {_in: $eventInstanceIds}}}, state: {_eq: "Active"}}}]}
  ) {
    discountId
    endDate
    endTime
    startDate
    startTime
    appliedTo
    discountCode
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDiscountCodesGQL extends Apollo.Query<TixGetDiscountCodesQuery, TixGetDiscountCodesQueryVariables> {
    document = GetDiscountCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountsByIdDocument = gql`
    query GetDiscountsById($discountIds: [uuid!]) {
  Discount(where: {discountId: {_in: $discountIds}}) {
    discountCode
    discountId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetDiscountsByIdGQL extends Apollo.Query<TixGetDiscountsByIdQuery, TixGetDiscountsByIdQueryVariables> {
    document = GetDiscountsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSavedReportsDocument = gql`
    query getSavedReports($companyId: uuid!, $reportType: String) {
  savedReport(
    where: {companyId: {_eq: $companyId}, reportType: {_eq: $reportType}}
  ) {
    reportName
    savedReportId
    venueId
    reportVenueIds
    discountCodeId
    discountEndDate
    discountStartDate
    level
    reportType
    visibility
    createdBy
    updatedBy
    savedReportEvents {
      eventInstanceId
      savedReportEventsId
      savedReportId
    }
    savedReportLayouts {
      includedColumnName
      savedReportLayoutId
    }
    scheduledReports {
      frequency
      scheduledReportEmails {
        emailAddress
        scheduledReportEmailId
        scheduleReportId
      }
      scheduledReportId
      scheduleName
      startSendingTimestamp
      stopSendingTimestamp
      timeOfDay
      timezone
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetSavedReportsGQL extends Apollo.Query<TixGetSavedReportsQuery, TixGetSavedReportsQueryVariables> {
    document = GetSavedReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertSavedReportsDocument = gql`
    mutation InsertSavedReports($objects: [savedReport_insert_input!]!) {
  insert_savedReport(objects: $objects) {
    returning {
      venueId
      companyId
      createdAt
      reportVenueIds
      discountCodeId
      discountEndDate
      discountStartDate
      createdBy
      reportName
      savedReportId
      updatedBy
      updatedAt
      level
      reportType
      visibility
      savedReportEvents {
        savedReportEventsId
        eventInstanceId
        savedReportId
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      savedReportLayouts {
        createdAt
        createdBy
        includedColumnName
        savedReportId
        savedReportLayoutId
        updatedAt
        updatedBy
      }
      scheduledReports {
        createdAt
        createdBy
        frequency
        savedReportId
        scheduledReportId
        startSendingTimestamp
        stopSendingTimestamp
        timezone
        scheduleName
        timeOfDay
        updatedAt
        updatedBy
        scheduledReportEmails {
          emailAddress
          scheduledReportEmailId
          scheduleReportId
          createdAt
          createdBy
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertSavedReportsGQL extends Apollo.Mutation<TixInsertSavedReportsMutation, TixInsertSavedReportsMutationVariables> {
    document = InsertSavedReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSavedReportDocument = gql`
    mutation UpdateSavedReport($savedReportId: uuid!, $UpdatedReport: savedReport_set_input!, $UpdatedReportLayout: savedReportLayout_set_input!, $newReportEvents: [savedReportEvents_insert_input!]!) {
  update_savedReport(
    where: {savedReportId: {_eq: $savedReportId}}
    _set: $UpdatedReport
  ) {
    returning {
      reportType
      savedReportId
      discountCodeId
      discountEndDate
      discountStartDate
      reportName
      updatedAt
      updatedBy
      level
      visibility
    }
  }
  update_savedReportLayout(
    where: {savedReportId: {_eq: $savedReportId}}
    _set: $UpdatedReportLayout
  ) {
    returning {
      includedColumnName
    }
  }
  delete_savedReportEvents(where: {savedReportId: {_eq: $savedReportId}}) {
    affected_rows
  }
  insert_savedReportEvents(objects: $newReportEvents) {
    returning {
      eventInstanceId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateSavedReportGQL extends Apollo.Mutation<TixUpdateSavedReportMutation, TixUpdateSavedReportMutationVariables> {
    document = UpdateSavedReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyReportDocument = gql`
    query GetCompanyReport($companyId: uuid!, $startDate: date!, $endDate: date!) {
  reservationSummaryReport(
    where: {companyId: {_eq: $companyId}, eventDate: {_gte: $startDate, _lte: $endDate}, eventState: {_eq: "Active"}}
    order_by: {venueName: asc, eventDate: desc}
  ) {
    CompanyName
    companyId
    discount
    discountCode
    emailAddress
    eventDate
    eventInstanceId
    eventName
    eventState
    formattedEventDate
    formattedReservationDate
    formattedStartTime
    fullName
    paymentState
    paymentType
    platformFee
    processingFee
    refundAmount
    reservationDate
    reservationId
    reservationNo
    reservationState
    salesChannel
    startTime
    subTotal
    ticketCount
    ticketType
    totalAmountPaid
    totalRevenue
    venueFee
    venueId
    venueName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetCompanyReportGQL extends Apollo.Query<TixGetCompanyReportQuery, TixGetCompanyReportQueryVariables> {
    document = GetCompanyReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventReportDocument = gql`
    query GetEventReport($eventInstanceId: uuid!) {
  ticket_v_ticket_sales_metrics(
    where: {event_instance_id: {_eq: $eventInstanceId}}
  ) {
    total_seats
    available
    checked_in
    not_checked_in
    total_seats
  }
  reservationDetailReport(
    where: {eventInstanceId: {_eq: $eventInstanceId}, eventState: {_eq: "Active"}}
    order_by: {lastName: asc, date: desc}
  ) {
    companyName
    venueName
    eventName
    eventInstanceId
    date
    startTime
    reservationNo
    ticketType: ticketName
    paymentToken
    emailAddress
    reservationDate
    ticketId
    noOfTickets
    ticketPrice
    totalAmountPaid
    stripeFeePaid
    platformFee
    venueFee
    ticketNo
    firstName
    lastName
    fullName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventReportGQL extends Apollo.Query<TixGetEventReportQuery, TixGetEventReportQueryVariables> {
    document = GetEventReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventSummaryReportDocument = gql`
    query GetEventSummaryReport($eventInstanceId: uuid!) {
  reservationSummaryReport(
    where: {eventInstanceId: {_eq: $eventInstanceId}, eventState: {_eq: "Active"}}
  ) {
    CompanyName
    companyId
    discount
    discountCode
    emailAddress
    eventDate
    eventInstanceId
    eventName
    eventState
    formattedEventDate
    formattedReservationDate
    formattedStartTime
    fullName
    paymentState
    paymentType
    platformFee
    processingFee
    refundAmount
    reservationDate
    reservationId
    reservationNo
    reservationState
    salesChannel
    startTime
    subTotal
    ticketCount
    ticketType
    totalAmountPaid
    totalRevenue
    venueFee
    venueId
    venueName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventSummaryReportGQL extends Apollo.Query<TixGetEventSummaryReportQuery, TixGetEventSummaryReportQueryVariables> {
    document = GetEventSummaryReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNightlyCloseoutReportDocument = gql`
    query getNightlyCloseoutReport($eventInstanceId: uuid!) {
  EventInstanceByPK(eventInstanceId: $eventInstanceId) {
    name
    date
    startTime
    DiscountCodeCount {
      discountCode
      discountType
      discountsUsed
      discountAmount
    }
    EventTicketCount {
      ticketCount
      ticketName
      ticketType
      ticketSection
    }
    Refunds {
      contactId
      refundAmount
      ticketCount
      state
    }
    RevenueByChannelType {
      fullName
      paymentType
      salesChannel
      totalRevenue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetNightlyCloseoutReportGQL extends Apollo.Query<TixGetNightlyCloseoutReportQuery, TixGetNightlyCloseoutReportQueryVariables> {
    document = GetNightlyCloseoutReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductSalesReportForCsvDocument = gql`
    query GetProductSalesReportForCsv($columns: [ProductSalesColumn!]!, $reportLevel: [String!], $eventInstanceId: String, $venueId: String, $startDate: DateTime, $endDate: DateTime) {
  getProductSalesReportForCsv(
    columns: $columns
    reportLevel: $reportLevel
    eventInstanceId: $eventInstanceId
    venueId: $venueId
    startDate: $startDate
    endDate: $endDate
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetProductSalesReportForCsvGQL extends Apollo.Query<TixGetProductSalesReportForCsvQuery, TixGetProductSalesReportForCsvQueryVariables> {
    document = GetProductSalesReportForCsvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductSalesReportDocument = gql`
    query GetProductSalesReport($endDate: String, $startDate: String, $venueId: String, $eventInstanceId: String) {
  getProductSalesReport(
    endDate: $endDate
    startDate: $startDate
    venueId: $venueId
    eventInstanceId: $eventInstanceId
  ) {
    comment
    orderDetailId
    reservationNo
    customerName
    customerEmail
    quantity
    productName
    unitPrice
    totalPrice
    purchaseDate
    eventName
    venueName
    orderId
    state
    processingFees
    taxAmount
    totalPaid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetProductSalesReportGQL extends Apollo.Query<TixGetProductSalesReportQuery, TixGetProductSalesReportQueryVariables> {
    document = GetProductSalesReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketNamesByEventInstanceDocument = gql`
    query GetTicketNamesByEventInstance($eventInstanceId: uuid!) {
  TicketCountByName(
    where: {eventInstanceId: {_eq: $eventInstanceId}}
    distinct_on: name
  ) {
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketNamesByEventInstanceGQL extends Apollo.Query<TixGetTicketNamesByEventInstanceQuery, TixGetTicketNamesByEventInstanceQueryVariables> {
    document = GetTicketNamesByEventInstanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketByTypeReportDocument = gql`
    query GetTicketByTypeReport($eventInstanceId: uuid!, $ticketNames: [String!]) {
  TicketCountByName(
    where: {eventInstanceId: {_eq: $eventInstanceId}, name: {_in: $ticketNames}}
  ) {
    fullName
    name
    ticketCount
    venueName
    startTime
    date
    ticketType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketByTypeReportGQL extends Apollo.Query<TixGetTicketByTypeReportQuery, TixGetTicketByTypeReportQueryVariables> {
    document = GetTicketByTypeReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingEventsSummaryReportDocument = gql`
    query GetUpcomingEventsSummaryReport($companyId: uuid!) {
  reservationSummaryReport(
    where: {companyId: {_eq: $companyId}, eventState: {_eq: "Active"}, eventDate: {_gte: "now()"}}
    order_by: {venueName: asc, eventDate: asc}
  ) {
    CompanyName
    companyId
    discount
    discountCode
    emailAddress
    eventDate
    eventInstanceId
    eventName
    eventState
    formattedEventDate
    formattedReservationDate
    formattedStartTime
    fullName
    paymentState
    paymentType
    platformFee
    processingFee
    refundAmount
    reservationDate
    reservationId
    reservationNo
    reservationState
    salesChannel
    startTime
    subTotal
    ticketCount
    ticketType
    totalAmountPaid
    totalRevenue
    venueFee
    venueId
    venueName
    TicketMetrics {
      total_seats
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetUpcomingEventsSummaryReportGQL extends Apollo.Query<TixGetUpcomingEventsSummaryReportQuery, TixGetUpcomingEventsSummaryReportQueryVariables> {
    document = GetUpcomingEventsSummaryReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TicketCountByRevenueTypeDocument = gql`
    query TicketCountByRevenueType($eventInstanceId: uuid) {
  TicketCountByChannelType(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    paymentType
    sales_channel
    ticketCount
    eventInstanceId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixTicketCountByRevenueTypeGQL extends Apollo.Query<TixTicketCountByRevenueTypeQuery, TixTicketCountByRevenueTypeQueryVariables> {
    document = TicketCountByRevenueTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScheduledAuditReportDocument = gql`
    mutation DeleteScheduledAuditReport($scheduledReport: ScheduledReportInput!, $scheduledReportId: uuid!) {
  delete_scheduledReportEmail(
    where: {scheduleReportId: {_eq: $scheduledReportId}}
  ) {
    affected_rows
  }
  delete_scheduledReport(where: {scheduledReportId: {_eq: $scheduledReportId}}) {
    affected_rows
  }
  deleteScheduledReportFromTheQueue(scheduledReport: $scheduledReport) {
    defaultRecipient
    time
    zone
    otherRecipients
    eventId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteScheduledAuditReportGQL extends Apollo.Mutation<TixDeleteScheduledAuditReportMutation, TixDeleteScheduledAuditReportMutationVariables> {
    document = DeleteScheduledAuditReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScheduledEventReportDocument = gql`
    mutation DeleteScheduledEventReport($deletedValues: [ConfigurationValue_updates!]!, $deletedEventConfigLinks: [EventInstanceConfigurationValue_updates!]!, $scheduledReport: ScheduledReportInput!) {
  update_ConfigurationValue_many(updates: $deletedValues) {
    returning {
      configurationValueId
      value
    }
  }
  UpdateEventInstanceConfigurationValueMany(updates: $deletedEventConfigLinks) {
    affected_rows
    returning {
      eventInstanceId
      configurationValueId
    }
  }
  deleteScheduledReportFromTheQueue(scheduledReport: $scheduledReport) {
    defaultRecipient
    time
    zone
    otherRecipients
    eventId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteScheduledEventReportGQL extends Apollo.Mutation<TixDeleteScheduledEventReportMutation, TixDeleteScheduledEventReportMutationVariables> {
    document = DeleteScheduledEventReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScheduledEventReportDocument = gql`
    query GetScheduledEventReport($eventId: uuid!) {
  ConfigurationItem(
    where: {GroupItem: {Group: {name: {_eq: "Event Management"}}, viewOrder: {_gt: 2, _lt: 7}}, state: {_eq: "Active"}}
    order_by: {GroupItem: {viewOrder: asc}}
  ) {
    configurationItemId
    name
    defaultValue
    elementType
    required
    helpText
    elementType
    placeholder
  }
  EventInstanceConfigurationValue(
    where: {state: {_eq: "Active"}, value: {state: {_eq: "Active"}, Item: {GroupItem: {Group: {name: {_eq: "Event Management"}, state: {_eq: "Active"}}, viewOrder: {_gt: 2, _lt: 7}}}}, eventInstanceId: {_eq: $eventId}}
    order_by: {value: {Item: {GroupItem: {viewOrder: asc}}}}
  ) {
    eventInstanceConfigurationId
    value {
      configurationValueId
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetScheduledEventReportGQL extends Apollo.Query<TixGetScheduledEventReportQuery, TixGetScheduledEventReportQueryVariables> {
    document = GetScheduledEventReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertScheduledAuditReportDocument = gql`
    mutation InsertScheduledAuditReport($scheduledReport: ScheduledReportInput!, $objects: [scheduledReport_insert_input!]!) {
  insert_scheduledReport(objects: $objects) {
    returning {
      savedReportId
      frequency
      scheduledReportId
      scheduleName
      startSendingTimestamp
      stopSendingTimestamp
      timeOfDay
      timezone
      scheduledReportEmails {
        emailAddress
        scheduleReportId
      }
    }
  }
  insertScheduledReportToTheQueue(scheduledReport: $scheduledReport) {
    defaultRecipient
    time
    zone
    otherRecipients
    eventId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertScheduledAuditReportGQL extends Apollo.Mutation<TixInsertScheduledAuditReportMutation, TixInsertScheduledAuditReportMutationVariables> {
    document = InsertScheduledAuditReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertScheduledEventReportDocument = gql`
    mutation InsertScheduledEventReport($configurationValues: [ConfigurationValue_insert_input!]!, $eventInstanceConfigurationValues: [EventInstanceConfigurationValue_insert_input!]!, $scheduledReport: ScheduledReportInput!) {
  InsertConfigurationValue(objects: $configurationValues) {
    affected_rows
  }
  InsertEventInstanceConfigurationValue(
    objects: $eventInstanceConfigurationValues
  ) {
    affected_rows
  }
  insertScheduledReportToTheQueue(scheduledReport: $scheduledReport) {
    defaultRecipient
    time
    zone
    otherRecipients
    eventId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertScheduledEventReportGQL extends Apollo.Mutation<TixInsertScheduledEventReportMutation, TixInsertScheduledEventReportMutationVariables> {
    document = InsertScheduledEventReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScheduledAuditReportDocument = gql`
    mutation UpdateScheduledAuditReport($old: ScheduledReportInput!, $newValue: ScheduledReportInput!, $UpdatedScheduleReport: scheduledReport_set_input!, $scheduledReportId: uuid!, $insertScheduledReportEmail: [scheduledReportEmail_insert_input!]!) {
  update_scheduledReport(
    where: {scheduledReportId: {_eq: $scheduledReportId}}
    _set: $UpdatedScheduleReport
  ) {
    returning {
      savedReportId
      frequency
      scheduledReportId
      scheduleName
      startSendingTimestamp
      stopSendingTimestamp
      timeOfDay
      timezone
      scheduledReportEmails {
        emailAddress
        scheduleReportId
      }
    }
  }
  delete_scheduledReportEmail(
    where: {scheduleReportId: {_eq: $scheduledReportId}}
  ) {
    affected_rows
  }
  insert_scheduledReportEmail(objects: $insertScheduledReportEmail) {
    returning {
      emailAddress
      scheduleReportId
    }
  }
  updateScheduledReportInTheQueue(old: $old, newValue: $newValue) {
    defaultRecipient
    time
    zone
    otherRecipients
    eventId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateScheduledAuditReportGQL extends Apollo.Mutation<TixUpdateScheduledAuditReportMutation, TixUpdateScheduledAuditReportMutationVariables> {
    document = UpdateScheduledAuditReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScheduledEventReportDocument = gql`
    mutation UpdateScheduledEventReport($updatedValues: [ConfigurationValue_updates!]!, $old: ScheduledReportInput!, $newValue: ScheduledReportInput!) {
  update_ConfigurationValue_many(updates: $updatedValues) {
    returning {
      configurationValueId
      value
    }
  }
  updateScheduledReportInTheQueue(old: $old, newValue: $newValue) {
    defaultRecipient
    time
    zone
    otherRecipients
    eventId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateScheduledEventReportGQL extends Apollo.Mutation<TixUpdateScheduledEventReportMutation, TixUpdateScheduledEventReportMutationVariables> {
    document = UpdateScheduledEventReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCompanyContactDocument = gql`
    mutation InsertCompanyContact($objects: [CompanyContact_insert_input!] = {}) {
  InsertCompanyContact(objects: $objects) {
    returning {
      companyContactId
      contactId
      companyId
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertCompanyContactGQL extends Apollo.Mutation<TixInsertCompanyContactMutation, TixInsertCompanyContactMutationVariables> {
    document = InsertCompanyContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertStaffUserDocument = gql`
    mutation InsertStaffUser($objects: [User_insert_input!] = {}) {
  InsertUser(objects: $objects) {
    returning {
      userId
      contactId
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertStaffUserGQL extends Apollo.Mutation<TixInsertStaffUserMutation, TixInsertStaffUserMutationVariables> {
    document = InsertStaffUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyStaffRoleDocument = gql`
    mutation DeleteCompanyStaffRole($userRoleId: uuid = "") {
  DeleteUserRole(where: {userRoleId: {_eq: $userRoleId}}) {
    returning {
      userRoleId
      userId
      companyId
      roleId
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteCompanyStaffRoleGQL extends Apollo.Mutation<TixDeleteCompanyStaffRoleMutation, TixDeleteCompanyStaffRoleMutationVariables> {
    document = DeleteCompanyStaffRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteContactCompanyRolesDocument = gql`
    mutation DeleteContactCompanyRoles($companyId: uuid!, $userId: uuid!) {
  DeleteUserRole(where: {companyId: {_eq: $companyId}, userId: {_eq: $userId}}) {
    returning {
      userRoleId
      userId
      companyId
      roleId
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteContactCompanyRolesGQL extends Apollo.Mutation<TixDeleteContactCompanyRolesMutation, TixDeleteContactCompanyRolesMutationVariables> {
    document = DeleteContactCompanyRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteContactPhoneNumbersDocument = gql`
    mutation DeleteContactPhoneNumbers($contactId: uuid!) {
  DeleteContactPhoneNumber(where: {contactId: {_eq: $contactId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteContactPhoneNumbersGQL extends Apollo.Mutation<TixDeleteContactPhoneNumbersMutation, TixDeleteContactPhoneNumbersMutationVariables> {
    document = DeleteContactPhoneNumbersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserFromStaffDocument = gql`
    mutation DeleteUserFromStaff($companyId: uuid!, $contactId: uuid!) {
  DeleteCompanyContact(
    where: {companyId: {_eq: $companyId}, contactId: {_eq: $contactId}}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteUserFromStaffGQL extends Apollo.Mutation<TixDeleteUserFromStaffMutation, TixDeleteUserFromStaffMutationVariables> {
    document = DeleteUserFromStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContactByEmailAddressDocument = gql`
    query getContactByEmailAddress($emailAddress: String = "%%") {
  Contact(where: {emailAddress: {_ilike: $emailAddress}}) {
    contactId
    firstName
    lastName
    emailAddress
    dob
    profilePicture
    user {
      userId
      userRoles {
        userRoleId
        companyId
        venueId
        role {
          roleId
          role
          title
          description
        }
      }
    }
    phoneNumbers {
      contactPhoneNumberId
      phoneNumber {
        phoneNumberId
        countryCode
        phoneNumber
        type
      }
    }
    addresses {
      address {
        contactAddress {
          contactAddressId
        }
        addressId
        streetAddress
        suiteApartment
        city
        stateProvince
        postalCode
        countryCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetContactByEmailAddressGQL extends Apollo.Query<TixGetContactByEmailAddressQuery, TixGetContactByEmailAddressQueryVariables> {
    document = GetContactByEmailAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContactByEmailAddressSearchDocument = gql`
    query GetContactByEmailAddressSearch($emailAddress: String = "%%") {
  Contact(
    where: {emailAddress: {_ilike: $emailAddress}, user: {userId: {_is_null: false}}}
    limit: 10
  ) {
    contactId
    emailAddress
    firstName
    lastName
    phoneNumbers {
      contactPhoneNumberId
      phoneNumber {
        phoneNumberId
        countryCode
        type
        phoneNumber
      }
    }
    user {
      userId
      userRoles {
        companyId
        userRoleId
        venueId
        role {
          description
          role
          state
          title
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetContactByEmailAddressSearchGQL extends Apollo.Query<TixGetContactByEmailAddressSearchQuery, TixGetContactByEmailAddressSearchQueryVariables> {
    document = GetContactByEmailAddressSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesDocument = gql`
    query GetRoles {
  Role(where: {title: {_nilike: "system admin"}}, order_by: {title: asc}) {
    roleId
    role
    description
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetRolesGQL extends Apollo.Query<TixGetRolesQuery, TixGetRolesQueryVariables> {
    document = GetRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStaffByPkDocument = gql`
    query GetStaffByPK($contactId: uuid = "") {
  Contact(where: {contactId: {_eq: $contactId}}) {
    contactId
    firstName
    lastName
    emailAddress
    profilePicture
    phoneNumbers {
      contactPhoneNumberId
      phoneNumber {
        phoneNumberId
        countryCode
        type
        phoneNumber
      }
    }
    user {
      userId
      userRoles {
        userRoleId
        companyId
        venueId
        role {
          roleId
          role
          title
          description
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetStaffByPkGQL extends Apollo.Query<TixGetStaffByPkQuery, TixGetStaffByPkQueryVariables> {
    document = GetStaffByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCompanyContactUserRolesDocument = gql`
    mutation InsertCompanyContactUserRoles($objects: [UserRole_insert_input!]!) {
  InsertUserRole(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertCompanyContactUserRolesGQL extends Apollo.Mutation<TixInsertCompanyContactUserRolesMutation, TixInsertCompanyContactUserRolesMutationVariables> {
    document = InsertCompanyContactUserRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertStaffContactDocument = gql`
    mutation insertStaffContact($emailAddress: String = "", $firstName: String = "", $lastName: String = "", $createdAt: timestamp = "now()", $createdBy: uuid!) {
  InsertContactOne(
    object: {emailAddress: $emailAddress, firstName: $firstName, lastName: $lastName, updatedAt: $createdAt, updatedBy: $createdBy}
    on_conflict: {constraint: email_unique, update_columns: [updatedAt, updatedBy, firstName, lastName]}
  ) {
    contactId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertStaffContactGQL extends Apollo.Mutation<TixInsertStaffContactMutation, TixInsertStaffContactMutationVariables> {
    document = InsertStaffContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStaffContactIdByEmailDocument = gql`
    query getStaffContactIdByEmail($emailAddress: String!) {
  Contact(where: {emailAddress: {_eq: $emailAddress}}) {
    contactId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetStaffContactIdByEmailGQL extends Apollo.Query<TixGetStaffContactIdByEmailQuery, TixGetStaffContactIdByEmailQueryVariables> {
    document = GetStaffContactIdByEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertStaffCompanyContactRelationshipDocument = gql`
    mutation insertStaffCompanyContactRelationship($companyId: uuid!, $contactId: uuid!) {
  InsertCompanyContact(objects: [{contactId: $contactId, companyId: $companyId}]) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertStaffCompanyContactRelationshipGQL extends Apollo.Mutation<TixInsertStaffCompanyContactRelationshipMutation, TixInsertStaffCompanyContactRelationshipMutationVariables> {
    document = InsertStaffCompanyContactRelationshipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertStaffUserAndRolesDocument = gql`
    mutation insertStaffUserAndRoles($contactId: uuid!, $data: [UserRole_insert_input!] = {}) {
  InsertUserOne(object: {contactId: $contactId, userRoles: {data: $data}}) {
    contactId
    lastFailedLogin
    lastSuccessfulLogin
    noFailedLogins
    state
    updatedAt
    updatedBy
    userId
    contact {
      contactId
      emailAddress
      firstName
      lastName
      state
      companyContacts {
        companyContactId
        companyId
        contactId
        state
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertStaffUserAndRolesGQL extends Apollo.Mutation<TixInsertStaffUserAndRolesMutation, TixInsertStaffUserAndRolesMutationVariables> {
    document = InsertStaffUserAndRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCompanyStaffRoleDocument = gql`
    mutation InsertCompanyStaffRole($objects: [UserRole_insert_input!] = {}) {
  InsertUserRole(objects: $objects) {
    returning {
      userRoleId
      userId
      roleId
      companyId
      state
      updatedBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertCompanyStaffRoleGQL extends Apollo.Mutation<TixInsertCompanyStaffRoleMutation, TixInsertCompanyStaffRoleMutationVariables> {
    document = InsertCompanyStaffRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertExistingUserToStaffDocument = gql`
    mutation InsertExistingUserToStaff($companyId: uuid!, $contactId: uuid!) {
  InsertCompanyContactOne(object: {companyId: $companyId, contactId: $contactId}) {
    contactId
    contact {
      contactId
      emailAddress
      firstName
      lastName
      state
      companyContacts {
        companyContactId
        companyId
        contactId
        state
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertExistingUserToStaffGQL extends Apollo.Mutation<TixInsertExistingUserToStaffMutation, TixInsertExistingUserToStaffMutationVariables> {
    document = InsertExistingUserToStaffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendMailByEmailDocument = gql`
    mutation SendMailByEmail($email: String = "") {
  createUserAndSendEmail(email: $email) {
    invited
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixSendMailByEmailGQL extends Apollo.Mutation<TixSendMailByEmailMutation, TixSendMailByEmailMutationVariables> {
    document = SendMailByEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketDocument = gql`
    query getTicket($reservationId: uuid!) {
  reservationInfo: ReservationAggregate(
    where: {reservationId: {_eq: $reservationId}}
  ) {
    nodes {
      tickets_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketGQL extends Apollo.Query<TixGetTicketQuery, TixGetTicketQueryVariables> {
    document = GetTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAppleWalletPassUrlDocument = gql`
    query getAppleWalletPassUrl($data: SendETicketInput!) {
  getAppleWalletPassUrl(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetAppleWalletPassUrlGQL extends Apollo.Query<TixGetAppleWalletPassUrlQuery, TixGetAppleWalletPassUrlQueryVariables> {
    document = GetAppleWalletPassUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGoogleWalletUrlDocument = gql`
    query GetGoogleWalletUrl($data: SendETicketInput!) {
  getGoogleWalletUrl(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetGoogleWalletUrlGQL extends Apollo.Query<TixGetGoogleWalletUrlQuery, TixGetGoogleWalletUrlQueryVariables> {
    document = GetGoogleWalletUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelExchangeDocument = gql`
    mutation CancelExchange($exchangeId: String!) {
  cancelTicketExchange(exchangeId: $exchangeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCancelExchangeGQL extends Apollo.Mutation<TixCancelExchangeMutation, TixCancelExchangeMutationVariables> {
    document = CancelExchangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmExchangeDocument = gql`
    mutation ConfirmExchange($exchangeId: String!) {
  confirmTicketExchange(exchangeId: $exchangeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixConfirmExchangeGQL extends Apollo.Mutation<TixConfirmExchangeMutation, TixConfirmExchangeMutationVariables> {
    document = ConfirmExchangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventExchangesCountDocument = gql`
    query GetEventExchangesCount($eventInstanceId: uuid!) {
  ticket_exchange_aggregate(
    where: {originalReservation: {eventInstanceId: {_eq: $eventInstanceId}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventExchangesCountGQL extends Apollo.Query<TixGetEventExchangesCountQuery, TixGetEventExchangesCountQueryVariables> {
    document = GetEventExchangesCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsForExchangeDocument = gql`
    query GetEventsForExchange($venueId: uuid!, $startDate: date! = "now()", $endDate: date! = "2099-01-01", $search: String = "%%", $offset: Int = 0, $limit: Int = 10) {
  EventInstance(
    where: {venueId: {_eq: $venueId}, state: {_eq: "Active"}, date: {_gte: $startDate, _lte: $endDate}, name: {_ilike: $search}}
    order_by: {date: asc, startTime: asc}
    offset: $offset
    limit: $limit
  ) {
    eventInstanceId
    name
    startTime
    endTime
    doorsOpen
    date
    venueId
    eventAdmins
    eventInstanceTickets {
      Configurations {
        TicketConfigurations {
          includeFees
          name
          noOfSeats
          salesChannel
          parentTicketId
          perOrderMax
          perOrderMin
          platformFee
          processingFee
          venueFee
          helpText
          helpTextTitle
          seat
          section
          row
          state
          ticketConfigId
          ticketType
          ticketPrice
          startSellingDate
          stopSellingDate
          startSellingTime
          stopSellingTime
          totalTicketsByType {
            ticketsSold
            ticketsRemaining
          }
        }
      }
    }
    eventTicketSalesMetrics {
      available
      checked_in
      event_instance_id
      not_checked_in
      total_seats
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventsForExchangeGQL extends Apollo.Query<TixGetEventsForExchangeQuery, TixGetEventsForExchangeQueryVariables> {
    document = GetEventsForExchangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExchangeByIdForPaymentDocument = gql`
    query GetExchangeByIdForPayment($exchangeId: String!) {
  getPaymentExchangeData(exchangeId: $exchangeId) {
    ...PaymentExchangeData
  }
}
    ${PaymentExchangeDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetExchangeByIdForPaymentGQL extends Apollo.Query<TixGetExchangeByIdForPaymentQuery, TixGetExchangeByIdForPaymentQueryVariables> {
    document = GetExchangeByIdForPaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExchangeVenueDocument = gql`
    query GetExchangeVenue($eventInstanceId: uuid!) {
  EventInstance(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    venue {
      name
      state
      addresses {
        venueAddressId
        address {
          addressId
          streetAddress
          suiteApartment
          city
          stateProvince
          postalCode
          countryCode
          sameAsCompany
        }
      }
      socialMedia {
        venueSocialMediaId
        socialMedia {
          socialMediaId
          url
          socialMediaType
        }
      }
      mediaFiles(where: {mediaFile: {mediaType: {_eq: "Venue Logo"}}}) {
        mediaFile {
          mediaFileId
          name
          location
          fileType
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetExchangeVenueGQL extends Apollo.Query<TixGetExchangeVenueQuery, TixGetExchangeVenueQueryVariables> {
    document = GetExchangeVenueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExchangesByEventDocument = gql`
    query GetExchangesByEvent($eventInstanceId: uuid!) {
  ticket_exchange(
    where: {originalReservation: {eventInstanceId: {_eq: $eventInstanceId}}}
    order_by: {createdAt: desc}
  ) {
    createdAt
    exchangeId
    state
    amount
    expiresAt
    exchangedProductIds
    exchangedTicketIds
    originalReservation {
      ...ExchangeReservationData
    }
    newReservation {
      ...ExchangeReservationData
    }
  }
}
    ${ExchangeReservationDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetExchangesByEventGQL extends Apollo.Query<TixGetExchangesByEventQuery, TixGetExchangesByEventQueryVariables> {
    document = GetExchangesByEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRequiredActionForExchangeDocument = gql`
    query GetRequiredActionForExchange($request: TicketExchangeRequestInput!) {
  getTicketExchangeRequiredAction(request: $request) {
    type
    amount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetRequiredActionForExchangeGQL extends Apollo.Query<TixGetRequiredActionForExchangeQuery, TixGetRequiredActionForExchangeQueryVariables> {
    document = GetRequiredActionForExchangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationsByEventDocument = gql`
    query GetReservationsByEvent($eventInstanceId: uuid!, $searchQuery: String! = "%%", $offset: Int = 0, $limit: Int = 10) {
  reservation: Reservation(
    where: {active: {_eq: true}, eventInstanceId: {_eq: $eventInstanceId}, _or: [{contact: {fullName: {_ilike: $searchQuery}}}, {contact: {emailAddress: {_ilike: $searchQuery}}}, {tickets: {reservationNo: {_ilike: $searchQuery}}}, {tickets: {ticketNo: {_ilike: $searchQuery}}}]}
    offset: $offset
    limit: $limit
  ) {
    ...OrderData
  }
}
    ${OrderDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetReservationsByEventGQL extends Apollo.Query<TixGetReservationsByEventQuery, TixGetReservationsByEventQueryVariables> {
    document = GetReservationsByEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InitiateExchangeDocument = gql`
    mutation InitiateExchange($request: TicketExchangeRequestInput!) {
  exchangeId: initiateTicketExchange(request: $request)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInitiateExchangeGQL extends Apollo.Mutation<TixInitiateExchangeMutation, TixInitiateExchangeMutationVariables> {
    document = InitiateExchangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendExchangeEmailDocument = gql`
    mutation SendExchangeEmail($exchangeId: String!) {
  sendTicketExchangeEmail(exchangeId: $exchangeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixSendExchangeEmailGQL extends Apollo.Mutation<TixSendExchangeEmailMutation, TixSendExchangeEmailMutationVariables> {
    document = SendExchangeEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendExchangePaymentEmailDocument = gql`
    mutation SendExchangePaymentEmail($exchangeId: String!) {
  sendExchangePaymentEmail(exchangeId: $exchangeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixSendExchangePaymentEmailGQL extends Apollo.Mutation<TixSendExchangePaymentEmailMutation, TixSendExchangePaymentEmailMutationVariables> {
    document = SendExchangePaymentEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddOrderToHoldDocument = gql`
    mutation AddOrderToHold($userSessionId: String!, $tickets: [TicketOnHoldInput!]!) {
  addOrderToHold(userSessionId: $userSessionId, tickets: $tickets)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixAddOrderToHoldGQL extends Apollo.Mutation<TixAddOrderToHoldMutation, TixAddOrderToHoldMutationVariables> {
    document = AddOrderToHoldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOtherOrdersOnHoldDocument = gql`
    query GetOtherOrdersOnHold($userSessionId: String!, $tickets: [String!]!) {
  getOtherUsersOnHoldTickets(
    userSessionId: $userSessionId
    ticketConfigIds: $tickets
  ) {
    onHold
    ticketConfigId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetOtherOrdersOnHoldGQL extends Apollo.Query<TixGetOtherOrdersOnHoldQuery, TixGetOtherOrdersOnHoldQueryVariables> {
    document = GetOtherOrdersOnHoldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveOrderFromHoldDocument = gql`
    mutation RemoveOrderFromHold($userSessionId: String!) {
  removeOrderFromHold(userSessionId: $userSessionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixRemoveOrderFromHoldGQL extends Apollo.Mutation<TixRemoveOrderFromHoldMutation, TixRemoveOrderFromHoldMutationVariables> {
    document = RemoveOrderFromHoldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationTicketsZipDocument = gql`
    query GetReservationTicketsZip($reservationId: String!, $baseTicketQrCodeScanUrl: String!, $zipName: String!) {
  getReservationTicketsZip(
    reservationId: $reservationId
    baseTicketQrCodeScanUrl: $baseTicketQrCodeScanUrl
    zipName: $zipName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetReservationTicketsZipGQL extends Apollo.Query<TixGetReservationTicketsZipQuery, TixGetReservationTicketsZipQueryVariables> {
    document = GetReservationTicketsZipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketIdsInReservationDocument = gql`
    query GetTicketIdsInReservation($reservationId: uuid!) {
  Reservation(where: {reservationId: {_eq: $reservationId}}) {
    tickets {
      ticketId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketIdsInReservationGQL extends Apollo.Query<TixGetTicketIdsInReservationQuery, TixGetTicketIdsInReservationQueryVariables> {
    document = GetTicketIdsInReservationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketPdfUrlsDocument = gql`
    query GetTicketPDFUrls($baseTicketQrCodeScanUrl: String!, $ticketIds: [String!]!) {
  getTicketPDFUrls(
    baseTicketQrCodeScanUrl: $baseTicketQrCodeScanUrl
    ticketIds: $ticketIds
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetTicketPdfUrlsGQL extends Apollo.Query<TixGetTicketPdfUrlsQuery, TixGetTicketPdfUrlsQueryVariables> {
    document = GetTicketPdfUrlsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadMediaDocument = gql`
    mutation UploadMedia($file: Upload = "") {
  uploadMedia(file: $file) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUploadMediaGQL extends Apollo.Mutation<TixUploadMediaMutation, TixUploadMediaMutationVariables> {
    document = UploadMediaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventCalendarDatesDocument = gql`
    query GetEventCalendarDates($venueId: uuid!, $monthStartDate: date!, $monthEndDate: date!, $currentDate: date = "now()") {
  calendarEventDates: EventInstance(
    where: {_and: {venueId: {_eq: $venueId}, _and: [{date: {_gte: $monthStartDate}}, {date: {_lte: $monthEndDate}}, {date: {_gte: $currentDate}}, {state: {_neq: "Hidden"}}]}}
  ) {
    date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetEventCalendarDatesGQL extends Apollo.Query<TixGetEventCalendarDatesQuery, TixGetEventCalendarDatesQueryVariables> {
    document = GetEventCalendarDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenuePortalEventDocument = gql`
    query GetVenuePortalEvent($eventInstanceId: uuid!) {
  EventInstance(where: {eventInstanceId: {_eq: $eventInstanceId}}) {
    ...VenuePortalEvent
  }
}
    ${VenuePortalEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenuePortalEventGQL extends Apollo.Query<TixGetVenuePortalEventQuery, TixGetVenuePortalEventQueryVariables> {
    document = GetVenuePortalEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenuePortalEventsWithSlugDocument = gql`
    query GetVenuePortalEventsWithSlug($venueId: uuid!, $searchQuery: String! = "%%", $startDate: date!, $endDate: date = "2099-01-01", $states: [String!] = ["Active"], $limit: Int = 5, $offset: Int = 0, $currentDate: date = "now()", $currentTime: time = "now()", $filterKeyword: String! = "%%") {
  EventInstance(
    where: {_and: [{venueId: {_eq: $venueId}}, {date: {_gte: $startDate, _lte: $endDate}}, {_and: [{slug: {_ilike: $filterKeyword}}, {name: {_ilike: $searchQuery}}]}, {state: {_in: $states}}, {_or: [{type: {_ilike: "event"}}, {_and: [{startSellingDate: {_lte: $currentDate}}, {stopSellingDate: {_gte: $currentDate}}]}]}, {_or: [{type: {_ilike: "event"}}, {_and: [{startSellingDate: {_eq: $currentDate}}, {_or: [{startSellingTime: {_is_null: true}}, {startSellingTime: {_lt: $currentTime}}]}]}, {_and: [{startSellingDate: {_lt: $currentDate}}, {stopSellingDate: {_gt: $currentDate}}]}, {_and: [{stopSellingDate: {_eq: $currentDate}}, {_or: [{stopSellingTime: {_is_null: true}}, {stopSellingTime: {_gt: $currentTime}}]}]}]}]}
    limit: $limit
    offset: $offset
    order_by: {date: asc, startTime: asc}
  ) {
    ...VenuePortalEvent
  }
}
    ${VenuePortalEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenuePortalEventsWithSlugGQL extends Apollo.Query<TixGetVenuePortalEventsWithSlugQuery, TixGetVenuePortalEventsWithSlugQueryVariables> {
    document = GetVenuePortalEventsWithSlugDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenuePortalEventsDocument = gql`
    query GetVenuePortalEvents($venueId: uuid!, $searchQuery: String! = "%%", $startDate: date!, $endDate: date = "2099-01-01", $states: [String!] = ["Active"], $limit: Int = 5, $offset: Int = 0, $currentDate: date = "now()", $currentTime: time = "now()") {
  EventInstance(
    where: {_and: [{venueId: {_eq: $venueId}}, {date: {_gte: $startDate, _lte: $endDate}}, {name: {_ilike: $searchQuery}}, {state: {_in: $states}}, {_or: [{type: {_ilike: "event"}}, {_and: [{startSellingDate: {_lte: $currentDate}}, {stopSellingDate: {_gte: $currentDate}}]}]}, {_or: [{type: {_ilike: "event"}}, {_and: [{startSellingDate: {_eq: $currentDate}}, {_or: [{startSellingTime: {_is_null: true}}, {startSellingTime: {_lt: $currentTime}}]}]}, {_and: [{startSellingDate: {_lt: $currentDate}}, {stopSellingDate: {_gt: $currentDate}}]}, {_and: [{stopSellingDate: {_eq: $currentDate}}, {_or: [{stopSellingTime: {_is_null: true}}, {stopSellingTime: {_gt: $currentTime}}]}]}]}]}
    limit: $limit
    offset: $offset
    order_by: {date: asc, startTime: asc}
  ) {
    ...VenuePortalEvent
  }
}
    ${VenuePortalEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenuePortalEventsGQL extends Apollo.Query<TixGetVenuePortalEventsQuery, TixGetVenuePortalEventsQueryVariables> {
    document = GetVenuePortalEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNewVenueDocument = gql`
    mutation CreateNewVenue($objects: [Venue_insert_input!] = {}) {
  InsertVenue(objects: $objects) {
    returning {
      venueId
      name
      description
      additionalInfo
      url
      phoneNumbers {
        venuePhoneNumberId
        phoneNumber {
          phoneNumberId
          phoneNumber
          type
          sameAsCompany
        }
      }
      addresses {
        venueAddressId
        address {
          addressId
          streetAddress
          suiteApartment
          city
          stateProvince
          postalCode
          countryCode
          sameAsCompany
        }
      }
      socialMedia {
        venueSocialMediaId
        socialMedia {
          socialMediaId
          url
          socialMediaType
        }
      }
      mediaFiles {
        venueImageFileId
        mediaFile {
          mediaFileId
          name
          location
          fileType
        }
      }
      tickets {
        venueTicketId
        name
        description
        totalSeats
        Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
          venueTicketConfig
          TicketConfigurations {
            view_order
            includeFees
            parentTicketId
            salesChannel
            name
            section
            ticketType
            noOfSeats
            row
            seat
            perOrderMin
            perOrderMax
            ticketPrice
            platformFee
            processingFee
            venueFee
            ticketConfigId
            startSellingDate
            stopSellingDate
            startSellingTime
            stopSellingTime
          }
        }
        Configurations_aggregate {
          aggregate {
            count(columns: venueTicketConfig)
          }
        }
      }
      lineups {
        venueLineupId
        lineup {
          lineupId
          name
          performers_aggregate {
            aggregate {
              count(columns: performerId)
            }
          }
          performers {
            lineupPerformerId
            performer {
              performerId
              name
              title
              additionalInfo
              description
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixCreateNewVenueGQL extends Apollo.Mutation<TixCreateNewVenueMutation, TixCreateNewVenueMutationVariables> {
    document = CreateNewVenueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTicketConfigurationDocument = gql`
    mutation DeleteTicketConfiguration($ticketConfigId: uuid = "") {
  DeleteTicketConfigByPK(ticketConfigId: $ticketConfigId) {
    ticketConfigId
  }
  DeleteVenueTicketConfig(where: {ticketConfigId: {_eq: $ticketConfigId}}) {
    returning {
      venueTicketConfig
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteTicketConfigurationGQL extends Apollo.Mutation<TixDeleteTicketConfigurationMutation, TixDeleteTicketConfigurationMutationVariables> {
    document = DeleteTicketConfigurationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueAddressesDocument = gql`
    mutation DeleteVenueAddresses($venueId: uuid!) {
  DeleteVenueAddress(where: {venueId: {_eq: $venueId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueAddressesGQL extends Apollo.Mutation<TixDeleteVenueAddressesMutation, TixDeleteVenueAddressesMutationVariables> {
    document = DeleteVenueAddressesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueMediaFileByMediaFilePkDocument = gql`
    mutation DeleteVenueMediaFileByMediaFilePK($mediaFileId: uuid = "") {
  DeleteVenueMediaFile(where: {mediaFileId: {_eq: $mediaFileId}}) {
    returning {
      venueId
      venueImageFileId
    }
  }
  DeleteMediaFileByPK(mediaFileId: $mediaFileId) {
    venueMediaFile {
      venueId
      venueImageFileId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueMediaFileByMediaFilePkGQL extends Apollo.Mutation<TixDeleteVenueMediaFileByMediaFilePkMutation, TixDeleteVenueMediaFileByMediaFilePkMutationVariables> {
    document = DeleteVenueMediaFileByMediaFilePkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueMediaFilesDocument = gql`
    mutation DeleteVenueMediaFiles($venueId: uuid!) {
  DeleteVenueMediaFile(where: {venueId: {_eq: $venueId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueMediaFilesGQL extends Apollo.Mutation<TixDeleteVenueMediaFilesMutation, TixDeleteVenueMediaFilesMutationVariables> {
    document = DeleteVenueMediaFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenuePhoneNumberByPhoneNumberPkDocument = gql`
    mutation DeleteVenuePhoneNumberByPhoneNumberPK($phoneNumberId: uuid = "") {
  DeleteVenuePhoneNumber(where: {phoneNumberId: {_eq: $phoneNumberId}}) {
    returning {
      venueId
      venuePhoneNumberId
    }
  }
  DeletePhoneNumberByPK(phoneNumberId: $phoneNumberId) {
    venuePhoneNumbers {
      venueId
      venuePhoneNumberId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenuePhoneNumberByPhoneNumberPkGQL extends Apollo.Mutation<TixDeleteVenuePhoneNumberByPhoneNumberPkMutation, TixDeleteVenuePhoneNumberByPhoneNumberPkMutationVariables> {
    document = DeleteVenuePhoneNumberByPhoneNumberPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenuePhoneNumbersDocument = gql`
    mutation DeleteVenuePhoneNumbers($venueId: uuid!) {
  DeleteVenuePhoneNumber(where: {venueId: {_eq: $venueId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenuePhoneNumbersGQL extends Apollo.Mutation<TixDeleteVenuePhoneNumbersMutation, TixDeleteVenuePhoneNumbersMutationVariables> {
    document = DeleteVenuePhoneNumbersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueSocialMediaBySocialMediaPkDocument = gql`
    mutation DeleteVenueSocialMediaBySocialMediaPK($socialMediaId: uuid = "") {
  DeleteVenueSocialMedia(where: {socialMediaId: {_eq: $socialMediaId}}) {
    returning {
      venueId
      venueSocialMediaId
    }
  }
  DeleteSocialMediaByPK(socialMediaId: $socialMediaId) {
    venueSocialMedia {
      venueId
      venueSocialMediaId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueSocialMediaBySocialMediaPkGQL extends Apollo.Mutation<TixDeleteVenueSocialMediaBySocialMediaPkMutation, TixDeleteVenueSocialMediaBySocialMediaPkMutationVariables> {
    document = DeleteVenueSocialMediaBySocialMediaPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueSocialMediasDocument = gql`
    mutation DeleteVenueSocialMedias($venueId: uuid!) {
  DeleteVenueSocialMedia(where: {venueId: {_eq: $venueId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueSocialMediasGQL extends Apollo.Mutation<TixDeleteVenueSocialMediasMutation, TixDeleteVenueSocialMediasMutationVariables> {
    document = DeleteVenueSocialMediasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueTicketDocument = gql`
    mutation DeleteVenueTicket($venueTicketId: uuid = "") {
  DeleteVenueTicketByPK(venueTicketId: $venueTicketId) {
    venueTicketId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueTicketGQL extends Apollo.Mutation<TixDeleteVenueTicketMutation, TixDeleteVenueTicketMutationVariables> {
    document = DeleteVenueTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueWarningByWarningPkDocument = gql`
    mutation DeleteVenueWarningByWarningPK($warningId: uuid = "") {
  DeleteVenueWarning(where: {warningId: {_eq: $warningId}}) {
    returning {
      venueId
      venueWarningId
    }
  }
  DeleteWarningByPK(warningId: $warningId) {
    venue_warning {
      venueId
      venueWarningId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueWarningByWarningPkGQL extends Apollo.Mutation<TixDeleteVenueWarningByWarningPkMutation, TixDeleteVenueWarningByWarningPkMutationVariables> {
    document = DeleteVenueWarningByWarningPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVenueWarningsDocument = gql`
    mutation DeleteVenueWarnings($venueId: uuid!) {
  DeleteVenueWarning(where: {venueId: {_eq: $venueId}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixDeleteVenueWarningsGQL extends Apollo.Mutation<TixDeleteVenueWarningsMutation, TixDeleteVenueWarningsMutationVariables> {
    document = DeleteVenueWarningsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPolicyByVenueIdDocument = gql`
    query GetPolicyByVenueId($venueId: uuid = "", $policyType: String = "") {
  Policy(where: {venueId: {_eq: $venueId}, policyType: {_eq: $policyType}}) {
    policyId
    policyType
    policyText
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetPolicyByVenueIdGQL extends Apollo.Query<TixGetPolicyByVenueIdQuery, TixGetPolicyByVenueIdQueryVariables> {
    document = GetPolicyByVenueIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenueByIdDocument = gql`
    query getVenueById($venueId: uuid = "") {
  VenueByPK(venueId: $venueId) {
    ...FullVenue
  }
}
    ${FullVenueFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenueByIdGQL extends Apollo.Query<TixGetVenueByIdQuery, TixGetVenueByIdQueryVariables> {
    document = GetVenueByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenueBySlugDocument = gql`
    query GetVenueBySlug($slug: String!) {
  Venue(where: {slug: {_eq: $slug}}) {
    ...FullVenue
  }
}
    ${FullVenueFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenueBySlugGQL extends Apollo.Query<TixGetVenueBySlugQuery, TixGetVenueBySlugQueryVariables> {
    document = GetVenueBySlugDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenueTicketByPkDocument = gql`
    query GetVenueTicketByPK($venueTicketId: uuid = "") {
  VenueTicketByPK(venueTicketId: $venueTicketId) {
    name
    state
    totalSeats
    updatedAt
    updatedBy
    venueId
    venueTicketId
    Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
      state
      ticketConfigId
      updatedAt
      updatedBy
      venueTicketConfig
      venueTicketId
      TicketConfigurations {
        view_order
        includeFees
        parentTicketId
        name
        salesChannel
        noOfSeats
        perOrderMax
        perOrderMin
        row
        seat
        section
        state
        ticketConfigId
        platformFee
        processingFee
        venueFee
        ticketPrice
        ticketType
        updatedAt
        updatedBy
        startSellingDate
        stopSellingDate
        startSellingTime
        stopSellingTime
        helpText
        helpTextTitle
      }
    }
    Configurations_aggregate {
      aggregate {
        count(columns: venueTicketConfig)
      }
    }
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenueTicketByPkGQL extends Apollo.Query<TixGetVenueTicketByPkQuery, TixGetVenueTicketByPkQueryVariables> {
    document = GetVenueTicketByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenuesByCompanyIdDocument = gql`
    query getVenuesByCompanyId($companyId: uuid = "", $fileType: String = "Venue Logo") {
  Venue(where: {companyId: {_eq: $companyId}, state: {_neq: "Deleted"}}) {
    ...VenueListItem
  }
}
    ${VenueListItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenuesByCompanyIdGQL extends Apollo.Query<TixGetVenuesByCompanyIdQuery, TixGetVenuesByCompanyIdQueryVariables> {
    document = GetVenuesByCompanyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVenuesByEventAdminIdDocument = gql`
    query getVenuesByEventAdminId($companyId: uuid = "", $fileType: String = "Venue Logo", $userId: [uuid!]) {
  Venue(
    where: {companyId: {_eq: $companyId}, state: {_neq: "Deleted"}, events: {event: {eventInstances: {eventAdmins: {_contains: $userId}}}}}
  ) {
    ...VenueListItem
  }
}
    ${VenueListItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TixGetVenuesByEventAdminIdGQL extends Apollo.Query<TixGetVenuesByEventAdminIdQuery, TixGetVenuesByEventAdminIdQueryVariables> {
    document = GetVenuesByEventAdminIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertVenueTicketConfigDocument = gql`
    mutation InsertVenueTicketConfig($objects: [VenueTicketConfig_insert_input!] = {}) {
  InsertVenueTicketConfig(objects: $objects) {
    returning {
      TicketConfigurations {
        includeFees
        parentTicketId
        view_order
        name
        salesChannel
        noOfSeats
        perOrderMax
        perOrderMin
        seat
        row
        section
        state
        ticketType
        ticketPrice
        platformFee
        processingFee
        venueFee
        ticketConfigId
        startSellingDate
        stopSellingDate
        startSellingTime
        stopSellingTime
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertVenueTicketConfigGQL extends Apollo.Mutation<TixInsertVenueTicketConfigMutation, TixInsertVenueTicketConfigMutationVariables> {
    document = InsertVenueTicketConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertVenueTicketDocument = gql`
    mutation InsertVenueTicket($objects: [VenueTicket_insert_input!] = {}) {
  InsertVenueTicket(objects: $objects) {
    returning {
      state
      updatedAt
      updatedBy
      venueTicketId
      name
      totalSeats
      description
      Configurations(order_by: {TicketConfigurations: {view_order: asc}}) {
        ticketConfigId
        TicketConfigurations {
          view_order
          includeFees
          parentTicketId
          name
          salesChannel
          noOfSeats
          perOrderMax
          perOrderMin
          seat
          row
          section
          state
          ticketType
          ticketPrice
          platformFee
          processingFee
          venueFee
          ticketConfigId
          updatedAt
          updatedBy
          startSellingDate
          stopSellingDate
          startSellingTime
          stopSellingTime
        }
        updatedAt
        updatedBy
        venueTicketConfig
        venueTicketId
        state
      }
      venueId
      Configurations_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixInsertVenueTicketGQL extends Apollo.Mutation<TixInsertVenueTicketMutation, TixInsertVenueTicketMutationVariables> {
    document = InsertVenueTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkVenueAsDeletedDocument = gql`
    mutation MarkVenueAsDeleted($venueId: uuid!, $updatedAt: timestamp = "now()", $updatedBy: uuid!) {
  UpdateVenue(
    where: {venueId: {_eq: $venueId}}
    _set: {state: "Deleted", updatedAt: $updatedAt, updatedBy: $updatedBy}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixMarkVenueAsDeletedGQL extends Apollo.Mutation<TixMarkVenueAsDeletedMutation, TixMarkVenueAsDeletedMutationVariables> {
    document = MarkVenueAsDeletedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetVenuePhoneNumbersSameAsCompanyDocument = gql`
    mutation SetVenuePhoneNumbersSameAsCompany($venueId: uuid, $updatedBy: uuid!, $updatedAt: timestamp = "now()") {
  DeleteVenuePhoneNumber(where: {venueId: {_eq: $venueId}}) {
    affected_rows
  }
  DeletePhoneNumber(where: {venuePhoneNumbers: {venueId: {_eq: $venueId}}}) {
    affected_rows
  }
  InsertPhoneNumber(
    objects: {sameAsCompany: true, updatedBy: $updatedBy, updatedAt: $updatedAt, venuePhoneNumbers: {data: {venueId: $venueId, updatedBy: $updatedBy}}}
  ) {
    returning {
      countryCode
      phoneNumber
      phoneNumberId
      venuePhoneNumbers {
        venueId
        venuePhoneNumberId
        updatedAt
        updatedBy
      }
      state
      type
      updatedAt
      updatedBy
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixSetVenuePhoneNumbersSameAsCompanyGQL extends Apollo.Mutation<TixSetVenuePhoneNumbersSameAsCompanyMutation, TixSetVenuePhoneNumbersSameAsCompanyMutationVariables> {
    document = SetVenuePhoneNumbersSameAsCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTicketConfigByPkDocument = gql`
    mutation UpdateTicketConfigByPK($ticketConfigId: uuid = "", $_set: TicketConfig_set_input = {}) {
  UpdateTicketConfigByPK(
    pk_columns: {ticketConfigId: $ticketConfigId}
    _set: $_set
  ) {
    name
    noOfSeats
    perOrderMax
    perOrderMin
    row
    seat
    section
    state
    ticketConfigId
    platformFee
    ticketPrice
    ticketType
    updatedAt
    updatedBy
    startSellingDate
    startSellingTime
    stopSellingDate
    stopSellingTime
    view_order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateTicketConfigByPkGQL extends Apollo.Mutation<TixUpdateTicketConfigByPkMutation, TixUpdateTicketConfigByPkMutationVariables> {
    document = UpdateTicketConfigByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateVenueTicketByPkDocument = gql`
    mutation UpdateVenueTicketByPK($venueTicketId: uuid = "", $_set: VenueTicket_set_input = {}) {
  UpdateVenueTicketByPK(pk_columns: {venueTicketId: $venueTicketId}, _set: $_set) {
    name
    state
    totalSeats
    updatedAt
    updatedBy
    venueId
    venueTicketId
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TixUpdateVenueTicketByPkGQL extends Apollo.Mutation<TixUpdateVenueTicketByPkMutation, TixUpdateVenueTicketByPkMutationVariables> {
    document = UpdateVenueTicketByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }